import * as yup from "yup";
export interface IForm {
  open: boolean;
  singleData: any;
  reload: boolean;
  setReload: React.Dispatch<React.SetStateAction<boolean>>;
  hideDialog: () => void;
  toast: any;
}


export const candidateData = [
  {
    city: "Austin",
    region: "Texas",
    fullName: "Cooper Brown",
    firstName: "Cooper",
    lastName: "Brown",
    usCitizen: true,
    currentJobTitle: "Sr. React.JS Developer",
    currentCompany: "Pfizer",
    yearsOfExperience: 6,
    dateLastActive: "2024-06-07T11:49:21Z",
    likelyToMove: false,
    desiredWorkSettings: ["REMOTE"],
    workPermitDocuments: ["US Citizen"],
    workPreferences: [
      {
        annualSalary: { min: 100000, max: 0 },
        hourlyRate: { min: 60, max: 0 },
        willingToRelocate: false
      }
    ],
    skills: [
      { skill: "React", yearsUsed: 10 },
      { skill: "Redux", yearsUsed: 10 },
      { skill: "Accessibility", yearsUsed: 9 },
      { skill: "AWS", yearsUsed: 9 },
      { skill: "JavaScript", yearsUsed: 9 }
    ]
  },

  {
    city: "Dallas",
    region: "Texas",
    fullName: "Ganesh Kumar",
    firstName: "Ganesh",
    lastName: "Kumar",
    usCitizen: false,
    currentJobTitle: "React.Js Developer",
    currentCompany: "Michaels Stores",
    yearsOfExperience: 11,
    dateLastActive: "2024-03-05T10:55:12Z",
    likelyToMove: true,
    desiredWorkSettings: ["REMOTE", "HYBRID"],
    workPermitDocuments: ["H1B Visa"],
    workPreferences: [
      {
        annualSalary: { min: 120000, max: 0 },
        hourlyRate: { min: 70, max: 0 },
        willingToRelocate: true
      }
    ],
    skills: [
      { skill: "React", yearsUsed: 8 },
      { skill: "HTML5", yearsUsed: 8 },
      { skill: "CSS", yearsUsed: 8 },
      { skill: "Node.js", yearsUsed: 5 },
      { skill: "jQuery", yearsUsed: 5 },
      { skill: "jQuery", yearsUsed: 5 },
      { skill: "jQuery", yearsUsed: 5 },
      { skill: "jQuery", yearsUsed: 5 },
      { skill: "jQuery", yearsUsed: 5 },
      { skill: "jQuery", yearsUsed: 5 },
    ]
  }
];


export const states: { name: string }[] = [
  { name: "Alabama" },
  { name: "Alaska" },
  { name: "Arizona" },
  { name: "Arkansas" },
  { name: "California" },
  { name: "Colorado" },
  { name: "Connecticut" },
  { name: "Delaware" },
  { name: "Florida" },
  { name: "Georgia" },
  { name: "Hawaii" },
  { name: "Idaho" },
  { name: "Illinois" },
  { name: "Indiana" },
  { name: "Iowa" },
  { name: "Kansas" },
  { name: "Kentucky" },
  { name: "Louisiana" },
  { name: "Maine" },
  { name: "Maryland" },
  { name: "Massachusetts" },
  { name: "Michigan" },
  { name: "Minnesota" },
  { name: "Mississippi" },
  { name: "Missouri" },
  { name: "Montana" },
  { name: "Nebraska" },
  { name: "Nevada" },
  { name: "New Hampshire" },
  { name: "New Jersey" },
  { name: "New Mexico" },
  { name: "New York" },
  { name: "North Carolina" },
  { name: "North Dakota" },
  { name: "Ohio" },
  { name: "Oklahoma" },
  { name: "Oregon" },
  { name: "Pennsylvania" },
  { name: "Rhode Island" },
  { name: "South Carolina" },
  { name: "South Dakota" },
  { name: "Tennessee" },
  { name: "Texas" },
  { name: "Utah" },
  { name: "Vermont" },
  { name: "Virginia" },
  { name: "Washington" },
  { name: "West Virginia" },
  { name: "Wisconsin" },
  { name: "Wyoming" }
];

export const stateWithCity: { State: string, City: string }[] = JSON.parse(`[
  {
    "State": "NY",
    "City": "Holtsville"
  },
  {
    "State": "PR",
    "City": "Adjuntas"
  },
  {
    "State": "PR",
    "City": "Aguada"
  },
  {
    "State": "PR",
    "City": "Aguadilla"
  },
  {
    "State": "PR",
    "City": "Maricao"
  },
  {
    "State": "PR",
    "City": "Anasco"
  },
  {
    "State": "PR",
    "City": "Angeles"
  },
  {
    "State": "PR",
    "City": "Arecibo"
  },
  {
    "State": "PR",
    "City": "Bajadero"
  },
  {
    "State": "PR",
    "City": "Barceloneta"
  },
  {
    "State": "PR",
    "City": "Boqueron"
  },
  {
    "State": "PR",
    "City": "Cabo Rojo"
  },
  {
    "State": "PR",
    "City": "Penuelas"
  },
  {
    "State": "PR",
    "City": "Camuy"
  },
  {
    "State": "PR",
    "City": "Castaner"
  },
  {
    "State": "PR",
    "City": "Rosario"
  },
  {
    "State": "PR",
    "City": "Sabana Grande"
  },
  {
    "State": "PR",
    "City": "Ciales"
  },
  {
    "State": "PR",
    "City": "Utuado"
  },
  {
    "State": "PR",
    "City": "Dorado"
  },
  {
    "State": "PR",
    "City": "Ensenada"
  },
  {
    "State": "PR",
    "City": "Florida"
  },
  {
    "State": "PR",
    "City": "Garrochales"
  },
  {
    "State": "PR",
    "City": "Guanica"
  },
  {
    "State": "PR",
    "City": "Guayanilla"
  },
  {
    "State": "PR",
    "City": "Hatillo"
  },
  {
    "State": "PR",
    "City": "Hormigueros"
  },
  {
    "State": "PR",
    "City": "Isabela"
  },
  {
    "State": "PR",
    "City": "Jayuya"
  },
  {
    "State": "PR",
    "City": "Lajas"
  },
  {
    "State": "PR",
    "City": "Lares"
  },
  {
    "State": "PR",
    "City": "Las Marias"
  },
  {
    "State": "PR",
    "City": "Manati"
  },
  {
    "State": "PR",
    "City": "Moca"
  },
  {
    "State": "PR",
    "City": "Rincon"
  },
  {
    "State": "PR",
    "City": "Quebradillas"
  },
  {
    "State": "PR",
    "City": "Mayaguez"
  },
  {
    "State": "PR",
    "City": "San German"
  },
  {
    "State": "PR",
    "City": "San Sebastian"
  },
  {
    "State": "PR",
    "City": "Morovis"
  },
  {
    "State": "PR",
    "City": "Sabana Hoyos"
  },
  {
    "State": "PR",
    "City": "San Antonio"
  },
  {
    "State": "PR",
    "City": "Vega Alta"
  },
  {
    "State": "PR",
    "City": "Vega Baja"
  },
  {
    "State": "PR",
    "City": "Yauco"
  },
  {
    "State": "PR",
    "City": "Aguas Buenas"
  },
  {
    "State": "PR",
    "City": "Aguirre"
  },
  {
    "State": "PR",
    "City": "Aibonito"
  },
  {
    "State": "PR",
    "City": "Maunabo"
  },
  {
    "State": "PR",
    "City": "Arroyo"
  },
  {
    "State": "PR",
    "City": "Mercedita"
  },
  {
    "State": "PR",
    "City": "Ponce"
  },
  {
    "State": "PR",
    "City": "Naguabo"
  },
  {
    "State": "PR",
    "City": "Naranjito"
  },
  {
    "State": "PR",
    "City": "Orocovis"
  },
  {
    "State": "PR",
    "City": "Palmer"
  },
  {
    "State": "PR",
    "City": "Patillas"
  },
  {
    "State": "PR",
    "City": "Caguas"
  },
  {
    "State": "PR",
    "City": "Canovanas"
  },
  {
    "State": "PR",
    "City": "Ceiba"
  },
  {
    "State": "PR",
    "City": "Cayey"
  },
  {
    "State": "PR",
    "City": "Fajardo"
  },
  {
    "State": "PR",
    "City": "Cidra"
  },
  {
    "State": "PR",
    "City": "Puerto Real"
  },
  {
    "State": "PR",
    "City": "Punta Santiago"
  },
  {
    "State": "PR",
    "City": "Roosevelt Roads"
  },
  {
    "State": "PR",
    "City": "Rio Blanco"
  },
  {
    "State": "PR",
    "City": "Rio Grande"
  },
  {
    "State": "PR",
    "City": "Salinas"
  },
  {
    "State": "PR",
    "City": "San Lorenzo"
  },
  {
    "State": "PR",
    "City": "Santa Isabel"
  },
  {
    "State": "PR",
    "City": "Vieques"
  },
  {
    "State": "PR",
    "City": "Villalba"
  },
  {
    "State": "PR",
    "City": "Yabucoa"
  },
  {
    "State": "PR",
    "City": "Coamo"
  },
  {
    "State": "PR",
    "City": "Las Piedras"
  },
  {
    "State": "PR",
    "City": "Loiza"
  },
  {
    "State": "PR",
    "City": "Luquillo"
  },
  {
    "State": "PR",
    "City": "Culebra"
  },
  {
    "State": "PR",
    "City": "Juncos"
  },
  {
    "State": "PR",
    "City": "Gurabo"
  },
  {
    "State": "PR",
    "City": "Coto Laurel"
  },
  {
    "State": "PR",
    "City": "Comerio"
  },
  {
    "State": "PR",
    "City": "Corozal"
  },
  {
    "State": "PR",
    "City": "Guayama"
  },
  {
    "State": "PR",
    "City": "La Plata"
  },
  {
    "State": "PR",
    "City": "Humacao"
  },
  {
    "State": "PR",
    "City": "Barranquitas"
  },
  {
    "State": "PR",
    "City": "Juana Diaz"
  },
  {
    "State": "VI",
    "City": "St Thomas"
  },
  {
    "State": "VI",
    "City": "Christiansted"
  },
  {
    "State": "VI",
    "City": "St John"
  },
  {
    "State": "VI",
    "City": "Frederiksted"
  },
  {
    "State": "VI",
    "City": "Kingshill"
  },
  {
    "State": "PR",
    "City": "San Juan"
  },
  {
    "State": "PR",
    "City": "Fort Buchanan"
  },
  {
    "State": "PR",
    "City": "Toa Baja"
  },
  {
    "State": "PR",
    "City": "Sabana Seca"
  },
  {
    "State": "PR",
    "City": "Toa Alta"
  },
  {
    "State": "PR",
    "City": "Bayamon"
  },
  {
    "State": "PR",
    "City": "Catano"
  },
  {
    "State": "PR",
    "City": "Guaynabo"
  },
  {
    "State": "PR",
    "City": "Trujillo Alto"
  },
  {
    "State": "PR",
    "City": "Saint Just"
  },
  {
    "State": "PR",
    "City": "Carolina"
  },
  {
    "State": "MA",
    "City": "Agawam"
  },
  {
    "State": "MA",
    "City": "Amherst"
  },
  {
    "State": "MA",
    "City": "Barre"
  },
  {
    "State": "MA",
    "City": "Belchertown"
  },
  {
    "State": "MA",
    "City": "Blandford"
  },
  {
    "State": "MA",
    "City": "Bondsville"
  },
  {
    "State": "MA",
    "City": "Brimfield"
  },
  {
    "State": "MA",
    "City": "Chester"
  },
  {
    "State": "MA",
    "City": "Chesterfield"
  },
  {
    "State": "MA",
    "City": "Chicopee"
  },
  {
    "State": "MA",
    "City": "Cummington"
  },
  {
    "State": "MA",
    "City": "Easthampton"
  },
  {
    "State": "MA",
    "City": "East Longmeadow"
  },
  {
    "State": "MA",
    "City": "East Otis"
  },
  {
    "State": "MA",
    "City": "Feeding Hills"
  },
  {
    "State": "MA",
    "City": "Gilbertville"
  },
  {
    "State": "MA",
    "City": "Goshen"
  },
  {
    "State": "MA",
    "City": "Granby"
  },
  {
    "State": "MA",
    "City": "Granville"
  },
  {
    "State": "MA",
    "City": "Hadley"
  },
  {
    "State": "MA",
    "City": "Hampden"
  },
  {
    "State": "MA",
    "City": "Hardwick"
  },
  {
    "State": "MA",
    "City": "Hatfield"
  },
  {
    "State": "MA",
    "City": "Haydenville"
  },
  {
    "State": "MA",
    "City": "Holyoke"
  },
  {
    "State": "MA",
    "City": "Huntington"
  },
  {
    "State": "MA",
    "City": "Leeds"
  },
  {
    "State": "MA",
    "City": "Leverett"
  },
  {
    "State": "MA",
    "City": "Ludlow"
  },
  {
    "State": "MA",
    "City": "Monson"
  },
  {
    "State": "MA",
    "City": "North Amherst"
  },
  {
    "State": "MA",
    "City": "Northampton"
  },
  {
    "State": "MA",
    "City": "Florence"
  },
  {
    "State": "MA",
    "City": "North Hatfield"
  },
  {
    "State": "MA",
    "City": "Oakham"
  },
  {
    "State": "MA",
    "City": "Palmer"
  },
  {
    "State": "MA",
    "City": "Plainfield"
  },
  {
    "State": "MA",
    "City": "Russell"
  },
  {
    "State": "MA",
    "City": "Shutesbury"
  },
  {
    "State": "MA",
    "City": "Southampton"
  },
  {
    "State": "MA",
    "City": "South Barre"
  },
  {
    "State": "MA",
    "City": "South Hadley"
  },
  {
    "State": "MA",
    "City": "Southwick"
  },
  {
    "State": "MA",
    "City": "Thorndike"
  },
  {
    "State": "MA",
    "City": "Three Rivers"
  },
  {
    "State": "MA",
    "City": "Wales"
  },
  {
    "State": "MA",
    "City": "Ware"
  },
  {
    "State": "MA",
    "City": "Warren"
  },
  {
    "State": "MA",
    "City": "West Chesterfield"
  },
  {
    "State": "MA",
    "City": "Westfield"
  },
  {
    "State": "MA",
    "City": "West Hatfield"
  },
  {
    "State": "MA",
    "City": "West Springfield"
  },
  {
    "State": "MA",
    "City": "West Warren"
  },
  {
    "State": "MA",
    "City": "Whately"
  },
  {
    "State": "MA",
    "City": "Wheelwright"
  },
  {
    "State": "MA",
    "City": "Wilbraham"
  },
  {
    "State": "MA",
    "City": "Williamsburg"
  },
  {
    "State": "MA",
    "City": "Woronoco"
  },
  {
    "State": "MA",
    "City": "Worthington"
  },
  {
    "State": "MA",
    "City": "Springfield"
  },
  {
    "State": "MA",
    "City": "Longmeadow"
  },
  {
    "State": "MA",
    "City": "Indian Orchard"
  },
  {
    "State": "MA",
    "City": "Pittsfield"
  },
  {
    "State": "MA",
    "City": "Adams"
  },
  {
    "State": "MA",
    "City": "Ashley Falls"
  },
  {
    "State": "MA",
    "City": "Becket"
  },
  {
    "State": "MA",
    "City": "Berkshire"
  },
  {
    "State": "MA",
    "City": "Cheshire"
  },
  {
    "State": "MA",
    "City": "Dalton"
  },
  {
    "State": "MA",
    "City": "Glendale"
  },
  {
    "State": "MA",
    "City": "Great Barrington"
  },
  {
    "State": "MA",
    "City": "Hinsdale"
  },
  {
    "State": "MA",
    "City": "Housatonic"
  },
  {
    "State": "MA",
    "City": "Lanesborough"
  },
  {
    "State": "MA",
    "City": "Lee"
  },
  {
    "State": "MA",
    "City": "Lenox"
  },
  {
    "State": "MA",
    "City": "Lenox Dale"
  },
  {
    "State": "MA",
    "City": "Middlefield"
  },
  {
    "State": "MA",
    "City": "Mill River"
  },
  {
    "State": "MA",
    "City": "Monterey"
  },
  {
    "State": "MA",
    "City": "North Adams"
  },
  {
    "State": "MA",
    "City": "North Egremont"
  },
  {
    "State": "MA",
    "City": "Otis"
  },
  {
    "State": "MA",
    "City": "Richmond"
  },
  {
    "State": "MA",
    "City": "Sandisfield"
  },
  {
    "State": "MA",
    "City": "Savoy"
  },
  {
    "State": "MA",
    "City": "Sheffield"
  },
  {
    "State": "MA",
    "City": "South Egremont"
  },
  {
    "State": "MA",
    "City": "Southfield"
  },
  {
    "State": "MA",
    "City": "South Lee"
  },
  {
    "State": "MA",
    "City": "Stockbridge"
  },
  {
    "State": "MA",
    "City": "Tyringham"
  },
  {
    "State": "MA",
    "City": "West Stockbridge"
  },
  {
    "State": "MA",
    "City": "Williamstown"
  },
  {
    "State": "MA",
    "City": "Windsor"
  },
  {
    "State": "MA",
    "City": "Greenfield"
  },
  {
    "State": "MA",
    "City": "Ashfield"
  },
  {
    "State": "MA",
    "City": "Athol"
  },
  {
    "State": "MA",
    "City": "Bernardston"
  },
  {
    "State": "MA",
    "City": "Buckland"
  },
  {
    "State": "MA",
    "City": "Charlemont"
  },
  {
    "State": "MA",
    "City": "Colrain"
  },
  {
    "State": "MA",
    "City": "Conway"
  },
  {
    "State": "MA",
    "City": "Deerfield"
  },
  {
    "State": "MA",
    "City": "Drury"
  },
  {
    "State": "MA",
    "City": "Erving"
  },
  {
    "State": "MA",
    "City": "Heath"
  },
  {
    "State": "MA",
    "City": "Lake Pleasant"
  },
  {
    "State": "MA",
    "City": "Millers Falls"
  },
  {
    "State": "MA",
    "City": "Monroe Bridge"
  },
  {
    "State": "MA",
    "City": "Montague"
  },
  {
    "State": "MA",
    "City": "Gill"
  },
  {
    "State": "MA",
    "City": "New Salem"
  },
  {
    "State": "MA",
    "City": "Northfield"
  },
  {
    "State": "MA",
    "City": "Orange"
  },
  {
    "State": "MA",
    "City": "Petersham"
  },
  {
    "State": "MA",
    "City": "Rowe"
  },
  {
    "State": "MA",
    "City": "Royalston"
  },
  {
    "State": "MA",
    "City": "Shelburne Falls"
  },
  {
    "State": "MA",
    "City": "South Deerfield"
  },
  {
    "State": "MA",
    "City": "Sunderland"
  },
  {
    "State": "MA",
    "City": "Turners Falls"
  },
  {
    "State": "MA",
    "City": "Warwick"
  },
  {
    "State": "MA",
    "City": "Wendell"
  },
  {
    "State": "MA",
    "City": "Wendell Depot"
  },
  {
    "State": "MA",
    "City": "Fitchburg"
  },
  {
    "State": "MA",
    "City": "Ashburnham"
  },
  {
    "State": "MA",
    "City": "Ashby"
  },
  {
    "State": "MA",
    "City": "Ayer"
  },
  {
    "State": "MA",
    "City": "Devens"
  },
  {
    "State": "MA",
    "City": "Baldwinville"
  },
  {
    "State": "MA",
    "City": "East Templeton"
  },
  {
    "State": "MA",
    "City": "Gardner"
  },
  {
    "State": "MA",
    "City": "Westminster"
  },
  {
    "State": "MA",
    "City": "Groton"
  },
  {
    "State": "MA",
    "City": "Harvard"
  },
  {
    "State": "MA",
    "City": "Hubbardston"
  },
  {
    "State": "MA",
    "City": "Leominster"
  },
  {
    "State": "MA",
    "City": "Littleton"
  },
  {
    "State": "MA",
    "City": "Lunenburg"
  },
  {
    "State": "MA",
    "City": "Pepperell"
  },
  {
    "State": "MA",
    "City": "Shirley"
  },
  {
    "State": "MA",
    "City": "Still River"
  },
  {
    "State": "MA",
    "City": "Templeton"
  },
  {
    "State": "MA",
    "City": "Townsend"
  },
  {
    "State": "MA",
    "City": "West Groton"
  },
  {
    "State": "MA",
    "City": "West Townsend"
  },
  {
    "State": "MA",
    "City": "Winchendon"
  },
  {
    "State": "MA",
    "City": "Winchendon Springs"
  },
  {
    "State": "MA",
    "City": "Auburn"
  },
  {
    "State": "MA",
    "City": "Berlin"
  },
  {
    "State": "MA",
    "City": "Blackstone"
  },
  {
    "State": "MA",
    "City": "Boylston"
  },
  {
    "State": "MA",
    "City": "Brookfield"
  },
  {
    "State": "MA",
    "City": "Charlton"
  },
  {
    "State": "MA",
    "City": "Charlton City"
  },
  {
    "State": "MA",
    "City": "Charlton Depot"
  },
  {
    "State": "MA",
    "City": "Clinton"
  },
  {
    "State": "MA",
    "City": "East Brookfield"
  },
  {
    "State": "MA",
    "City": "Douglas"
  },
  {
    "State": "MA",
    "City": "East Princeton"
  },
  {
    "State": "MA",
    "City": "Fiskdale"
  },
  {
    "State": "MA",
    "City": "Grafton"
  },
  {
    "State": "MA",
    "City": "Holden"
  },
  {
    "State": "MA",
    "City": "Holland"
  },
  {
    "State": "MA",
    "City": "Jefferson"
  },
  {
    "State": "MA",
    "City": "Lancaster"
  },
  {
    "State": "MA",
    "City": "Leicester"
  },
  {
    "State": "MA",
    "City": "Linwood"
  },
  {
    "State": "MA",
    "City": "Manchaug"
  },
  {
    "State": "MA",
    "City": "Millbury"
  },
  {
    "State": "MA",
    "City": "Millville"
  },
  {
    "State": "MA",
    "City": "New Braintree"
  },
  {
    "State": "MA",
    "City": "Northborough"
  },
  {
    "State": "MA",
    "City": "Northbridge"
  },
  {
    "State": "MA",
    "City": "North Brookfield"
  },
  {
    "State": "MA",
    "City": "North Grafton"
  },
  {
    "State": "MA",
    "City": "North Oxford"
  },
  {
    "State": "MA",
    "City": "North Uxbridge"
  },
  {
    "State": "MA",
    "City": "Oxford"
  },
  {
    "State": "MA",
    "City": "Princeton"
  },
  {
    "State": "MA",
    "City": "Rochdale"
  },
  {
    "State": "MA",
    "City": "Rutland"
  },
  {
    "State": "MA",
    "City": "Shrewsbury"
  },
  {
    "State": "MA",
    "City": "Southbridge"
  },
  {
    "State": "MA",
    "City": "South Grafton"
  },
  {
    "State": "MA",
    "City": "South Lancaster"
  },
  {
    "State": "MA",
    "City": "Spencer"
  },
  {
    "State": "MA",
    "City": "Sterling"
  },
  {
    "State": "MA",
    "City": "Sturbridge"
  },
  {
    "State": "MA",
    "City": "Upton"
  },
  {
    "State": "MA",
    "City": "Uxbridge"
  },
  {
    "State": "MA",
    "City": "Webster"
  },
  {
    "State": "MA",
    "City": "Dudley"
  },
  {
    "State": "MA",
    "City": "Westborough"
  },
  {
    "State": "MA",
    "City": "West Boylston"
  },
  {
    "State": "MA",
    "City": "West Brookfield"
  },
  {
    "State": "MA",
    "City": "West Millbury"
  },
  {
    "State": "MA",
    "City": "Whitinsville"
  },
  {
    "State": "MA",
    "City": "Sutton"
  },
  {
    "State": "MA",
    "City": "Worcester"
  },
  {
    "State": "MA",
    "City": "Cherry Valley"
  },
  {
    "State": "MA",
    "City": "Paxton"
  },
  {
    "State": "MA",
    "City": "Framingham"
  },
  {
    "State": "MA",
    "City": "Acton"
  },
  {
    "State": "MA",
    "City": "Boxborough"
  },
  {
    "State": "MA",
    "City": "Ashland"
  },
  {
    "State": "MA",
    "City": "Bedford"
  },
  {
    "State": "MA",
    "City": "Hanscom AFB"
  },
  {
    "State": "MA",
    "City": "Bolton"
  },
  {
    "State": "MA",
    "City": "Carlisle"
  },
  {
    "State": "MA",
    "City": "Concord"
  },
  {
    "State": "MA",
    "City": "Fayville"
  },
  {
    "State": "MA",
    "City": "Holliston"
  },
  {
    "State": "MA",
    "City": "Hopedale"
  },
  {
    "State": "MA",
    "City": "Hopkinton"
  },
  {
    "State": "MA",
    "City": "Hudson"
  },
  {
    "State": "MA",
    "City": "Marlborough"
  },
  {
    "State": "MA",
    "City": "Maynard"
  },
  {
    "State": "MA",
    "City": "Mendon"
  },
  {
    "State": "MA",
    "City": "Milford"
  },
  {
    "State": "MA",
    "City": "Natick"
  },
  {
    "State": "MA",
    "City": "Sherborn"
  },
  {
    "State": "MA",
    "City": "Southborough"
  },
  {
    "State": "MA",
    "City": "Lincoln"
  },
  {
    "State": "MA",
    "City": "Stow"
  },
  {
    "State": "MA",
    "City": "Sudbury"
  },
  {
    "State": "MA",
    "City": "Wayland"
  },
  {
    "State": "MA",
    "City": "Woodville"
  },
  {
    "State": "MA",
    "City": "Woburn"
  },
  {
    "State": "MA",
    "City": "Burlington"
  },
  {
    "State": "MA",
    "City": "Andover"
  },
  {
    "State": "MA",
    "City": "Billerica"
  },
  {
    "State": "MA",
    "City": "Chelmsford"
  },
  {
    "State": "MA",
    "City": "Dracut"
  },
  {
    "State": "MA",
    "City": "Dunstable"
  },
  {
    "State": "MA",
    "City": "Haverhill"
  },
  {
    "State": "MA",
    "City": "Georgetown"
  },
  {
    "State": "MA",
    "City": "Groveland"
  },
  {
    "State": "MA",
    "City": "Lawrence"
  },
  {
    "State": "MA",
    "City": "Methuen"
  },
  {
    "State": "MA",
    "City": "North Andover"
  },
  {
    "State": "MA",
    "City": "Lowell"
  },
  {
    "State": "MA",
    "City": "Merrimac"
  },
  {
    "State": "MA",
    "City": "North Billerica"
  },
  {
    "State": "MA",
    "City": "North Chelmsford"
  },
  {
    "State": "MA",
    "City": "North Reading"
  },
  {
    "State": "MA",
    "City": "Nutting Lake"
  },
  {
    "State": "MA",
    "City": "Pinehurst"
  },
  {
    "State": "MA",
    "City": "Reading"
  },
  {
    "State": "MA",
    "City": "Tewksbury"
  },
  {
    "State": "MA",
    "City": "Tyngsboro"
  },
  {
    "State": "MA",
    "City": "Wakefield"
  },
  {
    "State": "MA",
    "City": "West Boxford"
  },
  {
    "State": "MA",
    "City": "Westford"
  },
  {
    "State": "MA",
    "City": "Wilmington"
  },
  {
    "State": "MA",
    "City": "Winchester"
  },
  {
    "State": "MA",
    "City": "Lynn"
  },
  {
    "State": "MA",
    "City": "Saugus"
  },
  {
    "State": "MA",
    "City": "Swampscott"
  },
  {
    "State": "MA",
    "City": "Nahant"
  },
  {
    "State": "MA",
    "City": "Amesbury"
  },
  {
    "State": "MA",
    "City": "Beverly"
  },
  {
    "State": "MA",
    "City": "Boxford"
  },
  {
    "State": "MA",
    "City": "Byfield"
  },
  {
    "State": "MA",
    "City": "Danvers"
  },
  {
    "State": "MA",
    "City": "Essex"
  },
  {
    "State": "MA",
    "City": "Gloucester"
  },
  {
    "State": "MA",
    "City": "Hamilton"
  },
  {
    "State": "MA",
    "City": "Hathorne"
  },
  {
    "State": "MA",
    "City": "Ipswich"
  },
  {
    "State": "MA",
    "City": "Lynnfield"
  },
  {
    "State": "MA",
    "City": "Manchester"
  },
  {
    "State": "MA",
    "City": "Marblehead"
  },
  {
    "State": "MA",
    "City": "Middleton"
  },
  {
    "State": "MA",
    "City": "Newburyport"
  },
  {
    "State": "MA",
    "City": "Newbury"
  },
  {
    "State": "MA",
    "City": "Salisbury"
  },
  {
    "State": "MA",
    "City": "Peabody"
  },
  {
    "State": "MA",
    "City": "Prides Crossing"
  },
  {
    "State": "MA",
    "City": "Rockport"
  },
  {
    "State": "MA",
    "City": "Rowley"
  },
  {
    "State": "MA",
    "City": "Salem"
  },
  {
    "State": "MA",
    "City": "South Hamilton"
  },
  {
    "State": "MA",
    "City": "Topsfield"
  },
  {
    "State": "MA",
    "City": "Wenham"
  },
  {
    "State": "MA",
    "City": "West Newbury"
  },
  {
    "State": "MA",
    "City": "Accord"
  },
  {
    "State": "MA",
    "City": "Bellingham"
  },
  {
    "State": "MA",
    "City": "Brant Rock"
  },
  {
    "State": "MA",
    "City": "Canton"
  },
  {
    "State": "MA",
    "City": "Cohasset"
  },
  {
    "State": "MA",
    "City": "Dedham"
  },
  {
    "State": "MA",
    "City": "Dover"
  },
  {
    "State": "MA",
    "City": "East Mansfield"
  },
  {
    "State": "MA",
    "City": "East Walpole"
  },
  {
    "State": "MA",
    "City": "Foxboro"
  },
  {
    "State": "MA",
    "City": "Franklin"
  },
  {
    "State": "MA",
    "City": "Greenbush"
  },
  {
    "State": "MA",
    "City": "Green Harbor"
  },
  {
    "State": "MA",
    "City": "Hingham"
  },
  {
    "State": "MA",
    "City": "Hull"
  },
  {
    "State": "MA",
    "City": "Humarock"
  },
  {
    "State": "MA",
    "City": "Mansfield"
  },
  {
    "State": "MA",
    "City": "Marshfield"
  },
  {
    "State": "MA",
    "City": "Marshfield Hills"
  },
  {
    "State": "MA",
    "City": "Medfield"
  },
  {
    "State": "MA",
    "City": "Medway"
  },
  {
    "State": "MA",
    "City": "Millis"
  },
  {
    "State": "MA",
    "City": "Minot"
  },
  {
    "State": "MA",
    "City": "Norfolk"
  },
  {
    "State": "MA",
    "City": "North Marshfield"
  },
  {
    "State": "MA",
    "City": "North Scituate"
  },
  {
    "State": "MA",
    "City": "Norwell"
  },
  {
    "State": "MA",
    "City": "Norwood"
  },
  {
    "State": "MA",
    "City": "Ocean Bluff"
  },
  {
    "State": "MA",
    "City": "Scituate"
  },
  {
    "State": "MA",
    "City": "Sharon"
  },
  {
    "State": "MA",
    "City": "Sheldonville"
  },
  {
    "State": "MA",
    "City": "South Walpole"
  },
  {
    "State": "MA",
    "City": "Stoughton"
  },
  {
    "State": "MA",
    "City": "Walpole"
  },
  {
    "State": "MA",
    "City": "Westwood"
  },
  {
    "State": "MA",
    "City": "Wrentham"
  },
  {
    "State": "MA",
    "City": "Boston"
  },
  {
    "State": "MA",
    "City": "Roxbury"
  },
  {
    "State": "MA",
    "City": "Roxbury Crossing"
  },
  {
    "State": "MA",
    "City": "Dorchester"
  },
  {
    "State": "MA",
    "City": "Dorchester Center"
  },
  {
    "State": "MA",
    "City": "Mattapan"
  },
  {
    "State": "MA",
    "City": "South Boston"
  },
  {
    "State": "MA",
    "City": "East Boston"
  },
  {
    "State": "MA",
    "City": "Charlestown"
  },
  {
    "State": "MA",
    "City": "Jamaica Plain"
  },
  {
    "State": "MA",
    "City": "Roslindale"
  },
  {
    "State": "MA",
    "City": "West Roxbury"
  },
  {
    "State": "MA",
    "City": "Allston"
  },
  {
    "State": "MA",
    "City": "Brighton"
  },
  {
    "State": "MA",
    "City": "Hyde Park"
  },
  {
    "State": "MA",
    "City": "Readville"
  },
  {
    "State": "MA",
    "City": "Cambridge"
  },
  {
    "State": "MA",
    "City": "Somerville"
  },
  {
    "State": "MA",
    "City": "Malden"
  },
  {
    "State": "MA",
    "City": "Everett"
  },
  {
    "State": "MA",
    "City": "Chelsea"
  },
  {
    "State": "MA",
    "City": "Revere"
  },
  {
    "State": "MA",
    "City": "Winthrop"
  },
  {
    "State": "MA",
    "City": "Medford"
  },
  {
    "State": "MA",
    "City": "West Medford"
  },
  {
    "State": "MA",
    "City": "Quincy"
  },
  {
    "State": "MA",
    "City": "Melrose"
  },
  {
    "State": "MA",
    "City": "Stoneham"
  },
  {
    "State": "MA",
    "City": "Braintree"
  },
  {
    "State": "MA",
    "City": "Milton"
  },
  {
    "State": "MA",
    "City": "Milton Village"
  },
  {
    "State": "MA",
    "City": "Weymouth"
  },
  {
    "State": "MA",
    "City": "East Weymouth"
  },
  {
    "State": "MA",
    "City": "South Weymouth"
  },
  {
    "State": "MA",
    "City": "North Weymouth"
  },
  {
    "State": "MA",
    "City": "Brockton"
  },
  {
    "State": "MA",
    "City": "Avon"
  },
  {
    "State": "MA",
    "City": "Bridgewater"
  },
  {
    "State": "MA",
    "City": "Bryantville"
  },
  {
    "State": "MA",
    "City": "Carver"
  },
  {
    "State": "MA",
    "City": "Duxbury"
  },
  {
    "State": "MA",
    "City": "East Bridgewater"
  },
  {
    "State": "MA",
    "City": "Easton"
  },
  {
    "State": "MA",
    "City": "Elmwood"
  },
  {
    "State": "MA",
    "City": "Halifax"
  },
  {
    "State": "MA",
    "City": "Hanover"
  },
  {
    "State": "MA",
    "City": "Hanson"
  },
  {
    "State": "MA",
    "City": "Holbrook"
  },
  {
    "State": "MA",
    "City": "Middleboro"
  },
  {
    "State": "MA",
    "City": "Manomet"
  },
  {
    "State": "MA",
    "City": "Lakeville"
  },
  {
    "State": "MA",
    "City": "Monponsett"
  },
  {
    "State": "MA",
    "City": "Abington"
  },
  {
    "State": "MA",
    "City": "North Carver"
  },
  {
    "State": "MA",
    "City": "North Easton"
  },
  {
    "State": "MA",
    "City": "North Pembroke"
  },
  {
    "State": "MA",
    "City": "Pembroke"
  },
  {
    "State": "MA",
    "City": "Plymouth"
  },
  {
    "State": "MA",
    "City": "Kingston"
  },
  {
    "State": "MA",
    "City": "South Carver"
  },
  {
    "State": "MA",
    "City": "Plympton"
  },
  {
    "State": "MA",
    "City": "Randolph"
  },
  {
    "State": "MA",
    "City": "Rockland"
  },
  {
    "State": "MA",
    "City": "South Easton"
  },
  {
    "State": "MA",
    "City": "West Bridgewater"
  },
  {
    "State": "MA",
    "City": "White Horse Beach"
  },
  {
    "State": "MA",
    "City": "Whitman"
  },
  {
    "State": "MA",
    "City": "Lexington"
  },
  {
    "State": "MA",
    "City": "Brookline"
  },
  {
    "State": "MA",
    "City": "Brookline Village"
  },
  {
    "State": "MA",
    "City": "Waltham"
  },
  {
    "State": "MA",
    "City": "North Waltham"
  },
  {
    "State": "MA",
    "City": "New Town"
  },
  {
    "State": "MA",
    "City": "Babson Park"
  },
  {
    "State": "MA",
    "City": "Newton"
  },
  {
    "State": "MA",
    "City": "Newton Center"
  },
  {
    "State": "MA",
    "City": "Newtonville"
  },
  {
    "State": "MA",
    "City": "Newton Highlands"
  },
  {
    "State": "MA",
    "City": "Newton Lower Falls"
  },
  {
    "State": "MA",
    "City": "Newton Upper Falls"
  },
  {
    "State": "MA",
    "City": "West Newton"
  },
  {
    "State": "MA",
    "City": "Auburndale"
  },
  {
    "State": "MA",
    "City": "Chestnut Hill"
  },
  {
    "State": "MA",
    "City": "Waban"
  },
  {
    "State": "MA",
    "City": "Watertown"
  },
  {
    "State": "MA",
    "City": "Arlington"
  },
  {
    "State": "MA",
    "City": "Arlington Heights"
  },
  {
    "State": "MA",
    "City": "Belmont"
  },
  {
    "State": "MA",
    "City": "Waverley"
  },
  {
    "State": "MA",
    "City": "Wellesley Hills"
  },
  {
    "State": "MA",
    "City": "Wellesley"
  },
  {
    "State": "MA",
    "City": "Needham"
  },
  {
    "State": "MA",
    "City": "Weston"
  },
  {
    "State": "MA",
    "City": "Needham Heights"
  },
  {
    "State": "MA",
    "City": "Nonantum"
  },
  {
    "State": "MA",
    "City": "Buzzards Bay"
  },
  {
    "State": "MA",
    "City": "Cataumet"
  },
  {
    "State": "MA",
    "City": "Chilmark"
  },
  {
    "State": "MA",
    "City": "East Falmouth"
  },
  {
    "State": "MA",
    "City": "East Sandwich"
  },
  {
    "State": "MA",
    "City": "East Wareham"
  },
  {
    "State": "MA",
    "City": "Edgartown"
  },
  {
    "State": "MA",
    "City": "Falmouth"
  },
  {
    "State": "MA",
    "City": "Woods Hole"
  },
  {
    "State": "MA",
    "City": "Menemsha"
  },
  {
    "State": "MA",
    "City": "Monument Beach"
  },
  {
    "State": "MA",
    "City": "Nantucket"
  },
  {
    "State": "MA",
    "City": "North Falmouth"
  },
  {
    "State": "MA",
    "City": "Oak Bluffs"
  },
  {
    "State": "MA",
    "City": "Onset"
  },
  {
    "State": "MA",
    "City": "Pocasset"
  },
  {
    "State": "MA",
    "City": "Sagamore"
  },
  {
    "State": "MA",
    "City": "Sagamore Beach"
  },
  {
    "State": "MA",
    "City": "Sandwich"
  },
  {
    "State": "MA",
    "City": "Siasconset"
  },
  {
    "State": "MA",
    "City": "Silver Beach"
  },
  {
    "State": "MA",
    "City": "Vineyard Haven"
  },
  {
    "State": "MA",
    "City": "Wareham"
  },
  {
    "State": "MA",
    "City": "West Chop"
  },
  {
    "State": "MA",
    "City": "West Falmouth"
  },
  {
    "State": "MA",
    "City": "West Tisbury"
  },
  {
    "State": "MA",
    "City": "West Wareham"
  },
  {
    "State": "MA",
    "City": "Hyannis"
  },
  {
    "State": "MA",
    "City": "Barnstable"
  },
  {
    "State": "MA",
    "City": "Brewster"
  },
  {
    "State": "MA",
    "City": "Centerville"
  },
  {
    "State": "MA",
    "City": "Chatham"
  },
  {
    "State": "MA",
    "City": "Cotuit"
  },
  {
    "State": "MA",
    "City": "Cummaquid"
  },
  {
    "State": "MA",
    "City": "Dennis"
  },
  {
    "State": "MA",
    "City": "Dennis Port"
  },
  {
    "State": "MA",
    "City": "East Dennis"
  },
  {
    "State": "MA",
    "City": "Eastham"
  },
  {
    "State": "MA",
    "City": "East Orleans"
  },
  {
    "State": "MA",
    "City": "Forestdale"
  },
  {
    "State": "MA",
    "City": "Harwich"
  },
  {
    "State": "MA",
    "City": "Harwich Port"
  },
  {
    "State": "MA",
    "City": "Hyannis Port"
  },
  {
    "State": "MA",
    "City": "Marstons Mills"
  },
  {
    "State": "MA",
    "City": "Mashpee"
  },
  {
    "State": "MA",
    "City": "North Chatham"
  },
  {
    "State": "MA",
    "City": "North Eastham"
  },
  {
    "State": "MA",
    "City": "North Truro"
  },
  {
    "State": "MA",
    "City": "Orleans"
  },
  {
    "State": "MA",
    "City": "Osterville"
  },
  {
    "State": "MA",
    "City": "Provincetown"
  },
  {
    "State": "MA",
    "City": "South Chatham"
  },
  {
    "State": "MA",
    "City": "South Dennis"
  },
  {
    "State": "MA",
    "City": "South Harwich"
  },
  {
    "State": "MA",
    "City": "South Orleans"
  },
  {
    "State": "MA",
    "City": "South Wellfleet"
  },
  {
    "State": "MA",
    "City": "South Yarmouth"
  },
  {
    "State": "MA",
    "City": "Truro"
  },
  {
    "State": "MA",
    "City": "Wellfleet"
  },
  {
    "State": "MA",
    "City": "West Barnstable"
  },
  {
    "State": "MA",
    "City": "West Chatham"
  },
  {
    "State": "MA",
    "City": "West Dennis"
  },
  {
    "State": "MA",
    "City": "West Harwich"
  },
  {
    "State": "MA",
    "City": "West Hyannisport"
  },
  {
    "State": "MA",
    "City": "West Yarmouth"
  },
  {
    "State": "MA",
    "City": "Yarmouth Port"
  },
  {
    "State": "MA",
    "City": "Assonet"
  },
  {
    "State": "MA",
    "City": "Attleboro"
  },
  {
    "State": "MA",
    "City": "Chartley"
  },
  {
    "State": "MA",
    "City": "Cuttyhunk"
  },
  {
    "State": "MA",
    "City": "Dartmouth"
  },
  {
    "State": "MA",
    "City": "Dighton"
  },
  {
    "State": "MA",
    "City": "East Freetown"
  },
  {
    "State": "MA",
    "City": "East Taunton"
  },
  {
    "State": "MA",
    "City": "Fairhaven"
  },
  {
    "State": "MA",
    "City": "Fall River"
  },
  {
    "State": "MA",
    "City": "Somerset"
  },
  {
    "State": "MA",
    "City": "Marion"
  },
  {
    "State": "MA",
    "City": "Mattapoisett"
  },
  {
    "State": "MA",
    "City": "New Bedford"
  },
  {
    "State": "MA",
    "City": "Acushnet"
  },
  {
    "State": "MA",
    "City": "North Dartmouth"
  },
  {
    "State": "MA",
    "City": "South Dartmouth"
  },
  {
    "State": "MA",
    "City": "North Attleboro"
  },
  {
    "State": "MA",
    "City": "Plainville"
  },
  {
    "State": "MA",
    "City": "Attleboro Falls"
  },
  {
    "State": "MA",
    "City": "North Dighton"
  },
  {
    "State": "MA",
    "City": "Norton"
  },
  {
    "State": "MA",
    "City": "Raynham"
  },
  {
    "State": "MA",
    "City": "Raynham Center"
  },
  {
    "State": "MA",
    "City": "Rehoboth"
  },
  {
    "State": "MA",
    "City": "Rochester"
  },
  {
    "State": "MA",
    "City": "Seekonk"
  },
  {
    "State": "MA",
    "City": "Swansea"
  },
  {
    "State": "MA",
    "City": "Berkley"
  },
  {
    "State": "MA",
    "City": "Taunton"
  },
  {
    "State": "MA",
    "City": "Westport"
  },
  {
    "State": "MA",
    "City": "Westport Point"
  },
  {
    "State": "RI",
    "City": "Adamsville"
  },
  {
    "State": "RI",
    "City": "Albion"
  },
  {
    "State": "RI",
    "City": "Ashaway"
  },
  {
    "State": "RI",
    "City": "Barrington"
  },
  {
    "State": "RI",
    "City": "Block Island"
  },
  {
    "State": "RI",
    "City": "Bradford"
  },
  {
    "State": "RI",
    "City": "Bristol"
  },
  {
    "State": "RI",
    "City": "Carolina"
  },
  {
    "State": "RI",
    "City": "Charlestown"
  },
  {
    "State": "RI",
    "City": "Chepachet"
  },
  {
    "State": "RI",
    "City": "Clayville"
  },
  {
    "State": "RI",
    "City": "Coventry"
  },
  {
    "State": "RI",
    "City": "West Greenwich"
  },
  {
    "State": "RI",
    "City": "East Greenwich"
  },
  {
    "State": "RI",
    "City": "Exeter"
  },
  {
    "State": "RI",
    "City": "Fiskeville"
  },
  {
    "State": "RI",
    "City": "Forestdale"
  },
  {
    "State": "RI",
    "City": "Foster"
  },
  {
    "State": "RI",
    "City": "Glendale"
  },
  {
    "State": "RI",
    "City": "Greene"
  },
  {
    "State": "RI",
    "City": "Greenville"
  },
  {
    "State": "RI",
    "City": "Harmony"
  },
  {
    "State": "RI",
    "City": "Harrisville"
  },
  {
    "State": "RI",
    "City": "Hope"
  },
  {
    "State": "RI",
    "City": "Hope Valley"
  },
  {
    "State": "RI",
    "City": "Hopkinton"
  },
  {
    "State": "RI",
    "City": "Jamestown"
  },
  {
    "State": "RI",
    "City": "Kenyon"
  },
  {
    "State": "RI",
    "City": "Little Compton"
  },
  {
    "State": "RI",
    "City": "Manville"
  },
  {
    "State": "RI",
    "City": "Mapleville"
  },
  {
    "State": "RI",
    "City": "Newport"
  },
  {
    "State": "RI",
    "City": "Middletown"
  },
  {
    "State": "RI",
    "City": "North Kingstown"
  },
  {
    "State": "RI",
    "City": "North Scituate"
  },
  {
    "State": "RI",
    "City": "Oakland"
  },
  {
    "State": "RI",
    "City": "Pascoag"
  },
  {
    "State": "RI",
    "City": "Pawtucket"
  },
  {
    "State": "RI",
    "City": "Central Falls"
  },
  {
    "State": "RI",
    "City": "Cumberland"
  },
  {
    "State": "RI",
    "City": "Lincoln"
  },
  {
    "State": "RI",
    "City": "Portsmouth"
  },
  {
    "State": "RI",
    "City": "Prudence Island"
  },
  {
    "State": "RI",
    "City": "Rockville"
  },
  {
    "State": "RI",
    "City": "Saunderstown"
  },
  {
    "State": "RI",
    "City": "Shannock"
  },
  {
    "State": "RI",
    "City": "Slatersville"
  },
  {
    "State": "RI",
    "City": "Slocum"
  },
  {
    "State": "RI",
    "City": "Tiverton"
  },
  {
    "State": "RI",
    "City": "Wakefield"
  },
  {
    "State": "RI",
    "City": "Kingston"
  },
  {
    "State": "RI",
    "City": "Narragansett"
  },
  {
    "State": "RI",
    "City": "Peace Dale"
  },
  {
    "State": "RI",
    "City": "Warren"
  },
  {
    "State": "RI",
    "City": "Warwick"
  },
  {
    "State": "RI",
    "City": "Westerly"
  },
  {
    "State": "RI",
    "City": "West Kingston"
  },
  {
    "State": "RI",
    "City": "West Warwick"
  },
  {
    "State": "RI",
    "City": "Wood River Junction"
  },
  {
    "State": "RI",
    "City": "Woonsocket"
  },
  {
    "State": "RI",
    "City": "North Smithfield"
  },
  {
    "State": "RI",
    "City": "Wyoming"
  },
  {
    "State": "RI",
    "City": "Providence"
  },
  {
    "State": "RI",
    "City": "Cranston"
  },
  {
    "State": "RI",
    "City": "North Providence"
  },
  {
    "State": "RI",
    "City": "East Providence"
  },
  {
    "State": "RI",
    "City": "Riverside"
  },
  {
    "State": "RI",
    "City": "Rumford"
  },
  {
    "State": "RI",
    "City": "Smithfield"
  },
  {
    "State": "RI",
    "City": "Johnston"
  },
  {
    "State": "NH",
    "City": "Amherst"
  },
  {
    "State": "NH",
    "City": "Auburn"
  },
  {
    "State": "NH",
    "City": "Brookline"
  },
  {
    "State": "NH",
    "City": "Candia"
  },
  {
    "State": "NH",
    "City": "Chester"
  },
  {
    "State": "NH",
    "City": "Deerfield"
  },
  {
    "State": "NH",
    "City": "Derry"
  },
  {
    "State": "NH",
    "City": "East Candia"
  },
  {
    "State": "NH",
    "City": "East Derry"
  },
  {
    "State": "NH",
    "City": "Epping"
  },
  {
    "State": "NH",
    "City": "Francestown"
  },
  {
    "State": "NH",
    "City": "Fremont"
  },
  {
    "State": "NH",
    "City": "Goffstown"
  },
  {
    "State": "NH",
    "City": "Dunbarton"
  },
  {
    "State": "NH",
    "City": "Greenfield"
  },
  {
    "State": "NH",
    "City": "Greenville"
  },
  {
    "State": "NH",
    "City": "Hollis"
  },
  {
    "State": "NH",
    "City": "Hudson"
  },
  {
    "State": "NH",
    "City": "Litchfield"
  },
  {
    "State": "NH",
    "City": "Londonderry"
  },
  {
    "State": "NH",
    "City": "Merrimack"
  },
  {
    "State": "NH",
    "City": "Milford"
  },
  {
    "State": "NH",
    "City": "Mont Vernon"
  },
  {
    "State": "NH",
    "City": "Nashua"
  },
  {
    "State": "NH",
    "City": "New Boston"
  },
  {
    "State": "NH",
    "City": "New Ipswich"
  },
  {
    "State": "NH",
    "City": "North Salem"
  },
  {
    "State": "NH",
    "City": "Pelham"
  },
  {
    "State": "NH",
    "City": "Raymond"
  },
  {
    "State": "NH",
    "City": "Salem"
  },
  {
    "State": "NH",
    "City": "Lyndeborough"
  },
  {
    "State": "NH",
    "City": "Temple"
  },
  {
    "State": "NH",
    "City": "Wilton"
  },
  {
    "State": "NH",
    "City": "Windham"
  },
  {
    "State": "NH",
    "City": "Manchester"
  },
  {
    "State": "NH",
    "City": "Hooksett"
  },
  {
    "State": "NH",
    "City": "Bedford"
  },
  {
    "State": "NH",
    "City": "Waterville Valley"
  },
  {
    "State": "NH",
    "City": "Andover"
  },
  {
    "State": "NH",
    "City": "Ashland"
  },
  {
    "State": "NH",
    "City": "Barnstead"
  },
  {
    "State": "NH",
    "City": "Belmont"
  },
  {
    "State": "NH",
    "City": "Bradford"
  },
  {
    "State": "NH",
    "City": "Bristol"
  },
  {
    "State": "NH",
    "City": "Campton"
  },
  {
    "State": "NH",
    "City": "Canterbury"
  },
  {
    "State": "NH",
    "City": "Center Barnstead"
  },
  {
    "State": "NH",
    "City": "Center Harbor"
  },
  {
    "State": "NH",
    "City": "Center Sandwich"
  },
  {
    "State": "NH",
    "City": "Contoocook"
  },
  {
    "State": "NH",
    "City": "Danbury"
  },
  {
    "State": "NH",
    "City": "East Andover"
  },
  {
    "State": "NH",
    "City": "Elkins"
  },
  {
    "State": "NH",
    "City": "Epsom"
  },
  {
    "State": "NH",
    "City": "Franklin"
  },
  {
    "State": "NH",
    "City": "Gilmanton"
  },
  {
    "State": "NH",
    "City": "Glencliff"
  },
  {
    "State": "NH",
    "City": "Grafton"
  },
  {
    "State": "NH",
    "City": "Hebron"
  },
  {
    "State": "NH",
    "City": "Henniker"
  },
  {
    "State": "NH",
    "City": "Hill"
  },
  {
    "State": "NH",
    "City": "Hillsborough"
  },
  {
    "State": "NH",
    "City": "Holderness"
  },
  {
    "State": "NH",
    "City": "Laconia"
  },
  {
    "State": "NH",
    "City": "Gilford"
  },
  {
    "State": "NH",
    "City": "Lincoln"
  },
  {
    "State": "NH",
    "City": "Lochmere"
  },
  {
    "State": "NH",
    "City": "Meredith"
  },
  {
    "State": "NH",
    "City": "Moultonborough"
  },
  {
    "State": "NH",
    "City": "Newbury"
  },
  {
    "State": "NH",
    "City": "New Hampton"
  },
  {
    "State": "NH",
    "City": "New London"
  },
  {
    "State": "NH",
    "City": "Chichester"
  },
  {
    "State": "NH",
    "City": "North Sandwich"
  },
  {
    "State": "NH",
    "City": "North Sutton"
  },
  {
    "State": "NH",
    "City": "Northwood"
  },
  {
    "State": "NH",
    "City": "North Woodstock"
  },
  {
    "State": "NH",
    "City": "Pittsfield"
  },
  {
    "State": "NH",
    "City": "Plymouth"
  },
  {
    "State": "NH",
    "City": "Rumney"
  },
  {
    "State": "NH",
    "City": "Salisbury"
  },
  {
    "State": "NH",
    "City": "Sanbornton"
  },
  {
    "State": "NH",
    "City": "South Newbury"
  },
  {
    "State": "NH",
    "City": "South Sutton"
  },
  {
    "State": "NH",
    "City": "Stinson Lake"
  },
  {
    "State": "NH",
    "City": "Suncook"
  },
  {
    "State": "NH",
    "City": "Tilton"
  },
  {
    "State": "NH",
    "City": "Warner"
  },
  {
    "State": "NH",
    "City": "Warren"
  },
  {
    "State": "NH",
    "City": "Washington"
  },
  {
    "State": "NH",
    "City": "Weare"
  },
  {
    "State": "NH",
    "City": "Wentworth"
  },
  {
    "State": "NH",
    "City": "Springfield"
  },
  {
    "State": "NH",
    "City": "Thornton"
  },
  {
    "State": "NH",
    "City": "Wilmot"
  },
  {
    "State": "NH",
    "City": "Winnisquam"
  },
  {
    "State": "NH",
    "City": "Nottingham"
  },
  {
    "State": "NH",
    "City": "West Nottingham"
  },
  {
    "State": "NH",
    "City": "Woodstock"
  },
  {
    "State": "NH",
    "City": "Concord"
  },
  {
    "State": "NH",
    "City": "Bow"
  },
  {
    "State": "NH",
    "City": "Loudon"
  },
  {
    "State": "NH",
    "City": "Keene"
  },
  {
    "State": "NH",
    "City": "Antrim"
  },
  {
    "State": "NH",
    "City": "Ashuelot"
  },
  {
    "State": "NH",
    "City": "Bennington"
  },
  {
    "State": "NH",
    "City": "Chesterfield"
  },
  {
    "State": "NH",
    "City": "Dublin"
  },
  {
    "State": "NH",
    "City": "Sullivan"
  },
  {
    "State": "NH",
    "City": "Swanzey"
  },
  {
    "State": "NH",
    "City": "Fitzwilliam"
  },
  {
    "State": "NH",
    "City": "Gilsum"
  },
  {
    "State": "NH",
    "City": "Hancock"
  },
  {
    "State": "NH",
    "City": "Harrisville"
  },
  {
    "State": "NH",
    "City": "Hinsdale"
  },
  {
    "State": "NH",
    "City": "Jaffrey"
  },
  {
    "State": "NH",
    "City": "Marlborough"
  },
  {
    "State": "NH",
    "City": "Marlow"
  },
  {
    "State": "NH",
    "City": "Nelson"
  },
  {
    "State": "NH",
    "City": "Peterborough"
  },
  {
    "State": "NH",
    "City": "Rindge"
  },
  {
    "State": "NH",
    "City": "Spofford"
  },
  {
    "State": "NH",
    "City": "Stoddard"
  },
  {
    "State": "NH",
    "City": "Troy"
  },
  {
    "State": "NH",
    "City": "West Chesterfield"
  },
  {
    "State": "NH",
    "City": "Westmoreland"
  },
  {
    "State": "NH",
    "City": "West Peterborough"
  },
  {
    "State": "NH",
    "City": "West Swanzey"
  },
  {
    "State": "NH",
    "City": "Winchester"
  },
  {
    "State": "NH",
    "City": "Littleton"
  },
  {
    "State": "NH",
    "City": "Berlin"
  },
  {
    "State": "NH",
    "City": "Bethlehem"
  },
  {
    "State": "NH",
    "City": "Bretton Woods"
  },
  {
    "State": "NH",
    "City": "Colebrook"
  },
  {
    "State": "NH",
    "City": "Errol"
  },
  {
    "State": "NH",
    "City": "Franconia"
  },
  {
    "State": "NH",
    "City": "Gorham"
  },
  {
    "State": "NH",
    "City": "Groveton"
  },
  {
    "State": "NH",
    "City": "Jefferson"
  },
  {
    "State": "NH",
    "City": "Lancaster"
  },
  {
    "State": "NH",
    "City": "Lisbon"
  },
  {
    "State": "NH",
    "City": "Sugar Hill"
  },
  {
    "State": "NH",
    "City": "Milan"
  },
  {
    "State": "NH",
    "City": "Mount Washington"
  },
  {
    "State": "NH",
    "City": "North Stratford"
  },
  {
    "State": "NH",
    "City": "Pittsburg"
  },
  {
    "State": "NH",
    "City": "Randolph"
  },
  {
    "State": "NH",
    "City": "Twin Mountain"
  },
  {
    "State": "NH",
    "City": "West Stewartstown"
  },
  {
    "State": "NH",
    "City": "Whitefield"
  },
  {
    "State": "NH",
    "City": "Acworth"
  },
  {
    "State": "NH",
    "City": "Alstead"
  },
  {
    "State": "NH",
    "City": "Charlestown"
  },
  {
    "State": "NH",
    "City": "Drewsville"
  },
  {
    "State": "NH",
    "City": "Lempster"
  },
  {
    "State": "NH",
    "City": "South Acworth"
  },
  {
    "State": "NH",
    "City": "Walpole"
  },
  {
    "State": "NH",
    "City": "North Walpole"
  },
  {
    "State": "NH",
    "City": "Bath"
  },
  {
    "State": "NH",
    "City": "Canaan"
  },
  {
    "State": "NH",
    "City": "Claremont"
  },
  {
    "State": "NH",
    "City": "Cornish"
  },
  {
    "State": "NH",
    "City": "Cornish Flat"
  },
  {
    "State": "NH",
    "City": "Enfield"
  },
  {
    "State": "NH",
    "City": "Enfield Center"
  },
  {
    "State": "NH",
    "City": "Etna"
  },
  {
    "State": "NH",
    "City": "Georges Mills"
  },
  {
    "State": "NH",
    "City": "Goshen"
  },
  {
    "State": "NH",
    "City": "Grantham"
  },
  {
    "State": "NH",
    "City": "Guild"
  },
  {
    "State": "NH",
    "City": "Hanover"
  },
  {
    "State": "NH",
    "City": "Lebanon"
  },
  {
    "State": "NH",
    "City": "Haverhill"
  },
  {
    "State": "NH",
    "City": "Lyme"
  },
  {
    "State": "NH",
    "City": "Lyme Center"
  },
  {
    "State": "NH",
    "City": "Meriden"
  },
  {
    "State": "NH",
    "City": "Monroe"
  },
  {
    "State": "NH",
    "City": "Newport"
  },
  {
    "State": "NH",
    "City": "North Haverhill"
  },
  {
    "State": "NH",
    "City": "Orford"
  },
  {
    "State": "NH",
    "City": "Piermont"
  },
  {
    "State": "NH",
    "City": "Pike"
  },
  {
    "State": "NH",
    "City": "Plainfield"
  },
  {
    "State": "NH",
    "City": "Sunapee"
  },
  {
    "State": "NH",
    "City": "West Lebanon"
  },
  {
    "State": "NH",
    "City": "Woodsville"
  },
  {
    "State": "NH",
    "City": "Portsmouth"
  },
  {
    "State": "NH",
    "City": "Newington"
  },
  {
    "State": "NH",
    "City": "Alton"
  },
  {
    "State": "NH",
    "City": "Alton Bay"
  },
  {
    "State": "NH",
    "City": "Atkinson"
  },
  {
    "State": "NH",
    "City": "Bartlett"
  },
  {
    "State": "NH",
    "City": "Center Conway"
  },
  {
    "State": "NH",
    "City": "Center Ossipee"
  },
  {
    "State": "NH",
    "City": "Center Strafford"
  },
  {
    "State": "NH",
    "City": "Center Tuftonboro"
  },
  {
    "State": "NH",
    "City": "Chocorua"
  },
  {
    "State": "NH",
    "City": "Conway"
  },
  {
    "State": "NH",
    "City": "Danville"
  },
  {
    "State": "NH",
    "City": "Dover"
  },
  {
    "State": "NH",
    "City": "Madbury"
  },
  {
    "State": "NH",
    "City": "Durham"
  },
  {
    "State": "NH",
    "City": "Barrington"
  },
  {
    "State": "NH",
    "City": "East Hampstead"
  },
  {
    "State": "NH",
    "City": "East Kingston"
  },
  {
    "State": "NH",
    "City": "East Wakefield"
  },
  {
    "State": "NH",
    "City": "Eaton Center"
  },
  {
    "State": "NH",
    "City": "Exeter"
  },
  {
    "State": "NH",
    "City": "Farmington"
  },
  {
    "State": "NH",
    "City": "Freedom"
  },
  {
    "State": "NH",
    "City": "Gilmanton Iron Works"
  },
  {
    "State": "NH",
    "City": "Glen"
  },
  {
    "State": "NH",
    "City": "Rochester"
  },
  {
    "State": "NH",
    "City": "Greenland"
  },
  {
    "State": "NH",
    "City": "Hampstead"
  },
  {
    "State": "NH",
    "City": "Hampton"
  },
  {
    "State": "NH",
    "City": "Hampton Falls"
  },
  {
    "State": "NH",
    "City": "Intervale"
  },
  {
    "State": "NH",
    "City": "Jackson"
  },
  {
    "State": "NH",
    "City": "Kearsarge"
  },
  {
    "State": "NH",
    "City": "Kingston"
  },
  {
    "State": "NH",
    "City": "Madison"
  },
  {
    "State": "NH",
    "City": "Melvin Village"
  },
  {
    "State": "NH",
    "City": "Milton"
  },
  {
    "State": "NH",
    "City": "Milton Mills"
  },
  {
    "State": "NH",
    "City": "Mirror Lake"
  },
  {
    "State": "NH",
    "City": "New Castle"
  },
  {
    "State": "NH",
    "City": "New Durham"
  },
  {
    "State": "NH",
    "City": "Newfields"
  },
  {
    "State": "NH",
    "City": "Newmarket"
  },
  {
    "State": "NH",
    "City": "Newton"
  },
  {
    "State": "NH",
    "City": "Newton Junction"
  },
  {
    "State": "NH",
    "City": "North Conway"
  },
  {
    "State": "NH",
    "City": "Lee"
  },
  {
    "State": "NH",
    "City": "North Hampton"
  },
  {
    "State": "NH",
    "City": "Ossipee"
  },
  {
    "State": "NH",
    "City": "Plaistow"
  },
  {
    "State": "NH",
    "City": "Rollinsford"
  },
  {
    "State": "NH",
    "City": "Rye"
  },
  {
    "State": "NH",
    "City": "Rye Beach"
  },
  {
    "State": "NH",
    "City": "Sanbornville"
  },
  {
    "State": "NH",
    "City": "Sandown"
  },
  {
    "State": "NH",
    "City": "Seabrook"
  },
  {
    "State": "NH",
    "City": "Silver Lake"
  },
  {
    "State": "NH",
    "City": "Somersworth"
  },
  {
    "State": "NH",
    "City": "Effingham"
  },
  {
    "State": "NH",
    "City": "South Tamworth"
  },
  {
    "State": "NH",
    "City": "Strafford"
  },
  {
    "State": "NH",
    "City": "Stratham"
  },
  {
    "State": "NH",
    "City": "Tamworth"
  },
  {
    "State": "NH",
    "City": "Union"
  },
  {
    "State": "NH",
    "City": "West Ossipee"
  },
  {
    "State": "NH",
    "City": "Wolfeboro"
  },
  {
    "State": "NH",
    "City": "Wolfeboro Falls"
  },
  {
    "State": "NH",
    "City": "Wonalancet"
  },
  {
    "State": "ME",
    "City": "Berwick"
  },
  {
    "State": "ME",
    "City": "Cape Neddick"
  },
  {
    "State": "ME",
    "City": "Eliot"
  },
  {
    "State": "ME",
    "City": "Kittery"
  },
  {
    "State": "ME",
    "City": "Kittery Point"
  },
  {
    "State": "ME",
    "City": "North Berwick"
  },
  {
    "State": "ME",
    "City": "Ogunquit"
  },
  {
    "State": "ME",
    "City": "South Berwick"
  },
  {
    "State": "ME",
    "City": "York"
  },
  {
    "State": "ME",
    "City": "York Beach"
  },
  {
    "State": "ME",
    "City": "York Harbor"
  },
  {
    "State": "ME",
    "City": "Acton"
  },
  {
    "State": "ME",
    "City": "Alfred"
  },
  {
    "State": "ME",
    "City": "Bailey Island"
  },
  {
    "State": "ME",
    "City": "Bar Mills"
  },
  {
    "State": "ME",
    "City": "Biddeford"
  },
  {
    "State": "ME",
    "City": "Biddeford Pool"
  },
  {
    "State": "ME",
    "City": "Bowdoinham"
  },
  {
    "State": "ME",
    "City": "Bridgton"
  },
  {
    "State": "ME",
    "City": "Brownfield"
  },
  {
    "State": "ME",
    "City": "Brunswick"
  },
  {
    "State": "ME",
    "City": "Bustins Island"
  },
  {
    "State": "ME",
    "City": "Cape Porpoise"
  },
  {
    "State": "ME",
    "City": "Casco"
  },
  {
    "State": "ME",
    "City": "Center Lovell"
  },
  {
    "State": "ME",
    "City": "Chebeague Island"
  },
  {
    "State": "ME",
    "City": "Cliff Island"
  },
  {
    "State": "ME",
    "City": "Cornish"
  },
  {
    "State": "ME",
    "City": "Cumberland Center"
  },
  {
    "State": "ME",
    "City": "Denmark"
  },
  {
    "State": "ME",
    "City": "East Baldwin"
  },
  {
    "State": "ME",
    "City": "Lebanon"
  },
  {
    "State": "ME",
    "City": "East Parsonsfield"
  },
  {
    "State": "ME",
    "City": "Sebago"
  },
  {
    "State": "ME",
    "City": "East Waterboro"
  },
  {
    "State": "ME",
    "City": "Freeport"
  },
  {
    "State": "ME",
    "City": "Fryeburg"
  },
  {
    "State": "ME",
    "City": "Gorham"
  },
  {
    "State": "ME",
    "City": "Gray"
  },
  {
    "State": "ME",
    "City": "Harrison"
  },
  {
    "State": "ME",
    "City": "Hiram"
  },
  {
    "State": "ME",
    "City": "Hollis Center"
  },
  {
    "State": "ME",
    "City": "Kennebunk"
  },
  {
    "State": "ME",
    "City": "Kennebunkport"
  },
  {
    "State": "ME",
    "City": "Parsonsfield"
  },
  {
    "State": "ME",
    "City": "Limerick"
  },
  {
    "State": "ME",
    "City": "Limington"
  },
  {
    "State": "ME",
    "City": "Long Island"
  },
  {
    "State": "ME",
    "City": "Lovell"
  },
  {
    "State": "ME",
    "City": "Moody"
  },
  {
    "State": "ME",
    "City": "Naples"
  },
  {
    "State": "ME",
    "City": "Newfield"
  },
  {
    "State": "ME",
    "City": "North Bridgton"
  },
  {
    "State": "ME",
    "City": "North Waterboro"
  },
  {
    "State": "ME",
    "City": "Windham"
  },
  {
    "State": "ME",
    "City": "Ocean Park"
  },
  {
    "State": "ME",
    "City": "Old Orchard Beach"
  },
  {
    "State": "ME",
    "City": "Orrs Island"
  },
  {
    "State": "ME",
    "City": "Porter"
  },
  {
    "State": "ME",
    "City": "Pownal"
  },
  {
    "State": "ME",
    "City": "Scarborough"
  },
  {
    "State": "ME",
    "City": "Raymond"
  },
  {
    "State": "ME",
    "City": "Saco"
  },
  {
    "State": "ME",
    "City": "Sanford"
  },
  {
    "State": "ME",
    "City": "Sebago Lake"
  },
  {
    "State": "ME",
    "City": "Shapleigh"
  },
  {
    "State": "ME",
    "City": "South Casco"
  },
  {
    "State": "ME",
    "City": "South Freeport"
  },
  {
    "State": "ME",
    "City": "Harpswell"
  },
  {
    "State": "ME",
    "City": "South Windham"
  },
  {
    "State": "ME",
    "City": "Springvale"
  },
  {
    "State": "ME",
    "City": "Standish"
  },
  {
    "State": "ME",
    "City": "Steep Falls"
  },
  {
    "State": "ME",
    "City": "Topsham"
  },
  {
    "State": "ME",
    "City": "Waterboro"
  },
  {
    "State": "ME",
    "City": "Waterford"
  },
  {
    "State": "ME",
    "City": "Wells"
  },
  {
    "State": "ME",
    "City": "West Baldwin"
  },
  {
    "State": "ME",
    "City": "Westbrook"
  },
  {
    "State": "ME",
    "City": "Buxton"
  },
  {
    "State": "ME",
    "City": "West Kennebunk"
  },
  {
    "State": "ME",
    "City": "West Newfield"
  },
  {
    "State": "ME",
    "City": "Yarmouth"
  },
  {
    "State": "ME",
    "City": "North Yarmouth"
  },
  {
    "State": "ME",
    "City": "Portland"
  },
  {
    "State": "ME",
    "City": "Falmouth"
  },
  {
    "State": "ME",
    "City": "South Portland"
  },
  {
    "State": "ME",
    "City": "Cape Elizabeth"
  },
  {
    "State": "ME",
    "City": "Peaks Island"
  },
  {
    "State": "ME",
    "City": "Cumberland Foreside"
  },
  {
    "State": "ME",
    "City": "Auburn"
  },
  {
    "State": "ME",
    "City": "Andover"
  },
  {
    "State": "ME",
    "City": "Bethel"
  },
  {
    "State": "ME",
    "City": "Bryant Pond"
  },
  {
    "State": "ME",
    "City": "Buckfield"
  },
  {
    "State": "ME",
    "City": "Canton"
  },
  {
    "State": "ME",
    "City": "Durham"
  },
  {
    "State": "ME",
    "City": "Danville"
  },
  {
    "State": "ME",
    "City": "Dixfield"
  },
  {
    "State": "ME",
    "City": "Dryden"
  },
  {
    "State": "ME",
    "City": "East Andover"
  },
  {
    "State": "ME",
    "City": "East Dixfield"
  },
  {
    "State": "ME",
    "City": "East Livermore"
  },
  {
    "State": "ME",
    "City": "East Poland"
  },
  {
    "State": "ME",
    "City": "Stoneham"
  },
  {
    "State": "ME",
    "City": "East Wilton"
  },
  {
    "State": "ME",
    "City": "Greene"
  },
  {
    "State": "ME",
    "City": "Hanover"
  },
  {
    "State": "ME",
    "City": "Hebron"
  },
  {
    "State": "ME",
    "City": "Jay"
  },
  {
    "State": "ME",
    "City": "Lewiston"
  },
  {
    "State": "ME",
    "City": "Lisbon"
  },
  {
    "State": "ME",
    "City": "Lisbon Falls"
  },
  {
    "State": "ME",
    "City": "Livermore"
  },
  {
    "State": "ME",
    "City": "Livermore Falls"
  },
  {
    "State": "ME",
    "City": "Greenwood"
  },
  {
    "State": "ME",
    "City": "Mechanic Falls"
  },
  {
    "State": "ME",
    "City": "Mexico"
  },
  {
    "State": "ME",
    "City": "Minot"
  },
  {
    "State": "ME",
    "City": "Monmouth"
  },
  {
    "State": "ME",
    "City": "New Gloucester"
  },
  {
    "State": "ME",
    "City": "Newry"
  },
  {
    "State": "ME",
    "City": "North Jay"
  },
  {
    "State": "ME",
    "City": "Leeds"
  },
  {
    "State": "ME",
    "City": "North Monmouth"
  },
  {
    "State": "ME",
    "City": "North Turner"
  },
  {
    "State": "ME",
    "City": "North Waterford"
  },
  {
    "State": "ME",
    "City": "Norway"
  },
  {
    "State": "ME",
    "City": "Oxford"
  },
  {
    "State": "ME",
    "City": "Paris"
  },
  {
    "State": "ME",
    "City": "Poland"
  },
  {
    "State": "ME",
    "City": "Roxbury"
  },
  {
    "State": "ME",
    "City": "Rumford"
  },
  {
    "State": "ME",
    "City": "Sabattus"
  },
  {
    "State": "ME",
    "City": "South Paris"
  },
  {
    "State": "ME",
    "City": "Turner"
  },
  {
    "State": "ME",
    "City": "Wayne"
  },
  {
    "State": "ME",
    "City": "Weld"
  },
  {
    "State": "ME",
    "City": "West Bethel"
  },
  {
    "State": "ME",
    "City": "Bowdoin"
  },
  {
    "State": "ME",
    "City": "West Minot"
  },
  {
    "State": "ME",
    "City": "West Paris"
  },
  {
    "State": "ME",
    "City": "Peru"
  },
  {
    "State": "ME",
    "City": "West Poland"
  },
  {
    "State": "ME",
    "City": "Sumner"
  },
  {
    "State": "ME",
    "City": "Wilton"
  },
  {
    "State": "ME",
    "City": "Augusta"
  },
  {
    "State": "ME",
    "City": "Coopers Mills"
  },
  {
    "State": "ME",
    "City": "Dresden"
  },
  {
    "State": "ME",
    "City": "East Winthrop"
  },
  {
    "State": "ME",
    "City": "Farmingdale"
  },
  {
    "State": "ME",
    "City": "Gardiner"
  },
  {
    "State": "ME",
    "City": "Randolph"
  },
  {
    "State": "ME",
    "City": "Hallowell"
  },
  {
    "State": "ME",
    "City": "Jefferson"
  },
  {
    "State": "ME",
    "City": "Kents Hill"
  },
  {
    "State": "ME",
    "City": "Litchfield"
  },
  {
    "State": "ME",
    "City": "Manchester"
  },
  {
    "State": "ME",
    "City": "Mount Vernon"
  },
  {
    "State": "ME",
    "City": "Whitefield"
  },
  {
    "State": "ME",
    "City": "Palermo"
  },
  {
    "State": "ME",
    "City": "Readfield"
  },
  {
    "State": "ME",
    "City": "Richmond"
  },
  {
    "State": "ME",
    "City": "South China"
  },
  {
    "State": "ME",
    "City": "South Gardiner"
  },
  {
    "State": "ME",
    "City": "Vienna"
  },
  {
    "State": "ME",
    "City": "Windsor"
  },
  {
    "State": "ME",
    "City": "Winthrop"
  },
  {
    "State": "ME",
    "City": "Bangor"
  },
  {
    "State": "ME",
    "City": "Abbot"
  },
  {
    "State": "ME",
    "City": "Aurora"
  },
  {
    "State": "ME",
    "City": "Bradford"
  },
  {
    "State": "ME",
    "City": "Bradley"
  },
  {
    "State": "ME",
    "City": "Brewer"
  },
  {
    "State": "ME",
    "City": "Brookton"
  },
  {
    "State": "ME",
    "City": "Brownville"
  },
  {
    "State": "ME",
    "City": "Brownville Junction"
  },
  {
    "State": "ME",
    "City": "Bucksport"
  },
  {
    "State": "ME",
    "City": "Burlington"
  },
  {
    "State": "ME",
    "City": "Greenbush"
  },
  {
    "State": "ME",
    "City": "Carmel"
  },
  {
    "State": "ME",
    "City": "Castine"
  },
  {
    "State": "ME",
    "City": "Charleston"
  },
  {
    "State": "ME",
    "City": "Danforth"
  },
  {
    "State": "ME",
    "City": "Dover Foxcroft"
  },
  {
    "State": "ME",
    "City": "Corinth"
  },
  {
    "State": "ME",
    "City": "Eddington"
  },
  {
    "State": "ME",
    "City": "Holden"
  },
  {
    "State": "ME",
    "City": "East Millinocket"
  },
  {
    "State": "ME",
    "City": "East Orland"
  },
  {
    "State": "ME",
    "City": "Etna"
  },
  {
    "State": "ME",
    "City": "Exeter"
  },
  {
    "State": "ME",
    "City": "Frankfort"
  },
  {
    "State": "ME",
    "City": "Greenville"
  },
  {
    "State": "ME",
    "City": "Greenville Junction"
  },
  {
    "State": "ME",
    "City": "Guilford"
  },
  {
    "State": "ME",
    "City": "Hampden"
  },
  {
    "State": "ME",
    "City": "Howland"
  },
  {
    "State": "ME",
    "City": "Hudson"
  },
  {
    "State": "ME",
    "City": "Kenduskeag"
  },
  {
    "State": "ME",
    "City": "Kingman"
  },
  {
    "State": "ME",
    "City": "Lagrange"
  },
  {
    "State": "ME",
    "City": "Lambert Lake"
  },
  {
    "State": "ME",
    "City": "Lee"
  },
  {
    "State": "ME",
    "City": "Levant"
  },
  {
    "State": "ME",
    "City": "Lincoln"
  },
  {
    "State": "ME",
    "City": "Mattawamkeag"
  },
  {
    "State": "ME",
    "City": "Medway"
  },
  {
    "State": "ME",
    "City": "Milford"
  },
  {
    "State": "ME",
    "City": "Millinocket"
  },
  {
    "State": "ME",
    "City": "Milo"
  },
  {
    "State": "ME",
    "City": "Monson"
  },
  {
    "State": "ME",
    "City": "Olamon"
  },
  {
    "State": "ME",
    "City": "Old Town"
  },
  {
    "State": "ME",
    "City": "Orono"
  },
  {
    "State": "ME",
    "City": "Orient"
  },
  {
    "State": "ME",
    "City": "Orland"
  },
  {
    "State": "ME",
    "City": "Orrington"
  },
  {
    "State": "ME",
    "City": "Passadumkeag"
  },
  {
    "State": "ME",
    "City": "Penobscot"
  },
  {
    "State": "ME",
    "City": "Rockwood"
  },
  {
    "State": "ME",
    "City": "Sangerville"
  },
  {
    "State": "ME",
    "City": "Sebec"
  },
  {
    "State": "ME",
    "City": "Shirley Mills"
  },
  {
    "State": "ME",
    "City": "Springfield"
  },
  {
    "State": "ME",
    "City": "Stetson"
  },
  {
    "State": "ME",
    "City": "Stillwater"
  },
  {
    "State": "ME",
    "City": "Topsfield"
  },
  {
    "State": "ME",
    "City": "Vanceboro"
  },
  {
    "State": "ME",
    "City": "Waite"
  },
  {
    "State": "ME",
    "City": "West Enfield"
  },
  {
    "State": "ME",
    "City": "Winn"
  },
  {
    "State": "ME",
    "City": "Winterport"
  },
  {
    "State": "ME",
    "City": "Wytopitlock"
  },
  {
    "State": "ME",
    "City": "Bath"
  },
  {
    "State": "ME",
    "City": "Alna"
  },
  {
    "State": "ME",
    "City": "Boothbay"
  },
  {
    "State": "ME",
    "City": "Boothbay Harbor"
  },
  {
    "State": "ME",
    "City": "Bristol"
  },
  {
    "State": "ME",
    "City": "Chamberlain"
  },
  {
    "State": "ME",
    "City": "Damariscotta"
  },
  {
    "State": "ME",
    "City": "East Boothbay"
  },
  {
    "State": "ME",
    "City": "Friendship"
  },
  {
    "State": "ME",
    "City": "Georgetown"
  },
  {
    "State": "ME",
    "City": "Isle Of Springs"
  },
  {
    "State": "ME",
    "City": "Bremen"
  },
  {
    "State": "ME",
    "City": "Newcastle"
  },
  {
    "State": "ME",
    "City": "New Harbor"
  },
  {
    "State": "ME",
    "City": "Nobleboro"
  },
  {
    "State": "ME",
    "City": "Edgecomb"
  },
  {
    "State": "ME",
    "City": "Pemaquid"
  },
  {
    "State": "ME",
    "City": "Phippsburg"
  },
  {
    "State": "ME",
    "City": "Cushing"
  },
  {
    "State": "ME",
    "City": "Round Pond"
  },
  {
    "State": "ME",
    "City": "Sebasco Estates"
  },
  {
    "State": "ME",
    "City": "South Bristol"
  },
  {
    "State": "ME",
    "City": "Squirrel Island"
  },
  {
    "State": "ME",
    "City": "Trevett"
  },
  {
    "State": "ME",
    "City": "Waldoboro"
  },
  {
    "State": "ME",
    "City": "Walpole"
  },
  {
    "State": "ME",
    "City": "Washington"
  },
  {
    "State": "ME",
    "City": "West Boothbay Harbor"
  },
  {
    "State": "ME",
    "City": "Southport"
  },
  {
    "State": "ME",
    "City": "Wiscasset"
  },
  {
    "State": "ME",
    "City": "Woolwich"
  },
  {
    "State": "ME",
    "City": "Ellsworth"
  },
  {
    "State": "ME",
    "City": "Addison"
  },
  {
    "State": "ME",
    "City": "Gouldsboro"
  },
  {
    "State": "ME",
    "City": "Bar Harbor"
  },
  {
    "State": "ME",
    "City": "Beals"
  },
  {
    "State": "ME",
    "City": "Bernard"
  },
  {
    "State": "ME",
    "City": "Birch Harbor"
  },
  {
    "State": "ME",
    "City": "Blue Hill"
  },
  {
    "State": "ME",
    "City": "Brooklin"
  },
  {
    "State": "ME",
    "City": "Brooksville"
  },
  {
    "State": "ME",
    "City": "Calais"
  },
  {
    "State": "ME",
    "City": "Cherryfield"
  },
  {
    "State": "ME",
    "City": "Columbia Falls"
  },
  {
    "State": "ME",
    "City": "Corea"
  },
  {
    "State": "ME",
    "City": "Cranberry Isles"
  },
  {
    "State": "ME",
    "City": "Cutler"
  },
  {
    "State": "ME",
    "City": "Deer Isle"
  },
  {
    "State": "ME",
    "City": "Dennysville"
  },
  {
    "State": "ME",
    "City": "East Blue Hill"
  },
  {
    "State": "ME",
    "City": "East Machias"
  },
  {
    "State": "ME",
    "City": "Eastport"
  },
  {
    "State": "ME",
    "City": "Franklin"
  },
  {
    "State": "ME",
    "City": "Frenchboro"
  },
  {
    "State": "ME",
    "City": "Grand Lake Stream"
  },
  {
    "State": "ME",
    "City": "Hancock"
  },
  {
    "State": "ME",
    "City": "Harborside"
  },
  {
    "State": "ME",
    "City": "Harrington"
  },
  {
    "State": "ME",
    "City": "Hulls Cove"
  },
  {
    "State": "ME",
    "City": "Isle Au Haut"
  },
  {
    "State": "ME",
    "City": "Islesford"
  },
  {
    "State": "ME",
    "City": "Jonesboro"
  },
  {
    "State": "ME",
    "City": "Jonesport"
  },
  {
    "State": "ME",
    "City": "Little Deer Isle"
  },
  {
    "State": "ME",
    "City": "Lubec"
  },
  {
    "State": "ME",
    "City": "Bass Harbor"
  },
  {
    "State": "ME",
    "City": "Machias"
  },
  {
    "State": "ME",
    "City": "Machiasport"
  },
  {
    "State": "ME",
    "City": "Meddybemps"
  },
  {
    "State": "ME",
    "City": "Milbridge"
  },
  {
    "State": "ME",
    "City": "Mount Desert"
  },
  {
    "State": "ME",
    "City": "Northeast Harbor"
  },
  {
    "State": "ME",
    "City": "Sullivan"
  },
  {
    "State": "ME",
    "City": "Pembroke"
  },
  {
    "State": "ME",
    "City": "Perry"
  },
  {
    "State": "ME",
    "City": "Princeton"
  },
  {
    "State": "ME",
    "City": "Prospect Harbor"
  },
  {
    "State": "ME",
    "City": "Robbinston"
  },
  {
    "State": "ME",
    "City": "Salsbury Cove"
  },
  {
    "State": "ME",
    "City": "Sargentville"
  },
  {
    "State": "ME",
    "City": "Seal Cove"
  },
  {
    "State": "ME",
    "City": "Seal Harbor"
  },
  {
    "State": "ME",
    "City": "Sedgwick"
  },
  {
    "State": "ME",
    "City": "Sorrento"
  },
  {
    "State": "ME",
    "City": "Southwest Harbor"
  },
  {
    "State": "ME",
    "City": "Steuben"
  },
  {
    "State": "ME",
    "City": "Stonington"
  },
  {
    "State": "ME",
    "City": "Sunset"
  },
  {
    "State": "ME",
    "City": "Surry"
  },
  {
    "State": "ME",
    "City": "Swans Island"
  },
  {
    "State": "ME",
    "City": "Wesley"
  },
  {
    "State": "ME",
    "City": "Whiting"
  },
  {
    "State": "ME",
    "City": "Winter Harbor"
  },
  {
    "State": "ME",
    "City": "Baileyville"
  },
  {
    "State": "ME",
    "City": "Houlton"
  },
  {
    "State": "ME",
    "City": "Ashland"
  },
  {
    "State": "ME",
    "City": "Benedicta"
  },
  {
    "State": "ME",
    "City": "Blaine"
  },
  {
    "State": "ME",
    "City": "Bridgewater"
  },
  {
    "State": "ME",
    "City": "Caribou"
  },
  {
    "State": "ME",
    "City": "Clayton Lake"
  },
  {
    "State": "ME",
    "City": "Crouseville"
  },
  {
    "State": "ME",
    "City": "Eagle Lake"
  },
  {
    "State": "ME",
    "City": "Easton"
  },
  {
    "State": "ME",
    "City": "Estcourt Station"
  },
  {
    "State": "ME",
    "City": "Fort Fairfield"
  },
  {
    "State": "ME",
    "City": "Fort Kent"
  },
  {
    "State": "ME",
    "City": "Fort Kent Mills"
  },
  {
    "State": "ME",
    "City": "Frenchville"
  },
  {
    "State": "ME",
    "City": "Grand Isle"
  },
  {
    "State": "ME",
    "City": "Island Falls"
  },
  {
    "State": "ME",
    "City": "Limestone"
  },
  {
    "State": "ME",
    "City": "Madawaska"
  },
  {
    "State": "ME",
    "City": "Mapleton"
  },
  {
    "State": "ME",
    "City": "Mars Hill"
  },
  {
    "State": "ME",
    "City": "Monticello"
  },
  {
    "State": "ME",
    "City": "New Limerick"
  },
  {
    "State": "ME",
    "City": "New Sweden"
  },
  {
    "State": "ME",
    "City": "Oakfield"
  },
  {
    "State": "ME",
    "City": "Oxbow"
  },
  {
    "State": "ME",
    "City": "Patten"
  },
  {
    "State": "ME",
    "City": "Perham"
  },
  {
    "State": "ME",
    "City": "Portage"
  },
  {
    "State": "ME",
    "City": "Presque Isle"
  },
  {
    "State": "ME",
    "City": "Saint Agatha"
  },
  {
    "State": "ME",
    "City": "Saint David"
  },
  {
    "State": "ME",
    "City": "Saint Francis"
  },
  {
    "State": "ME",
    "City": "Sheridan"
  },
  {
    "State": "ME",
    "City": "Sherman"
  },
  {
    "State": "ME",
    "City": "Stacyville"
  },
  {
    "State": "ME",
    "City": "Sinclair"
  },
  {
    "State": "ME",
    "City": "Smyrna Mills"
  },
  {
    "State": "ME",
    "City": "Wallagrass"
  },
  {
    "State": "ME",
    "City": "Stockholm"
  },
  {
    "State": "ME",
    "City": "Van Buren"
  },
  {
    "State": "ME",
    "City": "Washburn"
  },
  {
    "State": "ME",
    "City": "Westfield"
  },
  {
    "State": "ME",
    "City": "Rockland"
  },
  {
    "State": "ME",
    "City": "Camden"
  },
  {
    "State": "ME",
    "City": "Glen Cove"
  },
  {
    "State": "ME",
    "City": "Hope"
  },
  {
    "State": "ME",
    "City": "Islesboro"
  },
  {
    "State": "ME",
    "City": "Lincolnville"
  },
  {
    "State": "ME",
    "City": "Lincolnville Center"
  },
  {
    "State": "ME",
    "City": "Matinicus"
  },
  {
    "State": "ME",
    "City": "Monhegan"
  },
  {
    "State": "ME",
    "City": "North Haven"
  },
  {
    "State": "ME",
    "City": "Owls Head"
  },
  {
    "State": "ME",
    "City": "Port Clyde"
  },
  {
    "State": "ME",
    "City": "Rockport"
  },
  {
    "State": "ME",
    "City": "South Thomaston"
  },
  {
    "State": "ME",
    "City": "Spruce Head"
  },
  {
    "State": "ME",
    "City": "Tenants Harbor"
  },
  {
    "State": "ME",
    "City": "Thomaston"
  },
  {
    "State": "ME",
    "City": "Union"
  },
  {
    "State": "ME",
    "City": "Vinalhaven"
  },
  {
    "State": "ME",
    "City": "Warren"
  },
  {
    "State": "ME",
    "City": "West Rockport"
  },
  {
    "State": "ME",
    "City": "Waterville"
  },
  {
    "State": "ME",
    "City": "Albion"
  },
  {
    "State": "ME",
    "City": "Anson"
  },
  {
    "State": "ME",
    "City": "Athens"
  },
  {
    "State": "ME",
    "City": "Belfast"
  },
  {
    "State": "ME",
    "City": "Belgrade"
  },
  {
    "State": "ME",
    "City": "Belgrade Lakes"
  },
  {
    "State": "ME",
    "City": "Bingham"
  },
  {
    "State": "ME",
    "City": "Brooks"
  },
  {
    "State": "ME",
    "City": "Burnham"
  },
  {
    "State": "ME",
    "City": "Cambridge"
  },
  {
    "State": "ME",
    "City": "Canaan"
  },
  {
    "State": "ME",
    "City": "Caratunk"
  },
  {
    "State": "ME",
    "City": "China Village"
  },
  {
    "State": "ME",
    "City": "Clinton"
  },
  {
    "State": "ME",
    "City": "Corinna"
  },
  {
    "State": "ME",
    "City": "Detroit"
  },
  {
    "State": "ME",
    "City": "Dexter"
  },
  {
    "State": "ME",
    "City": "Dixmont"
  },
  {
    "State": "ME",
    "City": "East Newport"
  },
  {
    "State": "ME",
    "City": "East Vassalboro"
  },
  {
    "State": "ME",
    "City": "Eustis"
  },
  {
    "State": "ME",
    "City": "Fairfield"
  },
  {
    "State": "ME",
    "City": "Farmington"
  },
  {
    "State": "ME",
    "City": "Garland"
  },
  {
    "State": "ME",
    "City": "Farmington Falls"
  },
  {
    "State": "ME",
    "City": "Freedom"
  },
  {
    "State": "ME",
    "City": "Harmony"
  },
  {
    "State": "ME",
    "City": "Hartland"
  },
  {
    "State": "ME",
    "City": "Hinckley"
  },
  {
    "State": "ME",
    "City": "Jackman"
  },
  {
    "State": "ME",
    "City": "Kingfield"
  },
  {
    "State": "ME",
    "City": "Liberty"
  },
  {
    "State": "ME",
    "City": "Madison"
  },
  {
    "State": "ME",
    "City": "Monroe"
  },
  {
    "State": "ME",
    "City": "Morrill"
  },
  {
    "State": "ME",
    "City": "Newport"
  },
  {
    "State": "ME",
    "City": "New Portland"
  },
  {
    "State": "ME",
    "City": "New Sharon"
  },
  {
    "State": "ME",
    "City": "New Vineyard"
  },
  {
    "State": "ME",
    "City": "Norridgewock"
  },
  {
    "State": "ME",
    "City": "North Anson"
  },
  {
    "State": "ME",
    "City": "North Vassalboro"
  },
  {
    "State": "ME",
    "City": "Oakland"
  },
  {
    "State": "ME",
    "City": "Oquossoc"
  },
  {
    "State": "ME",
    "City": "Palmyra"
  },
  {
    "State": "ME",
    "City": "Phillips"
  },
  {
    "State": "ME",
    "City": "Pittsfield"
  },
  {
    "State": "ME",
    "City": "Plymouth"
  },
  {
    "State": "ME",
    "City": "Rangeley"
  },
  {
    "State": "ME",
    "City": "Saint Albans"
  },
  {
    "State": "ME",
    "City": "Sandy Point"
  },
  {
    "State": "ME",
    "City": "Searsmont"
  },
  {
    "State": "ME",
    "City": "Searsport"
  },
  {
    "State": "ME",
    "City": "Shawmut"
  },
  {
    "State": "ME",
    "City": "Skowhegan"
  },
  {
    "State": "ME",
    "City": "Smithfield"
  },
  {
    "State": "ME",
    "City": "Solon"
  },
  {
    "State": "ME",
    "City": "Stockton Springs"
  },
  {
    "State": "ME",
    "City": "Stratton"
  },
  {
    "State": "ME",
    "City": "Strong"
  },
  {
    "State": "ME",
    "City": "Temple"
  },
  {
    "State": "ME",
    "City": "West Forks"
  },
  {
    "State": "ME",
    "City": "Thorndike"
  },
  {
    "State": "ME",
    "City": "Troy"
  },
  {
    "State": "ME",
    "City": "Unity"
  },
  {
    "State": "ME",
    "City": "Vassalboro"
  },
  {
    "State": "ME",
    "City": "West Farmington"
  },
  {
    "State": "VT",
    "City": "White River Junction"
  },
  {
    "State": "VT",
    "City": "Ascutney"
  },
  {
    "State": "VT",
    "City": "Barnard"
  },
  {
    "State": "VT",
    "City": "Bethel"
  },
  {
    "State": "VT",
    "City": "Bradford"
  },
  {
    "State": "VT",
    "City": "Bridgewater"
  },
  {
    "State": "VT",
    "City": "Bridgewater Corners"
  },
  {
    "State": "VT",
    "City": "Brookfield"
  },
  {
    "State": "VT",
    "City": "Brownsville"
  },
  {
    "State": "VT",
    "City": "Chelsea"
  },
  {
    "State": "VT",
    "City": "Corinth"
  },
  {
    "State": "VT",
    "City": "East Corinth"
  },
  {
    "State": "VT",
    "City": "East Randolph"
  },
  {
    "State": "VT",
    "City": "East Ryegate"
  },
  {
    "State": "VT",
    "City": "East Thetford"
  },
  {
    "State": "VT",
    "City": "Fairlee"
  },
  {
    "State": "VT",
    "City": "Groton"
  },
  {
    "State": "VT",
    "City": "Hartford"
  },
  {
    "State": "VT",
    "City": "Hartland"
  },
  {
    "State": "VT",
    "City": "Hartland Four Corners"
  },
  {
    "State": "VT",
    "City": "Mc Indoe Falls"
  },
  {
    "State": "VT",
    "City": "Newbury"
  },
  {
    "State": "VT",
    "City": "North Hartland"
  },
  {
    "State": "VT",
    "City": "North Pomfret"
  },
  {
    "State": "VT",
    "City": "North Thetford"
  },
  {
    "State": "VT",
    "City": "Norwich"
  },
  {
    "State": "VT",
    "City": "Plymouth"
  },
  {
    "State": "VT",
    "City": "Post Mills"
  },
  {
    "State": "VT",
    "City": "Quechee"
  },
  {
    "State": "VT",
    "City": "Randolph"
  },
  {
    "State": "VT",
    "City": "Randolph Center"
  },
  {
    "State": "VT",
    "City": "Reading"
  },
  {
    "State": "VT",
    "City": "Sharon"
  },
  {
    "State": "VT",
    "City": "South Pomfret"
  },
  {
    "State": "VT",
    "City": "South Royalton"
  },
  {
    "State": "VT",
    "City": "South Ryegate"
  },
  {
    "State": "VT",
    "City": "South Strafford"
  },
  {
    "State": "VT",
    "City": "South Woodstock"
  },
  {
    "State": "VT",
    "City": "Strafford"
  },
  {
    "State": "VT",
    "City": "Taftsville"
  },
  {
    "State": "VT",
    "City": "Thetford"
  },
  {
    "State": "VT",
    "City": "Thetford Center"
  },
  {
    "State": "VT",
    "City": "Topsham"
  },
  {
    "State": "VT",
    "City": "Tunbridge"
  },
  {
    "State": "VT",
    "City": "Vershire"
  },
  {
    "State": "VT",
    "City": "Wells River"
  },
  {
    "State": "VT",
    "City": "West Fairlee"
  },
  {
    "State": "VT",
    "City": "West Hartford"
  },
  {
    "State": "VT",
    "City": "West Newbury"
  },
  {
    "State": "VT",
    "City": "West Topsham"
  },
  {
    "State": "VT",
    "City": "Wilder"
  },
  {
    "State": "VT",
    "City": "Windsor"
  },
  {
    "State": "VT",
    "City": "Woodstock"
  },
  {
    "State": "VT",
    "City": "Bellows Falls"
  },
  {
    "State": "VT",
    "City": "Cambridgeport"
  },
  {
    "State": "VT",
    "City": "Cavendish"
  },
  {
    "State": "VT",
    "City": "Chester"
  },
  {
    "State": "VT",
    "City": "Chester Depot"
  },
  {
    "State": "VT",
    "City": "Grafton"
  },
  {
    "State": "VT",
    "City": "Londonderry"
  },
  {
    "State": "VT",
    "City": "Ludlow"
  },
  {
    "State": "VT",
    "City": "North Springfield"
  },
  {
    "State": "VT",
    "City": "Perkinsville"
  },
  {
    "State": "VT",
    "City": "Peru"
  },
  {
    "State": "VT",
    "City": "Proctorsville"
  },
  {
    "State": "VT",
    "City": "Saxtons River"
  },
  {
    "State": "VT",
    "City": "South Londonderry"
  },
  {
    "State": "VT",
    "City": "Springfield"
  },
  {
    "State": "VT",
    "City": "Westminster"
  },
  {
    "State": "VT",
    "City": "Westminster Station"
  },
  {
    "State": "VT",
    "City": "Weston"
  },
  {
    "State": "VT",
    "City": "Bennington"
  },
  {
    "State": "VT",
    "City": "Arlington"
  },
  {
    "State": "VT",
    "City": "Dorset"
  },
  {
    "State": "VT",
    "City": "East Arlington"
  },
  {
    "State": "VT",
    "City": "East Dorset"
  },
  {
    "State": "VT",
    "City": "Manchester"
  },
  {
    "State": "VT",
    "City": "Manchester Center"
  },
  {
    "State": "VT",
    "City": "North Bennington"
  },
  {
    "State": "VT",
    "City": "North Pownal"
  },
  {
    "State": "VT",
    "City": "Pownal"
  },
  {
    "State": "VT",
    "City": "Shaftsbury"
  },
  {
    "State": "VT",
    "City": "Brattleboro"
  },
  {
    "State": "VT",
    "City": "Bondville"
  },
  {
    "State": "VT",
    "City": "East Dover"
  },
  {
    "State": "VT",
    "City": "Jacksonville"
  },
  {
    "State": "VT",
    "City": "Jamaica"
  },
  {
    "State": "VT",
    "City": "Marlboro"
  },
  {
    "State": "VT",
    "City": "Newfane"
  },
  {
    "State": "VT",
    "City": "Putney"
  },
  {
    "State": "VT",
    "City": "Readsboro"
  },
  {
    "State": "VT",
    "City": "South Newfane"
  },
  {
    "State": "VT",
    "City": "Stamford"
  },
  {
    "State": "VT",
    "City": "Townshend"
  },
  {
    "State": "VT",
    "City": "Vernon"
  },
  {
    "State": "VT",
    "City": "Wardsboro"
  },
  {
    "State": "VT",
    "City": "West Dover"
  },
  {
    "State": "VT",
    "City": "West Dummerston"
  },
  {
    "State": "VT",
    "City": "West Halifax"
  },
  {
    "State": "VT",
    "City": "West Townshend"
  },
  {
    "State": "VT",
    "City": "West Wardsboro"
  },
  {
    "State": "VT",
    "City": "Whitingham"
  },
  {
    "State": "VT",
    "City": "Williamsville"
  },
  {
    "State": "VT",
    "City": "Wilmington"
  },
  {
    "State": "VT",
    "City": "Burlington"
  },
  {
    "State": "VT",
    "City": "South Burlington"
  },
  {
    "State": "VT",
    "City": "Winooski"
  },
  {
    "State": "VT",
    "City": "Colchester"
  },
  {
    "State": "VT",
    "City": "Alburgh"
  },
  {
    "State": "VT",
    "City": "Bakersfield"
  },
  {
    "State": "VT",
    "City": "Belvidere Center"
  },
  {
    "State": "VT",
    "City": "Bristol"
  },
  {
    "State": "VT",
    "City": "Cambridge"
  },
  {
    "State": "VT",
    "City": "Charlotte"
  },
  {
    "State": "VT",
    "City": "East Berkshire"
  },
  {
    "State": "VT",
    "City": "East Fairfield"
  },
  {
    "State": "VT",
    "City": "Enosburg Falls"
  },
  {
    "State": "VT",
    "City": "Essex"
  },
  {
    "State": "VT",
    "City": "Essex Junction"
  },
  {
    "State": "VT",
    "City": "Fairfax"
  },
  {
    "State": "VT",
    "City": "Fairfield"
  },
  {
    "State": "VT",
    "City": "Ferrisburgh"
  },
  {
    "State": "VT",
    "City": "Franklin"
  },
  {
    "State": "VT",
    "City": "Grand Isle"
  },
  {
    "State": "VT",
    "City": "Highgate Center"
  },
  {
    "State": "VT",
    "City": "Highgate Springs"
  },
  {
    "State": "VT",
    "City": "Hinesburg"
  },
  {
    "State": "VT",
    "City": "Huntington"
  },
  {
    "State": "VT",
    "City": "Isle La Motte"
  },
  {
    "State": "VT",
    "City": "Jeffersonville"
  },
  {
    "State": "VT",
    "City": "Jericho"
  },
  {
    "State": "VT",
    "City": "Jonesville"
  },
  {
    "State": "VT",
    "City": "Milton"
  },
  {
    "State": "VT",
    "City": "Monkton"
  },
  {
    "State": "VT",
    "City": "Montgomery"
  },
  {
    "State": "VT",
    "City": "Montgomery Center"
  },
  {
    "State": "VT",
    "City": "New Haven"
  },
  {
    "State": "VT",
    "City": "North Ferrisburgh"
  },
  {
    "State": "VT",
    "City": "North Hero"
  },
  {
    "State": "VT",
    "City": "Richford"
  },
  {
    "State": "VT",
    "City": "Richmond"
  },
  {
    "State": "VT",
    "City": "Saint Albans"
  },
  {
    "State": "VT",
    "City": "Saint Albans Bay"
  },
  {
    "State": "VT",
    "City": "Shelburne"
  },
  {
    "State": "VT",
    "City": "Sheldon"
  },
  {
    "State": "VT",
    "City": "Sheldon Springs"
  },
  {
    "State": "VT",
    "City": "South Hero"
  },
  {
    "State": "VT",
    "City": "Starksboro"
  },
  {
    "State": "VT",
    "City": "Swanton"
  },
  {
    "State": "VT",
    "City": "Underhill"
  },
  {
    "State": "VT",
    "City": "Underhill Center"
  },
  {
    "State": "VT",
    "City": "Vergennes"
  },
  {
    "State": "VT",
    "City": "Waterville"
  },
  {
    "State": "VT",
    "City": "Westford"
  },
  {
    "State": "VT",
    "City": "Williston"
  },
  {
    "State": "VT",
    "City": "Montpelier"
  },
  {
    "State": "VT",
    "City": "Adamant"
  },
  {
    "State": "VT",
    "City": "Barre"
  },
  {
    "State": "VT",
    "City": "Cabot"
  },
  {
    "State": "VT",
    "City": "Calais"
  },
  {
    "State": "VT",
    "City": "East Barre"
  },
  {
    "State": "VT",
    "City": "East Calais"
  },
  {
    "State": "VT",
    "City": "East Montpelier"
  },
  {
    "State": "VT",
    "City": "Eden"
  },
  {
    "State": "VT",
    "City": "Eden Mills"
  },
  {
    "State": "VT",
    "City": "Graniteville"
  },
  {
    "State": "VT",
    "City": "Hyde Park"
  },
  {
    "State": "VT",
    "City": "Johnson"
  },
  {
    "State": "VT",
    "City": "Lake Elmore"
  },
  {
    "State": "VT",
    "City": "Marshfield"
  },
  {
    "State": "VT",
    "City": "Moretown"
  },
  {
    "State": "VT",
    "City": "Morrisville"
  },
  {
    "State": "VT",
    "City": "Moscow"
  },
  {
    "State": "VT",
    "City": "Northfield"
  },
  {
    "State": "VT",
    "City": "Northfield Falls"
  },
  {
    "State": "VT",
    "City": "North Hyde Park"
  },
  {
    "State": "VT",
    "City": "North Montpelier"
  },
  {
    "State": "VT",
    "City": "Plainfield"
  },
  {
    "State": "VT",
    "City": "Roxbury"
  },
  {
    "State": "VT",
    "City": "South Barre"
  },
  {
    "State": "VT",
    "City": "Waterbury"
  },
  {
    "State": "VT",
    "City": "Stowe"
  },
  {
    "State": "VT",
    "City": "Waitsfield"
  },
  {
    "State": "VT",
    "City": "Warren"
  },
  {
    "State": "VT",
    "City": "Washington"
  },
  {
    "State": "VT",
    "City": "Waterbury Center"
  },
  {
    "State": "VT",
    "City": "Websterville"
  },
  {
    "State": "VT",
    "City": "Williamstown"
  },
  {
    "State": "VT",
    "City": "Wolcott"
  },
  {
    "State": "VT",
    "City": "Woodbury"
  },
  {
    "State": "VT",
    "City": "Worcester"
  },
  {
    "State": "VT",
    "City": "Rutland"
  },
  {
    "State": "VT",
    "City": "Belmont"
  },
  {
    "State": "VT",
    "City": "Benson"
  },
  {
    "State": "VT",
    "City": "Bomoseen"
  },
  {
    "State": "VT",
    "City": "Brandon"
  },
  {
    "State": "VT",
    "City": "Bridport"
  },
  {
    "State": "VT",
    "City": "Castleton"
  },
  {
    "State": "VT",
    "City": "Center Rutland"
  },
  {
    "State": "VT",
    "City": "Chittenden"
  },
  {
    "State": "VT",
    "City": "Cuttingsville"
  },
  {
    "State": "VT",
    "City": "Danby"
  },
  {
    "State": "VT",
    "City": "East Middlebury"
  },
  {
    "State": "VT",
    "City": "East Poultney"
  },
  {
    "State": "VT",
    "City": "East Wallingford"
  },
  {
    "State": "VT",
    "City": "Fair Haven"
  },
  {
    "State": "VT",
    "City": "Florence"
  },
  {
    "State": "VT",
    "City": "Forest Dale"
  },
  {
    "State": "VT",
    "City": "Gaysville"
  },
  {
    "State": "VT",
    "City": "Granville"
  },
  {
    "State": "VT",
    "City": "Hancock"
  },
  {
    "State": "VT",
    "City": "Hydeville"
  },
  {
    "State": "VT",
    "City": "Killington"
  },
  {
    "State": "VT",
    "City": "Middlebury"
  },
  {
    "State": "VT",
    "City": "Middletown Springs"
  },
  {
    "State": "VT",
    "City": "Mount Holly"
  },
  {
    "State": "VT",
    "City": "North Clarendon"
  },
  {
    "State": "VT",
    "City": "Orwell"
  },
  {
    "State": "VT",
    "City": "Pawlet"
  },
  {
    "State": "VT",
    "City": "Pittsfield"
  },
  {
    "State": "VT",
    "City": "Pittsford"
  },
  {
    "State": "VT",
    "City": "Poultney"
  },
  {
    "State": "VT",
    "City": "Proctor"
  },
  {
    "State": "VT",
    "City": "Ripton"
  },
  {
    "State": "VT",
    "City": "Rochester"
  },
  {
    "State": "VT",
    "City": "Rupert"
  },
  {
    "State": "VT",
    "City": "Salisbury"
  },
  {
    "State": "VT",
    "City": "Shoreham"
  },
  {
    "State": "VT",
    "City": "Stockbridge"
  },
  {
    "State": "VT",
    "City": "Wallingford"
  },
  {
    "State": "VT",
    "City": "Wells"
  },
  {
    "State": "VT",
    "City": "West Pawlet"
  },
  {
    "State": "VT",
    "City": "West Rupert"
  },
  {
    "State": "VT",
    "City": "West Rutland"
  },
  {
    "State": "VT",
    "City": "Whiting"
  },
  {
    "State": "VT",
    "City": "Saint Johnsbury"
  },
  {
    "State": "VT",
    "City": "Albany"
  },
  {
    "State": "VT",
    "City": "Barnet"
  },
  {
    "State": "VT",
    "City": "Barton"
  },
  {
    "State": "VT",
    "City": "Beebe Plain"
  },
  {
    "State": "VT",
    "City": "Concord"
  },
  {
    "State": "VT",
    "City": "Coventry"
  },
  {
    "State": "VT",
    "City": "Craftsbury"
  },
  {
    "State": "VT",
    "City": "Craftsbury Common"
  },
  {
    "State": "VT",
    "City": "Danville"
  },
  {
    "State": "VT",
    "City": "Derby"
  },
  {
    "State": "VT",
    "City": "Derby Line"
  },
  {
    "State": "VT",
    "City": "East Burke"
  },
  {
    "State": "VT",
    "City": "East Charleston"
  },
  {
    "State": "VT",
    "City": "East Hardwick"
  },
  {
    "State": "VT",
    "City": "East Haven"
  },
  {
    "State": "VT",
    "City": "East Saint Johnsbury"
  },
  {
    "State": "VT",
    "City": "Glover"
  },
  {
    "State": "VT",
    "City": "Granby"
  },
  {
    "State": "VT",
    "City": "Greensboro"
  },
  {
    "State": "VT",
    "City": "Greensboro Bend"
  },
  {
    "State": "VT",
    "City": "Hardwick"
  },
  {
    "State": "VT",
    "City": "Irasburg"
  },
  {
    "State": "VT",
    "City": "Island Pond"
  },
  {
    "State": "VT",
    "City": "Lowell"
  },
  {
    "State": "VT",
    "City": "Lower Waterford"
  },
  {
    "State": "VT",
    "City": "Lyndon"
  },
  {
    "State": "VT",
    "City": "Lyndon Center"
  },
  {
    "State": "VT",
    "City": "Lyndonville"
  },
  {
    "State": "VT",
    "City": "Morgan"
  },
  {
    "State": "VT",
    "City": "Newport"
  },
  {
    "State": "VT",
    "City": "Newport Center"
  },
  {
    "State": "VT",
    "City": "North Concord"
  },
  {
    "State": "VT",
    "City": "North Troy"
  },
  {
    "State": "VT",
    "City": "Orleans"
  },
  {
    "State": "VT",
    "City": "Passumpsic"
  },
  {
    "State": "VT",
    "City": "Peacham"
  },
  {
    "State": "VT",
    "City": "Saint Johnsbury Center"
  },
  {
    "State": "VT",
    "City": "Sheffield"
  },
  {
    "State": "VT",
    "City": "Sutton"
  },
  {
    "State": "VT",
    "City": "Troy"
  },
  {
    "State": "VT",
    "City": "West Burke"
  },
  {
    "State": "VT",
    "City": "West Charleston"
  },
  {
    "State": "VT",
    "City": "West Danville"
  },
  {
    "State": "VT",
    "City": "Westfield"
  },
  {
    "State": "VT",
    "City": "Averill"
  },
  {
    "State": "VT",
    "City": "Beecher Falls"
  },
  {
    "State": "VT",
    "City": "Canaan"
  },
  {
    "State": "VT",
    "City": "Gilman"
  },
  {
    "State": "VT",
    "City": "Guildhall"
  },
  {
    "State": "VT",
    "City": "Lunenburg"
  },
  {
    "State": "VT",
    "City": "Norton"
  },
  {
    "State": "CT",
    "City": "Avon"
  },
  {
    "State": "CT",
    "City": "Bloomfield"
  },
  {
    "State": "CT",
    "City": "Windsor"
  },
  {
    "State": "CT",
    "City": "Bristol"
  },
  {
    "State": "CT",
    "City": "Burlington"
  },
  {
    "State": "CT",
    "City": "Broad Brook"
  },
  {
    "State": "CT",
    "City": "Canaan"
  },
  {
    "State": "CT",
    "City": "Canton"
  },
  {
    "State": "CT",
    "City": "Canton Center"
  },
  {
    "State": "CT",
    "City": "Colebrook"
  },
  {
    "State": "CT",
    "City": "Collinsville"
  },
  {
    "State": "CT",
    "City": "East Berlin"
  },
  {
    "State": "CT",
    "City": "East Canaan"
  },
  {
    "State": "CT",
    "City": "East Glastonbury"
  },
  {
    "State": "CT",
    "City": "East Granby"
  },
  {
    "State": "CT",
    "City": "East Hartland"
  },
  {
    "State": "CT",
    "City": "East Windsor Hill"
  },
  {
    "State": "CT",
    "City": "Ellington"
  },
  {
    "State": "CT",
    "City": "Farmington"
  },
  {
    "State": "CT",
    "City": "Falls Village"
  },
  {
    "State": "CT",
    "City": "Glastonbury"
  },
  {
    "State": "CT",
    "City": "Granby"
  },
  {
    "State": "CT",
    "City": "Berlin"
  },
  {
    "State": "CT",
    "City": "Lakeville"
  },
  {
    "State": "CT",
    "City": "Manchester"
  },
  {
    "State": "CT",
    "City": "Bolton"
  },
  {
    "State": "CT",
    "City": "New Britain"
  },
  {
    "State": "CT",
    "City": "New Hartford"
  },
  {
    "State": "CT",
    "City": "Norfolk"
  },
  {
    "State": "CT",
    "City": "North Canton"
  },
  {
    "State": "CT",
    "City": "North Granby"
  },
  {
    "State": "CT",
    "City": "Pine Meadow"
  },
  {
    "State": "CT",
    "City": "Plainville"
  },
  {
    "State": "CT",
    "City": "Barkhamsted"
  },
  {
    "State": "CT",
    "City": "Poquonock"
  },
  {
    "State": "CT",
    "City": "Riverton"
  },
  {
    "State": "CT",
    "City": "Vernon Rockville"
  },
  {
    "State": "CT",
    "City": "Rocky Hill"
  },
  {
    "State": "CT",
    "City": "Salisbury"
  },
  {
    "State": "CT",
    "City": "Sharon"
  },
  {
    "State": "CT",
    "City": "Simsbury"
  },
  {
    "State": "CT",
    "City": "Somers"
  },
  {
    "State": "CT",
    "City": "Somersville"
  },
  {
    "State": "CT",
    "City": "South Glastonbury"
  },
  {
    "State": "CT",
    "City": "South Windsor"
  },
  {
    "State": "CT",
    "City": "Stafford"
  },
  {
    "State": "CT",
    "City": "Stafford Springs"
  },
  {
    "State": "CT",
    "City": "Staffordville"
  },
  {
    "State": "CT",
    "City": "Suffield"
  },
  {
    "State": "CT",
    "City": "Taconic"
  },
  {
    "State": "CT",
    "City": "Tariffville"
  },
  {
    "State": "CT",
    "City": "Enfield"
  },
  {
    "State": "CT",
    "City": "Tolland"
  },
  {
    "State": "CT",
    "City": "Unionville"
  },
  {
    "State": "CT",
    "City": "East Windsor"
  },
  {
    "State": "CT",
    "City": "Weatogue"
  },
  {
    "State": "CT",
    "City": "West Granby"
  },
  {
    "State": "CT",
    "City": "West Hartland"
  },
  {
    "State": "CT",
    "City": "West Simsbury"
  },
  {
    "State": "CT",
    "City": "West Suffield"
  },
  {
    "State": "CT",
    "City": "Winchester Center"
  },
  {
    "State": "CT",
    "City": "Windsor Locks"
  },
  {
    "State": "CT",
    "City": "Winsted"
  },
  {
    "State": "CT",
    "City": "Hartford"
  },
  {
    "State": "CT",
    "City": "West Hartford"
  },
  {
    "State": "CT",
    "City": "East Hartford"
  },
  {
    "State": "CT",
    "City": "Wethersfield"
  },
  {
    "State": "CT",
    "City": "Newington"
  },
  {
    "State": "CT",
    "City": "Willimantic"
  },
  {
    "State": "CT",
    "City": "Abington"
  },
  {
    "State": "CT",
    "City": "Amston"
  },
  {
    "State": "CT",
    "City": "Andover"
  },
  {
    "State": "CT",
    "City": "Ballouville"
  },
  {
    "State": "CT",
    "City": "Brooklyn"
  },
  {
    "State": "CT",
    "City": "Chaplin"
  },
  {
    "State": "CT",
    "City": "Columbia"
  },
  {
    "State": "CT",
    "City": "Coventry"
  },
  {
    "State": "CT",
    "City": "Danielson"
  },
  {
    "State": "CT",
    "City": "Dayville"
  },
  {
    "State": "CT",
    "City": "Eastford"
  },
  {
    "State": "CT",
    "City": "East Killingly"
  },
  {
    "State": "CT",
    "City": "East Woodstock"
  },
  {
    "State": "CT",
    "City": "Fabyan"
  },
  {
    "State": "CT",
    "City": "Grosvenor Dale"
  },
  {
    "State": "CT",
    "City": "Hampton"
  },
  {
    "State": "CT",
    "City": "Hebron"
  },
  {
    "State": "CT",
    "City": "Lebanon"
  },
  {
    "State": "CT",
    "City": "Mansfield Center"
  },
  {
    "State": "CT",
    "City": "Mansfield Depot"
  },
  {
    "State": "CT",
    "City": "North Franklin"
  },
  {
    "State": "CT",
    "City": "North Grosvenordale"
  },
  {
    "State": "CT",
    "City": "North Windham"
  },
  {
    "State": "CT",
    "City": "Pomfret"
  },
  {
    "State": "CT",
    "City": "Pomfret Center"
  },
  {
    "State": "CT",
    "City": "Putnam"
  },
  {
    "State": "CT",
    "City": "Quinebaug"
  },
  {
    "State": "CT",
    "City": "Rogers"
  },
  {
    "State": "CT",
    "City": "Scotland"
  },
  {
    "State": "CT",
    "City": "South Willington"
  },
  {
    "State": "CT",
    "City": "South Windham"
  },
  {
    "State": "CT",
    "City": "South Woodstock"
  },
  {
    "State": "CT",
    "City": "Storrs Mansfield"
  },
  {
    "State": "CT",
    "City": "Thompson"
  },
  {
    "State": "CT",
    "City": "Ashford"
  },
  {
    "State": "CT",
    "City": "Willington"
  },
  {
    "State": "CT",
    "City": "Windham"
  },
  {
    "State": "CT",
    "City": "Woodstock"
  },
  {
    "State": "CT",
    "City": "Woodstock Valley"
  },
  {
    "State": "CT",
    "City": "New London"
  },
  {
    "State": "CT",
    "City": "Baltic"
  },
  {
    "State": "CT",
    "City": "Canterbury"
  },
  {
    "State": "CT",
    "City": "Central Village"
  },
  {
    "State": "CT",
    "City": "East Lyme"
  },
  {
    "State": "CT",
    "City": "Bozrah"
  },
  {
    "State": "CT",
    "City": "Gales Ferry"
  },
  {
    "State": "CT",
    "City": "Gilman"
  },
  {
    "State": "CT",
    "City": "Mashantucket"
  },
  {
    "State": "CT",
    "City": "Ledyard"
  },
  {
    "State": "CT",
    "City": "Groton"
  },
  {
    "State": "CT",
    "City": "Hanover"
  },
  {
    "State": "CT",
    "City": "Jewett City"
  },
  {
    "State": "CT",
    "City": "Montville"
  },
  {
    "State": "CT",
    "City": "Moosup"
  },
  {
    "State": "CT",
    "City": "Mystic"
  },
  {
    "State": "CT",
    "City": "Niantic"
  },
  {
    "State": "CT",
    "City": "North Stonington"
  },
  {
    "State": "CT",
    "City": "Norwich"
  },
  {
    "State": "CT",
    "City": "Preston"
  },
  {
    "State": "CT",
    "City": "Oakdale"
  },
  {
    "State": "CT",
    "City": "Old Lyme"
  },
  {
    "State": "CT",
    "City": "Old Mystic"
  },
  {
    "State": "CT",
    "City": "Oneco"
  },
  {
    "State": "CT",
    "City": "Plainfield"
  },
  {
    "State": "CT",
    "City": "Quaker Hill"
  },
  {
    "State": "CT",
    "City": "South Lyme"
  },
  {
    "State": "CT",
    "City": "Sterling"
  },
  {
    "State": "CT",
    "City": "Stonington"
  },
  {
    "State": "CT",
    "City": "Pawcatuck"
  },
  {
    "State": "CT",
    "City": "Taftville"
  },
  {
    "State": "CT",
    "City": "Uncasville"
  },
  {
    "State": "CT",
    "City": "Versailles"
  },
  {
    "State": "CT",
    "City": "Voluntown"
  },
  {
    "State": "CT",
    "City": "Waterford"
  },
  {
    "State": "CT",
    "City": "Wauregan"
  },
  {
    "State": "CT",
    "City": "West Mystic"
  },
  {
    "State": "CT",
    "City": "Yantic"
  },
  {
    "State": "NY",
    "City": "Fishers Island"
  },
  {
    "State": "CT",
    "City": "Ansonia"
  },
  {
    "State": "CT",
    "City": "Beacon Falls"
  },
  {
    "State": "CT",
    "City": "Botsford"
  },
  {
    "State": "CT",
    "City": "Branford"
  },
  {
    "State": "CT",
    "City": "Cheshire"
  },
  {
    "State": "CT",
    "City": "Centerbrook"
  },
  {
    "State": "CT",
    "City": "Chester"
  },
  {
    "State": "CT",
    "City": "Clinton"
  },
  {
    "State": "CT",
    "City": "Cobalt"
  },
  {
    "State": "CT",
    "City": "Colchester"
  },
  {
    "State": "CT",
    "City": "Cromwell"
  },
  {
    "State": "CT",
    "City": "Deep River"
  },
  {
    "State": "CT",
    "City": "Derby"
  },
  {
    "State": "CT",
    "City": "Killingworth"
  },
  {
    "State": "CT",
    "City": "Salem"
  },
  {
    "State": "CT",
    "City": "Durham"
  },
  {
    "State": "CT",
    "City": "East Haddam"
  },
  {
    "State": "CT",
    "City": "East Hampton"
  },
  {
    "State": "CT",
    "City": "Essex"
  },
  {
    "State": "CT",
    "City": "Guilford"
  },
  {
    "State": "CT",
    "City": "Haddam"
  },
  {
    "State": "CT",
    "City": "Hadlyme"
  },
  {
    "State": "CT",
    "City": "Hawleyville"
  },
  {
    "State": "CT",
    "City": "Higganum"
  },
  {
    "State": "CT",
    "City": "Ivoryton"
  },
  {
    "State": "CT",
    "City": "Madison"
  },
  {
    "State": "CT",
    "City": "Marion"
  },
  {
    "State": "CT",
    "City": "Marlborough"
  },
  {
    "State": "CT",
    "City": "Meriden"
  },
  {
    "State": "CT",
    "City": "Middlefield"
  },
  {
    "State": "CT",
    "City": "Middle Haddam"
  },
  {
    "State": "CT",
    "City": "Middletown"
  },
  {
    "State": "CT",
    "City": "Milford"
  },
  {
    "State": "CT",
    "City": "Milldale"
  },
  {
    "State": "CT",
    "City": "Monroe"
  },
  {
    "State": "CT",
    "City": "Moodus"
  },
  {
    "State": "CT",
    "City": "Newtown"
  },
  {
    "State": "CT",
    "City": "North Branford"
  },
  {
    "State": "CT",
    "City": "Northford"
  },
  {
    "State": "CT",
    "City": "North Haven"
  },
  {
    "State": "CT",
    "City": "North Westchester"
  },
  {
    "State": "CT",
    "City": "Old Saybrook"
  },
  {
    "State": "CT",
    "City": "Orange"
  },
  {
    "State": "CT",
    "City": "Oxford"
  },
  {
    "State": "CT",
    "City": "Plantsville"
  },
  {
    "State": "CT",
    "City": "Portland"
  },
  {
    "State": "CT",
    "City": "Rockfall"
  },
  {
    "State": "CT",
    "City": "Sandy Hook"
  },
  {
    "State": "CT",
    "City": "Seymour"
  },
  {
    "State": "CT",
    "City": "Shelton"
  },
  {
    "State": "CT",
    "City": "South Britain"
  },
  {
    "State": "CT",
    "City": "Southbury"
  },
  {
    "State": "CT",
    "City": "Southington"
  },
  {
    "State": "CT",
    "City": "Stevenson"
  },
  {
    "State": "CT",
    "City": "Wallingford"
  },
  {
    "State": "CT",
    "City": "Stratford"
  },
  {
    "State": "CT",
    "City": "Westbrook"
  },
  {
    "State": "CT",
    "City": "New Haven"
  },
  {
    "State": "CT",
    "City": "East Haven"
  },
  {
    "State": "CT",
    "City": "Hamden"
  },
  {
    "State": "CT",
    "City": "West Haven"
  },
  {
    "State": "CT",
    "City": "Bethany"
  },
  {
    "State": "CT",
    "City": "Woodbridge"
  },
  {
    "State": "CT",
    "City": "Bridgeport"
  },
  {
    "State": "CT",
    "City": "Trumbull"
  },
  {
    "State": "CT",
    "City": "Easton"
  },
  {
    "State": "CT",
    "City": "Waterbury"
  },
  {
    "State": "CT",
    "City": "Prospect"
  },
  {
    "State": "CT",
    "City": "Wolcott"
  },
  {
    "State": "CT",
    "City": "Bantam"
  },
  {
    "State": "CT",
    "City": "Bethlehem"
  },
  {
    "State": "CT",
    "City": "Bridgewater"
  },
  {
    "State": "CT",
    "City": "Cornwall"
  },
  {
    "State": "CT",
    "City": "Cornwall Bridge"
  },
  {
    "State": "CT",
    "City": "Gaylordsville"
  },
  {
    "State": "CT",
    "City": "Goshen"
  },
  {
    "State": "CT",
    "City": "Kent"
  },
  {
    "State": "CT",
    "City": "Lakeside"
  },
  {
    "State": "CT",
    "City": "Litchfield"
  },
  {
    "State": "CT",
    "City": "Middlebury"
  },
  {
    "State": "CT",
    "City": "Morris"
  },
  {
    "State": "CT",
    "City": "Naugatuck"
  },
  {
    "State": "CT",
    "City": "New Milford"
  },
  {
    "State": "CT",
    "City": "New Preston Marble Dale"
  },
  {
    "State": "CT",
    "City": "Northfield"
  },
  {
    "State": "CT",
    "City": "Oakville"
  },
  {
    "State": "CT",
    "City": "Pequabuck"
  },
  {
    "State": "CT",
    "City": "Plymouth"
  },
  {
    "State": "CT",
    "City": "Roxbury"
  },
  {
    "State": "CT",
    "City": "Sherman"
  },
  {
    "State": "CT",
    "City": "South Kent"
  },
  {
    "State": "CT",
    "City": "Terryville"
  },
  {
    "State": "CT",
    "City": "Thomaston"
  },
  {
    "State": "CT",
    "City": "Torrington"
  },
  {
    "State": "CT",
    "City": "Harwinton"
  },
  {
    "State": "CT",
    "City": "Washington"
  },
  {
    "State": "CT",
    "City": "Washington Depot"
  },
  {
    "State": "CT",
    "City": "Watertown"
  },
  {
    "State": "CT",
    "City": "West Cornwall"
  },
  {
    "State": "CT",
    "City": "Woodbury"
  },
  {
    "State": "CT",
    "City": "Bethel"
  },
  {
    "State": "CT",
    "City": "Brookfield"
  },
  {
    "State": "CT",
    "City": "Cos Cob"
  },
  {
    "State": "CT",
    "City": "Danbury"
  },
  {
    "State": "CT",
    "City": "New Fairfield"
  },
  {
    "State": "CT",
    "City": "Darien"
  },
  {
    "State": "CT",
    "City": "Fairfield"
  },
  {
    "State": "CT",
    "City": "Georgetown"
  },
  {
    "State": "CT",
    "City": "Greenwich"
  },
  {
    "State": "CT",
    "City": "Greens Farms"
  },
  {
    "State": "CT",
    "City": "New Canaan"
  },
  {
    "State": "CT",
    "City": "Norwalk"
  },
  {
    "State": "CT",
    "City": "Old Greenwich"
  },
  {
    "State": "CT",
    "City": "Redding Center"
  },
  {
    "State": "CT",
    "City": "Redding Ridge"
  },
  {
    "State": "CT",
    "City": "Ridgefield"
  },
  {
    "State": "CT",
    "City": "Riverside"
  },
  {
    "State": "CT",
    "City": "Westport"
  },
  {
    "State": "CT",
    "City": "Weston"
  },
  {
    "State": "CT",
    "City": "Southport"
  },
  {
    "State": "CT",
    "City": "Redding"
  },
  {
    "State": "CT",
    "City": "Wilton"
  },
  {
    "State": "CT",
    "City": "Stamford"
  },
  {
    "State": "NJ",
    "City": "Avenel"
  },
  {
    "State": "NJ",
    "City": "Bayonne"
  },
  {
    "State": "NJ",
    "City": "Bloomfield"
  },
  {
    "State": "NJ",
    "City": "Fairfield"
  },
  {
    "State": "NJ",
    "City": "Boonton"
  },
  {
    "State": "NJ",
    "City": "Caldwell"
  },
  {
    "State": "NJ",
    "City": "Carteret"
  },
  {
    "State": "NJ",
    "City": "Cedar Grove"
  },
  {
    "State": "NJ",
    "City": "Cliffside Park"
  },
  {
    "State": "NJ",
    "City": "Clifton"
  },
  {
    "State": "NJ",
    "City": "Cranford"
  },
  {
    "State": "NJ",
    "City": "East Orange"
  },
  {
    "State": "NJ",
    "City": "Edgewater"
  },
  {
    "State": "NJ",
    "City": "Essex Fells"
  },
  {
    "State": "NJ",
    "City": "Fairview"
  },
  {
    "State": "NJ",
    "City": "Fanwood"
  },
  {
    "State": "NJ",
    "City": "Fort Lee"
  },
  {
    "State": "NJ",
    "City": "Garfield"
  },
  {
    "State": "NJ",
    "City": "Garwood"
  },
  {
    "State": "NJ",
    "City": "Glen Ridge"
  },
  {
    "State": "NJ",
    "City": "Harrison"
  },
  {
    "State": "NJ",
    "City": "Hoboken"
  },
  {
    "State": "NJ",
    "City": "North Arlington"
  },
  {
    "State": "NJ",
    "City": "Kearny"
  },
  {
    "State": "NJ",
    "City": "Kenilworth"
  },
  {
    "State": "NJ",
    "City": "Lake Hiawatha"
  },
  {
    "State": "NJ",
    "City": "Lincoln Park"
  },
  {
    "State": "NJ",
    "City": "Linden"
  },
  {
    "State": "NJ",
    "City": "Livingston"
  },
  {
    "State": "NJ",
    "City": "Maplewood"
  },
  {
    "State": "NJ",
    "City": "Millburn"
  },
  {
    "State": "NJ",
    "City": "Montclair"
  },
  {
    "State": "NJ",
    "City": "Verona"
  },
  {
    "State": "NJ",
    "City": "Montville"
  },
  {
    "State": "NJ",
    "City": "Mountain Lakes"
  },
  {
    "State": "NJ",
    "City": "North Bergen"
  },
  {
    "State": "NJ",
    "City": "Orange"
  },
  {
    "State": "NJ",
    "City": "West Orange"
  },
  {
    "State": "NJ",
    "City": "Parsippany"
  },
  {
    "State": "NJ",
    "City": "Passaic"
  },
  {
    "State": "NJ",
    "City": "Wallington"
  },
  {
    "State": "NJ",
    "City": "Pine Brook"
  },
  {
    "State": "NJ",
    "City": "Warren"
  },
  {
    "State": "NJ",
    "City": "Plainfield"
  },
  {
    "State": "NJ",
    "City": "Port Reading"
  },
  {
    "State": "NJ",
    "City": "Rahway"
  },
  {
    "State": "NJ",
    "City": "Clark"
  },
  {
    "State": "NJ",
    "City": "Colonia"
  },
  {
    "State": "NJ",
    "City": "Roseland"
  },
  {
    "State": "NJ",
    "City": "Watchung"
  },
  {
    "State": "NJ",
    "City": "Rutherford"
  },
  {
    "State": "NJ",
    "City": "Lyndhurst"
  },
  {
    "State": "NJ",
    "City": "Carlstadt"
  },
  {
    "State": "NJ",
    "City": "East Rutherford"
  },
  {
    "State": "NJ",
    "City": "Moonachie"
  },
  {
    "State": "NJ",
    "City": "Wood Ridge"
  },
  {
    "State": "NJ",
    "City": "Scotch Plains"
  },
  {
    "State": "NJ",
    "City": "Sewaren"
  },
  {
    "State": "NJ",
    "City": "Short Hills"
  },
  {
    "State": "NJ",
    "City": "South Orange"
  },
  {
    "State": "NJ",
    "City": "South Plainfield"
  },
  {
    "State": "NJ",
    "City": "Springfield"
  },
  {
    "State": "NJ",
    "City": "Towaco"
  },
  {
    "State": "NJ",
    "City": "Union"
  },
  {
    "State": "NJ",
    "City": "Weehawken"
  },
  {
    "State": "NJ",
    "City": "Union City"
  },
  {
    "State": "NJ",
    "City": "Vauxhall"
  },
  {
    "State": "NJ",
    "City": "Westfield"
  },
  {
    "State": "NJ",
    "City": "Mountainside"
  },
  {
    "State": "NJ",
    "City": "West New York"
  },
  {
    "State": "NJ",
    "City": "Secaucus"
  },
  {
    "State": "NJ",
    "City": "Woodbridge"
  },
  {
    "State": "NJ",
    "City": "Jersey City"
  },
  {
    "State": "NJ",
    "City": "Newark"
  },
  {
    "State": "NJ",
    "City": "Belleville"
  },
  {
    "State": "NJ",
    "City": "Nutley"
  },
  {
    "State": "NJ",
    "City": "Irvington"
  },
  {
    "State": "NJ",
    "City": "Elizabeth"
  },
  {
    "State": "NJ",
    "City": "Roselle"
  },
  {
    "State": "NJ",
    "City": "Roselle Park"
  },
  {
    "State": "NJ",
    "City": "Hillside"
  },
  {
    "State": "NJ",
    "City": "Elizabethport"
  },
  {
    "State": "NJ",
    "City": "Allendale"
  },
  {
    "State": "NJ",
    "City": "Bloomingdale"
  },
  {
    "State": "NJ",
    "City": "Butler"
  },
  {
    "State": "NJ",
    "City": "Elmwood Park"
  },
  {
    "State": "NJ",
    "City": "Fair Lawn"
  },
  {
    "State": "NJ",
    "City": "Franklin"
  },
  {
    "State": "NJ",
    "City": "Franklin Lakes"
  },
  {
    "State": "NJ",
    "City": "Glenwood"
  },
  {
    "State": "NJ",
    "City": "Hamburg"
  },
  {
    "State": "NJ",
    "City": "Haskell"
  },
  {
    "State": "NJ",
    "City": "Hewitt"
  },
  {
    "State": "NJ",
    "City": "Highland Lakes"
  },
  {
    "State": "NJ",
    "City": "Ho Ho Kus"
  },
  {
    "State": "NJ",
    "City": "Little Falls"
  },
  {
    "State": "NJ",
    "City": "Mc Afee"
  },
  {
    "State": "NJ",
    "City": "Mahwah"
  },
  {
    "State": "NJ",
    "City": "Midland Park"
  },
  {
    "State": "NJ",
    "City": "Newfoundland"
  },
  {
    "State": "NJ",
    "City": "Oakland"
  },
  {
    "State": "NJ",
    "City": "Oak Ridge"
  },
  {
    "State": "NJ",
    "City": "Ogdensburg"
  },
  {
    "State": "NJ",
    "City": "Pequannock"
  },
  {
    "State": "NJ",
    "City": "Pompton Lakes"
  },
  {
    "State": "NJ",
    "City": "Pompton Plains"
  },
  {
    "State": "NJ",
    "City": "Ramsey"
  },
  {
    "State": "NJ",
    "City": "Ridgewood"
  },
  {
    "State": "NJ",
    "City": "Glen Rock"
  },
  {
    "State": "NJ",
    "City": "Ringwood"
  },
  {
    "State": "NJ",
    "City": "Riverdale"
  },
  {
    "State": "NJ",
    "City": "Saddle River"
  },
  {
    "State": "NJ",
    "City": "Stockholm"
  },
  {
    "State": "NJ",
    "City": "Sussex"
  },
  {
    "State": "NJ",
    "City": "Vernon"
  },
  {
    "State": "NJ",
    "City": "Waldwick"
  },
  {
    "State": "NJ",
    "City": "Wanaque"
  },
  {
    "State": "NJ",
    "City": "Wayne"
  },
  {
    "State": "NJ",
    "City": "West Milford"
  },
  {
    "State": "NJ",
    "City": "Wyckoff"
  },
  {
    "State": "NJ",
    "City": "Paterson"
  },
  {
    "State": "NJ",
    "City": "Hawthorne"
  },
  {
    "State": "NJ",
    "City": "Haledon"
  },
  {
    "State": "NJ",
    "City": "Totowa"
  },
  {
    "State": "NJ",
    "City": "Hackensack"
  },
  {
    "State": "NJ",
    "City": "Bogota"
  },
  {
    "State": "NJ",
    "City": "Hasbrouck Heights"
  },
  {
    "State": "NJ",
    "City": "Leonia"
  },
  {
    "State": "NJ",
    "City": "South Hackensack"
  },
  {
    "State": "NJ",
    "City": "Maywood"
  },
  {
    "State": "NJ",
    "City": "Teterboro"
  },
  {
    "State": "NJ",
    "City": "Alpine"
  },
  {
    "State": "NJ",
    "City": "Bergenfield"
  },
  {
    "State": "NJ",
    "City": "Closter"
  },
  {
    "State": "NJ",
    "City": "Cresskill"
  },
  {
    "State": "NJ",
    "City": "Demarest"
  },
  {
    "State": "NJ",
    "City": "Dumont"
  },
  {
    "State": "NJ",
    "City": "Emerson"
  },
  {
    "State": "NJ",
    "City": "Englewood"
  },
  {
    "State": "NJ",
    "City": "Englewood Cliffs"
  },
  {
    "State": "NJ",
    "City": "Harrington Park"
  },
  {
    "State": "NJ",
    "City": "Haworth"
  },
  {
    "State": "NJ",
    "City": "Hillsdale"
  },
  {
    "State": "NJ",
    "City": "Little Ferry"
  },
  {
    "State": "NJ",
    "City": "Lodi"
  },
  {
    "State": "NJ",
    "City": "Montvale"
  },
  {
    "State": "NJ",
    "City": "New Milford"
  },
  {
    "State": "NJ",
    "City": "Northvale"
  },
  {
    "State": "NJ",
    "City": "Norwood"
  },
  {
    "State": "NJ",
    "City": "Oradell"
  },
  {
    "State": "NJ",
    "City": "Palisades Park"
  },
  {
    "State": "NJ",
    "City": "Paramus"
  },
  {
    "State": "NJ",
    "City": "Park Ridge"
  },
  {
    "State": "NJ",
    "City": "Ridgefield"
  },
  {
    "State": "NJ",
    "City": "Ridgefield Park"
  },
  {
    "State": "NJ",
    "City": "River Edge"
  },
  {
    "State": "NJ",
    "City": "Rochelle Park"
  },
  {
    "State": "NJ",
    "City": "Saddle Brook"
  },
  {
    "State": "NJ",
    "City": "Teaneck"
  },
  {
    "State": "NJ",
    "City": "Tenafly"
  },
  {
    "State": "NJ",
    "City": "Westwood"
  },
  {
    "State": "NJ",
    "City": "Township Of Washington"
  },
  {
    "State": "NJ",
    "City": "Woodcliff Lake"
  },
  {
    "State": "NJ",
    "City": "Red Bank"
  },
  {
    "State": "NJ",
    "City": "Shrewsbury"
  },
  {
    "State": "NJ",
    "City": "Fort Monmouth"
  },
  {
    "State": "NJ",
    "City": "Fair Haven"
  },
  {
    "State": "NJ",
    "City": "Adelphia"
  },
  {
    "State": "NJ",
    "City": "Allenhurst"
  },
  {
    "State": "NJ",
    "City": "Asbury Park"
  },
  {
    "State": "NJ",
    "City": "Belmar"
  },
  {
    "State": "NJ",
    "City": "Atlantic Highlands"
  },
  {
    "State": "NJ",
    "City": "Avon By The Sea"
  },
  {
    "State": "NJ",
    "City": "Belford"
  },
  {
    "State": "NJ",
    "City": "Bradley Beach"
  },
  {
    "State": "NJ",
    "City": "Cliffwood"
  },
  {
    "State": "NJ",
    "City": "Colts Neck"
  },
  {
    "State": "NJ",
    "City": "Deal"
  },
  {
    "State": "NJ",
    "City": "Eatontown"
  },
  {
    "State": "NJ",
    "City": "Englishtown"
  },
  {
    "State": "NJ",
    "City": "Farmingdale"
  },
  {
    "State": "NJ",
    "City": "Freehold"
  },
  {
    "State": "NJ",
    "City": "Hazlet"
  },
  {
    "State": "NJ",
    "City": "Howell"
  },
  {
    "State": "NJ",
    "City": "Highlands"
  },
  {
    "State": "NJ",
    "City": "Holmdel"
  },
  {
    "State": "NJ",
    "City": "Keansburg"
  },
  {
    "State": "NJ",
    "City": "Keyport"
  },
  {
    "State": "NJ",
    "City": "Leonardo"
  },
  {
    "State": "NJ",
    "City": "Lincroft"
  },
  {
    "State": "NJ",
    "City": "Little Silver"
  },
  {
    "State": "NJ",
    "City": "Long Branch"
  },
  {
    "State": "NJ",
    "City": "Marlboro"
  },
  {
    "State": "NJ",
    "City": "Matawan"
  },
  {
    "State": "NJ",
    "City": "Middletown"
  },
  {
    "State": "NJ",
    "City": "Monmouth Beach"
  },
  {
    "State": "NJ",
    "City": "Morganville"
  },
  {
    "State": "NJ",
    "City": "Navesink"
  },
  {
    "State": "NJ",
    "City": "Neptune"
  },
  {
    "State": "NJ",
    "City": "Oakhurst"
  },
  {
    "State": "NJ",
    "City": "Ocean Grove"
  },
  {
    "State": "NJ",
    "City": "Oceanport"
  },
  {
    "State": "NJ",
    "City": "Port Monmouth"
  },
  {
    "State": "NJ",
    "City": "Rumson"
  },
  {
    "State": "NJ",
    "City": "Spring Lake"
  },
  {
    "State": "NJ",
    "City": "Tennent"
  },
  {
    "State": "NJ",
    "City": "West Long Branch"
  },
  {
    "State": "NJ",
    "City": "Wickatunk"
  },
  {
    "State": "NJ",
    "City": "Dover"
  },
  {
    "State": "NJ",
    "City": "Mine Hill"
  },
  {
    "State": "NJ",
    "City": "Picatinny Arsenal"
  },
  {
    "State": "NJ",
    "City": "Allamuchy"
  },
  {
    "State": "NJ",
    "City": "Andover"
  },
  {
    "State": "NJ",
    "City": "Augusta"
  },
  {
    "State": "NJ",
    "City": "Belvidere"
  },
  {
    "State": "NJ",
    "City": "Blairstown"
  },
  {
    "State": "NJ",
    "City": "Branchville"
  },
  {
    "State": "NJ",
    "City": "Montague"
  },
  {
    "State": "NJ",
    "City": "Budd Lake"
  },
  {
    "State": "NJ",
    "City": "Buttzville"
  },
  {
    "State": "NJ",
    "City": "Califon"
  },
  {
    "State": "NJ",
    "City": "Changewater"
  },
  {
    "State": "NJ",
    "City": "Columbia"
  },
  {
    "State": "NJ",
    "City": "Delaware"
  },
  {
    "State": "NJ",
    "City": "Denville"
  },
  {
    "State": "NJ",
    "City": "Flanders"
  },
  {
    "State": "NJ",
    "City": "Glasser"
  },
  {
    "State": "NJ",
    "City": "Great Meadows"
  },
  {
    "State": "NJ",
    "City": "Greendell"
  },
  {
    "State": "NJ",
    "City": "Hackettstown"
  },
  {
    "State": "NJ",
    "City": "Hibernia"
  },
  {
    "State": "NJ",
    "City": "Hopatcong"
  },
  {
    "State": "NJ",
    "City": "Hope"
  },
  {
    "State": "NJ",
    "City": "Ironia"
  },
  {
    "State": "NJ",
    "City": "Johnsonburg"
  },
  {
    "State": "NJ",
    "City": "Kenvil"
  },
  {
    "State": "NJ",
    "City": "Lafayette"
  },
  {
    "State": "NJ",
    "City": "Lake Hopatcong"
  },
  {
    "State": "NJ",
    "City": "Landing"
  },
  {
    "State": "NJ",
    "City": "Layton"
  },
  {
    "State": "NJ",
    "City": "Ledgewood"
  },
  {
    "State": "NJ",
    "City": "Long Valley"
  },
  {
    "State": "NJ",
    "City": "Middleville"
  },
  {
    "State": "NJ",
    "City": "Mount Arlington"
  },
  {
    "State": "NJ",
    "City": "Netcong"
  },
  {
    "State": "NJ",
    "City": "Newton"
  },
  {
    "State": "NJ",
    "City": "Oxford"
  },
  {
    "State": "NJ",
    "City": "Port Murray"
  },
  {
    "State": "NJ",
    "City": "Rockaway"
  },
  {
    "State": "NJ",
    "City": "Randolph"
  },
  {
    "State": "NJ",
    "City": "Schooleys Mountain"
  },
  {
    "State": "NJ",
    "City": "Sparta"
  },
  {
    "State": "NJ",
    "City": "Stanhope"
  },
  {
    "State": "NJ",
    "City": "Stillwater"
  },
  {
    "State": "NJ",
    "City": "Succasunna"
  },
  {
    "State": "NJ",
    "City": "Swartswood"
  },
  {
    "State": "NJ",
    "City": "Mount Tabor"
  },
  {
    "State": "NJ",
    "City": "Tranquility"
  },
  {
    "State": "NJ",
    "City": "Vienna"
  },
  {
    "State": "NJ",
    "City": "Wallpack Center"
  },
  {
    "State": "NJ",
    "City": "Washington"
  },
  {
    "State": "NJ",
    "City": "Wharton"
  },
  {
    "State": "NJ",
    "City": "Summit"
  },
  {
    "State": "NJ",
    "City": "Basking Ridge"
  },
  {
    "State": "NJ",
    "City": "Bedminster"
  },
  {
    "State": "NJ",
    "City": "Berkeley Heights"
  },
  {
    "State": "NJ",
    "City": "Bernardsville"
  },
  {
    "State": "NJ",
    "City": "Brookside"
  },
  {
    "State": "NJ",
    "City": "Cedar Knolls"
  },
  {
    "State": "NJ",
    "City": "Chatham"
  },
  {
    "State": "NJ",
    "City": "Chester"
  },
  {
    "State": "NJ",
    "City": "Far Hills"
  },
  {
    "State": "NJ",
    "City": "Florham Park"
  },
  {
    "State": "NJ",
    "City": "Gillette"
  },
  {
    "State": "NJ",
    "City": "Gladstone"
  },
  {
    "State": "NJ",
    "City": "Green Village"
  },
  {
    "State": "NJ",
    "City": "East Hanover"
  },
  {
    "State": "NJ",
    "City": "Liberty Corner"
  },
  {
    "State": "NJ",
    "City": "Lyons"
  },
  {
    "State": "NJ",
    "City": "Madison"
  },
  {
    "State": "NJ",
    "City": "Mendham"
  },
  {
    "State": "NJ",
    "City": "Millington"
  },
  {
    "State": "NJ",
    "City": "Morris Plains"
  },
  {
    "State": "NJ",
    "City": "Morristown"
  },
  {
    "State": "NJ",
    "City": "Convent Station"
  },
  {
    "State": "NJ",
    "City": "Mount Freedom"
  },
  {
    "State": "NJ",
    "City": "New Providence"
  },
  {
    "State": "NJ",
    "City": "New Vernon"
  },
  {
    "State": "NJ",
    "City": "Peapack"
  },
  {
    "State": "NJ",
    "City": "Pluckemin"
  },
  {
    "State": "NJ",
    "City": "Pottersville"
  },
  {
    "State": "NJ",
    "City": "Stirling"
  },
  {
    "State": "NJ",
    "City": "Whippany"
  },
  {
    "State": "NJ",
    "City": "Alloway"
  },
  {
    "State": "NJ",
    "City": "Cherry Hill"
  },
  {
    "State": "NJ",
    "City": "Atco"
  },
  {
    "State": "NJ",
    "City": "Barnegat"
  },
  {
    "State": "NJ",
    "City": "Barnegat Light"
  },
  {
    "State": "NJ",
    "City": "Barrington"
  },
  {
    "State": "NJ",
    "City": "Beach Haven"
  },
  {
    "State": "NJ",
    "City": "Berlin"
  },
  {
    "State": "NJ",
    "City": "Beverly"
  },
  {
    "State": "NJ",
    "City": "Birmingham"
  },
  {
    "State": "NJ",
    "City": "Blackwood"
  },
  {
    "State": "NJ",
    "City": "Bridgeport"
  },
  {
    "State": "NJ",
    "City": "Browns Mills"
  },
  {
    "State": "NJ",
    "City": "Burlington"
  },
  {
    "State": "NJ",
    "City": "Cedar Brook"
  },
  {
    "State": "NJ",
    "City": "Chatsworth"
  },
  {
    "State": "NJ",
    "City": "Clarksboro"
  },
  {
    "State": "NJ",
    "City": "Clementon"
  },
  {
    "State": "NJ",
    "City": "Columbus"
  },
  {
    "State": "NJ",
    "City": "Deepwater"
  },
  {
    "State": "NJ",
    "City": "Ewan"
  },
  {
    "State": "NJ",
    "City": "Gibbsboro"
  },
  {
    "State": "NJ",
    "City": "Gibbstown"
  },
  {
    "State": "NJ",
    "City": "Glassboro"
  },
  {
    "State": "NJ",
    "City": "Glendora"
  },
  {
    "State": "NJ",
    "City": "Gloucester City"
  },
  {
    "State": "NJ",
    "City": "Bellmawr"
  },
  {
    "State": "NJ",
    "City": "Grenloch"
  },
  {
    "State": "NJ",
    "City": "Haddonfield"
  },
  {
    "State": "NJ",
    "City": "Haddon Heights"
  },
  {
    "State": "NJ",
    "City": "Hainesport"
  },
  {
    "State": "NJ",
    "City": "Hammonton"
  },
  {
    "State": "NJ",
    "City": "Hancocks Bridge"
  },
  {
    "State": "NJ",
    "City": "Harrisonville"
  },
  {
    "State": "NJ",
    "City": "Jobstown"
  },
  {
    "State": "NJ",
    "City": "Juliustown"
  },
  {
    "State": "NJ",
    "City": "Voorhees"
  },
  {
    "State": "NJ",
    "City": "Lawnside"
  },
  {
    "State": "NJ",
    "City": "Willingboro"
  },
  {
    "State": "NJ",
    "City": "Lumberton"
  },
  {
    "State": "NJ",
    "City": "Magnolia"
  },
  {
    "State": "NJ",
    "City": "Manahawkin"
  },
  {
    "State": "NJ",
    "City": "Mantua"
  },
  {
    "State": "NJ",
    "City": "Maple Shade"
  },
  {
    "State": "NJ",
    "City": "Marlton"
  },
  {
    "State": "NJ",
    "City": "Mount Laurel"
  },
  {
    "State": "NJ",
    "City": "Medford"
  },
  {
    "State": "NJ",
    "City": "Mickleton"
  },
  {
    "State": "NJ",
    "City": "Moorestown"
  },
  {
    "State": "NJ",
    "City": "Mount Ephraim"
  },
  {
    "State": "NJ",
    "City": "Mount Holly"
  },
  {
    "State": "NJ",
    "City": "Mount Royal"
  },
  {
    "State": "NJ",
    "City": "Mullica Hill"
  },
  {
    "State": "NJ",
    "City": "National Park"
  },
  {
    "State": "NJ",
    "City": "New Lisbon"
  },
  {
    "State": "NJ",
    "City": "Palmyra"
  },
  {
    "State": "NJ",
    "City": "Paulsboro"
  },
  {
    "State": "NJ",
    "City": "Pedricktown"
  },
  {
    "State": "NJ",
    "City": "Pemberton"
  },
  {
    "State": "NJ",
    "City": "Penns Grove"
  },
  {
    "State": "NJ",
    "City": "Pennsville"
  },
  {
    "State": "NJ",
    "City": "Pitman"
  },
  {
    "State": "NJ",
    "City": "Quinton"
  },
  {
    "State": "NJ",
    "City": "Rancocas"
  },
  {
    "State": "NJ",
    "City": "Richwood"
  },
  {
    "State": "NJ",
    "City": "Riverside"
  },
  {
    "State": "NJ",
    "City": "Riverton"
  },
  {
    "State": "NJ",
    "City": "Runnemede"
  },
  {
    "State": "NJ",
    "City": "Salem"
  },
  {
    "State": "NJ",
    "City": "Sewell"
  },
  {
    "State": "NJ",
    "City": "Sicklerville"
  },
  {
    "State": "NJ",
    "City": "Somerdale"
  },
  {
    "State": "NJ",
    "City": "Stratford"
  },
  {
    "State": "NJ",
    "City": "Swedesboro"
  },
  {
    "State": "NJ",
    "City": "Thorofare"
  },
  {
    "State": "NJ",
    "City": "Tuckerton"
  },
  {
    "State": "NJ",
    "City": "Vincentown"
  },
  {
    "State": "NJ",
    "City": "Waterford Works"
  },
  {
    "State": "NJ",
    "City": "Wenonah"
  },
  {
    "State": "NJ",
    "City": "West Berlin"
  },
  {
    "State": "NJ",
    "City": "West Creek"
  },
  {
    "State": "NJ",
    "City": "Westville"
  },
  {
    "State": "NJ",
    "City": "Williamstown"
  },
  {
    "State": "NJ",
    "City": "Winslow"
  },
  {
    "State": "NJ",
    "City": "Woodbury"
  },
  {
    "State": "NJ",
    "City": "Woodbury Heights"
  },
  {
    "State": "NJ",
    "City": "Woodstown"
  },
  {
    "State": "NJ",
    "City": "Camden"
  },
  {
    "State": "NJ",
    "City": "Audubon"
  },
  {
    "State": "NJ",
    "City": "Oaklyn"
  },
  {
    "State": "NJ",
    "City": "Collingswood"
  },
  {
    "State": "NJ",
    "City": "Merchantville"
  },
  {
    "State": "NJ",
    "City": "Pennsauken"
  },
  {
    "State": "NJ",
    "City": "Absecon"
  },
  {
    "State": "NJ",
    "City": "Avalon"
  },
  {
    "State": "NJ",
    "City": "Brigantine"
  },
  {
    "State": "NJ",
    "City": "Cape May"
  },
  {
    "State": "NJ",
    "City": "Cape May Court House"
  },
  {
    "State": "NJ",
    "City": "Cape May Point"
  },
  {
    "State": "NJ",
    "City": "Cologne"
  },
  {
    "State": "NJ",
    "City": "Dennisville"
  },
  {
    "State": "NJ",
    "City": "Egg Harbor City"
  },
  {
    "State": "NJ",
    "City": "Elwood"
  },
  {
    "State": "NJ",
    "City": "Goshen"
  },
  {
    "State": "NJ",
    "City": "Green Creek"
  },
  {
    "State": "NJ",
    "City": "Leeds Point"
  },
  {
    "State": "NJ",
    "City": "Linwood"
  },
  {
    "State": "NJ",
    "City": "Marmora"
  },
  {
    "State": "NJ",
    "City": "New Gretna"
  },
  {
    "State": "NJ",
    "City": "Northfield"
  },
  {
    "State": "NJ",
    "City": "Ocean City"
  },
  {
    "State": "NJ",
    "City": "Ocean View"
  },
  {
    "State": "NJ",
    "City": "Oceanville"
  },
  {
    "State": "NJ",
    "City": "Pleasantville"
  },
  {
    "State": "NJ",
    "City": "Egg Harbor Township"
  },
  {
    "State": "NJ",
    "City": "Pomona"
  },
  {
    "State": "NJ",
    "City": "Port Republic"
  },
  {
    "State": "NJ",
    "City": "Rio Grande"
  },
  {
    "State": "NJ",
    "City": "Sea Isle City"
  },
  {
    "State": "NJ",
    "City": "Somers Point"
  },
  {
    "State": "NJ",
    "City": "South Dennis"
  },
  {
    "State": "NJ",
    "City": "South Seaville"
  },
  {
    "State": "NJ",
    "City": "Stone Harbor"
  },
  {
    "State": "NJ",
    "City": "Strathmere"
  },
  {
    "State": "NJ",
    "City": "Tuckahoe"
  },
  {
    "State": "NJ",
    "City": "Villas"
  },
  {
    "State": "NJ",
    "City": "Whitesboro"
  },
  {
    "State": "NJ",
    "City": "Wildwood"
  },
  {
    "State": "NJ",
    "City": "Woodbine"
  },
  {
    "State": "NJ",
    "City": "Bridgeton"
  },
  {
    "State": "NJ",
    "City": "Buena"
  },
  {
    "State": "NJ",
    "City": "Cedarville"
  },
  {
    "State": "NJ",
    "City": "Clayton"
  },
  {
    "State": "NJ",
    "City": "Deerfield Street"
  },
  {
    "State": "NJ",
    "City": "Delmont"
  },
  {
    "State": "NJ",
    "City": "Dividing Creek"
  },
  {
    "State": "NJ",
    "City": "Dorchester"
  },
  {
    "State": "NJ",
    "City": "Dorothy"
  },
  {
    "State": "NJ",
    "City": "Elmer"
  },
  {
    "State": "NJ",
    "City": "Estell Manor"
  },
  {
    "State": "NJ",
    "City": "Fairton"
  },
  {
    "State": "NJ",
    "City": "Fortescue"
  },
  {
    "State": "NJ",
    "City": "Franklinville"
  },
  {
    "State": "NJ",
    "City": "Greenwich"
  },
  {
    "State": "NJ",
    "City": "Heislerville"
  },
  {
    "State": "NJ",
    "City": "Landisville"
  },
  {
    "State": "NJ",
    "City": "Leesburg"
  },
  {
    "State": "NJ",
    "City": "Malaga"
  },
  {
    "State": "NJ",
    "City": "Mauricetown"
  },
  {
    "State": "NJ",
    "City": "Mays Landing"
  },
  {
    "State": "NJ",
    "City": "Millville"
  },
  {
    "State": "NJ",
    "City": "Milmay"
  },
  {
    "State": "NJ",
    "City": "Minotola"
  },
  {
    "State": "NJ",
    "City": "Mizpah"
  },
  {
    "State": "NJ",
    "City": "Monroeville"
  },
  {
    "State": "NJ",
    "City": "Newfield"
  },
  {
    "State": "NJ",
    "City": "Newport"
  },
  {
    "State": "NJ",
    "City": "Newtonville"
  },
  {
    "State": "NJ",
    "City": "Norma"
  },
  {
    "State": "NJ",
    "City": "Port Elizabeth"
  },
  {
    "State": "NJ",
    "City": "Port Norris"
  },
  {
    "State": "NJ",
    "City": "Richland"
  },
  {
    "State": "NJ",
    "City": "Rosenhayn"
  },
  {
    "State": "NJ",
    "City": "Shiloh"
  },
  {
    "State": "NJ",
    "City": "Vineland"
  },
  {
    "State": "NJ",
    "City": "Atlantic City"
  },
  {
    "State": "NJ",
    "City": "Margate City"
  },
  {
    "State": "NJ",
    "City": "Longport"
  },
  {
    "State": "NJ",
    "City": "Ventnor City"
  },
  {
    "State": "NJ",
    "City": "Allentown"
  },
  {
    "State": "NJ",
    "City": "Belle Mead"
  },
  {
    "State": "NJ",
    "City": "Blawenburg"
  },
  {
    "State": "NJ",
    "City": "Bordentown"
  },
  {
    "State": "NJ",
    "City": "Millstone Township"
  },
  {
    "State": "NJ",
    "City": "Cookstown"
  },
  {
    "State": "NJ",
    "City": "Cranbury"
  },
  {
    "State": "NJ",
    "City": "Cream Ridge"
  },
  {
    "State": "NJ",
    "City": "Chesterfield"
  },
  {
    "State": "NJ",
    "City": "Florence"
  },
  {
    "State": "NJ",
    "City": "Hightstown"
  },
  {
    "State": "NJ",
    "City": "Hopewell"
  },
  {
    "State": "NJ",
    "City": "Imlaystown"
  },
  {
    "State": "NJ",
    "City": "Jackson"
  },
  {
    "State": "NJ",
    "City": "Kingston"
  },
  {
    "State": "NJ",
    "City": "Lambertville"
  },
  {
    "State": "NJ",
    "City": "New Egypt"
  },
  {
    "State": "NJ",
    "City": "Pennington"
  },
  {
    "State": "NJ",
    "City": "Plainsboro"
  },
  {
    "State": "NJ",
    "City": "Princeton"
  },
  {
    "State": "NJ",
    "City": "Princeton Junction"
  },
  {
    "State": "NJ",
    "City": "Ringoes"
  },
  {
    "State": "NJ",
    "City": "Rocky Hill"
  },
  {
    "State": "NJ",
    "City": "Roebling"
  },
  {
    "State": "NJ",
    "City": "Roosevelt"
  },
  {
    "State": "NJ",
    "City": "Rosemont"
  },
  {
    "State": "NJ",
    "City": "Sergeantsville"
  },
  {
    "State": "NJ",
    "City": "Skillman"
  },
  {
    "State": "NJ",
    "City": "Stockton"
  },
  {
    "State": "NJ",
    "City": "Titusville"
  },
  {
    "State": "NJ",
    "City": "Windsor"
  },
  {
    "State": "NJ",
    "City": "Wrightstown"
  },
  {
    "State": "NJ",
    "City": "Trenton"
  },
  {
    "State": "NJ",
    "City": "Joint Base Mdl"
  },
  {
    "State": "NJ",
    "City": "Lawrence Township"
  },
  {
    "State": "NJ",
    "City": "Robbinsville"
  },
  {
    "State": "NJ",
    "City": "Lakewood"
  },
  {
    "State": "NJ",
    "City": "Allenwood"
  },
  {
    "State": "NJ",
    "City": "Bayville"
  },
  {
    "State": "NJ",
    "City": "Beachwood"
  },
  {
    "State": "NJ",
    "City": "Brick"
  },
  {
    "State": "NJ",
    "City": "Brielle"
  },
  {
    "State": "NJ",
    "City": "Forked River"
  },
  {
    "State": "NJ",
    "City": "Island Heights"
  },
  {
    "State": "NJ",
    "City": "Lakehurst"
  },
  {
    "State": "NJ",
    "City": "Lanoka Harbor"
  },
  {
    "State": "NJ",
    "City": "Lavallette"
  },
  {
    "State": "NJ",
    "City": "Manasquan"
  },
  {
    "State": "NJ",
    "City": "Mantoloking"
  },
  {
    "State": "NJ",
    "City": "Normandy Beach"
  },
  {
    "State": "NJ",
    "City": "Ocean Gate"
  },
  {
    "State": "NJ",
    "City": "Pine Beach"
  },
  {
    "State": "NJ",
    "City": "Point Pleasant Beach"
  },
  {
    "State": "NJ",
    "City": "Sea Girt"
  },
  {
    "State": "NJ",
    "City": "Seaside Heights"
  },
  {
    "State": "NJ",
    "City": "Seaside Park"
  },
  {
    "State": "NJ",
    "City": "Toms River"
  },
  {
    "State": "NJ",
    "City": "Waretown"
  },
  {
    "State": "NJ",
    "City": "Manchester Township"
  },
  {
    "State": "NJ",
    "City": "Annandale"
  },
  {
    "State": "NJ",
    "City": "Asbury"
  },
  {
    "State": "NJ",
    "City": "Baptistown"
  },
  {
    "State": "NJ",
    "City": "Bloomsbury"
  },
  {
    "State": "NJ",
    "City": "Bound Brook"
  },
  {
    "State": "NJ",
    "City": "Bridgewater"
  },
  {
    "State": "NJ",
    "City": "Broadway"
  },
  {
    "State": "NJ",
    "City": "Clinton"
  },
  {
    "State": "NJ",
    "City": "Dayton"
  },
  {
    "State": "NJ",
    "City": "Dunellen"
  },
  {
    "State": "NJ",
    "City": "East Brunswick"
  },
  {
    "State": "NJ",
    "City": "Edison"
  },
  {
    "State": "NJ",
    "City": "Flagtown"
  },
  {
    "State": "NJ",
    "City": "Flemington"
  },
  {
    "State": "NJ",
    "City": "Franklin Park"
  },
  {
    "State": "NJ",
    "City": "Kendall Park"
  },
  {
    "State": "NJ",
    "City": "Frenchtown"
  },
  {
    "State": "NJ",
    "City": "Glen Gardner"
  },
  {
    "State": "NJ",
    "City": "Hampton"
  },
  {
    "State": "NJ",
    "City": "Helmetta"
  },
  {
    "State": "NJ",
    "City": "High Bridge"
  },
  {
    "State": "NJ",
    "City": "Iselin"
  },
  {
    "State": "NJ",
    "City": "Monroe Township"
  },
  {
    "State": "NJ",
    "City": "Keasbey"
  },
  {
    "State": "NJ",
    "City": "Lebanon"
  },
  {
    "State": "NJ",
    "City": "Little York"
  },
  {
    "State": "NJ",
    "City": "Manville"
  },
  {
    "State": "NJ",
    "City": "Martinsville"
  },
  {
    "State": "NJ",
    "City": "Metuchen"
  },
  {
    "State": "NJ",
    "City": "Hillsborough"
  },
  {
    "State": "NJ",
    "City": "Middlesex"
  },
  {
    "State": "NJ",
    "City": "Milford"
  },
  {
    "State": "NJ",
    "City": "Milltown"
  },
  {
    "State": "NJ",
    "City": "Monmouth Junction"
  },
  {
    "State": "NJ",
    "City": "Neshanic Station"
  },
  {
    "State": "NJ",
    "City": "Piscataway"
  },
  {
    "State": "NJ",
    "City": "Old Bridge"
  },
  {
    "State": "NJ",
    "City": "Oldwick"
  },
  {
    "State": "NJ",
    "City": "Parlin"
  },
  {
    "State": "NJ",
    "City": "Perth Amboy"
  },
  {
    "State": "NJ",
    "City": "Fords"
  },
  {
    "State": "NJ",
    "City": "Phillipsburg"
  },
  {
    "State": "NJ",
    "City": "Pittstown"
  },
  {
    "State": "NJ",
    "City": "Quakertown"
  },
  {
    "State": "NJ",
    "City": "Raritan"
  },
  {
    "State": "NJ",
    "City": "Readington"
  },
  {
    "State": "NJ",
    "City": "Sayreville"
  },
  {
    "State": "NJ",
    "City": "Somerset"
  },
  {
    "State": "NJ",
    "City": "Somerville"
  },
  {
    "State": "NJ",
    "City": "South Amboy"
  },
  {
    "State": "NJ",
    "City": "South Bound Brook"
  },
  {
    "State": "NJ",
    "City": "South River"
  },
  {
    "State": "NJ",
    "City": "Spotswood"
  },
  {
    "State": "NJ",
    "City": "Stanton"
  },
  {
    "State": "NJ",
    "City": "Stewartsville"
  },
  {
    "State": "NJ",
    "City": "Three Bridges"
  },
  {
    "State": "NJ",
    "City": "Whitehouse"
  },
  {
    "State": "NJ",
    "City": "Whitehouse Station"
  },
  {
    "State": "NJ",
    "City": "Zarephath"
  },
  {
    "State": "NJ",
    "City": "New Brunswick"
  },
  {
    "State": "NJ",
    "City": "North Brunswick"
  },
  {
    "State": "NJ",
    "City": "Highland Park"
  },
  {
    "State": "AE",
    "City": "Apo"
  },
  {
    "State": "AE",
    "City": "Dpo"
  },
  {
    "State": "AE",
    "City": "Fpo"
  },
  {
    "State": "NY",
    "City": "New York"
  },
  {
    "State": "NY",
    "City": "Staten Island"
  },
  {
    "State": "NY",
    "City": "Bronx"
  },
  {
    "State": "NY",
    "City": "Amawalk"
  },
  {
    "State": "NY",
    "City": "Ardsley"
  },
  {
    "State": "NY",
    "City": "Ardsley On Hudson"
  },
  {
    "State": "NY",
    "City": "Armonk"
  },
  {
    "State": "NY",
    "City": "Baldwin Place"
  },
  {
    "State": "NY",
    "City": "Bedford"
  },
  {
    "State": "NY",
    "City": "Bedford Hills"
  },
  {
    "State": "NY",
    "City": "Brewster"
  },
  {
    "State": "NY",
    "City": "Briarcliff Manor"
  },
  {
    "State": "NY",
    "City": "Buchanan"
  },
  {
    "State": "NY",
    "City": "Carmel"
  },
  {
    "State": "NY",
    "City": "Chappaqua"
  },
  {
    "State": "NY",
    "City": "Cold Spring"
  },
  {
    "State": "NY",
    "City": "Crompond"
  },
  {
    "State": "NY",
    "City": "Cross River"
  },
  {
    "State": "NY",
    "City": "Croton Falls"
  },
  {
    "State": "NY",
    "City": "Croton On Hudson"
  },
  {
    "State": "NY",
    "City": "Dobbs Ferry"
  },
  {
    "State": "NY",
    "City": "Elmsford"
  },
  {
    "State": "NY",
    "City": "Garrison"
  },
  {
    "State": "NY",
    "City": "Goldens Bridge"
  },
  {
    "State": "NY",
    "City": "Granite Springs"
  },
  {
    "State": "NY",
    "City": "Harrison"
  },
  {
    "State": "NY",
    "City": "Hartsdale"
  },
  {
    "State": "NY",
    "City": "Hawthorne"
  },
  {
    "State": "NY",
    "City": "Irvington"
  },
  {
    "State": "NY",
    "City": "Jefferson Valley"
  },
  {
    "State": "NY",
    "City": "Katonah"
  },
  {
    "State": "NY",
    "City": "Lake Peekskill"
  },
  {
    "State": "NY",
    "City": "Larchmont"
  },
  {
    "State": "NY",
    "City": "Lincolndale"
  },
  {
    "State": "NY",
    "City": "Mahopac"
  },
  {
    "State": "NY",
    "City": "Mahopac Falls"
  },
  {
    "State": "NY",
    "City": "Mamaroneck"
  },
  {
    "State": "NY",
    "City": "Maryknoll"
  },
  {
    "State": "NY",
    "City": "Millwood"
  },
  {
    "State": "NY",
    "City": "Mohegan Lake"
  },
  {
    "State": "NY",
    "City": "Montrose"
  },
  {
    "State": "NY",
    "City": "Mount Kisco"
  },
  {
    "State": "NY",
    "City": "Mount Vernon"
  },
  {
    "State": "NY",
    "City": "North Salem"
  },
  {
    "State": "NY",
    "City": "Ossining"
  },
  {
    "State": "NY",
    "City": "Peekskill"
  },
  {
    "State": "NY",
    "City": "Cortlandt Manor"
  },
  {
    "State": "NY",
    "City": "Pleasantville"
  },
  {
    "State": "NY",
    "City": "Port Chester"
  },
  {
    "State": "NY",
    "City": "Pound Ridge"
  },
  {
    "State": "NY",
    "City": "Purchase"
  },
  {
    "State": "NY",
    "City": "Purdys"
  },
  {
    "State": "NY",
    "City": "Putnam Valley"
  },
  {
    "State": "NY",
    "City": "Rye"
  },
  {
    "State": "NY",
    "City": "Scarsdale"
  },
  {
    "State": "NY",
    "City": "Shenorock"
  },
  {
    "State": "NY",
    "City": "Shrub Oak"
  },
  {
    "State": "NY",
    "City": "Somers"
  },
  {
    "State": "NY",
    "City": "South Salem"
  },
  {
    "State": "NY",
    "City": "Tarrytown"
  },
  {
    "State": "NY",
    "City": "Thornwood"
  },
  {
    "State": "NY",
    "City": "Valhalla"
  },
  {
    "State": "NY",
    "City": "Verplanck"
  },
  {
    "State": "NY",
    "City": "Waccabuc"
  },
  {
    "State": "NY",
    "City": "Yorktown Heights"
  },
  {
    "State": "NY",
    "City": "White Plains"
  },
  {
    "State": "NY",
    "City": "West Harrison"
  },
  {
    "State": "NY",
    "City": "Yonkers"
  },
  {
    "State": "NY",
    "City": "Hastings On Hudson"
  },
  {
    "State": "NY",
    "City": "Tuckahoe"
  },
  {
    "State": "NY",
    "City": "Bronxville"
  },
  {
    "State": "NY",
    "City": "Eastchester"
  },
  {
    "State": "NY",
    "City": "New Rochelle"
  },
  {
    "State": "NY",
    "City": "Pelham"
  },
  {
    "State": "NY",
    "City": "Suffern"
  },
  {
    "State": "NY",
    "City": "Arden"
  },
  {
    "State": "NY",
    "City": "Bear Mountain"
  },
  {
    "State": "NY",
    "City": "Bellvale"
  },
  {
    "State": "NY",
    "City": "Blauvelt"
  },
  {
    "State": "NY",
    "City": "Blooming Grove"
  },
  {
    "State": "NY",
    "City": "Bullville"
  },
  {
    "State": "NY",
    "City": "Campbell Hall"
  },
  {
    "State": "NY",
    "City": "Central Valley"
  },
  {
    "State": "NY",
    "City": "Chester"
  },
  {
    "State": "NY",
    "City": "Circleville"
  },
  {
    "State": "NY",
    "City": "Congers"
  },
  {
    "State": "NY",
    "City": "Florida"
  },
  {
    "State": "NY",
    "City": "Fort Montgomery"
  },
  {
    "State": "NY",
    "City": "Garnerville"
  },
  {
    "State": "NY",
    "City": "Goshen"
  },
  {
    "State": "NY",
    "City": "Greenwood Lake"
  },
  {
    "State": "NY",
    "City": "Harriman"
  },
  {
    "State": "NY",
    "City": "Haverstraw"
  },
  {
    "State": "NY",
    "City": "Highland Falls"
  },
  {
    "State": "NY",
    "City": "Highland Mills"
  },
  {
    "State": "NY",
    "City": "Hillburn"
  },
  {
    "State": "NY",
    "City": "Howells"
  },
  {
    "State": "NY",
    "City": "Johnson"
  },
  {
    "State": "NY",
    "City": "Middletown"
  },
  {
    "State": "NY",
    "City": "Monroe"
  },
  {
    "State": "NY",
    "City": "Monsey"
  },
  {
    "State": "NY",
    "City": "Mountainville"
  },
  {
    "State": "NY",
    "City": "Nanuet"
  },
  {
    "State": "NY",
    "City": "New City"
  },
  {
    "State": "NY",
    "City": "New Hampton"
  },
  {
    "State": "NY",
    "City": "New Milford"
  },
  {
    "State": "NY",
    "City": "Nyack"
  },
  {
    "State": "NY",
    "City": "Orangeburg"
  },
  {
    "State": "NY",
    "City": "Otisville"
  },
  {
    "State": "NY",
    "City": "Palisades"
  },
  {
    "State": "NY",
    "City": "Pearl River"
  },
  {
    "State": "NY",
    "City": "Piermont"
  },
  {
    "State": "NY",
    "City": "Pine Island"
  },
  {
    "State": "NY",
    "City": "Pomona"
  },
  {
    "State": "NY",
    "City": "Slate Hill"
  },
  {
    "State": "NY",
    "City": "Sloatsburg"
  },
  {
    "State": "NY",
    "City": "Southfields"
  },
  {
    "State": "NY",
    "City": "Sparkill"
  },
  {
    "State": "NY",
    "City": "Spring Valley"
  },
  {
    "State": "NY",
    "City": "Sterling Forest"
  },
  {
    "State": "NY",
    "City": "Stony Point"
  },
  {
    "State": "NY",
    "City": "Sugar Loaf"
  },
  {
    "State": "NY",
    "City": "Tallman"
  },
  {
    "State": "NY",
    "City": "Tappan"
  },
  {
    "State": "NY",
    "City": "Thiells"
  },
  {
    "State": "NY",
    "City": "Thompson Ridge"
  },
  {
    "State": "NY",
    "City": "Tomkins Cove"
  },
  {
    "State": "NY",
    "City": "Tuxedo Park"
  },
  {
    "State": "NY",
    "City": "Unionville"
  },
  {
    "State": "NY",
    "City": "Valley Cottage"
  },
  {
    "State": "NY",
    "City": "Warwick"
  },
  {
    "State": "NY",
    "City": "Washingtonville"
  },
  {
    "State": "NY",
    "City": "West Haverstraw"
  },
  {
    "State": "NY",
    "City": "West Nyack"
  },
  {
    "State": "NY",
    "City": "West Point"
  },
  {
    "State": "NY",
    "City": "Westtown"
  },
  {
    "State": "NY",
    "City": "Floral Park"
  },
  {
    "State": "NY",
    "City": "Elmont"
  },
  {
    "State": "NY",
    "City": "Glen Oaks"
  },
  {
    "State": "NY",
    "City": "Franklin Square"
  },
  {
    "State": "NY",
    "City": "Great Neck"
  },
  {
    "State": "NY",
    "City": "Manhasset"
  },
  {
    "State": "NY",
    "City": "New Hyde Park"
  },
  {
    "State": "NY",
    "City": "Port Washington"
  },
  {
    "State": "NY",
    "City": "Inwood"
  },
  {
    "State": "NY",
    "City": "Long Island City"
  },
  {
    "State": "NY",
    "City": "Astoria"
  },
  {
    "State": "NY",
    "City": "Sunnyside"
  },
  {
    "State": "NY",
    "City": "Brooklyn"
  },
  {
    "State": "NY",
    "City": "Flushing"
  },
  {
    "State": "NY",
    "City": "College Point"
  },
  {
    "State": "NY",
    "City": "Whitestone"
  },
  {
    "State": "NY",
    "City": "Bayside"
  },
  {
    "State": "NY",
    "City": "Little Neck"
  },
  {
    "State": "NY",
    "City": "Oakland Gardens"
  },
  {
    "State": "NY",
    "City": "Fresh Meadows"
  },
  {
    "State": "NY",
    "City": "Corona"
  },
  {
    "State": "NY",
    "City": "East Elmhurst"
  },
  {
    "State": "NY",
    "City": "Jackson Heights"
  },
  {
    "State": "NY",
    "City": "Elmhurst"
  },
  {
    "State": "NY",
    "City": "Rego Park"
  },
  {
    "State": "NY",
    "City": "Forest Hills"
  },
  {
    "State": "NY",
    "City": "Woodside"
  },
  {
    "State": "NY",
    "City": "Maspeth"
  },
  {
    "State": "NY",
    "City": "Middle Village"
  },
  {
    "State": "NY",
    "City": "Ridgewood"
  },
  {
    "State": "NY",
    "City": "Jamaica"
  },
  {
    "State": "NY",
    "City": "Cambria Heights"
  },
  {
    "State": "NY",
    "City": "Saint Albans"
  },
  {
    "State": "NY",
    "City": "Springfield Gardens"
  },
  {
    "State": "NY",
    "City": "Howard Beach"
  },
  {
    "State": "NY",
    "City": "Kew Gardens"
  },
  {
    "State": "NY",
    "City": "Ozone Park"
  },
  {
    "State": "NY",
    "City": "Richmond Hill"
  },
  {
    "State": "NY",
    "City": "South Richmond Hill"
  },
  {
    "State": "NY",
    "City": "South Ozone Park"
  },
  {
    "State": "NY",
    "City": "Woodhaven"
  },
  {
    "State": "NY",
    "City": "Rosedale"
  },
  {
    "State": "NY",
    "City": "Hollis"
  },
  {
    "State": "NY",
    "City": "Bellerose"
  },
  {
    "State": "NY",
    "City": "Queens Village"
  },
  {
    "State": "NY",
    "City": "Mineola"
  },
  {
    "State": "NY",
    "City": "Albertson"
  },
  {
    "State": "NY",
    "City": "Atlantic Beach"
  },
  {
    "State": "NY",
    "City": "Baldwin"
  },
  {
    "State": "NY",
    "City": "Carle Place"
  },
  {
    "State": "NY",
    "City": "Cedarhurst"
  },
  {
    "State": "NY",
    "City": "East Rockaway"
  },
  {
    "State": "NY",
    "City": "Freeport"
  },
  {
    "State": "NY",
    "City": "Garden City"
  },
  {
    "State": "NY",
    "City": "Glen Cove"
  },
  {
    "State": "NY",
    "City": "Glen Head"
  },
  {
    "State": "NY",
    "City": "Glenwood Landing"
  },
  {
    "State": "NY",
    "City": "Greenvale"
  },
  {
    "State": "NY",
    "City": "Hempstead"
  },
  {
    "State": "NY",
    "City": "West Hempstead"
  },
  {
    "State": "NY",
    "City": "Uniondale"
  },
  {
    "State": "NY",
    "City": "East Meadow"
  },
  {
    "State": "NY",
    "City": "Hewlett"
  },
  {
    "State": "NY",
    "City": "Island Park"
  },
  {
    "State": "NY",
    "City": "Lawrence"
  },
  {
    "State": "NY",
    "City": "Locust Valley"
  },
  {
    "State": "NY",
    "City": "Long Beach"
  },
  {
    "State": "NY",
    "City": "Lynbrook"
  },
  {
    "State": "NY",
    "City": "Malverne"
  },
  {
    "State": "NY",
    "City": "Merrick"
  },
  {
    "State": "NY",
    "City": "Old Westbury"
  },
  {
    "State": "NY",
    "City": "Point Lookout"
  },
  {
    "State": "NY",
    "City": "Rockville Centre"
  },
  {
    "State": "NY",
    "City": "Oceanside"
  },
  {
    "State": "NY",
    "City": "Roosevelt"
  },
  {
    "State": "NY",
    "City": "Roslyn"
  },
  {
    "State": "NY",
    "City": "Roslyn Heights"
  },
  {
    "State": "NY",
    "City": "Sea Cliff"
  },
  {
    "State": "NY",
    "City": "Valley Stream"
  },
  {
    "State": "NY",
    "City": "Westbury"
  },
  {
    "State": "NY",
    "City": "Rockville Center"
  },
  {
    "State": "NY",
    "City": "Williston Park"
  },
  {
    "State": "NY",
    "City": "Woodmere"
  },
  {
    "State": "NY",
    "City": "Far Rockaway"
  },
  {
    "State": "NY",
    "City": "Arverne"
  },
  {
    "State": "NY",
    "City": "Rockaway Park"
  },
  {
    "State": "NY",
    "City": "Breezy Point"
  },
  {
    "State": "NY",
    "City": "Amityville"
  },
  {
    "State": "NY",
    "City": "Babylon"
  },
  {
    "State": "NY",
    "City": "North Babylon"
  },
  {
    "State": "NY",
    "City": "West Babylon"
  },
  {
    "State": "NY",
    "City": "Bayport"
  },
  {
    "State": "NY",
    "City": "Bay Shore"
  },
  {
    "State": "NY",
    "City": "Bayville"
  },
  {
    "State": "NY",
    "City": "Bellmore"
  },
  {
    "State": "NY",
    "City": "Bellport"
  },
  {
    "State": "NY",
    "City": "Bethpage"
  },
  {
    "State": "NY",
    "City": "Blue Point"
  },
  {
    "State": "NY",
    "City": "Bohemia"
  },
  {
    "State": "NY",
    "City": "Brentwood"
  },
  {
    "State": "NY",
    "City": "Brightwaters"
  },
  {
    "State": "NY",
    "City": "Brookhaven"
  },
  {
    "State": "NY",
    "City": "Centereach"
  },
  {
    "State": "NY",
    "City": "Centerport"
  },
  {
    "State": "NY",
    "City": "Central Islip"
  },
  {
    "State": "NY",
    "City": "Cold Spring Harbor"
  },
  {
    "State": "NY",
    "City": "Commack"
  },
  {
    "State": "NY",
    "City": "Copiague"
  },
  {
    "State": "NY",
    "City": "Coram"
  },
  {
    "State": "NY",
    "City": "Deer Park"
  },
  {
    "State": "NY",
    "City": "East Islip"
  },
  {
    "State": "NY",
    "City": "East Northport"
  },
  {
    "State": "NY",
    "City": "East Norwich"
  },
  {
    "State": "NY",
    "City": "East Setauket"
  },
  {
    "State": "NY",
    "City": "Farmingdale"
  },
  {
    "State": "NY",
    "City": "Farmingville"
  },
  {
    "State": "NY",
    "City": "Great River"
  },
  {
    "State": "NY",
    "City": "Greenlawn"
  },
  {
    "State": "NY",
    "City": "Holbrook"
  },
  {
    "State": "NY",
    "City": "Huntington"
  },
  {
    "State": "NY",
    "City": "Huntington Station"
  },
  {
    "State": "NY",
    "City": "Melville"
  },
  {
    "State": "NY",
    "City": "Islandia"
  },
  {
    "State": "NY",
    "City": "Islip"
  },
  {
    "State": "NY",
    "City": "Islip Terrace"
  },
  {
    "State": "NY",
    "City": "Jericho"
  },
  {
    "State": "NY",
    "City": "Kings Park"
  },
  {
    "State": "NY",
    "City": "Lake Grove"
  },
  {
    "State": "NY",
    "City": "Levittown"
  },
  {
    "State": "NY",
    "City": "Lindenhurst"
  },
  {
    "State": "NY",
    "City": "Massapequa"
  },
  {
    "State": "NY",
    "City": "Massapequa Park"
  },
  {
    "State": "NY",
    "City": "Medford"
  },
  {
    "State": "NY",
    "City": "Miller Place"
  },
  {
    "State": "NY",
    "City": "Mill Neck"
  },
  {
    "State": "NY",
    "City": "Mount Sinai"
  },
  {
    "State": "NY",
    "City": "Nesconset"
  },
  {
    "State": "NY",
    "City": "Northport"
  },
  {
    "State": "NY",
    "City": "Oakdale"
  },
  {
    "State": "NY",
    "City": "Ocean Beach"
  },
  {
    "State": "NY",
    "City": "Oyster Bay"
  },
  {
    "State": "NY",
    "City": "Patchogue"
  },
  {
    "State": "NY",
    "City": "Port Jefferson Station"
  },
  {
    "State": "NY",
    "City": "Port Jefferson"
  },
  {
    "State": "NY",
    "City": "Rocky Point"
  },
  {
    "State": "NY",
    "City": "Ronkonkoma"
  },
  {
    "State": "NY",
    "City": "Saint James"
  },
  {
    "State": "NY",
    "City": "Sayville"
  },
  {
    "State": "NY",
    "City": "Seaford"
  },
  {
    "State": "NY",
    "City": "Selden"
  },
  {
    "State": "NY",
    "City": "Shoreham"
  },
  {
    "State": "NY",
    "City": "Smithtown"
  },
  {
    "State": "NY",
    "City": "Hauppauge"
  },
  {
    "State": "NY",
    "City": "Sound Beach"
  },
  {
    "State": "NY",
    "City": "Stony Brook"
  },
  {
    "State": "NY",
    "City": "Syosset"
  },
  {
    "State": "NY",
    "City": "Wading River"
  },
  {
    "State": "NY",
    "City": "Wantagh"
  },
  {
    "State": "NY",
    "City": "West Islip"
  },
  {
    "State": "NY",
    "City": "West Sayville"
  },
  {
    "State": "NY",
    "City": "Woodbury"
  },
  {
    "State": "NY",
    "City": "Wyandanch"
  },
  {
    "State": "NY",
    "City": "Hicksville"
  },
  {
    "State": "NY",
    "City": "Plainview"
  },
  {
    "State": "NY",
    "City": "Old Bethpage"
  },
  {
    "State": "NY",
    "City": "Riverhead"
  },
  {
    "State": "NY",
    "City": "Amagansett"
  },
  {
    "State": "NY",
    "City": "Aquebogue"
  },
  {
    "State": "NY",
    "City": "Bridgehampton"
  },
  {
    "State": "NY",
    "City": "Calverton"
  },
  {
    "State": "NY",
    "City": "Center Moriches"
  },
  {
    "State": "NY",
    "City": "Cutchogue"
  },
  {
    "State": "NY",
    "City": "East Hampton"
  },
  {
    "State": "NY",
    "City": "East Marion"
  },
  {
    "State": "NY",
    "City": "East Moriches"
  },
  {
    "State": "NY",
    "City": "Eastport"
  },
  {
    "State": "NY",
    "City": "East Quogue"
  },
  {
    "State": "NY",
    "City": "Greenport"
  },
  {
    "State": "NY",
    "City": "Hampton Bays"
  },
  {
    "State": "NY",
    "City": "Jamesport"
  },
  {
    "State": "NY",
    "City": "Laurel"
  },
  {
    "State": "NY",
    "City": "Manorville"
  },
  {
    "State": "NY",
    "City": "Mastic"
  },
  {
    "State": "NY",
    "City": "Mastic Beach"
  },
  {
    "State": "NY",
    "City": "Mattituck"
  },
  {
    "State": "NY",
    "City": "Middle Island"
  },
  {
    "State": "NY",
    "City": "Montauk"
  },
  {
    "State": "NY",
    "City": "Moriches"
  },
  {
    "State": "NY",
    "City": "New Suffolk"
  },
  {
    "State": "NY",
    "City": "Orient"
  },
  {
    "State": "NY",
    "City": "Peconic"
  },
  {
    "State": "NY",
    "City": "Quogue"
  },
  {
    "State": "NY",
    "City": "Remsenburg"
  },
  {
    "State": "NY",
    "City": "Ridge"
  },
  {
    "State": "NY",
    "City": "Sagaponack"
  },
  {
    "State": "NY",
    "City": "Sag Harbor"
  },
  {
    "State": "NY",
    "City": "Shelter Island"
  },
  {
    "State": "NY",
    "City": "Shelter Island Heights"
  },
  {
    "State": "NY",
    "City": "Shirley"
  },
  {
    "State": "NY",
    "City": "Southampton"
  },
  {
    "State": "NY",
    "City": "South Jamesport"
  },
  {
    "State": "NY",
    "City": "Southold"
  },
  {
    "State": "NY",
    "City": "Speonk"
  },
  {
    "State": "NY",
    "City": "Upton"
  },
  {
    "State": "NY",
    "City": "Wainscott"
  },
  {
    "State": "NY",
    "City": "Water Mill"
  },
  {
    "State": "NY",
    "City": "Westhampton"
  },
  {
    "State": "NY",
    "City": "Westhampton Beach"
  },
  {
    "State": "NY",
    "City": "Yaphank"
  },
  {
    "State": "NY",
    "City": "Alcove"
  },
  {
    "State": "NY",
    "City": "Alplaus"
  },
  {
    "State": "NY",
    "City": "Altamont"
  },
  {
    "State": "NY",
    "City": "Amsterdam"
  },
  {
    "State": "NY",
    "City": "Athens"
  },
  {
    "State": "NY",
    "City": "Auriesville"
  },
  {
    "State": "NY",
    "City": "Austerlitz"
  },
  {
    "State": "NY",
    "City": "Averill Park"
  },
  {
    "State": "NY",
    "City": "Ballston Lake"
  },
  {
    "State": "NY",
    "City": "Ballston Spa"
  },
  {
    "State": "NY",
    "City": "Berlin"
  },
  {
    "State": "NY",
    "City": "Berne"
  },
  {
    "State": "NY",
    "City": "Brainard"
  },
  {
    "State": "NY",
    "City": "Broadalbin"
  },
  {
    "State": "NY",
    "City": "Burnt Hills"
  },
  {
    "State": "NY",
    "City": "Buskirk"
  },
  {
    "State": "NY",
    "City": "Canaan"
  },
  {
    "State": "NY",
    "City": "Carlisle"
  },
  {
    "State": "NY",
    "City": "Caroga Lake"
  },
  {
    "State": "NY",
    "City": "Castleton On Hudson"
  },
  {
    "State": "NY",
    "City": "Central Bridge"
  },
  {
    "State": "NY",
    "City": "Charlotteville"
  },
  {
    "State": "NY",
    "City": "Chatham"
  },
  {
    "State": "NY",
    "City": "Cherry Plain"
  },
  {
    "State": "NY",
    "City": "Clarksville"
  },
  {
    "State": "NY",
    "City": "Climax"
  },
  {
    "State": "NY",
    "City": "Cobleskill"
  },
  {
    "State": "NY",
    "City": "Coeymans"
  },
  {
    "State": "NY",
    "City": "Coeymans Hollow"
  },
  {
    "State": "NY",
    "City": "Cohoes"
  },
  {
    "State": "NY",
    "City": "Columbiaville"
  },
  {
    "State": "NY",
    "City": "Coxsackie"
  },
  {
    "State": "NY",
    "City": "Cropseyville"
  },
  {
    "State": "NY",
    "City": "Delanson"
  },
  {
    "State": "NY",
    "City": "Delmar"
  },
  {
    "State": "NY",
    "City": "Dormansville"
  },
  {
    "State": "NY",
    "City": "Duanesburg"
  },
  {
    "State": "NY",
    "City": "Eagle Bridge"
  },
  {
    "State": "NY",
    "City": "Earlton"
  },
  {
    "State": "NY",
    "City": "East Berne"
  },
  {
    "State": "NY",
    "City": "East Chatham"
  },
  {
    "State": "NY",
    "City": "East Greenbush"
  },
  {
    "State": "NY",
    "City": "East Nassau"
  },
  {
    "State": "NY",
    "City": "East Schodack"
  },
  {
    "State": "NY",
    "City": "East Worcester"
  },
  {
    "State": "NY",
    "City": "Clifton Park"
  },
  {
    "State": "NY",
    "City": "Esperance"
  },
  {
    "State": "NY",
    "City": "Feura Bush"
  },
  {
    "State": "NY",
    "City": "Fonda"
  },
  {
    "State": "NY",
    "City": "Fort Hunter"
  },
  {
    "State": "NY",
    "City": "Fort Johnson"
  },
  {
    "State": "NY",
    "City": "Fultonham"
  },
  {
    "State": "NY",
    "City": "Fultonville"
  },
  {
    "State": "NY",
    "City": "Gallupville"
  },
  {
    "State": "NY",
    "City": "Galway"
  },
  {
    "State": "NY",
    "City": "Ghent"
  },
  {
    "State": "NY",
    "City": "Gilboa"
  },
  {
    "State": "NY",
    "City": "Glenmont"
  },
  {
    "State": "NY",
    "City": "Gloversville"
  },
  {
    "State": "NY",
    "City": "Grafton"
  },
  {
    "State": "NY",
    "City": "Greenville"
  },
  {
    "State": "NY",
    "City": "Guilderland"
  },
  {
    "State": "NY",
    "City": "Guilderland Center"
  },
  {
    "State": "NY",
    "City": "Hagaman"
  },
  {
    "State": "NY",
    "City": "Hannacroix"
  },
  {
    "State": "NY",
    "City": "Hoosick"
  },
  {
    "State": "NY",
    "City": "Hoosick Falls"
  },
  {
    "State": "NY",
    "City": "Howes Cave"
  },
  {
    "State": "NY",
    "City": "Jefferson"
  },
  {
    "State": "NY",
    "City": "Johnsonville"
  },
  {
    "State": "NY",
    "City": "Johnstown"
  },
  {
    "State": "NY",
    "City": "Kinderhook"
  },
  {
    "State": "NY",
    "City": "Knox"
  },
  {
    "State": "NY",
    "City": "Lake Pleasant"
  },
  {
    "State": "NY",
    "City": "Latham"
  },
  {
    "State": "NY",
    "City": "Malden Bridge"
  },
  {
    "State": "NY",
    "City": "Maryland"
  },
  {
    "State": "NY",
    "City": "Mayfield"
  },
  {
    "State": "NY",
    "City": "Mechanicville"
  },
  {
    "State": "NY",
    "City": "Medusa"
  },
  {
    "State": "NY",
    "City": "Melrose"
  },
  {
    "State": "NY",
    "City": "Middleburgh"
  },
  {
    "State": "NY",
    "City": "Nassau"
  },
  {
    "State": "NY",
    "City": "New Baltimore"
  },
  {
    "State": "NY",
    "City": "New Lebanon"
  },
  {
    "State": "NY",
    "City": "Newtonville"
  },
  {
    "State": "NY",
    "City": "Niverville"
  },
  {
    "State": "NY",
    "City": "North Blenheim"
  },
  {
    "State": "NY",
    "City": "North Chatham"
  },
  {
    "State": "NY",
    "City": "North Hoosick"
  },
  {
    "State": "NY",
    "City": "Northville"
  },
  {
    "State": "NY",
    "City": "Old Chatham"
  },
  {
    "State": "NY",
    "City": "Pattersonville"
  },
  {
    "State": "NY",
    "City": "Petersburg"
  },
  {
    "State": "NY",
    "City": "Piseco"
  },
  {
    "State": "NY",
    "City": "Poestenkill"
  },
  {
    "State": "NY",
    "City": "Quaker Street"
  },
  {
    "State": "NY",
    "City": "Ravena"
  },
  {
    "State": "NY",
    "City": "Rensselaer"
  },
  {
    "State": "NY",
    "City": "Rensselaerville"
  },
  {
    "State": "NY",
    "City": "Rexford"
  },
  {
    "State": "NY",
    "City": "Richmondville"
  },
  {
    "State": "NY",
    "City": "Rotterdam Junction"
  },
  {
    "State": "NY",
    "City": "Round Lake"
  },
  {
    "State": "NY",
    "City": "Sand Lake"
  },
  {
    "State": "NY",
    "City": "Schaghticoke"
  },
  {
    "State": "NY",
    "City": "Schenevus"
  },
  {
    "State": "NY",
    "City": "Schodack Landing"
  },
  {
    "State": "NY",
    "City": "Schoharie"
  },
  {
    "State": "NY",
    "City": "Selkirk"
  },
  {
    "State": "NY",
    "City": "Slingerlands"
  },
  {
    "State": "NY",
    "City": "Sloansville"
  },
  {
    "State": "NY",
    "City": "South Bethlehem"
  },
  {
    "State": "NY",
    "City": "Speculator"
  },
  {
    "State": "NY",
    "City": "Spencertown"
  },
  {
    "State": "NY",
    "City": "Sprakers"
  },
  {
    "State": "NY",
    "City": "Stamford"
  },
  {
    "State": "NY",
    "City": "Stephentown"
  },
  {
    "State": "NY",
    "City": "Stillwater"
  },
  {
    "State": "NY",
    "City": "Stottville"
  },
  {
    "State": "NY",
    "City": "Stuyvesant"
  },
  {
    "State": "NY",
    "City": "Stuyvesant Falls"
  },
  {
    "State": "NY",
    "City": "Summit"
  },
  {
    "State": "NY",
    "City": "Surprise"
  },
  {
    "State": "NY",
    "City": "Tribes Hill"
  },
  {
    "State": "NY",
    "City": "Troy"
  },
  {
    "State": "NY",
    "City": "Valatie"
  },
  {
    "State": "NY",
    "City": "Valley Falls"
  },
  {
    "State": "NY",
    "City": "Voorheesville"
  },
  {
    "State": "NY",
    "City": "Warnerville"
  },
  {
    "State": "NY",
    "City": "Waterford"
  },
  {
    "State": "NY",
    "City": "Watervliet"
  },
  {
    "State": "NY",
    "City": "Wells"
  },
  {
    "State": "NY",
    "City": "West Coxsackie"
  },
  {
    "State": "NY",
    "City": "Westerlo"
  },
  {
    "State": "NY",
    "City": "West Fulton"
  },
  {
    "State": "NY",
    "City": "West Lebanon"
  },
  {
    "State": "NY",
    "City": "West Sand Lake"
  },
  {
    "State": "NY",
    "City": "Worcester"
  },
  {
    "State": "NY",
    "City": "Wynantskill"
  },
  {
    "State": "NY",
    "City": "Albany"
  },
  {
    "State": "NY",
    "City": "Schenectady"
  },
  {
    "State": "NY",
    "City": "Kingston"
  },
  {
    "State": "NY",
    "City": "Accord"
  },
  {
    "State": "NY",
    "City": "Acra"
  },
  {
    "State": "NY",
    "City": "Arkville"
  },
  {
    "State": "NY",
    "City": "Ashland"
  },
  {
    "State": "NY",
    "City": "Bearsville"
  },
  {
    "State": "NY",
    "City": "Big Indian"
  },
  {
    "State": "NY",
    "City": "Bloomington"
  },
  {
    "State": "NY",
    "City": "Boiceville"
  },
  {
    "State": "NY",
    "City": "Cairo"
  },
  {
    "State": "NY",
    "City": "Catskill"
  },
  {
    "State": "NY",
    "City": "Chichester"
  },
  {
    "State": "NY",
    "City": "Connelly"
  },
  {
    "State": "NY",
    "City": "Cornwallville"
  },
  {
    "State": "NY",
    "City": "Cottekill"
  },
  {
    "State": "NY",
    "City": "Cragsmoor"
  },
  {
    "State": "NY",
    "City": "Denver"
  },
  {
    "State": "NY",
    "City": "Durham"
  },
  {
    "State": "NY",
    "City": "East Durham"
  },
  {
    "State": "NY",
    "City": "East Jewett"
  },
  {
    "State": "NY",
    "City": "Elka Park"
  },
  {
    "State": "NY",
    "City": "Ellenville"
  },
  {
    "State": "NY",
    "City": "Esopus"
  },
  {
    "State": "NY",
    "City": "Fleischmanns"
  },
  {
    "State": "NY",
    "City": "Freehold"
  },
  {
    "State": "NY",
    "City": "Glasco"
  },
  {
    "State": "NY",
    "City": "Glenford"
  },
  {
    "State": "NY",
    "City": "Grand Gorge"
  },
  {
    "State": "NY",
    "City": "Greenfield Park"
  },
  {
    "State": "NY",
    "City": "Haines Falls"
  },
  {
    "State": "NY",
    "City": "Halcottsville"
  },
  {
    "State": "NY",
    "City": "Hensonville"
  },
  {
    "State": "NY",
    "City": "High Falls"
  },
  {
    "State": "NY",
    "City": "Highmount"
  },
  {
    "State": "NY",
    "City": "Hunter"
  },
  {
    "State": "NY",
    "City": "Hurley"
  },
  {
    "State": "NY",
    "City": "Jewett"
  },
  {
    "State": "NY",
    "City": "Kerhonkson"
  },
  {
    "State": "NY",
    "City": "Lake Hill"
  },
  {
    "State": "NY",
    "City": "Lake Katrine"
  },
  {
    "State": "NY",
    "City": "Lanesville"
  },
  {
    "State": "NY",
    "City": "Leeds"
  },
  {
    "State": "NY",
    "City": "Lexington"
  },
  {
    "State": "NY",
    "City": "Malden On Hudson"
  },
  {
    "State": "NY",
    "City": "Maplecrest"
  },
  {
    "State": "NY",
    "City": "Margaretville"
  },
  {
    "State": "NY",
    "City": "Mount Marion"
  },
  {
    "State": "NY",
    "City": "Mount Tremper"
  },
  {
    "State": "NY",
    "City": "Napanoch"
  },
  {
    "State": "NY",
    "City": "New Kingston"
  },
  {
    "State": "NY",
    "City": "Oak Hill"
  },
  {
    "State": "NY",
    "City": "Olivebridge"
  },
  {
    "State": "NY",
    "City": "Palenville"
  },
  {
    "State": "NY",
    "City": "Phoenicia"
  },
  {
    "State": "NY",
    "City": "Pine Hill"
  },
  {
    "State": "NY",
    "City": "Port Ewen"
  },
  {
    "State": "NY",
    "City": "Prattsville"
  },
  {
    "State": "NY",
    "City": "Preston Hollow"
  },
  {
    "State": "NY",
    "City": "Purling"
  },
  {
    "State": "NY",
    "City": "Rifton"
  },
  {
    "State": "NY",
    "City": "Rosendale"
  },
  {
    "State": "NY",
    "City": "Round Top"
  },
  {
    "State": "NY",
    "City": "Roxbury"
  },
  {
    "State": "NY",
    "City": "Ruby"
  },
  {
    "State": "NY",
    "City": "Saugerties"
  },
  {
    "State": "NY",
    "City": "Shandaken"
  },
  {
    "State": "NY",
    "City": "Shokan"
  },
  {
    "State": "NY",
    "City": "South Cairo"
  },
  {
    "State": "NY",
    "City": "Spring Glen"
  },
  {
    "State": "NY",
    "City": "Stone Ridge"
  },
  {
    "State": "NY",
    "City": "Tannersville"
  },
  {
    "State": "NY",
    "City": "Tillson"
  },
  {
    "State": "NY",
    "City": "Ulster Park"
  },
  {
    "State": "NY",
    "City": "Wawarsing"
  },
  {
    "State": "NY",
    "City": "West Camp"
  },
  {
    "State": "NY",
    "City": "West Hurley"
  },
  {
    "State": "NY",
    "City": "West Kill"
  },
  {
    "State": "NY",
    "City": "West Park"
  },
  {
    "State": "NY",
    "City": "West Shokan"
  },
  {
    "State": "NY",
    "City": "Willow"
  },
  {
    "State": "NY",
    "City": "Windham"
  },
  {
    "State": "NY",
    "City": "Woodstock"
  },
  {
    "State": "NY",
    "City": "Amenia"
  },
  {
    "State": "NY",
    "City": "Ancram"
  },
  {
    "State": "NY",
    "City": "Ancramdale"
  },
  {
    "State": "NY",
    "City": "Annandale On Hudson"
  },
  {
    "State": "NY",
    "City": "Bangall"
  },
  {
    "State": "NY",
    "City": "Barrytown"
  },
  {
    "State": "NY",
    "City": "Beacon"
  },
  {
    "State": "NY",
    "City": "Billings"
  },
  {
    "State": "NY",
    "City": "Castle Point"
  },
  {
    "State": "NY",
    "City": "Chelsea"
  },
  {
    "State": "NY",
    "City": "Claverack"
  },
  {
    "State": "NY",
    "City": "Clinton Corners"
  },
  {
    "State": "NY",
    "City": "Clintondale"
  },
  {
    "State": "NY",
    "City": "Copake"
  },
  {
    "State": "NY",
    "City": "Copake Falls"
  },
  {
    "State": "NY",
    "City": "Cornwall"
  },
  {
    "State": "NY",
    "City": "Cornwall On Hudson"
  },
  {
    "State": "NY",
    "City": "Craryville"
  },
  {
    "State": "NY",
    "City": "Dover Plains"
  },
  {
    "State": "NY",
    "City": "Elizaville"
  },
  {
    "State": "NY",
    "City": "Fishkill"
  },
  {
    "State": "NY",
    "City": "Gardiner"
  },
  {
    "State": "NY",
    "City": "Germantown"
  },
  {
    "State": "NY",
    "City": "Glenham"
  },
  {
    "State": "NY",
    "City": "Highland"
  },
  {
    "State": "NY",
    "City": "Hillsdale"
  },
  {
    "State": "NY",
    "City": "Hollowville"
  },
  {
    "State": "NY",
    "City": "Holmes"
  },
  {
    "State": "NY",
    "City": "Hopewell Junction"
  },
  {
    "State": "NY",
    "City": "Hudson"
  },
  {
    "State": "NY",
    "City": "Hughsonville"
  },
  {
    "State": "NY",
    "City": "Hyde Park"
  },
  {
    "State": "NY",
    "City": "Lagrangeville"
  },
  {
    "State": "NY",
    "City": "Livingston"
  },
  {
    "State": "NY",
    "City": "Marlboro"
  },
  {
    "State": "NY",
    "City": "Maybrook"
  },
  {
    "State": "NY",
    "City": "Mellenville"
  },
  {
    "State": "NY",
    "City": "Millbrook"
  },
  {
    "State": "NY",
    "City": "Millerton"
  },
  {
    "State": "NY",
    "City": "Milton"
  },
  {
    "State": "NY",
    "City": "Modena"
  },
  {
    "State": "NY",
    "City": "Montgomery"
  },
  {
    "State": "NY",
    "City": "Newburgh"
  },
  {
    "State": "NY",
    "City": "New Windsor"
  },
  {
    "State": "NY",
    "City": "New Paltz"
  },
  {
    "State": "NY",
    "City": "Patterson"
  },
  {
    "State": "NY",
    "City": "Pawling"
  },
  {
    "State": "NY",
    "City": "Philmont"
  },
  {
    "State": "NY",
    "City": "Pine Bush"
  },
  {
    "State": "NY",
    "City": "Pine Plains"
  },
  {
    "State": "NY",
    "City": "Plattekill"
  },
  {
    "State": "NY",
    "City": "Pleasant Valley"
  },
  {
    "State": "NY",
    "City": "Poughquag"
  },
  {
    "State": "NY",
    "City": "Red Hook"
  },
  {
    "State": "NY",
    "City": "Rhinebeck"
  },
  {
    "State": "NY",
    "City": "Rhinecliff"
  },
  {
    "State": "NY",
    "City": "Rock Tavern"
  },
  {
    "State": "NY",
    "City": "Salisbury Mills"
  },
  {
    "State": "NY",
    "City": "Salt Point"
  },
  {
    "State": "NY",
    "City": "Staatsburg"
  },
  {
    "State": "NY",
    "City": "Stanfordville"
  },
  {
    "State": "NY",
    "City": "Stormville"
  },
  {
    "State": "NY",
    "City": "Tivoli"
  },
  {
    "State": "NY",
    "City": "Vails Gate"
  },
  {
    "State": "NY",
    "City": "Verbank"
  },
  {
    "State": "NY",
    "City": "Walden"
  },
  {
    "State": "NY",
    "City": "Walker Valley"
  },
  {
    "State": "NY",
    "City": "Wallkill"
  },
  {
    "State": "NY",
    "City": "Wappingers Falls"
  },
  {
    "State": "NY",
    "City": "Wassaic"
  },
  {
    "State": "NY",
    "City": "West Copake"
  },
  {
    "State": "NY",
    "City": "Wingdale"
  },
  {
    "State": "NY",
    "City": "Poughkeepsie"
  },
  {
    "State": "NY",
    "City": "Monticello"
  },
  {
    "State": "NY",
    "City": "Barryville"
  },
  {
    "State": "NY",
    "City": "Bethel"
  },
  {
    "State": "NY",
    "City": "Bloomingburg"
  },
  {
    "State": "NY",
    "City": "Burlingham"
  },
  {
    "State": "NY",
    "City": "Callicoon"
  },
  {
    "State": "NY",
    "City": "Callicoon Center"
  },
  {
    "State": "NY",
    "City": "Claryville"
  },
  {
    "State": "NY",
    "City": "Cochecton"
  },
  {
    "State": "NY",
    "City": "Cuddebackville"
  },
  {
    "State": "NY",
    "City": "Eldred"
  },
  {
    "State": "NY",
    "City": "Fallsburg"
  },
  {
    "State": "NY",
    "City": "Ferndale"
  },
  {
    "State": "NY",
    "City": "Fremont Center"
  },
  {
    "State": "NY",
    "City": "Glen Spey"
  },
  {
    "State": "NY",
    "City": "Glen Wild"
  },
  {
    "State": "NY",
    "City": "Grahamsville"
  },
  {
    "State": "NY",
    "City": "Hankins"
  },
  {
    "State": "NY",
    "City": "Harris"
  },
  {
    "State": "NY",
    "City": "Highland Lake"
  },
  {
    "State": "NY",
    "City": "Hortonville"
  },
  {
    "State": "NY",
    "City": "Huguenot"
  },
  {
    "State": "NY",
    "City": "Hurleyville"
  },
  {
    "State": "NY",
    "City": "Jeffersonville"
  },
  {
    "State": "NY",
    "City": "Kauneonga Lake"
  },
  {
    "State": "NY",
    "City": "Kenoza Lake"
  },
  {
    "State": "NY",
    "City": "Kiamesha Lake"
  },
  {
    "State": "NY",
    "City": "Lake Huntington"
  },
  {
    "State": "NY",
    "City": "Liberty"
  },
  {
    "State": "NY",
    "City": "Livingston Manor"
  },
  {
    "State": "NY",
    "City": "Loch Sheldrake"
  },
  {
    "State": "NY",
    "City": "Long Eddy"
  },
  {
    "State": "NY",
    "City": "Mongaup Valley"
  },
  {
    "State": "NY",
    "City": "Mountain Dale"
  },
  {
    "State": "NY",
    "City": "Narrowsburg"
  },
  {
    "State": "NY",
    "City": "Neversink"
  },
  {
    "State": "NY",
    "City": "North Branch"
  },
  {
    "State": "NY",
    "City": "Obernburg"
  },
  {
    "State": "NY",
    "City": "Parksville"
  },
  {
    "State": "NY",
    "City": "Phillipsport"
  },
  {
    "State": "NY",
    "City": "Pond Eddy"
  },
  {
    "State": "NY",
    "City": "Port Jervis"
  },
  {
    "State": "NY",
    "City": "Rock Hill"
  },
  {
    "State": "NY",
    "City": "Roscoe"
  },
  {
    "State": "NY",
    "City": "Forestburgh"
  },
  {
    "State": "NY",
    "City": "Smallwood"
  },
  {
    "State": "NY",
    "City": "South Fallsburg"
  },
  {
    "State": "NY",
    "City": "Sparrow Bush"
  },
  {
    "State": "NY",
    "City": "Summitville"
  },
  {
    "State": "NY",
    "City": "Swan Lake"
  },
  {
    "State": "NY",
    "City": "Thompsonville"
  },
  {
    "State": "NY",
    "City": "Westbrookville"
  },
  {
    "State": "NY",
    "City": "White Lake"
  },
  {
    "State": "NY",
    "City": "White Sulphur Springs"
  },
  {
    "State": "NY",
    "City": "Woodbourne"
  },
  {
    "State": "NY",
    "City": "Woodridge"
  },
  {
    "State": "NY",
    "City": "Wurtsboro"
  },
  {
    "State": "NY",
    "City": "Youngsville"
  },
  {
    "State": "NY",
    "City": "Yulan"
  },
  {
    "State": "NY",
    "City": "Glens Falls"
  },
  {
    "State": "NY",
    "City": "South Glens Falls"
  },
  {
    "State": "NY",
    "City": "Queensbury"
  },
  {
    "State": "NY",
    "City": "Adirondack"
  },
  {
    "State": "NY",
    "City": "Argyle"
  },
  {
    "State": "NY",
    "City": "Athol"
  },
  {
    "State": "NY",
    "City": "Bakers Mills"
  },
  {
    "State": "NY",
    "City": "Blue Mountain Lake"
  },
  {
    "State": "NY",
    "City": "Bolton Landing"
  },
  {
    "State": "NY",
    "City": "Brant Lake"
  },
  {
    "State": "NY",
    "City": "Cambridge"
  },
  {
    "State": "NY",
    "City": "Chestertown"
  },
  {
    "State": "NY",
    "City": "Clemons"
  },
  {
    "State": "NY",
    "City": "Cleverdale"
  },
  {
    "State": "NY",
    "City": "Comstock"
  },
  {
    "State": "NY",
    "City": "Corinth"
  },
  {
    "State": "NY",
    "City": "Cossayuna"
  },
  {
    "State": "NY",
    "City": "Diamond Point"
  },
  {
    "State": "NY",
    "City": "Fort Ann"
  },
  {
    "State": "NY",
    "City": "Fort Edward"
  },
  {
    "State": "NY",
    "City": "Gansevoort"
  },
  {
    "State": "NY",
    "City": "Granville"
  },
  {
    "State": "NY",
    "City": "Greenfield Center"
  },
  {
    "State": "NY",
    "City": "Greenwich"
  },
  {
    "State": "NY",
    "City": "Hadley"
  },
  {
    "State": "NY",
    "City": "Hague"
  },
  {
    "State": "NY",
    "City": "Hampton"
  },
  {
    "State": "NY",
    "City": "Hartford"
  },
  {
    "State": "NY",
    "City": "Hudson Falls"
  },
  {
    "State": "NY",
    "City": "Huletts Landing"
  },
  {
    "State": "NY",
    "City": "Indian Lake"
  },
  {
    "State": "NY",
    "City": "Johnsburg"
  },
  {
    "State": "NY",
    "City": "Kattskill Bay"
  },
  {
    "State": "NY",
    "City": "Lake George"
  },
  {
    "State": "NY",
    "City": "Lake Luzerne"
  },
  {
    "State": "NY",
    "City": "Long Lake"
  },
  {
    "State": "NY",
    "City": "Middle Falls"
  },
  {
    "State": "NY",
    "City": "Middle Granville"
  },
  {
    "State": "NY",
    "City": "Middle Grove"
  },
  {
    "State": "NY",
    "City": "Minerva"
  },
  {
    "State": "NY",
    "City": "Newcomb"
  },
  {
    "State": "NY",
    "City": "North Creek"
  },
  {
    "State": "NY",
    "City": "North Granville"
  },
  {
    "State": "NY",
    "City": "North Hudson"
  },
  {
    "State": "NY",
    "City": "North River"
  },
  {
    "State": "NY",
    "City": "Olmstedville"
  },
  {
    "State": "NY",
    "City": "Paradox"
  },
  {
    "State": "NY",
    "City": "Porter Corners"
  },
  {
    "State": "NY",
    "City": "Pottersville"
  },
  {
    "State": "NY",
    "City": "Putnam Station"
  },
  {
    "State": "NY",
    "City": "Riparius"
  },
  {
    "State": "NY",
    "City": "Rock City Falls"
  },
  {
    "State": "NY",
    "City": "Sabael"
  },
  {
    "State": "NY",
    "City": "Salem"
  },
  {
    "State": "NY",
    "City": "Saratoga Springs"
  },
  {
    "State": "NY",
    "City": "Schroon Lake"
  },
  {
    "State": "NY",
    "City": "Schuylerville"
  },
  {
    "State": "NY",
    "City": "Severance"
  },
  {
    "State": "NY",
    "City": "Shushan"
  },
  {
    "State": "NY",
    "City": "Silver Bay"
  },
  {
    "State": "NY",
    "City": "Stony Creek"
  },
  {
    "State": "NY",
    "City": "Ticonderoga"
  },
  {
    "State": "NY",
    "City": "Victory Mills"
  },
  {
    "State": "NY",
    "City": "Warrensburg"
  },
  {
    "State": "NY",
    "City": "Wevertown"
  },
  {
    "State": "NY",
    "City": "Whitehall"
  },
  {
    "State": "NY",
    "City": "Plattsburgh"
  },
  {
    "State": "NY",
    "City": "Altona"
  },
  {
    "State": "NY",
    "City": "Keeseville"
  },
  {
    "State": "NY",
    "City": "Au Sable Forks"
  },
  {
    "State": "NY",
    "City": "Bloomingdale"
  },
  {
    "State": "NY",
    "City": "Bombay"
  },
  {
    "State": "NY",
    "City": "Brainardsville"
  },
  {
    "State": "NY",
    "City": "Brushton"
  },
  {
    "State": "NY",
    "City": "Burke"
  },
  {
    "State": "NY",
    "City": "Cadyville"
  },
  {
    "State": "NY",
    "City": "Champlain"
  },
  {
    "State": "NY",
    "City": "Chateaugay"
  },
  {
    "State": "NY",
    "City": "Chazy"
  },
  {
    "State": "NY",
    "City": "Childwold"
  },
  {
    "State": "NY",
    "City": "Churubusco"
  },
  {
    "State": "NY",
    "City": "Constable"
  },
  {
    "State": "NY",
    "City": "Cranberry Lake"
  },
  {
    "State": "NY",
    "City": "Crown Point"
  },
  {
    "State": "NY",
    "City": "Dannemora"
  },
  {
    "State": "NY",
    "City": "Dickinson Center"
  },
  {
    "State": "NY",
    "City": "Elizabethtown"
  },
  {
    "State": "NY",
    "City": "Ellenburg"
  },
  {
    "State": "NY",
    "City": "Ellenburg Center"
  },
  {
    "State": "NY",
    "City": "Ellenburg Depot"
  },
  {
    "State": "NY",
    "City": "Essex"
  },
  {
    "State": "NY",
    "City": "Fort Covington"
  },
  {
    "State": "NY",
    "City": "Gabriels"
  },
  {
    "State": "NY",
    "City": "Jay"
  },
  {
    "State": "NY",
    "City": "Keene"
  },
  {
    "State": "NY",
    "City": "Keene Valley"
  },
  {
    "State": "NY",
    "City": "Lake Clear"
  },
  {
    "State": "NY",
    "City": "Lake Placid"
  },
  {
    "State": "NY",
    "City": "Lawrenceville"
  },
  {
    "State": "NY",
    "City": "Lewis"
  },
  {
    "State": "NY",
    "City": "Lyon Mountain"
  },
  {
    "State": "NY",
    "City": "Malone"
  },
  {
    "State": "NY",
    "City": "Mineville"
  },
  {
    "State": "NY",
    "City": "Moira"
  },
  {
    "State": "NY",
    "City": "Mooers"
  },
  {
    "State": "NY",
    "City": "Mooers Forks"
  },
  {
    "State": "NY",
    "City": "Moriah"
  },
  {
    "State": "NY",
    "City": "Moriah Center"
  },
  {
    "State": "NY",
    "City": "Morrisonville"
  },
  {
    "State": "NY",
    "City": "New Russia"
  },
  {
    "State": "NY",
    "City": "Nicholville"
  },
  {
    "State": "NY",
    "City": "North Bangor"
  },
  {
    "State": "NY",
    "City": "North Lawrence"
  },
  {
    "State": "NY",
    "City": "Owls Head"
  },
  {
    "State": "NY",
    "City": "Paul Smiths"
  },
  {
    "State": "NY",
    "City": "Peru"
  },
  {
    "State": "NY",
    "City": "Piercefield"
  },
  {
    "State": "NY",
    "City": "Port Henry"
  },
  {
    "State": "NY",
    "City": "Port Kent"
  },
  {
    "State": "NY",
    "City": "Rainbow Lake"
  },
  {
    "State": "NY",
    "City": "Ray Brook"
  },
  {
    "State": "NY",
    "City": "Redford"
  },
  {
    "State": "NY",
    "City": "Rouses Point"
  },
  {
    "State": "NY",
    "City": "Saint Regis Falls"
  },
  {
    "State": "NY",
    "City": "Saranac"
  },
  {
    "State": "NY",
    "City": "Saranac Lake"
  },
  {
    "State": "NY",
    "City": "Schuyler Falls"
  },
  {
    "State": "NY",
    "City": "Tupper Lake"
  },
  {
    "State": "NY",
    "City": "Upper Jay"
  },
  {
    "State": "NY",
    "City": "Vermontville"
  },
  {
    "State": "NY",
    "City": "West Chazy"
  },
  {
    "State": "NY",
    "City": "Westport"
  },
  {
    "State": "NY",
    "City": "Whippleville"
  },
  {
    "State": "NY",
    "City": "Willsboro"
  },
  {
    "State": "NY",
    "City": "Wilmington"
  },
  {
    "State": "NY",
    "City": "Witherbee"
  },
  {
    "State": "NY",
    "City": "Apulia Station"
  },
  {
    "State": "NY",
    "City": "Auburn"
  },
  {
    "State": "NY",
    "City": "Aurora"
  },
  {
    "State": "NY",
    "City": "Baldwinsville"
  },
  {
    "State": "NY",
    "City": "Bernhards Bay"
  },
  {
    "State": "NY",
    "City": "Brewerton"
  },
  {
    "State": "NY",
    "City": "Bridgeport"
  },
  {
    "State": "NY",
    "City": "Camillus"
  },
  {
    "State": "NY",
    "City": "Canastota"
  },
  {
    "State": "NY",
    "City": "Cato"
  },
  {
    "State": "NY",
    "City": "Cayuga"
  },
  {
    "State": "NY",
    "City": "Cazenovia"
  },
  {
    "State": "NY",
    "City": "Central Square"
  },
  {
    "State": "NY",
    "City": "Chittenango"
  },
  {
    "State": "NY",
    "City": "Cicero"
  },
  {
    "State": "NY",
    "City": "Cincinnatus"
  },
  {
    "State": "NY",
    "City": "Clay"
  },
  {
    "State": "NY",
    "City": "Cleveland"
  },
  {
    "State": "NY",
    "City": "Clockville"
  },
  {
    "State": "NY",
    "City": "Constantia"
  },
  {
    "State": "NY",
    "City": "Cortland"
  },
  {
    "State": "NY",
    "City": "Delphi Falls"
  },
  {
    "State": "NY",
    "City": "De Ruyter"
  },
  {
    "State": "NY",
    "City": "Dryden"
  },
  {
    "State": "NY",
    "City": "Durhamville"
  },
  {
    "State": "NY",
    "City": "East Homer"
  },
  {
    "State": "NY",
    "City": "East Syracuse"
  },
  {
    "State": "NY",
    "City": "Elbridge"
  },
  {
    "State": "NY",
    "City": "Erieville"
  },
  {
    "State": "NY",
    "City": "Etna"
  },
  {
    "State": "NY",
    "City": "Fabius"
  },
  {
    "State": "NY",
    "City": "Fair Haven"
  },
  {
    "State": "NY",
    "City": "Fayette"
  },
  {
    "State": "NY",
    "City": "Fayetteville"
  },
  {
    "State": "NY",
    "City": "Freeville"
  },
  {
    "State": "NY",
    "City": "Fulton"
  },
  {
    "State": "NY",
    "City": "Genoa"
  },
  {
    "State": "NY",
    "City": "Georgetown"
  },
  {
    "State": "NY",
    "City": "Groton"
  },
  {
    "State": "NY",
    "City": "Hannibal"
  },
  {
    "State": "NY",
    "City": "Hastings"
  },
  {
    "State": "NY",
    "City": "Homer"
  },
  {
    "State": "NY",
    "City": "Jamesville"
  },
  {
    "State": "NY",
    "City": "Jordan"
  },
  {
    "State": "NY",
    "City": "King Ferry"
  },
  {
    "State": "NY",
    "City": "Kirkville"
  },
  {
    "State": "NY",
    "City": "Lacona"
  },
  {
    "State": "NY",
    "City": "La Fayette"
  },
  {
    "State": "NY",
    "City": "Little York"
  },
  {
    "State": "NY",
    "City": "Liverpool"
  },
  {
    "State": "NY",
    "City": "Locke"
  },
  {
    "State": "NY",
    "City": "Lycoming"
  },
  {
    "State": "NY",
    "City": "Mc Graw"
  },
  {
    "State": "NY",
    "City": "Mc Lean"
  },
  {
    "State": "NY",
    "City": "Mallory"
  },
  {
    "State": "NY",
    "City": "Manlius"
  },
  {
    "State": "NY",
    "City": "Maple View"
  },
  {
    "State": "NY",
    "City": "Marcellus"
  },
  {
    "State": "NY",
    "City": "Marietta"
  },
  {
    "State": "NY",
    "City": "Martville"
  },
  {
    "State": "NY",
    "City": "Memphis"
  },
  {
    "State": "NY",
    "City": "Meridian"
  },
  {
    "State": "NY",
    "City": "Mexico"
  },
  {
    "State": "NY",
    "City": "Minetto"
  },
  {
    "State": "NY",
    "City": "Minoa"
  },
  {
    "State": "NY",
    "City": "Montezuma"
  },
  {
    "State": "NY",
    "City": "Moravia"
  },
  {
    "State": "NY",
    "City": "Mottville"
  },
  {
    "State": "NY",
    "City": "Nedrow"
  },
  {
    "State": "NY",
    "City": "New Haven"
  },
  {
    "State": "NY",
    "City": "New Woodstock"
  },
  {
    "State": "NY",
    "City": "North Bay"
  },
  {
    "State": "NY",
    "City": "North Pitcher"
  },
  {
    "State": "NY",
    "City": "Oswego"
  },
  {
    "State": "NY",
    "City": "Parish"
  },
  {
    "State": "NY",
    "City": "Pennellville"
  },
  {
    "State": "NY",
    "City": "Peterboro"
  },
  {
    "State": "NY",
    "City": "Phoenix"
  },
  {
    "State": "NY",
    "City": "Pitcher"
  },
  {
    "State": "NY",
    "City": "Plainville"
  },
  {
    "State": "NY",
    "City": "Pompey"
  },
  {
    "State": "NY",
    "City": "Poplar Ridge"
  },
  {
    "State": "NY",
    "City": "Port Byron"
  },
  {
    "State": "NY",
    "City": "Preble"
  },
  {
    "State": "NY",
    "City": "Pulaski"
  },
  {
    "State": "NY",
    "City": "Red Creek"
  },
  {
    "State": "NY",
    "City": "Richland"
  },
  {
    "State": "NY",
    "City": "Sandy Creek"
  },
  {
    "State": "NY",
    "City": "Savannah"
  },
  {
    "State": "NY",
    "City": "Scipio Center"
  },
  {
    "State": "NY",
    "City": "Seneca Falls"
  },
  {
    "State": "NY",
    "City": "Skaneateles"
  },
  {
    "State": "NY",
    "City": "Skaneateles Falls"
  },
  {
    "State": "NY",
    "City": "South Butler"
  },
  {
    "State": "NY",
    "City": "South Otselic"
  },
  {
    "State": "NY",
    "City": "Sterling"
  },
  {
    "State": "NY",
    "City": "Sylvan Beach"
  },
  {
    "State": "NY",
    "City": "Truxton"
  },
  {
    "State": "NY",
    "City": "Tully"
  },
  {
    "State": "NY",
    "City": "Union Springs"
  },
  {
    "State": "NY",
    "City": "Verona Beach"
  },
  {
    "State": "NY",
    "City": "Wampsville"
  },
  {
    "State": "NY",
    "City": "Warners"
  },
  {
    "State": "NY",
    "City": "Waterloo"
  },
  {
    "State": "NY",
    "City": "Weedsport"
  },
  {
    "State": "NY",
    "City": "West Monroe"
  },
  {
    "State": "NY",
    "City": "Syracuse"
  },
  {
    "State": "NY",
    "City": "Alder Creek"
  },
  {
    "State": "NY",
    "City": "Altmar"
  },
  {
    "State": "NY",
    "City": "Ava"
  },
  {
    "State": "NY",
    "City": "Barneveld"
  },
  {
    "State": "NY",
    "City": "Beaver Falls"
  },
  {
    "State": "NY",
    "City": "Blossvale"
  },
  {
    "State": "NY",
    "City": "Boonville"
  },
  {
    "State": "NY",
    "City": "Bouckville"
  },
  {
    "State": "NY",
    "City": "Brantingham"
  },
  {
    "State": "NY",
    "City": "Bridgewater"
  },
  {
    "State": "NY",
    "City": "Brookfield"
  },
  {
    "State": "NY",
    "City": "Burlington Flats"
  },
  {
    "State": "NY",
    "City": "Camden"
  },
  {
    "State": "NY",
    "City": "Canajoharie"
  },
  {
    "State": "NY",
    "City": "Cassville"
  },
  {
    "State": "NY",
    "City": "Chadwicks"
  },
  {
    "State": "NY",
    "City": "Cherry Valley"
  },
  {
    "State": "NY",
    "City": "Clark Mills"
  },
  {
    "State": "NY",
    "City": "Clayville"
  },
  {
    "State": "NY",
    "City": "Clinton"
  },
  {
    "State": "NY",
    "City": "Cold Brook"
  },
  {
    "State": "NY",
    "City": "Constableville"
  },
  {
    "State": "NY",
    "City": "Cooperstown"
  },
  {
    "State": "NY",
    "City": "Croghan"
  },
  {
    "State": "NY",
    "City": "Deansboro"
  },
  {
    "State": "NY",
    "City": "Dolgeville"
  },
  {
    "State": "NY",
    "City": "Eagle Bay"
  },
  {
    "State": "NY",
    "City": "Earlville"
  },
  {
    "State": "NY",
    "City": "East Springfield"
  },
  {
    "State": "NY",
    "City": "Eaton"
  },
  {
    "State": "NY",
    "City": "Edmeston"
  },
  {
    "State": "NY",
    "City": "Fly Creek"
  },
  {
    "State": "NY",
    "City": "Forestport"
  },
  {
    "State": "NY",
    "City": "Fort Plain"
  },
  {
    "State": "NY",
    "City": "Frankfort"
  },
  {
    "State": "NY",
    "City": "Franklin Springs"
  },
  {
    "State": "NY",
    "City": "Garrattsville"
  },
  {
    "State": "NY",
    "City": "Glenfield"
  },
  {
    "State": "NY",
    "City": "Greig"
  },
  {
    "State": "NY",
    "City": "Hamilton"
  },
  {
    "State": "NY",
    "City": "Hartwick"
  },
  {
    "State": "NY",
    "City": "Herkimer"
  },
  {
    "State": "NY",
    "City": "Hinckley"
  },
  {
    "State": "NY",
    "City": "Hoffmeister"
  },
  {
    "State": "NY",
    "City": "Holland Patent"
  },
  {
    "State": "NY",
    "City": "Hubbardsville"
  },
  {
    "State": "NY",
    "City": "Ilion"
  },
  {
    "State": "NY",
    "City": "Inlet"
  },
  {
    "State": "NY",
    "City": "Jordanville"
  },
  {
    "State": "NY",
    "City": "Knoxboro"
  },
  {
    "State": "NY",
    "City": "Lee Center"
  },
  {
    "State": "NY",
    "City": "Leonardsville"
  },
  {
    "State": "NY",
    "City": "Little Falls"
  },
  {
    "State": "NY",
    "City": "Lowville"
  },
  {
    "State": "NY",
    "City": "Lyons Falls"
  },
  {
    "State": "NY",
    "City": "Mc Connellsville"
  },
  {
    "State": "NY",
    "City": "Madison"
  },
  {
    "State": "NY",
    "City": "Marcy"
  },
  {
    "State": "NY",
    "City": "Martinsburg"
  },
  {
    "State": "NY",
    "City": "Middleville"
  },
  {
    "State": "NY",
    "City": "Mohawk"
  },
  {
    "State": "NY",
    "City": "Morrisville"
  },
  {
    "State": "NY",
    "City": "Munnsville"
  },
  {
    "State": "NY",
    "City": "Nelliston"
  },
  {
    "State": "NY",
    "City": "New Berlin"
  },
  {
    "State": "NY",
    "City": "New Hartford"
  },
  {
    "State": "NY",
    "City": "New Lisbon"
  },
  {
    "State": "NY",
    "City": "Newport"
  },
  {
    "State": "NY",
    "City": "New York Mills"
  },
  {
    "State": "NY",
    "City": "North Brookfield"
  },
  {
    "State": "NY",
    "City": "Old Forge"
  },
  {
    "State": "NY",
    "City": "Oneida"
  },
  {
    "State": "NY",
    "City": "Oriskany"
  },
  {
    "State": "NY",
    "City": "Oriskany Falls"
  },
  {
    "State": "NY",
    "City": "Orwell"
  },
  {
    "State": "NY",
    "City": "Palatine Bridge"
  },
  {
    "State": "NY",
    "City": "Poland"
  },
  {
    "State": "NY",
    "City": "Port Leyden"
  },
  {
    "State": "NY",
    "City": "Prospect"
  },
  {
    "State": "NY",
    "City": "Raquette Lake"
  },
  {
    "State": "NY",
    "City": "Redfield"
  },
  {
    "State": "NY",
    "City": "Remsen"
  },
  {
    "State": "NY",
    "City": "Richfield Springs"
  },
  {
    "State": "NY",
    "City": "Rome"
  },
  {
    "State": "NY",
    "City": "Roseboom"
  },
  {
    "State": "NY",
    "City": "Saint Johnsville"
  },
  {
    "State": "NY",
    "City": "Salisbury Center"
  },
  {
    "State": "NY",
    "City": "Sangerfield"
  },
  {
    "State": "NY",
    "City": "Sauquoit"
  },
  {
    "State": "NY",
    "City": "Schuyler Lake"
  },
  {
    "State": "NY",
    "City": "Sharon Springs"
  },
  {
    "State": "NY",
    "City": "Sherburne"
  },
  {
    "State": "NY",
    "City": "Sherrill"
  },
  {
    "State": "NY",
    "City": "Smyrna"
  },
  {
    "State": "NY",
    "City": "Solsville"
  },
  {
    "State": "NY",
    "City": "Springfield Center"
  },
  {
    "State": "NY",
    "City": "Stittville"
  },
  {
    "State": "NY",
    "City": "Stratford"
  },
  {
    "State": "NY",
    "City": "Taberg"
  },
  {
    "State": "NY",
    "City": "Thendara"
  },
  {
    "State": "NY",
    "City": "Turin"
  },
  {
    "State": "NY",
    "City": "Van Hornesville"
  },
  {
    "State": "NY",
    "City": "Vernon"
  },
  {
    "State": "NY",
    "City": "Vernon Center"
  },
  {
    "State": "NY",
    "City": "Verona"
  },
  {
    "State": "NY",
    "City": "Washington Mills"
  },
  {
    "State": "NY",
    "City": "Waterville"
  },
  {
    "State": "NY",
    "City": "West Burlington"
  },
  {
    "State": "NY",
    "City": "Westdale"
  },
  {
    "State": "NY",
    "City": "West Eaton"
  },
  {
    "State": "NY",
    "City": "West Edmeston"
  },
  {
    "State": "NY",
    "City": "Westernville"
  },
  {
    "State": "NY",
    "City": "Westford"
  },
  {
    "State": "NY",
    "City": "West Leyden"
  },
  {
    "State": "NY",
    "City": "Westmoreland"
  },
  {
    "State": "NY",
    "City": "West Winfield"
  },
  {
    "State": "NY",
    "City": "Whitesboro"
  },
  {
    "State": "NY",
    "City": "Williamstown"
  },
  {
    "State": "NY",
    "City": "Woodgate"
  },
  {
    "State": "NY",
    "City": "Yorkville"
  },
  {
    "State": "NY",
    "City": "Utica"
  },
  {
    "State": "NY",
    "City": "Watertown"
  },
  {
    "State": "NY",
    "City": "Fort Drum"
  },
  {
    "State": "NY",
    "City": "Adams"
  },
  {
    "State": "NY",
    "City": "Adams Center"
  },
  {
    "State": "NY",
    "City": "Alexandria Bay"
  },
  {
    "State": "NY",
    "City": "Antwerp"
  },
  {
    "State": "NY",
    "City": "Belleville"
  },
  {
    "State": "NY",
    "City": "Black River"
  },
  {
    "State": "NY",
    "City": "Brasher Falls"
  },
  {
    "State": "NY",
    "City": "Brier Hill"
  },
  {
    "State": "NY",
    "City": "Brownville"
  },
  {
    "State": "NY",
    "City": "Calcium"
  },
  {
    "State": "NY",
    "City": "Canton"
  },
  {
    "State": "NY",
    "City": "Cape Vincent"
  },
  {
    "State": "NY",
    "City": "Carthage"
  },
  {
    "State": "NY",
    "City": "Castorland"
  },
  {
    "State": "NY",
    "City": "Chase Mills"
  },
  {
    "State": "NY",
    "City": "Chaumont"
  },
  {
    "State": "NY",
    "City": "Chippewa Bay"
  },
  {
    "State": "NY",
    "City": "Clayton"
  },
  {
    "State": "NY",
    "City": "Colton"
  },
  {
    "State": "NY",
    "City": "Copenhagen"
  },
  {
    "State": "NY",
    "City": "Deer River"
  },
  {
    "State": "NY",
    "City": "Deferiet"
  },
  {
    "State": "NY",
    "City": "De Kalb Junction"
  },
  {
    "State": "NY",
    "City": "Denmark"
  },
  {
    "State": "NY",
    "City": "Depauville"
  },
  {
    "State": "NY",
    "City": "De Peyster"
  },
  {
    "State": "NY",
    "City": "Dexter"
  },
  {
    "State": "NY",
    "City": "Edwards"
  },
  {
    "State": "NY",
    "City": "Ellisburg"
  },
  {
    "State": "NY",
    "City": "Evans Mills"
  },
  {
    "State": "NY",
    "City": "Felts Mills"
  },
  {
    "State": "NY",
    "City": "Fine"
  },
  {
    "State": "NY",
    "City": "Wellesley Island"
  },
  {
    "State": "NY",
    "City": "Fishers Landing"
  },
  {
    "State": "NY",
    "City": "Gouverneur"
  },
  {
    "State": "NY",
    "City": "Great Bend"
  },
  {
    "State": "NY",
    "City": "Hailesboro"
  },
  {
    "State": "NY",
    "City": "Hammond"
  },
  {
    "State": "NY",
    "City": "Hannawa Falls"
  },
  {
    "State": "NY",
    "City": "Harrisville"
  },
  {
    "State": "NY",
    "City": "Helena"
  },
  {
    "State": "NY",
    "City": "Henderson"
  },
  {
    "State": "NY",
    "City": "Henderson Harbor"
  },
  {
    "State": "NY",
    "City": "Hermon"
  },
  {
    "State": "NY",
    "City": "Heuvelton"
  },
  {
    "State": "NY",
    "City": "Hogansburg"
  },
  {
    "State": "NY",
    "City": "La Fargeville"
  },
  {
    "State": "NY",
    "City": "Limerick"
  },
  {
    "State": "NY",
    "City": "Lisbon"
  },
  {
    "State": "NY",
    "City": "Lorraine"
  },
  {
    "State": "NY",
    "City": "Madrid"
  },
  {
    "State": "NY",
    "City": "Mannsville"
  },
  {
    "State": "NY",
    "City": "Massena"
  },
  {
    "State": "NY",
    "City": "Morristown"
  },
  {
    "State": "NY",
    "City": "Natural Bridge"
  },
  {
    "State": "NY",
    "City": "Newton Falls"
  },
  {
    "State": "NY",
    "City": "Norfolk"
  },
  {
    "State": "NY",
    "City": "Norwood"
  },
  {
    "State": "NY",
    "City": "Ogdensburg"
  },
  {
    "State": "NY",
    "City": "Oswegatchie"
  },
  {
    "State": "NY",
    "City": "Parishville"
  },
  {
    "State": "NY",
    "City": "Philadelphia"
  },
  {
    "State": "NY",
    "City": "Pierrepont Manor"
  },
  {
    "State": "NY",
    "City": "Plessis"
  },
  {
    "State": "NY",
    "City": "Potsdam"
  },
  {
    "State": "NY",
    "City": "Pyrites"
  },
  {
    "State": "NY",
    "City": "Raymondville"
  },
  {
    "State": "NY",
    "City": "Redwood"
  },
  {
    "State": "NY",
    "City": "Rensselaer Falls"
  },
  {
    "State": "NY",
    "City": "Richville"
  },
  {
    "State": "NY",
    "City": "Rodman"
  },
  {
    "State": "NY",
    "City": "Rooseveltown"
  },
  {
    "State": "NY",
    "City": "Russell"
  },
  {
    "State": "NY",
    "City": "Sackets Harbor"
  },
  {
    "State": "NY",
    "City": "South Colton"
  },
  {
    "State": "NY",
    "City": "Star Lake"
  },
  {
    "State": "NY",
    "City": "Theresa"
  },
  {
    "State": "NY",
    "City": "Thousand Island Park"
  },
  {
    "State": "NY",
    "City": "Three Mile Bay"
  },
  {
    "State": "NY",
    "City": "Waddington"
  },
  {
    "State": "NY",
    "City": "Wanakena"
  },
  {
    "State": "NY",
    "City": "West Stockholm"
  },
  {
    "State": "NY",
    "City": "Winthrop"
  },
  {
    "State": "NY",
    "City": "Afton"
  },
  {
    "State": "NY",
    "City": "Andes"
  },
  {
    "State": "NY",
    "City": "Apalachin"
  },
  {
    "State": "NY",
    "City": "Bainbridge"
  },
  {
    "State": "NY",
    "City": "Barton"
  },
  {
    "State": "NY",
    "City": "Berkshire"
  },
  {
    "State": "NY",
    "City": "Bible School Park"
  },
  {
    "State": "NY",
    "City": "Blodgett Mills"
  },
  {
    "State": "NY",
    "City": "Bloomville"
  },
  {
    "State": "NY",
    "City": "Bovina Center"
  },
  {
    "State": "NY",
    "City": "Candor"
  },
  {
    "State": "NY",
    "City": "Castle Creek"
  },
  {
    "State": "NY",
    "City": "Chenango Bridge"
  },
  {
    "State": "NY",
    "City": "Chenango Forks"
  },
  {
    "State": "NY",
    "City": "Colliersville"
  },
  {
    "State": "NY",
    "City": "Conklin"
  },
  {
    "State": "NY",
    "City": "Corbettsville"
  },
  {
    "State": "NY",
    "City": "Davenport"
  },
  {
    "State": "NY",
    "City": "Davenport Center"
  },
  {
    "State": "NY",
    "City": "Delancey"
  },
  {
    "State": "NY",
    "City": "Delhi"
  },
  {
    "State": "NY",
    "City": "Deposit"
  },
  {
    "State": "NY",
    "City": "Downsville"
  },
  {
    "State": "NY",
    "City": "East Branch"
  },
  {
    "State": "NY",
    "City": "East Meredith"
  },
  {
    "State": "NY",
    "City": "East Pharsalia"
  },
  {
    "State": "NY",
    "City": "Endicott"
  },
  {
    "State": "NY",
    "City": "Endwell"
  },
  {
    "State": "NY",
    "City": "Fishs Eddy"
  },
  {
    "State": "NY",
    "City": "Franklin"
  },
  {
    "State": "NY",
    "City": "Gilbertsville"
  },
  {
    "State": "NY",
    "City": "Glen Aubrey"
  },
  {
    "State": "NY",
    "City": "Greene"
  },
  {
    "State": "NY",
    "City": "Guilford"
  },
  {
    "State": "NY",
    "City": "Hamden"
  },
  {
    "State": "NY",
    "City": "Hancock"
  },
  {
    "State": "NY",
    "City": "Harford"
  },
  {
    "State": "NY",
    "City": "Harpersfield"
  },
  {
    "State": "NY",
    "City": "Harpursville"
  },
  {
    "State": "NY",
    "City": "Hobart"
  },
  {
    "State": "NY",
    "City": "Johnson City"
  },
  {
    "State": "NY",
    "City": "Killawog"
  },
  {
    "State": "NY",
    "City": "Kirkwood"
  },
  {
    "State": "NY",
    "City": "Laurens"
  },
  {
    "State": "NY",
    "City": "Lisle"
  },
  {
    "State": "NY",
    "City": "Mc Donough"
  },
  {
    "State": "NY",
    "City": "Maine"
  },
  {
    "State": "NY",
    "City": "Marathon"
  },
  {
    "State": "NY",
    "City": "Masonville"
  },
  {
    "State": "NY",
    "City": "Meridale"
  },
  {
    "State": "NY",
    "City": "Milford"
  },
  {
    "State": "NY",
    "City": "Morris"
  },
  {
    "State": "NY",
    "City": "Mount Upton"
  },
  {
    "State": "NY",
    "City": "Mount Vision"
  },
  {
    "State": "NY",
    "City": "Newark Valley"
  },
  {
    "State": "NY",
    "City": "Nichols"
  },
  {
    "State": "NY",
    "City": "Nineveh"
  },
  {
    "State": "NY",
    "City": "North Norwich"
  },
  {
    "State": "NY",
    "City": "Norwich"
  },
  {
    "State": "NY",
    "City": "Oneonta"
  },
  {
    "State": "NY",
    "City": "Otego"
  },
  {
    "State": "NY",
    "City": "Ouaquaga"
  },
  {
    "State": "NY",
    "City": "Owego"
  },
  {
    "State": "NY",
    "City": "Oxford"
  },
  {
    "State": "NY",
    "City": "Plymouth"
  },
  {
    "State": "NY",
    "City": "Port Crane"
  },
  {
    "State": "NY",
    "City": "Portlandville"
  },
  {
    "State": "NY",
    "City": "Richford"
  },
  {
    "State": "NY",
    "City": "Shinhopple"
  },
  {
    "State": "NY",
    "City": "Sidney"
  },
  {
    "State": "NY",
    "City": "Sidney Center"
  },
  {
    "State": "NY",
    "City": "Smithboro"
  },
  {
    "State": "NY",
    "City": "Smithville Flats"
  },
  {
    "State": "NY",
    "City": "South Kortright"
  },
  {
    "State": "NY",
    "City": "South New Berlin"
  },
  {
    "State": "NY",
    "City": "South Plymouth"
  },
  {
    "State": "NY",
    "City": "Tioga Center"
  },
  {
    "State": "NY",
    "City": "Treadwell"
  },
  {
    "State": "NY",
    "City": "Trout Creek"
  },
  {
    "State": "NY",
    "City": "Tunnel"
  },
  {
    "State": "NY",
    "City": "Unadilla"
  },
  {
    "State": "NY",
    "City": "Vestal"
  },
  {
    "State": "NY",
    "City": "Walton"
  },
  {
    "State": "NY",
    "City": "Wells Bridge"
  },
  {
    "State": "NY",
    "City": "West Davenport"
  },
  {
    "State": "NY",
    "City": "West Oneonta"
  },
  {
    "State": "NY",
    "City": "Whitney Point"
  },
  {
    "State": "NY",
    "City": "Willet"
  },
  {
    "State": "NY",
    "City": "Willseyville"
  },
  {
    "State": "NY",
    "City": "Windsor"
  },
  {
    "State": "NY",
    "City": "Binghamton"
  },
  {
    "State": "NY",
    "City": "Akron"
  },
  {
    "State": "NY",
    "City": "Alden"
  },
  {
    "State": "NY",
    "City": "Alexander"
  },
  {
    "State": "NY",
    "City": "Angola"
  },
  {
    "State": "NY",
    "City": "Appleton"
  },
  {
    "State": "NY",
    "City": "Arcade"
  },
  {
    "State": "NY",
    "City": "Athol Springs"
  },
  {
    "State": "NY",
    "City": "Attica"
  },
  {
    "State": "NY",
    "City": "Barker"
  },
  {
    "State": "NY",
    "City": "Basom"
  },
  {
    "State": "NY",
    "City": "Batavia"
  },
  {
    "State": "NY",
    "City": "Bliss"
  },
  {
    "State": "NY",
    "City": "Boston"
  },
  {
    "State": "NY",
    "City": "Bowmansville"
  },
  {
    "State": "NY",
    "City": "Brant"
  },
  {
    "State": "NY",
    "City": "Burt"
  },
  {
    "State": "NY",
    "City": "Centerville"
  },
  {
    "State": "NY",
    "City": "Chaffee"
  },
  {
    "State": "NY",
    "City": "Clarence"
  },
  {
    "State": "NY",
    "City": "Clarence Center"
  },
  {
    "State": "NY",
    "City": "Colden"
  },
  {
    "State": "NY",
    "City": "Collins"
  },
  {
    "State": "NY",
    "City": "Collins Center"
  },
  {
    "State": "NY",
    "City": "Corfu"
  },
  {
    "State": "NY",
    "City": "Cowlesville"
  },
  {
    "State": "NY",
    "City": "Crittenden"
  },
  {
    "State": "NY",
    "City": "Dale"
  },
  {
    "State": "NY",
    "City": "Darien Center"
  },
  {
    "State": "NY",
    "City": "Dayton"
  },
  {
    "State": "NY",
    "City": "Delevan"
  },
  {
    "State": "NY",
    "City": "Depew"
  },
  {
    "State": "NY",
    "City": "Derby"
  },
  {
    "State": "NY",
    "City": "Dunkirk"
  },
  {
    "State": "NY",
    "City": "East Amherst"
  },
  {
    "State": "NY",
    "City": "East Aurora"
  },
  {
    "State": "NY",
    "City": "East Bethany"
  },
  {
    "State": "NY",
    "City": "East Concord"
  },
  {
    "State": "NY",
    "City": "East Pembroke"
  },
  {
    "State": "NY",
    "City": "Eden"
  },
  {
    "State": "NY",
    "City": "Elba"
  },
  {
    "State": "NY",
    "City": "Elma"
  },
  {
    "State": "NY",
    "City": "Farmersville Station"
  },
  {
    "State": "NY",
    "City": "Farnham"
  },
  {
    "State": "NY",
    "City": "Forestville"
  },
  {
    "State": "NY",
    "City": "Fredonia"
  },
  {
    "State": "NY",
    "City": "Freedom"
  },
  {
    "State": "NY",
    "City": "Gainesville"
  },
  {
    "State": "NY",
    "City": "Gasport"
  },
  {
    "State": "NY",
    "City": "Getzville"
  },
  {
    "State": "NY",
    "City": "Glenwood"
  },
  {
    "State": "NY",
    "City": "Gowanda"
  },
  {
    "State": "NY",
    "City": "Grand Island"
  },
  {
    "State": "NY",
    "City": "Hamburg"
  },
  {
    "State": "NY",
    "City": "Holland"
  },
  {
    "State": "NY",
    "City": "Irving"
  },
  {
    "State": "NY",
    "City": "Java Center"
  },
  {
    "State": "NY",
    "City": "Java Village"
  },
  {
    "State": "NY",
    "City": "Lake View"
  },
  {
    "State": "NY",
    "City": "Lancaster"
  },
  {
    "State": "NY",
    "City": "Lawtons"
  },
  {
    "State": "NY",
    "City": "Lewiston"
  },
  {
    "State": "NY",
    "City": "Lockport"
  },
  {
    "State": "NY",
    "City": "Lyndonville"
  },
  {
    "State": "NY",
    "City": "Machias"
  },
  {
    "State": "NY",
    "City": "Marilla"
  },
  {
    "State": "NY",
    "City": "Medina"
  },
  {
    "State": "NY",
    "City": "Middleport"
  },
  {
    "State": "NY",
    "City": "Model City"
  },
  {
    "State": "NY",
    "City": "Newfane"
  },
  {
    "State": "NY",
    "City": "Niagara University"
  },
  {
    "State": "NY",
    "City": "North Boston"
  },
  {
    "State": "NY",
    "City": "North Collins"
  },
  {
    "State": "NY",
    "City": "North Evans"
  },
  {
    "State": "NY",
    "City": "North Java"
  },
  {
    "State": "NY",
    "City": "North Tonawanda"
  },
  {
    "State": "NY",
    "City": "Oakfield"
  },
  {
    "State": "NY",
    "City": "Olcott"
  },
  {
    "State": "NY",
    "City": "Orchard Park"
  },
  {
    "State": "NY",
    "City": "Perrysburg"
  },
  {
    "State": "NY",
    "City": "Pike"
  },
  {
    "State": "NY",
    "City": "Ransomville"
  },
  {
    "State": "NY",
    "City": "Sanborn"
  },
  {
    "State": "NY",
    "City": "Sandusky"
  },
  {
    "State": "NY",
    "City": "Sardinia"
  },
  {
    "State": "NY",
    "City": "Sheridan"
  },
  {
    "State": "NY",
    "City": "Silver Creek"
  },
  {
    "State": "NY",
    "City": "South Dayton"
  },
  {
    "State": "NY",
    "City": "South Wales"
  },
  {
    "State": "NY",
    "City": "Spring Brook"
  },
  {
    "State": "NY",
    "City": "Springville"
  },
  {
    "State": "NY",
    "City": "Stafford"
  },
  {
    "State": "NY",
    "City": "Stella Niagara"
  },
  {
    "State": "NY",
    "City": "Strykersville"
  },
  {
    "State": "NY",
    "City": "Tonawanda"
  },
  {
    "State": "NY",
    "City": "Van Buren Point"
  },
  {
    "State": "NY",
    "City": "Varysburg"
  },
  {
    "State": "NY",
    "City": "Versailles"
  },
  {
    "State": "NY",
    "City": "Wales Center"
  },
  {
    "State": "NY",
    "City": "West Falls"
  },
  {
    "State": "NY",
    "City": "West Valley"
  },
  {
    "State": "NY",
    "City": "Wilson"
  },
  {
    "State": "NY",
    "City": "Yorkshire"
  },
  {
    "State": "NY",
    "City": "Youngstown"
  },
  {
    "State": "NY",
    "City": "Buffalo"
  },
  {
    "State": "NY",
    "City": "Niagara Falls"
  },
  {
    "State": "NY",
    "City": "Adams Basin"
  },
  {
    "State": "NY",
    "City": "Albion"
  },
  {
    "State": "NY",
    "City": "Alton"
  },
  {
    "State": "NY",
    "City": "Avon"
  },
  {
    "State": "NY",
    "City": "Bellona"
  },
  {
    "State": "NY",
    "City": "Bergen"
  },
  {
    "State": "NY",
    "City": "Branchport"
  },
  {
    "State": "NY",
    "City": "Brockport"
  },
  {
    "State": "NY",
    "City": "Byron"
  },
  {
    "State": "NY",
    "City": "Caledonia"
  },
  {
    "State": "NY",
    "City": "Canandaigua"
  },
  {
    "State": "NY",
    "City": "Farmington"
  },
  {
    "State": "NY",
    "City": "Castile"
  },
  {
    "State": "NY",
    "City": "Churchville"
  },
  {
    "State": "NY",
    "City": "Clarendon"
  },
  {
    "State": "NY",
    "City": "Clarkson"
  },
  {
    "State": "NY",
    "City": "Clifton Springs"
  },
  {
    "State": "NY",
    "City": "Clyde"
  },
  {
    "State": "NY",
    "City": "Conesus"
  },
  {
    "State": "NY",
    "City": "Dansville"
  },
  {
    "State": "NY",
    "City": "Dresden"
  },
  {
    "State": "NY",
    "City": "East Bloomfield"
  },
  {
    "State": "NY",
    "City": "East Rochester"
  },
  {
    "State": "NY",
    "City": "East Williamson"
  },
  {
    "State": "NY",
    "City": "Fairport"
  },
  {
    "State": "NY",
    "City": "Fancher"
  },
  {
    "State": "NY",
    "City": "Fishers"
  },
  {
    "State": "NY",
    "City": "Geneseo"
  },
  {
    "State": "NY",
    "City": "Geneva"
  },
  {
    "State": "NY",
    "City": "Gorham"
  },
  {
    "State": "NY",
    "City": "Groveland"
  },
  {
    "State": "NY",
    "City": "Hall"
  },
  {
    "State": "NY",
    "City": "Hamlin"
  },
  {
    "State": "NY",
    "City": "Hemlock"
  },
  {
    "State": "NY",
    "City": "Henrietta"
  },
  {
    "State": "NY",
    "City": "Hilton"
  },
  {
    "State": "NY",
    "City": "Bloomfield"
  },
  {
    "State": "NY",
    "City": "Holley"
  },
  {
    "State": "NY",
    "City": "Honeoye"
  },
  {
    "State": "NY",
    "City": "Honeoye Falls"
  },
  {
    "State": "NY",
    "City": "Ionia"
  },
  {
    "State": "NY",
    "City": "Kendall"
  },
  {
    "State": "NY",
    "City": "Kent"
  },
  {
    "State": "NY",
    "City": "Keuka Park"
  },
  {
    "State": "NY",
    "City": "Knowlesville"
  },
  {
    "State": "NY",
    "City": "Lakeville"
  },
  {
    "State": "NY",
    "City": "Leicester"
  },
  {
    "State": "NY",
    "City": "Le Roy"
  },
  {
    "State": "NY",
    "City": "Lima"
  },
  {
    "State": "NY",
    "City": "Linwood"
  },
  {
    "State": "NY",
    "City": "Livonia"
  },
  {
    "State": "NY",
    "City": "Livonia Center"
  },
  {
    "State": "NY",
    "City": "Lyons"
  },
  {
    "State": "NY",
    "City": "Macedon"
  },
  {
    "State": "NY",
    "City": "Manchester"
  },
  {
    "State": "NY",
    "City": "Marion"
  },
  {
    "State": "NY",
    "City": "Mendon"
  },
  {
    "State": "NY",
    "City": "Middlesex"
  },
  {
    "State": "NY",
    "City": "Morton"
  },
  {
    "State": "NY",
    "City": "Mount Morris"
  },
  {
    "State": "NY",
    "City": "Mumford"
  },
  {
    "State": "NY",
    "City": "Naples"
  },
  {
    "State": "NY",
    "City": "Newark"
  },
  {
    "State": "NY",
    "City": "North Chili"
  },
  {
    "State": "NY",
    "City": "North Greece"
  },
  {
    "State": "NY",
    "City": "North Rose"
  },
  {
    "State": "NY",
    "City": "Nunda"
  },
  {
    "State": "NY",
    "City": "Oaks Corners"
  },
  {
    "State": "NY",
    "City": "Ontario"
  },
  {
    "State": "NY",
    "City": "Ontario Center"
  },
  {
    "State": "NY",
    "City": "Ovid"
  },
  {
    "State": "NY",
    "City": "Palmyra"
  },
  {
    "State": "NY",
    "City": "Pavilion"
  },
  {
    "State": "NY",
    "City": "Penfield"
  },
  {
    "State": "NY",
    "City": "Penn Yan"
  },
  {
    "State": "NY",
    "City": "Perkinsville"
  },
  {
    "State": "NY",
    "City": "Perry"
  },
  {
    "State": "NY",
    "City": "Phelps"
  },
  {
    "State": "NY",
    "City": "Piffard"
  },
  {
    "State": "NY",
    "City": "Pittsford"
  },
  {
    "State": "NY",
    "City": "Portageville"
  },
  {
    "State": "NY",
    "City": "Port Gibson"
  },
  {
    "State": "NY",
    "City": "Pultneyville"
  },
  {
    "State": "NY",
    "City": "Retsof"
  },
  {
    "State": "NY",
    "City": "Romulus"
  },
  {
    "State": "NY",
    "City": "Rose"
  },
  {
    "State": "NY",
    "City": "Rush"
  },
  {
    "State": "NY",
    "City": "Rushville"
  },
  {
    "State": "NY",
    "City": "Scottsburg"
  },
  {
    "State": "NY",
    "City": "Scottsville"
  },
  {
    "State": "NY",
    "City": "Seneca Castle"
  },
  {
    "State": "NY",
    "City": "Shortsville"
  },
  {
    "State": "NY",
    "City": "Silver Lake"
  },
  {
    "State": "NY",
    "City": "Silver Springs"
  },
  {
    "State": "NY",
    "City": "Sodus"
  },
  {
    "State": "NY",
    "City": "Sodus Point"
  },
  {
    "State": "NY",
    "City": "Sonyea"
  },
  {
    "State": "NY",
    "City": "South Byron"
  },
  {
    "State": "NY",
    "City": "South Lima"
  },
  {
    "State": "NY",
    "City": "Spencerport"
  },
  {
    "State": "NY",
    "City": "Springwater"
  },
  {
    "State": "NY",
    "City": "Stanley"
  },
  {
    "State": "NY",
    "City": "Union Hill"
  },
  {
    "State": "NY",
    "City": "Victor"
  },
  {
    "State": "NY",
    "City": "Walworth"
  },
  {
    "State": "NY",
    "City": "Warsaw"
  },
  {
    "State": "NY",
    "City": "Waterport"
  },
  {
    "State": "NY",
    "City": "Wayland"
  },
  {
    "State": "NY",
    "City": "Webster"
  },
  {
    "State": "NY",
    "City": "West Bloomfield"
  },
  {
    "State": "NY",
    "City": "West Henrietta"
  },
  {
    "State": "NY",
    "City": "Willard"
  },
  {
    "State": "NY",
    "City": "Williamson"
  },
  {
    "State": "NY",
    "City": "Wolcott"
  },
  {
    "State": "NY",
    "City": "Wyoming"
  },
  {
    "State": "NY",
    "City": "York"
  },
  {
    "State": "NY",
    "City": "Rochester"
  },
  {
    "State": "NY",
    "City": "Jamestown"
  },
  {
    "State": "NY",
    "City": "Allegany"
  },
  {
    "State": "NY",
    "City": "Allentown"
  },
  {
    "State": "NY",
    "City": "Alma"
  },
  {
    "State": "NY",
    "City": "Angelica"
  },
  {
    "State": "NY",
    "City": "Ashville"
  },
  {
    "State": "NY",
    "City": "Belfast"
  },
  {
    "State": "NY",
    "City": "Bemus Point"
  },
  {
    "State": "NY",
    "City": "Black Creek"
  },
  {
    "State": "NY",
    "City": "Bolivar"
  },
  {
    "State": "NY",
    "City": "Brocton"
  },
  {
    "State": "NY",
    "City": "Caneadea"
  },
  {
    "State": "NY",
    "City": "Cassadaga"
  },
  {
    "State": "NY",
    "City": "Cattaraugus"
  },
  {
    "State": "NY",
    "City": "Celoron"
  },
  {
    "State": "NY",
    "City": "Ceres"
  },
  {
    "State": "NY",
    "City": "Chautauqua"
  },
  {
    "State": "NY",
    "City": "Cherry Creek"
  },
  {
    "State": "NY",
    "City": "Clymer"
  },
  {
    "State": "NY",
    "City": "Conewango Valley"
  },
  {
    "State": "NY",
    "City": "Cuba"
  },
  {
    "State": "NY",
    "City": "Dewittville"
  },
  {
    "State": "NY",
    "City": "East Otto"
  },
  {
    "State": "NY",
    "City": "East Randolph"
  },
  {
    "State": "NY",
    "City": "Ellicottville"
  },
  {
    "State": "NY",
    "City": "Ellington"
  },
  {
    "State": "NY",
    "City": "Falconer"
  },
  {
    "State": "NY",
    "City": "Fillmore"
  },
  {
    "State": "NY",
    "City": "Findley Lake"
  },
  {
    "State": "NY",
    "City": "Franklinville"
  },
  {
    "State": "NY",
    "City": "Frewsburg"
  },
  {
    "State": "NY",
    "City": "Friendship"
  },
  {
    "State": "NY",
    "City": "Gerry"
  },
  {
    "State": "NY",
    "City": "Great Valley"
  },
  {
    "State": "NY",
    "City": "Greenhurst"
  },
  {
    "State": "NY",
    "City": "Hinsdale"
  },
  {
    "State": "NY",
    "City": "Houghton"
  },
  {
    "State": "NY",
    "City": "Hume"
  },
  {
    "State": "NY",
    "City": "Kennedy"
  },
  {
    "State": "NY",
    "City": "Kill Buck"
  },
  {
    "State": "NY",
    "City": "Lakewood"
  },
  {
    "State": "NY",
    "City": "Leon"
  },
  {
    "State": "NY",
    "City": "Lily Dale"
  },
  {
    "State": "NY",
    "City": "Limestone"
  },
  {
    "State": "NY",
    "City": "Little Genesee"
  },
  {
    "State": "NY",
    "City": "Little Valley"
  },
  {
    "State": "NY",
    "City": "Maple Springs"
  },
  {
    "State": "NY",
    "City": "Mayville"
  },
  {
    "State": "NY",
    "City": "Niobe"
  },
  {
    "State": "NY",
    "City": "Olean"
  },
  {
    "State": "NY",
    "City": "Otto"
  },
  {
    "State": "NY",
    "City": "Panama"
  },
  {
    "State": "NY",
    "City": "Portland"
  },
  {
    "State": "NY",
    "City": "Portville"
  },
  {
    "State": "NY",
    "City": "Randolph"
  },
  {
    "State": "NY",
    "City": "Richburg"
  },
  {
    "State": "NY",
    "City": "Ripley"
  },
  {
    "State": "NY",
    "City": "Rushford"
  },
  {
    "State": "NY",
    "City": "Saint Bonaventure"
  },
  {
    "State": "NY",
    "City": "Salamanca"
  },
  {
    "State": "NY",
    "City": "Sherman"
  },
  {
    "State": "NY",
    "City": "Sinclairville"
  },
  {
    "State": "NY",
    "City": "Steamburg"
  },
  {
    "State": "NY",
    "City": "Stockton"
  },
  {
    "State": "NY",
    "City": "Stow"
  },
  {
    "State": "NY",
    "City": "West Clarksville"
  },
  {
    "State": "NY",
    "City": "Westfield"
  },
  {
    "State": "NY",
    "City": "Westons Mills"
  },
  {
    "State": "NY",
    "City": "Addison"
  },
  {
    "State": "NY",
    "City": "Alfred"
  },
  {
    "State": "NY",
    "City": "Alfred Station"
  },
  {
    "State": "NY",
    "City": "Almond"
  },
  {
    "State": "NY",
    "City": "Alpine"
  },
  {
    "State": "NY",
    "City": "Andover"
  },
  {
    "State": "NY",
    "City": "Arkport"
  },
  {
    "State": "NY",
    "City": "Atlanta"
  },
  {
    "State": "NY",
    "City": "Avoca"
  },
  {
    "State": "NY",
    "City": "Bath"
  },
  {
    "State": "NY",
    "City": "Beaver Dams"
  },
  {
    "State": "NY",
    "City": "Belmont"
  },
  {
    "State": "NY",
    "City": "Big Flats"
  },
  {
    "State": "NY",
    "City": "Bradford"
  },
  {
    "State": "NY",
    "City": "Breesport"
  },
  {
    "State": "NY",
    "City": "Brooktondale"
  },
  {
    "State": "NY",
    "City": "Burdett"
  },
  {
    "State": "NY",
    "City": "Cameron"
  },
  {
    "State": "NY",
    "City": "Cameron Mills"
  },
  {
    "State": "NY",
    "City": "Campbell"
  },
  {
    "State": "NY",
    "City": "Canaseraga"
  },
  {
    "State": "NY",
    "City": "Canisteo"
  },
  {
    "State": "NY",
    "City": "Cayuta"
  },
  {
    "State": "NY",
    "City": "Chemung"
  },
  {
    "State": "NY",
    "City": "Cohocton"
  },
  {
    "State": "NY",
    "City": "Coopers Plains"
  },
  {
    "State": "NY",
    "City": "Corning"
  },
  {
    "State": "NY",
    "City": "Dalton"
  },
  {
    "State": "NY",
    "City": "Dundee"
  },
  {
    "State": "NY",
    "City": "Erin"
  },
  {
    "State": "NY",
    "City": "Greenwood"
  },
  {
    "State": "NY",
    "City": "Hammondsport"
  },
  {
    "State": "NY",
    "City": "Hector"
  },
  {
    "State": "NY",
    "City": "Himrod"
  },
  {
    "State": "NY",
    "City": "Hornell"
  },
  {
    "State": "NY",
    "City": "Horseheads"
  },
  {
    "State": "NY",
    "City": "Hunt"
  },
  {
    "State": "NY",
    "City": "Interlaken"
  },
  {
    "State": "NY",
    "City": "Ithaca"
  },
  {
    "State": "NY",
    "City": "Jacksonville"
  },
  {
    "State": "NY",
    "City": "Jasper"
  },
  {
    "State": "NY",
    "City": "Kanona"
  },
  {
    "State": "NY",
    "City": "Lakemont"
  },
  {
    "State": "NY",
    "City": "Lindley"
  },
  {
    "State": "NY",
    "City": "Lockwood"
  },
  {
    "State": "NY",
    "City": "Lodi"
  },
  {
    "State": "NY",
    "City": "Lowman"
  },
  {
    "State": "NY",
    "City": "Mecklenburg"
  },
  {
    "State": "NY",
    "City": "Millport"
  },
  {
    "State": "NY",
    "City": "Montour Falls"
  },
  {
    "State": "NY",
    "City": "Newfield"
  },
  {
    "State": "NY",
    "City": "Odessa"
  },
  {
    "State": "NY",
    "City": "Painted Post"
  },
  {
    "State": "NY",
    "City": "Pine City"
  },
  {
    "State": "NY",
    "City": "Pine Valley"
  },
  {
    "State": "NY",
    "City": "Prattsburgh"
  },
  {
    "State": "NY",
    "City": "Pulteney"
  },
  {
    "State": "NY",
    "City": "Reading Center"
  },
  {
    "State": "NY",
    "City": "Rexville"
  },
  {
    "State": "NY",
    "City": "Rock Stream"
  },
  {
    "State": "NY",
    "City": "Savona"
  },
  {
    "State": "NY",
    "City": "Scio"
  },
  {
    "State": "NY",
    "City": "Slaterville Springs"
  },
  {
    "State": "NY",
    "City": "Lansing"
  },
  {
    "State": "NY",
    "City": "Spencer"
  },
  {
    "State": "NY",
    "City": "Swain"
  },
  {
    "State": "NY",
    "City": "Troupsburg"
  },
  {
    "State": "NY",
    "City": "Trumansburg"
  },
  {
    "State": "NY",
    "City": "Tyrone"
  },
  {
    "State": "NY",
    "City": "Van Etten"
  },
  {
    "State": "NY",
    "City": "Watkins Glen"
  },
  {
    "State": "NY",
    "City": "Waverly"
  },
  {
    "State": "NY",
    "City": "Wayne"
  },
  {
    "State": "NY",
    "City": "Wellsburg"
  },
  {
    "State": "NY",
    "City": "Wellsville"
  },
  {
    "State": "NY",
    "City": "Whitesville"
  },
  {
    "State": "NY",
    "City": "Woodhull"
  },
  {
    "State": "NY",
    "City": "Elmira"
  },
  {
    "State": "PA",
    "City": "Aliquippa"
  },
  {
    "State": "PA",
    "City": "Ambridge"
  },
  {
    "State": "PA",
    "City": "Atlasburg"
  },
  {
    "State": "PA",
    "City": "Baden"
  },
  {
    "State": "PA",
    "City": "Bairdford"
  },
  {
    "State": "PA",
    "City": "Bakerstown"
  },
  {
    "State": "PA",
    "City": "Beaver"
  },
  {
    "State": "PA",
    "City": "Beaver Falls"
  },
  {
    "State": "PA",
    "City": "Belle Vernon"
  },
  {
    "State": "PA",
    "City": "Brackenridge"
  },
  {
    "State": "PA",
    "City": "Bradfordwoods"
  },
  {
    "State": "PA",
    "City": "Bridgeville"
  },
  {
    "State": "PA",
    "City": "Buena Vista"
  },
  {
    "State": "PA",
    "City": "Bulger"
  },
  {
    "State": "PA",
    "City": "Bunola"
  },
  {
    "State": "PA",
    "City": "Burgettstown"
  },
  {
    "State": "PA",
    "City": "Charleroi"
  },
  {
    "State": "PA",
    "City": "Cheswick"
  },
  {
    "State": "PA",
    "City": "Clairton"
  },
  {
    "State": "PA",
    "City": "Clinton"
  },
  {
    "State": "PA",
    "City": "Conway"
  },
  {
    "State": "PA",
    "City": "Coulters"
  },
  {
    "State": "PA",
    "City": "Creighton"
  },
  {
    "State": "PA",
    "City": "Cuddy"
  },
  {
    "State": "PA",
    "City": "Curtisville"
  },
  {
    "State": "PA",
    "City": "Donora"
  },
  {
    "State": "PA",
    "City": "Dravosburg"
  },
  {
    "State": "PA",
    "City": "East Mc Keesport"
  },
  {
    "State": "PA",
    "City": "Elizabeth"
  },
  {
    "State": "PA",
    "City": "Elrama"
  },
  {
    "State": "PA",
    "City": "Freedom"
  },
  {
    "State": "PA",
    "City": "Georgetown"
  },
  {
    "State": "PA",
    "City": "Gibsonia"
  },
  {
    "State": "PA",
    "City": "Glassport"
  },
  {
    "State": "PA",
    "City": "Crescent"
  },
  {
    "State": "PA",
    "City": "Greenock"
  },
  {
    "State": "PA",
    "City": "Harwick"
  },
  {
    "State": "PA",
    "City": "Hookstown"
  },
  {
    "State": "PA",
    "City": "Indianola"
  },
  {
    "State": "PA",
    "City": "Industry"
  },
  {
    "State": "PA",
    "City": "Joffre"
  },
  {
    "State": "PA",
    "City": "Langeloth"
  },
  {
    "State": "PA",
    "City": "Lawrence"
  },
  {
    "State": "PA",
    "City": "Leetsdale"
  },
  {
    "State": "PA",
    "City": "Mc Donald"
  },
  {
    "State": "PA",
    "City": "Midland"
  },
  {
    "State": "PA",
    "City": "Midway"
  },
  {
    "State": "PA",
    "City": "Monaca"
  },
  {
    "State": "PA",
    "City": "Monessen"
  },
  {
    "State": "PA",
    "City": "Monongahela"
  },
  {
    "State": "PA",
    "City": "Morgan"
  },
  {
    "State": "PA",
    "City": "Natrona Heights"
  },
  {
    "State": "PA",
    "City": "New Brighton"
  },
  {
    "State": "PA",
    "City": "New Eagle"
  },
  {
    "State": "PA",
    "City": "New Kensington"
  },
  {
    "State": "PA",
    "City": "Oakdale"
  },
  {
    "State": "PA",
    "City": "Pricedale"
  },
  {
    "State": "PA",
    "City": "Rochester"
  },
  {
    "State": "PA",
    "City": "Rural Ridge"
  },
  {
    "State": "PA",
    "City": "Russellton"
  },
  {
    "State": "PA",
    "City": "Shippingport"
  },
  {
    "State": "PA",
    "City": "Slovan"
  },
  {
    "State": "PA",
    "City": "South Heights"
  },
  {
    "State": "PA",
    "City": "Sturgeon"
  },
  {
    "State": "PA",
    "City": "Sutersville"
  },
  {
    "State": "PA",
    "City": "Tarentum"
  },
  {
    "State": "PA",
    "City": "Trafford"
  },
  {
    "State": "PA",
    "City": "Warrendale"
  },
  {
    "State": "PA",
    "City": "Webster"
  },
  {
    "State": "PA",
    "City": "West Elizabeth"
  },
  {
    "State": "PA",
    "City": "West Newton"
  },
  {
    "State": "PA",
    "City": "Wexford"
  },
  {
    "State": "PA",
    "City": "Wildwood"
  },
  {
    "State": "PA",
    "City": "Allison Park"
  },
  {
    "State": "PA",
    "City": "Bethel Park"
  },
  {
    "State": "PA",
    "City": "Braddock"
  },
  {
    "State": "PA",
    "City": "Carnegie"
  },
  {
    "State": "PA",
    "City": "Coraopolis"
  },
  {
    "State": "PA",
    "City": "Duquesne"
  },
  {
    "State": "PA",
    "City": "East Pittsburgh"
  },
  {
    "State": "PA",
    "City": "Glenshaw"
  },
  {
    "State": "PA",
    "City": "Homestead"
  },
  {
    "State": "PA",
    "City": "West Mifflin"
  },
  {
    "State": "PA",
    "City": "Imperial"
  },
  {
    "State": "PA",
    "City": "Ingomar"
  },
  {
    "State": "PA",
    "City": "South Park"
  },
  {
    "State": "PA",
    "City": "Mckeesport"
  },
  {
    "State": "PA",
    "City": "Mc Kees Rocks"
  },
  {
    "State": "PA",
    "City": "North Versailles"
  },
  {
    "State": "PA",
    "City": "Oakmont"
  },
  {
    "State": "PA",
    "City": "Pitcairn"
  },
  {
    "State": "PA",
    "City": "Presto"
  },
  {
    "State": "PA",
    "City": "Sewickley"
  },
  {
    "State": "PA",
    "City": "Springdale"
  },
  {
    "State": "PA",
    "City": "Turtle Creek"
  },
  {
    "State": "PA",
    "City": "Monroeville"
  },
  {
    "State": "PA",
    "City": "Verona"
  },
  {
    "State": "PA",
    "City": "Wilmerding"
  },
  {
    "State": "PA",
    "City": "Pittsburgh"
  },
  {
    "State": "PA",
    "City": "Washington"
  },
  {
    "State": "PA",
    "City": "Aleppo"
  },
  {
    "State": "PA",
    "City": "Amity"
  },
  {
    "State": "PA",
    "City": "Avella"
  },
  {
    "State": "PA",
    "City": "Beallsville"
  },
  {
    "State": "PA",
    "City": "Bentleyville"
  },
  {
    "State": "PA",
    "City": "Bobtown"
  },
  {
    "State": "PA",
    "City": "Brave"
  },
  {
    "State": "PA",
    "City": "Canonsburg"
  },
  {
    "State": "PA",
    "City": "Carmichaels"
  },
  {
    "State": "PA",
    "City": "Cecil"
  },
  {
    "State": "PA",
    "City": "Clarksville"
  },
  {
    "State": "PA",
    "City": "Claysville"
  },
  {
    "State": "PA",
    "City": "Cokeburg"
  },
  {
    "State": "PA",
    "City": "Crucible"
  },
  {
    "State": "PA",
    "City": "Dilliner"
  },
  {
    "State": "PA",
    "City": "Prosperity"
  },
  {
    "State": "PA",
    "City": "Eighty Four"
  },
  {
    "State": "PA",
    "City": "Ellsworth"
  },
  {
    "State": "PA",
    "City": "Finleyville"
  },
  {
    "State": "PA",
    "City": "Fredericktown"
  },
  {
    "State": "PA",
    "City": "Garards Fort"
  },
  {
    "State": "PA",
    "City": "Gastonville"
  },
  {
    "State": "PA",
    "City": "Graysville"
  },
  {
    "State": "PA",
    "City": "Greensboro"
  },
  {
    "State": "PA",
    "City": "Hendersonville"
  },
  {
    "State": "PA",
    "City": "Hickory"
  },
  {
    "State": "PA",
    "City": "Holbrook"
  },
  {
    "State": "PA",
    "City": "Houston"
  },
  {
    "State": "PA",
    "City": "Jefferson"
  },
  {
    "State": "PA",
    "City": "Marianna"
  },
  {
    "State": "PA",
    "City": "Mather"
  },
  {
    "State": "PA",
    "City": "Meadow Lands"
  },
  {
    "State": "PA",
    "City": "Millsboro"
  },
  {
    "State": "PA",
    "City": "Mount Morris"
  },
  {
    "State": "PA",
    "City": "Muse"
  },
  {
    "State": "PA",
    "City": "Nemacolin"
  },
  {
    "State": "PA",
    "City": "New Freeport"
  },
  {
    "State": "PA",
    "City": "Nineveh"
  },
  {
    "State": "PA",
    "City": "Rices Landing"
  },
  {
    "State": "PA",
    "City": "Richeyville"
  },
  {
    "State": "PA",
    "City": "Rogersville"
  },
  {
    "State": "PA",
    "City": "Scenery Hill"
  },
  {
    "State": "PA",
    "City": "Southview"
  },
  {
    "State": "PA",
    "City": "Spraggs"
  },
  {
    "State": "PA",
    "City": "Strabane"
  },
  {
    "State": "PA",
    "City": "Sycamore"
  },
  {
    "State": "PA",
    "City": "Taylorstown"
  },
  {
    "State": "PA",
    "City": "Van Voorhis"
  },
  {
    "State": "PA",
    "City": "Venetia"
  },
  {
    "State": "PA",
    "City": "Vestaburg"
  },
  {
    "State": "PA",
    "City": "Waynesburg"
  },
  {
    "State": "PA",
    "City": "West Alexander"
  },
  {
    "State": "PA",
    "City": "West Finley"
  },
  {
    "State": "PA",
    "City": "Westland"
  },
  {
    "State": "PA",
    "City": "West Middletown"
  },
  {
    "State": "PA",
    "City": "Wind Ridge"
  },
  {
    "State": "PA",
    "City": "Uniontown"
  },
  {
    "State": "PA",
    "City": "Adah"
  },
  {
    "State": "PA",
    "City": "Addison"
  },
  {
    "State": "PA",
    "City": "Allenport"
  },
  {
    "State": "PA",
    "City": "Allison"
  },
  {
    "State": "PA",
    "City": "Brier Hill"
  },
  {
    "State": "PA",
    "City": "Brownfield"
  },
  {
    "State": "PA",
    "City": "Brownsville"
  },
  {
    "State": "PA",
    "City": "California"
  },
  {
    "State": "PA",
    "City": "Cardale"
  },
  {
    "State": "PA",
    "City": "Chalk Hill"
  },
  {
    "State": "PA",
    "City": "Chestnut Ridge"
  },
  {
    "State": "PA",
    "City": "Coal Center"
  },
  {
    "State": "PA",
    "City": "Confluence"
  },
  {
    "State": "PA",
    "City": "Connellsville"
  },
  {
    "State": "PA",
    "City": "Daisytown"
  },
  {
    "State": "PA",
    "City": "Dawson"
  },
  {
    "State": "PA",
    "City": "Denbo"
  },
  {
    "State": "PA",
    "City": "Dickerson Run"
  },
  {
    "State": "PA",
    "City": "Dunbar"
  },
  {
    "State": "PA",
    "City": "Dunlevy"
  },
  {
    "State": "PA",
    "City": "East Millsboro"
  },
  {
    "State": "PA",
    "City": "Elco"
  },
  {
    "State": "PA",
    "City": "Fairbank"
  },
  {
    "State": "PA",
    "City": "Fairchance"
  },
  {
    "State": "PA",
    "City": "Farmington"
  },
  {
    "State": "PA",
    "City": "Fayette City"
  },
  {
    "State": "PA",
    "City": "Gans"
  },
  {
    "State": "PA",
    "City": "Gibbon Glade"
  },
  {
    "State": "PA",
    "City": "Grindstone"
  },
  {
    "State": "PA",
    "City": "Hibbs"
  },
  {
    "State": "PA",
    "City": "Hiller"
  },
  {
    "State": "PA",
    "City": "Hopwood"
  },
  {
    "State": "PA",
    "City": "Indian Head"
  },
  {
    "State": "PA",
    "City": "Isabella"
  },
  {
    "State": "PA",
    "City": "Jacobs Creek"
  },
  {
    "State": "PA",
    "City": "Keisterville"
  },
  {
    "State": "PA",
    "City": "La Belle"
  },
  {
    "State": "PA",
    "City": "Lake Lynn"
  },
  {
    "State": "PA",
    "City": "Leckrone"
  },
  {
    "State": "PA",
    "City": "Leisenring"
  },
  {
    "State": "PA",
    "City": "Lemont Furnace"
  },
  {
    "State": "PA",
    "City": "Mc Clellandtown"
  },
  {
    "State": "PA",
    "City": "Markleysburg"
  },
  {
    "State": "PA",
    "City": "Martin"
  },
  {
    "State": "PA",
    "City": "Masontown"
  },
  {
    "State": "PA",
    "City": "Melcroft"
  },
  {
    "State": "PA",
    "City": "Merrittstown"
  },
  {
    "State": "PA",
    "City": "Mill Run"
  },
  {
    "State": "PA",
    "City": "Mount Braddock"
  },
  {
    "State": "PA",
    "City": "Newell"
  },
  {
    "State": "PA",
    "City": "New Geneva"
  },
  {
    "State": "PA",
    "City": "New Salem"
  },
  {
    "State": "PA",
    "City": "Normalville"
  },
  {
    "State": "PA",
    "City": "Ohiopyle"
  },
  {
    "State": "PA",
    "City": "Oliver"
  },
  {
    "State": "PA",
    "City": "Perryopolis"
  },
  {
    "State": "PA",
    "City": "Point Marion"
  },
  {
    "State": "PA",
    "City": "Republic"
  },
  {
    "State": "PA",
    "City": "Ronco"
  },
  {
    "State": "PA",
    "City": "Roscoe"
  },
  {
    "State": "PA",
    "City": "Smithfield"
  },
  {
    "State": "PA",
    "City": "Smithton"
  },
  {
    "State": "PA",
    "City": "Smock"
  },
  {
    "State": "PA",
    "City": "Star Junction"
  },
  {
    "State": "PA",
    "City": "Stockdale"
  },
  {
    "State": "PA",
    "City": "Uledi"
  },
  {
    "State": "PA",
    "City": "Ursina"
  },
  {
    "State": "PA",
    "City": "Vanderbilt"
  },
  {
    "State": "PA",
    "City": "Waltersburg"
  },
  {
    "State": "PA",
    "City": "West Leisenring"
  },
  {
    "State": "PA",
    "City": "White"
  },
  {
    "State": "PA",
    "City": "Wickhaven"
  },
  {
    "State": "PA",
    "City": "Somerset"
  },
  {
    "State": "PA",
    "City": "Hidden Valley"
  },
  {
    "State": "PA",
    "City": "Acosta"
  },
  {
    "State": "PA",
    "City": "Alum Bank"
  },
  {
    "State": "PA",
    "City": "Bedford"
  },
  {
    "State": "PA",
    "City": "Berlin"
  },
  {
    "State": "PA",
    "City": "Boswell"
  },
  {
    "State": "PA",
    "City": "Boynton"
  },
  {
    "State": "PA",
    "City": "Breezewood"
  },
  {
    "State": "PA",
    "City": "Buffalo Mills"
  },
  {
    "State": "PA",
    "City": "Clearville"
  },
  {
    "State": "PA",
    "City": "Crystal Spring"
  },
  {
    "State": "PA",
    "City": "Everett"
  },
  {
    "State": "PA",
    "City": "Fairhope"
  },
  {
    "State": "PA",
    "City": "Fishertown"
  },
  {
    "State": "PA",
    "City": "Fort Hill"
  },
  {
    "State": "PA",
    "City": "Friedens"
  },
  {
    "State": "PA",
    "City": "Garrett"
  },
  {
    "State": "PA",
    "City": "Gray"
  },
  {
    "State": "PA",
    "City": "Hyndman"
  },
  {
    "State": "PA",
    "City": "Jenners"
  },
  {
    "State": "PA",
    "City": "Jennerstown"
  },
  {
    "State": "PA",
    "City": "Kantner"
  },
  {
    "State": "PA",
    "City": "Listie"
  },
  {
    "State": "PA",
    "City": "Manns Choice"
  },
  {
    "State": "PA",
    "City": "Markleton"
  },
  {
    "State": "PA",
    "City": "Meyersdale"
  },
  {
    "State": "PA",
    "City": "New Baltimore"
  },
  {
    "State": "PA",
    "City": "New Paris"
  },
  {
    "State": "PA",
    "City": "Quecreek"
  },
  {
    "State": "PA",
    "City": "Rockwood"
  },
  {
    "State": "PA",
    "City": "Salisbury"
  },
  {
    "State": "PA",
    "City": "Schellsburg"
  },
  {
    "State": "PA",
    "City": "Shanksville"
  },
  {
    "State": "PA",
    "City": "Sipesville"
  },
  {
    "State": "PA",
    "City": "Springs"
  },
  {
    "State": "PA",
    "City": "Stoystown"
  },
  {
    "State": "PA",
    "City": "Wellersburg"
  },
  {
    "State": "PA",
    "City": "West Salisbury"
  },
  {
    "State": "PA",
    "City": "Greensburg"
  },
  {
    "State": "PA",
    "City": "Acme"
  },
  {
    "State": "PA",
    "City": "Adamsburg"
  },
  {
    "State": "PA",
    "City": "Alverton"
  },
  {
    "State": "PA",
    "City": "Apollo"
  },
  {
    "State": "PA",
    "City": "Ardara"
  },
  {
    "State": "PA",
    "City": "Armbrust"
  },
  {
    "State": "PA",
    "City": "Arona"
  },
  {
    "State": "PA",
    "City": "Avonmore"
  },
  {
    "State": "PA",
    "City": "Bovard"
  },
  {
    "State": "PA",
    "City": "Bradenville"
  },
  {
    "State": "PA",
    "City": "Calumet"
  },
  {
    "State": "PA",
    "City": "Champion"
  },
  {
    "State": "PA",
    "City": "Claridge"
  },
  {
    "State": "PA",
    "City": "Crabtree"
  },
  {
    "State": "PA",
    "City": "Darragh"
  },
  {
    "State": "PA",
    "City": "Delmont"
  },
  {
    "State": "PA",
    "City": "Derry"
  },
  {
    "State": "PA",
    "City": "Donegal"
  },
  {
    "State": "PA",
    "City": "East Vandergrift"
  },
  {
    "State": "PA",
    "City": "Everson"
  },
  {
    "State": "PA",
    "City": "Export"
  },
  {
    "State": "PA",
    "City": "Forbes Road"
  },
  {
    "State": "PA",
    "City": "Grapeville"
  },
  {
    "State": "PA",
    "City": "Hannastown"
  },
  {
    "State": "PA",
    "City": "Harrison City"
  },
  {
    "State": "PA",
    "City": "Herminie"
  },
  {
    "State": "PA",
    "City": "Hostetter"
  },
  {
    "State": "PA",
    "City": "Hunker"
  },
  {
    "State": "PA",
    "City": "Hutchinson"
  },
  {
    "State": "PA",
    "City": "Hyde Park"
  },
  {
    "State": "PA",
    "City": "Irwin"
  },
  {
    "State": "PA",
    "City": "Jeannette"
  },
  {
    "State": "PA",
    "City": "Jones Mills"
  },
  {
    "State": "PA",
    "City": "Larimer"
  },
  {
    "State": "PA",
    "City": "Latrobe"
  },
  {
    "State": "PA",
    "City": "Laughlintown"
  },
  {
    "State": "PA",
    "City": "Leechburg"
  },
  {
    "State": "PA",
    "City": "Ligonier"
  },
  {
    "State": "PA",
    "City": "Lowber"
  },
  {
    "State": "PA",
    "City": "Loyalhanna"
  },
  {
    "State": "PA",
    "City": "Luxor"
  },
  {
    "State": "PA",
    "City": "Madison"
  },
  {
    "State": "PA",
    "City": "Mammoth"
  },
  {
    "State": "PA",
    "City": "Manor"
  },
  {
    "State": "PA",
    "City": "Mount Pleasant"
  },
  {
    "State": "PA",
    "City": "Murrysville"
  },
  {
    "State": "PA",
    "City": "New Alexandria"
  },
  {
    "State": "PA",
    "City": "New Derry"
  },
  {
    "State": "PA",
    "City": "New Stanton"
  },
  {
    "State": "PA",
    "City": "North Apollo"
  },
  {
    "State": "PA",
    "City": "Norvelt"
  },
  {
    "State": "PA",
    "City": "Penn"
  },
  {
    "State": "PA",
    "City": "Pleasant Unity"
  },
  {
    "State": "PA",
    "City": "Rector"
  },
  {
    "State": "PA",
    "City": "Rillton"
  },
  {
    "State": "PA",
    "City": "Ruffs Dale"
  },
  {
    "State": "PA",
    "City": "Salina"
  },
  {
    "State": "PA",
    "City": "Saltsburg"
  },
  {
    "State": "PA",
    "City": "Schenley"
  },
  {
    "State": "PA",
    "City": "Scottdale"
  },
  {
    "State": "PA",
    "City": "Slickville"
  },
  {
    "State": "PA",
    "City": "Southwest"
  },
  {
    "State": "PA",
    "City": "Spring Church"
  },
  {
    "State": "PA",
    "City": "Stahlstown"
  },
  {
    "State": "PA",
    "City": "Tarrs"
  },
  {
    "State": "PA",
    "City": "United"
  },
  {
    "State": "PA",
    "City": "Vandergrift"
  },
  {
    "State": "PA",
    "City": "Wendel"
  },
  {
    "State": "PA",
    "City": "Westmoreland City"
  },
  {
    "State": "PA",
    "City": "Whitney"
  },
  {
    "State": "PA",
    "City": "Wyano"
  },
  {
    "State": "PA",
    "City": "Youngstown"
  },
  {
    "State": "PA",
    "City": "Youngwood"
  },
  {
    "State": "PA",
    "City": "Yukon"
  },
  {
    "State": "PA",
    "City": "Indiana"
  },
  {
    "State": "PA",
    "City": "Alverda"
  },
  {
    "State": "PA",
    "City": "Anita"
  },
  {
    "State": "PA",
    "City": "Arcadia"
  },
  {
    "State": "PA",
    "City": "Aultman"
  },
  {
    "State": "PA",
    "City": "Northern Cambria"
  },
  {
    "State": "PA",
    "City": "Big Run"
  },
  {
    "State": "PA",
    "City": "Black Lick"
  },
  {
    "State": "PA",
    "City": "Blairsville"
  },
  {
    "State": "PA",
    "City": "Brush Valley"
  },
  {
    "State": "PA",
    "City": "Burnside"
  },
  {
    "State": "PA",
    "City": "Carrolltown"
  },
  {
    "State": "PA",
    "City": "Chambersville"
  },
  {
    "State": "PA",
    "City": "Cherry Tree"
  },
  {
    "State": "PA",
    "City": "Clarksburg"
  },
  {
    "State": "PA",
    "City": "Clune"
  },
  {
    "State": "PA",
    "City": "Clymer"
  },
  {
    "State": "PA",
    "City": "Commodore"
  },
  {
    "State": "PA",
    "City": "Coolspring"
  },
  {
    "State": "PA",
    "City": "Coral"
  },
  {
    "State": "PA",
    "City": "Creekside"
  },
  {
    "State": "PA",
    "City": "De Lancey"
  },
  {
    "State": "PA",
    "City": "Dixonville"
  },
  {
    "State": "PA",
    "City": "Elderton"
  },
  {
    "State": "PA",
    "City": "Elmora"
  },
  {
    "State": "PA",
    "City": "Emeigh"
  },
  {
    "State": "PA",
    "City": "Ernest"
  },
  {
    "State": "PA",
    "City": "Frostburg"
  },
  {
    "State": "PA",
    "City": "Gipsy"
  },
  {
    "State": "PA",
    "City": "Glen Campbell"
  },
  {
    "State": "PA",
    "City": "Hamilton"
  },
  {
    "State": "PA",
    "City": "Heilwood"
  },
  {
    "State": "PA",
    "City": "Hillsdale"
  },
  {
    "State": "PA",
    "City": "Home"
  },
  {
    "State": "PA",
    "City": "Homer City"
  },
  {
    "State": "PA",
    "City": "Josephine"
  },
  {
    "State": "PA",
    "City": "Kent"
  },
  {
    "State": "PA",
    "City": "La Jose"
  },
  {
    "State": "PA",
    "City": "Lucernemines"
  },
  {
    "State": "PA",
    "City": "Mc Intyre"
  },
  {
    "State": "PA",
    "City": "Mahaffey"
  },
  {
    "State": "PA",
    "City": "Marchand"
  },
  {
    "State": "PA",
    "City": "Marion Center"
  },
  {
    "State": "PA",
    "City": "Marsteller"
  },
  {
    "State": "PA",
    "City": "Mentcle"
  },
  {
    "State": "PA",
    "City": "Nicktown"
  },
  {
    "State": "PA",
    "City": "Northpoint"
  },
  {
    "State": "PA",
    "City": "Oliveburg"
  },
  {
    "State": "PA",
    "City": "Penn Run"
  },
  {
    "State": "PA",
    "City": "Punxsutawney"
  },
  {
    "State": "PA",
    "City": "Ringgold"
  },
  {
    "State": "PA",
    "City": "Rochester Mills"
  },
  {
    "State": "PA",
    "City": "Rossiter"
  },
  {
    "State": "PA",
    "City": "Saint Benedict"
  },
  {
    "State": "PA",
    "City": "Shelocta"
  },
  {
    "State": "PA",
    "City": "Spangler"
  },
  {
    "State": "PA",
    "City": "Sprankle Mills"
  },
  {
    "State": "PA",
    "City": "Starford"
  },
  {
    "State": "PA",
    "City": "Timblin"
  },
  {
    "State": "PA",
    "City": "Torrance"
  },
  {
    "State": "PA",
    "City": "Valier"
  },
  {
    "State": "PA",
    "City": "Walston"
  },
  {
    "State": "PA",
    "City": "West Lebanon"
  },
  {
    "State": "PA",
    "City": "Worthville"
  },
  {
    "State": "PA",
    "City": "Du Bois"
  },
  {
    "State": "PA",
    "City": "Benezett"
  },
  {
    "State": "PA",
    "City": "Brandy Camp"
  },
  {
    "State": "PA",
    "City": "Brockport"
  },
  {
    "State": "PA",
    "City": "Brockway"
  },
  {
    "State": "PA",
    "City": "Brookville"
  },
  {
    "State": "PA",
    "City": "Byrnedale"
  },
  {
    "State": "PA",
    "City": "Clarington"
  },
  {
    "State": "PA",
    "City": "Corsica"
  },
  {
    "State": "PA",
    "City": "Dagus Mines"
  },
  {
    "State": "PA",
    "City": "Driftwood"
  },
  {
    "State": "PA",
    "City": "Emporium"
  },
  {
    "State": "PA",
    "City": "Falls Creek"
  },
  {
    "State": "PA",
    "City": "Force"
  },
  {
    "State": "PA",
    "City": "Johnsonburg"
  },
  {
    "State": "PA",
    "City": "Kersey"
  },
  {
    "State": "PA",
    "City": "Knox Dale"
  },
  {
    "State": "PA",
    "City": "Luthersburg"
  },
  {
    "State": "PA",
    "City": "Penfield"
  },
  {
    "State": "PA",
    "City": "Reynoldsville"
  },
  {
    "State": "PA",
    "City": "Ridgway"
  },
  {
    "State": "PA",
    "City": "Rockton"
  },
  {
    "State": "PA",
    "City": "Saint Marys"
  },
  {
    "State": "PA",
    "City": "Sigel"
  },
  {
    "State": "PA",
    "City": "Sinnamahoning"
  },
  {
    "State": "PA",
    "City": "Stump Creek"
  },
  {
    "State": "PA",
    "City": "Summerville"
  },
  {
    "State": "PA",
    "City": "Sykesville"
  },
  {
    "State": "PA",
    "City": "Troutville"
  },
  {
    "State": "PA",
    "City": "Weedville"
  },
  {
    "State": "PA",
    "City": "Wilcox"
  },
  {
    "State": "PA",
    "City": "Johnstown"
  },
  {
    "State": "PA",
    "City": "Armagh"
  },
  {
    "State": "PA",
    "City": "Beaverdale"
  },
  {
    "State": "PA",
    "City": "Belsano"
  },
  {
    "State": "PA",
    "City": "Bolivar"
  },
  {
    "State": "PA",
    "City": "Cairnbrook"
  },
  {
    "State": "PA",
    "City": "Cassandra"
  },
  {
    "State": "PA",
    "City": "Central City"
  },
  {
    "State": "PA",
    "City": "Colver"
  },
  {
    "State": "PA",
    "City": "Davidsville"
  },
  {
    "State": "PA",
    "City": "Dilltown"
  },
  {
    "State": "PA",
    "City": "Dunlo"
  },
  {
    "State": "PA",
    "City": "Ebensburg"
  },
  {
    "State": "PA",
    "City": "Elton"
  },
  {
    "State": "PA",
    "City": "Hollsopple"
  },
  {
    "State": "PA",
    "City": "Hooversville"
  },
  {
    "State": "PA",
    "City": "Jerome"
  },
  {
    "State": "PA",
    "City": "Lilly"
  },
  {
    "State": "PA",
    "City": "Loretto"
  },
  {
    "State": "PA",
    "City": "Mineral Point"
  },
  {
    "State": "PA",
    "City": "Nanty Glo"
  },
  {
    "State": "PA",
    "City": "New Florence"
  },
  {
    "State": "PA",
    "City": "Parkhill"
  },
  {
    "State": "PA",
    "City": "Portage"
  },
  {
    "State": "PA",
    "City": "Revloc"
  },
  {
    "State": "PA",
    "City": "Robinson"
  },
  {
    "State": "PA",
    "City": "Saint Michael"
  },
  {
    "State": "PA",
    "City": "Salix"
  },
  {
    "State": "PA",
    "City": "Seanor"
  },
  {
    "State": "PA",
    "City": "Seward"
  },
  {
    "State": "PA",
    "City": "Sidman"
  },
  {
    "State": "PA",
    "City": "South Fork"
  },
  {
    "State": "PA",
    "City": "Strongstown"
  },
  {
    "State": "PA",
    "City": "Summerhill"
  },
  {
    "State": "PA",
    "City": "Tire Hill"
  },
  {
    "State": "PA",
    "City": "Twin Rocks"
  },
  {
    "State": "PA",
    "City": "Vintondale"
  },
  {
    "State": "PA",
    "City": "Wilmore"
  },
  {
    "State": "PA",
    "City": "Windber"
  },
  {
    "State": "PA",
    "City": "Butler"
  },
  {
    "State": "PA",
    "City": "Boyers"
  },
  {
    "State": "PA",
    "City": "Branchton"
  },
  {
    "State": "PA",
    "City": "Bruin"
  },
  {
    "State": "PA",
    "City": "Cabot"
  },
  {
    "State": "PA",
    "City": "Callery"
  },
  {
    "State": "PA",
    "City": "Chicora"
  },
  {
    "State": "PA",
    "City": "Connoquenessing"
  },
  {
    "State": "PA",
    "City": "East Brady"
  },
  {
    "State": "PA",
    "City": "East Butler"
  },
  {
    "State": "PA",
    "City": "Eau Claire"
  },
  {
    "State": "PA",
    "City": "Evans City"
  },
  {
    "State": "PA",
    "City": "Fenelton"
  },
  {
    "State": "PA",
    "City": "Forestville"
  },
  {
    "State": "PA",
    "City": "Foxburg"
  },
  {
    "State": "PA",
    "City": "Harmony"
  },
  {
    "State": "PA",
    "City": "Harrisville"
  },
  {
    "State": "PA",
    "City": "Herman"
  },
  {
    "State": "PA",
    "City": "Hilliards"
  },
  {
    "State": "PA",
    "City": "Karns City"
  },
  {
    "State": "PA",
    "City": "Lyndora"
  },
  {
    "State": "PA",
    "City": "Mars"
  },
  {
    "State": "PA",
    "City": "North Washington"
  },
  {
    "State": "PA",
    "City": "Parker"
  },
  {
    "State": "PA",
    "City": "Petrolia"
  },
  {
    "State": "PA",
    "City": "Portersville"
  },
  {
    "State": "PA",
    "City": "Prospect"
  },
  {
    "State": "PA",
    "City": "Renfrew"
  },
  {
    "State": "PA",
    "City": "Saint Petersburg"
  },
  {
    "State": "PA",
    "City": "Sarver"
  },
  {
    "State": "PA",
    "City": "Saxonburg"
  },
  {
    "State": "PA",
    "City": "Slippery Rock"
  },
  {
    "State": "PA",
    "City": "Turkey City"
  },
  {
    "State": "PA",
    "City": "Valencia"
  },
  {
    "State": "PA",
    "City": "West Sunbury"
  },
  {
    "State": "PA",
    "City": "Zelienople"
  },
  {
    "State": "PA",
    "City": "Cranberry Township"
  },
  {
    "State": "PA",
    "City": "New Castle"
  },
  {
    "State": "PA",
    "City": "Adamsville"
  },
  {
    "State": "PA",
    "City": "Atlantic"
  },
  {
    "State": "PA",
    "City": "Bessemer"
  },
  {
    "State": "PA",
    "City": "Clark"
  },
  {
    "State": "PA",
    "City": "Clarks Mills"
  },
  {
    "State": "PA",
    "City": "Darlington"
  },
  {
    "State": "PA",
    "City": "Edinburg"
  },
  {
    "State": "PA",
    "City": "Ellwood City"
  },
  {
    "State": "PA",
    "City": "Enon Valley"
  },
  {
    "State": "PA",
    "City": "Farrell"
  },
  {
    "State": "PA",
    "City": "Fombell"
  },
  {
    "State": "PA",
    "City": "Fredonia"
  },
  {
    "State": "PA",
    "City": "Greenville"
  },
  {
    "State": "PA",
    "City": "Grove City"
  },
  {
    "State": "PA",
    "City": "Hadley"
  },
  {
    "State": "PA",
    "City": "Hartstown"
  },
  {
    "State": "PA",
    "City": "Hillsville"
  },
  {
    "State": "PA",
    "City": "Jackson Center"
  },
  {
    "State": "PA",
    "City": "Jamestown"
  },
  {
    "State": "PA",
    "City": "Koppel"
  },
  {
    "State": "PA",
    "City": "Mercer"
  },
  {
    "State": "PA",
    "City": "New Bedford"
  },
  {
    "State": "PA",
    "City": "New Galilee"
  },
  {
    "State": "PA",
    "City": "New Wilmington"
  },
  {
    "State": "PA",
    "City": "Pulaski"
  },
  {
    "State": "PA",
    "City": "Sandy Lake"
  },
  {
    "State": "PA",
    "City": "Sharon"
  },
  {
    "State": "PA",
    "City": "Hermitage"
  },
  {
    "State": "PA",
    "City": "Sharpsville"
  },
  {
    "State": "PA",
    "City": "Sheakleyville"
  },
  {
    "State": "PA",
    "City": "Stoneboro"
  },
  {
    "State": "PA",
    "City": "Transfer"
  },
  {
    "State": "PA",
    "City": "Villa Maria"
  },
  {
    "State": "PA",
    "City": "Volant"
  },
  {
    "State": "PA",
    "City": "Wampum"
  },
  {
    "State": "PA",
    "City": "West Middlesex"
  },
  {
    "State": "PA",
    "City": "West Pittsburg"
  },
  {
    "State": "PA",
    "City": "Wheatland"
  },
  {
    "State": "PA",
    "City": "Kittanning"
  },
  {
    "State": "PA",
    "City": "Adrian"
  },
  {
    "State": "PA",
    "City": "Beyer"
  },
  {
    "State": "PA",
    "City": "Cadogan"
  },
  {
    "State": "PA",
    "City": "Callensburg"
  },
  {
    "State": "PA",
    "City": "Clarion"
  },
  {
    "State": "PA",
    "City": "Cooksburg"
  },
  {
    "State": "PA",
    "City": "Cowansville"
  },
  {
    "State": "PA",
    "City": "Crown"
  },
  {
    "State": "PA",
    "City": "Curllsville"
  },
  {
    "State": "PA",
    "City": "Dayton"
  },
  {
    "State": "PA",
    "City": "Distant"
  },
  {
    "State": "PA",
    "City": "Fairmount City"
  },
  {
    "State": "PA",
    "City": "Fisher"
  },
  {
    "State": "PA",
    "City": "Ford City"
  },
  {
    "State": "PA",
    "City": "Ford Cliff"
  },
  {
    "State": "PA",
    "City": "Freeport"
  },
  {
    "State": "PA",
    "City": "Hawthorn"
  },
  {
    "State": "PA",
    "City": "Knox"
  },
  {
    "State": "PA",
    "City": "Leeper"
  },
  {
    "State": "PA",
    "City": "Limestone"
  },
  {
    "State": "PA",
    "City": "Lucinda"
  },
  {
    "State": "PA",
    "City": "Mc Grann"
  },
  {
    "State": "PA",
    "City": "Manorville"
  },
  {
    "State": "PA",
    "City": "Marienville"
  },
  {
    "State": "PA",
    "City": "Mayport"
  },
  {
    "State": "PA",
    "City": "New Bethlehem"
  },
  {
    "State": "PA",
    "City": "Nu Mine"
  },
  {
    "State": "PA",
    "City": "Oak Ridge"
  },
  {
    "State": "PA",
    "City": "Plumville"
  },
  {
    "State": "PA",
    "City": "Rimersburg"
  },
  {
    "State": "PA",
    "City": "Rural Valley"
  },
  {
    "State": "PA",
    "City": "Sagamore"
  },
  {
    "State": "PA",
    "City": "Seminole"
  },
  {
    "State": "PA",
    "City": "Shippenville"
  },
  {
    "State": "PA",
    "City": "Sligo"
  },
  {
    "State": "PA",
    "City": "Smicksburg"
  },
  {
    "State": "PA",
    "City": "Snydersburg"
  },
  {
    "State": "PA",
    "City": "Strattanville"
  },
  {
    "State": "PA",
    "City": "Templeton"
  },
  {
    "State": "PA",
    "City": "Vowinckel"
  },
  {
    "State": "PA",
    "City": "Widnoon"
  },
  {
    "State": "PA",
    "City": "Worthington"
  },
  {
    "State": "PA",
    "City": "Yatesboro"
  },
  {
    "State": "PA",
    "City": "Oil City"
  },
  {
    "State": "PA",
    "City": "Carlton"
  },
  {
    "State": "PA",
    "City": "Chandlers Valley"
  },
  {
    "State": "PA",
    "City": "Clarendon"
  },
  {
    "State": "PA",
    "City": "Cochranton"
  },
  {
    "State": "PA",
    "City": "Conneaut Lake"
  },
  {
    "State": "PA",
    "City": "Cooperstown"
  },
  {
    "State": "PA",
    "City": "Cranberry"
  },
  {
    "State": "PA",
    "City": "East Hickory"
  },
  {
    "State": "PA",
    "City": "Endeavor"
  },
  {
    "State": "PA",
    "City": "Franklin"
  },
  {
    "State": "PA",
    "City": "Fryburg"
  },
  {
    "State": "PA",
    "City": "Guys Mills"
  },
  {
    "State": "PA",
    "City": "Hydetown"
  },
  {
    "State": "PA",
    "City": "Irvine"
  },
  {
    "State": "PA",
    "City": "Kossuth"
  },
  {
    "State": "PA",
    "City": "Lickingville"
  },
  {
    "State": "PA",
    "City": "Ludlow"
  },
  {
    "State": "PA",
    "City": "Marble"
  },
  {
    "State": "PA",
    "City": "Meadville"
  },
  {
    "State": "PA",
    "City": "Pittsfield"
  },
  {
    "State": "PA",
    "City": "Pleasantville"
  },
  {
    "State": "PA",
    "City": "Polk"
  },
  {
    "State": "PA",
    "City": "Reno"
  },
  {
    "State": "PA",
    "City": "Rouseville"
  },
  {
    "State": "PA",
    "City": "Russell"
  },
  {
    "State": "PA",
    "City": "Seneca"
  },
  {
    "State": "PA",
    "City": "Sheffield"
  },
  {
    "State": "PA",
    "City": "Sugar Grove"
  },
  {
    "State": "PA",
    "City": "Tidioute"
  },
  {
    "State": "PA",
    "City": "Tiona"
  },
  {
    "State": "PA",
    "City": "Tionesta"
  },
  {
    "State": "PA",
    "City": "Titusville"
  },
  {
    "State": "PA",
    "City": "Townville"
  },
  {
    "State": "PA",
    "City": "Tylersburg"
  },
  {
    "State": "PA",
    "City": "Utica"
  },
  {
    "State": "PA",
    "City": "Venus"
  },
  {
    "State": "PA",
    "City": "Warren"
  },
  {
    "State": "PA",
    "City": "West Hickory"
  },
  {
    "State": "PA",
    "City": "Youngsville"
  },
  {
    "State": "PA",
    "City": "Clintonville"
  },
  {
    "State": "PA",
    "City": "Emlenton"
  },
  {
    "State": "PA",
    "City": "Kennerdell"
  },
  {
    "State": "PA",
    "City": "Lamartine"
  },
  {
    "State": "PA",
    "City": "Albion"
  },
  {
    "State": "PA",
    "City": "Bear Lake"
  },
  {
    "State": "PA",
    "City": "Cambridge Springs"
  },
  {
    "State": "PA",
    "City": "Centerville"
  },
  {
    "State": "PA",
    "City": "Columbus"
  },
  {
    "State": "PA",
    "City": "Conneautville"
  },
  {
    "State": "PA",
    "City": "Corry"
  },
  {
    "State": "PA",
    "City": "Cranesville"
  },
  {
    "State": "PA",
    "City": "East Springfield"
  },
  {
    "State": "PA",
    "City": "Edinboro"
  },
  {
    "State": "PA",
    "City": "Elgin"
  },
  {
    "State": "PA",
    "City": "Fairview"
  },
  {
    "State": "PA",
    "City": "Garland"
  },
  {
    "State": "PA",
    "City": "Girard"
  },
  {
    "State": "PA",
    "City": "Grand Valley"
  },
  {
    "State": "PA",
    "City": "Harborcreek"
  },
  {
    "State": "PA",
    "City": "Harmonsburg"
  },
  {
    "State": "PA",
    "City": "Lake City"
  },
  {
    "State": "PA",
    "City": "Linesville"
  },
  {
    "State": "PA",
    "City": "Mc Kean"
  },
  {
    "State": "PA",
    "City": "Mill Village"
  },
  {
    "State": "PA",
    "City": "North East"
  },
  {
    "State": "PA",
    "City": "North Springfield"
  },
  {
    "State": "PA",
    "City": "Riceville"
  },
  {
    "State": "PA",
    "City": "Saegertown"
  },
  {
    "State": "PA",
    "City": "Spartansburg"
  },
  {
    "State": "PA",
    "City": "Springboro"
  },
  {
    "State": "PA",
    "City": "Spring Creek"
  },
  {
    "State": "PA",
    "City": "Union City"
  },
  {
    "State": "PA",
    "City": "Venango"
  },
  {
    "State": "PA",
    "City": "Waterford"
  },
  {
    "State": "PA",
    "City": "Wattsburg"
  },
  {
    "State": "PA",
    "City": "West Springfield"
  },
  {
    "State": "PA",
    "City": "Erie"
  },
  {
    "State": "PA",
    "City": "Altoona"
  },
  {
    "State": "PA",
    "City": "Alexandria"
  },
  {
    "State": "PA",
    "City": "Ashville"
  },
  {
    "State": "PA",
    "City": "Beccaria"
  },
  {
    "State": "PA",
    "City": "Bellwood"
  },
  {
    "State": "PA",
    "City": "Blandburg"
  },
  {
    "State": "PA",
    "City": "Brisbin"
  },
  {
    "State": "PA",
    "City": "Broad Top"
  },
  {
    "State": "PA",
    "City": "Calvin"
  },
  {
    "State": "PA",
    "City": "Cassville"
  },
  {
    "State": "PA",
    "City": "Chest Springs"
  },
  {
    "State": "PA",
    "City": "Claysburg"
  },
  {
    "State": "PA",
    "City": "Coalport"
  },
  {
    "State": "PA",
    "City": "Coupon"
  },
  {
    "State": "PA",
    "City": "Cresson"
  },
  {
    "State": "PA",
    "City": "Curryville"
  },
  {
    "State": "PA",
    "City": "Defiance"
  },
  {
    "State": "PA",
    "City": "Dudley"
  },
  {
    "State": "PA",
    "City": "Duncansville"
  },
  {
    "State": "PA",
    "City": "Dysart"
  },
  {
    "State": "PA",
    "City": "East Freedom"
  },
  {
    "State": "PA",
    "City": "Entriken"
  },
  {
    "State": "PA",
    "City": "Fallentimber"
  },
  {
    "State": "PA",
    "City": "Flinton"
  },
  {
    "State": "PA",
    "City": "Gallitzin"
  },
  {
    "State": "PA",
    "City": "Glasgow"
  },
  {
    "State": "PA",
    "City": "Glen Hope"
  },
  {
    "State": "PA",
    "City": "Hastings"
  },
  {
    "State": "PA",
    "City": "Hesston"
  },
  {
    "State": "PA",
    "City": "Hollidaysburg"
  },
  {
    "State": "PA",
    "City": "Hopewell"
  },
  {
    "State": "PA",
    "City": "Houtzdale"
  },
  {
    "State": "PA",
    "City": "Huntingdon"
  },
  {
    "State": "PA",
    "City": "Imler"
  },
  {
    "State": "PA",
    "City": "Irvona"
  },
  {
    "State": "PA",
    "City": "James Creek"
  },
  {
    "State": "PA",
    "City": "Loysburg"
  },
  {
    "State": "PA",
    "City": "Mc Connellstown"
  },
  {
    "State": "PA",
    "City": "Madera"
  },
  {
    "State": "PA",
    "City": "Martinsburg"
  },
  {
    "State": "PA",
    "City": "Morann"
  },
  {
    "State": "PA",
    "City": "New Enterprise"
  },
  {
    "State": "PA",
    "City": "Newry"
  },
  {
    "State": "PA",
    "City": "Osceola Mills"
  },
  {
    "State": "PA",
    "City": "Osterburg"
  },
  {
    "State": "PA",
    "City": "Patton"
  },
  {
    "State": "PA",
    "City": "Petersburg"
  },
  {
    "State": "PA",
    "City": "Queen"
  },
  {
    "State": "PA",
    "City": "Ramey"
  },
  {
    "State": "PA",
    "City": "Riddlesburg"
  },
  {
    "State": "PA",
    "City": "Roaring Spring"
  },
  {
    "State": "PA",
    "City": "Robertsdale"
  },
  {
    "State": "PA",
    "City": "Saint Boniface"
  },
  {
    "State": "PA",
    "City": "Sandy Ridge"
  },
  {
    "State": "PA",
    "City": "Saxton"
  },
  {
    "State": "PA",
    "City": "Six Mile Run"
  },
  {
    "State": "PA",
    "City": "Smithmill"
  },
  {
    "State": "PA",
    "City": "Smokerun"
  },
  {
    "State": "PA",
    "City": "Sproul"
  },
  {
    "State": "PA",
    "City": "Spruce Creek"
  },
  {
    "State": "PA",
    "City": "Tipton"
  },
  {
    "State": "PA",
    "City": "Todd"
  },
  {
    "State": "PA",
    "City": "Tyrone"
  },
  {
    "State": "PA",
    "City": "Waterfall"
  },
  {
    "State": "PA",
    "City": "Wells Tannery"
  },
  {
    "State": "PA",
    "City": "Westover"
  },
  {
    "State": "PA",
    "City": "Williamsburg"
  },
  {
    "State": "PA",
    "City": "Wood"
  },
  {
    "State": "PA",
    "City": "Woodbury"
  },
  {
    "State": "PA",
    "City": "Bradford"
  },
  {
    "State": "PA",
    "City": "Austin"
  },
  {
    "State": "PA",
    "City": "Crosby"
  },
  {
    "State": "PA",
    "City": "Custer City"
  },
  {
    "State": "PA",
    "City": "Cyclone"
  },
  {
    "State": "PA",
    "City": "Derrick City"
  },
  {
    "State": "PA",
    "City": "De Young"
  },
  {
    "State": "PA",
    "City": "Duke Center"
  },
  {
    "State": "PA",
    "City": "East Smethport"
  },
  {
    "State": "PA",
    "City": "Eldred"
  },
  {
    "State": "PA",
    "City": "Gifford"
  },
  {
    "State": "PA",
    "City": "Hazel Hurst"
  },
  {
    "State": "PA",
    "City": "James City"
  },
  {
    "State": "PA",
    "City": "Kane"
  },
  {
    "State": "PA",
    "City": "Lewis Run"
  },
  {
    "State": "PA",
    "City": "Mount Jewett"
  },
  {
    "State": "PA",
    "City": "Port Allegany"
  },
  {
    "State": "PA",
    "City": "Rew"
  },
  {
    "State": "PA",
    "City": "Rixford"
  },
  {
    "State": "PA",
    "City": "Roulette"
  },
  {
    "State": "PA",
    "City": "Shinglehouse"
  },
  {
    "State": "PA",
    "City": "Smethport"
  },
  {
    "State": "PA",
    "City": "Turtlepoint"
  },
  {
    "State": "PA",
    "City": "State College"
  },
  {
    "State": "PA",
    "City": "University Park"
  },
  {
    "State": "PA",
    "City": "Aaronsburg"
  },
  {
    "State": "PA",
    "City": "Allport"
  },
  {
    "State": "PA",
    "City": "Beech Creek"
  },
  {
    "State": "PA",
    "City": "Bellefonte"
  },
  {
    "State": "PA",
    "City": "Bigler"
  },
  {
    "State": "PA",
    "City": "Blanchard"
  },
  {
    "State": "PA",
    "City": "Boalsburg"
  },
  {
    "State": "PA",
    "City": "Centre Hall"
  },
  {
    "State": "PA",
    "City": "Clarence"
  },
  {
    "State": "PA",
    "City": "Clearfield"
  },
  {
    "State": "PA",
    "City": "Coburn"
  },
  {
    "State": "PA",
    "City": "Curwensville"
  },
  {
    "State": "PA",
    "City": "Drifting"
  },
  {
    "State": "PA",
    "City": "Fleming"
  },
  {
    "State": "PA",
    "City": "Frenchville"
  },
  {
    "State": "PA",
    "City": "Glen Richey"
  },
  {
    "State": "PA",
    "City": "Grampian"
  },
  {
    "State": "PA",
    "City": "Grassflat"
  },
  {
    "State": "PA",
    "City": "Hawk Run"
  },
  {
    "State": "PA",
    "City": "Howard"
  },
  {
    "State": "PA",
    "City": "Hyde"
  },
  {
    "State": "PA",
    "City": "Julian"
  },
  {
    "State": "PA",
    "City": "Karthaus"
  },
  {
    "State": "PA",
    "City": "Kylertown"
  },
  {
    "State": "PA",
    "City": "Lamar"
  },
  {
    "State": "PA",
    "City": "Lanse"
  },
  {
    "State": "PA",
    "City": "Lecontes Mills"
  },
  {
    "State": "PA",
    "City": "Lemont"
  },
  {
    "State": "PA",
    "City": "Madisonburg"
  },
  {
    "State": "PA",
    "City": "Milesburg"
  },
  {
    "State": "PA",
    "City": "Millheim"
  },
  {
    "State": "PA",
    "City": "Mineral Springs"
  },
  {
    "State": "PA",
    "City": "Mingoville"
  },
  {
    "State": "PA",
    "City": "Morrisdale"
  },
  {
    "State": "PA",
    "City": "Moshannon"
  },
  {
    "State": "PA",
    "City": "Munson"
  },
  {
    "State": "PA",
    "City": "New Millport"
  },
  {
    "State": "PA",
    "City": "Olanta"
  },
  {
    "State": "PA",
    "City": "Orviston"
  },
  {
    "State": "PA",
    "City": "Pennsylvania Furnace"
  },
  {
    "State": "PA",
    "City": "Philipsburg"
  },
  {
    "State": "PA",
    "City": "Pine Grove Mills"
  },
  {
    "State": "PA",
    "City": "Port Matilda"
  },
  {
    "State": "PA",
    "City": "Pottersdale"
  },
  {
    "State": "PA",
    "City": "Rebersburg"
  },
  {
    "State": "PA",
    "City": "Shawville"
  },
  {
    "State": "PA",
    "City": "Snow Shoe"
  },
  {
    "State": "PA",
    "City": "Spring Mills"
  },
  {
    "State": "PA",
    "City": "Wallaceton"
  },
  {
    "State": "PA",
    "City": "Warriors Mark"
  },
  {
    "State": "PA",
    "City": "West Decatur"
  },
  {
    "State": "PA",
    "City": "Winburne"
  },
  {
    "State": "PA",
    "City": "Woodland"
  },
  {
    "State": "PA",
    "City": "Woodward"
  },
  {
    "State": "PA",
    "City": "Wellsboro"
  },
  {
    "State": "PA",
    "City": "Alba"
  },
  {
    "State": "PA",
    "City": "Arnot"
  },
  {
    "State": "PA",
    "City": "Blossburg"
  },
  {
    "State": "PA",
    "City": "Columbia Cross Roads"
  },
  {
    "State": "PA",
    "City": "Coudersport"
  },
  {
    "State": "PA",
    "City": "Covington"
  },
  {
    "State": "PA",
    "City": "Cowanesque"
  },
  {
    "State": "PA",
    "City": "Elkland"
  },
  {
    "State": "PA",
    "City": "Gaines"
  },
  {
    "State": "PA",
    "City": "Galeton"
  },
  {
    "State": "PA",
    "City": "Genesee"
  },
  {
    "State": "PA",
    "City": "Gillett"
  },
  {
    "State": "PA",
    "City": "Granville Summit"
  },
  {
    "State": "PA",
    "City": "Harrison Valley"
  },
  {
    "State": "PA",
    "City": "Knoxville"
  },
  {
    "State": "PA",
    "City": "Lawrenceville"
  },
  {
    "State": "PA",
    "City": "Liberty"
  },
  {
    "State": "PA",
    "City": "Mainesburg"
  },
  {
    "State": "PA",
    "City": "Mansfield"
  },
  {
    "State": "PA",
    "City": "Middlebury Center"
  },
  {
    "State": "PA",
    "City": "Millerton"
  },
  {
    "State": "PA",
    "City": "Mills"
  },
  {
    "State": "PA",
    "City": "Morris"
  },
  {
    "State": "PA",
    "City": "Morris Run"
  },
  {
    "State": "PA",
    "City": "Nelson"
  },
  {
    "State": "PA",
    "City": "Osceola"
  },
  {
    "State": "PA",
    "City": "Sabinsville"
  },
  {
    "State": "PA",
    "City": "Sylvania"
  },
  {
    "State": "PA",
    "City": "Tioga"
  },
  {
    "State": "PA",
    "City": "Troy"
  },
  {
    "State": "PA",
    "City": "Ulysses"
  },
  {
    "State": "PA",
    "City": "Westfield"
  },
  {
    "State": "PA",
    "City": "Camp Hill"
  },
  {
    "State": "PA",
    "City": "Allensville"
  },
  {
    "State": "PA",
    "City": "Annville"
  },
  {
    "State": "PA",
    "City": "Belleville"
  },
  {
    "State": "PA",
    "City": "Berrysburg"
  },
  {
    "State": "PA",
    "City": "Blain"
  },
  {
    "State": "PA",
    "City": "Boiling Springs"
  },
  {
    "State": "PA",
    "City": "Bowmansdale"
  },
  {
    "State": "PA",
    "City": "Burnham"
  },
  {
    "State": "PA",
    "City": "Campbelltown"
  },
  {
    "State": "PA",
    "City": "Carlisle"
  },
  {
    "State": "PA",
    "City": "Cocolamus"
  },
  {
    "State": "PA",
    "City": "Cornwall"
  },
  {
    "State": "PA",
    "City": "Dalmatia"
  },
  {
    "State": "PA",
    "City": "Dauphin"
  },
  {
    "State": "PA",
    "City": "Dillsburg"
  },
  {
    "State": "PA",
    "City": "Duncannon"
  },
  {
    "State": "PA",
    "City": "East Waterford"
  },
  {
    "State": "PA",
    "City": "Elizabethtown"
  },
  {
    "State": "PA",
    "City": "Elizabethville"
  },
  {
    "State": "PA",
    "City": "Elliottsburg"
  },
  {
    "State": "PA",
    "City": "Enola"
  },
  {
    "State": "PA",
    "City": "Fredericksburg"
  },
  {
    "State": "PA",
    "City": "Grantham"
  },
  {
    "State": "PA",
    "City": "Grantville"
  },
  {
    "State": "PA",
    "City": "Granville"
  },
  {
    "State": "PA",
    "City": "Gratz"
  },
  {
    "State": "PA",
    "City": "Halifax"
  },
  {
    "State": "PA",
    "City": "Hershey"
  },
  {
    "State": "PA",
    "City": "Highspire"
  },
  {
    "State": "PA",
    "City": "Honey Grove"
  },
  {
    "State": "PA",
    "City": "Hummelstown"
  },
  {
    "State": "PA",
    "City": "Ickesburg"
  },
  {
    "State": "PA",
    "City": "Jonestown"
  },
  {
    "State": "PA",
    "City": "Kleinfeltersville"
  },
  {
    "State": "PA",
    "City": "Landisburg"
  },
  {
    "State": "PA",
    "City": "Lawn"
  },
  {
    "State": "PA",
    "City": "Lebanon"
  },
  {
    "State": "PA",
    "City": "Lemoyne"
  },
  {
    "State": "PA",
    "City": "Lewistown"
  },
  {
    "State": "PA",
    "City": "Liverpool"
  },
  {
    "State": "PA",
    "City": "Loysville"
  },
  {
    "State": "PA",
    "City": "Lykens"
  },
  {
    "State": "PA",
    "City": "Mc Alisterville"
  },
  {
    "State": "PA",
    "City": "Mechanicsburg"
  },
  {
    "State": "PA",
    "City": "Mc Veytown"
  },
  {
    "State": "PA",
    "City": "Mapleton Depot"
  },
  {
    "State": "PA",
    "City": "Marysville"
  },
  {
    "State": "PA",
    "City": "Mattawana"
  },
  {
    "State": "PA",
    "City": "Mexico"
  },
  {
    "State": "PA",
    "City": "Middletown"
  },
  {
    "State": "PA",
    "City": "Mifflin"
  },
  {
    "State": "PA",
    "City": "Mifflintown"
  },
  {
    "State": "PA",
    "City": "Mill Creek"
  },
  {
    "State": "PA",
    "City": "Millersburg"
  },
  {
    "State": "PA",
    "City": "Millerstown"
  },
  {
    "State": "PA",
    "City": "Milroy"
  },
  {
    "State": "PA",
    "City": "Mount Gretna"
  },
  {
    "State": "PA",
    "City": "Mount Holly Springs"
  },
  {
    "State": "PA",
    "City": "Mount Union"
  },
  {
    "State": "PA",
    "City": "Myerstown"
  },
  {
    "State": "PA",
    "City": "New Bloomfield"
  },
  {
    "State": "PA",
    "City": "New Buffalo"
  },
  {
    "State": "PA",
    "City": "New Cumberland"
  },
  {
    "State": "PA",
    "City": "New Germantown"
  },
  {
    "State": "PA",
    "City": "New Kingstown"
  },
  {
    "State": "PA",
    "City": "Newmanstown"
  },
  {
    "State": "PA",
    "City": "Newport"
  },
  {
    "State": "PA",
    "City": "Newton Hamilton"
  },
  {
    "State": "PA",
    "City": "Oakland Mills"
  },
  {
    "State": "PA",
    "City": "Ono"
  },
  {
    "State": "PA",
    "City": "Palmyra"
  },
  {
    "State": "PA",
    "City": "Pillow"
  },
  {
    "State": "PA",
    "City": "Plainfield"
  },
  {
    "State": "PA",
    "City": "Port Royal"
  },
  {
    "State": "PA",
    "City": "Quentin"
  },
  {
    "State": "PA",
    "City": "Reedsville"
  },
  {
    "State": "PA",
    "City": "Rexmont"
  },
  {
    "State": "PA",
    "City": "Richfield"
  },
  {
    "State": "PA",
    "City": "Richland"
  },
  {
    "State": "PA",
    "City": "Schaefferstown"
  },
  {
    "State": "PA",
    "City": "Shermans Dale"
  },
  {
    "State": "PA",
    "City": "Summerdale"
  },
  {
    "State": "PA",
    "City": "Thompsontown"
  },
  {
    "State": "PA",
    "City": "Wiconisco"
  },
  {
    "State": "PA",
    "City": "Williamstown"
  },
  {
    "State": "PA",
    "City": "Yeagertown"
  },
  {
    "State": "PA",
    "City": "Harrisburg"
  },
  {
    "State": "PA",
    "City": "Chambersburg"
  },
  {
    "State": "PA",
    "City": "Amberson"
  },
  {
    "State": "PA",
    "City": "Artemas"
  },
  {
    "State": "PA",
    "City": "Big Cove Tannery"
  },
  {
    "State": "PA",
    "City": "Blairs Mills"
  },
  {
    "State": "PA",
    "City": "Blue Ridge Summit"
  },
  {
    "State": "PA",
    "City": "Burnt Cabins"
  },
  {
    "State": "PA",
    "City": "Concord"
  },
  {
    "State": "PA",
    "City": "Doylesburg"
  },
  {
    "State": "PA",
    "City": "Dry Run"
  },
  {
    "State": "PA",
    "City": "Fannettsburg"
  },
  {
    "State": "PA",
    "City": "Fayetteville"
  },
  {
    "State": "PA",
    "City": "Fort Littleton"
  },
  {
    "State": "PA",
    "City": "Fort Loudon"
  },
  {
    "State": "PA",
    "City": "Greencastle"
  },
  {
    "State": "PA",
    "City": "Harrisonville"
  },
  {
    "State": "PA",
    "City": "Hustontown"
  },
  {
    "State": "PA",
    "City": "Lemasters"
  },
  {
    "State": "PA",
    "City": "Lurgan"
  },
  {
    "State": "PA",
    "City": "Mc Connellsburg"
  },
  {
    "State": "PA",
    "City": "Marion"
  },
  {
    "State": "PA",
    "City": "Mercersburg"
  },
  {
    "State": "PA",
    "City": "Mont Alto"
  },
  {
    "State": "PA",
    "City": "Needmore"
  },
  {
    "State": "PA",
    "City": "Neelyton"
  },
  {
    "State": "PA",
    "City": "Newburg"
  },
  {
    "State": "PA",
    "City": "Newville"
  },
  {
    "State": "PA",
    "City": "Orbisonia"
  },
  {
    "State": "PA",
    "City": "Orrstown"
  },
  {
    "State": "PA",
    "City": "Pleasant Hall"
  },
  {
    "State": "PA",
    "City": "Quincy"
  },
  {
    "State": "PA",
    "City": "Rockhill Furnace"
  },
  {
    "State": "PA",
    "City": "Rouzerville"
  },
  {
    "State": "PA",
    "City": "Roxbury"
  },
  {
    "State": "PA",
    "City": "Saint Thomas"
  },
  {
    "State": "PA",
    "City": "Saltillo"
  },
  {
    "State": "PA",
    "City": "Scotland"
  },
  {
    "State": "PA",
    "City": "Shade Gap"
  },
  {
    "State": "PA",
    "City": "Shady Grove"
  },
  {
    "State": "PA",
    "City": "Shippensburg"
  },
  {
    "State": "PA",
    "City": "Shirleysburg"
  },
  {
    "State": "PA",
    "City": "South Mountain"
  },
  {
    "State": "PA",
    "City": "Spring Run"
  },
  {
    "State": "PA",
    "City": "State Line"
  },
  {
    "State": "PA",
    "City": "Three Springs"
  },
  {
    "State": "PA",
    "City": "Upperstrasburg"
  },
  {
    "State": "PA",
    "City": "Walnut Bottom"
  },
  {
    "State": "PA",
    "City": "Warfordsburg"
  },
  {
    "State": "PA",
    "City": "Waynesboro"
  },
  {
    "State": "PA",
    "City": "Williamson"
  },
  {
    "State": "PA",
    "City": "Willow Hill"
  },
  {
    "State": "PA",
    "City": "Zullinger"
  },
  {
    "State": "PA",
    "City": "Abbottstown"
  },
  {
    "State": "PA",
    "City": "Airville"
  },
  {
    "State": "PA",
    "City": "Arendtsville"
  },
  {
    "State": "PA",
    "City": "Aspers"
  },
  {
    "State": "PA",
    "City": "Bendersville"
  },
  {
    "State": "PA",
    "City": "Biglerville"
  },
  {
    "State": "PA",
    "City": "Brogue"
  },
  {
    "State": "PA",
    "City": "Cashtown"
  },
  {
    "State": "PA",
    "City": "Codorus"
  },
  {
    "State": "PA",
    "City": "Craley"
  },
  {
    "State": "PA",
    "City": "Dallastown"
  },
  {
    "State": "PA",
    "City": "Delta"
  },
  {
    "State": "PA",
    "City": "Dover"
  },
  {
    "State": "PA",
    "City": "East Berlin"
  },
  {
    "State": "PA",
    "City": "East Prospect"
  },
  {
    "State": "PA",
    "City": "Emigsville"
  },
  {
    "State": "PA",
    "City": "Etters"
  },
  {
    "State": "PA",
    "City": "Fairfield"
  },
  {
    "State": "PA",
    "City": "Fawn Grove"
  },
  {
    "State": "PA",
    "City": "Felton"
  },
  {
    "State": "PA",
    "City": "Franklintown"
  },
  {
    "State": "PA",
    "City": "Gardners"
  },
  {
    "State": "PA",
    "City": "Gettysburg"
  },
  {
    "State": "PA",
    "City": "Glen Rock"
  },
  {
    "State": "PA",
    "City": "Glenville"
  },
  {
    "State": "PA",
    "City": "Hanover"
  },
  {
    "State": "PA",
    "City": "Idaville"
  },
  {
    "State": "PA",
    "City": "Lewisberry"
  },
  {
    "State": "PA",
    "City": "Littlestown"
  },
  {
    "State": "PA",
    "City": "Loganville"
  },
  {
    "State": "PA",
    "City": "Mc Knightstown"
  },
  {
    "State": "PA",
    "City": "Mc Sherrystown"
  },
  {
    "State": "PA",
    "City": "Manchester"
  },
  {
    "State": "PA",
    "City": "Mount Wolf"
  },
  {
    "State": "PA",
    "City": "New Freedom"
  },
  {
    "State": "PA",
    "City": "New Oxford"
  },
  {
    "State": "PA",
    "City": "New Park"
  },
  {
    "State": "PA",
    "City": "Orrtanna"
  },
  {
    "State": "PA",
    "City": "Porters Sideling"
  },
  {
    "State": "PA",
    "City": "Railroad"
  },
  {
    "State": "PA",
    "City": "Red Lion"
  },
  {
    "State": "PA",
    "City": "Rossville"
  },
  {
    "State": "PA",
    "City": "Seven Valleys"
  },
  {
    "State": "PA",
    "City": "Shrewsbury"
  },
  {
    "State": "PA",
    "City": "Spring Grove"
  },
  {
    "State": "PA",
    "City": "Stewartstown"
  },
  {
    "State": "PA",
    "City": "Thomasville"
  },
  {
    "State": "PA",
    "City": "Wellsville"
  },
  {
    "State": "PA",
    "City": "Windsor"
  },
  {
    "State": "PA",
    "City": "Wrightsville"
  },
  {
    "State": "PA",
    "City": "York Haven"
  },
  {
    "State": "PA",
    "City": "York New Salem"
  },
  {
    "State": "PA",
    "City": "York Springs"
  },
  {
    "State": "PA",
    "City": "Peach Glen"
  },
  {
    "State": "PA",
    "City": "York"
  },
  {
    "State": "PA",
    "City": "Akron"
  },
  {
    "State": "PA",
    "City": "Bainbridge"
  },
  {
    "State": "PA",
    "City": "Bart"
  },
  {
    "State": "PA",
    "City": "Bausman"
  },
  {
    "State": "PA",
    "City": "Bird In Hand"
  },
  {
    "State": "PA",
    "City": "Blue Ball"
  },
  {
    "State": "PA",
    "City": "Bowmansville"
  },
  {
    "State": "PA",
    "City": "Brownstown"
  },
  {
    "State": "PA",
    "City": "Christiana"
  },
  {
    "State": "PA",
    "City": "Columbia"
  },
  {
    "State": "PA",
    "City": "Conestoga"
  },
  {
    "State": "PA",
    "City": "Denver"
  },
  {
    "State": "PA",
    "City": "Drumore"
  },
  {
    "State": "PA",
    "City": "East Earl"
  },
  {
    "State": "PA",
    "City": "East Petersburg"
  },
  {
    "State": "PA",
    "City": "Elm"
  },
  {
    "State": "PA",
    "City": "Ephrata"
  },
  {
    "State": "PA",
    "City": "Gap"
  },
  {
    "State": "PA",
    "City": "Goodville"
  },
  {
    "State": "PA",
    "City": "Gordonville"
  },
  {
    "State": "PA",
    "City": "Holtwood"
  },
  {
    "State": "PA",
    "City": "Hopeland"
  },
  {
    "State": "PA",
    "City": "Intercourse"
  },
  {
    "State": "PA",
    "City": "Kinzers"
  },
  {
    "State": "PA",
    "City": "Kirkwood"
  },
  {
    "State": "PA",
    "City": "Lampeter"
  },
  {
    "State": "PA",
    "City": "Landisville"
  },
  {
    "State": "PA",
    "City": "Leola"
  },
  {
    "State": "PA",
    "City": "Lititz"
  },
  {
    "State": "PA",
    "City": "Manheim"
  },
  {
    "State": "PA",
    "City": "Marietta"
  },
  {
    "State": "PA",
    "City": "Martindale"
  },
  {
    "State": "PA",
    "City": "Maytown"
  },
  {
    "State": "PA",
    "City": "Millersville"
  },
  {
    "State": "PA",
    "City": "Mount Joy"
  },
  {
    "State": "PA",
    "City": "Mountville"
  },
  {
    "State": "PA",
    "City": "Narvon"
  },
  {
    "State": "PA",
    "City": "New Holland"
  },
  {
    "State": "PA",
    "City": "New Providence"
  },
  {
    "State": "PA",
    "City": "Paradise"
  },
  {
    "State": "PA",
    "City": "Peach Bottom"
  },
  {
    "State": "PA",
    "City": "Penryn"
  },
  {
    "State": "PA",
    "City": "Pequea"
  },
  {
    "State": "PA",
    "City": "Quarryville"
  },
  {
    "State": "PA",
    "City": "Reamstown"
  },
  {
    "State": "PA",
    "City": "Refton"
  },
  {
    "State": "PA",
    "City": "Reinholds"
  },
  {
    "State": "PA",
    "City": "Rheems"
  },
  {
    "State": "PA",
    "City": "Ronks"
  },
  {
    "State": "PA",
    "City": "Lancaster"
  },
  {
    "State": "PA",
    "City": "Silver Spring"
  },
  {
    "State": "PA",
    "City": "Smoketown"
  },
  {
    "State": "PA",
    "City": "Stevens"
  },
  {
    "State": "PA",
    "City": "Strasburg"
  },
  {
    "State": "PA",
    "City": "Talmage"
  },
  {
    "State": "PA",
    "City": "Terre Hill"
  },
  {
    "State": "PA",
    "City": "Washington Boro"
  },
  {
    "State": "PA",
    "City": "West Willow"
  },
  {
    "State": "PA",
    "City": "Willow Street"
  },
  {
    "State": "PA",
    "City": "Witmer"
  },
  {
    "State": "PA",
    "City": "Williamsport"
  },
  {
    "State": "PA",
    "City": "Antes Fort"
  },
  {
    "State": "PA",
    "City": "Avis"
  },
  {
    "State": "PA",
    "City": "Cammal"
  },
  {
    "State": "PA",
    "City": "Canton"
  },
  {
    "State": "PA",
    "City": "Castanea"
  },
  {
    "State": "PA",
    "City": "Cedar Run"
  },
  {
    "State": "PA",
    "City": "Cogan Station"
  },
  {
    "State": "PA",
    "City": "Cross Fork"
  },
  {
    "State": "PA",
    "City": "Dewart"
  },
  {
    "State": "PA",
    "City": "Eagles Mere"
  },
  {
    "State": "PA",
    "City": "Grover"
  },
  {
    "State": "PA",
    "City": "Hughesville"
  },
  {
    "State": "PA",
    "City": "North Bend"
  },
  {
    "State": "PA",
    "City": "Jersey Mills"
  },
  {
    "State": "PA",
    "City": "Jersey Shore"
  },
  {
    "State": "PA",
    "City": "Lairdsville"
  },
  {
    "State": "PA",
    "City": "Linden"
  },
  {
    "State": "PA",
    "City": "Lock Haven"
  },
  {
    "State": "PA",
    "City": "Loganton"
  },
  {
    "State": "PA",
    "City": "Mc Elhattan"
  },
  {
    "State": "PA",
    "City": "Mc Ewensville"
  },
  {
    "State": "PA",
    "City": "Mackeyville"
  },
  {
    "State": "PA",
    "City": "Mill Hall"
  },
  {
    "State": "PA",
    "City": "Montgomery"
  },
  {
    "State": "PA",
    "City": "Montoursville"
  },
  {
    "State": "PA",
    "City": "Muncy"
  },
  {
    "State": "PA",
    "City": "Muncy Valley"
  },
  {
    "State": "PA",
    "City": "Picture Rocks"
  },
  {
    "State": "PA",
    "City": "Ralston"
  },
  {
    "State": "PA",
    "City": "Renovo"
  },
  {
    "State": "PA",
    "City": "Roaring Branch"
  },
  {
    "State": "PA",
    "City": "Salona"
  },
  {
    "State": "PA",
    "City": "Shunk"
  },
  {
    "State": "PA",
    "City": "Slate Run"
  },
  {
    "State": "PA",
    "City": "Trout Run"
  },
  {
    "State": "PA",
    "City": "Turbotville"
  },
  {
    "State": "PA",
    "City": "Tylersville"
  },
  {
    "State": "PA",
    "City": "Unityville"
  },
  {
    "State": "PA",
    "City": "Waterville"
  },
  {
    "State": "PA",
    "City": "Watsontown"
  },
  {
    "State": "PA",
    "City": "Westport"
  },
  {
    "State": "PA",
    "City": "Woolrich"
  },
  {
    "State": "PA",
    "City": "Sunbury"
  },
  {
    "State": "PA",
    "City": "Allenwood"
  },
  {
    "State": "PA",
    "City": "Beaver Springs"
  },
  {
    "State": "PA",
    "City": "Beavertown"
  },
  {
    "State": "PA",
    "City": "Benton"
  },
  {
    "State": "PA",
    "City": "Bloomsburg"
  },
  {
    "State": "PA",
    "City": "Catawissa"
  },
  {
    "State": "PA",
    "City": "Danville"
  },
  {
    "State": "PA",
    "City": "Dornsife"
  },
  {
    "State": "PA",
    "City": "Elysburg"
  },
  {
    "State": "PA",
    "City": "Freeburg"
  },
  {
    "State": "PA",
    "City": "Hartleton"
  },
  {
    "State": "PA",
    "City": "Herndon"
  },
  {
    "State": "PA",
    "City": "Hummels Wharf"
  },
  {
    "State": "PA",
    "City": "Marion Heights"
  },
  {
    "State": "PA",
    "City": "Kreamer"
  },
  {
    "State": "PA",
    "City": "Kulpmont"
  },
  {
    "State": "PA",
    "City": "Laurelton"
  },
  {
    "State": "PA",
    "City": "Leck Kill"
  },
  {
    "State": "PA",
    "City": "Lewisburg"
  },
  {
    "State": "PA",
    "City": "Lightstreet"
  },
  {
    "State": "PA",
    "City": "Locust Gap"
  },
  {
    "State": "PA",
    "City": "Mc Clure"
  },
  {
    "State": "PA",
    "City": "Middleburg"
  },
  {
    "State": "PA",
    "City": "Mifflinburg"
  },
  {
    "State": "PA",
    "City": "Millmont"
  },
  {
    "State": "PA",
    "City": "Millville"
  },
  {
    "State": "PA",
    "City": "Milton"
  },
  {
    "State": "PA",
    "City": "Montandon"
  },
  {
    "State": "PA",
    "City": "Mount Carmel"
  },
  {
    "State": "PA",
    "City": "Mount Pleasant Mills"
  },
  {
    "State": "PA",
    "City": "New Berlin"
  },
  {
    "State": "PA",
    "City": "New Columbia"
  },
  {
    "State": "PA",
    "City": "Northumberland"
  },
  {
    "State": "PA",
    "City": "Numidia"
  },
  {
    "State": "PA",
    "City": "Orangeville"
  },
  {
    "State": "PA",
    "City": "Paxinos"
  },
  {
    "State": "PA",
    "City": "Paxtonville"
  },
  {
    "State": "PA",
    "City": "Penns Creek"
  },
  {
    "State": "PA",
    "City": "Port Trevorton"
  },
  {
    "State": "PA",
    "City": "Potts Grove"
  },
  {
    "State": "PA",
    "City": "Coal Township"
  },
  {
    "State": "PA",
    "City": "Rebuck"
  },
  {
    "State": "PA",
    "City": "Riverside"
  },
  {
    "State": "PA",
    "City": "Selinsgrove"
  },
  {
    "State": "PA",
    "City": "Shamokin"
  },
  {
    "State": "PA",
    "City": "Shamokin Dam"
  },
  {
    "State": "PA",
    "City": "Snydertown"
  },
  {
    "State": "PA",
    "City": "Stillwater"
  },
  {
    "State": "PA",
    "City": "Swengel"
  },
  {
    "State": "PA",
    "City": "Trevorton"
  },
  {
    "State": "PA",
    "City": "Troxelville"
  },
  {
    "State": "PA",
    "City": "Vicksburg"
  },
  {
    "State": "PA",
    "City": "Washingtonville"
  },
  {
    "State": "PA",
    "City": "Weikert"
  },
  {
    "State": "PA",
    "City": "West Milton"
  },
  {
    "State": "PA",
    "City": "White Deer"
  },
  {
    "State": "PA",
    "City": "Wilburton"
  },
  {
    "State": "PA",
    "City": "Winfield"
  },
  {
    "State": "PA",
    "City": "Pottsville"
  },
  {
    "State": "PA",
    "City": "Aristes"
  },
  {
    "State": "PA",
    "City": "Ashland"
  },
  {
    "State": "PA",
    "City": "Auburn"
  },
  {
    "State": "PA",
    "City": "Branchdale"
  },
  {
    "State": "PA",
    "City": "Brockton"
  },
  {
    "State": "PA",
    "City": "Cressona"
  },
  {
    "State": "PA",
    "City": "Cumbola"
  },
  {
    "State": "PA",
    "City": "Frackville"
  },
  {
    "State": "PA",
    "City": "Friedensburg"
  },
  {
    "State": "PA",
    "City": "Gilberton"
  },
  {
    "State": "PA",
    "City": "Girardville"
  },
  {
    "State": "PA",
    "City": "Gordon"
  },
  {
    "State": "PA",
    "City": "Hegins"
  },
  {
    "State": "PA",
    "City": "Klingerstown"
  },
  {
    "State": "PA",
    "City": "Landingville"
  },
  {
    "State": "PA",
    "City": "Lavelle"
  },
  {
    "State": "PA",
    "City": "Llewellyn"
  },
  {
    "State": "PA",
    "City": "Locustdale"
  },
  {
    "State": "PA",
    "City": "Lost Creek"
  },
  {
    "State": "PA",
    "City": "Mahanoy City"
  },
  {
    "State": "PA",
    "City": "Mahanoy Plane"
  },
  {
    "State": "PA",
    "City": "Mar Lin"
  },
  {
    "State": "PA",
    "City": "Mary D"
  },
  {
    "State": "PA",
    "City": "Middleport"
  },
  {
    "State": "PA",
    "City": "Minersville"
  },
  {
    "State": "PA",
    "City": "Muir"
  },
  {
    "State": "PA",
    "City": "New Philadelphia"
  },
  {
    "State": "PA",
    "City": "New Ringgold"
  },
  {
    "State": "PA",
    "City": "Orwigsburg"
  },
  {
    "State": "PA",
    "City": "Pine Grove"
  },
  {
    "State": "PA",
    "City": "Pitman"
  },
  {
    "State": "PA",
    "City": "Port Carbon"
  },
  {
    "State": "PA",
    "City": "Ravine"
  },
  {
    "State": "PA",
    "City": "Ringtown"
  },
  {
    "State": "PA",
    "City": "Sacramento"
  },
  {
    "State": "PA",
    "City": "Saint Clair"
  },
  {
    "State": "PA",
    "City": "Schuylkill Haven"
  },
  {
    "State": "PA",
    "City": "Seltzer"
  },
  {
    "State": "PA",
    "City": "Shenandoah"
  },
  {
    "State": "PA",
    "City": "Spring Glen"
  },
  {
    "State": "PA",
    "City": "Summit Station"
  },
  {
    "State": "PA",
    "City": "Tower City"
  },
  {
    "State": "PA",
    "City": "Tremont"
  },
  {
    "State": "PA",
    "City": "Tuscarora"
  },
  {
    "State": "PA",
    "City": "Valley View"
  },
  {
    "State": "PA",
    "City": "Zion Grove"
  },
  {
    "State": "PA",
    "City": "Lehigh Valley"
  },
  {
    "State": "PA",
    "City": "Ackermanville"
  },
  {
    "State": "PA",
    "City": "Alburtis"
  },
  {
    "State": "PA",
    "City": "Aquashicola"
  },
  {
    "State": "PA",
    "City": "Bangor"
  },
  {
    "State": "PA",
    "City": "Bath"
  },
  {
    "State": "PA",
    "City": "Bethlehem"
  },
  {
    "State": "PA",
    "City": "Bowmanstown"
  },
  {
    "State": "PA",
    "City": "Breinigsville"
  },
  {
    "State": "PA",
    "City": "Catasauqua"
  },
  {
    "State": "PA",
    "City": "Center Valley"
  },
  {
    "State": "PA",
    "City": "Cherryville"
  },
  {
    "State": "PA",
    "City": "Coopersburg"
  },
  {
    "State": "PA",
    "City": "Coplay"
  },
  {
    "State": "PA",
    "City": "Danielsville"
  },
  {
    "State": "PA",
    "City": "Durham"
  },
  {
    "State": "PA",
    "City": "Easton"
  },
  {
    "State": "PA",
    "City": "East Greenville"
  },
  {
    "State": "PA",
    "City": "East Texas"
  },
  {
    "State": "PA",
    "City": "Emmaus"
  },
  {
    "State": "PA",
    "City": "Flicksville"
  },
  {
    "State": "PA",
    "City": "Fogelsville"
  },
  {
    "State": "PA",
    "City": "Whitehall"
  },
  {
    "State": "PA",
    "City": "Germansville"
  },
  {
    "State": "PA",
    "City": "Green Lane"
  },
  {
    "State": "PA",
    "City": "Hellertown"
  },
  {
    "State": "PA",
    "City": "Hereford"
  },
  {
    "State": "PA",
    "City": "Kunkletown"
  },
  {
    "State": "PA",
    "City": "Laurys Station"
  },
  {
    "State": "PA",
    "City": "Limeport"
  },
  {
    "State": "PA",
    "City": "Macungie"
  },
  {
    "State": "PA",
    "City": "Martins Creek"
  },
  {
    "State": "PA",
    "City": "Nazareth"
  },
  {
    "State": "PA",
    "City": "Neffs"
  },
  {
    "State": "PA",
    "City": "New Tripoli"
  },
  {
    "State": "PA",
    "City": "Northampton"
  },
  {
    "State": "PA",
    "City": "Old Zionsville"
  },
  {
    "State": "PA",
    "City": "Orefield"
  },
  {
    "State": "PA",
    "City": "Palm"
  },
  {
    "State": "PA",
    "City": "Palmerton"
  },
  {
    "State": "PA",
    "City": "Pen Argyl"
  },
  {
    "State": "PA",
    "City": "Pennsburg"
  },
  {
    "State": "PA",
    "City": "Perkiomenville"
  },
  {
    "State": "PA",
    "City": "Red Hill"
  },
  {
    "State": "PA",
    "City": "Riegelsville"
  },
  {
    "State": "PA",
    "City": "Schnecksville"
  },
  {
    "State": "PA",
    "City": "Slatedale"
  },
  {
    "State": "PA",
    "City": "Slatington"
  },
  {
    "State": "PA",
    "City": "Springtown"
  },
  {
    "State": "PA",
    "City": "Stockertown"
  },
  {
    "State": "PA",
    "City": "Sumneytown"
  },
  {
    "State": "PA",
    "City": "Tatamy"
  },
  {
    "State": "PA",
    "City": "Treichlers"
  },
  {
    "State": "PA",
    "City": "Trexlertown"
  },
  {
    "State": "PA",
    "City": "Walnutport"
  },
  {
    "State": "PA",
    "City": "Wind Gap"
  },
  {
    "State": "PA",
    "City": "Zionsville"
  },
  {
    "State": "PA",
    "City": "Allentown"
  },
  {
    "State": "PA",
    "City": "Hazleton"
  },
  {
    "State": "PA",
    "City": "Albrightsville"
  },
  {
    "State": "PA",
    "City": "Andreas"
  },
  {
    "State": "PA",
    "City": "Ashfield"
  },
  {
    "State": "PA",
    "City": "Barnesville"
  },
  {
    "State": "PA",
    "City": "Beaver Meadows"
  },
  {
    "State": "PA",
    "City": "Coaldale"
  },
  {
    "State": "PA",
    "City": "Conyngham"
  },
  {
    "State": "PA",
    "City": "Delano"
  },
  {
    "State": "PA",
    "City": "Drifton"
  },
  {
    "State": "PA",
    "City": "Drums"
  },
  {
    "State": "PA",
    "City": "Ebervale"
  },
  {
    "State": "PA",
    "City": "Freeland"
  },
  {
    "State": "PA",
    "City": "Harleigh"
  },
  {
    "State": "PA",
    "City": "Jim Thorpe"
  },
  {
    "State": "PA",
    "City": "Junedale"
  },
  {
    "State": "PA",
    "City": "Kelayres"
  },
  {
    "State": "PA",
    "City": "Lansford"
  },
  {
    "State": "PA",
    "City": "Lattimer Mines"
  },
  {
    "State": "PA",
    "City": "Lehighton"
  },
  {
    "State": "PA",
    "City": "Mcadoo"
  },
  {
    "State": "PA",
    "City": "Milnesville"
  },
  {
    "State": "PA",
    "City": "Nesquehoning"
  },
  {
    "State": "PA",
    "City": "Nuremberg"
  },
  {
    "State": "PA",
    "City": "Oneida"
  },
  {
    "State": "PA",
    "City": "Parryville"
  },
  {
    "State": "PA",
    "City": "Quakake"
  },
  {
    "State": "PA",
    "City": "Rock Glen"
  },
  {
    "State": "PA",
    "City": "Saint Johns"
  },
  {
    "State": "PA",
    "City": "Sheppton"
  },
  {
    "State": "PA",
    "City": "Sugarloaf"
  },
  {
    "State": "PA",
    "City": "Summit Hill"
  },
  {
    "State": "PA",
    "City": "Sybertsville"
  },
  {
    "State": "PA",
    "City": "Tamaqua"
  },
  {
    "State": "PA",
    "City": "Tresckow"
  },
  {
    "State": "PA",
    "City": "Weatherly"
  },
  {
    "State": "PA",
    "City": "Weston"
  },
  {
    "State": "PA",
    "City": "East Stroudsburg"
  },
  {
    "State": "PA",
    "City": "Analomink"
  },
  {
    "State": "PA",
    "City": "Bartonsville"
  },
  {
    "State": "PA",
    "City": "Brodheadsville"
  },
  {
    "State": "PA",
    "City": "Buck Hill Falls"
  },
  {
    "State": "PA",
    "City": "Bushkill"
  },
  {
    "State": "PA",
    "City": "Canadensis"
  },
  {
    "State": "PA",
    "City": "Cresco"
  },
  {
    "State": "PA",
    "City": "Delaware Water Gap"
  },
  {
    "State": "PA",
    "City": "Dingmans Ferry"
  },
  {
    "State": "PA",
    "City": "Effort"
  },
  {
    "State": "PA",
    "City": "Gilbert"
  },
  {
    "State": "PA",
    "City": "Henryville"
  },
  {
    "State": "PA",
    "City": "Kresgeville"
  },
  {
    "State": "PA",
    "City": "Long Pond"
  },
  {
    "State": "PA",
    "City": "Marshalls Creek"
  },
  {
    "State": "PA",
    "City": "Matamoras"
  },
  {
    "State": "PA",
    "City": "Milford"
  },
  {
    "State": "PA",
    "City": "Millrift"
  },
  {
    "State": "PA",
    "City": "Minisink Hills"
  },
  {
    "State": "PA",
    "City": "Mountainhome"
  },
  {
    "State": "PA",
    "City": "Mount Bethel"
  },
  {
    "State": "PA",
    "City": "Mount Pocono"
  },
  {
    "State": "PA",
    "City": "Pocono Summit"
  },
  {
    "State": "PA",
    "City": "Pocono Lake"
  },
  {
    "State": "PA",
    "City": "Pocono Lake Preserve"
  },
  {
    "State": "PA",
    "City": "Pocono Manor"
  },
  {
    "State": "PA",
    "City": "Pocono Pines"
  },
  {
    "State": "PA",
    "City": "Portland"
  },
  {
    "State": "PA",
    "City": "Reeders"
  },
  {
    "State": "PA",
    "City": "Saylorsburg"
  },
  {
    "State": "PA",
    "City": "Sciota"
  },
  {
    "State": "PA",
    "City": "Scotrun"
  },
  {
    "State": "PA",
    "City": "Shawnee On Delaware"
  },
  {
    "State": "PA",
    "City": "Skytop"
  },
  {
    "State": "PA",
    "City": "Stroudsburg"
  },
  {
    "State": "PA",
    "City": "Swiftwater"
  },
  {
    "State": "PA",
    "City": "Tamiment"
  },
  {
    "State": "PA",
    "City": "Tannersville"
  },
  {
    "State": "PA",
    "City": "Unity House"
  },
  {
    "State": "PA",
    "City": "Archbald"
  },
  {
    "State": "PA",
    "City": "Beach Lake"
  },
  {
    "State": "PA",
    "City": "Carbondale"
  },
  {
    "State": "PA",
    "City": "Chinchilla"
  },
  {
    "State": "PA",
    "City": "Clarks Summit"
  },
  {
    "State": "PA",
    "City": "Clifford"
  },
  {
    "State": "PA",
    "City": "Dalton"
  },
  {
    "State": "PA",
    "City": "Damascus"
  },
  {
    "State": "PA",
    "City": "Elmhurst"
  },
  {
    "State": "PA",
    "City": "Equinunk"
  },
  {
    "State": "PA",
    "City": "Factoryville"
  },
  {
    "State": "PA",
    "City": "Fleetville"
  },
  {
    "State": "PA",
    "City": "Forest City"
  },
  {
    "State": "PA",
    "City": "Gouldsboro"
  },
  {
    "State": "PA",
    "City": "Greeley"
  },
  {
    "State": "PA",
    "City": "Greentown"
  },
  {
    "State": "PA",
    "City": "Hamlin"
  },
  {
    "State": "PA",
    "City": "Hawley"
  },
  {
    "State": "PA",
    "City": "Herrick Center"
  },
  {
    "State": "PA",
    "City": "Honesdale"
  },
  {
    "State": "PA",
    "City": "Jermyn"
  },
  {
    "State": "PA",
    "City": "Jessup"
  },
  {
    "State": "PA",
    "City": "Lackawaxen"
  },
  {
    "State": "PA",
    "City": "Lake Ariel"
  },
  {
    "State": "PA",
    "City": "Lake Como"
  },
  {
    "State": "PA",
    "City": "Lakeville"
  },
  {
    "State": "PA",
    "City": "Lakewood"
  },
  {
    "State": "PA",
    "City": "La Plume"
  },
  {
    "State": "PA",
    "City": "Lenoxville"
  },
  {
    "State": "PA",
    "City": "Milanville"
  },
  {
    "State": "PA",
    "City": "Moscow"
  },
  {
    "State": "PA",
    "City": "Newfoundland"
  },
  {
    "State": "PA",
    "City": "Nicholson"
  },
  {
    "State": "PA",
    "City": "Olyphant"
  },
  {
    "State": "PA",
    "City": "Orson"
  },
  {
    "State": "PA",
    "City": "Paupack"
  },
  {
    "State": "PA",
    "City": "Peckville"
  },
  {
    "State": "PA",
    "City": "Pleasant Mount"
  },
  {
    "State": "PA",
    "City": "Poyntelle"
  },
  {
    "State": "PA",
    "City": "Preston Park"
  },
  {
    "State": "PA",
    "City": "Prompton"
  },
  {
    "State": "PA",
    "City": "Rowland"
  },
  {
    "State": "PA",
    "City": "Shohola"
  },
  {
    "State": "PA",
    "City": "South Canaan"
  },
  {
    "State": "PA",
    "City": "South Sterling"
  },
  {
    "State": "PA",
    "City": "Starlight"
  },
  {
    "State": "PA",
    "City": "Starrucca"
  },
  {
    "State": "PA",
    "City": "Sterling"
  },
  {
    "State": "PA",
    "City": "Tafton"
  },
  {
    "State": "PA",
    "City": "Thompson"
  },
  {
    "State": "PA",
    "City": "Tobyhanna"
  },
  {
    "State": "PA",
    "City": "Tyler Hill"
  },
  {
    "State": "PA",
    "City": "Union Dale"
  },
  {
    "State": "PA",
    "City": "Waverly"
  },
  {
    "State": "PA",
    "City": "Waymart"
  },
  {
    "State": "PA",
    "City": "White Mills"
  },
  {
    "State": "PA",
    "City": "Scranton"
  },
  {
    "State": "PA",
    "City": "Moosic"
  },
  {
    "State": "PA",
    "City": "Taylor"
  },
  {
    "State": "PA",
    "City": "Old Forge"
  },
  {
    "State": "PA",
    "City": "Beach Haven"
  },
  {
    "State": "PA",
    "City": "Bear Creek"
  },
  {
    "State": "PA",
    "City": "Berwick"
  },
  {
    "State": "PA",
    "City": "Blakeslee"
  },
  {
    "State": "PA",
    "City": "Cambra"
  },
  {
    "State": "PA",
    "City": "Dallas"
  },
  {
    "State": "PA",
    "City": "Dushore"
  },
  {
    "State": "PA",
    "City": "Falls"
  },
  {
    "State": "PA",
    "City": "Forksville"
  },
  {
    "State": "PA",
    "City": "Glen Lyon"
  },
  {
    "State": "PA",
    "City": "Harveys Lake"
  },
  {
    "State": "PA",
    "City": "Hillsgrove"
  },
  {
    "State": "PA",
    "City": "Hunlock Creek"
  },
  {
    "State": "PA",
    "City": "Huntington Mills"
  },
  {
    "State": "PA",
    "City": "Laceyville"
  },
  {
    "State": "PA",
    "City": "Lake Harmony"
  },
  {
    "State": "PA",
    "City": "Lake Winola"
  },
  {
    "State": "PA",
    "City": "Laporte"
  },
  {
    "State": "PA",
    "City": "Lehman"
  },
  {
    "State": "PA",
    "City": "Lopez"
  },
  {
    "State": "PA",
    "City": "Mehoopany"
  },
  {
    "State": "PA",
    "City": "Meshoppen"
  },
  {
    "State": "PA",
    "City": "Mifflinville"
  },
  {
    "State": "PA",
    "City": "Mildred"
  },
  {
    "State": "PA",
    "City": "Nanticoke"
  },
  {
    "State": "PA",
    "City": "Nescopeck"
  },
  {
    "State": "PA",
    "City": "Noxen"
  },
  {
    "State": "PA",
    "City": "Pittston"
  },
  {
    "State": "PA",
    "City": "Duryea"
  },
  {
    "State": "PA",
    "City": "Wyoming"
  },
  {
    "State": "PA",
    "City": "Plymouth"
  },
  {
    "State": "PA",
    "City": "Ransom"
  },
  {
    "State": "PA",
    "City": "Shawanese"
  },
  {
    "State": "PA",
    "City": "Shickshinny"
  },
  {
    "State": "PA",
    "City": "Sweet Valley"
  },
  {
    "State": "PA",
    "City": "Tunkhannock"
  },
  {
    "State": "PA",
    "City": "Wapwallopen"
  },
  {
    "State": "PA",
    "City": "White Haven"
  },
  {
    "State": "PA",
    "City": "Wilkes Barre"
  },
  {
    "State": "PA",
    "City": "Kingston"
  },
  {
    "State": "PA",
    "City": "Mountain Top"
  },
  {
    "State": "PA",
    "City": "Shavertown"
  },
  {
    "State": "PA",
    "City": "Luzerne"
  },
  {
    "State": "PA",
    "City": "Montrose"
  },
  {
    "State": "PA",
    "City": "Athens"
  },
  {
    "State": "PA",
    "City": "Brackney"
  },
  {
    "State": "PA",
    "City": "Brooklyn"
  },
  {
    "State": "PA",
    "City": "Burlington"
  },
  {
    "State": "PA",
    "City": "Camptown"
  },
  {
    "State": "PA",
    "City": "Dimock"
  },
  {
    "State": "PA",
    "City": "East Smithfield"
  },
  {
    "State": "PA",
    "City": "Friendsville"
  },
  {
    "State": "PA",
    "City": "Gibson"
  },
  {
    "State": "PA",
    "City": "Great Bend"
  },
  {
    "State": "PA",
    "City": "Hallstead"
  },
  {
    "State": "PA",
    "City": "Harford"
  },
  {
    "State": "PA",
    "City": "Hop Bottom"
  },
  {
    "State": "PA",
    "City": "Jackson"
  },
  {
    "State": "PA",
    "City": "Kingsley"
  },
  {
    "State": "PA",
    "City": "Lanesboro"
  },
  {
    "State": "PA",
    "City": "Lawton"
  },
  {
    "State": "PA",
    "City": "Le Raysville"
  },
  {
    "State": "PA",
    "City": "Little Meadows"
  },
  {
    "State": "PA",
    "City": "Milan"
  },
  {
    "State": "PA",
    "City": "Monroeton"
  },
  {
    "State": "PA",
    "City": "New Albany"
  },
  {
    "State": "PA",
    "City": "New Milford"
  },
  {
    "State": "PA",
    "City": "Rome"
  },
  {
    "State": "PA",
    "City": "Sayre"
  },
  {
    "State": "PA",
    "City": "South Gibson"
  },
  {
    "State": "PA",
    "City": "South Montrose"
  },
  {
    "State": "PA",
    "City": "Springville"
  },
  {
    "State": "PA",
    "City": "Stevensville"
  },
  {
    "State": "PA",
    "City": "Sugar Run"
  },
  {
    "State": "PA",
    "City": "Susquehanna"
  },
  {
    "State": "PA",
    "City": "Towanda"
  },
  {
    "State": "PA",
    "City": "Ulster"
  },
  {
    "State": "PA",
    "City": "Warren Center"
  },
  {
    "State": "PA",
    "City": "Wyalusing"
  },
  {
    "State": "PA",
    "City": "Wysox"
  },
  {
    "State": "PA",
    "City": "Doylestown"
  },
  {
    "State": "PA",
    "City": "Bedminster"
  },
  {
    "State": "PA",
    "City": "Blooming Glen"
  },
  {
    "State": "PA",
    "City": "Buckingham"
  },
  {
    "State": "PA",
    "City": "Carversville"
  },
  {
    "State": "PA",
    "City": "Chalfont"
  },
  {
    "State": "PA",
    "City": "Colmar"
  },
  {
    "State": "PA",
    "City": "Danboro"
  },
  {
    "State": "PA",
    "City": "Dublin"
  },
  {
    "State": "PA",
    "City": "Earlington"
  },
  {
    "State": "PA",
    "City": "Erwinna"
  },
  {
    "State": "PA",
    "City": "Ferndale"
  },
  {
    "State": "PA",
    "City": "Forest Grove"
  },
  {
    "State": "PA",
    "City": "Fountainville"
  },
  {
    "State": "PA",
    "City": "Franconia"
  },
  {
    "State": "PA",
    "City": "Furlong"
  },
  {
    "State": "PA",
    "City": "Gardenville"
  },
  {
    "State": "PA",
    "City": "Hilltown"
  },
  {
    "State": "PA",
    "City": "Holicong"
  },
  {
    "State": "PA",
    "City": "Jamison"
  },
  {
    "State": "PA",
    "City": "Kintnersville"
  },
  {
    "State": "PA",
    "City": "Lahaska"
  },
  {
    "State": "PA",
    "City": "Line Lexington"
  },
  {
    "State": "PA",
    "City": "Lumberville"
  },
  {
    "State": "PA",
    "City": "Mechanicsville"
  },
  {
    "State": "PA",
    "City": "Milford Square"
  },
  {
    "State": "PA",
    "City": "Montgomeryville"
  },
  {
    "State": "PA",
    "City": "New Hope"
  },
  {
    "State": "PA",
    "City": "Newtown"
  },
  {
    "State": "PA",
    "City": "Ottsville"
  },
  {
    "State": "PA",
    "City": "Penns Park"
  },
  {
    "State": "PA",
    "City": "Perkasie"
  },
  {
    "State": "PA",
    "City": "Pineville"
  },
  {
    "State": "PA",
    "City": "Pipersville"
  },
  {
    "State": "PA",
    "City": "Plumsteadville"
  },
  {
    "State": "PA",
    "City": "Point Pleasant"
  },
  {
    "State": "PA",
    "City": "Quakertown"
  },
  {
    "State": "PA",
    "City": "Revere"
  },
  {
    "State": "PA",
    "City": "Richboro"
  },
  {
    "State": "PA",
    "City": "Richlandtown"
  },
  {
    "State": "PA",
    "City": "Rushland"
  },
  {
    "State": "PA",
    "City": "Salford"
  },
  {
    "State": "PA",
    "City": "Salfordville"
  },
  {
    "State": "PA",
    "City": "Sellersville"
  },
  {
    "State": "PA",
    "City": "Silverdale"
  },
  {
    "State": "PA",
    "City": "Solebury"
  },
  {
    "State": "PA",
    "City": "Souderton"
  },
  {
    "State": "PA",
    "City": "Southampton"
  },
  {
    "State": "PA",
    "City": "Spinnerstown"
  },
  {
    "State": "PA",
    "City": "Telford"
  },
  {
    "State": "PA",
    "City": "Trumbauersville"
  },
  {
    "State": "PA",
    "City": "Tylersport"
  },
  {
    "State": "PA",
    "City": "Upper Black Eddy"
  },
  {
    "State": "PA",
    "City": "Warminster"
  },
  {
    "State": "PA",
    "City": "Warrington"
  },
  {
    "State": "PA",
    "City": "Washington Crossing"
  },
  {
    "State": "PA",
    "City": "Woxall"
  },
  {
    "State": "PA",
    "City": "Wycombe"
  },
  {
    "State": "PA",
    "City": "Zionhill"
  },
  {
    "State": "PA",
    "City": "Abington"
  },
  {
    "State": "PA",
    "City": "Ambler"
  },
  {
    "State": "PA",
    "City": "Ardmore"
  },
  {
    "State": "PA",
    "City": "Bala Cynwyd"
  },
  {
    "State": "PA",
    "City": "Huntingdon Valley"
  },
  {
    "State": "PA",
    "City": "Bristol"
  },
  {
    "State": "PA",
    "City": "Broomall"
  },
  {
    "State": "PA",
    "City": "Bryn Athyn"
  },
  {
    "State": "PA",
    "City": "Bryn Mawr"
  },
  {
    "State": "PA",
    "City": "Cheltenham"
  },
  {
    "State": "PA",
    "City": "Chester"
  },
  {
    "State": "PA",
    "City": "Aston"
  },
  {
    "State": "PA",
    "City": "Brookhaven"
  },
  {
    "State": "PA",
    "City": "Chester Heights"
  },
  {
    "State": "PA",
    "City": "Clifton Heights"
  },
  {
    "State": "PA",
    "City": "Philadelphia"
  },
  {
    "State": "PA",
    "City": "Bensalem"
  },
  {
    "State": "PA",
    "City": "Croydon"
  },
  {
    "State": "PA",
    "City": "Crum Lynne"
  },
  {
    "State": "PA",
    "City": "Darby"
  },
  {
    "State": "PA",
    "City": "Dresher"
  },
  {
    "State": "PA",
    "City": "Drexel Hill"
  },
  {
    "State": "PA",
    "City": "Elkins Park"
  },
  {
    "State": "PA",
    "City": "Edgemont"
  },
  {
    "State": "PA",
    "City": "Essington"
  },
  {
    "State": "PA",
    "City": "Fairless Hills"
  },
  {
    "State": "PA",
    "City": "Flourtown"
  },
  {
    "State": "PA",
    "City": "Folcroft"
  },
  {
    "State": "PA",
    "City": "Folsom"
  },
  {
    "State": "PA",
    "City": "Fort Washington"
  },
  {
    "State": "PA",
    "City": "Gladwyne"
  },
  {
    "State": "PA",
    "City": "Glenolden"
  },
  {
    "State": "PA",
    "City": "Glen Riddle Lima"
  },
  {
    "State": "PA",
    "City": "Glenside"
  },
  {
    "State": "PA",
    "City": "Gradyville"
  },
  {
    "State": "PA",
    "City": "Hatboro"
  },
  {
    "State": "PA",
    "City": "Haverford"
  },
  {
    "State": "PA",
    "City": "Holmes"
  },
  {
    "State": "PA",
    "City": "Horsham"
  },
  {
    "State": "PA",
    "City": "Jenkintown"
  },
  {
    "State": "PA",
    "City": "Langhorne"
  },
  {
    "State": "PA",
    "City": "Lansdowne"
  },
  {
    "State": "PA",
    "City": "Lenni"
  },
  {
    "State": "PA",
    "City": "Feasterville Trevose"
  },
  {
    "State": "PA",
    "City": "Levittown"
  },
  {
    "State": "PA",
    "City": "Garnet Valley"
  },
  {
    "State": "PA",
    "City": "Marcus Hook"
  },
  {
    "State": "PA",
    "City": "Media"
  },
  {
    "State": "PA",
    "City": "Springfield"
  },
  {
    "State": "PA",
    "City": "Merion Station"
  },
  {
    "State": "PA",
    "City": "Morrisville"
  },
  {
    "State": "PA",
    "City": "Morton"
  },
  {
    "State": "PA",
    "City": "Narberth"
  },
  {
    "State": "PA",
    "City": "Newtown Square"
  },
  {
    "State": "PA",
    "City": "Norwood"
  },
  {
    "State": "PA",
    "City": "Oreland"
  },
  {
    "State": "PA",
    "City": "Prospect Park"
  },
  {
    "State": "PA",
    "City": "Ridley Park"
  },
  {
    "State": "PA",
    "City": "Sharon Hill"
  },
  {
    "State": "PA",
    "City": "Wayne"
  },
  {
    "State": "PA",
    "City": "Swarthmore"
  },
  {
    "State": "PA",
    "City": "Upper Darby"
  },
  {
    "State": "PA",
    "City": "Havertown"
  },
  {
    "State": "PA",
    "City": "Villanova"
  },
  {
    "State": "PA",
    "City": "Wallingford"
  },
  {
    "State": "PA",
    "City": "Willow Grove"
  },
  {
    "State": "PA",
    "City": "Woodlyn"
  },
  {
    "State": "PA",
    "City": "Wyncote"
  },
  {
    "State": "PA",
    "City": "Wynnewood"
  },
  {
    "State": "PA",
    "City": "Paoli"
  },
  {
    "State": "PA",
    "City": "Atglen"
  },
  {
    "State": "PA",
    "City": "Avondale"
  },
  {
    "State": "PA",
    "City": "Berwyn"
  },
  {
    "State": "PA",
    "City": "Brandamore"
  },
  {
    "State": "PA",
    "City": "Chadds Ford"
  },
  {
    "State": "PA",
    "City": "Chatham"
  },
  {
    "State": "PA",
    "City": "Cheyney"
  },
  {
    "State": "PA",
    "City": "Coatesville"
  },
  {
    "State": "PA",
    "City": "Cochranville"
  },
  {
    "State": "PA",
    "City": "Concordville"
  },
  {
    "State": "PA",
    "City": "Devon"
  },
  {
    "State": "PA",
    "City": "Downingtown"
  },
  {
    "State": "PA",
    "City": "Exton"
  },
  {
    "State": "PA",
    "City": "Glen Mills"
  },
  {
    "State": "PA",
    "City": "Glenmoore"
  },
  {
    "State": "PA",
    "City": "Honey Brook"
  },
  {
    "State": "PA",
    "City": "Immaculata"
  },
  {
    "State": "PA",
    "City": "Kelton"
  },
  {
    "State": "PA",
    "City": "Kemblesville"
  },
  {
    "State": "PA",
    "City": "Kennett Square"
  },
  {
    "State": "PA",
    "City": "Landenberg"
  },
  {
    "State": "PA",
    "City": "Lewisville"
  },
  {
    "State": "PA",
    "City": "Lincoln University"
  },
  {
    "State": "PA",
    "City": "Lionville"
  },
  {
    "State": "PA",
    "City": "Lyndell"
  },
  {
    "State": "PA",
    "City": "Malvern"
  },
  {
    "State": "PA",
    "City": "Mendenhall"
  },
  {
    "State": "PA",
    "City": "Modena"
  },
  {
    "State": "PA",
    "City": "New London"
  },
  {
    "State": "PA",
    "City": "Nottingham"
  },
  {
    "State": "PA",
    "City": "Oxford"
  },
  {
    "State": "PA",
    "City": "Parkesburg"
  },
  {
    "State": "PA",
    "City": "Pocopson"
  },
  {
    "State": "PA",
    "City": "Pomeroy"
  },
  {
    "State": "PA",
    "City": "Sadsburyville"
  },
  {
    "State": "PA",
    "City": "Suplee"
  },
  {
    "State": "PA",
    "City": "Thorndale"
  },
  {
    "State": "PA",
    "City": "Thornton"
  },
  {
    "State": "PA",
    "City": "Toughkenamon"
  },
  {
    "State": "PA",
    "City": "Unionville"
  },
  {
    "State": "PA",
    "City": "Wagontown"
  },
  {
    "State": "PA",
    "City": "West Chester"
  },
  {
    "State": "PA",
    "City": "West Grove"
  },
  {
    "State": "PA",
    "City": "Westtown"
  },
  {
    "State": "PA",
    "City": "Southeastern"
  },
  {
    "State": "PA",
    "City": "Norristown"
  },
  {
    "State": "PA",
    "City": "Bridgeport"
  },
  {
    "State": "PA",
    "City": "King Of Prussia"
  },
  {
    "State": "PA",
    "City": "Audubon"
  },
  {
    "State": "PA",
    "City": "Eagleville"
  },
  {
    "State": "PA",
    "City": "Fairview Village"
  },
  {
    "State": "PA",
    "City": "Arcola"
  },
  {
    "State": "PA",
    "City": "Birchrunville"
  },
  {
    "State": "PA",
    "City": "Blue Bell"
  },
  {
    "State": "PA",
    "City": "Cedars"
  },
  {
    "State": "PA",
    "City": "Chester Springs"
  },
  {
    "State": "PA",
    "City": "Collegeville"
  },
  {
    "State": "PA",
    "City": "Conshohocken"
  },
  {
    "State": "PA",
    "City": "Creamery"
  },
  {
    "State": "PA",
    "City": "Devault"
  },
  {
    "State": "PA",
    "City": "Frederick"
  },
  {
    "State": "PA",
    "City": "Gwynedd"
  },
  {
    "State": "PA",
    "City": "Gwynedd Valley"
  },
  {
    "State": "PA",
    "City": "Harleysville"
  },
  {
    "State": "PA",
    "City": "Hatfield"
  },
  {
    "State": "PA",
    "City": "Kimberton"
  },
  {
    "State": "PA",
    "City": "Kulpsville"
  },
  {
    "State": "PA",
    "City": "Lafayette Hill"
  },
  {
    "State": "PA",
    "City": "Lansdale"
  },
  {
    "State": "PA",
    "City": "Lederach"
  },
  {
    "State": "PA",
    "City": "Mainland"
  },
  {
    "State": "PA",
    "City": "Mont Clare"
  },
  {
    "State": "PA",
    "City": "North Wales"
  },
  {
    "State": "PA",
    "City": "Oaks"
  },
  {
    "State": "PA",
    "City": "Parker Ford"
  },
  {
    "State": "PA",
    "City": "Phoenixville"
  },
  {
    "State": "PA",
    "City": "Plymouth Meeting"
  },
  {
    "State": "PA",
    "City": "Pottstown"
  },
  {
    "State": "PA",
    "City": "Royersford"
  },
  {
    "State": "PA",
    "City": "Saint Peters"
  },
  {
    "State": "PA",
    "City": "Sassamansville"
  },
  {
    "State": "PA",
    "City": "Schwenksville"
  },
  {
    "State": "PA",
    "City": "Skippack"
  },
  {
    "State": "PA",
    "City": "Spring City"
  },
  {
    "State": "PA",
    "City": "Spring House"
  },
  {
    "State": "PA",
    "City": "Spring Mount"
  },
  {
    "State": "PA",
    "City": "Uwchland"
  },
  {
    "State": "PA",
    "City": "Valley Forge"
  },
  {
    "State": "PA",
    "City": "West Point"
  },
  {
    "State": "PA",
    "City": "Worcester"
  },
  {
    "State": "PA",
    "City": "Zieglerville"
  },
  {
    "State": "PA",
    "City": "Adamstown"
  },
  {
    "State": "PA",
    "City": "Bally"
  },
  {
    "State": "PA",
    "City": "Barto"
  },
  {
    "State": "PA",
    "City": "Bechtelsville"
  },
  {
    "State": "PA",
    "City": "Bernville"
  },
  {
    "State": "PA",
    "City": "Bethel"
  },
  {
    "State": "PA",
    "City": "Birdsboro"
  },
  {
    "State": "PA",
    "City": "Blandon"
  },
  {
    "State": "PA",
    "City": "Bowers"
  },
  {
    "State": "PA",
    "City": "Boyertown"
  },
  {
    "State": "PA",
    "City": "Centerport"
  },
  {
    "State": "PA",
    "City": "Douglassville"
  },
  {
    "State": "PA",
    "City": "Earlville"
  },
  {
    "State": "PA",
    "City": "Elverson"
  },
  {
    "State": "PA",
    "City": "Fleetwood"
  },
  {
    "State": "PA",
    "City": "Geigertown"
  },
  {
    "State": "PA",
    "City": "Gilbertsville"
  },
  {
    "State": "PA",
    "City": "Hamburg"
  },
  {
    "State": "PA",
    "City": "Kempton"
  },
  {
    "State": "PA",
    "City": "Kutztown"
  },
  {
    "State": "PA",
    "City": "Leesport"
  },
  {
    "State": "PA",
    "City": "Lenhartsville"
  },
  {
    "State": "PA",
    "City": "Limekiln"
  },
  {
    "State": "PA",
    "City": "Lyon Station"
  },
  {
    "State": "PA",
    "City": "Maxatawny"
  },
  {
    "State": "PA",
    "City": "Mertztown"
  },
  {
    "State": "PA",
    "City": "Mohnton"
  },
  {
    "State": "PA",
    "City": "Mohrsville"
  },
  {
    "State": "PA",
    "City": "Monocacy Station"
  },
  {
    "State": "PA",
    "City": "Morgantown"
  },
  {
    "State": "PA",
    "City": "Mount Aetna"
  },
  {
    "State": "PA",
    "City": "New Berlinville"
  },
  {
    "State": "PA",
    "City": "Oley"
  },
  {
    "State": "PA",
    "City": "Pine Forge"
  },
  {
    "State": "PA",
    "City": "Port Clinton"
  },
  {
    "State": "PA",
    "City": "Rehrersburg"
  },
  {
    "State": "PA",
    "City": "Robesonia"
  },
  {
    "State": "PA",
    "City": "Shartlesville"
  },
  {
    "State": "PA",
    "City": "Shoemakersville"
  },
  {
    "State": "PA",
    "City": "Strausstown"
  },
  {
    "State": "PA",
    "City": "Temple"
  },
  {
    "State": "PA",
    "City": "Topton"
  },
  {
    "State": "PA",
    "City": "Virginville"
  },
  {
    "State": "PA",
    "City": "Wernersville"
  },
  {
    "State": "PA",
    "City": "Womelsdorf"
  },
  {
    "State": "PA",
    "City": "Reading"
  },
  {
    "State": "DE",
    "City": "Bear"
  },
  {
    "State": "DE",
    "City": "Newark"
  },
  {
    "State": "DE",
    "City": "Claymont"
  },
  {
    "State": "DE",
    "City": "Delaware City"
  },
  {
    "State": "DE",
    "City": "Hockessin"
  },
  {
    "State": "DE",
    "City": "Kirkwood"
  },
  {
    "State": "DE",
    "City": "Middletown"
  },
  {
    "State": "DE",
    "City": "Montchanin"
  },
  {
    "State": "DE",
    "City": "New Castle"
  },
  {
    "State": "DE",
    "City": "Odessa"
  },
  {
    "State": "DE",
    "City": "Port Penn"
  },
  {
    "State": "DE",
    "City": "Rockland"
  },
  {
    "State": "DE",
    "City": "Saint Georges"
  },
  {
    "State": "DE",
    "City": "Townsend"
  },
  {
    "State": "DE",
    "City": "Winterthur"
  },
  {
    "State": "DE",
    "City": "Yorklyn"
  },
  {
    "State": "DE",
    "City": "Wilmington"
  },
  {
    "State": "DE",
    "City": "Dover"
  },
  {
    "State": "DE",
    "City": "Dover AFB"
  },
  {
    "State": "DE",
    "City": "Bethany Beach"
  },
  {
    "State": "DE",
    "City": "Bethel"
  },
  {
    "State": "DE",
    "City": "Bridgeville"
  },
  {
    "State": "DE",
    "City": "Camden Wyoming"
  },
  {
    "State": "DE",
    "City": "Cheswold"
  },
  {
    "State": "DE",
    "City": "Clayton"
  },
  {
    "State": "DE",
    "City": "Dagsboro"
  },
  {
    "State": "DE",
    "City": "Delmar"
  },
  {
    "State": "DE",
    "City": "Ellendale"
  },
  {
    "State": "DE",
    "City": "Felton"
  },
  {
    "State": "DE",
    "City": "Fenwick Island"
  },
  {
    "State": "DE",
    "City": "Frankford"
  },
  {
    "State": "DE",
    "City": "Frederica"
  },
  {
    "State": "DE",
    "City": "Georgetown"
  },
  {
    "State": "DE",
    "City": "Greenwood"
  },
  {
    "State": "DE",
    "City": "Harbeson"
  },
  {
    "State": "DE",
    "City": "Harrington"
  },
  {
    "State": "DE",
    "City": "Hartly"
  },
  {
    "State": "DE",
    "City": "Houston"
  },
  {
    "State": "DE",
    "City": "Kenton"
  },
  {
    "State": "DE",
    "City": "Laurel"
  },
  {
    "State": "DE",
    "City": "Lewes"
  },
  {
    "State": "DE",
    "City": "Lincoln"
  },
  {
    "State": "DE",
    "City": "Little Creek"
  },
  {
    "State": "DE",
    "City": "Magnolia"
  },
  {
    "State": "DE",
    "City": "Milford"
  },
  {
    "State": "DE",
    "City": "Marydel"
  },
  {
    "State": "DE",
    "City": "Millsboro"
  },
  {
    "State": "DE",
    "City": "Millville"
  },
  {
    "State": "DE",
    "City": "Milton"
  },
  {
    "State": "DE",
    "City": "Nassau"
  },
  {
    "State": "DE",
    "City": "Ocean View"
  },
  {
    "State": "DE",
    "City": "Rehoboth Beach"
  },
  {
    "State": "DE",
    "City": "Seaford"
  },
  {
    "State": "DE",
    "City": "Selbyville"
  },
  {
    "State": "DE",
    "City": "Smyrna"
  },
  {
    "State": "DE",
    "City": "Viola"
  },
  {
    "State": "DE",
    "City": "Woodside"
  },
  {
    "State": "DC",
    "City": "Washington"
  },
  {
    "State": "VA",
    "City": "Dulles"
  },
  {
    "State": "VA",
    "City": "Aldie"
  },
  {
    "State": "VA",
    "City": "Amissville"
  },
  {
    "State": "VA",
    "City": "Arcola"
  },
  {
    "State": "VA",
    "City": "Manassas"
  },
  {
    "State": "VA",
    "City": "Marshall"
  },
  {
    "State": "VA",
    "City": "Middleburg"
  },
  {
    "State": "VA",
    "City": "Catlett"
  },
  {
    "State": "VA",
    "City": "Centreville"
  },
  {
    "State": "VA",
    "City": "Clifton"
  },
  {
    "State": "VA",
    "City": "Orlean"
  },
  {
    "State": "VA",
    "City": "Paeonian Springs"
  },
  {
    "State": "VA",
    "City": "Paris"
  },
  {
    "State": "VA",
    "City": "Philomont"
  },
  {
    "State": "VA",
    "City": "Purcellville"
  },
  {
    "State": "VA",
    "City": "Bluemont"
  },
  {
    "State": "VA",
    "City": "Bristow"
  },
  {
    "State": "VA",
    "City": "Broad Run"
  },
  {
    "State": "VA",
    "City": "Calverton"
  },
  {
    "State": "VA",
    "City": "Casanova"
  },
  {
    "State": "VA",
    "City": "Rectortown"
  },
  {
    "State": "VA",
    "City": "Round Hill"
  },
  {
    "State": "VA",
    "City": "Catharpin"
  },
  {
    "State": "VA",
    "City": "Delaplane"
  },
  {
    "State": "VA",
    "City": "Ashburn"
  },
  {
    "State": "VA",
    "City": "Chantilly"
  },
  {
    "State": "VA",
    "City": "Gainesville"
  },
  {
    "State": "VA",
    "City": "Hamilton"
  },
  {
    "State": "VA",
    "City": "Lincoln"
  },
  {
    "State": "VA",
    "City": "Sterling"
  },
  {
    "State": "VA",
    "City": "Haymarket"
  },
  {
    "State": "VA",
    "City": "Herndon"
  },
  {
    "State": "VA",
    "City": "Leesburg"
  },
  {
    "State": "VA",
    "City": "Lovettsville"
  },
  {
    "State": "VA",
    "City": "Nokesville"
  },
  {
    "State": "VA",
    "City": "Upperville"
  },
  {
    "State": "VA",
    "City": "Warrenton"
  },
  {
    "State": "VA",
    "City": "Reston"
  },
  {
    "State": "VA",
    "City": "Waterford"
  },
  {
    "State": "VA",
    "City": "The Plains"
  },
  {
    "State": "DC",
    "City": "Naval Anacost Annex"
  },
  {
    "State": "DC",
    "City": "Washington Navy Yard"
  },
  {
    "State": "MD",
    "City": "Dhs"
  },
  {
    "State": "VA",
    "City": "Dhs"
  },
  {
    "State": "MD",
    "City": "Waldorf"
  },
  {
    "State": "MD",
    "City": "Abell"
  },
  {
    "State": "MD",
    "City": "Accokeek"
  },
  {
    "State": "MD",
    "City": "Aquasco"
  },
  {
    "State": "MD",
    "City": "Avenue"
  },
  {
    "State": "MD",
    "City": "Barstow"
  },
  {
    "State": "MD",
    "City": "Bel Alton"
  },
  {
    "State": "MD",
    "City": "Benedict"
  },
  {
    "State": "MD",
    "City": "Brandywine"
  },
  {
    "State": "MD",
    "City": "Broomes Island"
  },
  {
    "State": "MD",
    "City": "Bryans Road"
  },
  {
    "State": "MD",
    "City": "Bryantown"
  },
  {
    "State": "MD",
    "City": "Bushwood"
  },
  {
    "State": "MD",
    "City": "California"
  },
  {
    "State": "MD",
    "City": "Callaway"
  },
  {
    "State": "MD",
    "City": "Chaptico"
  },
  {
    "State": "MD",
    "City": "Charlotte Hall"
  },
  {
    "State": "MD",
    "City": "Cheltenham"
  },
  {
    "State": "MD",
    "City": "Clements"
  },
  {
    "State": "MD",
    "City": "Cobb Island"
  },
  {
    "State": "MD",
    "City": "Coltons Point"
  },
  {
    "State": "MD",
    "City": "Compton"
  },
  {
    "State": "MD",
    "City": "Dameron"
  },
  {
    "State": "MD",
    "City": "Dowell"
  },
  {
    "State": "MD",
    "City": "Drayden"
  },
  {
    "State": "MD",
    "City": "Faulkner"
  },
  {
    "State": "MD",
    "City": "Great Mills"
  },
  {
    "State": "MD",
    "City": "Helen"
  },
  {
    "State": "MD",
    "City": "Hollywood"
  },
  {
    "State": "MD",
    "City": "Hughesville"
  },
  {
    "State": "MD",
    "City": "Huntingtown"
  },
  {
    "State": "MD",
    "City": "Indian Head"
  },
  {
    "State": "MD",
    "City": "Ironsides"
  },
  {
    "State": "MD",
    "City": "Issue"
  },
  {
    "State": "MD",
    "City": "La Plata"
  },
  {
    "State": "MD",
    "City": "Leonardtown"
  },
  {
    "State": "MD",
    "City": "Lexington Park"
  },
  {
    "State": "MD",
    "City": "Loveville"
  },
  {
    "State": "MD",
    "City": "Lusby"
  },
  {
    "State": "MD",
    "City": "Marbury"
  },
  {
    "State": "MD",
    "City": "Mechanicsville"
  },
  {
    "State": "MD",
    "City": "Morganza"
  },
  {
    "State": "MD",
    "City": "Mount Victoria"
  },
  {
    "State": "MD",
    "City": "Nanjemoy"
  },
  {
    "State": "MD",
    "City": "Newburg"
  },
  {
    "State": "MD",
    "City": "Park Hall"
  },
  {
    "State": "MD",
    "City": "Patuxent River"
  },
  {
    "State": "MD",
    "City": "Piney Point"
  },
  {
    "State": "MD",
    "City": "Pomfret"
  },
  {
    "State": "MD",
    "City": "Port Republic"
  },
  {
    "State": "MD",
    "City": "Port Tobacco"
  },
  {
    "State": "MD",
    "City": "Prince Frederick"
  },
  {
    "State": "MD",
    "City": "Ridge"
  },
  {
    "State": "MD",
    "City": "Rock Point"
  },
  {
    "State": "MD",
    "City": "Saint Inigoes"
  },
  {
    "State": "MD",
    "City": "Saint Leonard"
  },
  {
    "State": "MD",
    "City": "Saint Marys City"
  },
  {
    "State": "MD",
    "City": "Scotland"
  },
  {
    "State": "MD",
    "City": "Solomons"
  },
  {
    "State": "MD",
    "City": "Sunderland"
  },
  {
    "State": "MD",
    "City": "Tall Timbers"
  },
  {
    "State": "MD",
    "City": "Valley Lee"
  },
  {
    "State": "MD",
    "City": "Welcome"
  },
  {
    "State": "MD",
    "City": "White Plains"
  },
  {
    "State": "MD",
    "City": "Southern Md Facility"
  },
  {
    "State": "MD",
    "City": "Annapolis Junction"
  },
  {
    "State": "MD",
    "City": "Lanham"
  },
  {
    "State": "MD",
    "City": "Beltsville"
  },
  {
    "State": "MD",
    "City": "Laurel"
  },
  {
    "State": "MD",
    "City": "Bladensburg"
  },
  {
    "State": "MD",
    "City": "Lothian"
  },
  {
    "State": "MD",
    "City": "Mount Rainier"
  },
  {
    "State": "MD",
    "City": "North Beach"
  },
  {
    "State": "MD",
    "City": "Bowie"
  },
  {
    "State": "MD",
    "City": "Brentwood"
  },
  {
    "State": "MD",
    "City": "Capitol Heights"
  },
  {
    "State": "MD",
    "City": "Chesapeake Beach"
  },
  {
    "State": "MD",
    "City": "Churchton"
  },
  {
    "State": "MD",
    "City": "Clinton"
  },
  {
    "State": "MD",
    "City": "Owings"
  },
  {
    "State": "MD",
    "City": "Riverdale"
  },
  {
    "State": "MD",
    "City": "College Park"
  },
  {
    "State": "MD",
    "City": "Fort Washington"
  },
  {
    "State": "MD",
    "City": "Oxon Hill"
  },
  {
    "State": "MD",
    "City": "Suitland"
  },
  {
    "State": "MD",
    "City": "District Heights"
  },
  {
    "State": "MD",
    "City": "Temple Hills"
  },
  {
    "State": "MD",
    "City": "Deale"
  },
  {
    "State": "MD",
    "City": "Dunkirk"
  },
  {
    "State": "MD",
    "City": "Fort George G Meade"
  },
  {
    "State": "MD",
    "City": "Friendship"
  },
  {
    "State": "MD",
    "City": "Fulton"
  },
  {
    "State": "MD",
    "City": "Andrews Air Force Base"
  },
  {
    "State": "MD",
    "City": "Savage"
  },
  {
    "State": "MD",
    "City": "Shady Side"
  },
  {
    "State": "MD",
    "City": "Galesville"
  },
  {
    "State": "MD",
    "City": "Greenbelt"
  },
  {
    "State": "MD",
    "City": "Glenn Dale"
  },
  {
    "State": "MD",
    "City": "Upper Marlboro"
  },
  {
    "State": "MD",
    "City": "Harwood"
  },
  {
    "State": "MD",
    "City": "Highland"
  },
  {
    "State": "MD",
    "City": "West River"
  },
  {
    "State": "MD",
    "City": "Tracys Landing"
  },
  {
    "State": "MD",
    "City": "Hyattsville"
  },
  {
    "State": "MD",
    "City": "Jessup"
  },
  {
    "State": "MD",
    "City": "Bethesda"
  },
  {
    "State": "MD",
    "City": "Glen Echo"
  },
  {
    "State": "MD",
    "City": "Chevy Chase"
  },
  {
    "State": "MD",
    "City": "Cabin John"
  },
  {
    "State": "MD",
    "City": "Olney"
  },
  {
    "State": "MD",
    "City": "Brookeville"
  },
  {
    "State": "MD",
    "City": "Poolesville"
  },
  {
    "State": "MD",
    "City": "Barnesville"
  },
  {
    "State": "MD",
    "City": "Beallsville"
  },
  {
    "State": "MD",
    "City": "Boyds"
  },
  {
    "State": "MD",
    "City": "Dickerson"
  },
  {
    "State": "MD",
    "City": "Rockville"
  },
  {
    "State": "MD",
    "City": "Potomac"
  },
  {
    "State": "MD",
    "City": "Derwood"
  },
  {
    "State": "MD",
    "City": "Sandy Spring"
  },
  {
    "State": "MD",
    "City": "Ashton"
  },
  {
    "State": "MD",
    "City": "Brinklow"
  },
  {
    "State": "MD",
    "City": "Burtonsville"
  },
  {
    "State": "MD",
    "City": "Spencerville"
  },
  {
    "State": "MD",
    "City": "Clarksburg"
  },
  {
    "State": "MD",
    "City": "Damascus"
  },
  {
    "State": "MD",
    "City": "Germantown"
  },
  {
    "State": "MD",
    "City": "Gaithersburg"
  },
  {
    "State": "MD",
    "City": "Washington Grove"
  },
  {
    "State": "MD",
    "City": "Montgomery Village"
  },
  {
    "State": "MD",
    "City": "Kensington"
  },
  {
    "State": "MD",
    "City": "Garrett Park"
  },
  {
    "State": "MD",
    "City": "Suburb Maryland Fac"
  },
  {
    "State": "MD",
    "City": "Silver Spring"
  },
  {
    "State": "MD",
    "City": "Takoma Park"
  },
  {
    "State": "MD",
    "City": "Aberdeen"
  },
  {
    "State": "MD",
    "City": "Aberdeen Proving Ground"
  },
  {
    "State": "MD",
    "City": "Abingdon"
  },
  {
    "State": "MD",
    "City": "Gunpowder"
  },
  {
    "State": "MD",
    "City": "Arnold"
  },
  {
    "State": "MD",
    "City": "Baldwin"
  },
  {
    "State": "MD",
    "City": "Bel Air"
  },
  {
    "State": "MD",
    "City": "Belcamp"
  },
  {
    "State": "MD",
    "City": "Benson"
  },
  {
    "State": "MD",
    "City": "Boring"
  },
  {
    "State": "MD",
    "City": "Brooklandville"
  },
  {
    "State": "MD",
    "City": "Butler"
  },
  {
    "State": "MD",
    "City": "Chase"
  },
  {
    "State": "MD",
    "City": "Churchville"
  },
  {
    "State": "MD",
    "City": "Clarksville"
  },
  {
    "State": "MD",
    "City": "Cockeysville"
  },
  {
    "State": "MD",
    "City": "Hunt Valley"
  },
  {
    "State": "MD",
    "City": "Crownsville"
  },
  {
    "State": "MD",
    "City": "Darlington"
  },
  {
    "State": "MD",
    "City": "Davidsonville"
  },
  {
    "State": "MD",
    "City": "Dayton"
  },
  {
    "State": "MD",
    "City": "Edgewater"
  },
  {
    "State": "MD",
    "City": "Edgewood"
  },
  {
    "State": "MD",
    "City": "Ellicott City"
  },
  {
    "State": "MD",
    "City": "Columbia"
  },
  {
    "State": "MD",
    "City": "Fallston"
  },
  {
    "State": "MD",
    "City": "Finksburg"
  },
  {
    "State": "MD",
    "City": "Forest Hill"
  },
  {
    "State": "MD",
    "City": "Fork"
  },
  {
    "State": "MD",
    "City": "Fort Howard"
  },
  {
    "State": "MD",
    "City": "Freeland"
  },
  {
    "State": "MD",
    "City": "Gambrills"
  },
  {
    "State": "MD",
    "City": "Gibson Island"
  },
  {
    "State": "MD",
    "City": "Glen Arm"
  },
  {
    "State": "MD",
    "City": "Glen Burnie"
  },
  {
    "State": "MD",
    "City": "Glyndon"
  },
  {
    "State": "MD",
    "City": "Hampstead"
  },
  {
    "State": "MD",
    "City": "Elkridge"
  },
  {
    "State": "MD",
    "City": "Hanover"
  },
  {
    "State": "MD",
    "City": "Harmans"
  },
  {
    "State": "MD",
    "City": "Havre De Grace"
  },
  {
    "State": "MD",
    "City": "Hydes"
  },
  {
    "State": "MD",
    "City": "Jarrettsville"
  },
  {
    "State": "MD",
    "City": "Joppa"
  },
  {
    "State": "MD",
    "City": "Kingsville"
  },
  {
    "State": "MD",
    "City": "Lineboro"
  },
  {
    "State": "MD",
    "City": "Linthicum Heights"
  },
  {
    "State": "MD",
    "City": "Long Green"
  },
  {
    "State": "MD",
    "City": "Lutherville Timonium"
  },
  {
    "State": "MD",
    "City": "Manchester"
  },
  {
    "State": "MD",
    "City": "Marriottsville"
  },
  {
    "State": "MD",
    "City": "Maryland Line"
  },
  {
    "State": "MD",
    "City": "Mayo"
  },
  {
    "State": "MD",
    "City": "Millersville"
  },
  {
    "State": "MD",
    "City": "Monkton"
  },
  {
    "State": "MD",
    "City": "Odenton"
  },
  {
    "State": "MD",
    "City": "Crofton"
  },
  {
    "State": "MD",
    "City": "Owings Mills"
  },
  {
    "State": "MD",
    "City": "Parkton"
  },
  {
    "State": "MD",
    "City": "Pasadena"
  },
  {
    "State": "MD",
    "City": "Perry Hall"
  },
  {
    "State": "MD",
    "City": "Perryman"
  },
  {
    "State": "MD",
    "City": "Phoenix"
  },
  {
    "State": "MD",
    "City": "Pylesville"
  },
  {
    "State": "MD",
    "City": "Randallstown"
  },
  {
    "State": "MD",
    "City": "Reisterstown"
  },
  {
    "State": "MD",
    "City": "Riderwood"
  },
  {
    "State": "MD",
    "City": "Riva"
  },
  {
    "State": "MD",
    "City": "Severn"
  },
  {
    "State": "MD",
    "City": "Severna Park"
  },
  {
    "State": "MD",
    "City": "Simpsonville"
  },
  {
    "State": "MD",
    "City": "Sparks Glencoe"
  },
  {
    "State": "MD",
    "City": "Stevenson"
  },
  {
    "State": "MD",
    "City": "Street"
  },
  {
    "State": "MD",
    "City": "Upperco"
  },
  {
    "State": "MD",
    "City": "Upper Falls"
  },
  {
    "State": "MD",
    "City": "Westminster"
  },
  {
    "State": "MD",
    "City": "Whiteford"
  },
  {
    "State": "MD",
    "City": "White Hall"
  },
  {
    "State": "MD",
    "City": "White Marsh"
  },
  {
    "State": "MD",
    "City": "Woodstock"
  },
  {
    "State": "MD",
    "City": "Baltimore"
  },
  {
    "State": "MD",
    "City": "Towson"
  },
  {
    "State": "MD",
    "City": "Gwynn Oak"
  },
  {
    "State": "MD",
    "City": "Pikesville"
  },
  {
    "State": "MD",
    "City": "Sparrows Point"
  },
  {
    "State": "MD",
    "City": "Middle River"
  },
  {
    "State": "MD",
    "City": "Essex"
  },
  {
    "State": "MD",
    "City": "Dundalk"
  },
  {
    "State": "MD",
    "City": "Brooklyn"
  },
  {
    "State": "MD",
    "City": "Curtis Bay"
  },
  {
    "State": "MD",
    "City": "Halethorpe"
  },
  {
    "State": "MD",
    "City": "Catonsville"
  },
  {
    "State": "MD",
    "City": "Parkville"
  },
  {
    "State": "MD",
    "City": "Nottingham"
  },
  {
    "State": "MD",
    "City": "Rosedale"
  },
  {
    "State": "MD",
    "City": "Windsor Mill"
  },
  {
    "State": "MD",
    "City": "Annapolis"
  },
  {
    "State": "MD",
    "City": "Cumberland"
  },
  {
    "State": "MD",
    "City": "Accident"
  },
  {
    "State": "MD",
    "City": "Barton"
  },
  {
    "State": "MD",
    "City": "Bittinger"
  },
  {
    "State": "MD",
    "City": "Bloomington"
  },
  {
    "State": "MD",
    "City": "Corriganville"
  },
  {
    "State": "MD",
    "City": "Eckhart Mines"
  },
  {
    "State": "MD",
    "City": "Ellerslie"
  },
  {
    "State": "MD",
    "City": "Flintstone"
  },
  {
    "State": "MD",
    "City": "Friendsville"
  },
  {
    "State": "MD",
    "City": "Frostburg"
  },
  {
    "State": "MD",
    "City": "Grantsville"
  },
  {
    "State": "MD",
    "City": "Kitzmiller"
  },
  {
    "State": "MD",
    "City": "Lonaconing"
  },
  {
    "State": "MD",
    "City": "Luke"
  },
  {
    "State": "MD",
    "City": "Mc Henry"
  },
  {
    "State": "MD",
    "City": "Midland"
  },
  {
    "State": "MD",
    "City": "Midlothian"
  },
  {
    "State": "MD",
    "City": "Mount Savage"
  },
  {
    "State": "MD",
    "City": "Oakland"
  },
  {
    "State": "MD",
    "City": "Oldtown"
  },
  {
    "State": "MD",
    "City": "Pinto"
  },
  {
    "State": "MD",
    "City": "Rawlings"
  },
  {
    "State": "MD",
    "City": "Spring Gap"
  },
  {
    "State": "MD",
    "City": "Swanton"
  },
  {
    "State": "MD",
    "City": "Westernport"
  },
  {
    "State": "MD",
    "City": "Easton"
  },
  {
    "State": "MD",
    "City": "Barclay"
  },
  {
    "State": "MD",
    "City": "Bethlehem"
  },
  {
    "State": "MD",
    "City": "Betterton"
  },
  {
    "State": "MD",
    "City": "Bozman"
  },
  {
    "State": "MD",
    "City": "Cambridge"
  },
  {
    "State": "MD",
    "City": "Centreville"
  },
  {
    "State": "MD",
    "City": "Chester"
  },
  {
    "State": "MD",
    "City": "Chestertown"
  },
  {
    "State": "MD",
    "City": "Church Creek"
  },
  {
    "State": "MD",
    "City": "Church Hill"
  },
  {
    "State": "MD",
    "City": "Claiborne"
  },
  {
    "State": "MD",
    "City": "Cordova"
  },
  {
    "State": "MD",
    "City": "Crapo"
  },
  {
    "State": "MD",
    "City": "Crocheron"
  },
  {
    "State": "MD",
    "City": "Crumpton"
  },
  {
    "State": "MD",
    "City": "Denton"
  },
  {
    "State": "MD",
    "City": "East New Market"
  },
  {
    "State": "MD",
    "City": "Federalsburg"
  },
  {
    "State": "MD",
    "City": "Fishing Creek"
  },
  {
    "State": "MD",
    "City": "Galena"
  },
  {
    "State": "MD",
    "City": "Goldsboro"
  },
  {
    "State": "MD",
    "City": "Grasonville"
  },
  {
    "State": "MD",
    "City": "Greensboro"
  },
  {
    "State": "MD",
    "City": "Henderson"
  },
  {
    "State": "MD",
    "City": "Hillsboro"
  },
  {
    "State": "MD",
    "City": "Hurlock"
  },
  {
    "State": "MD",
    "City": "Ingleside"
  },
  {
    "State": "MD",
    "City": "Kennedyville"
  },
  {
    "State": "MD",
    "City": "Mcdaniel"
  },
  {
    "State": "MD",
    "City": "Madison"
  },
  {
    "State": "MD",
    "City": "Marydel"
  },
  {
    "State": "MD",
    "City": "Massey"
  },
  {
    "State": "MD",
    "City": "Millington"
  },
  {
    "State": "MD",
    "City": "Neavitt"
  },
  {
    "State": "MD",
    "City": "Newcomb"
  },
  {
    "State": "MD",
    "City": "Oxford"
  },
  {
    "State": "MD",
    "City": "Preston"
  },
  {
    "State": "MD",
    "City": "Price"
  },
  {
    "State": "MD",
    "City": "Queen Anne"
  },
  {
    "State": "MD",
    "City": "Queenstown"
  },
  {
    "State": "MD",
    "City": "Rhodesdale"
  },
  {
    "State": "MD",
    "City": "Ridgely"
  },
  {
    "State": "MD",
    "City": "Rock Hall"
  },
  {
    "State": "MD",
    "City": "Royal Oak"
  },
  {
    "State": "MD",
    "City": "Saint Michaels"
  },
  {
    "State": "MD",
    "City": "Secretary"
  },
  {
    "State": "MD",
    "City": "Sherwood"
  },
  {
    "State": "MD",
    "City": "Stevensville"
  },
  {
    "State": "MD",
    "City": "Still Pond"
  },
  {
    "State": "MD",
    "City": "Sudlersville"
  },
  {
    "State": "MD",
    "City": "Taylors Island"
  },
  {
    "State": "MD",
    "City": "Templeville"
  },
  {
    "State": "MD",
    "City": "Tilghman"
  },
  {
    "State": "MD",
    "City": "Toddville"
  },
  {
    "State": "MD",
    "City": "Trappe"
  },
  {
    "State": "MD",
    "City": "Wingate"
  },
  {
    "State": "MD",
    "City": "Wittman"
  },
  {
    "State": "MD",
    "City": "Woolford"
  },
  {
    "State": "MD",
    "City": "Worton"
  },
  {
    "State": "MD",
    "City": "Wye Mills"
  },
  {
    "State": "MD",
    "City": "Frederick"
  },
  {
    "State": "MD",
    "City": "Adamstown"
  },
  {
    "State": "MD",
    "City": "Big Pool"
  },
  {
    "State": "MD",
    "City": "Boonsboro"
  },
  {
    "State": "MD",
    "City": "Braddock Heights"
  },
  {
    "State": "MD",
    "City": "Brownsville"
  },
  {
    "State": "MD",
    "City": "Brunswick"
  },
  {
    "State": "MD",
    "City": "Buckeystown"
  },
  {
    "State": "MD",
    "City": "Burkittsville"
  },
  {
    "State": "MD",
    "City": "Cascade"
  },
  {
    "State": "MD",
    "City": "Cavetown"
  },
  {
    "State": "MD",
    "City": "Chewsville"
  },
  {
    "State": "MD",
    "City": "Clear Spring"
  },
  {
    "State": "MD",
    "City": "Cooksville"
  },
  {
    "State": "MD",
    "City": "Emmitsburg"
  },
  {
    "State": "MD",
    "City": "Fairplay"
  },
  {
    "State": "MD",
    "City": "Funkstown"
  },
  {
    "State": "MD",
    "City": "Glenelg"
  },
  {
    "State": "MD",
    "City": "Glenwood"
  },
  {
    "State": "MD",
    "City": "Hagerstown"
  },
  {
    "State": "MD",
    "City": "Hancock"
  },
  {
    "State": "MD",
    "City": "Ijamsville"
  },
  {
    "State": "MD",
    "City": "Jefferson"
  },
  {
    "State": "MD",
    "City": "Keedysville"
  },
  {
    "State": "MD",
    "City": "Keymar"
  },
  {
    "State": "MD",
    "City": "Knoxville"
  },
  {
    "State": "MD",
    "City": "Ladiesburg"
  },
  {
    "State": "MD",
    "City": "Libertytown"
  },
  {
    "State": "MD",
    "City": "Lisbon"
  },
  {
    "State": "MD",
    "City": "Little Orleans"
  },
  {
    "State": "MD",
    "City": "Maugansville"
  },
  {
    "State": "MD",
    "City": "Middletown"
  },
  {
    "State": "MD",
    "City": "Monrovia"
  },
  {
    "State": "MD",
    "City": "Mount Airy"
  },
  {
    "State": "MD",
    "City": "Myersville"
  },
  {
    "State": "MD",
    "City": "New Market"
  },
  {
    "State": "MD",
    "City": "New Midway"
  },
  {
    "State": "MD",
    "City": "New Windsor"
  },
  {
    "State": "MD",
    "City": "Point Of Rocks"
  },
  {
    "State": "MD",
    "City": "Rocky Ridge"
  },
  {
    "State": "MD",
    "City": "Rohrersville"
  },
  {
    "State": "MD",
    "City": "Sabillasville"
  },
  {
    "State": "MD",
    "City": "Saint James"
  },
  {
    "State": "MD",
    "City": "Sharpsburg"
  },
  {
    "State": "MD",
    "City": "Smithsburg"
  },
  {
    "State": "MD",
    "City": "Sykesville"
  },
  {
    "State": "MD",
    "City": "Taneytown"
  },
  {
    "State": "MD",
    "City": "Thurmont"
  },
  {
    "State": "MD",
    "City": "Tuscarora"
  },
  {
    "State": "MD",
    "City": "Union Bridge"
  },
  {
    "State": "MD",
    "City": "Unionville"
  },
  {
    "State": "MD",
    "City": "Walkersville"
  },
  {
    "State": "MD",
    "City": "West Friendship"
  },
  {
    "State": "MD",
    "City": "Williamsport"
  },
  {
    "State": "MD",
    "City": "Woodbine"
  },
  {
    "State": "MD",
    "City": "Woodsboro"
  },
  {
    "State": "MD",
    "City": "Salisbury"
  },
  {
    "State": "MD",
    "City": "Allen"
  },
  {
    "State": "MD",
    "City": "Berlin"
  },
  {
    "State": "MD",
    "City": "Bishopville"
  },
  {
    "State": "MD",
    "City": "Bivalve"
  },
  {
    "State": "MD",
    "City": "Crisfield"
  },
  {
    "State": "MD",
    "City": "Deal Island"
  },
  {
    "State": "MD",
    "City": "Eden"
  },
  {
    "State": "MD",
    "City": "Ewell"
  },
  {
    "State": "MD",
    "City": "Fruitland"
  },
  {
    "State": "MD",
    "City": "Girdletree"
  },
  {
    "State": "MD",
    "City": "Hebron"
  },
  {
    "State": "MD",
    "City": "Linkwood"
  },
  {
    "State": "MD",
    "City": "Manokin"
  },
  {
    "State": "MD",
    "City": "Mardela Springs"
  },
  {
    "State": "MD",
    "City": "Marion Station"
  },
  {
    "State": "MD",
    "City": "Nanticoke"
  },
  {
    "State": "MD",
    "City": "Newark"
  },
  {
    "State": "MD",
    "City": "Ocean City"
  },
  {
    "State": "MD",
    "City": "Parsonsburg"
  },
  {
    "State": "MD",
    "City": "Pittsville"
  },
  {
    "State": "MD",
    "City": "Pocomoke City"
  },
  {
    "State": "MD",
    "City": "Powellville"
  },
  {
    "State": "MD",
    "City": "Princess Anne"
  },
  {
    "State": "MD",
    "City": "Quantico"
  },
  {
    "State": "MD",
    "City": "Rehobeth"
  },
  {
    "State": "MD",
    "City": "Sharptown"
  },
  {
    "State": "MD",
    "City": "Showell"
  },
  {
    "State": "MD",
    "City": "Snow Hill"
  },
  {
    "State": "MD",
    "City": "Stockton"
  },
  {
    "State": "MD",
    "City": "Tyaskin"
  },
  {
    "State": "MD",
    "City": "Tylerton"
  },
  {
    "State": "MD",
    "City": "Upper Fairmount"
  },
  {
    "State": "MD",
    "City": "Vienna"
  },
  {
    "State": "MD",
    "City": "Westover"
  },
  {
    "State": "MD",
    "City": "Whaleyville"
  },
  {
    "State": "MD",
    "City": "Willards"
  },
  {
    "State": "MD",
    "City": "Delmar"
  },
  {
    "State": "MD",
    "City": "North East"
  },
  {
    "State": "MD",
    "City": "Perry Point"
  },
  {
    "State": "MD",
    "City": "Perryville"
  },
  {
    "State": "MD",
    "City": "Port Deposit"
  },
  {
    "State": "MD",
    "City": "Rising Sun"
  },
  {
    "State": "MD",
    "City": "Warwick"
  },
  {
    "State": "MD",
    "City": "Cecilton"
  },
  {
    "State": "MD",
    "City": "Charlestown"
  },
  {
    "State": "MD",
    "City": "Chesapeake City"
  },
  {
    "State": "MD",
    "City": "Childs"
  },
  {
    "State": "MD",
    "City": "Colora"
  },
  {
    "State": "MD",
    "City": "Conowingo"
  },
  {
    "State": "MD",
    "City": "Earleville"
  },
  {
    "State": "MD",
    "City": "Elk Mills"
  },
  {
    "State": "MD",
    "City": "Elkton"
  },
  {
    "State": "MD",
    "City": "Georgetown"
  },
  {
    "State": "VA",
    "City": "Annandale"
  },
  {
    "State": "VA",
    "City": "Burke"
  },
  {
    "State": "VA",
    "City": "Dumfries"
  },
  {
    "State": "VA",
    "City": "Dunn Loring"
  },
  {
    "State": "VA",
    "City": "Fairfax"
  },
  {
    "State": "VA",
    "City": "Fairfax Station"
  },
  {
    "State": "VA",
    "City": "Falls Church"
  },
  {
    "State": "VA",
    "City": "Fort Belvoir"
  },
  {
    "State": "VA",
    "City": "Great Falls"
  },
  {
    "State": "VA",
    "City": "Greenway"
  },
  {
    "State": "VA",
    "City": "Lorton"
  },
  {
    "State": "VA",
    "City": "Merrifield"
  },
  {
    "State": "VA",
    "City": "Mc Lean"
  },
  {
    "State": "VA",
    "City": "West Mclean"
  },
  {
    "State": "VA",
    "City": "Mount Vernon"
  },
  {
    "State": "VA",
    "City": "Newington"
  },
  {
    "State": "VA",
    "City": "Oakton"
  },
  {
    "State": "VA",
    "City": "Occoquan"
  },
  {
    "State": "VA",
    "City": "Quantico"
  },
  {
    "State": "VA",
    "City": "Springfield"
  },
  {
    "State": "VA",
    "City": "Triangle"
  },
  {
    "State": "VA",
    "City": "Vienna"
  },
  {
    "State": "VA",
    "City": "Woodbridge"
  },
  {
    "State": "VA",
    "City": "Arlington"
  },
  {
    "State": "VA",
    "City": "Fort Myer"
  },
  {
    "State": "VA",
    "City": "Alexandria"
  },
  {
    "State": "VA",
    "City": "Fredericksburg"
  },
  {
    "State": "VA",
    "City": "Bowling Green"
  },
  {
    "State": "VA",
    "City": "Brooke"
  },
  {
    "State": "VA",
    "City": "Burgess"
  },
  {
    "State": "VA",
    "City": "Burr Hill"
  },
  {
    "State": "VA",
    "City": "Callao"
  },
  {
    "State": "VA",
    "City": "Caret"
  },
  {
    "State": "VA",
    "City": "Center Cross"
  },
  {
    "State": "VA",
    "City": "Champlain"
  },
  {
    "State": "VA",
    "City": "Coles Point"
  },
  {
    "State": "VA",
    "City": "Colonial Beach"
  },
  {
    "State": "VA",
    "City": "Corbin"
  },
  {
    "State": "VA",
    "City": "Dahlgren"
  },
  {
    "State": "VA",
    "City": "Dogue"
  },
  {
    "State": "VA",
    "City": "Dunnsville"
  },
  {
    "State": "VA",
    "City": "Edwardsville"
  },
  {
    "State": "VA",
    "City": "Farnham"
  },
  {
    "State": "VA",
    "City": "Garrisonville"
  },
  {
    "State": "VA",
    "City": "Hague"
  },
  {
    "State": "VA",
    "City": "Hartwood"
  },
  {
    "State": "VA",
    "City": "Haynesville"
  },
  {
    "State": "VA",
    "City": "Heathsville"
  },
  {
    "State": "VA",
    "City": "Hustle"
  },
  {
    "State": "VA",
    "City": "Irvington"
  },
  {
    "State": "VA",
    "City": "Jersey"
  },
  {
    "State": "VA",
    "City": "Kilmarnock"
  },
  {
    "State": "VA",
    "City": "King George"
  },
  {
    "State": "VA",
    "City": "Kinsale"
  },
  {
    "State": "VA",
    "City": "Ladysmith"
  },
  {
    "State": "VA",
    "City": "Lancaster"
  },
  {
    "State": "VA",
    "City": "Laneview"
  },
  {
    "State": "VA",
    "City": "Lively"
  },
  {
    "State": "VA",
    "City": "Locust Grove"
  },
  {
    "State": "VA",
    "City": "Loretto"
  },
  {
    "State": "VA",
    "City": "Lottsburg"
  },
  {
    "State": "VA",
    "City": "Merry Point"
  },
  {
    "State": "VA",
    "City": "Milford"
  },
  {
    "State": "VA",
    "City": "Mollusk"
  },
  {
    "State": "VA",
    "City": "Montross"
  },
  {
    "State": "VA",
    "City": "Morattico"
  },
  {
    "State": "VA",
    "City": "Mount Holly"
  },
  {
    "State": "VA",
    "City": "Ninde"
  },
  {
    "State": "VA",
    "City": "Nuttsville"
  },
  {
    "State": "VA",
    "City": "Oldhams"
  },
  {
    "State": "VA",
    "City": "Ophelia"
  },
  {
    "State": "VA",
    "City": "Partlow"
  },
  {
    "State": "VA",
    "City": "Port Royal"
  },
  {
    "State": "VA",
    "City": "Rappahannock Academy"
  },
  {
    "State": "VA",
    "City": "Reedville"
  },
  {
    "State": "VA",
    "City": "Rhoadesville"
  },
  {
    "State": "VA",
    "City": "Rollins Fork"
  },
  {
    "State": "VA",
    "City": "Ruby"
  },
  {
    "State": "VA",
    "City": "Ruther Glen"
  },
  {
    "State": "VA",
    "City": "Sealston"
  },
  {
    "State": "VA",
    "City": "Sharps"
  },
  {
    "State": "VA",
    "City": "Spotsylvania"
  },
  {
    "State": "VA",
    "City": "Sparta"
  },
  {
    "State": "VA",
    "City": "Stafford"
  },
  {
    "State": "VA",
    "City": "Stratford"
  },
  {
    "State": "VA",
    "City": "Tappahannock"
  },
  {
    "State": "VA",
    "City": "Thornburg"
  },
  {
    "State": "VA",
    "City": "Unionville"
  },
  {
    "State": "VA",
    "City": "Village"
  },
  {
    "State": "VA",
    "City": "Warsaw"
  },
  {
    "State": "VA",
    "City": "Weems"
  },
  {
    "State": "VA",
    "City": "Sandy Point"
  },
  {
    "State": "VA",
    "City": "White Stone"
  },
  {
    "State": "VA",
    "City": "Wicomico Church"
  },
  {
    "State": "VA",
    "City": "Woodford"
  },
  {
    "State": "VA",
    "City": "Zacata"
  },
  {
    "State": "VA",
    "City": "Winchester"
  },
  {
    "State": "VA",
    "City": "Bentonville"
  },
  {
    "State": "VA",
    "City": "Berryville"
  },
  {
    "State": "VA",
    "City": "Boyce"
  },
  {
    "State": "VA",
    "City": "Brucetown"
  },
  {
    "State": "VA",
    "City": "Chester Gap"
  },
  {
    "State": "VA",
    "City": "Clear Brook"
  },
  {
    "State": "VA",
    "City": "Cross Junction"
  },
  {
    "State": "VA",
    "City": "Fishers Hill"
  },
  {
    "State": "VA",
    "City": "Flint Hill"
  },
  {
    "State": "VA",
    "City": "Front Royal"
  },
  {
    "State": "VA",
    "City": "Gore"
  },
  {
    "State": "VA",
    "City": "Hume"
  },
  {
    "State": "VA",
    "City": "Huntly"
  },
  {
    "State": "VA",
    "City": "Strasburg"
  },
  {
    "State": "VA",
    "City": "Linden"
  },
  {
    "State": "VA",
    "City": "Markham"
  },
  {
    "State": "VA",
    "City": "Maurertown"
  },
  {
    "State": "VA",
    "City": "Middletown"
  },
  {
    "State": "VA",
    "City": "Millwood"
  },
  {
    "State": "VA",
    "City": "Rileyville"
  },
  {
    "State": "VA",
    "City": "Fort Valley"
  },
  {
    "State": "VA",
    "City": "Star Tannery"
  },
  {
    "State": "VA",
    "City": "Stephens City"
  },
  {
    "State": "VA",
    "City": "Stephenson"
  },
  {
    "State": "VA",
    "City": "Toms Brook"
  },
  {
    "State": "VA",
    "City": "White Post"
  },
  {
    "State": "VA",
    "City": "Woodstock"
  },
  {
    "State": "VA",
    "City": "Culpeper"
  },
  {
    "State": "VA",
    "City": "Aroda"
  },
  {
    "State": "VA",
    "City": "Banco"
  },
  {
    "State": "VA",
    "City": "Bealeton"
  },
  {
    "State": "VA",
    "City": "Boston"
  },
  {
    "State": "VA",
    "City": "Brandy Station"
  },
  {
    "State": "VA",
    "City": "Brightwood"
  },
  {
    "State": "VA",
    "City": "Castleton"
  },
  {
    "State": "VA",
    "City": "Elkwood"
  },
  {
    "State": "VA",
    "City": "Etlan"
  },
  {
    "State": "VA",
    "City": "Goldvein"
  },
  {
    "State": "VA",
    "City": "Graves Mill"
  },
  {
    "State": "VA",
    "City": "Haywood"
  },
  {
    "State": "VA",
    "City": "Hood"
  },
  {
    "State": "VA",
    "City": "Jeffersonton"
  },
  {
    "State": "VA",
    "City": "Leon"
  },
  {
    "State": "VA",
    "City": "Lignum"
  },
  {
    "State": "VA",
    "City": "Madison"
  },
  {
    "State": "VA",
    "City": "Midland"
  },
  {
    "State": "VA",
    "City": "Mitchells"
  },
  {
    "State": "VA",
    "City": "Oakpark"
  },
  {
    "State": "VA",
    "City": "Pratts"
  },
  {
    "State": "VA",
    "City": "Radiant"
  },
  {
    "State": "VA",
    "City": "Rapidan"
  },
  {
    "State": "VA",
    "City": "Remington"
  },
  {
    "State": "VA",
    "City": "Reva"
  },
  {
    "State": "VA",
    "City": "Richardsville"
  },
  {
    "State": "VA",
    "City": "Rixeyville"
  },
  {
    "State": "VA",
    "City": "Rochelle"
  },
  {
    "State": "VA",
    "City": "Somerville"
  },
  {
    "State": "VA",
    "City": "Sperryville"
  },
  {
    "State": "VA",
    "City": "Stevensburg"
  },
  {
    "State": "VA",
    "City": "Sumerduck"
  },
  {
    "State": "VA",
    "City": "Syria"
  },
  {
    "State": "VA",
    "City": "Viewtown"
  },
  {
    "State": "VA",
    "City": "Washington"
  },
  {
    "State": "VA",
    "City": "Wolftown"
  },
  {
    "State": "VA",
    "City": "Woodville"
  },
  {
    "State": "VA",
    "City": "Harrisonburg"
  },
  {
    "State": "VA",
    "City": "Basye"
  },
  {
    "State": "VA",
    "City": "Bergton"
  },
  {
    "State": "VA",
    "City": "Bridgewater"
  },
  {
    "State": "VA",
    "City": "Broadway"
  },
  {
    "State": "VA",
    "City": "Criders"
  },
  {
    "State": "VA",
    "City": "Dayton"
  },
  {
    "State": "VA",
    "City": "Edinburg"
  },
  {
    "State": "VA",
    "City": "Elkton"
  },
  {
    "State": "VA",
    "City": "Fulks Run"
  },
  {
    "State": "VA",
    "City": "Hinton"
  },
  {
    "State": "VA",
    "City": "Keezletown"
  },
  {
    "State": "VA",
    "City": "Lacey Spring"
  },
  {
    "State": "VA",
    "City": "Linville"
  },
  {
    "State": "VA",
    "City": "Luray"
  },
  {
    "State": "VA",
    "City": "Mc Gaheysville"
  },
  {
    "State": "VA",
    "City": "Mount Crawford"
  },
  {
    "State": "VA",
    "City": "Mount Jackson"
  },
  {
    "State": "VA",
    "City": "Mount Solon"
  },
  {
    "State": "VA",
    "City": "New Market"
  },
  {
    "State": "VA",
    "City": "Orkney Springs"
  },
  {
    "State": "VA",
    "City": "Penn Laird"
  },
  {
    "State": "VA",
    "City": "Quicksburg"
  },
  {
    "State": "VA",
    "City": "Pleasant Valley"
  },
  {
    "State": "VA",
    "City": "Shenandoah"
  },
  {
    "State": "VA",
    "City": "Singers Glen"
  },
  {
    "State": "VA",
    "City": "Stanley"
  },
  {
    "State": "VA",
    "City": "Timberville"
  },
  {
    "State": "VA",
    "City": "Charlottesville"
  },
  {
    "State": "VA",
    "City": "Afton"
  },
  {
    "State": "VA",
    "City": "Arrington"
  },
  {
    "State": "VA",
    "City": "Barboursville"
  },
  {
    "State": "VA",
    "City": "Batesville"
  },
  {
    "State": "VA",
    "City": "Covesville"
  },
  {
    "State": "VA",
    "City": "Crozet"
  },
  {
    "State": "VA",
    "City": "Dyke"
  },
  {
    "State": "VA",
    "City": "Earlysville"
  },
  {
    "State": "VA",
    "City": "Esmont"
  },
  {
    "State": "VA",
    "City": "Faber"
  },
  {
    "State": "VA",
    "City": "Fishersville"
  },
  {
    "State": "VA",
    "City": "Free Union"
  },
  {
    "State": "VA",
    "City": "Gordonsville"
  },
  {
    "State": "VA",
    "City": "Greenwood"
  },
  {
    "State": "VA",
    "City": "Ivy"
  },
  {
    "State": "VA",
    "City": "Keene"
  },
  {
    "State": "VA",
    "City": "Keswick"
  },
  {
    "State": "VA",
    "City": "Locust Dale"
  },
  {
    "State": "VA",
    "City": "Lovingston"
  },
  {
    "State": "VA",
    "City": "Lyndhurst"
  },
  {
    "State": "VA",
    "City": "Montpelier Station"
  },
  {
    "State": "VA",
    "City": "Nellysford"
  },
  {
    "State": "VA",
    "City": "North Garden"
  },
  {
    "State": "VA",
    "City": "Orange"
  },
  {
    "State": "VA",
    "City": "Palmyra"
  },
  {
    "State": "VA",
    "City": "Piney River"
  },
  {
    "State": "VA",
    "City": "Quinque"
  },
  {
    "State": "VA",
    "City": "Roseland"
  },
  {
    "State": "VA",
    "City": "Ruckersville"
  },
  {
    "State": "VA",
    "City": "Schuyler"
  },
  {
    "State": "VA",
    "City": "Shipman"
  },
  {
    "State": "VA",
    "City": "Somerset"
  },
  {
    "State": "VA",
    "City": "Stanardsville"
  },
  {
    "State": "VA",
    "City": "Troy"
  },
  {
    "State": "VA",
    "City": "Tyro"
  },
  {
    "State": "VA",
    "City": "Waynesboro"
  },
  {
    "State": "VA",
    "City": "White Hall"
  },
  {
    "State": "VA",
    "City": "Woodberry Forest"
  },
  {
    "State": "VA",
    "City": "Achilles"
  },
  {
    "State": "VA",
    "City": "Amelia Court House"
  },
  {
    "State": "VA",
    "City": "Ark"
  },
  {
    "State": "VA",
    "City": "Arvonia"
  },
  {
    "State": "VA",
    "City": "Ashland"
  },
  {
    "State": "VA",
    "City": "Aylett"
  },
  {
    "State": "VA",
    "City": "Barhamsville"
  },
  {
    "State": "VA",
    "City": "Beaumont"
  },
  {
    "State": "VA",
    "City": "Beaverdam"
  },
  {
    "State": "VA",
    "City": "Bena"
  },
  {
    "State": "VA",
    "City": "Bohannon"
  },
  {
    "State": "VA",
    "City": "Bremo Bluff"
  },
  {
    "State": "VA",
    "City": "Bruington"
  },
  {
    "State": "VA",
    "City": "Bumpass"
  },
  {
    "State": "VA",
    "City": "Cardinal"
  },
  {
    "State": "VA",
    "City": "Cartersville"
  },
  {
    "State": "VA",
    "City": "Charles City"
  },
  {
    "State": "VA",
    "City": "Christchurch"
  },
  {
    "State": "VA",
    "City": "Church View"
  },
  {
    "State": "VA",
    "City": "Cobbs Creek"
  },
  {
    "State": "VA",
    "City": "Columbia"
  },
  {
    "State": "VA",
    "City": "Crozier"
  },
  {
    "State": "VA",
    "City": "Cumberland"
  },
  {
    "State": "VA",
    "City": "Deltaville"
  },
  {
    "State": "VA",
    "City": "Diggs"
  },
  {
    "State": "VA",
    "City": "Doswell"
  },
  {
    "State": "VA",
    "City": "Dutton"
  },
  {
    "State": "VA",
    "City": "Fork Union"
  },
  {
    "State": "VA",
    "City": "Foster"
  },
  {
    "State": "VA",
    "City": "Glen Allen"
  },
  {
    "State": "VA",
    "City": "Gloucester"
  },
  {
    "State": "VA",
    "City": "Gloucester Point"
  },
  {
    "State": "VA",
    "City": "Goochland"
  },
  {
    "State": "VA",
    "City": "Grimstead"
  },
  {
    "State": "VA",
    "City": "Gum Spring"
  },
  {
    "State": "VA",
    "City": "Gwynn"
  },
  {
    "State": "VA",
    "City": "Hadensville"
  },
  {
    "State": "VA",
    "City": "Hallieford"
  },
  {
    "State": "VA",
    "City": "Hanover"
  },
  {
    "State": "VA",
    "City": "Hardyville"
  },
  {
    "State": "VA",
    "City": "Hartfield"
  },
  {
    "State": "VA",
    "City": "Hayes"
  },
  {
    "State": "VA",
    "City": "Henrico"
  },
  {
    "State": "VA",
    "City": "Hudgins"
  },
  {
    "State": "VA",
    "City": "Jamaica"
  },
  {
    "State": "VA",
    "City": "Jamestown"
  },
  {
    "State": "VA",
    "City": "Jetersville"
  },
  {
    "State": "VA",
    "City": "Kents Store"
  },
  {
    "State": "VA",
    "City": "King And Queen Court House"
  },
  {
    "State": "VA",
    "City": "King William"
  },
  {
    "State": "VA",
    "City": "Lanexa"
  },
  {
    "State": "VA",
    "City": "Lightfoot"
  },
  {
    "State": "VA",
    "City": "Little Plymouth"
  },
  {
    "State": "VA",
    "City": "Locust Hill"
  },
  {
    "State": "VA",
    "City": "Louisa"
  },
  {
    "State": "VA",
    "City": "Macon"
  },
  {
    "State": "VA",
    "City": "Maidens"
  },
  {
    "State": "VA",
    "City": "Manakin Sabot"
  },
  {
    "State": "VA",
    "City": "Mannboro"
  },
  {
    "State": "VA",
    "City": "Manquin"
  },
  {
    "State": "VA",
    "City": "Maryus"
  },
  {
    "State": "VA",
    "City": "Mascot"
  },
  {
    "State": "VA",
    "City": "Mathews"
  },
  {
    "State": "VA",
    "City": "Mattaponi"
  },
  {
    "State": "VA",
    "City": "Mechanicsville"
  },
  {
    "State": "VA",
    "City": "Midlothian"
  },
  {
    "State": "VA",
    "City": "Millers Tavern"
  },
  {
    "State": "VA",
    "City": "Mineral"
  },
  {
    "State": "VA",
    "City": "Moon"
  },
  {
    "State": "VA",
    "City": "Moseley"
  },
  {
    "State": "VA",
    "City": "New Canton"
  },
  {
    "State": "VA",
    "City": "New Kent"
  },
  {
    "State": "VA",
    "City": "New Point"
  },
  {
    "State": "VA",
    "City": "Newtown"
  },
  {
    "State": "VA",
    "City": "Norge"
  },
  {
    "State": "VA",
    "City": "North"
  },
  {
    "State": "VA",
    "City": "Oilville"
  },
  {
    "State": "VA",
    "City": "Onemo"
  },
  {
    "State": "VA",
    "City": "Ordinary"
  },
  {
    "State": "VA",
    "City": "Port Haywood"
  },
  {
    "State": "VA",
    "City": "Powhatan"
  },
  {
    "State": "VA",
    "City": "Providence Forge"
  },
  {
    "State": "VA",
    "City": "Quinton"
  },
  {
    "State": "VA",
    "City": "Rockville"
  },
  {
    "State": "VA",
    "City": "Ruthville"
  },
  {
    "State": "VA",
    "City": "Saint Stephens Church"
  },
  {
    "State": "VA",
    "City": "Saluda"
  },
  {
    "State": "VA",
    "City": "Sandston"
  },
  {
    "State": "VA",
    "City": "Sandy Hook"
  },
  {
    "State": "VA",
    "City": "Schley"
  },
  {
    "State": "VA",
    "City": "Severn"
  },
  {
    "State": "VA",
    "City": "Shacklefords"
  },
  {
    "State": "VA",
    "City": "State Farm"
  },
  {
    "State": "VA",
    "City": "Stevensville"
  },
  {
    "State": "VA",
    "City": "Studley"
  },
  {
    "State": "VA",
    "City": "Susan"
  },
  {
    "State": "VA",
    "City": "Toano"
  },
  {
    "State": "VA",
    "City": "Topping"
  },
  {
    "State": "VA",
    "City": "Trevilians"
  },
  {
    "State": "VA",
    "City": "Richmond"
  },
  {
    "State": "VA",
    "City": "Urbanna"
  },
  {
    "State": "VA",
    "City": "Wake"
  },
  {
    "State": "VA",
    "City": "Walkerton"
  },
  {
    "State": "VA",
    "City": "Ware Neck"
  },
  {
    "State": "VA",
    "City": "Water View"
  },
  {
    "State": "VA",
    "City": "West Point"
  },
  {
    "State": "VA",
    "City": "White Marsh"
  },
  {
    "State": "VA",
    "City": "Wicomico"
  },
  {
    "State": "VA",
    "City": "Williamsburg"
  },
  {
    "State": "VA",
    "City": "Woods Cross Roads"
  },
  {
    "State": "VA",
    "City": "Montpelier"
  },
  {
    "State": "VA",
    "City": "Accomac"
  },
  {
    "State": "VA",
    "City": "Assawoman"
  },
  {
    "State": "VA",
    "City": "Atlantic"
  },
  {
    "State": "VA",
    "City": "Battery Park"
  },
  {
    "State": "VA",
    "City": "Belle Haven"
  },
  {
    "State": "VA",
    "City": "Birdsnest"
  },
  {
    "State": "VA",
    "City": "Bloxom"
  },
  {
    "State": "VA",
    "City": "Cape Charles"
  },
  {
    "State": "VA",
    "City": "Capeville"
  },
  {
    "State": "VA",
    "City": "Carrollton"
  },
  {
    "State": "VA",
    "City": "Carrsville"
  },
  {
    "State": "VA",
    "City": "Cheriton"
  },
  {
    "State": "VA",
    "City": "Chesapeake"
  },
  {
    "State": "VA",
    "City": "Chincoteague Island"
  },
  {
    "State": "VA",
    "City": "Wallops Island"
  },
  {
    "State": "VA",
    "City": "Craddockville"
  },
  {
    "State": "VA",
    "City": "Davis Wharf"
  },
  {
    "State": "VA",
    "City": "Eastville"
  },
  {
    "State": "VA",
    "City": "Exmore"
  },
  {
    "State": "VA",
    "City": "Franktown"
  },
  {
    "State": "VA",
    "City": "Greenbackville"
  },
  {
    "State": "VA",
    "City": "Greenbush"
  },
  {
    "State": "VA",
    "City": "Hacksneck"
  },
  {
    "State": "VA",
    "City": "Hallwood"
  },
  {
    "State": "VA",
    "City": "Harborton"
  },
  {
    "State": "VA",
    "City": "Horntown"
  },
  {
    "State": "VA",
    "City": "Oak Hall"
  },
  {
    "State": "VA",
    "City": "Isle Of Wight"
  },
  {
    "State": "VA",
    "City": "Jamesville"
  },
  {
    "State": "VA",
    "City": "Jenkins Bridge"
  },
  {
    "State": "VA",
    "City": "Keller"
  },
  {
    "State": "VA",
    "City": "Locustville"
  },
  {
    "State": "VA",
    "City": "Machipongo"
  },
  {
    "State": "VA",
    "City": "Mappsville"
  },
  {
    "State": "VA",
    "City": "Marionville"
  },
  {
    "State": "VA",
    "City": "Mears"
  },
  {
    "State": "VA",
    "City": "Melfa"
  },
  {
    "State": "VA",
    "City": "Modest Town"
  },
  {
    "State": "VA",
    "City": "Nassawadox"
  },
  {
    "State": "VA",
    "City": "Nelsonia"
  },
  {
    "State": "VA",
    "City": "New Church"
  },
  {
    "State": "VA",
    "City": "Onancock"
  },
  {
    "State": "VA",
    "City": "Onley"
  },
  {
    "State": "VA",
    "City": "Oyster"
  },
  {
    "State": "VA",
    "City": "Painter"
  },
  {
    "State": "VA",
    "City": "Parksley"
  },
  {
    "State": "VA",
    "City": "Pungoteague"
  },
  {
    "State": "VA",
    "City": "Quinby"
  },
  {
    "State": "VA",
    "City": "Rescue"
  },
  {
    "State": "VA",
    "City": "Sanford"
  },
  {
    "State": "VA",
    "City": "Saxis"
  },
  {
    "State": "VA",
    "City": "Seaview"
  },
  {
    "State": "VA",
    "City": "Smithfield"
  },
  {
    "State": "VA",
    "City": "Suffolk"
  },
  {
    "State": "VA",
    "City": "Tangier"
  },
  {
    "State": "VA",
    "City": "Tasley"
  },
  {
    "State": "VA",
    "City": "Temperanceville"
  },
  {
    "State": "VA",
    "City": "Townsend"
  },
  {
    "State": "VA",
    "City": "Virginia Beach"
  },
  {
    "State": "VA",
    "City": "Wachapreague"
  },
  {
    "State": "VA",
    "City": "Wardtown"
  },
  {
    "State": "VA",
    "City": "Wattsville"
  },
  {
    "State": "VA",
    "City": "Willis Wharf"
  },
  {
    "State": "VA",
    "City": "Windsor"
  },
  {
    "State": "VA",
    "City": "Withams"
  },
  {
    "State": "VA",
    "City": "Norfolk"
  },
  {
    "State": "VA",
    "City": "Newport News"
  },
  {
    "State": "VA",
    "City": "Fort Eustis"
  },
  {
    "State": "VA",
    "City": "Hampton"
  },
  {
    "State": "VA",
    "City": "Fort Monroe"
  },
  {
    "State": "VA",
    "City": "Poquoson"
  },
  {
    "State": "VA",
    "City": "Yorktown"
  },
  {
    "State": "VA",
    "City": "Lackey"
  },
  {
    "State": "VA",
    "City": "Seaford"
  },
  {
    "State": "VA",
    "City": "Portsmouth"
  },
  {
    "State": "VA",
    "City": "Fort Lee"
  },
  {
    "State": "VA",
    "City": "Petersburg"
  },
  {
    "State": "VA",
    "City": "Virginia State University"
  },
  {
    "State": "VA",
    "City": "Alberta"
  },
  {
    "State": "VA",
    "City": "Ammon"
  },
  {
    "State": "VA",
    "City": "Blackstone"
  },
  {
    "State": "VA",
    "City": "Boykins"
  },
  {
    "State": "VA",
    "City": "Branchville"
  },
  {
    "State": "VA",
    "City": "Capron"
  },
  {
    "State": "VA",
    "City": "Carson"
  },
  {
    "State": "VA",
    "City": "Chester"
  },
  {
    "State": "VA",
    "City": "Chesterfield"
  },
  {
    "State": "VA",
    "City": "Church Road"
  },
  {
    "State": "VA",
    "City": "Colonial Heights"
  },
  {
    "State": "VA",
    "City": "Courtland"
  },
  {
    "State": "VA",
    "City": "Dendron"
  },
  {
    "State": "VA",
    "City": "Dewitt"
  },
  {
    "State": "VA",
    "City": "Dinwiddie"
  },
  {
    "State": "VA",
    "City": "Disputanta"
  },
  {
    "State": "VA",
    "City": "Dolphin"
  },
  {
    "State": "VA",
    "City": "Drewryville"
  },
  {
    "State": "VA",
    "City": "Ebony"
  },
  {
    "State": "VA",
    "City": "Elberon"
  },
  {
    "State": "VA",
    "City": "Emporia"
  },
  {
    "State": "VA",
    "City": "Ford"
  },
  {
    "State": "VA",
    "City": "Franklin"
  },
  {
    "State": "VA",
    "City": "Freeman"
  },
  {
    "State": "VA",
    "City": "Gasburg"
  },
  {
    "State": "VA",
    "City": "Hopewell"
  },
  {
    "State": "VA",
    "City": "Ivor"
  },
  {
    "State": "VA",
    "City": "Jarratt"
  },
  {
    "State": "VA",
    "City": "Lawrenceville"
  },
  {
    "State": "VA",
    "City": "Mc Kenney"
  },
  {
    "State": "VA",
    "City": "Meredithville"
  },
  {
    "State": "VA",
    "City": "Newsoms"
  },
  {
    "State": "VA",
    "City": "Prince George"
  },
  {
    "State": "VA",
    "City": "Rawlings"
  },
  {
    "State": "VA",
    "City": "Sedley"
  },
  {
    "State": "VA",
    "City": "Skippers"
  },
  {
    "State": "VA",
    "City": "Spring Grove"
  },
  {
    "State": "VA",
    "City": "Stony Creek"
  },
  {
    "State": "VA",
    "City": "Surry"
  },
  {
    "State": "VA",
    "City": "Sussex"
  },
  {
    "State": "VA",
    "City": "Sutherland"
  },
  {
    "State": "VA",
    "City": "Valentines"
  },
  {
    "State": "VA",
    "City": "Wakefield"
  },
  {
    "State": "VA",
    "City": "Warfield"
  },
  {
    "State": "VA",
    "City": "Waverly"
  },
  {
    "State": "VA",
    "City": "White Plains"
  },
  {
    "State": "VA",
    "City": "Wilsons"
  },
  {
    "State": "VA",
    "City": "Yale"
  },
  {
    "State": "VA",
    "City": "Zuni"
  },
  {
    "State": "VA",
    "City": "Claremont"
  },
  {
    "State": "VA",
    "City": "Farmville"
  },
  {
    "State": "VA",
    "City": "Baskerville"
  },
  {
    "State": "VA",
    "City": "Boydton"
  },
  {
    "State": "VA",
    "City": "Bracey"
  },
  {
    "State": "VA",
    "City": "Brodnax"
  },
  {
    "State": "VA",
    "City": "Buckingham"
  },
  {
    "State": "VA",
    "City": "Burkeville"
  },
  {
    "State": "VA",
    "City": "Charlotte Court House"
  },
  {
    "State": "VA",
    "City": "Chase City"
  },
  {
    "State": "VA",
    "City": "Clarksville"
  },
  {
    "State": "VA",
    "City": "Crewe"
  },
  {
    "State": "VA",
    "City": "Cullen"
  },
  {
    "State": "VA",
    "City": "Dillwyn"
  },
  {
    "State": "VA",
    "City": "Drakes Branch"
  },
  {
    "State": "VA",
    "City": "Dundas"
  },
  {
    "State": "VA",
    "City": "Evergreen"
  },
  {
    "State": "VA",
    "City": "Fort Mitchell"
  },
  {
    "State": "VA",
    "City": "Green Bay"
  },
  {
    "State": "VA",
    "City": "Hampden Sydney"
  },
  {
    "State": "VA",
    "City": "Kenbridge"
  },
  {
    "State": "VA",
    "City": "Keysville"
  },
  {
    "State": "VA",
    "City": "La Crosse"
  },
  {
    "State": "VA",
    "City": "Lunenburg"
  },
  {
    "State": "VA",
    "City": "Meherrin"
  },
  {
    "State": "VA",
    "City": "Nottoway"
  },
  {
    "State": "VA",
    "City": "Pamplin"
  },
  {
    "State": "VA",
    "City": "Phenix"
  },
  {
    "State": "VA",
    "City": "Prospect"
  },
  {
    "State": "VA",
    "City": "Randolph"
  },
  {
    "State": "VA",
    "City": "Red House"
  },
  {
    "State": "VA",
    "City": "Red Oak"
  },
  {
    "State": "VA",
    "City": "Rice"
  },
  {
    "State": "VA",
    "City": "Saxe"
  },
  {
    "State": "VA",
    "City": "Skipwith"
  },
  {
    "State": "VA",
    "City": "South Hill"
  },
  {
    "State": "VA",
    "City": "Victoria"
  },
  {
    "State": "VA",
    "City": "Wylliesburg"
  },
  {
    "State": "VA",
    "City": "Roanoke"
  },
  {
    "State": "VA",
    "City": "Ararat"
  },
  {
    "State": "VA",
    "City": "Axton"
  },
  {
    "State": "VA",
    "City": "Bassett"
  },
  {
    "State": "VA",
    "City": "Belspring"
  },
  {
    "State": "VA",
    "City": "Bent Mountain"
  },
  {
    "State": "VA",
    "City": "Blacksburg"
  },
  {
    "State": "VA",
    "City": "Blue Ridge"
  },
  {
    "State": "VA",
    "City": "Boones Mill"
  },
  {
    "State": "VA",
    "City": "Buchanan"
  },
  {
    "State": "VA",
    "City": "Callaway"
  },
  {
    "State": "VA",
    "City": "Christiansburg"
  },
  {
    "State": "VA",
    "City": "Cascade"
  },
  {
    "State": "VA",
    "City": "Catawba"
  },
  {
    "State": "VA",
    "City": "Check"
  },
  {
    "State": "VA",
    "City": "Claudville"
  },
  {
    "State": "VA",
    "City": "Cloverdale"
  },
  {
    "State": "VA",
    "City": "Collinsville"
  },
  {
    "State": "VA",
    "City": "Copper Hill"
  },
  {
    "State": "VA",
    "City": "Critz"
  },
  {
    "State": "VA",
    "City": "Daleville"
  },
  {
    "State": "VA",
    "City": "Dublin"
  },
  {
    "State": "VA",
    "City": "Eagle Rock"
  },
  {
    "State": "VA",
    "City": "Eggleston"
  },
  {
    "State": "VA",
    "City": "Elliston"
  },
  {
    "State": "VA",
    "City": "Ferrum"
  },
  {
    "State": "VA",
    "City": "Fieldale"
  },
  {
    "State": "VA",
    "City": "Fincastle"
  },
  {
    "State": "VA",
    "City": "Floyd"
  },
  {
    "State": "VA",
    "City": "Glade Hill"
  },
  {
    "State": "VA",
    "City": "Glen Lyn"
  },
  {
    "State": "VA",
    "City": "Goodview"
  },
  {
    "State": "VA",
    "City": "Hardy"
  },
  {
    "State": "VA",
    "City": "Henry"
  },
  {
    "State": "VA",
    "City": "Huddleston"
  },
  {
    "State": "VA",
    "City": "Indian Valley"
  },
  {
    "State": "VA",
    "City": "Mc Coy"
  },
  {
    "State": "VA",
    "City": "Martinsville"
  },
  {
    "State": "VA",
    "City": "Meadows Of Dan"
  },
  {
    "State": "VA",
    "City": "Moneta"
  },
  {
    "State": "VA",
    "City": "Montvale"
  },
  {
    "State": "VA",
    "City": "Narrows"
  },
  {
    "State": "VA",
    "City": "Newbern"
  },
  {
    "State": "VA",
    "City": "New Castle"
  },
  {
    "State": "VA",
    "City": "Newport"
  },
  {
    "State": "VA",
    "City": "New River"
  },
  {
    "State": "VA",
    "City": "Oriskany"
  },
  {
    "State": "VA",
    "City": "Paint Bank"
  },
  {
    "State": "VA",
    "City": "Parrott"
  },
  {
    "State": "VA",
    "City": "Patrick Springs"
  },
  {
    "State": "VA",
    "City": "Pearisburg"
  },
  {
    "State": "VA",
    "City": "Pembroke"
  },
  {
    "State": "VA",
    "City": "Penhook"
  },
  {
    "State": "VA",
    "City": "Pilot"
  },
  {
    "State": "VA",
    "City": "Pittsville"
  },
  {
    "State": "VA",
    "City": "Radford"
  },
  {
    "State": "VA",
    "City": "Redwood"
  },
  {
    "State": "VA",
    "City": "Rich Creek"
  },
  {
    "State": "VA",
    "City": "Ridgeway"
  },
  {
    "State": "VA",
    "City": "Riner"
  },
  {
    "State": "VA",
    "City": "Ripplemead"
  },
  {
    "State": "VA",
    "City": "Rocky Mount"
  },
  {
    "State": "VA",
    "City": "Salem"
  },
  {
    "State": "VA",
    "City": "Sandy Level"
  },
  {
    "State": "VA",
    "City": "Shawsville"
  },
  {
    "State": "VA",
    "City": "Spencer"
  },
  {
    "State": "VA",
    "City": "Staffordsville"
  },
  {
    "State": "VA",
    "City": "Stanleytown"
  },
  {
    "State": "VA",
    "City": "Stuart"
  },
  {
    "State": "VA",
    "City": "Thaxton"
  },
  {
    "State": "VA",
    "City": "Troutville"
  },
  {
    "State": "VA",
    "City": "Union Hall"
  },
  {
    "State": "VA",
    "City": "Vesta"
  },
  {
    "State": "VA",
    "City": "Villamont"
  },
  {
    "State": "VA",
    "City": "Vinton"
  },
  {
    "State": "VA",
    "City": "Wirtz"
  },
  {
    "State": "VA",
    "City": "Woolwine"
  },
  {
    "State": "VA",
    "City": "Bristol"
  },
  {
    "State": "VA",
    "City": "Abingdon"
  },
  {
    "State": "VA",
    "City": "Andover"
  },
  {
    "State": "VA",
    "City": "Appalachia"
  },
  {
    "State": "VA",
    "City": "Bee"
  },
  {
    "State": "VA",
    "City": "Ben Hur"
  },
  {
    "State": "VA",
    "City": "Big Stone Gap"
  },
  {
    "State": "VA",
    "City": "Birchleaf"
  },
  {
    "State": "VA",
    "City": "Blackwater"
  },
  {
    "State": "VA",
    "City": "Castlewood"
  },
  {
    "State": "VA",
    "City": "Cleveland"
  },
  {
    "State": "VA",
    "City": "Clinchco"
  },
  {
    "State": "VA",
    "City": "Clintwood"
  },
  {
    "State": "VA",
    "City": "Coeburn"
  },
  {
    "State": "VA",
    "City": "Damascus"
  },
  {
    "State": "VA",
    "City": "Dante"
  },
  {
    "State": "VA",
    "City": "Davenport"
  },
  {
    "State": "VA",
    "City": "Dryden"
  },
  {
    "State": "VA",
    "City": "Duffield"
  },
  {
    "State": "VA",
    "City": "Dungannon"
  },
  {
    "State": "VA",
    "City": "East Stone Gap"
  },
  {
    "State": "VA",
    "City": "Ewing"
  },
  {
    "State": "VA",
    "City": "Fort Blackmore"
  },
  {
    "State": "VA",
    "City": "Gate City"
  },
  {
    "State": "VA",
    "City": "Haysi"
  },
  {
    "State": "VA",
    "City": "Hiltons"
  },
  {
    "State": "VA",
    "City": "Honaker"
  },
  {
    "State": "VA",
    "City": "Jonesville"
  },
  {
    "State": "VA",
    "City": "Keokee"
  },
  {
    "State": "VA",
    "City": "Lebanon"
  },
  {
    "State": "VA",
    "City": "Mc Clure"
  },
  {
    "State": "VA",
    "City": "Mendota"
  },
  {
    "State": "VA",
    "City": "Nickelsville"
  },
  {
    "State": "VA",
    "City": "Nora"
  },
  {
    "State": "VA",
    "City": "Norton"
  },
  {
    "State": "VA",
    "City": "Pennington Gap"
  },
  {
    "State": "VA",
    "City": "Pound"
  },
  {
    "State": "VA",
    "City": "Rosedale"
  },
  {
    "State": "VA",
    "City": "Rose Hill"
  },
  {
    "State": "VA",
    "City": "Saint Charles"
  },
  {
    "State": "VA",
    "City": "Saint Paul"
  },
  {
    "State": "VA",
    "City": "Weber City"
  },
  {
    "State": "VA",
    "City": "Whitetop"
  },
  {
    "State": "VA",
    "City": "Wise"
  },
  {
    "State": "VA",
    "City": "Pulaski"
  },
  {
    "State": "VA",
    "City": "Atkins"
  },
  {
    "State": "VA",
    "City": "Austinville"
  },
  {
    "State": "VA",
    "City": "Barren Springs"
  },
  {
    "State": "VA",
    "City": "Bastian"
  },
  {
    "State": "VA",
    "City": "Bland"
  },
  {
    "State": "VA",
    "City": "Broadford"
  },
  {
    "State": "VA",
    "City": "Cana"
  },
  {
    "State": "VA",
    "City": "Ceres"
  },
  {
    "State": "VA",
    "City": "Chilhowie"
  },
  {
    "State": "VA",
    "City": "Cripple Creek"
  },
  {
    "State": "VA",
    "City": "Crockett"
  },
  {
    "State": "VA",
    "City": "Draper"
  },
  {
    "State": "VA",
    "City": "Dugspur"
  },
  {
    "State": "VA",
    "City": "Elk Creek"
  },
  {
    "State": "VA",
    "City": "Emory"
  },
  {
    "State": "VA",
    "City": "Fancy Gap"
  },
  {
    "State": "VA",
    "City": "Fries"
  },
  {
    "State": "VA",
    "City": "Galax"
  },
  {
    "State": "VA",
    "City": "Glade Spring"
  },
  {
    "State": "VA",
    "City": "Hillsville"
  },
  {
    "State": "VA",
    "City": "Hiwassee"
  },
  {
    "State": "VA",
    "City": "Independence"
  },
  {
    "State": "VA",
    "City": "Ivanhoe"
  },
  {
    "State": "VA",
    "City": "Lambsburg"
  },
  {
    "State": "VA",
    "City": "Laurel Fork"
  },
  {
    "State": "VA",
    "City": "Marion"
  },
  {
    "State": "VA",
    "City": "Max Meadows"
  },
  {
    "State": "VA",
    "City": "Meadowview"
  },
  {
    "State": "VA",
    "City": "Mouth Of Wilson"
  },
  {
    "State": "VA",
    "City": "Rocky Gap"
  },
  {
    "State": "VA",
    "City": "Rural Retreat"
  },
  {
    "State": "VA",
    "City": "Saltville"
  },
  {
    "State": "VA",
    "City": "Speedwell"
  },
  {
    "State": "VA",
    "City": "Sugar Grove"
  },
  {
    "State": "VA",
    "City": "Tannersville"
  },
  {
    "State": "VA",
    "City": "Troutdale"
  },
  {
    "State": "VA",
    "City": "Willis"
  },
  {
    "State": "VA",
    "City": "Woodlawn"
  },
  {
    "State": "VA",
    "City": "Wytheville"
  },
  {
    "State": "VA",
    "City": "Staunton"
  },
  {
    "State": "VA",
    "City": "Augusta Springs"
  },
  {
    "State": "VA",
    "City": "Bacova"
  },
  {
    "State": "VA",
    "City": "Blue Grass"
  },
  {
    "State": "VA",
    "City": "Brownsburg"
  },
  {
    "State": "VA",
    "City": "Buena Vista"
  },
  {
    "State": "VA",
    "City": "Churchville"
  },
  {
    "State": "VA",
    "City": "Clifton Forge"
  },
  {
    "State": "VA",
    "City": "Covington"
  },
  {
    "State": "VA",
    "City": "Craigsville"
  },
  {
    "State": "VA",
    "City": "Crimora"
  },
  {
    "State": "VA",
    "City": "Deerfield"
  },
  {
    "State": "VA",
    "City": "Doe Hill"
  },
  {
    "State": "VA",
    "City": "Fairfield"
  },
  {
    "State": "VA",
    "City": "Fort Defiance"
  },
  {
    "State": "VA",
    "City": "Glen Wilton"
  },
  {
    "State": "VA",
    "City": "Goshen"
  },
  {
    "State": "VA",
    "City": "Greenville"
  },
  {
    "State": "VA",
    "City": "Grottoes"
  },
  {
    "State": "VA",
    "City": "Head Waters"
  },
  {
    "State": "VA",
    "City": "Hot Springs"
  },
  {
    "State": "VA",
    "City": "Iron Gate"
  },
  {
    "State": "VA",
    "City": "Lexington"
  },
  {
    "State": "VA",
    "City": "Low Moor"
  },
  {
    "State": "VA",
    "City": "Mc Dowell"
  },
  {
    "State": "VA",
    "City": "Middlebrook"
  },
  {
    "State": "VA",
    "City": "Millboro"
  },
  {
    "State": "VA",
    "City": "Mint Spring"
  },
  {
    "State": "VA",
    "City": "Montebello"
  },
  {
    "State": "VA",
    "City": "Monterey"
  },
  {
    "State": "VA",
    "City": "Mount Sidney"
  },
  {
    "State": "VA",
    "City": "Mustoe"
  },
  {
    "State": "VA",
    "City": "New Hope"
  },
  {
    "State": "VA",
    "City": "Port Republic"
  },
  {
    "State": "VA",
    "City": "Raphine"
  },
  {
    "State": "VA",
    "City": "Rockbridge Baths"
  },
  {
    "State": "VA",
    "City": "Selma"
  },
  {
    "State": "VA",
    "City": "Steeles Tavern"
  },
  {
    "State": "VA",
    "City": "Stuarts Draft"
  },
  {
    "State": "VA",
    "City": "Swoope"
  },
  {
    "State": "VA",
    "City": "Verona"
  },
  {
    "State": "VA",
    "City": "Vesuvius"
  },
  {
    "State": "VA",
    "City": "Warm Springs"
  },
  {
    "State": "VA",
    "City": "West Augusta"
  },
  {
    "State": "VA",
    "City": "Weyers Cave"
  },
  {
    "State": "VA",
    "City": "Williamsville"
  },
  {
    "State": "VA",
    "City": "Lynchburg"
  },
  {
    "State": "VA",
    "City": "Altavista"
  },
  {
    "State": "VA",
    "City": "Alton"
  },
  {
    "State": "VA",
    "City": "Amherst"
  },
  {
    "State": "VA",
    "City": "Appomattox"
  },
  {
    "State": "VA",
    "City": "Bedford"
  },
  {
    "State": "VA",
    "City": "Big Island"
  },
  {
    "State": "VA",
    "City": "Blairs"
  },
  {
    "State": "VA",
    "City": "Brookneal"
  },
  {
    "State": "VA",
    "City": "Buffalo Junction"
  },
  {
    "State": "VA",
    "City": "Callands"
  },
  {
    "State": "VA",
    "City": "Chatham"
  },
  {
    "State": "VA",
    "City": "Clifford"
  },
  {
    "State": "VA",
    "City": "Clover"
  },
  {
    "State": "VA",
    "City": "Cluster Springs"
  },
  {
    "State": "VA",
    "City": "Coleman Falls"
  },
  {
    "State": "VA",
    "City": "Concord"
  },
  {
    "State": "VA",
    "City": "Crystal Hill"
  },
  {
    "State": "VA",
    "City": "Danville"
  },
  {
    "State": "VA",
    "City": "Dry Fork"
  },
  {
    "State": "VA",
    "City": "Evington"
  },
  {
    "State": "VA",
    "City": "Forest"
  },
  {
    "State": "VA",
    "City": "Gladstone"
  },
  {
    "State": "VA",
    "City": "Gladys"
  },
  {
    "State": "VA",
    "City": "Glasgow"
  },
  {
    "State": "VA",
    "City": "Goode"
  },
  {
    "State": "VA",
    "City": "Gretna"
  },
  {
    "State": "VA",
    "City": "Halifax"
  },
  {
    "State": "VA",
    "City": "Howardsville"
  },
  {
    "State": "VA",
    "City": "Hurt"
  },
  {
    "State": "VA",
    "City": "Java"
  },
  {
    "State": "VA",
    "City": "Keeling"
  },
  {
    "State": "VA",
    "City": "Long Island"
  },
  {
    "State": "VA",
    "City": "Lowry"
  },
  {
    "State": "VA",
    "City": "Lynch Station"
  },
  {
    "State": "VA",
    "City": "Madison Heights"
  },
  {
    "State": "VA",
    "City": "Monroe"
  },
  {
    "State": "VA",
    "City": "Naruna"
  },
  {
    "State": "VA",
    "City": "Nathalie"
  },
  {
    "State": "VA",
    "City": "Natural Bridge"
  },
  {
    "State": "VA",
    "City": "Natural Bridge Station"
  },
  {
    "State": "VA",
    "City": "Nelson"
  },
  {
    "State": "VA",
    "City": "Norwood"
  },
  {
    "State": "VA",
    "City": "Ringgold"
  },
  {
    "State": "VA",
    "City": "Rustburg"
  },
  {
    "State": "VA",
    "City": "Scottsburg"
  },
  {
    "State": "VA",
    "City": "Scottsville"
  },
  {
    "State": "VA",
    "City": "South Boston"
  },
  {
    "State": "VA",
    "City": "Spout Spring"
  },
  {
    "State": "VA",
    "City": "Sutherlin"
  },
  {
    "State": "VA",
    "City": "Sweet Briar"
  },
  {
    "State": "VA",
    "City": "Vernon Hill"
  },
  {
    "State": "VA",
    "City": "Virgilina"
  },
  {
    "State": "VA",
    "City": "Wingina"
  },
  {
    "State": "VA",
    "City": "Amonate"
  },
  {
    "State": "VA",
    "City": "Bandy"
  },
  {
    "State": "VA",
    "City": "Big Rock"
  },
  {
    "State": "VA",
    "City": "Bishop"
  },
  {
    "State": "VA",
    "City": "Bluefield"
  },
  {
    "State": "VA",
    "City": "Boissevain"
  },
  {
    "State": "VA",
    "City": "Breaks"
  },
  {
    "State": "VA",
    "City": "Burkes Garden"
  },
  {
    "State": "VA",
    "City": "Cedar Bluff"
  },
  {
    "State": "VA",
    "City": "Doran"
  },
  {
    "State": "VA",
    "City": "Falls Mills"
  },
  {
    "State": "VA",
    "City": "Grundy"
  },
  {
    "State": "VA",
    "City": "Horsepen"
  },
  {
    "State": "VA",
    "City": "Hurley"
  },
  {
    "State": "VA",
    "City": "Jewell Ridge"
  },
  {
    "State": "VA",
    "City": "Keen Mountain"
  },
  {
    "State": "VA",
    "City": "Mavisdale"
  },
  {
    "State": "VA",
    "City": "Maxie"
  },
  {
    "State": "VA",
    "City": "North Tazewell"
  },
  {
    "State": "VA",
    "City": "Oakwood"
  },
  {
    "State": "VA",
    "City": "Pilgrims Knob"
  },
  {
    "State": "VA",
    "City": "Pocahontas"
  },
  {
    "State": "VA",
    "City": "Pounding Mill"
  },
  {
    "State": "VA",
    "City": "Raven"
  },
  {
    "State": "VA",
    "City": "Red Ash"
  },
  {
    "State": "VA",
    "City": "Richlands"
  },
  {
    "State": "VA",
    "City": "Rowe"
  },
  {
    "State": "VA",
    "City": "Shortt Gap"
  },
  {
    "State": "VA",
    "City": "Swords Creek"
  },
  {
    "State": "VA",
    "City": "Tazewell"
  },
  {
    "State": "VA",
    "City": "Vansant"
  },
  {
    "State": "VA",
    "City": "Whitewood"
  },
  {
    "State": "VA",
    "City": "Wolford"
  },
  {
    "State": "WV",
    "City": "Bluefield"
  },
  {
    "State": "WV",
    "City": "Athens"
  },
  {
    "State": "WV",
    "City": "Beeson"
  },
  {
    "State": "WV",
    "City": "Bramwell"
  },
  {
    "State": "WV",
    "City": "Bud"
  },
  {
    "State": "WV",
    "City": "Covel"
  },
  {
    "State": "WV",
    "City": "Freeman"
  },
  {
    "State": "WV",
    "City": "Herndon"
  },
  {
    "State": "WV",
    "City": "Hiawatha"
  },
  {
    "State": "WV",
    "City": "Kegley"
  },
  {
    "State": "WV",
    "City": "Kellysville"
  },
  {
    "State": "WV",
    "City": "Lashmeet"
  },
  {
    "State": "WV",
    "City": "Matoaka"
  },
  {
    "State": "WV",
    "City": "Montcalm"
  },
  {
    "State": "WV",
    "City": "Nemours"
  },
  {
    "State": "WV",
    "City": "Princeton"
  },
  {
    "State": "WV",
    "City": "Rock"
  },
  {
    "State": "WV",
    "City": "Wolfe"
  },
  {
    "State": "WV",
    "City": "Welch"
  },
  {
    "State": "WV",
    "City": "Anawalt"
  },
  {
    "State": "WV",
    "City": "Avondale"
  },
  {
    "State": "WV",
    "City": "Bartley"
  },
  {
    "State": "WV",
    "City": "Berwind"
  },
  {
    "State": "WV",
    "City": "Big Sandy"
  },
  {
    "State": "WV",
    "City": "Bradshaw"
  },
  {
    "State": "WV",
    "City": "Brenton"
  },
  {
    "State": "WV",
    "City": "Clear Fork"
  },
  {
    "State": "WV",
    "City": "Coal Mountain"
  },
  {
    "State": "WV",
    "City": "Cucumber"
  },
  {
    "State": "WV",
    "City": "Cyclone"
  },
  {
    "State": "WV",
    "City": "Davy"
  },
  {
    "State": "WV",
    "City": "Eckman"
  },
  {
    "State": "WV",
    "City": "Elbert"
  },
  {
    "State": "WV",
    "City": "Elkhorn"
  },
  {
    "State": "WV",
    "City": "Fanrock"
  },
  {
    "State": "WV",
    "City": "Gary"
  },
  {
    "State": "WV",
    "City": "Hanover"
  },
  {
    "State": "WV",
    "City": "Hemphill"
  },
  {
    "State": "WV",
    "City": "Hensley"
  },
  {
    "State": "WV",
    "City": "Iaeger"
  },
  {
    "State": "WV",
    "City": "Ikes Fork"
  },
  {
    "State": "WV",
    "City": "Isaban"
  },
  {
    "State": "WV",
    "City": "Itmann"
  },
  {
    "State": "WV",
    "City": "Jenkinjones"
  },
  {
    "State": "WV",
    "City": "Jesse"
  },
  {
    "State": "WV",
    "City": "Jolo"
  },
  {
    "State": "WV",
    "City": "Justice"
  },
  {
    "State": "WV",
    "City": "Kimball"
  },
  {
    "State": "WV",
    "City": "Kopperston"
  },
  {
    "State": "WV",
    "City": "Kyle"
  },
  {
    "State": "WV",
    "City": "Lynco"
  },
  {
    "State": "WV",
    "City": "Marianna"
  },
  {
    "State": "WV",
    "City": "Matheny"
  },
  {
    "State": "WV",
    "City": "Maybeury"
  },
  {
    "State": "WV",
    "City": "Mohawk"
  },
  {
    "State": "WV",
    "City": "Newhall"
  },
  {
    "State": "WV",
    "City": "New Richmond"
  },
  {
    "State": "WV",
    "City": "Northfork"
  },
  {
    "State": "WV",
    "City": "North Spring"
  },
  {
    "State": "WV",
    "City": "Oceana"
  },
  {
    "State": "WV",
    "City": "Pageton"
  },
  {
    "State": "WV",
    "City": "Panther"
  },
  {
    "State": "WV",
    "City": "Paynesville"
  },
  {
    "State": "WV",
    "City": "Pineville"
  },
  {
    "State": "WV",
    "City": "Premier"
  },
  {
    "State": "WV",
    "City": "Raysal"
  },
  {
    "State": "WV",
    "City": "Rock View"
  },
  {
    "State": "WV",
    "City": "Roderfield"
  },
  {
    "State": "WV",
    "City": "Simon"
  },
  {
    "State": "WV",
    "City": "Squire"
  },
  {
    "State": "WV",
    "City": "Switchback"
  },
  {
    "State": "WV",
    "City": "Thorpe"
  },
  {
    "State": "WV",
    "City": "War"
  },
  {
    "State": "WV",
    "City": "Warriormine"
  },
  {
    "State": "WV",
    "City": "Wilcoe"
  },
  {
    "State": "WV",
    "City": "Wyoming"
  },
  {
    "State": "WV",
    "City": "Lewisburg"
  },
  {
    "State": "WV",
    "City": "Fairlea"
  },
  {
    "State": "WV",
    "City": "Alderson"
  },
  {
    "State": "WV",
    "City": "Arbovale"
  },
  {
    "State": "WV",
    "City": "Asbury"
  },
  {
    "State": "WV",
    "City": "Ballard"
  },
  {
    "State": "WV",
    "City": "Bartow"
  },
  {
    "State": "WV",
    "City": "Buckeye"
  },
  {
    "State": "WV",
    "City": "Caldwell"
  },
  {
    "State": "WV",
    "City": "Cass"
  },
  {
    "State": "WV",
    "City": "Crawley"
  },
  {
    "State": "WV",
    "City": "Dunmore"
  },
  {
    "State": "WV",
    "City": "Forest Hill"
  },
  {
    "State": "WV",
    "City": "Frankford"
  },
  {
    "State": "WV",
    "City": "Gap Mills"
  },
  {
    "State": "WV",
    "City": "Grassy Meadows"
  },
  {
    "State": "WV",
    "City": "Green Bank"
  },
  {
    "State": "WV",
    "City": "Greenville"
  },
  {
    "State": "WV",
    "City": "Hillsboro"
  },
  {
    "State": "WV",
    "City": "Lindside"
  },
  {
    "State": "WV",
    "City": "Marlinton"
  },
  {
    "State": "WV",
    "City": "Maxwelton"
  },
  {
    "State": "WV",
    "City": "White Sulphur Springs"
  },
  {
    "State": "WV",
    "City": "Pence Springs"
  },
  {
    "State": "WV",
    "City": "Peterstown"
  },
  {
    "State": "WV",
    "City": "Renick"
  },
  {
    "State": "WV",
    "City": "Ronceverte"
  },
  {
    "State": "WV",
    "City": "Secondcreek"
  },
  {
    "State": "WV",
    "City": "Sinks Grove"
  },
  {
    "State": "WV",
    "City": "Smoot"
  },
  {
    "State": "WV",
    "City": "Talcott"
  },
  {
    "State": "WV",
    "City": "Union"
  },
  {
    "State": "WV",
    "City": "Waiteville"
  },
  {
    "State": "WV",
    "City": "Wayside"
  },
  {
    "State": "WV",
    "City": "Williamsburg"
  },
  {
    "State": "WV",
    "City": "Wolfcreek"
  },
  {
    "State": "WV",
    "City": "Alloy"
  },
  {
    "State": "WV",
    "City": "Alum Creek"
  },
  {
    "State": "WV",
    "City": "Amma"
  },
  {
    "State": "WV",
    "City": "Arnett"
  },
  {
    "State": "WV",
    "City": "Artie"
  },
  {
    "State": "WV",
    "City": "Ashford"
  },
  {
    "State": "WV",
    "City": "Bancroft"
  },
  {
    "State": "WV",
    "City": "Belle"
  },
  {
    "State": "WV",
    "City": "Bickmore"
  },
  {
    "State": "WV",
    "City": "Bim"
  },
  {
    "State": "WV",
    "City": "Blair"
  },
  {
    "State": "WV",
    "City": "Bloomingrose"
  },
  {
    "State": "WV",
    "City": "Blount"
  },
  {
    "State": "WV",
    "City": "Blue Creek"
  },
  {
    "State": "WV",
    "City": "Bob White"
  },
  {
    "State": "WV",
    "City": "Bomont"
  },
  {
    "State": "WV",
    "City": "Boomer"
  },
  {
    "State": "WV",
    "City": "Buffalo"
  },
  {
    "State": "WV",
    "City": "Cabin Creek"
  },
  {
    "State": "WV",
    "City": "Cannelton"
  },
  {
    "State": "WV",
    "City": "Cedar Grove"
  },
  {
    "State": "WV",
    "City": "Charlton Heights"
  },
  {
    "State": "WV",
    "City": "Clay"
  },
  {
    "State": "WV",
    "City": "Clear Creek"
  },
  {
    "State": "WV",
    "City": "Clendenin"
  },
  {
    "State": "WV",
    "City": "Clothier"
  },
  {
    "State": "WV",
    "City": "Colcord"
  },
  {
    "State": "WV",
    "City": "Comfort"
  },
  {
    "State": "WV",
    "City": "Costa"
  },
  {
    "State": "WV",
    "City": "Danville"
  },
  {
    "State": "WV",
    "City": "Dawes"
  },
  {
    "State": "WV",
    "City": "Deep Water"
  },
  {
    "State": "WV",
    "City": "Dixie"
  },
  {
    "State": "WV",
    "City": "Dorothy"
  },
  {
    "State": "WV",
    "City": "Drybranch"
  },
  {
    "State": "WV",
    "City": "Dry Creek"
  },
  {
    "State": "WV",
    "City": "Duck"
  },
  {
    "State": "WV",
    "City": "Dunbar"
  },
  {
    "State": "WV",
    "City": "East Bank"
  },
  {
    "State": "WV",
    "City": "Eleanor"
  },
  {
    "State": "WV",
    "City": "Elkview"
  },
  {
    "State": "WV",
    "City": "Eskdale"
  },
  {
    "State": "WV",
    "City": "Ethel"
  },
  {
    "State": "WV",
    "City": "Falling Rock"
  },
  {
    "State": "WV",
    "City": "Foster"
  },
  {
    "State": "WV",
    "City": "Fraziers Bottom"
  },
  {
    "State": "WV",
    "City": "Gallagher"
  },
  {
    "State": "WV",
    "City": "Gauley Bridge"
  },
  {
    "State": "WV",
    "City": "Glasgow"
  },
  {
    "State": "WV",
    "City": "Glen"
  },
  {
    "State": "WV",
    "City": "Glen Ferris"
  },
  {
    "State": "WV",
    "City": "Gordon"
  },
  {
    "State": "WV",
    "City": "Handley"
  },
  {
    "State": "WV",
    "City": "Hansford"
  },
  {
    "State": "WV",
    "City": "Henderson"
  },
  {
    "State": "WV",
    "City": "Hernshaw"
  },
  {
    "State": "WV",
    "City": "Hewett"
  },
  {
    "State": "WV",
    "City": "Hometown"
  },
  {
    "State": "WV",
    "City": "Hugheston"
  },
  {
    "State": "WV",
    "City": "Indore"
  },
  {
    "State": "WV",
    "City": "Institute"
  },
  {
    "State": "WV",
    "City": "Ivydale"
  },
  {
    "State": "WV",
    "City": "Jeffrey"
  },
  {
    "State": "WV",
    "City": "Kanawha Falls"
  },
  {
    "State": "WV",
    "City": "Kimberly"
  },
  {
    "State": "WV",
    "City": "Kincaid"
  },
  {
    "State": "WV",
    "City": "Lake"
  },
  {
    "State": "WV",
    "City": "Leon"
  },
  {
    "State": "WV",
    "City": "Liberty"
  },
  {
    "State": "WV",
    "City": "Lizemores"
  },
  {
    "State": "WV",
    "City": "London"
  },
  {
    "State": "WV",
    "City": "Madison"
  },
  {
    "State": "WV",
    "City": "Mammoth"
  },
  {
    "State": "WV",
    "City": "Maysel"
  },
  {
    "State": "WV",
    "City": "Miami"
  },
  {
    "State": "WV",
    "City": "Montgomery"
  },
  {
    "State": "WV",
    "City": "Mount Carbon"
  },
  {
    "State": "WV",
    "City": "Naoma"
  },
  {
    "State": "WV",
    "City": "Nebo"
  },
  {
    "State": "WV",
    "City": "Nellis"
  },
  {
    "State": "WV",
    "City": "Nitro"
  },
  {
    "State": "WV",
    "City": "Orgas"
  },
  {
    "State": "WV",
    "City": "Ottawa"
  },
  {
    "State": "WV",
    "City": "Page"
  },
  {
    "State": "WV",
    "City": "Peytona"
  },
  {
    "State": "WV",
    "City": "Pinch"
  },
  {
    "State": "WV",
    "City": "Poca"
  },
  {
    "State": "WV",
    "City": "Pond Gap"
  },
  {
    "State": "WV",
    "City": "Powellton"
  },
  {
    "State": "WV",
    "City": "Pratt"
  },
  {
    "State": "WV",
    "City": "Procious"
  },
  {
    "State": "WV",
    "City": "Racine"
  },
  {
    "State": "WV",
    "City": "Red House"
  },
  {
    "State": "WV",
    "City": "Ridgeview"
  },
  {
    "State": "WV",
    "City": "Robson"
  },
  {
    "State": "WV",
    "City": "Rock Creek"
  },
  {
    "State": "WV",
    "City": "Saint Albans"
  },
  {
    "State": "WV",
    "City": "Saxon"
  },
  {
    "State": "WV",
    "City": "Seth"
  },
  {
    "State": "WV",
    "City": "Sharples"
  },
  {
    "State": "WV",
    "City": "Mount Olive"
  },
  {
    "State": "WV",
    "City": "Smithers"
  },
  {
    "State": "WV",
    "City": "Southside"
  },
  {
    "State": "WV",
    "City": "Sylvester"
  },
  {
    "State": "WV",
    "City": "Tad"
  },
  {
    "State": "WV",
    "City": "Tornado"
  },
  {
    "State": "WV",
    "City": "Turtle Creek"
  },
  {
    "State": "WV",
    "City": "Twilight"
  },
  {
    "State": "WV",
    "City": "Uneeda"
  },
  {
    "State": "WV",
    "City": "Van"
  },
  {
    "State": "WV",
    "City": "Wharton"
  },
  {
    "State": "WV",
    "City": "Whitesville"
  },
  {
    "State": "WV",
    "City": "Widen"
  },
  {
    "State": "WV",
    "City": "Winfield"
  },
  {
    "State": "WV",
    "City": "Winifrede"
  },
  {
    "State": "WV",
    "City": "Advent"
  },
  {
    "State": "WV",
    "City": "Arnoldsburg"
  },
  {
    "State": "WV",
    "City": "Chloe"
  },
  {
    "State": "WV",
    "City": "Cottageville"
  },
  {
    "State": "WV",
    "City": "Evans"
  },
  {
    "State": "WV",
    "City": "Gandeeville"
  },
  {
    "State": "WV",
    "City": "Gay"
  },
  {
    "State": "WV",
    "City": "Given"
  },
  {
    "State": "WV",
    "City": "Hartford"
  },
  {
    "State": "WV",
    "City": "Kenna"
  },
  {
    "State": "WV",
    "City": "Left Hand"
  },
  {
    "State": "WV",
    "City": "Le Roy"
  },
  {
    "State": "WV",
    "City": "Letart"
  },
  {
    "State": "WV",
    "City": "Looneyville"
  },
  {
    "State": "WV",
    "City": "Mason"
  },
  {
    "State": "WV",
    "City": "Millstone"
  },
  {
    "State": "WV",
    "City": "Millwood"
  },
  {
    "State": "WV",
    "City": "Mount Alto"
  },
  {
    "State": "WV",
    "City": "New Haven"
  },
  {
    "State": "WV",
    "City": "Newton"
  },
  {
    "State": "WV",
    "City": "Normantown"
  },
  {
    "State": "WV",
    "City": "Orma"
  },
  {
    "State": "WV",
    "City": "Reedy"
  },
  {
    "State": "WV",
    "City": "Ripley"
  },
  {
    "State": "WV",
    "City": "Sandyville"
  },
  {
    "State": "WV",
    "City": "Spencer"
  },
  {
    "State": "WV",
    "City": "Wallback"
  },
  {
    "State": "WV",
    "City": "Walton"
  },
  {
    "State": "WV",
    "City": "West Columbia"
  },
  {
    "State": "WV",
    "City": "Charleston"
  },
  {
    "State": "WV",
    "City": "South Charleston"
  },
  {
    "State": "WV",
    "City": "Martinsburg"
  },
  {
    "State": "WV",
    "City": "Bakerton"
  },
  {
    "State": "WV",
    "City": "Berkeley Springs"
  },
  {
    "State": "WV",
    "City": "Bunker Hill"
  },
  {
    "State": "WV",
    "City": "Charles Town"
  },
  {
    "State": "WV",
    "City": "Falling Waters"
  },
  {
    "State": "WV",
    "City": "Gerrardstown"
  },
  {
    "State": "WV",
    "City": "Glengary"
  },
  {
    "State": "WV",
    "City": "Great Cacapon"
  },
  {
    "State": "WV",
    "City": "Halltown"
  },
  {
    "State": "WV",
    "City": "Harpers Ferry"
  },
  {
    "State": "WV",
    "City": "Hedgesville"
  },
  {
    "State": "WV",
    "City": "Inwood"
  },
  {
    "State": "WV",
    "City": "Kearneysville"
  },
  {
    "State": "WV",
    "City": "Levels"
  },
  {
    "State": "WV",
    "City": "Millville"
  },
  {
    "State": "WV",
    "City": "Paw Paw"
  },
  {
    "State": "WV",
    "City": "Points"
  },
  {
    "State": "WV",
    "City": "Ranson"
  },
  {
    "State": "WV",
    "City": "Ridgeway"
  },
  {
    "State": "WV",
    "City": "Rippon"
  },
  {
    "State": "WV",
    "City": "Shenandoah Junction"
  },
  {
    "State": "WV",
    "City": "Shepherdstown"
  },
  {
    "State": "WV",
    "City": "Slanesville"
  },
  {
    "State": "WV",
    "City": "Summit Point"
  },
  {
    "State": "WV",
    "City": "Alkol"
  },
  {
    "State": "WV",
    "City": "Apple Grove"
  },
  {
    "State": "WV",
    "City": "Ashton"
  },
  {
    "State": "WV",
    "City": "Barboursville"
  },
  {
    "State": "WV",
    "City": "Big Creek"
  },
  {
    "State": "WV",
    "City": "Branchland"
  },
  {
    "State": "WV",
    "City": "Ceredo"
  },
  {
    "State": "WV",
    "City": "Chapmanville"
  },
  {
    "State": "WV",
    "City": "Culloden"
  },
  {
    "State": "WV",
    "City": "Dunlow"
  },
  {
    "State": "WV",
    "City": "East Lynn"
  },
  {
    "State": "WV",
    "City": "Fort Gay"
  },
  {
    "State": "WV",
    "City": "Gallipolis Ferry"
  },
  {
    "State": "WV",
    "City": "Genoa"
  },
  {
    "State": "WV",
    "City": "Glenwood"
  },
  {
    "State": "WV",
    "City": "Griffithsville"
  },
  {
    "State": "WV",
    "City": "Hamlin"
  },
  {
    "State": "WV",
    "City": "Harts"
  },
  {
    "State": "WV",
    "City": "Hurricane"
  },
  {
    "State": "WV",
    "City": "Julian"
  },
  {
    "State": "WV",
    "City": "Kenova"
  },
  {
    "State": "WV",
    "City": "Kiahsville"
  },
  {
    "State": "WV",
    "City": "Lavalette"
  },
  {
    "State": "WV",
    "City": "Lesage"
  },
  {
    "State": "WV",
    "City": "Midkiff"
  },
  {
    "State": "WV",
    "City": "Milton"
  },
  {
    "State": "WV",
    "City": "Myra"
  },
  {
    "State": "WV",
    "City": "Ona"
  },
  {
    "State": "WV",
    "City": "Pecks Mill"
  },
  {
    "State": "WV",
    "City": "Point Pleasant"
  },
  {
    "State": "WV",
    "City": "Prichard"
  },
  {
    "State": "WV",
    "City": "Ranger"
  },
  {
    "State": "WV",
    "City": "Salt Rock"
  },
  {
    "State": "WV",
    "City": "Scott Depot"
  },
  {
    "State": "WV",
    "City": "Shoals"
  },
  {
    "State": "WV",
    "City": "Sod"
  },
  {
    "State": "WV",
    "City": "Spurlockville"
  },
  {
    "State": "WV",
    "City": "Sumerco"
  },
  {
    "State": "WV",
    "City": "Teays"
  },
  {
    "State": "WV",
    "City": "Wayne"
  },
  {
    "State": "WV",
    "City": "West Hamlin"
  },
  {
    "State": "WV",
    "City": "Woodville"
  },
  {
    "State": "WV",
    "City": "Yawkey"
  },
  {
    "State": "WV",
    "City": "Logan"
  },
  {
    "State": "WV",
    "City": "Accoville"
  },
  {
    "State": "WV",
    "City": "Amherstdale"
  },
  {
    "State": "WV",
    "City": "Baisden"
  },
  {
    "State": "WV",
    "City": "Bruno"
  },
  {
    "State": "WV",
    "City": "Chauncey"
  },
  {
    "State": "WV",
    "City": "Cora"
  },
  {
    "State": "WV",
    "City": "Davin"
  },
  {
    "State": "WV",
    "City": "Gilbert"
  },
  {
    "State": "WV",
    "City": "Henlawson"
  },
  {
    "State": "WV",
    "City": "Holden"
  },
  {
    "State": "WV",
    "City": "Kistler"
  },
  {
    "State": "WV",
    "City": "Lorado"
  },
  {
    "State": "WV",
    "City": "Lyburn"
  },
  {
    "State": "WV",
    "City": "Mallory"
  },
  {
    "State": "WV",
    "City": "Man"
  },
  {
    "State": "WV",
    "City": "Mount Gay"
  },
  {
    "State": "WV",
    "City": "Omar"
  },
  {
    "State": "WV",
    "City": "Peach Creek"
  },
  {
    "State": "WV",
    "City": "Sarah Ann"
  },
  {
    "State": "WV",
    "City": "Stollings"
  },
  {
    "State": "WV",
    "City": "Switzer"
  },
  {
    "State": "WV",
    "City": "Verdunville"
  },
  {
    "State": "WV",
    "City": "Verner"
  },
  {
    "State": "WV",
    "City": "Wharncliffe"
  },
  {
    "State": "WV",
    "City": "Whitman"
  },
  {
    "State": "WV",
    "City": "Wilkinson"
  },
  {
    "State": "WV",
    "City": "Yolyn"
  },
  {
    "State": "WV",
    "City": "Williamson"
  },
  {
    "State": "WV",
    "City": "Borderland"
  },
  {
    "State": "WV",
    "City": "Breeden"
  },
  {
    "State": "WV",
    "City": "Chattaroy"
  },
  {
    "State": "WV",
    "City": "Crum"
  },
  {
    "State": "WV",
    "City": "Delbarton"
  },
  {
    "State": "WV",
    "City": "Dingess"
  },
  {
    "State": "WV",
    "City": "Edgarton"
  },
  {
    "State": "WV",
    "City": "Kermit"
  },
  {
    "State": "WV",
    "City": "Lenore"
  },
  {
    "State": "WV",
    "City": "Matewan"
  },
  {
    "State": "WV",
    "City": "Naugatuck"
  },
  {
    "State": "WV",
    "City": "Newtown"
  },
  {
    "State": "WV",
    "City": "North Matewan"
  },
  {
    "State": "WV",
    "City": "Ragland"
  },
  {
    "State": "WV",
    "City": "Rawl"
  },
  {
    "State": "WV",
    "City": "Red Jacket"
  },
  {
    "State": "WV",
    "City": "Varney"
  },
  {
    "State": "WV",
    "City": "Wilsondale"
  },
  {
    "State": "WV",
    "City": "Huntington"
  },
  {
    "State": "WV",
    "City": "Beckley"
  },
  {
    "State": "WV",
    "City": "Allen Junction"
  },
  {
    "State": "WV",
    "City": "Amigo"
  },
  {
    "State": "WV",
    "City": "Ansted"
  },
  {
    "State": "WV",
    "City": "Beaver"
  },
  {
    "State": "WV",
    "City": "Bolt"
  },
  {
    "State": "WV",
    "City": "Bradley"
  },
  {
    "State": "WV",
    "City": "Camp Creek"
  },
  {
    "State": "WV",
    "City": "Coal City"
  },
  {
    "State": "WV",
    "City": "Cool Ridge"
  },
  {
    "State": "WV",
    "City": "Corinne"
  },
  {
    "State": "WV",
    "City": "Crab Orchard"
  },
  {
    "State": "WV",
    "City": "Danese"
  },
  {
    "State": "WV",
    "City": "Daniels"
  },
  {
    "State": "WV",
    "City": "Dothan"
  },
  {
    "State": "WV",
    "City": "Eccles"
  },
  {
    "State": "WV",
    "City": "Edmond"
  },
  {
    "State": "WV",
    "City": "Fairdale"
  },
  {
    "State": "WV",
    "City": "Fayetteville"
  },
  {
    "State": "WV",
    "City": "Flat Top"
  },
  {
    "State": "WV",
    "City": "Ghent"
  },
  {
    "State": "WV",
    "City": "Glen Daniel"
  },
  {
    "State": "WV",
    "City": "Glen Fork"
  },
  {
    "State": "WV",
    "City": "Glen Jean"
  },
  {
    "State": "WV",
    "City": "Glen Rogers"
  },
  {
    "State": "WV",
    "City": "Glen White"
  },
  {
    "State": "WV",
    "City": "Harper"
  },
  {
    "State": "WV",
    "City": "Helen"
  },
  {
    "State": "WV",
    "City": "Hico"
  },
  {
    "State": "WV",
    "City": "Hilltop"
  },
  {
    "State": "WV",
    "City": "Josephine"
  },
  {
    "State": "WV",
    "City": "Lanark"
  },
  {
    "State": "WV",
    "City": "Lansing"
  },
  {
    "State": "WV",
    "City": "Layland"
  },
  {
    "State": "WV",
    "City": "Lester"
  },
  {
    "State": "WV",
    "City": "Lochgelly"
  },
  {
    "State": "WV",
    "City": "Lookout"
  },
  {
    "State": "WV",
    "City": "Maben"
  },
  {
    "State": "WV",
    "City": "Mabscott"
  },
  {
    "State": "WV",
    "City": "Mac Arthur"
  },
  {
    "State": "WV",
    "City": "Mc Graws"
  },
  {
    "State": "WV",
    "City": "Saulsville"
  },
  {
    "State": "WV",
    "City": "Midway"
  },
  {
    "State": "WV",
    "City": "Minden"
  },
  {
    "State": "WV",
    "City": "Mount Hope"
  },
  {
    "State": "WV",
    "City": "Mullens"
  },
  {
    "State": "WV",
    "City": "Oak Hill"
  },
  {
    "State": "WV",
    "City": "Odd"
  },
  {
    "State": "WV",
    "City": "Pax"
  },
  {
    "State": "WV",
    "City": "Piney View"
  },
  {
    "State": "WV",
    "City": "Prince"
  },
  {
    "State": "WV",
    "City": "Princewick"
  },
  {
    "State": "WV",
    "City": "Prosperity"
  },
  {
    "State": "WV",
    "City": "Raleigh"
  },
  {
    "State": "WV",
    "City": "Ravencliff"
  },
  {
    "State": "WV",
    "City": "Rhodell"
  },
  {
    "State": "WV",
    "City": "Sabine"
  },
  {
    "State": "WV",
    "City": "Scarbro"
  },
  {
    "State": "WV",
    "City": "Shady Spring"
  },
  {
    "State": "WV",
    "City": "Skelton"
  },
  {
    "State": "WV",
    "City": "Slab Fork"
  },
  {
    "State": "WV",
    "City": "Sophia"
  },
  {
    "State": "WV",
    "City": "Spanishburg"
  },
  {
    "State": "WV",
    "City": "Stanaford"
  },
  {
    "State": "WV",
    "City": "Stephenson"
  },
  {
    "State": "WV",
    "City": "Surveyor"
  },
  {
    "State": "WV",
    "City": "Thurmond"
  },
  {
    "State": "WV",
    "City": "Victor"
  },
  {
    "State": "WV",
    "City": "Winona"
  },
  {
    "State": "WV",
    "City": "Wyco"
  },
  {
    "State": "WV",
    "City": "Hinton"
  },
  {
    "State": "WV",
    "City": "Charmco"
  },
  {
    "State": "WV",
    "City": "Rainelle"
  },
  {
    "State": "WV",
    "City": "Elton"
  },
  {
    "State": "WV",
    "City": "Green Sulphur Springs"
  },
  {
    "State": "WV",
    "City": "Jumping Branch"
  },
  {
    "State": "WV",
    "City": "Lerona"
  },
  {
    "State": "WV",
    "City": "Leslie"
  },
  {
    "State": "WV",
    "City": "Meadow Bridge"
  },
  {
    "State": "WV",
    "City": "Meadow Creek"
  },
  {
    "State": "WV",
    "City": "Nimitz"
  },
  {
    "State": "WV",
    "City": "Pipestem"
  },
  {
    "State": "WV",
    "City": "Quinwood"
  },
  {
    "State": "WV",
    "City": "Rupert"
  },
  {
    "State": "WV",
    "City": "Sandstone"
  },
  {
    "State": "WV",
    "City": "Spring Dale"
  },
  {
    "State": "WV",
    "City": "White Oak"
  },
  {
    "State": "WV",
    "City": "Wheeling"
  },
  {
    "State": "WV",
    "City": "Beech Bottom"
  },
  {
    "State": "WV",
    "City": "Benwood"
  },
  {
    "State": "WV",
    "City": "Bethany"
  },
  {
    "State": "WV",
    "City": "Cameron"
  },
  {
    "State": "WV",
    "City": "Chester"
  },
  {
    "State": "WV",
    "City": "Colliers"
  },
  {
    "State": "WV",
    "City": "Dallas"
  },
  {
    "State": "WV",
    "City": "Follansbee"
  },
  {
    "State": "WV",
    "City": "Glen Dale"
  },
  {
    "State": "WV",
    "City": "Glen Easton"
  },
  {
    "State": "WV",
    "City": "Mcmechen"
  },
  {
    "State": "WV",
    "City": "Moundsville"
  },
  {
    "State": "WV",
    "City": "New Cumberland"
  },
  {
    "State": "WV",
    "City": "Newell"
  },
  {
    "State": "WV",
    "City": "Proctor"
  },
  {
    "State": "WV",
    "City": "New Manchester"
  },
  {
    "State": "WV",
    "City": "Short Creek"
  },
  {
    "State": "WV",
    "City": "Triadelphia"
  },
  {
    "State": "WV",
    "City": "Valley Grove"
  },
  {
    "State": "WV",
    "City": "Weirton"
  },
  {
    "State": "WV",
    "City": "Wellsburg"
  },
  {
    "State": "WV",
    "City": "West Liberty"
  },
  {
    "State": "WV",
    "City": "Windsor Heights"
  },
  {
    "State": "WV",
    "City": "Parkersburg"
  },
  {
    "State": "WV",
    "City": "Vienna"
  },
  {
    "State": "WV",
    "City": "Mineral Wells"
  },
  {
    "State": "WV",
    "City": "Belleville"
  },
  {
    "State": "WV",
    "City": "Belmont"
  },
  {
    "State": "WV",
    "City": "Big Bend"
  },
  {
    "State": "WV",
    "City": "Big Springs"
  },
  {
    "State": "WV",
    "City": "Brohard"
  },
  {
    "State": "WV",
    "City": "Creston"
  },
  {
    "State": "WV",
    "City": "Davisville"
  },
  {
    "State": "WV",
    "City": "Elizabeth"
  },
  {
    "State": "WV",
    "City": "Friendly"
  },
  {
    "State": "WV",
    "City": "Grantsville"
  },
  {
    "State": "WV",
    "City": "Macfarlan"
  },
  {
    "State": "WV",
    "City": "Middlebourne"
  },
  {
    "State": "WV",
    "City": "Mount Zion"
  },
  {
    "State": "WV",
    "City": "Munday"
  },
  {
    "State": "WV",
    "City": "New Martinsville"
  },
  {
    "State": "WV",
    "City": "Paden City"
  },
  {
    "State": "WV",
    "City": "Palestine"
  },
  {
    "State": "WV",
    "City": "Petroleum"
  },
  {
    "State": "WV",
    "City": "Porters Falls"
  },
  {
    "State": "WV",
    "City": "Ravenswood"
  },
  {
    "State": "WV",
    "City": "Reader"
  },
  {
    "State": "WV",
    "City": "Rockport"
  },
  {
    "State": "WV",
    "City": "Saint Marys"
  },
  {
    "State": "WV",
    "City": "Sistersville"
  },
  {
    "State": "WV",
    "City": "Smithville"
  },
  {
    "State": "WV",
    "City": "Walker"
  },
  {
    "State": "WV",
    "City": "Washington"
  },
  {
    "State": "WV",
    "City": "Waverly"
  },
  {
    "State": "WV",
    "City": "Williamstown"
  },
  {
    "State": "WV",
    "City": "Buckhannon"
  },
  {
    "State": "WV",
    "City": "Fenwick"
  },
  {
    "State": "WV",
    "City": "Erbacon"
  },
  {
    "State": "WV",
    "City": "Craigsville"
  },
  {
    "State": "WV",
    "City": "Cowen"
  },
  {
    "State": "WV",
    "City": "Camden On Gauley"
  },
  {
    "State": "WV",
    "City": "Snowshoe"
  },
  {
    "State": "WV",
    "City": "Adrian"
  },
  {
    "State": "WV",
    "City": "Cleveland"
  },
  {
    "State": "WV",
    "City": "Diana"
  },
  {
    "State": "WV",
    "City": "French Creek"
  },
  {
    "State": "WV",
    "City": "Frenchton"
  },
  {
    "State": "WV",
    "City": "Hacker Valley"
  },
  {
    "State": "WV",
    "City": "Helvetia"
  },
  {
    "State": "WV",
    "City": "Kanawha Head"
  },
  {
    "State": "WV",
    "City": "Lorentz"
  },
  {
    "State": "WV",
    "City": "Pickens"
  },
  {
    "State": "WV",
    "City": "Rock Cave"
  },
  {
    "State": "WV",
    "City": "Selbyville"
  },
  {
    "State": "WV",
    "City": "Tallmansville"
  },
  {
    "State": "WV",
    "City": "Volga"
  },
  {
    "State": "WV",
    "City": "Elkins"
  },
  {
    "State": "WV",
    "City": "Belington"
  },
  {
    "State": "WV",
    "City": "Beverly"
  },
  {
    "State": "WV",
    "City": "Bowden"
  },
  {
    "State": "WV",
    "City": "Coalton"
  },
  {
    "State": "WV",
    "City": "Dailey"
  },
  {
    "State": "WV",
    "City": "Davis"
  },
  {
    "State": "WV",
    "City": "Richwood"
  },
  {
    "State": "WV",
    "City": "Dryfork"
  },
  {
    "State": "WV",
    "City": "Durbin"
  },
  {
    "State": "WV",
    "City": "Upperglade"
  },
  {
    "State": "WV",
    "City": "Ellamore"
  },
  {
    "State": "WV",
    "City": "Glady"
  },
  {
    "State": "WV",
    "City": "Hambleton"
  },
  {
    "State": "WV",
    "City": "Harman"
  },
  {
    "State": "WV",
    "City": "Hendricks"
  },
  {
    "State": "WV",
    "City": "Huttonsville"
  },
  {
    "State": "WV",
    "City": "Junior"
  },
  {
    "State": "WV",
    "City": "Kerens"
  },
  {
    "State": "WV",
    "City": "Mabie"
  },
  {
    "State": "WV",
    "City": "Mill Creek"
  },
  {
    "State": "WV",
    "City": "Monterville"
  },
  {
    "State": "WV",
    "City": "Montrose"
  },
  {
    "State": "WV",
    "City": "Norton"
  },
  {
    "State": "WV",
    "City": "Parsons"
  },
  {
    "State": "WV",
    "City": "Webster Springs"
  },
  {
    "State": "WV",
    "City": "Red Creek"
  },
  {
    "State": "WV",
    "City": "Slatyfork"
  },
  {
    "State": "WV",
    "City": "Thomas"
  },
  {
    "State": "WV",
    "City": "Valley Bend"
  },
  {
    "State": "WV",
    "City": "Valley Head"
  },
  {
    "State": "WV",
    "City": "Whitmer"
  },
  {
    "State": "WV",
    "City": "Bergoo"
  },
  {
    "State": "WV",
    "City": "Clarksburg"
  },
  {
    "State": "WV",
    "City": "Alma"
  },
  {
    "State": "WV",
    "City": "Alum Bridge"
  },
  {
    "State": "WV",
    "City": "Anmoore"
  },
  {
    "State": "WV",
    "City": "Auburn"
  },
  {
    "State": "WV",
    "City": "Berea"
  },
  {
    "State": "WV",
    "City": "Bridgeport"
  },
  {
    "State": "WV",
    "City": "Burnsville"
  },
  {
    "State": "WV",
    "City": "Cairo"
  },
  {
    "State": "WV",
    "City": "Camden"
  },
  {
    "State": "WV",
    "City": "Center Point"
  },
  {
    "State": "WV",
    "City": "Coxs Mills"
  },
  {
    "State": "WV",
    "City": "Crawford"
  },
  {
    "State": "WV",
    "City": "Ellenboro"
  },
  {
    "State": "WV",
    "City": "Flemington"
  },
  {
    "State": "WV",
    "City": "Folsom"
  },
  {
    "State": "WV",
    "City": "Galloway"
  },
  {
    "State": "WV",
    "City": "Glenville"
  },
  {
    "State": "WV",
    "City": "Grafton"
  },
  {
    "State": "WV",
    "City": "Gypsy"
  },
  {
    "State": "WV",
    "City": "Harrisville"
  },
  {
    "State": "WV",
    "City": "Haywood"
  },
  {
    "State": "WV",
    "City": "Hepzibah"
  },
  {
    "State": "WV",
    "City": "Horner"
  },
  {
    "State": "WV",
    "City": "Independence"
  },
  {
    "State": "WV",
    "City": "Ireland"
  },
  {
    "State": "WV",
    "City": "Jacksonburg"
  },
  {
    "State": "WV",
    "City": "Jane Lew"
  },
  {
    "State": "WV",
    "City": "Linn"
  },
  {
    "State": "WV",
    "City": "Lost Creek"
  },
  {
    "State": "WV",
    "City": "Lumberport"
  },
  {
    "State": "WV",
    "City": "Meadowbrook"
  },
  {
    "State": "WV",
    "City": "Moatsville"
  },
  {
    "State": "WV",
    "City": "Mount Clare"
  },
  {
    "State": "WV",
    "City": "Newburg"
  },
  {
    "State": "WV",
    "City": "New Milton"
  },
  {
    "State": "WV",
    "City": "Orlando"
  },
  {
    "State": "WV",
    "City": "Pennsboro"
  },
  {
    "State": "WV",
    "City": "Philippi"
  },
  {
    "State": "WV",
    "City": "Pine Grove"
  },
  {
    "State": "WV",
    "City": "Pullman"
  },
  {
    "State": "WV",
    "City": "Reynoldsville"
  },
  {
    "State": "WV",
    "City": "Rosemont"
  },
  {
    "State": "WV",
    "City": "Rowlesburg"
  },
  {
    "State": "WV",
    "City": "Salem"
  },
  {
    "State": "WV",
    "City": "Sand Fork"
  },
  {
    "State": "WV",
    "City": "Shinnston"
  },
  {
    "State": "WV",
    "City": "Shirley"
  },
  {
    "State": "WV",
    "City": "Simpson"
  },
  {
    "State": "WV",
    "City": "Smithburg"
  },
  {
    "State": "WV",
    "City": "Smithfield"
  },
  {
    "State": "WV",
    "City": "Spelter"
  },
  {
    "State": "WV",
    "City": "Thornton"
  },
  {
    "State": "WV",
    "City": "Troy"
  },
  {
    "State": "WV",
    "City": "Tunnelton"
  },
  {
    "State": "WV",
    "City": "Walkersville"
  },
  {
    "State": "WV",
    "City": "Wallace"
  },
  {
    "State": "WV",
    "City": "West Milford"
  },
  {
    "State": "WV",
    "City": "Weston"
  },
  {
    "State": "WV",
    "City": "West Union"
  },
  {
    "State": "WV",
    "City": "Wilsonburg"
  },
  {
    "State": "WV",
    "City": "Wyatt"
  },
  {
    "State": "WV",
    "City": "Morgantown"
  },
  {
    "State": "WV",
    "City": "Albright"
  },
  {
    "State": "WV",
    "City": "Arthurdale"
  },
  {
    "State": "WV",
    "City": "Blacksville"
  },
  {
    "State": "WV",
    "City": "Bretz"
  },
  {
    "State": "WV",
    "City": "Bruceton Mills"
  },
  {
    "State": "WV",
    "City": "Cassville"
  },
  {
    "State": "WV",
    "City": "Dellslow"
  },
  {
    "State": "WV",
    "City": "Granville"
  },
  {
    "State": "WV",
    "City": "Kingwood"
  },
  {
    "State": "WV",
    "City": "Maidsville"
  },
  {
    "State": "WV",
    "City": "Masontown"
  },
  {
    "State": "WV",
    "City": "Osage"
  },
  {
    "State": "WV",
    "City": "Pentress"
  },
  {
    "State": "WV",
    "City": "Pursglove"
  },
  {
    "State": "WV",
    "City": "Reedsville"
  },
  {
    "State": "WV",
    "City": "Fairmont"
  },
  {
    "State": "WV",
    "City": "Barrackville"
  },
  {
    "State": "WV",
    "City": "Baxter"
  },
  {
    "State": "WV",
    "City": "Big Run"
  },
  {
    "State": "WV",
    "City": "Burton"
  },
  {
    "State": "WV",
    "City": "Carolina"
  },
  {
    "State": "WV",
    "City": "Colfax"
  },
  {
    "State": "WV",
    "City": "Enterprise"
  },
  {
    "State": "WV",
    "City": "Fairview"
  },
  {
    "State": "WV",
    "City": "Farmington"
  },
  {
    "State": "WV",
    "City": "Four States"
  },
  {
    "State": "WV",
    "City": "Grant Town"
  },
  {
    "State": "WV",
    "City": "Hundred"
  },
  {
    "State": "WV",
    "City": "Idamay"
  },
  {
    "State": "WV",
    "City": "Kingmont"
  },
  {
    "State": "WV",
    "City": "Littleton"
  },
  {
    "State": "WV",
    "City": "Mannington"
  },
  {
    "State": "WV",
    "City": "Metz"
  },
  {
    "State": "WV",
    "City": "Montana Mines"
  },
  {
    "State": "WV",
    "City": "Rachel"
  },
  {
    "State": "WV",
    "City": "Rivesville"
  },
  {
    "State": "WV",
    "City": "Wana"
  },
  {
    "State": "WV",
    "City": "Worthington"
  },
  {
    "State": "WV",
    "City": "Sutton"
  },
  {
    "State": "WV",
    "City": "Birch River"
  },
  {
    "State": "WV",
    "City": "Cedarville"
  },
  {
    "State": "WV",
    "City": "Copen"
  },
  {
    "State": "WV",
    "City": "Dille"
  },
  {
    "State": "WV",
    "City": "Exchange"
  },
  {
    "State": "WV",
    "City": "Flatwoods"
  },
  {
    "State": "WV",
    "City": "Frametown"
  },
  {
    "State": "WV",
    "City": "Gassaway"
  },
  {
    "State": "WV",
    "City": "Heaters"
  },
  {
    "State": "WV",
    "City": "Little Birch"
  },
  {
    "State": "WV",
    "City": "Napier"
  },
  {
    "State": "WV",
    "City": "Rosedale"
  },
  {
    "State": "WV",
    "City": "Shock"
  },
  {
    "State": "WV",
    "City": "Summersville"
  },
  {
    "State": "WV",
    "City": "Belva"
  },
  {
    "State": "WV",
    "City": "Calvin"
  },
  {
    "State": "WV",
    "City": "Canvas"
  },
  {
    "State": "WV",
    "City": "Drennen"
  },
  {
    "State": "WV",
    "City": "Gilboa"
  },
  {
    "State": "WV",
    "City": "Keslers Cross Lanes"
  },
  {
    "State": "WV",
    "City": "Leivasy"
  },
  {
    "State": "WV",
    "City": "Mount Lookout"
  },
  {
    "State": "WV",
    "City": "Mount Nebo"
  },
  {
    "State": "WV",
    "City": "Nallen"
  },
  {
    "State": "WV",
    "City": "Nettie"
  },
  {
    "State": "WV",
    "City": "Pool"
  },
  {
    "State": "WV",
    "City": "Swiss"
  },
  {
    "State": "WV",
    "City": "Tioga"
  },
  {
    "State": "WV",
    "City": "Augusta"
  },
  {
    "State": "WV",
    "City": "Aurora"
  },
  {
    "State": "WV",
    "City": "Bayard"
  },
  {
    "State": "WV",
    "City": "Burlington"
  },
  {
    "State": "WV",
    "City": "Capon Bridge"
  },
  {
    "State": "WV",
    "City": "Delray"
  },
  {
    "State": "WV",
    "City": "Eglon"
  },
  {
    "State": "WV",
    "City": "Elk Garden"
  },
  {
    "State": "WV",
    "City": "Fort Ashby"
  },
  {
    "State": "WV",
    "City": "Gormania"
  },
  {
    "State": "WV",
    "City": "Green Spring"
  },
  {
    "State": "WV",
    "City": "Keyser"
  },
  {
    "State": "WV",
    "City": "Lahmansville"
  },
  {
    "State": "WV",
    "City": "Mount Storm"
  },
  {
    "State": "WV",
    "City": "New Creek"
  },
  {
    "State": "WV",
    "City": "Piedmont"
  },
  {
    "State": "WV",
    "City": "Ridgeley"
  },
  {
    "State": "WV",
    "City": "Rio"
  },
  {
    "State": "WV",
    "City": "Romney"
  },
  {
    "State": "WV",
    "City": "Shanks"
  },
  {
    "State": "WV",
    "City": "Springfield"
  },
  {
    "State": "WV",
    "City": "Terra Alta"
  },
  {
    "State": "WV",
    "City": "Wiley Ford"
  },
  {
    "State": "WV",
    "City": "Baker"
  },
  {
    "State": "WV",
    "City": "Brandywine"
  },
  {
    "State": "WV",
    "City": "Circleville"
  },
  {
    "State": "WV",
    "City": "Franklin"
  },
  {
    "State": "WV",
    "City": "High View"
  },
  {
    "State": "WV",
    "City": "Lost City"
  },
  {
    "State": "WV",
    "City": "Mathias"
  },
  {
    "State": "WV",
    "City": "Riverton"
  },
  {
    "State": "WV",
    "City": "Sugar Grove"
  },
  {
    "State": "WV",
    "City": "Bloomery"
  },
  {
    "State": "WV",
    "City": "Fisher"
  },
  {
    "State": "WV",
    "City": "Capon Springs"
  },
  {
    "State": "WV",
    "City": "Maysville"
  },
  {
    "State": "WV",
    "City": "Moorefield"
  },
  {
    "State": "WV",
    "City": "Milam"
  },
  {
    "State": "WV",
    "City": "Old Fields"
  },
  {
    "State": "WV",
    "City": "Petersburg"
  },
  {
    "State": "WV",
    "City": "Wardensville"
  },
  {
    "State": "WV",
    "City": "Purgitsville"
  },
  {
    "State": "WV",
    "City": "Cabins"
  },
  {
    "State": "WV",
    "City": "Yellow Spring"
  },
  {
    "State": "WV",
    "City": "Upper Tract"
  },
  {
    "State": "WV",
    "City": "Seneca Rocks"
  },
  {
    "State": "WV",
    "City": "Onego"
  },
  {
    "State": "NC",
    "City": "Advance"
  },
  {
    "State": "NC",
    "City": "Ararat"
  },
  {
    "State": "NC",
    "City": "Belews Creek"
  },
  {
    "State": "NC",
    "City": "Bethania"
  },
  {
    "State": "NC",
    "City": "Boonville"
  },
  {
    "State": "NC",
    "City": "Clemmons"
  },
  {
    "State": "NC",
    "City": "Cleveland"
  },
  {
    "State": "NC",
    "City": "Cooleemee"
  },
  {
    "State": "NC",
    "City": "Danbury"
  },
  {
    "State": "NC",
    "City": "Dobson"
  },
  {
    "State": "NC",
    "City": "East Bend"
  },
  {
    "State": "NC",
    "City": "Germanton"
  },
  {
    "State": "NC",
    "City": "Hamptonville"
  },
  {
    "State": "NC",
    "City": "King"
  },
  {
    "State": "NC",
    "City": "Lawsonville"
  },
  {
    "State": "NC",
    "City": "Lewisville"
  },
  {
    "State": "NC",
    "City": "Lowgap"
  },
  {
    "State": "NC",
    "City": "Madison"
  },
  {
    "State": "NC",
    "City": "Mayodan"
  },
  {
    "State": "NC",
    "City": "Mocksville"
  },
  {
    "State": "NC",
    "City": "Mount Airy"
  },
  {
    "State": "NC",
    "City": "Pfafftown"
  },
  {
    "State": "NC",
    "City": "Pilot Mountain"
  },
  {
    "State": "NC",
    "City": "Pine Hall"
  },
  {
    "State": "NC",
    "City": "Pinnacle"
  },
  {
    "State": "NC",
    "City": "Rural Hall"
  },
  {
    "State": "NC",
    "City": "Sandy Ridge"
  },
  {
    "State": "NC",
    "City": "Siloam"
  },
  {
    "State": "NC",
    "City": "Stoneville"
  },
  {
    "State": "NC",
    "City": "Toast"
  },
  {
    "State": "NC",
    "City": "Tobaccoville"
  },
  {
    "State": "NC",
    "City": "Walkertown"
  },
  {
    "State": "NC",
    "City": "Walnut Cove"
  },
  {
    "State": "NC",
    "City": "Westfield"
  },
  {
    "State": "NC",
    "City": "Woodleaf"
  },
  {
    "State": "NC",
    "City": "Yadkinville"
  },
  {
    "State": "NC",
    "City": "Winston Salem"
  },
  {
    "State": "NC",
    "City": "Winston-salem"
  },
  {
    "State": "NC",
    "City": "Alamance"
  },
  {
    "State": "NC",
    "City": "Altamahaw"
  },
  {
    "State": "NC",
    "City": "Asheboro"
  },
  {
    "State": "NC",
    "City": "Bear Creek"
  },
  {
    "State": "NC",
    "City": "Bennett"
  },
  {
    "State": "NC",
    "City": "Biscoe"
  },
  {
    "State": "NC",
    "City": "Blanch"
  },
  {
    "State": "NC",
    "City": "Bonlee"
  },
  {
    "State": "NC",
    "City": "Browns Summit"
  },
  {
    "State": "NC",
    "City": "Burlington"
  },
  {
    "State": "NC",
    "City": "Bynum"
  },
  {
    "State": "NC",
    "City": "Candor"
  },
  {
    "State": "NC",
    "City": "Cedar Falls"
  },
  {
    "State": "NC",
    "City": "Cedar Grove"
  },
  {
    "State": "NC",
    "City": "Climax"
  },
  {
    "State": "NC",
    "City": "Colfax"
  },
  {
    "State": "NC",
    "City": "Cumnock"
  },
  {
    "State": "NC",
    "City": "Denton"
  },
  {
    "State": "NC",
    "City": "Eagle Springs"
  },
  {
    "State": "NC",
    "City": "Efland"
  },
  {
    "State": "NC",
    "City": "Elon"
  },
  {
    "State": "NC",
    "City": "Ether"
  },
  {
    "State": "NC",
    "City": "Franklinville"
  },
  {
    "State": "NC",
    "City": "Gibsonville"
  },
  {
    "State": "NC",
    "City": "Goldston"
  },
  {
    "State": "NC",
    "City": "Graham"
  },
  {
    "State": "NC",
    "City": "Gulf"
  },
  {
    "State": "NC",
    "City": "Haw River"
  },
  {
    "State": "NC",
    "City": "Highfalls"
  },
  {
    "State": "NC",
    "City": "High Point"
  },
  {
    "State": "NC",
    "City": "Hillsborough"
  },
  {
    "State": "NC",
    "City": "Jackson Springs"
  },
  {
    "State": "NC",
    "City": "Jamestown"
  },
  {
    "State": "NC",
    "City": "Julian"
  },
  {
    "State": "NC",
    "City": "Kernersville"
  },
  {
    "State": "NC",
    "City": "Eden"
  },
  {
    "State": "NC",
    "City": "Leasburg"
  },
  {
    "State": "NC",
    "City": "Lexington"
  },
  {
    "State": "NC",
    "City": "Liberty"
  },
  {
    "State": "NC",
    "City": "Linwood"
  },
  {
    "State": "NC",
    "City": "Mc Leansville"
  },
  {
    "State": "NC",
    "City": "Mebane"
  },
  {
    "State": "NC",
    "City": "Milton"
  },
  {
    "State": "NC",
    "City": "Mount Gilead"
  },
  {
    "State": "NC",
    "City": "Oak Ridge"
  },
  {
    "State": "NC",
    "City": "Pelham"
  },
  {
    "State": "NC",
    "City": "Pittsboro"
  },
  {
    "State": "NC",
    "City": "Pleasant Garden"
  },
  {
    "State": "NC",
    "City": "Prospect Hill"
  },
  {
    "State": "NC",
    "City": "Providence"
  },
  {
    "State": "NC",
    "City": "Ramseur"
  },
  {
    "State": "NC",
    "City": "Randleman"
  },
  {
    "State": "NC",
    "City": "Reidsville"
  },
  {
    "State": "NC",
    "City": "Robbins"
  },
  {
    "State": "NC",
    "City": "Ruffin"
  },
  {
    "State": "NC",
    "City": "Sanford"
  },
  {
    "State": "NC",
    "City": "Saxapahaw"
  },
  {
    "State": "NC",
    "City": "Seagrove"
  },
  {
    "State": "NC",
    "City": "Sedalia"
  },
  {
    "State": "NC",
    "City": "Semora"
  },
  {
    "State": "NC",
    "City": "Siler City"
  },
  {
    "State": "NC",
    "City": "Snow Camp"
  },
  {
    "State": "NC",
    "City": "Sophia"
  },
  {
    "State": "NC",
    "City": "Southmont"
  },
  {
    "State": "NC",
    "City": "Staley"
  },
  {
    "State": "NC",
    "City": "Star"
  },
  {
    "State": "NC",
    "City": "Stokesdale"
  },
  {
    "State": "NC",
    "City": "Summerfield"
  },
  {
    "State": "NC",
    "City": "Swepsonville"
  },
  {
    "State": "NC",
    "City": "Thomasville"
  },
  {
    "State": "NC",
    "City": "Trinity"
  },
  {
    "State": "NC",
    "City": "Troy"
  },
  {
    "State": "NC",
    "City": "Wallburg"
  },
  {
    "State": "NC",
    "City": "Welcome"
  },
  {
    "State": "NC",
    "City": "Wentworth"
  },
  {
    "State": "NC",
    "City": "West End"
  },
  {
    "State": "NC",
    "City": "Whitsett"
  },
  {
    "State": "NC",
    "City": "Yanceyville"
  },
  {
    "State": "NC",
    "City": "Greensboro"
  },
  {
    "State": "NC",
    "City": "Angier"
  },
  {
    "State": "NC",
    "City": "Apex"
  },
  {
    "State": "NC",
    "City": "Bahama"
  },
  {
    "State": "NC",
    "City": "Benson"
  },
  {
    "State": "NC",
    "City": "Broadway"
  },
  {
    "State": "NC",
    "City": "Buies Creek"
  },
  {
    "State": "NC",
    "City": "Bullock"
  },
  {
    "State": "NC",
    "City": "Bunn"
  },
  {
    "State": "NC",
    "City": "Butner"
  },
  {
    "State": "NC",
    "City": "Carrboro"
  },
  {
    "State": "NC",
    "City": "Cary"
  },
  {
    "State": "NC",
    "City": "Chapel Hill"
  },
  {
    "State": "NC",
    "City": "Clayton"
  },
  {
    "State": "NC",
    "City": "Coats"
  },
  {
    "State": "NC",
    "City": "Creedmoor"
  },
  {
    "State": "NC",
    "City": "Four Oaks"
  },
  {
    "State": "NC",
    "City": "Franklinton"
  },
  {
    "State": "NC",
    "City": "Fuquay Varina"
  },
  {
    "State": "NC",
    "City": "Garner"
  },
  {
    "State": "NC",
    "City": "Goldsboro"
  },
  {
    "State": "NC",
    "City": "Henderson"
  },
  {
    "State": "NC",
    "City": "Holly Springs"
  },
  {
    "State": "NC",
    "City": "Hurdle Mills"
  },
  {
    "State": "NC",
    "City": "Kenly"
  },
  {
    "State": "NC",
    "City": "Kipling"
  },
  {
    "State": "NC",
    "City": "Kittrell"
  },
  {
    "State": "NC",
    "City": "Knightdale"
  },
  {
    "State": "NC",
    "City": "Lillington"
  },
  {
    "State": "NC",
    "City": "Louisburg"
  },
  {
    "State": "NC",
    "City": "Macon"
  },
  {
    "State": "NC",
    "City": "Mamers"
  },
  {
    "State": "NC",
    "City": "Manson"
  },
  {
    "State": "NC",
    "City": "Micro"
  },
  {
    "State": "NC",
    "City": "Middleburg"
  },
  {
    "State": "NC",
    "City": "Middlesex"
  },
  {
    "State": "NC",
    "City": "Moncure"
  },
  {
    "State": "NC",
    "City": "Morrisville"
  },
  {
    "State": "NC",
    "City": "New Hill"
  },
  {
    "State": "NC",
    "City": "Norlina"
  },
  {
    "State": "NC",
    "City": "Oxford"
  },
  {
    "State": "NC",
    "City": "Pine Level"
  },
  {
    "State": "NC",
    "City": "Princeton"
  },
  {
    "State": "NC",
    "City": "Ridgeway"
  },
  {
    "State": "NC",
    "City": "Rolesville"
  },
  {
    "State": "NC",
    "City": "Rougemont"
  },
  {
    "State": "NC",
    "City": "Roxboro"
  },
  {
    "State": "NC",
    "City": "Selma"
  },
  {
    "State": "NC",
    "City": "Smithfield"
  },
  {
    "State": "NC",
    "City": "Stem"
  },
  {
    "State": "NC",
    "City": "Stovall"
  },
  {
    "State": "NC",
    "City": "Timberlake"
  },
  {
    "State": "NC",
    "City": "Townsville"
  },
  {
    "State": "NC",
    "City": "Vaughan"
  },
  {
    "State": "NC",
    "City": "Wake Forest"
  },
  {
    "State": "NC",
    "City": "Warrenton"
  },
  {
    "State": "NC",
    "City": "Wendell"
  },
  {
    "State": "NC",
    "City": "Willow Spring"
  },
  {
    "State": "NC",
    "City": "Wilsons Mills"
  },
  {
    "State": "NC",
    "City": "Wise"
  },
  {
    "State": "NC",
    "City": "Youngsville"
  },
  {
    "State": "NC",
    "City": "Zebulon"
  },
  {
    "State": "NC",
    "City": "Raleigh"
  },
  {
    "State": "NC",
    "City": "Durham"
  },
  {
    "State": "NC",
    "City": "Rocky Mount"
  },
  {
    "State": "NC",
    "City": "Aulander"
  },
  {
    "State": "NC",
    "City": "Aurora"
  },
  {
    "State": "NC",
    "City": "Bailey"
  },
  {
    "State": "NC",
    "City": "Bath"
  },
  {
    "State": "NC",
    "City": "Battleboro"
  },
  {
    "State": "NC",
    "City": "Belhaven"
  },
  {
    "State": "NC",
    "City": "Bellarthur"
  },
  {
    "State": "NC",
    "City": "Bethel"
  },
  {
    "State": "NC",
    "City": "Black Creek"
  },
  {
    "State": "NC",
    "City": "Blounts Creek"
  },
  {
    "State": "NC",
    "City": "Castalia"
  },
  {
    "State": "NC",
    "City": "Chocowinity"
  },
  {
    "State": "NC",
    "City": "Como"
  },
  {
    "State": "NC",
    "City": "Conetoe"
  },
  {
    "State": "NC",
    "City": "Conway"
  },
  {
    "State": "NC",
    "City": "Edward"
  },
  {
    "State": "NC",
    "City": "Elm City"
  },
  {
    "State": "NC",
    "City": "Enfield"
  },
  {
    "State": "NC",
    "City": "Engelhard"
  },
  {
    "State": "NC",
    "City": "Everetts"
  },
  {
    "State": "NC",
    "City": "Fairfield"
  },
  {
    "State": "NC",
    "City": "Falkland"
  },
  {
    "State": "NC",
    "City": "Farmville"
  },
  {
    "State": "NC",
    "City": "Fountain"
  },
  {
    "State": "NC",
    "City": "Fremont"
  },
  {
    "State": "NC",
    "City": "Garysburg"
  },
  {
    "State": "NC",
    "City": "Gaston"
  },
  {
    "State": "NC",
    "City": "Greenville"
  },
  {
    "State": "NC",
    "City": "Grimesland"
  },
  {
    "State": "NC",
    "City": "Halifax"
  },
  {
    "State": "NC",
    "City": "Hamilton"
  },
  {
    "State": "NC",
    "City": "Hassell"
  },
  {
    "State": "NC",
    "City": "Henrico"
  },
  {
    "State": "NC",
    "City": "Hobgood"
  },
  {
    "State": "NC",
    "City": "Hollister"
  },
  {
    "State": "NC",
    "City": "Jackson"
  },
  {
    "State": "NC",
    "City": "Jamesville"
  },
  {
    "State": "NC",
    "City": "Kelford"
  },
  {
    "State": "NC",
    "City": "Lewiston Woodville"
  },
  {
    "State": "NC",
    "City": "Littleton"
  },
  {
    "State": "NC",
    "City": "Lucama"
  },
  {
    "State": "NC",
    "City": "Macclesfield"
  },
  {
    "State": "NC",
    "City": "Margarettsville"
  },
  {
    "State": "NC",
    "City": "Milwaukee"
  },
  {
    "State": "NC",
    "City": "Murfreesboro"
  },
  {
    "State": "NC",
    "City": "Nashville"
  },
  {
    "State": "NC",
    "City": "Oak City"
  },
  {
    "State": "NC",
    "City": "Pantego"
  },
  {
    "State": "NC",
    "City": "Parmele"
  },
  {
    "State": "NC",
    "City": "Pendleton"
  },
  {
    "State": "NC",
    "City": "Pikeville"
  },
  {
    "State": "NC",
    "City": "Pinetops"
  },
  {
    "State": "NC",
    "City": "Pinetown"
  },
  {
    "State": "NC",
    "City": "Pleasant Hill"
  },
  {
    "State": "NC",
    "City": "Potecasi"
  },
  {
    "State": "NC",
    "City": "Red Oak"
  },
  {
    "State": "NC",
    "City": "Rich Square"
  },
  {
    "State": "NC",
    "City": "Roanoke Rapids"
  },
  {
    "State": "NC",
    "City": "Robersonville"
  },
  {
    "State": "NC",
    "City": "Roxobel"
  },
  {
    "State": "NC",
    "City": "Saratoga"
  },
  {
    "State": "NC",
    "City": "Scotland Neck"
  },
  {
    "State": "NC",
    "City": "Scranton"
  },
  {
    "State": "NC",
    "City": "Seaboard"
  },
  {
    "State": "NC",
    "City": "Severn"
  },
  {
    "State": "NC",
    "City": "Sharpsburg"
  },
  {
    "State": "NC",
    "City": "Simpson"
  },
  {
    "State": "NC",
    "City": "Sims"
  },
  {
    "State": "NC",
    "City": "Speed"
  },
  {
    "State": "NC",
    "City": "Spring Hope"
  },
  {
    "State": "NC",
    "City": "Stantonsburg"
  },
  {
    "State": "NC",
    "City": "Stokes"
  },
  {
    "State": "NC",
    "City": "Swanquarter"
  },
  {
    "State": "NC",
    "City": "Tarboro"
  },
  {
    "State": "NC",
    "City": "Tillery"
  },
  {
    "State": "NC",
    "City": "Walstonburg"
  },
  {
    "State": "NC",
    "City": "Washington"
  },
  {
    "State": "NC",
    "City": "Weldon"
  },
  {
    "State": "NC",
    "City": "Whitakers"
  },
  {
    "State": "NC",
    "City": "Williamston"
  },
  {
    "State": "NC",
    "City": "Wilson"
  },
  {
    "State": "NC",
    "City": "Woodland"
  },
  {
    "State": "NC",
    "City": "Elizabeth City"
  },
  {
    "State": "NC",
    "City": "Ahoskie"
  },
  {
    "State": "NC",
    "City": "Avon"
  },
  {
    "State": "NC",
    "City": "Aydlett"
  },
  {
    "State": "NC",
    "City": "Barco"
  },
  {
    "State": "NC",
    "City": "Belvidere"
  },
  {
    "State": "NC",
    "City": "Buxton"
  },
  {
    "State": "NC",
    "City": "Camden"
  },
  {
    "State": "NC",
    "City": "Cofield"
  },
  {
    "State": "NC",
    "City": "Coinjock"
  },
  {
    "State": "NC",
    "City": "Colerain"
  },
  {
    "State": "NC",
    "City": "Columbia"
  },
  {
    "State": "NC",
    "City": "Corapeake"
  },
  {
    "State": "NC",
    "City": "Corolla"
  },
  {
    "State": "NC",
    "City": "Creswell"
  },
  {
    "State": "NC",
    "City": "Currituck"
  },
  {
    "State": "NC",
    "City": "Hertford"
  },
  {
    "State": "NC",
    "City": "Edenton"
  },
  {
    "State": "NC",
    "City": "Eure"
  },
  {
    "State": "NC",
    "City": "Frisco"
  },
  {
    "State": "NC",
    "City": "Gates"
  },
  {
    "State": "NC",
    "City": "Gatesville"
  },
  {
    "State": "NC",
    "City": "Grandy"
  },
  {
    "State": "NC",
    "City": "Harbinger"
  },
  {
    "State": "NC",
    "City": "Harrellsville"
  },
  {
    "State": "NC",
    "City": "Hatteras"
  },
  {
    "State": "NC",
    "City": "Hobbsville"
  },
  {
    "State": "NC",
    "City": "Jarvisburg"
  },
  {
    "State": "NC",
    "City": "Kill Devil Hills"
  },
  {
    "State": "NC",
    "City": "Kitty Hawk"
  },
  {
    "State": "NC",
    "City": "Knotts Island"
  },
  {
    "State": "NC",
    "City": "Manns Harbor"
  },
  {
    "State": "NC",
    "City": "Manteo"
  },
  {
    "State": "NC",
    "City": "Maple"
  },
  {
    "State": "NC",
    "City": "Merry Hill"
  },
  {
    "State": "NC",
    "City": "Moyock"
  },
  {
    "State": "NC",
    "City": "Nags Head"
  },
  {
    "State": "NC",
    "City": "Ocracoke"
  },
  {
    "State": "NC",
    "City": "Plymouth"
  },
  {
    "State": "NC",
    "City": "Point Harbor"
  },
  {
    "State": "NC",
    "City": "Poplar Branch"
  },
  {
    "State": "NC",
    "City": "Powells Point"
  },
  {
    "State": "NC",
    "City": "Powellsville"
  },
  {
    "State": "NC",
    "City": "Rodanthe"
  },
  {
    "State": "NC",
    "City": "Roduco"
  },
  {
    "State": "NC",
    "City": "Roper"
  },
  {
    "State": "NC",
    "City": "Salvo"
  },
  {
    "State": "NC",
    "City": "Shawboro"
  },
  {
    "State": "NC",
    "City": "Shiloh"
  },
  {
    "State": "NC",
    "City": "South Mills"
  },
  {
    "State": "NC",
    "City": "Stumpy Point"
  },
  {
    "State": "NC",
    "City": "Sunbury"
  },
  {
    "State": "NC",
    "City": "Tyner"
  },
  {
    "State": "NC",
    "City": "Wanchese"
  },
  {
    "State": "NC",
    "City": "Waves"
  },
  {
    "State": "NC",
    "City": "Windsor"
  },
  {
    "State": "NC",
    "City": "Winfall"
  },
  {
    "State": "NC",
    "City": "Winton"
  },
  {
    "State": "NC",
    "City": "Albemarle"
  },
  {
    "State": "NC",
    "City": "Alexis"
  },
  {
    "State": "NC",
    "City": "Ansonville"
  },
  {
    "State": "NC",
    "City": "Badin"
  },
  {
    "State": "NC",
    "City": "Barium Springs"
  },
  {
    "State": "NC",
    "City": "Belmont"
  },
  {
    "State": "NC",
    "City": "Bessemer City"
  },
  {
    "State": "NC",
    "City": "Boiling Springs"
  },
  {
    "State": "NC",
    "City": "Bostic"
  },
  {
    "State": "NC",
    "City": "Caroleen"
  },
  {
    "State": "NC",
    "City": "Casar"
  },
  {
    "State": "NC",
    "City": "Cherryville"
  },
  {
    "State": "NC",
    "City": "China Grove"
  },
  {
    "State": "NC",
    "City": "Cliffside"
  },
  {
    "State": "NC",
    "City": "Concord"
  },
  {
    "State": "NC",
    "City": "Cornelius"
  },
  {
    "State": "NC",
    "City": "Cramerton"
  },
  {
    "State": "NC",
    "City": "Crouse"
  },
  {
    "State": "NC",
    "City": "Dallas"
  },
  {
    "State": "NC",
    "City": "Davidson"
  },
  {
    "State": "NC",
    "City": "Denver"
  },
  {
    "State": "NC",
    "City": "Earl"
  },
  {
    "State": "NC",
    "City": "East Spencer"
  },
  {
    "State": "NC",
    "City": "Ellenboro"
  },
  {
    "State": "NC",
    "City": "Faith"
  },
  {
    "State": "NC",
    "City": "Fallston"
  },
  {
    "State": "NC",
    "City": "Forest City"
  },
  {
    "State": "NC",
    "City": "Gastonia"
  },
  {
    "State": "NC",
    "City": "Huntersville"
  },
  {
    "State": "NC",
    "City": "Gold Hill"
  },
  {
    "State": "NC",
    "City": "Granite Quarry"
  },
  {
    "State": "NC",
    "City": "Grover"
  },
  {
    "State": "NC",
    "City": "Harris"
  },
  {
    "State": "NC",
    "City": "Harrisburg"
  },
  {
    "State": "NC",
    "City": "Henrietta"
  },
  {
    "State": "NC",
    "City": "High Shoals"
  },
  {
    "State": "NC",
    "City": "Indian Trail"
  },
  {
    "State": "NC",
    "City": "Iron Station"
  },
  {
    "State": "NC",
    "City": "Kannapolis"
  },
  {
    "State": "NC",
    "City": "Kings Mountain"
  },
  {
    "State": "NC",
    "City": "Landis"
  },
  {
    "State": "NC",
    "City": "Lattimore"
  },
  {
    "State": "NC",
    "City": "Lawndale"
  },
  {
    "State": "NC",
    "City": "Lilesville"
  },
  {
    "State": "NC",
    "City": "Lincolnton"
  },
  {
    "State": "NC",
    "City": "Locust"
  },
  {
    "State": "NC",
    "City": "Lowell"
  },
  {
    "State": "NC",
    "City": "Mc Adenville"
  },
  {
    "State": "NC",
    "City": "Mc Farlan"
  },
  {
    "State": "NC",
    "City": "Marshville"
  },
  {
    "State": "NC",
    "City": "Matthews"
  },
  {
    "State": "NC",
    "City": "Midland"
  },
  {
    "State": "NC",
    "City": "Mineral Springs"
  },
  {
    "State": "NC",
    "City": "Misenheimer"
  },
  {
    "State": "NC",
    "City": "Monroe"
  },
  {
    "State": "NC",
    "City": "Mooresboro"
  },
  {
    "State": "NC",
    "City": "Mooresville"
  },
  {
    "State": "NC",
    "City": "Morven"
  },
  {
    "State": "NC",
    "City": "Mount Holly"
  },
  {
    "State": "NC",
    "City": "Mount Mourne"
  },
  {
    "State": "NC",
    "City": "Mount Pleasant"
  },
  {
    "State": "NC",
    "City": "Mount Ulla"
  },
  {
    "State": "NC",
    "City": "Newell"
  },
  {
    "State": "NC",
    "City": "New London"
  },
  {
    "State": "NC",
    "City": "Norwood"
  },
  {
    "State": "NC",
    "City": "Oakboro"
  },
  {
    "State": "NC",
    "City": "Paw Creek"
  },
  {
    "State": "NC",
    "City": "Peachland"
  },
  {
    "State": "NC",
    "City": "Pineville"
  },
  {
    "State": "NC",
    "City": "Polkton"
  },
  {
    "State": "NC",
    "City": "Polkville"
  },
  {
    "State": "NC",
    "City": "Richfield"
  },
  {
    "State": "NC",
    "City": "Rockwell"
  },
  {
    "State": "NC",
    "City": "Rutherfordton"
  },
  {
    "State": "NC",
    "City": "Salisbury"
  },
  {
    "State": "NC",
    "City": "Shelby"
  },
  {
    "State": "NC",
    "City": "Spencer"
  },
  {
    "State": "NC",
    "City": "Spindale"
  },
  {
    "State": "NC",
    "City": "Stanfield"
  },
  {
    "State": "NC",
    "City": "Stanley"
  },
  {
    "State": "NC",
    "City": "Troutman"
  },
  {
    "State": "NC",
    "City": "Union Mills"
  },
  {
    "State": "NC",
    "City": "Vale"
  },
  {
    "State": "NC",
    "City": "Waco"
  },
  {
    "State": "NC",
    "City": "Wadesboro"
  },
  {
    "State": "NC",
    "City": "Waxhaw"
  },
  {
    "State": "NC",
    "City": "Wingate"
  },
  {
    "State": "NC",
    "City": "Charlotte"
  },
  {
    "State": "NC",
    "City": "Fayetteville"
  },
  {
    "State": "NC",
    "City": "Fort Bragg"
  },
  {
    "State": "NC",
    "City": "Pope Army Airfield"
  },
  {
    "State": "NC",
    "City": "Aberdeen"
  },
  {
    "State": "NC",
    "City": "Autryville"
  },
  {
    "State": "NC",
    "City": "Barnesville"
  },
  {
    "State": "NC",
    "City": "Bladenboro"
  },
  {
    "State": "NC",
    "City": "Bunnlevel"
  },
  {
    "State": "NC",
    "City": "Calypso"
  },
  {
    "State": "NC",
    "City": "Cameron"
  },
  {
    "State": "NC",
    "City": "Carthage"
  },
  {
    "State": "NC",
    "City": "Clinton"
  },
  {
    "State": "NC",
    "City": "Cordova"
  },
  {
    "State": "NC",
    "City": "Cumberland"
  },
  {
    "State": "NC",
    "City": "Dublin"
  },
  {
    "State": "NC",
    "City": "Dudley"
  },
  {
    "State": "NC",
    "City": "Dunn"
  },
  {
    "State": "NC",
    "City": "Elizabethtown"
  },
  {
    "State": "NC",
    "City": "Ellerbe"
  },
  {
    "State": "NC",
    "City": "Erwin"
  },
  {
    "State": "NC",
    "City": "Fairmont"
  },
  {
    "State": "NC",
    "City": "Faison"
  },
  {
    "State": "NC",
    "City": "Falcon"
  },
  {
    "State": "NC",
    "City": "Gibson"
  },
  {
    "State": "NC",
    "City": "Godwin"
  },
  {
    "State": "NC",
    "City": "Hamlet"
  },
  {
    "State": "NC",
    "City": "Hoffman"
  },
  {
    "State": "NC",
    "City": "Hope Mills"
  },
  {
    "State": "NC",
    "City": "Kenansville"
  },
  {
    "State": "NC",
    "City": "Lakeview"
  },
  {
    "State": "NC",
    "City": "Laurel Hill"
  },
  {
    "State": "NC",
    "City": "Laurinburg"
  },
  {
    "State": "NC",
    "City": "Lemon Springs"
  },
  {
    "State": "NC",
    "City": "Linden"
  },
  {
    "State": "NC",
    "City": "Lumber Bridge"
  },
  {
    "State": "NC",
    "City": "Lumberton"
  },
  {
    "State": "NC",
    "City": "Marietta"
  },
  {
    "State": "NC",
    "City": "Marston"
  },
  {
    "State": "NC",
    "City": "Maxton"
  },
  {
    "State": "NC",
    "City": "Mount Olive"
  },
  {
    "State": "NC",
    "City": "Newton Grove"
  },
  {
    "State": "NC",
    "City": "Norman"
  },
  {
    "State": "NC",
    "City": "Olivia"
  },
  {
    "State": "NC",
    "City": "Orrum"
  },
  {
    "State": "NC",
    "City": "Pinehurst"
  },
  {
    "State": "NC",
    "City": "Parkton"
  },
  {
    "State": "NC",
    "City": "Pembroke"
  },
  {
    "State": "NC",
    "City": "Pinebluff"
  },
  {
    "State": "NC",
    "City": "Proctorville"
  },
  {
    "State": "NC",
    "City": "Raeford"
  },
  {
    "State": "NC",
    "City": "Red Springs"
  },
  {
    "State": "NC",
    "City": "Rex"
  },
  {
    "State": "NC",
    "City": "Rockingham"
  },
  {
    "State": "NC",
    "City": "Roseboro"
  },
  {
    "State": "NC",
    "City": "Rowland"
  },
  {
    "State": "NC",
    "City": "Saint Pauls"
  },
  {
    "State": "NC",
    "City": "Salemburg"
  },
  {
    "State": "NC",
    "City": "Shannon"
  },
  {
    "State": "NC",
    "City": "Southern Pines"
  },
  {
    "State": "NC",
    "City": "Spring Lake"
  },
  {
    "State": "NC",
    "City": "Stedman"
  },
  {
    "State": "NC",
    "City": "Tar Heel"
  },
  {
    "State": "NC",
    "City": "Turkey"
  },
  {
    "State": "NC",
    "City": "Vass"
  },
  {
    "State": "NC",
    "City": "Wade"
  },
  {
    "State": "NC",
    "City": "Wagram"
  },
  {
    "State": "NC",
    "City": "Warsaw"
  },
  {
    "State": "NC",
    "City": "White Oak"
  },
  {
    "State": "NC",
    "City": "Wilmington"
  },
  {
    "State": "NC",
    "City": "Ash"
  },
  {
    "State": "NC",
    "City": "Atkinson"
  },
  {
    "State": "NC",
    "City": "Bolivia"
  },
  {
    "State": "NC",
    "City": "Bolton"
  },
  {
    "State": "NC",
    "City": "Brunswick"
  },
  {
    "State": "NC",
    "City": "Burgaw"
  },
  {
    "State": "NC",
    "City": "Carolina Beach"
  },
  {
    "State": "NC",
    "City": "Castle Hayne"
  },
  {
    "State": "NC",
    "City": "Cerro Gordo"
  },
  {
    "State": "NC",
    "City": "Chadbourn"
  },
  {
    "State": "NC",
    "City": "Clarendon"
  },
  {
    "State": "NC",
    "City": "Clarkton"
  },
  {
    "State": "NC",
    "City": "Council"
  },
  {
    "State": "NC",
    "City": "Currie"
  },
  {
    "State": "NC",
    "City": "Delco"
  },
  {
    "State": "NC",
    "City": "Evergreen"
  },
  {
    "State": "NC",
    "City": "Fair Bluff"
  },
  {
    "State": "NC",
    "City": "Garland"
  },
  {
    "State": "NC",
    "City": "Hallsboro"
  },
  {
    "State": "NC",
    "City": "Hampstead"
  },
  {
    "State": "NC",
    "City": "Harrells"
  },
  {
    "State": "NC",
    "City": "Holly Ridge"
  },
  {
    "State": "NC",
    "City": "Ivanhoe"
  },
  {
    "State": "NC",
    "City": "Kelly"
  },
  {
    "State": "NC",
    "City": "Kure Beach"
  },
  {
    "State": "NC",
    "City": "Lake Waccamaw"
  },
  {
    "State": "NC",
    "City": "Leland"
  },
  {
    "State": "NC",
    "City": "Longwood"
  },
  {
    "State": "NC",
    "City": "Magnolia"
  },
  {
    "State": "NC",
    "City": "Maple Hill"
  },
  {
    "State": "NC",
    "City": "Nakina"
  },
  {
    "State": "NC",
    "City": "Riegelwood"
  },
  {
    "State": "NC",
    "City": "Rocky Point"
  },
  {
    "State": "NC",
    "City": "Rose Hill"
  },
  {
    "State": "NC",
    "City": "Shallotte"
  },
  {
    "State": "NC",
    "City": "Sneads Ferry"
  },
  {
    "State": "NC",
    "City": "Southport"
  },
  {
    "State": "NC",
    "City": "Supply"
  },
  {
    "State": "NC",
    "City": "Tabor City"
  },
  {
    "State": "NC",
    "City": "Teachey"
  },
  {
    "State": "NC",
    "City": "Oak Island"
  },
  {
    "State": "NC",
    "City": "Wallace"
  },
  {
    "State": "NC",
    "City": "Calabash"
  },
  {
    "State": "NC",
    "City": "Sunset Beach"
  },
  {
    "State": "NC",
    "City": "Ocean Isle Beach"
  },
  {
    "State": "NC",
    "City": "Whiteville"
  },
  {
    "State": "NC",
    "City": "Willard"
  },
  {
    "State": "NC",
    "City": "Winnabow"
  },
  {
    "State": "NC",
    "City": "Wrightsville Beach"
  },
  {
    "State": "NC",
    "City": "Kinston"
  },
  {
    "State": "NC",
    "City": "Albertson"
  },
  {
    "State": "NC",
    "City": "Alliance"
  },
  {
    "State": "NC",
    "City": "Arapahoe"
  },
  {
    "State": "NC",
    "City": "Atlantic"
  },
  {
    "State": "NC",
    "City": "Atlantic Beach"
  },
  {
    "State": "NC",
    "City": "Ayden"
  },
  {
    "State": "NC",
    "City": "Bayboro"
  },
  {
    "State": "NC",
    "City": "Beaufort"
  },
  {
    "State": "NC",
    "City": "Beulaville"
  },
  {
    "State": "NC",
    "City": "Bridgeton"
  },
  {
    "State": "NC",
    "City": "Cedar Island"
  },
  {
    "State": "NC",
    "City": "Chinquapin"
  },
  {
    "State": "NC",
    "City": "Comfort"
  },
  {
    "State": "NC",
    "City": "Cove City"
  },
  {
    "State": "NC",
    "City": "Davis"
  },
  {
    "State": "NC",
    "City": "Deep Run"
  },
  {
    "State": "NC",
    "City": "Dover"
  },
  {
    "State": "NC",
    "City": "Ernul"
  },
  {
    "State": "NC",
    "City": "Gloucester"
  },
  {
    "State": "NC",
    "City": "Grantsboro"
  },
  {
    "State": "NC",
    "City": "Grifton"
  },
  {
    "State": "NC",
    "City": "Harkers Island"
  },
  {
    "State": "NC",
    "City": "Havelock"
  },
  {
    "State": "NC",
    "City": "Cherry Point"
  },
  {
    "State": "NC",
    "City": "Hobucken"
  },
  {
    "State": "NC",
    "City": "Hookerton"
  },
  {
    "State": "NC",
    "City": "Hubert"
  },
  {
    "State": "NC",
    "City": "Jacksonville"
  },
  {
    "State": "NC",
    "City": "Camp Lejeune"
  },
  {
    "State": "NC",
    "City": "Tarawa Terrace"
  },
  {
    "State": "NC",
    "City": "Midway Park"
  },
  {
    "State": "NC",
    "City": "Mccutcheon Field"
  },
  {
    "State": "NC",
    "City": "La Grange"
  },
  {
    "State": "NC",
    "City": "Lowland"
  },
  {
    "State": "NC",
    "City": "Marshallberg"
  },
  {
    "State": "NC",
    "City": "Maury"
  },
  {
    "State": "NC",
    "City": "Maysville"
  },
  {
    "State": "NC",
    "City": "Merritt"
  },
  {
    "State": "NC",
    "City": "Morehead City"
  },
  {
    "State": "NC",
    "City": "New Bern"
  },
  {
    "State": "NC",
    "City": "Newport"
  },
  {
    "State": "NC",
    "City": "Oriental"
  },
  {
    "State": "NC",
    "City": "Pink Hill"
  },
  {
    "State": "NC",
    "City": "Pollocksville"
  },
  {
    "State": "NC",
    "City": "Richlands"
  },
  {
    "State": "NC",
    "City": "Salter Path"
  },
  {
    "State": "NC",
    "City": "Sealevel"
  },
  {
    "State": "NC",
    "City": "Seven Springs"
  },
  {
    "State": "NC",
    "City": "Smyrna"
  },
  {
    "State": "NC",
    "City": "Snow Hill"
  },
  {
    "State": "NC",
    "City": "Stacy"
  },
  {
    "State": "NC",
    "City": "Stella"
  },
  {
    "State": "NC",
    "City": "Stonewall"
  },
  {
    "State": "NC",
    "City": "Swansboro"
  },
  {
    "State": "NC",
    "City": "Trenton"
  },
  {
    "State": "NC",
    "City": "Vanceboro"
  },
  {
    "State": "NC",
    "City": "Vandemere"
  },
  {
    "State": "NC",
    "City": "Williston"
  },
  {
    "State": "NC",
    "City": "Winterville"
  },
  {
    "State": "NC",
    "City": "Emerald Isle"
  },
  {
    "State": "NC",
    "City": "Hickory"
  },
  {
    "State": "NC",
    "City": "Banner Elk"
  },
  {
    "State": "NC",
    "City": "Blowing Rock"
  },
  {
    "State": "NC",
    "City": "Boomer"
  },
  {
    "State": "NC",
    "City": "Boone"
  },
  {
    "State": "NC",
    "City": "Catawba"
  },
  {
    "State": "NC",
    "City": "Claremont"
  },
  {
    "State": "NC",
    "City": "Collettsville"
  },
  {
    "State": "NC",
    "City": "Connelly Springs"
  },
  {
    "State": "NC",
    "City": "Conover"
  },
  {
    "State": "NC",
    "City": "Creston"
  },
  {
    "State": "NC",
    "City": "Crossnore"
  },
  {
    "State": "NC",
    "City": "Crumpler"
  },
  {
    "State": "NC",
    "City": "Deep Gap"
  },
  {
    "State": "NC",
    "City": "Drexel"
  },
  {
    "State": "NC",
    "City": "Elkin"
  },
  {
    "State": "NC",
    "City": "Elk Park"
  },
  {
    "State": "NC",
    "City": "Ennice"
  },
  {
    "State": "NC",
    "City": "Ferguson"
  },
  {
    "State": "NC",
    "City": "Statesville"
  },
  {
    "State": "NC",
    "City": "Fleetwood"
  },
  {
    "State": "NC",
    "City": "Glade Valley"
  },
  {
    "State": "NC",
    "City": "Glen Alpine"
  },
  {
    "State": "NC",
    "City": "Glendale Springs"
  },
  {
    "State": "NC",
    "City": "Granite Falls"
  },
  {
    "State": "NC",
    "City": "Grassy Creek"
  },
  {
    "State": "NC",
    "City": "Lenoir"
  },
  {
    "State": "NC",
    "City": "Harmony"
  },
  {
    "State": "NC",
    "City": "Hays"
  },
  {
    "State": "NC",
    "City": "Hiddenite"
  },
  {
    "State": "NC",
    "City": "Hildebran"
  },
  {
    "State": "NC",
    "City": "Hudson"
  },
  {
    "State": "NC",
    "City": "Jefferson"
  },
  {
    "State": "NC",
    "City": "Jonas Ridge"
  },
  {
    "State": "NC",
    "City": "Jonesville"
  },
  {
    "State": "NC",
    "City": "Lansing"
  },
  {
    "State": "NC",
    "City": "Laurel Springs"
  },
  {
    "State": "NC",
    "City": "Linville"
  },
  {
    "State": "NC",
    "City": "Linville Falls"
  },
  {
    "State": "NC",
    "City": "Mc Grady"
  },
  {
    "State": "NC",
    "City": "Maiden"
  },
  {
    "State": "NC",
    "City": "Millers Creek"
  },
  {
    "State": "NC",
    "City": "Minneapolis"
  },
  {
    "State": "NC",
    "City": "Montezuma"
  },
  {
    "State": "NC",
    "City": "Moravian Falls"
  },
  {
    "State": "NC",
    "City": "Morganton"
  },
  {
    "State": "NC",
    "City": "North Wilkesboro"
  },
  {
    "State": "NC",
    "City": "Newland"
  },
  {
    "State": "NC",
    "City": "Newton"
  },
  {
    "State": "NC",
    "City": "Olin"
  },
  {
    "State": "NC",
    "City": "Patterson"
  },
  {
    "State": "NC",
    "City": "Pineola"
  },
  {
    "State": "NC",
    "City": "Piney Creek"
  },
  {
    "State": "NC",
    "City": "Plumtree"
  },
  {
    "State": "NC",
    "City": "Purlear"
  },
  {
    "State": "NC",
    "City": "Icard"
  },
  {
    "State": "NC",
    "City": "Rhodhiss"
  },
  {
    "State": "NC",
    "City": "Roaring Gap"
  },
  {
    "State": "NC",
    "City": "Roaring River"
  },
  {
    "State": "NC",
    "City": "Ronda"
  },
  {
    "State": "NC",
    "City": "Rutherford College"
  },
  {
    "State": "NC",
    "City": "Scottville"
  },
  {
    "State": "NC",
    "City": "Sherrills Ford"
  },
  {
    "State": "NC",
    "City": "Sparta"
  },
  {
    "State": "NC",
    "City": "State Road"
  },
  {
    "State": "NC",
    "City": "Stony Point"
  },
  {
    "State": "NC",
    "City": "Sugar Grove"
  },
  {
    "State": "NC",
    "City": "Taylorsville"
  },
  {
    "State": "NC",
    "City": "Terrell"
  },
  {
    "State": "NC",
    "City": "Thurmond"
  },
  {
    "State": "NC",
    "City": "Todd"
  },
  {
    "State": "NC",
    "City": "Traphill"
  },
  {
    "State": "NC",
    "City": "Turnersburg"
  },
  {
    "State": "NC",
    "City": "Union Grove"
  },
  {
    "State": "NC",
    "City": "Valdese"
  },
  {
    "State": "NC",
    "City": "Valle Crucis"
  },
  {
    "State": "NC",
    "City": "Vilas"
  },
  {
    "State": "NC",
    "City": "Warrensville"
  },
  {
    "State": "NC",
    "City": "West Jefferson"
  },
  {
    "State": "NC",
    "City": "Wilkesboro"
  },
  {
    "State": "NC",
    "City": "Zionville"
  },
  {
    "State": "NC",
    "City": "Scotts"
  },
  {
    "State": "NC",
    "City": "Alexander"
  },
  {
    "State": "NC",
    "City": "Almond"
  },
  {
    "State": "NC",
    "City": "Arden"
  },
  {
    "State": "NC",
    "City": "Bakersville"
  },
  {
    "State": "NC",
    "City": "Balsam"
  },
  {
    "State": "NC",
    "City": "Balsam Grove"
  },
  {
    "State": "NC",
    "City": "Barnardsville"
  },
  {
    "State": "NC",
    "City": "Bat Cave"
  },
  {
    "State": "NC",
    "City": "Black Mountain"
  },
  {
    "State": "NC",
    "City": "Brevard"
  },
  {
    "State": "NC",
    "City": "Bryson City"
  },
  {
    "State": "NC",
    "City": "Burnsville"
  },
  {
    "State": "NC",
    "City": "Candler"
  },
  {
    "State": "NC",
    "City": "Canton"
  },
  {
    "State": "NC",
    "City": "Cashiers"
  },
  {
    "State": "NC",
    "City": "Cedar Mountain"
  },
  {
    "State": "NC",
    "City": "Cherokee"
  },
  {
    "State": "NC",
    "City": "Chimney Rock"
  },
  {
    "State": "NC",
    "City": "Clyde"
  },
  {
    "State": "NC",
    "City": "Columbus"
  },
  {
    "State": "NC",
    "City": "Cullowhee"
  },
  {
    "State": "NC",
    "City": "Dana"
  },
  {
    "State": "NC",
    "City": "Dillsboro"
  },
  {
    "State": "NC",
    "City": "East Flat Rock"
  },
  {
    "State": "NC",
    "City": "Edneyville"
  },
  {
    "State": "NC",
    "City": "Enka"
  },
  {
    "State": "NC",
    "City": "Etowah"
  },
  {
    "State": "NC",
    "City": "Fairview"
  },
  {
    "State": "NC",
    "City": "Flat Rock"
  },
  {
    "State": "NC",
    "City": "Fletcher"
  },
  {
    "State": "NC",
    "City": "Fontana Dam"
  },
  {
    "State": "NC",
    "City": "Franklin"
  },
  {
    "State": "NC",
    "City": "Gerton"
  },
  {
    "State": "NC",
    "City": "Glenville"
  },
  {
    "State": "NC",
    "City": "Glenwood"
  },
  {
    "State": "NC",
    "City": "Hazelwood"
  },
  {
    "State": "NC",
    "City": "Hendersonville"
  },
  {
    "State": "NC",
    "City": "Green Mountain"
  },
  {
    "State": "NC",
    "City": "Highlands"
  },
  {
    "State": "NC",
    "City": "Horse Shoe"
  },
  {
    "State": "NC",
    "City": "Hot Springs"
  },
  {
    "State": "NC",
    "City": "Lake Junaluska"
  },
  {
    "State": "NC",
    "City": "Lake Lure"
  },
  {
    "State": "NC",
    "City": "Lake Toxaway"
  },
  {
    "State": "NC",
    "City": "Leicester"
  },
  {
    "State": "NC",
    "City": "Little Switzerland"
  },
  {
    "State": "NC",
    "City": "Lynn"
  },
  {
    "State": "NC",
    "City": "Maggie Valley"
  },
  {
    "State": "NC",
    "City": "Marion"
  },
  {
    "State": "NC",
    "City": "Marshall"
  },
  {
    "State": "NC",
    "City": "Mars Hill"
  },
  {
    "State": "NC",
    "City": "Micaville"
  },
  {
    "State": "NC",
    "City": "Mill Spring"
  },
  {
    "State": "NC",
    "City": "Montreat"
  },
  {
    "State": "NC",
    "City": "Mountain Home"
  },
  {
    "State": "NC",
    "City": "Mills River"
  },
  {
    "State": "NC",
    "City": "Naples"
  },
  {
    "State": "NC",
    "City": "Nebo"
  },
  {
    "State": "NC",
    "City": "Old Fort"
  },
  {
    "State": "NC",
    "City": "Otto"
  },
  {
    "State": "NC",
    "City": "Penland"
  },
  {
    "State": "NC",
    "City": "Penrose"
  },
  {
    "State": "NC",
    "City": "Pisgah Forest"
  },
  {
    "State": "NC",
    "City": "Ridgecrest"
  },
  {
    "State": "NC",
    "City": "Robbinsville"
  },
  {
    "State": "NC",
    "City": "Rosman"
  },
  {
    "State": "NC",
    "City": "Saluda"
  },
  {
    "State": "NC",
    "City": "Sapphire"
  },
  {
    "State": "NC",
    "City": "Scaly Mountain"
  },
  {
    "State": "NC",
    "City": "Skyland"
  },
  {
    "State": "NC",
    "City": "Spruce Pine"
  },
  {
    "State": "NC",
    "City": "Swannanoa"
  },
  {
    "State": "NC",
    "City": "Sylva"
  },
  {
    "State": "NC",
    "City": "Topton"
  },
  {
    "State": "NC",
    "City": "Tryon"
  },
  {
    "State": "NC",
    "City": "Tuckasegee"
  },
  {
    "State": "NC",
    "City": "Tuxedo"
  },
  {
    "State": "NC",
    "City": "Waynesville"
  },
  {
    "State": "NC",
    "City": "Weaverville"
  },
  {
    "State": "NC",
    "City": "Webster"
  },
  {
    "State": "NC",
    "City": "Whittier"
  },
  {
    "State": "NC",
    "City": "Zirconia"
  },
  {
    "State": "NC",
    "City": "Asheville"
  },
  {
    "State": "NC",
    "City": "Andrews"
  },
  {
    "State": "NC",
    "City": "Brasstown"
  },
  {
    "State": "NC",
    "City": "Culberson"
  },
  {
    "State": "NC",
    "City": "Hayesville"
  },
  {
    "State": "NC",
    "City": "Marble"
  },
  {
    "State": "NC",
    "City": "Murphy"
  },
  {
    "State": "NC",
    "City": "Warne"
  },
  {
    "State": "SC",
    "City": "Alcolu"
  },
  {
    "State": "SC",
    "City": "Ballentine"
  },
  {
    "State": "SC",
    "City": "Bamberg"
  },
  {
    "State": "SC",
    "City": "Batesburg"
  },
  {
    "State": "SC",
    "City": "Bethune"
  },
  {
    "State": "SC",
    "City": "Bishopville"
  },
  {
    "State": "SC",
    "City": "Blackstock"
  },
  {
    "State": "SC",
    "City": "Blair"
  },
  {
    "State": "SC",
    "City": "Blythewood"
  },
  {
    "State": "SC",
    "City": "Bowman"
  },
  {
    "State": "SC",
    "City": "Camden"
  },
  {
    "State": "SC",
    "City": "Cameron"
  },
  {
    "State": "SC",
    "City": "Carlisle"
  },
  {
    "State": "SC",
    "City": "Cassatt"
  },
  {
    "State": "SC",
    "City": "Cayce"
  },
  {
    "State": "SC",
    "City": "Chapin"
  },
  {
    "State": "SC",
    "City": "Chappells"
  },
  {
    "State": "SC",
    "City": "Cope"
  },
  {
    "State": "SC",
    "City": "Cordova"
  },
  {
    "State": "SC",
    "City": "Dalzell"
  },
  {
    "State": "SC",
    "City": "Davis Station"
  },
  {
    "State": "SC",
    "City": "Denmark"
  },
  {
    "State": "SC",
    "City": "Eastover"
  },
  {
    "State": "SC",
    "City": "Elgin"
  },
  {
    "State": "SC",
    "City": "Elliott"
  },
  {
    "State": "SC",
    "City": "Elloree"
  },
  {
    "State": "SC",
    "City": "Eutawville"
  },
  {
    "State": "SC",
    "City": "Gable"
  },
  {
    "State": "SC",
    "City": "Gadsden"
  },
  {
    "State": "SC",
    "City": "Gaston"
  },
  {
    "State": "SC",
    "City": "Gilbert"
  },
  {
    "State": "SC",
    "City": "Great Falls"
  },
  {
    "State": "SC",
    "City": "Greeleyville"
  },
  {
    "State": "SC",
    "City": "Heath Springs"
  },
  {
    "State": "SC",
    "City": "Holly Hill"
  },
  {
    "State": "SC",
    "City": "Hopkins"
  },
  {
    "State": "SC",
    "City": "Horatio"
  },
  {
    "State": "SC",
    "City": "Irmo"
  },
  {
    "State": "SC",
    "City": "Jenkinsville"
  },
  {
    "State": "SC",
    "City": "Kershaw"
  },
  {
    "State": "SC",
    "City": "Lamar"
  },
  {
    "State": "SC",
    "City": "Leesville"
  },
  {
    "State": "SC",
    "City": "Lexington"
  },
  {
    "State": "SC",
    "City": "Liberty Hill"
  },
  {
    "State": "SC",
    "City": "Little Mountain"
  },
  {
    "State": "SC",
    "City": "Lugoff"
  },
  {
    "State": "SC",
    "City": "Lydia"
  },
  {
    "State": "SC",
    "City": "Lynchburg"
  },
  {
    "State": "SC",
    "City": "Ehrhardt"
  },
  {
    "State": "SC",
    "City": "Lodge"
  },
  {
    "State": "SC",
    "City": "Mc Bee"
  },
  {
    "State": "SC",
    "City": "Manning"
  },
  {
    "State": "SC",
    "City": "Mayesville"
  },
  {
    "State": "SC",
    "City": "Monetta"
  },
  {
    "State": "SC",
    "City": "Neeses"
  },
  {
    "State": "SC",
    "City": "Newberry"
  },
  {
    "State": "SC",
    "City": "New Zion"
  },
  {
    "State": "SC",
    "City": "North"
  },
  {
    "State": "SC",
    "City": "Norway"
  },
  {
    "State": "SC",
    "City": "Olanta"
  },
  {
    "State": "SC",
    "City": "Orangeburg"
  },
  {
    "State": "SC",
    "City": "Peak"
  },
  {
    "State": "SC",
    "City": "Pelion"
  },
  {
    "State": "SC",
    "City": "Pinewood"
  },
  {
    "State": "SC",
    "City": "Pomaria"
  },
  {
    "State": "SC",
    "City": "Prosperity"
  },
  {
    "State": "SC",
    "City": "Rembert"
  },
  {
    "State": "SC",
    "City": "Ridge Spring"
  },
  {
    "State": "SC",
    "City": "Ridgeway"
  },
  {
    "State": "SC",
    "City": "Rion"
  },
  {
    "State": "SC",
    "City": "Rowesville"
  },
  {
    "State": "SC",
    "City": "Saint Matthews"
  },
  {
    "State": "SC",
    "City": "Salley"
  },
  {
    "State": "SC",
    "City": "Saluda"
  },
  {
    "State": "SC",
    "City": "Santee"
  },
  {
    "State": "SC",
    "City": "Sardinia"
  },
  {
    "State": "SC",
    "City": "Silverstreet"
  },
  {
    "State": "SC",
    "City": "Springfield"
  },
  {
    "State": "SC",
    "City": "State Park"
  },
  {
    "State": "SC",
    "City": "Summerton"
  },
  {
    "State": "SC",
    "City": "Sumter"
  },
  {
    "State": "SC",
    "City": "Shaw AFB"
  },
  {
    "State": "SC",
    "City": "Swansea"
  },
  {
    "State": "SC",
    "City": "Timmonsville"
  },
  {
    "State": "SC",
    "City": "Turbeville"
  },
  {
    "State": "SC",
    "City": "Vance"
  },
  {
    "State": "SC",
    "City": "Wagener"
  },
  {
    "State": "SC",
    "City": "Ward"
  },
  {
    "State": "SC",
    "City": "Wedgefield"
  },
  {
    "State": "SC",
    "City": "West Columbia"
  },
  {
    "State": "SC",
    "City": "Westville"
  },
  {
    "State": "SC",
    "City": "White Rock"
  },
  {
    "State": "SC",
    "City": "Whitmire"
  },
  {
    "State": "SC",
    "City": "Winnsboro"
  },
  {
    "State": "SC",
    "City": "Columbia"
  },
  {
    "State": "SC",
    "City": "Spartanburg"
  },
  {
    "State": "SC",
    "City": "Boiling Springs"
  },
  {
    "State": "SC",
    "City": "Arcadia"
  },
  {
    "State": "SC",
    "City": "Buffalo"
  },
  {
    "State": "SC",
    "City": "Campobello"
  },
  {
    "State": "SC",
    "City": "Chesnee"
  },
  {
    "State": "SC",
    "City": "Clifton"
  },
  {
    "State": "SC",
    "City": "Clinton"
  },
  {
    "State": "SC",
    "City": "Converse"
  },
  {
    "State": "SC",
    "City": "Cowpens"
  },
  {
    "State": "SC",
    "City": "Cross Anchor"
  },
  {
    "State": "SC",
    "City": "Cross Hill"
  },
  {
    "State": "SC",
    "City": "Drayton"
  },
  {
    "State": "SC",
    "City": "Duncan"
  },
  {
    "State": "SC",
    "City": "Enoree"
  },
  {
    "State": "SC",
    "City": "Fairforest"
  },
  {
    "State": "SC",
    "City": "Fingerville"
  },
  {
    "State": "SC",
    "City": "Gaffney"
  },
  {
    "State": "SC",
    "City": "Glendale"
  },
  {
    "State": "SC",
    "City": "Gramling"
  },
  {
    "State": "SC",
    "City": "Inman"
  },
  {
    "State": "SC",
    "City": "Joanna"
  },
  {
    "State": "SC",
    "City": "Jonesville"
  },
  {
    "State": "SC",
    "City": "Kinards"
  },
  {
    "State": "SC",
    "City": "Landrum"
  },
  {
    "State": "SC",
    "City": "Laurens"
  },
  {
    "State": "SC",
    "City": "Lockhart"
  },
  {
    "State": "SC",
    "City": "Lyman"
  },
  {
    "State": "SC",
    "City": "Mayo"
  },
  {
    "State": "SC",
    "City": "Moore"
  },
  {
    "State": "SC",
    "City": "Mountville"
  },
  {
    "State": "SC",
    "City": "Pacolet"
  },
  {
    "State": "SC",
    "City": "Pacolet Mills"
  },
  {
    "State": "SC",
    "City": "Pauline"
  },
  {
    "State": "SC",
    "City": "Reidville"
  },
  {
    "State": "SC",
    "City": "Roebuck"
  },
  {
    "State": "SC",
    "City": "Startex"
  },
  {
    "State": "SC",
    "City": "Una"
  },
  {
    "State": "SC",
    "City": "Union"
  },
  {
    "State": "SC",
    "City": "Waterloo"
  },
  {
    "State": "SC",
    "City": "Wellford"
  },
  {
    "State": "SC",
    "City": "White Stone"
  },
  {
    "State": "SC",
    "City": "Woodruff"
  },
  {
    "State": "SC",
    "City": "Charleston"
  },
  {
    "State": "SC",
    "City": "Charleston AFB"
  },
  {
    "State": "SC",
    "City": "North Charleston"
  },
  {
    "State": "SC",
    "City": "Hanahan"
  },
  {
    "State": "SC",
    "City": "Adams Run"
  },
  {
    "State": "SC",
    "City": "Awendaw"
  },
  {
    "State": "SC",
    "City": "Bethera"
  },
  {
    "State": "SC",
    "City": "Bonneau"
  },
  {
    "State": "SC",
    "City": "Branchville"
  },
  {
    "State": "SC",
    "City": "Canadys"
  },
  {
    "State": "SC",
    "City": "Cordesville"
  },
  {
    "State": "SC",
    "City": "Cottageville"
  },
  {
    "State": "SC",
    "City": "Cross"
  },
  {
    "State": "SC",
    "City": "Dorchester"
  },
  {
    "State": "SC",
    "City": "Edisto Island"
  },
  {
    "State": "SC",
    "City": "Folly Beach"
  },
  {
    "State": "SC",
    "City": "Georgetown"
  },
  {
    "State": "SC",
    "City": "Goose Creek"
  },
  {
    "State": "SC",
    "City": "Green Pond"
  },
  {
    "State": "SC",
    "City": "Grover"
  },
  {
    "State": "SC",
    "City": "Harleyville"
  },
  {
    "State": "SC",
    "City": "Hollywood"
  },
  {
    "State": "SC",
    "City": "Huger"
  },
  {
    "State": "SC",
    "City": "Isle Of Palms"
  },
  {
    "State": "SC",
    "City": "Jacksonboro"
  },
  {
    "State": "SC",
    "City": "Jamestown"
  },
  {
    "State": "SC",
    "City": "Johns Island"
  },
  {
    "State": "SC",
    "City": "Ladson"
  },
  {
    "State": "SC",
    "City": "Mc Clellanville"
  },
  {
    "State": "SC",
    "City": "Moncks Corner"
  },
  {
    "State": "SC",
    "City": "Mount Pleasant"
  },
  {
    "State": "SC",
    "City": "Pineville"
  },
  {
    "State": "SC",
    "City": "Pinopolis"
  },
  {
    "State": "SC",
    "City": "Ravenel"
  },
  {
    "State": "SC",
    "City": "Reevesville"
  },
  {
    "State": "SC",
    "City": "Ridgeville"
  },
  {
    "State": "SC",
    "City": "Round O"
  },
  {
    "State": "SC",
    "City": "Ruffin"
  },
  {
    "State": "SC",
    "City": "Russellville"
  },
  {
    "State": "SC",
    "City": "Saint George"
  },
  {
    "State": "SC",
    "City": "Saint Stephen"
  },
  {
    "State": "SC",
    "City": "Smoaks"
  },
  {
    "State": "SC",
    "City": "Sullivans Island"
  },
  {
    "State": "SC",
    "City": "Summerville"
  },
  {
    "State": "SC",
    "City": "Wadmalaw Island"
  },
  {
    "State": "SC",
    "City": "Walterboro"
  },
  {
    "State": "SC",
    "City": "Williams"
  },
  {
    "State": "SC",
    "City": "Florence"
  },
  {
    "State": "SC",
    "City": "Andrews"
  },
  {
    "State": "SC",
    "City": "Aynor"
  },
  {
    "State": "SC",
    "City": "Bennettsville"
  },
  {
    "State": "SC",
    "City": "Blenheim"
  },
  {
    "State": "SC",
    "City": "Cades"
  },
  {
    "State": "SC",
    "City": "Centenary"
  },
  {
    "State": "SC",
    "City": "Cheraw"
  },
  {
    "State": "SC",
    "City": "Clio"
  },
  {
    "State": "SC",
    "City": "Conway"
  },
  {
    "State": "SC",
    "City": "Coward"
  },
  {
    "State": "SC",
    "City": "Darlington"
  },
  {
    "State": "SC",
    "City": "Dillon"
  },
  {
    "State": "SC",
    "City": "Effingham"
  },
  {
    "State": "SC",
    "City": "Fork"
  },
  {
    "State": "SC",
    "City": "Galivants Ferry"
  },
  {
    "State": "SC",
    "City": "Green Sea"
  },
  {
    "State": "SC",
    "City": "Gresham"
  },
  {
    "State": "SC",
    "City": "Hamer"
  },
  {
    "State": "SC",
    "City": "Hartsville"
  },
  {
    "State": "SC",
    "City": "Hemingway"
  },
  {
    "State": "SC",
    "City": "Johnsonville"
  },
  {
    "State": "SC",
    "City": "Kingstree"
  },
  {
    "State": "SC",
    "City": "Lake City"
  },
  {
    "State": "SC",
    "City": "Lake View"
  },
  {
    "State": "SC",
    "City": "Lane"
  },
  {
    "State": "SC",
    "City": "Latta"
  },
  {
    "State": "SC",
    "City": "Little River"
  },
  {
    "State": "SC",
    "City": "Little Rock"
  },
  {
    "State": "SC",
    "City": "Longs"
  },
  {
    "State": "SC",
    "City": "Loris"
  },
  {
    "State": "SC",
    "City": "Mc Coll"
  },
  {
    "State": "SC",
    "City": "Marion"
  },
  {
    "State": "SC",
    "City": "Myrtle Beach"
  },
  {
    "State": "SC",
    "City": "Minturn"
  },
  {
    "State": "SC",
    "City": "Mullins"
  },
  {
    "State": "SC",
    "City": "Murrells Inlet"
  },
  {
    "State": "SC",
    "City": "Nesmith"
  },
  {
    "State": "SC",
    "City": "Nichols"
  },
  {
    "State": "SC",
    "City": "North Myrtle Beach"
  },
  {
    "State": "SC",
    "City": "Pamplico"
  },
  {
    "State": "SC",
    "City": "Patrick"
  },
  {
    "State": "SC",
    "City": "Pawleys Island"
  },
  {
    "State": "SC",
    "City": "Rains"
  },
  {
    "State": "SC",
    "City": "Salters"
  },
  {
    "State": "SC",
    "City": "Scranton"
  },
  {
    "State": "SC",
    "City": "Sellers"
  },
  {
    "State": "SC",
    "City": "Society Hill"
  },
  {
    "State": "SC",
    "City": "Tatum"
  },
  {
    "State": "SC",
    "City": "Wallace"
  },
  {
    "State": "SC",
    "City": "Greenville"
  },
  {
    "State": "SC",
    "City": "Abbeville"
  },
  {
    "State": "SC",
    "City": "Anderson"
  },
  {
    "State": "SC",
    "City": "Belton"
  },
  {
    "State": "SC",
    "City": "Calhoun Falls"
  },
  {
    "State": "SC",
    "City": "Central"
  },
  {
    "State": "SC",
    "City": "Clemson"
  },
  {
    "State": "SC",
    "City": "Cleveland"
  },
  {
    "State": "SC",
    "City": "Conestee"
  },
  {
    "State": "SC",
    "City": "Donalds"
  },
  {
    "State": "SC",
    "City": "Due West"
  },
  {
    "State": "SC",
    "City": "Easley"
  },
  {
    "State": "SC",
    "City": "Fair Play"
  },
  {
    "State": "SC",
    "City": "Fountain Inn"
  },
  {
    "State": "SC",
    "City": "Gray Court"
  },
  {
    "State": "SC",
    "City": "Greenwood"
  },
  {
    "State": "SC",
    "City": "Greer"
  },
  {
    "State": "SC",
    "City": "Hodges"
  },
  {
    "State": "SC",
    "City": "Honea Path"
  },
  {
    "State": "SC",
    "City": "Iva"
  },
  {
    "State": "SC",
    "City": "La France"
  },
  {
    "State": "SC",
    "City": "Liberty"
  },
  {
    "State": "SC",
    "City": "Long Creek"
  },
  {
    "State": "SC",
    "City": "Lowndesville"
  },
  {
    "State": "SC",
    "City": "Marietta"
  },
  {
    "State": "SC",
    "City": "Mauldin"
  },
  {
    "State": "SC",
    "City": "Mountain Rest"
  },
  {
    "State": "SC",
    "City": "Newry"
  },
  {
    "State": "SC",
    "City": "Ninety Six"
  },
  {
    "State": "SC",
    "City": "Norris"
  },
  {
    "State": "SC",
    "City": "Pelzer"
  },
  {
    "State": "SC",
    "City": "Pendleton"
  },
  {
    "State": "SC",
    "City": "Pickens"
  },
  {
    "State": "SC",
    "City": "Seneca"
  },
  {
    "State": "SC",
    "City": "Piedmont"
  },
  {
    "State": "SC",
    "City": "Richland"
  },
  {
    "State": "SC",
    "City": "Salem"
  },
  {
    "State": "SC",
    "City": "Sandy Springs"
  },
  {
    "State": "SC",
    "City": "Simpsonville"
  },
  {
    "State": "SC",
    "City": "Six Mile"
  },
  {
    "State": "SC",
    "City": "Slater"
  },
  {
    "State": "SC",
    "City": "Starr"
  },
  {
    "State": "SC",
    "City": "Sunset"
  },
  {
    "State": "SC",
    "City": "Tamassee"
  },
  {
    "State": "SC",
    "City": "Taylors"
  },
  {
    "State": "SC",
    "City": "Tigerville"
  },
  {
    "State": "SC",
    "City": "Townville"
  },
  {
    "State": "SC",
    "City": "Travelers Rest"
  },
  {
    "State": "SC",
    "City": "Walhalla"
  },
  {
    "State": "SC",
    "City": "Ware Shoals"
  },
  {
    "State": "SC",
    "City": "Westminster"
  },
  {
    "State": "SC",
    "City": "West Union"
  },
  {
    "State": "SC",
    "City": "Williamston"
  },
  {
    "State": "SC",
    "City": "Blacksburg"
  },
  {
    "State": "SC",
    "City": "Bowling Green"
  },
  {
    "State": "SC",
    "City": "Catawba"
  },
  {
    "State": "SC",
    "City": "Chester"
  },
  {
    "State": "SC",
    "City": "Fort Mill"
  },
  {
    "State": "SC",
    "City": "Chesterfield"
  },
  {
    "State": "SC",
    "City": "Clover"
  },
  {
    "State": "SC",
    "City": "Edgemoor"
  },
  {
    "State": "SC",
    "City": "Fort Lawn"
  },
  {
    "State": "SC",
    "City": "Hickory Grove"
  },
  {
    "State": "SC",
    "City": "Jefferson"
  },
  {
    "State": "SC",
    "City": "Lancaster"
  },
  {
    "State": "SC",
    "City": "Lando"
  },
  {
    "State": "SC",
    "City": "Mc Connells"
  },
  {
    "State": "SC",
    "City": "Mount Croghan"
  },
  {
    "State": "SC",
    "City": "Pageland"
  },
  {
    "State": "SC",
    "City": "Richburg"
  },
  {
    "State": "SC",
    "City": "Rock Hill"
  },
  {
    "State": "SC",
    "City": "Ruby"
  },
  {
    "State": "SC",
    "City": "Sharon"
  },
  {
    "State": "SC",
    "City": "Smyrna"
  },
  {
    "State": "SC",
    "City": "Van Wyck"
  },
  {
    "State": "SC",
    "City": "York"
  },
  {
    "State": "SC",
    "City": "Aiken"
  },
  {
    "State": "SC",
    "City": "New Ellenton"
  },
  {
    "State": "SC",
    "City": "Allendale"
  },
  {
    "State": "SC",
    "City": "Barnwell"
  },
  {
    "State": "SC",
    "City": "Hilda"
  },
  {
    "State": "SC",
    "City": "Bath"
  },
  {
    "State": "SC",
    "City": "Blackville"
  },
  {
    "State": "SC",
    "City": "Bradley"
  },
  {
    "State": "SC",
    "City": "Clarks Hill"
  },
  {
    "State": "SC",
    "City": "Clearwater"
  },
  {
    "State": "SC",
    "City": "Edgefield"
  },
  {
    "State": "SC",
    "City": "Elko"
  },
  {
    "State": "SC",
    "City": "Fairfax"
  },
  {
    "State": "SC",
    "City": "Gloverville"
  },
  {
    "State": "SC",
    "City": "Graniteville"
  },
  {
    "State": "SC",
    "City": "Jackson"
  },
  {
    "State": "SC",
    "City": "Johnston"
  },
  {
    "State": "SC",
    "City": "Langley"
  },
  {
    "State": "SC",
    "City": "Mc Cormick"
  },
  {
    "State": "SC",
    "City": "Martin"
  },
  {
    "State": "SC",
    "City": "Modoc"
  },
  {
    "State": "SC",
    "City": "Montmorenci"
  },
  {
    "State": "SC",
    "City": "Mount Carmel"
  },
  {
    "State": "SC",
    "City": "North Augusta"
  },
  {
    "State": "SC",
    "City": "Beech Island"
  },
  {
    "State": "SC",
    "City": "Olar"
  },
  {
    "State": "SC",
    "City": "Parksville"
  },
  {
    "State": "SC",
    "City": "Plum Branch"
  },
  {
    "State": "SC",
    "City": "Sycamore"
  },
  {
    "State": "SC",
    "City": "Trenton"
  },
  {
    "State": "SC",
    "City": "Troy"
  },
  {
    "State": "SC",
    "City": "Ulmer"
  },
  {
    "State": "SC",
    "City": "Vaucluse"
  },
  {
    "State": "SC",
    "City": "Warrenville"
  },
  {
    "State": "SC",
    "City": "Williston"
  },
  {
    "State": "SC",
    "City": "Windsor"
  },
  {
    "State": "SC",
    "City": "Beaufort"
  },
  {
    "State": "SC",
    "City": "Parris Island"
  },
  {
    "State": "SC",
    "City": "Okatie"
  },
  {
    "State": "SC",
    "City": "Bluffton"
  },
  {
    "State": "SC",
    "City": "Brunson"
  },
  {
    "State": "SC",
    "City": "Coosawhatchie"
  },
  {
    "State": "SC",
    "City": "Crocketville"
  },
  {
    "State": "SC",
    "City": "Dale"
  },
  {
    "State": "SC",
    "City": "Daufuskie Island"
  },
  {
    "State": "SC",
    "City": "Early Branch"
  },
  {
    "State": "SC",
    "City": "Estill"
  },
  {
    "State": "SC",
    "City": "Saint Helena Island"
  },
  {
    "State": "SC",
    "City": "Furman"
  },
  {
    "State": "SC",
    "City": "Garnett"
  },
  {
    "State": "SC",
    "City": "Gifford"
  },
  {
    "State": "SC",
    "City": "Hampton"
  },
  {
    "State": "SC",
    "City": "Hilton Head Island"
  },
  {
    "State": "SC",
    "City": "Hardeeville"
  },
  {
    "State": "SC",
    "City": "Islandton"
  },
  {
    "State": "SC",
    "City": "Lobeco"
  },
  {
    "State": "SC",
    "City": "Luray"
  },
  {
    "State": "SC",
    "City": "Miley"
  },
  {
    "State": "SC",
    "City": "Pineland"
  },
  {
    "State": "SC",
    "City": "Port Royal"
  },
  {
    "State": "SC",
    "City": "Ridgeland"
  },
  {
    "State": "SC",
    "City": "Scotia"
  },
  {
    "State": "SC",
    "City": "Seabrook"
  },
  {
    "State": "SC",
    "City": "Sheldon"
  },
  {
    "State": "SC",
    "City": "Tillman"
  },
  {
    "State": "SC",
    "City": "Varnville"
  },
  {
    "State": "SC",
    "City": "Yemassee"
  },
  {
    "State": "GA",
    "City": "Avondale Estates"
  },
  {
    "State": "GA",
    "City": "Norcross"
  },
  {
    "State": "GA",
    "City": "Alpharetta"
  },
  {
    "State": "GA",
    "City": "Marietta"
  },
  {
    "State": "GA",
    "City": "Auburn"
  },
  {
    "State": "GA",
    "City": "Conyers"
  },
  {
    "State": "GA",
    "City": "Covington"
  },
  {
    "State": "GA",
    "City": "Grayson"
  },
  {
    "State": "GA",
    "City": "Jersey"
  },
  {
    "State": "GA",
    "City": "Dacula"
  },
  {
    "State": "GA",
    "City": "Clarkston"
  },
  {
    "State": "GA",
    "City": "Suwanee"
  },
  {
    "State": "GA",
    "City": "Social Circle"
  },
  {
    "State": "GA",
    "City": "North Metro"
  },
  {
    "State": "GA",
    "City": "Cumming"
  },
  {
    "State": "GA",
    "City": "Decatur"
  },
  {
    "State": "GA",
    "City": "Lithonia"
  },
  {
    "State": "GA",
    "City": "Snellville"
  },
  {
    "State": "GA",
    "City": "Lawrenceville"
  },
  {
    "State": "GA",
    "City": "Lilburn"
  },
  {
    "State": "GA",
    "City": "Loganville"
  },
  {
    "State": "GA",
    "City": "Oxford"
  },
  {
    "State": "GA",
    "City": "Mansfield"
  },
  {
    "State": "GA",
    "City": "Newborn"
  },
  {
    "State": "GA",
    "City": "Porterdale"
  },
  {
    "State": "GA",
    "City": "Pine Lake"
  },
  {
    "State": "GA",
    "City": "Redan"
  },
  {
    "State": "GA",
    "City": "Roswell"
  },
  {
    "State": "GA",
    "City": "Scottdale"
  },
  {
    "State": "GA",
    "City": "Smyrna"
  },
  {
    "State": "GA",
    "City": "Stone Mountain"
  },
  {
    "State": "GA",
    "City": "Tucker"
  },
  {
    "State": "GA",
    "City": "Peachtree Corners"
  },
  {
    "State": "GA",
    "City": "Duluth"
  },
  {
    "State": "GA",
    "City": "Acworth"
  },
  {
    "State": "GA",
    "City": "Adairsville"
  },
  {
    "State": "GA",
    "City": "Aragon"
  },
  {
    "State": "GA",
    "City": "Armuchee"
  },
  {
    "State": "GA",
    "City": "Austell"
  },
  {
    "State": "GA",
    "City": "Ball Ground"
  },
  {
    "State": "GA",
    "City": "Bowdon"
  },
  {
    "State": "GA",
    "City": "Bowdon Junction"
  },
  {
    "State": "GA",
    "City": "Bremen"
  },
  {
    "State": "GA",
    "City": "Clarkdale"
  },
  {
    "State": "GA",
    "City": "Carrollton"
  },
  {
    "State": "GA",
    "City": "Buchanan"
  },
  {
    "State": "GA",
    "City": "Canton"
  },
  {
    "State": "GA",
    "City": "Cartersville"
  },
  {
    "State": "GA",
    "City": "Lithia Springs"
  },
  {
    "State": "GA",
    "City": "Cassville"
  },
  {
    "State": "GA",
    "City": "Cave Spring"
  },
  {
    "State": "GA",
    "City": "Cedartown"
  },
  {
    "State": "GA",
    "City": "Mableton"
  },
  {
    "State": "GA",
    "City": "Powder Springs"
  },
  {
    "State": "GA",
    "City": "Coosa"
  },
  {
    "State": "GA",
    "City": "Dallas"
  },
  {
    "State": "GA",
    "City": "Douglasville"
  },
  {
    "State": "GA",
    "City": "Emerson"
  },
  {
    "State": "GA",
    "City": "Esom Hill"
  },
  {
    "State": "GA",
    "City": "Fairmount"
  },
  {
    "State": "GA",
    "City": "Felton"
  },
  {
    "State": "GA",
    "City": "Hiram"
  },
  {
    "State": "GA",
    "City": "Holly Springs"
  },
  {
    "State": "GA",
    "City": "Jasper"
  },
  {
    "State": "GA",
    "City": "Kennesaw"
  },
  {
    "State": "GA",
    "City": "Kingston"
  },
  {
    "State": "GA",
    "City": "Lebanon"
  },
  {
    "State": "GA",
    "City": "Lindale"
  },
  {
    "State": "GA",
    "City": "Marble Hill"
  },
  {
    "State": "GA",
    "City": "Mount Berry"
  },
  {
    "State": "GA",
    "City": "Mount Zion"
  },
  {
    "State": "GA",
    "City": "Nelson"
  },
  {
    "State": "GA",
    "City": "Rockmart"
  },
  {
    "State": "GA",
    "City": "Rome"
  },
  {
    "State": "GA",
    "City": "Roopville"
  },
  {
    "State": "GA",
    "City": "Rydal"
  },
  {
    "State": "GA",
    "City": "Shannon"
  },
  {
    "State": "GA",
    "City": "Silver Creek"
  },
  {
    "State": "GA",
    "City": "Talking Rock"
  },
  {
    "State": "GA",
    "City": "Tallapoosa"
  },
  {
    "State": "GA",
    "City": "Tate"
  },
  {
    "State": "GA",
    "City": "Taylorsville"
  },
  {
    "State": "GA",
    "City": "Temple"
  },
  {
    "State": "GA",
    "City": "Villa Rica"
  },
  {
    "State": "GA",
    "City": "Waco"
  },
  {
    "State": "GA",
    "City": "Waleska"
  },
  {
    "State": "GA",
    "City": "White"
  },
  {
    "State": "GA",
    "City": "Whitesburg"
  },
  {
    "State": "GA",
    "City": "Winston"
  },
  {
    "State": "GA",
    "City": "Woodstock"
  },
  {
    "State": "GA",
    "City": "Barnesville"
  },
  {
    "State": "GA",
    "City": "Brooks"
  },
  {
    "State": "GA",
    "City": "Concord"
  },
  {
    "State": "GA",
    "City": "Experiment"
  },
  {
    "State": "GA",
    "City": "Fairburn"
  },
  {
    "State": "GA",
    "City": "Fayetteville"
  },
  {
    "State": "GA",
    "City": "Flovilla"
  },
  {
    "State": "GA",
    "City": "Franklin"
  },
  {
    "State": "GA",
    "City": "Gay"
  },
  {
    "State": "GA",
    "City": "Glenn"
  },
  {
    "State": "GA",
    "City": "Grantville"
  },
  {
    "State": "GA",
    "City": "Greenville"
  },
  {
    "State": "GA",
    "City": "Griffin"
  },
  {
    "State": "GA",
    "City": "Hampton"
  },
  {
    "State": "GA",
    "City": "Haralson"
  },
  {
    "State": "GA",
    "City": "Hogansville"
  },
  {
    "State": "GA",
    "City": "Jackson"
  },
  {
    "State": "GA",
    "City": "Jenkinsburg"
  },
  {
    "State": "GA",
    "City": "Jonesboro"
  },
  {
    "State": "GA",
    "City": "Lagrange"
  },
  {
    "State": "GA",
    "City": "Locust Grove"
  },
  {
    "State": "GA",
    "City": "Lovejoy"
  },
  {
    "State": "GA",
    "City": "Luthersville"
  },
  {
    "State": "GA",
    "City": "Mcdonough"
  },
  {
    "State": "GA",
    "City": "Meansville"
  },
  {
    "State": "GA",
    "City": "Milner"
  },
  {
    "State": "GA",
    "City": "Molena"
  },
  {
    "State": "GA",
    "City": "Moreland"
  },
  {
    "State": "GA",
    "City": "Morrow"
  },
  {
    "State": "GA",
    "City": "Newnan"
  },
  {
    "State": "GA",
    "City": "Orchard Hill"
  },
  {
    "State": "GA",
    "City": "Palmetto"
  },
  {
    "State": "GA",
    "City": "Peachtree City"
  },
  {
    "State": "GA",
    "City": "Red Oak"
  },
  {
    "State": "GA",
    "City": "Rex"
  },
  {
    "State": "GA",
    "City": "Riverdale"
  },
  {
    "State": "GA",
    "City": "Sargent"
  },
  {
    "State": "GA",
    "City": "Senoia"
  },
  {
    "State": "GA",
    "City": "Sharpsburg"
  },
  {
    "State": "GA",
    "City": "Stockbridge"
  },
  {
    "State": "GA",
    "City": "Sunny Side"
  },
  {
    "State": "GA",
    "City": "The Rock"
  },
  {
    "State": "GA",
    "City": "Thomaston"
  },
  {
    "State": "GA",
    "City": "Conley"
  },
  {
    "State": "GA",
    "City": "Turin"
  },
  {
    "State": "GA",
    "City": "Tyrone"
  },
  {
    "State": "GA",
    "City": "Union City"
  },
  {
    "State": "GA",
    "City": "Williamson"
  },
  {
    "State": "GA",
    "City": "Woodbury"
  },
  {
    "State": "GA",
    "City": "Ellenwood"
  },
  {
    "State": "GA",
    "City": "Zebulon"
  },
  {
    "State": "GA",
    "City": "Forest Park"
  },
  {
    "State": "GA",
    "City": "Atlanta"
  },
  {
    "State": "GA",
    "City": "Swainsboro"
  },
  {
    "State": "GA",
    "City": "Ailey"
  },
  {
    "State": "GA",
    "City": "Alamo"
  },
  {
    "State": "GA",
    "City": "Alston"
  },
  {
    "State": "GA",
    "City": "Bartow"
  },
  {
    "State": "GA",
    "City": "Bellville"
  },
  {
    "State": "GA",
    "City": "Brooklet"
  },
  {
    "State": "GA",
    "City": "Claxton"
  },
  {
    "State": "GA",
    "City": "Cobbtown"
  },
  {
    "State": "GA",
    "City": "Collins"
  },
  {
    "State": "GA",
    "City": "Daisy"
  },
  {
    "State": "GA",
    "City": "Dover"
  },
  {
    "State": "GA",
    "City": "Garfield"
  },
  {
    "State": "GA",
    "City": "Girard"
  },
  {
    "State": "GA",
    "City": "Glennville"
  },
  {
    "State": "GA",
    "City": "Glenwood"
  },
  {
    "State": "GA",
    "City": "Hagan"
  },
  {
    "State": "GA",
    "City": "Louisville"
  },
  {
    "State": "GA",
    "City": "Lyons"
  },
  {
    "State": "GA",
    "City": "Manassas"
  },
  {
    "State": "GA",
    "City": "Metter"
  },
  {
    "State": "GA",
    "City": "Midville"
  },
  {
    "State": "GA",
    "City": "Millen"
  },
  {
    "State": "GA",
    "City": "Mount Vernon"
  },
  {
    "State": "GA",
    "City": "Newington"
  },
  {
    "State": "GA",
    "City": "Norristown"
  },
  {
    "State": "GA",
    "City": "Nunez"
  },
  {
    "State": "GA",
    "City": "Oliver"
  },
  {
    "State": "GA",
    "City": "Portal"
  },
  {
    "State": "GA",
    "City": "Pulaski"
  },
  {
    "State": "GA",
    "City": "Register"
  },
  {
    "State": "GA",
    "City": "Reidsville"
  },
  {
    "State": "GA",
    "City": "Rockledge"
  },
  {
    "State": "GA",
    "City": "Rocky Ford"
  },
  {
    "State": "GA",
    "City": "Sardis"
  },
  {
    "State": "GA",
    "City": "Soperton"
  },
  {
    "State": "GA",
    "City": "Statesboro"
  },
  {
    "State": "GA",
    "City": "Stillmore"
  },
  {
    "State": "GA",
    "City": "Sylvania"
  },
  {
    "State": "GA",
    "City": "Tarrytown"
  },
  {
    "State": "GA",
    "City": "Twin City"
  },
  {
    "State": "GA",
    "City": "Uvalda"
  },
  {
    "State": "GA",
    "City": "Vidalia"
  },
  {
    "State": "GA",
    "City": "Wadley"
  },
  {
    "State": "GA",
    "City": "Gainesville"
  },
  {
    "State": "GA",
    "City": "Chestnut Mountain"
  },
  {
    "State": "GA",
    "City": "Alto"
  },
  {
    "State": "GA",
    "City": "Baldwin"
  },
  {
    "State": "GA",
    "City": "Blairsville"
  },
  {
    "State": "GA",
    "City": "Blue Ridge"
  },
  {
    "State": "GA",
    "City": "Buford"
  },
  {
    "State": "GA",
    "City": "Bowersville"
  },
  {
    "State": "GA",
    "City": "Braselton"
  },
  {
    "State": "GA",
    "City": "Canon"
  },
  {
    "State": "GA",
    "City": "Carnesville"
  },
  {
    "State": "GA",
    "City": "Cherry Log"
  },
  {
    "State": "GA",
    "City": "Clarkesville"
  },
  {
    "State": "GA",
    "City": "Clayton"
  },
  {
    "State": "GA",
    "City": "Clermont"
  },
  {
    "State": "GA",
    "City": "Cleveland"
  },
  {
    "State": "GA",
    "City": "Commerce"
  },
  {
    "State": "GA",
    "City": "Cornelia"
  },
  {
    "State": "GA",
    "City": "Dahlonega"
  },
  {
    "State": "GA",
    "City": "Dawsonville"
  },
  {
    "State": "GA",
    "City": "Demorest"
  },
  {
    "State": "GA",
    "City": "Ellijay"
  },
  {
    "State": "GA",
    "City": "Dillard"
  },
  {
    "State": "GA",
    "City": "Eastanollee"
  },
  {
    "State": "GA",
    "City": "East Ellijay"
  },
  {
    "State": "GA",
    "City": "Epworth"
  },
  {
    "State": "GA",
    "City": "Flowery Branch"
  },
  {
    "State": "GA",
    "City": "Gillsville"
  },
  {
    "State": "GA",
    "City": "Habersham"
  },
  {
    "State": "GA",
    "City": "Helen"
  },
  {
    "State": "GA",
    "City": "Hiawassee"
  },
  {
    "State": "GA",
    "City": "Homer"
  },
  {
    "State": "GA",
    "City": "Hoschton"
  },
  {
    "State": "GA",
    "City": "Jefferson"
  },
  {
    "State": "GA",
    "City": "Lakemont"
  },
  {
    "State": "GA",
    "City": "Lavonia"
  },
  {
    "State": "GA",
    "City": "Lula"
  },
  {
    "State": "GA",
    "City": "Mc Caysville"
  },
  {
    "State": "GA",
    "City": "Martin"
  },
  {
    "State": "GA",
    "City": "Maysville"
  },
  {
    "State": "GA",
    "City": "Mineral Bluff"
  },
  {
    "State": "GA",
    "City": "Morganton"
  },
  {
    "State": "GA",
    "City": "Mountain City"
  },
  {
    "State": "GA",
    "City": "Mount Airy"
  },
  {
    "State": "GA",
    "City": "Murrayville"
  },
  {
    "State": "GA",
    "City": "Nicholson"
  },
  {
    "State": "GA",
    "City": "Oakwood"
  },
  {
    "State": "GA",
    "City": "Pendergrass"
  },
  {
    "State": "GA",
    "City": "Rabun Gap"
  },
  {
    "State": "GA",
    "City": "Sautee Nacoochee"
  },
  {
    "State": "GA",
    "City": "Suches"
  },
  {
    "State": "GA",
    "City": "Tallulah Falls"
  },
  {
    "State": "GA",
    "City": "Talmo"
  },
  {
    "State": "GA",
    "City": "Tiger"
  },
  {
    "State": "GA",
    "City": "Toccoa"
  },
  {
    "State": "GA",
    "City": "Turnerville"
  },
  {
    "State": "GA",
    "City": "Wiley"
  },
  {
    "State": "GA",
    "City": "Young Harris"
  },
  {
    "State": "GA",
    "City": "Toccoa Falls"
  },
  {
    "State": "GA",
    "City": "Athens"
  },
  {
    "State": "GA",
    "City": "Arnoldsville"
  },
  {
    "State": "GA",
    "City": "Bethlehem"
  },
  {
    "State": "GA",
    "City": "Bishop"
  },
  {
    "State": "GA",
    "City": "Bogart"
  },
  {
    "State": "GA",
    "City": "Bostwick"
  },
  {
    "State": "GA",
    "City": "Bowman"
  },
  {
    "State": "GA",
    "City": "Buckhead"
  },
  {
    "State": "GA",
    "City": "Carlton"
  },
  {
    "State": "GA",
    "City": "Colbert"
  },
  {
    "State": "GA",
    "City": "Comer"
  },
  {
    "State": "GA",
    "City": "Crawford"
  },
  {
    "State": "GA",
    "City": "Crawfordville"
  },
  {
    "State": "GA",
    "City": "Danielsville"
  },
  {
    "State": "GA",
    "City": "Dewy Rose"
  },
  {
    "State": "GA",
    "City": "Elberton"
  },
  {
    "State": "GA",
    "City": "Farmington"
  },
  {
    "State": "GA",
    "City": "Franklin Springs"
  },
  {
    "State": "GA",
    "City": "Good Hope"
  },
  {
    "State": "GA",
    "City": "Greensboro"
  },
  {
    "State": "GA",
    "City": "Hartwell"
  },
  {
    "State": "GA",
    "City": "High Shoals"
  },
  {
    "State": "GA",
    "City": "Hull"
  },
  {
    "State": "GA",
    "City": "Ila"
  },
  {
    "State": "GA",
    "City": "Lexington"
  },
  {
    "State": "GA",
    "City": "Madison"
  },
  {
    "State": "GA",
    "City": "Monroe"
  },
  {
    "State": "GA",
    "City": "Rayle"
  },
  {
    "State": "GA",
    "City": "Royston"
  },
  {
    "State": "GA",
    "City": "Rutledge"
  },
  {
    "State": "GA",
    "City": "Sharon"
  },
  {
    "State": "GA",
    "City": "Siloam"
  },
  {
    "State": "GA",
    "City": "Statham"
  },
  {
    "State": "GA",
    "City": "Stephens"
  },
  {
    "State": "GA",
    "City": "Tignall"
  },
  {
    "State": "GA",
    "City": "Union Point"
  },
  {
    "State": "GA",
    "City": "Maxeys"
  },
  {
    "State": "GA",
    "City": "Washington"
  },
  {
    "State": "GA",
    "City": "Watkinsville"
  },
  {
    "State": "GA",
    "City": "White Plains"
  },
  {
    "State": "GA",
    "City": "Winder"
  },
  {
    "State": "GA",
    "City": "Winterville"
  },
  {
    "State": "GA",
    "City": "Calhoun"
  },
  {
    "State": "GA",
    "City": "Chatsworth"
  },
  {
    "State": "GA",
    "City": "Chickamauga"
  },
  {
    "State": "GA",
    "City": "Cisco"
  },
  {
    "State": "GA",
    "City": "Cohutta"
  },
  {
    "State": "GA",
    "City": "Crandall"
  },
  {
    "State": "GA",
    "City": "Dalton"
  },
  {
    "State": "GA",
    "City": "Eton"
  },
  {
    "State": "GA",
    "City": "Flintstone"
  },
  {
    "State": "GA",
    "City": "Graysville"
  },
  {
    "State": "GA",
    "City": "La Fayette"
  },
  {
    "State": "GA",
    "City": "Lyerly"
  },
  {
    "State": "GA",
    "City": "Menlo"
  },
  {
    "State": "GA",
    "City": "Oakman"
  },
  {
    "State": "GA",
    "City": "Plainville"
  },
  {
    "State": "GA",
    "City": "Ranger"
  },
  {
    "State": "GA",
    "City": "Resaca"
  },
  {
    "State": "GA",
    "City": "Ringgold"
  },
  {
    "State": "GA",
    "City": "Rising Fawn"
  },
  {
    "State": "GA",
    "City": "Rock Spring"
  },
  {
    "State": "GA",
    "City": "Rocky Face"
  },
  {
    "State": "GA",
    "City": "Rossville"
  },
  {
    "State": "GA",
    "City": "Fort Oglethorpe"
  },
  {
    "State": "GA",
    "City": "Sugar Valley"
  },
  {
    "State": "GA",
    "City": "Summerville"
  },
  {
    "State": "GA",
    "City": "Lookout Mountain"
  },
  {
    "State": "GA",
    "City": "Tennga"
  },
  {
    "State": "GA",
    "City": "Trenton"
  },
  {
    "State": "GA",
    "City": "Trion"
  },
  {
    "State": "GA",
    "City": "Tunnel Hill"
  },
  {
    "State": "GA",
    "City": "Varnell"
  },
  {
    "State": "GA",
    "City": "Wildwood"
  },
  {
    "State": "GA",
    "City": "Appling"
  },
  {
    "State": "GA",
    "City": "Avera"
  },
  {
    "State": "GA",
    "City": "Blythe"
  },
  {
    "State": "GA",
    "City": "Boneville"
  },
  {
    "State": "GA",
    "City": "Camak"
  },
  {
    "State": "GA",
    "City": "Dearing"
  },
  {
    "State": "GA",
    "City": "Evans"
  },
  {
    "State": "GA",
    "City": "Gibson"
  },
  {
    "State": "GA",
    "City": "Gough"
  },
  {
    "State": "GA",
    "City": "Gracewood"
  },
  {
    "State": "GA",
    "City": "Grovetown"
  },
  {
    "State": "GA",
    "City": "Harlem"
  },
  {
    "State": "GA",
    "City": "Hephzibah"
  },
  {
    "State": "GA",
    "City": "Keysville"
  },
  {
    "State": "GA",
    "City": "Lincolnton"
  },
  {
    "State": "GA",
    "City": "Matthews"
  },
  {
    "State": "GA",
    "City": "Mesena"
  },
  {
    "State": "GA",
    "City": "Mitchell"
  },
  {
    "State": "GA",
    "City": "Norwood"
  },
  {
    "State": "GA",
    "City": "Perkins"
  },
  {
    "State": "GA",
    "City": "Stapleton"
  },
  {
    "State": "GA",
    "City": "Thomson"
  },
  {
    "State": "GA",
    "City": "Warrenton"
  },
  {
    "State": "GA",
    "City": "Waynesboro"
  },
  {
    "State": "GA",
    "City": "Wrens"
  },
  {
    "State": "GA",
    "City": "Augusta"
  },
  {
    "State": "GA",
    "City": "Abbeville"
  },
  {
    "State": "GA",
    "City": "Adrian"
  },
  {
    "State": "GA",
    "City": "Allentown"
  },
  {
    "State": "GA",
    "City": "Bolingbroke"
  },
  {
    "State": "GA",
    "City": "Bonaire"
  },
  {
    "State": "GA",
    "City": "Butler"
  },
  {
    "State": "GA",
    "City": "Byromville"
  },
  {
    "State": "GA",
    "City": "Byron"
  },
  {
    "State": "GA",
    "City": "Cadwell"
  },
  {
    "State": "GA",
    "City": "Cordele"
  },
  {
    "State": "GA",
    "City": "Chauncey"
  },
  {
    "State": "GA",
    "City": "Chester"
  },
  {
    "State": "GA",
    "City": "Clinchfield"
  },
  {
    "State": "GA",
    "City": "Cochran"
  },
  {
    "State": "GA",
    "City": "Culloden"
  },
  {
    "State": "GA",
    "City": "Danville"
  },
  {
    "State": "GA",
    "City": "Davisboro"
  },
  {
    "State": "GA",
    "City": "Dexter"
  },
  {
    "State": "GA",
    "City": "Dry Branch"
  },
  {
    "State": "GA",
    "City": "Dublin"
  },
  {
    "State": "GA",
    "City": "Dudley"
  },
  {
    "State": "GA",
    "City": "Eastman"
  },
  {
    "State": "GA",
    "City": "Eatonton"
  },
  {
    "State": "GA",
    "City": "Elko"
  },
  {
    "State": "GA",
    "City": "East Dublin"
  },
  {
    "State": "GA",
    "City": "Centerville"
  },
  {
    "State": "GA",
    "City": "Forsyth"
  },
  {
    "State": "GA",
    "City": "Fort Valley"
  },
  {
    "State": "GA",
    "City": "Gordon"
  },
  {
    "State": "GA",
    "City": "Gray"
  },
  {
    "State": "GA",
    "City": "Haddock"
  },
  {
    "State": "GA",
    "City": "Hardwick"
  },
  {
    "State": "GA",
    "City": "Harrison"
  },
  {
    "State": "GA",
    "City": "Hawkinsville"
  },
  {
    "State": "GA",
    "City": "Mc Rae Helena"
  },
  {
    "State": "GA",
    "City": "Hillsboro"
  },
  {
    "State": "GA",
    "City": "Howard"
  },
  {
    "State": "GA",
    "City": "Ideal"
  },
  {
    "State": "GA",
    "City": "Irwinton"
  },
  {
    "State": "GA",
    "City": "Jeffersonville"
  },
  {
    "State": "GA",
    "City": "Jewell"
  },
  {
    "State": "GA",
    "City": "Juliette"
  },
  {
    "State": "GA",
    "City": "Kathleen"
  },
  {
    "State": "GA",
    "City": "Kite"
  },
  {
    "State": "GA",
    "City": "Knoxville"
  },
  {
    "State": "GA",
    "City": "Lilly"
  },
  {
    "State": "GA",
    "City": "Lizella"
  },
  {
    "State": "GA",
    "City": "Mc Intyre"
  },
  {
    "State": "GA",
    "City": "Marshallville"
  },
  {
    "State": "GA",
    "City": "Mauk"
  },
  {
    "State": "GA",
    "City": "Milledgeville"
  },
  {
    "State": "GA",
    "City": "Milan"
  },
  {
    "State": "GA",
    "City": "Montezuma"
  },
  {
    "State": "GA",
    "City": "Monticello"
  },
  {
    "State": "GA",
    "City": "Montrose"
  },
  {
    "State": "GA",
    "City": "Musella"
  },
  {
    "State": "GA",
    "City": "Oconee"
  },
  {
    "State": "GA",
    "City": "Oglethorpe"
  },
  {
    "State": "GA",
    "City": "Perry"
  },
  {
    "State": "GA",
    "City": "Pinehurst"
  },
  {
    "State": "GA",
    "City": "Pineview"
  },
  {
    "State": "GA",
    "City": "Pitts"
  },
  {
    "State": "GA",
    "City": "Rentz"
  },
  {
    "State": "GA",
    "City": "Reynolds"
  },
  {
    "State": "GA",
    "City": "Rhine"
  },
  {
    "State": "GA",
    "City": "Roberta"
  },
  {
    "State": "GA",
    "City": "Rochelle"
  },
  {
    "State": "GA",
    "City": "Rupert"
  },
  {
    "State": "GA",
    "City": "Sandersville"
  },
  {
    "State": "GA",
    "City": "Scotland"
  },
  {
    "State": "GA",
    "City": "Seville"
  },
  {
    "State": "GA",
    "City": "Shady Dale"
  },
  {
    "State": "GA",
    "City": "Smarr"
  },
  {
    "State": "GA",
    "City": "Sparta"
  },
  {
    "State": "GA",
    "City": "Warner Robins"
  },
  {
    "State": "GA",
    "City": "Tennille"
  },
  {
    "State": "GA",
    "City": "Toomsboro"
  },
  {
    "State": "GA",
    "City": "Unadilla"
  },
  {
    "State": "GA",
    "City": "Vienna"
  },
  {
    "State": "GA",
    "City": "Warthen"
  },
  {
    "State": "GA",
    "City": "Wrightsville"
  },
  {
    "State": "GA",
    "City": "Yatesville"
  },
  {
    "State": "GA",
    "City": "Macon"
  },
  {
    "State": "GA",
    "City": "Allenhurst"
  },
  {
    "State": "GA",
    "City": "Bloomingdale"
  },
  {
    "State": "GA",
    "City": "Clyo"
  },
  {
    "State": "GA",
    "City": "Crescent"
  },
  {
    "State": "GA",
    "City": "Darien"
  },
  {
    "State": "GA",
    "City": "Eden"
  },
  {
    "State": "GA",
    "City": "Ellabell"
  },
  {
    "State": "GA",
    "City": "Fleming"
  },
  {
    "State": "GA",
    "City": "Hinesville"
  },
  {
    "State": "GA",
    "City": "Guyton"
  },
  {
    "State": "GA",
    "City": "Fort Stewart"
  },
  {
    "State": "GA",
    "City": "Ludowici"
  },
  {
    "State": "GA",
    "City": "Meldrim"
  },
  {
    "State": "GA",
    "City": "Meridian"
  },
  {
    "State": "GA",
    "City": "Midway"
  },
  {
    "State": "GA",
    "City": "Pembroke"
  },
  {
    "State": "GA",
    "City": "Pooler"
  },
  {
    "State": "GA",
    "City": "Riceboro"
  },
  {
    "State": "GA",
    "City": "Richmond Hill"
  },
  {
    "State": "GA",
    "City": "Rincon"
  },
  {
    "State": "GA",
    "City": "Sapelo Island"
  },
  {
    "State": "GA",
    "City": "Tybee Island"
  },
  {
    "State": "GA",
    "City": "Springfield"
  },
  {
    "State": "GA",
    "City": "Townsend"
  },
  {
    "State": "GA",
    "City": "Walthourville"
  },
  {
    "State": "GA",
    "City": "Savannah"
  },
  {
    "State": "GA",
    "City": "Port Wentworth"
  },
  {
    "State": "GA",
    "City": "Waycross"
  },
  {
    "State": "GA",
    "City": "Alma"
  },
  {
    "State": "GA",
    "City": "Ambrose"
  },
  {
    "State": "GA",
    "City": "Baxley"
  },
  {
    "State": "GA",
    "City": "Blackshear"
  },
  {
    "State": "GA",
    "City": "Bristol"
  },
  {
    "State": "GA",
    "City": "Broxton"
  },
  {
    "State": "GA",
    "City": "Brunswick"
  },
  {
    "State": "GA",
    "City": "Saint Simons Island"
  },
  {
    "State": "GA",
    "City": "Jekyll Island"
  },
  {
    "State": "GA",
    "City": "Denton"
  },
  {
    "State": "GA",
    "City": "Douglas"
  },
  {
    "State": "GA",
    "City": "Folkston"
  },
  {
    "State": "GA",
    "City": "Hazlehurst"
  },
  {
    "State": "GA",
    "City": "Hoboken"
  },
  {
    "State": "GA",
    "City": "Hortense"
  },
  {
    "State": "GA",
    "City": "Jacksonville"
  },
  {
    "State": "GA",
    "City": "Jesup"
  },
  {
    "State": "GA",
    "City": "Kings Bay"
  },
  {
    "State": "GA",
    "City": "Kingsland"
  },
  {
    "State": "GA",
    "City": "Lumber City"
  },
  {
    "State": "GA",
    "City": "Manor"
  },
  {
    "State": "GA",
    "City": "Mershon"
  },
  {
    "State": "GA",
    "City": "Millwood"
  },
  {
    "State": "GA",
    "City": "Nahunta"
  },
  {
    "State": "GA",
    "City": "Nicholls"
  },
  {
    "State": "GA",
    "City": "Odum"
  },
  {
    "State": "GA",
    "City": "Offerman"
  },
  {
    "State": "GA",
    "City": "Patterson"
  },
  {
    "State": "GA",
    "City": "Saint Marys"
  },
  {
    "State": "GA",
    "City": "Screven"
  },
  {
    "State": "GA",
    "City": "Sea Island"
  },
  {
    "State": "GA",
    "City": "Saint George"
  },
  {
    "State": "GA",
    "City": "Surrency"
  },
  {
    "State": "GA",
    "City": "Waresboro"
  },
  {
    "State": "GA",
    "City": "Waverly"
  },
  {
    "State": "GA",
    "City": "Waynesville"
  },
  {
    "State": "GA",
    "City": "West Green"
  },
  {
    "State": "GA",
    "City": "White Oak"
  },
  {
    "State": "GA",
    "City": "Woodbine"
  },
  {
    "State": "GA",
    "City": "Valdosta"
  },
  {
    "State": "GA",
    "City": "Adel"
  },
  {
    "State": "GA",
    "City": "Alapaha"
  },
  {
    "State": "GA",
    "City": "Argyle"
  },
  {
    "State": "GA",
    "City": "Axson"
  },
  {
    "State": "GA",
    "City": "Barney"
  },
  {
    "State": "GA",
    "City": "Boston"
  },
  {
    "State": "GA",
    "City": "Cecil"
  },
  {
    "State": "GA",
    "City": "Dixie"
  },
  {
    "State": "GA",
    "City": "Du Pont"
  },
  {
    "State": "GA",
    "City": "Fargo"
  },
  {
    "State": "GA",
    "City": "Hahira"
  },
  {
    "State": "GA",
    "City": "Homerville"
  },
  {
    "State": "GA",
    "City": "Lakeland"
  },
  {
    "State": "GA",
    "City": "Lake Park"
  },
  {
    "State": "GA",
    "City": "Lenox"
  },
  {
    "State": "GA",
    "City": "Morven"
  },
  {
    "State": "GA",
    "City": "Nashville"
  },
  {
    "State": "GA",
    "City": "Naylor"
  },
  {
    "State": "GA",
    "City": "Pearson"
  },
  {
    "State": "GA",
    "City": "Quitman"
  },
  {
    "State": "GA",
    "City": "Ray City"
  },
  {
    "State": "GA",
    "City": "Sparks"
  },
  {
    "State": "GA",
    "City": "Statenville"
  },
  {
    "State": "GA",
    "City": "Stockton"
  },
  {
    "State": "GA",
    "City": "Willacoochee"
  },
  {
    "State": "GA",
    "City": "Moody AFB"
  },
  {
    "State": "GA",
    "City": "Albany"
  },
  {
    "State": "GA",
    "City": "Americus"
  },
  {
    "State": "GA",
    "City": "Andersonville"
  },
  {
    "State": "GA",
    "City": "Arabi"
  },
  {
    "State": "GA",
    "City": "Ashburn"
  },
  {
    "State": "GA",
    "City": "Baconton"
  },
  {
    "State": "GA",
    "City": "Barwick"
  },
  {
    "State": "GA",
    "City": "Berlin"
  },
  {
    "State": "GA",
    "City": "Brookfield"
  },
  {
    "State": "GA",
    "City": "Camilla"
  },
  {
    "State": "GA",
    "City": "Chula"
  },
  {
    "State": "GA",
    "City": "Cobb"
  },
  {
    "State": "GA",
    "City": "Coolidge"
  },
  {
    "State": "GA",
    "City": "Cotton"
  },
  {
    "State": "GA",
    "City": "De Soto"
  },
  {
    "State": "GA",
    "City": "Doerun"
  },
  {
    "State": "GA",
    "City": "Ellenton"
  },
  {
    "State": "GA",
    "City": "Enigma"
  },
  {
    "State": "GA",
    "City": "Fitzgerald"
  },
  {
    "State": "GA",
    "City": "Funston"
  },
  {
    "State": "GA",
    "City": "Hartsfield"
  },
  {
    "State": "GA",
    "City": "Thomasville"
  },
  {
    "State": "GA",
    "City": "Irwinville"
  },
  {
    "State": "GA",
    "City": "Leesburg"
  },
  {
    "State": "GA",
    "City": "Leslie"
  },
  {
    "State": "GA",
    "City": "Meigs"
  },
  {
    "State": "GA",
    "City": "Moultrie"
  },
  {
    "State": "GA",
    "City": "Mystic"
  },
  {
    "State": "GA",
    "City": "Norman Park"
  },
  {
    "State": "GA",
    "City": "Oakfield"
  },
  {
    "State": "GA",
    "City": "Ochlocknee"
  },
  {
    "State": "GA",
    "City": "Ocilla"
  },
  {
    "State": "GA",
    "City": "Omega"
  },
  {
    "State": "GA",
    "City": "Pavo"
  },
  {
    "State": "GA",
    "City": "Pelham"
  },
  {
    "State": "GA",
    "City": "Plains"
  },
  {
    "State": "GA",
    "City": "Poulan"
  },
  {
    "State": "GA",
    "City": "Putney"
  },
  {
    "State": "GA",
    "City": "Rebecca"
  },
  {
    "State": "GA",
    "City": "Sale City"
  },
  {
    "State": "GA",
    "City": "Smithville"
  },
  {
    "State": "GA",
    "City": "Sumner"
  },
  {
    "State": "GA",
    "City": "Sycamore"
  },
  {
    "State": "GA",
    "City": "Sylvester"
  },
  {
    "State": "GA",
    "City": "Tifton"
  },
  {
    "State": "GA",
    "City": "TY TY"
  },
  {
    "State": "GA",
    "City": "Warwick"
  },
  {
    "State": "GA",
    "City": "Wray"
  },
  {
    "State": "GA",
    "City": "Box Springs"
  },
  {
    "State": "GA",
    "City": "Buena Vista"
  },
  {
    "State": "GA",
    "City": "Cataula"
  },
  {
    "State": "GA",
    "City": "Cusseta"
  },
  {
    "State": "GA",
    "City": "Ellaville"
  },
  {
    "State": "GA",
    "City": "Ellerslie"
  },
  {
    "State": "GA",
    "City": "Fortson"
  },
  {
    "State": "GA",
    "City": "Geneva"
  },
  {
    "State": "GA",
    "City": "Hamilton"
  },
  {
    "State": "GA",
    "City": "Junction City"
  },
  {
    "State": "GA",
    "City": "Louvale"
  },
  {
    "State": "GA",
    "City": "Lumpkin"
  },
  {
    "State": "GA",
    "City": "Manchester"
  },
  {
    "State": "GA",
    "City": "Midland"
  },
  {
    "State": "GA",
    "City": "Omaha"
  },
  {
    "State": "GA",
    "City": "Pine Mountain"
  },
  {
    "State": "GA",
    "City": "Pine Mountain Valley"
  },
  {
    "State": "GA",
    "City": "Preston"
  },
  {
    "State": "GA",
    "City": "Richland"
  },
  {
    "State": "GA",
    "City": "Shiloh"
  },
  {
    "State": "GA",
    "City": "Talbotton"
  },
  {
    "State": "GA",
    "City": "Upatoi"
  },
  {
    "State": "GA",
    "City": "Warm Springs"
  },
  {
    "State": "GA",
    "City": "Waverly Hall"
  },
  {
    "State": "GA",
    "City": "Weston"
  },
  {
    "State": "GA",
    "City": "West Point"
  },
  {
    "State": "GA",
    "City": "Woodland"
  },
  {
    "State": "GA",
    "City": "Columbus"
  },
  {
    "State": "GA",
    "City": "Fort Benning"
  },
  {
    "State": "FL",
    "City": "Fleming Island"
  },
  {
    "State": "FL",
    "City": "Ponte Vedra Beach"
  },
  {
    "State": "FL",
    "City": "Bostwick"
  },
  {
    "State": "FL",
    "City": "Branford"
  },
  {
    "State": "FL",
    "City": "Bryceville"
  },
  {
    "State": "FL",
    "City": "Callahan"
  },
  {
    "State": "FL",
    "City": "Day"
  },
  {
    "State": "FL",
    "City": "Lake City"
  },
  {
    "State": "FL",
    "City": "Raiford"
  },
  {
    "State": "FL",
    "City": "Doctors Inlet"
  },
  {
    "State": "FL",
    "City": "Elkton"
  },
  {
    "State": "FL",
    "City": "Fernandina Beach"
  },
  {
    "State": "FL",
    "City": "Fort White"
  },
  {
    "State": "FL",
    "City": "Glen Saint Mary"
  },
  {
    "State": "FL",
    "City": "Yulee"
  },
  {
    "State": "FL",
    "City": "Graham"
  },
  {
    "State": "FL",
    "City": "Green Cove Springs"
  },
  {
    "State": "FL",
    "City": "Hampton"
  },
  {
    "State": "FL",
    "City": "Hilliard"
  },
  {
    "State": "FL",
    "City": "Middleburg"
  },
  {
    "State": "FL",
    "City": "Jasper"
  },
  {
    "State": "FL",
    "City": "Jennings"
  },
  {
    "State": "FL",
    "City": "Lake Butler"
  },
  {
    "State": "FL",
    "City": "Lawtey"
  },
  {
    "State": "FL",
    "City": "Lee"
  },
  {
    "State": "FL",
    "City": "Live Oak"
  },
  {
    "State": "FL",
    "City": "Lulu"
  },
  {
    "State": "FL",
    "City": "Mc Alpin"
  },
  {
    "State": "FL",
    "City": "Macclenny"
  },
  {
    "State": "FL",
    "City": "Orange Park"
  },
  {
    "State": "FL",
    "City": "Mayo"
  },
  {
    "State": "FL",
    "City": "O Brien"
  },
  {
    "State": "FL",
    "City": "Olustee"
  },
  {
    "State": "FL",
    "City": "Penney Farms"
  },
  {
    "State": "FL",
    "City": "Saint Augustine"
  },
  {
    "State": "FL",
    "City": "Ponte Vedra"
  },
  {
    "State": "FL",
    "City": "Sanderson"
  },
  {
    "State": "FL",
    "City": "Starke"
  },
  {
    "State": "FL",
    "City": "Wellborn"
  },
  {
    "State": "FL",
    "City": "White Springs"
  },
  {
    "State": "FL",
    "City": "Jacksonville"
  },
  {
    "State": "FL",
    "City": "Astor"
  },
  {
    "State": "FL",
    "City": "Barberville"
  },
  {
    "State": "FL",
    "City": "Bunnell"
  },
  {
    "State": "FL",
    "City": "Candler"
  },
  {
    "State": "FL",
    "City": "Crescent City"
  },
  {
    "State": "FL",
    "City": "Citra"
  },
  {
    "State": "FL",
    "City": "Daytona Beach"
  },
  {
    "State": "FL",
    "City": "Port Orange"
  },
  {
    "State": "FL",
    "City": "De Leon Springs"
  },
  {
    "State": "FL",
    "City": "East Palatka"
  },
  {
    "State": "FL",
    "City": "Edgewater"
  },
  {
    "State": "FL",
    "City": "Eastlake Weir"
  },
  {
    "State": "FL",
    "City": "Fort Mc Coy"
  },
  {
    "State": "FL",
    "City": "Palm Coast"
  },
  {
    "State": "FL",
    "City": "Flagler Beach"
  },
  {
    "State": "FL",
    "City": "Grandin"
  },
  {
    "State": "FL",
    "City": "Georgetown"
  },
  {
    "State": "FL",
    "City": "Florahome"
  },
  {
    "State": "FL",
    "City": "Hastings"
  },
  {
    "State": "FL",
    "City": "Hollister"
  },
  {
    "State": "FL",
    "City": "Interlachen"
  },
  {
    "State": "FL",
    "City": "Lake Como"
  },
  {
    "State": "FL",
    "City": "Lady Lake"
  },
  {
    "State": "FL",
    "City": "Lake Geneva"
  },
  {
    "State": "FL",
    "City": "The Villages"
  },
  {
    "State": "FL",
    "City": "New Smyrna Beach"
  },
  {
    "State": "FL",
    "City": "Ormond Beach"
  },
  {
    "State": "FL",
    "City": "Palatka"
  },
  {
    "State": "FL",
    "City": "Ocklawaha"
  },
  {
    "State": "FL",
    "City": "Pierson"
  },
  {
    "State": "FL",
    "City": "Pomona Park"
  },
  {
    "State": "FL",
    "City": "Orange Springs"
  },
  {
    "State": "FL",
    "City": "Putnam Hall"
  },
  {
    "State": "FL",
    "City": "San Mateo"
  },
  {
    "State": "FL",
    "City": "Satsuma"
  },
  {
    "State": "FL",
    "City": "Seville"
  },
  {
    "State": "FL",
    "City": "Sparr"
  },
  {
    "State": "FL",
    "City": "Welaka"
  },
  {
    "State": "FL",
    "City": "Weirsdale"
  },
  {
    "State": "FL",
    "City": "Atlantic Beach"
  },
  {
    "State": "FL",
    "City": "Jacksonville Beach"
  },
  {
    "State": "FL",
    "City": "Saint Johns"
  },
  {
    "State": "FL",
    "City": "Neptune Beach"
  },
  {
    "State": "FL",
    "City": "Tallahassee"
  },
  {
    "State": "FL",
    "City": "Apalachicola"
  },
  {
    "State": "FL",
    "City": "Bristol"
  },
  {
    "State": "FL",
    "City": "Carrabelle"
  },
  {
    "State": "FL",
    "City": "Lanark Village"
  },
  {
    "State": "FL",
    "City": "Chattahoochee"
  },
  {
    "State": "FL",
    "City": "Crawfordville"
  },
  {
    "State": "FL",
    "City": "Eastpoint"
  },
  {
    "State": "FL",
    "City": "Greensboro"
  },
  {
    "State": "FL",
    "City": "Greenville"
  },
  {
    "State": "FL",
    "City": "Gretna"
  },
  {
    "State": "FL",
    "City": "Havana"
  },
  {
    "State": "FL",
    "City": "Hosford"
  },
  {
    "State": "FL",
    "City": "Sumatra"
  },
  {
    "State": "FL",
    "City": "Lamont"
  },
  {
    "State": "FL",
    "City": "Lloyd"
  },
  {
    "State": "FL",
    "City": "Madison"
  },
  {
    "State": "FL",
    "City": "Midway"
  },
  {
    "State": "FL",
    "City": "Monticello"
  },
  {
    "State": "FL",
    "City": "Panacea"
  },
  {
    "State": "FL",
    "City": "Perry"
  },
  {
    "State": "FL",
    "City": "Pinetta"
  },
  {
    "State": "FL",
    "City": "Quincy"
  },
  {
    "State": "FL",
    "City": "Saint Marks"
  },
  {
    "State": "FL",
    "City": "Salem"
  },
  {
    "State": "FL",
    "City": "Shady Grove"
  },
  {
    "State": "FL",
    "City": "Sopchoppy"
  },
  {
    "State": "FL",
    "City": "Steinhatchee"
  },
  {
    "State": "FL",
    "City": "Telogia"
  },
  {
    "State": "FL",
    "City": "Wacissa"
  },
  {
    "State": "FL",
    "City": "Woodville"
  },
  {
    "State": "FL",
    "City": "Panama City"
  },
  {
    "State": "FL",
    "City": "Panama City Beach"
  },
  {
    "State": "FL",
    "City": "Mexico Beach"
  },
  {
    "State": "FL",
    "City": "Alford"
  },
  {
    "State": "FL",
    "City": "Altha"
  },
  {
    "State": "FL",
    "City": "Argyle"
  },
  {
    "State": "FL",
    "City": "Bascom"
  },
  {
    "State": "FL",
    "City": "Blountstown"
  },
  {
    "State": "FL",
    "City": "Bonifay"
  },
  {
    "State": "FL",
    "City": "Campbellton"
  },
  {
    "State": "FL",
    "City": "Caryville"
  },
  {
    "State": "FL",
    "City": "Chipley"
  },
  {
    "State": "FL",
    "City": "Clarksville"
  },
  {
    "State": "FL",
    "City": "Cottondale"
  },
  {
    "State": "FL",
    "City": "Cypress"
  },
  {
    "State": "FL",
    "City": "Defuniak Springs"
  },
  {
    "State": "FL",
    "City": "Mossy Head"
  },
  {
    "State": "FL",
    "City": "Ebro"
  },
  {
    "State": "FL",
    "City": "Fountain"
  },
  {
    "State": "FL",
    "City": "Freeport"
  },
  {
    "State": "FL",
    "City": "Graceville"
  },
  {
    "State": "FL",
    "City": "Grand Ridge"
  },
  {
    "State": "FL",
    "City": "Greenwood"
  },
  {
    "State": "FL",
    "City": "Lynn Haven"
  },
  {
    "State": "FL",
    "City": "Malone"
  },
  {
    "State": "FL",
    "City": "Marianna"
  },
  {
    "State": "FL",
    "City": "Wewahitchka"
  },
  {
    "State": "FL",
    "City": "Noma"
  },
  {
    "State": "FL",
    "City": "Point Washington"
  },
  {
    "State": "FL",
    "City": "Ponce De Leon"
  },
  {
    "State": "FL",
    "City": "Port Saint Joe"
  },
  {
    "State": "FL",
    "City": "Santa Rosa Beach"
  },
  {
    "State": "FL",
    "City": "Sneads"
  },
  {
    "State": "FL",
    "City": "Inlet Beach"
  },
  {
    "State": "FL",
    "City": "Vernon"
  },
  {
    "State": "FL",
    "City": "Wausau"
  },
  {
    "State": "FL",
    "City": "Westville"
  },
  {
    "State": "FL",
    "City": "Youngstown"
  },
  {
    "State": "FL",
    "City": "Pensacola"
  },
  {
    "State": "FL",
    "City": "Bagdad"
  },
  {
    "State": "FL",
    "City": "Baker"
  },
  {
    "State": "FL",
    "City": "Cantonment"
  },
  {
    "State": "FL",
    "City": "Century"
  },
  {
    "State": "FL",
    "City": "Crestview"
  },
  {
    "State": "FL",
    "City": "Milligan"
  },
  {
    "State": "FL",
    "City": "Paxton"
  },
  {
    "State": "FL",
    "City": "Destin"
  },
  {
    "State": "FL",
    "City": "Eglin AFB"
  },
  {
    "State": "FL",
    "City": "Hurlburt Field"
  },
  {
    "State": "FL",
    "City": "Fort Walton Beach"
  },
  {
    "State": "FL",
    "City": "Miramar Beach"
  },
  {
    "State": "FL",
    "City": "Gonzalez"
  },
  {
    "State": "FL",
    "City": "Gulf Breeze"
  },
  {
    "State": "FL",
    "City": "Holt"
  },
  {
    "State": "FL",
    "City": "Jay"
  },
  {
    "State": "FL",
    "City": "Navarre"
  },
  {
    "State": "FL",
    "City": "Laurel Hill"
  },
  {
    "State": "FL",
    "City": "Mc David"
  },
  {
    "State": "FL",
    "City": "Mary Esther"
  },
  {
    "State": "FL",
    "City": "Milton"
  },
  {
    "State": "FL",
    "City": "Molino"
  },
  {
    "State": "FL",
    "City": "Niceville"
  },
  {
    "State": "FL",
    "City": "Shalimar"
  },
  {
    "State": "FL",
    "City": "Valparaiso"
  },
  {
    "State": "FL",
    "City": "Gainesville"
  },
  {
    "State": "FL",
    "City": "Alachua"
  },
  {
    "State": "FL",
    "City": "Anthony"
  },
  {
    "State": "FL",
    "City": "Archer"
  },
  {
    "State": "FL",
    "City": "Bell"
  },
  {
    "State": "FL",
    "City": "Bronson"
  },
  {
    "State": "FL",
    "City": "Brooker"
  },
  {
    "State": "FL",
    "City": "Cedar Key"
  },
  {
    "State": "FL",
    "City": "Chiefland"
  },
  {
    "State": "FL",
    "City": "Cross City"
  },
  {
    "State": "FL",
    "City": "Earleton"
  },
  {
    "State": "FL",
    "City": "Evinston"
  },
  {
    "State": "FL",
    "City": "Fairfield"
  },
  {
    "State": "FL",
    "City": "Gulf Hammock"
  },
  {
    "State": "FL",
    "City": "Hawthorne"
  },
  {
    "State": "FL",
    "City": "High Springs"
  },
  {
    "State": "FL",
    "City": "Horseshoe Beach"
  },
  {
    "State": "FL",
    "City": "Island Grove"
  },
  {
    "State": "FL",
    "City": "Keystone Heights"
  },
  {
    "State": "FL",
    "City": "La Crosse"
  },
  {
    "State": "FL",
    "City": "Lochloosa"
  },
  {
    "State": "FL",
    "City": "Lowell"
  },
  {
    "State": "FL",
    "City": "Mc Intosh"
  },
  {
    "State": "FL",
    "City": "Melrose"
  },
  {
    "State": "FL",
    "City": "Micanopy"
  },
  {
    "State": "FL",
    "City": "Morriston"
  },
  {
    "State": "FL",
    "City": "Newberry"
  },
  {
    "State": "FL",
    "City": "Old Town"
  },
  {
    "State": "FL",
    "City": "Orange Lake"
  },
  {
    "State": "FL",
    "City": "Otter Creek"
  },
  {
    "State": "FL",
    "City": "Reddick"
  },
  {
    "State": "FL",
    "City": "Suwannee"
  },
  {
    "State": "FL",
    "City": "Trenton"
  },
  {
    "State": "FL",
    "City": "Waldo"
  },
  {
    "State": "FL",
    "City": "Williston"
  },
  {
    "State": "FL",
    "City": "Worthington Springs"
  },
  {
    "State": "FL",
    "City": "Altamonte Springs"
  },
  {
    "State": "FL",
    "City": "Altoona"
  },
  {
    "State": "FL",
    "City": "Apopka"
  },
  {
    "State": "FL",
    "City": "Cassadaga"
  },
  {
    "State": "FL",
    "City": "Casselberry"
  },
  {
    "State": "FL",
    "City": "Winter Springs"
  },
  {
    "State": "FL",
    "City": "Christmas"
  },
  {
    "State": "FL",
    "City": "Clarcona"
  },
  {
    "State": "FL",
    "City": "Debary"
  },
  {
    "State": "FL",
    "City": "Deland"
  },
  {
    "State": "FL",
    "City": "Glenwood"
  },
  {
    "State": "FL",
    "City": "Deltona"
  },
  {
    "State": "FL",
    "City": "Eustis"
  },
  {
    "State": "FL",
    "City": "Geneva"
  },
  {
    "State": "FL",
    "City": "Goldenrod"
  },
  {
    "State": "FL",
    "City": "Grand Island"
  },
  {
    "State": "FL",
    "City": "Lake Helen"
  },
  {
    "State": "FL",
    "City": "Mid Florida"
  },
  {
    "State": "FL",
    "City": "Lake Mary"
  },
  {
    "State": "FL",
    "City": "Lake Monroe"
  },
  {
    "State": "FL",
    "City": "Longwood"
  },
  {
    "State": "FL",
    "City": "Maitland"
  },
  {
    "State": "FL",
    "City": "Mims"
  },
  {
    "State": "FL",
    "City": "Mount Dora"
  },
  {
    "State": "FL",
    "City": "Oak Hill"
  },
  {
    "State": "FL",
    "City": "Oviedo"
  },
  {
    "State": "FL",
    "City": "Orange City"
  },
  {
    "State": "FL",
    "City": "Osteen"
  },
  {
    "State": "FL",
    "City": "Paisley"
  },
  {
    "State": "FL",
    "City": "Plymouth"
  },
  {
    "State": "FL",
    "City": "Sanford"
  },
  {
    "State": "FL",
    "City": "Scottsmoor"
  },
  {
    "State": "FL",
    "City": "Sorrento"
  },
  {
    "State": "FL",
    "City": "Tangerine"
  },
  {
    "State": "FL",
    "City": "Tavares"
  },
  {
    "State": "FL",
    "City": "Titusville"
  },
  {
    "State": "FL",
    "City": "Umatilla"
  },
  {
    "State": "FL",
    "City": "Winter Park"
  },
  {
    "State": "FL",
    "City": "Zellwood"
  },
  {
    "State": "FL",
    "City": "Orlando"
  },
  {
    "State": "FL",
    "City": "Melbourne"
  },
  {
    "State": "FL",
    "City": "Indialantic"
  },
  {
    "State": "FL",
    "City": "Palm Bay"
  },
  {
    "State": "FL",
    "City": "Cape Canaveral"
  },
  {
    "State": "FL",
    "City": "Cocoa"
  },
  {
    "State": "FL",
    "City": "Patrick AFB"
  },
  {
    "State": "FL",
    "City": "Cocoa Beach"
  },
  {
    "State": "FL",
    "City": "Satellite Beach"
  },
  {
    "State": "FL",
    "City": "Fellsmere"
  },
  {
    "State": "FL",
    "City": "Grant"
  },
  {
    "State": "FL",
    "City": "Malabar"
  },
  {
    "State": "FL",
    "City": "Melbourne Beach"
  },
  {
    "State": "FL",
    "City": "Merritt Island"
  },
  {
    "State": "FL",
    "City": "Rockledge"
  },
  {
    "State": "FL",
    "City": "Roseland"
  },
  {
    "State": "FL",
    "City": "Sebastian"
  },
  {
    "State": "FL",
    "City": "Sharpes"
  },
  {
    "State": "FL",
    "City": "Vero Beach"
  },
  {
    "State": "FL",
    "City": "Wabasso"
  },
  {
    "State": "FL",
    "City": "Winter Beach"
  },
  {
    "State": "FL",
    "City": "Long Key"
  },
  {
    "State": "FL",
    "City": "Hialeah"
  },
  {
    "State": "FL",
    "City": "Dania"
  },
  {
    "State": "FL",
    "City": "Hallandale"
  },
  {
    "State": "FL",
    "City": "Hollywood"
  },
  {
    "State": "FL",
    "City": "Pembroke Pines"
  },
  {
    "State": "FL",
    "City": "Homestead"
  },
  {
    "State": "FL",
    "City": "Islamorada"
  },
  {
    "State": "FL",
    "City": "Key Largo"
  },
  {
    "State": "FL",
    "City": "Key West"
  },
  {
    "State": "FL",
    "City": "Summerland Key"
  },
  {
    "State": "FL",
    "City": "Big Pine Key"
  },
  {
    "State": "FL",
    "City": "Marathon"
  },
  {
    "State": "FL",
    "City": "Key Colony Beach"
  },
  {
    "State": "FL",
    "City": "Marathon Shores"
  },
  {
    "State": "FL",
    "City": "Opa Locka"
  },
  {
    "State": "FL",
    "City": "Miami Gardens"
  },
  {
    "State": "FL",
    "City": "Pompano Beach"
  },
  {
    "State": "FL",
    "City": "Coral Springs"
  },
  {
    "State": "FL",
    "City": "Tavernier"
  },
  {
    "State": "FL",
    "City": "Margate"
  },
  {
    "State": "FL",
    "City": "Coconut Creek"
  },
  {
    "State": "FL",
    "City": "Miami"
  },
  {
    "State": "FL",
    "City": "Miami Beach"
  },
  {
    "State": "FL",
    "City": "Coral Gables"
  },
  {
    "State": "FL",
    "City": "Key Biscayne"
  },
  {
    "State": "FL",
    "City": "North Miami Beach"
  },
  {
    "State": "FL",
    "City": "Fort Lauderdale"
  },
  {
    "State": "FL",
    "City": "Plantation"
  },
  {
    "State": "FL",
    "City": "West Palm Beach"
  },
  {
    "State": "FL",
    "City": "North Palm Beach"
  },
  {
    "State": "FL",
    "City": "Palm Beach Gardens"
  },
  {
    "State": "FL",
    "City": "Wellington"
  },
  {
    "State": "FL",
    "City": "Royal Palm Beach"
  },
  {
    "State": "FL",
    "City": "Boynton Beach"
  },
  {
    "State": "FL",
    "City": "Boca Raton"
  },
  {
    "State": "FL",
    "City": "Belle Glade"
  },
  {
    "State": "FL",
    "City": "Canal Point"
  },
  {
    "State": "FL",
    "City": "Clewiston"
  },
  {
    "State": "FL",
    "City": "Deerfield Beach"
  },
  {
    "State": "FL",
    "City": "Delray Beach"
  },
  {
    "State": "FL",
    "City": "Lake Worth"
  },
  {
    "State": "FL",
    "City": "Greenacres"
  },
  {
    "State": "FL",
    "City": "Hobe Sound"
  },
  {
    "State": "FL",
    "City": "Jupiter"
  },
  {
    "State": "FL",
    "City": "Lake Harbor"
  },
  {
    "State": "FL",
    "City": "Lake Worth Beach"
  },
  {
    "State": "FL",
    "City": "Loxahatchee"
  },
  {
    "State": "FL",
    "City": "Moore Haven"
  },
  {
    "State": "FL",
    "City": "Pahokee"
  },
  {
    "State": "FL",
    "City": "Palm Beach"
  },
  {
    "State": "FL",
    "City": "South Bay"
  },
  {
    "State": "FL",
    "City": "Balm"
  },
  {
    "State": "FL",
    "City": "Brandon"
  },
  {
    "State": "FL",
    "City": "Bushnell"
  },
  {
    "State": "FL",
    "City": "Center Hill"
  },
  {
    "State": "FL",
    "City": "Coleman"
  },
  {
    "State": "FL",
    "City": "Dade City"
  },
  {
    "State": "FL",
    "City": "Crystal Springs"
  },
  {
    "State": "FL",
    "City": "Dover"
  },
  {
    "State": "FL",
    "City": "Durant"
  },
  {
    "State": "FL",
    "City": "Gibsonton"
  },
  {
    "State": "FL",
    "City": "Lacoochee"
  },
  {
    "State": "FL",
    "City": "Lake Panasoffkee"
  },
  {
    "State": "FL",
    "City": "Zephyrhills"
  },
  {
    "State": "FL",
    "City": "Wesley Chapel"
  },
  {
    "State": "FL",
    "City": "Lithia"
  },
  {
    "State": "FL",
    "City": "Lutz"
  },
  {
    "State": "FL",
    "City": "Mango"
  },
  {
    "State": "FL",
    "City": "Odessa"
  },
  {
    "State": "FL",
    "City": "Plant City"
  },
  {
    "State": "FL",
    "City": "Riverview"
  },
  {
    "State": "FL",
    "City": "Ruskin"
  },
  {
    "State": "FL",
    "City": "Sun City Center"
  },
  {
    "State": "FL",
    "City": "Apollo Beach"
  },
  {
    "State": "FL",
    "City": "Saint Leo"
  },
  {
    "State": "FL",
    "City": "San Antonio"
  },
  {
    "State": "FL",
    "City": "Seffner"
  },
  {
    "State": "FL",
    "City": "Sumterville"
  },
  {
    "State": "FL",
    "City": "Sun City"
  },
  {
    "State": "FL",
    "City": "Sydney"
  },
  {
    "State": "FL",
    "City": "Thonotosassa"
  },
  {
    "State": "FL",
    "City": "Trilby"
  },
  {
    "State": "FL",
    "City": "Valrico"
  },
  {
    "State": "FL",
    "City": "Webster"
  },
  {
    "State": "FL",
    "City": "Wimauma"
  },
  {
    "State": "FL",
    "City": "Tampa"
  },
  {
    "State": "FL",
    "City": "Saint Petersburg"
  },
  {
    "State": "FL",
    "City": "Bay Pines"
  },
  {
    "State": "FL",
    "City": "Clearwater"
  },
  {
    "State": "FL",
    "City": "Clearwater Beach"
  },
  {
    "State": "FL",
    "City": "Largo"
  },
  {
    "State": "FL",
    "City": "Seminole"
  },
  {
    "State": "FL",
    "City": "Pinellas Park"
  },
  {
    "State": "FL",
    "City": "Indian Rocks Beach"
  },
  {
    "State": "FL",
    "City": "Belleair Beach"
  },
  {
    "State": "FL",
    "City": "Lakeland"
  },
  {
    "State": "FL",
    "City": "Alturas"
  },
  {
    "State": "FL",
    "City": "Auburndale"
  },
  {
    "State": "FL",
    "City": "Avon Park"
  },
  {
    "State": "FL",
    "City": "Babson Park"
  },
  {
    "State": "FL",
    "City": "Bartow"
  },
  {
    "State": "FL",
    "City": "Bowling Green"
  },
  {
    "State": "FL",
    "City": "Bradley"
  },
  {
    "State": "FL",
    "City": "Davenport"
  },
  {
    "State": "FL",
    "City": "Dundee"
  },
  {
    "State": "FL",
    "City": "Eagle Lake"
  },
  {
    "State": "FL",
    "City": "Eaton Park"
  },
  {
    "State": "FL",
    "City": "Fort Meade"
  },
  {
    "State": "FL",
    "City": "Frostproof"
  },
  {
    "State": "FL",
    "City": "Haines City"
  },
  {
    "State": "FL",
    "City": "Highland City"
  },
  {
    "State": "FL",
    "City": "Homeland"
  },
  {
    "State": "FL",
    "City": "Intercession City"
  },
  {
    "State": "FL",
    "City": "Kathleen"
  },
  {
    "State": "FL",
    "City": "Lake Alfred"
  },
  {
    "State": "FL",
    "City": "Lake Hamilton"
  },
  {
    "State": "FL",
    "City": "Lake Placid"
  },
  {
    "State": "FL",
    "City": "Lake Wales"
  },
  {
    "State": "FL",
    "City": "Lakeshore"
  },
  {
    "State": "FL",
    "City": "Indian Lake Estates"
  },
  {
    "State": "FL",
    "City": "Nalcrest"
  },
  {
    "State": "FL",
    "City": "Lorida"
  },
  {
    "State": "FL",
    "City": "Loughman"
  },
  {
    "State": "FL",
    "City": "Mulberry"
  },
  {
    "State": "FL",
    "City": "Nichols"
  },
  {
    "State": "FL",
    "City": "Ona"
  },
  {
    "State": "FL",
    "City": "River Ranch"
  },
  {
    "State": "FL",
    "City": "Polk City"
  },
  {
    "State": "FL",
    "City": "Sebring"
  },
  {
    "State": "FL",
    "City": "Wauchula"
  },
  {
    "State": "FL",
    "City": "Waverly"
  },
  {
    "State": "FL",
    "City": "Winter Haven"
  },
  {
    "State": "FL",
    "City": "Zolfo Springs"
  },
  {
    "State": "FL",
    "City": "Fort Myers"
  },
  {
    "State": "FL",
    "City": "North Fort Myers"
  },
  {
    "State": "FL",
    "City": "Cape Coral"
  },
  {
    "State": "FL",
    "City": "Alva"
  },
  {
    "State": "FL",
    "City": "Boca Grande"
  },
  {
    "State": "FL",
    "City": "Bokeelia"
  },
  {
    "State": "FL",
    "City": "Captiva"
  },
  {
    "State": "FL",
    "City": "El Jobean"
  },
  {
    "State": "FL",
    "City": "Estero"
  },
  {
    "State": "FL",
    "City": "Felda"
  },
  {
    "State": "FL",
    "City": "Fort Myers Beach"
  },
  {
    "State": "FL",
    "City": "Labelle"
  },
  {
    "State": "FL",
    "City": "Lehigh Acres"
  },
  {
    "State": "FL",
    "City": "Murdock"
  },
  {
    "State": "FL",
    "City": "Palmdale"
  },
  {
    "State": "FL",
    "City": "Pineland"
  },
  {
    "State": "FL",
    "City": "Placida"
  },
  {
    "State": "FL",
    "City": "Rotonda West"
  },
  {
    "State": "FL",
    "City": "Port Charlotte"
  },
  {
    "State": "FL",
    "City": "Punta Gorda"
  },
  {
    "State": "FL",
    "City": "Saint James City"
  },
  {
    "State": "FL",
    "City": "Sanibel"
  },
  {
    "State": "FL",
    "City": "Venus"
  },
  {
    "State": "AA",
    "City": "Dpo"
  },
  {
    "State": "AA",
    "City": "Apo"
  },
  {
    "State": "AA",
    "City": "Fpo"
  },
  {
    "State": "FL",
    "City": "Naples"
  },
  {
    "State": "FL",
    "City": "Bonita Springs"
  },
  {
    "State": "FL",
    "City": "Copeland"
  },
  {
    "State": "FL",
    "City": "Chokoloskee"
  },
  {
    "State": "FL",
    "City": "Everglades City"
  },
  {
    "State": "FL",
    "City": "Goodland"
  },
  {
    "State": "FL",
    "City": "Ochopee"
  },
  {
    "State": "FL",
    "City": "Immokalee"
  },
  {
    "State": "FL",
    "City": "Marco Island"
  },
  {
    "State": "FL",
    "City": "Bradenton"
  },
  {
    "State": "FL",
    "City": "Cortez"
  },
  {
    "State": "FL",
    "City": "Anna Maria"
  },
  {
    "State": "FL",
    "City": "Bradenton Beach"
  },
  {
    "State": "FL",
    "City": "Holmes Beach"
  },
  {
    "State": "FL",
    "City": "Parrish"
  },
  {
    "State": "FL",
    "City": "Palmetto"
  },
  {
    "State": "FL",
    "City": "Ellenton"
  },
  {
    "State": "FL",
    "City": "Englewood"
  },
  {
    "State": "FL",
    "City": "Longboat Key"
  },
  {
    "State": "FL",
    "City": "Osprey"
  },
  {
    "State": "FL",
    "City": "Sarasota"
  },
  {
    "State": "FL",
    "City": "Terra Ceia"
  },
  {
    "State": "FL",
    "City": "Myakka City"
  },
  {
    "State": "FL",
    "City": "Oneco"
  },
  {
    "State": "FL",
    "City": "Arcadia"
  },
  {
    "State": "FL",
    "City": "Fort Ogden"
  },
  {
    "State": "FL",
    "City": "Nocatee"
  },
  {
    "State": "FL",
    "City": "Tallevast"
  },
  {
    "State": "FL",
    "City": "Laurel"
  },
  {
    "State": "FL",
    "City": "Nokomis"
  },
  {
    "State": "FL",
    "City": "Venice"
  },
  {
    "State": "FL",
    "City": "North Port"
  },
  {
    "State": "FL",
    "City": "Belleview"
  },
  {
    "State": "FL",
    "City": "Crystal River"
  },
  {
    "State": "FL",
    "City": "Dunnellon"
  },
  {
    "State": "FL",
    "City": "Floral City"
  },
  {
    "State": "FL",
    "City": "Hernando"
  },
  {
    "State": "FL",
    "City": "Holder"
  },
  {
    "State": "FL",
    "City": "Homosassa"
  },
  {
    "State": "FL",
    "City": "Homosassa Springs"
  },
  {
    "State": "FL",
    "City": "Inglis"
  },
  {
    "State": "FL",
    "City": "Inverness"
  },
  {
    "State": "FL",
    "City": "Lecanto"
  },
  {
    "State": "FL",
    "City": "Beverly Hills"
  },
  {
    "State": "FL",
    "City": "Ocala"
  },
  {
    "State": "FL",
    "City": "Oxford"
  },
  {
    "State": "FL",
    "City": "Silver Springs"
  },
  {
    "State": "FL",
    "City": "Summerfield"
  },
  {
    "State": "FL",
    "City": "Yankeetown"
  },
  {
    "State": "FL",
    "City": "Brooksville"
  },
  {
    "State": "FL",
    "City": "Spring Hill"
  },
  {
    "State": "FL",
    "City": "Istachatta"
  },
  {
    "State": "FL",
    "City": "Land O Lakes"
  },
  {
    "State": "FL",
    "City": "New Port Richey"
  },
  {
    "State": "FL",
    "City": "Ozona"
  },
  {
    "State": "FL",
    "City": "Nobleton"
  },
  {
    "State": "FL",
    "City": "Hudson"
  },
  {
    "State": "FL",
    "City": "Port Richey"
  },
  {
    "State": "FL",
    "City": "Oldsmar"
  },
  {
    "State": "FL",
    "City": "Aripeka"
  },
  {
    "State": "FL",
    "City": "Elfers"
  },
  {
    "State": "FL",
    "City": "Crystal Beach"
  },
  {
    "State": "FL",
    "City": "Palm Harbor"
  },
  {
    "State": "FL",
    "City": "Tarpon Springs"
  },
  {
    "State": "FL",
    "City": "Holiday"
  },
  {
    "State": "FL",
    "City": "Safety Harbor"
  },
  {
    "State": "FL",
    "City": "Dunedin"
  },
  {
    "State": "FL",
    "City": "Astatula"
  },
  {
    "State": "FL",
    "City": "Clermont"
  },
  {
    "State": "FL",
    "City": "Ferndale"
  },
  {
    "State": "FL",
    "City": "Fruitland Park"
  },
  {
    "State": "FL",
    "City": "Gotha"
  },
  {
    "State": "FL",
    "City": "Groveland"
  },
  {
    "State": "FL",
    "City": "Howey In The Hills"
  },
  {
    "State": "FL",
    "City": "Kenansville"
  },
  {
    "State": "FL",
    "City": "Killarney"
  },
  {
    "State": "FL",
    "City": "Kissimmee"
  },
  {
    "State": "FL",
    "City": "Leesburg"
  },
  {
    "State": "FL",
    "City": "Mascotte"
  },
  {
    "State": "FL",
    "City": "Minneola"
  },
  {
    "State": "FL",
    "City": "Montverde"
  },
  {
    "State": "FL",
    "City": "Oakland"
  },
  {
    "State": "FL",
    "City": "Ocoee"
  },
  {
    "State": "FL",
    "City": "Okahumpka"
  },
  {
    "State": "FL",
    "City": "Saint Cloud"
  },
  {
    "State": "FL",
    "City": "Winter Garden"
  },
  {
    "State": "FL",
    "City": "Wildwood"
  },
  {
    "State": "FL",
    "City": "Windermere"
  },
  {
    "State": "FL",
    "City": "Yalaha"
  },
  {
    "State": "FL",
    "City": "Fort Pierce"
  },
  {
    "State": "FL",
    "City": "Port Saint Lucie"
  },
  {
    "State": "FL",
    "City": "Indiantown"
  },
  {
    "State": "FL",
    "City": "Jensen Beach"
  },
  {
    "State": "FL",
    "City": "Okeechobee"
  },
  {
    "State": "FL",
    "City": "Palm City"
  },
  {
    "State": "FL",
    "City": "Port Salerno"
  },
  {
    "State": "FL",
    "City": "Stuart"
  },
  {
    "State": "AL",
    "City": "Moody"
  },
  {
    "State": "AL",
    "City": "Adamsville"
  },
  {
    "State": "AL",
    "City": "Adger"
  },
  {
    "State": "AL",
    "City": "Alabaster"
  },
  {
    "State": "AL",
    "City": "Alexander City"
  },
  {
    "State": "AL",
    "City": "Allgood"
  },
  {
    "State": "AL",
    "City": "Alpine"
  },
  {
    "State": "AL",
    "City": "Alton"
  },
  {
    "State": "AL",
    "City": "Arab"
  },
  {
    "State": "AL",
    "City": "Baileyton"
  },
  {
    "State": "AL",
    "City": "Bessemer"
  },
  {
    "State": "AL",
    "City": "Blountsville"
  },
  {
    "State": "AL",
    "City": "Bon Air"
  },
  {
    "State": "AL",
    "City": "Bremen"
  },
  {
    "State": "AL",
    "City": "Brent"
  },
  {
    "State": "AL",
    "City": "Brierfield"
  },
  {
    "State": "AL",
    "City": "Brookside"
  },
  {
    "State": "AL",
    "City": "Burnwell"
  },
  {
    "State": "AL",
    "City": "Calera"
  },
  {
    "State": "AL",
    "City": "Cardiff"
  },
  {
    "State": "AL",
    "City": "Centreville"
  },
  {
    "State": "AL",
    "City": "Chelsea"
  },
  {
    "State": "AL",
    "City": "Childersburg"
  },
  {
    "State": "AL",
    "City": "Clanton"
  },
  {
    "State": "AL",
    "City": "Clay"
  },
  {
    "State": "AL",
    "City": "Cleveland"
  },
  {
    "State": "AL",
    "City": "Columbiana"
  },
  {
    "State": "AL",
    "City": "Cook Springs"
  },
  {
    "State": "AL",
    "City": "Crane Hill"
  },
  {
    "State": "AL",
    "City": "Cropwell"
  },
  {
    "State": "AL",
    "City": "Cullman"
  },
  {
    "State": "AL",
    "City": "Docena"
  },
  {
    "State": "AL",
    "City": "Dolomite"
  },
  {
    "State": "AL",
    "City": "Dora"
  },
  {
    "State": "AL",
    "City": "Empire"
  },
  {
    "State": "AL",
    "City": "Fairfield"
  },
  {
    "State": "AL",
    "City": "Fultondale"
  },
  {
    "State": "AL",
    "City": "Garden City"
  },
  {
    "State": "AL",
    "City": "Gardendale"
  },
  {
    "State": "AL",
    "City": "Goodwater"
  },
  {
    "State": "AL",
    "City": "Graysville"
  },
  {
    "State": "AL",
    "City": "Green Pond"
  },
  {
    "State": "AL",
    "City": "Hanceville"
  },
  {
    "State": "AL",
    "City": "Harpersville"
  },
  {
    "State": "AL",
    "City": "Hayden"
  },
  {
    "State": "AL",
    "City": "Helena"
  },
  {
    "State": "AL",
    "City": "Hollins"
  },
  {
    "State": "AL",
    "City": "Holly Pond"
  },
  {
    "State": "AL",
    "City": "Jemison"
  },
  {
    "State": "AL",
    "City": "Joppa"
  },
  {
    "State": "AL",
    "City": "Kellyton"
  },
  {
    "State": "AL",
    "City": "Kimberly"
  },
  {
    "State": "AL",
    "City": "Leeds"
  },
  {
    "State": "AL",
    "City": "Lincoln"
  },
  {
    "State": "AL",
    "City": "Locust Fork"
  },
  {
    "State": "AL",
    "City": "Logan"
  },
  {
    "State": "AL",
    "City": "Mc Calla"
  },
  {
    "State": "AL",
    "City": "Margaret"
  },
  {
    "State": "AL",
    "City": "Montevallo"
  },
  {
    "State": "AL",
    "City": "Morris"
  },
  {
    "State": "AL",
    "City": "Mount Olive"
  },
  {
    "State": "AL",
    "City": "Mulga"
  },
  {
    "State": "AL",
    "City": "New Castle"
  },
  {
    "State": "AL",
    "City": "Odenville"
  },
  {
    "State": "AL",
    "City": "Oneonta"
  },
  {
    "State": "AL",
    "City": "Palmerdale"
  },
  {
    "State": "AL",
    "City": "Pelham"
  },
  {
    "State": "AL",
    "City": "Pell City"
  },
  {
    "State": "AL",
    "City": "Pinson"
  },
  {
    "State": "AL",
    "City": "Pleasant Grove"
  },
  {
    "State": "AL",
    "City": "Quinton"
  },
  {
    "State": "AL",
    "City": "Ragland"
  },
  {
    "State": "AL",
    "City": "Remlap"
  },
  {
    "State": "AL",
    "City": "Riverside"
  },
  {
    "State": "AL",
    "City": "Rockford"
  },
  {
    "State": "AL",
    "City": "Saginaw"
  },
  {
    "State": "AL",
    "City": "Sayre"
  },
  {
    "State": "AL",
    "City": "Shannon"
  },
  {
    "State": "AL",
    "City": "Shelby"
  },
  {
    "State": "AL",
    "City": "Siluria"
  },
  {
    "State": "AL",
    "City": "Springville"
  },
  {
    "State": "AL",
    "City": "Sterrett"
  },
  {
    "State": "AL",
    "City": "Sumiton"
  },
  {
    "State": "AL",
    "City": "Sycamore"
  },
  {
    "State": "AL",
    "City": "Sylacauga"
  },
  {
    "State": "AL",
    "City": "Talladega"
  },
  {
    "State": "AL",
    "City": "Thorsby"
  },
  {
    "State": "AL",
    "City": "Trafford"
  },
  {
    "State": "AL",
    "City": "Trussville"
  },
  {
    "State": "AL",
    "City": "Union Grove"
  },
  {
    "State": "AL",
    "City": "Vandiver"
  },
  {
    "State": "AL",
    "City": "Vincent"
  },
  {
    "State": "AL",
    "City": "Vinemont"
  },
  {
    "State": "AL",
    "City": "Warrior"
  },
  {
    "State": "AL",
    "City": "Watson"
  },
  {
    "State": "AL",
    "City": "Wattsville"
  },
  {
    "State": "AL",
    "City": "Weogufka"
  },
  {
    "State": "AL",
    "City": "West Blocton"
  },
  {
    "State": "AL",
    "City": "Westover"
  },
  {
    "State": "AL",
    "City": "Wilsonville"
  },
  {
    "State": "AL",
    "City": "Wilton"
  },
  {
    "State": "AL",
    "City": "Woodstock"
  },
  {
    "State": "AL",
    "City": "Birmingham"
  },
  {
    "State": "AL",
    "City": "Tuscaloosa"
  },
  {
    "State": "AL",
    "City": "Abernant"
  },
  {
    "State": "AL",
    "City": "Akron"
  },
  {
    "State": "AL",
    "City": "Aliceville"
  },
  {
    "State": "AL",
    "City": "Boligee"
  },
  {
    "State": "AL",
    "City": "Brookwood"
  },
  {
    "State": "AL",
    "City": "Buhl"
  },
  {
    "State": "AL",
    "City": "Carrollton"
  },
  {
    "State": "AL",
    "City": "Clinton"
  },
  {
    "State": "AL",
    "City": "Coaling"
  },
  {
    "State": "AL",
    "City": "Coker"
  },
  {
    "State": "AL",
    "City": "Cottondale"
  },
  {
    "State": "AL",
    "City": "Duncanville"
  },
  {
    "State": "AL",
    "City": "Echola"
  },
  {
    "State": "AL",
    "City": "Elrod"
  },
  {
    "State": "AL",
    "City": "Emelle"
  },
  {
    "State": "AL",
    "City": "Epes"
  },
  {
    "State": "AL",
    "City": "Ethelsville"
  },
  {
    "State": "AL",
    "City": "Eutaw"
  },
  {
    "State": "AL",
    "City": "Fosters"
  },
  {
    "State": "AL",
    "City": "Gainesville"
  },
  {
    "State": "AL",
    "City": "Gordo"
  },
  {
    "State": "AL",
    "City": "Kellerman"
  },
  {
    "State": "AL",
    "City": "Knoxville"
  },
  {
    "State": "AL",
    "City": "Livingston"
  },
  {
    "State": "AL",
    "City": "Mc Shan"
  },
  {
    "State": "AL",
    "City": "Northport"
  },
  {
    "State": "AL",
    "City": "Moundville"
  },
  {
    "State": "AL",
    "City": "Panola"
  },
  {
    "State": "AL",
    "City": "Peterson"
  },
  {
    "State": "AL",
    "City": "Ralph"
  },
  {
    "State": "AL",
    "City": "Reform"
  },
  {
    "State": "AL",
    "City": "Samantha"
  },
  {
    "State": "AL",
    "City": "Vance"
  },
  {
    "State": "AL",
    "City": "West Greene"
  },
  {
    "State": "AL",
    "City": "Jasper"
  },
  {
    "State": "AL",
    "City": "Addison"
  },
  {
    "State": "AL",
    "City": "Arley"
  },
  {
    "State": "AL",
    "City": "Bankston"
  },
  {
    "State": "AL",
    "City": "Bear Creek"
  },
  {
    "State": "AL",
    "City": "Beaverton"
  },
  {
    "State": "AL",
    "City": "Belk"
  },
  {
    "State": "AL",
    "City": "Berry"
  },
  {
    "State": "AL",
    "City": "Brilliant"
  },
  {
    "State": "AL",
    "City": "Carbon Hill"
  },
  {
    "State": "AL",
    "City": "Cordova"
  },
  {
    "State": "AL",
    "City": "Delmar"
  },
  {
    "State": "AL",
    "City": "Detroit"
  },
  {
    "State": "AL",
    "City": "Double Springs"
  },
  {
    "State": "AL",
    "City": "Eldridge"
  },
  {
    "State": "AL",
    "City": "Fayette"
  },
  {
    "State": "AL",
    "City": "Glen Allen"
  },
  {
    "State": "AL",
    "City": "Goodsprings"
  },
  {
    "State": "AL",
    "City": "Guin"
  },
  {
    "State": "AL",
    "City": "Hackleburg"
  },
  {
    "State": "AL",
    "City": "Haleyville"
  },
  {
    "State": "AL",
    "City": "Hamilton"
  },
  {
    "State": "AL",
    "City": "Hodges"
  },
  {
    "State": "AL",
    "City": "Houston"
  },
  {
    "State": "AL",
    "City": "Kansas"
  },
  {
    "State": "AL",
    "City": "Kennedy"
  },
  {
    "State": "AL",
    "City": "Lynn"
  },
  {
    "State": "AL",
    "City": "Millport"
  },
  {
    "State": "AL",
    "City": "Natural Bridge"
  },
  {
    "State": "AL",
    "City": "Nauvoo"
  },
  {
    "State": "AL",
    "City": "Oakman"
  },
  {
    "State": "AL",
    "City": "Parrish"
  },
  {
    "State": "AL",
    "City": "Phil Campbell"
  },
  {
    "State": "AL",
    "City": "Red Bay"
  },
  {
    "State": "AL",
    "City": "Sipsey"
  },
  {
    "State": "AL",
    "City": "Spruce Pine"
  },
  {
    "State": "AL",
    "City": "Sulligent"
  },
  {
    "State": "AL",
    "City": "Townley"
  },
  {
    "State": "AL",
    "City": "Vernon"
  },
  {
    "State": "AL",
    "City": "Vina"
  },
  {
    "State": "AL",
    "City": "Winfield"
  },
  {
    "State": "AL",
    "City": "Decatur"
  },
  {
    "State": "AL",
    "City": "Anderson"
  },
  {
    "State": "AL",
    "City": "Athens"
  },
  {
    "State": "AL",
    "City": "Belle Mina"
  },
  {
    "State": "AL",
    "City": "Cherokee"
  },
  {
    "State": "AL",
    "City": "Cloverdale"
  },
  {
    "State": "AL",
    "City": "Courtland"
  },
  {
    "State": "AL",
    "City": "Danville"
  },
  {
    "State": "AL",
    "City": "Elkmont"
  },
  {
    "State": "AL",
    "City": "Eva"
  },
  {
    "State": "AL",
    "City": "Falkville"
  },
  {
    "State": "AL",
    "City": "Florence"
  },
  {
    "State": "AL",
    "City": "Hartselle"
  },
  {
    "State": "AL",
    "City": "Hillsboro"
  },
  {
    "State": "AL",
    "City": "Killen"
  },
  {
    "State": "AL",
    "City": "Leighton"
  },
  {
    "State": "AL",
    "City": "Lester"
  },
  {
    "State": "AL",
    "City": "Lexington"
  },
  {
    "State": "AL",
    "City": "Mooresville"
  },
  {
    "State": "AL",
    "City": "Moulton"
  },
  {
    "State": "AL",
    "City": "Mount Hope"
  },
  {
    "State": "AL",
    "City": "Rogersville"
  },
  {
    "State": "AL",
    "City": "Russellville"
  },
  {
    "State": "AL",
    "City": "Sheffield"
  },
  {
    "State": "AL",
    "City": "Muscle Shoals"
  },
  {
    "State": "AL",
    "City": "Somerville"
  },
  {
    "State": "AL",
    "City": "Tanner"
  },
  {
    "State": "AL",
    "City": "Town Creek"
  },
  {
    "State": "AL",
    "City": "Trinity"
  },
  {
    "State": "AL",
    "City": "Tuscumbia"
  },
  {
    "State": "AL",
    "City": "Waterloo"
  },
  {
    "State": "AL",
    "City": "Ardmore"
  },
  {
    "State": "AL",
    "City": "Bridgeport"
  },
  {
    "State": "AL",
    "City": "Brownsboro"
  },
  {
    "State": "AL",
    "City": "Capshaw"
  },
  {
    "State": "AL",
    "City": "Dutton"
  },
  {
    "State": "AL",
    "City": "Estillfork"
  },
  {
    "State": "AL",
    "City": "Fackler"
  },
  {
    "State": "AL",
    "City": "Grant"
  },
  {
    "State": "AL",
    "City": "Gurley"
  },
  {
    "State": "AL",
    "City": "Harvest"
  },
  {
    "State": "AL",
    "City": "Hazel Green"
  },
  {
    "State": "AL",
    "City": "Hollytree"
  },
  {
    "State": "AL",
    "City": "Hollywood"
  },
  {
    "State": "AL",
    "City": "Laceys Spring"
  },
  {
    "State": "AL",
    "City": "Langston"
  },
  {
    "State": "AL",
    "City": "Madison"
  },
  {
    "State": "AL",
    "City": "Meridianville"
  },
  {
    "State": "AL",
    "City": "New Hope"
  },
  {
    "State": "AL",
    "City": "New Market"
  },
  {
    "State": "AL",
    "City": "Normal"
  },
  {
    "State": "AL",
    "City": "Owens Cross Roads"
  },
  {
    "State": "AL",
    "City": "Paint Rock"
  },
  {
    "State": "AL",
    "City": "Pisgah"
  },
  {
    "State": "AL",
    "City": "Princeton"
  },
  {
    "State": "AL",
    "City": "Ryland"
  },
  {
    "State": "AL",
    "City": "Scottsboro"
  },
  {
    "State": "AL",
    "City": "Section"
  },
  {
    "State": "AL",
    "City": "Stevenson"
  },
  {
    "State": "AL",
    "City": "Toney"
  },
  {
    "State": "AL",
    "City": "Trenton"
  },
  {
    "State": "AL",
    "City": "Valhermoso Springs"
  },
  {
    "State": "AL",
    "City": "Woodville"
  },
  {
    "State": "AL",
    "City": "Huntsville"
  },
  {
    "State": "AL",
    "City": "Gadsden"
  },
  {
    "State": "AL",
    "City": "Rainbow City"
  },
  {
    "State": "AL",
    "City": "Albertville"
  },
  {
    "State": "AL",
    "City": "Altoona"
  },
  {
    "State": "AL",
    "City": "Ashville"
  },
  {
    "State": "AL",
    "City": "Attalla"
  },
  {
    "State": "AL",
    "City": "Boaz"
  },
  {
    "State": "AL",
    "City": "Bryant"
  },
  {
    "State": "AL",
    "City": "Cedar Bluff"
  },
  {
    "State": "AL",
    "City": "Centre"
  },
  {
    "State": "AL",
    "City": "Collinsville"
  },
  {
    "State": "AL",
    "City": "Crossville"
  },
  {
    "State": "AL",
    "City": "Dawson"
  },
  {
    "State": "AL",
    "City": "Douglas"
  },
  {
    "State": "AL",
    "City": "Flat Rock"
  },
  {
    "State": "AL",
    "City": "Fort Payne"
  },
  {
    "State": "AL",
    "City": "Fyffe"
  },
  {
    "State": "AL",
    "City": "Gallant"
  },
  {
    "State": "AL",
    "City": "Gaylesville"
  },
  {
    "State": "AL",
    "City": "Geraldine"
  },
  {
    "State": "AL",
    "City": "Groveoak"
  },
  {
    "State": "AL",
    "City": "Guntersville"
  },
  {
    "State": "AL",
    "City": "Henagar"
  },
  {
    "State": "AL",
    "City": "Higdon"
  },
  {
    "State": "AL",
    "City": "Horton"
  },
  {
    "State": "AL",
    "City": "Ider"
  },
  {
    "State": "AL",
    "City": "Leesburg"
  },
  {
    "State": "AL",
    "City": "Mentone"
  },
  {
    "State": "AL",
    "City": "Rainsville"
  },
  {
    "State": "AL",
    "City": "Steele"
  },
  {
    "State": "AL",
    "City": "Sylvania"
  },
  {
    "State": "AL",
    "City": "Valley Head"
  },
  {
    "State": "AL",
    "City": "Walnut Grove"
  },
  {
    "State": "AL",
    "City": "Autaugaville"
  },
  {
    "State": "AL",
    "City": "Banks"
  },
  {
    "State": "AL",
    "City": "Billingsley"
  },
  {
    "State": "AL",
    "City": "Booth"
  },
  {
    "State": "AL",
    "City": "Brantley"
  },
  {
    "State": "AL",
    "City": "Brundidge"
  },
  {
    "State": "AL",
    "City": "Cecil"
  },
  {
    "State": "AL",
    "City": "Chapman"
  },
  {
    "State": "AL",
    "City": "Clayton"
  },
  {
    "State": "AL",
    "City": "Clio"
  },
  {
    "State": "AL",
    "City": "Coosada"
  },
  {
    "State": "AL",
    "City": "Deatsville"
  },
  {
    "State": "AL",
    "City": "East Tallassee"
  },
  {
    "State": "AL",
    "City": "Eclectic"
  },
  {
    "State": "AL",
    "City": "Elmore"
  },
  {
    "State": "AL",
    "City": "Equality"
  },
  {
    "State": "AL",
    "City": "Eufaula"
  },
  {
    "State": "AL",
    "City": "Dozier"
  },
  {
    "State": "AL",
    "City": "Fitzpatrick"
  },
  {
    "State": "AL",
    "City": "Forest Home"
  },
  {
    "State": "AL",
    "City": "Fort Davis"
  },
  {
    "State": "AL",
    "City": "Fort Deposit"
  },
  {
    "State": "AL",
    "City": "Georgiana"
  },
  {
    "State": "AL",
    "City": "Glenwood"
  },
  {
    "State": "AL",
    "City": "Goshen"
  },
  {
    "State": "AL",
    "City": "Grady"
  },
  {
    "State": "AL",
    "City": "Greenville"
  },
  {
    "State": "AL",
    "City": "Gantt"
  },
  {
    "State": "AL",
    "City": "Hardaway"
  },
  {
    "State": "AL",
    "City": "Hayneville"
  },
  {
    "State": "AL",
    "City": "Highland Home"
  },
  {
    "State": "AL",
    "City": "Honoraville"
  },
  {
    "State": "AL",
    "City": "Hope Hull"
  },
  {
    "State": "AL",
    "City": "Kent"
  },
  {
    "State": "AL",
    "City": "Lapine"
  },
  {
    "State": "AL",
    "City": "Letohatchee"
  },
  {
    "State": "AL",
    "City": "Louisville"
  },
  {
    "State": "AL",
    "City": "Luverne"
  },
  {
    "State": "AL",
    "City": "Marbury"
  },
  {
    "State": "AL",
    "City": "Mathews"
  },
  {
    "State": "AL",
    "City": "Midway"
  },
  {
    "State": "AL",
    "City": "Millbrook"
  },
  {
    "State": "AL",
    "City": "Mount Meigs"
  },
  {
    "State": "AL",
    "City": "Perote"
  },
  {
    "State": "AL",
    "City": "Petrey"
  },
  {
    "State": "AL",
    "City": "Pike Road"
  },
  {
    "State": "AL",
    "City": "Pine Level"
  },
  {
    "State": "AL",
    "City": "Prattville"
  },
  {
    "State": "AL",
    "City": "Ramer"
  },
  {
    "State": "AL",
    "City": "Rutledge"
  },
  {
    "State": "AL",
    "City": "Shorter"
  },
  {
    "State": "AL",
    "City": "Tallassee"
  },
  {
    "State": "AL",
    "City": "Troy"
  },
  {
    "State": "AL",
    "City": "Titus"
  },
  {
    "State": "AL",
    "City": "Tuskegee"
  },
  {
    "State": "AL",
    "City": "Tuskegee Institute"
  },
  {
    "State": "AL",
    "City": "Union Springs"
  },
  {
    "State": "AL",
    "City": "Verbena"
  },
  {
    "State": "AL",
    "City": "Wetumpka"
  },
  {
    "State": "AL",
    "City": "Montgomery"
  },
  {
    "State": "AL",
    "City": "Anniston"
  },
  {
    "State": "AL",
    "City": "Oxford"
  },
  {
    "State": "AL",
    "City": "Alexandria"
  },
  {
    "State": "AL",
    "City": "Ashland"
  },
  {
    "State": "AL",
    "City": "Bynum"
  },
  {
    "State": "AL",
    "City": "Choccolocco"
  },
  {
    "State": "AL",
    "City": "Cragford"
  },
  {
    "State": "AL",
    "City": "Daviston"
  },
  {
    "State": "AL",
    "City": "De Armanville"
  },
  {
    "State": "AL",
    "City": "Delta"
  },
  {
    "State": "AL",
    "City": "Eastaboga"
  },
  {
    "State": "AL",
    "City": "Edwardsville"
  },
  {
    "State": "AL",
    "City": "Fruithurst"
  },
  {
    "State": "AL",
    "City": "Graham"
  },
  {
    "State": "AL",
    "City": "Heflin"
  },
  {
    "State": "AL",
    "City": "Jacksonville"
  },
  {
    "State": "AL",
    "City": "Lineville"
  },
  {
    "State": "AL",
    "City": "Millerville"
  },
  {
    "State": "AL",
    "City": "Munford"
  },
  {
    "State": "AL",
    "City": "Muscadine"
  },
  {
    "State": "AL",
    "City": "Ohatchee"
  },
  {
    "State": "AL",
    "City": "Piedmont"
  },
  {
    "State": "AL",
    "City": "Ranburne"
  },
  {
    "State": "AL",
    "City": "Roanoke"
  },
  {
    "State": "AL",
    "City": "Spring Garden"
  },
  {
    "State": "AL",
    "City": "Wadley"
  },
  {
    "State": "AL",
    "City": "Weaver"
  },
  {
    "State": "AL",
    "City": "Wedowee"
  },
  {
    "State": "AL",
    "City": "Wellington"
  },
  {
    "State": "AL",
    "City": "Woodland"
  },
  {
    "State": "AL",
    "City": "Dothan"
  },
  {
    "State": "AL",
    "City": "Abbeville"
  },
  {
    "State": "AL",
    "City": "Ariton"
  },
  {
    "State": "AL",
    "City": "Ashford"
  },
  {
    "State": "AL",
    "City": "Bellwood"
  },
  {
    "State": "AL",
    "City": "Black"
  },
  {
    "State": "AL",
    "City": "Chancellor"
  },
  {
    "State": "AL",
    "City": "Clopton"
  },
  {
    "State": "AL",
    "City": "Coffee Springs"
  },
  {
    "State": "AL",
    "City": "Columbia"
  },
  {
    "State": "AL",
    "City": "Cottonwood"
  },
  {
    "State": "AL",
    "City": "Cowarts"
  },
  {
    "State": "AL",
    "City": "Daleville"
  },
  {
    "State": "AL",
    "City": "Elba"
  },
  {
    "State": "AL",
    "City": "Enterprise"
  },
  {
    "State": "AL",
    "City": "Geneva"
  },
  {
    "State": "AL",
    "City": "Gordon"
  },
  {
    "State": "AL",
    "City": "Hartford"
  },
  {
    "State": "AL",
    "City": "Headland"
  },
  {
    "State": "AL",
    "City": "Jack"
  },
  {
    "State": "AL",
    "City": "Malvern"
  },
  {
    "State": "AL",
    "City": "Midland City"
  },
  {
    "State": "AL",
    "City": "New Brockton"
  },
  {
    "State": "AL",
    "City": "Newton"
  },
  {
    "State": "AL",
    "City": "Newville"
  },
  {
    "State": "AL",
    "City": "Ozark"
  },
  {
    "State": "AL",
    "City": "Fort Rucker"
  },
  {
    "State": "AL",
    "City": "Pansey"
  },
  {
    "State": "AL",
    "City": "Pinckard"
  },
  {
    "State": "AL",
    "City": "Shorterville"
  },
  {
    "State": "AL",
    "City": "Skipperville"
  },
  {
    "State": "AL",
    "City": "Slocomb"
  },
  {
    "State": "AL",
    "City": "Webb"
  },
  {
    "State": "AL",
    "City": "Evergreen"
  },
  {
    "State": "AL",
    "City": "Andalusia"
  },
  {
    "State": "AL",
    "City": "Beatrice"
  },
  {
    "State": "AL",
    "City": "Brewton"
  },
  {
    "State": "AL",
    "City": "Brooklyn"
  },
  {
    "State": "AL",
    "City": "Castleberry"
  },
  {
    "State": "AL",
    "City": "Coy"
  },
  {
    "State": "AL",
    "City": "Dickinson"
  },
  {
    "State": "AL",
    "City": "Excel"
  },
  {
    "State": "AL",
    "City": "Flomaton"
  },
  {
    "State": "AL",
    "City": "Florala"
  },
  {
    "State": "AL",
    "City": "Franklin"
  },
  {
    "State": "AL",
    "City": "Frisco City"
  },
  {
    "State": "AL",
    "City": "Fulton"
  },
  {
    "State": "AL",
    "City": "Uriah"
  },
  {
    "State": "AL",
    "City": "Grove Hill"
  },
  {
    "State": "AL",
    "City": "Kinston"
  },
  {
    "State": "AL",
    "City": "Lenox"
  },
  {
    "State": "AL",
    "City": "Lockhart"
  },
  {
    "State": "AL",
    "City": "Mc Kenzie"
  },
  {
    "State": "AL",
    "City": "Megargel"
  },
  {
    "State": "AL",
    "City": "Mexia"
  },
  {
    "State": "AL",
    "City": "Monroeville"
  },
  {
    "State": "AL",
    "City": "Opp"
  },
  {
    "State": "AL",
    "City": "Perdue Hill"
  },
  {
    "State": "AL",
    "City": "Peterman"
  },
  {
    "State": "AL",
    "City": "Range"
  },
  {
    "State": "AL",
    "City": "Red Level"
  },
  {
    "State": "AL",
    "City": "Repton"
  },
  {
    "State": "AL",
    "City": "River Falls"
  },
  {
    "State": "AL",
    "City": "Samson"
  },
  {
    "State": "AL",
    "City": "Vredenburgh"
  },
  {
    "State": "AL",
    "City": "Whatley"
  },
  {
    "State": "AL",
    "City": "Wing"
  },
  {
    "State": "AL",
    "City": "Jackson"
  },
  {
    "State": "AL",
    "City": "Atmore"
  },
  {
    "State": "AL",
    "City": "Axis"
  },
  {
    "State": "AL",
    "City": "Bay Minette"
  },
  {
    "State": "AL",
    "City": "Bayou La Batre"
  },
  {
    "State": "AL",
    "City": "Bon Secour"
  },
  {
    "State": "AL",
    "City": "Bucks"
  },
  {
    "State": "AL",
    "City": "Calvert"
  },
  {
    "State": "AL",
    "City": "Carlton"
  },
  {
    "State": "AL",
    "City": "Chatom"
  },
  {
    "State": "AL",
    "City": "Chunchula"
  },
  {
    "State": "AL",
    "City": "Citronelle"
  },
  {
    "State": "AL",
    "City": "Coden"
  },
  {
    "State": "AL",
    "City": "Coffeeville"
  },
  {
    "State": "AL",
    "City": "Creola"
  },
  {
    "State": "AL",
    "City": "Daphne"
  },
  {
    "State": "AL",
    "City": "Dauphin Island"
  },
  {
    "State": "AL",
    "City": "Deer Park"
  },
  {
    "State": "AL",
    "City": "Elberta"
  },
  {
    "State": "AL",
    "City": "Fairhope"
  },
  {
    "State": "AL",
    "City": "Foley"
  },
  {
    "State": "AL",
    "City": "Frankville"
  },
  {
    "State": "AL",
    "City": "Fruitdale"
  },
  {
    "State": "AL",
    "City": "Gainestown"
  },
  {
    "State": "AL",
    "City": "Grand Bay"
  },
  {
    "State": "AL",
    "City": "Gulf Shores"
  },
  {
    "State": "AL",
    "City": "Huxford"
  },
  {
    "State": "AL",
    "City": "Irvington"
  },
  {
    "State": "AL",
    "City": "Leroy"
  },
  {
    "State": "AL",
    "City": "Lillian"
  },
  {
    "State": "AL",
    "City": "Little River"
  },
  {
    "State": "AL",
    "City": "Loxley"
  },
  {
    "State": "AL",
    "City": "Mc Intosh"
  },
  {
    "State": "AL",
    "City": "Magnolia Springs"
  },
  {
    "State": "AL",
    "City": "Malcolm"
  },
  {
    "State": "AL",
    "City": "Millry"
  },
  {
    "State": "AL",
    "City": "Montrose"
  },
  {
    "State": "AL",
    "City": "Mount Vernon"
  },
  {
    "State": "AL",
    "City": "Orange Beach"
  },
  {
    "State": "AL",
    "City": "Perdido"
  },
  {
    "State": "AL",
    "City": "Point Clear"
  },
  {
    "State": "AL",
    "City": "Robertsdale"
  },
  {
    "State": "AL",
    "City": "Saint Elmo"
  },
  {
    "State": "AL",
    "City": "Saint Stephens"
  },
  {
    "State": "AL",
    "City": "Saraland"
  },
  {
    "State": "AL",
    "City": "Satsuma"
  },
  {
    "State": "AL",
    "City": "Seminole"
  },
  {
    "State": "AL",
    "City": "Semmes"
  },
  {
    "State": "AL",
    "City": "Silverhill"
  },
  {
    "State": "AL",
    "City": "Spanish Fort"
  },
  {
    "State": "AL",
    "City": "Stapleton"
  },
  {
    "State": "AL",
    "City": "Stockton"
  },
  {
    "State": "AL",
    "City": "Summerdale"
  },
  {
    "State": "AL",
    "City": "Sunflower"
  },
  {
    "State": "AL",
    "City": "Theodore"
  },
  {
    "State": "AL",
    "City": "Tibbie"
  },
  {
    "State": "AL",
    "City": "Vinegar Bend"
  },
  {
    "State": "AL",
    "City": "Wagarville"
  },
  {
    "State": "AL",
    "City": "Wilmer"
  },
  {
    "State": "AL",
    "City": "Mobile"
  },
  {
    "State": "AL",
    "City": "Eight Mile"
  },
  {
    "State": "AL",
    "City": "Selma"
  },
  {
    "State": "AL",
    "City": "Alberta"
  },
  {
    "State": "AL",
    "City": "Annemanie"
  },
  {
    "State": "AL",
    "City": "Arlington"
  },
  {
    "State": "AL",
    "City": "Boykin"
  },
  {
    "State": "AL",
    "City": "Camden"
  },
  {
    "State": "AL",
    "City": "Campbell"
  },
  {
    "State": "AL",
    "City": "Catherine"
  },
  {
    "State": "AL",
    "City": "Demopolis"
  },
  {
    "State": "AL",
    "City": "Dixons Mills"
  },
  {
    "State": "AL",
    "City": "Faunsdale"
  },
  {
    "State": "AL",
    "City": "Forkland"
  },
  {
    "State": "AL",
    "City": "Furman"
  },
  {
    "State": "AL",
    "City": "Gallion"
  },
  {
    "State": "AL",
    "City": "Greensboro"
  },
  {
    "State": "AL",
    "City": "Jefferson"
  },
  {
    "State": "AL",
    "City": "Linden"
  },
  {
    "State": "AL",
    "City": "Jones"
  },
  {
    "State": "AL",
    "City": "Maplesville"
  },
  {
    "State": "AL",
    "City": "Lower Peach Tree"
  },
  {
    "State": "AL",
    "City": "Lowndesboro"
  },
  {
    "State": "AL",
    "City": "Mc Williams"
  },
  {
    "State": "AL",
    "City": "Magnolia"
  },
  {
    "State": "AL",
    "City": "Marion"
  },
  {
    "State": "AL",
    "City": "Plantersville"
  },
  {
    "State": "AL",
    "City": "Marion Junction"
  },
  {
    "State": "AL",
    "City": "Minter"
  },
  {
    "State": "AL",
    "City": "Morvin"
  },
  {
    "State": "AL",
    "City": "Myrtlewood"
  },
  {
    "State": "AL",
    "City": "Nanafalia"
  },
  {
    "State": "AL",
    "City": "Newbern"
  },
  {
    "State": "AL",
    "City": "Oak Hill"
  },
  {
    "State": "AL",
    "City": "Orrville"
  },
  {
    "State": "AL",
    "City": "Pine Apple"
  },
  {
    "State": "AL",
    "City": "Pine Hill"
  },
  {
    "State": "AL",
    "City": "Safford"
  },
  {
    "State": "AL",
    "City": "Sardis"
  },
  {
    "State": "AL",
    "City": "Sawyerville"
  },
  {
    "State": "AL",
    "City": "Sweet Water"
  },
  {
    "State": "AL",
    "City": "Thomaston"
  },
  {
    "State": "AL",
    "City": "Thomasville"
  },
  {
    "State": "AL",
    "City": "Tyler"
  },
  {
    "State": "AL",
    "City": "Uniontown"
  },
  {
    "State": "AL",
    "City": "Stanton"
  },
  {
    "State": "AL",
    "City": "Randolph"
  },
  {
    "State": "AL",
    "City": "Lawley"
  },
  {
    "State": "AL",
    "City": "Opelika"
  },
  {
    "State": "AL",
    "City": "Auburn"
  },
  {
    "State": "AL",
    "City": "Auburn University"
  },
  {
    "State": "AL",
    "City": "Camp Hill"
  },
  {
    "State": "AL",
    "City": "Cottonton"
  },
  {
    "State": "AL",
    "City": "Cusseta"
  },
  {
    "State": "AL",
    "City": "Dadeville"
  },
  {
    "State": "AL",
    "City": "Valley"
  },
  {
    "State": "AL",
    "City": "Five Points"
  },
  {
    "State": "AL",
    "City": "Fort Mitchell"
  },
  {
    "State": "AL",
    "City": "Hatchechubbee"
  },
  {
    "State": "AL",
    "City": "Holy Trinity"
  },
  {
    "State": "AL",
    "City": "Hurtsboro"
  },
  {
    "State": "AL",
    "City": "Jacksons Gap"
  },
  {
    "State": "AL",
    "City": "Lafayette"
  },
  {
    "State": "AL",
    "City": "Lanett"
  },
  {
    "State": "AL",
    "City": "Loachapoka"
  },
  {
    "State": "AL",
    "City": "Notasulga"
  },
  {
    "State": "AL",
    "City": "Phenix City"
  },
  {
    "State": "AL",
    "City": "Pittsview"
  },
  {
    "State": "AL",
    "City": "Salem"
  },
  {
    "State": "AL",
    "City": "Seale"
  },
  {
    "State": "AL",
    "City": "Smiths Station"
  },
  {
    "State": "AL",
    "City": "Waverly"
  },
  {
    "State": "AL",
    "City": "Bellamy"
  },
  {
    "State": "AL",
    "City": "Butler"
  },
  {
    "State": "AL",
    "City": "Cuba"
  },
  {
    "State": "AL",
    "City": "Gilbertown"
  },
  {
    "State": "AL",
    "City": "Jachin"
  },
  {
    "State": "AL",
    "City": "Lisman"
  },
  {
    "State": "AL",
    "City": "Melvin"
  },
  {
    "State": "AL",
    "City": "Needham"
  },
  {
    "State": "AL",
    "City": "Pennington"
  },
  {
    "State": "AL",
    "City": "Silas"
  },
  {
    "State": "AL",
    "City": "Toxey"
  },
  {
    "State": "AL",
    "City": "Ward"
  },
  {
    "State": "AL",
    "City": "York"
  },
  {
    "State": "TN",
    "City": "Adams"
  },
  {
    "State": "TN",
    "City": "Antioch"
  },
  {
    "State": "TN",
    "City": "Alexandria"
  },
  {
    "State": "TN",
    "City": "Arrington"
  },
  {
    "State": "TN",
    "City": "Ashland City"
  },
  {
    "State": "TN",
    "City": "Auburntown"
  },
  {
    "State": "TN",
    "City": "Beechgrove"
  },
  {
    "State": "TN",
    "City": "Belfast"
  },
  {
    "State": "TN",
    "City": "Bell Buckle"
  },
  {
    "State": "TN",
    "City": "Bethpage"
  },
  {
    "State": "TN",
    "City": "Big Rock"
  },
  {
    "State": "TN",
    "City": "Brentwood"
  },
  {
    "State": "TN",
    "City": "Bon Aqua"
  },
  {
    "State": "TN",
    "City": "Bradyville"
  },
  {
    "State": "TN",
    "City": "Bumpus Mills"
  },
  {
    "State": "TN",
    "City": "Burns"
  },
  {
    "State": "TN",
    "City": "Carthage"
  },
  {
    "State": "TN",
    "City": "Castalian Springs"
  },
  {
    "State": "TN",
    "City": "Cedar Hill"
  },
  {
    "State": "TN",
    "City": "Centerville"
  },
  {
    "State": "TN",
    "City": "Chapel Hill"
  },
  {
    "State": "TN",
    "City": "Chapmansboro"
  },
  {
    "State": "TN",
    "City": "Charlotte"
  },
  {
    "State": "TN",
    "City": "Christiana"
  },
  {
    "State": "TN",
    "City": "Clarksville"
  },
  {
    "State": "TN",
    "City": "College Grove"
  },
  {
    "State": "TN",
    "City": "Cornersville"
  },
  {
    "State": "TN",
    "City": "Cottontown"
  },
  {
    "State": "TN",
    "City": "Cross Plains"
  },
  {
    "State": "TN",
    "City": "Cumberland City"
  },
  {
    "State": "TN",
    "City": "Cumberland Furnace"
  },
  {
    "State": "TN",
    "City": "Cunningham"
  },
  {
    "State": "TN",
    "City": "Dickson"
  },
  {
    "State": "TN",
    "City": "Dixon Springs"
  },
  {
    "State": "TN",
    "City": "Dover"
  },
  {
    "State": "TN",
    "City": "Dowelltown"
  },
  {
    "State": "TN",
    "City": "Eagleville"
  },
  {
    "State": "TN",
    "City": "Erin"
  },
  {
    "State": "TN",
    "City": "Fairview"
  },
  {
    "State": "TN",
    "City": "Fosterville"
  },
  {
    "State": "TN",
    "City": "Franklin"
  },
  {
    "State": "TN",
    "City": "Gallatin"
  },
  {
    "State": "TN",
    "City": "Goodlettsville"
  },
  {
    "State": "TN",
    "City": "Gladeville"
  },
  {
    "State": "TN",
    "City": "Greenbrier"
  },
  {
    "State": "TN",
    "City": "Hartsville"
  },
  {
    "State": "TN",
    "City": "Hendersonville"
  },
  {
    "State": "TN",
    "City": "Hermitage"
  },
  {
    "State": "TN",
    "City": "Hurricane Mills"
  },
  {
    "State": "TN",
    "City": "Indian Mound"
  },
  {
    "State": "TN",
    "City": "Joelton"
  },
  {
    "State": "TN",
    "City": "Kingston Springs"
  },
  {
    "State": "TN",
    "City": "Lafayette"
  },
  {
    "State": "TN",
    "City": "Lascassas"
  },
  {
    "State": "TN",
    "City": "La Vergne"
  },
  {
    "State": "TN",
    "City": "Lebanon"
  },
  {
    "State": "TN",
    "City": "Lewisburg"
  },
  {
    "State": "TN",
    "City": "Liberty"
  },
  {
    "State": "TN",
    "City": "Linden"
  },
  {
    "State": "TN",
    "City": "Lobelville"
  },
  {
    "State": "TN",
    "City": "Lyles"
  },
  {
    "State": "TN",
    "City": "Mc Ewen"
  },
  {
    "State": "TN",
    "City": "Mcminnville"
  },
  {
    "State": "TN",
    "City": "Madison"
  },
  {
    "State": "TN",
    "City": "Milton"
  },
  {
    "State": "TN",
    "City": "Mitchellville"
  },
  {
    "State": "TN",
    "City": "Mount Juliet"
  },
  {
    "State": "TN",
    "City": "Murfreesboro"
  },
  {
    "State": "TN",
    "City": "New Johnsonville"
  },
  {
    "State": "TN",
    "City": "Nolensville"
  },
  {
    "State": "TN",
    "City": "Norene"
  },
  {
    "State": "TN",
    "City": "Nunnelly"
  },
  {
    "State": "TN",
    "City": "Old Hickory"
  },
  {
    "State": "TN",
    "City": "Only"
  },
  {
    "State": "TN",
    "City": "Orlinda"
  },
  {
    "State": "TN",
    "City": "Palmyra"
  },
  {
    "State": "TN",
    "City": "Pegram"
  },
  {
    "State": "TN",
    "City": "Petersburg"
  },
  {
    "State": "TN",
    "City": "Pleasant Shade"
  },
  {
    "State": "TN",
    "City": "Pleasant View"
  },
  {
    "State": "TN",
    "City": "Portland"
  },
  {
    "State": "TN",
    "City": "Readyville"
  },
  {
    "State": "TN",
    "City": "Red Boiling Springs"
  },
  {
    "State": "TN",
    "City": "Riddleton"
  },
  {
    "State": "TN",
    "City": "Ridgetop"
  },
  {
    "State": "TN",
    "City": "Rockvale"
  },
  {
    "State": "TN",
    "City": "Shelbyville"
  },
  {
    "State": "TN",
    "City": "Slayden"
  },
  {
    "State": "TN",
    "City": "Smithville"
  },
  {
    "State": "TN",
    "City": "Smyrna"
  },
  {
    "State": "TN",
    "City": "Southside"
  },
  {
    "State": "TN",
    "City": "Springfield"
  },
  {
    "State": "TN",
    "City": "Spring Hill"
  },
  {
    "State": "TN",
    "City": "Stewart"
  },
  {
    "State": "TN",
    "City": "Tennessee Ridge"
  },
  {
    "State": "TN",
    "City": "Thompsons Station"
  },
  {
    "State": "TN",
    "City": "Unionville"
  },
  {
    "State": "TN",
    "City": "Vanleer"
  },
  {
    "State": "TN",
    "City": "Wartrace"
  },
  {
    "State": "TN",
    "City": "Watertown"
  },
  {
    "State": "TN",
    "City": "Waverly"
  },
  {
    "State": "TN",
    "City": "Westmoreland"
  },
  {
    "State": "TN",
    "City": "White Bluff"
  },
  {
    "State": "TN",
    "City": "White House"
  },
  {
    "State": "TN",
    "City": "Whites Creek"
  },
  {
    "State": "TN",
    "City": "Woodbury"
  },
  {
    "State": "TN",
    "City": "Woodlawn"
  },
  {
    "State": "TN",
    "City": "Nashville"
  },
  {
    "State": "TN",
    "City": "Altamont"
  },
  {
    "State": "TN",
    "City": "Apison"
  },
  {
    "State": "TN",
    "City": "Athens"
  },
  {
    "State": "TN",
    "City": "Bakewell"
  },
  {
    "State": "TN",
    "City": "Beersheba Springs"
  },
  {
    "State": "TN",
    "City": "Belvidere"
  },
  {
    "State": "TN",
    "City": "Benton"
  },
  {
    "State": "TN",
    "City": "Birchwood"
  },
  {
    "State": "TN",
    "City": "Calhoun"
  },
  {
    "State": "TN",
    "City": "Charleston"
  },
  {
    "State": "TN",
    "City": "Cleveland"
  },
  {
    "State": "TN",
    "City": "Coalmont"
  },
  {
    "State": "TN",
    "City": "Coker Creek"
  },
  {
    "State": "TN",
    "City": "Collegedale"
  },
  {
    "State": "TN",
    "City": "Conasauga"
  },
  {
    "State": "TN",
    "City": "Copperhill"
  },
  {
    "State": "TN",
    "City": "Cowan"
  },
  {
    "State": "TN",
    "City": "Dayton"
  },
  {
    "State": "TN",
    "City": "Decatur"
  },
  {
    "State": "TN",
    "City": "Decherd"
  },
  {
    "State": "TN",
    "City": "Delano"
  },
  {
    "State": "TN",
    "City": "Ducktown"
  },
  {
    "State": "TN",
    "City": "Dunlap"
  },
  {
    "State": "TN",
    "City": "Elora"
  },
  {
    "State": "TN",
    "City": "Englewood"
  },
  {
    "State": "TN",
    "City": "Estill Springs"
  },
  {
    "State": "TN",
    "City": "Etowah"
  },
  {
    "State": "TN",
    "City": "Evensville"
  },
  {
    "State": "TN",
    "City": "Farner"
  },
  {
    "State": "TN",
    "City": "Fayetteville"
  },
  {
    "State": "TN",
    "City": "Flintville"
  },
  {
    "State": "TN",
    "City": "Georgetown"
  },
  {
    "State": "TN",
    "City": "Grandview"
  },
  {
    "State": "TN",
    "City": "Graysville"
  },
  {
    "State": "TN",
    "City": "Gruetli Laager"
  },
  {
    "State": "TN",
    "City": "Guild"
  },
  {
    "State": "TN",
    "City": "Harrison"
  },
  {
    "State": "TN",
    "City": "Hillsboro"
  },
  {
    "State": "TN",
    "City": "Hixson"
  },
  {
    "State": "TN",
    "City": "Huntland"
  },
  {
    "State": "TN",
    "City": "Jasper"
  },
  {
    "State": "TN",
    "City": "Kelso"
  },
  {
    "State": "TN",
    "City": "Manchester"
  },
  {
    "State": "TN",
    "City": "Lookout Mountain"
  },
  {
    "State": "TN",
    "City": "Lupton City"
  },
  {
    "State": "TN",
    "City": "Lynchburg"
  },
  {
    "State": "TN",
    "City": "Mc Donald"
  },
  {
    "State": "TN",
    "City": "Madisonville"
  },
  {
    "State": "TN",
    "City": "Monteagle"
  },
  {
    "State": "TN",
    "City": "Morrison"
  },
  {
    "State": "TN",
    "City": "Mulberry"
  },
  {
    "State": "TN",
    "City": "Normandy"
  },
  {
    "State": "TN",
    "City": "Ocoee"
  },
  {
    "State": "TN",
    "City": "Old Fort"
  },
  {
    "State": "TN",
    "City": "Ooltewah"
  },
  {
    "State": "TN",
    "City": "Palmer"
  },
  {
    "State": "TN",
    "City": "Pelham"
  },
  {
    "State": "TN",
    "City": "Pikeville"
  },
  {
    "State": "TN",
    "City": "Reliance"
  },
  {
    "State": "TN",
    "City": "Riceville"
  },
  {
    "State": "TN",
    "City": "Sale Creek"
  },
  {
    "State": "TN",
    "City": "Sequatchie"
  },
  {
    "State": "TN",
    "City": "Sewanee"
  },
  {
    "State": "TN",
    "City": "Sherwood"
  },
  {
    "State": "TN",
    "City": "Signal Mountain"
  },
  {
    "State": "TN",
    "City": "Smartt"
  },
  {
    "State": "TN",
    "City": "Soddy Daisy"
  },
  {
    "State": "TN",
    "City": "South Pittsburg"
  },
  {
    "State": "TN",
    "City": "Spring City"
  },
  {
    "State": "TN",
    "City": "Summitville"
  },
  {
    "State": "TN",
    "City": "Tellico Plains"
  },
  {
    "State": "TN",
    "City": "Tracy City"
  },
  {
    "State": "TN",
    "City": "Tullahoma"
  },
  {
    "State": "TN",
    "City": "Arnold AFB"
  },
  {
    "State": "TN",
    "City": "Turtletown"
  },
  {
    "State": "TN",
    "City": "Viola"
  },
  {
    "State": "TN",
    "City": "Whiteside"
  },
  {
    "State": "TN",
    "City": "Whitwell"
  },
  {
    "State": "TN",
    "City": "Winchester"
  },
  {
    "State": "TN",
    "City": "Chattanooga"
  },
  {
    "State": "TN",
    "City": "Memphis"
  },
  {
    "State": "TN",
    "City": "Johnson City"
  },
  {
    "State": "TN",
    "City": "Afton"
  },
  {
    "State": "TN",
    "City": "Blountville"
  },
  {
    "State": "TN",
    "City": "Bluff City"
  },
  {
    "State": "TN",
    "City": "Bristol"
  },
  {
    "State": "TN",
    "City": "Butler"
  },
  {
    "State": "TN",
    "City": "Chuckey"
  },
  {
    "State": "TN",
    "City": "Church Hill"
  },
  {
    "State": "TN",
    "City": "Elizabethton"
  },
  {
    "State": "TN",
    "City": "Mount Carmel"
  },
  {
    "State": "TN",
    "City": "Erwin"
  },
  {
    "State": "TN",
    "City": "Fall Branch"
  },
  {
    "State": "TN",
    "City": "Flag Pond"
  },
  {
    "State": "TN",
    "City": "Hampton"
  },
  {
    "State": "TN",
    "City": "Jonesborough"
  },
  {
    "State": "TN",
    "City": "Kingsport"
  },
  {
    "State": "TN",
    "City": "Laurel Bloomery"
  },
  {
    "State": "TN",
    "City": "Limestone"
  },
  {
    "State": "TN",
    "City": "Milligan College"
  },
  {
    "State": "TN",
    "City": "Mountain City"
  },
  {
    "State": "TN",
    "City": "Mountain Home"
  },
  {
    "State": "TN",
    "City": "Piney Flats"
  },
  {
    "State": "TN",
    "City": "Roan Mountain"
  },
  {
    "State": "TN",
    "City": "Shady Valley"
  },
  {
    "State": "TN",
    "City": "Telford"
  },
  {
    "State": "TN",
    "City": "Trade"
  },
  {
    "State": "TN",
    "City": "Unicoi"
  },
  {
    "State": "TN",
    "City": "Watauga"
  },
  {
    "State": "TN",
    "City": "Alcoa"
  },
  {
    "State": "TN",
    "City": "Andersonville"
  },
  {
    "State": "TN",
    "City": "Arthur"
  },
  {
    "State": "TN",
    "City": "Bean Station"
  },
  {
    "State": "TN",
    "City": "Blaine"
  },
  {
    "State": "TN",
    "City": "Briceville"
  },
  {
    "State": "TN",
    "City": "Bulls Gap"
  },
  {
    "State": "TN",
    "City": "Bybee"
  },
  {
    "State": "TN",
    "City": "Caryville"
  },
  {
    "State": "TN",
    "City": "Clairfield"
  },
  {
    "State": "TN",
    "City": "Clinton"
  },
  {
    "State": "TN",
    "City": "Coalfield"
  },
  {
    "State": "TN",
    "City": "Corryton"
  },
  {
    "State": "TN",
    "City": "Cosby"
  },
  {
    "State": "TN",
    "City": "Crab Orchard"
  },
  {
    "State": "TN",
    "City": "Cumberland Gap"
  },
  {
    "State": "TN",
    "City": "Dandridge"
  },
  {
    "State": "TN",
    "City": "Deer Lodge"
  },
  {
    "State": "TN",
    "City": "Del Rio"
  },
  {
    "State": "TN",
    "City": "Duff"
  },
  {
    "State": "TN",
    "City": "Eagan"
  },
  {
    "State": "TN",
    "City": "Eidson"
  },
  {
    "State": "TN",
    "City": "Elgin"
  },
  {
    "State": "TN",
    "City": "Rugby"
  },
  {
    "State": "TN",
    "City": "Friendsville"
  },
  {
    "State": "TN",
    "City": "Gatlinburg"
  },
  {
    "State": "TN",
    "City": "Greenback"
  },
  {
    "State": "TN",
    "City": "Greeneville"
  },
  {
    "State": "TN",
    "City": "Harriman"
  },
  {
    "State": "TN",
    "City": "Harrogate"
  },
  {
    "State": "TN",
    "City": "Hartford"
  },
  {
    "State": "TN",
    "City": "Heiskell"
  },
  {
    "State": "TN",
    "City": "Helenwood"
  },
  {
    "State": "TN",
    "City": "Huntsville"
  },
  {
    "State": "TN",
    "City": "Jacksboro"
  },
  {
    "State": "TN",
    "City": "Jefferson City"
  },
  {
    "State": "TN",
    "City": "Jellico"
  },
  {
    "State": "TN",
    "City": "Kingston"
  },
  {
    "State": "TN",
    "City": "Kodak"
  },
  {
    "State": "TN",
    "City": "Kyles Ford"
  },
  {
    "State": "TN",
    "City": "La Follette"
  },
  {
    "State": "TN",
    "City": "Rocky Top"
  },
  {
    "State": "TN",
    "City": "Lancing"
  },
  {
    "State": "TN",
    "City": "Lenoir City"
  },
  {
    "State": "TN",
    "City": "Lone Mountain"
  },
  {
    "State": "TN",
    "City": "Loudon"
  },
  {
    "State": "TN",
    "City": "Louisville"
  },
  {
    "State": "TN",
    "City": "Lowland"
  },
  {
    "State": "TN",
    "City": "Luttrell"
  },
  {
    "State": "TN",
    "City": "Maryville"
  },
  {
    "State": "TN",
    "City": "Mascot"
  },
  {
    "State": "TN",
    "City": "Maynardville"
  },
  {
    "State": "TN",
    "City": "Midway"
  },
  {
    "State": "TN",
    "City": "Mohawk"
  },
  {
    "State": "TN",
    "City": "Mooresburg"
  },
  {
    "State": "TN",
    "City": "Morristown"
  },
  {
    "State": "TN",
    "City": "Mosheim"
  },
  {
    "State": "TN",
    "City": "Newcomb"
  },
  {
    "State": "TN",
    "City": "New Market"
  },
  {
    "State": "TN",
    "City": "Newport"
  },
  {
    "State": "TN",
    "City": "New Tazewell"
  },
  {
    "State": "TN",
    "City": "Niota"
  },
  {
    "State": "TN",
    "City": "Norris"
  },
  {
    "State": "TN",
    "City": "Oakdale"
  },
  {
    "State": "TN",
    "City": "Oak Ridge"
  },
  {
    "State": "TN",
    "City": "Oliver Springs"
  },
  {
    "State": "TN",
    "City": "Oneida"
  },
  {
    "State": "TN",
    "City": "Parrottsville"
  },
  {
    "State": "TN",
    "City": "Petros"
  },
  {
    "State": "TN",
    "City": "Philadelphia"
  },
  {
    "State": "TN",
    "City": "Pioneer"
  },
  {
    "State": "TN",
    "City": "Powder Springs"
  },
  {
    "State": "TN",
    "City": "Powell"
  },
  {
    "State": "TN",
    "City": "Pruden"
  },
  {
    "State": "TN",
    "City": "Robbins"
  },
  {
    "State": "TN",
    "City": "Rockford"
  },
  {
    "State": "TN",
    "City": "Rockwood"
  },
  {
    "State": "TN",
    "City": "Rogersville"
  },
  {
    "State": "TN",
    "City": "Russellville"
  },
  {
    "State": "TN",
    "City": "Rutledge"
  },
  {
    "State": "TN",
    "City": "Sevierville"
  },
  {
    "State": "TN",
    "City": "Pigeon Forge"
  },
  {
    "State": "TN",
    "City": "Seymour"
  },
  {
    "State": "TN",
    "City": "Sharps Chapel"
  },
  {
    "State": "TN",
    "City": "Shawanee"
  },
  {
    "State": "TN",
    "City": "Sneedville"
  },
  {
    "State": "TN",
    "City": "Speedwell"
  },
  {
    "State": "TN",
    "City": "Strawberry Plains"
  },
  {
    "State": "TN",
    "City": "Sunbright"
  },
  {
    "State": "TN",
    "City": "Surgoinsville"
  },
  {
    "State": "TN",
    "City": "Sweetwater"
  },
  {
    "State": "TN",
    "City": "Talbott"
  },
  {
    "State": "TN",
    "City": "Tallassee"
  },
  {
    "State": "TN",
    "City": "Tazewell"
  },
  {
    "State": "TN",
    "City": "Ten Mile"
  },
  {
    "State": "TN",
    "City": "Thorn Hill"
  },
  {
    "State": "TN",
    "City": "Townsend"
  },
  {
    "State": "TN",
    "City": "Vonore"
  },
  {
    "State": "TN",
    "City": "Walland"
  },
  {
    "State": "TN",
    "City": "Wartburg"
  },
  {
    "State": "TN",
    "City": "Washburn"
  },
  {
    "State": "TN",
    "City": "White Pine"
  },
  {
    "State": "TN",
    "City": "Whitesburg"
  },
  {
    "State": "TN",
    "City": "Winfield"
  },
  {
    "State": "TN",
    "City": "Knoxville"
  },
  {
    "State": "TN",
    "City": "Farragut"
  },
  {
    "State": "TN",
    "City": "Alamo"
  },
  {
    "State": "TN",
    "City": "Arlington"
  },
  {
    "State": "TN",
    "City": "Atoka"
  },
  {
    "State": "TN",
    "City": "Bells"
  },
  {
    "State": "TN",
    "City": "Bogota"
  },
  {
    "State": "TN",
    "City": "Bolivar"
  },
  {
    "State": "TN",
    "City": "Braden"
  },
  {
    "State": "TN",
    "City": "Brighton"
  },
  {
    "State": "TN",
    "City": "Brownsville"
  },
  {
    "State": "TN",
    "City": "Brunswick"
  },
  {
    "State": "TN",
    "City": "Burlison"
  },
  {
    "State": "TN",
    "City": "Cordova"
  },
  {
    "State": "TN",
    "City": "Collierville"
  },
  {
    "State": "TN",
    "City": "Covington"
  },
  {
    "State": "TN",
    "City": "Crockett Mills"
  },
  {
    "State": "TN",
    "City": "Drummonds"
  },
  {
    "State": "TN",
    "City": "Dyersburg"
  },
  {
    "State": "TN",
    "City": "Eads"
  },
  {
    "State": "TN",
    "City": "Ellendale"
  },
  {
    "State": "TN",
    "City": "Finley"
  },
  {
    "State": "TN",
    "City": "Friendship"
  },
  {
    "State": "TN",
    "City": "Gallaway"
  },
  {
    "State": "TN",
    "City": "Gates"
  },
  {
    "State": "TN",
    "City": "Grand Junction"
  },
  {
    "State": "TN",
    "City": "Halls"
  },
  {
    "State": "TN",
    "City": "Henning"
  },
  {
    "State": "TN",
    "City": "Hickory Valley"
  },
  {
    "State": "TN",
    "City": "Hornsby"
  },
  {
    "State": "TN",
    "City": "Laconia"
  },
  {
    "State": "TN",
    "City": "La Grange"
  },
  {
    "State": "TN",
    "City": "Lenox"
  },
  {
    "State": "TN",
    "City": "Macon"
  },
  {
    "State": "TN",
    "City": "Mason"
  },
  {
    "State": "TN",
    "City": "Maury City"
  },
  {
    "State": "TN",
    "City": "Middleton"
  },
  {
    "State": "TN",
    "City": "Millington"
  },
  {
    "State": "TN",
    "City": "Moscow"
  },
  {
    "State": "TN",
    "City": "Munford"
  },
  {
    "State": "TN",
    "City": "Newbern"
  },
  {
    "State": "TN",
    "City": "Oakland"
  },
  {
    "State": "TN",
    "City": "Pocahontas"
  },
  {
    "State": "TN",
    "City": "Ripley"
  },
  {
    "State": "TN",
    "City": "Rossville"
  },
  {
    "State": "TN",
    "City": "Saulsbury"
  },
  {
    "State": "TN",
    "City": "Somerville"
  },
  {
    "State": "TN",
    "City": "Stanton"
  },
  {
    "State": "TN",
    "City": "Tigrett"
  },
  {
    "State": "TN",
    "City": "Tipton"
  },
  {
    "State": "TN",
    "City": "Whiteville"
  },
  {
    "State": "TN",
    "City": "Williston"
  },
  {
    "State": "TN",
    "City": "Wynnburg"
  },
  {
    "State": "TN",
    "City": "Tiptonville"
  },
  {
    "State": "TN",
    "City": "Ridgely"
  },
  {
    "State": "TN",
    "City": "Germantown"
  },
  {
    "State": "TN",
    "City": "Mc Kenzie"
  },
  {
    "State": "TN",
    "City": "Atwood"
  },
  {
    "State": "TN",
    "City": "Big Sandy"
  },
  {
    "State": "TN",
    "City": "Buchanan"
  },
  {
    "State": "TN",
    "City": "Como"
  },
  {
    "State": "TN",
    "City": "Cottage Grove"
  },
  {
    "State": "TN",
    "City": "Dresden"
  },
  {
    "State": "TN",
    "City": "Dukedom"
  },
  {
    "State": "TN",
    "City": "Elbridge"
  },
  {
    "State": "TN",
    "City": "Gleason"
  },
  {
    "State": "TN",
    "City": "Greenfield"
  },
  {
    "State": "TN",
    "City": "Henry"
  },
  {
    "State": "TN",
    "City": "Hornbeak"
  },
  {
    "State": "TN",
    "City": "Kenton"
  },
  {
    "State": "TN",
    "City": "Mc Lemoresville"
  },
  {
    "State": "TN",
    "City": "Mansfield"
  },
  {
    "State": "TN",
    "City": "Martin"
  },
  {
    "State": "TN",
    "City": "Obion"
  },
  {
    "State": "TN",
    "City": "Palmersville"
  },
  {
    "State": "TN",
    "City": "Paris"
  },
  {
    "State": "TN",
    "City": "Puryear"
  },
  {
    "State": "TN",
    "City": "Rives"
  },
  {
    "State": "TN",
    "City": "Samburg"
  },
  {
    "State": "TN",
    "City": "Sharon"
  },
  {
    "State": "TN",
    "City": "Springville"
  },
  {
    "State": "TN",
    "City": "South Fulton"
  },
  {
    "State": "TN",
    "City": "Trezevant"
  },
  {
    "State": "TN",
    "City": "Trimble"
  },
  {
    "State": "TN",
    "City": "Troy"
  },
  {
    "State": "TN",
    "City": "Union City"
  },
  {
    "State": "TN",
    "City": "Woodland Mills"
  },
  {
    "State": "TN",
    "City": "Jackson"
  },
  {
    "State": "TN",
    "City": "Adamsville"
  },
  {
    "State": "TN",
    "City": "Bath Springs"
  },
  {
    "State": "TN",
    "City": "Beech Bluff"
  },
  {
    "State": "TN",
    "City": "Bethel Springs"
  },
  {
    "State": "TN",
    "City": "Bradford"
  },
  {
    "State": "TN",
    "City": "Bruceton"
  },
  {
    "State": "TN",
    "City": "Buena Vista"
  },
  {
    "State": "TN",
    "City": "Camden"
  },
  {
    "State": "TN",
    "City": "Cedar Grove"
  },
  {
    "State": "TN",
    "City": "Clarksburg"
  },
  {
    "State": "TN",
    "City": "Counce"
  },
  {
    "State": "TN",
    "City": "Crump"
  },
  {
    "State": "TN",
    "City": "Darden"
  },
  {
    "State": "TN",
    "City": "Decaturville"
  },
  {
    "State": "TN",
    "City": "Dyer"
  },
  {
    "State": "TN",
    "City": "Eaton"
  },
  {
    "State": "TN",
    "City": "Enville"
  },
  {
    "State": "TN",
    "City": "Eva"
  },
  {
    "State": "TN",
    "City": "Finger"
  },
  {
    "State": "TN",
    "City": "Fruitvale"
  },
  {
    "State": "TN",
    "City": "Gadsden"
  },
  {
    "State": "TN",
    "City": "Gibson"
  },
  {
    "State": "TN",
    "City": "Guys"
  },
  {
    "State": "TN",
    "City": "Henderson"
  },
  {
    "State": "TN",
    "City": "Holladay"
  },
  {
    "State": "TN",
    "City": "Hollow Rock"
  },
  {
    "State": "TN",
    "City": "Humboldt"
  },
  {
    "State": "TN",
    "City": "Huntingdon"
  },
  {
    "State": "TN",
    "City": "Huron"
  },
  {
    "State": "TN",
    "City": "Idlewild"
  },
  {
    "State": "TN",
    "City": "Jacks Creek"
  },
  {
    "State": "TN",
    "City": "Lavinia"
  },
  {
    "State": "TN",
    "City": "Lexington"
  },
  {
    "State": "TN",
    "City": "Luray"
  },
  {
    "State": "TN",
    "City": "Medina"
  },
  {
    "State": "TN",
    "City": "Medon"
  },
  {
    "State": "TN",
    "City": "Michie"
  },
  {
    "State": "TN",
    "City": "Milan"
  },
  {
    "State": "TN",
    "City": "Milledgeville"
  },
  {
    "State": "TN",
    "City": "Morris Chapel"
  },
  {
    "State": "TN",
    "City": "Oakfield"
  },
  {
    "State": "TN",
    "City": "Parsons"
  },
  {
    "State": "TN",
    "City": "Pickwick Dam"
  },
  {
    "State": "TN",
    "City": "Pinson"
  },
  {
    "State": "TN",
    "City": "Ramer"
  },
  {
    "State": "TN",
    "City": "Reagan"
  },
  {
    "State": "TN",
    "City": "Rutherford"
  },
  {
    "State": "TN",
    "City": "Saltillo"
  },
  {
    "State": "TN",
    "City": "Sardis"
  },
  {
    "State": "TN",
    "City": "Savannah"
  },
  {
    "State": "TN",
    "City": "Scotts Hill"
  },
  {
    "State": "TN",
    "City": "Selmer"
  },
  {
    "State": "TN",
    "City": "Shiloh"
  },
  {
    "State": "TN",
    "City": "Silerton"
  },
  {
    "State": "TN",
    "City": "Spring Creek"
  },
  {
    "State": "TN",
    "City": "Stantonville"
  },
  {
    "State": "TN",
    "City": "Sugar Tree"
  },
  {
    "State": "TN",
    "City": "Toone"
  },
  {
    "State": "TN",
    "City": "Trenton"
  },
  {
    "State": "TN",
    "City": "Westport"
  },
  {
    "State": "TN",
    "City": "Wildersville"
  },
  {
    "State": "TN",
    "City": "Yorkville"
  },
  {
    "State": "TN",
    "City": "Yuma"
  },
  {
    "State": "TN",
    "City": "Denmark"
  },
  {
    "State": "TN",
    "City": "Mercer"
  },
  {
    "State": "TN",
    "City": "Chewalla"
  },
  {
    "State": "TN",
    "City": "Columbia"
  },
  {
    "State": "TN",
    "City": "Clifton"
  },
  {
    "State": "TN",
    "City": "Ardmore"
  },
  {
    "State": "TN",
    "City": "Collinwood"
  },
  {
    "State": "TN",
    "City": "Culleoka"
  },
  {
    "State": "TN",
    "City": "Cypress Inn"
  },
  {
    "State": "TN",
    "City": "Dellrose"
  },
  {
    "State": "TN",
    "City": "Duck River"
  },
  {
    "State": "TN",
    "City": "Elkton"
  },
  {
    "State": "TN",
    "City": "Ethridge"
  },
  {
    "State": "TN",
    "City": "Five Points"
  },
  {
    "State": "TN",
    "City": "Frankewing"
  },
  {
    "State": "TN",
    "City": "Goodspring"
  },
  {
    "State": "TN",
    "City": "Hampshire"
  },
  {
    "State": "TN",
    "City": "Hohenwald"
  },
  {
    "State": "TN",
    "City": "Iron City"
  },
  {
    "State": "TN",
    "City": "Lawrenceburg"
  },
  {
    "State": "TN",
    "City": "Leoma"
  },
  {
    "State": "TN",
    "City": "Loretto"
  },
  {
    "State": "TN",
    "City": "Lutts"
  },
  {
    "State": "TN",
    "City": "Lynnville"
  },
  {
    "State": "TN",
    "City": "Minor Hill"
  },
  {
    "State": "TN",
    "City": "Mount Pleasant"
  },
  {
    "State": "TN",
    "City": "Olivehill"
  },
  {
    "State": "TN",
    "City": "Primm Springs"
  },
  {
    "State": "TN",
    "City": "Prospect"
  },
  {
    "State": "TN",
    "City": "Pulaski"
  },
  {
    "State": "TN",
    "City": "Saint Joseph"
  },
  {
    "State": "TN",
    "City": "Santa Fe"
  },
  {
    "State": "TN",
    "City": "Summertown"
  },
  {
    "State": "TN",
    "City": "Waynesboro"
  },
  {
    "State": "TN",
    "City": "Westpoint"
  },
  {
    "State": "TN",
    "City": "Williamsport"
  },
  {
    "State": "TN",
    "City": "Taft"
  },
  {
    "State": "TN",
    "City": "Cookeville"
  },
  {
    "State": "TN",
    "City": "Allardt"
  },
  {
    "State": "TN",
    "City": "Allons"
  },
  {
    "State": "TN",
    "City": "Allred"
  },
  {
    "State": "TN",
    "City": "Alpine"
  },
  {
    "State": "TN",
    "City": "Baxter"
  },
  {
    "State": "TN",
    "City": "Bloomington Springs"
  },
  {
    "State": "TN",
    "City": "Brush Creek"
  },
  {
    "State": "TN",
    "City": "Buffalo Valley"
  },
  {
    "State": "TN",
    "City": "Byrdstown"
  },
  {
    "State": "TN",
    "City": "Campaign"
  },
  {
    "State": "TN",
    "City": "Celina"
  },
  {
    "State": "TN",
    "City": "Chestnut Mound"
  },
  {
    "State": "TN",
    "City": "Clarkrange"
  },
  {
    "State": "TN",
    "City": "Crawford"
  },
  {
    "State": "TN",
    "City": "Crossville"
  },
  {
    "State": "TN",
    "City": "Jamestown"
  },
  {
    "State": "TN",
    "City": "Doyle"
  },
  {
    "State": "TN",
    "City": "Elmwood"
  },
  {
    "State": "TN",
    "City": "Gainesboro"
  },
  {
    "State": "TN",
    "City": "Gordonsville"
  },
  {
    "State": "TN",
    "City": "Granville"
  },
  {
    "State": "TN",
    "City": "Grimsley"
  },
  {
    "State": "TN",
    "City": "Hickman"
  },
  {
    "State": "TN",
    "City": "Hilham"
  },
  {
    "State": "TN",
    "City": "Lancaster"
  },
  {
    "State": "TN",
    "City": "Livingston"
  },
  {
    "State": "TN",
    "City": "Monroe"
  },
  {
    "State": "TN",
    "City": "Monterey"
  },
  {
    "State": "TN",
    "City": "Moss"
  },
  {
    "State": "TN",
    "City": "Pall Mall"
  },
  {
    "State": "TN",
    "City": "Pleasant Hill"
  },
  {
    "State": "TN",
    "City": "Quebeck"
  },
  {
    "State": "TN",
    "City": "Rickman"
  },
  {
    "State": "TN",
    "City": "Rock Island"
  },
  {
    "State": "TN",
    "City": "Silver Point"
  },
  {
    "State": "TN",
    "City": "Sparta"
  },
  {
    "State": "TN",
    "City": "Spencer"
  },
  {
    "State": "TN",
    "City": "Walling"
  },
  {
    "State": "TN",
    "City": "Whitleyville"
  },
  {
    "State": "TN",
    "City": "Wilder"
  },
  {
    "State": "MS",
    "City": "Abbeville"
  },
  {
    "State": "MS",
    "City": "Arkabutla"
  },
  {
    "State": "MS",
    "City": "Ashland"
  },
  {
    "State": "MS",
    "City": "Batesville"
  },
  {
    "State": "MS",
    "City": "Marks"
  },
  {
    "State": "MS",
    "City": "Blue Mountain"
  },
  {
    "State": "MS",
    "City": "Byhalia"
  },
  {
    "State": "MS",
    "City": "Clarksdale"
  },
  {
    "State": "MS",
    "City": "Coahoma"
  },
  {
    "State": "MS",
    "City": "Coldwater"
  },
  {
    "State": "MS",
    "City": "Como"
  },
  {
    "State": "MS",
    "City": "Courtland"
  },
  {
    "State": "MS",
    "City": "Crenshaw"
  },
  {
    "State": "MS",
    "City": "Crowder"
  },
  {
    "State": "MS",
    "City": "Darling"
  },
  {
    "State": "MS",
    "City": "Dumas"
  },
  {
    "State": "MS",
    "City": "Dundee"
  },
  {
    "State": "MS",
    "City": "Etta"
  },
  {
    "State": "MS",
    "City": "Sledge"
  },
  {
    "State": "MS",
    "City": "Falkner"
  },
  {
    "State": "MS",
    "City": "Farrell"
  },
  {
    "State": "MS",
    "City": "Friars Point"
  },
  {
    "State": "MS",
    "City": "Hernando"
  },
  {
    "State": "MS",
    "City": "Hickory Flat"
  },
  {
    "State": "MS",
    "City": "Holly Springs"
  },
  {
    "State": "MS",
    "City": "Horn Lake"
  },
  {
    "State": "MS",
    "City": "Independence"
  },
  {
    "State": "MS",
    "City": "Jonestown"
  },
  {
    "State": "MS",
    "City": "Lake Cormorant"
  },
  {
    "State": "MS",
    "City": "Lamar"
  },
  {
    "State": "MS",
    "City": "Lambert"
  },
  {
    "State": "MS",
    "City": "Lula"
  },
  {
    "State": "MS",
    "City": "Lyon"
  },
  {
    "State": "MS",
    "City": "Michigan City"
  },
  {
    "State": "MS",
    "City": "Mount Pleasant"
  },
  {
    "State": "MS",
    "City": "Myrtle"
  },
  {
    "State": "MS",
    "City": "Nesbit"
  },
  {
    "State": "MS",
    "City": "New Albany"
  },
  {
    "State": "MS",
    "City": "Olive Branch"
  },
  {
    "State": "MS",
    "City": "Oxford"
  },
  {
    "State": "MS",
    "City": "Pope"
  },
  {
    "State": "MS",
    "City": "Potts Camp"
  },
  {
    "State": "MS",
    "City": "Red Banks"
  },
  {
    "State": "MS",
    "City": "Ripley"
  },
  {
    "State": "MS",
    "City": "Robinsonville"
  },
  {
    "State": "MS",
    "City": "Sarah"
  },
  {
    "State": "MS",
    "City": "Sardis"
  },
  {
    "State": "MS",
    "City": "Senatobia"
  },
  {
    "State": "MS",
    "City": "Sherard"
  },
  {
    "State": "MS",
    "City": "Southaven"
  },
  {
    "State": "MS",
    "City": "Taylor"
  },
  {
    "State": "MS",
    "City": "Tiplersville"
  },
  {
    "State": "MS",
    "City": "Memphis Stc"
  },
  {
    "State": "MS",
    "City": "Tunica"
  },
  {
    "State": "MS",
    "City": "University"
  },
  {
    "State": "MS",
    "City": "Victoria"
  },
  {
    "State": "MS",
    "City": "Walls"
  },
  {
    "State": "MS",
    "City": "Walnut"
  },
  {
    "State": "MS",
    "City": "Waterford"
  },
  {
    "State": "MS",
    "City": "Greenville"
  },
  {
    "State": "MS",
    "City": "Alligator"
  },
  {
    "State": "MS",
    "City": "Anguilla"
  },
  {
    "State": "MS",
    "City": "Arcola"
  },
  {
    "State": "MS",
    "City": "Avon"
  },
  {
    "State": "MS",
    "City": "Benoit"
  },
  {
    "State": "MS",
    "City": "Beulah"
  },
  {
    "State": "MS",
    "City": "Boyle"
  },
  {
    "State": "MS",
    "City": "Chatham"
  },
  {
    "State": "MS",
    "City": "Cleveland"
  },
  {
    "State": "MS",
    "City": "Doddsville"
  },
  {
    "State": "MS",
    "City": "Drew"
  },
  {
    "State": "MS",
    "City": "Parchman"
  },
  {
    "State": "MS",
    "City": "Dublin"
  },
  {
    "State": "MS",
    "City": "Duncan"
  },
  {
    "State": "MS",
    "City": "Glen Allan"
  },
  {
    "State": "MS",
    "City": "Grace"
  },
  {
    "State": "MS",
    "City": "Gunnison"
  },
  {
    "State": "MS",
    "City": "Hollandale"
  },
  {
    "State": "MS",
    "City": "Indianola"
  },
  {
    "State": "MS",
    "City": "Inverness"
  },
  {
    "State": "MS",
    "City": "Isola"
  },
  {
    "State": "MS",
    "City": "Leland"
  },
  {
    "State": "MS",
    "City": "Merigold"
  },
  {
    "State": "MS",
    "City": "Metcalfe"
  },
  {
    "State": "MS",
    "City": "Moorhead"
  },
  {
    "State": "MS",
    "City": "Mound Bayou"
  },
  {
    "State": "MS",
    "City": "Pace"
  },
  {
    "State": "MS",
    "City": "Panther Burn"
  },
  {
    "State": "MS",
    "City": "Rena Lara"
  },
  {
    "State": "MS",
    "City": "Rome"
  },
  {
    "State": "MS",
    "City": "Rosedale"
  },
  {
    "State": "MS",
    "City": "Ruleville"
  },
  {
    "State": "MS",
    "City": "Scott"
  },
  {
    "State": "MS",
    "City": "Shaw"
  },
  {
    "State": "MS",
    "City": "Shelby"
  },
  {
    "State": "MS",
    "City": "Stoneville"
  },
  {
    "State": "MS",
    "City": "Sunflower"
  },
  {
    "State": "MS",
    "City": "Wayside"
  },
  {
    "State": "MS",
    "City": "Winstonville"
  },
  {
    "State": "MS",
    "City": "Winterville"
  },
  {
    "State": "MS",
    "City": "Tupelo"
  },
  {
    "State": "MS",
    "City": "Algoma"
  },
  {
    "State": "MS",
    "City": "Amory"
  },
  {
    "State": "MS",
    "City": "Baldwyn"
  },
  {
    "State": "MS",
    "City": "Becker"
  },
  {
    "State": "MS",
    "City": "Belden"
  },
  {
    "State": "MS",
    "City": "Belmont"
  },
  {
    "State": "MS",
    "City": "Blue Springs"
  },
  {
    "State": "MS",
    "City": "Booneville"
  },
  {
    "State": "MS",
    "City": "Burnsville"
  },
  {
    "State": "MS",
    "City": "Corinth"
  },
  {
    "State": "MS",
    "City": "Dennis"
  },
  {
    "State": "MS",
    "City": "Derma"
  },
  {
    "State": "MS",
    "City": "Ecru"
  },
  {
    "State": "MS",
    "City": "Fulton"
  },
  {
    "State": "MS",
    "City": "Gattman"
  },
  {
    "State": "MS",
    "City": "Glen"
  },
  {
    "State": "MS",
    "City": "Golden"
  },
  {
    "State": "MS",
    "City": "Greenwood Springs"
  },
  {
    "State": "MS",
    "City": "Guntown"
  },
  {
    "State": "MS",
    "City": "Houlka"
  },
  {
    "State": "MS",
    "City": "Houston"
  },
  {
    "State": "MS",
    "City": "Iuka"
  },
  {
    "State": "MS",
    "City": "Mantachie"
  },
  {
    "State": "MS",
    "City": "Marietta"
  },
  {
    "State": "MS",
    "City": "Mooreville"
  },
  {
    "State": "MS",
    "City": "Nettleton"
  },
  {
    "State": "MS",
    "City": "New Site"
  },
  {
    "State": "MS",
    "City": "Okolona"
  },
  {
    "State": "MS",
    "City": "Plantersville"
  },
  {
    "State": "MS",
    "City": "Pontotoc"
  },
  {
    "State": "MS",
    "City": "Randolph"
  },
  {
    "State": "MS",
    "City": "Rienzi"
  },
  {
    "State": "MS",
    "City": "Saltillo"
  },
  {
    "State": "MS",
    "City": "Shannon"
  },
  {
    "State": "MS",
    "City": "Sherman"
  },
  {
    "State": "MS",
    "City": "Smithville"
  },
  {
    "State": "MS",
    "City": "Thaxton"
  },
  {
    "State": "MS",
    "City": "Tishomingo"
  },
  {
    "State": "MS",
    "City": "Toccopola"
  },
  {
    "State": "MS",
    "City": "Trebloc"
  },
  {
    "State": "MS",
    "City": "Tremont"
  },
  {
    "State": "MS",
    "City": "Van Vleet"
  },
  {
    "State": "MS",
    "City": "Vardaman"
  },
  {
    "State": "MS",
    "City": "Verona"
  },
  {
    "State": "MS",
    "City": "Wheeler"
  },
  {
    "State": "MS",
    "City": "Grenada"
  },
  {
    "State": "MS",
    "City": "Banner"
  },
  {
    "State": "MS",
    "City": "Big Creek"
  },
  {
    "State": "MS",
    "City": "Bruce"
  },
  {
    "State": "MS",
    "City": "Calhoun City"
  },
  {
    "State": "MS",
    "City": "Carrollton"
  },
  {
    "State": "MS",
    "City": "Cascilla"
  },
  {
    "State": "MS",
    "City": "Charleston"
  },
  {
    "State": "MS",
    "City": "Coffeeville"
  },
  {
    "State": "MS",
    "City": "Coila"
  },
  {
    "State": "MS",
    "City": "Cruger"
  },
  {
    "State": "MS",
    "City": "Duck Hill"
  },
  {
    "State": "MS",
    "City": "Elliott"
  },
  {
    "State": "MS",
    "City": "Enid"
  },
  {
    "State": "MS",
    "City": "Glendora"
  },
  {
    "State": "MS",
    "City": "Gore Springs"
  },
  {
    "State": "MS",
    "City": "Greenwood"
  },
  {
    "State": "MS",
    "City": "Holcomb"
  },
  {
    "State": "MS",
    "City": "Itta Bena"
  },
  {
    "State": "MS",
    "City": "Mc Carley"
  },
  {
    "State": "MS",
    "City": "Minter City"
  },
  {
    "State": "MS",
    "City": "Morgan City"
  },
  {
    "State": "MS",
    "City": "North Carrollton"
  },
  {
    "State": "MS",
    "City": "Oakland"
  },
  {
    "State": "MS",
    "City": "Paris"
  },
  {
    "State": "MS",
    "City": "Philipp"
  },
  {
    "State": "MS",
    "City": "Pittsboro"
  },
  {
    "State": "MS",
    "City": "Schlater"
  },
  {
    "State": "MS",
    "City": "Scobey"
  },
  {
    "State": "MS",
    "City": "Sidon"
  },
  {
    "State": "MS",
    "City": "Slate Spring"
  },
  {
    "State": "MS",
    "City": "Sumner"
  },
  {
    "State": "MS",
    "City": "Swan Lake"
  },
  {
    "State": "MS",
    "City": "Swiftown"
  },
  {
    "State": "MS",
    "City": "Tie Plant"
  },
  {
    "State": "MS",
    "City": "Tillatoba"
  },
  {
    "State": "MS",
    "City": "Tippo"
  },
  {
    "State": "MS",
    "City": "Tutwiler"
  },
  {
    "State": "MS",
    "City": "Vance"
  },
  {
    "State": "MS",
    "City": "Water Valley"
  },
  {
    "State": "MS",
    "City": "Webb"
  },
  {
    "State": "MS",
    "City": "Winona"
  },
  {
    "State": "MS",
    "City": "Belzoni"
  },
  {
    "State": "MS",
    "City": "Benton"
  },
  {
    "State": "MS",
    "City": "Bentonia"
  },
  {
    "State": "MS",
    "City": "Bolton"
  },
  {
    "State": "MS",
    "City": "Brandon"
  },
  {
    "State": "MS",
    "City": "Braxton"
  },
  {
    "State": "MS",
    "City": "Camden"
  },
  {
    "State": "MS",
    "City": "Canton"
  },
  {
    "State": "MS",
    "City": "Carthage"
  },
  {
    "State": "MS",
    "City": "Cary"
  },
  {
    "State": "MS",
    "City": "Clinton"
  },
  {
    "State": "MS",
    "City": "Conehatta"
  },
  {
    "State": "MS",
    "City": "Crystal Springs"
  },
  {
    "State": "MS",
    "City": "Delta City"
  },
  {
    "State": "MS",
    "City": "D LO"
  },
  {
    "State": "MS",
    "City": "Durant"
  },
  {
    "State": "MS",
    "City": "Edwards"
  },
  {
    "State": "MS",
    "City": "Ethel"
  },
  {
    "State": "MS",
    "City": "Fayette"
  },
  {
    "State": "MS",
    "City": "Flora"
  },
  {
    "State": "MS",
    "City": "Pocahontas"
  },
  {
    "State": "MS",
    "City": "Florence"
  },
  {
    "State": "MS",
    "City": "Forest"
  },
  {
    "State": "MS",
    "City": "Gallman"
  },
  {
    "State": "MS",
    "City": "Georgetown"
  },
  {
    "State": "MS",
    "City": "Goodman"
  },
  {
    "State": "MS",
    "City": "Harperville"
  },
  {
    "State": "MS",
    "City": "Harrisville"
  },
  {
    "State": "MS",
    "City": "Hazlehurst"
  },
  {
    "State": "MS",
    "City": "Hermanville"
  },
  {
    "State": "MS",
    "City": "Hillsboro"
  },
  {
    "State": "MS",
    "City": "Holly Bluff"
  },
  {
    "State": "MS",
    "City": "Kosciusko"
  },
  {
    "State": "MS",
    "City": "Lake"
  },
  {
    "State": "MS",
    "City": "Lena"
  },
  {
    "State": "MS",
    "City": "Lexington"
  },
  {
    "State": "MS",
    "City": "Lorman"
  },
  {
    "State": "MS",
    "City": "Louise"
  },
  {
    "State": "MS",
    "City": "Ludlow"
  },
  {
    "State": "MS",
    "City": "Mc Adams"
  },
  {
    "State": "MS",
    "City": "Mc Cool"
  },
  {
    "State": "MS",
    "City": "Madden"
  },
  {
    "State": "MS",
    "City": "Madison"
  },
  {
    "State": "MS",
    "City": "Magee"
  },
  {
    "State": "MS",
    "City": "Mayersville"
  },
  {
    "State": "MS",
    "City": "Mendenhall"
  },
  {
    "State": "MS",
    "City": "Midnight"
  },
  {
    "State": "MS",
    "City": "Mize"
  },
  {
    "State": "MS",
    "City": "Morton"
  },
  {
    "State": "MS",
    "City": "Mount Olive"
  },
  {
    "State": "MS",
    "City": "Natchez"
  },
  {
    "State": "MS",
    "City": "Newhebron"
  },
  {
    "State": "MS",
    "City": "Pattison"
  },
  {
    "State": "MS",
    "City": "Pelahatchie"
  },
  {
    "State": "MS",
    "City": "Pickens"
  },
  {
    "State": "MS",
    "City": "Piney Woods"
  },
  {
    "State": "MS",
    "City": "Pinola"
  },
  {
    "State": "MS",
    "City": "Port Gibson"
  },
  {
    "State": "MS",
    "City": "Puckett"
  },
  {
    "State": "MS",
    "City": "Pulaski"
  },
  {
    "State": "MS",
    "City": "Raleigh"
  },
  {
    "State": "MS",
    "City": "Raymond"
  },
  {
    "State": "MS",
    "City": "Redwood"
  },
  {
    "State": "MS",
    "City": "Ridgeland"
  },
  {
    "State": "MS",
    "City": "Rolling Fork"
  },
  {
    "State": "MS",
    "City": "Sallis"
  },
  {
    "State": "MS",
    "City": "Sandhill"
  },
  {
    "State": "MS",
    "City": "Satartia"
  },
  {
    "State": "MS",
    "City": "Sharon"
  },
  {
    "State": "MS",
    "City": "Sibley"
  },
  {
    "State": "MS",
    "City": "Silver City"
  },
  {
    "State": "MS",
    "City": "Star"
  },
  {
    "State": "MS",
    "City": "Taylorsville"
  },
  {
    "State": "MS",
    "City": "Tchula"
  },
  {
    "State": "MS",
    "City": "Terry"
  },
  {
    "State": "MS",
    "City": "Thomastown"
  },
  {
    "State": "MS",
    "City": "Tinsley"
  },
  {
    "State": "MS",
    "City": "Tougaloo"
  },
  {
    "State": "MS",
    "City": "Utica"
  },
  {
    "State": "MS",
    "City": "Vaiden"
  },
  {
    "State": "MS",
    "City": "Valley Park"
  },
  {
    "State": "MS",
    "City": "Vaughan"
  },
  {
    "State": "MS",
    "City": "Vicksburg"
  },
  {
    "State": "MS",
    "City": "Walnut Grove"
  },
  {
    "State": "MS",
    "City": "Washington"
  },
  {
    "State": "MS",
    "City": "Wesson"
  },
  {
    "State": "MS",
    "City": "West"
  },
  {
    "State": "MS",
    "City": "Whitfield"
  },
  {
    "State": "MS",
    "City": "Yazoo City"
  },
  {
    "State": "MS",
    "City": "Jackson"
  },
  {
    "State": "MS",
    "City": "Pearl"
  },
  {
    "State": "MS",
    "City": "Richland"
  },
  {
    "State": "MS",
    "City": "Flowood"
  },
  {
    "State": "MS",
    "City": "Byram"
  },
  {
    "State": "MS",
    "City": "Meridian"
  },
  {
    "State": "MS",
    "City": "Bailey"
  },
  {
    "State": "MS",
    "City": "Buckatunna"
  },
  {
    "State": "MS",
    "City": "Chunky"
  },
  {
    "State": "MS",
    "City": "Clara"
  },
  {
    "State": "MS",
    "City": "Collinsville"
  },
  {
    "State": "MS",
    "City": "Daleville"
  },
  {
    "State": "MS",
    "City": "Decatur"
  },
  {
    "State": "MS",
    "City": "De Kalb"
  },
  {
    "State": "MS",
    "City": "Enterprise"
  },
  {
    "State": "MS",
    "City": "Hickory"
  },
  {
    "State": "MS",
    "City": "Lauderdale"
  },
  {
    "State": "MS",
    "City": "Lawrence"
  },
  {
    "State": "MS",
    "City": "Little Rock"
  },
  {
    "State": "MS",
    "City": "Louin"
  },
  {
    "State": "MS",
    "City": "Louisville"
  },
  {
    "State": "MS",
    "City": "Macon"
  },
  {
    "State": "MS",
    "City": "Marion"
  },
  {
    "State": "MS",
    "City": "Newton"
  },
  {
    "State": "MS",
    "City": "Noxapater"
  },
  {
    "State": "MS",
    "City": "Pachuta"
  },
  {
    "State": "MS",
    "City": "Paulding"
  },
  {
    "State": "MS",
    "City": "Philadelphia"
  },
  {
    "State": "MS",
    "City": "Porterville"
  },
  {
    "State": "MS",
    "City": "Preston"
  },
  {
    "State": "MS",
    "City": "Quitman"
  },
  {
    "State": "MS",
    "City": "Rose Hill"
  },
  {
    "State": "MS",
    "City": "Scooba"
  },
  {
    "State": "MS",
    "City": "Sebastopol"
  },
  {
    "State": "MS",
    "City": "Shubuta"
  },
  {
    "State": "MS",
    "City": "Shuqualak"
  },
  {
    "State": "MS",
    "City": "State Line"
  },
  {
    "State": "MS",
    "City": "Stonewall"
  },
  {
    "State": "MS",
    "City": "Toomsuba"
  },
  {
    "State": "MS",
    "City": "Union"
  },
  {
    "State": "MS",
    "City": "Vossburg"
  },
  {
    "State": "MS",
    "City": "Waynesboro"
  },
  {
    "State": "MS",
    "City": "Hattiesburg"
  },
  {
    "State": "MS",
    "City": "Bassfield"
  },
  {
    "State": "MS",
    "City": "Bay Springs"
  },
  {
    "State": "MS",
    "City": "Beaumont"
  },
  {
    "State": "MS",
    "City": "Brooklyn"
  },
  {
    "State": "MS",
    "City": "Carriere"
  },
  {
    "State": "MS",
    "City": "Carson"
  },
  {
    "State": "MS",
    "City": "Collins"
  },
  {
    "State": "MS",
    "City": "Columbia"
  },
  {
    "State": "MS",
    "City": "Eastabuchie"
  },
  {
    "State": "MS",
    "City": "Ellisville"
  },
  {
    "State": "MS",
    "City": "Heidelberg"
  },
  {
    "State": "MS",
    "City": "Laurel"
  },
  {
    "State": "MS",
    "City": "Leakesville"
  },
  {
    "State": "MS",
    "City": "Lucedale"
  },
  {
    "State": "MS",
    "City": "Lumberton"
  },
  {
    "State": "MS",
    "City": "Mc Lain"
  },
  {
    "State": "MS",
    "City": "Mc Neill"
  },
  {
    "State": "MS",
    "City": "Moselle"
  },
  {
    "State": "MS",
    "City": "Moss"
  },
  {
    "State": "MS",
    "City": "Neely"
  },
  {
    "State": "MS",
    "City": "New Augusta"
  },
  {
    "State": "MS",
    "City": "Nicholson"
  },
  {
    "State": "MS",
    "City": "Ovett"
  },
  {
    "State": "MS",
    "City": "Petal"
  },
  {
    "State": "MS",
    "City": "Picayune"
  },
  {
    "State": "MS",
    "City": "Poplarville"
  },
  {
    "State": "MS",
    "City": "Prentiss"
  },
  {
    "State": "MS",
    "City": "Purvis"
  },
  {
    "State": "MS",
    "City": "Richton"
  },
  {
    "State": "MS",
    "City": "Sandersville"
  },
  {
    "State": "MS",
    "City": "Sandy Hook"
  },
  {
    "State": "MS",
    "City": "Seminary"
  },
  {
    "State": "MS",
    "City": "Soso"
  },
  {
    "State": "MS",
    "City": "Stringer"
  },
  {
    "State": "MS",
    "City": "Sumrall"
  },
  {
    "State": "MS",
    "City": "Foxworth"
  },
  {
    "State": "MS",
    "City": "Gulfport"
  },
  {
    "State": "MS",
    "City": "Bay Saint Louis"
  },
  {
    "State": "MS",
    "City": "Stennis Space Center"
  },
  {
    "State": "MS",
    "City": "Diamondhead"
  },
  {
    "State": "MS",
    "City": "Biloxi"
  },
  {
    "State": "MS",
    "City": "Diberville"
  },
  {
    "State": "MS",
    "City": "Escatawpa"
  },
  {
    "State": "MS",
    "City": "Gautier"
  },
  {
    "State": "MS",
    "City": "Hurley"
  },
  {
    "State": "MS",
    "City": "Kiln"
  },
  {
    "State": "MS",
    "City": "Lakeshore"
  },
  {
    "State": "MS",
    "City": "Long Beach"
  },
  {
    "State": "MS",
    "City": "Mc Henry"
  },
  {
    "State": "MS",
    "City": "Moss Point"
  },
  {
    "State": "MS",
    "City": "Ocean Springs"
  },
  {
    "State": "MS",
    "City": "Vancleave"
  },
  {
    "State": "MS",
    "City": "Pascagoula"
  },
  {
    "State": "MS",
    "City": "Pass Christian"
  },
  {
    "State": "MS",
    "City": "Pearlington"
  },
  {
    "State": "MS",
    "City": "Perkinston"
  },
  {
    "State": "MS",
    "City": "Saucier"
  },
  {
    "State": "MS",
    "City": "Waveland"
  },
  {
    "State": "MS",
    "City": "Wiggins"
  },
  {
    "State": "MS",
    "City": "Brookhaven"
  },
  {
    "State": "MS",
    "City": "Bogue Chitto"
  },
  {
    "State": "MS",
    "City": "Bude"
  },
  {
    "State": "MS",
    "City": "Centreville"
  },
  {
    "State": "MS",
    "City": "Chatawa"
  },
  {
    "State": "MS",
    "City": "Crosby"
  },
  {
    "State": "MS",
    "City": "Fernwood"
  },
  {
    "State": "MS",
    "City": "Gloster"
  },
  {
    "State": "MS",
    "City": "Jayess"
  },
  {
    "State": "MS",
    "City": "Kokomo"
  },
  {
    "State": "MS",
    "City": "Liberty"
  },
  {
    "State": "MS",
    "City": "Mc Call Creek"
  },
  {
    "State": "MS",
    "City": "Mccomb"
  },
  {
    "State": "MS",
    "City": "Magnolia"
  },
  {
    "State": "MS",
    "City": "Meadville"
  },
  {
    "State": "MS",
    "City": "Monticello"
  },
  {
    "State": "MS",
    "City": "Oak Vale"
  },
  {
    "State": "MS",
    "City": "Osyka"
  },
  {
    "State": "MS",
    "City": "Roxie"
  },
  {
    "State": "MS",
    "City": "Ruth"
  },
  {
    "State": "MS",
    "City": "Silver Creek"
  },
  {
    "State": "MS",
    "City": "Smithdale"
  },
  {
    "State": "MS",
    "City": "Sontag"
  },
  {
    "State": "MS",
    "City": "Summit"
  },
  {
    "State": "MS",
    "City": "Tylertown"
  },
  {
    "State": "MS",
    "City": "Union Church"
  },
  {
    "State": "MS",
    "City": "Woodville"
  },
  {
    "State": "MS",
    "City": "Columbus"
  },
  {
    "State": "MS",
    "City": "Aberdeen"
  },
  {
    "State": "MS",
    "City": "Ackerman"
  },
  {
    "State": "MS",
    "City": "Artesia"
  },
  {
    "State": "MS",
    "City": "Bellefontaine"
  },
  {
    "State": "MS",
    "City": "Brooksville"
  },
  {
    "State": "MS",
    "City": "Caledonia"
  },
  {
    "State": "MS",
    "City": "Cedarbluff"
  },
  {
    "State": "MS",
    "City": "Crawford"
  },
  {
    "State": "MS",
    "City": "Eupora"
  },
  {
    "State": "MS",
    "City": "French Camp"
  },
  {
    "State": "MS",
    "City": "Hamilton"
  },
  {
    "State": "MS",
    "City": "Kilmichael"
  },
  {
    "State": "MS",
    "City": "Maben"
  },
  {
    "State": "MS",
    "City": "Mantee"
  },
  {
    "State": "MS",
    "City": "Mathiston"
  },
  {
    "State": "MS",
    "City": "Mayhew"
  },
  {
    "State": "MS",
    "City": "Montpelier"
  },
  {
    "State": "MS",
    "City": "Pheba"
  },
  {
    "State": "MS",
    "City": "Prairie"
  },
  {
    "State": "MS",
    "City": "Starkville"
  },
  {
    "State": "MS",
    "City": "Mississippi State"
  },
  {
    "State": "MS",
    "City": "Steens"
  },
  {
    "State": "MS",
    "City": "Stewart"
  },
  {
    "State": "MS",
    "City": "Sturgis"
  },
  {
    "State": "MS",
    "City": "Walthall"
  },
  {
    "State": "MS",
    "City": "Weir"
  },
  {
    "State": "MS",
    "City": "West Point"
  },
  {
    "State": "MS",
    "City": "Woodland"
  },
  {
    "State": "GA",
    "City": "Arlington"
  },
  {
    "State": "GA",
    "City": "Attapulgus"
  },
  {
    "State": "GA",
    "City": "Bainbridge"
  },
  {
    "State": "GA",
    "City": "Blakely"
  },
  {
    "State": "GA",
    "City": "Bluffton"
  },
  {
    "State": "GA",
    "City": "Brinson"
  },
  {
    "State": "GA",
    "City": "Bronwood"
  },
  {
    "State": "GA",
    "City": "Cairo"
  },
  {
    "State": "GA",
    "City": "Calvary"
  },
  {
    "State": "GA",
    "City": "Cedar Springs"
  },
  {
    "State": "GA",
    "City": "Climax"
  },
  {
    "State": "GA",
    "City": "Coleman"
  },
  {
    "State": "GA",
    "City": "Colquitt"
  },
  {
    "State": "GA",
    "City": "Cuthbert"
  },
  {
    "State": "GA",
    "City": "Damascus"
  },
  {
    "State": "GA",
    "City": "Dawson"
  },
  {
    "State": "GA",
    "City": "Donalsonville"
  },
  {
    "State": "GA",
    "City": "Edison"
  },
  {
    "State": "GA",
    "City": "Fort Gaines"
  },
  {
    "State": "GA",
    "City": "Fowlstown"
  },
  {
    "State": "GA",
    "City": "Georgetown"
  },
  {
    "State": "GA",
    "City": "Iron City"
  },
  {
    "State": "GA",
    "City": "Jakin"
  },
  {
    "State": "GA",
    "City": "Leary"
  },
  {
    "State": "GA",
    "City": "Morgan"
  },
  {
    "State": "GA",
    "City": "Morris"
  },
  {
    "State": "GA",
    "City": "Newton"
  },
  {
    "State": "GA",
    "City": "Parrott"
  },
  {
    "State": "GA",
    "City": "Sasser"
  },
  {
    "State": "GA",
    "City": "Shellman"
  },
  {
    "State": "GA",
    "City": "Whigham"
  },
  {
    "State": "KY",
    "City": "Bagdad"
  },
  {
    "State": "KY",
    "City": "Bardstown"
  },
  {
    "State": "KY",
    "City": "Bedford"
  },
  {
    "State": "KY",
    "City": "Bethlehem"
  },
  {
    "State": "KY",
    "City": "Bloomfield"
  },
  {
    "State": "KY",
    "City": "Bradfordsville"
  },
  {
    "State": "KY",
    "City": "Buckner"
  },
  {
    "State": "KY",
    "City": "Campbellsburg"
  },
  {
    "State": "KY",
    "City": "Chaplin"
  },
  {
    "State": "KY",
    "City": "Coxs Creek"
  },
  {
    "State": "KY",
    "City": "Crestwood"
  },
  {
    "State": "KY",
    "City": "Eastwood"
  },
  {
    "State": "KY",
    "City": "Eminence"
  },
  {
    "State": "KY",
    "City": "Fairfield"
  },
  {
    "State": "KY",
    "City": "Finchville"
  },
  {
    "State": "KY",
    "City": "Fisherville"
  },
  {
    "State": "KY",
    "City": "Glenview"
  },
  {
    "State": "KY",
    "City": "Goshen"
  },
  {
    "State": "KY",
    "City": "Harrods Creek"
  },
  {
    "State": "KY",
    "City": "La Grange"
  },
  {
    "State": "KY",
    "City": "Lebanon"
  },
  {
    "State": "KY",
    "City": "Lockport"
  },
  {
    "State": "KY",
    "City": "Loretto"
  },
  {
    "State": "KY",
    "City": "Mackville"
  },
  {
    "State": "KY",
    "City": "Masonic Home"
  },
  {
    "State": "KY",
    "City": "Milton"
  },
  {
    "State": "KY",
    "City": "Mount Eden"
  },
  {
    "State": "KY",
    "City": "Mount Washington"
  },
  {
    "State": "KY",
    "City": "Nazareth"
  },
  {
    "State": "KY",
    "City": "Nerinx"
  },
  {
    "State": "KY",
    "City": "New Castle"
  },
  {
    "State": "KY",
    "City": "New Haven"
  },
  {
    "State": "KY",
    "City": "New Hope"
  },
  {
    "State": "KY",
    "City": "Pendleton"
  },
  {
    "State": "KY",
    "City": "Pewee Valley"
  },
  {
    "State": "KY",
    "City": "Pleasureville"
  },
  {
    "State": "KY",
    "City": "Port Royal"
  },
  {
    "State": "KY",
    "City": "Prospect"
  },
  {
    "State": "KY",
    "City": "Raywick"
  },
  {
    "State": "KY",
    "City": "Saint Catharine"
  },
  {
    "State": "KY",
    "City": "Saint Francis"
  },
  {
    "State": "KY",
    "City": "Saint Mary"
  },
  {
    "State": "KY",
    "City": "Shelbyville"
  },
  {
    "State": "KY",
    "City": "Simpsonville"
  },
  {
    "State": "KY",
    "City": "Smithfield"
  },
  {
    "State": "KY",
    "City": "Springfield"
  },
  {
    "State": "KY",
    "City": "Sulphur"
  },
  {
    "State": "KY",
    "City": "Taylorsville"
  },
  {
    "State": "KY",
    "City": "Turners Station"
  },
  {
    "State": "KY",
    "City": "Waddy"
  },
  {
    "State": "KY",
    "City": "Westport"
  },
  {
    "State": "KY",
    "City": "Willisburg"
  },
  {
    "State": "KY",
    "City": "Battletown"
  },
  {
    "State": "KY",
    "City": "Boston"
  },
  {
    "State": "KY",
    "City": "Brandenburg"
  },
  {
    "State": "KY",
    "City": "Brooks"
  },
  {
    "State": "KY",
    "City": "Clermont"
  },
  {
    "State": "KY",
    "City": "Cloverport"
  },
  {
    "State": "KY",
    "City": "Custer"
  },
  {
    "State": "KY",
    "City": "Ekron"
  },
  {
    "State": "KY",
    "City": "Fairdale"
  },
  {
    "State": "KY",
    "City": "Falls Of Rough"
  },
  {
    "State": "KY",
    "City": "Fort Knox"
  },
  {
    "State": "KY",
    "City": "Hillview"
  },
  {
    "State": "KY",
    "City": "Garfield"
  },
  {
    "State": "KY",
    "City": "Guston"
  },
  {
    "State": "KY",
    "City": "Hardinsburg"
  },
  {
    "State": "KY",
    "City": "Harned"
  },
  {
    "State": "KY",
    "City": "Hudson"
  },
  {
    "State": "KY",
    "City": "Irvington"
  },
  {
    "State": "KY",
    "City": "Lebanon Junction"
  },
  {
    "State": "KY",
    "City": "Mc Daniels"
  },
  {
    "State": "KY",
    "City": "Mc Quady"
  },
  {
    "State": "KY",
    "City": "Muldraugh"
  },
  {
    "State": "KY",
    "City": "Payneville"
  },
  {
    "State": "KY",
    "City": "Radcliff"
  },
  {
    "State": "KY",
    "City": "Rhodelia"
  },
  {
    "State": "KY",
    "City": "Rineyville"
  },
  {
    "State": "KY",
    "City": "Shepherdsville"
  },
  {
    "State": "KY",
    "City": "Stephensport"
  },
  {
    "State": "KY",
    "City": "Union Star"
  },
  {
    "State": "KY",
    "City": "Vine Grove"
  },
  {
    "State": "KY",
    "City": "Webster"
  },
  {
    "State": "KY",
    "City": "West Point"
  },
  {
    "State": "KY",
    "City": "Westview"
  },
  {
    "State": "KY",
    "City": "Louisville"
  },
  {
    "State": "KY",
    "City": "Burgin"
  },
  {
    "State": "KY",
    "City": "Carlisle"
  },
  {
    "State": "KY",
    "City": "Clay City"
  },
  {
    "State": "KY",
    "City": "Clearfield"
  },
  {
    "State": "KY",
    "City": "Denniston"
  },
  {
    "State": "KY",
    "City": "Elliottville"
  },
  {
    "State": "KY",
    "City": "Farmers"
  },
  {
    "State": "KY",
    "City": "Frenchburg"
  },
  {
    "State": "KY",
    "City": "Georgetown"
  },
  {
    "State": "KY",
    "City": "Gravel Switch"
  },
  {
    "State": "KY",
    "City": "Harrodsburg"
  },
  {
    "State": "KY",
    "City": "Hope"
  },
  {
    "State": "KY",
    "City": "Irvine"
  },
  {
    "State": "KY",
    "City": "Jeffersonville"
  },
  {
    "State": "KY",
    "City": "Keene"
  },
  {
    "State": "KY",
    "City": "Nicholasville"
  },
  {
    "State": "KY",
    "City": "Lawrenceburg"
  },
  {
    "State": "KY",
    "City": "Means"
  },
  {
    "State": "KY",
    "City": "Midway"
  },
  {
    "State": "KY",
    "City": "Millersburg"
  },
  {
    "State": "KY",
    "City": "Moorefield"
  },
  {
    "State": "KY",
    "City": "Morehead"
  },
  {
    "State": "KY",
    "City": "Mount Sterling"
  },
  {
    "State": "KY",
    "City": "New Liberty"
  },
  {
    "State": "KY",
    "City": "North Middletown"
  },
  {
    "State": "KY",
    "City": "Olympia"
  },
  {
    "State": "KY",
    "City": "Owenton"
  },
  {
    "State": "KY",
    "City": "Owingsville"
  },
  {
    "State": "KY",
    "City": "Paris"
  },
  {
    "State": "KY",
    "City": "Perry Park"
  },
  {
    "State": "KY",
    "City": "Preston"
  },
  {
    "State": "KY",
    "City": "Sadieville"
  },
  {
    "State": "KY",
    "City": "Salt Lick"
  },
  {
    "State": "KY",
    "City": "Salvisa"
  },
  {
    "State": "KY",
    "City": "Sharpsburg"
  },
  {
    "State": "KY",
    "City": "Slade"
  },
  {
    "State": "KY",
    "City": "Stamping Ground"
  },
  {
    "State": "KY",
    "City": "Stanton"
  },
  {
    "State": "KY",
    "City": "Versailles"
  },
  {
    "State": "KY",
    "City": "Waco"
  },
  {
    "State": "KY",
    "City": "Wellington"
  },
  {
    "State": "KY",
    "City": "Wilmore"
  },
  {
    "State": "KY",
    "City": "Winchester"
  },
  {
    "State": "KY",
    "City": "Annville"
  },
  {
    "State": "KY",
    "City": "Berea"
  },
  {
    "State": "KY",
    "City": "Bighill"
  },
  {
    "State": "KY",
    "City": "Brodhead"
  },
  {
    "State": "KY",
    "City": "Bryantsville"
  },
  {
    "State": "KY",
    "City": "Crab Orchard"
  },
  {
    "State": "KY",
    "City": "Danville"
  },
  {
    "State": "KY",
    "City": "Gray Hawk"
  },
  {
    "State": "KY",
    "City": "Hustonville"
  },
  {
    "State": "KY",
    "City": "Junction City"
  },
  {
    "State": "KY",
    "City": "Kings Mountain"
  },
  {
    "State": "KY",
    "City": "Lancaster"
  },
  {
    "State": "KY",
    "City": "Livingston"
  },
  {
    "State": "KY",
    "City": "Mc Kee"
  },
  {
    "State": "KY",
    "City": "Mc Kinney"
  },
  {
    "State": "KY",
    "City": "Mitchellsburg"
  },
  {
    "State": "KY",
    "City": "Mount Vernon"
  },
  {
    "State": "KY",
    "City": "Orlando"
  },
  {
    "State": "KY",
    "City": "Paint Lick"
  },
  {
    "State": "KY",
    "City": "Parksville"
  },
  {
    "State": "KY",
    "City": "Perryville"
  },
  {
    "State": "KY",
    "City": "Ravenna"
  },
  {
    "State": "KY",
    "City": "Renfro Valley"
  },
  {
    "State": "KY",
    "City": "Richmond"
  },
  {
    "State": "KY",
    "City": "Sandgap"
  },
  {
    "State": "KY",
    "City": "Stanford"
  },
  {
    "State": "KY",
    "City": "Tyner"
  },
  {
    "State": "KY",
    "City": "Waneta"
  },
  {
    "State": "KY",
    "City": "Waynesburg"
  },
  {
    "State": "KY",
    "City": "Wildie"
  },
  {
    "State": "KY",
    "City": "Winston"
  },
  {
    "State": "KY",
    "City": "Lexington"
  },
  {
    "State": "KY",
    "City": "Frankfort"
  },
  {
    "State": "KY",
    "City": "Corbin"
  },
  {
    "State": "KY",
    "City": "Bush"
  },
  {
    "State": "KY",
    "City": "East Bernstadt"
  },
  {
    "State": "KY",
    "City": "Emlyn"
  },
  {
    "State": "KY",
    "City": "Gray"
  },
  {
    "State": "KY",
    "City": "Keavy"
  },
  {
    "State": "KY",
    "City": "Lily"
  },
  {
    "State": "KY",
    "City": "London"
  },
  {
    "State": "KY",
    "City": "Nevisdale"
  },
  {
    "State": "KY",
    "City": "Pittsburg"
  },
  {
    "State": "KY",
    "City": "Rockholds"
  },
  {
    "State": "KY",
    "City": "Siler"
  },
  {
    "State": "KY",
    "City": "Williamsburg"
  },
  {
    "State": "KY",
    "City": "Woodbine"
  },
  {
    "State": "KY",
    "City": "Ages Brookside"
  },
  {
    "State": "KY",
    "City": "Asher"
  },
  {
    "State": "KY",
    "City": "Baxter"
  },
  {
    "State": "KY",
    "City": "Benham"
  },
  {
    "State": "KY",
    "City": "Big Laurel"
  },
  {
    "State": "KY",
    "City": "Bledsoe"
  },
  {
    "State": "KY",
    "City": "Calvin"
  },
  {
    "State": "KY",
    "City": "Cawood"
  },
  {
    "State": "KY",
    "City": "Chappell"
  },
  {
    "State": "KY",
    "City": "Coalgood"
  },
  {
    "State": "KY",
    "City": "Coldiron"
  },
  {
    "State": "KY",
    "City": "Cranks"
  },
  {
    "State": "KY",
    "City": "Cumberland"
  },
  {
    "State": "KY",
    "City": "Dayhoit"
  },
  {
    "State": "KY",
    "City": "Eolia"
  },
  {
    "State": "KY",
    "City": "Essie"
  },
  {
    "State": "KY",
    "City": "Evarts"
  },
  {
    "State": "KY",
    "City": "Grays Knob"
  },
  {
    "State": "KY",
    "City": "Gulston"
  },
  {
    "State": "KY",
    "City": "Harlan"
  },
  {
    "State": "KY",
    "City": "Helton"
  },
  {
    "State": "KY",
    "City": "Holmes Mill"
  },
  {
    "State": "KY",
    "City": "Hoskinston"
  },
  {
    "State": "KY",
    "City": "Hulen"
  },
  {
    "State": "KY",
    "City": "Kenvir"
  },
  {
    "State": "KY",
    "City": "Lejunior"
  },
  {
    "State": "KY",
    "City": "Loyall"
  },
  {
    "State": "KY",
    "City": "Lynch"
  },
  {
    "State": "KY",
    "City": "Miracle"
  },
  {
    "State": "KY",
    "City": "Mozelle"
  },
  {
    "State": "KY",
    "City": "Partridge"
  },
  {
    "State": "KY",
    "City": "Pathfork"
  },
  {
    "State": "KY",
    "City": "Putney"
  },
  {
    "State": "KY",
    "City": "Stinnett"
  },
  {
    "State": "KY",
    "City": "Totz"
  },
  {
    "State": "KY",
    "City": "Wallins Creek"
  },
  {
    "State": "KY",
    "City": "Warbranch"
  },
  {
    "State": "KY",
    "City": "Arjay"
  },
  {
    "State": "KY",
    "City": "Artemus"
  },
  {
    "State": "KY",
    "City": "Barbourville"
  },
  {
    "State": "KY",
    "City": "Beverly"
  },
  {
    "State": "KY",
    "City": "Big Creek"
  },
  {
    "State": "KY",
    "City": "Bimble"
  },
  {
    "State": "KY",
    "City": "Bryants Store"
  },
  {
    "State": "KY",
    "City": "Cannon"
  },
  {
    "State": "KY",
    "City": "Closplint"
  },
  {
    "State": "KY",
    "City": "Dewitt"
  },
  {
    "State": "KY",
    "City": "Eriline"
  },
  {
    "State": "KY",
    "City": "Fall Rock"
  },
  {
    "State": "KY",
    "City": "Flat Lick"
  },
  {
    "State": "KY",
    "City": "Fourmile"
  },
  {
    "State": "KY",
    "City": "Frakes"
  },
  {
    "State": "KY",
    "City": "Garrard"
  },
  {
    "State": "KY",
    "City": "Girdler"
  },
  {
    "State": "KY",
    "City": "Goose Rock"
  },
  {
    "State": "KY",
    "City": "Green Road"
  },
  {
    "State": "KY",
    "City": "Heidrick"
  },
  {
    "State": "KY",
    "City": "Hima"
  },
  {
    "State": "KY",
    "City": "Hinkle"
  },
  {
    "State": "KY",
    "City": "Ingram"
  },
  {
    "State": "KY",
    "City": "Kettle Island"
  },
  {
    "State": "KY",
    "City": "Manchester"
  },
  {
    "State": "KY",
    "City": "Mary Alice"
  },
  {
    "State": "KY",
    "City": "Middlesboro"
  },
  {
    "State": "KY",
    "City": "Oneida"
  },
  {
    "State": "KY",
    "City": "Pineville"
  },
  {
    "State": "KY",
    "City": "Roark"
  },
  {
    "State": "KY",
    "City": "Saul"
  },
  {
    "State": "KY",
    "City": "Scalf"
  },
  {
    "State": "KY",
    "City": "Sextons Creek"
  },
  {
    "State": "KY",
    "City": "Stoney Fork"
  },
  {
    "State": "KY",
    "City": "Trosper"
  },
  {
    "State": "KY",
    "City": "Walker"
  },
  {
    "State": "KY",
    "City": "Woollum"
  },
  {
    "State": "KY",
    "City": "Alexandria"
  },
  {
    "State": "KY",
    "City": "Augusta"
  },
  {
    "State": "KY",
    "City": "Berry"
  },
  {
    "State": "KY",
    "City": "Brooksville"
  },
  {
    "State": "KY",
    "City": "Burlington"
  },
  {
    "State": "KY",
    "City": "Butler"
  },
  {
    "State": "KY",
    "City": "California"
  },
  {
    "State": "KY",
    "City": "Carrollton"
  },
  {
    "State": "KY",
    "City": "Corinth"
  },
  {
    "State": "KY",
    "City": "Covington"
  },
  {
    "State": "KY",
    "City": "Latonia"
  },
  {
    "State": "KY",
    "City": "Ft Mitchell"
  },
  {
    "State": "KY",
    "City": "Erlanger"
  },
  {
    "State": "KY",
    "City": "Hebron"
  },
  {
    "State": "KY",
    "City": "Florence"
  },
  {
    "State": "KY",
    "City": "Crittenden"
  },
  {
    "State": "KY",
    "City": "Cynthiana"
  },
  {
    "State": "KY",
    "City": "De Mossville"
  },
  {
    "State": "KY",
    "City": "Dover"
  },
  {
    "State": "KY",
    "City": "Dry Ridge"
  },
  {
    "State": "KY",
    "City": "Elizaville"
  },
  {
    "State": "KY",
    "City": "Ewing"
  },
  {
    "State": "KY",
    "City": "Falmouth"
  },
  {
    "State": "KY",
    "City": "Flemingsburg"
  },
  {
    "State": "KY",
    "City": "Foster"
  },
  {
    "State": "KY",
    "City": "Germantown"
  },
  {
    "State": "KY",
    "City": "Ghent"
  },
  {
    "State": "KY",
    "City": "Glencoe"
  },
  {
    "State": "KY",
    "City": "Hillsboro"
  },
  {
    "State": "KY",
    "City": "Independence"
  },
  {
    "State": "KY",
    "City": "Jonesville"
  },
  {
    "State": "KY",
    "City": "Kenton"
  },
  {
    "State": "KY",
    "City": "Mason"
  },
  {
    "State": "KY",
    "City": "Mayslick"
  },
  {
    "State": "KY",
    "City": "Maysville"
  },
  {
    "State": "KY",
    "City": "Melbourne"
  },
  {
    "State": "KY",
    "City": "Milford"
  },
  {
    "State": "KY",
    "City": "Minerva"
  },
  {
    "State": "KY",
    "City": "Morning View"
  },
  {
    "State": "KY",
    "City": "Mount Olivet"
  },
  {
    "State": "KY",
    "City": "Muses Mills"
  },
  {
    "State": "KY",
    "City": "Newport"
  },
  {
    "State": "KY",
    "City": "Bellevue"
  },
  {
    "State": "KY",
    "City": "Dayton"
  },
  {
    "State": "KY",
    "City": "Fort Thomas"
  },
  {
    "State": "KY",
    "City": "Petersburg"
  },
  {
    "State": "KY",
    "City": "Plummers Landing"
  },
  {
    "State": "KY",
    "City": "Sanders"
  },
  {
    "State": "KY",
    "City": "Silver Grove"
  },
  {
    "State": "KY",
    "City": "Sparta"
  },
  {
    "State": "KY",
    "City": "Union"
  },
  {
    "State": "KY",
    "City": "Verona"
  },
  {
    "State": "KY",
    "City": "Wallingford"
  },
  {
    "State": "KY",
    "City": "Walton"
  },
  {
    "State": "KY",
    "City": "Warsaw"
  },
  {
    "State": "KY",
    "City": "Washington"
  },
  {
    "State": "KY",
    "City": "Williamstown"
  },
  {
    "State": "KY",
    "City": "Worthville"
  },
  {
    "State": "KY",
    "City": "Ashland"
  },
  {
    "State": "KY",
    "City": "Argillite"
  },
  {
    "State": "KY",
    "City": "Blaine"
  },
  {
    "State": "KY",
    "City": "Carter"
  },
  {
    "State": "KY",
    "City": "Catlettsburg"
  },
  {
    "State": "KY",
    "City": "Denton"
  },
  {
    "State": "KY",
    "City": "Emerson"
  },
  {
    "State": "KY",
    "City": "Flatwoods"
  },
  {
    "State": "KY",
    "City": "Garrison"
  },
  {
    "State": "KY",
    "City": "Grahn"
  },
  {
    "State": "KY",
    "City": "Grayson"
  },
  {
    "State": "KY",
    "City": "Greenup"
  },
  {
    "State": "KY",
    "City": "Hitchins"
  },
  {
    "State": "KY",
    "City": "Isonville"
  },
  {
    "State": "KY",
    "City": "Martha"
  },
  {
    "State": "KY",
    "City": "Mazie"
  },
  {
    "State": "KY",
    "City": "Olive Hill"
  },
  {
    "State": "KY",
    "City": "Quincy"
  },
  {
    "State": "KY",
    "City": "Rush"
  },
  {
    "State": "KY",
    "City": "Russell"
  },
  {
    "State": "KY",
    "City": "Sandy Hook"
  },
  {
    "State": "KY",
    "City": "Soldier"
  },
  {
    "State": "KY",
    "City": "South Portsmouth"
  },
  {
    "State": "KY",
    "City": "South Shore"
  },
  {
    "State": "KY",
    "City": "Vanceburg"
  },
  {
    "State": "KY",
    "City": "Webbville"
  },
  {
    "State": "KY",
    "City": "Willard"
  },
  {
    "State": "KY",
    "City": "Worthington"
  },
  {
    "State": "KY",
    "City": "Tollesboro"
  },
  {
    "State": "KY",
    "City": "Adams"
  },
  {
    "State": "KY",
    "City": "Beauty"
  },
  {
    "State": "KY",
    "City": "Boons Camp"
  },
  {
    "State": "KY",
    "City": "Debord"
  },
  {
    "State": "KY",
    "City": "East Point"
  },
  {
    "State": "KY",
    "City": "Flatgap"
  },
  {
    "State": "KY",
    "City": "Hagerhill"
  },
  {
    "State": "KY",
    "City": "Inez"
  },
  {
    "State": "KY",
    "City": "Keaton"
  },
  {
    "State": "KY",
    "City": "Louisa"
  },
  {
    "State": "KY",
    "City": "Lovely"
  },
  {
    "State": "KY",
    "City": "Lowmansville"
  },
  {
    "State": "KY",
    "City": "Meally"
  },
  {
    "State": "KY",
    "City": "Oil Springs"
  },
  {
    "State": "KY",
    "City": "Paintsville"
  },
  {
    "State": "KY",
    "City": "Pilgrim"
  },
  {
    "State": "KY",
    "City": "River"
  },
  {
    "State": "KY",
    "City": "Sitka"
  },
  {
    "State": "KY",
    "City": "Staffordsville"
  },
  {
    "State": "KY",
    "City": "Stambaugh"
  },
  {
    "State": "KY",
    "City": "Thelma"
  },
  {
    "State": "KY",
    "City": "Tomahawk"
  },
  {
    "State": "KY",
    "City": "Tutor Key"
  },
  {
    "State": "KY",
    "City": "Ulysses"
  },
  {
    "State": "KY",
    "City": "Van Lear"
  },
  {
    "State": "KY",
    "City": "Warfield"
  },
  {
    "State": "KY",
    "City": "West Van Lear"
  },
  {
    "State": "KY",
    "City": "Williamsport"
  },
  {
    "State": "KY",
    "City": "Wittensville"
  },
  {
    "State": "KY",
    "City": "Campton"
  },
  {
    "State": "KY",
    "City": "Athol"
  },
  {
    "State": "KY",
    "City": "Bays"
  },
  {
    "State": "KY",
    "City": "Beattyville"
  },
  {
    "State": "KY",
    "City": "Bethany"
  },
  {
    "State": "KY",
    "City": "Booneville"
  },
  {
    "State": "KY",
    "City": "Clayhole"
  },
  {
    "State": "KY",
    "City": "Hazel Green"
  },
  {
    "State": "KY",
    "City": "Heidelberg"
  },
  {
    "State": "KY",
    "City": "Island City"
  },
  {
    "State": "KY",
    "City": "Jackson"
  },
  {
    "State": "KY",
    "City": "Lone"
  },
  {
    "State": "KY",
    "City": "Lost Creek"
  },
  {
    "State": "KY",
    "City": "Mistletoe"
  },
  {
    "State": "KY",
    "City": "Mize"
  },
  {
    "State": "KY",
    "City": "Pine Ridge"
  },
  {
    "State": "KY",
    "City": "Primrose"
  },
  {
    "State": "KY",
    "City": "Ricetown"
  },
  {
    "State": "KY",
    "City": "Rogers"
  },
  {
    "State": "KY",
    "City": "Rousseau"
  },
  {
    "State": "KY",
    "City": "Rowdy"
  },
  {
    "State": "KY",
    "City": "Saint Helens"
  },
  {
    "State": "KY",
    "City": "Vancleve"
  },
  {
    "State": "KY",
    "City": "Vincent"
  },
  {
    "State": "KY",
    "City": "Whick"
  },
  {
    "State": "KY",
    "City": "Zoe"
  },
  {
    "State": "KY",
    "City": "Cannel City"
  },
  {
    "State": "KY",
    "City": "Crockett"
  },
  {
    "State": "KY",
    "City": "Elkfork"
  },
  {
    "State": "KY",
    "City": "Ezel"
  },
  {
    "State": "KY",
    "City": "Falcon"
  },
  {
    "State": "KY",
    "City": "Gapville"
  },
  {
    "State": "KY",
    "City": "Malone"
  },
  {
    "State": "KY",
    "City": "Ophir"
  },
  {
    "State": "KY",
    "City": "Royalton"
  },
  {
    "State": "KY",
    "City": "Salyersville"
  },
  {
    "State": "KY",
    "City": "West Liberty"
  },
  {
    "State": "KY",
    "City": "Wrigley"
  },
  {
    "State": "KY",
    "City": "Pikeville"
  },
  {
    "State": "KY",
    "City": "South Williamson"
  },
  {
    "State": "KY",
    "City": "Ashcamp"
  },
  {
    "State": "KY",
    "City": "Belcher"
  },
  {
    "State": "KY",
    "City": "Belfry"
  },
  {
    "State": "KY",
    "City": "Burdine"
  },
  {
    "State": "KY",
    "City": "Canada"
  },
  {
    "State": "KY",
    "City": "Dorton"
  },
  {
    "State": "KY",
    "City": "Elkhorn City"
  },
  {
    "State": "KY",
    "City": "Fedscreek"
  },
  {
    "State": "KY",
    "City": "Fords Branch"
  },
  {
    "State": "KY",
    "City": "Forest Hills"
  },
  {
    "State": "KY",
    "City": "Freeburn"
  },
  {
    "State": "KY",
    "City": "Hardy"
  },
  {
    "State": "KY",
    "City": "Hellier"
  },
  {
    "State": "KY",
    "City": "Huddy"
  },
  {
    "State": "KY",
    "City": "Jenkins"
  },
  {
    "State": "KY",
    "City": "Jonancy"
  },
  {
    "State": "KY",
    "City": "Kimper"
  },
  {
    "State": "KY",
    "City": "Lick Creek"
  },
  {
    "State": "KY",
    "City": "Lookout"
  },
  {
    "State": "KY",
    "City": "Mc Andrews"
  },
  {
    "State": "KY",
    "City": "Mc Carr"
  },
  {
    "State": "KY",
    "City": "Majestic"
  },
  {
    "State": "KY",
    "City": "Mouthcard"
  },
  {
    "State": "KY",
    "City": "Myra"
  },
  {
    "State": "KY",
    "City": "Phelps"
  },
  {
    "State": "KY",
    "City": "Phyllis"
  },
  {
    "State": "KY",
    "City": "Pinsonfork"
  },
  {
    "State": "KY",
    "City": "Raccoon"
  },
  {
    "State": "KY",
    "City": "Ransom"
  },
  {
    "State": "KY",
    "City": "Regina"
  },
  {
    "State": "KY",
    "City": "Robinson Creek"
  },
  {
    "State": "KY",
    "City": "Rockhouse"
  },
  {
    "State": "KY",
    "City": "Shelbiana"
  },
  {
    "State": "KY",
    "City": "Shelby Gap"
  },
  {
    "State": "KY",
    "City": "Sidney"
  },
  {
    "State": "KY",
    "City": "Steele"
  },
  {
    "State": "KY",
    "City": "Stone"
  },
  {
    "State": "KY",
    "City": "Stopover"
  },
  {
    "State": "KY",
    "City": "Varney"
  },
  {
    "State": "KY",
    "City": "Virgie"
  },
  {
    "State": "KY",
    "City": "Allen"
  },
  {
    "State": "KY",
    "City": "Auxier"
  },
  {
    "State": "KY",
    "City": "Banner"
  },
  {
    "State": "KY",
    "City": "Beaver"
  },
  {
    "State": "KY",
    "City": "Betsy Layne"
  },
  {
    "State": "KY",
    "City": "Bevinsville"
  },
  {
    "State": "KY",
    "City": "Blue River"
  },
  {
    "State": "KY",
    "City": "Bypro"
  },
  {
    "State": "KY",
    "City": "Dana"
  },
  {
    "State": "KY",
    "City": "David"
  },
  {
    "State": "KY",
    "City": "Drift"
  },
  {
    "State": "KY",
    "City": "Dwale"
  },
  {
    "State": "KY",
    "City": "Eastern"
  },
  {
    "State": "KY",
    "City": "Garrett"
  },
  {
    "State": "KY",
    "City": "Grethel"
  },
  {
    "State": "KY",
    "City": "Gunlock"
  },
  {
    "State": "KY",
    "City": "Harold"
  },
  {
    "State": "KY",
    "City": "Hi Hat"
  },
  {
    "State": "KY",
    "City": "Hueysville"
  },
  {
    "State": "KY",
    "City": "Ivel"
  },
  {
    "State": "KY",
    "City": "Lackey"
  },
  {
    "State": "KY",
    "City": "Langley"
  },
  {
    "State": "KY",
    "City": "Mc Dowell"
  },
  {
    "State": "KY",
    "City": "Martin"
  },
  {
    "State": "KY",
    "City": "Melvin"
  },
  {
    "State": "KY",
    "City": "Minnie"
  },
  {
    "State": "KY",
    "City": "Prestonsburg"
  },
  {
    "State": "KY",
    "City": "Printer"
  },
  {
    "State": "KY",
    "City": "Stanville"
  },
  {
    "State": "KY",
    "City": "Teaberry"
  },
  {
    "State": "KY",
    "City": "Tram"
  },
  {
    "State": "KY",
    "City": "Wayland"
  },
  {
    "State": "KY",
    "City": "Weeksbury"
  },
  {
    "State": "KY",
    "City": "Wheelwright"
  },
  {
    "State": "KY",
    "City": "Hazard"
  },
  {
    "State": "KY",
    "City": "Ary"
  },
  {
    "State": "KY",
    "City": "Avawam"
  },
  {
    "State": "KY",
    "City": "Bear Branch"
  },
  {
    "State": "KY",
    "City": "Bonnyman"
  },
  {
    "State": "KY",
    "City": "Buckhorn"
  },
  {
    "State": "KY",
    "City": "Bulan"
  },
  {
    "State": "KY",
    "City": "Busy"
  },
  {
    "State": "KY",
    "City": "Carrie"
  },
  {
    "State": "KY",
    "City": "Chavies"
  },
  {
    "State": "KY",
    "City": "Combs"
  },
  {
    "State": "KY",
    "City": "Cornettsville"
  },
  {
    "State": "KY",
    "City": "Delphia"
  },
  {
    "State": "KY",
    "City": "Dice"
  },
  {
    "State": "KY",
    "City": "Dwarf"
  },
  {
    "State": "KY",
    "City": "Emmalena"
  },
  {
    "State": "KY",
    "City": "Fisty"
  },
  {
    "State": "KY",
    "City": "Gays Creek"
  },
  {
    "State": "KY",
    "City": "Happy"
  },
  {
    "State": "KY",
    "City": "Hardburly"
  },
  {
    "State": "KY",
    "City": "Hyden"
  },
  {
    "State": "KY",
    "City": "Jeff"
  },
  {
    "State": "KY",
    "City": "Krypton"
  },
  {
    "State": "KY",
    "City": "Sassafras"
  },
  {
    "State": "KY",
    "City": "Scuddy"
  },
  {
    "State": "KY",
    "City": "Sizerock"
  },
  {
    "State": "KY",
    "City": "Slemp"
  },
  {
    "State": "KY",
    "City": "Smilax"
  },
  {
    "State": "KY",
    "City": "Thousandsticks"
  },
  {
    "State": "KY",
    "City": "Vest"
  },
  {
    "State": "KY",
    "City": "Vicco"
  },
  {
    "State": "KY",
    "City": "Viper"
  },
  {
    "State": "KY",
    "City": "Wendover"
  },
  {
    "State": "KY",
    "City": "Wooton"
  },
  {
    "State": "KY",
    "City": "Yeaddiss"
  },
  {
    "State": "KY",
    "City": "Yerkes"
  },
  {
    "State": "KY",
    "City": "Blackey"
  },
  {
    "State": "KY",
    "City": "Cromona"
  },
  {
    "State": "KY",
    "City": "Deane"
  },
  {
    "State": "KY",
    "City": "Ermine"
  },
  {
    "State": "KY",
    "City": "Garner"
  },
  {
    "State": "KY",
    "City": "Gordon"
  },
  {
    "State": "KY",
    "City": "Hallie"
  },
  {
    "State": "KY",
    "City": "Hindman"
  },
  {
    "State": "KY",
    "City": "Isom"
  },
  {
    "State": "KY",
    "City": "Jackhorn"
  },
  {
    "State": "KY",
    "City": "Jeremiah"
  },
  {
    "State": "KY",
    "City": "Kite"
  },
  {
    "State": "KY",
    "City": "Leburn"
  },
  {
    "State": "KY",
    "City": "Letcher"
  },
  {
    "State": "KY",
    "City": "Linefork"
  },
  {
    "State": "KY",
    "City": "Littcarr"
  },
  {
    "State": "KY",
    "City": "Mc Roberts"
  },
  {
    "State": "KY",
    "City": "Mallie"
  },
  {
    "State": "KY",
    "City": "Mayking"
  },
  {
    "State": "KY",
    "City": "Millstone"
  },
  {
    "State": "KY",
    "City": "Mousie"
  },
  {
    "State": "KY",
    "City": "Neon"
  },
  {
    "State": "KY",
    "City": "Pine Top"
  },
  {
    "State": "KY",
    "City": "Pippa Passes"
  },
  {
    "State": "KY",
    "City": "Premium"
  },
  {
    "State": "KY",
    "City": "Redfox"
  },
  {
    "State": "KY",
    "City": "Roxana"
  },
  {
    "State": "KY",
    "City": "Seco"
  },
  {
    "State": "KY",
    "City": "Thornton"
  },
  {
    "State": "KY",
    "City": "Whitesburg"
  },
  {
    "State": "KY",
    "City": "Dema"
  },
  {
    "State": "KY",
    "City": "Raven"
  },
  {
    "State": "KY",
    "City": "Topmost"
  },
  {
    "State": "KY",
    "City": "Paducah"
  },
  {
    "State": "KY",
    "City": "Almo"
  },
  {
    "State": "KY",
    "City": "Arlington"
  },
  {
    "State": "KY",
    "City": "Bandana"
  },
  {
    "State": "KY",
    "City": "Bardwell"
  },
  {
    "State": "KY",
    "City": "Barlow"
  },
  {
    "State": "KY",
    "City": "Benton"
  },
  {
    "State": "KY",
    "City": "Boaz"
  },
  {
    "State": "KY",
    "City": "Burna"
  },
  {
    "State": "KY",
    "City": "Calvert City"
  },
  {
    "State": "KY",
    "City": "Clinton"
  },
  {
    "State": "KY",
    "City": "Columbus"
  },
  {
    "State": "KY",
    "City": "Crayne"
  },
  {
    "State": "KY",
    "City": "Cunningham"
  },
  {
    "State": "KY",
    "City": "Dexter"
  },
  {
    "State": "KY",
    "City": "Dycusburg"
  },
  {
    "State": "KY",
    "City": "Eddyville"
  },
  {
    "State": "KY",
    "City": "Fancy Farm"
  },
  {
    "State": "KY",
    "City": "Farmington"
  },
  {
    "State": "KY",
    "City": "Fulton"
  },
  {
    "State": "KY",
    "City": "Gilbertsville"
  },
  {
    "State": "KY",
    "City": "Grand Rivers"
  },
  {
    "State": "KY",
    "City": "Hampton"
  },
  {
    "State": "KY",
    "City": "Hardin"
  },
  {
    "State": "KY",
    "City": "Hazel"
  },
  {
    "State": "KY",
    "City": "Hickman"
  },
  {
    "State": "KY",
    "City": "Hickory"
  },
  {
    "State": "KY",
    "City": "Kevil"
  },
  {
    "State": "KY",
    "City": "Kirksey"
  },
  {
    "State": "KY",
    "City": "Kuttawa"
  },
  {
    "State": "KY",
    "City": "La Center"
  },
  {
    "State": "KY",
    "City": "Ledbetter"
  },
  {
    "State": "KY",
    "City": "Lovelaceville"
  },
  {
    "State": "KY",
    "City": "Lowes"
  },
  {
    "State": "KY",
    "City": "Lynnville"
  },
  {
    "State": "KY",
    "City": "Marion"
  },
  {
    "State": "KY",
    "City": "Mayfield"
  },
  {
    "State": "KY",
    "City": "Melber"
  },
  {
    "State": "KY",
    "City": "Milburn"
  },
  {
    "State": "KY",
    "City": "Murray"
  },
  {
    "State": "KY",
    "City": "New Concord"
  },
  {
    "State": "KY",
    "City": "Salem"
  },
  {
    "State": "KY",
    "City": "Sedalia"
  },
  {
    "State": "KY",
    "City": "Smithland"
  },
  {
    "State": "KY",
    "City": "Symsonia"
  },
  {
    "State": "KY",
    "City": "Tiline"
  },
  {
    "State": "KY",
    "City": "Tolu"
  },
  {
    "State": "KY",
    "City": "Water Valley"
  },
  {
    "State": "KY",
    "City": "West Paducah"
  },
  {
    "State": "KY",
    "City": "Wickliffe"
  },
  {
    "State": "KY",
    "City": "Wingo"
  },
  {
    "State": "KY",
    "City": "Bowling Green"
  },
  {
    "State": "KY",
    "City": "Adolphus"
  },
  {
    "State": "KY",
    "City": "Alvaton"
  },
  {
    "State": "KY",
    "City": "Austin"
  },
  {
    "State": "KY",
    "City": "Beaumont"
  },
  {
    "State": "KY",
    "City": "Cave City"
  },
  {
    "State": "KY",
    "City": "Edmonton"
  },
  {
    "State": "KY",
    "City": "Eighty Eight"
  },
  {
    "State": "KY",
    "City": "Etoile"
  },
  {
    "State": "KY",
    "City": "Fountain Run"
  },
  {
    "State": "KY",
    "City": "Franklin"
  },
  {
    "State": "KY",
    "City": "Gamaliel"
  },
  {
    "State": "KY",
    "City": "Glasgow"
  },
  {
    "State": "KY",
    "City": "Hestand"
  },
  {
    "State": "KY",
    "City": "Hiseville"
  },
  {
    "State": "KY",
    "City": "Holland"
  },
  {
    "State": "KY",
    "City": "Knob Lick"
  },
  {
    "State": "KY",
    "City": "Lucas"
  },
  {
    "State": "KY",
    "City": "Mount Hermon"
  },
  {
    "State": "KY",
    "City": "Oakland"
  },
  {
    "State": "KY",
    "City": "Park City"
  },
  {
    "State": "KY",
    "City": "Rocky Hill"
  },
  {
    "State": "KY",
    "City": "Scottsville"
  },
  {
    "State": "KY",
    "City": "Summer Shade"
  },
  {
    "State": "KY",
    "City": "Tompkinsville"
  },
  {
    "State": "KY",
    "City": "Woodburn"
  },
  {
    "State": "KY",
    "City": "Smiths Grove"
  },
  {
    "State": "KY",
    "City": "Aberdeen"
  },
  {
    "State": "KY",
    "City": "Adairville"
  },
  {
    "State": "KY",
    "City": "Allensville"
  },
  {
    "State": "KY",
    "City": "Auburn"
  },
  {
    "State": "KY",
    "City": "Bee Spring"
  },
  {
    "State": "KY",
    "City": "Brownsville"
  },
  {
    "State": "KY",
    "City": "Cadiz"
  },
  {
    "State": "KY",
    "City": "Center"
  },
  {
    "State": "KY",
    "City": "Cerulean"
  },
  {
    "State": "KY",
    "City": "Clifty"
  },
  {
    "State": "KY",
    "City": "Crofton"
  },
  {
    "State": "KY",
    "City": "Dunbar"
  },
  {
    "State": "KY",
    "City": "Elkton"
  },
  {
    "State": "KY",
    "City": "Fairview"
  },
  {
    "State": "KY",
    "City": "Fort Campbell"
  },
  {
    "State": "KY",
    "City": "Gracey"
  },
  {
    "State": "KY",
    "City": "Guthrie"
  },
  {
    "State": "KY",
    "City": "Herndon"
  },
  {
    "State": "KY",
    "City": "Hopkinsville"
  },
  {
    "State": "KY",
    "City": "Jetson"
  },
  {
    "State": "KY",
    "City": "La Fayette"
  },
  {
    "State": "KY",
    "City": "Lewisburg"
  },
  {
    "State": "KY",
    "City": "Mammoth Cave"
  },
  {
    "State": "KY",
    "City": "Morgantown"
  },
  {
    "State": "KY",
    "City": "Oak Grove"
  },
  {
    "State": "KY",
    "City": "Olmstead"
  },
  {
    "State": "KY",
    "City": "Pembroke"
  },
  {
    "State": "KY",
    "City": "Rochester"
  },
  {
    "State": "KY",
    "City": "Rockfield"
  },
  {
    "State": "KY",
    "City": "Roundhill"
  },
  {
    "State": "KY",
    "City": "Russellville"
  },
  {
    "State": "KY",
    "City": "Sharon Grove"
  },
  {
    "State": "KY",
    "City": "South Union"
  },
  {
    "State": "KY",
    "City": "Sweeden"
  },
  {
    "State": "KY",
    "City": "Trenton"
  },
  {
    "State": "KY",
    "City": "Welchs Creek"
  },
  {
    "State": "KY",
    "City": "Woodbury"
  },
  {
    "State": "KY",
    "City": "Owensboro"
  },
  {
    "State": "KY",
    "City": "Beaver Dam"
  },
  {
    "State": "KY",
    "City": "Beech Creek"
  },
  {
    "State": "KY",
    "City": "Beech Grove"
  },
  {
    "State": "KY",
    "City": "Beechmont"
  },
  {
    "State": "KY",
    "City": "Belton"
  },
  {
    "State": "KY",
    "City": "Bremen"
  },
  {
    "State": "KY",
    "City": "Browder"
  },
  {
    "State": "KY",
    "City": "Calhoun"
  },
  {
    "State": "KY",
    "City": "Centertown"
  },
  {
    "State": "KY",
    "City": "Central City"
  },
  {
    "State": "KY",
    "City": "Cleaton"
  },
  {
    "State": "KY",
    "City": "Cromwell"
  },
  {
    "State": "KY",
    "City": "Curdsville"
  },
  {
    "State": "KY",
    "City": "Drakesboro"
  },
  {
    "State": "KY",
    "City": "Dundee"
  },
  {
    "State": "KY",
    "City": "Dunmor"
  },
  {
    "State": "KY",
    "City": "Fordsville"
  },
  {
    "State": "KY",
    "City": "Graham"
  },
  {
    "State": "KY",
    "City": "Greenville"
  },
  {
    "State": "KY",
    "City": "Hartford"
  },
  {
    "State": "KY",
    "City": "Hawesville"
  },
  {
    "State": "KY",
    "City": "Horse Branch"
  },
  {
    "State": "KY",
    "City": "Island"
  },
  {
    "State": "KY",
    "City": "Lewisport"
  },
  {
    "State": "KY",
    "City": "Livermore"
  },
  {
    "State": "KY",
    "City": "Mc Henry"
  },
  {
    "State": "KY",
    "City": "Maceo"
  },
  {
    "State": "KY",
    "City": "Maple Mount"
  },
  {
    "State": "KY",
    "City": "Olaton"
  },
  {
    "State": "KY",
    "City": "Philpot"
  },
  {
    "State": "KY",
    "City": "Powderly"
  },
  {
    "State": "KY",
    "City": "Reynolds Station"
  },
  {
    "State": "KY",
    "City": "Rockport"
  },
  {
    "State": "KY",
    "City": "Rosine"
  },
  {
    "State": "KY",
    "City": "Rumsey"
  },
  {
    "State": "KY",
    "City": "Sacramento"
  },
  {
    "State": "KY",
    "City": "South Carrollton"
  },
  {
    "State": "KY",
    "City": "Stanley"
  },
  {
    "State": "KY",
    "City": "Utica"
  },
  {
    "State": "KY",
    "City": "West Louisville"
  },
  {
    "State": "KY",
    "City": "Whitesville"
  },
  {
    "State": "KY",
    "City": "Baskett"
  },
  {
    "State": "KY",
    "City": "Blackford"
  },
  {
    "State": "KY",
    "City": "Clay"
  },
  {
    "State": "KY",
    "City": "Corydon"
  },
  {
    "State": "KY",
    "City": "Dawson Springs"
  },
  {
    "State": "KY",
    "City": "Dixon"
  },
  {
    "State": "KY",
    "City": "Earlington"
  },
  {
    "State": "KY",
    "City": "Fredonia"
  },
  {
    "State": "KY",
    "City": "Hanson"
  },
  {
    "State": "KY",
    "City": "Henderson"
  },
  {
    "State": "KY",
    "City": "Madisonville"
  },
  {
    "State": "KY",
    "City": "Manitou"
  },
  {
    "State": "KY",
    "City": "Morganfield"
  },
  {
    "State": "KY",
    "City": "Mortons Gap"
  },
  {
    "State": "KY",
    "City": "Nebo"
  },
  {
    "State": "KY",
    "City": "Nortonville"
  },
  {
    "State": "KY",
    "City": "Poole"
  },
  {
    "State": "KY",
    "City": "Princeton"
  },
  {
    "State": "KY",
    "City": "Providence"
  },
  {
    "State": "KY",
    "City": "Reed"
  },
  {
    "State": "KY",
    "City": "Robards"
  },
  {
    "State": "KY",
    "City": "Saint Charles"
  },
  {
    "State": "KY",
    "City": "Sebree"
  },
  {
    "State": "KY",
    "City": "Slaughters"
  },
  {
    "State": "KY",
    "City": "Smith Mills"
  },
  {
    "State": "KY",
    "City": "Spottsville"
  },
  {
    "State": "KY",
    "City": "Sturgis"
  },
  {
    "State": "KY",
    "City": "Sullivan"
  },
  {
    "State": "KY",
    "City": "Uniontown"
  },
  {
    "State": "KY",
    "City": "Waverly"
  },
  {
    "State": "KY",
    "City": "Wheatcroft"
  },
  {
    "State": "KY",
    "City": "White Plains"
  },
  {
    "State": "KY",
    "City": "Somerset"
  },
  {
    "State": "KY",
    "City": "Bethelridge"
  },
  {
    "State": "KY",
    "City": "Bronston"
  },
  {
    "State": "KY",
    "City": "Burnside"
  },
  {
    "State": "KY",
    "City": "Dunnville"
  },
  {
    "State": "KY",
    "City": "Ferguson"
  },
  {
    "State": "KY",
    "City": "Liberty"
  },
  {
    "State": "KY",
    "City": "Middleburg"
  },
  {
    "State": "KY",
    "City": "Nancy"
  },
  {
    "State": "KY",
    "City": "Science Hill"
  },
  {
    "State": "KY",
    "City": "Tateville"
  },
  {
    "State": "KY",
    "City": "West Somerset"
  },
  {
    "State": "KY",
    "City": "Windsor"
  },
  {
    "State": "KY",
    "City": "Yosemite"
  },
  {
    "State": "KY",
    "City": "Eubank"
  },
  {
    "State": "KY",
    "City": "Albany"
  },
  {
    "State": "KY",
    "City": "Alpha"
  },
  {
    "State": "KY",
    "City": "Jamestown"
  },
  {
    "State": "KY",
    "City": "Marshes Siding"
  },
  {
    "State": "KY",
    "City": "Monticello"
  },
  {
    "State": "KY",
    "City": "Parkers Lake"
  },
  {
    "State": "KY",
    "City": "Pine Knot"
  },
  {
    "State": "KY",
    "City": "Revelo"
  },
  {
    "State": "KY",
    "City": "Russell Springs"
  },
  {
    "State": "KY",
    "City": "Stearns"
  },
  {
    "State": "KY",
    "City": "Strunk"
  },
  {
    "State": "KY",
    "City": "Whitley City"
  },
  {
    "State": "KY",
    "City": "Elizabethtown"
  },
  {
    "State": "KY",
    "City": "Big Clifty"
  },
  {
    "State": "KY",
    "City": "Bonnieville"
  },
  {
    "State": "KY",
    "City": "Breeding"
  },
  {
    "State": "KY",
    "City": "Buffalo"
  },
  {
    "State": "KY",
    "City": "Burkesville"
  },
  {
    "State": "KY",
    "City": "Campbellsville"
  },
  {
    "State": "KY",
    "City": "Cane Valley"
  },
  {
    "State": "KY",
    "City": "Caneyville"
  },
  {
    "State": "KY",
    "City": "Canmer"
  },
  {
    "State": "KY",
    "City": "Cecilia"
  },
  {
    "State": "KY",
    "City": "Clarkson"
  },
  {
    "State": "KY",
    "City": "Columbia"
  },
  {
    "State": "KY",
    "City": "Cub Run"
  },
  {
    "State": "KY",
    "City": "Dubre"
  },
  {
    "State": "KY",
    "City": "Eastview"
  },
  {
    "State": "KY",
    "City": "Elk Horn"
  },
  {
    "State": "KY",
    "City": "Glendale"
  },
  {
    "State": "KY",
    "City": "Glens Fork"
  },
  {
    "State": "KY",
    "City": "Gradyville"
  },
  {
    "State": "KY",
    "City": "Greensburg"
  },
  {
    "State": "KY",
    "City": "Hardyville"
  },
  {
    "State": "KY",
    "City": "Hodgenville"
  },
  {
    "State": "KY",
    "City": "Horse Cave"
  },
  {
    "State": "KY",
    "City": "Knifley"
  },
  {
    "State": "KY",
    "City": "Leitchfield"
  },
  {
    "State": "KY",
    "City": "Magnolia"
  },
  {
    "State": "KY",
    "City": "Mannsville"
  },
  {
    "State": "KY",
    "City": "Marrowbone"
  },
  {
    "State": "KY",
    "City": "Millwood"
  },
  {
    "State": "KY",
    "City": "Mount Sherman"
  },
  {
    "State": "KY",
    "City": "Munfordville"
  },
  {
    "State": "KY",
    "City": "Sonora"
  },
  {
    "State": "KY",
    "City": "Summersville"
  },
  {
    "State": "KY",
    "City": "Upton"
  },
  {
    "State": "KY",
    "City": "White Mills"
  },
  {
    "State": "OH",
    "City": "Alexandria"
  },
  {
    "State": "OH",
    "City": "Amlin"
  },
  {
    "State": "OH",
    "City": "Ashley"
  },
  {
    "State": "OH",
    "City": "Blacklick"
  },
  {
    "State": "OH",
    "City": "Bladensburg"
  },
  {
    "State": "OH",
    "City": "Brinkhaven"
  },
  {
    "State": "OH",
    "City": "Broadway"
  },
  {
    "State": "OH",
    "City": "Buckeye Lake"
  },
  {
    "State": "OH",
    "City": "Cable"
  },
  {
    "State": "OH",
    "City": "Catawba"
  },
  {
    "State": "OH",
    "City": "Centerburg"
  },
  {
    "State": "OH",
    "City": "Croton"
  },
  {
    "State": "OH",
    "City": "Danville"
  },
  {
    "State": "OH",
    "City": "Delaware"
  },
  {
    "State": "OH",
    "City": "Dublin"
  },
  {
    "State": "OH",
    "City": "Etna"
  },
  {
    "State": "OH",
    "City": "Fredericktown"
  },
  {
    "State": "OH",
    "City": "Galena"
  },
  {
    "State": "OH",
    "City": "Gambier"
  },
  {
    "State": "OH",
    "City": "Granville"
  },
  {
    "State": "OH",
    "City": "Hebron"
  },
  {
    "State": "OH",
    "City": "Hilliard"
  },
  {
    "State": "OH",
    "City": "Homer"
  },
  {
    "State": "OH",
    "City": "Howard"
  },
  {
    "State": "OH",
    "City": "Irwin"
  },
  {
    "State": "OH",
    "City": "Jacksontown"
  },
  {
    "State": "OH",
    "City": "Johnstown"
  },
  {
    "State": "OH",
    "City": "Kilbourne"
  },
  {
    "State": "OH",
    "City": "Kirkersville"
  },
  {
    "State": "OH",
    "City": "Lewis Center"
  },
  {
    "State": "OH",
    "City": "Magnetic Springs"
  },
  {
    "State": "OH",
    "City": "Martinsburg"
  },
  {
    "State": "OH",
    "City": "Marysville"
  },
  {
    "State": "OH",
    "City": "Mechanicsburg"
  },
  {
    "State": "OH",
    "City": "Milford Center"
  },
  {
    "State": "OH",
    "City": "Millersport"
  },
  {
    "State": "OH",
    "City": "Mingo"
  },
  {
    "State": "OH",
    "City": "Mount Liberty"
  },
  {
    "State": "OH",
    "City": "Mount Vernon"
  },
  {
    "State": "OH",
    "City": "New Albany"
  },
  {
    "State": "OH",
    "City": "Newark"
  },
  {
    "State": "OH",
    "City": "Heath"
  },
  {
    "State": "OH",
    "City": "North Lewisburg"
  },
  {
    "State": "OH",
    "City": "Ostrander"
  },
  {
    "State": "OH",
    "City": "Pataskala"
  },
  {
    "State": "OH",
    "City": "Plain City"
  },
  {
    "State": "OH",
    "City": "Powell"
  },
  {
    "State": "OH",
    "City": "Radnor"
  },
  {
    "State": "OH",
    "City": "Raymond"
  },
  {
    "State": "OH",
    "City": "Reynoldsburg"
  },
  {
    "State": "OH",
    "City": "Rosewood"
  },
  {
    "State": "OH",
    "City": "Saint Louisville"
  },
  {
    "State": "OH",
    "City": "Saint Paris"
  },
  {
    "State": "OH",
    "City": "Summit Station"
  },
  {
    "State": "OH",
    "City": "Sunbury"
  },
  {
    "State": "OH",
    "City": "Thornville"
  },
  {
    "State": "OH",
    "City": "Unionville Center"
  },
  {
    "State": "OH",
    "City": "Urbana"
  },
  {
    "State": "OH",
    "City": "Utica"
  },
  {
    "State": "OH",
    "City": "Westerville"
  },
  {
    "State": "OH",
    "City": "Westville"
  },
  {
    "State": "OH",
    "City": "Woodstock"
  },
  {
    "State": "OH",
    "City": "Columbus"
  },
  {
    "State": "OH",
    "City": "Adelphi"
  },
  {
    "State": "OH",
    "City": "Amanda"
  },
  {
    "State": "OH",
    "City": "Ashville"
  },
  {
    "State": "OH",
    "City": "Baltimore"
  },
  {
    "State": "OH",
    "City": "Bloomingburg"
  },
  {
    "State": "OH",
    "City": "Bremen"
  },
  {
    "State": "OH",
    "City": "Brice"
  },
  {
    "State": "OH",
    "City": "Canal Winchester"
  },
  {
    "State": "OH",
    "City": "Carbon Hill"
  },
  {
    "State": "OH",
    "City": "Carroll"
  },
  {
    "State": "OH",
    "City": "Circleville"
  },
  {
    "State": "OH",
    "City": "Clarksburg"
  },
  {
    "State": "OH",
    "City": "Commercial Point"
  },
  {
    "State": "OH",
    "City": "Derby"
  },
  {
    "State": "OH",
    "City": "Galloway"
  },
  {
    "State": "OH",
    "City": "Grove City"
  },
  {
    "State": "OH",
    "City": "Groveport"
  },
  {
    "State": "OH",
    "City": "Harrisburg"
  },
  {
    "State": "OH",
    "City": "Haydenville"
  },
  {
    "State": "OH",
    "City": "Jeffersonville"
  },
  {
    "State": "OH",
    "City": "Lancaster"
  },
  {
    "State": "OH",
    "City": "Laurelville"
  },
  {
    "State": "OH",
    "City": "Lithopolis"
  },
  {
    "State": "OH",
    "City": "Lockbourne"
  },
  {
    "State": "OH",
    "City": "Logan"
  },
  {
    "State": "OH",
    "City": "London"
  },
  {
    "State": "OH",
    "City": "Milledgeville"
  },
  {
    "State": "OH",
    "City": "Mount Sterling"
  },
  {
    "State": "OH",
    "City": "Murray City"
  },
  {
    "State": "OH",
    "City": "New Holland"
  },
  {
    "State": "OH",
    "City": "Orient"
  },
  {
    "State": "OH",
    "City": "Pickerington"
  },
  {
    "State": "OH",
    "City": "Pleasantville"
  },
  {
    "State": "OH",
    "City": "Rockbridge"
  },
  {
    "State": "OH",
    "City": "Rushville"
  },
  {
    "State": "OH",
    "City": "Sedalia"
  },
  {
    "State": "OH",
    "City": "South Bloomingville"
  },
  {
    "State": "OH",
    "City": "South Solon"
  },
  {
    "State": "OH",
    "City": "Stoutsville"
  },
  {
    "State": "OH",
    "City": "Sugar Grove"
  },
  {
    "State": "OH",
    "City": "Tarlton"
  },
  {
    "State": "OH",
    "City": "Thurston"
  },
  {
    "State": "OH",
    "City": "Union Furnace"
  },
  {
    "State": "OH",
    "City": "Washington Court House"
  },
  {
    "State": "OH",
    "City": "West Jefferson"
  },
  {
    "State": "OH",
    "City": "West Rushville"
  },
  {
    "State": "OH",
    "City": "Williamsport"
  },
  {
    "State": "OH",
    "City": "Marion"
  },
  {
    "State": "OH",
    "City": "Belle Center"
  },
  {
    "State": "OH",
    "City": "Bellefontaine"
  },
  {
    "State": "OH",
    "City": "Caledonia"
  },
  {
    "State": "OH",
    "City": "Cardington"
  },
  {
    "State": "OH",
    "City": "Carey"
  },
  {
    "State": "OH",
    "City": "Chesterville"
  },
  {
    "State": "OH",
    "City": "De Graff"
  },
  {
    "State": "OH",
    "City": "East Liberty"
  },
  {
    "State": "OH",
    "City": "Edison"
  },
  {
    "State": "OH",
    "City": "Fulton"
  },
  {
    "State": "OH",
    "City": "Green Camp"
  },
  {
    "State": "OH",
    "City": "Harpster"
  },
  {
    "State": "OH",
    "City": "Huntsville"
  },
  {
    "State": "OH",
    "City": "Iberia"
  },
  {
    "State": "OH",
    "City": "Kenton"
  },
  {
    "State": "OH",
    "City": "Kirby"
  },
  {
    "State": "OH",
    "City": "Lakeview"
  },
  {
    "State": "OH",
    "City": "La Rue"
  },
  {
    "State": "OH",
    "City": "Lewistown"
  },
  {
    "State": "OH",
    "City": "Marengo"
  },
  {
    "State": "OH",
    "City": "Martel"
  },
  {
    "State": "OH",
    "City": "Middleburg"
  },
  {
    "State": "OH",
    "City": "Morral"
  },
  {
    "State": "OH",
    "City": "Mount Gilead"
  },
  {
    "State": "OH",
    "City": "Mount Victory"
  },
  {
    "State": "OH",
    "City": "New Bloomington"
  },
  {
    "State": "OH",
    "City": "Prospect"
  },
  {
    "State": "OH",
    "City": "Quincy"
  },
  {
    "State": "OH",
    "City": "Richwood"
  },
  {
    "State": "OH",
    "City": "Ridgeway"
  },
  {
    "State": "OH",
    "City": "Roundhead"
  },
  {
    "State": "OH",
    "City": "Rushsylvania"
  },
  {
    "State": "OH",
    "City": "Russells Point"
  },
  {
    "State": "OH",
    "City": "Shauck"
  },
  {
    "State": "OH",
    "City": "Sparta"
  },
  {
    "State": "OH",
    "City": "Upper Sandusky"
  },
  {
    "State": "OH",
    "City": "Waldo"
  },
  {
    "State": "OH",
    "City": "West Liberty"
  },
  {
    "State": "OH",
    "City": "West Mansfield"
  },
  {
    "State": "OH",
    "City": "Wharton"
  },
  {
    "State": "OH",
    "City": "Zanesfield"
  },
  {
    "State": "OH",
    "City": "Bowling Green"
  },
  {
    "State": "OH",
    "City": "Bradner"
  },
  {
    "State": "OH",
    "City": "Burgoon"
  },
  {
    "State": "OH",
    "City": "Clay Center"
  },
  {
    "State": "OH",
    "City": "Clyde"
  },
  {
    "State": "OH",
    "City": "Curtice"
  },
  {
    "State": "OH",
    "City": "Cygnet"
  },
  {
    "State": "OH",
    "City": "Dunbridge"
  },
  {
    "State": "OH",
    "City": "Elmore"
  },
  {
    "State": "OH",
    "City": "Fremont"
  },
  {
    "State": "OH",
    "City": "Genoa"
  },
  {
    "State": "OH",
    "City": "Gibsonburg"
  },
  {
    "State": "OH",
    "City": "Graytown"
  },
  {
    "State": "OH",
    "City": "Gypsum"
  },
  {
    "State": "OH",
    "City": "Harbor View"
  },
  {
    "State": "OH",
    "City": "Helena"
  },
  {
    "State": "OH",
    "City": "Isle Saint George"
  },
  {
    "State": "OH",
    "City": "Jerry City"
  },
  {
    "State": "OH",
    "City": "Kelleys Island"
  },
  {
    "State": "OH",
    "City": "Lacarne"
  },
  {
    "State": "OH",
    "City": "Lakeside Marblehead"
  },
  {
    "State": "OH",
    "City": "Lemoyne"
  },
  {
    "State": "OH",
    "City": "Lindsey"
  },
  {
    "State": "OH",
    "City": "Luckey"
  },
  {
    "State": "OH",
    "City": "Martin"
  },
  {
    "State": "OH",
    "City": "Middle Bass"
  },
  {
    "State": "OH",
    "City": "Millbury"
  },
  {
    "State": "OH",
    "City": "Oak Harbor"
  },
  {
    "State": "OH",
    "City": "Pemberville"
  },
  {
    "State": "OH",
    "City": "Portage"
  },
  {
    "State": "OH",
    "City": "Port Clinton"
  },
  {
    "State": "OH",
    "City": "Put In Bay"
  },
  {
    "State": "OH",
    "City": "Risingsun"
  },
  {
    "State": "OH",
    "City": "Rocky Ridge"
  },
  {
    "State": "OH",
    "City": "Rossford"
  },
  {
    "State": "OH",
    "City": "Rudolph"
  },
  {
    "State": "OH",
    "City": "Stony Ridge"
  },
  {
    "State": "OH",
    "City": "Vickery"
  },
  {
    "State": "OH",
    "City": "Walbridge"
  },
  {
    "State": "OH",
    "City": "Wayne"
  },
  {
    "State": "OH",
    "City": "West Millgrove"
  },
  {
    "State": "OH",
    "City": "Williston"
  },
  {
    "State": "OH",
    "City": "Woodville"
  },
  {
    "State": "OH",
    "City": "Alvordton"
  },
  {
    "State": "OH",
    "City": "Archbold"
  },
  {
    "State": "OH",
    "City": "Berkey"
  },
  {
    "State": "OH",
    "City": "Blakeslee"
  },
  {
    "State": "OH",
    "City": "Bryan"
  },
  {
    "State": "OH",
    "City": "Colton"
  },
  {
    "State": "OH",
    "City": "Custar"
  },
  {
    "State": "OH",
    "City": "Defiance"
  },
  {
    "State": "OH",
    "City": "Delta"
  },
  {
    "State": "OH",
    "City": "Deshler"
  },
  {
    "State": "OH",
    "City": "Edgerton"
  },
  {
    "State": "OH",
    "City": "Edon"
  },
  {
    "State": "OH",
    "City": "Evansport"
  },
  {
    "State": "OH",
    "City": "Farmer"
  },
  {
    "State": "OH",
    "City": "Fayette"
  },
  {
    "State": "OH",
    "City": "Grand Rapids"
  },
  {
    "State": "OH",
    "City": "Grelton"
  },
  {
    "State": "OH",
    "City": "Hamler"
  },
  {
    "State": "OH",
    "City": "Haskins"
  },
  {
    "State": "OH",
    "City": "Hicksville"
  },
  {
    "State": "OH",
    "City": "Holgate"
  },
  {
    "State": "OH",
    "City": "Holland"
  },
  {
    "State": "OH",
    "City": "Hoytville"
  },
  {
    "State": "OH",
    "City": "Jewell"
  },
  {
    "State": "OH",
    "City": "Kunkle"
  },
  {
    "State": "OH",
    "City": "Liberty Center"
  },
  {
    "State": "OH",
    "City": "Lyons"
  },
  {
    "State": "OH",
    "City": "Mc Clure"
  },
  {
    "State": "OH",
    "City": "Malinta"
  },
  {
    "State": "OH",
    "City": "Mark Center"
  },
  {
    "State": "OH",
    "City": "Maumee"
  },
  {
    "State": "OH",
    "City": "Metamora"
  },
  {
    "State": "OH",
    "City": "Milton Center"
  },
  {
    "State": "OH",
    "City": "Monclova"
  },
  {
    "State": "OH",
    "City": "Montpelier"
  },
  {
    "State": "OH",
    "City": "Napoleon"
  },
  {
    "State": "OH",
    "City": "Neapolis"
  },
  {
    "State": "OH",
    "City": "New Bavaria"
  },
  {
    "State": "OH",
    "City": "Ney"
  },
  {
    "State": "OH",
    "City": "Okolona"
  },
  {
    "State": "OH",
    "City": "Perrysburg"
  },
  {
    "State": "OH",
    "City": "Pettisville"
  },
  {
    "State": "OH",
    "City": "Pioneer"
  },
  {
    "State": "OH",
    "City": "Ridgeville Corners"
  },
  {
    "State": "OH",
    "City": "Sherwood"
  },
  {
    "State": "OH",
    "City": "Stryker"
  },
  {
    "State": "OH",
    "City": "Swanton"
  },
  {
    "State": "OH",
    "City": "Sylvania"
  },
  {
    "State": "OH",
    "City": "Tontogany"
  },
  {
    "State": "OH",
    "City": "Waterville"
  },
  {
    "State": "OH",
    "City": "Wauseon"
  },
  {
    "State": "OH",
    "City": "Weston"
  },
  {
    "State": "OH",
    "City": "West Unity"
  },
  {
    "State": "OH",
    "City": "Whitehouse"
  },
  {
    "State": "OH",
    "City": "Toledo"
  },
  {
    "State": "OH",
    "City": "Oregon"
  },
  {
    "State": "OH",
    "City": "Northwood"
  },
  {
    "State": "OH",
    "City": "Zanesville"
  },
  {
    "State": "OH",
    "City": "Ava"
  },
  {
    "State": "OH",
    "City": "Barnesville"
  },
  {
    "State": "OH",
    "City": "Beallsville"
  },
  {
    "State": "OH",
    "City": "Belle Valley"
  },
  {
    "State": "OH",
    "City": "Belmont"
  },
  {
    "State": "OH",
    "City": "Bethesda"
  },
  {
    "State": "OH",
    "City": "Blue Rock"
  },
  {
    "State": "OH",
    "City": "Brownsville"
  },
  {
    "State": "OH",
    "City": "Buffalo"
  },
  {
    "State": "OH",
    "City": "Byesville"
  },
  {
    "State": "OH",
    "City": "Caldwell"
  },
  {
    "State": "OH",
    "City": "Cambridge"
  },
  {
    "State": "OH",
    "City": "Chandlersville"
  },
  {
    "State": "OH",
    "City": "Chesterhill"
  },
  {
    "State": "OH",
    "City": "Corning"
  },
  {
    "State": "OH",
    "City": "Crooksville"
  },
  {
    "State": "OH",
    "City": "Cumberland"
  },
  {
    "State": "OH",
    "City": "Derwent"
  },
  {
    "State": "OH",
    "City": "Duncan Falls"
  },
  {
    "State": "OH",
    "City": "East Fultonham"
  },
  {
    "State": "OH",
    "City": "Fairview"
  },
  {
    "State": "OH",
    "City": "Fultonham"
  },
  {
    "State": "OH",
    "City": "Glenford"
  },
  {
    "State": "OH",
    "City": "Gratiot"
  },
  {
    "State": "OH",
    "City": "Hopewell"
  },
  {
    "State": "OH",
    "City": "Jerusalem"
  },
  {
    "State": "OH",
    "City": "Junction City"
  },
  {
    "State": "OH",
    "City": "Kimbolton"
  },
  {
    "State": "OH",
    "City": "Kipling"
  },
  {
    "State": "OH",
    "City": "Laings"
  },
  {
    "State": "OH",
    "City": "Lewisville"
  },
  {
    "State": "OH",
    "City": "Lore City"
  },
  {
    "State": "OH",
    "City": "Mcconnelsville"
  },
  {
    "State": "OH",
    "City": "Malaga"
  },
  {
    "State": "OH",
    "City": "Malta"
  },
  {
    "State": "OH",
    "City": "Morristown"
  },
  {
    "State": "OH",
    "City": "Mount Perry"
  },
  {
    "State": "OH",
    "City": "Moxahala"
  },
  {
    "State": "OH",
    "City": "New Concord"
  },
  {
    "State": "OH",
    "City": "New Lexington"
  },
  {
    "State": "OH",
    "City": "New Straitsville"
  },
  {
    "State": "OH",
    "City": "Norwich"
  },
  {
    "State": "OH",
    "City": "Old Washington"
  },
  {
    "State": "OH",
    "City": "Philo"
  },
  {
    "State": "OH",
    "City": "Pleasant City"
  },
  {
    "State": "OH",
    "City": "Quaker City"
  },
  {
    "State": "OH",
    "City": "Roseville"
  },
  {
    "State": "OH",
    "City": "Salesville"
  },
  {
    "State": "OH",
    "City": "Sarahsville"
  },
  {
    "State": "OH",
    "City": "Senecaville"
  },
  {
    "State": "OH",
    "City": "Shawnee"
  },
  {
    "State": "OH",
    "City": "Somerset"
  },
  {
    "State": "OH",
    "City": "Stafford"
  },
  {
    "State": "OH",
    "City": "Stockport"
  },
  {
    "State": "OH",
    "City": "Summerfield"
  },
  {
    "State": "OH",
    "City": "Sycamore Valley"
  },
  {
    "State": "OH",
    "City": "White Cottage"
  },
  {
    "State": "OH",
    "City": "Woodsfield"
  },
  {
    "State": "OH",
    "City": "Adamsville"
  },
  {
    "State": "OH",
    "City": "Bakersville"
  },
  {
    "State": "OH",
    "City": "Baltic"
  },
  {
    "State": "OH",
    "City": "Blissfield"
  },
  {
    "State": "OH",
    "City": "Conesville"
  },
  {
    "State": "OH",
    "City": "Coshocton"
  },
  {
    "State": "OH",
    "City": "Dresden"
  },
  {
    "State": "OH",
    "City": "Frazeysburg"
  },
  {
    "State": "OH",
    "City": "Fresno"
  },
  {
    "State": "OH",
    "City": "Keene"
  },
  {
    "State": "OH",
    "City": "Nashport"
  },
  {
    "State": "OH",
    "City": "Newcomerstown"
  },
  {
    "State": "OH",
    "City": "Plainfield"
  },
  {
    "State": "OH",
    "City": "Port Washington"
  },
  {
    "State": "OH",
    "City": "Stone Creek"
  },
  {
    "State": "OH",
    "City": "Trinway"
  },
  {
    "State": "OH",
    "City": "Walhonding"
  },
  {
    "State": "OH",
    "City": "Warsaw"
  },
  {
    "State": "OH",
    "City": "West Lafayette"
  },
  {
    "State": "OH",
    "City": "Adena"
  },
  {
    "State": "OH",
    "City": "Alledonia"
  },
  {
    "State": "OH",
    "City": "Amsterdam"
  },
  {
    "State": "OH",
    "City": "Barton"
  },
  {
    "State": "OH",
    "City": "Bellaire"
  },
  {
    "State": "OH",
    "City": "Cadiz"
  },
  {
    "State": "OH",
    "City": "Bergholz"
  },
  {
    "State": "OH",
    "City": "Blaine"
  },
  {
    "State": "OH",
    "City": "Bloomingdale"
  },
  {
    "State": "OH",
    "City": "Bridgeport"
  },
  {
    "State": "OH",
    "City": "Brilliant"
  },
  {
    "State": "OH",
    "City": "Cameron"
  },
  {
    "State": "OH",
    "City": "Clarington"
  },
  {
    "State": "OH",
    "City": "Colerain"
  },
  {
    "State": "OH",
    "City": "Dillonvale"
  },
  {
    "State": "OH",
    "City": "East Liverpool"
  },
  {
    "State": "OH",
    "City": "East Springfield"
  },
  {
    "State": "OH",
    "City": "Empire"
  },
  {
    "State": "OH",
    "City": "Fairpoint"
  },
  {
    "State": "OH",
    "City": "Glencoe"
  },
  {
    "State": "OH",
    "City": "Hammondsville"
  },
  {
    "State": "OH",
    "City": "Hannibal"
  },
  {
    "State": "OH",
    "City": "Irondale"
  },
  {
    "State": "OH",
    "City": "Jacobsburg"
  },
  {
    "State": "OH",
    "City": "Lansing"
  },
  {
    "State": "OH",
    "City": "Martins Ferry"
  },
  {
    "State": "OH",
    "City": "Maynard"
  },
  {
    "State": "OH",
    "City": "Mingo Junction"
  },
  {
    "State": "OH",
    "City": "Mount Pleasant"
  },
  {
    "State": "OH",
    "City": "Neffs"
  },
  {
    "State": "OH",
    "City": "Piney Fork"
  },
  {
    "State": "OH",
    "City": "Powhatan Point"
  },
  {
    "State": "OH",
    "City": "Rayland"
  },
  {
    "State": "OH",
    "City": "Richmond"
  },
  {
    "State": "OH",
    "City": "Salineville"
  },
  {
    "State": "OH",
    "City": "Sardis"
  },
  {
    "State": "OH",
    "City": "Shadyside"
  },
  {
    "State": "OH",
    "City": "Smithfield"
  },
  {
    "State": "OH",
    "City": "Saint Clairsville"
  },
  {
    "State": "OH",
    "City": "Lafferty"
  },
  {
    "State": "OH",
    "City": "Steubenville"
  },
  {
    "State": "OH",
    "City": "Stratton"
  },
  {
    "State": "OH",
    "City": "Summitville"
  },
  {
    "State": "OH",
    "City": "Tiltonsville"
  },
  {
    "State": "OH",
    "City": "Toronto"
  },
  {
    "State": "OH",
    "City": "Warnock"
  },
  {
    "State": "OH",
    "City": "Wellsville"
  },
  {
    "State": "OH",
    "City": "Wolf Run"
  },
  {
    "State": "OH",
    "City": "Yorkville"
  },
  {
    "State": "OH",
    "City": "Bannock"
  },
  {
    "State": "OH",
    "City": "Freeport"
  },
  {
    "State": "OH",
    "City": "Harrisville"
  },
  {
    "State": "OH",
    "City": "Hopedale"
  },
  {
    "State": "OH",
    "City": "Flushing"
  },
  {
    "State": "OH",
    "City": "New Athens"
  },
  {
    "State": "OH",
    "City": "Piedmont"
  },
  {
    "State": "OH",
    "City": "New Rumley"
  },
  {
    "State": "OH",
    "City": "Holloway"
  },
  {
    "State": "OH",
    "City": "Jewett"
  },
  {
    "State": "OH",
    "City": "Scio"
  },
  {
    "State": "OH",
    "City": "Amherst"
  },
  {
    "State": "OH",
    "City": "Andover"
  },
  {
    "State": "OH",
    "City": "Ashtabula"
  },
  {
    "State": "OH",
    "City": "Austinburg"
  },
  {
    "State": "OH",
    "City": "Avon"
  },
  {
    "State": "OH",
    "City": "Avon Lake"
  },
  {
    "State": "OH",
    "City": "Berea"
  },
  {
    "State": "OH",
    "City": "Burton"
  },
  {
    "State": "OH",
    "City": "Chagrin Falls"
  },
  {
    "State": "OH",
    "City": "Chardon"
  },
  {
    "State": "OH",
    "City": "Chesterland"
  },
  {
    "State": "OH",
    "City": "Columbia Station"
  },
  {
    "State": "OH",
    "City": "Conneaut"
  },
  {
    "State": "OH",
    "City": "Dorset"
  },
  {
    "State": "OH",
    "City": "East Claridon"
  },
  {
    "State": "OH",
    "City": "Elyria"
  },
  {
    "State": "OH",
    "City": "North Ridgeville"
  },
  {
    "State": "OH",
    "City": "Gates Mills"
  },
  {
    "State": "OH",
    "City": "Geneva"
  },
  {
    "State": "OH",
    "City": "Grafton"
  },
  {
    "State": "OH",
    "City": "Grand River"
  },
  {
    "State": "OH",
    "City": "Huntsburg"
  },
  {
    "State": "OH",
    "City": "Jefferson"
  },
  {
    "State": "OH",
    "City": "Kingsville"
  },
  {
    "State": "OH",
    "City": "Kipton"
  },
  {
    "State": "OH",
    "City": "Lagrange"
  },
  {
    "State": "OH",
    "City": "Lorain"
  },
  {
    "State": "OH",
    "City": "Sheffield Lake"
  },
  {
    "State": "OH",
    "City": "Macedonia"
  },
  {
    "State": "OH",
    "City": "Madison"
  },
  {
    "State": "OH",
    "City": "Mentor"
  },
  {
    "State": "OH",
    "City": "Middlefield"
  },
  {
    "State": "OH",
    "City": "Montville"
  },
  {
    "State": "OH",
    "City": "Newbury"
  },
  {
    "State": "OH",
    "City": "Northfield"
  },
  {
    "State": "OH",
    "City": "North Kingsville"
  },
  {
    "State": "OH",
    "City": "North Olmsted"
  },
  {
    "State": "OH",
    "City": "Novelty"
  },
  {
    "State": "OH",
    "City": "Oberlin"
  },
  {
    "State": "OH",
    "City": "Orwell"
  },
  {
    "State": "OH",
    "City": "Painesville"
  },
  {
    "State": "OH",
    "City": "Parkman"
  },
  {
    "State": "OH",
    "City": "Perry"
  },
  {
    "State": "OH",
    "City": "Pierpont"
  },
  {
    "State": "OH",
    "City": "Rock Creek"
  },
  {
    "State": "OH",
    "City": "Rome"
  },
  {
    "State": "OH",
    "City": "Thompson"
  },
  {
    "State": "OH",
    "City": "Twinsburg"
  },
  {
    "State": "OH",
    "City": "Unionville"
  },
  {
    "State": "OH",
    "City": "Vermilion"
  },
  {
    "State": "OH",
    "City": "Wellington"
  },
  {
    "State": "OH",
    "City": "Wickliffe"
  },
  {
    "State": "OH",
    "City": "Williamsfield"
  },
  {
    "State": "OH",
    "City": "Willoughby"
  },
  {
    "State": "OH",
    "City": "Eastlake"
  },
  {
    "State": "OH",
    "City": "Windsor"
  },
  {
    "State": "OH",
    "City": "Cleveland"
  },
  {
    "State": "OH",
    "City": "Lakewood"
  },
  {
    "State": "OH",
    "City": "Rocky River"
  },
  {
    "State": "OH",
    "City": "Euclid"
  },
  {
    "State": "OH",
    "City": "Beachwood"
  },
  {
    "State": "OH",
    "City": "Independence"
  },
  {
    "State": "OH",
    "City": "North Royalton"
  },
  {
    "State": "OH",
    "City": "Strongsville"
  },
  {
    "State": "OH",
    "City": "Maple Heights"
  },
  {
    "State": "OH",
    "City": "Olmsted Falls"
  },
  {
    "State": "OH",
    "City": "Solon"
  },
  {
    "State": "OH",
    "City": "Bay Village"
  },
  {
    "State": "OH",
    "City": "Brecksville"
  },
  {
    "State": "OH",
    "City": "Brookpark"
  },
  {
    "State": "OH",
    "City": "Westlake"
  },
  {
    "State": "OH",
    "City": "Bedford"
  },
  {
    "State": "OH",
    "City": "Broadview Heights"
  },
  {
    "State": "OH",
    "City": "Atwater"
  },
  {
    "State": "OH",
    "City": "Aurora"
  },
  {
    "State": "OH",
    "City": "Barberton"
  },
  {
    "State": "OH",
    "City": "Bath"
  },
  {
    "State": "OH",
    "City": "Brady Lake"
  },
  {
    "State": "OH",
    "City": "Brunswick"
  },
  {
    "State": "OH",
    "City": "Burbank"
  },
  {
    "State": "OH",
    "City": "Chippewa Lake"
  },
  {
    "State": "OH",
    "City": "Clinton"
  },
  {
    "State": "OH",
    "City": "Creston"
  },
  {
    "State": "OH",
    "City": "Cuyahoga Falls"
  },
  {
    "State": "OH",
    "City": "Stow"
  },
  {
    "State": "OH",
    "City": "Doylestown"
  },
  {
    "State": "OH",
    "City": "Garrettsville"
  },
  {
    "State": "OH",
    "City": "Green"
  },
  {
    "State": "OH",
    "City": "Hinckley"
  },
  {
    "State": "OH",
    "City": "Hiram"
  },
  {
    "State": "OH",
    "City": "Homerville"
  },
  {
    "State": "OH",
    "City": "Hudson"
  },
  {
    "State": "OH",
    "City": "Kent"
  },
  {
    "State": "OH",
    "City": "Streetsboro"
  },
  {
    "State": "OH",
    "City": "Lakemore"
  },
  {
    "State": "OH",
    "City": "Westfield Center"
  },
  {
    "State": "OH",
    "City": "Litchfield"
  },
  {
    "State": "OH",
    "City": "Lodi"
  },
  {
    "State": "OH",
    "City": "Mantua"
  },
  {
    "State": "OH",
    "City": "Medina"
  },
  {
    "State": "OH",
    "City": "Mogadore"
  },
  {
    "State": "OH",
    "City": "Munroe Falls"
  },
  {
    "State": "OH",
    "City": "Peninsula"
  },
  {
    "State": "OH",
    "City": "Randolph"
  },
  {
    "State": "OH",
    "City": "Ravenna"
  },
  {
    "State": "OH",
    "City": "Rittman"
  },
  {
    "State": "OH",
    "City": "Rootstown"
  },
  {
    "State": "OH",
    "City": "Seville"
  },
  {
    "State": "OH",
    "City": "Sharon Center"
  },
  {
    "State": "OH",
    "City": "Spencer"
  },
  {
    "State": "OH",
    "City": "Sterling"
  },
  {
    "State": "OH",
    "City": "Tallmadge"
  },
  {
    "State": "OH",
    "City": "Valley City"
  },
  {
    "State": "OH",
    "City": "Wadsworth"
  },
  {
    "State": "OH",
    "City": "Wayland"
  },
  {
    "State": "OH",
    "City": "Richfield"
  },
  {
    "State": "OH",
    "City": "West Salem"
  },
  {
    "State": "OH",
    "City": "Windham"
  },
  {
    "State": "OH",
    "City": "Akron"
  },
  {
    "State": "OH",
    "City": "Fairlawn"
  },
  {
    "State": "OH",
    "City": "Berlin Center"
  },
  {
    "State": "OH",
    "City": "Bristolville"
  },
  {
    "State": "OH",
    "City": "Brookfield"
  },
  {
    "State": "OH",
    "City": "Burghill"
  },
  {
    "State": "OH",
    "City": "Campbell"
  },
  {
    "State": "OH",
    "City": "Canfield"
  },
  {
    "State": "OH",
    "City": "Columbiana"
  },
  {
    "State": "OH",
    "City": "Cortland"
  },
  {
    "State": "OH",
    "City": "Deerfield"
  },
  {
    "State": "OH",
    "City": "Diamond"
  },
  {
    "State": "OH",
    "City": "East Palestine"
  },
  {
    "State": "OH",
    "City": "Elkton"
  },
  {
    "State": "OH",
    "City": "Ellsworth"
  },
  {
    "State": "OH",
    "City": "Farmdale"
  },
  {
    "State": "OH",
    "City": "Fowler"
  },
  {
    "State": "OH",
    "City": "Girard"
  },
  {
    "State": "OH",
    "City": "Greenford"
  },
  {
    "State": "OH",
    "City": "Hanoverton"
  },
  {
    "State": "OH",
    "City": "Hartford"
  },
  {
    "State": "OH",
    "City": "Hubbard"
  },
  {
    "State": "OH",
    "City": "Kensington"
  },
  {
    "State": "OH",
    "City": "Kinsman"
  },
  {
    "State": "OH",
    "City": "Lake Milton"
  },
  {
    "State": "OH",
    "City": "Leavittsburg"
  },
  {
    "State": "OH",
    "City": "Leetonia"
  },
  {
    "State": "OH",
    "City": "Lisbon"
  },
  {
    "State": "OH",
    "City": "Lowellville"
  },
  {
    "State": "OH",
    "City": "Mc Donald"
  },
  {
    "State": "OH",
    "City": "Masury"
  },
  {
    "State": "OH",
    "City": "Mesopotamia"
  },
  {
    "State": "OH",
    "City": "Mineral Ridge"
  },
  {
    "State": "OH",
    "City": "Negley"
  },
  {
    "State": "OH",
    "City": "New Middletown"
  },
  {
    "State": "OH",
    "City": "New Springfield"
  },
  {
    "State": "OH",
    "City": "Newton Falls"
  },
  {
    "State": "OH",
    "City": "New Waterford"
  },
  {
    "State": "OH",
    "City": "Niles"
  },
  {
    "State": "OH",
    "City": "North Benton"
  },
  {
    "State": "OH",
    "City": "North Bloomfield"
  },
  {
    "State": "OH",
    "City": "North Jackson"
  },
  {
    "State": "OH",
    "City": "North Lima"
  },
  {
    "State": "OH",
    "City": "Orangeville"
  },
  {
    "State": "OH",
    "City": "Petersburg"
  },
  {
    "State": "OH",
    "City": "Rogers"
  },
  {
    "State": "OH",
    "City": "Salem"
  },
  {
    "State": "OH",
    "City": "Southington"
  },
  {
    "State": "OH",
    "City": "Struthers"
  },
  {
    "State": "OH",
    "City": "Vienna"
  },
  {
    "State": "OH",
    "City": "Warren"
  },
  {
    "State": "OH",
    "City": "Washingtonville"
  },
  {
    "State": "OH",
    "City": "West Farmington"
  },
  {
    "State": "OH",
    "City": "West Point"
  },
  {
    "State": "OH",
    "City": "Winona"
  },
  {
    "State": "OH",
    "City": "Youngstown"
  },
  {
    "State": "OH",
    "City": "Alliance"
  },
  {
    "State": "OH",
    "City": "Apple Creek"
  },
  {
    "State": "OH",
    "City": "Augusta"
  },
  {
    "State": "OH",
    "City": "Beach City"
  },
  {
    "State": "OH",
    "City": "Beloit"
  },
  {
    "State": "OH",
    "City": "Berlin"
  },
  {
    "State": "OH",
    "City": "Big Prairie"
  },
  {
    "State": "OH",
    "City": "Bolivar"
  },
  {
    "State": "OH",
    "City": "Brewster"
  },
  {
    "State": "OH",
    "City": "Canal Fulton"
  },
  {
    "State": "OH",
    "City": "Carrollton"
  },
  {
    "State": "OH",
    "City": "Charm"
  },
  {
    "State": "OH",
    "City": "Dalton"
  },
  {
    "State": "OH",
    "City": "Damascus"
  },
  {
    "State": "OH",
    "City": "Dellroy"
  },
  {
    "State": "OH",
    "City": "Dennison"
  },
  {
    "State": "OH",
    "City": "Dover"
  },
  {
    "State": "OH",
    "City": "Dundee"
  },
  {
    "State": "OH",
    "City": "East Rochester"
  },
  {
    "State": "OH",
    "City": "East Sparta"
  },
  {
    "State": "OH",
    "City": "Fredericksburg"
  },
  {
    "State": "OH",
    "City": "Glenmont"
  },
  {
    "State": "OH",
    "City": "Gnadenhutten"
  },
  {
    "State": "OH",
    "City": "Greentown"
  },
  {
    "State": "OH",
    "City": "Harlem Springs"
  },
  {
    "State": "OH",
    "City": "Hartville"
  },
  {
    "State": "OH",
    "City": "Holmesville"
  },
  {
    "State": "OH",
    "City": "Homeworth"
  },
  {
    "State": "OH",
    "City": "Kidron"
  },
  {
    "State": "OH",
    "City": "Killbuck"
  },
  {
    "State": "OH",
    "City": "Lakeville"
  },
  {
    "State": "OH",
    "City": "Leesville"
  },
  {
    "State": "OH",
    "City": "Limaville"
  },
  {
    "State": "OH",
    "City": "Louisville"
  },
  {
    "State": "OH",
    "City": "Magnolia"
  },
  {
    "State": "OH",
    "City": "Malvern"
  },
  {
    "State": "OH",
    "City": "Marshallville"
  },
  {
    "State": "OH",
    "City": "Massillon"
  },
  {
    "State": "OH",
    "City": "Maximo"
  },
  {
    "State": "OH",
    "City": "Mechanicstown"
  },
  {
    "State": "OH",
    "City": "Middlebranch"
  },
  {
    "State": "OH",
    "City": "Midvale"
  },
  {
    "State": "OH",
    "City": "Millersburg"
  },
  {
    "State": "OH",
    "City": "Mineral City"
  },
  {
    "State": "OH",
    "City": "Minerva"
  },
  {
    "State": "OH",
    "City": "Mount Eaton"
  },
  {
    "State": "OH",
    "City": "Mount Hope"
  },
  {
    "State": "OH",
    "City": "Nashville"
  },
  {
    "State": "OH",
    "City": "Navarre"
  },
  {
    "State": "OH",
    "City": "New Philadelphia"
  },
  {
    "State": "OH",
    "City": "North Georgetown"
  },
  {
    "State": "OH",
    "City": "North Lawrence"
  },
  {
    "State": "OH",
    "City": "Orrville"
  },
  {
    "State": "OH",
    "City": "Paris"
  },
  {
    "State": "OH",
    "City": "Robertsville"
  },
  {
    "State": "OH",
    "City": "Sandyville"
  },
  {
    "State": "OH",
    "City": "Sebring"
  },
  {
    "State": "OH",
    "City": "Sherrodsville"
  },
  {
    "State": "OH",
    "City": "Shreve"
  },
  {
    "State": "OH",
    "City": "Smithville"
  },
  {
    "State": "OH",
    "City": "Somerdale"
  },
  {
    "State": "OH",
    "City": "Stillwater"
  },
  {
    "State": "OH",
    "City": "Strasburg"
  },
  {
    "State": "OH",
    "City": "Sugarcreek"
  },
  {
    "State": "OH",
    "City": "Tuscarawas"
  },
  {
    "State": "OH",
    "City": "Uhrichsville"
  },
  {
    "State": "OH",
    "City": "Uniontown"
  },
  {
    "State": "OH",
    "City": "Walnut Creek"
  },
  {
    "State": "OH",
    "City": "Waynesburg"
  },
  {
    "State": "OH",
    "City": "Wilmot"
  },
  {
    "State": "OH",
    "City": "Winesburg"
  },
  {
    "State": "OH",
    "City": "Wooster"
  },
  {
    "State": "OH",
    "City": "Deersville"
  },
  {
    "State": "OH",
    "City": "Bowerston"
  },
  {
    "State": "OH",
    "City": "Zoar"
  },
  {
    "State": "OH",
    "City": "Tippecanoe"
  },
  {
    "State": "OH",
    "City": "Canton"
  },
  {
    "State": "OH",
    "City": "North Canton"
  },
  {
    "State": "OH",
    "City": "East Canton"
  },
  {
    "State": "OH",
    "City": "Alvada"
  },
  {
    "State": "OH",
    "City": "Arcadia"
  },
  {
    "State": "OH",
    "City": "Ashland"
  },
  {
    "State": "OH",
    "City": "Attica"
  },
  {
    "State": "OH",
    "City": "Bascom"
  },
  {
    "State": "OH",
    "City": "Bellevue"
  },
  {
    "State": "OH",
    "City": "Bellville"
  },
  {
    "State": "OH",
    "City": "Berlin Heights"
  },
  {
    "State": "OH",
    "City": "Bettsville"
  },
  {
    "State": "OH",
    "City": "Birmingham"
  },
  {
    "State": "OH",
    "City": "Bloomdale"
  },
  {
    "State": "OH",
    "City": "Bloomville"
  },
  {
    "State": "OH",
    "City": "Bucyrus"
  },
  {
    "State": "OH",
    "City": "Butler"
  },
  {
    "State": "OH",
    "City": "Castalia"
  },
  {
    "State": "OH",
    "City": "Chatfield"
  },
  {
    "State": "OH",
    "City": "Collins"
  },
  {
    "State": "OH",
    "City": "Crestline"
  },
  {
    "State": "OH",
    "City": "Flat Rock"
  },
  {
    "State": "OH",
    "City": "Fostoria"
  },
  {
    "State": "OH",
    "City": "Galion"
  },
  {
    "State": "OH",
    "City": "Green Springs"
  },
  {
    "State": "OH",
    "City": "Greenwich"
  },
  {
    "State": "OH",
    "City": "Hayesville"
  },
  {
    "State": "OH",
    "City": "Huron"
  },
  {
    "State": "OH",
    "City": "Jeromesville"
  },
  {
    "State": "OH",
    "City": "Kansas"
  },
  {
    "State": "OH",
    "City": "Loudonville"
  },
  {
    "State": "OH",
    "City": "Lucas"
  },
  {
    "State": "OH",
    "City": "Mc Cutchenville"
  },
  {
    "State": "OH",
    "City": "Melmore"
  },
  {
    "State": "OH",
    "City": "Milan"
  },
  {
    "State": "OH",
    "City": "Monroeville"
  },
  {
    "State": "OH",
    "City": "Nankin"
  },
  {
    "State": "OH",
    "City": "Nevada"
  },
  {
    "State": "OH",
    "City": "New Haven"
  },
  {
    "State": "OH",
    "City": "New London"
  },
  {
    "State": "OH",
    "City": "New Riegel"
  },
  {
    "State": "OH",
    "City": "New Washington"
  },
  {
    "State": "OH",
    "City": "North Fairfield"
  },
  {
    "State": "OH",
    "City": "North Robinson"
  },
  {
    "State": "OH",
    "City": "Norwalk"
  },
  {
    "State": "OH",
    "City": "Nova"
  },
  {
    "State": "OH",
    "City": "Oceola"
  },
  {
    "State": "OH",
    "City": "Old Fort"
  },
  {
    "State": "OH",
    "City": "Ontario"
  },
  {
    "State": "OH",
    "City": "Perrysville"
  },
  {
    "State": "OH",
    "City": "Plymouth"
  },
  {
    "State": "OH",
    "City": "Polk"
  },
  {
    "State": "OH",
    "City": "Republic"
  },
  {
    "State": "OH",
    "City": "Sandusky"
  },
  {
    "State": "OH",
    "City": "Savannah"
  },
  {
    "State": "OH",
    "City": "Shelby"
  },
  {
    "State": "OH",
    "City": "Shiloh"
  },
  {
    "State": "OH",
    "City": "Sullivan"
  },
  {
    "State": "OH",
    "City": "Sulphur Springs"
  },
  {
    "State": "OH",
    "City": "Sycamore"
  },
  {
    "State": "OH",
    "City": "Tiffin"
  },
  {
    "State": "OH",
    "City": "Tiro"
  },
  {
    "State": "OH",
    "City": "Willard"
  },
  {
    "State": "OH",
    "City": "Wakeman"
  },
  {
    "State": "OH",
    "City": "Mansfield"
  },
  {
    "State": "OH",
    "City": "Addyston"
  },
  {
    "State": "OH",
    "City": "Cleves"
  },
  {
    "State": "OH",
    "City": "College Corner"
  },
  {
    "State": "OH",
    "City": "Collinsville"
  },
  {
    "State": "OH",
    "City": "Franklin"
  },
  {
    "State": "OH",
    "City": "Hamilton"
  },
  {
    "State": "OH",
    "City": "Fairfield"
  },
  {
    "State": "OH",
    "City": "Harrison"
  },
  {
    "State": "OH",
    "City": "Harveysburg"
  },
  {
    "State": "OH",
    "City": "Hooven"
  },
  {
    "State": "OH",
    "City": "Kings Mills"
  },
  {
    "State": "OH",
    "City": "Lebanon"
  },
  {
    "State": "OH",
    "City": "Maineville"
  },
  {
    "State": "OH",
    "City": "Mason"
  },
  {
    "State": "OH",
    "City": "Miamitown"
  },
  {
    "State": "OH",
    "City": "Middletown"
  },
  {
    "State": "OH",
    "City": "Monroe"
  },
  {
    "State": "OH",
    "City": "Mount Saint Joseph"
  },
  {
    "State": "OH",
    "City": "North Bend"
  },
  {
    "State": "OH",
    "City": "Okeana"
  },
  {
    "State": "OH",
    "City": "Oregonia"
  },
  {
    "State": "OH",
    "City": "Overpeck"
  },
  {
    "State": "OH",
    "City": "Oxford"
  },
  {
    "State": "OH",
    "City": "Ross"
  },
  {
    "State": "OH",
    "City": "Seven Mile"
  },
  {
    "State": "OH",
    "City": "Shandon"
  },
  {
    "State": "OH",
    "City": "Somerville"
  },
  {
    "State": "OH",
    "City": "South Lebanon"
  },
  {
    "State": "OH",
    "City": "Springboro"
  },
  {
    "State": "OH",
    "City": "Trenton"
  },
  {
    "State": "OH",
    "City": "Waynesville"
  },
  {
    "State": "OH",
    "City": "West Chester"
  },
  {
    "State": "OH",
    "City": "West Elkton"
  },
  {
    "State": "OH",
    "City": "Aberdeen"
  },
  {
    "State": "OH",
    "City": "Amelia"
  },
  {
    "State": "OH",
    "City": "Batavia"
  },
  {
    "State": "OH",
    "City": "Bentonville"
  },
  {
    "State": "OH",
    "City": "Bethel"
  },
  {
    "State": "OH",
    "City": "Blanchester"
  },
  {
    "State": "OH",
    "City": "Buford"
  },
  {
    "State": "OH",
    "City": "Camp Dennison"
  },
  {
    "State": "OH",
    "City": "Chilo"
  },
  {
    "State": "OH",
    "City": "Clarksville"
  },
  {
    "State": "OH",
    "City": "Cuba"
  },
  {
    "State": "OH",
    "City": "Decatur"
  },
  {
    "State": "OH",
    "City": "Fayetteville"
  },
  {
    "State": "OH",
    "City": "Feesburg"
  },
  {
    "State": "OH",
    "City": "Felicity"
  },
  {
    "State": "OH",
    "City": "Georgetown"
  },
  {
    "State": "OH",
    "City": "Goshen"
  },
  {
    "State": "OH",
    "City": "Greenfield"
  },
  {
    "State": "OH",
    "City": "Hamersville"
  },
  {
    "State": "OH",
    "City": "Higginsport"
  },
  {
    "State": "OH",
    "City": "Highland"
  },
  {
    "State": "OH",
    "City": "Hillsboro"
  },
  {
    "State": "OH",
    "City": "Leesburg"
  },
  {
    "State": "OH",
    "City": "Lees Creek"
  },
  {
    "State": "OH",
    "City": "Loveland"
  },
  {
    "State": "OH",
    "City": "Lynchburg"
  },
  {
    "State": "OH",
    "City": "Manchester"
  },
  {
    "State": "OH",
    "City": "Marathon"
  },
  {
    "State": "OH",
    "City": "Martinsville"
  },
  {
    "State": "OH",
    "City": "Miamiville"
  },
  {
    "State": "OH",
    "City": "Midland"
  },
  {
    "State": "OH",
    "City": "Milford"
  },
  {
    "State": "OH",
    "City": "Morrow"
  },
  {
    "State": "OH",
    "City": "Moscow"
  },
  {
    "State": "OH",
    "City": "Mount Orab"
  },
  {
    "State": "OH",
    "City": "Mowrystown"
  },
  {
    "State": "OH",
    "City": "Neville"
  },
  {
    "State": "OH",
    "City": "New Richmond"
  },
  {
    "State": "OH",
    "City": "Newtonsville"
  },
  {
    "State": "OH",
    "City": "New Vienna"
  },
  {
    "State": "OH",
    "City": "Owensville"
  },
  {
    "State": "OH",
    "City": "Pleasant Plain"
  },
  {
    "State": "OH",
    "City": "Port William"
  },
  {
    "State": "OH",
    "City": "Reesville"
  },
  {
    "State": "OH",
    "City": "Ripley"
  },
  {
    "State": "OH",
    "City": "Russellville"
  },
  {
    "State": "OH",
    "City": "Sabina"
  },
  {
    "State": "OH",
    "City": "Sardinia"
  },
  {
    "State": "OH",
    "City": "Sinking Spring"
  },
  {
    "State": "OH",
    "City": "Terrace Park"
  },
  {
    "State": "OH",
    "City": "Williamsburg"
  },
  {
    "State": "OH",
    "City": "Wilmington"
  },
  {
    "State": "OH",
    "City": "Cincinnati"
  },
  {
    "State": "OH",
    "City": "Alpha"
  },
  {
    "State": "OH",
    "City": "Anna"
  },
  {
    "State": "OH",
    "City": "Ansonia"
  },
  {
    "State": "OH",
    "City": "Arcanum"
  },
  {
    "State": "OH",
    "City": "Bellbrook"
  },
  {
    "State": "OH",
    "City": "Botkins"
  },
  {
    "State": "OH",
    "City": "Bowersville"
  },
  {
    "State": "OH",
    "City": "Bradford"
  },
  {
    "State": "OH",
    "City": "Brookville"
  },
  {
    "State": "OH",
    "City": "Burkettsville"
  },
  {
    "State": "OH",
    "City": "Camden"
  },
  {
    "State": "OH",
    "City": "Casstown"
  },
  {
    "State": "OH",
    "City": "Cedarville"
  },
  {
    "State": "OH",
    "City": "Clayton"
  },
  {
    "State": "OH",
    "City": "Clifton"
  },
  {
    "State": "OH",
    "City": "Conover"
  },
  {
    "State": "OH",
    "City": "Covington"
  },
  {
    "State": "OH",
    "City": "Donnelsville"
  },
  {
    "State": "OH",
    "City": "Eaton"
  },
  {
    "State": "OH",
    "City": "Eldorado"
  },
  {
    "State": "OH",
    "City": "Englewood"
  },
  {
    "State": "OH",
    "City": "Enon"
  },
  {
    "State": "OH",
    "City": "Fairborn"
  },
  {
    "State": "OH",
    "City": "Farmersville"
  },
  {
    "State": "OH",
    "City": "Fletcher"
  },
  {
    "State": "OH",
    "City": "Germantown"
  },
  {
    "State": "OH",
    "City": "Gettysburg"
  },
  {
    "State": "OH",
    "City": "Gratis"
  },
  {
    "State": "OH",
    "City": "Greenville"
  },
  {
    "State": "OH",
    "City": "Hollansburg"
  },
  {
    "State": "OH",
    "City": "Houston"
  },
  {
    "State": "OH",
    "City": "Jackson Center"
  },
  {
    "State": "OH",
    "City": "Jamestown"
  },
  {
    "State": "OH",
    "City": "Kettlersville"
  },
  {
    "State": "OH",
    "City": "Laura"
  },
  {
    "State": "OH",
    "City": "Lewisburg"
  },
  {
    "State": "OH",
    "City": "Ludlow Falls"
  },
  {
    "State": "OH",
    "City": "Maplewood"
  },
  {
    "State": "OH",
    "City": "Medway"
  },
  {
    "State": "OH",
    "City": "Miamisburg"
  },
  {
    "State": "OH",
    "City": "New Carlisle"
  },
  {
    "State": "OH",
    "City": "New Lebanon"
  },
  {
    "State": "OH",
    "City": "New Madison"
  },
  {
    "State": "OH",
    "City": "New Paris"
  },
  {
    "State": "OH",
    "City": "New Weston"
  },
  {
    "State": "OH",
    "City": "North Hampton"
  },
  {
    "State": "OH",
    "City": "North Star"
  },
  {
    "State": "OH",
    "City": "Osgood"
  },
  {
    "State": "OH",
    "City": "Palestine"
  },
  {
    "State": "OH",
    "City": "Pemberton"
  },
  {
    "State": "OH",
    "City": "Phillipsburg"
  },
  {
    "State": "OH",
    "City": "Piqua"
  },
  {
    "State": "OH",
    "City": "Pitsburg"
  },
  {
    "State": "OH",
    "City": "Pleasant Hill"
  },
  {
    "State": "OH",
    "City": "Port Jefferson"
  },
  {
    "State": "OH",
    "City": "Potsdam"
  },
  {
    "State": "OH",
    "City": "Rossburg"
  },
  {
    "State": "OH",
    "City": "Russia"
  },
  {
    "State": "OH",
    "City": "Sidney"
  },
  {
    "State": "OH",
    "City": "South Charleston"
  },
  {
    "State": "OH",
    "City": "South Vienna"
  },
  {
    "State": "OH",
    "City": "Spring Valley"
  },
  {
    "State": "OH",
    "City": "Tipp City"
  },
  {
    "State": "OH",
    "City": "Tremont City"
  },
  {
    "State": "OH",
    "City": "Troy"
  },
  {
    "State": "OH",
    "City": "Vandalia"
  },
  {
    "State": "OH",
    "City": "Verona"
  },
  {
    "State": "OH",
    "City": "Versailles"
  },
  {
    "State": "OH",
    "City": "West Alexandria"
  },
  {
    "State": "OH",
    "City": "West Manchester"
  },
  {
    "State": "OH",
    "City": "West Milton"
  },
  {
    "State": "OH",
    "City": "Wilberforce"
  },
  {
    "State": "OH",
    "City": "Xenia"
  },
  {
    "State": "OH",
    "City": "Yellow Springs"
  },
  {
    "State": "OH",
    "City": "Yorkshire"
  },
  {
    "State": "OH",
    "City": "Christiansburg"
  },
  {
    "State": "OH",
    "City": "Union City"
  },
  {
    "State": "OH",
    "City": "Dayton"
  },
  {
    "State": "OH",
    "City": "Springfield"
  },
  {
    "State": "OH",
    "City": "Chillicothe"
  },
  {
    "State": "OH",
    "City": "Bainbridge"
  },
  {
    "State": "OH",
    "City": "Beaver"
  },
  {
    "State": "OH",
    "City": "Bidwell"
  },
  {
    "State": "OH",
    "City": "Blue Creek"
  },
  {
    "State": "OH",
    "City": "Bourneville"
  },
  {
    "State": "OH",
    "City": "Cherry Fork"
  },
  {
    "State": "OH",
    "City": "Chesapeake"
  },
  {
    "State": "OH",
    "City": "Cheshire"
  },
  {
    "State": "OH",
    "City": "Coalton"
  },
  {
    "State": "OH",
    "City": "Creola"
  },
  {
    "State": "OH",
    "City": "Crown City"
  },
  {
    "State": "OH",
    "City": "Cynthiana"
  },
  {
    "State": "OH",
    "City": "Frankfort"
  },
  {
    "State": "OH",
    "City": "Franklin Furnace"
  },
  {
    "State": "OH",
    "City": "Friendship"
  },
  {
    "State": "OH",
    "City": "Gallipolis"
  },
  {
    "State": "OH",
    "City": "Hallsville"
  },
  {
    "State": "OH",
    "City": "Hamden"
  },
  {
    "State": "OH",
    "City": "Haverhill"
  },
  {
    "State": "OH",
    "City": "Ironton"
  },
  {
    "State": "OH",
    "City": "Jackson"
  },
  {
    "State": "OH",
    "City": "Jasper"
  },
  {
    "State": "OH",
    "City": "Kerr"
  },
  {
    "State": "OH",
    "City": "Kingston"
  },
  {
    "State": "OH",
    "City": "Kitts Hill"
  },
  {
    "State": "OH",
    "City": "Latham"
  },
  {
    "State": "OH",
    "City": "Londonderry"
  },
  {
    "State": "OH",
    "City": "Lucasville"
  },
  {
    "State": "OH",
    "City": "Lynx"
  },
  {
    "State": "OH",
    "City": "Mc Arthur"
  },
  {
    "State": "OH",
    "City": "Mc Dermott"
  },
  {
    "State": "OH",
    "City": "Minford"
  },
  {
    "State": "OH",
    "City": "New Plymouth"
  },
  {
    "State": "OH",
    "City": "Oak Hill"
  },
  {
    "State": "OH",
    "City": "Otway"
  },
  {
    "State": "OH",
    "City": "Patriot"
  },
  {
    "State": "OH",
    "City": "Pedro"
  },
  {
    "State": "OH",
    "City": "Peebles"
  },
  {
    "State": "OH",
    "City": "Piketon"
  },
  {
    "State": "OH",
    "City": "Portsmouth"
  },
  {
    "State": "OH",
    "City": "West Portsmouth"
  },
  {
    "State": "OH",
    "City": "Proctorville"
  },
  {
    "State": "OH",
    "City": "Rarden"
  },
  {
    "State": "OH",
    "City": "Ray"
  },
  {
    "State": "OH",
    "City": "Richmond Dale"
  },
  {
    "State": "OH",
    "City": "Rio Grande"
  },
  {
    "State": "OH",
    "City": "Rock Camp"
  },
  {
    "State": "OH",
    "City": "Scioto Furnace"
  },
  {
    "State": "OH",
    "City": "Scottown"
  },
  {
    "State": "OH",
    "City": "Seaman"
  },
  {
    "State": "OH",
    "City": "South Point"
  },
  {
    "State": "OH",
    "City": "South Salem"
  },
  {
    "State": "OH",
    "City": "South Webster"
  },
  {
    "State": "OH",
    "City": "Stockdale"
  },
  {
    "State": "OH",
    "City": "Stout"
  },
  {
    "State": "OH",
    "City": "Thurman"
  },
  {
    "State": "OH",
    "City": "Vinton"
  },
  {
    "State": "OH",
    "City": "Wakefield"
  },
  {
    "State": "OH",
    "City": "Waterloo"
  },
  {
    "State": "OH",
    "City": "Waverly"
  },
  {
    "State": "OH",
    "City": "Wellston"
  },
  {
    "State": "OH",
    "City": "West Union"
  },
  {
    "State": "OH",
    "City": "Wheelersburg"
  },
  {
    "State": "OH",
    "City": "Wilkesville"
  },
  {
    "State": "OH",
    "City": "Willow Wood"
  },
  {
    "State": "OH",
    "City": "Winchester"
  },
  {
    "State": "OH",
    "City": "Zaleski"
  },
  {
    "State": "OH",
    "City": "Athens"
  },
  {
    "State": "OH",
    "City": "Albany"
  },
  {
    "State": "OH",
    "City": "Amesville"
  },
  {
    "State": "OH",
    "City": "Barlow"
  },
  {
    "State": "OH",
    "City": "Bartlett"
  },
  {
    "State": "OH",
    "City": "Belpre"
  },
  {
    "State": "OH",
    "City": "Beverly"
  },
  {
    "State": "OH",
    "City": "Buchtel"
  },
  {
    "State": "OH",
    "City": "Carbondale"
  },
  {
    "State": "OH",
    "City": "Chauncey"
  },
  {
    "State": "OH",
    "City": "Chester"
  },
  {
    "State": "OH",
    "City": "Coal Run"
  },
  {
    "State": "OH",
    "City": "Coolville"
  },
  {
    "State": "OH",
    "City": "Cutler"
  },
  {
    "State": "OH",
    "City": "Dexter City"
  },
  {
    "State": "OH",
    "City": "Fleming"
  },
  {
    "State": "OH",
    "City": "Glouster"
  },
  {
    "State": "OH",
    "City": "Graysville"
  },
  {
    "State": "OH",
    "City": "Guysville"
  },
  {
    "State": "OH",
    "City": "Hockingport"
  },
  {
    "State": "OH",
    "City": "Jacksonville"
  },
  {
    "State": "OH",
    "City": "Langsville"
  },
  {
    "State": "OH",
    "City": "Little Hocking"
  },
  {
    "State": "OH",
    "City": "Long Bottom"
  },
  {
    "State": "OH",
    "City": "Lowell"
  },
  {
    "State": "OH",
    "City": "Lower Salem"
  },
  {
    "State": "OH",
    "City": "Macksburg"
  },
  {
    "State": "OH",
    "City": "Marietta"
  },
  {
    "State": "OH",
    "City": "Middleport"
  },
  {
    "State": "OH",
    "City": "Millfield"
  },
  {
    "State": "OH",
    "City": "Nelsonville"
  },
  {
    "State": "OH",
    "City": "New Marshfield"
  },
  {
    "State": "OH",
    "City": "New Matamoras"
  },
  {
    "State": "OH",
    "City": "Newport"
  },
  {
    "State": "OH",
    "City": "Pomeroy"
  },
  {
    "State": "OH",
    "City": "Portland"
  },
  {
    "State": "OH",
    "City": "Racine"
  },
  {
    "State": "OH",
    "City": "Reedsville"
  },
  {
    "State": "OH",
    "City": "Reno"
  },
  {
    "State": "OH",
    "City": "Rutland"
  },
  {
    "State": "OH",
    "City": "Shade"
  },
  {
    "State": "OH",
    "City": "Sharpsburg"
  },
  {
    "State": "OH",
    "City": "Stewart"
  },
  {
    "State": "OH",
    "City": "Syracuse"
  },
  {
    "State": "OH",
    "City": "The Plains"
  },
  {
    "State": "OH",
    "City": "Trimble"
  },
  {
    "State": "OH",
    "City": "Tuppers Plains"
  },
  {
    "State": "OH",
    "City": "Vincent"
  },
  {
    "State": "OH",
    "City": "Waterford"
  },
  {
    "State": "OH",
    "City": "Watertown"
  },
  {
    "State": "OH",
    "City": "Whipple"
  },
  {
    "State": "OH",
    "City": "Wingett Run"
  },
  {
    "State": "OH",
    "City": "Lima"
  },
  {
    "State": "OH",
    "City": "Beaverdam"
  },
  {
    "State": "OH",
    "City": "Gomer"
  },
  {
    "State": "OH",
    "City": "Ada"
  },
  {
    "State": "OH",
    "City": "Alger"
  },
  {
    "State": "OH",
    "City": "Antwerp"
  },
  {
    "State": "OH",
    "City": "Arlington"
  },
  {
    "State": "OH",
    "City": "Belmore"
  },
  {
    "State": "OH",
    "City": "Benton Ridge"
  },
  {
    "State": "OH",
    "City": "Bluffton"
  },
  {
    "State": "OH",
    "City": "Buckland"
  },
  {
    "State": "OH",
    "City": "Cairo"
  },
  {
    "State": "OH",
    "City": "Cecil"
  },
  {
    "State": "OH",
    "City": "Celina"
  },
  {
    "State": "OH",
    "City": "Chickasaw"
  },
  {
    "State": "OH",
    "City": "Cloverdale"
  },
  {
    "State": "OH",
    "City": "Coldwater"
  },
  {
    "State": "OH",
    "City": "Columbus Grove"
  },
  {
    "State": "OH",
    "City": "Continental"
  },
  {
    "State": "OH",
    "City": "Convoy"
  },
  {
    "State": "OH",
    "City": "Delphos"
  },
  {
    "State": "OH",
    "City": "Dola"
  },
  {
    "State": "OH",
    "City": "Dunkirk"
  },
  {
    "State": "OH",
    "City": "Dupont"
  },
  {
    "State": "OH",
    "City": "Elgin"
  },
  {
    "State": "OH",
    "City": "Findlay"
  },
  {
    "State": "OH",
    "City": "Jenera"
  },
  {
    "State": "OH",
    "City": "Forest"
  },
  {
    "State": "OH",
    "City": "Fort Jennings"
  },
  {
    "State": "OH",
    "City": "Fort Loramie"
  },
  {
    "State": "OH",
    "City": "Fort Recovery"
  },
  {
    "State": "OH",
    "City": "Glandorf"
  },
  {
    "State": "OH",
    "City": "Grover Hill"
  },
  {
    "State": "OH",
    "City": "Harrod"
  },
  {
    "State": "OH",
    "City": "Haviland"
  },
  {
    "State": "OH",
    "City": "Kalida"
  },
  {
    "State": "OH",
    "City": "Lafayette"
  },
  {
    "State": "OH",
    "City": "Latty"
  },
  {
    "State": "OH",
    "City": "Leipsic"
  },
  {
    "State": "OH",
    "City": "Mc Comb"
  },
  {
    "State": "OH",
    "City": "Mc Guffey"
  },
  {
    "State": "OH",
    "City": "Maria Stein"
  },
  {
    "State": "OH",
    "City": "Melrose"
  },
  {
    "State": "OH",
    "City": "Mendon"
  },
  {
    "State": "OH",
    "City": "Middle Point"
  },
  {
    "State": "OH",
    "City": "Miller City"
  },
  {
    "State": "OH",
    "City": "Minster"
  },
  {
    "State": "OH",
    "City": "Montezuma"
  },
  {
    "State": "OH",
    "City": "Mount Blanchard"
  },
  {
    "State": "OH",
    "City": "Mount Cory"
  },
  {
    "State": "OH",
    "City": "New Bremen"
  },
  {
    "State": "OH",
    "City": "New Hampshire"
  },
  {
    "State": "OH",
    "City": "New Knoxville"
  },
  {
    "State": "OH",
    "City": "North Baltimore"
  },
  {
    "State": "OH",
    "City": "Oakwood"
  },
  {
    "State": "OH",
    "City": "Ohio City"
  },
  {
    "State": "OH",
    "City": "Ottawa"
  },
  {
    "State": "OH",
    "City": "Ottoville"
  },
  {
    "State": "OH",
    "City": "Pandora"
  },
  {
    "State": "OH",
    "City": "Paulding"
  },
  {
    "State": "OH",
    "City": "Payne"
  },
  {
    "State": "OH",
    "City": "Rawson"
  },
  {
    "State": "OH",
    "City": "Rockford"
  },
  {
    "State": "OH",
    "City": "Saint Henry"
  },
  {
    "State": "OH",
    "City": "Saint Johns"
  },
  {
    "State": "OH",
    "City": "Saint Marys"
  },
  {
    "State": "OH",
    "City": "Scott"
  },
  {
    "State": "OH",
    "City": "Spencerville"
  },
  {
    "State": "OH",
    "City": "Uniopolis"
  },
  {
    "State": "OH",
    "City": "Van Buren"
  },
  {
    "State": "OH",
    "City": "Vanlue"
  },
  {
    "State": "OH",
    "City": "Van Wert"
  },
  {
    "State": "OH",
    "City": "Vaughnsville"
  },
  {
    "State": "OH",
    "City": "Venedocia"
  },
  {
    "State": "OH",
    "City": "Wapakoneta"
  },
  {
    "State": "OH",
    "City": "Waynesfield"
  },
  {
    "State": "OH",
    "City": "Williamstown"
  },
  {
    "State": "OH",
    "City": "Willshire"
  },
  {
    "State": "OH",
    "City": "Wren"
  },
  {
    "State": "IN",
    "City": "Alexandria"
  },
  {
    "State": "IN",
    "City": "Anderson"
  },
  {
    "State": "IN",
    "City": "Arcadia"
  },
  {
    "State": "IN",
    "City": "Atlanta"
  },
  {
    "State": "IN",
    "City": "Carmel"
  },
  {
    "State": "IN",
    "City": "Cicero"
  },
  {
    "State": "IN",
    "City": "Colfax"
  },
  {
    "State": "IN",
    "City": "Elwood"
  },
  {
    "State": "IN",
    "City": "Fishers"
  },
  {
    "State": "IN",
    "City": "Forest"
  },
  {
    "State": "IN",
    "City": "Fortville"
  },
  {
    "State": "IN",
    "City": "Frankfort"
  },
  {
    "State": "IN",
    "City": "Frankton"
  },
  {
    "State": "IN",
    "City": "Goldsmith"
  },
  {
    "State": "IN",
    "City": "Hobbs"
  },
  {
    "State": "IN",
    "City": "Ingalls"
  },
  {
    "State": "IN",
    "City": "Kempton"
  },
  {
    "State": "IN",
    "City": "Kirklin"
  },
  {
    "State": "IN",
    "City": "Lapel"
  },
  {
    "State": "IN",
    "City": "Lebanon"
  },
  {
    "State": "IN",
    "City": "Mccordsville"
  },
  {
    "State": "IN",
    "City": "Markleville"
  },
  {
    "State": "IN",
    "City": "Michigantown"
  },
  {
    "State": "IN",
    "City": "Mulberry"
  },
  {
    "State": "IN",
    "City": "Noblesville"
  },
  {
    "State": "IN",
    "City": "Orestes"
  },
  {
    "State": "IN",
    "City": "Pendleton"
  },
  {
    "State": "IN",
    "City": "Rossville"
  },
  {
    "State": "IN",
    "City": "Sedalia"
  },
  {
    "State": "IN",
    "City": "Sharpsville"
  },
  {
    "State": "IN",
    "City": "Sheridan"
  },
  {
    "State": "IN",
    "City": "Summitville"
  },
  {
    "State": "IN",
    "City": "Thorntown"
  },
  {
    "State": "IN",
    "City": "Tipton"
  },
  {
    "State": "IN",
    "City": "Westfield"
  },
  {
    "State": "IN",
    "City": "Whitestown"
  },
  {
    "State": "IN",
    "City": "Windfall"
  },
  {
    "State": "IN",
    "City": "Zionsville"
  },
  {
    "State": "IN",
    "City": "Advance"
  },
  {
    "State": "IN",
    "City": "Amo"
  },
  {
    "State": "IN",
    "City": "Arlington"
  },
  {
    "State": "IN",
    "City": "Bainbridge"
  },
  {
    "State": "IN",
    "City": "Bargersville"
  },
  {
    "State": "IN",
    "City": "Beech Grove"
  },
  {
    "State": "IN",
    "City": "Boggstown"
  },
  {
    "State": "IN",
    "City": "Brooklyn"
  },
  {
    "State": "IN",
    "City": "Brownsburg"
  },
  {
    "State": "IN",
    "City": "Camby"
  },
  {
    "State": "IN",
    "City": "Carthage"
  },
  {
    "State": "IN",
    "City": "Charlottesville"
  },
  {
    "State": "IN",
    "City": "Clayton"
  },
  {
    "State": "IN",
    "City": "Cloverdale"
  },
  {
    "State": "IN",
    "City": "Coatesville"
  },
  {
    "State": "IN",
    "City": "Danville"
  },
  {
    "State": "IN",
    "City": "Avon"
  },
  {
    "State": "IN",
    "City": "Edinburgh"
  },
  {
    "State": "IN",
    "City": "Eminence"
  },
  {
    "State": "IN",
    "City": "Fairland"
  },
  {
    "State": "IN",
    "City": "Falmouth"
  },
  {
    "State": "IN",
    "City": "Fillmore"
  },
  {
    "State": "IN",
    "City": "Finly"
  },
  {
    "State": "IN",
    "City": "Fountaintown"
  },
  {
    "State": "IN",
    "City": "Franklin"
  },
  {
    "State": "IN",
    "City": "Glenwood"
  },
  {
    "State": "IN",
    "City": "Greencastle"
  },
  {
    "State": "IN",
    "City": "Greenfield"
  },
  {
    "State": "IN",
    "City": "Greenwood"
  },
  {
    "State": "IN",
    "City": "Gwynneville"
  },
  {
    "State": "IN",
    "City": "Homer"
  },
  {
    "State": "IN",
    "City": "Jamestown"
  },
  {
    "State": "IN",
    "City": "Knightstown"
  },
  {
    "State": "IN",
    "City": "Lizton"
  },
  {
    "State": "IN",
    "City": "Manilla"
  },
  {
    "State": "IN",
    "City": "Martinsville"
  },
  {
    "State": "IN",
    "City": "Maxwell"
  },
  {
    "State": "IN",
    "City": "Mays"
  },
  {
    "State": "IN",
    "City": "Milroy"
  },
  {
    "State": "IN",
    "City": "Monrovia"
  },
  {
    "State": "IN",
    "City": "Mooresville"
  },
  {
    "State": "IN",
    "City": "Morgantown"
  },
  {
    "State": "IN",
    "City": "Morristown"
  },
  {
    "State": "IN",
    "City": "Needham"
  },
  {
    "State": "IN",
    "City": "New Palestine"
  },
  {
    "State": "IN",
    "City": "Nineveh"
  },
  {
    "State": "IN",
    "City": "North Salem"
  },
  {
    "State": "IN",
    "City": "Paragon"
  },
  {
    "State": "IN",
    "City": "Pittsboro"
  },
  {
    "State": "IN",
    "City": "Plainfield"
  },
  {
    "State": "IN",
    "City": "Putnamville"
  },
  {
    "State": "IN",
    "City": "Reelsville"
  },
  {
    "State": "IN",
    "City": "Roachdale"
  },
  {
    "State": "IN",
    "City": "Rushville"
  },
  {
    "State": "IN",
    "City": "Russellville"
  },
  {
    "State": "IN",
    "City": "Shelbyville"
  },
  {
    "State": "IN",
    "City": "Stilesville"
  },
  {
    "State": "IN",
    "City": "Trafalgar"
  },
  {
    "State": "IN",
    "City": "Waldron"
  },
  {
    "State": "IN",
    "City": "West Newton"
  },
  {
    "State": "IN",
    "City": "Whiteland"
  },
  {
    "State": "IN",
    "City": "Wilkinson"
  },
  {
    "State": "IN",
    "City": "Indianapolis"
  },
  {
    "State": "IN",
    "City": "Beverly Shores"
  },
  {
    "State": "IN",
    "City": "Boone Grove"
  },
  {
    "State": "IN",
    "City": "Cedar Lake"
  },
  {
    "State": "IN",
    "City": "Chesterton"
  },
  {
    "State": "IN",
    "City": "Crown Point"
  },
  {
    "State": "IN",
    "City": "Demotte"
  },
  {
    "State": "IN",
    "City": "Dyer"
  },
  {
    "State": "IN",
    "City": "East Chicago"
  },
  {
    "State": "IN",
    "City": "Griffith"
  },
  {
    "State": "IN",
    "City": "Hammond"
  },
  {
    "State": "IN",
    "City": "Munster"
  },
  {
    "State": "IN",
    "City": "Highland"
  },
  {
    "State": "IN",
    "City": "Hanna"
  },
  {
    "State": "IN",
    "City": "Hebron"
  },
  {
    "State": "IN",
    "City": "Hobart"
  },
  {
    "State": "IN",
    "City": "Kingsbury"
  },
  {
    "State": "IN",
    "City": "Kingsford Heights"
  },
  {
    "State": "IN",
    "City": "Kouts"
  },
  {
    "State": "IN",
    "City": "La Crosse"
  },
  {
    "State": "IN",
    "City": "Lake Village"
  },
  {
    "State": "IN",
    "City": "La Porte"
  },
  {
    "State": "IN",
    "City": "Leroy"
  },
  {
    "State": "IN",
    "City": "Lowell"
  },
  {
    "State": "IN",
    "City": "Michigan City"
  },
  {
    "State": "IN",
    "City": "Mill Creek"
  },
  {
    "State": "IN",
    "City": "North Judson"
  },
  {
    "State": "IN",
    "City": "Portage"
  },
  {
    "State": "IN",
    "City": "Rolling Prairie"
  },
  {
    "State": "IN",
    "City": "Roselawn"
  },
  {
    "State": "IN",
    "City": "Saint John"
  },
  {
    "State": "IN",
    "City": "San Pierre"
  },
  {
    "State": "IN",
    "City": "Schererville"
  },
  {
    "State": "IN",
    "City": "Schneider"
  },
  {
    "State": "IN",
    "City": "Shelby"
  },
  {
    "State": "IN",
    "City": "Sumava Resorts"
  },
  {
    "State": "IN",
    "City": "Tefft"
  },
  {
    "State": "IN",
    "City": "Thayer"
  },
  {
    "State": "IN",
    "City": "Union Mills"
  },
  {
    "State": "IN",
    "City": "Valparaiso"
  },
  {
    "State": "IN",
    "City": "Wanatah"
  },
  {
    "State": "IN",
    "City": "Westville"
  },
  {
    "State": "IN",
    "City": "Wheatfield"
  },
  {
    "State": "IN",
    "City": "Wheeler"
  },
  {
    "State": "IN",
    "City": "Whiting"
  },
  {
    "State": "IN",
    "City": "Gary"
  },
  {
    "State": "IN",
    "City": "Lake Station"
  },
  {
    "State": "IN",
    "City": "Merrillville"
  },
  {
    "State": "IN",
    "City": "Argos"
  },
  {
    "State": "IN",
    "City": "Atwood"
  },
  {
    "State": "IN",
    "City": "Bourbon"
  },
  {
    "State": "IN",
    "City": "Bremen"
  },
  {
    "State": "IN",
    "City": "Bristol"
  },
  {
    "State": "IN",
    "City": "Burket"
  },
  {
    "State": "IN",
    "City": "Claypool"
  },
  {
    "State": "IN",
    "City": "Culver"
  },
  {
    "State": "IN",
    "City": "Donaldson"
  },
  {
    "State": "IN",
    "City": "Elkhart"
  },
  {
    "State": "IN",
    "City": "Etna Green"
  },
  {
    "State": "IN",
    "City": "Goshen"
  },
  {
    "State": "IN",
    "City": "Granger"
  },
  {
    "State": "IN",
    "City": "Grovertown"
  },
  {
    "State": "IN",
    "City": "Hamlet"
  },
  {
    "State": "IN",
    "City": "Knox"
  },
  {
    "State": "IN",
    "City": "Lakeville"
  },
  {
    "State": "IN",
    "City": "Lapaz"
  },
  {
    "State": "IN",
    "City": "Leesburg"
  },
  {
    "State": "IN",
    "City": "Mentone"
  },
  {
    "State": "IN",
    "City": "Middlebury"
  },
  {
    "State": "IN",
    "City": "Milford"
  },
  {
    "State": "IN",
    "City": "Millersburg"
  },
  {
    "State": "IN",
    "City": "Mishawaka"
  },
  {
    "State": "IN",
    "City": "Nappanee"
  },
  {
    "State": "IN",
    "City": "New Carlisle"
  },
  {
    "State": "IN",
    "City": "New Paris"
  },
  {
    "State": "IN",
    "City": "North Liberty"
  },
  {
    "State": "IN",
    "City": "North Webster"
  },
  {
    "State": "IN",
    "City": "Notre Dame"
  },
  {
    "State": "IN",
    "City": "Osceola"
  },
  {
    "State": "IN",
    "City": "Pierceton"
  },
  {
    "State": "IN",
    "City": "Plymouth"
  },
  {
    "State": "IN",
    "City": "Shipshewana"
  },
  {
    "State": "IN",
    "City": "Syracuse"
  },
  {
    "State": "IN",
    "City": "Tippecanoe"
  },
  {
    "State": "IN",
    "City": "Topeka"
  },
  {
    "State": "IN",
    "City": "Tyner"
  },
  {
    "State": "IN",
    "City": "Wakarusa"
  },
  {
    "State": "IN",
    "City": "Walkerton"
  },
  {
    "State": "IN",
    "City": "Warsaw"
  },
  {
    "State": "IN",
    "City": "Winona Lake"
  },
  {
    "State": "IN",
    "City": "Wyatt"
  },
  {
    "State": "IN",
    "City": "South Bend"
  },
  {
    "State": "IN",
    "City": "Albion"
  },
  {
    "State": "IN",
    "City": "Andrews"
  },
  {
    "State": "IN",
    "City": "Angola"
  },
  {
    "State": "IN",
    "City": "Arcola"
  },
  {
    "State": "IN",
    "City": "Ashley"
  },
  {
    "State": "IN",
    "City": "Auburn"
  },
  {
    "State": "IN",
    "City": "Avilla"
  },
  {
    "State": "IN",
    "City": "Berne"
  },
  {
    "State": "IN",
    "City": "Bippus"
  },
  {
    "State": "IN",
    "City": "Bluffton"
  },
  {
    "State": "IN",
    "City": "Butler"
  },
  {
    "State": "IN",
    "City": "Churubusco"
  },
  {
    "State": "IN",
    "City": "Columbia City"
  },
  {
    "State": "IN",
    "City": "Corunna"
  },
  {
    "State": "IN",
    "City": "Craigville"
  },
  {
    "State": "IN",
    "City": "Cromwell"
  },
  {
    "State": "IN",
    "City": "Decatur"
  },
  {
    "State": "IN",
    "City": "Fremont"
  },
  {
    "State": "IN",
    "City": "Garrett"
  },
  {
    "State": "IN",
    "City": "Geneva"
  },
  {
    "State": "IN",
    "City": "Grabill"
  },
  {
    "State": "IN",
    "City": "Hamilton"
  },
  {
    "State": "IN",
    "City": "Harlan"
  },
  {
    "State": "IN",
    "City": "Hoagland"
  },
  {
    "State": "IN",
    "City": "Howe"
  },
  {
    "State": "IN",
    "City": "Hudson"
  },
  {
    "State": "IN",
    "City": "Huntertown"
  },
  {
    "State": "IN",
    "City": "Huntington"
  },
  {
    "State": "IN",
    "City": "Kendallville"
  },
  {
    "State": "IN",
    "City": "Keystone"
  },
  {
    "State": "IN",
    "City": "Kimmell"
  },
  {
    "State": "IN",
    "City": "Lagrange"
  },
  {
    "State": "IN",
    "City": "Laotto"
  },
  {
    "State": "IN",
    "City": "Larwill"
  },
  {
    "State": "IN",
    "City": "Leo"
  },
  {
    "State": "IN",
    "City": "Liberty Center"
  },
  {
    "State": "IN",
    "City": "Ligonier"
  },
  {
    "State": "IN",
    "City": "Linn Grove"
  },
  {
    "State": "IN",
    "City": "Markle"
  },
  {
    "State": "IN",
    "City": "Mongo"
  },
  {
    "State": "IN",
    "City": "Monroe"
  },
  {
    "State": "IN",
    "City": "Monroeville"
  },
  {
    "State": "IN",
    "City": "New Haven"
  },
  {
    "State": "IN",
    "City": "Orland"
  },
  {
    "State": "IN",
    "City": "Ossian"
  },
  {
    "State": "IN",
    "City": "Petroleum"
  },
  {
    "State": "IN",
    "City": "Pleasant Lake"
  },
  {
    "State": "IN",
    "City": "Pleasant Mills"
  },
  {
    "State": "IN",
    "City": "Poneto"
  },
  {
    "State": "IN",
    "City": "Preble"
  },
  {
    "State": "IN",
    "City": "Roanoke"
  },
  {
    "State": "IN",
    "City": "Rome City"
  },
  {
    "State": "IN",
    "City": "Saint Joe"
  },
  {
    "State": "IN",
    "City": "South Milford"
  },
  {
    "State": "IN",
    "City": "South Whitley"
  },
  {
    "State": "IN",
    "City": "Spencerville"
  },
  {
    "State": "IN",
    "City": "Stroh"
  },
  {
    "State": "IN",
    "City": "Uniondale"
  },
  {
    "State": "IN",
    "City": "Warren"
  },
  {
    "State": "IN",
    "City": "Waterloo"
  },
  {
    "State": "IN",
    "City": "Wawaka"
  },
  {
    "State": "IN",
    "City": "Wolcottville"
  },
  {
    "State": "IN",
    "City": "Wolflake"
  },
  {
    "State": "IN",
    "City": "Woodburn"
  },
  {
    "State": "IN",
    "City": "Yoder"
  },
  {
    "State": "IN",
    "City": "Zanesville"
  },
  {
    "State": "IN",
    "City": "Fort Wayne"
  },
  {
    "State": "IN",
    "City": "Kokomo"
  },
  {
    "State": "IN",
    "City": "Akron"
  },
  {
    "State": "IN",
    "City": "Amboy"
  },
  {
    "State": "IN",
    "City": "Athens"
  },
  {
    "State": "IN",
    "City": "Bringhurst"
  },
  {
    "State": "IN",
    "City": "Bunker Hill"
  },
  {
    "State": "IN",
    "City": "Burlington"
  },
  {
    "State": "IN",
    "City": "Burrows"
  },
  {
    "State": "IN",
    "City": "Camden"
  },
  {
    "State": "IN",
    "City": "Converse"
  },
  {
    "State": "IN",
    "City": "Cutler"
  },
  {
    "State": "IN",
    "City": "Deedsville"
  },
  {
    "State": "IN",
    "City": "Delong"
  },
  {
    "State": "IN",
    "City": "Delphi"
  },
  {
    "State": "IN",
    "City": "Denver"
  },
  {
    "State": "IN",
    "City": "Fairmount"
  },
  {
    "State": "IN",
    "City": "Flora"
  },
  {
    "State": "IN",
    "City": "Fowlerton"
  },
  {
    "State": "IN",
    "City": "Fulton"
  },
  {
    "State": "IN",
    "City": "Galveston"
  },
  {
    "State": "IN",
    "City": "Gas City"
  },
  {
    "State": "IN",
    "City": "Grass Creek"
  },
  {
    "State": "IN",
    "City": "Greentown"
  },
  {
    "State": "IN",
    "City": "Hemlock"
  },
  {
    "State": "IN",
    "City": "Jonesboro"
  },
  {
    "State": "IN",
    "City": "Kewanna"
  },
  {
    "State": "IN",
    "City": "La Fontaine"
  },
  {
    "State": "IN",
    "City": "Lagro"
  },
  {
    "State": "IN",
    "City": "Lake Cicott"
  },
  {
    "State": "IN",
    "City": "Laketon"
  },
  {
    "State": "IN",
    "City": "Leiters Ford"
  },
  {
    "State": "IN",
    "City": "Liberty Mills"
  },
  {
    "State": "IN",
    "City": "Logansport"
  },
  {
    "State": "IN",
    "City": "Lucerne"
  },
  {
    "State": "IN",
    "City": "Macy"
  },
  {
    "State": "IN",
    "City": "Marion"
  },
  {
    "State": "IN",
    "City": "Matthews"
  },
  {
    "State": "IN",
    "City": "Mexico"
  },
  {
    "State": "IN",
    "City": "Miami"
  },
  {
    "State": "IN",
    "City": "Monterey"
  },
  {
    "State": "IN",
    "City": "New Waverly"
  },
  {
    "State": "IN",
    "City": "North Manchester"
  },
  {
    "State": "IN",
    "City": "Oakford"
  },
  {
    "State": "IN",
    "City": "Onward"
  },
  {
    "State": "IN",
    "City": "Ora"
  },
  {
    "State": "IN",
    "City": "Peru"
  },
  {
    "State": "IN",
    "City": "Grissom Arb"
  },
  {
    "State": "IN",
    "City": "Roann"
  },
  {
    "State": "IN",
    "City": "Rochester"
  },
  {
    "State": "IN",
    "City": "Rockfield"
  },
  {
    "State": "IN",
    "City": "Royal Center"
  },
  {
    "State": "IN",
    "City": "Russiaville"
  },
  {
    "State": "IN",
    "City": "Servia"
  },
  {
    "State": "IN",
    "City": "Silver Lake"
  },
  {
    "State": "IN",
    "City": "Somerset"
  },
  {
    "State": "IN",
    "City": "Star City"
  },
  {
    "State": "IN",
    "City": "Swayzee"
  },
  {
    "State": "IN",
    "City": "Sweetser"
  },
  {
    "State": "IN",
    "City": "Twelve Mile"
  },
  {
    "State": "IN",
    "City": "Upland"
  },
  {
    "State": "IN",
    "City": "Urbana"
  },
  {
    "State": "IN",
    "City": "Van Buren"
  },
  {
    "State": "IN",
    "City": "Wabash"
  },
  {
    "State": "IN",
    "City": "Walton"
  },
  {
    "State": "IN",
    "City": "West Middleton"
  },
  {
    "State": "IN",
    "City": "Winamac"
  },
  {
    "State": "IN",
    "City": "Young America"
  },
  {
    "State": "IN",
    "City": "Aurora"
  },
  {
    "State": "IN",
    "City": "West College Corner"
  },
  {
    "State": "IN",
    "City": "Batesville"
  },
  {
    "State": "IN",
    "City": "Bath"
  },
  {
    "State": "IN",
    "City": "Bennington"
  },
  {
    "State": "IN",
    "City": "Brookville"
  },
  {
    "State": "IN",
    "City": "Cedar Grove"
  },
  {
    "State": "IN",
    "City": "Cross Plains"
  },
  {
    "State": "IN",
    "City": "Dillsboro"
  },
  {
    "State": "IN",
    "City": "East Enterprise"
  },
  {
    "State": "IN",
    "City": "Florence"
  },
  {
    "State": "IN",
    "City": "Friendship"
  },
  {
    "State": "IN",
    "City": "Guilford"
  },
  {
    "State": "IN",
    "City": "Holton"
  },
  {
    "State": "IN",
    "City": "Laurel"
  },
  {
    "State": "IN",
    "City": "Lawrenceburg"
  },
  {
    "State": "IN",
    "City": "Metamora"
  },
  {
    "State": "IN",
    "City": "Milan"
  },
  {
    "State": "IN",
    "City": "Moores Hill"
  },
  {
    "State": "IN",
    "City": "Morris"
  },
  {
    "State": "IN",
    "City": "Napoleon"
  },
  {
    "State": "IN",
    "City": "New Trenton"
  },
  {
    "State": "IN",
    "City": "Oldenburg"
  },
  {
    "State": "IN",
    "City": "Osgood"
  },
  {
    "State": "IN",
    "City": "Patriot"
  },
  {
    "State": "IN",
    "City": "Pierceville"
  },
  {
    "State": "IN",
    "City": "Rising Sun"
  },
  {
    "State": "IN",
    "City": "Sunman"
  },
  {
    "State": "IN",
    "City": "Versailles"
  },
  {
    "State": "IN",
    "City": "Vevay"
  },
  {
    "State": "IN",
    "City": "West Harrison"
  },
  {
    "State": "IN",
    "City": "Austin"
  },
  {
    "State": "IN",
    "City": "Bethlehem"
  },
  {
    "State": "IN",
    "City": "Borden"
  },
  {
    "State": "IN",
    "City": "Bradford"
  },
  {
    "State": "IN",
    "City": "Campbellsburg"
  },
  {
    "State": "IN",
    "City": "Central"
  },
  {
    "State": "IN",
    "City": "Charlestown"
  },
  {
    "State": "IN",
    "City": "Corydon"
  },
  {
    "State": "IN",
    "City": "Crandall"
  },
  {
    "State": "IN",
    "City": "Depauw"
  },
  {
    "State": "IN",
    "City": "Eckerty"
  },
  {
    "State": "IN",
    "City": "Elizabeth"
  },
  {
    "State": "IN",
    "City": "English"
  },
  {
    "State": "IN",
    "City": "Floyds Knobs"
  },
  {
    "State": "IN",
    "City": "Fredericksburg"
  },
  {
    "State": "IN",
    "City": "Georgetown"
  },
  {
    "State": "IN",
    "City": "Grantsburg"
  },
  {
    "State": "IN",
    "City": "Greenville"
  },
  {
    "State": "IN",
    "City": "Hardinsburg"
  },
  {
    "State": "IN",
    "City": "Henryville"
  },
  {
    "State": "IN",
    "City": "Clarksville"
  },
  {
    "State": "IN",
    "City": "Jeffersonville"
  },
  {
    "State": "IN",
    "City": "Laconia"
  },
  {
    "State": "IN",
    "City": "Lanesville"
  },
  {
    "State": "IN",
    "City": "Leavenworth"
  },
  {
    "State": "IN",
    "City": "Lexington"
  },
  {
    "State": "IN",
    "City": "Little York"
  },
  {
    "State": "IN",
    "City": "Marengo"
  },
  {
    "State": "IN",
    "City": "Marysville"
  },
  {
    "State": "IN",
    "City": "Mauckport"
  },
  {
    "State": "IN",
    "City": "Memphis"
  },
  {
    "State": "IN",
    "City": "Milltown"
  },
  {
    "State": "IN",
    "City": "Mount Saint Francis"
  },
  {
    "State": "IN",
    "City": "Nabb"
  },
  {
    "State": "IN",
    "City": "New Albany"
  },
  {
    "State": "IN",
    "City": "New Middletown"
  },
  {
    "State": "IN",
    "City": "New Salisbury"
  },
  {
    "State": "IN",
    "City": "New Washington"
  },
  {
    "State": "IN",
    "City": "Otisco"
  },
  {
    "State": "IN",
    "City": "Palmyra"
  },
  {
    "State": "IN",
    "City": "Pekin"
  },
  {
    "State": "IN",
    "City": "Ramsey"
  },
  {
    "State": "IN",
    "City": "Salem"
  },
  {
    "State": "IN",
    "City": "Scottsburg"
  },
  {
    "State": "IN",
    "City": "Sellersburg"
  },
  {
    "State": "IN",
    "City": "Sulphur"
  },
  {
    "State": "IN",
    "City": "Taswell"
  },
  {
    "State": "IN",
    "City": "Underwood"
  },
  {
    "State": "IN",
    "City": "Columbus"
  },
  {
    "State": "IN",
    "City": "Brownstown"
  },
  {
    "State": "IN",
    "City": "Butlerville"
  },
  {
    "State": "IN",
    "City": "Canaan"
  },
  {
    "State": "IN",
    "City": "Clarksburg"
  },
  {
    "State": "IN",
    "City": "Clifford"
  },
  {
    "State": "IN",
    "City": "Commiskey"
  },
  {
    "State": "IN",
    "City": "Cortland"
  },
  {
    "State": "IN",
    "City": "Crothersville"
  },
  {
    "State": "IN",
    "City": "Deputy"
  },
  {
    "State": "IN",
    "City": "Dupont"
  },
  {
    "State": "IN",
    "City": "Elizabethtown"
  },
  {
    "State": "IN",
    "City": "Flat Rock"
  },
  {
    "State": "IN",
    "City": "Freetown"
  },
  {
    "State": "IN",
    "City": "Grammer"
  },
  {
    "State": "IN",
    "City": "Greensburg"
  },
  {
    "State": "IN",
    "City": "Hanover"
  },
  {
    "State": "IN",
    "City": "Hartsville"
  },
  {
    "State": "IN",
    "City": "Hayden"
  },
  {
    "State": "IN",
    "City": "Hope"
  },
  {
    "State": "IN",
    "City": "Jonesville"
  },
  {
    "State": "IN",
    "City": "Kurtz"
  },
  {
    "State": "IN",
    "City": "Madison"
  },
  {
    "State": "IN",
    "City": "Medora"
  },
  {
    "State": "IN",
    "City": "Millhousen"
  },
  {
    "State": "IN",
    "City": "New Point"
  },
  {
    "State": "IN",
    "City": "Norman"
  },
  {
    "State": "IN",
    "City": "North Vernon"
  },
  {
    "State": "IN",
    "City": "Paris Crossing"
  },
  {
    "State": "IN",
    "City": "Saint Paul"
  },
  {
    "State": "IN",
    "City": "Scipio"
  },
  {
    "State": "IN",
    "City": "Seymour"
  },
  {
    "State": "IN",
    "City": "Taylorsville"
  },
  {
    "State": "IN",
    "City": "Vallonia"
  },
  {
    "State": "IN",
    "City": "Vernon"
  },
  {
    "State": "IN",
    "City": "Westport"
  },
  {
    "State": "IN",
    "City": "Muncie"
  },
  {
    "State": "IN",
    "City": "Albany"
  },
  {
    "State": "IN",
    "City": "Bentonville"
  },
  {
    "State": "IN",
    "City": "Boston"
  },
  {
    "State": "IN",
    "City": "Brownsville"
  },
  {
    "State": "IN",
    "City": "Bryant"
  },
  {
    "State": "IN",
    "City": "Cambridge City"
  },
  {
    "State": "IN",
    "City": "Centerville"
  },
  {
    "State": "IN",
    "City": "Connersville"
  },
  {
    "State": "IN",
    "City": "Daleville"
  },
  {
    "State": "IN",
    "City": "Dublin"
  },
  {
    "State": "IN",
    "City": "Dunkirk"
  },
  {
    "State": "IN",
    "City": "Dunreith"
  },
  {
    "State": "IN",
    "City": "Eaton"
  },
  {
    "State": "IN",
    "City": "Economy"
  },
  {
    "State": "IN",
    "City": "Farmland"
  },
  {
    "State": "IN",
    "City": "Fountain City"
  },
  {
    "State": "IN",
    "City": "Gaston"
  },
  {
    "State": "IN",
    "City": "Greensboro"
  },
  {
    "State": "IN",
    "City": "Greens Fork"
  },
  {
    "State": "IN",
    "City": "Hagerstown"
  },
  {
    "State": "IN",
    "City": "Hartford City"
  },
  {
    "State": "IN",
    "City": "Kennard"
  },
  {
    "State": "IN",
    "City": "Lewisville"
  },
  {
    "State": "IN",
    "City": "Liberty"
  },
  {
    "State": "IN",
    "City": "Losantville"
  },
  {
    "State": "IN",
    "City": "Lynn"
  },
  {
    "State": "IN",
    "City": "Middletown"
  },
  {
    "State": "IN",
    "City": "Milton"
  },
  {
    "State": "IN",
    "City": "Modoc"
  },
  {
    "State": "IN",
    "City": "Montpelier"
  },
  {
    "State": "IN",
    "City": "Mooreland"
  },
  {
    "State": "IN",
    "City": "Mount Summit"
  },
  {
    "State": "IN",
    "City": "New Castle"
  },
  {
    "State": "IN",
    "City": "New Lisbon"
  },
  {
    "State": "IN",
    "City": "Oakville"
  },
  {
    "State": "IN",
    "City": "Parker City"
  },
  {
    "State": "IN",
    "City": "Pennville"
  },
  {
    "State": "IN",
    "City": "Pershing"
  },
  {
    "State": "IN",
    "City": "Portland"
  },
  {
    "State": "IN",
    "City": "Redkey"
  },
  {
    "State": "IN",
    "City": "Richmond"
  },
  {
    "State": "IN",
    "City": "Ridgeville"
  },
  {
    "State": "IN",
    "City": "Salamonia"
  },
  {
    "State": "IN",
    "City": "Saratoga"
  },
  {
    "State": "IN",
    "City": "Selma"
  },
  {
    "State": "IN",
    "City": "Shirley"
  },
  {
    "State": "IN",
    "City": "Spiceland"
  },
  {
    "State": "IN",
    "City": "Springport"
  },
  {
    "State": "IN",
    "City": "Straughn"
  },
  {
    "State": "IN",
    "City": "Sulphur Springs"
  },
  {
    "State": "IN",
    "City": "Union City"
  },
  {
    "State": "IN",
    "City": "Webster"
  },
  {
    "State": "IN",
    "City": "Williamsburg"
  },
  {
    "State": "IN",
    "City": "Winchester"
  },
  {
    "State": "IN",
    "City": "Yorktown"
  },
  {
    "State": "IN",
    "City": "Bloomington"
  },
  {
    "State": "IN",
    "City": "Avoca"
  },
  {
    "State": "IN",
    "City": "Bedford"
  },
  {
    "State": "IN",
    "City": "Bloomfield"
  },
  {
    "State": "IN",
    "City": "Clear Creek"
  },
  {
    "State": "IN",
    "City": "Coal City"
  },
  {
    "State": "IN",
    "City": "Ellettsville"
  },
  {
    "State": "IN",
    "City": "Fort Ritner"
  },
  {
    "State": "IN",
    "City": "Freedom"
  },
  {
    "State": "IN",
    "City": "French Lick"
  },
  {
    "State": "IN",
    "City": "Gosport"
  },
  {
    "State": "IN",
    "City": "Harrodsburg"
  },
  {
    "State": "IN",
    "City": "Helmsburg"
  },
  {
    "State": "IN",
    "City": "Heltonville"
  },
  {
    "State": "IN",
    "City": "Huron"
  },
  {
    "State": "IN",
    "City": "Jasonville"
  },
  {
    "State": "IN",
    "City": "Koleen"
  },
  {
    "State": "IN",
    "City": "Linton"
  },
  {
    "State": "IN",
    "City": "Lyons"
  },
  {
    "State": "IN",
    "City": "Midland"
  },
  {
    "State": "IN",
    "City": "Mitchell"
  },
  {
    "State": "IN",
    "City": "Nashville"
  },
  {
    "State": "IN",
    "City": "Newberry"
  },
  {
    "State": "IN",
    "City": "Oolitic"
  },
  {
    "State": "IN",
    "City": "Orleans"
  },
  {
    "State": "IN",
    "City": "Owensburg"
  },
  {
    "State": "IN",
    "City": "Paoli"
  },
  {
    "State": "IN",
    "City": "Patricksburg"
  },
  {
    "State": "IN",
    "City": "Quincy"
  },
  {
    "State": "IN",
    "City": "Scotland"
  },
  {
    "State": "IN",
    "City": "Smithville"
  },
  {
    "State": "IN",
    "City": "Solsberry"
  },
  {
    "State": "IN",
    "City": "Spencer"
  },
  {
    "State": "IN",
    "City": "Springville"
  },
  {
    "State": "IN",
    "City": "Stanford"
  },
  {
    "State": "IN",
    "City": "Stinesville"
  },
  {
    "State": "IN",
    "City": "Switz City"
  },
  {
    "State": "IN",
    "City": "Tunnelton"
  },
  {
    "State": "IN",
    "City": "Unionville"
  },
  {
    "State": "IN",
    "City": "West Baden Springs"
  },
  {
    "State": "IN",
    "City": "Williams"
  },
  {
    "State": "IN",
    "City": "Worthington"
  },
  {
    "State": "IN",
    "City": "Washington"
  },
  {
    "State": "IN",
    "City": "Bicknell"
  },
  {
    "State": "IN",
    "City": "Birdseye"
  },
  {
    "State": "IN",
    "City": "Branchville"
  },
  {
    "State": "IN",
    "City": "Bristow"
  },
  {
    "State": "IN",
    "City": "Bruceville"
  },
  {
    "State": "IN",
    "City": "Cannelburg"
  },
  {
    "State": "IN",
    "City": "Cannelton"
  },
  {
    "State": "IN",
    "City": "Celestine"
  },
  {
    "State": "IN",
    "City": "Crane"
  },
  {
    "State": "IN",
    "City": "Dale"
  },
  {
    "State": "IN",
    "City": "Decker"
  },
  {
    "State": "IN",
    "City": "Derby"
  },
  {
    "State": "IN",
    "City": "Dubois"
  },
  {
    "State": "IN",
    "City": "Edwardsport"
  },
  {
    "State": "IN",
    "City": "Elnora"
  },
  {
    "State": "IN",
    "City": "Evanston"
  },
  {
    "State": "IN",
    "City": "Ferdinand"
  },
  {
    "State": "IN",
    "City": "Freelandville"
  },
  {
    "State": "IN",
    "City": "Fulda"
  },
  {
    "State": "IN",
    "City": "Gentryville"
  },
  {
    "State": "IN",
    "City": "Holland"
  },
  {
    "State": "IN",
    "City": "Huntingburg"
  },
  {
    "State": "IN",
    "City": "Ireland"
  },
  {
    "State": "IN",
    "City": "Jasper"
  },
  {
    "State": "IN",
    "City": "Lamar"
  },
  {
    "State": "IN",
    "City": "Leopold"
  },
  {
    "State": "IN",
    "City": "Lincoln City"
  },
  {
    "State": "IN",
    "City": "Loogootee"
  },
  {
    "State": "IN",
    "City": "Mariah Hill"
  },
  {
    "State": "IN",
    "City": "Monroe City"
  },
  {
    "State": "IN",
    "City": "Montgomery"
  },
  {
    "State": "IN",
    "City": "Oaktown"
  },
  {
    "State": "IN",
    "City": "Odon"
  },
  {
    "State": "IN",
    "City": "Otwell"
  },
  {
    "State": "IN",
    "City": "Petersburg"
  },
  {
    "State": "IN",
    "City": "Plainville"
  },
  {
    "State": "IN",
    "City": "Ragsdale"
  },
  {
    "State": "IN",
    "City": "Rome"
  },
  {
    "State": "IN",
    "City": "Saint Anthony"
  },
  {
    "State": "IN",
    "City": "Saint Croix"
  },
  {
    "State": "IN",
    "City": "Saint Meinrad"
  },
  {
    "State": "IN",
    "City": "Sandborn"
  },
  {
    "State": "IN",
    "City": "Santa Claus"
  },
  {
    "State": "IN",
    "City": "Schnellville"
  },
  {
    "State": "IN",
    "City": "Shoals"
  },
  {
    "State": "IN",
    "City": "Spurgeon"
  },
  {
    "State": "IN",
    "City": "Stendal"
  },
  {
    "State": "IN",
    "City": "Tell City"
  },
  {
    "State": "IN",
    "City": "Troy"
  },
  {
    "State": "IN",
    "City": "Velpen"
  },
  {
    "State": "IN",
    "City": "Vincennes"
  },
  {
    "State": "IN",
    "City": "Westphalia"
  },
  {
    "State": "IN",
    "City": "Wheatland"
  },
  {
    "State": "IN",
    "City": "Winslow"
  },
  {
    "State": "IN",
    "City": "Boonville"
  },
  {
    "State": "IN",
    "City": "Chandler"
  },
  {
    "State": "IN",
    "City": "Chrisney"
  },
  {
    "State": "IN",
    "City": "Cynthiana"
  },
  {
    "State": "IN",
    "City": "Elberfeld"
  },
  {
    "State": "IN",
    "City": "Folsomville"
  },
  {
    "State": "IN",
    "City": "Grandview"
  },
  {
    "State": "IN",
    "City": "Griffin"
  },
  {
    "State": "IN",
    "City": "Hatfield"
  },
  {
    "State": "IN",
    "City": "Inglefield"
  },
  {
    "State": "IN",
    "City": "Lynnville"
  },
  {
    "State": "IN",
    "City": "Mount Vernon"
  },
  {
    "State": "IN",
    "City": "Newburgh"
  },
  {
    "State": "IN",
    "City": "New Harmony"
  },
  {
    "State": "IN",
    "City": "Poseyville"
  },
  {
    "State": "IN",
    "City": "Richland"
  },
  {
    "State": "IN",
    "City": "Rockport"
  },
  {
    "State": "IN",
    "City": "Tennyson"
  },
  {
    "State": "IN",
    "City": "Wadesville"
  },
  {
    "State": "IN",
    "City": "Haubstadt"
  },
  {
    "State": "IN",
    "City": "Hazleton"
  },
  {
    "State": "IN",
    "City": "Buckskin"
  },
  {
    "State": "IN",
    "City": "Fort Branch"
  },
  {
    "State": "IN",
    "City": "Francisco"
  },
  {
    "State": "IN",
    "City": "Mackey"
  },
  {
    "State": "IN",
    "City": "Oakland City"
  },
  {
    "State": "IN",
    "City": "Owensville"
  },
  {
    "State": "IN",
    "City": "Patoka"
  },
  {
    "State": "IN",
    "City": "Princeton"
  },
  {
    "State": "IN",
    "City": "Somerville"
  },
  {
    "State": "IN",
    "City": "Evansville"
  },
  {
    "State": "IN",
    "City": "Terre Haute"
  },
  {
    "State": "IN",
    "City": "Bellmore"
  },
  {
    "State": "IN",
    "City": "Blanford"
  },
  {
    "State": "IN",
    "City": "Bloomingdale"
  },
  {
    "State": "IN",
    "City": "Bowling Green"
  },
  {
    "State": "IN",
    "City": "Brazil"
  },
  {
    "State": "IN",
    "City": "Bridgeton"
  },
  {
    "State": "IN",
    "City": "Carbon"
  },
  {
    "State": "IN",
    "City": "Carlisle"
  },
  {
    "State": "IN",
    "City": "Centerpoint"
  },
  {
    "State": "IN",
    "City": "Clay City"
  },
  {
    "State": "IN",
    "City": "Clinton"
  },
  {
    "State": "IN",
    "City": "Coalmont"
  },
  {
    "State": "IN",
    "City": "Cory"
  },
  {
    "State": "IN",
    "City": "Dana"
  },
  {
    "State": "IN",
    "City": "Dugger"
  },
  {
    "State": "IN",
    "City": "Fairbanks"
  },
  {
    "State": "IN",
    "City": "Farmersburg"
  },
  {
    "State": "IN",
    "City": "Fontanet"
  },
  {
    "State": "IN",
    "City": "Graysville"
  },
  {
    "State": "IN",
    "City": "Harmony"
  },
  {
    "State": "IN",
    "City": "Hillsdale"
  },
  {
    "State": "IN",
    "City": "Hymera"
  },
  {
    "State": "IN",
    "City": "Judson"
  },
  {
    "State": "IN",
    "City": "Knightsville"
  },
  {
    "State": "IN",
    "City": "Lewis"
  },
  {
    "State": "IN",
    "City": "Marshall"
  },
  {
    "State": "IN",
    "City": "Mecca"
  },
  {
    "State": "IN",
    "City": "Merom"
  },
  {
    "State": "IN",
    "City": "Montezuma"
  },
  {
    "State": "IN",
    "City": "New Goshen"
  },
  {
    "State": "IN",
    "City": "Sullivan"
  },
  {
    "State": "IN",
    "City": "Paxton"
  },
  {
    "State": "IN",
    "City": "Pimento"
  },
  {
    "State": "IN",
    "City": "Poland"
  },
  {
    "State": "IN",
    "City": "Prairie Creek"
  },
  {
    "State": "IN",
    "City": "Prairieton"
  },
  {
    "State": "IN",
    "City": "Riley"
  },
  {
    "State": "IN",
    "City": "Rockville"
  },
  {
    "State": "IN",
    "City": "Rosedale"
  },
  {
    "State": "IN",
    "City": "Saint Bernice"
  },
  {
    "State": "IN",
    "City": "Saint Mary Of The Woods"
  },
  {
    "State": "IN",
    "City": "Seelyville"
  },
  {
    "State": "IN",
    "City": "Shelburn"
  },
  {
    "State": "IN",
    "City": "Shepardsville"
  },
  {
    "State": "IN",
    "City": "Staunton"
  },
  {
    "State": "IN",
    "City": "Universal"
  },
  {
    "State": "IN",
    "City": "West Terre Haute"
  },
  {
    "State": "IN",
    "City": "Lafayette"
  },
  {
    "State": "IN",
    "City": "West Lafayette"
  },
  {
    "State": "IN",
    "City": "Alamo"
  },
  {
    "State": "IN",
    "City": "Ambia"
  },
  {
    "State": "IN",
    "City": "Attica"
  },
  {
    "State": "IN",
    "City": "Battle Ground"
  },
  {
    "State": "IN",
    "City": "Boswell"
  },
  {
    "State": "IN",
    "City": "Brook"
  },
  {
    "State": "IN",
    "City": "Brookston"
  },
  {
    "State": "IN",
    "City": "Buck Creek"
  },
  {
    "State": "IN",
    "City": "Buffalo"
  },
  {
    "State": "IN",
    "City": "Burnettsville"
  },
  {
    "State": "IN",
    "City": "Cayuga"
  },
  {
    "State": "IN",
    "City": "Chalmers"
  },
  {
    "State": "IN",
    "City": "Clarks Hill"
  },
  {
    "State": "IN",
    "City": "Covington"
  },
  {
    "State": "IN",
    "City": "Crawfordsville"
  },
  {
    "State": "IN",
    "City": "Darlington"
  },
  {
    "State": "IN",
    "City": "Dayton"
  },
  {
    "State": "IN",
    "City": "Earl Park"
  },
  {
    "State": "IN",
    "City": "Fair Oaks"
  },
  {
    "State": "IN",
    "City": "Fowler"
  },
  {
    "State": "IN",
    "City": "Francesville"
  },
  {
    "State": "IN",
    "City": "Goodland"
  },
  {
    "State": "IN",
    "City": "Hillsboro"
  },
  {
    "State": "IN",
    "City": "Idaville"
  },
  {
    "State": "IN",
    "City": "Kentland"
  },
  {
    "State": "IN",
    "City": "Kingman"
  },
  {
    "State": "IN",
    "City": "Ladoga"
  },
  {
    "State": "IN",
    "City": "Linden"
  },
  {
    "State": "IN",
    "City": "Medaryville"
  },
  {
    "State": "IN",
    "City": "Mellott"
  },
  {
    "State": "IN",
    "City": "Monon"
  },
  {
    "State": "IN",
    "City": "Monticello"
  },
  {
    "State": "IN",
    "City": "Montmorenci"
  },
  {
    "State": "IN",
    "City": "Morocco"
  },
  {
    "State": "IN",
    "City": "Mount Ayr"
  },
  {
    "State": "IN",
    "City": "New Market"
  },
  {
    "State": "IN",
    "City": "Newport"
  },
  {
    "State": "IN",
    "City": "New Richmond"
  },
  {
    "State": "IN",
    "City": "New Ross"
  },
  {
    "State": "IN",
    "City": "Newtown"
  },
  {
    "State": "IN",
    "City": "Otterbein"
  },
  {
    "State": "IN",
    "City": "Oxford"
  },
  {
    "State": "IN",
    "City": "Perrysville"
  },
  {
    "State": "IN",
    "City": "Pine Village"
  },
  {
    "State": "IN",
    "City": "Remington"
  },
  {
    "State": "IN",
    "City": "Rensselaer"
  },
  {
    "State": "IN",
    "City": "Reynolds"
  },
  {
    "State": "IN",
    "City": "Romney"
  },
  {
    "State": "IN",
    "City": "State Line"
  },
  {
    "State": "IN",
    "City": "Stockwell"
  },
  {
    "State": "IN",
    "City": "Talbot"
  },
  {
    "State": "IN",
    "City": "Templeton"
  },
  {
    "State": "IN",
    "City": "Veedersburg"
  },
  {
    "State": "IN",
    "City": "Wallace"
  },
  {
    "State": "IN",
    "City": "Waveland"
  },
  {
    "State": "IN",
    "City": "Waynetown"
  },
  {
    "State": "IN",
    "City": "West Lebanon"
  },
  {
    "State": "IN",
    "City": "Westpoint"
  },
  {
    "State": "IN",
    "City": "Williamsport"
  },
  {
    "State": "IN",
    "City": "Wingate"
  },
  {
    "State": "IN",
    "City": "Wolcott"
  },
  {
    "State": "IN",
    "City": "Yeoman"
  },
  {
    "State": "MI",
    "City": "Algonac"
  },
  {
    "State": "MI",
    "City": "Allenton"
  },
  {
    "State": "MI",
    "City": "Almont"
  },
  {
    "State": "MI",
    "City": "Anchorville"
  },
  {
    "State": "MI",
    "City": "Armada"
  },
  {
    "State": "MI",
    "City": "Avoca"
  },
  {
    "State": "MI",
    "City": "Troy"
  },
  {
    "State": "MI",
    "City": "Birmingham"
  },
  {
    "State": "MI",
    "City": "Capac"
  },
  {
    "State": "MI",
    "City": "Center Line"
  },
  {
    "State": "MI",
    "City": "Clawson"
  },
  {
    "State": "MI",
    "City": "Eastpointe"
  },
  {
    "State": "MI",
    "City": "Emmett"
  },
  {
    "State": "MI",
    "City": "Fair Haven"
  },
  {
    "State": "MI",
    "City": "Franklin"
  },
  {
    "State": "MI",
    "City": "Fraser"
  },
  {
    "State": "MI",
    "City": "Goodells"
  },
  {
    "State": "MI",
    "City": "Harsens Island"
  },
  {
    "State": "MI",
    "City": "Hazel Park"
  },
  {
    "State": "MI",
    "City": "Jeddo"
  },
  {
    "State": "MI",
    "City": "Southfield"
  },
  {
    "State": "MI",
    "City": "Clinton Township"
  },
  {
    "State": "MI",
    "City": "Marine City"
  },
  {
    "State": "MI",
    "City": "Marysville"
  },
  {
    "State": "MI",
    "City": "Memphis"
  },
  {
    "State": "MI",
    "City": "Macomb"
  },
  {
    "State": "MI",
    "City": "Mount Clemens"
  },
  {
    "State": "MI",
    "City": "Harrison Township"
  },
  {
    "State": "MI",
    "City": "New Baltimore"
  },
  {
    "State": "MI",
    "City": "New Haven"
  },
  {
    "State": "MI",
    "City": "North Street"
  },
  {
    "State": "MI",
    "City": "East China"
  },
  {
    "State": "MI",
    "City": "Fort Gratiot"
  },
  {
    "State": "MI",
    "City": "Port Huron"
  },
  {
    "State": "MI",
    "City": "Richmond"
  },
  {
    "State": "MI",
    "City": "Columbus"
  },
  {
    "State": "MI",
    "City": "Casco"
  },
  {
    "State": "MI",
    "City": "Romeo"
  },
  {
    "State": "MI",
    "City": "Roseville"
  },
  {
    "State": "MI",
    "City": "Royal Oak"
  },
  {
    "State": "MI",
    "City": "Pleasant Ridge"
  },
  {
    "State": "MI",
    "City": "Huntington Woods"
  },
  {
    "State": "MI",
    "City": "Madison Heights"
  },
  {
    "State": "MI",
    "City": "Berkley"
  },
  {
    "State": "MI",
    "City": "Smiths Creek"
  },
  {
    "State": "MI",
    "City": "Saint Clair"
  },
  {
    "State": "MI",
    "City": "Saint Clair Shores"
  },
  {
    "State": "MI",
    "City": "Warren"
  },
  {
    "State": "MI",
    "City": "Washington"
  },
  {
    "State": "MI",
    "City": "Ray"
  },
  {
    "State": "MI",
    "City": "Yale"
  },
  {
    "State": "MI",
    "City": "Allen Park"
  },
  {
    "State": "MI",
    "City": "Ann Arbor"
  },
  {
    "State": "MI",
    "City": "Azalia"
  },
  {
    "State": "MI",
    "City": "Belleville"
  },
  {
    "State": "MI",
    "City": "Brighton"
  },
  {
    "State": "MI",
    "City": "Bridgewater"
  },
  {
    "State": "MI",
    "City": "Carleton"
  },
  {
    "State": "MI",
    "City": "Chelsea"
  },
  {
    "State": "MI",
    "City": "Dearborn"
  },
  {
    "State": "MI",
    "City": "Melvindale"
  },
  {
    "State": "MI",
    "City": "Dearborn Heights"
  },
  {
    "State": "MI",
    "City": "Dexter"
  },
  {
    "State": "MI",
    "City": "Dundee"
  },
  {
    "State": "MI",
    "City": "Erie"
  },
  {
    "State": "MI",
    "City": "Flat Rock"
  },
  {
    "State": "MI",
    "City": "Garden City"
  },
  {
    "State": "MI",
    "City": "Gregory"
  },
  {
    "State": "MI",
    "City": "Grosse Ile"
  },
  {
    "State": "MI",
    "City": "Hamburg"
  },
  {
    "State": "MI",
    "City": "Ida"
  },
  {
    "State": "MI",
    "City": "Inkster"
  },
  {
    "State": "MI",
    "City": "Lakeland"
  },
  {
    "State": "MI",
    "City": "Lambertville"
  },
  {
    "State": "MI",
    "City": "La Salle"
  },
  {
    "State": "MI",
    "City": "Lincoln Park"
  },
  {
    "State": "MI",
    "City": "Livonia"
  },
  {
    "State": "MI",
    "City": "Luna Pier"
  },
  {
    "State": "MI",
    "City": "Manchester"
  },
  {
    "State": "MI",
    "City": "Maybee"
  },
  {
    "State": "MI",
    "City": "Milan"
  },
  {
    "State": "MI",
    "City": "Monroe"
  },
  {
    "State": "MI",
    "City": "New Boston"
  },
  {
    "State": "MI",
    "City": "New Hudson"
  },
  {
    "State": "MI",
    "City": "Newport"
  },
  {
    "State": "MI",
    "City": "Northville"
  },
  {
    "State": "MI",
    "City": "Pinckney"
  },
  {
    "State": "MI",
    "City": "Plymouth"
  },
  {
    "State": "MI",
    "City": "Rockwood"
  },
  {
    "State": "MI",
    "City": "Romulus"
  },
  {
    "State": "MI",
    "City": "Salem"
  },
  {
    "State": "MI",
    "City": "Saline"
  },
  {
    "State": "MI",
    "City": "Samaria"
  },
  {
    "State": "MI",
    "City": "South Lyon"
  },
  {
    "State": "MI",
    "City": "South Rockwood"
  },
  {
    "State": "MI",
    "City": "Taylor"
  },
  {
    "State": "MI",
    "City": "Temperance"
  },
  {
    "State": "MI",
    "City": "Trenton"
  },
  {
    "State": "MI",
    "City": "Wayne"
  },
  {
    "State": "MI",
    "City": "Westland"
  },
  {
    "State": "MI",
    "City": "Canton"
  },
  {
    "State": "MI",
    "City": "Whitmore Lake"
  },
  {
    "State": "MI",
    "City": "Whittaker"
  },
  {
    "State": "MI",
    "City": "Willis"
  },
  {
    "State": "MI",
    "City": "Wyandotte"
  },
  {
    "State": "MI",
    "City": "Riverview"
  },
  {
    "State": "MI",
    "City": "Southgate"
  },
  {
    "State": "MI",
    "City": "Ypsilanti"
  },
  {
    "State": "MI",
    "City": "Detroit"
  },
  {
    "State": "MI",
    "City": "Highland Park"
  },
  {
    "State": "MI",
    "City": "Hamtramck"
  },
  {
    "State": "MI",
    "City": "River Rouge"
  },
  {
    "State": "MI",
    "City": "Ferndale"
  },
  {
    "State": "MI",
    "City": "Harper Woods"
  },
  {
    "State": "MI",
    "City": "Ecorse"
  },
  {
    "State": "MI",
    "City": "Grosse Pointe"
  },
  {
    "State": "MI",
    "City": "Oak Park"
  },
  {
    "State": "MI",
    "City": "Redford"
  },
  {
    "State": "MI",
    "City": "Bloomfield Hills"
  },
  {
    "State": "MI",
    "City": "Rochester"
  },
  {
    "State": "MI",
    "City": "Sterling Heights"
  },
  {
    "State": "MI",
    "City": "Utica"
  },
  {
    "State": "MI",
    "City": "Keego Harbor"
  },
  {
    "State": "MI",
    "City": "Auburn Hills"
  },
  {
    "State": "MI",
    "City": "West Bloomfield"
  },
  {
    "State": "MI",
    "City": "Waterford"
  },
  {
    "State": "MI",
    "City": "Drayton Plains"
  },
  {
    "State": "MI",
    "City": "Farmington"
  },
  {
    "State": "MI",
    "City": "Pontiac"
  },
  {
    "State": "MI",
    "City": "Clarkston"
  },
  {
    "State": "MI",
    "City": "Davisburg"
  },
  {
    "State": "MI",
    "City": "Hartland"
  },
  {
    "State": "MI",
    "City": "Highland"
  },
  {
    "State": "MI",
    "City": "Lake Orion"
  },
  {
    "State": "MI",
    "City": "Oakland"
  },
  {
    "State": "MI",
    "City": "Lakeville"
  },
  {
    "State": "MI",
    "City": "Leonard"
  },
  {
    "State": "MI",
    "City": "Oxford"
  },
  {
    "State": "MI",
    "City": "Novi"
  },
  {
    "State": "MI",
    "City": "Milford"
  },
  {
    "State": "MI",
    "City": "Commerce Township"
  },
  {
    "State": "MI",
    "City": "White Lake"
  },
  {
    "State": "MI",
    "City": "Union Lake"
  },
  {
    "State": "MI",
    "City": "Walled Lake"
  },
  {
    "State": "MI",
    "City": "Wixom"
  },
  {
    "State": "MI",
    "City": "Applegate"
  },
  {
    "State": "MI",
    "City": "Argyle"
  },
  {
    "State": "MI",
    "City": "Atlas"
  },
  {
    "State": "MI",
    "City": "Attica"
  },
  {
    "State": "MI",
    "City": "Bad Axe"
  },
  {
    "State": "MI",
    "City": "Bancroft"
  },
  {
    "State": "MI",
    "City": "Birch Run"
  },
  {
    "State": "MI",
    "City": "Brown City"
  },
  {
    "State": "MI",
    "City": "Burt"
  },
  {
    "State": "MI",
    "City": "Byron"
  },
  {
    "State": "MI",
    "City": "Carsonville"
  },
  {
    "State": "MI",
    "City": "Clio"
  },
  {
    "State": "MI",
    "City": "Columbiaville"
  },
  {
    "State": "MI",
    "City": "Croswell"
  },
  {
    "State": "MI",
    "City": "Davison"
  },
  {
    "State": "MI",
    "City": "Decker"
  },
  {
    "State": "MI",
    "City": "Deckerville"
  },
  {
    "State": "MI",
    "City": "Dryden"
  },
  {
    "State": "MI",
    "City": "Durand"
  },
  {
    "State": "MI",
    "City": "Fenton"
  },
  {
    "State": "MI",
    "City": "Filion"
  },
  {
    "State": "MI",
    "City": "Flushing"
  },
  {
    "State": "MI",
    "City": "Forestville"
  },
  {
    "State": "MI",
    "City": "Fostoria"
  },
  {
    "State": "MI",
    "City": "Gaines"
  },
  {
    "State": "MI",
    "City": "Genesee"
  },
  {
    "State": "MI",
    "City": "Goodrich"
  },
  {
    "State": "MI",
    "City": "Grand Blanc"
  },
  {
    "State": "MI",
    "City": "Hadley"
  },
  {
    "State": "MI",
    "City": "Harbor Beach"
  },
  {
    "State": "MI",
    "City": "Holly"
  },
  {
    "State": "MI",
    "City": "Imlay City"
  },
  {
    "State": "MI",
    "City": "Kinde"
  },
  {
    "State": "MI",
    "City": "Lapeer"
  },
  {
    "State": "MI",
    "City": "Lennon"
  },
  {
    "State": "MI",
    "City": "Lexington"
  },
  {
    "State": "MI",
    "City": "Linden"
  },
  {
    "State": "MI",
    "City": "Marlette"
  },
  {
    "State": "MI",
    "City": "Melvin"
  },
  {
    "State": "MI",
    "City": "Metamora"
  },
  {
    "State": "MI",
    "City": "Minden City"
  },
  {
    "State": "MI",
    "City": "Montrose"
  },
  {
    "State": "MI",
    "City": "Mount Morris"
  },
  {
    "State": "MI",
    "City": "New Lothrop"
  },
  {
    "State": "MI",
    "City": "North Branch"
  },
  {
    "State": "MI",
    "City": "Ortonville"
  },
  {
    "State": "MI",
    "City": "Otisville"
  },
  {
    "State": "MI",
    "City": "Otter Lake"
  },
  {
    "State": "MI",
    "City": "Palms"
  },
  {
    "State": "MI",
    "City": "Peck"
  },
  {
    "State": "MI",
    "City": "Port Austin"
  },
  {
    "State": "MI",
    "City": "Port Hope"
  },
  {
    "State": "MI",
    "City": "Port Sanilac"
  },
  {
    "State": "MI",
    "City": "Ruth"
  },
  {
    "State": "MI",
    "City": "Sandusky"
  },
  {
    "State": "MI",
    "City": "Snover"
  },
  {
    "State": "MI",
    "City": "Swartz Creek"
  },
  {
    "State": "MI",
    "City": "Ubly"
  },
  {
    "State": "MI",
    "City": "Vernon"
  },
  {
    "State": "MI",
    "City": "Flint"
  },
  {
    "State": "MI",
    "City": "Burton"
  },
  {
    "State": "MI",
    "City": "Saginaw"
  },
  {
    "State": "MI",
    "City": "Alger"
  },
  {
    "State": "MI",
    "City": "Auburn"
  },
  {
    "State": "MI",
    "City": "Beaverton"
  },
  {
    "State": "MI",
    "City": "Bentley"
  },
  {
    "State": "MI",
    "City": "Brant"
  },
  {
    "State": "MI",
    "City": "Breckenridge"
  },
  {
    "State": "MI",
    "City": "Chesaning"
  },
  {
    "State": "MI",
    "City": "Clare"
  },
  {
    "State": "MI",
    "City": "Coleman"
  },
  {
    "State": "MI",
    "City": "Comins"
  },
  {
    "State": "MI",
    "City": "Edenville"
  },
  {
    "State": "MI",
    "City": "Fairview"
  },
  {
    "State": "MI",
    "City": "Farwell"
  },
  {
    "State": "MI",
    "City": "Freeland"
  },
  {
    "State": "MI",
    "City": "Gladwin"
  },
  {
    "State": "MI",
    "City": "Harrison"
  },
  {
    "State": "MI",
    "City": "Hemlock"
  },
  {
    "State": "MI",
    "City": "Higgins Lake"
  },
  {
    "State": "MI",
    "City": "Hope"
  },
  {
    "State": "MI",
    "City": "Houghton Lake"
  },
  {
    "State": "MI",
    "City": "Houghton Lake Heights"
  },
  {
    "State": "MI",
    "City": "Kawkawlin"
  },
  {
    "State": "MI",
    "City": "Lake"
  },
  {
    "State": "MI",
    "City": "Lake George"
  },
  {
    "State": "MI",
    "City": "Linwood"
  },
  {
    "State": "MI",
    "City": "Lupton"
  },
  {
    "State": "MI",
    "City": "Luzerne"
  },
  {
    "State": "MI",
    "City": "Merrill"
  },
  {
    "State": "MI",
    "City": "Midland"
  },
  {
    "State": "MI",
    "City": "Mio"
  },
  {
    "State": "MI",
    "City": "Oakley"
  },
  {
    "State": "MI",
    "City": "Pinconning"
  },
  {
    "State": "MI",
    "City": "Prudenville"
  },
  {
    "State": "MI",
    "City": "Rhodes"
  },
  {
    "State": "MI",
    "City": "Roscommon"
  },
  {
    "State": "MI",
    "City": "Rose City"
  },
  {
    "State": "MI",
    "City": "Saint Charles"
  },
  {
    "State": "MI",
    "City": "Saint Helen"
  },
  {
    "State": "MI",
    "City": "Sanford"
  },
  {
    "State": "MI",
    "City": "Standish"
  },
  {
    "State": "MI",
    "City": "Sterling"
  },
  {
    "State": "MI",
    "City": "West Branch"
  },
  {
    "State": "MI",
    "City": "Wheeler"
  },
  {
    "State": "MI",
    "City": "Akron"
  },
  {
    "State": "MI",
    "City": "Au Gres"
  },
  {
    "State": "MI",
    "City": "Barton City"
  },
  {
    "State": "MI",
    "City": "Bay City"
  },
  {
    "State": "MI",
    "City": "University Center"
  },
  {
    "State": "MI",
    "City": "Bay Port"
  },
  {
    "State": "MI",
    "City": "Black River"
  },
  {
    "State": "MI",
    "City": "Bridgeport"
  },
  {
    "State": "MI",
    "City": "Caro"
  },
  {
    "State": "MI",
    "City": "Carrollton"
  },
  {
    "State": "MI",
    "City": "Caseville"
  },
  {
    "State": "MI",
    "City": "Cass City"
  },
  {
    "State": "MI",
    "City": "Clifford"
  },
  {
    "State": "MI",
    "City": "Curran"
  },
  {
    "State": "MI",
    "City": "Deford"
  },
  {
    "State": "MI",
    "City": "East Tawas"
  },
  {
    "State": "MI",
    "City": "Elkton"
  },
  {
    "State": "MI",
    "City": "Essexville"
  },
  {
    "State": "MI",
    "City": "Fairgrove"
  },
  {
    "State": "MI",
    "City": "Frankenmuth"
  },
  {
    "State": "MI",
    "City": "Gagetown"
  },
  {
    "State": "MI",
    "City": "Gilford"
  },
  {
    "State": "MI",
    "City": "Glennie"
  },
  {
    "State": "MI",
    "City": "Greenbush"
  },
  {
    "State": "MI",
    "City": "Hale"
  },
  {
    "State": "MI",
    "City": "Harrisville"
  },
  {
    "State": "MI",
    "City": "Kingston"
  },
  {
    "State": "MI",
    "City": "Lincoln"
  },
  {
    "State": "MI",
    "City": "Long Lake"
  },
  {
    "State": "MI",
    "City": "Mayville"
  },
  {
    "State": "MI",
    "City": "Mikado"
  },
  {
    "State": "MI",
    "City": "Millington"
  },
  {
    "State": "MI",
    "City": "Munger"
  },
  {
    "State": "MI",
    "City": "National City"
  },
  {
    "State": "MI",
    "City": "Omer"
  },
  {
    "State": "MI",
    "City": "Oscoda"
  },
  {
    "State": "MI",
    "City": "Owendale"
  },
  {
    "State": "MI",
    "City": "Pigeon"
  },
  {
    "State": "MI",
    "City": "Prescott"
  },
  {
    "State": "MI",
    "City": "Reese"
  },
  {
    "State": "MI",
    "City": "Richville"
  },
  {
    "State": "MI",
    "City": "Sebewaing"
  },
  {
    "State": "MI",
    "City": "Silverwood"
  },
  {
    "State": "MI",
    "City": "South Branch"
  },
  {
    "State": "MI",
    "City": "Spruce"
  },
  {
    "State": "MI",
    "City": "Tawas City"
  },
  {
    "State": "MI",
    "City": "Turner"
  },
  {
    "State": "MI",
    "City": "Twining"
  },
  {
    "State": "MI",
    "City": "Unionville"
  },
  {
    "State": "MI",
    "City": "Vassar"
  },
  {
    "State": "MI",
    "City": "Whittemore"
  },
  {
    "State": "MI",
    "City": "Alma"
  },
  {
    "State": "MI",
    "City": "Mount Pleasant"
  },
  {
    "State": "MI",
    "City": "Okemos"
  },
  {
    "State": "MI",
    "City": "Ashley"
  },
  {
    "State": "MI",
    "City": "Bannister"
  },
  {
    "State": "MI",
    "City": "Bath"
  },
  {
    "State": "MI",
    "City": "Belding"
  },
  {
    "State": "MI",
    "City": "Carson City"
  },
  {
    "State": "MI",
    "City": "Cedar Lake"
  },
  {
    "State": "MI",
    "City": "Charlotte"
  },
  {
    "State": "MI",
    "City": "Clarksville"
  },
  {
    "State": "MI",
    "City": "Cohoctah"
  },
  {
    "State": "MI",
    "City": "Corunna"
  },
  {
    "State": "MI",
    "City": "Crystal"
  },
  {
    "State": "MI",
    "City": "Dansville"
  },
  {
    "State": "MI",
    "City": "Dewitt"
  },
  {
    "State": "MI",
    "City": "Dimondale"
  },
  {
    "State": "MI",
    "City": "Eagle"
  },
  {
    "State": "MI",
    "City": "East Lansing"
  },
  {
    "State": "MI",
    "City": "Eaton Rapids"
  },
  {
    "State": "MI",
    "City": "Edmore"
  },
  {
    "State": "MI",
    "City": "Elm Hall"
  },
  {
    "State": "MI",
    "City": "Elsie"
  },
  {
    "State": "MI",
    "City": "Elwell"
  },
  {
    "State": "MI",
    "City": "Eureka"
  },
  {
    "State": "MI",
    "City": "Fenwick"
  },
  {
    "State": "MI",
    "City": "Fowler"
  },
  {
    "State": "MI",
    "City": "Fowlerville"
  },
  {
    "State": "MI",
    "City": "Grand Ledge"
  },
  {
    "State": "MI",
    "City": "Greenville"
  },
  {
    "State": "MI",
    "City": "Haslett"
  },
  {
    "State": "MI",
    "City": "Henderson"
  },
  {
    "State": "MI",
    "City": "Holt"
  },
  {
    "State": "MI",
    "City": "Howell"
  },
  {
    "State": "MI",
    "City": "Hubbardston"
  },
  {
    "State": "MI",
    "City": "Ionia"
  },
  {
    "State": "MI",
    "City": "Ithaca"
  },
  {
    "State": "MI",
    "City": "Laingsburg"
  },
  {
    "State": "MI",
    "City": "Lake Odessa"
  },
  {
    "State": "MI",
    "City": "Lakeview"
  },
  {
    "State": "MI",
    "City": "Lyons"
  },
  {
    "State": "MI",
    "City": "Mcbrides"
  },
  {
    "State": "MI",
    "City": "Maple Rapids"
  },
  {
    "State": "MI",
    "City": "Mason"
  },
  {
    "State": "MI",
    "City": "Middleton"
  },
  {
    "State": "MI",
    "City": "Morrice"
  },
  {
    "State": "MI",
    "City": "Muir"
  },
  {
    "State": "MI",
    "City": "Mulliken"
  },
  {
    "State": "MI",
    "City": "North Star"
  },
  {
    "State": "MI",
    "City": "Orleans"
  },
  {
    "State": "MI",
    "City": "Ovid"
  },
  {
    "State": "MI",
    "City": "Owosso"
  },
  {
    "State": "MI",
    "City": "Palo"
  },
  {
    "State": "MI",
    "City": "Perrinton"
  },
  {
    "State": "MI",
    "City": "Perry"
  },
  {
    "State": "MI",
    "City": "Pewamo"
  },
  {
    "State": "MI",
    "City": "Pompeii"
  },
  {
    "State": "MI",
    "City": "Portland"
  },
  {
    "State": "MI",
    "City": "Potterville"
  },
  {
    "State": "MI",
    "City": "Riverdale"
  },
  {
    "State": "MI",
    "City": "Rosebush"
  },
  {
    "State": "MI",
    "City": "Saint Johns"
  },
  {
    "State": "MI",
    "City": "Saint Louis"
  },
  {
    "State": "MI",
    "City": "Saranac"
  },
  {
    "State": "MI",
    "City": "Shaftsburg"
  },
  {
    "State": "MI",
    "City": "Shepherd"
  },
  {
    "State": "MI",
    "City": "Sheridan"
  },
  {
    "State": "MI",
    "City": "Sidney"
  },
  {
    "State": "MI",
    "City": "Six Lakes"
  },
  {
    "State": "MI",
    "City": "Smyrna"
  },
  {
    "State": "MI",
    "City": "Stanton"
  },
  {
    "State": "MI",
    "City": "Sumner"
  },
  {
    "State": "MI",
    "City": "Sunfield"
  },
  {
    "State": "MI",
    "City": "Vestaburg"
  },
  {
    "State": "MI",
    "City": "Webberville"
  },
  {
    "State": "MI",
    "City": "Weidman"
  },
  {
    "State": "MI",
    "City": "Westphalia"
  },
  {
    "State": "MI",
    "City": "Williamston"
  },
  {
    "State": "MI",
    "City": "Winn"
  },
  {
    "State": "MI",
    "City": "Woodland"
  },
  {
    "State": "MI",
    "City": "Lansing"
  },
  {
    "State": "MI",
    "City": "Kalamazoo"
  },
  {
    "State": "MI",
    "City": "Portage"
  },
  {
    "State": "MI",
    "City": "Allegan"
  },
  {
    "State": "MI",
    "City": "Athens"
  },
  {
    "State": "MI",
    "City": "Augusta"
  },
  {
    "State": "MI",
    "City": "Bangor"
  },
  {
    "State": "MI",
    "City": "Battle Creek"
  },
  {
    "State": "MI",
    "City": "Bedford"
  },
  {
    "State": "MI",
    "City": "Bellevue"
  },
  {
    "State": "MI",
    "City": "Benton Harbor"
  },
  {
    "State": "MI",
    "City": "Bloomingdale"
  },
  {
    "State": "MI",
    "City": "Breedsville"
  },
  {
    "State": "MI",
    "City": "Bronson"
  },
  {
    "State": "MI",
    "City": "Burlington"
  },
  {
    "State": "MI",
    "City": "Burr Oak"
  },
  {
    "State": "MI",
    "City": "Cassopolis"
  },
  {
    "State": "MI",
    "City": "Centreville"
  },
  {
    "State": "MI",
    "City": "Ceresco"
  },
  {
    "State": "MI",
    "City": "Climax"
  },
  {
    "State": "MI",
    "City": "Cloverdale"
  },
  {
    "State": "MI",
    "City": "Coldwater"
  },
  {
    "State": "MI",
    "City": "Coloma"
  },
  {
    "State": "MI",
    "City": "Hagar Shores"
  },
  {
    "State": "MI",
    "City": "Colon"
  },
  {
    "State": "MI",
    "City": "Comstock"
  },
  {
    "State": "MI",
    "City": "Constantine"
  },
  {
    "State": "MI",
    "City": "Covert"
  },
  {
    "State": "MI",
    "City": "Decatur"
  },
  {
    "State": "MI",
    "City": "Delton"
  },
  {
    "State": "MI",
    "City": "Dowagiac"
  },
  {
    "State": "MI",
    "City": "Dowling"
  },
  {
    "State": "MI",
    "City": "East Leroy"
  },
  {
    "State": "MI",
    "City": "Fulton"
  },
  {
    "State": "MI",
    "City": "Galesburg"
  },
  {
    "State": "MI",
    "City": "Gobles"
  },
  {
    "State": "MI",
    "City": "Grand Junction"
  },
  {
    "State": "MI",
    "City": "Hartford"
  },
  {
    "State": "MI",
    "City": "Hastings"
  },
  {
    "State": "MI",
    "City": "Hickory Corners"
  },
  {
    "State": "MI",
    "City": "Jones"
  },
  {
    "State": "MI",
    "City": "Kendall"
  },
  {
    "State": "MI",
    "City": "Lacota"
  },
  {
    "State": "MI",
    "City": "Lawrence"
  },
  {
    "State": "MI",
    "City": "Lawton"
  },
  {
    "State": "MI",
    "City": "Leonidas"
  },
  {
    "State": "MI",
    "City": "Marcellus"
  },
  {
    "State": "MI",
    "City": "Marshall"
  },
  {
    "State": "MI",
    "City": "Martin"
  },
  {
    "State": "MI",
    "City": "Mattawan"
  },
  {
    "State": "MI",
    "City": "Mendon"
  },
  {
    "State": "MI",
    "City": "Nashville"
  },
  {
    "State": "MI",
    "City": "Nazareth"
  },
  {
    "State": "MI",
    "City": "Nottawa"
  },
  {
    "State": "MI",
    "City": "Olivet"
  },
  {
    "State": "MI",
    "City": "Oshtemo"
  },
  {
    "State": "MI",
    "City": "Otsego"
  },
  {
    "State": "MI",
    "City": "Paw Paw"
  },
  {
    "State": "MI",
    "City": "Plainwell"
  },
  {
    "State": "MI",
    "City": "Quincy"
  },
  {
    "State": "MI",
    "City": "Richland"
  },
  {
    "State": "MI",
    "City": "Riverside"
  },
  {
    "State": "MI",
    "City": "Saint Joseph"
  },
  {
    "State": "MI",
    "City": "Schoolcraft"
  },
  {
    "State": "MI",
    "City": "Scotts"
  },
  {
    "State": "MI",
    "City": "Sherwood"
  },
  {
    "State": "MI",
    "City": "South Haven"
  },
  {
    "State": "MI",
    "City": "Sturgis"
  },
  {
    "State": "MI",
    "City": "Tekonsha"
  },
  {
    "State": "MI",
    "City": "Three Rivers"
  },
  {
    "State": "MI",
    "City": "Union City"
  },
  {
    "State": "MI",
    "City": "Vandalia"
  },
  {
    "State": "MI",
    "City": "Vermontville"
  },
  {
    "State": "MI",
    "City": "Vicksburg"
  },
  {
    "State": "MI",
    "City": "Watervliet"
  },
  {
    "State": "MI",
    "City": "White Pigeon"
  },
  {
    "State": "MI",
    "City": "Baroda"
  },
  {
    "State": "MI",
    "City": "Berrien Center"
  },
  {
    "State": "MI",
    "City": "Berrien Springs"
  },
  {
    "State": "MI",
    "City": "Bridgman"
  },
  {
    "State": "MI",
    "City": "Buchanan"
  },
  {
    "State": "MI",
    "City": "Eau Claire"
  },
  {
    "State": "MI",
    "City": "Edwardsburg"
  },
  {
    "State": "MI",
    "City": "Galien"
  },
  {
    "State": "MI",
    "City": "Harbert"
  },
  {
    "State": "MI",
    "City": "Lakeside"
  },
  {
    "State": "MI",
    "City": "New Buffalo"
  },
  {
    "State": "MI",
    "City": "New Troy"
  },
  {
    "State": "MI",
    "City": "Niles"
  },
  {
    "State": "MI",
    "City": "Sawyer"
  },
  {
    "State": "MI",
    "City": "Sodus"
  },
  {
    "State": "MI",
    "City": "Stevensville"
  },
  {
    "State": "MI",
    "City": "Three Oaks"
  },
  {
    "State": "MI",
    "City": "Union Pier"
  },
  {
    "State": "MI",
    "City": "Union"
  },
  {
    "State": "MI",
    "City": "Jackson"
  },
  {
    "State": "MI",
    "City": "Addison"
  },
  {
    "State": "MI",
    "City": "Adrian"
  },
  {
    "State": "MI",
    "City": "Albion"
  },
  {
    "State": "MI",
    "City": "Allen"
  },
  {
    "State": "MI",
    "City": "Blissfield"
  },
  {
    "State": "MI",
    "City": "Britton"
  },
  {
    "State": "MI",
    "City": "Brooklyn"
  },
  {
    "State": "MI",
    "City": "Camden"
  },
  {
    "State": "MI",
    "City": "Cement City"
  },
  {
    "State": "MI",
    "City": "Clarklake"
  },
  {
    "State": "MI",
    "City": "Clayton"
  },
  {
    "State": "MI",
    "City": "Clinton"
  },
  {
    "State": "MI",
    "City": "Concord"
  },
  {
    "State": "MI",
    "City": "Deerfield"
  },
  {
    "State": "MI",
    "City": "Frontier"
  },
  {
    "State": "MI",
    "City": "Grass Lake"
  },
  {
    "State": "MI",
    "City": "Hanover"
  },
  {
    "State": "MI",
    "City": "Hillsdale"
  },
  {
    "State": "MI",
    "City": "Homer"
  },
  {
    "State": "MI",
    "City": "Horton"
  },
  {
    "State": "MI",
    "City": "Hudson"
  },
  {
    "State": "MI",
    "City": "Jasper"
  },
  {
    "State": "MI",
    "City": "Jerome"
  },
  {
    "State": "MI",
    "City": "Jonesville"
  },
  {
    "State": "MI",
    "City": "Leslie"
  },
  {
    "State": "MI",
    "City": "Litchfield"
  },
  {
    "State": "MI",
    "City": "Manitou Beach"
  },
  {
    "State": "MI",
    "City": "Michigan Center"
  },
  {
    "State": "MI",
    "City": "Montgomery"
  },
  {
    "State": "MI",
    "City": "Morenci"
  },
  {
    "State": "MI",
    "City": "Moscow"
  },
  {
    "State": "MI",
    "City": "Mosherville"
  },
  {
    "State": "MI",
    "City": "Munith"
  },
  {
    "State": "MI",
    "City": "Napoleon"
  },
  {
    "State": "MI",
    "City": "North Adams"
  },
  {
    "State": "MI",
    "City": "Norvell"
  },
  {
    "State": "MI",
    "City": "Onondaga"
  },
  {
    "State": "MI",
    "City": "Onsted"
  },
  {
    "State": "MI",
    "City": "Osseo"
  },
  {
    "State": "MI",
    "City": "Ottawa Lake"
  },
  {
    "State": "MI",
    "City": "Palmyra"
  },
  {
    "State": "MI",
    "City": "Parma"
  },
  {
    "State": "MI",
    "City": "Petersburg"
  },
  {
    "State": "MI",
    "City": "Pittsford"
  },
  {
    "State": "MI",
    "City": "Pleasant Lake"
  },
  {
    "State": "MI",
    "City": "Reading"
  },
  {
    "State": "MI",
    "City": "Riga"
  },
  {
    "State": "MI",
    "City": "Rives Junction"
  },
  {
    "State": "MI",
    "City": "Sand Creek"
  },
  {
    "State": "MI",
    "City": "Somerset"
  },
  {
    "State": "MI",
    "City": "Somerset Center"
  },
  {
    "State": "MI",
    "City": "Spring Arbor"
  },
  {
    "State": "MI",
    "City": "Springport"
  },
  {
    "State": "MI",
    "City": "Stockbridge"
  },
  {
    "State": "MI",
    "City": "Tecumseh"
  },
  {
    "State": "MI",
    "City": "Tipton"
  },
  {
    "State": "MI",
    "City": "Waldron"
  },
  {
    "State": "MI",
    "City": "Weston"
  },
  {
    "State": "MI",
    "City": "Ada"
  },
  {
    "State": "MI",
    "City": "Alto"
  },
  {
    "State": "MI",
    "City": "Bailey"
  },
  {
    "State": "MI",
    "City": "Baldwin"
  },
  {
    "State": "MI",
    "City": "Barryton"
  },
  {
    "State": "MI",
    "City": "Belmont"
  },
  {
    "State": "MI",
    "City": "Big Rapids"
  },
  {
    "State": "MI",
    "City": "Bitely"
  },
  {
    "State": "MI",
    "City": "Blanchard"
  },
  {
    "State": "MI",
    "City": "Bradley"
  },
  {
    "State": "MI",
    "City": "Brohman"
  },
  {
    "State": "MI",
    "City": "Burnips"
  },
  {
    "State": "MI",
    "City": "Byron Center"
  },
  {
    "State": "MI",
    "City": "Caledonia"
  },
  {
    "State": "MI",
    "City": "Cannonsburg"
  },
  {
    "State": "MI",
    "City": "Casnovia"
  },
  {
    "State": "MI",
    "City": "Cedar Springs"
  },
  {
    "State": "MI",
    "City": "Chippewa Lake"
  },
  {
    "State": "MI",
    "City": "Comstock Park"
  },
  {
    "State": "MI",
    "City": "Coral"
  },
  {
    "State": "MI",
    "City": "Dorr"
  },
  {
    "State": "MI",
    "City": "Freeport"
  },
  {
    "State": "MI",
    "City": "Gowen"
  },
  {
    "State": "MI",
    "City": "Grant"
  },
  {
    "State": "MI",
    "City": "Hopkins"
  },
  {
    "State": "MI",
    "City": "Howard City"
  },
  {
    "State": "MI",
    "City": "Kent City"
  },
  {
    "State": "MI",
    "City": "Lowell"
  },
  {
    "State": "MI",
    "City": "Mecosta"
  },
  {
    "State": "MI",
    "City": "Middleville"
  },
  {
    "State": "MI",
    "City": "Moline"
  },
  {
    "State": "MI",
    "City": "Morley"
  },
  {
    "State": "MI",
    "City": "Newaygo"
  },
  {
    "State": "MI",
    "City": "Paris"
  },
  {
    "State": "MI",
    "City": "Pierson"
  },
  {
    "State": "MI",
    "City": "Remus"
  },
  {
    "State": "MI",
    "City": "Rockford"
  },
  {
    "State": "MI",
    "City": "Rodney"
  },
  {
    "State": "MI",
    "City": "Sand Lake"
  },
  {
    "State": "MI",
    "City": "Shelbyville"
  },
  {
    "State": "MI",
    "City": "Sparta"
  },
  {
    "State": "MI",
    "City": "Stanwood"
  },
  {
    "State": "MI",
    "City": "Trufant"
  },
  {
    "State": "MI",
    "City": "Wayland"
  },
  {
    "State": "MI",
    "City": "White Cloud"
  },
  {
    "State": "MI",
    "City": "Allendale"
  },
  {
    "State": "MI",
    "City": "Branch"
  },
  {
    "State": "MI",
    "City": "Conklin"
  },
  {
    "State": "MI",
    "City": "Coopersville"
  },
  {
    "State": "MI",
    "City": "Custer"
  },
  {
    "State": "MI",
    "City": "Douglas"
  },
  {
    "State": "MI",
    "City": "Fennville"
  },
  {
    "State": "MI",
    "City": "Ferrysburg"
  },
  {
    "State": "MI",
    "City": "Fountain"
  },
  {
    "State": "MI",
    "City": "Free Soil"
  },
  {
    "State": "MI",
    "City": "Fremont"
  },
  {
    "State": "MI",
    "City": "Fruitport"
  },
  {
    "State": "MI",
    "City": "Glenn"
  },
  {
    "State": "MI",
    "City": "Grand Haven"
  },
  {
    "State": "MI",
    "City": "Grandville"
  },
  {
    "State": "MI",
    "City": "Hamilton"
  },
  {
    "State": "MI",
    "City": "Hart"
  },
  {
    "State": "MI",
    "City": "Hesperia"
  },
  {
    "State": "MI",
    "City": "Holland"
  },
  {
    "State": "MI",
    "City": "Holton"
  },
  {
    "State": "MI",
    "City": "Hudsonville"
  },
  {
    "State": "MI",
    "City": "Jamestown"
  },
  {
    "State": "MI",
    "City": "Jenison"
  },
  {
    "State": "MI",
    "City": "Lamont"
  },
  {
    "State": "MI",
    "City": "Ludington"
  },
  {
    "State": "MI",
    "City": "Macatawa"
  },
  {
    "State": "MI",
    "City": "Marne"
  },
  {
    "State": "MI",
    "City": "Mears"
  },
  {
    "State": "MI",
    "City": "Montague"
  },
  {
    "State": "MI",
    "City": "Muskegon"
  },
  {
    "State": "MI",
    "City": "New Era"
  },
  {
    "State": "MI",
    "City": "Nunica"
  },
  {
    "State": "MI",
    "City": "Pentwater"
  },
  {
    "State": "MI",
    "City": "Pullman"
  },
  {
    "State": "MI",
    "City": "Ravenna"
  },
  {
    "State": "MI",
    "City": "Rothbury"
  },
  {
    "State": "MI",
    "City": "Saugatuck"
  },
  {
    "State": "MI",
    "City": "Scottville"
  },
  {
    "State": "MI",
    "City": "Shelby"
  },
  {
    "State": "MI",
    "City": "Spring Lake"
  },
  {
    "State": "MI",
    "City": "Twin Lake"
  },
  {
    "State": "MI",
    "City": "Walhalla"
  },
  {
    "State": "MI",
    "City": "Walkerville"
  },
  {
    "State": "MI",
    "City": "West Olive"
  },
  {
    "State": "MI",
    "City": "Whitehall"
  },
  {
    "State": "MI",
    "City": "Sylvan Beach"
  },
  {
    "State": "MI",
    "City": "Zeeland"
  },
  {
    "State": "MI",
    "City": "Grand Rapids"
  },
  {
    "State": "MI",
    "City": "Wyoming"
  },
  {
    "State": "MI",
    "City": "Cadillac"
  },
  {
    "State": "MI",
    "City": "Acme"
  },
  {
    "State": "MI",
    "City": "Alba"
  },
  {
    "State": "MI",
    "City": "Alden"
  },
  {
    "State": "MI",
    "City": "Arcadia"
  },
  {
    "State": "MI",
    "City": "Bear Lake"
  },
  {
    "State": "MI",
    "City": "Bellaire"
  },
  {
    "State": "MI",
    "City": "Benzonia"
  },
  {
    "State": "MI",
    "City": "Beulah"
  },
  {
    "State": "MI",
    "City": "Boon"
  },
  {
    "State": "MI",
    "City": "Brethren"
  },
  {
    "State": "MI",
    "City": "Buckley"
  },
  {
    "State": "MI",
    "City": "Cedar"
  },
  {
    "State": "MI",
    "City": "Central Lake"
  },
  {
    "State": "MI",
    "City": "Chase"
  },
  {
    "State": "MI",
    "City": "Copemish"
  },
  {
    "State": "MI",
    "City": "Eastlake"
  },
  {
    "State": "MI",
    "City": "Eastport"
  },
  {
    "State": "MI",
    "City": "Elberta"
  },
  {
    "State": "MI",
    "City": "Elk Rapids"
  },
  {
    "State": "MI",
    "City": "Empire"
  },
  {
    "State": "MI",
    "City": "Evart"
  },
  {
    "State": "MI",
    "City": "Falmouth"
  },
  {
    "State": "MI",
    "City": "Fife Lake"
  },
  {
    "State": "MI",
    "City": "Filer City"
  },
  {
    "State": "MI",
    "City": "Frankfort"
  },
  {
    "State": "MI",
    "City": "Glen Arbor"
  },
  {
    "State": "MI",
    "City": "Grawn"
  },
  {
    "State": "MI",
    "City": "Harrietta"
  },
  {
    "State": "MI",
    "City": "Hersey"
  },
  {
    "State": "MI",
    "City": "Honor"
  },
  {
    "State": "MI",
    "City": "Idlewild"
  },
  {
    "State": "MI",
    "City": "Interlochen"
  },
  {
    "State": "MI",
    "City": "Irons"
  },
  {
    "State": "MI",
    "City": "Kaleva"
  },
  {
    "State": "MI",
    "City": "Kalkaska"
  },
  {
    "State": "MI",
    "City": "Kewadin"
  },
  {
    "State": "MI",
    "City": "Kingsley"
  },
  {
    "State": "MI",
    "City": "Lake Ann"
  },
  {
    "State": "MI",
    "City": "Lake City"
  },
  {
    "State": "MI",
    "City": "Lake Leelanau"
  },
  {
    "State": "MI",
    "City": "Leland"
  },
  {
    "State": "MI",
    "City": "Leroy"
  },
  {
    "State": "MI",
    "City": "Luther"
  },
  {
    "State": "MI",
    "City": "Mc Bain"
  },
  {
    "State": "MI",
    "City": "Mancelona"
  },
  {
    "State": "MI",
    "City": "Manistee"
  },
  {
    "State": "MI",
    "City": "Manton"
  },
  {
    "State": "MI",
    "City": "Maple City"
  },
  {
    "State": "MI",
    "City": "Marion"
  },
  {
    "State": "MI",
    "City": "Mayfield"
  },
  {
    "State": "MI",
    "City": "Merritt"
  },
  {
    "State": "MI",
    "City": "Mesick"
  },
  {
    "State": "MI",
    "City": "Northport"
  },
  {
    "State": "MI",
    "City": "Old Mission"
  },
  {
    "State": "MI",
    "City": "Omena"
  },
  {
    "State": "MI",
    "City": "Onekama"
  },
  {
    "State": "MI",
    "City": "Rapid City"
  },
  {
    "State": "MI",
    "City": "Reed City"
  },
  {
    "State": "MI",
    "City": "Sears"
  },
  {
    "State": "MI",
    "City": "South Boardman"
  },
  {
    "State": "MI",
    "City": "Suttons Bay"
  },
  {
    "State": "MI",
    "City": "Thompsonville"
  },
  {
    "State": "MI",
    "City": "Traverse City"
  },
  {
    "State": "MI",
    "City": "Tustin"
  },
  {
    "State": "MI",
    "City": "Wellston"
  },
  {
    "State": "MI",
    "City": "Williamsburg"
  },
  {
    "State": "MI",
    "City": "Mackinaw City"
  },
  {
    "State": "MI",
    "City": "Afton"
  },
  {
    "State": "MI",
    "City": "Alanson"
  },
  {
    "State": "MI",
    "City": "Alpena"
  },
  {
    "State": "MI",
    "City": "Atlanta"
  },
  {
    "State": "MI",
    "City": "Barbeau"
  },
  {
    "State": "MI",
    "City": "Bay Shore"
  },
  {
    "State": "MI",
    "City": "Boyne City"
  },
  {
    "State": "MI",
    "City": "Boyne Falls"
  },
  {
    "State": "MI",
    "City": "Brimley"
  },
  {
    "State": "MI",
    "City": "Brutus"
  },
  {
    "State": "MI",
    "City": "Burt Lake"
  },
  {
    "State": "MI",
    "City": "Carp Lake"
  },
  {
    "State": "MI",
    "City": "Cedarville"
  },
  {
    "State": "MI",
    "City": "Charlevoix"
  },
  {
    "State": "MI",
    "City": "Cheboygan"
  },
  {
    "State": "MI",
    "City": "Conway"
  },
  {
    "State": "MI",
    "City": "Cross Village"
  },
  {
    "State": "MI",
    "City": "Dafter"
  },
  {
    "State": "MI",
    "City": "De Tour Village"
  },
  {
    "State": "MI",
    "City": "Drummond Island"
  },
  {
    "State": "MI",
    "City": "East Jordan"
  },
  {
    "State": "MI",
    "City": "Eckerman"
  },
  {
    "State": "MI",
    "City": "Ellsworth"
  },
  {
    "State": "MI",
    "City": "Elmira"
  },
  {
    "State": "MI",
    "City": "Frederic"
  },
  {
    "State": "MI",
    "City": "Gaylord"
  },
  {
    "State": "MI",
    "City": "Goetzville"
  },
  {
    "State": "MI",
    "City": "Good Hart"
  },
  {
    "State": "MI",
    "City": "Grayling"
  },
  {
    "State": "MI",
    "City": "Harbor Springs"
  },
  {
    "State": "MI",
    "City": "Hawks"
  },
  {
    "State": "MI",
    "City": "Herron"
  },
  {
    "State": "MI",
    "City": "Hessel"
  },
  {
    "State": "MI",
    "City": "Hillman"
  },
  {
    "State": "MI",
    "City": "Hubbard Lake"
  },
  {
    "State": "MI",
    "City": "Hulbert"
  },
  {
    "State": "MI",
    "City": "Indian River"
  },
  {
    "State": "MI",
    "City": "Johannesburg"
  },
  {
    "State": "MI",
    "City": "Kinross"
  },
  {
    "State": "MI",
    "City": "Lachine"
  },
  {
    "State": "MI",
    "City": "Levering"
  },
  {
    "State": "MI",
    "City": "Lewiston"
  },
  {
    "State": "MI",
    "City": "Mackinac Island"
  },
  {
    "State": "MI",
    "City": "Millersburg"
  },
  {
    "State": "MI",
    "City": "Moran"
  },
  {
    "State": "MI",
    "City": "Mullett Lake"
  },
  {
    "State": "MI",
    "City": "Naubinway"
  },
  {
    "State": "MI",
    "City": "Oden"
  },
  {
    "State": "MI",
    "City": "Onaway"
  },
  {
    "State": "MI",
    "City": "Ossineke"
  },
  {
    "State": "MI",
    "City": "Paradise"
  },
  {
    "State": "MI",
    "City": "Pellston"
  },
  {
    "State": "MI",
    "City": "Petoskey"
  },
  {
    "State": "MI",
    "City": "Pickford"
  },
  {
    "State": "MI",
    "City": "Pointe Aux Pins"
  },
  {
    "State": "MI",
    "City": "Posen"
  },
  {
    "State": "MI",
    "City": "Presque Isle"
  },
  {
    "State": "MI",
    "City": "Rogers City"
  },
  {
    "State": "MI",
    "City": "Rudyard"
  },
  {
    "State": "MI",
    "City": "Saint Ignace"
  },
  {
    "State": "MI",
    "City": "Beaver Island"
  },
  {
    "State": "MI",
    "City": "Sault Sainte Marie"
  },
  {
    "State": "MI",
    "City": "Kincheloe"
  },
  {
    "State": "MI",
    "City": "Topinabee"
  },
  {
    "State": "MI",
    "City": "Tower"
  },
  {
    "State": "MI",
    "City": "Trout Lake"
  },
  {
    "State": "MI",
    "City": "Vanderbilt"
  },
  {
    "State": "MI",
    "City": "Walloon Lake"
  },
  {
    "State": "MI",
    "City": "Waters"
  },
  {
    "State": "MI",
    "City": "Wolverine"
  },
  {
    "State": "MI",
    "City": "Iron Mountain"
  },
  {
    "State": "MI",
    "City": "Kingsford"
  },
  {
    "State": "MI",
    "City": "Allouez"
  },
  {
    "State": "MI",
    "City": "Au Train"
  },
  {
    "State": "MI",
    "City": "Bark River"
  },
  {
    "State": "MI",
    "City": "Big Bay"
  },
  {
    "State": "MI",
    "City": "Carney"
  },
  {
    "State": "MI",
    "City": "Champion"
  },
  {
    "State": "MI",
    "City": "Channing"
  },
  {
    "State": "MI",
    "City": "Chatham"
  },
  {
    "State": "MI",
    "City": "Cooks"
  },
  {
    "State": "MI",
    "City": "Cornell"
  },
  {
    "State": "MI",
    "City": "Arnold"
  },
  {
    "State": "MI",
    "City": "Curtis"
  },
  {
    "State": "MI",
    "City": "Daggett"
  },
  {
    "State": "MI",
    "City": "Deerton"
  },
  {
    "State": "MI",
    "City": "Eben Junction"
  },
  {
    "State": "MI",
    "City": "Rumely"
  },
  {
    "State": "MI",
    "City": "Engadine"
  },
  {
    "State": "MI",
    "City": "Escanaba"
  },
  {
    "State": "MI",
    "City": "Felch"
  },
  {
    "State": "MI",
    "City": "Little Lake"
  },
  {
    "State": "MI",
    "City": "Foster City"
  },
  {
    "State": "MI",
    "City": "Garden"
  },
  {
    "State": "MI",
    "City": "Germfask"
  },
  {
    "State": "MI",
    "City": "Gladstone"
  },
  {
    "State": "MI",
    "City": "Gould City"
  },
  {
    "State": "MI",
    "City": "Grand Marais"
  },
  {
    "State": "MI",
    "City": "Gulliver"
  },
  {
    "State": "MI",
    "City": "Gwinn"
  },
  {
    "State": "MI",
    "City": "Harris"
  },
  {
    "State": "MI",
    "City": "Hermansville"
  },
  {
    "State": "MI",
    "City": "Ingalls"
  },
  {
    "State": "MI",
    "City": "Ishpeming"
  },
  {
    "State": "MI",
    "City": "Loretto"
  },
  {
    "State": "MI",
    "City": "Mc Millan"
  },
  {
    "State": "MI",
    "City": "Manistique"
  },
  {
    "State": "MI",
    "City": "Marquette"
  },
  {
    "State": "MI",
    "City": "Menominee"
  },
  {
    "State": "MI",
    "City": "Michigamme"
  },
  {
    "State": "MI",
    "City": "Munising"
  },
  {
    "State": "MI",
    "City": "Nadeau"
  },
  {
    "State": "MI",
    "City": "Nahma"
  },
  {
    "State": "MI",
    "City": "National Mine"
  },
  {
    "State": "MI",
    "City": "Negaunee"
  },
  {
    "State": "MI",
    "City": "Newberry"
  },
  {
    "State": "MI",
    "City": "Norway"
  },
  {
    "State": "MI",
    "City": "Palmer"
  },
  {
    "State": "MI",
    "City": "Perkins"
  },
  {
    "State": "MI",
    "City": "Perronville"
  },
  {
    "State": "MI",
    "City": "Powers"
  },
  {
    "State": "MI",
    "City": "Quinnesec"
  },
  {
    "State": "MI",
    "City": "Ralph"
  },
  {
    "State": "MI",
    "City": "Rapid River"
  },
  {
    "State": "MI",
    "City": "Republic"
  },
  {
    "State": "MI",
    "City": "Rock"
  },
  {
    "State": "MI",
    "City": "Sagola"
  },
  {
    "State": "MI",
    "City": "Seney"
  },
  {
    "State": "MI",
    "City": "Shingleton"
  },
  {
    "State": "MI",
    "City": "Skandia"
  },
  {
    "State": "MI",
    "City": "Spalding"
  },
  {
    "State": "MI",
    "City": "Stephenson"
  },
  {
    "State": "MI",
    "City": "Trenary"
  },
  {
    "State": "MI",
    "City": "Vulcan"
  },
  {
    "State": "MI",
    "City": "Wallace"
  },
  {
    "State": "MI",
    "City": "Wells"
  },
  {
    "State": "MI",
    "City": "Wetmore"
  },
  {
    "State": "MI",
    "City": "Wilson"
  },
  {
    "State": "MI",
    "City": "Ahmeek"
  },
  {
    "State": "MI",
    "City": "Alpha"
  },
  {
    "State": "MI",
    "City": "Amasa"
  },
  {
    "State": "MI",
    "City": "Atlantic Mine"
  },
  {
    "State": "MI",
    "City": "Baraga"
  },
  {
    "State": "MI",
    "City": "Bergland"
  },
  {
    "State": "MI",
    "City": "Bessemer"
  },
  {
    "State": "MI",
    "City": "Bruce Crossing"
  },
  {
    "State": "MI",
    "City": "Calumet"
  },
  {
    "State": "MI",
    "City": "Caspian"
  },
  {
    "State": "MI",
    "City": "Chassell"
  },
  {
    "State": "MI",
    "City": "Copper City"
  },
  {
    "State": "MI",
    "City": "Copper Harbor"
  },
  {
    "State": "MI",
    "City": "Covington"
  },
  {
    "State": "MI",
    "City": "Crystal Falls"
  },
  {
    "State": "MI",
    "City": "Dodgeville"
  },
  {
    "State": "MI",
    "City": "Dollar Bay"
  },
  {
    "State": "MI",
    "City": "Ewen"
  },
  {
    "State": "MI",
    "City": "Gaastra"
  },
  {
    "State": "MI",
    "City": "Greenland"
  },
  {
    "State": "MI",
    "City": "Hancock"
  },
  {
    "State": "MI",
    "City": "Houghton"
  },
  {
    "State": "MI",
    "City": "Hubbell"
  },
  {
    "State": "MI",
    "City": "Iron River"
  },
  {
    "State": "MI",
    "City": "Ironwood"
  },
  {
    "State": "MI",
    "City": "Kearsarge"
  },
  {
    "State": "MI",
    "City": "Lake Linden"
  },
  {
    "State": "MI",
    "City": "Lanse"
  },
  {
    "State": "MI",
    "City": "Marenisco"
  },
  {
    "State": "MI",
    "City": "Mass City"
  },
  {
    "State": "MI",
    "City": "Mohawk"
  },
  {
    "State": "MI",
    "City": "Nisula"
  },
  {
    "State": "MI",
    "City": "Ontonagon"
  },
  {
    "State": "MI",
    "City": "Painesdale"
  },
  {
    "State": "MI",
    "City": "Pelkie"
  },
  {
    "State": "MI",
    "City": "Ramsay"
  },
  {
    "State": "MI",
    "City": "Rockland"
  },
  {
    "State": "MI",
    "City": "Sidnaw"
  },
  {
    "State": "MI",
    "City": "Skanee"
  },
  {
    "State": "MI",
    "City": "South Range"
  },
  {
    "State": "MI",
    "City": "Stambaugh"
  },
  {
    "State": "MI",
    "City": "Toivola"
  },
  {
    "State": "MI",
    "City": "Trout Creek"
  },
  {
    "State": "MI",
    "City": "Wakefield"
  },
  {
    "State": "MI",
    "City": "Watersmeet"
  },
  {
    "State": "MI",
    "City": "Watton"
  },
  {
    "State": "MI",
    "City": "White Pine"
  },
  {
    "State": "IA",
    "City": "Ackworth"
  },
  {
    "State": "IA",
    "City": "Adair"
  },
  {
    "State": "IA",
    "City": "Adel"
  },
  {
    "State": "IA",
    "City": "Albion"
  },
  {
    "State": "IA",
    "City": "Alden"
  },
  {
    "State": "IA",
    "City": "Alleman"
  },
  {
    "State": "IA",
    "City": "Allerton"
  },
  {
    "State": "IA",
    "City": "Altoona"
  },
  {
    "State": "IA",
    "City": "Ames"
  },
  {
    "State": "IA",
    "City": "Anita"
  },
  {
    "State": "IA",
    "City": "Ankeny"
  },
  {
    "State": "IA",
    "City": "Atlantic"
  },
  {
    "State": "IA",
    "City": "Audubon"
  },
  {
    "State": "IA",
    "City": "Bagley"
  },
  {
    "State": "IA",
    "City": "Barnes City"
  },
  {
    "State": "IA",
    "City": "Baxter"
  },
  {
    "State": "IA",
    "City": "Bayard"
  },
  {
    "State": "IA",
    "City": "Beaver"
  },
  {
    "State": "IA",
    "City": "Berwick"
  },
  {
    "State": "IA",
    "City": "Bevington"
  },
  {
    "State": "IA",
    "City": "Blairsburg"
  },
  {
    "State": "IA",
    "City": "Bondurant"
  },
  {
    "State": "IA",
    "City": "Boone"
  },
  {
    "State": "IA",
    "City": "Booneville"
  },
  {
    "State": "IA",
    "City": "Bouton"
  },
  {
    "State": "IA",
    "City": "Boxholm"
  },
  {
    "State": "IA",
    "City": "Bradford"
  },
  {
    "State": "IA",
    "City": "Brayton"
  },
  {
    "State": "IA",
    "City": "Buckeye"
  },
  {
    "State": "IA",
    "City": "Bussey"
  },
  {
    "State": "IA",
    "City": "Cambridge"
  },
  {
    "State": "IA",
    "City": "Carlisle"
  },
  {
    "State": "IA",
    "City": "Casey"
  },
  {
    "State": "IA",
    "City": "Chariton"
  },
  {
    "State": "IA",
    "City": "Churdan"
  },
  {
    "State": "IA",
    "City": "Clemons"
  },
  {
    "State": "IA",
    "City": "Clio"
  },
  {
    "State": "IA",
    "City": "Colfax"
  },
  {
    "State": "IA",
    "City": "Collins"
  },
  {
    "State": "IA",
    "City": "Colo"
  },
  {
    "State": "IA",
    "City": "Columbia"
  },
  {
    "State": "IA",
    "City": "Coon Rapids"
  },
  {
    "State": "IA",
    "City": "Cooper"
  },
  {
    "State": "IA",
    "City": "Corydon"
  },
  {
    "State": "IA",
    "City": "Cumming"
  },
  {
    "State": "IA",
    "City": "Melcher Dallas"
  },
  {
    "State": "IA",
    "City": "Dallas Center"
  },
  {
    "State": "IA",
    "City": "Dana"
  },
  {
    "State": "IA",
    "City": "Davis City"
  },
  {
    "State": "IA",
    "City": "Dawson"
  },
  {
    "State": "IA",
    "City": "Decatur"
  },
  {
    "State": "IA",
    "City": "Derby"
  },
  {
    "State": "IA",
    "City": "De Soto"
  },
  {
    "State": "IA",
    "City": "Dexter"
  },
  {
    "State": "IA",
    "City": "Dows"
  },
  {
    "State": "IA",
    "City": "Earlham"
  },
  {
    "State": "IA",
    "City": "Elkhart"
  },
  {
    "State": "IA",
    "City": "Ellston"
  },
  {
    "State": "IA",
    "City": "Ellsworth"
  },
  {
    "State": "IA",
    "City": "Exira"
  },
  {
    "State": "IA",
    "City": "Ferguson"
  },
  {
    "State": "IA",
    "City": "Galt"
  },
  {
    "State": "IA",
    "City": "Garden City"
  },
  {
    "State": "IA",
    "City": "Garden Grove"
  },
  {
    "State": "IA",
    "City": "Gibson"
  },
  {
    "State": "IA",
    "City": "Gilbert"
  },
  {
    "State": "IA",
    "City": "Gilman"
  },
  {
    "State": "IA",
    "City": "Grand Junction"
  },
  {
    "State": "IA",
    "City": "Grand River"
  },
  {
    "State": "IA",
    "City": "Granger"
  },
  {
    "State": "IA",
    "City": "Gray"
  },
  {
    "State": "IA",
    "City": "Grimes"
  },
  {
    "State": "IA",
    "City": "Grinnell"
  },
  {
    "State": "IA",
    "City": "Guthrie Center"
  },
  {
    "State": "IA",
    "City": "Hamilton"
  },
  {
    "State": "IA",
    "City": "Hamlin"
  },
  {
    "State": "IA",
    "City": "Hartford"
  },
  {
    "State": "IA",
    "City": "Harvey"
  },
  {
    "State": "IA",
    "City": "Haverhill"
  },
  {
    "State": "IA",
    "City": "Hubbard"
  },
  {
    "State": "IA",
    "City": "Humeston"
  },
  {
    "State": "IA",
    "City": "Huxley"
  },
  {
    "State": "IA",
    "City": "Indianola"
  },
  {
    "State": "IA",
    "City": "Iowa Falls"
  },
  {
    "State": "IA",
    "City": "Ira"
  },
  {
    "State": "IA",
    "City": "Jamaica"
  },
  {
    "State": "IA",
    "City": "Jefferson"
  },
  {
    "State": "IA",
    "City": "Jewell"
  },
  {
    "State": "IA",
    "City": "Johnston"
  },
  {
    "State": "IA",
    "City": "Kamrar"
  },
  {
    "State": "IA",
    "City": "Kellerton"
  },
  {
    "State": "IA",
    "City": "Kelley"
  },
  {
    "State": "IA",
    "City": "Kellogg"
  },
  {
    "State": "IA",
    "City": "Keswick"
  },
  {
    "State": "IA",
    "City": "Killduff"
  },
  {
    "State": "IA",
    "City": "Knoxville"
  },
  {
    "State": "IA",
    "City": "Lacona"
  },
  {
    "State": "IA",
    "City": "Lamoni"
  },
  {
    "State": "IA",
    "City": "Laurel"
  },
  {
    "State": "IA",
    "City": "Le Grand"
  },
  {
    "State": "IA",
    "City": "Leighton"
  },
  {
    "State": "IA",
    "City": "Leon"
  },
  {
    "State": "IA",
    "City": "Liberty Center"
  },
  {
    "State": "IA",
    "City": "Linden"
  },
  {
    "State": "IA",
    "City": "Lineville"
  },
  {
    "State": "IA",
    "City": "Liscomb"
  },
  {
    "State": "IA",
    "City": "Lorimor"
  },
  {
    "State": "IA",
    "City": "Lovilia"
  },
  {
    "State": "IA",
    "City": "Lucas"
  },
  {
    "State": "IA",
    "City": "Luther"
  },
  {
    "State": "IA",
    "City": "Lynnville"
  },
  {
    "State": "IA",
    "City": "Mc Callsburg"
  },
  {
    "State": "IA",
    "City": "Macksburg"
  },
  {
    "State": "IA",
    "City": "Madrid"
  },
  {
    "State": "IA",
    "City": "Malcom"
  },
  {
    "State": "IA",
    "City": "Marshalltown"
  },
  {
    "State": "IA",
    "City": "Martensdale"
  },
  {
    "State": "IA",
    "City": "Maxwell"
  },
  {
    "State": "IA",
    "City": "Melbourne"
  },
  {
    "State": "IA",
    "City": "Menlo"
  },
  {
    "State": "IA",
    "City": "Millerton"
  },
  {
    "State": "IA",
    "City": "Milo"
  },
  {
    "State": "IA",
    "City": "Minburn"
  },
  {
    "State": "IA",
    "City": "Mingo"
  },
  {
    "State": "IA",
    "City": "Mitchellville"
  },
  {
    "State": "IA",
    "City": "Monroe"
  },
  {
    "State": "IA",
    "City": "Montezuma"
  },
  {
    "State": "IA",
    "City": "Montour"
  },
  {
    "State": "IA",
    "City": "Murray"
  },
  {
    "State": "IA",
    "City": "Nevada"
  },
  {
    "State": "IA",
    "City": "New Providence"
  },
  {
    "State": "IA",
    "City": "New Sharon"
  },
  {
    "State": "IA",
    "City": "Newton"
  },
  {
    "State": "IA",
    "City": "New Virginia"
  },
  {
    "State": "IA",
    "City": "Norwalk"
  },
  {
    "State": "IA",
    "City": "Ogden"
  },
  {
    "State": "IA",
    "City": "Osceola"
  },
  {
    "State": "IA",
    "City": "Otley"
  },
  {
    "State": "IA",
    "City": "Panora"
  },
  {
    "State": "IA",
    "City": "Paton"
  },
  {
    "State": "IA",
    "City": "Patterson"
  },
  {
    "State": "IA",
    "City": "Pella"
  },
  {
    "State": "IA",
    "City": "Perry"
  },
  {
    "State": "IA",
    "City": "Peru"
  },
  {
    "State": "IA",
    "City": "Pilot Mound"
  },
  {
    "State": "IA",
    "City": "Pleasantville"
  },
  {
    "State": "IA",
    "City": "Polk City"
  },
  {
    "State": "IA",
    "City": "Popejoy"
  },
  {
    "State": "IA",
    "City": "Prairie City"
  },
  {
    "State": "IA",
    "City": "Prole"
  },
  {
    "State": "IA",
    "City": "Radcliffe"
  },
  {
    "State": "IA",
    "City": "Randall"
  },
  {
    "State": "IA",
    "City": "Reasnor"
  },
  {
    "State": "IA",
    "City": "Redfield"
  },
  {
    "State": "IA",
    "City": "Rhodes"
  },
  {
    "State": "IA",
    "City": "Rippey"
  },
  {
    "State": "IA",
    "City": "Roland"
  },
  {
    "State": "IA",
    "City": "Runnells"
  },
  {
    "State": "IA",
    "City": "Russell"
  },
  {
    "State": "IA",
    "City": "Saint Anthony"
  },
  {
    "State": "IA",
    "City": "Saint Charles"
  },
  {
    "State": "IA",
    "City": "Saint Marys"
  },
  {
    "State": "IA",
    "City": "Searsboro"
  },
  {
    "State": "IA",
    "City": "Sheldahl"
  },
  {
    "State": "IA",
    "City": "Slater"
  },
  {
    "State": "IA",
    "City": "Stanhope"
  },
  {
    "State": "IA",
    "City": "State Center"
  },
  {
    "State": "IA",
    "City": "Story City"
  },
  {
    "State": "IA",
    "City": "Stratford"
  },
  {
    "State": "IA",
    "City": "Stuart"
  },
  {
    "State": "IA",
    "City": "Sully"
  },
  {
    "State": "IA",
    "City": "Swan"
  },
  {
    "State": "IA",
    "City": "Thayer"
  },
  {
    "State": "IA",
    "City": "Thornburg"
  },
  {
    "State": "IA",
    "City": "Tracy"
  },
  {
    "State": "IA",
    "City": "Truro"
  },
  {
    "State": "IA",
    "City": "Union"
  },
  {
    "State": "IA",
    "City": "Gifford"
  },
  {
    "State": "IA",
    "City": "Van Meter"
  },
  {
    "State": "IA",
    "City": "Van Wert"
  },
  {
    "State": "IA",
    "City": "Waukee"
  },
  {
    "State": "IA",
    "City": "Weldon"
  },
  {
    "State": "IA",
    "City": "West Des Moines"
  },
  {
    "State": "IA",
    "City": "What Cheer"
  },
  {
    "State": "IA",
    "City": "Whitten"
  },
  {
    "State": "IA",
    "City": "Williams"
  },
  {
    "State": "IA",
    "City": "Williamson"
  },
  {
    "State": "IA",
    "City": "Winterset"
  },
  {
    "State": "IA",
    "City": "Wiota"
  },
  {
    "State": "IA",
    "City": "Woodburn"
  },
  {
    "State": "IA",
    "City": "Woodward"
  },
  {
    "State": "IA",
    "City": "Yale"
  },
  {
    "State": "IA",
    "City": "Zearing"
  },
  {
    "State": "IA",
    "City": "Des Moines"
  },
  {
    "State": "IA",
    "City": "Urbandale"
  },
  {
    "State": "IA",
    "City": "Windsor Heights"
  },
  {
    "State": "IA",
    "City": "Clive"
  },
  {
    "State": "IA",
    "City": "Pleasant Hill"
  },
  {
    "State": "IA",
    "City": "Mason City"
  },
  {
    "State": "IA",
    "City": "Alexander"
  },
  {
    "State": "IA",
    "City": "Belmond"
  },
  {
    "State": "IA",
    "City": "Britt"
  },
  {
    "State": "IA",
    "City": "Buffalo Center"
  },
  {
    "State": "IA",
    "City": "Carpenter"
  },
  {
    "State": "IA",
    "City": "Chapin"
  },
  {
    "State": "IA",
    "City": "Clear Lake"
  },
  {
    "State": "IA",
    "City": "Corwith"
  },
  {
    "State": "IA",
    "City": "Coulter"
  },
  {
    "State": "IA",
    "City": "Crystal Lake"
  },
  {
    "State": "IA",
    "City": "Dougherty"
  },
  {
    "State": "IA",
    "City": "Fertile"
  },
  {
    "State": "IA",
    "City": "Floyd"
  },
  {
    "State": "IA",
    "City": "Forest City"
  },
  {
    "State": "IA",
    "City": "Garner"
  },
  {
    "State": "IA",
    "City": "Goodell"
  },
  {
    "State": "IA",
    "City": "Grafton"
  },
  {
    "State": "IA",
    "City": "Hampton"
  },
  {
    "State": "IA",
    "City": "Hanlontown"
  },
  {
    "State": "IA",
    "City": "Joice"
  },
  {
    "State": "IA",
    "City": "Kanawha"
  },
  {
    "State": "IA",
    "City": "Kensett"
  },
  {
    "State": "IA",
    "City": "Klemme"
  },
  {
    "State": "IA",
    "City": "Lake Mills"
  },
  {
    "State": "IA",
    "City": "Lakota"
  },
  {
    "State": "IA",
    "City": "Latimer"
  },
  {
    "State": "IA",
    "City": "Leland"
  },
  {
    "State": "IA",
    "City": "Little Cedar"
  },
  {
    "State": "IA",
    "City": "Mc Intire"
  },
  {
    "State": "IA",
    "City": "Manly"
  },
  {
    "State": "IA",
    "City": "Meservey"
  },
  {
    "State": "IA",
    "City": "Nora Springs"
  },
  {
    "State": "IA",
    "City": "Northwood"
  },
  {
    "State": "IA",
    "City": "Orchard"
  },
  {
    "State": "IA",
    "City": "Osage"
  },
  {
    "State": "IA",
    "City": "Plymouth"
  },
  {
    "State": "IA",
    "City": "Rake"
  },
  {
    "State": "IA",
    "City": "Riceville"
  },
  {
    "State": "IA",
    "City": "Rock Falls"
  },
  {
    "State": "IA",
    "City": "Rockford"
  },
  {
    "State": "IA",
    "City": "Rockwell"
  },
  {
    "State": "IA",
    "City": "Rowan"
  },
  {
    "State": "IA",
    "City": "Rudd"
  },
  {
    "State": "IA",
    "City": "Saint Ansgar"
  },
  {
    "State": "IA",
    "City": "Scarville"
  },
  {
    "State": "IA",
    "City": "Sheffield"
  },
  {
    "State": "IA",
    "City": "Stacyville"
  },
  {
    "State": "IA",
    "City": "Swaledale"
  },
  {
    "State": "IA",
    "City": "Thompson"
  },
  {
    "State": "IA",
    "City": "Thornton"
  },
  {
    "State": "IA",
    "City": "Titonka"
  },
  {
    "State": "IA",
    "City": "Toeterville"
  },
  {
    "State": "IA",
    "City": "Ventura"
  },
  {
    "State": "IA",
    "City": "Wesley"
  },
  {
    "State": "IA",
    "City": "Woden"
  },
  {
    "State": "IA",
    "City": "Fort Dodge"
  },
  {
    "State": "IA",
    "City": "Albert City"
  },
  {
    "State": "IA",
    "City": "Algona"
  },
  {
    "State": "IA",
    "City": "Armstrong"
  },
  {
    "State": "IA",
    "City": "Ayrshire"
  },
  {
    "State": "IA",
    "City": "Badger"
  },
  {
    "State": "IA",
    "City": "Bancroft"
  },
  {
    "State": "IA",
    "City": "Barnum"
  },
  {
    "State": "IA",
    "City": "Bode"
  },
  {
    "State": "IA",
    "City": "Bradgate"
  },
  {
    "State": "IA",
    "City": "Burnside"
  },
  {
    "State": "IA",
    "City": "Burt"
  },
  {
    "State": "IA",
    "City": "Callender"
  },
  {
    "State": "IA",
    "City": "Clare"
  },
  {
    "State": "IA",
    "City": "Clarion"
  },
  {
    "State": "IA",
    "City": "Curlew"
  },
  {
    "State": "IA",
    "City": "Cylinder"
  },
  {
    "State": "IA",
    "City": "Dakota City"
  },
  {
    "State": "IA",
    "City": "Dayton"
  },
  {
    "State": "IA",
    "City": "Dolliver"
  },
  {
    "State": "IA",
    "City": "Duncombe"
  },
  {
    "State": "IA",
    "City": "Eagle Grove"
  },
  {
    "State": "IA",
    "City": "Early"
  },
  {
    "State": "IA",
    "City": "Emmetsburg"
  },
  {
    "State": "IA",
    "City": "Farnhamville"
  },
  {
    "State": "IA",
    "City": "Fenton"
  },
  {
    "State": "IA",
    "City": "Fonda"
  },
  {
    "State": "IA",
    "City": "Gilmore City"
  },
  {
    "State": "IA",
    "City": "Goldfield"
  },
  {
    "State": "IA",
    "City": "Gowrie"
  },
  {
    "State": "IA",
    "City": "Harcourt"
  },
  {
    "State": "IA",
    "City": "Hardy"
  },
  {
    "State": "IA",
    "City": "Havelock"
  },
  {
    "State": "IA",
    "City": "Humboldt"
  },
  {
    "State": "IA",
    "City": "Jolley"
  },
  {
    "State": "IA",
    "City": "Knierim"
  },
  {
    "State": "IA",
    "City": "Laurens"
  },
  {
    "State": "IA",
    "City": "Ledyard"
  },
  {
    "State": "IA",
    "City": "Lehigh"
  },
  {
    "State": "IA",
    "City": "Livermore"
  },
  {
    "State": "IA",
    "City": "Lone Rock"
  },
  {
    "State": "IA",
    "City": "Lu Verne"
  },
  {
    "State": "IA",
    "City": "Lytton"
  },
  {
    "State": "IA",
    "City": "Mallard"
  },
  {
    "State": "IA",
    "City": "Manson"
  },
  {
    "State": "IA",
    "City": "Marathon"
  },
  {
    "State": "IA",
    "City": "Moorland"
  },
  {
    "State": "IA",
    "City": "Nemaha"
  },
  {
    "State": "IA",
    "City": "Newell"
  },
  {
    "State": "IA",
    "City": "Otho"
  },
  {
    "State": "IA",
    "City": "Ottosen"
  },
  {
    "State": "IA",
    "City": "Palmer"
  },
  {
    "State": "IA",
    "City": "Plover"
  },
  {
    "State": "IA",
    "City": "Pocahontas"
  },
  {
    "State": "IA",
    "City": "Pomeroy"
  },
  {
    "State": "IA",
    "City": "Rembrandt"
  },
  {
    "State": "IA",
    "City": "Renwick"
  },
  {
    "State": "IA",
    "City": "Ringsted"
  },
  {
    "State": "IA",
    "City": "Rockwell City"
  },
  {
    "State": "IA",
    "City": "Rolfe"
  },
  {
    "State": "IA",
    "City": "Rutland"
  },
  {
    "State": "IA",
    "City": "Sac City"
  },
  {
    "State": "IA",
    "City": "Sioux Rapids"
  },
  {
    "State": "IA",
    "City": "Somers"
  },
  {
    "State": "IA",
    "City": "Storm Lake"
  },
  {
    "State": "IA",
    "City": "Swea City"
  },
  {
    "State": "IA",
    "City": "Thor"
  },
  {
    "State": "IA",
    "City": "Truesdale"
  },
  {
    "State": "IA",
    "City": "Varina"
  },
  {
    "State": "IA",
    "City": "Vincent"
  },
  {
    "State": "IA",
    "City": "Webster City"
  },
  {
    "State": "IA",
    "City": "West Bend"
  },
  {
    "State": "IA",
    "City": "Whittemore"
  },
  {
    "State": "IA",
    "City": "Woolstock"
  },
  {
    "State": "IA",
    "City": "Ackley"
  },
  {
    "State": "IA",
    "City": "Allison"
  },
  {
    "State": "IA",
    "City": "Alta Vista"
  },
  {
    "State": "IA",
    "City": "Aplington"
  },
  {
    "State": "IA",
    "City": "Aredale"
  },
  {
    "State": "IA",
    "City": "Arlington"
  },
  {
    "State": "IA",
    "City": "Aurora"
  },
  {
    "State": "IA",
    "City": "Austinville"
  },
  {
    "State": "IA",
    "City": "Beaman"
  },
  {
    "State": "IA",
    "City": "Bristow"
  },
  {
    "State": "IA",
    "City": "Buckingham"
  },
  {
    "State": "IA",
    "City": "Cedar Falls"
  },
  {
    "State": "IA",
    "City": "Charles City"
  },
  {
    "State": "IA",
    "City": "Clarksville"
  },
  {
    "State": "IA",
    "City": "Colwell"
  },
  {
    "State": "IA",
    "City": "Conrad"
  },
  {
    "State": "IA",
    "City": "Denver"
  },
  {
    "State": "IA",
    "City": "Dewar"
  },
  {
    "State": "IA",
    "City": "Dike"
  },
  {
    "State": "IA",
    "City": "Dumont"
  },
  {
    "State": "IA",
    "City": "Dunkerton"
  },
  {
    "State": "IA",
    "City": "Eldora"
  },
  {
    "State": "IA",
    "City": "Elma"
  },
  {
    "State": "IA",
    "City": "Fairbank"
  },
  {
    "State": "IA",
    "City": "Fredericksburg"
  },
  {
    "State": "IA",
    "City": "Frederika"
  },
  {
    "State": "IA",
    "City": "Garwin"
  },
  {
    "State": "IA",
    "City": "Geneva"
  },
  {
    "State": "IA",
    "City": "Gilbertville"
  },
  {
    "State": "IA",
    "City": "Gladbrook"
  },
  {
    "State": "IA",
    "City": "Greene"
  },
  {
    "State": "IA",
    "City": "Grundy Center"
  },
  {
    "State": "IA",
    "City": "Hazleton"
  },
  {
    "State": "IA",
    "City": "Holland"
  },
  {
    "State": "IA",
    "City": "Hudson"
  },
  {
    "State": "IA",
    "City": "Independence"
  },
  {
    "State": "IA",
    "City": "Ionia"
  },
  {
    "State": "IA",
    "City": "Janesville"
  },
  {
    "State": "IA",
    "City": "Jesup"
  },
  {
    "State": "IA",
    "City": "Kesley"
  },
  {
    "State": "IA",
    "City": "Lamont"
  },
  {
    "State": "IA",
    "City": "La Porte City"
  },
  {
    "State": "IA",
    "City": "Lincoln"
  },
  {
    "State": "IA",
    "City": "Marble Rock"
  },
  {
    "State": "IA",
    "City": "Masonville"
  },
  {
    "State": "IA",
    "City": "Maynard"
  },
  {
    "State": "IA",
    "City": "Morrison"
  },
  {
    "State": "IA",
    "City": "Nashua"
  },
  {
    "State": "IA",
    "City": "New Hampton"
  },
  {
    "State": "IA",
    "City": "New Hartford"
  },
  {
    "State": "IA",
    "City": "North Washington"
  },
  {
    "State": "IA",
    "City": "Oelwein"
  },
  {
    "State": "IA",
    "City": "Oran"
  },
  {
    "State": "IA",
    "City": "Parkersburg"
  },
  {
    "State": "IA",
    "City": "Plainfield"
  },
  {
    "State": "IA",
    "City": "Raymond"
  },
  {
    "State": "IA",
    "City": "Readlyn"
  },
  {
    "State": "IA",
    "City": "Reinbeck"
  },
  {
    "State": "IA",
    "City": "Shell Rock"
  },
  {
    "State": "IA",
    "City": "Stanley"
  },
  {
    "State": "IA",
    "City": "Steamboat Rock"
  },
  {
    "State": "IA",
    "City": "Stout"
  },
  {
    "State": "IA",
    "City": "Sumner"
  },
  {
    "State": "IA",
    "City": "Traer"
  },
  {
    "State": "IA",
    "City": "Tripoli"
  },
  {
    "State": "IA",
    "City": "Waverly"
  },
  {
    "State": "IA",
    "City": "Wellsburg"
  },
  {
    "State": "IA",
    "City": "Westgate"
  },
  {
    "State": "IA",
    "City": "Winthrop"
  },
  {
    "State": "IA",
    "City": "Waterloo"
  },
  {
    "State": "IA",
    "City": "Evansdale"
  },
  {
    "State": "IA",
    "City": "Creston"
  },
  {
    "State": "IA",
    "City": "Afton"
  },
  {
    "State": "IA",
    "City": "Arispe"
  },
  {
    "State": "IA",
    "City": "Bedford"
  },
  {
    "State": "IA",
    "City": "Benton"
  },
  {
    "State": "IA",
    "City": "Blockton"
  },
  {
    "State": "IA",
    "City": "Bridgewater"
  },
  {
    "State": "IA",
    "City": "Carbon"
  },
  {
    "State": "IA",
    "City": "Clearfield"
  },
  {
    "State": "IA",
    "City": "Corning"
  },
  {
    "State": "IA",
    "City": "Cromwell"
  },
  {
    "State": "IA",
    "City": "Cumberland"
  },
  {
    "State": "IA",
    "City": "Diagonal"
  },
  {
    "State": "IA",
    "City": "Fontanelle"
  },
  {
    "State": "IA",
    "City": "Grant"
  },
  {
    "State": "IA",
    "City": "Gravity"
  },
  {
    "State": "IA",
    "City": "Greenfield"
  },
  {
    "State": "IA",
    "City": "Lenox"
  },
  {
    "State": "IA",
    "City": "Massena"
  },
  {
    "State": "IA",
    "City": "Mount Ayr"
  },
  {
    "State": "IA",
    "City": "Nodaway"
  },
  {
    "State": "IA",
    "City": "Orient"
  },
  {
    "State": "IA",
    "City": "Prescott"
  },
  {
    "State": "IA",
    "City": "Redding"
  },
  {
    "State": "IA",
    "City": "Shannon City"
  },
  {
    "State": "IA",
    "City": "Sharpsburg"
  },
  {
    "State": "IA",
    "City": "Tingley"
  },
  {
    "State": "IA",
    "City": "Villisca"
  },
  {
    "State": "IA",
    "City": "Akron"
  },
  {
    "State": "IA",
    "City": "Alta"
  },
  {
    "State": "IA",
    "City": "Alton"
  },
  {
    "State": "IA",
    "City": "Anthon"
  },
  {
    "State": "IA",
    "City": "Aurelia"
  },
  {
    "State": "IA",
    "City": "Battle Creek"
  },
  {
    "State": "IA",
    "City": "Bronson"
  },
  {
    "State": "IA",
    "City": "Brunsville"
  },
  {
    "State": "IA",
    "City": "Calumet"
  },
  {
    "State": "IA",
    "City": "Castana"
  },
  {
    "State": "IA",
    "City": "Chatsworth"
  },
  {
    "State": "IA",
    "City": "Cherokee"
  },
  {
    "State": "IA",
    "City": "Cleghorn"
  },
  {
    "State": "IA",
    "City": "Climbing Hill"
  },
  {
    "State": "IA",
    "City": "Correctionville"
  },
  {
    "State": "IA",
    "City": "Cushing"
  },
  {
    "State": "IA",
    "City": "Danbury"
  },
  {
    "State": "IA",
    "City": "Galva"
  },
  {
    "State": "IA",
    "City": "Granville"
  },
  {
    "State": "IA",
    "City": "Hawarden"
  },
  {
    "State": "IA",
    "City": "Hinton"
  },
  {
    "State": "IA",
    "City": "Holstein"
  },
  {
    "State": "IA",
    "City": "Hornick"
  },
  {
    "State": "IA",
    "City": "Ireton"
  },
  {
    "State": "IA",
    "City": "Kingsley"
  },
  {
    "State": "IA",
    "City": "Larrabee"
  },
  {
    "State": "IA",
    "City": "Lawton"
  },
  {
    "State": "IA",
    "City": "Le Mars"
  },
  {
    "State": "IA",
    "City": "Linn Grove"
  },
  {
    "State": "IA",
    "City": "Mapleton"
  },
  {
    "State": "IA",
    "City": "Marcus"
  },
  {
    "State": "IA",
    "City": "Maurice"
  },
  {
    "State": "IA",
    "City": "Meriden"
  },
  {
    "State": "IA",
    "City": "Merrill"
  },
  {
    "State": "IA",
    "City": "Moville"
  },
  {
    "State": "IA",
    "City": "Onawa"
  },
  {
    "State": "IA",
    "City": "Orange City"
  },
  {
    "State": "IA",
    "City": "Oto"
  },
  {
    "State": "IA",
    "City": "Oyens"
  },
  {
    "State": "IA",
    "City": "Paullina"
  },
  {
    "State": "IA",
    "City": "Peterson"
  },
  {
    "State": "IA",
    "City": "Pierson"
  },
  {
    "State": "IA",
    "City": "Quimby"
  },
  {
    "State": "IA",
    "City": "Remsen"
  },
  {
    "State": "IA",
    "City": "Rodney"
  },
  {
    "State": "IA",
    "City": "Salix"
  },
  {
    "State": "IA",
    "City": "Schaller"
  },
  {
    "State": "IA",
    "City": "Sergeant Bluff"
  },
  {
    "State": "IA",
    "City": "Sloan"
  },
  {
    "State": "IA",
    "City": "Smithland"
  },
  {
    "State": "IA",
    "City": "Sutherland"
  },
  {
    "State": "IA",
    "City": "Ute"
  },
  {
    "State": "IA",
    "City": "Washta"
  },
  {
    "State": "IA",
    "City": "Westfield"
  },
  {
    "State": "IA",
    "City": "Whiting"
  },
  {
    "State": "IA",
    "City": "Sioux City"
  },
  {
    "State": "IA",
    "City": "Sheldon"
  },
  {
    "State": "IA",
    "City": "Alvord"
  },
  {
    "State": "IA",
    "City": "Archer"
  },
  {
    "State": "IA",
    "City": "Ashton"
  },
  {
    "State": "IA",
    "City": "Boyden"
  },
  {
    "State": "IA",
    "City": "Doon"
  },
  {
    "State": "IA",
    "City": "George"
  },
  {
    "State": "IA",
    "City": "Hospers"
  },
  {
    "State": "IA",
    "City": "Hull"
  },
  {
    "State": "IA",
    "City": "Inwood"
  },
  {
    "State": "IA",
    "City": "Larchwood"
  },
  {
    "State": "IA",
    "City": "Lester"
  },
  {
    "State": "IA",
    "City": "Little Rock"
  },
  {
    "State": "IA",
    "City": "Matlock"
  },
  {
    "State": "IA",
    "City": "Primghar"
  },
  {
    "State": "IA",
    "City": "Rock Rapids"
  },
  {
    "State": "IA",
    "City": "Rock Valley"
  },
  {
    "State": "IA",
    "City": "Sanborn"
  },
  {
    "State": "IA",
    "City": "Sibley"
  },
  {
    "State": "IA",
    "City": "Sioux Center"
  },
  {
    "State": "IA",
    "City": "Spencer"
  },
  {
    "State": "IA",
    "City": "Arnolds Park"
  },
  {
    "State": "IA",
    "City": "Dickens"
  },
  {
    "State": "IA",
    "City": "Estherville"
  },
  {
    "State": "IA",
    "City": "Everly"
  },
  {
    "State": "IA",
    "City": "Fostoria"
  },
  {
    "State": "IA",
    "City": "Gillett Grove"
  },
  {
    "State": "IA",
    "City": "Graettinger"
  },
  {
    "State": "IA",
    "City": "Greenville"
  },
  {
    "State": "IA",
    "City": "Gruver"
  },
  {
    "State": "IA",
    "City": "Harris"
  },
  {
    "State": "IA",
    "City": "Hartley"
  },
  {
    "State": "IA",
    "City": "Lake Park"
  },
  {
    "State": "IA",
    "City": "Melvin"
  },
  {
    "State": "IA",
    "City": "Milford"
  },
  {
    "State": "IA",
    "City": "Ocheyedan"
  },
  {
    "State": "IA",
    "City": "Okoboji"
  },
  {
    "State": "IA",
    "City": "Royal"
  },
  {
    "State": "IA",
    "City": "Ruthven"
  },
  {
    "State": "IA",
    "City": "Spirit Lake"
  },
  {
    "State": "IA",
    "City": "Superior"
  },
  {
    "State": "IA",
    "City": "Terril"
  },
  {
    "State": "IA",
    "City": "Wallingford"
  },
  {
    "State": "IA",
    "City": "Webb"
  },
  {
    "State": "IA",
    "City": "Carroll"
  },
  {
    "State": "IA",
    "City": "Arcadia"
  },
  {
    "State": "IA",
    "City": "Arthur"
  },
  {
    "State": "IA",
    "City": "Aspinwall"
  },
  {
    "State": "IA",
    "City": "Auburn"
  },
  {
    "State": "IA",
    "City": "Breda"
  },
  {
    "State": "IA",
    "City": "Charter Oak"
  },
  {
    "State": "IA",
    "City": "Dedham"
  },
  {
    "State": "IA",
    "City": "Deloit"
  },
  {
    "State": "IA",
    "City": "Denison"
  },
  {
    "State": "IA",
    "City": "Glidden"
  },
  {
    "State": "IA",
    "City": "Halbur"
  },
  {
    "State": "IA",
    "City": "Ida Grove"
  },
  {
    "State": "IA",
    "City": "Irwin"
  },
  {
    "State": "IA",
    "City": "Kirkman"
  },
  {
    "State": "IA",
    "City": "Kiron"
  },
  {
    "State": "IA",
    "City": "Lake City"
  },
  {
    "State": "IA",
    "City": "Lake View"
  },
  {
    "State": "IA",
    "City": "Lanesboro"
  },
  {
    "State": "IA",
    "City": "Lidderdale"
  },
  {
    "State": "IA",
    "City": "Lohrville"
  },
  {
    "State": "IA",
    "City": "Manilla"
  },
  {
    "State": "IA",
    "City": "Manning"
  },
  {
    "State": "IA",
    "City": "Odebolt"
  },
  {
    "State": "IA",
    "City": "Ralston"
  },
  {
    "State": "IA",
    "City": "Ricketts"
  },
  {
    "State": "IA",
    "City": "Schleswig"
  },
  {
    "State": "IA",
    "City": "Scranton"
  },
  {
    "State": "IA",
    "City": "Templeton"
  },
  {
    "State": "IA",
    "City": "Vail"
  },
  {
    "State": "IA",
    "City": "Wall Lake"
  },
  {
    "State": "IA",
    "City": "Westside"
  },
  {
    "State": "IA",
    "City": "Council Bluffs"
  },
  {
    "State": "IA",
    "City": "Carter Lake"
  },
  {
    "State": "IA",
    "City": "Arion"
  },
  {
    "State": "IA",
    "City": "Avoca"
  },
  {
    "State": "IA",
    "City": "Blencoe"
  },
  {
    "State": "IA",
    "City": "Carson"
  },
  {
    "State": "IA",
    "City": "Crescent"
  },
  {
    "State": "IA",
    "City": "Defiance"
  },
  {
    "State": "IA",
    "City": "Dow City"
  },
  {
    "State": "IA",
    "City": "Dunlap"
  },
  {
    "State": "IA",
    "City": "Earling"
  },
  {
    "State": "IA",
    "City": "Elk Horn"
  },
  {
    "State": "IA",
    "City": "Elliott"
  },
  {
    "State": "IA",
    "City": "Emerson"
  },
  {
    "State": "IA",
    "City": "Glenwood"
  },
  {
    "State": "IA",
    "City": "Griswold"
  },
  {
    "State": "IA",
    "City": "Hancock"
  },
  {
    "State": "IA",
    "City": "Harlan"
  },
  {
    "State": "IA",
    "City": "Hastings"
  },
  {
    "State": "IA",
    "City": "Henderson"
  },
  {
    "State": "IA",
    "City": "Honey Creek"
  },
  {
    "State": "IA",
    "City": "Kimballton"
  },
  {
    "State": "IA",
    "City": "Lewis"
  },
  {
    "State": "IA",
    "City": "Little Sioux"
  },
  {
    "State": "IA",
    "City": "Logan"
  },
  {
    "State": "IA",
    "City": "Mc Clelland"
  },
  {
    "State": "IA",
    "City": "Macedonia"
  },
  {
    "State": "IA",
    "City": "Magnolia"
  },
  {
    "State": "IA",
    "City": "Malvern"
  },
  {
    "State": "IA",
    "City": "Marne"
  },
  {
    "State": "IA",
    "City": "Minden"
  },
  {
    "State": "IA",
    "City": "Mineola"
  },
  {
    "State": "IA",
    "City": "Missouri Valley"
  },
  {
    "State": "IA",
    "City": "Modale"
  },
  {
    "State": "IA",
    "City": "Mondamin"
  },
  {
    "State": "IA",
    "City": "Moorhead"
  },
  {
    "State": "IA",
    "City": "Neola"
  },
  {
    "State": "IA",
    "City": "Oakland"
  },
  {
    "State": "IA",
    "City": "Pacific Junction"
  },
  {
    "State": "IA",
    "City": "Panama"
  },
  {
    "State": "IA",
    "City": "Persia"
  },
  {
    "State": "IA",
    "City": "Pisgah"
  },
  {
    "State": "IA",
    "City": "Portsmouth"
  },
  {
    "State": "IA",
    "City": "Red Oak"
  },
  {
    "State": "IA",
    "City": "Shelby"
  },
  {
    "State": "IA",
    "City": "Silver City"
  },
  {
    "State": "IA",
    "City": "Soldier"
  },
  {
    "State": "IA",
    "City": "Stanton"
  },
  {
    "State": "IA",
    "City": "Treynor"
  },
  {
    "State": "IA",
    "City": "Underwood"
  },
  {
    "State": "IA",
    "City": "Walnut"
  },
  {
    "State": "IA",
    "City": "Westphalia"
  },
  {
    "State": "IA",
    "City": "Woodbine"
  },
  {
    "State": "IA",
    "City": "Shenandoah"
  },
  {
    "State": "IA",
    "City": "Blanchard"
  },
  {
    "State": "IA",
    "City": "Braddyville"
  },
  {
    "State": "IA",
    "City": "Clarinda"
  },
  {
    "State": "IA",
    "City": "Coin"
  },
  {
    "State": "IA",
    "City": "College Springs"
  },
  {
    "State": "IA",
    "City": "Essex"
  },
  {
    "State": "IA",
    "City": "Farragut"
  },
  {
    "State": "IA",
    "City": "Hamburg"
  },
  {
    "State": "IA",
    "City": "Imogene"
  },
  {
    "State": "IA",
    "City": "New Market"
  },
  {
    "State": "IA",
    "City": "Northboro"
  },
  {
    "State": "IA",
    "City": "Percival"
  },
  {
    "State": "IA",
    "City": "Randolph"
  },
  {
    "State": "IA",
    "City": "Riverton"
  },
  {
    "State": "IA",
    "City": "Shambaugh"
  },
  {
    "State": "IA",
    "City": "Sidney"
  },
  {
    "State": "IA",
    "City": "Tabor"
  },
  {
    "State": "IA",
    "City": "Thurman"
  },
  {
    "State": "IA",
    "City": "Yorktown"
  },
  {
    "State": "IA",
    "City": "Dubuque"
  },
  {
    "State": "IA",
    "City": "Andrew"
  },
  {
    "State": "IA",
    "City": "Bellevue"
  },
  {
    "State": "IA",
    "City": "Bernard"
  },
  {
    "State": "IA",
    "City": "Cascade"
  },
  {
    "State": "IA",
    "City": "Colesburg"
  },
  {
    "State": "IA",
    "City": "Delaware"
  },
  {
    "State": "IA",
    "City": "Delmar"
  },
  {
    "State": "IA",
    "City": "Dundee"
  },
  {
    "State": "IA",
    "City": "Durango"
  },
  {
    "State": "IA",
    "City": "Dyersville"
  },
  {
    "State": "IA",
    "City": "Earlville"
  },
  {
    "State": "IA",
    "City": "Edgewood"
  },
  {
    "State": "IA",
    "City": "Elkader"
  },
  {
    "State": "IA",
    "City": "Elkport"
  },
  {
    "State": "IA",
    "City": "Epworth"
  },
  {
    "State": "IA",
    "City": "Farley"
  },
  {
    "State": "IA",
    "City": "Farmersburg"
  },
  {
    "State": "IA",
    "City": "Garber"
  },
  {
    "State": "IA",
    "City": "Garnavillo"
  },
  {
    "State": "IA",
    "City": "Greeley"
  },
  {
    "State": "IA",
    "City": "Guttenberg"
  },
  {
    "State": "IA",
    "City": "Holy Cross"
  },
  {
    "State": "IA",
    "City": "La Motte"
  },
  {
    "State": "IA",
    "City": "Luxemburg"
  },
  {
    "State": "IA",
    "City": "Manchester"
  },
  {
    "State": "IA",
    "City": "Maquoketa"
  },
  {
    "State": "IA",
    "City": "Miles"
  },
  {
    "State": "IA",
    "City": "New Vienna"
  },
  {
    "State": "IA",
    "City": "North Buena Vista"
  },
  {
    "State": "IA",
    "City": "Peosta"
  },
  {
    "State": "IA",
    "City": "Preston"
  },
  {
    "State": "IA",
    "City": "Sabula"
  },
  {
    "State": "IA",
    "City": "Saint Donatus"
  },
  {
    "State": "IA",
    "City": "Saint Olaf"
  },
  {
    "State": "IA",
    "City": "Sherrill"
  },
  {
    "State": "IA",
    "City": "Spragueville"
  },
  {
    "State": "IA",
    "City": "Springbrook"
  },
  {
    "State": "IA",
    "City": "Strawberry Point"
  },
  {
    "State": "IA",
    "City": "Volga"
  },
  {
    "State": "IA",
    "City": "Worthington"
  },
  {
    "State": "IA",
    "City": "Zwingle"
  },
  {
    "State": "IA",
    "City": "Decorah"
  },
  {
    "State": "IA",
    "City": "Calmar"
  },
  {
    "State": "IA",
    "City": "Castalia"
  },
  {
    "State": "IA",
    "City": "Chester"
  },
  {
    "State": "IA",
    "City": "Clermont"
  },
  {
    "State": "IA",
    "City": "Cresco"
  },
  {
    "State": "IA",
    "City": "Dorchester"
  },
  {
    "State": "IA",
    "City": "Elgin"
  },
  {
    "State": "IA",
    "City": "Fayette"
  },
  {
    "State": "IA",
    "City": "Fort Atkinson"
  },
  {
    "State": "IA",
    "City": "Harpers Ferry"
  },
  {
    "State": "IA",
    "City": "Hawkeye"
  },
  {
    "State": "IA",
    "City": "Highlandville"
  },
  {
    "State": "IA",
    "City": "Lansing"
  },
  {
    "State": "IA",
    "City": "Lawler"
  },
  {
    "State": "IA",
    "City": "Lime Springs"
  },
  {
    "State": "IA",
    "City": "Luana"
  },
  {
    "State": "IA",
    "City": "Mc Gregor"
  },
  {
    "State": "IA",
    "City": "Marquette"
  },
  {
    "State": "IA",
    "City": "Monona"
  },
  {
    "State": "IA",
    "City": "New Albin"
  },
  {
    "State": "IA",
    "City": "Ossian"
  },
  {
    "State": "IA",
    "City": "Postville"
  },
  {
    "State": "IA",
    "City": "Protivin"
  },
  {
    "State": "IA",
    "City": "Randalia"
  },
  {
    "State": "IA",
    "City": "Ridgeway"
  },
  {
    "State": "IA",
    "City": "Saint Lucas"
  },
  {
    "State": "IA",
    "City": "Spillville"
  },
  {
    "State": "IA",
    "City": "Wadena"
  },
  {
    "State": "IA",
    "City": "Waterville"
  },
  {
    "State": "IA",
    "City": "Waucoma"
  },
  {
    "State": "IA",
    "City": "Waukon"
  },
  {
    "State": "IA",
    "City": "West Union"
  },
  {
    "State": "IA",
    "City": "Ainsworth"
  },
  {
    "State": "IA",
    "City": "Alburnett"
  },
  {
    "State": "IA",
    "City": "Amana"
  },
  {
    "State": "IA",
    "City": "Anamosa"
  },
  {
    "State": "IA",
    "City": "Atkins"
  },
  {
    "State": "IA",
    "City": "Baldwin"
  },
  {
    "State": "IA",
    "City": "Belle Plaine"
  },
  {
    "State": "IA",
    "City": "Blairstown"
  },
  {
    "State": "IA",
    "City": "Brandon"
  },
  {
    "State": "IA",
    "City": "Brooklyn"
  },
  {
    "State": "IA",
    "City": "Center Junction"
  },
  {
    "State": "IA",
    "City": "Center Point"
  },
  {
    "State": "IA",
    "City": "Central City"
  },
  {
    "State": "IA",
    "City": "Chelsea"
  },
  {
    "State": "IA",
    "City": "Clarence"
  },
  {
    "State": "IA",
    "City": "Clutier"
  },
  {
    "State": "IA",
    "City": "Coggon"
  },
  {
    "State": "IA",
    "City": "Prairieburg"
  },
  {
    "State": "IA",
    "City": "Conroy"
  },
  {
    "State": "IA",
    "City": "Guernsey"
  },
  {
    "State": "IA",
    "City": "Deep River"
  },
  {
    "State": "IA",
    "City": "Delhi"
  },
  {
    "State": "IA",
    "City": "Dysart"
  },
  {
    "State": "IA",
    "City": "Elberon"
  },
  {
    "State": "IA",
    "City": "Ely"
  },
  {
    "State": "IA",
    "City": "Fairfax"
  },
  {
    "State": "IA",
    "City": "Garrison"
  },
  {
    "State": "IA",
    "City": "Harper"
  },
  {
    "State": "IA",
    "City": "Hartwick"
  },
  {
    "State": "IA",
    "City": "Hiawatha"
  },
  {
    "State": "IA",
    "City": "Hills"
  },
  {
    "State": "IA",
    "City": "Homestead"
  },
  {
    "State": "IA",
    "City": "Hopkinton"
  },
  {
    "State": "IA",
    "City": "Iowa City"
  },
  {
    "State": "IA",
    "City": "Coralville"
  },
  {
    "State": "IA",
    "City": "Kalona"
  },
  {
    "State": "IA",
    "City": "Keota"
  },
  {
    "State": "IA",
    "City": "Keystone"
  },
  {
    "State": "IA",
    "City": "Ladora"
  },
  {
    "State": "IA",
    "City": "Langworthy"
  },
  {
    "State": "IA",
    "City": "Lisbon"
  },
  {
    "State": "IA",
    "City": "Lost Nation"
  },
  {
    "State": "IA",
    "City": "Lowden"
  },
  {
    "State": "IA",
    "City": "Luzerne"
  },
  {
    "State": "IA",
    "City": "Marengo"
  },
  {
    "State": "IA",
    "City": "Marion"
  },
  {
    "State": "IA",
    "City": "Martelle"
  },
  {
    "State": "IA",
    "City": "Mechanicsville"
  },
  {
    "State": "IA",
    "City": "Middle Amana"
  },
  {
    "State": "IA",
    "City": "Millersburg"
  },
  {
    "State": "IA",
    "City": "Monmouth"
  },
  {
    "State": "IA",
    "City": "Monticello"
  },
  {
    "State": "IA",
    "City": "Morley"
  },
  {
    "State": "IA",
    "City": "Mount Auburn"
  },
  {
    "State": "IA",
    "City": "Mount Vernon"
  },
  {
    "State": "IA",
    "City": "Newhall"
  },
  {
    "State": "IA",
    "City": "North English"
  },
  {
    "State": "IA",
    "City": "North Liberty"
  },
  {
    "State": "IA",
    "City": "Norway"
  },
  {
    "State": "IA",
    "City": "Oakdale"
  },
  {
    "State": "IA",
    "City": "Olin"
  },
  {
    "State": "IA",
    "City": "Onslow"
  },
  {
    "State": "IA",
    "City": "Oxford"
  },
  {
    "State": "IA",
    "City": "Oxford Junction"
  },
  {
    "State": "IA",
    "City": "Palo"
  },
  {
    "State": "IA",
    "City": "Parnell"
  },
  {
    "State": "IA",
    "City": "Quasqueton"
  },
  {
    "State": "IA",
    "City": "Riverside"
  },
  {
    "State": "IA",
    "City": "Robins"
  },
  {
    "State": "IA",
    "City": "Rowley"
  },
  {
    "State": "IA",
    "City": "Ryan"
  },
  {
    "State": "IA",
    "City": "Shellsburg"
  },
  {
    "State": "IA",
    "City": "Solon"
  },
  {
    "State": "IA",
    "City": "South Amana"
  },
  {
    "State": "IA",
    "City": "South English"
  },
  {
    "State": "IA",
    "City": "Springville"
  },
  {
    "State": "IA",
    "City": "Stanwood"
  },
  {
    "State": "IA",
    "City": "Swisher"
  },
  {
    "State": "IA",
    "City": "Tama"
  },
  {
    "State": "IA",
    "City": "Tiffin"
  },
  {
    "State": "IA",
    "City": "Toddville"
  },
  {
    "State": "IA",
    "City": "Toledo"
  },
  {
    "State": "IA",
    "City": "Troy Mills"
  },
  {
    "State": "IA",
    "City": "Urbana"
  },
  {
    "State": "IA",
    "City": "Van Horne"
  },
  {
    "State": "IA",
    "City": "Victor"
  },
  {
    "State": "IA",
    "City": "Vining"
  },
  {
    "State": "IA",
    "City": "Vinton"
  },
  {
    "State": "IA",
    "City": "Viola"
  },
  {
    "State": "IA",
    "City": "Walford"
  },
  {
    "State": "IA",
    "City": "Walker"
  },
  {
    "State": "IA",
    "City": "Washington"
  },
  {
    "State": "IA",
    "City": "Watkins"
  },
  {
    "State": "IA",
    "City": "Webster"
  },
  {
    "State": "IA",
    "City": "Wellman"
  },
  {
    "State": "IA",
    "City": "West Branch"
  },
  {
    "State": "IA",
    "City": "West Chester"
  },
  {
    "State": "IA",
    "City": "Williamsburg"
  },
  {
    "State": "IA",
    "City": "Wyoming"
  },
  {
    "State": "IA",
    "City": "Cedar Rapids"
  },
  {
    "State": "IA",
    "City": "Ottumwa"
  },
  {
    "State": "IA",
    "City": "Agency"
  },
  {
    "State": "IA",
    "City": "Albia"
  },
  {
    "State": "IA",
    "City": "Batavia"
  },
  {
    "State": "IA",
    "City": "Beacon"
  },
  {
    "State": "IA",
    "City": "Birmingham"
  },
  {
    "State": "IA",
    "City": "Blakesburg"
  },
  {
    "State": "IA",
    "City": "Bloomfield"
  },
  {
    "State": "IA",
    "City": "West Grove"
  },
  {
    "State": "IA",
    "City": "Brighton"
  },
  {
    "State": "IA",
    "City": "Cantril"
  },
  {
    "State": "IA",
    "City": "Cedar"
  },
  {
    "State": "IA",
    "City": "Centerville"
  },
  {
    "State": "IA",
    "City": "Chillicothe"
  },
  {
    "State": "IA",
    "City": "Cincinnati"
  },
  {
    "State": "IA",
    "City": "Delta"
  },
  {
    "State": "IA",
    "City": "Douds"
  },
  {
    "State": "IA",
    "City": "Drakesville"
  },
  {
    "State": "IA",
    "City": "Eddyville"
  },
  {
    "State": "IA",
    "City": "Eldon"
  },
  {
    "State": "IA",
    "City": "Exline"
  },
  {
    "State": "IA",
    "City": "Fairfield"
  },
  {
    "State": "IA",
    "City": "Floris"
  },
  {
    "State": "IA",
    "City": "Fremont"
  },
  {
    "State": "IA",
    "City": "Hayesville"
  },
  {
    "State": "IA",
    "City": "Hedrick"
  },
  {
    "State": "IA",
    "City": "Keosauqua"
  },
  {
    "State": "IA",
    "City": "Kirkville"
  },
  {
    "State": "IA",
    "City": "Libertyville"
  },
  {
    "State": "IA",
    "City": "Martinsburg"
  },
  {
    "State": "IA",
    "City": "Melrose"
  },
  {
    "State": "IA",
    "City": "Milton"
  },
  {
    "State": "IA",
    "City": "Moravia"
  },
  {
    "State": "IA",
    "City": "Moulton"
  },
  {
    "State": "IA",
    "City": "Mount Sterling"
  },
  {
    "State": "IA",
    "City": "Mystic"
  },
  {
    "State": "IA",
    "City": "Ollie"
  },
  {
    "State": "IA",
    "City": "Oskaloosa"
  },
  {
    "State": "IA",
    "City": "Packwood"
  },
  {
    "State": "IA",
    "City": "Plano"
  },
  {
    "State": "IA",
    "City": "Promise City"
  },
  {
    "State": "IA",
    "City": "Pulaski"
  },
  {
    "State": "IA",
    "City": "Richland"
  },
  {
    "State": "IA",
    "City": "Rose Hill"
  },
  {
    "State": "IA",
    "City": "Selma"
  },
  {
    "State": "IA",
    "City": "Seymour"
  },
  {
    "State": "IA",
    "City": "Sigourney"
  },
  {
    "State": "IA",
    "City": "Udell"
  },
  {
    "State": "IA",
    "City": "Unionville"
  },
  {
    "State": "IA",
    "City": "University Park"
  },
  {
    "State": "IA",
    "City": "Burlington"
  },
  {
    "State": "IA",
    "City": "Argyle"
  },
  {
    "State": "IA",
    "City": "Bonaparte"
  },
  {
    "State": "IA",
    "City": "Crawfordsville"
  },
  {
    "State": "IA",
    "City": "Danville"
  },
  {
    "State": "IA",
    "City": "Denmark"
  },
  {
    "State": "IA",
    "City": "Donnellson"
  },
  {
    "State": "IA",
    "City": "Farmington"
  },
  {
    "State": "IA",
    "City": "Fort Madison"
  },
  {
    "State": "IA",
    "City": "Hillsboro"
  },
  {
    "State": "IA",
    "City": "Houghton"
  },
  {
    "State": "IA",
    "City": "Keokuk"
  },
  {
    "State": "IA",
    "City": "Lockridge"
  },
  {
    "State": "IA",
    "City": "Mediapolis"
  },
  {
    "State": "IA",
    "City": "Middletown"
  },
  {
    "State": "IA",
    "City": "Montrose"
  },
  {
    "State": "IA",
    "City": "Morning Sun"
  },
  {
    "State": "IA",
    "City": "Mount Pleasant"
  },
  {
    "State": "IA",
    "City": "Rome"
  },
  {
    "State": "IA",
    "City": "Mount Union"
  },
  {
    "State": "IA",
    "City": "New London"
  },
  {
    "State": "IA",
    "City": "Oakville"
  },
  {
    "State": "IA",
    "City": "Olds"
  },
  {
    "State": "IA",
    "City": "Pilot Grove"
  },
  {
    "State": "IA",
    "City": "Salem"
  },
  {
    "State": "IA",
    "City": "Sperry"
  },
  {
    "State": "IA",
    "City": "Stockport"
  },
  {
    "State": "IA",
    "City": "Swedesburg"
  },
  {
    "State": "IA",
    "City": "Wapello"
  },
  {
    "State": "IA",
    "City": "Wayland"
  },
  {
    "State": "IA",
    "City": "West Burlington"
  },
  {
    "State": "IA",
    "City": "West Point"
  },
  {
    "State": "IA",
    "City": "Saint Paul"
  },
  {
    "State": "IA",
    "City": "Wever"
  },
  {
    "State": "IA",
    "City": "Winfield"
  },
  {
    "State": "IA",
    "City": "Yarmouth"
  },
  {
    "State": "IA",
    "City": "Andover"
  },
  {
    "State": "IA",
    "City": "Atalissa"
  },
  {
    "State": "IA",
    "City": "Bennett"
  },
  {
    "State": "IA",
    "City": "Bettendorf"
  },
  {
    "State": "IA",
    "City": "Blue Grass"
  },
  {
    "State": "IA",
    "City": "Bryant"
  },
  {
    "State": "IA",
    "City": "Buffalo"
  },
  {
    "State": "IA",
    "City": "Calamus"
  },
  {
    "State": "IA",
    "City": "Camanche"
  },
  {
    "State": "IA",
    "City": "Charlotte"
  },
  {
    "State": "IA",
    "City": "Clinton"
  },
  {
    "State": "IA",
    "City": "Columbus City"
  },
  {
    "State": "IA",
    "City": "Columbus Junction"
  },
  {
    "State": "IA",
    "City": "Conesville"
  },
  {
    "State": "IA",
    "City": "De Witt"
  },
  {
    "State": "IA",
    "City": "Dixon"
  },
  {
    "State": "IA",
    "City": "Donahue"
  },
  {
    "State": "IA",
    "City": "Durant"
  },
  {
    "State": "IA",
    "City": "Eldridge"
  },
  {
    "State": "IA",
    "City": "Fruitland"
  },
  {
    "State": "IA",
    "City": "Goose Lake"
  },
  {
    "State": "IA",
    "City": "Grand Mound"
  },
  {
    "State": "IA",
    "City": "Grandview"
  },
  {
    "State": "IA",
    "City": "Le Claire"
  },
  {
    "State": "IA",
    "City": "Letts"
  },
  {
    "State": "IA",
    "City": "Lone Tree"
  },
  {
    "State": "IA",
    "City": "Long Grove"
  },
  {
    "State": "IA",
    "City": "Low Moor"
  },
  {
    "State": "IA",
    "City": "Mc Causland"
  },
  {
    "State": "IA",
    "City": "Montpelier"
  },
  {
    "State": "IA",
    "City": "Moscow"
  },
  {
    "State": "IA",
    "City": "Muscatine"
  },
  {
    "State": "IA",
    "City": "New Liberty"
  },
  {
    "State": "IA",
    "City": "Nichols"
  },
  {
    "State": "IA",
    "City": "Pleasant Valley"
  },
  {
    "State": "IA",
    "City": "Princeton"
  },
  {
    "State": "IA",
    "City": "Stockton"
  },
  {
    "State": "IA",
    "City": "Teeds Grove"
  },
  {
    "State": "IA",
    "City": "Tipton"
  },
  {
    "State": "IA",
    "City": "Walcott"
  },
  {
    "State": "IA",
    "City": "Welton"
  },
  {
    "State": "IA",
    "City": "West Liberty"
  },
  {
    "State": "IA",
    "City": "Wheatland"
  },
  {
    "State": "IA",
    "City": "Wilton"
  },
  {
    "State": "IA",
    "City": "Davenport"
  },
  {
    "State": "WI",
    "City": "Adell"
  },
  {
    "State": "WI",
    "City": "Allenton"
  },
  {
    "State": "WI",
    "City": "Ashippun"
  },
  {
    "State": "WI",
    "City": "Belgium"
  },
  {
    "State": "WI",
    "City": "Brookfield"
  },
  {
    "State": "WI",
    "City": "Brownsville"
  },
  {
    "State": "WI",
    "City": "Butler"
  },
  {
    "State": "WI",
    "City": "Campbellsport"
  },
  {
    "State": "WI",
    "City": "Cascade"
  },
  {
    "State": "WI",
    "City": "Cedarburg"
  },
  {
    "State": "WI",
    "City": "Cedar Grove"
  },
  {
    "State": "WI",
    "City": "Chilton"
  },
  {
    "State": "WI",
    "City": "Cleveland"
  },
  {
    "State": "WI",
    "City": "Clyman"
  },
  {
    "State": "WI",
    "City": "Colgate"
  },
  {
    "State": "WI",
    "City": "Delafield"
  },
  {
    "State": "WI",
    "City": "Eden"
  },
  {
    "State": "WI",
    "City": "Elkhart Lake"
  },
  {
    "State": "WI",
    "City": "Fredonia"
  },
  {
    "State": "WI",
    "City": "Germantown"
  },
  {
    "State": "WI",
    "City": "Glenbeulah"
  },
  {
    "State": "WI",
    "City": "Grafton"
  },
  {
    "State": "WI",
    "City": "Greenbush"
  },
  {
    "State": "WI",
    "City": "Hartford"
  },
  {
    "State": "WI",
    "City": "Hartland"
  },
  {
    "State": "WI",
    "City": "Hingham"
  },
  {
    "State": "WI",
    "City": "Horicon"
  },
  {
    "State": "WI",
    "City": "Hubertus"
  },
  {
    "State": "WI",
    "City": "Hustisford"
  },
  {
    "State": "WI",
    "City": "Iron Ridge"
  },
  {
    "State": "WI",
    "City": "Ixonia"
  },
  {
    "State": "WI",
    "City": "Jackson"
  },
  {
    "State": "WI",
    "City": "Johnson Creek"
  },
  {
    "State": "WI",
    "City": "Juneau"
  },
  {
    "State": "WI",
    "City": "Kewaskum"
  },
  {
    "State": "WI",
    "City": "Kiel"
  },
  {
    "State": "WI",
    "City": "Kohler"
  },
  {
    "State": "WI",
    "City": "Lannon"
  },
  {
    "State": "WI",
    "City": "Lebanon"
  },
  {
    "State": "WI",
    "City": "Lomira"
  },
  {
    "State": "WI",
    "City": "Malone"
  },
  {
    "State": "WI",
    "City": "Mayville"
  },
  {
    "State": "WI",
    "City": "Menomonee Falls"
  },
  {
    "State": "WI",
    "City": "Merton"
  },
  {
    "State": "WI",
    "City": "Mount Calvary"
  },
  {
    "State": "WI",
    "City": "Nashotah"
  },
  {
    "State": "WI",
    "City": "Neosho"
  },
  {
    "State": "WI",
    "City": "Newburg"
  },
  {
    "State": "WI",
    "City": "New Holstein"
  },
  {
    "State": "WI",
    "City": "Newton"
  },
  {
    "State": "WI",
    "City": "North Lake"
  },
  {
    "State": "WI",
    "City": "Oakfield"
  },
  {
    "State": "WI",
    "City": "Oconomowoc"
  },
  {
    "State": "WI",
    "City": "Okauchee"
  },
  {
    "State": "WI",
    "City": "Oostburg"
  },
  {
    "State": "WI",
    "City": "Pewaukee"
  },
  {
    "State": "WI",
    "City": "Plymouth"
  },
  {
    "State": "WI",
    "City": "Port Washington"
  },
  {
    "State": "WI",
    "City": "Random Lake"
  },
  {
    "State": "WI",
    "City": "Richfield"
  },
  {
    "State": "WI",
    "City": "Rubicon"
  },
  {
    "State": "WI",
    "City": "Saint Cloud"
  },
  {
    "State": "WI",
    "City": "Saukville"
  },
  {
    "State": "WI",
    "City": "Sheboygan"
  },
  {
    "State": "WI",
    "City": "Sheboygan Falls"
  },
  {
    "State": "WI",
    "City": "Slinger"
  },
  {
    "State": "WI",
    "City": "Stockbridge"
  },
  {
    "State": "WI",
    "City": "Sussex"
  },
  {
    "State": "WI",
    "City": "West Bend"
  },
  {
    "State": "WI",
    "City": "Theresa"
  },
  {
    "State": "WI",
    "City": "Mequon"
  },
  {
    "State": "WI",
    "City": "Waldo"
  },
  {
    "State": "WI",
    "City": "Watertown"
  },
  {
    "State": "WI",
    "City": "Woodland"
  },
  {
    "State": "WI",
    "City": "Bassett"
  },
  {
    "State": "WI",
    "City": "Benet Lake"
  },
  {
    "State": "WI",
    "City": "Big Bend"
  },
  {
    "State": "WI",
    "City": "Bristol"
  },
  {
    "State": "WI",
    "City": "Burlington"
  },
  {
    "State": "WI",
    "City": "Caledonia"
  },
  {
    "State": "WI",
    "City": "Camp Lake"
  },
  {
    "State": "WI",
    "City": "Cudahy"
  },
  {
    "State": "WI",
    "City": "Darien"
  },
  {
    "State": "WI",
    "City": "Delavan"
  },
  {
    "State": "WI",
    "City": "Dousman"
  },
  {
    "State": "WI",
    "City": "Eagle"
  },
  {
    "State": "WI",
    "City": "East Troy"
  },
  {
    "State": "WI",
    "City": "Elkhorn"
  },
  {
    "State": "WI",
    "City": "Elm Grove"
  },
  {
    "State": "WI",
    "City": "Fontana"
  },
  {
    "State": "WI",
    "City": "Franksville"
  },
  {
    "State": "WI",
    "City": "Genesee Depot"
  },
  {
    "State": "WI",
    "City": "Genoa City"
  },
  {
    "State": "WI",
    "City": "Greendale"
  },
  {
    "State": "WI",
    "City": "Hales Corners"
  },
  {
    "State": "WI",
    "City": "Franklin"
  },
  {
    "State": "WI",
    "City": "Helenville"
  },
  {
    "State": "WI",
    "City": "Honey Creek"
  },
  {
    "State": "WI",
    "City": "Kansasville"
  },
  {
    "State": "WI",
    "City": "Kenosha"
  },
  {
    "State": "WI",
    "City": "New Berlin"
  },
  {
    "State": "WI",
    "City": "Lake Geneva"
  },
  {
    "State": "WI",
    "City": "Lyons"
  },
  {
    "State": "WI",
    "City": "Mukwonago"
  },
  {
    "State": "WI",
    "City": "Muskego"
  },
  {
    "State": "WI",
    "City": "New Munster"
  },
  {
    "State": "WI",
    "City": "North Prairie"
  },
  {
    "State": "WI",
    "City": "Oak Creek"
  },
  {
    "State": "WI",
    "City": "Palmyra"
  },
  {
    "State": "WI",
    "City": "Pell Lake"
  },
  {
    "State": "WI",
    "City": "Pleasant Prairie"
  },
  {
    "State": "WI",
    "City": "Powers Lake"
  },
  {
    "State": "WI",
    "City": "Rochester"
  },
  {
    "State": "WI",
    "City": "Salem"
  },
  {
    "State": "WI",
    "City": "Silver Lake"
  },
  {
    "State": "WI",
    "City": "Somers"
  },
  {
    "State": "WI",
    "City": "South Milwaukee"
  },
  {
    "State": "WI",
    "City": "Springfield"
  },
  {
    "State": "WI",
    "City": "Sturtevant"
  },
  {
    "State": "WI",
    "City": "Sullivan"
  },
  {
    "State": "WI",
    "City": "Trevor"
  },
  {
    "State": "WI",
    "City": "Twin Lakes"
  },
  {
    "State": "WI",
    "City": "Union Grove"
  },
  {
    "State": "WI",
    "City": "Wales"
  },
  {
    "State": "WI",
    "City": "Walworth"
  },
  {
    "State": "WI",
    "City": "Waterford"
  },
  {
    "State": "WI",
    "City": "Waukesha"
  },
  {
    "State": "WI",
    "City": "Whitewater"
  },
  {
    "State": "WI",
    "City": "Williams Bay"
  },
  {
    "State": "WI",
    "City": "Wilmot"
  },
  {
    "State": "WI",
    "City": "Woodworth"
  },
  {
    "State": "WI",
    "City": "Zenda"
  },
  {
    "State": "WI",
    "City": "Milwaukee"
  },
  {
    "State": "WI",
    "City": "Saint Francis"
  },
  {
    "State": "WI",
    "City": "Racine"
  },
  {
    "State": "WI",
    "City": "Afton"
  },
  {
    "State": "WI",
    "City": "Albany"
  },
  {
    "State": "WI",
    "City": "Arena"
  },
  {
    "State": "WI",
    "City": "Argyle"
  },
  {
    "State": "WI",
    "City": "Avalon"
  },
  {
    "State": "WI",
    "City": "Avoca"
  },
  {
    "State": "WI",
    "City": "Barneveld"
  },
  {
    "State": "WI",
    "City": "Belleville"
  },
  {
    "State": "WI",
    "City": "Belmont"
  },
  {
    "State": "WI",
    "City": "Beloit"
  },
  {
    "State": "WI",
    "City": "Black Earth"
  },
  {
    "State": "WI",
    "City": "Blanchardville"
  },
  {
    "State": "WI",
    "City": "Blue Mounds"
  },
  {
    "State": "WI",
    "City": "Blue River"
  },
  {
    "State": "WI",
    "City": "Brodhead"
  },
  {
    "State": "WI",
    "City": "Brooklyn"
  },
  {
    "State": "WI",
    "City": "Browntown"
  },
  {
    "State": "WI",
    "City": "Cambridge"
  },
  {
    "State": "WI",
    "City": "Clinton"
  },
  {
    "State": "WI",
    "City": "Cobb"
  },
  {
    "State": "WI",
    "City": "Cottage Grove"
  },
  {
    "State": "WI",
    "City": "Cross Plains"
  },
  {
    "State": "WI",
    "City": "Dane"
  },
  {
    "State": "WI",
    "City": "Darlington"
  },
  {
    "State": "WI",
    "City": "Deerfield"
  },
  {
    "State": "WI",
    "City": "Deforest"
  },
  {
    "State": "WI",
    "City": "Dodgeville"
  },
  {
    "State": "WI",
    "City": "Edgerton"
  },
  {
    "State": "WI",
    "City": "Edmund"
  },
  {
    "State": "WI",
    "City": "Evansville"
  },
  {
    "State": "WI",
    "City": "Footville"
  },
  {
    "State": "WI",
    "City": "Fort Atkinson"
  },
  {
    "State": "WI",
    "City": "Gotham"
  },
  {
    "State": "WI",
    "City": "Gratiot"
  },
  {
    "State": "WI",
    "City": "Hanover"
  },
  {
    "State": "WI",
    "City": "Highland"
  },
  {
    "State": "WI",
    "City": "Hollandale"
  },
  {
    "State": "WI",
    "City": "Janesville"
  },
  {
    "State": "WI",
    "City": "Jefferson"
  },
  {
    "State": "WI",
    "City": "Juda"
  },
  {
    "State": "WI",
    "City": "Lake Mills"
  },
  {
    "State": "WI",
    "City": "Linden"
  },
  {
    "State": "WI",
    "City": "Livingston"
  },
  {
    "State": "WI",
    "City": "Lodi"
  },
  {
    "State": "WI",
    "City": "Lone Rock"
  },
  {
    "State": "WI",
    "City": "Lowell"
  },
  {
    "State": "WI",
    "City": "Mcfarland"
  },
  {
    "State": "WI",
    "City": "Marshall"
  },
  {
    "State": "WI",
    "City": "Mazomanie"
  },
  {
    "State": "WI",
    "City": "Merrimac"
  },
  {
    "State": "WI",
    "City": "Middleton"
  },
  {
    "State": "WI",
    "City": "Milton"
  },
  {
    "State": "WI",
    "City": "Mineral Point"
  },
  {
    "State": "WI",
    "City": "Monroe"
  },
  {
    "State": "WI",
    "City": "Montfort"
  },
  {
    "State": "WI",
    "City": "Monticello"
  },
  {
    "State": "WI",
    "City": "Morrisonville"
  },
  {
    "State": "WI",
    "City": "Mount Horeb"
  },
  {
    "State": "WI",
    "City": "Muscoda"
  },
  {
    "State": "WI",
    "City": "New Glarus"
  },
  {
    "State": "WI",
    "City": "Oregon"
  },
  {
    "State": "WI",
    "City": "Orfordville"
  },
  {
    "State": "WI",
    "City": "Plain"
  },
  {
    "State": "WI",
    "City": "Prairie Du Sac"
  },
  {
    "State": "WI",
    "City": "Reeseville"
  },
  {
    "State": "WI",
    "City": "Rewey"
  },
  {
    "State": "WI",
    "City": "Richland Center"
  },
  {
    "State": "WI",
    "City": "Ridgeway"
  },
  {
    "State": "WI",
    "City": "Sauk City"
  },
  {
    "State": "WI",
    "City": "Sextonville"
  },
  {
    "State": "WI",
    "City": "Sharon"
  },
  {
    "State": "WI",
    "City": "Shullsburg"
  },
  {
    "State": "WI",
    "City": "South Wayne"
  },
  {
    "State": "WI",
    "City": "Spring Green"
  },
  {
    "State": "WI",
    "City": "Stoughton"
  },
  {
    "State": "WI",
    "City": "Sun Prairie"
  },
  {
    "State": "WI",
    "City": "Verona"
  },
  {
    "State": "WI",
    "City": "Waterloo"
  },
  {
    "State": "WI",
    "City": "Waunakee"
  },
  {
    "State": "WI",
    "City": "Windsor"
  },
  {
    "State": "WI",
    "City": "Woodford"
  },
  {
    "State": "WI",
    "City": "Madison"
  },
  {
    "State": "WI",
    "City": "Bagley"
  },
  {
    "State": "WI",
    "City": "Beetown"
  },
  {
    "State": "WI",
    "City": "Benton"
  },
  {
    "State": "WI",
    "City": "Bloomington"
  },
  {
    "State": "WI",
    "City": "Boscobel"
  },
  {
    "State": "WI",
    "City": "Cassville"
  },
  {
    "State": "WI",
    "City": "Cuba City"
  },
  {
    "State": "WI",
    "City": "Dickeyville"
  },
  {
    "State": "WI",
    "City": "Fennimore"
  },
  {
    "State": "WI",
    "City": "Glen Haven"
  },
  {
    "State": "WI",
    "City": "Hazel Green"
  },
  {
    "State": "WI",
    "City": "Kieler"
  },
  {
    "State": "WI",
    "City": "Lancaster"
  },
  {
    "State": "WI",
    "City": "Mount Hope"
  },
  {
    "State": "WI",
    "City": "Patch Grove"
  },
  {
    "State": "WI",
    "City": "Platteville"
  },
  {
    "State": "WI",
    "City": "Potosi"
  },
  {
    "State": "WI",
    "City": "Prairie Du Chien"
  },
  {
    "State": "WI",
    "City": "Sinsinawa"
  },
  {
    "State": "WI",
    "City": "Stitzer"
  },
  {
    "State": "WI",
    "City": "Wauzeka"
  },
  {
    "State": "WI",
    "City": "Woodman"
  },
  {
    "State": "WI",
    "City": "Portage"
  },
  {
    "State": "WI",
    "City": "Adams"
  },
  {
    "State": "WI",
    "City": "Arlington"
  },
  {
    "State": "WI",
    "City": "Baraboo"
  },
  {
    "State": "WI",
    "City": "Beaver Dam"
  },
  {
    "State": "WI",
    "City": "Brandon"
  },
  {
    "State": "WI",
    "City": "Briggsville"
  },
  {
    "State": "WI",
    "City": "Burnett"
  },
  {
    "State": "WI",
    "City": "Cambria"
  },
  {
    "State": "WI",
    "City": "Cazenovia"
  },
  {
    "State": "WI",
    "City": "Columbus"
  },
  {
    "State": "WI",
    "City": "Dalton"
  },
  {
    "State": "WI",
    "City": "Dellwood"
  },
  {
    "State": "WI",
    "City": "Doylestown"
  },
  {
    "State": "WI",
    "City": "Elroy"
  },
  {
    "State": "WI",
    "City": "Endeavor"
  },
  {
    "State": "WI",
    "City": "Fairwater"
  },
  {
    "State": "WI",
    "City": "Fall River"
  },
  {
    "State": "WI",
    "City": "Fox Lake"
  },
  {
    "State": "WI",
    "City": "Friendship"
  },
  {
    "State": "WI",
    "City": "Friesland"
  },
  {
    "State": "WI",
    "City": "Grand Marsh"
  },
  {
    "State": "WI",
    "City": "Hillpoint"
  },
  {
    "State": "WI",
    "City": "Kingston"
  },
  {
    "State": "WI",
    "City": "Lake Delton"
  },
  {
    "State": "WI",
    "City": "La Valle"
  },
  {
    "State": "WI",
    "City": "Lime Ridge"
  },
  {
    "State": "WI",
    "City": "Loganville"
  },
  {
    "State": "WI",
    "City": "Lyndon Station"
  },
  {
    "State": "WI",
    "City": "Markesan"
  },
  {
    "State": "WI",
    "City": "Marquette"
  },
  {
    "State": "WI",
    "City": "Mauston"
  },
  {
    "State": "WI",
    "City": "Montello"
  },
  {
    "State": "WI",
    "City": "New Lisbon"
  },
  {
    "State": "WI",
    "City": "North Freedom"
  },
  {
    "State": "WI",
    "City": "Oxford"
  },
  {
    "State": "WI",
    "City": "Packwaukee"
  },
  {
    "State": "WI",
    "City": "Pardeeville"
  },
  {
    "State": "WI",
    "City": "Poynette"
  },
  {
    "State": "WI",
    "City": "Randolph"
  },
  {
    "State": "WI",
    "City": "Reedsburg"
  },
  {
    "State": "WI",
    "City": "Rio"
  },
  {
    "State": "WI",
    "City": "Rock Springs"
  },
  {
    "State": "WI",
    "City": "Union Center"
  },
  {
    "State": "WI",
    "City": "Waupun"
  },
  {
    "State": "WI",
    "City": "Westfield"
  },
  {
    "State": "WI",
    "City": "Wisconsin Dells"
  },
  {
    "State": "WI",
    "City": "Wonewoc"
  },
  {
    "State": "WI",
    "City": "Wyocena"
  },
  {
    "State": "WI",
    "City": "Amery"
  },
  {
    "State": "WI",
    "City": "Baldwin"
  },
  {
    "State": "WI",
    "City": "Beldenville"
  },
  {
    "State": "WI",
    "City": "Clayton"
  },
  {
    "State": "WI",
    "City": "Clear Lake"
  },
  {
    "State": "WI",
    "City": "Cushing"
  },
  {
    "State": "WI",
    "City": "Deer Park"
  },
  {
    "State": "WI",
    "City": "Dresser"
  },
  {
    "State": "WI",
    "City": "East Ellsworth"
  },
  {
    "State": "WI",
    "City": "Ellsworth"
  },
  {
    "State": "WI",
    "City": "Glenwood City"
  },
  {
    "State": "WI",
    "City": "Hager City"
  },
  {
    "State": "WI",
    "City": "Hammond"
  },
  {
    "State": "WI",
    "City": "Hudson"
  },
  {
    "State": "WI",
    "City": "New Richmond"
  },
  {
    "State": "WI",
    "City": "Osceola"
  },
  {
    "State": "WI",
    "City": "Prescott"
  },
  {
    "State": "WI",
    "City": "River Falls"
  },
  {
    "State": "WI",
    "City": "Roberts"
  },
  {
    "State": "WI",
    "City": "Saint Croix Falls"
  },
  {
    "State": "WI",
    "City": "Somerset"
  },
  {
    "State": "WI",
    "City": "Star Prairie"
  },
  {
    "State": "WI",
    "City": "Wilson"
  },
  {
    "State": "WI",
    "City": "Woodville"
  },
  {
    "State": "WI",
    "City": "Houlton"
  },
  {
    "State": "WI",
    "City": "Abrams"
  },
  {
    "State": "WI",
    "City": "Amberg"
  },
  {
    "State": "WI",
    "City": "Armstrong Creek"
  },
  {
    "State": "WI",
    "City": "Athelstane"
  },
  {
    "State": "WI",
    "City": "Black Creek"
  },
  {
    "State": "WI",
    "City": "Bonduel"
  },
  {
    "State": "WI",
    "City": "Brillion"
  },
  {
    "State": "WI",
    "City": "Cecil"
  },
  {
    "State": "WI",
    "City": "Coleman"
  },
  {
    "State": "WI",
    "City": "Combined Locks"
  },
  {
    "State": "WI",
    "City": "Crivitz"
  },
  {
    "State": "WI",
    "City": "De Pere"
  },
  {
    "State": "WI",
    "City": "Dunbar"
  },
  {
    "State": "WI",
    "City": "Fence"
  },
  {
    "State": "WI",
    "City": "Florence"
  },
  {
    "State": "WI",
    "City": "Forest Junction"
  },
  {
    "State": "WI",
    "City": "Gillett"
  },
  {
    "State": "WI",
    "City": "Goodman"
  },
  {
    "State": "WI",
    "City": "Greenleaf"
  },
  {
    "State": "WI",
    "City": "Green Valley"
  },
  {
    "State": "WI",
    "City": "Gresham"
  },
  {
    "State": "WI",
    "City": "Hilbert"
  },
  {
    "State": "WI",
    "City": "Kaukauna"
  },
  {
    "State": "WI",
    "City": "Freedom"
  },
  {
    "State": "WI",
    "City": "Keshena"
  },
  {
    "State": "WI",
    "City": "Kimberly"
  },
  {
    "State": "WI",
    "City": "Krakow"
  },
  {
    "State": "WI",
    "City": "Lakewood"
  },
  {
    "State": "WI",
    "City": "Lena"
  },
  {
    "State": "WI",
    "City": "Little Chute"
  },
  {
    "State": "WI",
    "City": "Little Suamico"
  },
  {
    "State": "WI",
    "City": "Marinette"
  },
  {
    "State": "WI",
    "City": "Mountain"
  },
  {
    "State": "WI",
    "City": "Neopit"
  },
  {
    "State": "WI",
    "City": "Niagara"
  },
  {
    "State": "WI",
    "City": "Nichols"
  },
  {
    "State": "WI",
    "City": "Oconto"
  },
  {
    "State": "WI",
    "City": "Oconto Falls"
  },
  {
    "State": "WI",
    "City": "Oneida"
  },
  {
    "State": "WI",
    "City": "Pembine"
  },
  {
    "State": "WI",
    "City": "Peshtigo"
  },
  {
    "State": "WI",
    "City": "Porterfield"
  },
  {
    "State": "WI",
    "City": "Potter"
  },
  {
    "State": "WI",
    "City": "Pound"
  },
  {
    "State": "WI",
    "City": "Pulaski"
  },
  {
    "State": "WI",
    "City": "Seymour"
  },
  {
    "State": "WI",
    "City": "Shawano"
  },
  {
    "State": "WI",
    "City": "Sherwood"
  },
  {
    "State": "WI",
    "City": "Shiocton"
  },
  {
    "State": "WI",
    "City": "Sobieski"
  },
  {
    "State": "WI",
    "City": "Suamico"
  },
  {
    "State": "WI",
    "City": "Suring"
  },
  {
    "State": "WI",
    "City": "Townsend"
  },
  {
    "State": "WI",
    "City": "Wausaukee"
  },
  {
    "State": "WI",
    "City": "Wrightstown"
  },
  {
    "State": "WI",
    "City": "Zachow"
  },
  {
    "State": "WI",
    "City": "Algoma"
  },
  {
    "State": "WI",
    "City": "Baileys Harbor"
  },
  {
    "State": "WI",
    "City": "Brussels"
  },
  {
    "State": "WI",
    "City": "Casco"
  },
  {
    "State": "WI",
    "City": "Collins"
  },
  {
    "State": "WI",
    "City": "Denmark"
  },
  {
    "State": "WI",
    "City": "Egg Harbor"
  },
  {
    "State": "WI",
    "City": "Ellison Bay"
  },
  {
    "State": "WI",
    "City": "Ephraim"
  },
  {
    "State": "WI",
    "City": "Fish Creek"
  },
  {
    "State": "WI",
    "City": "Forestville"
  },
  {
    "State": "WI",
    "City": "Francis Creek"
  },
  {
    "State": "WI",
    "City": "Kellnersville"
  },
  {
    "State": "WI",
    "City": "Kewaunee"
  },
  {
    "State": "WI",
    "City": "Luxemburg"
  },
  {
    "State": "WI",
    "City": "Manitowoc"
  },
  {
    "State": "WI",
    "City": "Maplewood"
  },
  {
    "State": "WI",
    "City": "Maribel"
  },
  {
    "State": "WI",
    "City": "Mishicot"
  },
  {
    "State": "WI",
    "City": "New Franken"
  },
  {
    "State": "WI",
    "City": "Reedsville"
  },
  {
    "State": "WI",
    "City": "Saint Nazianz"
  },
  {
    "State": "WI",
    "City": "Sister Bay"
  },
  {
    "State": "WI",
    "City": "Sturgeon Bay"
  },
  {
    "State": "WI",
    "City": "Tisch Mills"
  },
  {
    "State": "WI",
    "City": "Two Rivers"
  },
  {
    "State": "WI",
    "City": "Valders"
  },
  {
    "State": "WI",
    "City": "Washington Island"
  },
  {
    "State": "WI",
    "City": "Whitelaw"
  },
  {
    "State": "WI",
    "City": "Green Bay"
  },
  {
    "State": "WI",
    "City": "Wausau"
  },
  {
    "State": "WI",
    "City": "Marshfield"
  },
  {
    "State": "WI",
    "City": "Abbotsford"
  },
  {
    "State": "WI",
    "City": "Amherst"
  },
  {
    "State": "WI",
    "City": "Amherst Junction"
  },
  {
    "State": "WI",
    "City": "Aniwa"
  },
  {
    "State": "WI",
    "City": "Antigo"
  },
  {
    "State": "WI",
    "City": "Arpin"
  },
  {
    "State": "WI",
    "City": "Athens"
  },
  {
    "State": "WI",
    "City": "Auburndale"
  },
  {
    "State": "WI",
    "City": "Babcock"
  },
  {
    "State": "WI",
    "City": "Birnamwood"
  },
  {
    "State": "WI",
    "City": "Blenker"
  },
  {
    "State": "WI",
    "City": "Bowler"
  },
  {
    "State": "WI",
    "City": "Brokaw"
  },
  {
    "State": "WI",
    "City": "Bryant"
  },
  {
    "State": "WI",
    "City": "Chili"
  },
  {
    "State": "WI",
    "City": "Colby"
  },
  {
    "State": "WI",
    "City": "Curtiss"
  },
  {
    "State": "WI",
    "City": "Custer"
  },
  {
    "State": "WI",
    "City": "Deerbrook"
  },
  {
    "State": "WI",
    "City": "Dorchester"
  },
  {
    "State": "WI",
    "City": "Edgar"
  },
  {
    "State": "WI",
    "City": "Eland"
  },
  {
    "State": "WI",
    "City": "Elcho"
  },
  {
    "State": "WI",
    "City": "Elderon"
  },
  {
    "State": "WI",
    "City": "Elton"
  },
  {
    "State": "WI",
    "City": "Galloway"
  },
  {
    "State": "WI",
    "City": "Gilman"
  },
  {
    "State": "WI",
    "City": "Jump River"
  },
  {
    "State": "WI",
    "City": "Gleason"
  },
  {
    "State": "WI",
    "City": "Granton"
  },
  {
    "State": "WI",
    "City": "Greenwood"
  },
  {
    "State": "WI",
    "City": "Hannibal"
  },
  {
    "State": "WI",
    "City": "Hatley"
  },
  {
    "State": "WI",
    "City": "Hewitt"
  },
  {
    "State": "WI",
    "City": "Irma"
  },
  {
    "State": "WI",
    "City": "Junction City"
  },
  {
    "State": "WI",
    "City": "Loyal"
  },
  {
    "State": "WI",
    "City": "Lublin"
  },
  {
    "State": "WI",
    "City": "Marathon"
  },
  {
    "State": "WI",
    "City": "Mattoon"
  },
  {
    "State": "WI",
    "City": "Medford"
  },
  {
    "State": "WI",
    "City": "Merrill"
  },
  {
    "State": "WI",
    "City": "Milladore"
  },
  {
    "State": "WI",
    "City": "Mosinee"
  },
  {
    "State": "WI",
    "City": "Neillsville"
  },
  {
    "State": "WI",
    "City": "Nekoosa"
  },
  {
    "State": "WI",
    "City": "Nelsonville"
  },
  {
    "State": "WI",
    "City": "Ogema"
  },
  {
    "State": "WI",
    "City": "Owen"
  },
  {
    "State": "WI",
    "City": "Pearson"
  },
  {
    "State": "WI",
    "City": "Pelican Lake"
  },
  {
    "State": "WI",
    "City": "Phlox"
  },
  {
    "State": "WI",
    "City": "Pickerel"
  },
  {
    "State": "WI",
    "City": "Pittsville"
  },
  {
    "State": "WI",
    "City": "Plover"
  },
  {
    "State": "WI",
    "City": "Port Edwards"
  },
  {
    "State": "WI",
    "City": "Rib Lake"
  },
  {
    "State": "WI",
    "City": "Ringle"
  },
  {
    "State": "WI",
    "City": "Rosholt"
  },
  {
    "State": "WI",
    "City": "Rothschild"
  },
  {
    "State": "WI",
    "City": "Rudolph"
  },
  {
    "State": "WI",
    "City": "Schofield"
  },
  {
    "State": "WI",
    "City": "Spencer"
  },
  {
    "State": "WI",
    "City": "Stetsonville"
  },
  {
    "State": "WI",
    "City": "Stevens Point"
  },
  {
    "State": "WI",
    "City": "Stratford"
  },
  {
    "State": "WI",
    "City": "Summit Lake"
  },
  {
    "State": "WI",
    "City": "Tigerton"
  },
  {
    "State": "WI",
    "City": "Tomahawk"
  },
  {
    "State": "WI",
    "City": "Unity"
  },
  {
    "State": "WI",
    "City": "Vesper"
  },
  {
    "State": "WI",
    "City": "Westboro"
  },
  {
    "State": "WI",
    "City": "White Lake"
  },
  {
    "State": "WI",
    "City": "Willard"
  },
  {
    "State": "WI",
    "City": "Wisconsin Rapids"
  },
  {
    "State": "WI",
    "City": "Withee"
  },
  {
    "State": "WI",
    "City": "Wittenberg"
  },
  {
    "State": "WI",
    "City": "Rhinelander"
  },
  {
    "State": "WI",
    "City": "Argonne"
  },
  {
    "State": "WI",
    "City": "Boulder Junction"
  },
  {
    "State": "WI",
    "City": "Brantwood"
  },
  {
    "State": "WI",
    "City": "Butternut"
  },
  {
    "State": "WI",
    "City": "Catawba"
  },
  {
    "State": "WI",
    "City": "Clam Lake"
  },
  {
    "State": "WI",
    "City": "Conover"
  },
  {
    "State": "WI",
    "City": "Crandon"
  },
  {
    "State": "WI",
    "City": "Eagle River"
  },
  {
    "State": "WI",
    "City": "Fifield"
  },
  {
    "State": "WI",
    "City": "Gile"
  },
  {
    "State": "WI",
    "City": "Glen Flora"
  },
  {
    "State": "WI",
    "City": "Glidden"
  },
  {
    "State": "WI",
    "City": "Harshaw"
  },
  {
    "State": "WI",
    "City": "Hawkins"
  },
  {
    "State": "WI",
    "City": "Hazelhurst"
  },
  {
    "State": "WI",
    "City": "Heafford Junction"
  },
  {
    "State": "WI",
    "City": "Hurley"
  },
  {
    "State": "WI",
    "City": "Iron Belt"
  },
  {
    "State": "WI",
    "City": "Kennan"
  },
  {
    "State": "WI",
    "City": "Lac Du Flambeau"
  },
  {
    "State": "WI",
    "City": "Lake Tomahawk"
  },
  {
    "State": "WI",
    "City": "Land O Lakes"
  },
  {
    "State": "WI",
    "City": "Laona"
  },
  {
    "State": "WI",
    "City": "Long Lake"
  },
  {
    "State": "WI",
    "City": "Mc Naughton"
  },
  {
    "State": "WI",
    "City": "Manitowish Waters"
  },
  {
    "State": "WI",
    "City": "Mellen"
  },
  {
    "State": "WI",
    "City": "Mercer"
  },
  {
    "State": "WI",
    "City": "Minocqua"
  },
  {
    "State": "WI",
    "City": "Montreal"
  },
  {
    "State": "WI",
    "City": "Park Falls"
  },
  {
    "State": "WI",
    "City": "Phelps"
  },
  {
    "State": "WI",
    "City": "Phillips"
  },
  {
    "State": "WI",
    "City": "Prentice"
  },
  {
    "State": "WI",
    "City": "Presque Isle"
  },
  {
    "State": "WI",
    "City": "Saint Germain"
  },
  {
    "State": "WI",
    "City": "Saxon"
  },
  {
    "State": "WI",
    "City": "Sayner"
  },
  {
    "State": "WI",
    "City": "Star Lake"
  },
  {
    "State": "WI",
    "City": "Three Lakes"
  },
  {
    "State": "WI",
    "City": "Tony"
  },
  {
    "State": "WI",
    "City": "Tripoli"
  },
  {
    "State": "WI",
    "City": "Upson"
  },
  {
    "State": "WI",
    "City": "Wabeno"
  },
  {
    "State": "WI",
    "City": "Woodruff"
  },
  {
    "State": "WI",
    "City": "La Crosse"
  },
  {
    "State": "WI",
    "City": "Alma"
  },
  {
    "State": "WI",
    "City": "Alma Center"
  },
  {
    "State": "WI",
    "City": "Arcadia"
  },
  {
    "State": "WI",
    "City": "Arkdale"
  },
  {
    "State": "WI",
    "City": "Bangor"
  },
  {
    "State": "WI",
    "City": "Black River Falls"
  },
  {
    "State": "WI",
    "City": "Blair"
  },
  {
    "State": "WI",
    "City": "Camp Douglas"
  },
  {
    "State": "WI",
    "City": "Cashton"
  },
  {
    "State": "WI",
    "City": "Cataract"
  },
  {
    "State": "WI",
    "City": "Chaseburg"
  },
  {
    "State": "WI",
    "City": "Cochrane"
  },
  {
    "State": "WI",
    "City": "Coon Valley"
  },
  {
    "State": "WI",
    "City": "De Soto"
  },
  {
    "State": "WI",
    "City": "Dodge"
  },
  {
    "State": "WI",
    "City": "Eastman"
  },
  {
    "State": "WI",
    "City": "Ettrick"
  },
  {
    "State": "WI",
    "City": "Ferryville"
  },
  {
    "State": "WI",
    "City": "Fountain City"
  },
  {
    "State": "WI",
    "City": "Galesville"
  },
  {
    "State": "WI",
    "City": "Gays Mills"
  },
  {
    "State": "WI",
    "City": "Genoa"
  },
  {
    "State": "WI",
    "City": "Hillsboro"
  },
  {
    "State": "WI",
    "City": "Hixton"
  },
  {
    "State": "WI",
    "City": "Holmen"
  },
  {
    "State": "WI",
    "City": "Hustler"
  },
  {
    "State": "WI",
    "City": "Kendall"
  },
  {
    "State": "WI",
    "City": "La Farge"
  },
  {
    "State": "WI",
    "City": "Lynxville"
  },
  {
    "State": "WI",
    "City": "Mather"
  },
  {
    "State": "WI",
    "City": "Melrose"
  },
  {
    "State": "WI",
    "City": "Millston"
  },
  {
    "State": "WI",
    "City": "Mindoro"
  },
  {
    "State": "WI",
    "City": "Mount Sterling"
  },
  {
    "State": "WI",
    "City": "Necedah"
  },
  {
    "State": "WI",
    "City": "Norwalk"
  },
  {
    "State": "WI",
    "City": "Oakdale"
  },
  {
    "State": "WI",
    "City": "Onalaska"
  },
  {
    "State": "WI",
    "City": "Ontario"
  },
  {
    "State": "WI",
    "City": "Readstown"
  },
  {
    "State": "WI",
    "City": "Rockland"
  },
  {
    "State": "WI",
    "City": "Seneca"
  },
  {
    "State": "WI",
    "City": "Soldiers Grove"
  },
  {
    "State": "WI",
    "City": "Sparta"
  },
  {
    "State": "WI",
    "City": "Steuben"
  },
  {
    "State": "WI",
    "City": "Stoddard"
  },
  {
    "State": "WI",
    "City": "Taylor"
  },
  {
    "State": "WI",
    "City": "Tomah"
  },
  {
    "State": "WI",
    "City": "Trempealeau"
  },
  {
    "State": "WI",
    "City": "Tunnel City"
  },
  {
    "State": "WI",
    "City": "Viola"
  },
  {
    "State": "WI",
    "City": "Viroqua"
  },
  {
    "State": "WI",
    "City": "Warrens"
  },
  {
    "State": "WI",
    "City": "Westby"
  },
  {
    "State": "WI",
    "City": "West Salem"
  },
  {
    "State": "WI",
    "City": "Wilton"
  },
  {
    "State": "WI",
    "City": "Eau Claire"
  },
  {
    "State": "WI",
    "City": "Altoona"
  },
  {
    "State": "WI",
    "City": "Arkansaw"
  },
  {
    "State": "WI",
    "City": "Augusta"
  },
  {
    "State": "WI",
    "City": "Bay City"
  },
  {
    "State": "WI",
    "City": "Bloomer"
  },
  {
    "State": "WI",
    "City": "Boyceville"
  },
  {
    "State": "WI",
    "City": "Boyd"
  },
  {
    "State": "WI",
    "City": "Cadott"
  },
  {
    "State": "WI",
    "City": "Chetek"
  },
  {
    "State": "WI",
    "City": "Chippewa Falls"
  },
  {
    "State": "WI",
    "City": "Colfax"
  },
  {
    "State": "WI",
    "City": "Conrath"
  },
  {
    "State": "WI",
    "City": "Cornell"
  },
  {
    "State": "WI",
    "City": "Dallas"
  },
  {
    "State": "WI",
    "City": "Downing"
  },
  {
    "State": "WI",
    "City": "Downsville"
  },
  {
    "State": "WI",
    "City": "Durand"
  },
  {
    "State": "WI",
    "City": "Eau Galle"
  },
  {
    "State": "WI",
    "City": "Eleva"
  },
  {
    "State": "WI",
    "City": "Elk Mound"
  },
  {
    "State": "WI",
    "City": "Elmwood"
  },
  {
    "State": "WI",
    "City": "Fairchild"
  },
  {
    "State": "WI",
    "City": "Fall Creek"
  },
  {
    "State": "WI",
    "City": "Gilmanton"
  },
  {
    "State": "WI",
    "City": "Holcombe"
  },
  {
    "State": "WI",
    "City": "Humbird"
  },
  {
    "State": "WI",
    "City": "Independence"
  },
  {
    "State": "WI",
    "City": "Jim Falls"
  },
  {
    "State": "WI",
    "City": "Knapp"
  },
  {
    "State": "WI",
    "City": "Maiden Rock"
  },
  {
    "State": "WI",
    "City": "Menomonie"
  },
  {
    "State": "WI",
    "City": "Merrillan"
  },
  {
    "State": "WI",
    "City": "Mondovi"
  },
  {
    "State": "WI",
    "City": "Nelson"
  },
  {
    "State": "WI",
    "City": "New Auburn"
  },
  {
    "State": "WI",
    "City": "Osseo"
  },
  {
    "State": "WI",
    "City": "Pepin"
  },
  {
    "State": "WI",
    "City": "Pigeon Falls"
  },
  {
    "State": "WI",
    "City": "Plum City"
  },
  {
    "State": "WI",
    "City": "Prairie Farm"
  },
  {
    "State": "WI",
    "City": "Ridgeland"
  },
  {
    "State": "WI",
    "City": "Rock Falls"
  },
  {
    "State": "WI",
    "City": "Sand Creek"
  },
  {
    "State": "WI",
    "City": "Sheldon"
  },
  {
    "State": "WI",
    "City": "Spring Valley"
  },
  {
    "State": "WI",
    "City": "Stanley"
  },
  {
    "State": "WI",
    "City": "Stockholm"
  },
  {
    "State": "WI",
    "City": "Strum"
  },
  {
    "State": "WI",
    "City": "Thorp"
  },
  {
    "State": "WI",
    "City": "Wheeler"
  },
  {
    "State": "WI",
    "City": "Whitehall"
  },
  {
    "State": "WI",
    "City": "Spooner"
  },
  {
    "State": "WI",
    "City": "Almena"
  },
  {
    "State": "WI",
    "City": "Ashland"
  },
  {
    "State": "WI",
    "City": "Balsam Lake"
  },
  {
    "State": "WI",
    "City": "Barron"
  },
  {
    "State": "WI",
    "City": "Barronett"
  },
  {
    "State": "WI",
    "City": "Bayfield"
  },
  {
    "State": "WI",
    "City": "Benoit"
  },
  {
    "State": "WI",
    "City": "Birchwood"
  },
  {
    "State": "WI",
    "City": "Brill"
  },
  {
    "State": "WI",
    "City": "Bruce"
  },
  {
    "State": "WI",
    "City": "Brule"
  },
  {
    "State": "WI",
    "City": "Cable"
  },
  {
    "State": "WI",
    "City": "Cameron"
  },
  {
    "State": "WI",
    "City": "Centuria"
  },
  {
    "State": "WI",
    "City": "Comstock"
  },
  {
    "State": "WI",
    "City": "Cornucopia"
  },
  {
    "State": "WI",
    "City": "Couderay"
  },
  {
    "State": "WI",
    "City": "Cumberland"
  },
  {
    "State": "WI",
    "City": "Danbury"
  },
  {
    "State": "WI",
    "City": "Drummond"
  },
  {
    "State": "WI",
    "City": "Edgewater"
  },
  {
    "State": "WI",
    "City": "Exeland"
  },
  {
    "State": "WI",
    "City": "Foxboro"
  },
  {
    "State": "WI",
    "City": "Frederic"
  },
  {
    "State": "WI",
    "City": "Gordon"
  },
  {
    "State": "WI",
    "City": "Grand View"
  },
  {
    "State": "WI",
    "City": "Grantsburg"
  },
  {
    "State": "WI",
    "City": "Haugen"
  },
  {
    "State": "WI",
    "City": "Hawthorne"
  },
  {
    "State": "WI",
    "City": "Hayward"
  },
  {
    "State": "WI",
    "City": "Herbster"
  },
  {
    "State": "WI",
    "City": "Hertel"
  },
  {
    "State": "WI",
    "City": "High Bridge"
  },
  {
    "State": "WI",
    "City": "Iron River"
  },
  {
    "State": "WI",
    "City": "Ladysmith"
  },
  {
    "State": "WI",
    "City": "Lake Nebagamon"
  },
  {
    "State": "WI",
    "City": "La Pointe"
  },
  {
    "State": "WI",
    "City": "Luck"
  },
  {
    "State": "WI",
    "City": "Maple"
  },
  {
    "State": "WI",
    "City": "Marengo"
  },
  {
    "State": "WI",
    "City": "Mason"
  },
  {
    "State": "WI",
    "City": "Mikana"
  },
  {
    "State": "WI",
    "City": "Milltown"
  },
  {
    "State": "WI",
    "City": "Minong"
  },
  {
    "State": "WI",
    "City": "Odanah"
  },
  {
    "State": "WI",
    "City": "Ojibwa"
  },
  {
    "State": "WI",
    "City": "Poplar"
  },
  {
    "State": "WI",
    "City": "Port Wing"
  },
  {
    "State": "WI",
    "City": "Radisson"
  },
  {
    "State": "WI",
    "City": "Rice Lake"
  },
  {
    "State": "WI",
    "City": "Sarona"
  },
  {
    "State": "WI",
    "City": "Shell Lake"
  },
  {
    "State": "WI",
    "City": "Siren"
  },
  {
    "State": "WI",
    "City": "Solon Springs"
  },
  {
    "State": "WI",
    "City": "South Range"
  },
  {
    "State": "WI",
    "City": "Springbrook"
  },
  {
    "State": "WI",
    "City": "Stone Lake"
  },
  {
    "State": "WI",
    "City": "Superior"
  },
  {
    "State": "WI",
    "City": "Trego"
  },
  {
    "State": "WI",
    "City": "Turtle Lake"
  },
  {
    "State": "WI",
    "City": "Wascott"
  },
  {
    "State": "WI",
    "City": "Washburn"
  },
  {
    "State": "WI",
    "City": "Webster"
  },
  {
    "State": "WI",
    "City": "Weyerhaeuser"
  },
  {
    "State": "WI",
    "City": "Winter"
  },
  {
    "State": "WI",
    "City": "Oshkosh"
  },
  {
    "State": "WI",
    "City": "Almond"
  },
  {
    "State": "WI",
    "City": "Appleton"
  },
  {
    "State": "WI",
    "City": "Bancroft"
  },
  {
    "State": "WI",
    "City": "Bear Creek"
  },
  {
    "State": "WI",
    "City": "Berlin"
  },
  {
    "State": "WI",
    "City": "Big Falls"
  },
  {
    "State": "WI",
    "City": "Butte Des Morts"
  },
  {
    "State": "WI",
    "City": "Caroline"
  },
  {
    "State": "WI",
    "City": "Clintonville"
  },
  {
    "State": "WI",
    "City": "Coloma"
  },
  {
    "State": "WI",
    "City": "Dale"
  },
  {
    "State": "WI",
    "City": "Eldorado"
  },
  {
    "State": "WI",
    "City": "Embarrass"
  },
  {
    "State": "WI",
    "City": "Eureka"
  },
  {
    "State": "WI",
    "City": "Fond Du Lac"
  },
  {
    "State": "WI",
    "City": "Fremont"
  },
  {
    "State": "WI",
    "City": "Green Lake"
  },
  {
    "State": "WI",
    "City": "Greenville"
  },
  {
    "State": "WI",
    "City": "Hancock"
  },
  {
    "State": "WI",
    "City": "Hortonville"
  },
  {
    "State": "WI",
    "City": "Iola"
  },
  {
    "State": "WI",
    "City": "King"
  },
  {
    "State": "WI",
    "City": "Larsen"
  },
  {
    "State": "WI",
    "City": "Leopolis"
  },
  {
    "State": "WI",
    "City": "Manawa"
  },
  {
    "State": "WI",
    "City": "Marion"
  },
  {
    "State": "WI",
    "City": "Menasha"
  },
  {
    "State": "WI",
    "City": "Neenah"
  },
  {
    "State": "WI",
    "City": "Neshkoro"
  },
  {
    "State": "WI",
    "City": "New London"
  },
  {
    "State": "WI",
    "City": "Ogdensburg"
  },
  {
    "State": "WI",
    "City": "Omro"
  },
  {
    "State": "WI",
    "City": "Pickett"
  },
  {
    "State": "WI",
    "City": "Pine River"
  },
  {
    "State": "WI",
    "City": "Plainfield"
  },
  {
    "State": "WI",
    "City": "Poy Sippi"
  },
  {
    "State": "WI",
    "City": "Princeton"
  },
  {
    "State": "WI",
    "City": "Readfield"
  },
  {
    "State": "WI",
    "City": "Redgranite"
  },
  {
    "State": "WI",
    "City": "Ripon"
  },
  {
    "State": "WI",
    "City": "Rosendale"
  },
  {
    "State": "WI",
    "City": "Saxeville"
  },
  {
    "State": "WI",
    "City": "Scandinavia"
  },
  {
    "State": "WI",
    "City": "Tilleda"
  },
  {
    "State": "WI",
    "City": "Van Dyne"
  },
  {
    "State": "WI",
    "City": "Waukau"
  },
  {
    "State": "WI",
    "City": "Waupaca"
  },
  {
    "State": "WI",
    "City": "Wautoma"
  },
  {
    "State": "WI",
    "City": "Weyauwega"
  },
  {
    "State": "WI",
    "City": "Wild Rose"
  },
  {
    "State": "WI",
    "City": "Winnebago"
  },
  {
    "State": "WI",
    "City": "Winneconne"
  },
  {
    "State": "MN",
    "City": "Afton"
  },
  {
    "State": "MN",
    "City": "Almelund"
  },
  {
    "State": "MN",
    "City": "Bayport"
  },
  {
    "State": "MN",
    "City": "Bethel"
  },
  {
    "State": "MN",
    "City": "Braham"
  },
  {
    "State": "MN",
    "City": "Brook Park"
  },
  {
    "State": "MN",
    "City": "Cambridge"
  },
  {
    "State": "MN",
    "City": "Cannon Falls"
  },
  {
    "State": "MN",
    "City": "Castle Rock"
  },
  {
    "State": "MN",
    "City": "Cedar"
  },
  {
    "State": "MN",
    "City": "Center City"
  },
  {
    "State": "MN",
    "City": "Chisago City"
  },
  {
    "State": "MN",
    "City": "Circle Pines"
  },
  {
    "State": "MN",
    "City": "Cottage Grove"
  },
  {
    "State": "MN",
    "City": "Dalbo"
  },
  {
    "State": "MN",
    "City": "Dennison"
  },
  {
    "State": "MN",
    "City": "Dundas"
  },
  {
    "State": "MN",
    "City": "Elko New Market"
  },
  {
    "State": "MN",
    "City": "Faribault"
  },
  {
    "State": "MN",
    "City": "Farmington"
  },
  {
    "State": "MN",
    "City": "Forest Lake"
  },
  {
    "State": "MN",
    "City": "Frontenac"
  },
  {
    "State": "MN",
    "City": "Goodhue"
  },
  {
    "State": "MN",
    "City": "Grandy"
  },
  {
    "State": "MN",
    "City": "Grasston"
  },
  {
    "State": "MN",
    "City": "Hampton"
  },
  {
    "State": "MN",
    "City": "Harris"
  },
  {
    "State": "MN",
    "City": "Hastings"
  },
  {
    "State": "MN",
    "City": "Henriette"
  },
  {
    "State": "MN",
    "City": "Hinckley"
  },
  {
    "State": "MN",
    "City": "Hugo"
  },
  {
    "State": "MN",
    "City": "Isanti"
  },
  {
    "State": "MN",
    "City": "Lake City"
  },
  {
    "State": "MN",
    "City": "Lake Elmo"
  },
  {
    "State": "MN",
    "City": "Lakeland"
  },
  {
    "State": "MN",
    "City": "Lakeville"
  },
  {
    "State": "MN",
    "City": "Lindstrom"
  },
  {
    "State": "MN",
    "City": "Lonsdale"
  },
  {
    "State": "MN",
    "City": "Marine On Saint Croix"
  },
  {
    "State": "MN",
    "City": "Medford"
  },
  {
    "State": "MN",
    "City": "Mora"
  },
  {
    "State": "MN",
    "City": "Morristown"
  },
  {
    "State": "MN",
    "City": "Nerstrand"
  },
  {
    "State": "MN",
    "City": "Newport"
  },
  {
    "State": "MN",
    "City": "North Branch"
  },
  {
    "State": "MN",
    "City": "Northfield"
  },
  {
    "State": "MN",
    "City": "Owatonna"
  },
  {
    "State": "MN",
    "City": "Pine City"
  },
  {
    "State": "MN",
    "City": "Randolph"
  },
  {
    "State": "MN",
    "City": "Red Wing"
  },
  {
    "State": "MN",
    "City": "Rock Creek"
  },
  {
    "State": "MN",
    "City": "Rosemount"
  },
  {
    "State": "MN",
    "City": "Rush City"
  },
  {
    "State": "MN",
    "City": "Saint Francis"
  },
  {
    "State": "MN",
    "City": "Saint Paul Park"
  },
  {
    "State": "MN",
    "City": "Sandstone"
  },
  {
    "State": "MN",
    "City": "Scandia"
  },
  {
    "State": "MN",
    "City": "Shafer"
  },
  {
    "State": "MN",
    "City": "South Saint Paul"
  },
  {
    "State": "MN",
    "City": "Inver Grove Heights"
  },
  {
    "State": "MN",
    "City": "Stacy"
  },
  {
    "State": "MN",
    "City": "Stanchfield"
  },
  {
    "State": "MN",
    "City": "Stillwater"
  },
  {
    "State": "MN",
    "City": "Taylors Falls"
  },
  {
    "State": "MN",
    "City": "Vermillion"
  },
  {
    "State": "MN",
    "City": "Warsaw"
  },
  {
    "State": "MN",
    "City": "Webster"
  },
  {
    "State": "MN",
    "City": "Welch"
  },
  {
    "State": "MN",
    "City": "Willernie"
  },
  {
    "State": "MN",
    "City": "Wyoming"
  },
  {
    "State": "MN",
    "City": "Saint Paul"
  },
  {
    "State": "MN",
    "City": "Mendota"
  },
  {
    "State": "MN",
    "City": "Albertville"
  },
  {
    "State": "MN",
    "City": "Annandale"
  },
  {
    "State": "MN",
    "City": "Anoka"
  },
  {
    "State": "MN",
    "City": "Andover"
  },
  {
    "State": "MN",
    "City": "Hopkins"
  },
  {
    "State": "MN",
    "City": "Burnsville"
  },
  {
    "State": "MN",
    "City": "Arlington"
  },
  {
    "State": "MN",
    "City": "Becker"
  },
  {
    "State": "MN",
    "City": "Big Lake"
  },
  {
    "State": "MN",
    "City": "Bird Island"
  },
  {
    "State": "MN",
    "City": "Maple Grove"
  },
  {
    "State": "MN",
    "City": "Brownton"
  },
  {
    "State": "MN",
    "City": "Buffalo"
  },
  {
    "State": "MN",
    "City": "Buffalo Lake"
  },
  {
    "State": "MN",
    "City": "Carver"
  },
  {
    "State": "MN",
    "City": "Champlin"
  },
  {
    "State": "MN",
    "City": "Chanhassen"
  },
  {
    "State": "MN",
    "City": "Chaska"
  },
  {
    "State": "MN",
    "City": "Clear Lake"
  },
  {
    "State": "MN",
    "City": "Clearwater"
  },
  {
    "State": "MN",
    "City": "Cokato"
  },
  {
    "State": "MN",
    "City": "Cologne"
  },
  {
    "State": "MN",
    "City": "Crystal Bay"
  },
  {
    "State": "MN",
    "City": "Darwin"
  },
  {
    "State": "MN",
    "City": "Dassel"
  },
  {
    "State": "MN",
    "City": "Dayton"
  },
  {
    "State": "MN",
    "City": "Delano"
  },
  {
    "State": "MN",
    "City": "Eden Valley"
  },
  {
    "State": "MN",
    "City": "Elk River"
  },
  {
    "State": "MN",
    "City": "Excelsior"
  },
  {
    "State": "MN",
    "City": "Fairfax"
  },
  {
    "State": "MN",
    "City": "Franklin"
  },
  {
    "State": "MN",
    "City": "Gaylord"
  },
  {
    "State": "MN",
    "City": "Gibbon"
  },
  {
    "State": "MN",
    "City": "Glencoe"
  },
  {
    "State": "MN",
    "City": "Green Isle"
  },
  {
    "State": "MN",
    "City": "Hamburg"
  },
  {
    "State": "MN",
    "City": "Hamel"
  },
  {
    "State": "MN",
    "City": "Hanover"
  },
  {
    "State": "MN",
    "City": "Hector"
  },
  {
    "State": "MN",
    "City": "Eden Prairie"
  },
  {
    "State": "MN",
    "City": "Minnetonka"
  },
  {
    "State": "MN",
    "City": "Maple Plain"
  },
  {
    "State": "MN",
    "City": "Howard Lake"
  },
  {
    "State": "MN",
    "City": "Hutchinson"
  },
  {
    "State": "MN",
    "City": "Jordan"
  },
  {
    "State": "MN",
    "City": "Kimball"
  },
  {
    "State": "MN",
    "City": "Lester Prairie"
  },
  {
    "State": "MN",
    "City": "Litchfield"
  },
  {
    "State": "MN",
    "City": "Long Lake"
  },
  {
    "State": "MN",
    "City": "Loretto"
  },
  {
    "State": "MN",
    "City": "Maple Lake"
  },
  {
    "State": "MN",
    "City": "Mayer"
  },
  {
    "State": "MN",
    "City": "Minnetonka Beach"
  },
  {
    "State": "MN",
    "City": "Monticello"
  },
  {
    "State": "MN",
    "City": "Montrose"
  },
  {
    "State": "MN",
    "City": "Mound"
  },
  {
    "State": "MN",
    "City": "New Auburn"
  },
  {
    "State": "MN",
    "City": "New Germany"
  },
  {
    "State": "MN",
    "City": "Norwood Young America"
  },
  {
    "State": "MN",
    "City": "Osseo"
  },
  {
    "State": "MN",
    "City": "Plato"
  },
  {
    "State": "MN",
    "City": "Princeton"
  },
  {
    "State": "MN",
    "City": "Prior Lake"
  },
  {
    "State": "MN",
    "City": "Rockford"
  },
  {
    "State": "MN",
    "City": "Rogers"
  },
  {
    "State": "MN",
    "City": "Saint Bonifacius"
  },
  {
    "State": "MN",
    "City": "Saint Michael"
  },
  {
    "State": "MN",
    "City": "Santiago"
  },
  {
    "State": "MN",
    "City": "Savage"
  },
  {
    "State": "MN",
    "City": "Shakopee"
  },
  {
    "State": "MN",
    "City": "Silver Creek"
  },
  {
    "State": "MN",
    "City": "Silver Lake"
  },
  {
    "State": "MN",
    "City": "South Haven"
  },
  {
    "State": "MN",
    "City": "Norwood"
  },
  {
    "State": "MN",
    "City": "Spring Park"
  },
  {
    "State": "MN",
    "City": "Stewart"
  },
  {
    "State": "MN",
    "City": "Victoria"
  },
  {
    "State": "MN",
    "City": "Waconia"
  },
  {
    "State": "MN",
    "City": "Watertown"
  },
  {
    "State": "MN",
    "City": "Watkins"
  },
  {
    "State": "MN",
    "City": "Waverly"
  },
  {
    "State": "MN",
    "City": "Wayzata"
  },
  {
    "State": "MN",
    "City": "Navarre"
  },
  {
    "State": "MN",
    "City": "Young America"
  },
  {
    "State": "MN",
    "City": "Winsted"
  },
  {
    "State": "MN",
    "City": "Winthrop"
  },
  {
    "State": "MN",
    "City": "Zimmerman"
  },
  {
    "State": "MN",
    "City": "Minneapolis"
  },
  {
    "State": "MN",
    "City": "Beaver Bay"
  },
  {
    "State": "MN",
    "City": "Brimson"
  },
  {
    "State": "MN",
    "City": "Finland"
  },
  {
    "State": "MN",
    "City": "Grand Marais"
  },
  {
    "State": "MN",
    "City": "Grand Portage"
  },
  {
    "State": "MN",
    "City": "Hovland"
  },
  {
    "State": "MN",
    "City": "Isabella"
  },
  {
    "State": "MN",
    "City": "Knife River"
  },
  {
    "State": "MN",
    "City": "Lutsen"
  },
  {
    "State": "MN",
    "City": "Schroeder"
  },
  {
    "State": "MN",
    "City": "Silver Bay"
  },
  {
    "State": "MN",
    "City": "Tofte"
  },
  {
    "State": "MN",
    "City": "Two Harbors"
  },
  {
    "State": "MN",
    "City": "Adolph"
  },
  {
    "State": "MN",
    "City": "Alborn"
  },
  {
    "State": "MN",
    "City": "Angora"
  },
  {
    "State": "MN",
    "City": "Askov"
  },
  {
    "State": "MN",
    "City": "Aurora"
  },
  {
    "State": "MN",
    "City": "Babbitt"
  },
  {
    "State": "MN",
    "City": "Barnum"
  },
  {
    "State": "MN",
    "City": "Biwabik"
  },
  {
    "State": "MN",
    "City": "Bovey"
  },
  {
    "State": "MN",
    "City": "Britt"
  },
  {
    "State": "MN",
    "City": "Brookston"
  },
  {
    "State": "MN",
    "City": "Bruno"
  },
  {
    "State": "MN",
    "City": "Buhl"
  },
  {
    "State": "MN",
    "City": "Calumet"
  },
  {
    "State": "MN",
    "City": "Canyon"
  },
  {
    "State": "MN",
    "City": "Carlton"
  },
  {
    "State": "MN",
    "City": "Chisholm"
  },
  {
    "State": "MN",
    "City": "Cloquet"
  },
  {
    "State": "MN",
    "City": "Cohasset"
  },
  {
    "State": "MN",
    "City": "Coleraine"
  },
  {
    "State": "MN",
    "City": "Cook"
  },
  {
    "State": "MN",
    "City": "Cotton"
  },
  {
    "State": "MN",
    "City": "Crane Lake"
  },
  {
    "State": "MN",
    "City": "Cromwell"
  },
  {
    "State": "MN",
    "City": "Grand Rapids"
  },
  {
    "State": "MN",
    "City": "Ely"
  },
  {
    "State": "MN",
    "City": "Embarrass"
  },
  {
    "State": "MN",
    "City": "Esko"
  },
  {
    "State": "MN",
    "City": "Eveleth"
  },
  {
    "State": "MN",
    "City": "Finlayson"
  },
  {
    "State": "MN",
    "City": "Floodwood"
  },
  {
    "State": "MN",
    "City": "Forbes"
  },
  {
    "State": "MN",
    "City": "Gilbert"
  },
  {
    "State": "MN",
    "City": "Goodland"
  },
  {
    "State": "MN",
    "City": "Hibbing"
  },
  {
    "State": "MN",
    "City": "Hill City"
  },
  {
    "State": "MN",
    "City": "Holyoke"
  },
  {
    "State": "MN",
    "City": "Hoyt Lakes"
  },
  {
    "State": "MN",
    "City": "Iron"
  },
  {
    "State": "MN",
    "City": "Jacobson"
  },
  {
    "State": "MN",
    "City": "Keewatin"
  },
  {
    "State": "MN",
    "City": "Kerrick"
  },
  {
    "State": "MN",
    "City": "Kettle River"
  },
  {
    "State": "MN",
    "City": "Kinney"
  },
  {
    "State": "MN",
    "City": "Mcgregor"
  },
  {
    "State": "MN",
    "City": "Makinen"
  },
  {
    "State": "MN",
    "City": "Marble"
  },
  {
    "State": "MN",
    "City": "Meadowlands"
  },
  {
    "State": "MN",
    "City": "Melrude"
  },
  {
    "State": "MN",
    "City": "Moose Lake"
  },
  {
    "State": "MN",
    "City": "Mountain Iron"
  },
  {
    "State": "MN",
    "City": "Nashwauk"
  },
  {
    "State": "MN",
    "City": "Orr"
  },
  {
    "State": "MN",
    "City": "Nett Lake"
  },
  {
    "State": "MN",
    "City": "Pengilly"
  },
  {
    "State": "MN",
    "City": "Virginia"
  },
  {
    "State": "MN",
    "City": "Saginaw"
  },
  {
    "State": "MN",
    "City": "Sawyer"
  },
  {
    "State": "MN",
    "City": "Side Lake"
  },
  {
    "State": "MN",
    "City": "Soudan"
  },
  {
    "State": "MN",
    "City": "Sturgeon Lake"
  },
  {
    "State": "MN",
    "City": "Swan River"
  },
  {
    "State": "MN",
    "City": "Swatara"
  },
  {
    "State": "MN",
    "City": "Taconite"
  },
  {
    "State": "MN",
    "City": "Tamarack"
  },
  {
    "State": "MN",
    "City": "Tower"
  },
  {
    "State": "MN",
    "City": "Twig"
  },
  {
    "State": "MN",
    "City": "Warba"
  },
  {
    "State": "MN",
    "City": "Willow River"
  },
  {
    "State": "MN",
    "City": "Winton"
  },
  {
    "State": "MN",
    "City": "Wrenshall"
  },
  {
    "State": "MN",
    "City": "Wright"
  },
  {
    "State": "MN",
    "City": "Duluth"
  },
  {
    "State": "MN",
    "City": "Rochester"
  },
  {
    "State": "MN",
    "City": "Adams"
  },
  {
    "State": "MN",
    "City": "Altura"
  },
  {
    "State": "MN",
    "City": "Austin"
  },
  {
    "State": "MN",
    "City": "Blooming Prairie"
  },
  {
    "State": "MN",
    "City": "Brownsdale"
  },
  {
    "State": "MN",
    "City": "Brownsville"
  },
  {
    "State": "MN",
    "City": "Byron"
  },
  {
    "State": "MN",
    "City": "Caledonia"
  },
  {
    "State": "MN",
    "City": "Canton"
  },
  {
    "State": "MN",
    "City": "Chatfield"
  },
  {
    "State": "MN",
    "City": "Claremont"
  },
  {
    "State": "MN",
    "City": "Dakota"
  },
  {
    "State": "MN",
    "City": "Dexter"
  },
  {
    "State": "MN",
    "City": "Dodge Center"
  },
  {
    "State": "MN",
    "City": "Dover"
  },
  {
    "State": "MN",
    "City": "Eitzen"
  },
  {
    "State": "MN",
    "City": "Elgin"
  },
  {
    "State": "MN",
    "City": "Elkton"
  },
  {
    "State": "MN",
    "City": "Eyota"
  },
  {
    "State": "MN",
    "City": "Fountain"
  },
  {
    "State": "MN",
    "City": "Grand Meadow"
  },
  {
    "State": "MN",
    "City": "Harmony"
  },
  {
    "State": "MN",
    "City": "Hayfield"
  },
  {
    "State": "MN",
    "City": "Hokah"
  },
  {
    "State": "MN",
    "City": "Homer"
  },
  {
    "State": "MN",
    "City": "Houston"
  },
  {
    "State": "MN",
    "City": "Kasson"
  },
  {
    "State": "MN",
    "City": "Kellogg"
  },
  {
    "State": "MN",
    "City": "Kenyon"
  },
  {
    "State": "MN",
    "City": "La Crescent"
  },
  {
    "State": "MN",
    "City": "Lanesboro"
  },
  {
    "State": "MN",
    "City": "Lansing"
  },
  {
    "State": "MN",
    "City": "Le Roy"
  },
  {
    "State": "MN",
    "City": "Lewiston"
  },
  {
    "State": "MN",
    "City": "Lyle"
  },
  {
    "State": "MN",
    "City": "Mabel"
  },
  {
    "State": "MN",
    "City": "Mantorville"
  },
  {
    "State": "MN",
    "City": "Mazeppa"
  },
  {
    "State": "MN",
    "City": "Millville"
  },
  {
    "State": "MN",
    "City": "Minnesota City"
  },
  {
    "State": "MN",
    "City": "Oronoco"
  },
  {
    "State": "MN",
    "City": "Ostrander"
  },
  {
    "State": "MN",
    "City": "Peterson"
  },
  {
    "State": "MN",
    "City": "Pine Island"
  },
  {
    "State": "MN",
    "City": "Plainview"
  },
  {
    "State": "MN",
    "City": "Preston"
  },
  {
    "State": "MN",
    "City": "Racine"
  },
  {
    "State": "MN",
    "City": "Reads Landing"
  },
  {
    "State": "MN",
    "City": "Rollingstone"
  },
  {
    "State": "MN",
    "City": "Rose Creek"
  },
  {
    "State": "MN",
    "City": "Rushford"
  },
  {
    "State": "MN",
    "City": "Saint Charles"
  },
  {
    "State": "MN",
    "City": "Sargeant"
  },
  {
    "State": "MN",
    "City": "Spring Grove"
  },
  {
    "State": "MN",
    "City": "Spring Valley"
  },
  {
    "State": "MN",
    "City": "Stewartville"
  },
  {
    "State": "MN",
    "City": "Taopi"
  },
  {
    "State": "MN",
    "City": "Utica"
  },
  {
    "State": "MN",
    "City": "Wabasha"
  },
  {
    "State": "MN",
    "City": "Waltham"
  },
  {
    "State": "MN",
    "City": "Wanamingo"
  },
  {
    "State": "MN",
    "City": "West Concord"
  },
  {
    "State": "MN",
    "City": "Winona"
  },
  {
    "State": "MN",
    "City": "Stockton"
  },
  {
    "State": "MN",
    "City": "Wykoff"
  },
  {
    "State": "MN",
    "City": "Zumbro Falls"
  },
  {
    "State": "MN",
    "City": "Zumbrota"
  },
  {
    "State": "MN",
    "City": "Mankato"
  },
  {
    "State": "MN",
    "City": "Albert Lea"
  },
  {
    "State": "MN",
    "City": "Alden"
  },
  {
    "State": "MN",
    "City": "Amboy"
  },
  {
    "State": "MN",
    "City": "Belle Plaine"
  },
  {
    "State": "MN",
    "City": "Blue Earth"
  },
  {
    "State": "MN",
    "City": "Bricelyn"
  },
  {
    "State": "MN",
    "City": "Clarks Grove"
  },
  {
    "State": "MN",
    "City": "Cleveland"
  },
  {
    "State": "MN",
    "City": "Comfrey"
  },
  {
    "State": "MN",
    "City": "Conger"
  },
  {
    "State": "MN",
    "City": "Courtland"
  },
  {
    "State": "MN",
    "City": "Darfur"
  },
  {
    "State": "MN",
    "City": "Delavan"
  },
  {
    "State": "MN",
    "City": "Eagle Lake"
  },
  {
    "State": "MN",
    "City": "Easton"
  },
  {
    "State": "MN",
    "City": "Ellendale"
  },
  {
    "State": "MN",
    "City": "Elmore"
  },
  {
    "State": "MN",
    "City": "Elysian"
  },
  {
    "State": "MN",
    "City": "Emmons"
  },
  {
    "State": "MN",
    "City": "Essig"
  },
  {
    "State": "MN",
    "City": "Fairmont"
  },
  {
    "State": "MN",
    "City": "Freeborn"
  },
  {
    "State": "MN",
    "City": "Frost"
  },
  {
    "State": "MN",
    "City": "Garden City"
  },
  {
    "State": "MN",
    "City": "Geneva"
  },
  {
    "State": "MN",
    "City": "Glenville"
  },
  {
    "State": "MN",
    "City": "Good Thunder"
  },
  {
    "State": "MN",
    "City": "Granada"
  },
  {
    "State": "MN",
    "City": "Hanska"
  },
  {
    "State": "MN",
    "City": "Hartland"
  },
  {
    "State": "MN",
    "City": "Hayward"
  },
  {
    "State": "MN",
    "City": "Henderson"
  },
  {
    "State": "MN",
    "City": "Hollandale"
  },
  {
    "State": "MN",
    "City": "Hope"
  },
  {
    "State": "MN",
    "City": "Huntley"
  },
  {
    "State": "MN",
    "City": "Janesville"
  },
  {
    "State": "MN",
    "City": "Kasota"
  },
  {
    "State": "MN",
    "City": "Kiester"
  },
  {
    "State": "MN",
    "City": "Kilkenny"
  },
  {
    "State": "MN",
    "City": "Lafayette"
  },
  {
    "State": "MN",
    "City": "Lake Crystal"
  },
  {
    "State": "MN",
    "City": "La Salle"
  },
  {
    "State": "MN",
    "City": "Le Center"
  },
  {
    "State": "MN",
    "City": "Le Sueur"
  },
  {
    "State": "MN",
    "City": "Lewisville"
  },
  {
    "State": "MN",
    "City": "Madelia"
  },
  {
    "State": "MN",
    "City": "Madison Lake"
  },
  {
    "State": "MN",
    "City": "Mapleton"
  },
  {
    "State": "MN",
    "City": "Minnesota Lake"
  },
  {
    "State": "MN",
    "City": "Montgomery"
  },
  {
    "State": "MN",
    "City": "New Prague"
  },
  {
    "State": "MN",
    "City": "New Richland"
  },
  {
    "State": "MN",
    "City": "New Ulm"
  },
  {
    "State": "MN",
    "City": "Nicollet"
  },
  {
    "State": "MN",
    "City": "Northrop"
  },
  {
    "State": "MN",
    "City": "Pemberton"
  },
  {
    "State": "MN",
    "City": "Saint Clair"
  },
  {
    "State": "MN",
    "City": "Saint James"
  },
  {
    "State": "MN",
    "City": "Saint Peter"
  },
  {
    "State": "MN",
    "City": "Sanborn"
  },
  {
    "State": "MN",
    "City": "Searles"
  },
  {
    "State": "MN",
    "City": "Sleepy Eye"
  },
  {
    "State": "MN",
    "City": "Springfield"
  },
  {
    "State": "MN",
    "City": "Truman"
  },
  {
    "State": "MN",
    "City": "Twin Lakes"
  },
  {
    "State": "MN",
    "City": "Vernon Center"
  },
  {
    "State": "MN",
    "City": "Waldorf"
  },
  {
    "State": "MN",
    "City": "Waseca"
  },
  {
    "State": "MN",
    "City": "Waterville"
  },
  {
    "State": "MN",
    "City": "Wells"
  },
  {
    "State": "MN",
    "City": "Winnebago"
  },
  {
    "State": "MN",
    "City": "Windom"
  },
  {
    "State": "MN",
    "City": "Adrian"
  },
  {
    "State": "MN",
    "City": "Alpha"
  },
  {
    "State": "MN",
    "City": "Arco"
  },
  {
    "State": "MN",
    "City": "Avoca"
  },
  {
    "State": "MN",
    "City": "Balaton"
  },
  {
    "State": "MN",
    "City": "Beaver Creek"
  },
  {
    "State": "MN",
    "City": "Bigelow"
  },
  {
    "State": "MN",
    "City": "Bingham Lake"
  },
  {
    "State": "MN",
    "City": "Brewster"
  },
  {
    "State": "MN",
    "City": "Butterfield"
  },
  {
    "State": "MN",
    "City": "Ceylon"
  },
  {
    "State": "MN",
    "City": "Chandler"
  },
  {
    "State": "MN",
    "City": "Currie"
  },
  {
    "State": "MN",
    "City": "Dovray"
  },
  {
    "State": "MN",
    "City": "Dunnell"
  },
  {
    "State": "MN",
    "City": "Edgerton"
  },
  {
    "State": "MN",
    "City": "Ellsworth"
  },
  {
    "State": "MN",
    "City": "Fulda"
  },
  {
    "State": "MN",
    "City": "Garvin"
  },
  {
    "State": "MN",
    "City": "Hardwick"
  },
  {
    "State": "MN",
    "City": "Hendricks"
  },
  {
    "State": "MN",
    "City": "Heron Lake"
  },
  {
    "State": "MN",
    "City": "Hills"
  },
  {
    "State": "MN",
    "City": "Holland"
  },
  {
    "State": "MN",
    "City": "Ihlen"
  },
  {
    "State": "MN",
    "City": "Iona"
  },
  {
    "State": "MN",
    "City": "Ivanhoe"
  },
  {
    "State": "MN",
    "City": "Jackson"
  },
  {
    "State": "MN",
    "City": "Jasper"
  },
  {
    "State": "MN",
    "City": "Jeffers"
  },
  {
    "State": "MN",
    "City": "Kanaranzi"
  },
  {
    "State": "MN",
    "City": "Kenneth"
  },
  {
    "State": "MN",
    "City": "Lake Benton"
  },
  {
    "State": "MN",
    "City": "Lakefield"
  },
  {
    "State": "MN",
    "City": "Lake Wilson"
  },
  {
    "State": "MN",
    "City": "Lamberton"
  },
  {
    "State": "MN",
    "City": "Leota"
  },
  {
    "State": "MN",
    "City": "Lismore"
  },
  {
    "State": "MN",
    "City": "Luverne"
  },
  {
    "State": "MN",
    "City": "Lynd"
  },
  {
    "State": "MN",
    "City": "Magnolia"
  },
  {
    "State": "MN",
    "City": "Mountain Lake"
  },
  {
    "State": "MN",
    "City": "Odin"
  },
  {
    "State": "MN",
    "City": "Okabena"
  },
  {
    "State": "MN",
    "City": "Ormsby"
  },
  {
    "State": "MN",
    "City": "Pipestone"
  },
  {
    "State": "MN",
    "City": "Reading"
  },
  {
    "State": "MN",
    "City": "Revere"
  },
  {
    "State": "MN",
    "City": "Round Lake"
  },
  {
    "State": "MN",
    "City": "Rushmore"
  },
  {
    "State": "MN",
    "City": "Russell"
  },
  {
    "State": "MN",
    "City": "Ruthton"
  },
  {
    "State": "MN",
    "City": "Sherburn"
  },
  {
    "State": "MN",
    "City": "Slayton"
  },
  {
    "State": "MN",
    "City": "Steen"
  },
  {
    "State": "MN",
    "City": "Storden"
  },
  {
    "State": "MN",
    "City": "Tracy"
  },
  {
    "State": "MN",
    "City": "Trimont"
  },
  {
    "State": "MN",
    "City": "Trosky"
  },
  {
    "State": "MN",
    "City": "Tyler"
  },
  {
    "State": "MN",
    "City": "Walnut Grove"
  },
  {
    "State": "MN",
    "City": "Welcome"
  },
  {
    "State": "MN",
    "City": "Westbrook"
  },
  {
    "State": "MN",
    "City": "Wilmont"
  },
  {
    "State": "MN",
    "City": "Woodstock"
  },
  {
    "State": "MN",
    "City": "Worthington"
  },
  {
    "State": "MN",
    "City": "Willmar"
  },
  {
    "State": "MN",
    "City": "Alberta"
  },
  {
    "State": "MN",
    "City": "Appleton"
  },
  {
    "State": "MN",
    "City": "Atwater"
  },
  {
    "State": "MN",
    "City": "Barry"
  },
  {
    "State": "MN",
    "City": "Beardsley"
  },
  {
    "State": "MN",
    "City": "Bellingham"
  },
  {
    "State": "MN",
    "City": "Belview"
  },
  {
    "State": "MN",
    "City": "Benson"
  },
  {
    "State": "MN",
    "City": "Blomkest"
  },
  {
    "State": "MN",
    "City": "Boyd"
  },
  {
    "State": "MN",
    "City": "Browns Valley"
  },
  {
    "State": "MN",
    "City": "Canby"
  },
  {
    "State": "MN",
    "City": "Chokio"
  },
  {
    "State": "MN",
    "City": "Clara City"
  },
  {
    "State": "MN",
    "City": "Clarkfield"
  },
  {
    "State": "MN",
    "City": "Clements"
  },
  {
    "State": "MN",
    "City": "Clinton"
  },
  {
    "State": "MN",
    "City": "Clontarf"
  },
  {
    "State": "MN",
    "City": "Correll"
  },
  {
    "State": "MN",
    "City": "Cosmos"
  },
  {
    "State": "MN",
    "City": "Cottonwood"
  },
  {
    "State": "MN",
    "City": "Danube"
  },
  {
    "State": "MN",
    "City": "Danvers"
  },
  {
    "State": "MN",
    "City": "Dawson"
  },
  {
    "State": "MN",
    "City": "Donnelly"
  },
  {
    "State": "MN",
    "City": "Dumont"
  },
  {
    "State": "MN",
    "City": "Echo"
  },
  {
    "State": "MN",
    "City": "Ghent"
  },
  {
    "State": "MN",
    "City": "Graceville"
  },
  {
    "State": "MN",
    "City": "Granite Falls"
  },
  {
    "State": "MN",
    "City": "Grove City"
  },
  {
    "State": "MN",
    "City": "Hancock"
  },
  {
    "State": "MN",
    "City": "Hanley Falls"
  },
  {
    "State": "MN",
    "City": "Herman"
  },
  {
    "State": "MN",
    "City": "Holloway"
  },
  {
    "State": "MN",
    "City": "Kandiyohi"
  },
  {
    "State": "MN",
    "City": "Kerkhoven"
  },
  {
    "State": "MN",
    "City": "Lake Lillian"
  },
  {
    "State": "MN",
    "City": "Lucan"
  },
  {
    "State": "MN",
    "City": "Madison"
  },
  {
    "State": "MN",
    "City": "Marietta"
  },
  {
    "State": "MN",
    "City": "Marshall"
  },
  {
    "State": "MN",
    "City": "Maynard"
  },
  {
    "State": "MN",
    "City": "Milan"
  },
  {
    "State": "MN",
    "City": "Milroy"
  },
  {
    "State": "MN",
    "City": "Minneota"
  },
  {
    "State": "MN",
    "City": "Montevideo"
  },
  {
    "State": "MN",
    "City": "Morgan"
  },
  {
    "State": "MN",
    "City": "Morris"
  },
  {
    "State": "MN",
    "City": "Morton"
  },
  {
    "State": "MN",
    "City": "Murdock"
  },
  {
    "State": "MN",
    "City": "New London"
  },
  {
    "State": "MN",
    "City": "Norcross"
  },
  {
    "State": "MN",
    "City": "Odessa"
  },
  {
    "State": "MN",
    "City": "Olivia"
  },
  {
    "State": "MN",
    "City": "Ortonville"
  },
  {
    "State": "MN",
    "City": "Pennock"
  },
  {
    "State": "MN",
    "City": "Porter"
  },
  {
    "State": "MN",
    "City": "Prinsburg"
  },
  {
    "State": "MN",
    "City": "Raymond"
  },
  {
    "State": "MN",
    "City": "Redwood Falls"
  },
  {
    "State": "MN",
    "City": "Renville"
  },
  {
    "State": "MN",
    "City": "Sacred Heart"
  },
  {
    "State": "MN",
    "City": "Seaforth"
  },
  {
    "State": "MN",
    "City": "Spicer"
  },
  {
    "State": "MN",
    "City": "Sunburg"
  },
  {
    "State": "MN",
    "City": "Taunton"
  },
  {
    "State": "MN",
    "City": "Vesta"
  },
  {
    "State": "MN",
    "City": "Wabasso"
  },
  {
    "State": "MN",
    "City": "Wanda"
  },
  {
    "State": "MN",
    "City": "Watson"
  },
  {
    "State": "MN",
    "City": "Wheaton"
  },
  {
    "State": "MN",
    "City": "Wood Lake"
  },
  {
    "State": "MN",
    "City": "Saint Cloud"
  },
  {
    "State": "MN",
    "City": "Albany"
  },
  {
    "State": "MN",
    "City": "Alexandria"
  },
  {
    "State": "MN",
    "City": "Ashby"
  },
  {
    "State": "MN",
    "City": "Avon"
  },
  {
    "State": "MN",
    "City": "Barrett"
  },
  {
    "State": "MN",
    "City": "Belgrade"
  },
  {
    "State": "MN",
    "City": "Bock"
  },
  {
    "State": "MN",
    "City": "Bowlus"
  },
  {
    "State": "MN",
    "City": "Brandon"
  },
  {
    "State": "MN",
    "City": "Brooten"
  },
  {
    "State": "MN",
    "City": "Buckman"
  },
  {
    "State": "MN",
    "City": "Burtrum"
  },
  {
    "State": "MN",
    "City": "Carlos"
  },
  {
    "State": "MN",
    "City": "Cold Spring"
  },
  {
    "State": "MN",
    "City": "Collegeville"
  },
  {
    "State": "MN",
    "City": "Cyrus"
  },
  {
    "State": "MN",
    "City": "Dalton"
  },
  {
    "State": "MN",
    "City": "Elrosa"
  },
  {
    "State": "MN",
    "City": "Evansville"
  },
  {
    "State": "MN",
    "City": "Farwell"
  },
  {
    "State": "MN",
    "City": "Flensburg"
  },
  {
    "State": "MN",
    "City": "Foley"
  },
  {
    "State": "MN",
    "City": "Foreston"
  },
  {
    "State": "MN",
    "City": "Freeport"
  },
  {
    "State": "MN",
    "City": "Garfield"
  },
  {
    "State": "MN",
    "City": "Gilman"
  },
  {
    "State": "MN",
    "City": "Glenwood"
  },
  {
    "State": "MN",
    "City": "Greenwald"
  },
  {
    "State": "MN",
    "City": "Grey Eagle"
  },
  {
    "State": "MN",
    "City": "Hillman"
  },
  {
    "State": "MN",
    "City": "Hoffman"
  },
  {
    "State": "MN",
    "City": "Holdingford"
  },
  {
    "State": "MN",
    "City": "Holmes City"
  },
  {
    "State": "MN",
    "City": "Isle"
  },
  {
    "State": "MN",
    "City": "Kensington"
  },
  {
    "State": "MN",
    "City": "Lastrup"
  },
  {
    "State": "MN",
    "City": "Little Falls"
  },
  {
    "State": "MN",
    "City": "Long Prairie"
  },
  {
    "State": "MN",
    "City": "Lowry"
  },
  {
    "State": "MN",
    "City": "Mc Grath"
  },
  {
    "State": "MN",
    "City": "Melrose"
  },
  {
    "State": "MN",
    "City": "Milaca"
  },
  {
    "State": "MN",
    "City": "Miltona"
  },
  {
    "State": "MN",
    "City": "Nelson"
  },
  {
    "State": "MN",
    "City": "New Munich"
  },
  {
    "State": "MN",
    "City": "Oak Park"
  },
  {
    "State": "MN",
    "City": "Ogilvie"
  },
  {
    "State": "MN",
    "City": "Onamia"
  },
  {
    "State": "MN",
    "City": "Osakis"
  },
  {
    "State": "MN",
    "City": "Parkers Prairie"
  },
  {
    "State": "MN",
    "City": "Paynesville"
  },
  {
    "State": "MN",
    "City": "Pease"
  },
  {
    "State": "MN",
    "City": "Pierz"
  },
  {
    "State": "MN",
    "City": "Rice"
  },
  {
    "State": "MN",
    "City": "Richmond"
  },
  {
    "State": "MN",
    "City": "Rockville"
  },
  {
    "State": "MN",
    "City": "Roscoe"
  },
  {
    "State": "MN",
    "City": "Royalton"
  },
  {
    "State": "MN",
    "City": "Saint Joseph"
  },
  {
    "State": "MN",
    "City": "Saint Stephen"
  },
  {
    "State": "MN",
    "City": "Saint Martin"
  },
  {
    "State": "MN",
    "City": "Sartell"
  },
  {
    "State": "MN",
    "City": "Sauk Centre"
  },
  {
    "State": "MN",
    "City": "Sauk Rapids"
  },
  {
    "State": "MN",
    "City": "Starbuck"
  },
  {
    "State": "MN",
    "City": "Swanville"
  },
  {
    "State": "MN",
    "City": "Upsala"
  },
  {
    "State": "MN",
    "City": "Villard"
  },
  {
    "State": "MN",
    "City": "Wahkon"
  },
  {
    "State": "MN",
    "City": "Waite Park"
  },
  {
    "State": "MN",
    "City": "West Union"
  },
  {
    "State": "MN",
    "City": "Brainerd"
  },
  {
    "State": "MN",
    "City": "Baxter"
  },
  {
    "State": "MN",
    "City": "Ah Gwah Ching"
  },
  {
    "State": "MN",
    "City": "Aitkin"
  },
  {
    "State": "MN",
    "City": "Akeley"
  },
  {
    "State": "MN",
    "City": "Aldrich"
  },
  {
    "State": "MN",
    "City": "Backus"
  },
  {
    "State": "MN",
    "City": "Benedict"
  },
  {
    "State": "MN",
    "City": "Bertha"
  },
  {
    "State": "MN",
    "City": "Browerville"
  },
  {
    "State": "MN",
    "City": "Clarissa"
  },
  {
    "State": "MN",
    "City": "Crosby"
  },
  {
    "State": "MN",
    "City": "Crosslake"
  },
  {
    "State": "MN",
    "City": "Cushing"
  },
  {
    "State": "MN",
    "City": "Deerwood"
  },
  {
    "State": "MN",
    "City": "Eagle Bend"
  },
  {
    "State": "MN",
    "City": "Emily"
  },
  {
    "State": "MN",
    "City": "Fifty Lakes"
  },
  {
    "State": "MN",
    "City": "Fort Ripley"
  },
  {
    "State": "MN",
    "City": "Garrison"
  },
  {
    "State": "MN",
    "City": "Hackensack"
  },
  {
    "State": "MN",
    "City": "Hewitt"
  },
  {
    "State": "MN",
    "City": "Ironton"
  },
  {
    "State": "MN",
    "City": "Jenkins"
  },
  {
    "State": "MN",
    "City": "Lake George"
  },
  {
    "State": "MN",
    "City": "Lake Hubert"
  },
  {
    "State": "MN",
    "City": "Laporte"
  },
  {
    "State": "MN",
    "City": "Menahga"
  },
  {
    "State": "MN",
    "City": "Merrifield"
  },
  {
    "State": "MN",
    "City": "Motley"
  },
  {
    "State": "MN",
    "City": "Nevis"
  },
  {
    "State": "MN",
    "City": "Nisswa"
  },
  {
    "State": "MN",
    "City": "Palisade"
  },
  {
    "State": "MN",
    "City": "Park Rapids"
  },
  {
    "State": "MN",
    "City": "Pequot Lakes"
  },
  {
    "State": "MN",
    "City": "Pillager"
  },
  {
    "State": "MN",
    "City": "Pine River"
  },
  {
    "State": "MN",
    "City": "Randall"
  },
  {
    "State": "MN",
    "City": "Sebeka"
  },
  {
    "State": "MN",
    "City": "Nimrod"
  },
  {
    "State": "MN",
    "City": "Staples"
  },
  {
    "State": "MN",
    "City": "Verndale"
  },
  {
    "State": "MN",
    "City": "Wadena"
  },
  {
    "State": "MN",
    "City": "Walker"
  },
  {
    "State": "MN",
    "City": "Detroit Lakes"
  },
  {
    "State": "MN",
    "City": "Ada"
  },
  {
    "State": "MN",
    "City": "Audubon"
  },
  {
    "State": "MN",
    "City": "Barnesville"
  },
  {
    "State": "MN",
    "City": "Battle Lake"
  },
  {
    "State": "MN",
    "City": "Bejou"
  },
  {
    "State": "MN",
    "City": "Beltrami"
  },
  {
    "State": "MN",
    "City": "Bluffton"
  },
  {
    "State": "MN",
    "City": "Borup"
  },
  {
    "State": "MN",
    "City": "Breckenridge"
  },
  {
    "State": "MN",
    "City": "Callaway"
  },
  {
    "State": "MN",
    "City": "Campbell"
  },
  {
    "State": "MN",
    "City": "Climax"
  },
  {
    "State": "MN",
    "City": "Clitherall"
  },
  {
    "State": "MN",
    "City": "Comstock"
  },
  {
    "State": "MN",
    "City": "Deer Creek"
  },
  {
    "State": "MN",
    "City": "Dent"
  },
  {
    "State": "MN",
    "City": "Dilworth"
  },
  {
    "State": "MN",
    "City": "Elbow Lake"
  },
  {
    "State": "MN",
    "City": "Elizabeth"
  },
  {
    "State": "MN",
    "City": "Erhard"
  },
  {
    "State": "MN",
    "City": "Erskine"
  },
  {
    "State": "MN",
    "City": "Felton"
  },
  {
    "State": "MN",
    "City": "Fergus Falls"
  },
  {
    "State": "MN",
    "City": "Fertile"
  },
  {
    "State": "MN",
    "City": "Flom"
  },
  {
    "State": "MN",
    "City": "Fosston"
  },
  {
    "State": "MN",
    "City": "Foxhome"
  },
  {
    "State": "MN",
    "City": "Frazee"
  },
  {
    "State": "MN",
    "City": "Gary"
  },
  {
    "State": "MN",
    "City": "Georgetown"
  },
  {
    "State": "MN",
    "City": "Glyndon"
  },
  {
    "State": "MN",
    "City": "Halstad"
  },
  {
    "State": "MN",
    "City": "Hawley"
  },
  {
    "State": "MN",
    "City": "Hendrum"
  },
  {
    "State": "MN",
    "City": "Henning"
  },
  {
    "State": "MN",
    "City": "Hitterdal"
  },
  {
    "State": "MN",
    "City": "Kent"
  },
  {
    "State": "MN",
    "City": "Lake Park"
  },
  {
    "State": "MN",
    "City": "Mcintosh"
  },
  {
    "State": "MN",
    "City": "Mahnomen"
  },
  {
    "State": "MN",
    "City": "Moorhead"
  },
  {
    "State": "MN",
    "City": "Nashua"
  },
  {
    "State": "MN",
    "City": "Naytahwaush"
  },
  {
    "State": "MN",
    "City": "New York Mills"
  },
  {
    "State": "MN",
    "City": "Nielsville"
  },
  {
    "State": "MN",
    "City": "Ogema"
  },
  {
    "State": "MN",
    "City": "Osage"
  },
  {
    "State": "MN",
    "City": "Ottertail"
  },
  {
    "State": "MN",
    "City": "Pelican Rapids"
  },
  {
    "State": "MN",
    "City": "Perham"
  },
  {
    "State": "MN",
    "City": "Perley"
  },
  {
    "State": "MN",
    "City": "Ponsford"
  },
  {
    "State": "MN",
    "City": "Richville"
  },
  {
    "State": "MN",
    "City": "Richwood"
  },
  {
    "State": "MN",
    "City": "Rochert"
  },
  {
    "State": "MN",
    "City": "Rothsay"
  },
  {
    "State": "MN",
    "City": "Sabin"
  },
  {
    "State": "MN",
    "City": "Shelly"
  },
  {
    "State": "MN",
    "City": "Tintah"
  },
  {
    "State": "MN",
    "City": "Twin Valley"
  },
  {
    "State": "MN",
    "City": "Ulen"
  },
  {
    "State": "MN",
    "City": "Underwood"
  },
  {
    "State": "MN",
    "City": "Vergas"
  },
  {
    "State": "MN",
    "City": "Vining"
  },
  {
    "State": "MN",
    "City": "Waubun"
  },
  {
    "State": "MN",
    "City": "Wendell"
  },
  {
    "State": "MN",
    "City": "White Earth"
  },
  {
    "State": "MN",
    "City": "Winger"
  },
  {
    "State": "MN",
    "City": "Wolf Lake"
  },
  {
    "State": "MN",
    "City": "Wolverton"
  },
  {
    "State": "MN",
    "City": "Bemidji"
  },
  {
    "State": "MN",
    "City": "Bagley"
  },
  {
    "State": "MN",
    "City": "Baudette"
  },
  {
    "State": "MN",
    "City": "Bena"
  },
  {
    "State": "MN",
    "City": "Big Falls"
  },
  {
    "State": "MN",
    "City": "Bigfork"
  },
  {
    "State": "MN",
    "City": "Birchdale"
  },
  {
    "State": "MN",
    "City": "Blackduck"
  },
  {
    "State": "MN",
    "City": "Bowstring"
  },
  {
    "State": "MN",
    "City": "Cass Lake"
  },
  {
    "State": "MN",
    "City": "Clearbrook"
  },
  {
    "State": "MN",
    "City": "Deer River"
  },
  {
    "State": "MN",
    "City": "Talmoon"
  },
  {
    "State": "MN",
    "City": "Effie"
  },
  {
    "State": "MN",
    "City": "Federal Dam"
  },
  {
    "State": "MN",
    "City": "Gonvick"
  },
  {
    "State": "MN",
    "City": "Gully"
  },
  {
    "State": "MN",
    "City": "Hines"
  },
  {
    "State": "MN",
    "City": "International Falls"
  },
  {
    "State": "MN",
    "City": "Kelliher"
  },
  {
    "State": "MN",
    "City": "Lengby"
  },
  {
    "State": "MN",
    "City": "Leonard"
  },
  {
    "State": "MN",
    "City": "Littlefork"
  },
  {
    "State": "MN",
    "City": "Loman"
  },
  {
    "State": "MN",
    "City": "Longville"
  },
  {
    "State": "MN",
    "City": "Marcell"
  },
  {
    "State": "MN",
    "City": "Margie"
  },
  {
    "State": "MN",
    "City": "Max"
  },
  {
    "State": "MN",
    "City": "Mizpah"
  },
  {
    "State": "MN",
    "City": "Northome"
  },
  {
    "State": "MN",
    "City": "Outing"
  },
  {
    "State": "MN",
    "City": "Pennington"
  },
  {
    "State": "MN",
    "City": "Ponemah"
  },
  {
    "State": "MN",
    "City": "Puposky"
  },
  {
    "State": "MN",
    "City": "Ranier"
  },
  {
    "State": "MN",
    "City": "Kabetogama"
  },
  {
    "State": "MN",
    "City": "Redby"
  },
  {
    "State": "MN",
    "City": "Redlake"
  },
  {
    "State": "MN",
    "City": "Remer"
  },
  {
    "State": "MN",
    "City": "Roosevelt"
  },
  {
    "State": "MN",
    "City": "Shevlin"
  },
  {
    "State": "MN",
    "City": "Solway"
  },
  {
    "State": "MN",
    "City": "South International Falls"
  },
  {
    "State": "MN",
    "City": "Spring Lake"
  },
  {
    "State": "MN",
    "City": "Squaw Lake"
  },
  {
    "State": "MN",
    "City": "Swift"
  },
  {
    "State": "MN",
    "City": "Tenstrike"
  },
  {
    "State": "MN",
    "City": "Trail"
  },
  {
    "State": "MN",
    "City": "Waskish"
  },
  {
    "State": "MN",
    "City": "Williams"
  },
  {
    "State": "MN",
    "City": "Wilton"
  },
  {
    "State": "MN",
    "City": "Wirt"
  },
  {
    "State": "MN",
    "City": "Thief River Falls"
  },
  {
    "State": "MN",
    "City": "Alvarado"
  },
  {
    "State": "MN",
    "City": "Angle Inlet"
  },
  {
    "State": "MN",
    "City": "Argyle"
  },
  {
    "State": "MN",
    "City": "Badger"
  },
  {
    "State": "MN",
    "City": "Brooks"
  },
  {
    "State": "MN",
    "City": "Crookston"
  },
  {
    "State": "MN",
    "City": "Donaldson"
  },
  {
    "State": "MN",
    "City": "East Grand Forks"
  },
  {
    "State": "MN",
    "City": "Euclid"
  },
  {
    "State": "MN",
    "City": "Fisher"
  },
  {
    "State": "MN",
    "City": "Gatzke"
  },
  {
    "State": "MN",
    "City": "Goodridge"
  },
  {
    "State": "MN",
    "City": "Greenbush"
  },
  {
    "State": "MN",
    "City": "Grygla"
  },
  {
    "State": "MN",
    "City": "Hallock"
  },
  {
    "State": "MN",
    "City": "Halma"
  },
  {
    "State": "MN",
    "City": "Humboldt"
  },
  {
    "State": "MN",
    "City": "Karlstad"
  },
  {
    "State": "MN",
    "City": "Kennedy"
  },
  {
    "State": "MN",
    "City": "Lake Bronson"
  },
  {
    "State": "MN",
    "City": "Lancaster"
  },
  {
    "State": "MN",
    "City": "Mentor"
  },
  {
    "State": "MN",
    "City": "Middle River"
  },
  {
    "State": "MN",
    "City": "Newfolden"
  },
  {
    "State": "MN",
    "City": "Noyes"
  },
  {
    "State": "MN",
    "City": "Oak Island"
  },
  {
    "State": "MN",
    "City": "Oklee"
  },
  {
    "State": "MN",
    "City": "Oslo"
  },
  {
    "State": "MN",
    "City": "Plummer"
  },
  {
    "State": "MN",
    "City": "Red Lake Falls"
  },
  {
    "State": "MN",
    "City": "Roseau"
  },
  {
    "State": "MN",
    "City": "Saint Hilaire"
  },
  {
    "State": "MN",
    "City": "Saint Vincent"
  },
  {
    "State": "MN",
    "City": "Salol"
  },
  {
    "State": "MN",
    "City": "Stephen"
  },
  {
    "State": "MN",
    "City": "Strandquist"
  },
  {
    "State": "MN",
    "City": "Strathcona"
  },
  {
    "State": "MN",
    "City": "Viking"
  },
  {
    "State": "MN",
    "City": "Wannaska"
  },
  {
    "State": "MN",
    "City": "Warren"
  },
  {
    "State": "MN",
    "City": "Warroad"
  },
  {
    "State": "DC",
    "City": "Parcel Return Service"
  },
  {
    "State": "SD",
    "City": "Alcester"
  },
  {
    "State": "SD",
    "City": "Aurora"
  },
  {
    "State": "SD",
    "City": "Baltic"
  },
  {
    "State": "SD",
    "City": "Beresford"
  },
  {
    "State": "SD",
    "City": "Brandon"
  },
  {
    "State": "SD",
    "City": "Brookings"
  },
  {
    "State": "SD",
    "City": "Burbank"
  },
  {
    "State": "SD",
    "City": "Canistota"
  },
  {
    "State": "SD",
    "City": "Canton"
  },
  {
    "State": "SD",
    "City": "Centerville"
  },
  {
    "State": "SD",
    "City": "Chancellor"
  },
  {
    "State": "SD",
    "City": "Chester"
  },
  {
    "State": "SD",
    "City": "Colman"
  },
  {
    "State": "SD",
    "City": "Colton"
  },
  {
    "State": "SD",
    "City": "Crooks"
  },
  {
    "State": "SD",
    "City": "Davis"
  },
  {
    "State": "SD",
    "City": "Dell Rapids"
  },
  {
    "State": "SD",
    "City": "Egan"
  },
  {
    "State": "SD",
    "City": "Elk Point"
  },
  {
    "State": "SD",
    "City": "Elkton"
  },
  {
    "State": "SD",
    "City": "Fairview"
  },
  {
    "State": "SD",
    "City": "Flandreau"
  },
  {
    "State": "SD",
    "City": "Freeman"
  },
  {
    "State": "SD",
    "City": "Garretson"
  },
  {
    "State": "SD",
    "City": "Gayville"
  },
  {
    "State": "SD",
    "City": "Harrisburg"
  },
  {
    "State": "SD",
    "City": "Hartford"
  },
  {
    "State": "SD",
    "City": "Hudson"
  },
  {
    "State": "SD",
    "City": "Humboldt"
  },
  {
    "State": "SD",
    "City": "Hurley"
  },
  {
    "State": "SD",
    "City": "Irene"
  },
  {
    "State": "SD",
    "City": "Jefferson"
  },
  {
    "State": "SD",
    "City": "Lennox"
  },
  {
    "State": "SD",
    "City": "Lesterville"
  },
  {
    "State": "SD",
    "City": "Lyons"
  },
  {
    "State": "SD",
    "City": "Madison"
  },
  {
    "State": "SD",
    "City": "Marion"
  },
  {
    "State": "SD",
    "City": "Menno"
  },
  {
    "State": "SD",
    "City": "Mission Hill"
  },
  {
    "State": "SD",
    "City": "Monroe"
  },
  {
    "State": "SD",
    "City": "Montrose"
  },
  {
    "State": "SD",
    "City": "North Sioux City"
  },
  {
    "State": "SD",
    "City": "Nunda"
  },
  {
    "State": "SD",
    "City": "Oldham"
  },
  {
    "State": "SD",
    "City": "Olivet"
  },
  {
    "State": "SD",
    "City": "Parker"
  },
  {
    "State": "SD",
    "City": "Ramona"
  },
  {
    "State": "SD",
    "City": "Renner"
  },
  {
    "State": "SD",
    "City": "Rowena"
  },
  {
    "State": "SD",
    "City": "Rutland"
  },
  {
    "State": "SD",
    "City": "Salem"
  },
  {
    "State": "SD",
    "City": "Scotland"
  },
  {
    "State": "SD",
    "City": "Sinai"
  },
  {
    "State": "SD",
    "City": "Springfield"
  },
  {
    "State": "SD",
    "City": "Tabor"
  },
  {
    "State": "SD",
    "City": "Tea"
  },
  {
    "State": "SD",
    "City": "Trent"
  },
  {
    "State": "SD",
    "City": "Tyndall"
  },
  {
    "State": "SD",
    "City": "Utica"
  },
  {
    "State": "SD",
    "City": "Valley Springs"
  },
  {
    "State": "SD",
    "City": "Vermillion"
  },
  {
    "State": "SD",
    "City": "Viborg"
  },
  {
    "State": "SD",
    "City": "Volga"
  },
  {
    "State": "SD",
    "City": "Volin"
  },
  {
    "State": "SD",
    "City": "Wakonda"
  },
  {
    "State": "SD",
    "City": "Wentworth"
  },
  {
    "State": "SD",
    "City": "Winfred"
  },
  {
    "State": "SD",
    "City": "Worthing"
  },
  {
    "State": "SD",
    "City": "Yankton"
  },
  {
    "State": "SD",
    "City": "Sioux Falls"
  },
  {
    "State": "SD",
    "City": "Watertown"
  },
  {
    "State": "SD",
    "City": "Arlington"
  },
  {
    "State": "SD",
    "City": "Astoria"
  },
  {
    "State": "SD",
    "City": "Badger"
  },
  {
    "State": "SD",
    "City": "Big Stone City"
  },
  {
    "State": "SD",
    "City": "Bradley"
  },
  {
    "State": "SD",
    "City": "Brandt"
  },
  {
    "State": "SD",
    "City": "Bristol"
  },
  {
    "State": "SD",
    "City": "Bruce"
  },
  {
    "State": "SD",
    "City": "Bryant"
  },
  {
    "State": "SD",
    "City": "Castlewood"
  },
  {
    "State": "SD",
    "City": "Claire City"
  },
  {
    "State": "SD",
    "City": "Clark"
  },
  {
    "State": "SD",
    "City": "Clear Lake"
  },
  {
    "State": "SD",
    "City": "Corona"
  },
  {
    "State": "SD",
    "City": "De Smet"
  },
  {
    "State": "SD",
    "City": "Eden"
  },
  {
    "State": "SD",
    "City": "Erwin"
  },
  {
    "State": "SD",
    "City": "Estelline"
  },
  {
    "State": "SD",
    "City": "Florence"
  },
  {
    "State": "SD",
    "City": "Garden City"
  },
  {
    "State": "SD",
    "City": "Gary"
  },
  {
    "State": "SD",
    "City": "Goodwin"
  },
  {
    "State": "SD",
    "City": "Grenville"
  },
  {
    "State": "SD",
    "City": "Hayti"
  },
  {
    "State": "SD",
    "City": "Hazel"
  },
  {
    "State": "SD",
    "City": "Henry"
  },
  {
    "State": "SD",
    "City": "Kranzburg"
  },
  {
    "State": "SD",
    "City": "Labolt"
  },
  {
    "State": "SD",
    "City": "Lake City"
  },
  {
    "State": "SD",
    "City": "Lake Norden"
  },
  {
    "State": "SD",
    "City": "Lake Preston"
  },
  {
    "State": "SD",
    "City": "Marvin"
  },
  {
    "State": "SD",
    "City": "Milbank"
  },
  {
    "State": "SD",
    "City": "New Effington"
  },
  {
    "State": "SD",
    "City": "Ortley"
  },
  {
    "State": "SD",
    "City": "Peever"
  },
  {
    "State": "SD",
    "City": "Raymond"
  },
  {
    "State": "SD",
    "City": "Revillo"
  },
  {
    "State": "SD",
    "City": "Rosholt"
  },
  {
    "State": "SD",
    "City": "Roslyn"
  },
  {
    "State": "SD",
    "City": "Sisseton"
  },
  {
    "State": "SD",
    "City": "South Shore"
  },
  {
    "State": "SD",
    "City": "Stockholm"
  },
  {
    "State": "SD",
    "City": "Strandburg"
  },
  {
    "State": "SD",
    "City": "Summit"
  },
  {
    "State": "SD",
    "City": "Toronto"
  },
  {
    "State": "SD",
    "City": "Twin Brooks"
  },
  {
    "State": "SD",
    "City": "Veblen"
  },
  {
    "State": "SD",
    "City": "Vienna"
  },
  {
    "State": "SD",
    "City": "Wallace"
  },
  {
    "State": "SD",
    "City": "Waubay"
  },
  {
    "State": "SD",
    "City": "Webster"
  },
  {
    "State": "SD",
    "City": "White"
  },
  {
    "State": "SD",
    "City": "Willow Lake"
  },
  {
    "State": "SD",
    "City": "Wilmot"
  },
  {
    "State": "SD",
    "City": "Mitchell"
  },
  {
    "State": "SD",
    "City": "Alexandria"
  },
  {
    "State": "SD",
    "City": "Alpena"
  },
  {
    "State": "SD",
    "City": "Armour"
  },
  {
    "State": "SD",
    "City": "Artesian"
  },
  {
    "State": "SD",
    "City": "Avon"
  },
  {
    "State": "SD",
    "City": "Bonesteel"
  },
  {
    "State": "SD",
    "City": "Bridgewater"
  },
  {
    "State": "SD",
    "City": "Canova"
  },
  {
    "State": "SD",
    "City": "Carpenter"
  },
  {
    "State": "SD",
    "City": "Carthage"
  },
  {
    "State": "SD",
    "City": "Cavour"
  },
  {
    "State": "SD",
    "City": "Chamberlain"
  },
  {
    "State": "SD",
    "City": "Corsica"
  },
  {
    "State": "SD",
    "City": "Dante"
  },
  {
    "State": "SD",
    "City": "Delmont"
  },
  {
    "State": "SD",
    "City": "Dimock"
  },
  {
    "State": "SD",
    "City": "Emery"
  },
  {
    "State": "SD",
    "City": "Ethan"
  },
  {
    "State": "SD",
    "City": "Fairfax"
  },
  {
    "State": "SD",
    "City": "Fedora"
  },
  {
    "State": "SD",
    "City": "Fort Thompson"
  },
  {
    "State": "SD",
    "City": "Fulton"
  },
  {
    "State": "SD",
    "City": "Gann Valley"
  },
  {
    "State": "SD",
    "City": "Geddes"
  },
  {
    "State": "SD",
    "City": "Harrison"
  },
  {
    "State": "SD",
    "City": "Highmore"
  },
  {
    "State": "SD",
    "City": "Stephan"
  },
  {
    "State": "SD",
    "City": "Hitchcock"
  },
  {
    "State": "SD",
    "City": "Howard"
  },
  {
    "State": "SD",
    "City": "Huron"
  },
  {
    "State": "SD",
    "City": "Iroquois"
  },
  {
    "State": "SD",
    "City": "Kaylor"
  },
  {
    "State": "SD",
    "City": "Kimball"
  },
  {
    "State": "SD",
    "City": "Lake Andes"
  },
  {
    "State": "SD",
    "City": "Lane"
  },
  {
    "State": "SD",
    "City": "Letcher"
  },
  {
    "State": "SD",
    "City": "Marty"
  },
  {
    "State": "SD",
    "City": "Miller"
  },
  {
    "State": "SD",
    "City": "Mount Vernon"
  },
  {
    "State": "SD",
    "City": "New Holland"
  },
  {
    "State": "SD",
    "City": "Oacoma"
  },
  {
    "State": "SD",
    "City": "Parkston"
  },
  {
    "State": "SD",
    "City": "Pickstown"
  },
  {
    "State": "SD",
    "City": "Plankinton"
  },
  {
    "State": "SD",
    "City": "Platte"
  },
  {
    "State": "SD",
    "City": "Pukwana"
  },
  {
    "State": "SD",
    "City": "Ree Heights"
  },
  {
    "State": "SD",
    "City": "Saint Lawrence"
  },
  {
    "State": "SD",
    "City": "Spencer"
  },
  {
    "State": "SD",
    "City": "Stickney"
  },
  {
    "State": "SD",
    "City": "Tripp"
  },
  {
    "State": "SD",
    "City": "Virgil"
  },
  {
    "State": "SD",
    "City": "Wagner"
  },
  {
    "State": "SD",
    "City": "Wessington"
  },
  {
    "State": "SD",
    "City": "Wessington Springs"
  },
  {
    "State": "SD",
    "City": "White Lake"
  },
  {
    "State": "SD",
    "City": "Wolsey"
  },
  {
    "State": "SD",
    "City": "Woonsocket"
  },
  {
    "State": "SD",
    "City": "Yale"
  },
  {
    "State": "SD",
    "City": "Aberdeen"
  },
  {
    "State": "SD",
    "City": "Akaska"
  },
  {
    "State": "SD",
    "City": "Amherst"
  },
  {
    "State": "SD",
    "City": "Andover"
  },
  {
    "State": "SD",
    "City": "Ashton"
  },
  {
    "State": "SD",
    "City": "Barnard"
  },
  {
    "State": "SD",
    "City": "Bath"
  },
  {
    "State": "SD",
    "City": "Bowdle"
  },
  {
    "State": "SD",
    "City": "Brentford"
  },
  {
    "State": "SD",
    "City": "Britton"
  },
  {
    "State": "SD",
    "City": "Claremont"
  },
  {
    "State": "SD",
    "City": "Columbia"
  },
  {
    "State": "SD",
    "City": "Conde"
  },
  {
    "State": "SD",
    "City": "Cresbard"
  },
  {
    "State": "SD",
    "City": "Doland"
  },
  {
    "State": "SD",
    "City": "Eureka"
  },
  {
    "State": "SD",
    "City": "Faulkton"
  },
  {
    "State": "SD",
    "City": "Ferney"
  },
  {
    "State": "SD",
    "City": "Frankfort"
  },
  {
    "State": "SD",
    "City": "Frederick"
  },
  {
    "State": "SD",
    "City": "Gettysburg"
  },
  {
    "State": "SD",
    "City": "Groton"
  },
  {
    "State": "SD",
    "City": "Hecla"
  },
  {
    "State": "SD",
    "City": "Hosmer"
  },
  {
    "State": "SD",
    "City": "Houghton"
  },
  {
    "State": "SD",
    "City": "Hoven"
  },
  {
    "State": "SD",
    "City": "Ipswich"
  },
  {
    "State": "SD",
    "City": "Java"
  },
  {
    "State": "SD",
    "City": "Langford"
  },
  {
    "State": "SD",
    "City": "Lebanon"
  },
  {
    "State": "SD",
    "City": "Leola"
  },
  {
    "State": "SD",
    "City": "Long Lake"
  },
  {
    "State": "SD",
    "City": "Mansfield"
  },
  {
    "State": "SD",
    "City": "Mellette"
  },
  {
    "State": "SD",
    "City": "Northville"
  },
  {
    "State": "SD",
    "City": "Onaka"
  },
  {
    "State": "SD",
    "City": "Orient"
  },
  {
    "State": "SD",
    "City": "Pierpont"
  },
  {
    "State": "SD",
    "City": "Redfield"
  },
  {
    "State": "SD",
    "City": "Rockham"
  },
  {
    "State": "SD",
    "City": "Roscoe"
  },
  {
    "State": "SD",
    "City": "Selby"
  },
  {
    "State": "SD",
    "City": "Seneca"
  },
  {
    "State": "SD",
    "City": "Stratford"
  },
  {
    "State": "SD",
    "City": "Tolstoy"
  },
  {
    "State": "SD",
    "City": "Tulare"
  },
  {
    "State": "SD",
    "City": "Turton"
  },
  {
    "State": "SD",
    "City": "Warner"
  },
  {
    "State": "SD",
    "City": "Westport"
  },
  {
    "State": "SD",
    "City": "Pierre"
  },
  {
    "State": "SD",
    "City": "Agar"
  },
  {
    "State": "SD",
    "City": "Belvidere"
  },
  {
    "State": "SD",
    "City": "Blunt"
  },
  {
    "State": "SD",
    "City": "Burke"
  },
  {
    "State": "SD",
    "City": "Colome"
  },
  {
    "State": "SD",
    "City": "Dallas"
  },
  {
    "State": "SD",
    "City": "Draper"
  },
  {
    "State": "SD",
    "City": "Fort Pierre"
  },
  {
    "State": "SD",
    "City": "Gregory"
  },
  {
    "State": "SD",
    "City": "Hamill"
  },
  {
    "State": "SD",
    "City": "Harrold"
  },
  {
    "State": "SD",
    "City": "Hayes"
  },
  {
    "State": "SD",
    "City": "Herrick"
  },
  {
    "State": "SD",
    "City": "Holabird"
  },
  {
    "State": "SD",
    "City": "Ideal"
  },
  {
    "State": "SD",
    "City": "Kadoka"
  },
  {
    "State": "SD",
    "City": "Kennebec"
  },
  {
    "State": "SD",
    "City": "Long Valley"
  },
  {
    "State": "SD",
    "City": "Lower Brule"
  },
  {
    "State": "SD",
    "City": "Martin"
  },
  {
    "State": "SD",
    "City": "Midland"
  },
  {
    "State": "SD",
    "City": "Milesville"
  },
  {
    "State": "SD",
    "City": "Mission"
  },
  {
    "State": "SD",
    "City": "Murdo"
  },
  {
    "State": "SD",
    "City": "Norris"
  },
  {
    "State": "SD",
    "City": "Okaton"
  },
  {
    "State": "SD",
    "City": "Okreek"
  },
  {
    "State": "SD",
    "City": "Onida"
  },
  {
    "State": "SD",
    "City": "Parmelee"
  },
  {
    "State": "SD",
    "City": "Philip"
  },
  {
    "State": "SD",
    "City": "Presho"
  },
  {
    "State": "SD",
    "City": "Reliance"
  },
  {
    "State": "SD",
    "City": "Rosebud"
  },
  {
    "State": "SD",
    "City": "Saint Charles"
  },
  {
    "State": "SD",
    "City": "Saint Francis"
  },
  {
    "State": "SD",
    "City": "Tuthill"
  },
  {
    "State": "SD",
    "City": "Vivian"
  },
  {
    "State": "SD",
    "City": "Wanblee"
  },
  {
    "State": "SD",
    "City": "White River"
  },
  {
    "State": "SD",
    "City": "Winner"
  },
  {
    "State": "SD",
    "City": "Witten"
  },
  {
    "State": "SD",
    "City": "Wood"
  },
  {
    "State": "SD",
    "City": "Mobridge"
  },
  {
    "State": "SD",
    "City": "Bison"
  },
  {
    "State": "SD",
    "City": "Bullhead"
  },
  {
    "State": "SD",
    "City": "Cherry Creek"
  },
  {
    "State": "SD",
    "City": "Dupree"
  },
  {
    "State": "SD",
    "City": "Eagle Butte"
  },
  {
    "State": "SD",
    "City": "Faith"
  },
  {
    "State": "SD",
    "City": "Glencross"
  },
  {
    "State": "SD",
    "City": "Glenham"
  },
  {
    "State": "SD",
    "City": "Herreid"
  },
  {
    "State": "SD",
    "City": "Isabel"
  },
  {
    "State": "SD",
    "City": "Keldron"
  },
  {
    "State": "SD",
    "City": "Lantry"
  },
  {
    "State": "SD",
    "City": "Lemmon"
  },
  {
    "State": "SD",
    "City": "Little Eagle"
  },
  {
    "State": "SD",
    "City": "Lodgepole"
  },
  {
    "State": "SD",
    "City": "Mc Intosh"
  },
  {
    "State": "SD",
    "City": "Mc Laughlin"
  },
  {
    "State": "SD",
    "City": "Meadow"
  },
  {
    "State": "SD",
    "City": "Morristown"
  },
  {
    "State": "SD",
    "City": "Mound City"
  },
  {
    "State": "SD",
    "City": "Pollock"
  },
  {
    "State": "SD",
    "City": "Prairie City"
  },
  {
    "State": "SD",
    "City": "Ralph"
  },
  {
    "State": "SD",
    "City": "Reva"
  },
  {
    "State": "SD",
    "City": "Ridgeview"
  },
  {
    "State": "SD",
    "City": "Timber Lake"
  },
  {
    "State": "SD",
    "City": "Trail City"
  },
  {
    "State": "SD",
    "City": "Wakpala"
  },
  {
    "State": "SD",
    "City": "Walker"
  },
  {
    "State": "SD",
    "City": "Watauga"
  },
  {
    "State": "SD",
    "City": "Whitehorse"
  },
  {
    "State": "SD",
    "City": "Rapid City"
  },
  {
    "State": "SD",
    "City": "Ellsworth AFB"
  },
  {
    "State": "SD",
    "City": "Allen"
  },
  {
    "State": "SD",
    "City": "Batesland"
  },
  {
    "State": "SD",
    "City": "Belle Fourche"
  },
  {
    "State": "SD",
    "City": "Black Hawk"
  },
  {
    "State": "SD",
    "City": "Box Elder"
  },
  {
    "State": "SD",
    "City": "Buffalo"
  },
  {
    "State": "SD",
    "City": "Buffalo Gap"
  },
  {
    "State": "SD",
    "City": "Camp Crook"
  },
  {
    "State": "SD",
    "City": "Caputa"
  },
  {
    "State": "SD",
    "City": "Custer"
  },
  {
    "State": "SD",
    "City": "Deadwood"
  },
  {
    "State": "SD",
    "City": "Edgemont"
  },
  {
    "State": "SD",
    "City": "Enning"
  },
  {
    "State": "SD",
    "City": "Fairburn"
  },
  {
    "State": "SD",
    "City": "Fort Meade"
  },
  {
    "State": "SD",
    "City": "Hermosa"
  },
  {
    "State": "SD",
    "City": "Hill City"
  },
  {
    "State": "SD",
    "City": "Hot Springs"
  },
  {
    "State": "SD",
    "City": "Howes"
  },
  {
    "State": "SD",
    "City": "Interior"
  },
  {
    "State": "SD",
    "City": "Keystone"
  },
  {
    "State": "SD",
    "City": "Kyle"
  },
  {
    "State": "SD",
    "City": "Lead"
  },
  {
    "State": "SD",
    "City": "Ludlow"
  },
  {
    "State": "SD",
    "City": "Manderson"
  },
  {
    "State": "SD",
    "City": "Mud Butte"
  },
  {
    "State": "SD",
    "City": "Nemo"
  },
  {
    "State": "SD",
    "City": "Newell"
  },
  {
    "State": "SD",
    "City": "New Underwood"
  },
  {
    "State": "SD",
    "City": "Nisland"
  },
  {
    "State": "SD",
    "City": "Oelrichs"
  },
  {
    "State": "SD",
    "City": "Oglala"
  },
  {
    "State": "SD",
    "City": "Oral"
  },
  {
    "State": "SD",
    "City": "Owanka"
  },
  {
    "State": "SD",
    "City": "Piedmont"
  },
  {
    "State": "SD",
    "City": "Pine Ridge"
  },
  {
    "State": "SD",
    "City": "Porcupine"
  },
  {
    "State": "SD",
    "City": "Pringle"
  },
  {
    "State": "SD",
    "City": "Quinn"
  },
  {
    "State": "SD",
    "City": "Redig"
  },
  {
    "State": "SD",
    "City": "Saint Onge"
  },
  {
    "State": "SD",
    "City": "Scenic"
  },
  {
    "State": "SD",
    "City": "Smithwick"
  },
  {
    "State": "SD",
    "City": "Spearfish"
  },
  {
    "State": "SD",
    "City": "Sturgis"
  },
  {
    "State": "SD",
    "City": "Union Center"
  },
  {
    "State": "SD",
    "City": "Vale"
  },
  {
    "State": "SD",
    "City": "Wall"
  },
  {
    "State": "SD",
    "City": "Wasta"
  },
  {
    "State": "SD",
    "City": "White Owl"
  },
  {
    "State": "SD",
    "City": "Whitewood"
  },
  {
    "State": "SD",
    "City": "Wounded Knee"
  },
  {
    "State": "ND",
    "City": "Abercrombie"
  },
  {
    "State": "ND",
    "City": "Absaraka"
  },
  {
    "State": "ND",
    "City": "Amenia"
  },
  {
    "State": "ND",
    "City": "Argusville"
  },
  {
    "State": "ND",
    "City": "Arthur"
  },
  {
    "State": "ND",
    "City": "Ayr"
  },
  {
    "State": "ND",
    "City": "Barney"
  },
  {
    "State": "ND",
    "City": "Blanchard"
  },
  {
    "State": "ND",
    "City": "Buffalo"
  },
  {
    "State": "ND",
    "City": "Casselton"
  },
  {
    "State": "ND",
    "City": "Cayuga"
  },
  {
    "State": "ND",
    "City": "Christine"
  },
  {
    "State": "ND",
    "City": "Clifford"
  },
  {
    "State": "ND",
    "City": "Cogswell"
  },
  {
    "State": "ND",
    "City": "Colfax"
  },
  {
    "State": "ND",
    "City": "Davenport"
  },
  {
    "State": "ND",
    "City": "Enderlin"
  },
  {
    "State": "ND",
    "City": "Erie"
  },
  {
    "State": "ND",
    "City": "Fairmount"
  },
  {
    "State": "ND",
    "City": "Fingal"
  },
  {
    "State": "ND",
    "City": "Forman"
  },
  {
    "State": "ND",
    "City": "Fort Ransom"
  },
  {
    "State": "ND",
    "City": "Galesburg"
  },
  {
    "State": "ND",
    "City": "Gardner"
  },
  {
    "State": "ND",
    "City": "Grandin"
  },
  {
    "State": "ND",
    "City": "Gwinner"
  },
  {
    "State": "ND",
    "City": "Hankinson"
  },
  {
    "State": "ND",
    "City": "Harwood"
  },
  {
    "State": "ND",
    "City": "Havana"
  },
  {
    "State": "ND",
    "City": "Hillsboro"
  },
  {
    "State": "ND",
    "City": "Hope"
  },
  {
    "State": "ND",
    "City": "Horace"
  },
  {
    "State": "ND",
    "City": "Hunter"
  },
  {
    "State": "ND",
    "City": "Kathryn"
  },
  {
    "State": "ND",
    "City": "Kindred"
  },
  {
    "State": "ND",
    "City": "Leonard"
  },
  {
    "State": "ND",
    "City": "Lidgerwood"
  },
  {
    "State": "ND",
    "City": "Lisbon"
  },
  {
    "State": "ND",
    "City": "Luverne"
  },
  {
    "State": "ND",
    "City": "Mcleod"
  },
  {
    "State": "ND",
    "City": "Mantador"
  },
  {
    "State": "ND",
    "City": "Mapleton"
  },
  {
    "State": "ND",
    "City": "Milnor"
  },
  {
    "State": "ND",
    "City": "Mooreton"
  },
  {
    "State": "ND",
    "City": "Nome"
  },
  {
    "State": "ND",
    "City": "Oriska"
  },
  {
    "State": "ND",
    "City": "Page"
  },
  {
    "State": "ND",
    "City": "Pillsbury"
  },
  {
    "State": "ND",
    "City": "Rutland"
  },
  {
    "State": "ND",
    "City": "Sheldon"
  },
  {
    "State": "ND",
    "City": "Stirum"
  },
  {
    "State": "ND",
    "City": "Tower City"
  },
  {
    "State": "ND",
    "City": "Valley City"
  },
  {
    "State": "ND",
    "City": "Wahpeton"
  },
  {
    "State": "ND",
    "City": "Walcott"
  },
  {
    "State": "ND",
    "City": "West Fargo"
  },
  {
    "State": "ND",
    "City": "Wheatland"
  },
  {
    "State": "ND",
    "City": "Wyndmere"
  },
  {
    "State": "ND",
    "City": "Fargo"
  },
  {
    "State": "ND",
    "City": "Grand Forks"
  },
  {
    "State": "ND",
    "City": "Grand Forks AFB"
  },
  {
    "State": "ND",
    "City": "Adams"
  },
  {
    "State": "ND",
    "City": "Aneta"
  },
  {
    "State": "ND",
    "City": "Arvilla"
  },
  {
    "State": "ND",
    "City": "Bathgate"
  },
  {
    "State": "ND",
    "City": "Buxton"
  },
  {
    "State": "ND",
    "City": "Caledonia"
  },
  {
    "State": "ND",
    "City": "Cavalier"
  },
  {
    "State": "ND",
    "City": "Crystal"
  },
  {
    "State": "ND",
    "City": "Cummings"
  },
  {
    "State": "ND",
    "City": "Dahlen"
  },
  {
    "State": "ND",
    "City": "Drayton"
  },
  {
    "State": "ND",
    "City": "Edinburg"
  },
  {
    "State": "ND",
    "City": "Emerado"
  },
  {
    "State": "ND",
    "City": "Fairdale"
  },
  {
    "State": "ND",
    "City": "Finley"
  },
  {
    "State": "ND",
    "City": "Fordville"
  },
  {
    "State": "ND",
    "City": "Forest River"
  },
  {
    "State": "ND",
    "City": "Gilby"
  },
  {
    "State": "ND",
    "City": "Glasston"
  },
  {
    "State": "ND",
    "City": "Grafton"
  },
  {
    "State": "ND",
    "City": "Hamilton"
  },
  {
    "State": "ND",
    "City": "Hannah"
  },
  {
    "State": "ND",
    "City": "Hatton"
  },
  {
    "State": "ND",
    "City": "Hensel"
  },
  {
    "State": "ND",
    "City": "Hoople"
  },
  {
    "State": "ND",
    "City": "Inkster"
  },
  {
    "State": "ND",
    "City": "Langdon"
  },
  {
    "State": "ND",
    "City": "Lankin"
  },
  {
    "State": "ND",
    "City": "Larimore"
  },
  {
    "State": "ND",
    "City": "Mcville"
  },
  {
    "State": "ND",
    "City": "Maida"
  },
  {
    "State": "ND",
    "City": "Manvel"
  },
  {
    "State": "ND",
    "City": "Mayville"
  },
  {
    "State": "ND",
    "City": "Mekinock"
  },
  {
    "State": "ND",
    "City": "Michigan"
  },
  {
    "State": "ND",
    "City": "Milton"
  },
  {
    "State": "ND",
    "City": "Minto"
  },
  {
    "State": "ND",
    "City": "Mountain"
  },
  {
    "State": "ND",
    "City": "Neche"
  },
  {
    "State": "ND",
    "City": "Niagara"
  },
  {
    "State": "ND",
    "City": "Northwood"
  },
  {
    "State": "ND",
    "City": "Osnabrock"
  },
  {
    "State": "ND",
    "City": "Park River"
  },
  {
    "State": "ND",
    "City": "Pembina"
  },
  {
    "State": "ND",
    "City": "Petersburg"
  },
  {
    "State": "ND",
    "City": "Pisek"
  },
  {
    "State": "ND",
    "City": "Portland"
  },
  {
    "State": "ND",
    "City": "Reynolds"
  },
  {
    "State": "ND",
    "City": "Saint Thomas"
  },
  {
    "State": "ND",
    "City": "Sharon"
  },
  {
    "State": "ND",
    "City": "Thompson"
  },
  {
    "State": "ND",
    "City": "Wales"
  },
  {
    "State": "ND",
    "City": "Walhalla"
  },
  {
    "State": "ND",
    "City": "Devils Lake"
  },
  {
    "State": "ND",
    "City": "Agate"
  },
  {
    "State": "ND",
    "City": "Alsen"
  },
  {
    "State": "ND",
    "City": "Balta"
  },
  {
    "State": "ND",
    "City": "Belcourt"
  },
  {
    "State": "ND",
    "City": "Bisbee"
  },
  {
    "State": "ND",
    "City": "Bottineau"
  },
  {
    "State": "ND",
    "City": "Bremen"
  },
  {
    "State": "ND",
    "City": "Brocket"
  },
  {
    "State": "ND",
    "City": "Calvin"
  },
  {
    "State": "ND",
    "City": "Cando"
  },
  {
    "State": "ND",
    "City": "Churchs Ferry"
  },
  {
    "State": "ND",
    "City": "Crary"
  },
  {
    "State": "ND",
    "City": "Dunseith"
  },
  {
    "State": "ND",
    "City": "Edmore"
  },
  {
    "State": "ND",
    "City": "Egeland"
  },
  {
    "State": "ND",
    "City": "Esmond"
  },
  {
    "State": "ND",
    "City": "Fort Totten"
  },
  {
    "State": "ND",
    "City": "Hampden"
  },
  {
    "State": "ND",
    "City": "Hansboro"
  },
  {
    "State": "ND",
    "City": "Harvey"
  },
  {
    "State": "ND",
    "City": "Knox"
  },
  {
    "State": "ND",
    "City": "Lakota"
  },
  {
    "State": "ND",
    "City": "Lawton"
  },
  {
    "State": "ND",
    "City": "Leeds"
  },
  {
    "State": "ND",
    "City": "Maddock"
  },
  {
    "State": "ND",
    "City": "Minnewaukan"
  },
  {
    "State": "ND",
    "City": "Munich"
  },
  {
    "State": "ND",
    "City": "Mylo"
  },
  {
    "State": "ND",
    "City": "Nekoma"
  },
  {
    "State": "ND",
    "City": "New Rockford"
  },
  {
    "State": "ND",
    "City": "Oberon"
  },
  {
    "State": "ND",
    "City": "Pekin"
  },
  {
    "State": "ND",
    "City": "Penn"
  },
  {
    "State": "ND",
    "City": "Perth"
  },
  {
    "State": "ND",
    "City": "Rocklake"
  },
  {
    "State": "ND",
    "City": "Rolette"
  },
  {
    "State": "ND",
    "City": "Rolla"
  },
  {
    "State": "ND",
    "City": "Rugby"
  },
  {
    "State": "ND",
    "City": "Saint John"
  },
  {
    "State": "ND",
    "City": "Saint Michael"
  },
  {
    "State": "ND",
    "City": "Sarles"
  },
  {
    "State": "ND",
    "City": "Sheyenne"
  },
  {
    "State": "ND",
    "City": "Starkweather"
  },
  {
    "State": "ND",
    "City": "Tokio"
  },
  {
    "State": "ND",
    "City": "Tolna"
  },
  {
    "State": "ND",
    "City": "Warwick"
  },
  {
    "State": "ND",
    "City": "Webster"
  },
  {
    "State": "ND",
    "City": "Willow City"
  },
  {
    "State": "ND",
    "City": "Wolford"
  },
  {
    "State": "ND",
    "City": "York"
  },
  {
    "State": "ND",
    "City": "Jamestown"
  },
  {
    "State": "ND",
    "City": "Ashley"
  },
  {
    "State": "ND",
    "City": "Berlin"
  },
  {
    "State": "ND",
    "City": "Binford"
  },
  {
    "State": "ND",
    "City": "Bowdon"
  },
  {
    "State": "ND",
    "City": "Buchanan"
  },
  {
    "State": "ND",
    "City": "Carrington"
  },
  {
    "State": "ND",
    "City": "Cathay"
  },
  {
    "State": "ND",
    "City": "Chaseley"
  },
  {
    "State": "ND",
    "City": "Cleveland"
  },
  {
    "State": "ND",
    "City": "Cooperstown"
  },
  {
    "State": "ND",
    "City": "Courtenay"
  },
  {
    "State": "ND",
    "City": "Dawson"
  },
  {
    "State": "ND",
    "City": "Dazey"
  },
  {
    "State": "ND",
    "City": "Denhoff"
  },
  {
    "State": "ND",
    "City": "Dickey"
  },
  {
    "State": "ND",
    "City": "Edgeley"
  },
  {
    "State": "ND",
    "City": "Ellendale"
  },
  {
    "State": "ND",
    "City": "Fessenden"
  },
  {
    "State": "ND",
    "City": "Forbes"
  },
  {
    "State": "ND",
    "City": "Fredonia"
  },
  {
    "State": "ND",
    "City": "Fullerton"
  },
  {
    "State": "ND",
    "City": "Gackle"
  },
  {
    "State": "ND",
    "City": "Glenfield"
  },
  {
    "State": "ND",
    "City": "Goodrich"
  },
  {
    "State": "ND",
    "City": "Grace City"
  },
  {
    "State": "ND",
    "City": "Hannaford"
  },
  {
    "State": "ND",
    "City": "Hurdsfield"
  },
  {
    "State": "ND",
    "City": "Jessie"
  },
  {
    "State": "ND",
    "City": "Jud"
  },
  {
    "State": "ND",
    "City": "Kensal"
  },
  {
    "State": "ND",
    "City": "Kulm"
  },
  {
    "State": "ND",
    "City": "Lamoure"
  },
  {
    "State": "ND",
    "City": "Lehr"
  },
  {
    "State": "ND",
    "City": "Litchville"
  },
  {
    "State": "ND",
    "City": "Mcclusky"
  },
  {
    "State": "ND",
    "City": "Mchenry"
  },
  {
    "State": "ND",
    "City": "Marion"
  },
  {
    "State": "ND",
    "City": "Medina"
  },
  {
    "State": "ND",
    "City": "Montpelier"
  },
  {
    "State": "ND",
    "City": "Oakes"
  },
  {
    "State": "ND",
    "City": "Pettibone"
  },
  {
    "State": "ND",
    "City": "Pingree"
  },
  {
    "State": "ND",
    "City": "Regan"
  },
  {
    "State": "ND",
    "City": "Robinson"
  },
  {
    "State": "ND",
    "City": "Rogers"
  },
  {
    "State": "ND",
    "City": "Sanborn"
  },
  {
    "State": "ND",
    "City": "Spiritwood"
  },
  {
    "State": "ND",
    "City": "Steele"
  },
  {
    "State": "ND",
    "City": "Streeter"
  },
  {
    "State": "ND",
    "City": "Sutton"
  },
  {
    "State": "ND",
    "City": "Sykeston"
  },
  {
    "State": "ND",
    "City": "Tappen"
  },
  {
    "State": "ND",
    "City": "Tuttle"
  },
  {
    "State": "ND",
    "City": "Verona"
  },
  {
    "State": "ND",
    "City": "Wimbledon"
  },
  {
    "State": "ND",
    "City": "Wing"
  },
  {
    "State": "ND",
    "City": "Wishek"
  },
  {
    "State": "ND",
    "City": "Woodworth"
  },
  {
    "State": "ND",
    "City": "Ypsilanti"
  },
  {
    "State": "ND",
    "City": "Bismarck"
  },
  {
    "State": "ND",
    "City": "Almont"
  },
  {
    "State": "ND",
    "City": "Baldwin"
  },
  {
    "State": "ND",
    "City": "Beulah"
  },
  {
    "State": "ND",
    "City": "Braddock"
  },
  {
    "State": "ND",
    "City": "Cannon Ball"
  },
  {
    "State": "ND",
    "City": "Carson"
  },
  {
    "State": "ND",
    "City": "Center"
  },
  {
    "State": "ND",
    "City": "Coleharbor"
  },
  {
    "State": "ND",
    "City": "Driscoll"
  },
  {
    "State": "ND",
    "City": "Elgin"
  },
  {
    "State": "ND",
    "City": "Flasher"
  },
  {
    "State": "ND",
    "City": "Fort Yates"
  },
  {
    "State": "ND",
    "City": "Garrison"
  },
  {
    "State": "ND",
    "City": "Golden Valley"
  },
  {
    "State": "ND",
    "City": "Hague"
  },
  {
    "State": "ND",
    "City": "Hazelton"
  },
  {
    "State": "ND",
    "City": "Hazen"
  },
  {
    "State": "ND",
    "City": "Kintyre"
  },
  {
    "State": "ND",
    "City": "Linton"
  },
  {
    "State": "ND",
    "City": "Mandan"
  },
  {
    "State": "ND",
    "City": "Menoken"
  },
  {
    "State": "ND",
    "City": "Mercer"
  },
  {
    "State": "ND",
    "City": "Moffit"
  },
  {
    "State": "ND",
    "City": "Napoleon"
  },
  {
    "State": "ND",
    "City": "New Leipzig"
  },
  {
    "State": "ND",
    "City": "New Salem"
  },
  {
    "State": "ND",
    "City": "Raleigh"
  },
  {
    "State": "ND",
    "City": "Riverdale"
  },
  {
    "State": "ND",
    "City": "Saint Anthony"
  },
  {
    "State": "ND",
    "City": "Selfridge"
  },
  {
    "State": "ND",
    "City": "Shields"
  },
  {
    "State": "ND",
    "City": "Solen"
  },
  {
    "State": "ND",
    "City": "Stanton"
  },
  {
    "State": "ND",
    "City": "Sterling"
  },
  {
    "State": "ND",
    "City": "Strasburg"
  },
  {
    "State": "ND",
    "City": "Turtle Lake"
  },
  {
    "State": "ND",
    "City": "Underwood"
  },
  {
    "State": "ND",
    "City": "Washburn"
  },
  {
    "State": "ND",
    "City": "Wilton"
  },
  {
    "State": "ND",
    "City": "Zap"
  },
  {
    "State": "ND",
    "City": "Zeeland"
  },
  {
    "State": "ND",
    "City": "Dickinson"
  },
  {
    "State": "ND",
    "City": "Amidon"
  },
  {
    "State": "ND",
    "City": "Beach"
  },
  {
    "State": "ND",
    "City": "Belfield"
  },
  {
    "State": "ND",
    "City": "Bowman"
  },
  {
    "State": "ND",
    "City": "Dodge"
  },
  {
    "State": "ND",
    "City": "Dunn Center"
  },
  {
    "State": "ND",
    "City": "Fairfield"
  },
  {
    "State": "ND",
    "City": "Gladstone"
  },
  {
    "State": "ND",
    "City": "Glen Ullin"
  },
  {
    "State": "ND",
    "City": "Golva"
  },
  {
    "State": "ND",
    "City": "Grassy Butte"
  },
  {
    "State": "ND",
    "City": "Halliday"
  },
  {
    "State": "ND",
    "City": "Hebron"
  },
  {
    "State": "ND",
    "City": "Hettinger"
  },
  {
    "State": "ND",
    "City": "Killdeer"
  },
  {
    "State": "ND",
    "City": "Lefor"
  },
  {
    "State": "ND",
    "City": "Manning"
  },
  {
    "State": "ND",
    "City": "Marmarth"
  },
  {
    "State": "ND",
    "City": "Marshall"
  },
  {
    "State": "ND",
    "City": "Medora"
  },
  {
    "State": "ND",
    "City": "Mott"
  },
  {
    "State": "ND",
    "City": "New England"
  },
  {
    "State": "ND",
    "City": "Reeder"
  },
  {
    "State": "ND",
    "City": "Regent"
  },
  {
    "State": "ND",
    "City": "Rhame"
  },
  {
    "State": "ND",
    "City": "Richardton"
  },
  {
    "State": "ND",
    "City": "Scranton"
  },
  {
    "State": "ND",
    "City": "Sentinel Butte"
  },
  {
    "State": "ND",
    "City": "South Heart"
  },
  {
    "State": "ND",
    "City": "Taylor"
  },
  {
    "State": "ND",
    "City": "Minot"
  },
  {
    "State": "ND",
    "City": "Minot AFB"
  },
  {
    "State": "ND",
    "City": "Anamoose"
  },
  {
    "State": "ND",
    "City": "Antler"
  },
  {
    "State": "ND",
    "City": "Balfour"
  },
  {
    "State": "ND",
    "City": "Bantry"
  },
  {
    "State": "ND",
    "City": "Benedict"
  },
  {
    "State": "ND",
    "City": "Berthold"
  },
  {
    "State": "ND",
    "City": "Bowbells"
  },
  {
    "State": "ND",
    "City": "Burlington"
  },
  {
    "State": "ND",
    "City": "Butte"
  },
  {
    "State": "ND",
    "City": "Carpio"
  },
  {
    "State": "ND",
    "City": "Columbus"
  },
  {
    "State": "ND",
    "City": "Crosby"
  },
  {
    "State": "ND",
    "City": "Deering"
  },
  {
    "State": "ND",
    "City": "Des Lacs"
  },
  {
    "State": "ND",
    "City": "Donnybrook"
  },
  {
    "State": "ND",
    "City": "Douglas"
  },
  {
    "State": "ND",
    "City": "Drake"
  },
  {
    "State": "ND",
    "City": "Flaxton"
  },
  {
    "State": "ND",
    "City": "Glenburn"
  },
  {
    "State": "ND",
    "City": "Granville"
  },
  {
    "State": "ND",
    "City": "Karlsruhe"
  },
  {
    "State": "ND",
    "City": "Kenmare"
  },
  {
    "State": "ND",
    "City": "Kramer"
  },
  {
    "State": "ND",
    "City": "Lansford"
  },
  {
    "State": "ND",
    "City": "Lignite"
  },
  {
    "State": "ND",
    "City": "Mcgregor"
  },
  {
    "State": "ND",
    "City": "Makoti"
  },
  {
    "State": "ND",
    "City": "Mandaree"
  },
  {
    "State": "ND",
    "City": "Martin"
  },
  {
    "State": "ND",
    "City": "Max"
  },
  {
    "State": "ND",
    "City": "Maxbass"
  },
  {
    "State": "ND",
    "City": "Mohall"
  },
  {
    "State": "ND",
    "City": "Newburg"
  },
  {
    "State": "ND",
    "City": "New Town"
  },
  {
    "State": "ND",
    "City": "Noonan"
  },
  {
    "State": "ND",
    "City": "Norwich"
  },
  {
    "State": "ND",
    "City": "Palermo"
  },
  {
    "State": "ND",
    "City": "Parshall"
  },
  {
    "State": "ND",
    "City": "Plaza"
  },
  {
    "State": "ND",
    "City": "Portal"
  },
  {
    "State": "ND",
    "City": "Powers Lake"
  },
  {
    "State": "ND",
    "City": "Roseglen"
  },
  {
    "State": "ND",
    "City": "Ross"
  },
  {
    "State": "ND",
    "City": "Ruso"
  },
  {
    "State": "ND",
    "City": "Ryder"
  },
  {
    "State": "ND",
    "City": "Sawyer"
  },
  {
    "State": "ND",
    "City": "Sherwood"
  },
  {
    "State": "ND",
    "City": "Souris"
  },
  {
    "State": "ND",
    "City": "Stanley"
  },
  {
    "State": "ND",
    "City": "Surrey"
  },
  {
    "State": "ND",
    "City": "Tolley"
  },
  {
    "State": "ND",
    "City": "Towner"
  },
  {
    "State": "ND",
    "City": "Upham"
  },
  {
    "State": "ND",
    "City": "Velva"
  },
  {
    "State": "ND",
    "City": "Voltaire"
  },
  {
    "State": "ND",
    "City": "Westhope"
  },
  {
    "State": "ND",
    "City": "White Earth"
  },
  {
    "State": "ND",
    "City": "Wildrose"
  },
  {
    "State": "ND",
    "City": "Williston"
  },
  {
    "State": "ND",
    "City": "Alamo"
  },
  {
    "State": "ND",
    "City": "Alexander"
  },
  {
    "State": "ND",
    "City": "Ambrose"
  },
  {
    "State": "ND",
    "City": "Arnegard"
  },
  {
    "State": "ND",
    "City": "Cartwright"
  },
  {
    "State": "ND",
    "City": "Epping"
  },
  {
    "State": "ND",
    "City": "Fortuna"
  },
  {
    "State": "ND",
    "City": "Grenora"
  },
  {
    "State": "ND",
    "City": "Keene"
  },
  {
    "State": "ND",
    "City": "Ray"
  },
  {
    "State": "ND",
    "City": "Tioga"
  },
  {
    "State": "ND",
    "City": "Trenton"
  },
  {
    "State": "ND",
    "City": "Watford City"
  },
  {
    "State": "ND",
    "City": "Zahl"
  },
  {
    "State": "MT",
    "City": "Absarokee"
  },
  {
    "State": "MT",
    "City": "Acton"
  },
  {
    "State": "MT",
    "City": "Ashland"
  },
  {
    "State": "MT",
    "City": "Ballantine"
  },
  {
    "State": "MT",
    "City": "Bearcreek"
  },
  {
    "State": "MT",
    "City": "Belfry"
  },
  {
    "State": "MT",
    "City": "Bighorn"
  },
  {
    "State": "MT",
    "City": "Big Timber"
  },
  {
    "State": "MT",
    "City": "Birney"
  },
  {
    "State": "MT",
    "City": "Boyd"
  },
  {
    "State": "MT",
    "City": "Bridger"
  },
  {
    "State": "MT",
    "City": "Broadview"
  },
  {
    "State": "MT",
    "City": "Busby"
  },
  {
    "State": "MT",
    "City": "Clyde Park"
  },
  {
    "State": "MT",
    "City": "Columbus"
  },
  {
    "State": "MT",
    "City": "Cooke City"
  },
  {
    "State": "MT",
    "City": "Crow Agency"
  },
  {
    "State": "MT",
    "City": "Custer"
  },
  {
    "State": "MT",
    "City": "Decker"
  },
  {
    "State": "MT",
    "City": "Edgar"
  },
  {
    "State": "MT",
    "City": "Emigrant"
  },
  {
    "State": "MT",
    "City": "Fishtail"
  },
  {
    "State": "MT",
    "City": "Fromberg"
  },
  {
    "State": "MT",
    "City": "Gardiner"
  },
  {
    "State": "MT",
    "City": "Garryowen"
  },
  {
    "State": "MT",
    "City": "Grass Range"
  },
  {
    "State": "MT",
    "City": "Greycliff"
  },
  {
    "State": "MT",
    "City": "Hardin"
  },
  {
    "State": "MT",
    "City": "Fort Smith"
  },
  {
    "State": "MT",
    "City": "Harlowton"
  },
  {
    "State": "MT",
    "City": "Huntley"
  },
  {
    "State": "MT",
    "City": "Hysham"
  },
  {
    "State": "MT",
    "City": "Ingomar"
  },
  {
    "State": "MT",
    "City": "Joliet"
  },
  {
    "State": "MT",
    "City": "Lame Deer"
  },
  {
    "State": "MT",
    "City": "Laurel"
  },
  {
    "State": "MT",
    "City": "Lavina"
  },
  {
    "State": "MT",
    "City": "Livingston"
  },
  {
    "State": "MT",
    "City": "Lodge Grass"
  },
  {
    "State": "MT",
    "City": "Mc Leod"
  },
  {
    "State": "MT",
    "City": "Martinsdale"
  },
  {
    "State": "MT",
    "City": "Melstone"
  },
  {
    "State": "MT",
    "City": "Melville"
  },
  {
    "State": "MT",
    "City": "Molt"
  },
  {
    "State": "MT",
    "City": "Mosby"
  },
  {
    "State": "MT",
    "City": "Musselshell"
  },
  {
    "State": "MT",
    "City": "Nye"
  },
  {
    "State": "MT",
    "City": "Otter"
  },
  {
    "State": "MT",
    "City": "Park City"
  },
  {
    "State": "MT",
    "City": "Pompeys Pillar"
  },
  {
    "State": "MT",
    "City": "Pray"
  },
  {
    "State": "MT",
    "City": "Pryor"
  },
  {
    "State": "MT",
    "City": "Rapelje"
  },
  {
    "State": "MT",
    "City": "Red Lodge"
  },
  {
    "State": "MT",
    "City": "Reed Point"
  },
  {
    "State": "MT",
    "City": "Roberts"
  },
  {
    "State": "MT",
    "City": "Roscoe"
  },
  {
    "State": "MT",
    "City": "Roundup"
  },
  {
    "State": "MT",
    "City": "Ryegate"
  },
  {
    "State": "MT",
    "City": "Saint Xavier"
  },
  {
    "State": "MT",
    "City": "Sanders"
  },
  {
    "State": "MT",
    "City": "Sand Springs"
  },
  {
    "State": "MT",
    "City": "Shawmut"
  },
  {
    "State": "MT",
    "City": "Shepherd"
  },
  {
    "State": "MT",
    "City": "Silver Gate"
  },
  {
    "State": "MT",
    "City": "Springdale"
  },
  {
    "State": "MT",
    "City": "Sumatra"
  },
  {
    "State": "MT",
    "City": "Teigen"
  },
  {
    "State": "MT",
    "City": "Two Dot"
  },
  {
    "State": "MT",
    "City": "Wilsall"
  },
  {
    "State": "MT",
    "City": "Winnett"
  },
  {
    "State": "MT",
    "City": "Worden"
  },
  {
    "State": "MT",
    "City": "Wyola"
  },
  {
    "State": "MT",
    "City": "Billings"
  },
  {
    "State": "MT",
    "City": "Wolf Point"
  },
  {
    "State": "MT",
    "City": "Antelope"
  },
  {
    "State": "MT",
    "City": "Bainville"
  },
  {
    "State": "MT",
    "City": "Brockton"
  },
  {
    "State": "MT",
    "City": "Brockway"
  },
  {
    "State": "MT",
    "City": "Circle"
  },
  {
    "State": "MT",
    "City": "Crane"
  },
  {
    "State": "MT",
    "City": "Culbertson"
  },
  {
    "State": "MT",
    "City": "Dagmar"
  },
  {
    "State": "MT",
    "City": "Fairview"
  },
  {
    "State": "MT",
    "City": "Flaxville"
  },
  {
    "State": "MT",
    "City": "Fort Peck"
  },
  {
    "State": "MT",
    "City": "Frazer"
  },
  {
    "State": "MT",
    "City": "Froid"
  },
  {
    "State": "MT",
    "City": "Glasgow"
  },
  {
    "State": "MT",
    "City": "Saint Marie"
  },
  {
    "State": "MT",
    "City": "Glentana"
  },
  {
    "State": "MT",
    "City": "Hinsdale"
  },
  {
    "State": "MT",
    "City": "Homestead"
  },
  {
    "State": "MT",
    "City": "Lambert"
  },
  {
    "State": "MT",
    "City": "Larslan"
  },
  {
    "State": "MT",
    "City": "Medicine Lake"
  },
  {
    "State": "MT",
    "City": "Nashua"
  },
  {
    "State": "MT",
    "City": "Opheim"
  },
  {
    "State": "MT",
    "City": "Outlook"
  },
  {
    "State": "MT",
    "City": "Peerless"
  },
  {
    "State": "MT",
    "City": "Plentywood"
  },
  {
    "State": "MT",
    "City": "Poplar"
  },
  {
    "State": "MT",
    "City": "Raymond"
  },
  {
    "State": "MT",
    "City": "Redstone"
  },
  {
    "State": "MT",
    "City": "Reserve"
  },
  {
    "State": "MT",
    "City": "Richey"
  },
  {
    "State": "MT",
    "City": "Richland"
  },
  {
    "State": "MT",
    "City": "Saco"
  },
  {
    "State": "MT",
    "City": "Savage"
  },
  {
    "State": "MT",
    "City": "Scobey"
  },
  {
    "State": "MT",
    "City": "Sidney"
  },
  {
    "State": "MT",
    "City": "Vandalia"
  },
  {
    "State": "MT",
    "City": "Vida"
  },
  {
    "State": "MT",
    "City": "Westby"
  },
  {
    "State": "MT",
    "City": "Whitetail"
  },
  {
    "State": "MT",
    "City": "Miles City"
  },
  {
    "State": "MT",
    "City": "Alzada"
  },
  {
    "State": "MT",
    "City": "Angela"
  },
  {
    "State": "MT",
    "City": "Baker"
  },
  {
    "State": "MT",
    "City": "Biddle"
  },
  {
    "State": "MT",
    "City": "Bloomfield"
  },
  {
    "State": "MT",
    "City": "Boyes"
  },
  {
    "State": "MT",
    "City": "Broadus"
  },
  {
    "State": "MT",
    "City": "Brusett"
  },
  {
    "State": "MT",
    "City": "Capitol"
  },
  {
    "State": "MT",
    "City": "Cohagen"
  },
  {
    "State": "MT",
    "City": "Colstrip"
  },
  {
    "State": "MT",
    "City": "Ekalaka"
  },
  {
    "State": "MT",
    "City": "Fallon"
  },
  {
    "State": "MT",
    "City": "Forsyth"
  },
  {
    "State": "MT",
    "City": "Glendive"
  },
  {
    "State": "MT",
    "City": "Hammond"
  },
  {
    "State": "MT",
    "City": "Hathaway"
  },
  {
    "State": "MT",
    "City": "Ismay"
  },
  {
    "State": "MT",
    "City": "Jordan"
  },
  {
    "State": "MT",
    "City": "Kinsey"
  },
  {
    "State": "MT",
    "City": "Lindsay"
  },
  {
    "State": "MT",
    "City": "Mildred"
  },
  {
    "State": "MT",
    "City": "Olive"
  },
  {
    "State": "MT",
    "City": "Plevna"
  },
  {
    "State": "MT",
    "City": "Powderville"
  },
  {
    "State": "MT",
    "City": "Rosebud"
  },
  {
    "State": "MT",
    "City": "Terry"
  },
  {
    "State": "MT",
    "City": "Volborg"
  },
  {
    "State": "MT",
    "City": "Wibaux"
  },
  {
    "State": "MT",
    "City": "Willard"
  },
  {
    "State": "MT",
    "City": "Great Falls"
  },
  {
    "State": "MT",
    "City": "Malmstrom AFB"
  },
  {
    "State": "MT",
    "City": "Augusta"
  },
  {
    "State": "MT",
    "City": "Babb"
  },
  {
    "State": "MT",
    "City": "Belt"
  },
  {
    "State": "MT",
    "City": "Black Eagle"
  },
  {
    "State": "MT",
    "City": "Brady"
  },
  {
    "State": "MT",
    "City": "Browning"
  },
  {
    "State": "MT",
    "City": "Buffalo"
  },
  {
    "State": "MT",
    "City": "Bynum"
  },
  {
    "State": "MT",
    "City": "Carter"
  },
  {
    "State": "MT",
    "City": "Cascade"
  },
  {
    "State": "MT",
    "City": "Choteau"
  },
  {
    "State": "MT",
    "City": "Coffee Creek"
  },
  {
    "State": "MT",
    "City": "Conrad"
  },
  {
    "State": "MT",
    "City": "Cut Bank"
  },
  {
    "State": "MT",
    "City": "Denton"
  },
  {
    "State": "MT",
    "City": "Dupuyer"
  },
  {
    "State": "MT",
    "City": "Dutton"
  },
  {
    "State": "MT",
    "City": "East Glacier Park"
  },
  {
    "State": "MT",
    "City": "Ethridge"
  },
  {
    "State": "MT",
    "City": "Fairfield"
  },
  {
    "State": "MT",
    "City": "Floweree"
  },
  {
    "State": "MT",
    "City": "Forest Grove"
  },
  {
    "State": "MT",
    "City": "Fort Benton"
  },
  {
    "State": "MT",
    "City": "Fort Shaw"
  },
  {
    "State": "MT",
    "City": "Galata"
  },
  {
    "State": "MT",
    "City": "Geraldine"
  },
  {
    "State": "MT",
    "City": "Geyser"
  },
  {
    "State": "MT",
    "City": "Heart Butte"
  },
  {
    "State": "MT",
    "City": "Highwood"
  },
  {
    "State": "MT",
    "City": "Hilger"
  },
  {
    "State": "MT",
    "City": "Hobson"
  },
  {
    "State": "MT",
    "City": "Judith Gap"
  },
  {
    "State": "MT",
    "City": "Kevin"
  },
  {
    "State": "MT",
    "City": "Ledger"
  },
  {
    "State": "MT",
    "City": "Lewistown"
  },
  {
    "State": "MT",
    "City": "Loma"
  },
  {
    "State": "MT",
    "City": "Lothair"
  },
  {
    "State": "MT",
    "City": "Moccasin"
  },
  {
    "State": "MT",
    "City": "Monarch"
  },
  {
    "State": "MT",
    "City": "Moore"
  },
  {
    "State": "MT",
    "City": "Neihart"
  },
  {
    "State": "MT",
    "City": "Oilmont"
  },
  {
    "State": "MT",
    "City": "Pendroy"
  },
  {
    "State": "MT",
    "City": "Power"
  },
  {
    "State": "MT",
    "City": "Raynesford"
  },
  {
    "State": "MT",
    "City": "Roy"
  },
  {
    "State": "MT",
    "City": "Sand Coulee"
  },
  {
    "State": "MT",
    "City": "Shelby"
  },
  {
    "State": "MT",
    "City": "Simms"
  },
  {
    "State": "MT",
    "City": "Stanford"
  },
  {
    "State": "MT",
    "City": "Stockett"
  },
  {
    "State": "MT",
    "City": "Sunburst"
  },
  {
    "State": "MT",
    "City": "Sun River"
  },
  {
    "State": "MT",
    "City": "Sweet Grass"
  },
  {
    "State": "MT",
    "City": "Ulm"
  },
  {
    "State": "MT",
    "City": "Valier"
  },
  {
    "State": "MT",
    "City": "Vaughn"
  },
  {
    "State": "MT",
    "City": "Winifred"
  },
  {
    "State": "MT",
    "City": "Havre"
  },
  {
    "State": "MT",
    "City": "Big Sandy"
  },
  {
    "State": "MT",
    "City": "Box Elder"
  },
  {
    "State": "MT",
    "City": "Chester"
  },
  {
    "State": "MT",
    "City": "Chinook"
  },
  {
    "State": "MT",
    "City": "Dodson"
  },
  {
    "State": "MT",
    "City": "Gildford"
  },
  {
    "State": "MT",
    "City": "Harlem"
  },
  {
    "State": "MT",
    "City": "Hays"
  },
  {
    "State": "MT",
    "City": "Hingham"
  },
  {
    "State": "MT",
    "City": "Hogeland"
  },
  {
    "State": "MT",
    "City": "Inverness"
  },
  {
    "State": "MT",
    "City": "Joplin"
  },
  {
    "State": "MT",
    "City": "Kremlin"
  },
  {
    "State": "MT",
    "City": "Lloyd"
  },
  {
    "State": "MT",
    "City": "Loring"
  },
  {
    "State": "MT",
    "City": "Malta"
  },
  {
    "State": "MT",
    "City": "Rudyard"
  },
  {
    "State": "MT",
    "City": "Turner"
  },
  {
    "State": "MT",
    "City": "Whitewater"
  },
  {
    "State": "MT",
    "City": "Whitlash"
  },
  {
    "State": "MT",
    "City": "Zortman"
  },
  {
    "State": "MT",
    "City": "Zurich"
  },
  {
    "State": "MT",
    "City": "Helena"
  },
  {
    "State": "MT",
    "City": "Basin"
  },
  {
    "State": "MT",
    "City": "Boulder"
  },
  {
    "State": "MT",
    "City": "Canyon Creek"
  },
  {
    "State": "MT",
    "City": "Clancy"
  },
  {
    "State": "MT",
    "City": "East Helena"
  },
  {
    "State": "MT",
    "City": "Fort Harrison"
  },
  {
    "State": "MT",
    "City": "Jefferson City"
  },
  {
    "State": "MT",
    "City": "Lincoln"
  },
  {
    "State": "MT",
    "City": "Marysville"
  },
  {
    "State": "MT",
    "City": "Radersburg"
  },
  {
    "State": "MT",
    "City": "Ringling"
  },
  {
    "State": "MT",
    "City": "Toston"
  },
  {
    "State": "MT",
    "City": "Townsend"
  },
  {
    "State": "MT",
    "City": "White Sulphur Springs"
  },
  {
    "State": "MT",
    "City": "Winston"
  },
  {
    "State": "MT",
    "City": "Wolf Creek"
  },
  {
    "State": "MT",
    "City": "Butte"
  },
  {
    "State": "MT",
    "City": "Alder"
  },
  {
    "State": "MT",
    "City": "Anaconda"
  },
  {
    "State": "MT",
    "City": "Avon"
  },
  {
    "State": "MT",
    "City": "Belgrade"
  },
  {
    "State": "MT",
    "City": "Bozeman"
  },
  {
    "State": "MT",
    "City": "Big Sky"
  },
  {
    "State": "MT",
    "City": "Cameron"
  },
  {
    "State": "MT",
    "City": "Cardwell"
  },
  {
    "State": "MT",
    "City": "Deer Lodge"
  },
  {
    "State": "MT",
    "City": "Dell"
  },
  {
    "State": "MT",
    "City": "Dillon"
  },
  {
    "State": "MT",
    "City": "Divide"
  },
  {
    "State": "MT",
    "City": "Elliston"
  },
  {
    "State": "MT",
    "City": "Ennis"
  },
  {
    "State": "MT",
    "City": "Gallatin Gateway"
  },
  {
    "State": "MT",
    "City": "Garrison"
  },
  {
    "State": "MT",
    "City": "Glen"
  },
  {
    "State": "MT",
    "City": "Gold Creek"
  },
  {
    "State": "MT",
    "City": "Harrison"
  },
  {
    "State": "MT",
    "City": "Jackson"
  },
  {
    "State": "MT",
    "City": "Lima"
  },
  {
    "State": "MT",
    "City": "Mc Allister"
  },
  {
    "State": "MT",
    "City": "Manhattan"
  },
  {
    "State": "MT",
    "City": "Melrose"
  },
  {
    "State": "MT",
    "City": "Norris"
  },
  {
    "State": "MT",
    "City": "Polaris"
  },
  {
    "State": "MT",
    "City": "Pony"
  },
  {
    "State": "MT",
    "City": "Ramsay"
  },
  {
    "State": "MT",
    "City": "Sheridan"
  },
  {
    "State": "MT",
    "City": "Silver Star"
  },
  {
    "State": "MT",
    "City": "Three Forks"
  },
  {
    "State": "MT",
    "City": "Twin Bridges"
  },
  {
    "State": "MT",
    "City": "Virginia City"
  },
  {
    "State": "MT",
    "City": "Warm Springs"
  },
  {
    "State": "MT",
    "City": "West Yellowstone"
  },
  {
    "State": "MT",
    "City": "Whitehall"
  },
  {
    "State": "MT",
    "City": "Willow Creek"
  },
  {
    "State": "MT",
    "City": "Wisdom"
  },
  {
    "State": "MT",
    "City": "Wise River"
  },
  {
    "State": "MT",
    "City": "Missoula"
  },
  {
    "State": "MT",
    "City": "Alberton"
  },
  {
    "State": "MT",
    "City": "Arlee"
  },
  {
    "State": "MT",
    "City": "Bonner"
  },
  {
    "State": "MT",
    "City": "Charlo"
  },
  {
    "State": "MT",
    "City": "Clinton"
  },
  {
    "State": "MT",
    "City": "Condon"
  },
  {
    "State": "MT",
    "City": "Conner"
  },
  {
    "State": "MT",
    "City": "Corvallis"
  },
  {
    "State": "MT",
    "City": "Darby"
  },
  {
    "State": "MT",
    "City": "De Borgia"
  },
  {
    "State": "MT",
    "City": "Dixon"
  },
  {
    "State": "MT",
    "City": "Drummond"
  },
  {
    "State": "MT",
    "City": "Florence"
  },
  {
    "State": "MT",
    "City": "Frenchtown"
  },
  {
    "State": "MT",
    "City": "Grantsdale"
  },
  {
    "State": "MT",
    "City": "Hall"
  },
  {
    "State": "MT",
    "City": "Hamilton"
  },
  {
    "State": "MT",
    "City": "Pinesdale"
  },
  {
    "State": "MT",
    "City": "Haugan"
  },
  {
    "State": "MT",
    "City": "Helmville"
  },
  {
    "State": "MT",
    "City": "Heron"
  },
  {
    "State": "MT",
    "City": "Hot Springs"
  },
  {
    "State": "MT",
    "City": "Huson"
  },
  {
    "State": "MT",
    "City": "Lolo"
  },
  {
    "State": "MT",
    "City": "Lonepine"
  },
  {
    "State": "MT",
    "City": "Milltown"
  },
  {
    "State": "MT",
    "City": "Noxon"
  },
  {
    "State": "MT",
    "City": "Ovando"
  },
  {
    "State": "MT",
    "City": "Pablo"
  },
  {
    "State": "MT",
    "City": "Paradise"
  },
  {
    "State": "MT",
    "City": "Philipsburg"
  },
  {
    "State": "MT",
    "City": "Plains"
  },
  {
    "State": "MT",
    "City": "Polson"
  },
  {
    "State": "MT",
    "City": "Ravalli"
  },
  {
    "State": "MT",
    "City": "Ronan"
  },
  {
    "State": "MT",
    "City": "Saint Ignatius"
  },
  {
    "State": "MT",
    "City": "Saint Regis"
  },
  {
    "State": "MT",
    "City": "Saltese"
  },
  {
    "State": "MT",
    "City": "Seeley Lake"
  },
  {
    "State": "MT",
    "City": "Stevensville"
  },
  {
    "State": "MT",
    "City": "Sula"
  },
  {
    "State": "MT",
    "City": "Superior"
  },
  {
    "State": "MT",
    "City": "Thompson Falls"
  },
  {
    "State": "MT",
    "City": "Trout Creek"
  },
  {
    "State": "MT",
    "City": "Victor"
  },
  {
    "State": "MT",
    "City": "Kalispell"
  },
  {
    "State": "MT",
    "City": "Big Arm"
  },
  {
    "State": "MT",
    "City": "Bigfork"
  },
  {
    "State": "MT",
    "City": "Columbia Falls"
  },
  {
    "State": "MT",
    "City": "Coram"
  },
  {
    "State": "MT",
    "City": "Dayton"
  },
  {
    "State": "MT",
    "City": "Elmo"
  },
  {
    "State": "MT",
    "City": "Essex"
  },
  {
    "State": "MT",
    "City": "Eureka"
  },
  {
    "State": "MT",
    "City": "Fortine"
  },
  {
    "State": "MT",
    "City": "Hungry Horse"
  },
  {
    "State": "MT",
    "City": "Kila"
  },
  {
    "State": "MT",
    "City": "Lake Mc Donald"
  },
  {
    "State": "MT",
    "City": "Lakeside"
  },
  {
    "State": "MT",
    "City": "Libby"
  },
  {
    "State": "MT",
    "City": "Marion"
  },
  {
    "State": "MT",
    "City": "Martin City"
  },
  {
    "State": "MT",
    "City": "Olney"
  },
  {
    "State": "MT",
    "City": "Polebridge"
  },
  {
    "State": "MT",
    "City": "Proctor"
  },
  {
    "State": "MT",
    "City": "Rexford"
  },
  {
    "State": "MT",
    "City": "Rollins"
  },
  {
    "State": "MT",
    "City": "Somers"
  },
  {
    "State": "MT",
    "City": "Stryker"
  },
  {
    "State": "MT",
    "City": "Trego"
  },
  {
    "State": "MT",
    "City": "Troy"
  },
  {
    "State": "MT",
    "City": "West Glacier"
  },
  {
    "State": "MT",
    "City": "Whitefish"
  },
  {
    "State": "IL",
    "City": "Alden"
  },
  {
    "State": "IL",
    "City": "Antioch"
  },
  {
    "State": "IL",
    "City": "Arlington Heights"
  },
  {
    "State": "IL",
    "City": "Elk Grove Village"
  },
  {
    "State": "IL",
    "City": "Rolling Meadows"
  },
  {
    "State": "IL",
    "City": "Barrington"
  },
  {
    "State": "IL",
    "City": "Crystal Lake"
  },
  {
    "State": "IL",
    "City": "Cary"
  },
  {
    "State": "IL",
    "City": "Deerfield"
  },
  {
    "State": "IL",
    "City": "Des Plaines"
  },
  {
    "State": "IL",
    "City": "Fox Lake"
  },
  {
    "State": "IL",
    "City": "Fox River Grove"
  },
  {
    "State": "IL",
    "City": "Glencoe"
  },
  {
    "State": "IL",
    "City": "Glenview"
  },
  {
    "State": "IL",
    "City": "Golf"
  },
  {
    "State": "IL",
    "City": "Grayslake"
  },
  {
    "State": "IL",
    "City": "Gurnee"
  },
  {
    "State": "IL",
    "City": "Harvard"
  },
  {
    "State": "IL",
    "City": "Hebron"
  },
  {
    "State": "IL",
    "City": "Highland Park"
  },
  {
    "State": "IL",
    "City": "Fort Sheridan"
  },
  {
    "State": "IL",
    "City": "Palatine"
  },
  {
    "State": "IL",
    "City": "Highwood"
  },
  {
    "State": "IL",
    "City": "Ingleside"
  },
  {
    "State": "IL",
    "City": "Island Lake"
  },
  {
    "State": "IL",
    "City": "Kenilworth"
  },
  {
    "State": "IL",
    "City": "Lake Bluff"
  },
  {
    "State": "IL",
    "City": "Lake Forest"
  },
  {
    "State": "IL",
    "City": "Lake Villa"
  },
  {
    "State": "IL",
    "City": "Lake Zurich"
  },
  {
    "State": "IL",
    "City": "Libertyville"
  },
  {
    "State": "IL",
    "City": "Mchenry"
  },
  {
    "State": "IL",
    "City": "Morton Grove"
  },
  {
    "State": "IL",
    "City": "Mount Prospect"
  },
  {
    "State": "IL",
    "City": "Mundelein"
  },
  {
    "State": "IL",
    "City": "Vernon Hills"
  },
  {
    "State": "IL",
    "City": "Northbrook"
  },
  {
    "State": "IL",
    "City": "North Chicago"
  },
  {
    "State": "IL",
    "City": "Park Ridge"
  },
  {
    "State": "IL",
    "City": "Lincolnshire"
  },
  {
    "State": "IL",
    "City": "Prospect Heights"
  },
  {
    "State": "IL",
    "City": "Richmond"
  },
  {
    "State": "IL",
    "City": "Ringwood"
  },
  {
    "State": "IL",
    "City": "Round Lake"
  },
  {
    "State": "IL",
    "City": "Russell"
  },
  {
    "State": "IL",
    "City": "Skokie"
  },
  {
    "State": "IL",
    "City": "Waukegan"
  },
  {
    "State": "IL",
    "City": "Spring Grove"
  },
  {
    "State": "IL",
    "City": "Techny"
  },
  {
    "State": "IL",
    "City": "Wadsworth"
  },
  {
    "State": "IL",
    "City": "Wauconda"
  },
  {
    "State": "IL",
    "City": "Great Lakes"
  },
  {
    "State": "IL",
    "City": "Buffalo Grove"
  },
  {
    "State": "IL",
    "City": "Wheeling"
  },
  {
    "State": "IL",
    "City": "Wilmette"
  },
  {
    "State": "IL",
    "City": "Winnetka"
  },
  {
    "State": "IL",
    "City": "Winthrop Harbor"
  },
  {
    "State": "IL",
    "City": "Wonder Lake"
  },
  {
    "State": "IL",
    "City": "Woodstock"
  },
  {
    "State": "IL",
    "City": "Zion"
  },
  {
    "State": "IL",
    "City": "Addison"
  },
  {
    "State": "IL",
    "City": "Algonquin"
  },
  {
    "State": "IL",
    "City": "Bartlett"
  },
  {
    "State": "IL",
    "City": "Bellwood"
  },
  {
    "State": "IL",
    "City": "Bensenville"
  },
  {
    "State": "IL",
    "City": "Streamwood"
  },
  {
    "State": "IL",
    "City": "Bloomingdale"
  },
  {
    "State": "IL",
    "City": "Burlington"
  },
  {
    "State": "IL",
    "City": "Carpentersville"
  },
  {
    "State": "IL",
    "City": "Clare"
  },
  {
    "State": "IL",
    "City": "Cortland"
  },
  {
    "State": "IL",
    "City": "Creston"
  },
  {
    "State": "IL",
    "City": "Dekalb"
  },
  {
    "State": "IL",
    "City": "Carol Stream"
  },
  {
    "State": "IL",
    "City": "Dundee"
  },
  {
    "State": "IL",
    "City": "Elburn"
  },
  {
    "State": "IL",
    "City": "Elgin"
  },
  {
    "State": "IL",
    "City": "Elmhurst"
  },
  {
    "State": "IL",
    "City": "Esmond"
  },
  {
    "State": "IL",
    "City": "Forest Park"
  },
  {
    "State": "IL",
    "City": "Franklin Park"
  },
  {
    "State": "IL",
    "City": "Hanover Park"
  },
  {
    "State": "IL",
    "City": "Geneva"
  },
  {
    "State": "IL",
    "City": "Genoa"
  },
  {
    "State": "IL",
    "City": "Gilberts"
  },
  {
    "State": "IL",
    "City": "Glen Ellyn"
  },
  {
    "State": "IL",
    "City": "Glendale Heights"
  },
  {
    "State": "IL",
    "City": "Hampshire"
  },
  {
    "State": "IL",
    "City": "Hines"
  },
  {
    "State": "IL",
    "City": "Huntley"
  },
  {
    "State": "IL",
    "City": "Itasca"
  },
  {
    "State": "IL",
    "City": "Kaneville"
  },
  {
    "State": "IL",
    "City": "Kingston"
  },
  {
    "State": "IL",
    "City": "Kirkland"
  },
  {
    "State": "IL",
    "City": "Lafox"
  },
  {
    "State": "IL",
    "City": "Lombard"
  },
  {
    "State": "IL",
    "City": "Malta"
  },
  {
    "State": "IL",
    "City": "Maple Park"
  },
  {
    "State": "IL",
    "City": "Marengo"
  },
  {
    "State": "IL",
    "City": "Maywood"
  },
  {
    "State": "IL",
    "City": "Westchester"
  },
  {
    "State": "IL",
    "City": "Broadview"
  },
  {
    "State": "IL",
    "City": "Lake In The Hills"
  },
  {
    "State": "IL",
    "City": "Medinah"
  },
  {
    "State": "IL",
    "City": "Schaumburg"
  },
  {
    "State": "IL",
    "City": "Melrose Park"
  },
  {
    "State": "IL",
    "City": "Hillside"
  },
  {
    "State": "IL",
    "City": "Berkeley"
  },
  {
    "State": "IL",
    "City": "Stone Park"
  },
  {
    "State": "IL",
    "City": "Hoffman Estates"
  },
  {
    "State": "IL",
    "City": "Plato Center"
  },
  {
    "State": "IL",
    "City": "River Grove"
  },
  {
    "State": "IL",
    "City": "Roselle"
  },
  {
    "State": "IL",
    "City": "Saint Charles"
  },
  {
    "State": "IL",
    "City": "Schiller Park"
  },
  {
    "State": "IL",
    "City": "South Elgin"
  },
  {
    "State": "IL",
    "City": "Sycamore"
  },
  {
    "State": "IL",
    "City": "Union"
  },
  {
    "State": "IL",
    "City": "Villa Park"
  },
  {
    "State": "IL",
    "City": "Wasco"
  },
  {
    "State": "IL",
    "City": "Wayne"
  },
  {
    "State": "IL",
    "City": "West Chicago"
  },
  {
    "State": "IL",
    "City": "Wheaton"
  },
  {
    "State": "IL",
    "City": "Winfield"
  },
  {
    "State": "IL",
    "City": "Wood Dale"
  },
  {
    "State": "IL",
    "City": "Evanston"
  },
  {
    "State": "IL",
    "City": "Chicago"
  },
  {
    "State": "IL",
    "City": "Oak Park"
  },
  {
    "State": "IL",
    "City": "River Forest"
  },
  {
    "State": "IL",
    "City": "Beecher"
  },
  {
    "State": "IL",
    "City": "Berwyn"
  },
  {
    "State": "IL",
    "City": "Crest Hill"
  },
  {
    "State": "IL",
    "City": "Shorewood"
  },
  {
    "State": "IL",
    "City": "Blue Island"
  },
  {
    "State": "IL",
    "City": "Braceville"
  },
  {
    "State": "IL",
    "City": "Braidwood"
  },
  {
    "State": "IL",
    "City": "Calumet City"
  },
  {
    "State": "IL",
    "City": "Channahon"
  },
  {
    "State": "IL",
    "City": "Chicago Heights"
  },
  {
    "State": "IL",
    "City": "Chicago Ridge"
  },
  {
    "State": "IL",
    "City": "Coal City"
  },
  {
    "State": "IL",
    "City": "Crete"
  },
  {
    "State": "IL",
    "City": "Crestwood"
  },
  {
    "State": "IL",
    "City": "Dolton"
  },
  {
    "State": "IL",
    "City": "Dwight"
  },
  {
    "State": "IL",
    "City": "Elwood"
  },
  {
    "State": "IL",
    "City": "Flossmoor"
  },
  {
    "State": "IL",
    "City": "Frankfort"
  },
  {
    "State": "IL",
    "City": "Gardner"
  },
  {
    "State": "IL",
    "City": "Glenwood"
  },
  {
    "State": "IL",
    "City": "Harvey"
  },
  {
    "State": "IL",
    "City": "Markham"
  },
  {
    "State": "IL",
    "City": "Hazel Crest"
  },
  {
    "State": "IL",
    "City": "Homewood"
  },
  {
    "State": "IL",
    "City": "Joliet"
  },
  {
    "State": "IL",
    "City": "Kinsman"
  },
  {
    "State": "IL",
    "City": "Lansing"
  },
  {
    "State": "IL",
    "City": "Lemont"
  },
  {
    "State": "IL",
    "City": "Bolingbrook"
  },
  {
    "State": "IL",
    "City": "Lockport"
  },
  {
    "State": "IL",
    "City": "Manhattan"
  },
  {
    "State": "IL",
    "City": "Matteson"
  },
  {
    "State": "IL",
    "City": "Mazon"
  },
  {
    "State": "IL",
    "City": "Midlothian"
  },
  {
    "State": "IL",
    "City": "Romeoville"
  },
  {
    "State": "IL",
    "City": "Minooka"
  },
  {
    "State": "IL",
    "City": "Mokena"
  },
  {
    "State": "IL",
    "City": "Monee"
  },
  {
    "State": "IL",
    "City": "Morris"
  },
  {
    "State": "IL",
    "City": "New Lenox"
  },
  {
    "State": "IL",
    "City": "Oak Forest"
  },
  {
    "State": "IL",
    "City": "Oak Lawn"
  },
  {
    "State": "IL",
    "City": "Bridgeview"
  },
  {
    "State": "IL",
    "City": "Hometown"
  },
  {
    "State": "IL",
    "City": "Hickory Hills"
  },
  {
    "State": "IL",
    "City": "Justice"
  },
  {
    "State": "IL",
    "City": "Burbank"
  },
  {
    "State": "IL",
    "City": "Odell"
  },
  {
    "State": "IL",
    "City": "Olympia Fields"
  },
  {
    "State": "IL",
    "City": "Orland Park"
  },
  {
    "State": "IL",
    "City": "Palos Heights"
  },
  {
    "State": "IL",
    "City": "Palos Park"
  },
  {
    "State": "IL",
    "City": "Palos Hills"
  },
  {
    "State": "IL",
    "City": "Park Forest"
  },
  {
    "State": "IL",
    "City": "Peotone"
  },
  {
    "State": "IL",
    "City": "Posen"
  },
  {
    "State": "IL",
    "City": "Ransom"
  },
  {
    "State": "IL",
    "City": "Richton Park"
  },
  {
    "State": "IL",
    "City": "Robbins"
  },
  {
    "State": "IL",
    "City": "South Holland"
  },
  {
    "State": "IL",
    "City": "South Wilmington"
  },
  {
    "State": "IL",
    "City": "Steger"
  },
  {
    "State": "IL",
    "City": "Thornton"
  },
  {
    "State": "IL",
    "City": "Tinley Park"
  },
  {
    "State": "IL",
    "City": "Country Club Hills"
  },
  {
    "State": "IL",
    "City": "Verona"
  },
  {
    "State": "IL",
    "City": "Willow Springs"
  },
  {
    "State": "IL",
    "City": "Wilmington"
  },
  {
    "State": "IL",
    "City": "Worth"
  },
  {
    "State": "IL",
    "City": "University Park"
  },
  {
    "State": "IL",
    "City": "Homer Glen"
  },
  {
    "State": "IL",
    "City": "Bedford Park"
  },
  {
    "State": "IL",
    "City": "Summit Argo"
  },
  {
    "State": "IL",
    "City": "Aurora"
  },
  {
    "State": "IL",
    "City": "Batavia"
  },
  {
    "State": "IL",
    "City": "Big Rock"
  },
  {
    "State": "IL",
    "City": "Bristol"
  },
  {
    "State": "IL",
    "City": "Brookfield"
  },
  {
    "State": "IL",
    "City": "Clarendon Hills"
  },
  {
    "State": "IL",
    "City": "Downers Grove"
  },
  {
    "State": "IL",
    "City": "Woodridge"
  },
  {
    "State": "IL",
    "City": "Earlville"
  },
  {
    "State": "IL",
    "City": "Eola"
  },
  {
    "State": "IL",
    "City": "Hinckley"
  },
  {
    "State": "IL",
    "City": "Hinsdale"
  },
  {
    "State": "IL",
    "City": "Oak Brook"
  },
  {
    "State": "IL",
    "City": "La Grange"
  },
  {
    "State": "IL",
    "City": "La Grange Park"
  },
  {
    "State": "IL",
    "City": "Willowbrook"
  },
  {
    "State": "IL",
    "City": "Lee"
  },
  {
    "State": "IL",
    "City": "Leland"
  },
  {
    "State": "IL",
    "City": "Lisle"
  },
  {
    "State": "IL",
    "City": "Lyons"
  },
  {
    "State": "IL",
    "City": "Millbrook"
  },
  {
    "State": "IL",
    "City": "Millington"
  },
  {
    "State": "IL",
    "City": "Montgomery"
  },
  {
    "State": "IL",
    "City": "Mooseheart"
  },
  {
    "State": "IL",
    "City": "Naperville"
  },
  {
    "State": "IL",
    "City": "Newark"
  },
  {
    "State": "IL",
    "City": "North Aurora"
  },
  {
    "State": "IL",
    "City": "Oswego"
  },
  {
    "State": "IL",
    "City": "Plainfield"
  },
  {
    "State": "IL",
    "City": "Plano"
  },
  {
    "State": "IL",
    "City": "Riverside"
  },
  {
    "State": "IL",
    "City": "Sandwich"
  },
  {
    "State": "IL",
    "City": "Serena"
  },
  {
    "State": "IL",
    "City": "Shabbona"
  },
  {
    "State": "IL",
    "City": "Sheridan"
  },
  {
    "State": "IL",
    "City": "Somonauk"
  },
  {
    "State": "IL",
    "City": "Steward"
  },
  {
    "State": "IL",
    "City": "Sugar Grove"
  },
  {
    "State": "IL",
    "City": "Warrenville"
  },
  {
    "State": "IL",
    "City": "Waterman"
  },
  {
    "State": "IL",
    "City": "Wedron"
  },
  {
    "State": "IL",
    "City": "Western Springs"
  },
  {
    "State": "IL",
    "City": "Westmont"
  },
  {
    "State": "IL",
    "City": "Yorkville"
  },
  {
    "State": "IL",
    "City": "Darien"
  },
  {
    "State": "IL",
    "City": "Fox Valley"
  },
  {
    "State": "IL",
    "City": "Harwood Heights"
  },
  {
    "State": "IL",
    "City": "Elmwood Park"
  },
  {
    "State": "IL",
    "City": "Lincolnwood"
  },
  {
    "State": "IL",
    "City": "Niles"
  },
  {
    "State": "IL",
    "City": "Alsip"
  },
  {
    "State": "IL",
    "City": "Cicero"
  },
  {
    "State": "IL",
    "City": "Evergreen Park"
  },
  {
    "State": "IL",
    "City": "Riverdale"
  },
  {
    "State": "IL",
    "City": "Kankakee"
  },
  {
    "State": "IL",
    "City": "Aroma Park"
  },
  {
    "State": "IL",
    "City": "Ashkum"
  },
  {
    "State": "IL",
    "City": "Beaverville"
  },
  {
    "State": "IL",
    "City": "Bonfield"
  },
  {
    "State": "IL",
    "City": "Bourbonnais"
  },
  {
    "State": "IL",
    "City": "Bradley"
  },
  {
    "State": "IL",
    "City": "Buckingham"
  },
  {
    "State": "IL",
    "City": "Buckley"
  },
  {
    "State": "IL",
    "City": "Cabery"
  },
  {
    "State": "IL",
    "City": "Campus"
  },
  {
    "State": "IL",
    "City": "Chatsworth"
  },
  {
    "State": "IL",
    "City": "Chebanse"
  },
  {
    "State": "IL",
    "City": "Cissna Park"
  },
  {
    "State": "IL",
    "City": "Claytonville"
  },
  {
    "State": "IL",
    "City": "Clifton"
  },
  {
    "State": "IL",
    "City": "Crescent City"
  },
  {
    "State": "IL",
    "City": "Cullom"
  },
  {
    "State": "IL",
    "City": "Danforth"
  },
  {
    "State": "IL",
    "City": "Donovan"
  },
  {
    "State": "IL",
    "City": "East Lynn"
  },
  {
    "State": "IL",
    "City": "Elliott"
  },
  {
    "State": "IL",
    "City": "Emington"
  },
  {
    "State": "IL",
    "City": "Essex"
  },
  {
    "State": "IL",
    "City": "Gibson City"
  },
  {
    "State": "IL",
    "City": "Gilman"
  },
  {
    "State": "IL",
    "City": "Goodwine"
  },
  {
    "State": "IL",
    "City": "Grant Park"
  },
  {
    "State": "IL",
    "City": "Herscher"
  },
  {
    "State": "IL",
    "City": "Hoopeston"
  },
  {
    "State": "IL",
    "City": "Hopkins Park"
  },
  {
    "State": "IL",
    "City": "Iroquois"
  },
  {
    "State": "IL",
    "City": "Kempton"
  },
  {
    "State": "IL",
    "City": "Loda"
  },
  {
    "State": "IL",
    "City": "Ludlow"
  },
  {
    "State": "IL",
    "City": "Manteno"
  },
  {
    "State": "IL",
    "City": "Martinton"
  },
  {
    "State": "IL",
    "City": "Melvin"
  },
  {
    "State": "IL",
    "City": "Milford"
  },
  {
    "State": "IL",
    "City": "Momence"
  },
  {
    "State": "IL",
    "City": "Onarga"
  },
  {
    "State": "IL",
    "City": "Papineau"
  },
  {
    "State": "IL",
    "City": "Paxton"
  },
  {
    "State": "IL",
    "City": "Pembroke Township"
  },
  {
    "State": "IL",
    "City": "Piper City"
  },
  {
    "State": "IL",
    "City": "Rankin"
  },
  {
    "State": "IL",
    "City": "Reddick"
  },
  {
    "State": "IL",
    "City": "Roberts"
  },
  {
    "State": "IL",
    "City": "Rossville"
  },
  {
    "State": "IL",
    "City": "Saint Anne"
  },
  {
    "State": "IL",
    "City": "Sheldon"
  },
  {
    "State": "IL",
    "City": "Stockland"
  },
  {
    "State": "IL",
    "City": "Thawville"
  },
  {
    "State": "IL",
    "City": "Union Hill"
  },
  {
    "State": "IL",
    "City": "Watseka"
  },
  {
    "State": "IL",
    "City": "Wellington"
  },
  {
    "State": "IL",
    "City": "Woodland"
  },
  {
    "State": "IL",
    "City": "Apple River"
  },
  {
    "State": "IL",
    "City": "Ashton"
  },
  {
    "State": "IL",
    "City": "Baileyville"
  },
  {
    "State": "IL",
    "City": "Belvidere"
  },
  {
    "State": "IL",
    "City": "Byron"
  },
  {
    "State": "IL",
    "City": "Caledonia"
  },
  {
    "State": "IL",
    "City": "Capron"
  },
  {
    "State": "IL",
    "City": "Cedarville"
  },
  {
    "State": "IL",
    "City": "Chadwick"
  },
  {
    "State": "IL",
    "City": "Chana"
  },
  {
    "State": "IL",
    "City": "Cherry Valley"
  },
  {
    "State": "IL",
    "City": "Dakota"
  },
  {
    "State": "IL",
    "City": "Davis"
  },
  {
    "State": "IL",
    "City": "Davis Junction"
  },
  {
    "State": "IL",
    "City": "Dixon"
  },
  {
    "State": "IL",
    "City": "Durand"
  },
  {
    "State": "IL",
    "City": "East Dubuque"
  },
  {
    "State": "IL",
    "City": "Eleroy"
  },
  {
    "State": "IL",
    "City": "Elizabeth"
  },
  {
    "State": "IL",
    "City": "Forreston"
  },
  {
    "State": "IL",
    "City": "Franklin Grove"
  },
  {
    "State": "IL",
    "City": "Freeport"
  },
  {
    "State": "IL",
    "City": "Galena"
  },
  {
    "State": "IL",
    "City": "Galt"
  },
  {
    "State": "IL",
    "City": "Garden Prairie"
  },
  {
    "State": "IL",
    "City": "German Valley"
  },
  {
    "State": "IL",
    "City": "Hanover"
  },
  {
    "State": "IL",
    "City": "Harmon"
  },
  {
    "State": "IL",
    "City": "Holcomb"
  },
  {
    "State": "IL",
    "City": "Kent"
  },
  {
    "State": "IL",
    "City": "Lanark"
  },
  {
    "State": "IL",
    "City": "Leaf River"
  },
  {
    "State": "IL",
    "City": "Lena"
  },
  {
    "State": "IL",
    "City": "Lindenwood"
  },
  {
    "State": "IL",
    "City": "Mc Connell"
  },
  {
    "State": "IL",
    "City": "Milledgeville"
  },
  {
    "State": "IL",
    "City": "Monroe Center"
  },
  {
    "State": "IL",
    "City": "Mount Carroll"
  },
  {
    "State": "IL",
    "City": "Mount Morris"
  },
  {
    "State": "IL",
    "City": "Nachusa"
  },
  {
    "State": "IL",
    "City": "Nora"
  },
  {
    "State": "IL",
    "City": "Orangeville"
  },
  {
    "State": "IL",
    "City": "Oregon"
  },
  {
    "State": "IL",
    "City": "Pearl City"
  },
  {
    "State": "IL",
    "City": "Pecatonica"
  },
  {
    "State": "IL",
    "City": "Polo"
  },
  {
    "State": "IL",
    "City": "Poplar Grove"
  },
  {
    "State": "IL",
    "City": "Ridott"
  },
  {
    "State": "IL",
    "City": "Rochelle"
  },
  {
    "State": "IL",
    "City": "Rock City"
  },
  {
    "State": "IL",
    "City": "Rock Falls"
  },
  {
    "State": "IL",
    "City": "Rockton"
  },
  {
    "State": "IL",
    "City": "Roscoe"
  },
  {
    "State": "IL",
    "City": "Savanna"
  },
  {
    "State": "IL",
    "City": "Scales Mound"
  },
  {
    "State": "IL",
    "City": "Seward"
  },
  {
    "State": "IL",
    "City": "Shannon"
  },
  {
    "State": "IL",
    "City": "Shirland"
  },
  {
    "State": "IL",
    "City": "South Beloit"
  },
  {
    "State": "IL",
    "City": "Sterling"
  },
  {
    "State": "IL",
    "City": "Stillman Valley"
  },
  {
    "State": "IL",
    "City": "Stockton"
  },
  {
    "State": "IL",
    "City": "Warren"
  },
  {
    "State": "IL",
    "City": "Winnebago"
  },
  {
    "State": "IL",
    "City": "Winslow"
  },
  {
    "State": "IL",
    "City": "Woosung"
  },
  {
    "State": "IL",
    "City": "Rockford"
  },
  {
    "State": "IL",
    "City": "Loves Park"
  },
  {
    "State": "IL",
    "City": "Machesney Park"
  },
  {
    "State": "IL",
    "City": "Rock Island"
  },
  {
    "State": "IL",
    "City": "Albany"
  },
  {
    "State": "IL",
    "City": "Aledo"
  },
  {
    "State": "IL",
    "City": "Andalusia"
  },
  {
    "State": "IL",
    "City": "Andover"
  },
  {
    "State": "IL",
    "City": "Annawan"
  },
  {
    "State": "IL",
    "City": "Atkinson"
  },
  {
    "State": "IL",
    "City": "Barstow"
  },
  {
    "State": "IL",
    "City": "Buffalo Prairie"
  },
  {
    "State": "IL",
    "City": "Cambridge"
  },
  {
    "State": "IL",
    "City": "Carbon Cliff"
  },
  {
    "State": "IL",
    "City": "Coal Valley"
  },
  {
    "State": "IL",
    "City": "Colona"
  },
  {
    "State": "IL",
    "City": "Cordova"
  },
  {
    "State": "IL",
    "City": "Deer Grove"
  },
  {
    "State": "IL",
    "City": "East Moline"
  },
  {
    "State": "IL",
    "City": "Erie"
  },
  {
    "State": "IL",
    "City": "Fenton"
  },
  {
    "State": "IL",
    "City": "Fulton"
  },
  {
    "State": "IL",
    "City": "Geneseo"
  },
  {
    "State": "IL",
    "City": "Hampton"
  },
  {
    "State": "IL",
    "City": "Hillsdale"
  },
  {
    "State": "IL",
    "City": "Hooppole"
  },
  {
    "State": "IL",
    "City": "Illinois City"
  },
  {
    "State": "IL",
    "City": "Joy"
  },
  {
    "State": "IL",
    "City": "Lyndon"
  },
  {
    "State": "IL",
    "City": "Lynn Center"
  },
  {
    "State": "IL",
    "City": "Matherville"
  },
  {
    "State": "IL",
    "City": "Milan"
  },
  {
    "State": "IL",
    "City": "Moline"
  },
  {
    "State": "IL",
    "City": "Morrison"
  },
  {
    "State": "IL",
    "City": "New Boston"
  },
  {
    "State": "IL",
    "City": "Orion"
  },
  {
    "State": "IL",
    "City": "Osco"
  },
  {
    "State": "IL",
    "City": "Port Byron"
  },
  {
    "State": "IL",
    "City": "Preemption"
  },
  {
    "State": "IL",
    "City": "Prophetstown"
  },
  {
    "State": "IL",
    "City": "Rapids City"
  },
  {
    "State": "IL",
    "City": "Reynolds"
  },
  {
    "State": "IL",
    "City": "Sherrard"
  },
  {
    "State": "IL",
    "City": "Silvis"
  },
  {
    "State": "IL",
    "City": "Tampico"
  },
  {
    "State": "IL",
    "City": "Taylor Ridge"
  },
  {
    "State": "IL",
    "City": "Thomson"
  },
  {
    "State": "IL",
    "City": "La Salle"
  },
  {
    "State": "IL",
    "City": "Amboy"
  },
  {
    "State": "IL",
    "City": "Ancona"
  },
  {
    "State": "IL",
    "City": "Arlington"
  },
  {
    "State": "IL",
    "City": "Blackstone"
  },
  {
    "State": "IL",
    "City": "Buda"
  },
  {
    "State": "IL",
    "City": "Bureau"
  },
  {
    "State": "IL",
    "City": "Cedar Point"
  },
  {
    "State": "IL",
    "City": "Cherry"
  },
  {
    "State": "IL",
    "City": "Compton"
  },
  {
    "State": "IL",
    "City": "Cornell"
  },
  {
    "State": "IL",
    "City": "Dalzell"
  },
  {
    "State": "IL",
    "City": "Dana"
  },
  {
    "State": "IL",
    "City": "Depue"
  },
  {
    "State": "IL",
    "City": "Dover"
  },
  {
    "State": "IL",
    "City": "Eldena"
  },
  {
    "State": "IL",
    "City": "Grand Ridge"
  },
  {
    "State": "IL",
    "City": "Granville"
  },
  {
    "State": "IL",
    "City": "Hennepin"
  },
  {
    "State": "IL",
    "City": "Kasbeer"
  },
  {
    "State": "IL",
    "City": "Ladd"
  },
  {
    "State": "IL",
    "City": "La Moille"
  },
  {
    "State": "IL",
    "City": "Lee Center"
  },
  {
    "State": "IL",
    "City": "Leonore"
  },
  {
    "State": "IL",
    "City": "Long Point"
  },
  {
    "State": "IL",
    "City": "Lostant"
  },
  {
    "State": "IL",
    "City": "Mc Nabb"
  },
  {
    "State": "IL",
    "City": "Magnolia"
  },
  {
    "State": "IL",
    "City": "Malden"
  },
  {
    "State": "IL",
    "City": "Manlius"
  },
  {
    "State": "IL",
    "City": "Mark"
  },
  {
    "State": "IL",
    "City": "Marseilles"
  },
  {
    "State": "IL",
    "City": "Mendota"
  },
  {
    "State": "IL",
    "City": "Mineral"
  },
  {
    "State": "IL",
    "City": "Neponset"
  },
  {
    "State": "IL",
    "City": "New Bedford"
  },
  {
    "State": "IL",
    "City": "Oglesby"
  },
  {
    "State": "IL",
    "City": "Ohio"
  },
  {
    "State": "IL",
    "City": "Ottawa"
  },
  {
    "State": "IL",
    "City": "Paw Paw"
  },
  {
    "State": "IL",
    "City": "Peru"
  },
  {
    "State": "IL",
    "City": "Princeton"
  },
  {
    "State": "IL",
    "City": "Rutland"
  },
  {
    "State": "IL",
    "City": "Seatonville"
  },
  {
    "State": "IL",
    "City": "Seneca"
  },
  {
    "State": "IL",
    "City": "Sheffield"
  },
  {
    "State": "IL",
    "City": "Spring Valley"
  },
  {
    "State": "IL",
    "City": "Standard"
  },
  {
    "State": "IL",
    "City": "Streator"
  },
  {
    "State": "IL",
    "City": "Sublette"
  },
  {
    "State": "IL",
    "City": "Tiskilwa"
  },
  {
    "State": "IL",
    "City": "Toluca"
  },
  {
    "State": "IL",
    "City": "Tonica"
  },
  {
    "State": "IL",
    "City": "Triumph"
  },
  {
    "State": "IL",
    "City": "Troy Grove"
  },
  {
    "State": "IL",
    "City": "Utica"
  },
  {
    "State": "IL",
    "City": "Van Orin"
  },
  {
    "State": "IL",
    "City": "Varna"
  },
  {
    "State": "IL",
    "City": "Walnut"
  },
  {
    "State": "IL",
    "City": "Wenona"
  },
  {
    "State": "IL",
    "City": "West Brooklyn"
  },
  {
    "State": "IL",
    "City": "Wyanet"
  },
  {
    "State": "IL",
    "City": "Galesburg"
  },
  {
    "State": "IL",
    "City": "Abingdon"
  },
  {
    "State": "IL",
    "City": "Adair"
  },
  {
    "State": "IL",
    "City": "Alexis"
  },
  {
    "State": "IL",
    "City": "Alpha"
  },
  {
    "State": "IL",
    "City": "Altona"
  },
  {
    "State": "IL",
    "City": "Avon"
  },
  {
    "State": "IL",
    "City": "Bardolph"
  },
  {
    "State": "IL",
    "City": "Berwick"
  },
  {
    "State": "IL",
    "City": "Biggsville"
  },
  {
    "State": "IL",
    "City": "Bishop Hill"
  },
  {
    "State": "IL",
    "City": "Blandinsville"
  },
  {
    "State": "IL",
    "City": "Bradford"
  },
  {
    "State": "IL",
    "City": "Bushnell"
  },
  {
    "State": "IL",
    "City": "Cameron"
  },
  {
    "State": "IL",
    "City": "Camp Grove"
  },
  {
    "State": "IL",
    "City": "Carman"
  },
  {
    "State": "IL",
    "City": "Castleton"
  },
  {
    "State": "IL",
    "City": "Cuba"
  },
  {
    "State": "IL",
    "City": "Dahinda"
  },
  {
    "State": "IL",
    "City": "East Galesburg"
  },
  {
    "State": "IL",
    "City": "Ellisville"
  },
  {
    "State": "IL",
    "City": "Fairview"
  },
  {
    "State": "IL",
    "City": "Fiatt"
  },
  {
    "State": "IL",
    "City": "Galva"
  },
  {
    "State": "IL",
    "City": "Gerlaw"
  },
  {
    "State": "IL",
    "City": "Gilson"
  },
  {
    "State": "IL",
    "City": "Gladstone"
  },
  {
    "State": "IL",
    "City": "Good Hope"
  },
  {
    "State": "IL",
    "City": "Henderson"
  },
  {
    "State": "IL",
    "City": "Industry"
  },
  {
    "State": "IL",
    "City": "Ipava"
  },
  {
    "State": "IL",
    "City": "Keithsburg"
  },
  {
    "State": "IL",
    "City": "Kewanee"
  },
  {
    "State": "IL",
    "City": "Kirkwood"
  },
  {
    "State": "IL",
    "City": "Knoxville"
  },
  {
    "State": "IL",
    "City": "La Fayette"
  },
  {
    "State": "IL",
    "City": "La Harpe"
  },
  {
    "State": "IL",
    "City": "Laura"
  },
  {
    "State": "IL",
    "City": "Littleton"
  },
  {
    "State": "IL",
    "City": "Little York"
  },
  {
    "State": "IL",
    "City": "Lomax"
  },
  {
    "State": "IL",
    "City": "Macomb"
  },
  {
    "State": "IL",
    "City": "Maquon"
  },
  {
    "State": "IL",
    "City": "Marietta"
  },
  {
    "State": "IL",
    "City": "Media"
  },
  {
    "State": "IL",
    "City": "Monmouth"
  },
  {
    "State": "IL",
    "City": "New Windsor"
  },
  {
    "State": "IL",
    "City": "North Henderson"
  },
  {
    "State": "IL",
    "City": "Oneida"
  },
  {
    "State": "IL",
    "City": "Ophiem"
  },
  {
    "State": "IL",
    "City": "Oquawka"
  },
  {
    "State": "IL",
    "City": "Prairie City"
  },
  {
    "State": "IL",
    "City": "Raritan"
  },
  {
    "State": "IL",
    "City": "Rio"
  },
  {
    "State": "IL",
    "City": "Roseville"
  },
  {
    "State": "IL",
    "City": "Saint Augustine"
  },
  {
    "State": "IL",
    "City": "Sciota"
  },
  {
    "State": "IL",
    "City": "Seaton"
  },
  {
    "State": "IL",
    "City": "Smithfield"
  },
  {
    "State": "IL",
    "City": "Smithshire"
  },
  {
    "State": "IL",
    "City": "Speer"
  },
  {
    "State": "IL",
    "City": "Stronghurst"
  },
  {
    "State": "IL",
    "City": "Table Grove"
  },
  {
    "State": "IL",
    "City": "Toulon"
  },
  {
    "State": "IL",
    "City": "Vermont"
  },
  {
    "State": "IL",
    "City": "Victoria"
  },
  {
    "State": "IL",
    "City": "Viola"
  },
  {
    "State": "IL",
    "City": "Wataga"
  },
  {
    "State": "IL",
    "City": "Williamsfield"
  },
  {
    "State": "IL",
    "City": "Woodhull"
  },
  {
    "State": "IL",
    "City": "Wyoming"
  },
  {
    "State": "IL",
    "City": "Astoria"
  },
  {
    "State": "IL",
    "City": "Benson"
  },
  {
    "State": "IL",
    "City": "Brimfield"
  },
  {
    "State": "IL",
    "City": "Bryant"
  },
  {
    "State": "IL",
    "City": "Canton"
  },
  {
    "State": "IL",
    "City": "Chillicothe"
  },
  {
    "State": "IL",
    "City": "Dunfermline"
  },
  {
    "State": "IL",
    "City": "Dunlap"
  },
  {
    "State": "IL",
    "City": "Edelstein"
  },
  {
    "State": "IL",
    "City": "Edwards"
  },
  {
    "State": "IL",
    "City": "Elmwood"
  },
  {
    "State": "IL",
    "City": "Eureka"
  },
  {
    "State": "IL",
    "City": "Farmington"
  },
  {
    "State": "IL",
    "City": "Forest City"
  },
  {
    "State": "IL",
    "City": "Glasford"
  },
  {
    "State": "IL",
    "City": "Green Valley"
  },
  {
    "State": "IL",
    "City": "Groveland"
  },
  {
    "State": "IL",
    "City": "Hanna City"
  },
  {
    "State": "IL",
    "City": "Henry"
  },
  {
    "State": "IL",
    "City": "Kingston Mines"
  },
  {
    "State": "IL",
    "City": "Lacon"
  },
  {
    "State": "IL",
    "City": "La Rose"
  },
  {
    "State": "IL",
    "City": "Lewistown"
  },
  {
    "State": "IL",
    "City": "Liverpool"
  },
  {
    "State": "IL",
    "City": "London Mills"
  },
  {
    "State": "IL",
    "City": "Lowpoint"
  },
  {
    "State": "IL",
    "City": "Manito"
  },
  {
    "State": "IL",
    "City": "Mapleton"
  },
  {
    "State": "IL",
    "City": "Metamora"
  },
  {
    "State": "IL",
    "City": "Morton"
  },
  {
    "State": "IL",
    "City": "Mossville"
  },
  {
    "State": "IL",
    "City": "Norris"
  },
  {
    "State": "IL",
    "City": "Pekin"
  },
  {
    "State": "IL",
    "City": "Princeville"
  },
  {
    "State": "IL",
    "City": "Putnam"
  },
  {
    "State": "IL",
    "City": "Roanoke"
  },
  {
    "State": "IL",
    "City": "Rome"
  },
  {
    "State": "IL",
    "City": "Saint David"
  },
  {
    "State": "IL",
    "City": "South Pekin"
  },
  {
    "State": "IL",
    "City": "Sparland"
  },
  {
    "State": "IL",
    "City": "Topeka"
  },
  {
    "State": "IL",
    "City": "Tremont"
  },
  {
    "State": "IL",
    "City": "Trivoli"
  },
  {
    "State": "IL",
    "City": "Washburn"
  },
  {
    "State": "IL",
    "City": "Washington"
  },
  {
    "State": "IL",
    "City": "Yates City"
  },
  {
    "State": "IL",
    "City": "Peoria"
  },
  {
    "State": "IL",
    "City": "Creve Coeur"
  },
  {
    "State": "IL",
    "City": "East Peoria"
  },
  {
    "State": "IL",
    "City": "Peoria Heights"
  },
  {
    "State": "IL",
    "City": "Bloomington"
  },
  {
    "State": "IL",
    "City": "Anchor"
  },
  {
    "State": "IL",
    "City": "Armington"
  },
  {
    "State": "IL",
    "City": "Arrowsmith"
  },
  {
    "State": "IL",
    "City": "Atlanta"
  },
  {
    "State": "IL",
    "City": "Bellflower"
  },
  {
    "State": "IL",
    "City": "Carlock"
  },
  {
    "State": "IL",
    "City": "Chenoa"
  },
  {
    "State": "IL",
    "City": "Clinton"
  },
  {
    "State": "IL",
    "City": "Colfax"
  },
  {
    "State": "IL",
    "City": "Congerville"
  },
  {
    "State": "IL",
    "City": "Cooksville"
  },
  {
    "State": "IL",
    "City": "Cropsey"
  },
  {
    "State": "IL",
    "City": "Danvers"
  },
  {
    "State": "IL",
    "City": "Deer Creek"
  },
  {
    "State": "IL",
    "City": "Delavan"
  },
  {
    "State": "IL",
    "City": "Dewitt"
  },
  {
    "State": "IL",
    "City": "Downs"
  },
  {
    "State": "IL",
    "City": "Ellsworth"
  },
  {
    "State": "IL",
    "City": "El Paso"
  },
  {
    "State": "IL",
    "City": "Fairbury"
  },
  {
    "State": "IL",
    "City": "Flanagan"
  },
  {
    "State": "IL",
    "City": "Forrest"
  },
  {
    "State": "IL",
    "City": "Goodfield"
  },
  {
    "State": "IL",
    "City": "Graymont"
  },
  {
    "State": "IL",
    "City": "Gridley"
  },
  {
    "State": "IL",
    "City": "Heyworth"
  },
  {
    "State": "IL",
    "City": "Hopedale"
  },
  {
    "State": "IL",
    "City": "Hudson"
  },
  {
    "State": "IL",
    "City": "Kenney"
  },
  {
    "State": "IL",
    "City": "Lane"
  },
  {
    "State": "IL",
    "City": "Lawndale"
  },
  {
    "State": "IL",
    "City": "Le Roy"
  },
  {
    "State": "IL",
    "City": "Lexington"
  },
  {
    "State": "IL",
    "City": "Mc Lean"
  },
  {
    "State": "IL",
    "City": "Mackinaw"
  },
  {
    "State": "IL",
    "City": "Maroa"
  },
  {
    "State": "IL",
    "City": "Merna"
  },
  {
    "State": "IL",
    "City": "Minier"
  },
  {
    "State": "IL",
    "City": "Minonk"
  },
  {
    "State": "IL",
    "City": "Normal"
  },
  {
    "State": "IL",
    "City": "Pontiac"
  },
  {
    "State": "IL",
    "City": "Saunemin"
  },
  {
    "State": "IL",
    "City": "Saybrook"
  },
  {
    "State": "IL",
    "City": "Secor"
  },
  {
    "State": "IL",
    "City": "Shirley"
  },
  {
    "State": "IL",
    "City": "Sibley"
  },
  {
    "State": "IL",
    "City": "Stanford"
  },
  {
    "State": "IL",
    "City": "Strawn"
  },
  {
    "State": "IL",
    "City": "Towanda"
  },
  {
    "State": "IL",
    "City": "Wapella"
  },
  {
    "State": "IL",
    "City": "Waynesville"
  },
  {
    "State": "IL",
    "City": "Urbana"
  },
  {
    "State": "IL",
    "City": "Allerton"
  },
  {
    "State": "IL",
    "City": "Alvin"
  },
  {
    "State": "IL",
    "City": "Armstrong"
  },
  {
    "State": "IL",
    "City": "Bement"
  },
  {
    "State": "IL",
    "City": "Bismarck"
  },
  {
    "State": "IL",
    "City": "Bondville"
  },
  {
    "State": "IL",
    "City": "Broadlands"
  },
  {
    "State": "IL",
    "City": "Catlin"
  },
  {
    "State": "IL",
    "City": "Cerro Gordo"
  },
  {
    "State": "IL",
    "City": "Champaign"
  },
  {
    "State": "IL",
    "City": "Cisco"
  },
  {
    "State": "IL",
    "City": "Collison"
  },
  {
    "State": "IL",
    "City": "Danville"
  },
  {
    "State": "IL",
    "City": "Tilton"
  },
  {
    "State": "IL",
    "City": "De Land"
  },
  {
    "State": "IL",
    "City": "Dewey"
  },
  {
    "State": "IL",
    "City": "Fairmount"
  },
  {
    "State": "IL",
    "City": "Farmer City"
  },
  {
    "State": "IL",
    "City": "Fisher"
  },
  {
    "State": "IL",
    "City": "Fithian"
  },
  {
    "State": "IL",
    "City": "Foosland"
  },
  {
    "State": "IL",
    "City": "Georgetown"
  },
  {
    "State": "IL",
    "City": "Gifford"
  },
  {
    "State": "IL",
    "City": "Henning"
  },
  {
    "State": "IL",
    "City": "Homer"
  },
  {
    "State": "IL",
    "City": "Indianola"
  },
  {
    "State": "IL",
    "City": "Ivesdale"
  },
  {
    "State": "IL",
    "City": "Longview"
  },
  {
    "State": "IL",
    "City": "Mahomet"
  },
  {
    "State": "IL",
    "City": "Mansfield"
  },
  {
    "State": "IL",
    "City": "Milmine"
  },
  {
    "State": "IL",
    "City": "Monticello"
  },
  {
    "State": "IL",
    "City": "Muncie"
  },
  {
    "State": "IL",
    "City": "Oakwood"
  },
  {
    "State": "IL",
    "City": "Ogden"
  },
  {
    "State": "IL",
    "City": "Penfield"
  },
  {
    "State": "IL",
    "City": "Pesotum"
  },
  {
    "State": "IL",
    "City": "Philo"
  },
  {
    "State": "IL",
    "City": "Potomac"
  },
  {
    "State": "IL",
    "City": "Rantoul"
  },
  {
    "State": "IL",
    "City": "Ridge Farm"
  },
  {
    "State": "IL",
    "City": "Royal"
  },
  {
    "State": "IL",
    "City": "Sadorus"
  },
  {
    "State": "IL",
    "City": "Saint Joseph"
  },
  {
    "State": "IL",
    "City": "Savoy"
  },
  {
    "State": "IL",
    "City": "Seymour"
  },
  {
    "State": "IL",
    "City": "Sidell"
  },
  {
    "State": "IL",
    "City": "Sidney"
  },
  {
    "State": "IL",
    "City": "Thomasboro"
  },
  {
    "State": "IL",
    "City": "Tolono"
  },
  {
    "State": "IL",
    "City": "Weldon"
  },
  {
    "State": "IL",
    "City": "Westville"
  },
  {
    "State": "IL",
    "City": "White Heath"
  },
  {
    "State": "IL",
    "City": "Arcola"
  },
  {
    "State": "IL",
    "City": "Arthur"
  },
  {
    "State": "IL",
    "City": "Ashmore"
  },
  {
    "State": "IL",
    "City": "Atwood"
  },
  {
    "State": "IL",
    "City": "Bethany"
  },
  {
    "State": "IL",
    "City": "Brocton"
  },
  {
    "State": "IL",
    "City": "Camargo"
  },
  {
    "State": "IL",
    "City": "Charleston"
  },
  {
    "State": "IL",
    "City": "Chrisman"
  },
  {
    "State": "IL",
    "City": "Dalton City"
  },
  {
    "State": "IL",
    "City": "Gays"
  },
  {
    "State": "IL",
    "City": "Hammond"
  },
  {
    "State": "IL",
    "City": "Hindsboro"
  },
  {
    "State": "IL",
    "City": "Humboldt"
  },
  {
    "State": "IL",
    "City": "Hume"
  },
  {
    "State": "IL",
    "City": "Kansas"
  },
  {
    "State": "IL",
    "City": "La Place"
  },
  {
    "State": "IL",
    "City": "Lovington"
  },
  {
    "State": "IL",
    "City": "Mattoon"
  },
  {
    "State": "IL",
    "City": "Metcalf"
  },
  {
    "State": "IL",
    "City": "Murdock"
  },
  {
    "State": "IL",
    "City": "Newman"
  },
  {
    "State": "IL",
    "City": "Oakland"
  },
  {
    "State": "IL",
    "City": "Paris"
  },
  {
    "State": "IL",
    "City": "Redmon"
  },
  {
    "State": "IL",
    "City": "Sullivan"
  },
  {
    "State": "IL",
    "City": "Tuscola"
  },
  {
    "State": "IL",
    "City": "Vermilion"
  },
  {
    "State": "IL",
    "City": "Villa Grove"
  },
  {
    "State": "IL",
    "City": "Windsor"
  },
  {
    "State": "IL",
    "City": "Alhambra"
  },
  {
    "State": "IL",
    "City": "Alton"
  },
  {
    "State": "IL",
    "City": "Batchtown"
  },
  {
    "State": "IL",
    "City": "Benld"
  },
  {
    "State": "IL",
    "City": "Bethalto"
  },
  {
    "State": "IL",
    "City": "Bingham"
  },
  {
    "State": "IL",
    "City": "Brighton"
  },
  {
    "State": "IL",
    "City": "Brussels"
  },
  {
    "State": "IL",
    "City": "Bunker Hill"
  },
  {
    "State": "IL",
    "City": "Butler"
  },
  {
    "State": "IL",
    "City": "Carrollton"
  },
  {
    "State": "IL",
    "City": "Coffeen"
  },
  {
    "State": "IL",
    "City": "Cottage Hills"
  },
  {
    "State": "IL",
    "City": "Donnellson"
  },
  {
    "State": "IL",
    "City": "Dorsey"
  },
  {
    "State": "IL",
    "City": "Dow"
  },
  {
    "State": "IL",
    "City": "Eagarville"
  },
  {
    "State": "IL",
    "City": "East Alton"
  },
  {
    "State": "IL",
    "City": "Edwardsville"
  },
  {
    "State": "IL",
    "City": "Eldred"
  },
  {
    "State": "IL",
    "City": "Elsah"
  },
  {
    "State": "IL",
    "City": "Fidelity"
  },
  {
    "State": "IL",
    "City": "Fieldon"
  },
  {
    "State": "IL",
    "City": "Fillmore"
  },
  {
    "State": "IL",
    "City": "Gillespie"
  },
  {
    "State": "IL",
    "City": "Glen Carbon"
  },
  {
    "State": "IL",
    "City": "Godfrey"
  },
  {
    "State": "IL",
    "City": "Golden Eagle"
  },
  {
    "State": "IL",
    "City": "Grafton"
  },
  {
    "State": "IL",
    "City": "Granite City"
  },
  {
    "State": "IL",
    "City": "Greenfield"
  },
  {
    "State": "IL",
    "City": "Hamburg"
  },
  {
    "State": "IL",
    "City": "Hamel"
  },
  {
    "State": "IL",
    "City": "Hardin"
  },
  {
    "State": "IL",
    "City": "Hartford"
  },
  {
    "State": "IL",
    "City": "Hillsboro"
  },
  {
    "State": "IL",
    "City": "Hillview"
  },
  {
    "State": "IL",
    "City": "Irving"
  },
  {
    "State": "IL",
    "City": "Jerseyville"
  },
  {
    "State": "IL",
    "City": "Kampsville"
  },
  {
    "State": "IL",
    "City": "Kane"
  },
  {
    "State": "IL",
    "City": "Litchfield"
  },
  {
    "State": "IL",
    "City": "Livingston"
  },
  {
    "State": "IL",
    "City": "Lovejoy"
  },
  {
    "State": "IL",
    "City": "Madison"
  },
  {
    "State": "IL",
    "City": "Marine"
  },
  {
    "State": "IL",
    "City": "Maryville"
  },
  {
    "State": "IL",
    "City": "Medora"
  },
  {
    "State": "IL",
    "City": "Michael"
  },
  {
    "State": "IL",
    "City": "Moro"
  },
  {
    "State": "IL",
    "City": "Mount Olive"
  },
  {
    "State": "IL",
    "City": "Mozier"
  },
  {
    "State": "IL",
    "City": "National Stock Yards"
  },
  {
    "State": "IL",
    "City": "New Douglas"
  },
  {
    "State": "IL",
    "City": "Nokomis"
  },
  {
    "State": "IL",
    "City": "Ohlman"
  },
  {
    "State": "IL",
    "City": "Panama"
  },
  {
    "State": "IL",
    "City": "Patterson"
  },
  {
    "State": "IL",
    "City": "Piasa"
  },
  {
    "State": "IL",
    "City": "Ramsey"
  },
  {
    "State": "IL",
    "City": "Rockbridge"
  },
  {
    "State": "IL",
    "City": "Roodhouse"
  },
  {
    "State": "IL",
    "City": "Rosamond"
  },
  {
    "State": "IL",
    "City": "Roxana"
  },
  {
    "State": "IL",
    "City": "Sawyerville"
  },
  {
    "State": "IL",
    "City": "Sorento"
  },
  {
    "State": "IL",
    "City": "South Roxana"
  },
  {
    "State": "IL",
    "City": "Staunton"
  },
  {
    "State": "IL",
    "City": "Taylor Springs"
  },
  {
    "State": "IL",
    "City": "Venice"
  },
  {
    "State": "IL",
    "City": "Walshville"
  },
  {
    "State": "IL",
    "City": "White Hall"
  },
  {
    "State": "IL",
    "City": "Wilsonville"
  },
  {
    "State": "IL",
    "City": "Witt"
  },
  {
    "State": "IL",
    "City": "Wood River"
  },
  {
    "State": "IL",
    "City": "Worden"
  },
  {
    "State": "IL",
    "City": "Wrights"
  },
  {
    "State": "IL",
    "City": "East Saint Louis"
  },
  {
    "State": "IL",
    "City": "Fairview Heights"
  },
  {
    "State": "IL",
    "City": "Addieville"
  },
  {
    "State": "IL",
    "City": "Albers"
  },
  {
    "State": "IL",
    "City": "Aviston"
  },
  {
    "State": "IL",
    "City": "Baldwin"
  },
  {
    "State": "IL",
    "City": "Bartelso"
  },
  {
    "State": "IL",
    "City": "Beckemeyer"
  },
  {
    "State": "IL",
    "City": "Belleville"
  },
  {
    "State": "IL",
    "City": "Mascoutah"
  },
  {
    "State": "IL",
    "City": "Scott Air Force Base"
  },
  {
    "State": "IL",
    "City": "Breese"
  },
  {
    "State": "IL",
    "City": "Carlyle"
  },
  {
    "State": "IL",
    "City": "Caseyville"
  },
  {
    "State": "IL",
    "City": "Chester"
  },
  {
    "State": "IL",
    "City": "Collinsville"
  },
  {
    "State": "IL",
    "City": "Columbia"
  },
  {
    "State": "IL",
    "City": "Coulterville"
  },
  {
    "State": "IL",
    "City": "Cutler"
  },
  {
    "State": "IL",
    "City": "Dupo"
  },
  {
    "State": "IL",
    "City": "East Carondelet"
  },
  {
    "State": "IL",
    "City": "Ellis Grove"
  },
  {
    "State": "IL",
    "City": "Evansville"
  },
  {
    "State": "IL",
    "City": "Freeburg"
  },
  {
    "State": "IL",
    "City": "Fults"
  },
  {
    "State": "IL",
    "City": "Germantown"
  },
  {
    "State": "IL",
    "City": "Greenville"
  },
  {
    "State": "IL",
    "City": "Hagarstown"
  },
  {
    "State": "IL",
    "City": "Hecker"
  },
  {
    "State": "IL",
    "City": "Highland"
  },
  {
    "State": "IL",
    "City": "Hoffman"
  },
  {
    "State": "IL",
    "City": "Huey"
  },
  {
    "State": "IL",
    "City": "Keyesport"
  },
  {
    "State": "IL",
    "City": "Lebanon"
  },
  {
    "State": "IL",
    "City": "Lenzburg"
  },
  {
    "State": "IL",
    "City": "Maeystown"
  },
  {
    "State": "IL",
    "City": "Marissa"
  },
  {
    "State": "IL",
    "City": "Menard"
  },
  {
    "State": "IL",
    "City": "Millstadt"
  },
  {
    "State": "IL",
    "City": "Modoc"
  },
  {
    "State": "IL",
    "City": "Mulberry Grove"
  },
  {
    "State": "IL",
    "City": "Nashville"
  },
  {
    "State": "IL",
    "City": "New Athens"
  },
  {
    "State": "IL",
    "City": "New Baden"
  },
  {
    "State": "IL",
    "City": "New Memphis"
  },
  {
    "State": "IL",
    "City": "Oakdale"
  },
  {
    "State": "IL",
    "City": "O Fallon"
  },
  {
    "State": "IL",
    "City": "Okawville"
  },
  {
    "State": "IL",
    "City": "Percy"
  },
  {
    "State": "IL",
    "City": "Pierron"
  },
  {
    "State": "IL",
    "City": "Pinckneyville"
  },
  {
    "State": "IL",
    "City": "Pocahontas"
  },
  {
    "State": "IL",
    "City": "Prairie Du Rocher"
  },
  {
    "State": "IL",
    "City": "Red Bud"
  },
  {
    "State": "IL",
    "City": "Renault"
  },
  {
    "State": "IL",
    "City": "Rockwood"
  },
  {
    "State": "IL",
    "City": "Saint Jacob"
  },
  {
    "State": "IL",
    "City": "Saint Libory"
  },
  {
    "State": "IL",
    "City": "Smithboro"
  },
  {
    "State": "IL",
    "City": "Smithton"
  },
  {
    "State": "IL",
    "City": "Sparta"
  },
  {
    "State": "IL",
    "City": "Steeleville"
  },
  {
    "State": "IL",
    "City": "Summerfield"
  },
  {
    "State": "IL",
    "City": "Tilden"
  },
  {
    "State": "IL",
    "City": "Trenton"
  },
  {
    "State": "IL",
    "City": "Troy"
  },
  {
    "State": "IL",
    "City": "Valmeyer"
  },
  {
    "State": "IL",
    "City": "Walsh"
  },
  {
    "State": "IL",
    "City": "Waterloo"
  },
  {
    "State": "IL",
    "City": "Quincy"
  },
  {
    "State": "IL",
    "City": "Augusta"
  },
  {
    "State": "IL",
    "City": "Barry"
  },
  {
    "State": "IL",
    "City": "Basco"
  },
  {
    "State": "IL",
    "City": "Baylis"
  },
  {
    "State": "IL",
    "City": "Bowen"
  },
  {
    "State": "IL",
    "City": "Camden"
  },
  {
    "State": "IL",
    "City": "Camp Point"
  },
  {
    "State": "IL",
    "City": "Carthage"
  },
  {
    "State": "IL",
    "City": "Chambersburg"
  },
  {
    "State": "IL",
    "City": "Clayton"
  },
  {
    "State": "IL",
    "City": "Coatsburg"
  },
  {
    "State": "IL",
    "City": "Colchester"
  },
  {
    "State": "IL",
    "City": "Colusa"
  },
  {
    "State": "IL",
    "City": "Dallas City"
  },
  {
    "State": "IL",
    "City": "Elvaston"
  },
  {
    "State": "IL",
    "City": "Ferris"
  },
  {
    "State": "IL",
    "City": "Fowler"
  },
  {
    "State": "IL",
    "City": "Golden"
  },
  {
    "State": "IL",
    "City": "Griggsville"
  },
  {
    "State": "IL",
    "City": "Hamilton"
  },
  {
    "State": "IL",
    "City": "Hull"
  },
  {
    "State": "IL",
    "City": "Huntsville"
  },
  {
    "State": "IL",
    "City": "Kinderhook"
  },
  {
    "State": "IL",
    "City": "La Prairie"
  },
  {
    "State": "IL",
    "City": "Liberty"
  },
  {
    "State": "IL",
    "City": "Lima"
  },
  {
    "State": "IL",
    "City": "Loraine"
  },
  {
    "State": "IL",
    "City": "Mendon"
  },
  {
    "State": "IL",
    "City": "Milton"
  },
  {
    "State": "IL",
    "City": "Mount Sterling"
  },
  {
    "State": "IL",
    "City": "Nauvoo"
  },
  {
    "State": "IL",
    "City": "Nebo"
  },
  {
    "State": "IL",
    "City": "New Canton"
  },
  {
    "State": "IL",
    "City": "New Salem"
  },
  {
    "State": "IL",
    "City": "Niota"
  },
  {
    "State": "IL",
    "City": "Paloma"
  },
  {
    "State": "IL",
    "City": "Payson"
  },
  {
    "State": "IL",
    "City": "Pearl"
  },
  {
    "State": "IL",
    "City": "Perry"
  },
  {
    "State": "IL",
    "City": "Pittsfield"
  },
  {
    "State": "IL",
    "City": "Plainville"
  },
  {
    "State": "IL",
    "City": "Pleasant Hill"
  },
  {
    "State": "IL",
    "City": "Plymouth"
  },
  {
    "State": "IL",
    "City": "Rockport"
  },
  {
    "State": "IL",
    "City": "Sutter"
  },
  {
    "State": "IL",
    "City": "Tennessee"
  },
  {
    "State": "IL",
    "City": "Timewell"
  },
  {
    "State": "IL",
    "City": "Ursa"
  },
  {
    "State": "IL",
    "City": "Versailles"
  },
  {
    "State": "IL",
    "City": "Warsaw"
  },
  {
    "State": "IL",
    "City": "West Point"
  },
  {
    "State": "IL",
    "City": "Effingham"
  },
  {
    "State": "IL",
    "City": "Allendale"
  },
  {
    "State": "IL",
    "City": "Altamont"
  },
  {
    "State": "IL",
    "City": "Annapolis"
  },
  {
    "State": "IL",
    "City": "Beecher City"
  },
  {
    "State": "IL",
    "City": "Bridgeport"
  },
  {
    "State": "IL",
    "City": "Brownstown"
  },
  {
    "State": "IL",
    "City": "Calhoun"
  },
  {
    "State": "IL",
    "City": "Casey"
  },
  {
    "State": "IL",
    "City": "Claremont"
  },
  {
    "State": "IL",
    "City": "Cowden"
  },
  {
    "State": "IL",
    "City": "Dennison"
  },
  {
    "State": "IL",
    "City": "Dieterich"
  },
  {
    "State": "IL",
    "City": "Dundas"
  },
  {
    "State": "IL",
    "City": "Edgewood"
  },
  {
    "State": "IL",
    "City": "Flat Rock"
  },
  {
    "State": "IL",
    "City": "Greenup"
  },
  {
    "State": "IL",
    "City": "Herrick"
  },
  {
    "State": "IL",
    "City": "Hidalgo"
  },
  {
    "State": "IL",
    "City": "Hutsonville"
  },
  {
    "State": "IL",
    "City": "Ingraham"
  },
  {
    "State": "IL",
    "City": "Janesville"
  },
  {
    "State": "IL",
    "City": "Jewett"
  },
  {
    "State": "IL",
    "City": "Lakewood"
  },
  {
    "State": "IL",
    "City": "Lawrenceville"
  },
  {
    "State": "IL",
    "City": "Lerna"
  },
  {
    "State": "IL",
    "City": "Marshall"
  },
  {
    "State": "IL",
    "City": "Martinsville"
  },
  {
    "State": "IL",
    "City": "Mason"
  },
  {
    "State": "IL",
    "City": "Mode"
  },
  {
    "State": "IL",
    "City": "Montrose"
  },
  {
    "State": "IL",
    "City": "Mount Erie"
  },
  {
    "State": "IL",
    "City": "Neoga"
  },
  {
    "State": "IL",
    "City": "Newton"
  },
  {
    "State": "IL",
    "City": "Oblong"
  },
  {
    "State": "IL",
    "City": "Olney"
  },
  {
    "State": "IL",
    "City": "Palestine"
  },
  {
    "State": "IL",
    "City": "Parkersburg"
  },
  {
    "State": "IL",
    "City": "Robinson"
  },
  {
    "State": "IL",
    "City": "Saint Elmo"
  },
  {
    "State": "IL",
    "City": "Sainte Marie"
  },
  {
    "State": "IL",
    "City": "Saint Francisville"
  },
  {
    "State": "IL",
    "City": "Shumway"
  },
  {
    "State": "IL",
    "City": "Sigel"
  },
  {
    "State": "IL",
    "City": "Stewardson"
  },
  {
    "State": "IL",
    "City": "Stoy"
  },
  {
    "State": "IL",
    "City": "Strasburg"
  },
  {
    "State": "IL",
    "City": "Sumner"
  },
  {
    "State": "IL",
    "City": "Teutopolis"
  },
  {
    "State": "IL",
    "City": "Toledo"
  },
  {
    "State": "IL",
    "City": "Trilla"
  },
  {
    "State": "IL",
    "City": "Vandalia"
  },
  {
    "State": "IL",
    "City": "Watson"
  },
  {
    "State": "IL",
    "City": "Westfield"
  },
  {
    "State": "IL",
    "City": "West Liberty"
  },
  {
    "State": "IL",
    "City": "West Salem"
  },
  {
    "State": "IL",
    "City": "West Union"
  },
  {
    "State": "IL",
    "City": "West York"
  },
  {
    "State": "IL",
    "City": "Wheeler"
  },
  {
    "State": "IL",
    "City": "Willow Hill"
  },
  {
    "State": "IL",
    "City": "Yale"
  },
  {
    "State": "IL",
    "City": "Argenta"
  },
  {
    "State": "IL",
    "City": "Assumption"
  },
  {
    "State": "IL",
    "City": "Beason"
  },
  {
    "State": "IL",
    "City": "Blue Mound"
  },
  {
    "State": "IL",
    "City": "Boody"
  },
  {
    "State": "IL",
    "City": "Buffalo"
  },
  {
    "State": "IL",
    "City": "Bulpitt"
  },
  {
    "State": "IL",
    "City": "Chestnut"
  },
  {
    "State": "IL",
    "City": "Cornland"
  },
  {
    "State": "IL",
    "City": "Dawson"
  },
  {
    "State": "IL",
    "City": "Decatur"
  },
  {
    "State": "IL",
    "City": "Divernon"
  },
  {
    "State": "IL",
    "City": "Edinburg"
  },
  {
    "State": "IL",
    "City": "Elwin"
  },
  {
    "State": "IL",
    "City": "Farmersville"
  },
  {
    "State": "IL",
    "City": "Findlay"
  },
  {
    "State": "IL",
    "City": "Forsyth"
  },
  {
    "State": "IL",
    "City": "Glenarm"
  },
  {
    "State": "IL",
    "City": "Harristown"
  },
  {
    "State": "IL",
    "City": "Harvel"
  },
  {
    "State": "IL",
    "City": "Illiopolis"
  },
  {
    "State": "IL",
    "City": "Kincaid"
  },
  {
    "State": "IL",
    "City": "Lake Fork"
  },
  {
    "State": "IL",
    "City": "Latham"
  },
  {
    "State": "IL",
    "City": "Macon"
  },
  {
    "State": "IL",
    "City": "Mechanicsburg"
  },
  {
    "State": "IL",
    "City": "Morrisonville"
  },
  {
    "State": "IL",
    "City": "Mount Auburn"
  },
  {
    "State": "IL",
    "City": "Mount Pulaski"
  },
  {
    "State": "IL",
    "City": "Mt Zion"
  },
  {
    "State": "IL",
    "City": "Moweaqua"
  },
  {
    "State": "IL",
    "City": "Niantic"
  },
  {
    "State": "IL",
    "City": "Oconee"
  },
  {
    "State": "IL",
    "City": "Oreana"
  },
  {
    "State": "IL",
    "City": "Owaneco"
  },
  {
    "State": "IL",
    "City": "Palmer"
  },
  {
    "State": "IL",
    "City": "Pana"
  },
  {
    "State": "IL",
    "City": "Pawnee"
  },
  {
    "State": "IL",
    "City": "Raymond"
  },
  {
    "State": "IL",
    "City": "Riverton"
  },
  {
    "State": "IL",
    "City": "Rochester"
  },
  {
    "State": "IL",
    "City": "Shelbyville"
  },
  {
    "State": "IL",
    "City": "Stonington"
  },
  {
    "State": "IL",
    "City": "Taylorville"
  },
  {
    "State": "IL",
    "City": "Tovey"
  },
  {
    "State": "IL",
    "City": "Tower Hill"
  },
  {
    "State": "IL",
    "City": "Waggoner"
  },
  {
    "State": "IL",
    "City": "Warrensburg"
  },
  {
    "State": "IL",
    "City": "Alexander"
  },
  {
    "State": "IL",
    "City": "Alsey"
  },
  {
    "State": "IL",
    "City": "Arenzville"
  },
  {
    "State": "IL",
    "City": "Ashland"
  },
  {
    "State": "IL",
    "City": "Athens"
  },
  {
    "State": "IL",
    "City": "Auburn"
  },
  {
    "State": "IL",
    "City": "Bath"
  },
  {
    "State": "IL",
    "City": "Beardstown"
  },
  {
    "State": "IL",
    "City": "Bluffs"
  },
  {
    "State": "IL",
    "City": "Bluff Springs"
  },
  {
    "State": "IL",
    "City": "Browning"
  },
  {
    "State": "IL",
    "City": "Cantrall"
  },
  {
    "State": "IL",
    "City": "Carlinville"
  },
  {
    "State": "IL",
    "City": "Chandlerville"
  },
  {
    "State": "IL",
    "City": "Chapin"
  },
  {
    "State": "IL",
    "City": "Chatham"
  },
  {
    "State": "IL",
    "City": "Chesterfield"
  },
  {
    "State": "IL",
    "City": "Concord"
  },
  {
    "State": "IL",
    "City": "Easton"
  },
  {
    "State": "IL",
    "City": "Elkhart"
  },
  {
    "State": "IL",
    "City": "Emden"
  },
  {
    "State": "IL",
    "City": "Franklin"
  },
  {
    "State": "IL",
    "City": "Frederick"
  },
  {
    "State": "IL",
    "City": "Girard"
  },
  {
    "State": "IL",
    "City": "Greenview"
  },
  {
    "State": "IL",
    "City": "Hartsburg"
  },
  {
    "State": "IL",
    "City": "Havana"
  },
  {
    "State": "IL",
    "City": "Hettick"
  },
  {
    "State": "IL",
    "City": "Jacksonville"
  },
  {
    "State": "IL",
    "City": "Kilbourne"
  },
  {
    "State": "IL",
    "City": "Lincoln"
  },
  {
    "State": "IL",
    "City": "Lincolns New Salem"
  },
  {
    "State": "IL",
    "City": "Literberry"
  },
  {
    "State": "IL",
    "City": "Loami"
  },
  {
    "State": "IL",
    "City": "Lowder"
  },
  {
    "State": "IL",
    "City": "Manchester"
  },
  {
    "State": "IL",
    "City": "Mason City"
  },
  {
    "State": "IL",
    "City": "Meredosia"
  },
  {
    "State": "IL",
    "City": "Middletown"
  },
  {
    "State": "IL",
    "City": "Modesto"
  },
  {
    "State": "IL",
    "City": "Murrayville"
  },
  {
    "State": "IL",
    "City": "New Berlin"
  },
  {
    "State": "IL",
    "City": "New Holland"
  },
  {
    "State": "IL",
    "City": "Nilwood"
  },
  {
    "State": "IL",
    "City": "Oakford"
  },
  {
    "State": "IL",
    "City": "Palmyra"
  },
  {
    "State": "IL",
    "City": "Petersburg"
  },
  {
    "State": "IL",
    "City": "Pleasant Plains"
  },
  {
    "State": "IL",
    "City": "Rushville"
  },
  {
    "State": "IL",
    "City": "San Jose"
  },
  {
    "State": "IL",
    "City": "Scottville"
  },
  {
    "State": "IL",
    "City": "Sherman"
  },
  {
    "State": "IL",
    "City": "Shipman"
  },
  {
    "State": "IL",
    "City": "Tallula"
  },
  {
    "State": "IL",
    "City": "Thayer"
  },
  {
    "State": "IL",
    "City": "Virden"
  },
  {
    "State": "IL",
    "City": "Virginia"
  },
  {
    "State": "IL",
    "City": "Waverly"
  },
  {
    "State": "IL",
    "City": "Williamsville"
  },
  {
    "State": "IL",
    "City": "Winchester"
  },
  {
    "State": "IL",
    "City": "Woodson"
  },
  {
    "State": "IL",
    "City": "Springfield"
  },
  {
    "State": "IL",
    "City": "Centralia"
  },
  {
    "State": "IL",
    "City": "Hoyleton"
  },
  {
    "State": "IL",
    "City": "Akin"
  },
  {
    "State": "IL",
    "City": "Albion"
  },
  {
    "State": "IL",
    "City": "Alma"
  },
  {
    "State": "IL",
    "City": "Ashley"
  },
  {
    "State": "IL",
    "City": "Barnhill"
  },
  {
    "State": "IL",
    "City": "Belle Rive"
  },
  {
    "State": "IL",
    "City": "Bellmont"
  },
  {
    "State": "IL",
    "City": "Benton"
  },
  {
    "State": "IL",
    "City": "Bluford"
  },
  {
    "State": "IL",
    "City": "Bone Gap"
  },
  {
    "State": "IL",
    "City": "Bonnie"
  },
  {
    "State": "IL",
    "City": "Broughton"
  },
  {
    "State": "IL",
    "City": "Browns"
  },
  {
    "State": "IL",
    "City": "Buckner"
  },
  {
    "State": "IL",
    "City": "Burnt Prairie"
  },
  {
    "State": "IL",
    "City": "Carmi"
  },
  {
    "State": "IL",
    "City": "Christopher"
  },
  {
    "State": "IL",
    "City": "Cisne"
  },
  {
    "State": "IL",
    "City": "Clay City"
  },
  {
    "State": "IL",
    "City": "Coello"
  },
  {
    "State": "IL",
    "City": "Crossville"
  },
  {
    "State": "IL",
    "City": "Dahlgren"
  },
  {
    "State": "IL",
    "City": "Dale"
  },
  {
    "State": "IL",
    "City": "Dix"
  },
  {
    "State": "IL",
    "City": "Du Bois"
  },
  {
    "State": "IL",
    "City": "Du Quoin"
  },
  {
    "State": "IL",
    "City": "Ellery"
  },
  {
    "State": "IL",
    "City": "Emma"
  },
  {
    "State": "IL",
    "City": "Enfield"
  },
  {
    "State": "IL",
    "City": "Ewing"
  },
  {
    "State": "IL",
    "City": "Fairfield"
  },
  {
    "State": "IL",
    "City": "Farina"
  },
  {
    "State": "IL",
    "City": "Flora"
  },
  {
    "State": "IL",
    "City": "Frankfort Heights"
  },
  {
    "State": "IL",
    "City": "Freeman Spur"
  },
  {
    "State": "IL",
    "City": "Geff"
  },
  {
    "State": "IL",
    "City": "Golden Gate"
  },
  {
    "State": "IL",
    "City": "Grayville"
  },
  {
    "State": "IL",
    "City": "Ina"
  },
  {
    "State": "IL",
    "City": "Irvington"
  },
  {
    "State": "IL",
    "City": "Iuka"
  },
  {
    "State": "IL",
    "City": "Johnsonville"
  },
  {
    "State": "IL",
    "City": "Keenes"
  },
  {
    "State": "IL",
    "City": "Keensburg"
  },
  {
    "State": "IL",
    "City": "Kell"
  },
  {
    "State": "IL",
    "City": "Kinmundy"
  },
  {
    "State": "IL",
    "City": "Lancaster"
  },
  {
    "State": "IL",
    "City": "Logan"
  },
  {
    "State": "IL",
    "City": "Loogootee"
  },
  {
    "State": "IL",
    "City": "Louisville"
  },
  {
    "State": "IL",
    "City": "Mc Leansboro"
  },
  {
    "State": "IL",
    "City": "Macedonia"
  },
  {
    "State": "IL",
    "City": "Maunie"
  },
  {
    "State": "IL",
    "City": "Mill Shoals"
  },
  {
    "State": "IL",
    "City": "Mount Carmel"
  },
  {
    "State": "IL",
    "City": "Mount Vernon"
  },
  {
    "State": "IL",
    "City": "Mulkeytown"
  },
  {
    "State": "IL",
    "City": "Nason"
  },
  {
    "State": "IL",
    "City": "New Haven"
  },
  {
    "State": "IL",
    "City": "Noble"
  },
  {
    "State": "IL",
    "City": "Norris City"
  },
  {
    "State": "IL",
    "City": "Odin"
  },
  {
    "State": "IL",
    "City": "Omaha"
  },
  {
    "State": "IL",
    "City": "Opdyke"
  },
  {
    "State": "IL",
    "City": "Orient"
  },
  {
    "State": "IL",
    "City": "Patoka"
  },
  {
    "State": "IL",
    "City": "Radom"
  },
  {
    "State": "IL",
    "City": "Richview"
  },
  {
    "State": "IL",
    "City": "Rinard"
  },
  {
    "State": "IL",
    "City": "Sailor Springs"
  },
  {
    "State": "IL",
    "City": "Saint Peter"
  },
  {
    "State": "IL",
    "City": "Salem"
  },
  {
    "State": "IL",
    "City": "Sandoval"
  },
  {
    "State": "IL",
    "City": "Scheller"
  },
  {
    "State": "IL",
    "City": "Sesser"
  },
  {
    "State": "IL",
    "City": "Shobonier"
  },
  {
    "State": "IL",
    "City": "Sims"
  },
  {
    "State": "IL",
    "City": "Springerton"
  },
  {
    "State": "IL",
    "City": "Tamaroa"
  },
  {
    "State": "IL",
    "City": "Texico"
  },
  {
    "State": "IL",
    "City": "Thompsonville"
  },
  {
    "State": "IL",
    "City": "Valier"
  },
  {
    "State": "IL",
    "City": "Vernon"
  },
  {
    "State": "IL",
    "City": "Walnut Hill"
  },
  {
    "State": "IL",
    "City": "Waltonville"
  },
  {
    "State": "IL",
    "City": "Wayne City"
  },
  {
    "State": "IL",
    "City": "West Frankfort"
  },
  {
    "State": "IL",
    "City": "Whittington"
  },
  {
    "State": "IL",
    "City": "Woodlawn"
  },
  {
    "State": "IL",
    "City": "Xenia"
  },
  {
    "State": "IL",
    "City": "Carbondale"
  },
  {
    "State": "IL",
    "City": "Alto Pass"
  },
  {
    "State": "IL",
    "City": "Anna"
  },
  {
    "State": "IL",
    "City": "Ava"
  },
  {
    "State": "IL",
    "City": "Belknap"
  },
  {
    "State": "IL",
    "City": "Boles"
  },
  {
    "State": "IL",
    "City": "Brookport"
  },
  {
    "State": "IL",
    "City": "Buncombe"
  },
  {
    "State": "IL",
    "City": "Cairo"
  },
  {
    "State": "IL",
    "City": "Cambria"
  },
  {
    "State": "IL",
    "City": "Campbell Hill"
  },
  {
    "State": "IL",
    "City": "Carrier Mills"
  },
  {
    "State": "IL",
    "City": "Carterville"
  },
  {
    "State": "IL",
    "City": "Cave In Rock"
  },
  {
    "State": "IL",
    "City": "Cobden"
  },
  {
    "State": "IL",
    "City": "Colp"
  },
  {
    "State": "IL",
    "City": "Creal Springs"
  },
  {
    "State": "IL",
    "City": "Cypress"
  },
  {
    "State": "IL",
    "City": "De Soto"
  },
  {
    "State": "IL",
    "City": "Dongola"
  },
  {
    "State": "IL",
    "City": "Dowell"
  },
  {
    "State": "IL",
    "City": "Eddyville"
  },
  {
    "State": "IL",
    "City": "Eldorado"
  },
  {
    "State": "IL",
    "City": "Elizabethtown"
  },
  {
    "State": "IL",
    "City": "Elkville"
  },
  {
    "State": "IL",
    "City": "Energy"
  },
  {
    "State": "IL",
    "City": "Equality"
  },
  {
    "State": "IL",
    "City": "Galatia"
  },
  {
    "State": "IL",
    "City": "Golconda"
  },
  {
    "State": "IL",
    "City": "Goreville"
  },
  {
    "State": "IL",
    "City": "Gorham"
  },
  {
    "State": "IL",
    "City": "Grand Chain"
  },
  {
    "State": "IL",
    "City": "Grand Tower"
  },
  {
    "State": "IL",
    "City": "Grantsburg"
  },
  {
    "State": "IL",
    "City": "Harrisburg"
  },
  {
    "State": "IL",
    "City": "Herod"
  },
  {
    "State": "IL",
    "City": "Herrin"
  },
  {
    "State": "IL",
    "City": "Hurst"
  },
  {
    "State": "IL",
    "City": "Jacob"
  },
  {
    "State": "IL",
    "City": "Johnston City"
  },
  {
    "State": "IL",
    "City": "Jonesboro"
  },
  {
    "State": "IL",
    "City": "Joppa"
  },
  {
    "State": "IL",
    "City": "Junction"
  },
  {
    "State": "IL",
    "City": "Karbers Ridge"
  },
  {
    "State": "IL",
    "City": "Karnak"
  },
  {
    "State": "IL",
    "City": "Mc Clure"
  },
  {
    "State": "IL",
    "City": "Makanda"
  },
  {
    "State": "IL",
    "City": "Marion"
  },
  {
    "State": "IL",
    "City": "Metropolis"
  },
  {
    "State": "IL",
    "City": "Millcreek"
  },
  {
    "State": "IL",
    "City": "Miller City"
  },
  {
    "State": "IL",
    "City": "Mound City"
  },
  {
    "State": "IL",
    "City": "Mounds"
  },
  {
    "State": "IL",
    "City": "Muddy"
  },
  {
    "State": "IL",
    "City": "Murphysboro"
  },
  {
    "State": "IL",
    "City": "New Burnside"
  },
  {
    "State": "IL",
    "City": "Olive Branch"
  },
  {
    "State": "IL",
    "City": "Olmsted"
  },
  {
    "State": "IL",
    "City": "Oraville"
  },
  {
    "State": "IL",
    "City": "Ozark"
  },
  {
    "State": "IL",
    "City": "Perks"
  },
  {
    "State": "IL",
    "City": "Pittsburg"
  },
  {
    "State": "IL",
    "City": "Pomona"
  },
  {
    "State": "IL",
    "City": "Pulaski"
  },
  {
    "State": "IL",
    "City": "Raleigh"
  },
  {
    "State": "IL",
    "City": "Ridgway"
  },
  {
    "State": "IL",
    "City": "Rosiclare"
  },
  {
    "State": "IL",
    "City": "Royalton"
  },
  {
    "State": "IL",
    "City": "Shawneetown"
  },
  {
    "State": "IL",
    "City": "Simpson"
  },
  {
    "State": "IL",
    "City": "Stonefort"
  },
  {
    "State": "IL",
    "City": "Tamms"
  },
  {
    "State": "IL",
    "City": "Thebes"
  },
  {
    "State": "IL",
    "City": "Ullin"
  },
  {
    "State": "IL",
    "City": "Unity"
  },
  {
    "State": "IL",
    "City": "Vergennes"
  },
  {
    "State": "IL",
    "City": "Vienna"
  },
  {
    "State": "IL",
    "City": "Villa Ridge"
  },
  {
    "State": "IL",
    "City": "Willisville"
  },
  {
    "State": "IL",
    "City": "Wolf Lake"
  },
  {
    "State": "IL",
    "City": "Zeigler"
  },
  {
    "State": "MO",
    "City": "Allenton"
  },
  {
    "State": "MO",
    "City": "Chesterfield"
  },
  {
    "State": "MO",
    "City": "Arnold"
  },
  {
    "State": "MO",
    "City": "Ballwin"
  },
  {
    "State": "MO",
    "City": "Barnhart"
  },
  {
    "State": "MO",
    "City": "Beaufort"
  },
  {
    "State": "MO",
    "City": "Berger"
  },
  {
    "State": "MO",
    "City": "Catawissa"
  },
  {
    "State": "MO",
    "City": "Cedar Hill"
  },
  {
    "State": "MO",
    "City": "Crystal City"
  },
  {
    "State": "MO",
    "City": "De Soto"
  },
  {
    "State": "MO",
    "City": "Dittmer"
  },
  {
    "State": "MO",
    "City": "Eureka"
  },
  {
    "State": "MO",
    "City": "Fenton"
  },
  {
    "State": "MO",
    "City": "Festus"
  },
  {
    "State": "MO",
    "City": "Fletcher"
  },
  {
    "State": "MO",
    "City": "Florissant"
  },
  {
    "State": "MO",
    "City": "French Village"
  },
  {
    "State": "MO",
    "City": "Gerald"
  },
  {
    "State": "MO",
    "City": "Wildwood"
  },
  {
    "State": "MO",
    "City": "Gray Summit"
  },
  {
    "State": "MO",
    "City": "Grubville"
  },
  {
    "State": "MO",
    "City": "Hazelwood"
  },
  {
    "State": "MO",
    "City": "Maryland Heights"
  },
  {
    "State": "MO",
    "City": "Bridgeton"
  },
  {
    "State": "MO",
    "City": "Earth City"
  },
  {
    "State": "MO",
    "City": "Hematite"
  },
  {
    "State": "MO",
    "City": "Herculaneum"
  },
  {
    "State": "MO",
    "City": "High Ridge"
  },
  {
    "State": "MO",
    "City": "Hillsboro"
  },
  {
    "State": "MO",
    "City": "House Springs"
  },
  {
    "State": "MO",
    "City": "Imperial"
  },
  {
    "State": "MO",
    "City": "Kimmswick"
  },
  {
    "State": "MO",
    "City": "Labadie"
  },
  {
    "State": "MO",
    "City": "Leslie"
  },
  {
    "State": "MO",
    "City": "Liguori"
  },
  {
    "State": "MO",
    "City": "Lonedell"
  },
  {
    "State": "MO",
    "City": "Luebbering"
  },
  {
    "State": "MO",
    "City": "Mapaville"
  },
  {
    "State": "MO",
    "City": "Morse Mill"
  },
  {
    "State": "MO",
    "City": "New Haven"
  },
  {
    "State": "MO",
    "City": "Pacific"
  },
  {
    "State": "MO",
    "City": "Pevely"
  },
  {
    "State": "MO",
    "City": "Richwoods"
  },
  {
    "State": "MO",
    "City": "Robertsville"
  },
  {
    "State": "MO",
    "City": "Saint Albans"
  },
  {
    "State": "MO",
    "City": "Saint Ann"
  },
  {
    "State": "MO",
    "City": "Saint Clair"
  },
  {
    "State": "MO",
    "City": "Stanton"
  },
  {
    "State": "MO",
    "City": "Sullivan"
  },
  {
    "State": "MO",
    "City": "Union"
  },
  {
    "State": "MO",
    "City": "Valles Mines"
  },
  {
    "State": "MO",
    "City": "Valley Park"
  },
  {
    "State": "MO",
    "City": "Villa Ridge"
  },
  {
    "State": "MO",
    "City": "Washington"
  },
  {
    "State": "MO",
    "City": "Rosebud"
  },
  {
    "State": "MO",
    "City": "Saint Louis"
  },
  {
    "State": "MO",
    "City": "Saint Charles"
  },
  {
    "State": "MO",
    "City": "Annada"
  },
  {
    "State": "MO",
    "City": "Augusta"
  },
  {
    "State": "MO",
    "City": "Bellflower"
  },
  {
    "State": "MO",
    "City": "Bowling Green"
  },
  {
    "State": "MO",
    "City": "Clarksville"
  },
  {
    "State": "MO",
    "City": "Cottleville"
  },
  {
    "State": "MO",
    "City": "Curryville"
  },
  {
    "State": "MO",
    "City": "Defiance"
  },
  {
    "State": "MO",
    "City": "Dutzow"
  },
  {
    "State": "MO",
    "City": "Elsberry"
  },
  {
    "State": "MO",
    "City": "Eolia"
  },
  {
    "State": "MO",
    "City": "Farber"
  },
  {
    "State": "MO",
    "City": "Flinthill"
  },
  {
    "State": "MO",
    "City": "Foley"
  },
  {
    "State": "MO",
    "City": "Foristell"
  },
  {
    "State": "MO",
    "City": "Hawk Point"
  },
  {
    "State": "MO",
    "City": "High Hill"
  },
  {
    "State": "MO",
    "City": "Jonesburg"
  },
  {
    "State": "MO",
    "City": "Laddonia"
  },
  {
    "State": "MO",
    "City": "Louisiana"
  },
  {
    "State": "MO",
    "City": "Marthasville"
  },
  {
    "State": "MO",
    "City": "Middletown"
  },
  {
    "State": "MO",
    "City": "Montgomery City"
  },
  {
    "State": "MO",
    "City": "Moscow Mills"
  },
  {
    "State": "MO",
    "City": "New Florence"
  },
  {
    "State": "MO",
    "City": "New Melle"
  },
  {
    "State": "MO",
    "City": "O Fallon"
  },
  {
    "State": "MO",
    "City": "Lake Saint Louis"
  },
  {
    "State": "MO",
    "City": "Old Monroe"
  },
  {
    "State": "MO",
    "City": "Olney"
  },
  {
    "State": "MO",
    "City": "Portage Des Sioux"
  },
  {
    "State": "MO",
    "City": "Saint Peters"
  },
  {
    "State": "MO",
    "City": "Silex"
  },
  {
    "State": "MO",
    "City": "Treloar"
  },
  {
    "State": "MO",
    "City": "Troy"
  },
  {
    "State": "MO",
    "City": "Truesdale"
  },
  {
    "State": "MO",
    "City": "Truxton"
  },
  {
    "State": "MO",
    "City": "Vandalia"
  },
  {
    "State": "MO",
    "City": "Warrenton"
  },
  {
    "State": "MO",
    "City": "Wellsville"
  },
  {
    "State": "MO",
    "City": "Wentzville"
  },
  {
    "State": "MO",
    "City": "West Alton"
  },
  {
    "State": "MO",
    "City": "Whiteside"
  },
  {
    "State": "MO",
    "City": "Williamsburg"
  },
  {
    "State": "MO",
    "City": "Winfield"
  },
  {
    "State": "MO",
    "City": "Wright City"
  },
  {
    "State": "MO",
    "City": "Hannibal"
  },
  {
    "State": "MO",
    "City": "Alexandria"
  },
  {
    "State": "MO",
    "City": "Anabel"
  },
  {
    "State": "MO",
    "City": "Arbela"
  },
  {
    "State": "MO",
    "City": "Ashburn"
  },
  {
    "State": "MO",
    "City": "Bethel"
  },
  {
    "State": "MO",
    "City": "Canton"
  },
  {
    "State": "MO",
    "City": "Center"
  },
  {
    "State": "MO",
    "City": "Clarence"
  },
  {
    "State": "MO",
    "City": "Durham"
  },
  {
    "State": "MO",
    "City": "Emden"
  },
  {
    "State": "MO",
    "City": "Ewing"
  },
  {
    "State": "MO",
    "City": "Frankford"
  },
  {
    "State": "MO",
    "City": "Granger"
  },
  {
    "State": "MO",
    "City": "Hunnewell"
  },
  {
    "State": "MO",
    "City": "Kahoka"
  },
  {
    "State": "MO",
    "City": "Knox City"
  },
  {
    "State": "MO",
    "City": "La Belle"
  },
  {
    "State": "MO",
    "City": "La Grange"
  },
  {
    "State": "MO",
    "City": "Lentner"
  },
  {
    "State": "MO",
    "City": "Leonard"
  },
  {
    "State": "MO",
    "City": "Lewistown"
  },
  {
    "State": "MO",
    "City": "Luray"
  },
  {
    "State": "MO",
    "City": "Maywood"
  },
  {
    "State": "MO",
    "City": "Monroe City"
  },
  {
    "State": "MO",
    "City": "Monticello"
  },
  {
    "State": "MO",
    "City": "Newark"
  },
  {
    "State": "MO",
    "City": "New London"
  },
  {
    "State": "MO",
    "City": "Novelty"
  },
  {
    "State": "MO",
    "City": "Palmyra"
  },
  {
    "State": "MO",
    "City": "Perry"
  },
  {
    "State": "MO",
    "City": "Philadelphia"
  },
  {
    "State": "MO",
    "City": "Plevna"
  },
  {
    "State": "MO",
    "City": "Revere"
  },
  {
    "State": "MO",
    "City": "Saint Patrick"
  },
  {
    "State": "MO",
    "City": "Saverton"
  },
  {
    "State": "MO",
    "City": "Shelbina"
  },
  {
    "State": "MO",
    "City": "Shelbyville"
  },
  {
    "State": "MO",
    "City": "Taylor"
  },
  {
    "State": "MO",
    "City": "Wayland"
  },
  {
    "State": "MO",
    "City": "Williamstown"
  },
  {
    "State": "MO",
    "City": "Wyaconda"
  },
  {
    "State": "MO",
    "City": "Kirksville"
  },
  {
    "State": "MO",
    "City": "Atlanta"
  },
  {
    "State": "MO",
    "City": "Baring"
  },
  {
    "State": "MO",
    "City": "Bevier"
  },
  {
    "State": "MO",
    "City": "Brashear"
  },
  {
    "State": "MO",
    "City": "Callao"
  },
  {
    "State": "MO",
    "City": "Coatsville"
  },
  {
    "State": "MO",
    "City": "Downing"
  },
  {
    "State": "MO",
    "City": "Edina"
  },
  {
    "State": "MO",
    "City": "Elmer"
  },
  {
    "State": "MO",
    "City": "Ethel"
  },
  {
    "State": "MO",
    "City": "Gibbs"
  },
  {
    "State": "MO",
    "City": "Glenwood"
  },
  {
    "State": "MO",
    "City": "Gorin"
  },
  {
    "State": "MO",
    "City": "Green Castle"
  },
  {
    "State": "MO",
    "City": "Green City"
  },
  {
    "State": "MO",
    "City": "Greentop"
  },
  {
    "State": "MO",
    "City": "Hurdland"
  },
  {
    "State": "MO",
    "City": "Lancaster"
  },
  {
    "State": "MO",
    "City": "La Plata"
  },
  {
    "State": "MO",
    "City": "Livonia"
  },
  {
    "State": "MO",
    "City": "Macon"
  },
  {
    "State": "MO",
    "City": "Memphis"
  },
  {
    "State": "MO",
    "City": "Milan"
  },
  {
    "State": "MO",
    "City": "New Boston"
  },
  {
    "State": "MO",
    "City": "New Cambria"
  },
  {
    "State": "MO",
    "City": "Novinger"
  },
  {
    "State": "MO",
    "City": "Pollock"
  },
  {
    "State": "MO",
    "City": "Queen City"
  },
  {
    "State": "MO",
    "City": "Rutledge"
  },
  {
    "State": "MO",
    "City": "Unionville"
  },
  {
    "State": "MO",
    "City": "Winigan"
  },
  {
    "State": "MO",
    "City": "Worthington"
  },
  {
    "State": "MO",
    "City": "Park Hills"
  },
  {
    "State": "MO",
    "City": "Annapolis"
  },
  {
    "State": "MO",
    "City": "Arcadia"
  },
  {
    "State": "MO",
    "City": "Belgrade"
  },
  {
    "State": "MO",
    "City": "Belleview"
  },
  {
    "State": "MO",
    "City": "Bismarck"
  },
  {
    "State": "MO",
    "City": "Black"
  },
  {
    "State": "MO",
    "City": "Blackwell"
  },
  {
    "State": "MO",
    "City": "Bloomsdale"
  },
  {
    "State": "MO",
    "City": "Bonne Terre"
  },
  {
    "State": "MO",
    "City": "Bunker"
  },
  {
    "State": "MO",
    "City": "Cadet"
  },
  {
    "State": "MO",
    "City": "Caledonia"
  },
  {
    "State": "MO",
    "City": "Cascade"
  },
  {
    "State": "MO",
    "City": "Centerville"
  },
  {
    "State": "MO",
    "City": "Des Arc"
  },
  {
    "State": "MO",
    "City": "Doe Run"
  },
  {
    "State": "MO",
    "City": "Ellington"
  },
  {
    "State": "MO",
    "City": "Farmington"
  },
  {
    "State": "MO",
    "City": "Fredericktown"
  },
  {
    "State": "MO",
    "City": "Irondale"
  },
  {
    "State": "MO",
    "City": "Ironton"
  },
  {
    "State": "MO",
    "City": "Knob Lick"
  },
  {
    "State": "MO",
    "City": "Leadwood"
  },
  {
    "State": "MO",
    "City": "Lesterville"
  },
  {
    "State": "MO",
    "City": "Marquand"
  },
  {
    "State": "MO",
    "City": "Middle Brook"
  },
  {
    "State": "MO",
    "City": "Mineral Point"
  },
  {
    "State": "MO",
    "City": "Patton"
  },
  {
    "State": "MO",
    "City": "Pilot Knob"
  },
  {
    "State": "MO",
    "City": "Potosi"
  },
  {
    "State": "MO",
    "City": "Redford"
  },
  {
    "State": "MO",
    "City": "Reynolds"
  },
  {
    "State": "MO",
    "City": "Sainte Genevieve"
  },
  {
    "State": "MO",
    "City": "Saint Mary"
  },
  {
    "State": "MO",
    "City": "Tiff"
  },
  {
    "State": "MO",
    "City": "Vulcan"
  },
  {
    "State": "MO",
    "City": "Cape Girardeau"
  },
  {
    "State": "MO",
    "City": "Advance"
  },
  {
    "State": "MO",
    "City": "Altenburg"
  },
  {
    "State": "MO",
    "City": "Bell City"
  },
  {
    "State": "MO",
    "City": "Benton"
  },
  {
    "State": "MO",
    "City": "Brazeau"
  },
  {
    "State": "MO",
    "City": "Brownwood"
  },
  {
    "State": "MO",
    "City": "Burfordville"
  },
  {
    "State": "MO",
    "City": "Chaffee"
  },
  {
    "State": "MO",
    "City": "Commerce"
  },
  {
    "State": "MO",
    "City": "Daisy"
  },
  {
    "State": "MO",
    "City": "Delta"
  },
  {
    "State": "MO",
    "City": "Dutchtown"
  },
  {
    "State": "MO",
    "City": "Farrar"
  },
  {
    "State": "MO",
    "City": "Friedheim"
  },
  {
    "State": "MO",
    "City": "Frohna"
  },
  {
    "State": "MO",
    "City": "Gipsy"
  },
  {
    "State": "MO",
    "City": "Glenallen"
  },
  {
    "State": "MO",
    "City": "Gordonville"
  },
  {
    "State": "MO",
    "City": "Jackson"
  },
  {
    "State": "MO",
    "City": "Kelso"
  },
  {
    "State": "MO",
    "City": "Leopold"
  },
  {
    "State": "MO",
    "City": "Mc Gee"
  },
  {
    "State": "MO",
    "City": "Marble Hill"
  },
  {
    "State": "MO",
    "City": "Millersville"
  },
  {
    "State": "MO",
    "City": "Morley"
  },
  {
    "State": "MO",
    "City": "Oak Ridge"
  },
  {
    "State": "MO",
    "City": "Old Appleton"
  },
  {
    "State": "MO",
    "City": "Oran"
  },
  {
    "State": "MO",
    "City": "Perkins"
  },
  {
    "State": "MO",
    "City": "Perryville"
  },
  {
    "State": "MO",
    "City": "Mc Bride"
  },
  {
    "State": "MO",
    "City": "Pocahontas"
  },
  {
    "State": "MO",
    "City": "Scott City"
  },
  {
    "State": "MO",
    "City": "Sedgewickville"
  },
  {
    "State": "MO",
    "City": "Sturdivant"
  },
  {
    "State": "MO",
    "City": "Uniontown"
  },
  {
    "State": "MO",
    "City": "Vanduser"
  },
  {
    "State": "MO",
    "City": "Whitewater"
  },
  {
    "State": "MO",
    "City": "Zalma"
  },
  {
    "State": "MO",
    "City": "Sikeston"
  },
  {
    "State": "MO",
    "City": "Anniston"
  },
  {
    "State": "MO",
    "City": "Arbyrd"
  },
  {
    "State": "MO",
    "City": "Bernie"
  },
  {
    "State": "MO",
    "City": "Bertrand"
  },
  {
    "State": "MO",
    "City": "Blodgett"
  },
  {
    "State": "MO",
    "City": "Bloomfield"
  },
  {
    "State": "MO",
    "City": "Braggadocio"
  },
  {
    "State": "MO",
    "City": "Bragg City"
  },
  {
    "State": "MO",
    "City": "Canalou"
  },
  {
    "State": "MO",
    "City": "Cardwell"
  },
  {
    "State": "MO",
    "City": "Caruthersville"
  },
  {
    "State": "MO",
    "City": "Catron"
  },
  {
    "State": "MO",
    "City": "Charleston"
  },
  {
    "State": "MO",
    "City": "Clarkton"
  },
  {
    "State": "MO",
    "City": "Cooter"
  },
  {
    "State": "MO",
    "City": "Deering"
  },
  {
    "State": "MO",
    "City": "Dexter"
  },
  {
    "State": "MO",
    "City": "East Prairie"
  },
  {
    "State": "MO",
    "City": "Essex"
  },
  {
    "State": "MO",
    "City": "Gibson"
  },
  {
    "State": "MO",
    "City": "Gideon"
  },
  {
    "State": "MO",
    "City": "Gobler"
  },
  {
    "State": "MO",
    "City": "Grayridge"
  },
  {
    "State": "MO",
    "City": "Hayti"
  },
  {
    "State": "MO",
    "City": "Holcomb"
  },
  {
    "State": "MO",
    "City": "Holland"
  },
  {
    "State": "MO",
    "City": "Hornersville"
  },
  {
    "State": "MO",
    "City": "Kennett"
  },
  {
    "State": "MO",
    "City": "Kewanee"
  },
  {
    "State": "MO",
    "City": "Lilbourn"
  },
  {
    "State": "MO",
    "City": "Malden"
  },
  {
    "State": "MO",
    "City": "Marston"
  },
  {
    "State": "MO",
    "City": "Matthews"
  },
  {
    "State": "MO",
    "City": "Morehouse"
  },
  {
    "State": "MO",
    "City": "New Madrid"
  },
  {
    "State": "MO",
    "City": "Parma"
  },
  {
    "State": "MO",
    "City": "Portageville"
  },
  {
    "State": "MO",
    "City": "Risco"
  },
  {
    "State": "MO",
    "City": "Rives"
  },
  {
    "State": "MO",
    "City": "Senath"
  },
  {
    "State": "MO",
    "City": "Steele"
  },
  {
    "State": "MO",
    "City": "Tallapoosa"
  },
  {
    "State": "MO",
    "City": "Wardell"
  },
  {
    "State": "MO",
    "City": "Whiteoak"
  },
  {
    "State": "MO",
    "City": "Wolf Island"
  },
  {
    "State": "MO",
    "City": "Wyatt"
  },
  {
    "State": "MO",
    "City": "Poplar Bluff"
  },
  {
    "State": "MO",
    "City": "Briar"
  },
  {
    "State": "MO",
    "City": "Broseley"
  },
  {
    "State": "MO",
    "City": "Campbell"
  },
  {
    "State": "MO",
    "City": "Clubb"
  },
  {
    "State": "MO",
    "City": "Doniphan"
  },
  {
    "State": "MO",
    "City": "Dudley"
  },
  {
    "State": "MO",
    "City": "Ellsinore"
  },
  {
    "State": "MO",
    "City": "Fagus"
  },
  {
    "State": "MO",
    "City": "Fairdealing"
  },
  {
    "State": "MO",
    "City": "Fisk"
  },
  {
    "State": "MO",
    "City": "Fremont"
  },
  {
    "State": "MO",
    "City": "Gatewood"
  },
  {
    "State": "MO",
    "City": "Grandin"
  },
  {
    "State": "MO",
    "City": "Greenville"
  },
  {
    "State": "MO",
    "City": "Harviell"
  },
  {
    "State": "MO",
    "City": "Lodi"
  },
  {
    "State": "MO",
    "City": "Lowndes"
  },
  {
    "State": "MO",
    "City": "Mill Spring"
  },
  {
    "State": "MO",
    "City": "Naylor"
  },
  {
    "State": "MO",
    "City": "Neelyville"
  },
  {
    "State": "MO",
    "City": "Oxly"
  },
  {
    "State": "MO",
    "City": "Patterson"
  },
  {
    "State": "MO",
    "City": "Piedmont"
  },
  {
    "State": "MO",
    "City": "Puxico"
  },
  {
    "State": "MO",
    "City": "Qulin"
  },
  {
    "State": "MO",
    "City": "Rombauer"
  },
  {
    "State": "MO",
    "City": "Shook"
  },
  {
    "State": "MO",
    "City": "Silva"
  },
  {
    "State": "MO",
    "City": "Van Buren"
  },
  {
    "State": "MO",
    "City": "Wappapello"
  },
  {
    "State": "MO",
    "City": "Williamsville"
  },
  {
    "State": "MO",
    "City": "Alma"
  },
  {
    "State": "MO",
    "City": "Lees Summit"
  },
  {
    "State": "MO",
    "City": "Bates City"
  },
  {
    "State": "MO",
    "City": "Belton"
  },
  {
    "State": "MO",
    "City": "Blue Springs"
  },
  {
    "State": "MO",
    "City": "Buckner"
  },
  {
    "State": "MO",
    "City": "Camden"
  },
  {
    "State": "MO",
    "City": "Camden Point"
  },
  {
    "State": "MO",
    "City": "Centerview"
  },
  {
    "State": "MO",
    "City": "Concordia"
  },
  {
    "State": "MO",
    "City": "Corder"
  },
  {
    "State": "MO",
    "City": "Dover"
  },
  {
    "State": "MO",
    "City": "Excelsior Springs"
  },
  {
    "State": "MO",
    "City": "Farley"
  },
  {
    "State": "MO",
    "City": "Grain Valley"
  },
  {
    "State": "MO",
    "City": "Grandview"
  },
  {
    "State": "MO",
    "City": "Greenwood"
  },
  {
    "State": "MO",
    "City": "Hardin"
  },
  {
    "State": "MO",
    "City": "Henrietta"
  },
  {
    "State": "MO",
    "City": "Higginsville"
  },
  {
    "State": "MO",
    "City": "Holden"
  },
  {
    "State": "MO",
    "City": "Holt"
  },
  {
    "State": "MO",
    "City": "Independence"
  },
  {
    "State": "MO",
    "City": "Kearney"
  },
  {
    "State": "MO",
    "City": "Kingsville"
  },
  {
    "State": "MO",
    "City": "Lawson"
  },
  {
    "State": "MO",
    "City": "Levasy"
  },
  {
    "State": "MO",
    "City": "Lexington"
  },
  {
    "State": "MO",
    "City": "Liberty"
  },
  {
    "State": "MO",
    "City": "Lone Jack"
  },
  {
    "State": "MO",
    "City": "Mayview"
  },
  {
    "State": "MO",
    "City": "Missouri City"
  },
  {
    "State": "MO",
    "City": "Mosby"
  },
  {
    "State": "MO",
    "City": "Napoleon"
  },
  {
    "State": "MO",
    "City": "Oak Grove"
  },
  {
    "State": "MO",
    "City": "Odessa"
  },
  {
    "State": "MO",
    "City": "Orrick"
  },
  {
    "State": "MO",
    "City": "Peculiar"
  },
  {
    "State": "MO",
    "City": "Platte City"
  },
  {
    "State": "MO",
    "City": "Pleasant Hill"
  },
  {
    "State": "MO",
    "City": "Raymore"
  },
  {
    "State": "MO",
    "City": "Rayville"
  },
  {
    "State": "MO",
    "City": "Richmond"
  },
  {
    "State": "MO",
    "City": "Sibley"
  },
  {
    "State": "MO",
    "City": "Smithville"
  },
  {
    "State": "MO",
    "City": "Strasburg"
  },
  {
    "State": "MO",
    "City": "Waldron"
  },
  {
    "State": "MO",
    "City": "Warrensburg"
  },
  {
    "State": "MO",
    "City": "Waverly"
  },
  {
    "State": "MO",
    "City": "Wellington"
  },
  {
    "State": "MO",
    "City": "Weston"
  },
  {
    "State": "MO",
    "City": "Kansas City"
  },
  {
    "State": "MO",
    "City": "Riverside"
  },
  {
    "State": "MO",
    "City": "Agency"
  },
  {
    "State": "MO",
    "City": "Albany"
  },
  {
    "State": "MO",
    "City": "Allendale"
  },
  {
    "State": "MO",
    "City": "Amazonia"
  },
  {
    "State": "MO",
    "City": "Amity"
  },
  {
    "State": "MO",
    "City": "Barnard"
  },
  {
    "State": "MO",
    "City": "Bethany"
  },
  {
    "State": "MO",
    "City": "Blythedale"
  },
  {
    "State": "MO",
    "City": "Bolckow"
  },
  {
    "State": "MO",
    "City": "Burlington Junction"
  },
  {
    "State": "MO",
    "City": "Cameron"
  },
  {
    "State": "MO",
    "City": "Clarksdale"
  },
  {
    "State": "MO",
    "City": "Clearmont"
  },
  {
    "State": "MO",
    "City": "Clyde"
  },
  {
    "State": "MO",
    "City": "Conception"
  },
  {
    "State": "MO",
    "City": "Conception Junction"
  },
  {
    "State": "MO",
    "City": "Cosby"
  },
  {
    "State": "MO",
    "City": "Craig"
  },
  {
    "State": "MO",
    "City": "Darlington"
  },
  {
    "State": "MO",
    "City": "Dearborn"
  },
  {
    "State": "MO",
    "City": "De Kalb"
  },
  {
    "State": "MO",
    "City": "Denver"
  },
  {
    "State": "MO",
    "City": "Eagleville"
  },
  {
    "State": "MO",
    "City": "Easton"
  },
  {
    "State": "MO",
    "City": "Edgerton"
  },
  {
    "State": "MO",
    "City": "Elmo"
  },
  {
    "State": "MO",
    "City": "Fairfax"
  },
  {
    "State": "MO",
    "City": "Maysville"
  },
  {
    "State": "MO",
    "City": "Faucett"
  },
  {
    "State": "MO",
    "City": "Fillmore"
  },
  {
    "State": "MO",
    "City": "Forest City"
  },
  {
    "State": "MO",
    "City": "Gentry"
  },
  {
    "State": "MO",
    "City": "Gower"
  },
  {
    "State": "MO",
    "City": "Graham"
  },
  {
    "State": "MO",
    "City": "Grant City"
  },
  {
    "State": "MO",
    "City": "Guilford"
  },
  {
    "State": "MO",
    "City": "Hatfield"
  },
  {
    "State": "MO",
    "City": "Helena"
  },
  {
    "State": "MO",
    "City": "Hopkins"
  },
  {
    "State": "MO",
    "City": "King City"
  },
  {
    "State": "MO",
    "City": "Lathrop"
  },
  {
    "State": "MO",
    "City": "Maitland"
  },
  {
    "State": "MO",
    "City": "Martinsville"
  },
  {
    "State": "MO",
    "City": "Maryville"
  },
  {
    "State": "MO",
    "City": "Mound City"
  },
  {
    "State": "MO",
    "City": "New Hampton"
  },
  {
    "State": "MO",
    "City": "Oregon"
  },
  {
    "State": "MO",
    "City": "Osborn"
  },
  {
    "State": "MO",
    "City": "Parnell"
  },
  {
    "State": "MO",
    "City": "Pickering"
  },
  {
    "State": "MO",
    "City": "Plattsburg"
  },
  {
    "State": "MO",
    "City": "Ravenwood"
  },
  {
    "State": "MO",
    "City": "Rea"
  },
  {
    "State": "MO",
    "City": "Ridgeway"
  },
  {
    "State": "MO",
    "City": "Rock Port"
  },
  {
    "State": "MO",
    "City": "Rosendale"
  },
  {
    "State": "MO",
    "City": "Rushville"
  },
  {
    "State": "MO",
    "City": "Savannah"
  },
  {
    "State": "MO",
    "City": "Sheridan"
  },
  {
    "State": "MO",
    "City": "Skidmore"
  },
  {
    "State": "MO",
    "City": "Stanberry"
  },
  {
    "State": "MO",
    "City": "Stewartsville"
  },
  {
    "State": "MO",
    "City": "Tarkio"
  },
  {
    "State": "MO",
    "City": "Trimble"
  },
  {
    "State": "MO",
    "City": "Turney"
  },
  {
    "State": "MO",
    "City": "Union Star"
  },
  {
    "State": "MO",
    "City": "Watson"
  },
  {
    "State": "MO",
    "City": "Weatherby"
  },
  {
    "State": "MO",
    "City": "Westboro"
  },
  {
    "State": "MO",
    "City": "Worth"
  },
  {
    "State": "MO",
    "City": "Saint Joseph"
  },
  {
    "State": "MO",
    "City": "Chillicothe"
  },
  {
    "State": "MO",
    "City": "Altamont"
  },
  {
    "State": "MO",
    "City": "Bogard"
  },
  {
    "State": "MO",
    "City": "Bosworth"
  },
  {
    "State": "MO",
    "City": "Braymer"
  },
  {
    "State": "MO",
    "City": "Breckenridge"
  },
  {
    "State": "MO",
    "City": "Brookfield"
  },
  {
    "State": "MO",
    "City": "Browning"
  },
  {
    "State": "MO",
    "City": "Bucklin"
  },
  {
    "State": "MO",
    "City": "Cainsville"
  },
  {
    "State": "MO",
    "City": "Carrollton"
  },
  {
    "State": "MO",
    "City": "Chula"
  },
  {
    "State": "MO",
    "City": "Coffey"
  },
  {
    "State": "MO",
    "City": "Cowgill"
  },
  {
    "State": "MO",
    "City": "Dawn"
  },
  {
    "State": "MO",
    "City": "De Witt"
  },
  {
    "State": "MO",
    "City": "Gallatin"
  },
  {
    "State": "MO",
    "City": "Galt"
  },
  {
    "State": "MO",
    "City": "Gilman City"
  },
  {
    "State": "MO",
    "City": "Hale"
  },
  {
    "State": "MO",
    "City": "Hamilton"
  },
  {
    "State": "MO",
    "City": "Harris"
  },
  {
    "State": "MO",
    "City": "Humphreys"
  },
  {
    "State": "MO",
    "City": "Jameson"
  },
  {
    "State": "MO",
    "City": "Jamesport"
  },
  {
    "State": "MO",
    "City": "Kidder"
  },
  {
    "State": "MO",
    "City": "Kingston"
  },
  {
    "State": "MO",
    "City": "Laclede"
  },
  {
    "State": "MO",
    "City": "Laredo"
  },
  {
    "State": "MO",
    "City": "Linneus"
  },
  {
    "State": "MO",
    "City": "Lock Springs"
  },
  {
    "State": "MO",
    "City": "Lucerne"
  },
  {
    "State": "MO",
    "City": "Ludlow"
  },
  {
    "State": "MO",
    "City": "Mc Fall"
  },
  {
    "State": "MO",
    "City": "Marceline"
  },
  {
    "State": "MO",
    "City": "Meadville"
  },
  {
    "State": "MO",
    "City": "Mendon"
  },
  {
    "State": "MO",
    "City": "Mercer"
  },
  {
    "State": "MO",
    "City": "Mooresville"
  },
  {
    "State": "MO",
    "City": "Newtown"
  },
  {
    "State": "MO",
    "City": "Norborne"
  },
  {
    "State": "MO",
    "City": "Pattonsburg"
  },
  {
    "State": "MO",
    "City": "Polo"
  },
  {
    "State": "MO",
    "City": "Powersville"
  },
  {
    "State": "MO",
    "City": "Princeton"
  },
  {
    "State": "MO",
    "City": "Purdin"
  },
  {
    "State": "MO",
    "City": "Rothville"
  },
  {
    "State": "MO",
    "City": "Spickard"
  },
  {
    "State": "MO",
    "City": "Stet"
  },
  {
    "State": "MO",
    "City": "Sumner"
  },
  {
    "State": "MO",
    "City": "Tina"
  },
  {
    "State": "MO",
    "City": "Trenton"
  },
  {
    "State": "MO",
    "City": "Utica"
  },
  {
    "State": "MO",
    "City": "Wheeling"
  },
  {
    "State": "MO",
    "City": "Winston"
  },
  {
    "State": "MO",
    "City": "Harrisonville"
  },
  {
    "State": "MO",
    "City": "Adrian"
  },
  {
    "State": "MO",
    "City": "Amoret"
  },
  {
    "State": "MO",
    "City": "Amsterdam"
  },
  {
    "State": "MO",
    "City": "Appleton City"
  },
  {
    "State": "MO",
    "City": "Archie"
  },
  {
    "State": "MO",
    "City": "Blairstown"
  },
  {
    "State": "MO",
    "City": "Bronaugh"
  },
  {
    "State": "MO",
    "City": "Butler"
  },
  {
    "State": "MO",
    "City": "Chilhowee"
  },
  {
    "State": "MO",
    "City": "Cleveland"
  },
  {
    "State": "MO",
    "City": "Clinton"
  },
  {
    "State": "MO",
    "City": "Collins"
  },
  {
    "State": "MO",
    "City": "Creighton"
  },
  {
    "State": "MO",
    "City": "Deepwater"
  },
  {
    "State": "MO",
    "City": "Deerfield"
  },
  {
    "State": "MO",
    "City": "Drexel"
  },
  {
    "State": "MO",
    "City": "East Lynne"
  },
  {
    "State": "MO",
    "City": "El Dorado Springs"
  },
  {
    "State": "MO",
    "City": "Foster"
  },
  {
    "State": "MO",
    "City": "Freeman"
  },
  {
    "State": "MO",
    "City": "Garden City"
  },
  {
    "State": "MO",
    "City": "Golden City"
  },
  {
    "State": "MO",
    "City": "Harwood"
  },
  {
    "State": "MO",
    "City": "Hume"
  },
  {
    "State": "MO",
    "City": "Jasper"
  },
  {
    "State": "MO",
    "City": "Jerico Springs"
  },
  {
    "State": "MO",
    "City": "Lamar"
  },
  {
    "State": "MO",
    "City": "Leeton"
  },
  {
    "State": "MO",
    "City": "Liberal"
  },
  {
    "State": "MO",
    "City": "Lowry City"
  },
  {
    "State": "MO",
    "City": "Metz"
  },
  {
    "State": "MO",
    "City": "Milford"
  },
  {
    "State": "MO",
    "City": "Milo"
  },
  {
    "State": "MO",
    "City": "Mindenmines"
  },
  {
    "State": "MO",
    "City": "Montrose"
  },
  {
    "State": "MO",
    "City": "Moundville"
  },
  {
    "State": "MO",
    "City": "Nevada"
  },
  {
    "State": "MO",
    "City": "Osceola"
  },
  {
    "State": "MO",
    "City": "Richards"
  },
  {
    "State": "MO",
    "City": "Rich Hill"
  },
  {
    "State": "MO",
    "City": "Rockville"
  },
  {
    "State": "MO",
    "City": "Roscoe"
  },
  {
    "State": "MO",
    "City": "Schell City"
  },
  {
    "State": "MO",
    "City": "Sheldon"
  },
  {
    "State": "MO",
    "City": "Urich"
  },
  {
    "State": "MO",
    "City": "Walker"
  },
  {
    "State": "MO",
    "City": "Joplin"
  },
  {
    "State": "MO",
    "City": "Alba"
  },
  {
    "State": "MO",
    "City": "Anderson"
  },
  {
    "State": "MO",
    "City": "Asbury"
  },
  {
    "State": "MO",
    "City": "Avilla"
  },
  {
    "State": "MO",
    "City": "Carl Junction"
  },
  {
    "State": "MO",
    "City": "Carterville"
  },
  {
    "State": "MO",
    "City": "Carthage"
  },
  {
    "State": "MO",
    "City": "Diamond"
  },
  {
    "State": "MO",
    "City": "Duenweg"
  },
  {
    "State": "MO",
    "City": "Fairview"
  },
  {
    "State": "MO",
    "City": "Goodman"
  },
  {
    "State": "MO",
    "City": "Granby"
  },
  {
    "State": "MO",
    "City": "Lanagan"
  },
  {
    "State": "MO",
    "City": "La Russell"
  },
  {
    "State": "MO",
    "City": "Neck City"
  },
  {
    "State": "MO",
    "City": "Neosho"
  },
  {
    "State": "MO",
    "City": "Newtonia"
  },
  {
    "State": "MO",
    "City": "Noel"
  },
  {
    "State": "MO",
    "City": "Oronogo"
  },
  {
    "State": "MO",
    "City": "Pineville"
  },
  {
    "State": "MO",
    "City": "Purcell"
  },
  {
    "State": "MO",
    "City": "Racine"
  },
  {
    "State": "MO",
    "City": "Reeds"
  },
  {
    "State": "MO",
    "City": "Rocky Comfort"
  },
  {
    "State": "MO",
    "City": "Sarcoxie"
  },
  {
    "State": "MO",
    "City": "South West City"
  },
  {
    "State": "MO",
    "City": "Saginaw"
  },
  {
    "State": "MO",
    "City": "Seneca"
  },
  {
    "State": "MO",
    "City": "Stark City"
  },
  {
    "State": "MO",
    "City": "Stella"
  },
  {
    "State": "MO",
    "City": "Tiff City"
  },
  {
    "State": "MO",
    "City": "Waco"
  },
  {
    "State": "MO",
    "City": "Webb City"
  },
  {
    "State": "MO",
    "City": "Wentworth"
  },
  {
    "State": "MO",
    "City": "Wheaton"
  },
  {
    "State": "MO",
    "City": "Argyle"
  },
  {
    "State": "MO",
    "City": "Ashland"
  },
  {
    "State": "MO",
    "City": "Barnett"
  },
  {
    "State": "MO",
    "City": "Belle"
  },
  {
    "State": "MO",
    "City": "Bland"
  },
  {
    "State": "MO",
    "City": "Bonnots Mill"
  },
  {
    "State": "MO",
    "City": "Brumley"
  },
  {
    "State": "MO",
    "City": "California"
  },
  {
    "State": "MO",
    "City": "Camdenton"
  },
  {
    "State": "MO",
    "City": "Centertown"
  },
  {
    "State": "MO",
    "City": "Chamois"
  },
  {
    "State": "MO",
    "City": "Clarksburg"
  },
  {
    "State": "MO",
    "City": "Eldon"
  },
  {
    "State": "MO",
    "City": "Eugene"
  },
  {
    "State": "MO",
    "City": "Fortuna"
  },
  {
    "State": "MO",
    "City": "Freeburg"
  },
  {
    "State": "MO",
    "City": "Gasconade"
  },
  {
    "State": "MO",
    "City": "Gravois Mills"
  },
  {
    "State": "MO",
    "City": "Laurie"
  },
  {
    "State": "MO",
    "City": "Hartsburg"
  },
  {
    "State": "MO",
    "City": "Henley"
  },
  {
    "State": "MO",
    "City": "Hermann"
  },
  {
    "State": "MO",
    "City": "High Point"
  },
  {
    "State": "MO",
    "City": "Holts Summit"
  },
  {
    "State": "MO",
    "City": "Jamestown"
  },
  {
    "State": "MO",
    "City": "Kaiser"
  },
  {
    "State": "MO",
    "City": "Koeltztown"
  },
  {
    "State": "MO",
    "City": "Lake Ozark"
  },
  {
    "State": "MO",
    "City": "Latham"
  },
  {
    "State": "MO",
    "City": "Linn"
  },
  {
    "State": "MO",
    "City": "Linn Creek"
  },
  {
    "State": "MO",
    "City": "Lohman"
  },
  {
    "State": "MO",
    "City": "Loose Creek"
  },
  {
    "State": "MO",
    "City": "Mc Girk"
  },
  {
    "State": "MO",
    "City": "Meta"
  },
  {
    "State": "MO",
    "City": "Mokane"
  },
  {
    "State": "MO",
    "City": "Morrison"
  },
  {
    "State": "MO",
    "City": "Mount Sterling"
  },
  {
    "State": "MO",
    "City": "New Bloomfield"
  },
  {
    "State": "MO",
    "City": "Olean"
  },
  {
    "State": "MO",
    "City": "Osage Beach"
  },
  {
    "State": "MO",
    "City": "Owensville"
  },
  {
    "State": "MO",
    "City": "Portland"
  },
  {
    "State": "MO",
    "City": "Prairie Home"
  },
  {
    "State": "MO",
    "City": "Rhineland"
  },
  {
    "State": "MO",
    "City": "Rocky Mount"
  },
  {
    "State": "MO",
    "City": "Russellville"
  },
  {
    "State": "MO",
    "City": "Saint Elizabeth"
  },
  {
    "State": "MO",
    "City": "Saint Thomas"
  },
  {
    "State": "MO",
    "City": "Steedman"
  },
  {
    "State": "MO",
    "City": "Stover"
  },
  {
    "State": "MO",
    "City": "Sunrise Beach"
  },
  {
    "State": "MO",
    "City": "Tebbetts"
  },
  {
    "State": "MO",
    "City": "Tipton"
  },
  {
    "State": "MO",
    "City": "Tuscumbia"
  },
  {
    "State": "MO",
    "City": "Ulman"
  },
  {
    "State": "MO",
    "City": "Versailles"
  },
  {
    "State": "MO",
    "City": "Westphalia"
  },
  {
    "State": "MO",
    "City": "Jefferson City"
  },
  {
    "State": "MO",
    "City": "Columbia"
  },
  {
    "State": "MO",
    "City": "Armstrong"
  },
  {
    "State": "MO",
    "City": "Auxvasse"
  },
  {
    "State": "MO",
    "City": "Benton City"
  },
  {
    "State": "MO",
    "City": "Boonville"
  },
  {
    "State": "MO",
    "City": "Brunswick"
  },
  {
    "State": "MO",
    "City": "Bunceton"
  },
  {
    "State": "MO",
    "City": "Cairo"
  },
  {
    "State": "MO",
    "City": "Centralia"
  },
  {
    "State": "MO",
    "City": "Clark"
  },
  {
    "State": "MO",
    "City": "Clifton Hill"
  },
  {
    "State": "MO",
    "City": "Dalton"
  },
  {
    "State": "MO",
    "City": "Excello"
  },
  {
    "State": "MO",
    "City": "Fayette"
  },
  {
    "State": "MO",
    "City": "Franklin"
  },
  {
    "State": "MO",
    "City": "Fulton"
  },
  {
    "State": "MO",
    "City": "Glasgow"
  },
  {
    "State": "MO",
    "City": "Hallsville"
  },
  {
    "State": "MO",
    "City": "Harrisburg"
  },
  {
    "State": "MO",
    "City": "Higbee"
  },
  {
    "State": "MO",
    "City": "Holliday"
  },
  {
    "State": "MO",
    "City": "Huntsville"
  },
  {
    "State": "MO",
    "City": "Jacksonville"
  },
  {
    "State": "MO",
    "City": "Keytesville"
  },
  {
    "State": "MO",
    "City": "Kingdom City"
  },
  {
    "State": "MO",
    "City": "Madison"
  },
  {
    "State": "MO",
    "City": "Martinsburg"
  },
  {
    "State": "MO",
    "City": "Mexico"
  },
  {
    "State": "MO",
    "City": "Moberly"
  },
  {
    "State": "MO",
    "City": "New Franklin"
  },
  {
    "State": "MO",
    "City": "Paris"
  },
  {
    "State": "MO",
    "City": "Pilot Grove"
  },
  {
    "State": "MO",
    "City": "Renick"
  },
  {
    "State": "MO",
    "City": "Rocheport"
  },
  {
    "State": "MO",
    "City": "Rush Hill"
  },
  {
    "State": "MO",
    "City": "Salisbury"
  },
  {
    "State": "MO",
    "City": "Santa Fe"
  },
  {
    "State": "MO",
    "City": "Stoutsville"
  },
  {
    "State": "MO",
    "City": "Sturgeon"
  },
  {
    "State": "MO",
    "City": "Thompson"
  },
  {
    "State": "MO",
    "City": "Triplett"
  },
  {
    "State": "MO",
    "City": "Wooldridge"
  },
  {
    "State": "MO",
    "City": "Sedalia"
  },
  {
    "State": "MO",
    "City": "Whiteman Air Force Base"
  },
  {
    "State": "MO",
    "City": "Arrow Rock"
  },
  {
    "State": "MO",
    "City": "Blackburn"
  },
  {
    "State": "MO",
    "City": "Blackwater"
  },
  {
    "State": "MO",
    "City": "Calhoun"
  },
  {
    "State": "MO",
    "City": "Climax Springs"
  },
  {
    "State": "MO",
    "City": "Cole Camp"
  },
  {
    "State": "MO",
    "City": "Edwards"
  },
  {
    "State": "MO",
    "City": "Emma"
  },
  {
    "State": "MO",
    "City": "Florence"
  },
  {
    "State": "MO",
    "City": "Gilliam"
  },
  {
    "State": "MO",
    "City": "Green Ridge"
  },
  {
    "State": "MO",
    "City": "Houstonia"
  },
  {
    "State": "MO",
    "City": "Hughesville"
  },
  {
    "State": "MO",
    "City": "Ionia"
  },
  {
    "State": "MO",
    "City": "Knob Noster"
  },
  {
    "State": "MO",
    "City": "La Monte"
  },
  {
    "State": "MO",
    "City": "Lincoln"
  },
  {
    "State": "MO",
    "City": "Malta Bend"
  },
  {
    "State": "MO",
    "City": "Marshall"
  },
  {
    "State": "MO",
    "City": "Miami"
  },
  {
    "State": "MO",
    "City": "Mora"
  },
  {
    "State": "MO",
    "City": "Nelson"
  },
  {
    "State": "MO",
    "City": "Otterville"
  },
  {
    "State": "MO",
    "City": "Slater"
  },
  {
    "State": "MO",
    "City": "Smithton"
  },
  {
    "State": "MO",
    "City": "Sweet Springs"
  },
  {
    "State": "MO",
    "City": "Syracuse"
  },
  {
    "State": "MO",
    "City": "Warsaw"
  },
  {
    "State": "MO",
    "City": "Windsor"
  },
  {
    "State": "MO",
    "City": "Rolla"
  },
  {
    "State": "MO",
    "City": "Beulah"
  },
  {
    "State": "MO",
    "City": "Birch Tree"
  },
  {
    "State": "MO",
    "City": "Bixby"
  },
  {
    "State": "MO",
    "City": "Boss"
  },
  {
    "State": "MO",
    "City": "Bourbon"
  },
  {
    "State": "MO",
    "City": "Brinktown"
  },
  {
    "State": "MO",
    "City": "Bucyrus"
  },
  {
    "State": "MO",
    "City": "Cherryville"
  },
  {
    "State": "MO",
    "City": "Cook Sta"
  },
  {
    "State": "MO",
    "City": "Crocker"
  },
  {
    "State": "MO",
    "City": "Cuba"
  },
  {
    "State": "MO",
    "City": "Davisville"
  },
  {
    "State": "MO",
    "City": "Devils Elbow"
  },
  {
    "State": "MO",
    "City": "Dixon"
  },
  {
    "State": "MO",
    "City": "Duke"
  },
  {
    "State": "MO",
    "City": "Edgar Springs"
  },
  {
    "State": "MO",
    "City": "Eldridge"
  },
  {
    "State": "MO",
    "City": "Elk Creek"
  },
  {
    "State": "MO",
    "City": "Eminence"
  },
  {
    "State": "MO",
    "City": "Eunice"
  },
  {
    "State": "MO",
    "City": "Falcon"
  },
  {
    "State": "MO",
    "City": "Fort Leonard Wood"
  },
  {
    "State": "MO",
    "City": "Hartshorn"
  },
  {
    "State": "MO",
    "City": "Houston"
  },
  {
    "State": "MO",
    "City": "Huggins"
  },
  {
    "State": "MO",
    "City": "Iberia"
  },
  {
    "State": "MO",
    "City": "Jadwin"
  },
  {
    "State": "MO",
    "City": "Jerome"
  },
  {
    "State": "MO",
    "City": "Lake Spring"
  },
  {
    "State": "MO",
    "City": "Laquey"
  },
  {
    "State": "MO",
    "City": "Leasburg"
  },
  {
    "State": "MO",
    "City": "Lebanon"
  },
  {
    "State": "MO",
    "City": "Lenox"
  },
  {
    "State": "MO",
    "City": "Licking"
  },
  {
    "State": "MO",
    "City": "Lynchburg"
  },
  {
    "State": "MO",
    "City": "Montier"
  },
  {
    "State": "MO",
    "City": "Mountain View"
  },
  {
    "State": "MO",
    "City": "Newburg"
  },
  {
    "State": "MO",
    "City": "Plato"
  },
  {
    "State": "MO",
    "City": "Raymondville"
  },
  {
    "State": "MO",
    "City": "Richland"
  },
  {
    "State": "MO",
    "City": "Roby"
  },
  {
    "State": "MO",
    "City": "Saint James"
  },
  {
    "State": "MO",
    "City": "Salem"
  },
  {
    "State": "MO",
    "City": "Solo"
  },
  {
    "State": "MO",
    "City": "Steelville"
  },
  {
    "State": "MO",
    "City": "Viburnum"
  },
  {
    "State": "MO",
    "City": "Stoutland"
  },
  {
    "State": "MO",
    "City": "Success"
  },
  {
    "State": "MO",
    "City": "Summersville"
  },
  {
    "State": "MO",
    "City": "Vichy"
  },
  {
    "State": "MO",
    "City": "Vienna"
  },
  {
    "State": "MO",
    "City": "Waynesville"
  },
  {
    "State": "MO",
    "City": "Saint Robert"
  },
  {
    "State": "MO",
    "City": "Wesco"
  },
  {
    "State": "MO",
    "City": "Winona"
  },
  {
    "State": "MO",
    "City": "Yukon"
  },
  {
    "State": "MO",
    "City": "Long Lane"
  },
  {
    "State": "MO",
    "City": "Montreal"
  },
  {
    "State": "MO",
    "City": "Aldrich"
  },
  {
    "State": "MO",
    "City": "Arcola"
  },
  {
    "State": "MO",
    "City": "Ash Grove"
  },
  {
    "State": "MO",
    "City": "Aurora"
  },
  {
    "State": "MO",
    "City": "Alton"
  },
  {
    "State": "MO",
    "City": "Caplinger Mills"
  },
  {
    "State": "MO",
    "City": "Ava"
  },
  {
    "State": "MO",
    "City": "Bakersfield"
  },
  {
    "State": "MO",
    "City": "Billings"
  },
  {
    "State": "MO",
    "City": "Blue Eye"
  },
  {
    "State": "MO",
    "City": "Bois D Arc"
  },
  {
    "State": "MO",
    "City": "Bolivar"
  },
  {
    "State": "MO",
    "City": "Bradleyville"
  },
  {
    "State": "MO",
    "City": "Branson"
  },
  {
    "State": "MO",
    "City": "Brighton"
  },
  {
    "State": "MO",
    "City": "Brixey"
  },
  {
    "State": "MO",
    "City": "Brookline"
  },
  {
    "State": "MO",
    "City": "Bruner"
  },
  {
    "State": "MO",
    "City": "Buffalo"
  },
  {
    "State": "MO",
    "City": "Butterfield"
  },
  {
    "State": "MO",
    "City": "Cape Fair"
  },
  {
    "State": "MO",
    "City": "Cassville"
  },
  {
    "State": "MO",
    "City": "Caulfield"
  },
  {
    "State": "MO",
    "City": "Cedarcreek"
  },
  {
    "State": "MO",
    "City": "Chadwick"
  },
  {
    "State": "MO",
    "City": "Chestnutridge"
  },
  {
    "State": "MO",
    "City": "Clever"
  },
  {
    "State": "MO",
    "City": "Conway"
  },
  {
    "State": "MO",
    "City": "Crane"
  },
  {
    "State": "MO",
    "City": "Cross Timbers"
  },
  {
    "State": "MO",
    "City": "Dadeville"
  },
  {
    "State": "MO",
    "City": "Diggins"
  },
  {
    "State": "MO",
    "City": "Dora"
  },
  {
    "State": "MO",
    "City": "Drury"
  },
  {
    "State": "MO",
    "City": "Dunnegan"
  },
  {
    "State": "MO",
    "City": "Eagle Rock"
  },
  {
    "State": "MO",
    "City": "Elkland"
  },
  {
    "State": "MO",
    "City": "Morrisville"
  },
  {
    "State": "MO",
    "City": "Everton"
  },
  {
    "State": "MO",
    "City": "Exeter"
  },
  {
    "State": "MO",
    "City": "Fair Grove"
  },
  {
    "State": "MO",
    "City": "Fair Play"
  },
  {
    "State": "MO",
    "City": "Flemington"
  },
  {
    "State": "MO",
    "City": "Fordland"
  },
  {
    "State": "MO",
    "City": "Forsyth"
  },
  {
    "State": "MO",
    "City": "Freistatt"
  },
  {
    "State": "MO",
    "City": "Gainesville"
  },
  {
    "State": "MO",
    "City": "Galena"
  },
  {
    "State": "MO",
    "City": "Garrison"
  },
  {
    "State": "MO",
    "City": "Golden"
  },
  {
    "State": "MO",
    "City": "Graff"
  },
  {
    "State": "MO",
    "City": "Greenfield"
  },
  {
    "State": "MO",
    "City": "Grovespring"
  },
  {
    "State": "MO",
    "City": "Half Way"
  },
  {
    "State": "MO",
    "City": "Halltown"
  },
  {
    "State": "MO",
    "City": "Hardenville"
  },
  {
    "State": "MO",
    "City": "Hartville"
  },
  {
    "State": "MO",
    "City": "Hermitage"
  },
  {
    "State": "MO",
    "City": "Highlandville"
  },
  {
    "State": "MO",
    "City": "Hollister"
  },
  {
    "State": "MO",
    "City": "Humansville"
  },
  {
    "State": "MO",
    "City": "Hurley"
  },
  {
    "State": "MO",
    "City": "Isabella"
  },
  {
    "State": "MO",
    "City": "Kirbyville"
  },
  {
    "State": "MO",
    "City": "Kissee Mills"
  },
  {
    "State": "MO",
    "City": "Lampe"
  },
  {
    "State": "MO",
    "City": "Lockwood"
  },
  {
    "State": "MO",
    "City": "Louisburg"
  },
  {
    "State": "MO",
    "City": "Kimberling City"
  },
  {
    "State": "MO",
    "City": "Brandsville"
  },
  {
    "State": "MO",
    "City": "Cabool"
  },
  {
    "State": "MO",
    "City": "Couch"
  },
  {
    "State": "MO",
    "City": "Koshkonong"
  },
  {
    "State": "MO",
    "City": "Mc Clurg"
  },
  {
    "State": "MO",
    "City": "Macomb"
  },
  {
    "State": "MO",
    "City": "Mansfield"
  },
  {
    "State": "MO",
    "City": "Marionville"
  },
  {
    "State": "MO",
    "City": "Marshfield"
  },
  {
    "State": "MO",
    "City": "Miller"
  },
  {
    "State": "MO",
    "City": "Monett"
  },
  {
    "State": "MO",
    "City": "Mountain Grove"
  },
  {
    "State": "MO",
    "City": "Mount Vernon"
  },
  {
    "State": "MO",
    "City": "Niangua"
  },
  {
    "State": "MO",
    "City": "Nixa"
  },
  {
    "State": "MO",
    "City": "Noble"
  },
  {
    "State": "MO",
    "City": "Norwood"
  },
  {
    "State": "MO",
    "City": "Oldfield"
  },
  {
    "State": "MO",
    "City": "Ozark"
  },
  {
    "State": "MO",
    "City": "Phillipsburg"
  },
  {
    "State": "MO",
    "City": "Pierce City"
  },
  {
    "State": "MO",
    "City": "Pittsburg"
  },
  {
    "State": "MO",
    "City": "Pleasant Hope"
  },
  {
    "State": "MO",
    "City": "Point Lookout"
  },
  {
    "State": "MO",
    "City": "Polk"
  },
  {
    "State": "MO",
    "City": "Ponce De Leon"
  },
  {
    "State": "MO",
    "City": "Pontiac"
  },
  {
    "State": "MO",
    "City": "Powell"
  },
  {
    "State": "MO",
    "City": "Powersite"
  },
  {
    "State": "MO",
    "City": "Preston"
  },
  {
    "State": "MO",
    "City": "Protem"
  },
  {
    "State": "MO",
    "City": "Purdy"
  },
  {
    "State": "MO",
    "City": "Quincy"
  },
  {
    "State": "MO",
    "City": "Reeds Spring"
  },
  {
    "State": "MO",
    "City": "Republic"
  },
  {
    "State": "MO",
    "City": "Ridgedale"
  },
  {
    "State": "MO",
    "City": "Rockaway Beach"
  },
  {
    "State": "MO",
    "City": "Rockbridge"
  },
  {
    "State": "MO",
    "City": "Rogersville"
  },
  {
    "State": "MO",
    "City": "Rueter"
  },
  {
    "State": "MO",
    "City": "Seligman"
  },
  {
    "State": "MO",
    "City": "Seymour"
  },
  {
    "State": "MO",
    "City": "Shell Knob"
  },
  {
    "State": "MO",
    "City": "South Greenfield"
  },
  {
    "State": "MO",
    "City": "Sparta"
  },
  {
    "State": "MO",
    "City": "Spokane"
  },
  {
    "State": "MO",
    "City": "Squires"
  },
  {
    "State": "MO",
    "City": "Stotts City"
  },
  {
    "State": "MO",
    "City": "Strafford"
  },
  {
    "State": "MO",
    "City": "Taneyville"
  },
  {
    "State": "MO",
    "City": "Tecumseh"
  },
  {
    "State": "MO",
    "City": "Theodosia"
  },
  {
    "State": "MO",
    "City": "Thornfield"
  },
  {
    "State": "MO",
    "City": "Tunas"
  },
  {
    "State": "MO",
    "City": "Turners"
  },
  {
    "State": "MO",
    "City": "Udall"
  },
  {
    "State": "MO",
    "City": "Urbana"
  },
  {
    "State": "MO",
    "City": "Vanzant"
  },
  {
    "State": "MO",
    "City": "Verona"
  },
  {
    "State": "MO",
    "City": "Walnut Grove"
  },
  {
    "State": "MO",
    "City": "Walnut Shade"
  },
  {
    "State": "MO",
    "City": "Washburn"
  },
  {
    "State": "MO",
    "City": "Wasola"
  },
  {
    "State": "MO",
    "City": "Weaubleau"
  },
  {
    "State": "MO",
    "City": "West Plains"
  },
  {
    "State": "MO",
    "City": "South Fork"
  },
  {
    "State": "MO",
    "City": "Moody"
  },
  {
    "State": "MO",
    "City": "Myrtle"
  },
  {
    "State": "MO",
    "City": "Wheatland"
  },
  {
    "State": "MO",
    "City": "Willard"
  },
  {
    "State": "MO",
    "City": "Windyville"
  },
  {
    "State": "MO",
    "City": "Zanoni"
  },
  {
    "State": "MO",
    "City": "Stockton"
  },
  {
    "State": "MO",
    "City": "Macks Creek"
  },
  {
    "State": "MO",
    "City": "Roach"
  },
  {
    "State": "MO",
    "City": "Peace Valley"
  },
  {
    "State": "MO",
    "City": "Pomona"
  },
  {
    "State": "MO",
    "City": "Pottersville"
  },
  {
    "State": "MO",
    "City": "Thayer"
  },
  {
    "State": "MO",
    "City": "Willow Springs"
  },
  {
    "State": "MO",
    "City": "Springfield"
  },
  {
    "State": "KS",
    "City": "Atchison"
  },
  {
    "State": "KS",
    "City": "Baldwin City"
  },
  {
    "State": "KS",
    "City": "Basehor"
  },
  {
    "State": "KS",
    "City": "Bendena"
  },
  {
    "State": "KS",
    "City": "Blue Mound"
  },
  {
    "State": "KS",
    "City": "Bonner Springs"
  },
  {
    "State": "KS",
    "City": "Bucyrus"
  },
  {
    "State": "KS",
    "City": "Centerville"
  },
  {
    "State": "KS",
    "City": "Colony"
  },
  {
    "State": "KS",
    "City": "Cummings"
  },
  {
    "State": "KS",
    "City": "Denton"
  },
  {
    "State": "KS",
    "City": "De Soto"
  },
  {
    "State": "KS",
    "City": "Clearview City"
  },
  {
    "State": "KS",
    "City": "Easton"
  },
  {
    "State": "KS",
    "City": "Edgerton"
  },
  {
    "State": "KS",
    "City": "Effingham"
  },
  {
    "State": "KS",
    "City": "Elwood"
  },
  {
    "State": "KS",
    "City": "Eudora"
  },
  {
    "State": "KS",
    "City": "Fontana"
  },
  {
    "State": "KS",
    "City": "Fort Leavenworth"
  },
  {
    "State": "KS",
    "City": "Gardner"
  },
  {
    "State": "KS",
    "City": "New Century"
  },
  {
    "State": "KS",
    "City": "Garnett"
  },
  {
    "State": "KS",
    "City": "Greeley"
  },
  {
    "State": "KS",
    "City": "Highland"
  },
  {
    "State": "KS",
    "City": "Hillsdale"
  },
  {
    "State": "KS",
    "City": "Kincaid"
  },
  {
    "State": "KS",
    "City": "La Cygne"
  },
  {
    "State": "KS",
    "City": "Lancaster"
  },
  {
    "State": "KS",
    "City": "Lane"
  },
  {
    "State": "KS",
    "City": "Lansing"
  },
  {
    "State": "KS",
    "City": "Lawrence"
  },
  {
    "State": "KS",
    "City": "Leavenworth"
  },
  {
    "State": "KS",
    "City": "Lecompton"
  },
  {
    "State": "KS",
    "City": "Olathe"
  },
  {
    "State": "KS",
    "City": "Linwood"
  },
  {
    "State": "KS",
    "City": "Louisburg"
  },
  {
    "State": "KS",
    "City": "Mc Louth"
  },
  {
    "State": "KS",
    "City": "Mound City"
  },
  {
    "State": "KS",
    "City": "Muscotah"
  },
  {
    "State": "KS",
    "City": "Nortonville"
  },
  {
    "State": "KS",
    "City": "Osawatomie"
  },
  {
    "State": "KS",
    "City": "Oskaloosa"
  },
  {
    "State": "KS",
    "City": "Ottawa"
  },
  {
    "State": "KS",
    "City": "Ozawkie"
  },
  {
    "State": "KS",
    "City": "Paola"
  },
  {
    "State": "KS",
    "City": "Parker"
  },
  {
    "State": "KS",
    "City": "Perry"
  },
  {
    "State": "KS",
    "City": "Pleasanton"
  },
  {
    "State": "KS",
    "City": "Pomona"
  },
  {
    "State": "KS",
    "City": "Potter"
  },
  {
    "State": "KS",
    "City": "Princeton"
  },
  {
    "State": "KS",
    "City": "Rantoul"
  },
  {
    "State": "KS",
    "City": "Richmond"
  },
  {
    "State": "KS",
    "City": "Spring Hill"
  },
  {
    "State": "KS",
    "City": "Stilwell"
  },
  {
    "State": "KS",
    "City": "Tonganoxie"
  },
  {
    "State": "KS",
    "City": "Troy"
  },
  {
    "State": "KS",
    "City": "Valley Falls"
  },
  {
    "State": "KS",
    "City": "Wathena"
  },
  {
    "State": "KS",
    "City": "Welda"
  },
  {
    "State": "KS",
    "City": "Wellsville"
  },
  {
    "State": "KS",
    "City": "Westphalia"
  },
  {
    "State": "KS",
    "City": "White Cloud"
  },
  {
    "State": "KS",
    "City": "Williamsburg"
  },
  {
    "State": "KS",
    "City": "Winchester"
  },
  {
    "State": "KS",
    "City": "Kansas City"
  },
  {
    "State": "KS",
    "City": "Edwardsville"
  },
  {
    "State": "KS",
    "City": "Mission"
  },
  {
    "State": "KS",
    "City": "Shawnee"
  },
  {
    "State": "KS",
    "City": "Overland Park"
  },
  {
    "State": "KS",
    "City": "Leawood"
  },
  {
    "State": "KS",
    "City": "Prairie Village"
  },
  {
    "State": "KS",
    "City": "Lenexa"
  },
  {
    "State": "KS",
    "City": "Shawnee Mission"
  },
  {
    "State": "KS",
    "City": "Alma"
  },
  {
    "State": "KS",
    "City": "Auburn"
  },
  {
    "State": "KS",
    "City": "Axtell"
  },
  {
    "State": "KS",
    "City": "Baileyville"
  },
  {
    "State": "KS",
    "City": "Beattie"
  },
  {
    "State": "KS",
    "City": "Belvue"
  },
  {
    "State": "KS",
    "City": "Bern"
  },
  {
    "State": "KS",
    "City": "Berryton"
  },
  {
    "State": "KS",
    "City": "Blue Rapids"
  },
  {
    "State": "KS",
    "City": "Bremen"
  },
  {
    "State": "KS",
    "City": "Burlingame"
  },
  {
    "State": "KS",
    "City": "Carbondale"
  },
  {
    "State": "KS",
    "City": "Centralia"
  },
  {
    "State": "KS",
    "City": "Circleville"
  },
  {
    "State": "KS",
    "City": "Corning"
  },
  {
    "State": "KS",
    "City": "Delia"
  },
  {
    "State": "KS",
    "City": "Denison"
  },
  {
    "State": "KS",
    "City": "Dover"
  },
  {
    "State": "KS",
    "City": "Emmett"
  },
  {
    "State": "KS",
    "City": "Eskridge"
  },
  {
    "State": "KS",
    "City": "Everest"
  },
  {
    "State": "KS",
    "City": "Fairview"
  },
  {
    "State": "KS",
    "City": "Fostoria"
  },
  {
    "State": "KS",
    "City": "Frankfort"
  },
  {
    "State": "KS",
    "City": "Goff"
  },
  {
    "State": "KS",
    "City": "Grantville"
  },
  {
    "State": "KS",
    "City": "Harveyville"
  },
  {
    "State": "KS",
    "City": "Havensville"
  },
  {
    "State": "KS",
    "City": "Hiawatha"
  },
  {
    "State": "KS",
    "City": "Holton"
  },
  {
    "State": "KS",
    "City": "Home"
  },
  {
    "State": "KS",
    "City": "Horton"
  },
  {
    "State": "KS",
    "City": "Hoyt"
  },
  {
    "State": "KS",
    "City": "Junction City"
  },
  {
    "State": "KS",
    "City": "Fort Riley"
  },
  {
    "State": "KS",
    "City": "Leonardville"
  },
  {
    "State": "KS",
    "City": "Lyndon"
  },
  {
    "State": "KS",
    "City": "Mc Farland"
  },
  {
    "State": "KS",
    "City": "Manhattan"
  },
  {
    "State": "KS",
    "City": "Maple Hill"
  },
  {
    "State": "KS",
    "City": "Marysville"
  },
  {
    "State": "KS",
    "City": "Mayetta"
  },
  {
    "State": "KS",
    "City": "Melvern"
  },
  {
    "State": "KS",
    "City": "Meriden"
  },
  {
    "State": "KS",
    "City": "Milford"
  },
  {
    "State": "KS",
    "City": "Morrill"
  },
  {
    "State": "KS",
    "City": "Netawaka"
  },
  {
    "State": "KS",
    "City": "Ogden"
  },
  {
    "State": "KS",
    "City": "Oketo"
  },
  {
    "State": "KS",
    "City": "Olsburg"
  },
  {
    "State": "KS",
    "City": "Onaga"
  },
  {
    "State": "KS",
    "City": "Oneida"
  },
  {
    "State": "KS",
    "City": "Osage City"
  },
  {
    "State": "KS",
    "City": "Overbrook"
  },
  {
    "State": "KS",
    "City": "Paxico"
  },
  {
    "State": "KS",
    "City": "Powhattan"
  },
  {
    "State": "KS",
    "City": "Quenemo"
  },
  {
    "State": "KS",
    "City": "Riley"
  },
  {
    "State": "KS",
    "City": "Robinson"
  },
  {
    "State": "KS",
    "City": "Rossville"
  },
  {
    "State": "KS",
    "City": "Sabetha"
  },
  {
    "State": "KS",
    "City": "Saint George"
  },
  {
    "State": "KS",
    "City": "Saint Marys"
  },
  {
    "State": "KS",
    "City": "Scranton"
  },
  {
    "State": "KS",
    "City": "Seneca"
  },
  {
    "State": "KS",
    "City": "Silver Lake"
  },
  {
    "State": "KS",
    "City": "Soldier"
  },
  {
    "State": "KS",
    "City": "Summerfield"
  },
  {
    "State": "KS",
    "City": "Tecumseh"
  },
  {
    "State": "KS",
    "City": "Vassar"
  },
  {
    "State": "KS",
    "City": "Vermillion"
  },
  {
    "State": "KS",
    "City": "Wakarusa"
  },
  {
    "State": "KS",
    "City": "Wamego"
  },
  {
    "State": "KS",
    "City": "Waterville"
  },
  {
    "State": "KS",
    "City": "Westmoreland"
  },
  {
    "State": "KS",
    "City": "Wetmore"
  },
  {
    "State": "KS",
    "City": "Whiting"
  },
  {
    "State": "KS",
    "City": "Randolph"
  },
  {
    "State": "KS",
    "City": "Topeka"
  },
  {
    "State": "KS",
    "City": "Fort Scott"
  },
  {
    "State": "KS",
    "City": "Altoona"
  },
  {
    "State": "KS",
    "City": "Arcadia"
  },
  {
    "State": "KS",
    "City": "Arma"
  },
  {
    "State": "KS",
    "City": "Baxter Springs"
  },
  {
    "State": "KS",
    "City": "Benedict"
  },
  {
    "State": "KS",
    "City": "Bronson"
  },
  {
    "State": "KS",
    "City": "Buffalo"
  },
  {
    "State": "KS",
    "City": "Chanute"
  },
  {
    "State": "KS",
    "City": "Cherokee"
  },
  {
    "State": "KS",
    "City": "Columbus"
  },
  {
    "State": "KS",
    "City": "Crestline"
  },
  {
    "State": "KS",
    "City": "Elsmore"
  },
  {
    "State": "KS",
    "City": "Erie"
  },
  {
    "State": "KS",
    "City": "Farlington"
  },
  {
    "State": "KS",
    "City": "Franklin"
  },
  {
    "State": "KS",
    "City": "Fredonia"
  },
  {
    "State": "KS",
    "City": "Fulton"
  },
  {
    "State": "KS",
    "City": "Galena"
  },
  {
    "State": "KS",
    "City": "Galesburg"
  },
  {
    "State": "KS",
    "City": "Garland"
  },
  {
    "State": "KS",
    "City": "Gas"
  },
  {
    "State": "KS",
    "City": "Girard"
  },
  {
    "State": "KS",
    "City": "Hepler"
  },
  {
    "State": "KS",
    "City": "Humboldt"
  },
  {
    "State": "KS",
    "City": "Iola"
  },
  {
    "State": "KS",
    "City": "La Harpe"
  },
  {
    "State": "KS",
    "City": "Mc Cune"
  },
  {
    "State": "KS",
    "City": "Mapleton"
  },
  {
    "State": "KS",
    "City": "Moran"
  },
  {
    "State": "KS",
    "City": "Mulberry"
  },
  {
    "State": "KS",
    "City": "Neodesha"
  },
  {
    "State": "KS",
    "City": "Neosho Falls"
  },
  {
    "State": "KS",
    "City": "New Albany"
  },
  {
    "State": "KS",
    "City": "Opolis"
  },
  {
    "State": "KS",
    "City": "Piqua"
  },
  {
    "State": "KS",
    "City": "Pittsburg"
  },
  {
    "State": "KS",
    "City": "Frontenac"
  },
  {
    "State": "KS",
    "City": "Prescott"
  },
  {
    "State": "KS",
    "City": "Redfield"
  },
  {
    "State": "KS",
    "City": "Riverton"
  },
  {
    "State": "KS",
    "City": "Saint Paul"
  },
  {
    "State": "KS",
    "City": "Savonburg"
  },
  {
    "State": "KS",
    "City": "Scammon"
  },
  {
    "State": "KS",
    "City": "Stark"
  },
  {
    "State": "KS",
    "City": "Thayer"
  },
  {
    "State": "KS",
    "City": "Toronto"
  },
  {
    "State": "KS",
    "City": "Treece"
  },
  {
    "State": "KS",
    "City": "Uniontown"
  },
  {
    "State": "KS",
    "City": "Walnut"
  },
  {
    "State": "KS",
    "City": "Weir"
  },
  {
    "State": "KS",
    "City": "West Mineral"
  },
  {
    "State": "KS",
    "City": "Yates Center"
  },
  {
    "State": "KS",
    "City": "Emporia"
  },
  {
    "State": "KS",
    "City": "Admire"
  },
  {
    "State": "KS",
    "City": "Allen"
  },
  {
    "State": "KS",
    "City": "Alta Vista"
  },
  {
    "State": "KS",
    "City": "Americus"
  },
  {
    "State": "KS",
    "City": "Burdick"
  },
  {
    "State": "KS",
    "City": "Burlington"
  },
  {
    "State": "KS",
    "City": "Burns"
  },
  {
    "State": "KS",
    "City": "Cassoday"
  },
  {
    "State": "KS",
    "City": "Cedar Point"
  },
  {
    "State": "KS",
    "City": "Cottonwood Falls"
  },
  {
    "State": "KS",
    "City": "Council Grove"
  },
  {
    "State": "KS",
    "City": "Dwight"
  },
  {
    "State": "KS",
    "City": "Elmdale"
  },
  {
    "State": "KS",
    "City": "Florence"
  },
  {
    "State": "KS",
    "City": "Gridley"
  },
  {
    "State": "KS",
    "City": "Hamilton"
  },
  {
    "State": "KS",
    "City": "Hartford"
  },
  {
    "State": "KS",
    "City": "Lamont"
  },
  {
    "State": "KS",
    "City": "Lebo"
  },
  {
    "State": "KS",
    "City": "Le Roy"
  },
  {
    "State": "KS",
    "City": "Lincolnville"
  },
  {
    "State": "KS",
    "City": "Lost Springs"
  },
  {
    "State": "KS",
    "City": "Madison"
  },
  {
    "State": "KS",
    "City": "Marion"
  },
  {
    "State": "KS",
    "City": "Matfield Green"
  },
  {
    "State": "KS",
    "City": "Neal"
  },
  {
    "State": "KS",
    "City": "Neosho Rapids"
  },
  {
    "State": "KS",
    "City": "Olpe"
  },
  {
    "State": "KS",
    "City": "Peabody"
  },
  {
    "State": "KS",
    "City": "Reading"
  },
  {
    "State": "KS",
    "City": "Strong City"
  },
  {
    "State": "KS",
    "City": "Virgil"
  },
  {
    "State": "KS",
    "City": "Waverly"
  },
  {
    "State": "KS",
    "City": "White City"
  },
  {
    "State": "KS",
    "City": "Wilsey"
  },
  {
    "State": "KS",
    "City": "Concordia"
  },
  {
    "State": "KS",
    "City": "Agenda"
  },
  {
    "State": "KS",
    "City": "Athol"
  },
  {
    "State": "KS",
    "City": "Barnes"
  },
  {
    "State": "KS",
    "City": "Belleville"
  },
  {
    "State": "KS",
    "City": "Burr Oak"
  },
  {
    "State": "KS",
    "City": "Clifton"
  },
  {
    "State": "KS",
    "City": "Clyde"
  },
  {
    "State": "KS",
    "City": "Courtland"
  },
  {
    "State": "KS",
    "City": "Cuba"
  },
  {
    "State": "KS",
    "City": "Esbon"
  },
  {
    "State": "KS",
    "City": "Formoso"
  },
  {
    "State": "KS",
    "City": "Greenleaf"
  },
  {
    "State": "KS",
    "City": "Haddam"
  },
  {
    "State": "KS",
    "City": "Hanover"
  },
  {
    "State": "KS",
    "City": "Hollenberg"
  },
  {
    "State": "KS",
    "City": "Jamestown"
  },
  {
    "State": "KS",
    "City": "Jewell"
  },
  {
    "State": "KS",
    "City": "Kensington"
  },
  {
    "State": "KS",
    "City": "Lebanon"
  },
  {
    "State": "KS",
    "City": "Linn"
  },
  {
    "State": "KS",
    "City": "Mahaska"
  },
  {
    "State": "KS",
    "City": "Mankato"
  },
  {
    "State": "KS",
    "City": "Morrowville"
  },
  {
    "State": "KS",
    "City": "Munden"
  },
  {
    "State": "KS",
    "City": "Narka"
  },
  {
    "State": "KS",
    "City": "Norway"
  },
  {
    "State": "KS",
    "City": "Palmer"
  },
  {
    "State": "KS",
    "City": "Randall"
  },
  {
    "State": "KS",
    "City": "Republic"
  },
  {
    "State": "KS",
    "City": "Scandia"
  },
  {
    "State": "KS",
    "City": "Smith Center"
  },
  {
    "State": "KS",
    "City": "Washington"
  },
  {
    "State": "KS",
    "City": "Webber"
  },
  {
    "State": "KS",
    "City": "Andale"
  },
  {
    "State": "KS",
    "City": "Andover"
  },
  {
    "State": "KS",
    "City": "Anthony"
  },
  {
    "State": "KS",
    "City": "Argonia"
  },
  {
    "State": "KS",
    "City": "Arkansas City"
  },
  {
    "State": "KS",
    "City": "Atlanta"
  },
  {
    "State": "KS",
    "City": "Attica"
  },
  {
    "State": "KS",
    "City": "Augusta"
  },
  {
    "State": "KS",
    "City": "Beaumont"
  },
  {
    "State": "KS",
    "City": "Belle Plaine"
  },
  {
    "State": "KS",
    "City": "Bentley"
  },
  {
    "State": "KS",
    "City": "Benton"
  },
  {
    "State": "KS",
    "City": "Bluff City"
  },
  {
    "State": "KS",
    "City": "Burden"
  },
  {
    "State": "KS",
    "City": "Burrton"
  },
  {
    "State": "KS",
    "City": "Byers"
  },
  {
    "State": "KS",
    "City": "Caldwell"
  },
  {
    "State": "KS",
    "City": "Cambridge"
  },
  {
    "State": "KS",
    "City": "Cedar Vale"
  },
  {
    "State": "KS",
    "City": "Cheney"
  },
  {
    "State": "KS",
    "City": "Clearwater"
  },
  {
    "State": "KS",
    "City": "Coats"
  },
  {
    "State": "KS",
    "City": "Coldwater"
  },
  {
    "State": "KS",
    "City": "Colwich"
  },
  {
    "State": "KS",
    "City": "Conway Springs"
  },
  {
    "State": "KS",
    "City": "Cunningham"
  },
  {
    "State": "KS",
    "City": "Danville"
  },
  {
    "State": "KS",
    "City": "Derby"
  },
  {
    "State": "KS",
    "City": "Dexter"
  },
  {
    "State": "KS",
    "City": "Douglass"
  },
  {
    "State": "KS",
    "City": "Elbing"
  },
  {
    "State": "KS",
    "City": "El Dorado"
  },
  {
    "State": "KS",
    "City": "Eureka"
  },
  {
    "State": "KS",
    "City": "Fall River"
  },
  {
    "State": "KS",
    "City": "Freeport"
  },
  {
    "State": "KS",
    "City": "Garden Plain"
  },
  {
    "State": "KS",
    "City": "Geuda Springs"
  },
  {
    "State": "KS",
    "City": "Goddard"
  },
  {
    "State": "KS",
    "City": "Goessel"
  },
  {
    "State": "KS",
    "City": "Greensburg"
  },
  {
    "State": "KS",
    "City": "Greenwich"
  },
  {
    "State": "KS",
    "City": "Halstead"
  },
  {
    "State": "KS",
    "City": "Hardtner"
  },
  {
    "State": "KS",
    "City": "Harper"
  },
  {
    "State": "KS",
    "City": "Haviland"
  },
  {
    "State": "KS",
    "City": "Haysville"
  },
  {
    "State": "KS",
    "City": "Hazelton"
  },
  {
    "State": "KS",
    "City": "Hesston"
  },
  {
    "State": "KS",
    "City": "Hillsboro"
  },
  {
    "State": "KS",
    "City": "Isabel"
  },
  {
    "State": "KS",
    "City": "Iuka"
  },
  {
    "State": "KS",
    "City": "Kechi"
  },
  {
    "State": "KS",
    "City": "Kingman"
  },
  {
    "State": "KS",
    "City": "Kiowa"
  },
  {
    "State": "KS",
    "City": "Lake City"
  },
  {
    "State": "KS",
    "City": "Latham"
  },
  {
    "State": "KS",
    "City": "Lehigh"
  },
  {
    "State": "KS",
    "City": "Leon"
  },
  {
    "State": "KS",
    "City": "Maize"
  },
  {
    "State": "KS",
    "City": "Maple City"
  },
  {
    "State": "KS",
    "City": "Mayfield"
  },
  {
    "State": "KS",
    "City": "Medicine Lodge"
  },
  {
    "State": "KS",
    "City": "Milan"
  },
  {
    "State": "KS",
    "City": "Milton"
  },
  {
    "State": "KS",
    "City": "Moundridge"
  },
  {
    "State": "KS",
    "City": "Mount Hope"
  },
  {
    "State": "KS",
    "City": "Mullinville"
  },
  {
    "State": "KS",
    "City": "Mulvane"
  },
  {
    "State": "KS",
    "City": "Murdock"
  },
  {
    "State": "KS",
    "City": "Nashville"
  },
  {
    "State": "KS",
    "City": "Newton"
  },
  {
    "State": "KS",
    "City": "North Newton"
  },
  {
    "State": "KS",
    "City": "Norwich"
  },
  {
    "State": "KS",
    "City": "Oxford"
  },
  {
    "State": "KS",
    "City": "Peck"
  },
  {
    "State": "KS",
    "City": "Piedmont"
  },
  {
    "State": "KS",
    "City": "Potwin"
  },
  {
    "State": "KS",
    "City": "Pratt"
  },
  {
    "State": "KS",
    "City": "Protection"
  },
  {
    "State": "KS",
    "City": "Rock"
  },
  {
    "State": "KS",
    "City": "Rosalia"
  },
  {
    "State": "KS",
    "City": "Rose Hill"
  },
  {
    "State": "KS",
    "City": "Sawyer"
  },
  {
    "State": "KS",
    "City": "Sedgwick"
  },
  {
    "State": "KS",
    "City": "Severy"
  },
  {
    "State": "KS",
    "City": "Sharon"
  },
  {
    "State": "KS",
    "City": "South Haven"
  },
  {
    "State": "KS",
    "City": "Spivey"
  },
  {
    "State": "KS",
    "City": "Sun City"
  },
  {
    "State": "KS",
    "City": "Towanda"
  },
  {
    "State": "KS",
    "City": "Udall"
  },
  {
    "State": "KS",
    "City": "Valley Center"
  },
  {
    "State": "KS",
    "City": "Viola"
  },
  {
    "State": "KS",
    "City": "Waldron"
  },
  {
    "State": "KS",
    "City": "Walton"
  },
  {
    "State": "KS",
    "City": "Wellington"
  },
  {
    "State": "KS",
    "City": "Whitewater"
  },
  {
    "State": "KS",
    "City": "Wilmore"
  },
  {
    "State": "KS",
    "City": "Winfield"
  },
  {
    "State": "KS",
    "City": "Zenda"
  },
  {
    "State": "KS",
    "City": "Wichita"
  },
  {
    "State": "KS",
    "City": "Mcconnell AFB"
  },
  {
    "State": "KS",
    "City": "Independence"
  },
  {
    "State": "KS",
    "City": "Altamont"
  },
  {
    "State": "KS",
    "City": "Bartlett"
  },
  {
    "State": "KS",
    "City": "Caney"
  },
  {
    "State": "KS",
    "City": "Chautauqua"
  },
  {
    "State": "KS",
    "City": "Cherryvale"
  },
  {
    "State": "KS",
    "City": "Chetopa"
  },
  {
    "State": "KS",
    "City": "Coffeyville"
  },
  {
    "State": "KS",
    "City": "Dearing"
  },
  {
    "State": "KS",
    "City": "Dennis"
  },
  {
    "State": "KS",
    "City": "Edna"
  },
  {
    "State": "KS",
    "City": "Elk City"
  },
  {
    "State": "KS",
    "City": "Elk Falls"
  },
  {
    "State": "KS",
    "City": "Grenola"
  },
  {
    "State": "KS",
    "City": "Havana"
  },
  {
    "State": "KS",
    "City": "Howard"
  },
  {
    "State": "KS",
    "City": "Liberty"
  },
  {
    "State": "KS",
    "City": "Longton"
  },
  {
    "State": "KS",
    "City": "Moline"
  },
  {
    "State": "KS",
    "City": "Mound Valley"
  },
  {
    "State": "KS",
    "City": "Niotaze"
  },
  {
    "State": "KS",
    "City": "Oswego"
  },
  {
    "State": "KS",
    "City": "Parsons"
  },
  {
    "State": "KS",
    "City": "Peru"
  },
  {
    "State": "KS",
    "City": "Sedan"
  },
  {
    "State": "KS",
    "City": "Sycamore"
  },
  {
    "State": "KS",
    "City": "Tyro"
  },
  {
    "State": "KS",
    "City": "Salina"
  },
  {
    "State": "KS",
    "City": "Abilene"
  },
  {
    "State": "KS",
    "City": "Assaria"
  },
  {
    "State": "KS",
    "City": "Aurora"
  },
  {
    "State": "KS",
    "City": "Barnard"
  },
  {
    "State": "KS",
    "City": "Beloit"
  },
  {
    "State": "KS",
    "City": "Bennington"
  },
  {
    "State": "KS",
    "City": "Beverly"
  },
  {
    "State": "KS",
    "City": "Brookville"
  },
  {
    "State": "KS",
    "City": "Bushton"
  },
  {
    "State": "KS",
    "City": "Canton"
  },
  {
    "State": "KS",
    "City": "Cawker City"
  },
  {
    "State": "KS",
    "City": "Chapman"
  },
  {
    "State": "KS",
    "City": "Clay Center"
  },
  {
    "State": "KS",
    "City": "Delphos"
  },
  {
    "State": "KS",
    "City": "Downs"
  },
  {
    "State": "KS",
    "City": "Durham"
  },
  {
    "State": "KS",
    "City": "Ellsworth"
  },
  {
    "State": "KS",
    "City": "Enterprise"
  },
  {
    "State": "KS",
    "City": "Falun"
  },
  {
    "State": "KS",
    "City": "Galva"
  },
  {
    "State": "KS",
    "City": "Geneseo"
  },
  {
    "State": "KS",
    "City": "Glasco"
  },
  {
    "State": "KS",
    "City": "Glen Elder"
  },
  {
    "State": "KS",
    "City": "Green"
  },
  {
    "State": "KS",
    "City": "Gypsum"
  },
  {
    "State": "KS",
    "City": "Herington"
  },
  {
    "State": "KS",
    "City": "Holyrood"
  },
  {
    "State": "KS",
    "City": "Hope"
  },
  {
    "State": "KS",
    "City": "Hunter"
  },
  {
    "State": "KS",
    "City": "Kanopolis"
  },
  {
    "State": "KS",
    "City": "Lincoln"
  },
  {
    "State": "KS",
    "City": "Lindsborg"
  },
  {
    "State": "KS",
    "City": "Little River"
  },
  {
    "State": "KS",
    "City": "Longford"
  },
  {
    "State": "KS",
    "City": "Lorraine"
  },
  {
    "State": "KS",
    "City": "Mcpherson"
  },
  {
    "State": "KS",
    "City": "Marquette"
  },
  {
    "State": "KS",
    "City": "Miltonvale"
  },
  {
    "State": "KS",
    "City": "Minneapolis"
  },
  {
    "State": "KS",
    "City": "Morganville"
  },
  {
    "State": "KS",
    "City": "New Cambria"
  },
  {
    "State": "KS",
    "City": "Osborne"
  },
  {
    "State": "KS",
    "City": "Portis"
  },
  {
    "State": "KS",
    "City": "Ramona"
  },
  {
    "State": "KS",
    "City": "Roxbury"
  },
  {
    "State": "KS",
    "City": "Simpson"
  },
  {
    "State": "KS",
    "City": "Solomon"
  },
  {
    "State": "KS",
    "City": "Sylvan Grove"
  },
  {
    "State": "KS",
    "City": "Talmage"
  },
  {
    "State": "KS",
    "City": "Tampa"
  },
  {
    "State": "KS",
    "City": "Tescott"
  },
  {
    "State": "KS",
    "City": "Tipton"
  },
  {
    "State": "KS",
    "City": "Wakefield"
  },
  {
    "State": "KS",
    "City": "Wilson"
  },
  {
    "State": "KS",
    "City": "Windom"
  },
  {
    "State": "KS",
    "City": "Woodbine"
  },
  {
    "State": "KS",
    "City": "Hutchinson"
  },
  {
    "State": "KS",
    "City": "South Hutchinson"
  },
  {
    "State": "KS",
    "City": "Abbyville"
  },
  {
    "State": "KS",
    "City": "Albert"
  },
  {
    "State": "KS",
    "City": "Alden"
  },
  {
    "State": "KS",
    "City": "Alexander"
  },
  {
    "State": "KS",
    "City": "Arlington"
  },
  {
    "State": "KS",
    "City": "Arnold"
  },
  {
    "State": "KS",
    "City": "Bazine"
  },
  {
    "State": "KS",
    "City": "Beeler"
  },
  {
    "State": "KS",
    "City": "Belpre"
  },
  {
    "State": "KS",
    "City": "Bison"
  },
  {
    "State": "KS",
    "City": "Brownell"
  },
  {
    "State": "KS",
    "City": "Buhler"
  },
  {
    "State": "KS",
    "City": "Burdett"
  },
  {
    "State": "KS",
    "City": "Chase"
  },
  {
    "State": "KS",
    "City": "Claflin"
  },
  {
    "State": "KS",
    "City": "Ellinwood"
  },
  {
    "State": "KS",
    "City": "Garfield"
  },
  {
    "State": "KS",
    "City": "Great Bend"
  },
  {
    "State": "KS",
    "City": "Haven"
  },
  {
    "State": "KS",
    "City": "Hoisington"
  },
  {
    "State": "KS",
    "City": "Hudson"
  },
  {
    "State": "KS",
    "City": "Inman"
  },
  {
    "State": "KS",
    "City": "Kinsley"
  },
  {
    "State": "KS",
    "City": "La Crosse"
  },
  {
    "State": "KS",
    "City": "Larned"
  },
  {
    "State": "KS",
    "City": "Lewis"
  },
  {
    "State": "KS",
    "City": "Liebenthal"
  },
  {
    "State": "KS",
    "City": "Lyons"
  },
  {
    "State": "KS",
    "City": "Mc Cracken"
  },
  {
    "State": "KS",
    "City": "Macksville"
  },
  {
    "State": "KS",
    "City": "Nekoma"
  },
  {
    "State": "KS",
    "City": "Ness City"
  },
  {
    "State": "KS",
    "City": "Nickerson"
  },
  {
    "State": "KS",
    "City": "Offerle"
  },
  {
    "State": "KS",
    "City": "Olmitz"
  },
  {
    "State": "KS",
    "City": "Otis"
  },
  {
    "State": "KS",
    "City": "Partridge"
  },
  {
    "State": "KS",
    "City": "Pawnee Rock"
  },
  {
    "State": "KS",
    "City": "Plevna"
  },
  {
    "State": "KS",
    "City": "Pretty Prairie"
  },
  {
    "State": "KS",
    "City": "Ransom"
  },
  {
    "State": "KS",
    "City": "Raymond"
  },
  {
    "State": "KS",
    "City": "Rozel"
  },
  {
    "State": "KS",
    "City": "Rush Center"
  },
  {
    "State": "KS",
    "City": "St John"
  },
  {
    "State": "KS",
    "City": "Stafford"
  },
  {
    "State": "KS",
    "City": "Sterling"
  },
  {
    "State": "KS",
    "City": "Sylvia"
  },
  {
    "State": "KS",
    "City": "Turon"
  },
  {
    "State": "KS",
    "City": "Utica"
  },
  {
    "State": "KS",
    "City": "Yoder"
  },
  {
    "State": "KS",
    "City": "Hays"
  },
  {
    "State": "KS",
    "City": "Agra"
  },
  {
    "State": "KS",
    "City": "Almena"
  },
  {
    "State": "KS",
    "City": "Alton"
  },
  {
    "State": "KS",
    "City": "Bogue"
  },
  {
    "State": "KS",
    "City": "Bunker Hill"
  },
  {
    "State": "KS",
    "City": "Catharine"
  },
  {
    "State": "KS",
    "City": "Cedar"
  },
  {
    "State": "KS",
    "City": "Clayton"
  },
  {
    "State": "KS",
    "City": "Collyer"
  },
  {
    "State": "KS",
    "City": "Damar"
  },
  {
    "State": "KS",
    "City": "Dorrance"
  },
  {
    "State": "KS",
    "City": "Dresden"
  },
  {
    "State": "KS",
    "City": "Ellis"
  },
  {
    "State": "KS",
    "City": "Gaylord"
  },
  {
    "State": "KS",
    "City": "Glade"
  },
  {
    "State": "KS",
    "City": "Gorham"
  },
  {
    "State": "KS",
    "City": "Hill City"
  },
  {
    "State": "KS",
    "City": "Jennings"
  },
  {
    "State": "KS",
    "City": "Kirwin"
  },
  {
    "State": "KS",
    "City": "Lenora"
  },
  {
    "State": "KS",
    "City": "Logan"
  },
  {
    "State": "KS",
    "City": "Long Island"
  },
  {
    "State": "KS",
    "City": "Lucas"
  },
  {
    "State": "KS",
    "City": "Luray"
  },
  {
    "State": "KS",
    "City": "Morland"
  },
  {
    "State": "KS",
    "City": "Natoma"
  },
  {
    "State": "KS",
    "City": "Norcatur"
  },
  {
    "State": "KS",
    "City": "Norton"
  },
  {
    "State": "KS",
    "City": "Ogallah"
  },
  {
    "State": "KS",
    "City": "Palco"
  },
  {
    "State": "KS",
    "City": "Paradise"
  },
  {
    "State": "KS",
    "City": "Penokee"
  },
  {
    "State": "KS",
    "City": "Pfeifer"
  },
  {
    "State": "KS",
    "City": "Phillipsburg"
  },
  {
    "State": "KS",
    "City": "Plainville"
  },
  {
    "State": "KS",
    "City": "Prairie View"
  },
  {
    "State": "KS",
    "City": "Russell"
  },
  {
    "State": "KS",
    "City": "Schoenchen"
  },
  {
    "State": "KS",
    "City": "Stockton"
  },
  {
    "State": "KS",
    "City": "Victoria"
  },
  {
    "State": "KS",
    "City": "Wakeeney"
  },
  {
    "State": "KS",
    "City": "Waldo"
  },
  {
    "State": "KS",
    "City": "Walker"
  },
  {
    "State": "KS",
    "City": "Woodston"
  },
  {
    "State": "KS",
    "City": "Colby"
  },
  {
    "State": "KS",
    "City": "Atwood"
  },
  {
    "State": "KS",
    "City": "Bird City"
  },
  {
    "State": "KS",
    "City": "Brewster"
  },
  {
    "State": "KS",
    "City": "Edson"
  },
  {
    "State": "KS",
    "City": "Gem"
  },
  {
    "State": "KS",
    "City": "Goodland"
  },
  {
    "State": "KS",
    "City": "Gove"
  },
  {
    "State": "KS",
    "City": "Grainfield"
  },
  {
    "State": "KS",
    "City": "Grinnell"
  },
  {
    "State": "KS",
    "City": "Herndon"
  },
  {
    "State": "KS",
    "City": "Hoxie"
  },
  {
    "State": "KS",
    "City": "Kanorado"
  },
  {
    "State": "KS",
    "City": "Levant"
  },
  {
    "State": "KS",
    "City": "Ludell"
  },
  {
    "State": "KS",
    "City": "Mc Donald"
  },
  {
    "State": "KS",
    "City": "Monument"
  },
  {
    "State": "KS",
    "City": "Oakley"
  },
  {
    "State": "KS",
    "City": "Oberlin"
  },
  {
    "State": "KS",
    "City": "Park"
  },
  {
    "State": "KS",
    "City": "Quinter"
  },
  {
    "State": "KS",
    "City": "Rexford"
  },
  {
    "State": "KS",
    "City": "Saint Francis"
  },
  {
    "State": "KS",
    "City": "Selden"
  },
  {
    "State": "KS",
    "City": "Sharon Springs"
  },
  {
    "State": "KS",
    "City": "Wallace"
  },
  {
    "State": "KS",
    "City": "Weskan"
  },
  {
    "State": "KS",
    "City": "Winona"
  },
  {
    "State": "KS",
    "City": "Dodge City"
  },
  {
    "State": "KS",
    "City": "Ashland"
  },
  {
    "State": "KS",
    "City": "Bucklin"
  },
  {
    "State": "KS",
    "City": "Cimarron"
  },
  {
    "State": "KS",
    "City": "Coolidge"
  },
  {
    "State": "KS",
    "City": "Copeland"
  },
  {
    "State": "KS",
    "City": "Deerfield"
  },
  {
    "State": "KS",
    "City": "Dighton"
  },
  {
    "State": "KS",
    "City": "Englewood"
  },
  {
    "State": "KS",
    "City": "Ensign"
  },
  {
    "State": "KS",
    "City": "Ford"
  },
  {
    "State": "KS",
    "City": "Fort Dodge"
  },
  {
    "State": "KS",
    "City": "Fowler"
  },
  {
    "State": "KS",
    "City": "Garden City"
  },
  {
    "State": "KS",
    "City": "Hanston"
  },
  {
    "State": "KS",
    "City": "Healy"
  },
  {
    "State": "KS",
    "City": "Holcomb"
  },
  {
    "State": "KS",
    "City": "Ingalls"
  },
  {
    "State": "KS",
    "City": "Jetmore"
  },
  {
    "State": "KS",
    "City": "Johnson"
  },
  {
    "State": "KS",
    "City": "Kendall"
  },
  {
    "State": "KS",
    "City": "Kismet"
  },
  {
    "State": "KS",
    "City": "Lakin"
  },
  {
    "State": "KS",
    "City": "Leoti"
  },
  {
    "State": "KS",
    "City": "Manter"
  },
  {
    "State": "KS",
    "City": "Marienthal"
  },
  {
    "State": "KS",
    "City": "Meade"
  },
  {
    "State": "KS",
    "City": "Minneola"
  },
  {
    "State": "KS",
    "City": "Montezuma"
  },
  {
    "State": "KS",
    "City": "Pierceville"
  },
  {
    "State": "KS",
    "City": "Plains"
  },
  {
    "State": "KS",
    "City": "Satanta"
  },
  {
    "State": "KS",
    "City": "Scott City"
  },
  {
    "State": "KS",
    "City": "Spearville"
  },
  {
    "State": "KS",
    "City": "Sublette"
  },
  {
    "State": "KS",
    "City": "Syracuse"
  },
  {
    "State": "KS",
    "City": "Tribune"
  },
  {
    "State": "KS",
    "City": "Ulysses"
  },
  {
    "State": "KS",
    "City": "Wright"
  },
  {
    "State": "KS",
    "City": "Liberal"
  },
  {
    "State": "KS",
    "City": "Elkhart"
  },
  {
    "State": "KS",
    "City": "Hugoton"
  },
  {
    "State": "KS",
    "City": "Moscow"
  },
  {
    "State": "KS",
    "City": "Richfield"
  },
  {
    "State": "KS",
    "City": "Rolla"
  },
  {
    "State": "NE",
    "City": "Abie"
  },
  {
    "State": "NE",
    "City": "Arlington"
  },
  {
    "State": "NE",
    "City": "Ashland"
  },
  {
    "State": "NE",
    "City": "Bancroft"
  },
  {
    "State": "NE",
    "City": "Bellevue"
  },
  {
    "State": "NE",
    "City": "Bennington"
  },
  {
    "State": "NE",
    "City": "Blair"
  },
  {
    "State": "NE",
    "City": "Boys Town"
  },
  {
    "State": "NE",
    "City": "Bruno"
  },
  {
    "State": "NE",
    "City": "Cedar Bluffs"
  },
  {
    "State": "NE",
    "City": "Cedar Creek"
  },
  {
    "State": "NE",
    "City": "Ceresco"
  },
  {
    "State": "NE",
    "City": "Colon"
  },
  {
    "State": "NE",
    "City": "Craig"
  },
  {
    "State": "NE",
    "City": "Decatur"
  },
  {
    "State": "NE",
    "City": "Elkhorn"
  },
  {
    "State": "NE",
    "City": "Fort Calhoun"
  },
  {
    "State": "NE",
    "City": "Fremont"
  },
  {
    "State": "NE",
    "City": "Gretna"
  },
  {
    "State": "NE",
    "City": "Herman"
  },
  {
    "State": "NE",
    "City": "Homer"
  },
  {
    "State": "NE",
    "City": "Hooper"
  },
  {
    "State": "NE",
    "City": "Ithaca"
  },
  {
    "State": "NE",
    "City": "Kennard"
  },
  {
    "State": "NE",
    "City": "Linwood"
  },
  {
    "State": "NE",
    "City": "Louisville"
  },
  {
    "State": "NE",
    "City": "Lyons"
  },
  {
    "State": "NE",
    "City": "Macy"
  },
  {
    "State": "NE",
    "City": "Malmo"
  },
  {
    "State": "NE",
    "City": "Mead"
  },
  {
    "State": "NE",
    "City": "Memphis"
  },
  {
    "State": "NE",
    "City": "Nickerson"
  },
  {
    "State": "NE",
    "City": "Oakland"
  },
  {
    "State": "NE",
    "City": "Papillion"
  },
  {
    "State": "NE",
    "City": "Pender"
  },
  {
    "State": "NE",
    "City": "Plattsmouth"
  },
  {
    "State": "NE",
    "City": "Prague"
  },
  {
    "State": "NE",
    "City": "Rosalie"
  },
  {
    "State": "NE",
    "City": "St Columbans"
  },
  {
    "State": "NE",
    "City": "Scribner"
  },
  {
    "State": "NE",
    "City": "South Bend"
  },
  {
    "State": "NE",
    "City": "Springfield"
  },
  {
    "State": "NE",
    "City": "Tekamah"
  },
  {
    "State": "NE",
    "City": "Thurston"
  },
  {
    "State": "NE",
    "City": "Uehling"
  },
  {
    "State": "NE",
    "City": "Valley"
  },
  {
    "State": "NE",
    "City": "Valparaiso"
  },
  {
    "State": "NE",
    "City": "Wahoo"
  },
  {
    "State": "NE",
    "City": "Walthill"
  },
  {
    "State": "NE",
    "City": "Washington"
  },
  {
    "State": "NE",
    "City": "Waterloo"
  },
  {
    "State": "NE",
    "City": "Weston"
  },
  {
    "State": "NE",
    "City": "Winnebago"
  },
  {
    "State": "NE",
    "City": "Winslow"
  },
  {
    "State": "NE",
    "City": "Yutan"
  },
  {
    "State": "NE",
    "City": "Omaha"
  },
  {
    "State": "NE",
    "City": "Offutt AFB"
  },
  {
    "State": "NE",
    "City": "La Vista"
  },
  {
    "State": "NE",
    "City": "Adams"
  },
  {
    "State": "NE",
    "City": "Alexandria"
  },
  {
    "State": "NE",
    "City": "Alvo"
  },
  {
    "State": "NE",
    "City": "Auburn"
  },
  {
    "State": "NE",
    "City": "Avoca"
  },
  {
    "State": "NE",
    "City": "Barneston"
  },
  {
    "State": "NE",
    "City": "Beatrice"
  },
  {
    "State": "NE",
    "City": "Beaver Crossing"
  },
  {
    "State": "NE",
    "City": "Bee"
  },
  {
    "State": "NE",
    "City": "Belvidere"
  },
  {
    "State": "NE",
    "City": "Benedict"
  },
  {
    "State": "NE",
    "City": "Bennet"
  },
  {
    "State": "NE",
    "City": "Blue Springs"
  },
  {
    "State": "NE",
    "City": "Bradshaw"
  },
  {
    "State": "NE",
    "City": "Brock"
  },
  {
    "State": "NE",
    "City": "Brownville"
  },
  {
    "State": "NE",
    "City": "Bruning"
  },
  {
    "State": "NE",
    "City": "Burchard"
  },
  {
    "State": "NE",
    "City": "Burr"
  },
  {
    "State": "NE",
    "City": "Byron"
  },
  {
    "State": "NE",
    "City": "Carleton"
  },
  {
    "State": "NE",
    "City": "Chester"
  },
  {
    "State": "NE",
    "City": "Clatonia"
  },
  {
    "State": "NE",
    "City": "Cook"
  },
  {
    "State": "NE",
    "City": "Cordova"
  },
  {
    "State": "NE",
    "City": "Cortland"
  },
  {
    "State": "NE",
    "City": "Crab Orchard"
  },
  {
    "State": "NE",
    "City": "Crete"
  },
  {
    "State": "NE",
    "City": "Davenport"
  },
  {
    "State": "NE",
    "City": "Davey"
  },
  {
    "State": "NE",
    "City": "Dawson"
  },
  {
    "State": "NE",
    "City": "Daykin"
  },
  {
    "State": "NE",
    "City": "Denton"
  },
  {
    "State": "NE",
    "City": "Deshler"
  },
  {
    "State": "NE",
    "City": "De Witt"
  },
  {
    "State": "NE",
    "City": "Diller"
  },
  {
    "State": "NE",
    "City": "Dorchester"
  },
  {
    "State": "NE",
    "City": "Douglas"
  },
  {
    "State": "NE",
    "City": "Du Bois"
  },
  {
    "State": "NE",
    "City": "Dunbar"
  },
  {
    "State": "NE",
    "City": "Eagle"
  },
  {
    "State": "NE",
    "City": "Elk Creek"
  },
  {
    "State": "NE",
    "City": "Elmwood"
  },
  {
    "State": "NE",
    "City": "Endicott"
  },
  {
    "State": "NE",
    "City": "Exeter"
  },
  {
    "State": "NE",
    "City": "Fairbury"
  },
  {
    "State": "NE",
    "City": "Fairmont"
  },
  {
    "State": "NE",
    "City": "Falls City"
  },
  {
    "State": "NE",
    "City": "Filley"
  },
  {
    "State": "NE",
    "City": "Firth"
  },
  {
    "State": "NE",
    "City": "Friend"
  },
  {
    "State": "NE",
    "City": "Garland"
  },
  {
    "State": "NE",
    "City": "Geneva"
  },
  {
    "State": "NE",
    "City": "Gilead"
  },
  {
    "State": "NE",
    "City": "Goehner"
  },
  {
    "State": "NE",
    "City": "Grafton"
  },
  {
    "State": "NE",
    "City": "Greenwood"
  },
  {
    "State": "NE",
    "City": "Gresham"
  },
  {
    "State": "NE",
    "City": "Hallam"
  },
  {
    "State": "NE",
    "City": "Hebron"
  },
  {
    "State": "NE",
    "City": "Henderson"
  },
  {
    "State": "NE",
    "City": "Hickman"
  },
  {
    "State": "NE",
    "City": "Hubbell"
  },
  {
    "State": "NE",
    "City": "Humboldt"
  },
  {
    "State": "NE",
    "City": "Jansen"
  },
  {
    "State": "NE",
    "City": "Johnson"
  },
  {
    "State": "NE",
    "City": "Julian"
  },
  {
    "State": "NE",
    "City": "Lewiston"
  },
  {
    "State": "NE",
    "City": "Liberty"
  },
  {
    "State": "NE",
    "City": "Lorton"
  },
  {
    "State": "NE",
    "City": "Mc Cool Junction"
  },
  {
    "State": "NE",
    "City": "Malcolm"
  },
  {
    "State": "NE",
    "City": "Manley"
  },
  {
    "State": "NE",
    "City": "Martell"
  },
  {
    "State": "NE",
    "City": "Milford"
  },
  {
    "State": "NE",
    "City": "Milligan"
  },
  {
    "State": "NE",
    "City": "Murdock"
  },
  {
    "State": "NE",
    "City": "Murray"
  },
  {
    "State": "NE",
    "City": "Nebraska City"
  },
  {
    "State": "NE",
    "City": "Nehawka"
  },
  {
    "State": "NE",
    "City": "Nemaha"
  },
  {
    "State": "NE",
    "City": "Odell"
  },
  {
    "State": "NE",
    "City": "Ohiowa"
  },
  {
    "State": "NE",
    "City": "Otoe"
  },
  {
    "State": "NE",
    "City": "Palmyra"
  },
  {
    "State": "NE",
    "City": "Panama"
  },
  {
    "State": "NE",
    "City": "Pawnee City"
  },
  {
    "State": "NE",
    "City": "Peru"
  },
  {
    "State": "NE",
    "City": "Pickrell"
  },
  {
    "State": "NE",
    "City": "Pleasant Dale"
  },
  {
    "State": "NE",
    "City": "Plymouth"
  },
  {
    "State": "NE",
    "City": "Raymond"
  },
  {
    "State": "NE",
    "City": "Reynolds"
  },
  {
    "State": "NE",
    "City": "Roca"
  },
  {
    "State": "NE",
    "City": "Rulo"
  },
  {
    "State": "NE",
    "City": "Salem"
  },
  {
    "State": "NE",
    "City": "Seward"
  },
  {
    "State": "NE",
    "City": "Shickley"
  },
  {
    "State": "NE",
    "City": "Shubert"
  },
  {
    "State": "NE",
    "City": "Sprague"
  },
  {
    "State": "NE",
    "City": "Staplehurst"
  },
  {
    "State": "NE",
    "City": "Steele City"
  },
  {
    "State": "NE",
    "City": "Steinauer"
  },
  {
    "State": "NE",
    "City": "Stella"
  },
  {
    "State": "NE",
    "City": "Sterling"
  },
  {
    "State": "NE",
    "City": "Strang"
  },
  {
    "State": "NE",
    "City": "Swanton"
  },
  {
    "State": "NE",
    "City": "Syracuse"
  },
  {
    "State": "NE",
    "City": "Table Rock"
  },
  {
    "State": "NE",
    "City": "Talmage"
  },
  {
    "State": "NE",
    "City": "Tecumseh"
  },
  {
    "State": "NE",
    "City": "Ong"
  },
  {
    "State": "NE",
    "City": "Tobias"
  },
  {
    "State": "NE",
    "City": "Unadilla"
  },
  {
    "State": "NE",
    "City": "Union"
  },
  {
    "State": "NE",
    "City": "Utica"
  },
  {
    "State": "NE",
    "City": "Verdon"
  },
  {
    "State": "NE",
    "City": "Virginia"
  },
  {
    "State": "NE",
    "City": "Waco"
  },
  {
    "State": "NE",
    "City": "Walton"
  },
  {
    "State": "NE",
    "City": "Waverly"
  },
  {
    "State": "NE",
    "City": "Weeping Water"
  },
  {
    "State": "NE",
    "City": "Western"
  },
  {
    "State": "NE",
    "City": "Wilber"
  },
  {
    "State": "NE",
    "City": "Wymore"
  },
  {
    "State": "NE",
    "City": "York"
  },
  {
    "State": "NE",
    "City": "Lincoln"
  },
  {
    "State": "NE",
    "City": "Columbus"
  },
  {
    "State": "NE",
    "City": "Albion"
  },
  {
    "State": "NE",
    "City": "Ames"
  },
  {
    "State": "NE",
    "City": "Bartlett"
  },
  {
    "State": "NE",
    "City": "Belgrade"
  },
  {
    "State": "NE",
    "City": "Bellwood"
  },
  {
    "State": "NE",
    "City": "Brainard"
  },
  {
    "State": "NE",
    "City": "Cedar Rapids"
  },
  {
    "State": "NE",
    "City": "Clarks"
  },
  {
    "State": "NE",
    "City": "Clarkson"
  },
  {
    "State": "NE",
    "City": "Creston"
  },
  {
    "State": "NE",
    "City": "David City"
  },
  {
    "State": "NE",
    "City": "Dodge"
  },
  {
    "State": "NE",
    "City": "Duncan"
  },
  {
    "State": "NE",
    "City": "Dwight"
  },
  {
    "State": "NE",
    "City": "Elgin"
  },
  {
    "State": "NE",
    "City": "Ericson"
  },
  {
    "State": "NE",
    "City": "Fullerton"
  },
  {
    "State": "NE",
    "City": "Genoa"
  },
  {
    "State": "NE",
    "City": "Howells"
  },
  {
    "State": "NE",
    "City": "Humphrey"
  },
  {
    "State": "NE",
    "City": "Leigh"
  },
  {
    "State": "NE",
    "City": "Lindsay"
  },
  {
    "State": "NE",
    "City": "Monroe"
  },
  {
    "State": "NE",
    "City": "Morse Bluff"
  },
  {
    "State": "NE",
    "City": "North Bend"
  },
  {
    "State": "NE",
    "City": "Osceola"
  },
  {
    "State": "NE",
    "City": "Petersburg"
  },
  {
    "State": "NE",
    "City": "Platte Center"
  },
  {
    "State": "NE",
    "City": "Polk"
  },
  {
    "State": "NE",
    "City": "Primrose"
  },
  {
    "State": "NE",
    "City": "Rising City"
  },
  {
    "State": "NE",
    "City": "Rogers"
  },
  {
    "State": "NE",
    "City": "Saint Edward"
  },
  {
    "State": "NE",
    "City": "Schuyler"
  },
  {
    "State": "NE",
    "City": "Shelby"
  },
  {
    "State": "NE",
    "City": "Silver Creek"
  },
  {
    "State": "NE",
    "City": "Snyder"
  },
  {
    "State": "NE",
    "City": "Spalding"
  },
  {
    "State": "NE",
    "City": "Stromsburg"
  },
  {
    "State": "NE",
    "City": "Surprise"
  },
  {
    "State": "NE",
    "City": "Ulysses"
  },
  {
    "State": "NE",
    "City": "Norfolk"
  },
  {
    "State": "NE",
    "City": "Allen"
  },
  {
    "State": "NE",
    "City": "Amelia"
  },
  {
    "State": "NE",
    "City": "Atkinson"
  },
  {
    "State": "NE",
    "City": "Bassett"
  },
  {
    "State": "NE",
    "City": "Battle Creek"
  },
  {
    "State": "NE",
    "City": "Beemer"
  },
  {
    "State": "NE",
    "City": "Belden"
  },
  {
    "State": "NE",
    "City": "Bloomfield"
  },
  {
    "State": "NE",
    "City": "Bristow"
  },
  {
    "State": "NE",
    "City": "Brunswick"
  },
  {
    "State": "NE",
    "City": "Butte"
  },
  {
    "State": "NE",
    "City": "Carroll"
  },
  {
    "State": "NE",
    "City": "Center"
  },
  {
    "State": "NE",
    "City": "Chambers"
  },
  {
    "State": "NE",
    "City": "Clearwater"
  },
  {
    "State": "NE",
    "City": "Coleridge"
  },
  {
    "State": "NE",
    "City": "Concord"
  },
  {
    "State": "NE",
    "City": "Creighton"
  },
  {
    "State": "NE",
    "City": "Crofton"
  },
  {
    "State": "NE",
    "City": "Dakota City"
  },
  {
    "State": "NE",
    "City": "Dixon"
  },
  {
    "State": "NE",
    "City": "Emerson"
  },
  {
    "State": "NE",
    "City": "Emmet"
  },
  {
    "State": "NE",
    "City": "Ewing"
  },
  {
    "State": "NE",
    "City": "Fordyce"
  },
  {
    "State": "NE",
    "City": "Hadar"
  },
  {
    "State": "NE",
    "City": "Hartington"
  },
  {
    "State": "NE",
    "City": "Hoskins"
  },
  {
    "State": "NE",
    "City": "Hubbard"
  },
  {
    "State": "NE",
    "City": "Inman"
  },
  {
    "State": "NE",
    "City": "Jackson"
  },
  {
    "State": "NE",
    "City": "Laurel"
  },
  {
    "State": "NE",
    "City": "Lynch"
  },
  {
    "State": "NE",
    "City": "Mclean"
  },
  {
    "State": "NE",
    "City": "Madison"
  },
  {
    "State": "NE",
    "City": "Magnet"
  },
  {
    "State": "NE",
    "City": "Maskell"
  },
  {
    "State": "NE",
    "City": "Meadow Grove"
  },
  {
    "State": "NE",
    "City": "Mills"
  },
  {
    "State": "NE",
    "City": "Naper"
  },
  {
    "State": "NE",
    "City": "Neligh"
  },
  {
    "State": "NE",
    "City": "Newcastle"
  },
  {
    "State": "NE",
    "City": "Newman Grove"
  },
  {
    "State": "NE",
    "City": "Newport"
  },
  {
    "State": "NE",
    "City": "Niobrara"
  },
  {
    "State": "NE",
    "City": "Oakdale"
  },
  {
    "State": "NE",
    "City": "Oneill"
  },
  {
    "State": "NE",
    "City": "Orchard"
  },
  {
    "State": "NE",
    "City": "Osmond"
  },
  {
    "State": "NE",
    "City": "Page"
  },
  {
    "State": "NE",
    "City": "Pierce"
  },
  {
    "State": "NE",
    "City": "Pilger"
  },
  {
    "State": "NE",
    "City": "Plainview"
  },
  {
    "State": "NE",
    "City": "Ponca"
  },
  {
    "State": "NE",
    "City": "Randolph"
  },
  {
    "State": "NE",
    "City": "Royal"
  },
  {
    "State": "NE",
    "City": "Saint Helena"
  },
  {
    "State": "NE",
    "City": "South Sioux City"
  },
  {
    "State": "NE",
    "City": "Spencer"
  },
  {
    "State": "NE",
    "City": "Springview"
  },
  {
    "State": "NE",
    "City": "Stanton"
  },
  {
    "State": "NE",
    "City": "Stuart"
  },
  {
    "State": "NE",
    "City": "Tilden"
  },
  {
    "State": "NE",
    "City": "Verdigre"
  },
  {
    "State": "NE",
    "City": "Wakefield"
  },
  {
    "State": "NE",
    "City": "Waterbury"
  },
  {
    "State": "NE",
    "City": "Wausa"
  },
  {
    "State": "NE",
    "City": "Wayne"
  },
  {
    "State": "NE",
    "City": "West Point"
  },
  {
    "State": "NE",
    "City": "Winnetoon"
  },
  {
    "State": "NE",
    "City": "Winside"
  },
  {
    "State": "NE",
    "City": "Wisner"
  },
  {
    "State": "NE",
    "City": "Wynot"
  },
  {
    "State": "NE",
    "City": "Grand Island"
  },
  {
    "State": "NE",
    "City": "Alda"
  },
  {
    "State": "NE",
    "City": "Amherst"
  },
  {
    "State": "NE",
    "City": "Anselmo"
  },
  {
    "State": "NE",
    "City": "Ansley"
  },
  {
    "State": "NE",
    "City": "Arcadia"
  },
  {
    "State": "NE",
    "City": "Archer"
  },
  {
    "State": "NE",
    "City": "Ashton"
  },
  {
    "State": "NE",
    "City": "Aurora"
  },
  {
    "State": "NE",
    "City": "Boelus"
  },
  {
    "State": "NE",
    "City": "Brewster"
  },
  {
    "State": "NE",
    "City": "Broken Bow"
  },
  {
    "State": "NE",
    "City": "Burwell"
  },
  {
    "State": "NE",
    "City": "Cairo"
  },
  {
    "State": "NE",
    "City": "Callaway"
  },
  {
    "State": "NE",
    "City": "Central City"
  },
  {
    "State": "NE",
    "City": "Chapman"
  },
  {
    "State": "NE",
    "City": "Comstock"
  },
  {
    "State": "NE",
    "City": "Dannebrog"
  },
  {
    "State": "NE",
    "City": "Doniphan"
  },
  {
    "State": "NE",
    "City": "Dunning"
  },
  {
    "State": "NE",
    "City": "Eddyville"
  },
  {
    "State": "NE",
    "City": "Elba"
  },
  {
    "State": "NE",
    "City": "Elm Creek"
  },
  {
    "State": "NE",
    "City": "Elyria"
  },
  {
    "State": "NE",
    "City": "Farwell"
  },
  {
    "State": "NE",
    "City": "Gibbon"
  },
  {
    "State": "NE",
    "City": "Giltner"
  },
  {
    "State": "NE",
    "City": "Greeley"
  },
  {
    "State": "NE",
    "City": "Hampton"
  },
  {
    "State": "NE",
    "City": "Hazard"
  },
  {
    "State": "NE",
    "City": "Kearney"
  },
  {
    "State": "NE",
    "City": "Hordville"
  },
  {
    "State": "NE",
    "City": "Lexington"
  },
  {
    "State": "NE",
    "City": "Litchfield"
  },
  {
    "State": "NE",
    "City": "Loup City"
  },
  {
    "State": "NE",
    "City": "Marquette"
  },
  {
    "State": "NE",
    "City": "Mason City"
  },
  {
    "State": "NE",
    "City": "Merna"
  },
  {
    "State": "NE",
    "City": "Miller"
  },
  {
    "State": "NE",
    "City": "North Loup"
  },
  {
    "State": "NE",
    "City": "Oconto"
  },
  {
    "State": "NE",
    "City": "Odessa"
  },
  {
    "State": "NE",
    "City": "Ord"
  },
  {
    "State": "NE",
    "City": "Overton"
  },
  {
    "State": "NE",
    "City": "Palmer"
  },
  {
    "State": "NE",
    "City": "Phillips"
  },
  {
    "State": "NE",
    "City": "Pleasanton"
  },
  {
    "State": "NE",
    "City": "Ravenna"
  },
  {
    "State": "NE",
    "City": "Riverdale"
  },
  {
    "State": "NE",
    "City": "Rockville"
  },
  {
    "State": "NE",
    "City": "Saint Libory"
  },
  {
    "State": "NE",
    "City": "Saint Paul"
  },
  {
    "State": "NE",
    "City": "Sargent"
  },
  {
    "State": "NE",
    "City": "Scotia"
  },
  {
    "State": "NE",
    "City": "Shelton"
  },
  {
    "State": "NE",
    "City": "Sumner"
  },
  {
    "State": "NE",
    "City": "Taylor"
  },
  {
    "State": "NE",
    "City": "Westerville"
  },
  {
    "State": "NE",
    "City": "Wolbach"
  },
  {
    "State": "NE",
    "City": "Wood River"
  },
  {
    "State": "NE",
    "City": "Hastings"
  },
  {
    "State": "NE",
    "City": "Alma"
  },
  {
    "State": "NE",
    "City": "Arapahoe"
  },
  {
    "State": "NE",
    "City": "Atlanta"
  },
  {
    "State": "NE",
    "City": "Axtell"
  },
  {
    "State": "NE",
    "City": "Ayr"
  },
  {
    "State": "NE",
    "City": "Beaver City"
  },
  {
    "State": "NE",
    "City": "Bertrand"
  },
  {
    "State": "NE",
    "City": "Bladen"
  },
  {
    "State": "NE",
    "City": "Bloomington"
  },
  {
    "State": "NE",
    "City": "Blue Hill"
  },
  {
    "State": "NE",
    "City": "Campbell"
  },
  {
    "State": "NE",
    "City": "Clay Center"
  },
  {
    "State": "NE",
    "City": "Deweese"
  },
  {
    "State": "NE",
    "City": "Edgar"
  },
  {
    "State": "NE",
    "City": "Edison"
  },
  {
    "State": "NE",
    "City": "Elwood"
  },
  {
    "State": "NE",
    "City": "Fairfield"
  },
  {
    "State": "NE",
    "City": "Franklin"
  },
  {
    "State": "NE",
    "City": "Funk"
  },
  {
    "State": "NE",
    "City": "Glenvil"
  },
  {
    "State": "NE",
    "City": "Guide Rock"
  },
  {
    "State": "NE",
    "City": "Hardy"
  },
  {
    "State": "NE",
    "City": "Harvard"
  },
  {
    "State": "NE",
    "City": "Heartwell"
  },
  {
    "State": "NE",
    "City": "Hendley"
  },
  {
    "State": "NE",
    "City": "Hildreth"
  },
  {
    "State": "NE",
    "City": "Holbrook"
  },
  {
    "State": "NE",
    "City": "Holdrege"
  },
  {
    "State": "NE",
    "City": "Holstein"
  },
  {
    "State": "NE",
    "City": "Inavale"
  },
  {
    "State": "NE",
    "City": "Inland"
  },
  {
    "State": "NE",
    "City": "Juniata"
  },
  {
    "State": "NE",
    "City": "Kenesaw"
  },
  {
    "State": "NE",
    "City": "Lawrence"
  },
  {
    "State": "NE",
    "City": "Loomis"
  },
  {
    "State": "NE",
    "City": "Minden"
  },
  {
    "State": "NE",
    "City": "Naponee"
  },
  {
    "State": "NE",
    "City": "Nelson"
  },
  {
    "State": "NE",
    "City": "Oak"
  },
  {
    "State": "NE",
    "City": "Orleans"
  },
  {
    "State": "NE",
    "City": "Oxford"
  },
  {
    "State": "NE",
    "City": "Ragan"
  },
  {
    "State": "NE",
    "City": "Red Cloud"
  },
  {
    "State": "NE",
    "City": "Republican City"
  },
  {
    "State": "NE",
    "City": "Riverton"
  },
  {
    "State": "NE",
    "City": "Roseland"
  },
  {
    "State": "NE",
    "City": "Ruskin"
  },
  {
    "State": "NE",
    "City": "Saronville"
  },
  {
    "State": "NE",
    "City": "Smithfield"
  },
  {
    "State": "NE",
    "City": "Stamford"
  },
  {
    "State": "NE",
    "City": "Superior"
  },
  {
    "State": "NE",
    "City": "Sutton"
  },
  {
    "State": "NE",
    "City": "Trumbull"
  },
  {
    "State": "NE",
    "City": "Upland"
  },
  {
    "State": "NE",
    "City": "Wilcox"
  },
  {
    "State": "NE",
    "City": "Mc Cook"
  },
  {
    "State": "NE",
    "City": "Bartley"
  },
  {
    "State": "NE",
    "City": "Benkelman"
  },
  {
    "State": "NE",
    "City": "Cambridge"
  },
  {
    "State": "NE",
    "City": "Champion"
  },
  {
    "State": "NE",
    "City": "Culbertson"
  },
  {
    "State": "NE",
    "City": "Curtis"
  },
  {
    "State": "NE",
    "City": "Danbury"
  },
  {
    "State": "NE",
    "City": "Enders"
  },
  {
    "State": "NE",
    "City": "Eustis"
  },
  {
    "State": "NE",
    "City": "Farnam"
  },
  {
    "State": "NE",
    "City": "Haigler"
  },
  {
    "State": "NE",
    "City": "Hayes Center"
  },
  {
    "State": "NE",
    "City": "Imperial"
  },
  {
    "State": "NE",
    "City": "Indianola"
  },
  {
    "State": "NE",
    "City": "Lebanon"
  },
  {
    "State": "NE",
    "City": "Max"
  },
  {
    "State": "NE",
    "City": "Maywood"
  },
  {
    "State": "NE",
    "City": "Moorefield"
  },
  {
    "State": "NE",
    "City": "Palisade"
  },
  {
    "State": "NE",
    "City": "Parks"
  },
  {
    "State": "NE",
    "City": "Stockville"
  },
  {
    "State": "NE",
    "City": "Stratton"
  },
  {
    "State": "NE",
    "City": "Trenton"
  },
  {
    "State": "NE",
    "City": "Wauneta"
  },
  {
    "State": "NE",
    "City": "Wilsonville"
  },
  {
    "State": "NE",
    "City": "North Platte"
  },
  {
    "State": "NE",
    "City": "Arnold"
  },
  {
    "State": "NE",
    "City": "Arthur"
  },
  {
    "State": "NE",
    "City": "Big Springs"
  },
  {
    "State": "NE",
    "City": "Brady"
  },
  {
    "State": "NE",
    "City": "Broadwater"
  },
  {
    "State": "NE",
    "City": "Brule"
  },
  {
    "State": "NE",
    "City": "Bushnell"
  },
  {
    "State": "NE",
    "City": "Chappell"
  },
  {
    "State": "NE",
    "City": "Cozad"
  },
  {
    "State": "NE",
    "City": "Dalton"
  },
  {
    "State": "NE",
    "City": "Dickens"
  },
  {
    "State": "NE",
    "City": "Dix"
  },
  {
    "State": "NE",
    "City": "Elsie"
  },
  {
    "State": "NE",
    "City": "Elsmere"
  },
  {
    "State": "NE",
    "City": "Gothenburg"
  },
  {
    "State": "NE",
    "City": "Grant"
  },
  {
    "State": "NE",
    "City": "Gurley"
  },
  {
    "State": "NE",
    "City": "Halsey"
  },
  {
    "State": "NE",
    "City": "Hershey"
  },
  {
    "State": "NE",
    "City": "Keystone"
  },
  {
    "State": "NE",
    "City": "Kimball"
  },
  {
    "State": "NE",
    "City": "Lemoyne"
  },
  {
    "State": "NE",
    "City": "Lewellen"
  },
  {
    "State": "NE",
    "City": "Lisco"
  },
  {
    "State": "NE",
    "City": "Lodgepole"
  },
  {
    "State": "NE",
    "City": "Madrid"
  },
  {
    "State": "NE",
    "City": "Maxwell"
  },
  {
    "State": "NE",
    "City": "Mullen"
  },
  {
    "State": "NE",
    "City": "Ogallala"
  },
  {
    "State": "NE",
    "City": "Oshkosh"
  },
  {
    "State": "NE",
    "City": "Paxton"
  },
  {
    "State": "NE",
    "City": "Potter"
  },
  {
    "State": "NE",
    "City": "Purdum"
  },
  {
    "State": "NE",
    "City": "Sidney"
  },
  {
    "State": "NE",
    "City": "Seneca"
  },
  {
    "State": "NE",
    "City": "Stapleton"
  },
  {
    "State": "NE",
    "City": "Sutherland"
  },
  {
    "State": "NE",
    "City": "Thedford"
  },
  {
    "State": "NE",
    "City": "Tryon"
  },
  {
    "State": "NE",
    "City": "Venango"
  },
  {
    "State": "NE",
    "City": "Wallace"
  },
  {
    "State": "NE",
    "City": "Wellfleet"
  },
  {
    "State": "NE",
    "City": "Willow Island"
  },
  {
    "State": "NE",
    "City": "Valentine"
  },
  {
    "State": "NE",
    "City": "Ainsworth"
  },
  {
    "State": "NE",
    "City": "Cody"
  },
  {
    "State": "NE",
    "City": "Crookston"
  },
  {
    "State": "NE",
    "City": "Johnstown"
  },
  {
    "State": "NE",
    "City": "Kilgore"
  },
  {
    "State": "NE",
    "City": "Long Pine"
  },
  {
    "State": "NE",
    "City": "Merriman"
  },
  {
    "State": "NE",
    "City": "Nenzel"
  },
  {
    "State": "NE",
    "City": "Sparks"
  },
  {
    "State": "NE",
    "City": "Wood Lake"
  },
  {
    "State": "NE",
    "City": "Alliance"
  },
  {
    "State": "NE",
    "City": "Angora"
  },
  {
    "State": "NE",
    "City": "Ashby"
  },
  {
    "State": "NE",
    "City": "Bayard"
  },
  {
    "State": "NE",
    "City": "Bingham"
  },
  {
    "State": "NE",
    "City": "Bridgeport"
  },
  {
    "State": "NE",
    "City": "Chadron"
  },
  {
    "State": "NE",
    "City": "Crawford"
  },
  {
    "State": "NE",
    "City": "Ellsworth"
  },
  {
    "State": "NE",
    "City": "Gering"
  },
  {
    "State": "NE",
    "City": "Gordon"
  },
  {
    "State": "NE",
    "City": "Harrisburg"
  },
  {
    "State": "NE",
    "City": "Harrison"
  },
  {
    "State": "NE",
    "City": "Hay Springs"
  },
  {
    "State": "NE",
    "City": "Hemingford"
  },
  {
    "State": "NE",
    "City": "Hyannis"
  },
  {
    "State": "NE",
    "City": "Lakeside"
  },
  {
    "State": "NE",
    "City": "Lyman"
  },
  {
    "State": "NE",
    "City": "Mcgrew"
  },
  {
    "State": "NE",
    "City": "Marsland"
  },
  {
    "State": "NE",
    "City": "Melbeta"
  },
  {
    "State": "NE",
    "City": "Minatare"
  },
  {
    "State": "NE",
    "City": "Mitchell"
  },
  {
    "State": "NE",
    "City": "Morrill"
  },
  {
    "State": "NE",
    "City": "Rushville"
  },
  {
    "State": "NE",
    "City": "Scottsbluff"
  },
  {
    "State": "NE",
    "City": "Whiteclay"
  },
  {
    "State": "NE",
    "City": "Whitman"
  },
  {
    "State": "NE",
    "City": "Whitney"
  },
  {
    "State": "LA",
    "City": "Metairie"
  },
  {
    "State": "LA",
    "City": "Des Allemands"
  },
  {
    "State": "LA",
    "City": "Ama"
  },
  {
    "State": "LA",
    "City": "Arabi"
  },
  {
    "State": "LA",
    "City": "Barataria"
  },
  {
    "State": "LA",
    "City": "Belle Chasse"
  },
  {
    "State": "LA",
    "City": "Boothville"
  },
  {
    "State": "LA",
    "City": "Boutte"
  },
  {
    "State": "LA",
    "City": "Braithwaite"
  },
  {
    "State": "LA",
    "City": "Buras"
  },
  {
    "State": "LA",
    "City": "Chalmette"
  },
  {
    "State": "LA",
    "City": "Destrehan"
  },
  {
    "State": "LA",
    "City": "Edgard"
  },
  {
    "State": "LA",
    "City": "Empire"
  },
  {
    "State": "LA",
    "City": "Garyville"
  },
  {
    "State": "LA",
    "City": "Gramercy"
  },
  {
    "State": "LA",
    "City": "Gretna"
  },
  {
    "State": "LA",
    "City": "Hahnville"
  },
  {
    "State": "LA",
    "City": "Harvey"
  },
  {
    "State": "LA",
    "City": "Kenner"
  },
  {
    "State": "LA",
    "City": "Lafitte"
  },
  {
    "State": "LA",
    "City": "La Place"
  },
  {
    "State": "LA",
    "City": "Luling"
  },
  {
    "State": "LA",
    "City": "Lutcher"
  },
  {
    "State": "LA",
    "City": "Marrero"
  },
  {
    "State": "LA",
    "City": "Meraux"
  },
  {
    "State": "LA",
    "City": "Mount Airy"
  },
  {
    "State": "LA",
    "City": "New Sarpy"
  },
  {
    "State": "LA",
    "City": "Norco"
  },
  {
    "State": "LA",
    "City": "Paradis"
  },
  {
    "State": "LA",
    "City": "Pilottown"
  },
  {
    "State": "LA",
    "City": "Pointe A La Hache"
  },
  {
    "State": "LA",
    "City": "Port Sulphur"
  },
  {
    "State": "LA",
    "City": "Reserve"
  },
  {
    "State": "LA",
    "City": "Saint Bernard"
  },
  {
    "State": "LA",
    "City": "Saint James"
  },
  {
    "State": "LA",
    "City": "Saint Rose"
  },
  {
    "State": "LA",
    "City": "Vacherie"
  },
  {
    "State": "LA",
    "City": "Venice"
  },
  {
    "State": "LA",
    "City": "Violet"
  },
  {
    "State": "LA",
    "City": "Westwego"
  },
  {
    "State": "LA",
    "City": "New Orleans"
  },
  {
    "State": "LA",
    "City": "Thibodaux"
  },
  {
    "State": "LA",
    "City": "Pierre Part"
  },
  {
    "State": "LA",
    "City": "Amelia"
  },
  {
    "State": "LA",
    "City": "Belle Rose"
  },
  {
    "State": "LA",
    "City": "Berwick"
  },
  {
    "State": "LA",
    "City": "Bourg"
  },
  {
    "State": "LA",
    "City": "Chauvin"
  },
  {
    "State": "LA",
    "City": "Cut Off"
  },
  {
    "State": "LA",
    "City": "Donaldsonville"
  },
  {
    "State": "LA",
    "City": "Donner"
  },
  {
    "State": "LA",
    "City": "Dulac"
  },
  {
    "State": "LA",
    "City": "Galliano"
  },
  {
    "State": "LA",
    "City": "Gheens"
  },
  {
    "State": "LA",
    "City": "Gibson"
  },
  {
    "State": "LA",
    "City": "Golden Meadow"
  },
  {
    "State": "LA",
    "City": "Grand Isle"
  },
  {
    "State": "LA",
    "City": "Gray"
  },
  {
    "State": "LA",
    "City": "Houma"
  },
  {
    "State": "LA",
    "City": "Kraemer"
  },
  {
    "State": "LA",
    "City": "Labadieville"
  },
  {
    "State": "LA",
    "City": "Larose"
  },
  {
    "State": "LA",
    "City": "Lockport"
  },
  {
    "State": "LA",
    "City": "Mathews"
  },
  {
    "State": "LA",
    "City": "Montegut"
  },
  {
    "State": "LA",
    "City": "Morgan City"
  },
  {
    "State": "LA",
    "City": "Napoleonville"
  },
  {
    "State": "LA",
    "City": "Paincourtville"
  },
  {
    "State": "LA",
    "City": "Patterson"
  },
  {
    "State": "LA",
    "City": "Plattenville"
  },
  {
    "State": "LA",
    "City": "Raceland"
  },
  {
    "State": "LA",
    "City": "Schriever"
  },
  {
    "State": "LA",
    "City": "Theriot"
  },
  {
    "State": "LA",
    "City": "Hammond"
  },
  {
    "State": "LA",
    "City": "Abita Springs"
  },
  {
    "State": "LA",
    "City": "Akers"
  },
  {
    "State": "LA",
    "City": "Amite"
  },
  {
    "State": "LA",
    "City": "Angie"
  },
  {
    "State": "LA",
    "City": "Bogalusa"
  },
  {
    "State": "LA",
    "City": "Bush"
  },
  {
    "State": "LA",
    "City": "Covington"
  },
  {
    "State": "LA",
    "City": "Fluker"
  },
  {
    "State": "LA",
    "City": "Folsom"
  },
  {
    "State": "LA",
    "City": "Franklinton"
  },
  {
    "State": "LA",
    "City": "Greensburg"
  },
  {
    "State": "LA",
    "City": "Husser"
  },
  {
    "State": "LA",
    "City": "Independence"
  },
  {
    "State": "LA",
    "City": "Kentwood"
  },
  {
    "State": "LA",
    "City": "Lacombe"
  },
  {
    "State": "LA",
    "City": "Loranger"
  },
  {
    "State": "LA",
    "City": "Madisonville"
  },
  {
    "State": "LA",
    "City": "Mandeville"
  },
  {
    "State": "LA",
    "City": "Maurepas"
  },
  {
    "State": "LA",
    "City": "Mount Hermon"
  },
  {
    "State": "LA",
    "City": "Natalbany"
  },
  {
    "State": "LA",
    "City": "Pearl River"
  },
  {
    "State": "LA",
    "City": "Pine Grove"
  },
  {
    "State": "LA",
    "City": "Ponchatoula"
  },
  {
    "State": "LA",
    "City": "Robert"
  },
  {
    "State": "LA",
    "City": "Roseland"
  },
  {
    "State": "LA",
    "City": "Saint Benedict"
  },
  {
    "State": "LA",
    "City": "Slidell"
  },
  {
    "State": "LA",
    "City": "Springfield"
  },
  {
    "State": "LA",
    "City": "Sun"
  },
  {
    "State": "LA",
    "City": "Talisheek"
  },
  {
    "State": "LA",
    "City": "Tangipahoa"
  },
  {
    "State": "LA",
    "City": "Tickfaw"
  },
  {
    "State": "LA",
    "City": "Varnado"
  },
  {
    "State": "LA",
    "City": "Lafayette"
  },
  {
    "State": "LA",
    "City": "Abbeville"
  },
  {
    "State": "LA",
    "City": "Arnaudville"
  },
  {
    "State": "LA",
    "City": "Avery Island"
  },
  {
    "State": "LA",
    "City": "Baldwin"
  },
  {
    "State": "LA",
    "City": "Basile"
  },
  {
    "State": "LA",
    "City": "Branch"
  },
  {
    "State": "LA",
    "City": "Breaux Bridge"
  },
  {
    "State": "LA",
    "City": "Broussard"
  },
  {
    "State": "LA",
    "City": "Cade"
  },
  {
    "State": "LA",
    "City": "Carencro"
  },
  {
    "State": "LA",
    "City": "Cecilia"
  },
  {
    "State": "LA",
    "City": "Centerville"
  },
  {
    "State": "LA",
    "City": "Charenton"
  },
  {
    "State": "LA",
    "City": "Chataignier"
  },
  {
    "State": "LA",
    "City": "Church Point"
  },
  {
    "State": "LA",
    "City": "Crowley"
  },
  {
    "State": "LA",
    "City": "Delcambre"
  },
  {
    "State": "LA",
    "City": "Duson"
  },
  {
    "State": "LA",
    "City": "Egan"
  },
  {
    "State": "LA",
    "City": "Elton"
  },
  {
    "State": "LA",
    "City": "Erath"
  },
  {
    "State": "LA",
    "City": "Estherwood"
  },
  {
    "State": "LA",
    "City": "Eunice"
  },
  {
    "State": "LA",
    "City": "Evangeline"
  },
  {
    "State": "LA",
    "City": "Franklin"
  },
  {
    "State": "LA",
    "City": "Garden City"
  },
  {
    "State": "LA",
    "City": "Grand Coteau"
  },
  {
    "State": "LA",
    "City": "Gueydan"
  },
  {
    "State": "LA",
    "City": "Iota"
  },
  {
    "State": "LA",
    "City": "Jeanerette"
  },
  {
    "State": "LA",
    "City": "Jennings"
  },
  {
    "State": "LA",
    "City": "Kaplan"
  },
  {
    "State": "LA",
    "City": "Lake Arthur"
  },
  {
    "State": "LA",
    "City": "Lawtell"
  },
  {
    "State": "LA",
    "City": "Leonville"
  },
  {
    "State": "LA",
    "City": "Loreauville"
  },
  {
    "State": "LA",
    "City": "Mamou"
  },
  {
    "State": "LA",
    "City": "Maurice"
  },
  {
    "State": "LA",
    "City": "Mermentau"
  },
  {
    "State": "LA",
    "City": "Milton"
  },
  {
    "State": "LA",
    "City": "Morse"
  },
  {
    "State": "LA",
    "City": "New Iberia"
  },
  {
    "State": "LA",
    "City": "Lydia"
  },
  {
    "State": "LA",
    "City": "Opelousas"
  },
  {
    "State": "LA",
    "City": "Perry"
  },
  {
    "State": "LA",
    "City": "Pine Prairie"
  },
  {
    "State": "LA",
    "City": "Port Barre"
  },
  {
    "State": "LA",
    "City": "Rayne"
  },
  {
    "State": "LA",
    "City": "Reddell"
  },
  {
    "State": "LA",
    "City": "Roanoke"
  },
  {
    "State": "LA",
    "City": "Saint Martinville"
  },
  {
    "State": "LA",
    "City": "Scott"
  },
  {
    "State": "LA",
    "City": "Sunset"
  },
  {
    "State": "LA",
    "City": "Turkey Creek"
  },
  {
    "State": "LA",
    "City": "Ville Platte"
  },
  {
    "State": "LA",
    "City": "Washington"
  },
  {
    "State": "LA",
    "City": "Welsh"
  },
  {
    "State": "LA",
    "City": "Youngsville"
  },
  {
    "State": "LA",
    "City": "Lake Charles"
  },
  {
    "State": "LA",
    "City": "Bell City"
  },
  {
    "State": "LA",
    "City": "Cameron"
  },
  {
    "State": "LA",
    "City": "Creole"
  },
  {
    "State": "LA",
    "City": "Dequincy"
  },
  {
    "State": "LA",
    "City": "Deridder"
  },
  {
    "State": "LA",
    "City": "Dry Creek"
  },
  {
    "State": "LA",
    "City": "Elizabeth"
  },
  {
    "State": "LA",
    "City": "Evans"
  },
  {
    "State": "LA",
    "City": "Fenton"
  },
  {
    "State": "LA",
    "City": "Grand Chenier"
  },
  {
    "State": "LA",
    "City": "Grant"
  },
  {
    "State": "LA",
    "City": "Hackberry"
  },
  {
    "State": "LA",
    "City": "Hayes"
  },
  {
    "State": "LA",
    "City": "Iowa"
  },
  {
    "State": "LA",
    "City": "Kinder"
  },
  {
    "State": "LA",
    "City": "Lacassine"
  },
  {
    "State": "LA",
    "City": "Leblanc"
  },
  {
    "State": "LA",
    "City": "Longville"
  },
  {
    "State": "LA",
    "City": "Merryville"
  },
  {
    "State": "LA",
    "City": "Mittie"
  },
  {
    "State": "LA",
    "City": "Oberlin"
  },
  {
    "State": "LA",
    "City": "Pitkin"
  },
  {
    "State": "LA",
    "City": "Ragley"
  },
  {
    "State": "LA",
    "City": "Reeves"
  },
  {
    "State": "LA",
    "City": "Rosepine"
  },
  {
    "State": "LA",
    "City": "Singer"
  },
  {
    "State": "LA",
    "City": "Starks"
  },
  {
    "State": "LA",
    "City": "Sugartown"
  },
  {
    "State": "LA",
    "City": "Sulphur"
  },
  {
    "State": "LA",
    "City": "Vinton"
  },
  {
    "State": "LA",
    "City": "Westlake"
  },
  {
    "State": "LA",
    "City": "Baker"
  },
  {
    "State": "LA",
    "City": "Denham Springs"
  },
  {
    "State": "LA",
    "City": "Gonzales"
  },
  {
    "State": "LA",
    "City": "Addis"
  },
  {
    "State": "LA",
    "City": "Albany"
  },
  {
    "State": "LA",
    "City": "Angola"
  },
  {
    "State": "LA",
    "City": "Batchelor"
  },
  {
    "State": "LA",
    "City": "Brittany"
  },
  {
    "State": "LA",
    "City": "Brusly"
  },
  {
    "State": "LA",
    "City": "Carville"
  },
  {
    "State": "LA",
    "City": "Clinton"
  },
  {
    "State": "LA",
    "City": "Convent"
  },
  {
    "State": "LA",
    "City": "Darrow"
  },
  {
    "State": "LA",
    "City": "Duplessis"
  },
  {
    "State": "LA",
    "City": "Erwinville"
  },
  {
    "State": "LA",
    "City": "Ethel"
  },
  {
    "State": "LA",
    "City": "Fordoche"
  },
  {
    "State": "LA",
    "City": "French Settlement"
  },
  {
    "State": "LA",
    "City": "Geismar"
  },
  {
    "State": "LA",
    "City": "Glynn"
  },
  {
    "State": "LA",
    "City": "Burnside"
  },
  {
    "State": "LA",
    "City": "Greenwell Springs"
  },
  {
    "State": "LA",
    "City": "Grosse Tete"
  },
  {
    "State": "LA",
    "City": "Hester"
  },
  {
    "State": "LA",
    "City": "Holden"
  },
  {
    "State": "LA",
    "City": "Innis"
  },
  {
    "State": "LA",
    "City": "Jackson"
  },
  {
    "State": "LA",
    "City": "Jarreau"
  },
  {
    "State": "LA",
    "City": "Krotz Springs"
  },
  {
    "State": "LA",
    "City": "Lakeland"
  },
  {
    "State": "LA",
    "City": "Lettsworth"
  },
  {
    "State": "LA",
    "City": "Livingston"
  },
  {
    "State": "LA",
    "City": "Livonia"
  },
  {
    "State": "LA",
    "City": "Lottie"
  },
  {
    "State": "LA",
    "City": "Maringouin"
  },
  {
    "State": "LA",
    "City": "Morganza"
  },
  {
    "State": "LA",
    "City": "New Roads"
  },
  {
    "State": "LA",
    "City": "Norwood"
  },
  {
    "State": "LA",
    "City": "Oscar"
  },
  {
    "State": "LA",
    "City": "Paulina"
  },
  {
    "State": "LA",
    "City": "Plaquemine"
  },
  {
    "State": "LA",
    "City": "Port Allen"
  },
  {
    "State": "LA",
    "City": "Prairieville"
  },
  {
    "State": "LA",
    "City": "Pride"
  },
  {
    "State": "LA",
    "City": "Rosedale"
  },
  {
    "State": "LA",
    "City": "Rougon"
  },
  {
    "State": "LA",
    "City": "Saint Amant"
  },
  {
    "State": "LA",
    "City": "Saint Francisville"
  },
  {
    "State": "LA",
    "City": "Saint Gabriel"
  },
  {
    "State": "LA",
    "City": "Slaughter"
  },
  {
    "State": "LA",
    "City": "Sorrento"
  },
  {
    "State": "LA",
    "City": "Sunshine"
  },
  {
    "State": "LA",
    "City": "Tunica"
  },
  {
    "State": "LA",
    "City": "Ventress"
  },
  {
    "State": "LA",
    "City": "Wakefield"
  },
  {
    "State": "LA",
    "City": "Walker"
  },
  {
    "State": "LA",
    "City": "Watson"
  },
  {
    "State": "LA",
    "City": "Weyanoke"
  },
  {
    "State": "LA",
    "City": "White Castle"
  },
  {
    "State": "LA",
    "City": "Wilson"
  },
  {
    "State": "LA",
    "City": "Zachary"
  },
  {
    "State": "LA",
    "City": "Uncle Sam"
  },
  {
    "State": "LA",
    "City": "Baton Rouge"
  },
  {
    "State": "LA",
    "City": "Arcadia"
  },
  {
    "State": "LA",
    "City": "Ashland"
  },
  {
    "State": "LA",
    "City": "Athens"
  },
  {
    "State": "LA",
    "City": "Belcher"
  },
  {
    "State": "LA",
    "City": "Benton"
  },
  {
    "State": "LA",
    "City": "Bethany"
  },
  {
    "State": "LA",
    "City": "Bienville"
  },
  {
    "State": "LA",
    "City": "Blanchard"
  },
  {
    "State": "LA",
    "City": "Castor"
  },
  {
    "State": "LA",
    "City": "Cotton Valley"
  },
  {
    "State": "LA",
    "City": "Coushatta"
  },
  {
    "State": "LA",
    "City": "Cullen"
  },
  {
    "State": "LA",
    "City": "Doyline"
  },
  {
    "State": "LA",
    "City": "Dubberly"
  },
  {
    "State": "LA",
    "City": "Frierson"
  },
  {
    "State": "LA",
    "City": "Gibsland"
  },
  {
    "State": "LA",
    "City": "Gilliam"
  },
  {
    "State": "LA",
    "City": "Gloster"
  },
  {
    "State": "LA",
    "City": "Goldonna"
  },
  {
    "State": "LA",
    "City": "Grand Cane"
  },
  {
    "State": "LA",
    "City": "Greenwood"
  },
  {
    "State": "LA",
    "City": "Hall Summit"
  },
  {
    "State": "LA",
    "City": "Haughton"
  },
  {
    "State": "LA",
    "City": "Haynesville"
  },
  {
    "State": "LA",
    "City": "Heflin"
  },
  {
    "State": "LA",
    "City": "Homer"
  },
  {
    "State": "LA",
    "City": "Hosston"
  },
  {
    "State": "LA",
    "City": "Ida"
  },
  {
    "State": "LA",
    "City": "Jamestown"
  },
  {
    "State": "LA",
    "City": "Keatchie"
  },
  {
    "State": "LA",
    "City": "Keithville"
  },
  {
    "State": "LA",
    "City": "Lisbon"
  },
  {
    "State": "LA",
    "City": "Logansport"
  },
  {
    "State": "LA",
    "City": "Longstreet"
  },
  {
    "State": "LA",
    "City": "Elm Grove"
  },
  {
    "State": "LA",
    "City": "Mansfield"
  },
  {
    "State": "LA",
    "City": "Minden"
  },
  {
    "State": "LA",
    "City": "Mooringsport"
  },
  {
    "State": "LA",
    "City": "Oil City"
  },
  {
    "State": "LA",
    "City": "Pelican"
  },
  {
    "State": "LA",
    "City": "Plain Dealing"
  },
  {
    "State": "LA",
    "City": "Pleasant Hill"
  },
  {
    "State": "LA",
    "City": "Powhatan"
  },
  {
    "State": "LA",
    "City": "Princeton"
  },
  {
    "State": "LA",
    "City": "Ringgold"
  },
  {
    "State": "LA",
    "City": "Rodessa"
  },
  {
    "State": "LA",
    "City": "Saline"
  },
  {
    "State": "LA",
    "City": "Sarepta"
  },
  {
    "State": "LA",
    "City": "Shongaloo"
  },
  {
    "State": "LA",
    "City": "Sibley"
  },
  {
    "State": "LA",
    "City": "Springhill"
  },
  {
    "State": "LA",
    "City": "Stonewall"
  },
  {
    "State": "LA",
    "City": "Summerfield"
  },
  {
    "State": "LA",
    "City": "Taylor"
  },
  {
    "State": "LA",
    "City": "Vivian"
  },
  {
    "State": "LA",
    "City": "Shreveport"
  },
  {
    "State": "LA",
    "City": "Barksdale AFB"
  },
  {
    "State": "LA",
    "City": "Bossier City"
  },
  {
    "State": "LA",
    "City": "Monroe"
  },
  {
    "State": "LA",
    "City": "Archibald"
  },
  {
    "State": "LA",
    "City": "Baskin"
  },
  {
    "State": "LA",
    "City": "Bastrop"
  },
  {
    "State": "LA",
    "City": "Bernice"
  },
  {
    "State": "LA",
    "City": "Bonita"
  },
  {
    "State": "LA",
    "City": "Calhoun"
  },
  {
    "State": "LA",
    "City": "Chatham"
  },
  {
    "State": "LA",
    "City": "Choudrant"
  },
  {
    "State": "LA",
    "City": "Collinston"
  },
  {
    "State": "LA",
    "City": "Crowville"
  },
  {
    "State": "LA",
    "City": "Delhi"
  },
  {
    "State": "LA",
    "City": "Delta"
  },
  {
    "State": "LA",
    "City": "Downsville"
  },
  {
    "State": "LA",
    "City": "Dubach"
  },
  {
    "State": "LA",
    "City": "Epps"
  },
  {
    "State": "LA",
    "City": "Eros"
  },
  {
    "State": "LA",
    "City": "Fairbanks"
  },
  {
    "State": "LA",
    "City": "Farmerville"
  },
  {
    "State": "LA",
    "City": "Forest"
  },
  {
    "State": "LA",
    "City": "Fort Necessity"
  },
  {
    "State": "LA",
    "City": "Grambling"
  },
  {
    "State": "LA",
    "City": "Hodge"
  },
  {
    "State": "LA",
    "City": "Jigger"
  },
  {
    "State": "LA",
    "City": "Jones"
  },
  {
    "State": "LA",
    "City": "Jonesboro"
  },
  {
    "State": "LA",
    "City": "Kilbourne"
  },
  {
    "State": "LA",
    "City": "Lake Providence"
  },
  {
    "State": "LA",
    "City": "Lillie"
  },
  {
    "State": "LA",
    "City": "Mangham"
  },
  {
    "State": "LA",
    "City": "Marion"
  },
  {
    "State": "LA",
    "City": "Mer Rouge"
  },
  {
    "State": "LA",
    "City": "Oak Grove"
  },
  {
    "State": "LA",
    "City": "Oak Ridge"
  },
  {
    "State": "LA",
    "City": "Pioneer"
  },
  {
    "State": "LA",
    "City": "Quitman"
  },
  {
    "State": "LA",
    "City": "Rayville"
  },
  {
    "State": "LA",
    "City": "Ruston"
  },
  {
    "State": "LA",
    "City": "Simsboro"
  },
  {
    "State": "LA",
    "City": "Sondheimer"
  },
  {
    "State": "LA",
    "City": "Spearsville"
  },
  {
    "State": "LA",
    "City": "Start"
  },
  {
    "State": "LA",
    "City": "Sterlington"
  },
  {
    "State": "LA",
    "City": "Swartz"
  },
  {
    "State": "LA",
    "City": "Tallulah"
  },
  {
    "State": "LA",
    "City": "Transylvania"
  },
  {
    "State": "LA",
    "City": "West Monroe"
  },
  {
    "State": "LA",
    "City": "Winnsboro"
  },
  {
    "State": "LA",
    "City": "Alexandria"
  },
  {
    "State": "LA",
    "City": "Acme"
  },
  {
    "State": "LA",
    "City": "Bordelonville"
  },
  {
    "State": "LA",
    "City": "Bunkie"
  },
  {
    "State": "LA",
    "City": "Center Point"
  },
  {
    "State": "LA",
    "City": "Chase"
  },
  {
    "State": "LA",
    "City": "Cheneyville"
  },
  {
    "State": "LA",
    "City": "Clayton"
  },
  {
    "State": "LA",
    "City": "Cottonport"
  },
  {
    "State": "LA",
    "City": "Deville"
  },
  {
    "State": "LA",
    "City": "Dupont"
  },
  {
    "State": "LA",
    "City": "Echo"
  },
  {
    "State": "LA",
    "City": "Effie"
  },
  {
    "State": "LA",
    "City": "Evergreen"
  },
  {
    "State": "LA",
    "City": "Ferriday"
  },
  {
    "State": "LA",
    "City": "Gilbert"
  },
  {
    "State": "LA",
    "City": "Hamburg"
  },
  {
    "State": "LA",
    "City": "Harrisonburg"
  },
  {
    "State": "LA",
    "City": "Hessmer"
  },
  {
    "State": "LA",
    "City": "Jena"
  },
  {
    "State": "LA",
    "City": "Jonesville"
  },
  {
    "State": "LA",
    "City": "Lebeau"
  },
  {
    "State": "LA",
    "City": "Lecompte"
  },
  {
    "State": "LA",
    "City": "Libuse"
  },
  {
    "State": "LA",
    "City": "Mansura"
  },
  {
    "State": "LA",
    "City": "Marksville"
  },
  {
    "State": "LA",
    "City": "Melville"
  },
  {
    "State": "LA",
    "City": "Monterey"
  },
  {
    "State": "LA",
    "City": "Moreauville"
  },
  {
    "State": "LA",
    "City": "Morrow"
  },
  {
    "State": "LA",
    "City": "Newellton"
  },
  {
    "State": "LA",
    "City": "Palmetto"
  },
  {
    "State": "LA",
    "City": "Pineville"
  },
  {
    "State": "LA",
    "City": "Plaucheville"
  },
  {
    "State": "LA",
    "City": "Rhinehart"
  },
  {
    "State": "LA",
    "City": "Ruby"
  },
  {
    "State": "LA",
    "City": "Saint Joseph"
  },
  {
    "State": "LA",
    "City": "Saint Landry"
  },
  {
    "State": "LA",
    "City": "Sicily Island"
  },
  {
    "State": "LA",
    "City": "Simmesport"
  },
  {
    "State": "LA",
    "City": "Trout"
  },
  {
    "State": "LA",
    "City": "Vidalia"
  },
  {
    "State": "LA",
    "City": "Waterproof"
  },
  {
    "State": "LA",
    "City": "Wildsville"
  },
  {
    "State": "LA",
    "City": "Wisner"
  },
  {
    "State": "LA",
    "City": "Aimwell"
  },
  {
    "State": "LA",
    "City": "Anacoco"
  },
  {
    "State": "LA",
    "City": "Atlanta"
  },
  {
    "State": "LA",
    "City": "Ball"
  },
  {
    "State": "LA",
    "City": "Belmont"
  },
  {
    "State": "LA",
    "City": "Bentley"
  },
  {
    "State": "LA",
    "City": "Boyce"
  },
  {
    "State": "LA",
    "City": "Calvin"
  },
  {
    "State": "LA",
    "City": "Campti"
  },
  {
    "State": "LA",
    "City": "Clarence"
  },
  {
    "State": "LA",
    "City": "Clarks"
  },
  {
    "State": "LA",
    "City": "Cloutierville"
  },
  {
    "State": "LA",
    "City": "Colfax"
  },
  {
    "State": "LA",
    "City": "Columbia"
  },
  {
    "State": "LA",
    "City": "Converse"
  },
  {
    "State": "LA",
    "City": "Dodson"
  },
  {
    "State": "LA",
    "City": "Dry Prong"
  },
  {
    "State": "LA",
    "City": "Elmer"
  },
  {
    "State": "LA",
    "City": "Enterprise"
  },
  {
    "State": "LA",
    "City": "Fisher"
  },
  {
    "State": "LA",
    "City": "Flatwoods"
  },
  {
    "State": "LA",
    "City": "Flora"
  },
  {
    "State": "LA",
    "City": "Florien"
  },
  {
    "State": "LA",
    "City": "Forest Hill"
  },
  {
    "State": "LA",
    "City": "Gardner"
  },
  {
    "State": "LA",
    "City": "Georgetown"
  },
  {
    "State": "LA",
    "City": "Glenmora"
  },
  {
    "State": "LA",
    "City": "Gorum"
  },
  {
    "State": "LA",
    "City": "Grayson"
  },
  {
    "State": "LA",
    "City": "Hineston"
  },
  {
    "State": "LA",
    "City": "Hornbeck"
  },
  {
    "State": "LA",
    "City": "Joyce"
  },
  {
    "State": "LA",
    "City": "Kelly"
  },
  {
    "State": "LA",
    "City": "Kurthwood"
  },
  {
    "State": "LA",
    "City": "Leesville"
  },
  {
    "State": "LA",
    "City": "Lena"
  },
  {
    "State": "LA",
    "City": "Longleaf"
  },
  {
    "State": "LA",
    "City": "Many"
  },
  {
    "State": "LA",
    "City": "Marthaville"
  },
  {
    "State": "LA",
    "City": "Melrose"
  },
  {
    "State": "LA",
    "City": "Montgomery"
  },
  {
    "State": "LA",
    "City": "Mora"
  },
  {
    "State": "LA",
    "City": "Natchez"
  },
  {
    "State": "LA",
    "City": "Natchitoches"
  },
  {
    "State": "LA",
    "City": "Fort Polk"
  },
  {
    "State": "LA",
    "City": "Negreet"
  },
  {
    "State": "LA",
    "City": "New Llano"
  },
  {
    "State": "LA",
    "City": "Noble"
  },
  {
    "State": "LA",
    "City": "Oakdale"
  },
  {
    "State": "LA",
    "City": "Olla"
  },
  {
    "State": "LA",
    "City": "Otis"
  },
  {
    "State": "LA",
    "City": "Pollock"
  },
  {
    "State": "LA",
    "City": "Provencal"
  },
  {
    "State": "LA",
    "City": "Robeline"
  },
  {
    "State": "LA",
    "City": "Saint Maurice"
  },
  {
    "State": "LA",
    "City": "Sieper"
  },
  {
    "State": "LA",
    "City": "Sikes"
  },
  {
    "State": "LA",
    "City": "Simpson"
  },
  {
    "State": "LA",
    "City": "Slagle"
  },
  {
    "State": "LA",
    "City": "Tioga"
  },
  {
    "State": "LA",
    "City": "Tullos"
  },
  {
    "State": "LA",
    "City": "Urania"
  },
  {
    "State": "LA",
    "City": "Winnfield"
  },
  {
    "State": "LA",
    "City": "Woodworth"
  },
  {
    "State": "LA",
    "City": "Zwolle"
  },
  {
    "State": "AR",
    "City": "Pine Bluff"
  },
  {
    "State": "AR",
    "City": "White Hall"
  },
  {
    "State": "AR",
    "City": "Arkansas City"
  },
  {
    "State": "AR",
    "City": "Banks"
  },
  {
    "State": "AR",
    "City": "Crossett"
  },
  {
    "State": "AR",
    "City": "Dermott"
  },
  {
    "State": "AR",
    "City": "Dumas"
  },
  {
    "State": "AR",
    "City": "Eudora"
  },
  {
    "State": "AR",
    "City": "Fountain Hill"
  },
  {
    "State": "AR",
    "City": "Gould"
  },
  {
    "State": "AR",
    "City": "Grady"
  },
  {
    "State": "AR",
    "City": "Hamburg"
  },
  {
    "State": "AR",
    "City": "Hermitage"
  },
  {
    "State": "AR",
    "City": "Jersey"
  },
  {
    "State": "AR",
    "City": "Kingsland"
  },
  {
    "State": "AR",
    "City": "Lake Village"
  },
  {
    "State": "AR",
    "City": "Mc Gehee"
  },
  {
    "State": "AR",
    "City": "Monticello"
  },
  {
    "State": "AR",
    "City": "Montrose"
  },
  {
    "State": "AR",
    "City": "Moscow"
  },
  {
    "State": "AR",
    "City": "New Edinburg"
  },
  {
    "State": "AR",
    "City": "Parkdale"
  },
  {
    "State": "AR",
    "City": "Pickens"
  },
  {
    "State": "AR",
    "City": "Portland"
  },
  {
    "State": "AR",
    "City": "Rison"
  },
  {
    "State": "AR",
    "City": "Rohwer"
  },
  {
    "State": "AR",
    "City": "Star City"
  },
  {
    "State": "AR",
    "City": "Tillar"
  },
  {
    "State": "AR",
    "City": "Warren"
  },
  {
    "State": "AR",
    "City": "Watson"
  },
  {
    "State": "AR",
    "City": "Wilmar"
  },
  {
    "State": "AR",
    "City": "Wilmot"
  },
  {
    "State": "AR",
    "City": "Winchester"
  },
  {
    "State": "AR",
    "City": "Yorktown"
  },
  {
    "State": "AR",
    "City": "Camden"
  },
  {
    "State": "AR",
    "City": "Bearden"
  },
  {
    "State": "AR",
    "City": "Beirne"
  },
  {
    "State": "AR",
    "City": "Bluff City"
  },
  {
    "State": "AR",
    "City": "Calion"
  },
  {
    "State": "AR",
    "City": "Carthage"
  },
  {
    "State": "AR",
    "City": "Chidester"
  },
  {
    "State": "AR",
    "City": "Curtis"
  },
  {
    "State": "AR",
    "City": "El Dorado"
  },
  {
    "State": "AR",
    "City": "Emerson"
  },
  {
    "State": "AR",
    "City": "Fordyce"
  },
  {
    "State": "AR",
    "City": "Gurdon"
  },
  {
    "State": "AR",
    "City": "Hampton"
  },
  {
    "State": "AR",
    "City": "Harrell"
  },
  {
    "State": "AR",
    "City": "Huttig"
  },
  {
    "State": "AR",
    "City": "Ivan"
  },
  {
    "State": "AR",
    "City": "Junction City"
  },
  {
    "State": "AR",
    "City": "Lawson"
  },
  {
    "State": "AR",
    "City": "Louann"
  },
  {
    "State": "AR",
    "City": "Mc Neil"
  },
  {
    "State": "AR",
    "City": "Magnolia"
  },
  {
    "State": "AR",
    "City": "Mount Holly"
  },
  {
    "State": "AR",
    "City": "Norphlet"
  },
  {
    "State": "AR",
    "City": "Smackover"
  },
  {
    "State": "AR",
    "City": "Sparkman"
  },
  {
    "State": "AR",
    "City": "Stephens"
  },
  {
    "State": "AR",
    "City": "Strong"
  },
  {
    "State": "AR",
    "City": "Thornton"
  },
  {
    "State": "AR",
    "City": "Waldo"
  },
  {
    "State": "AR",
    "City": "Whelen Springs"
  },
  {
    "State": "AR",
    "City": "Hope"
  },
  {
    "State": "AR",
    "City": "Alleene"
  },
  {
    "State": "AR",
    "City": "Ashdown"
  },
  {
    "State": "AR",
    "City": "Ben Lomond"
  },
  {
    "State": "AR",
    "City": "Blevins"
  },
  {
    "State": "AR",
    "City": "Bradley"
  },
  {
    "State": "AR",
    "City": "Buckner"
  },
  {
    "State": "AR",
    "City": "Cale"
  },
  {
    "State": "AR",
    "City": "Columbus"
  },
  {
    "State": "AR",
    "City": "De Queen"
  },
  {
    "State": "AR",
    "City": "Dierks"
  },
  {
    "State": "AR",
    "City": "Doddridge"
  },
  {
    "State": "AR",
    "City": "Emmet"
  },
  {
    "State": "AR",
    "City": "Foreman"
  },
  {
    "State": "AR",
    "City": "Fouke"
  },
  {
    "State": "AR",
    "City": "Fulton"
  },
  {
    "State": "AR",
    "City": "Garland City"
  },
  {
    "State": "AR",
    "City": "Genoa"
  },
  {
    "State": "AR",
    "City": "Gillham"
  },
  {
    "State": "AR",
    "City": "Horatio"
  },
  {
    "State": "AR",
    "City": "Laneburg"
  },
  {
    "State": "AR",
    "City": "Lewisville"
  },
  {
    "State": "AR",
    "City": "Lockesburg"
  },
  {
    "State": "AR",
    "City": "Mc Caskill"
  },
  {
    "State": "AR",
    "City": "Mineral Springs"
  },
  {
    "State": "AR",
    "City": "Nashville"
  },
  {
    "State": "AR",
    "City": "Ogden"
  },
  {
    "State": "AR",
    "City": "Texarkana"
  },
  {
    "State": "AR",
    "City": "Ozan"
  },
  {
    "State": "AR",
    "City": "Prescott"
  },
  {
    "State": "AR",
    "City": "Rosston"
  },
  {
    "State": "AR",
    "City": "Saratoga"
  },
  {
    "State": "AR",
    "City": "Stamps"
  },
  {
    "State": "AR",
    "City": "Taylor"
  },
  {
    "State": "AR",
    "City": "Washington"
  },
  {
    "State": "AR",
    "City": "Willisville"
  },
  {
    "State": "AR",
    "City": "Wilton"
  },
  {
    "State": "AR",
    "City": "Winthrop"
  },
  {
    "State": "AR",
    "City": "Hot Springs National Park"
  },
  {
    "State": "AR",
    "City": "Hot Springs Village"
  },
  {
    "State": "AR",
    "City": "Alpine"
  },
  {
    "State": "AR",
    "City": "Amity"
  },
  {
    "State": "AR",
    "City": "Antoine"
  },
  {
    "State": "AR",
    "City": "Arkadelphia"
  },
  {
    "State": "AR",
    "City": "Bismarck"
  },
  {
    "State": "AR",
    "City": "Board Camp"
  },
  {
    "State": "AR",
    "City": "Bonnerdale"
  },
  {
    "State": "AR",
    "City": "Caddo Gap"
  },
  {
    "State": "AR",
    "City": "Cove"
  },
  {
    "State": "AR",
    "City": "Delight"
  },
  {
    "State": "AR",
    "City": "Donaldson"
  },
  {
    "State": "AR",
    "City": "Friendship"
  },
  {
    "State": "AR",
    "City": "Glenwood"
  },
  {
    "State": "AR",
    "City": "Grannis"
  },
  {
    "State": "AR",
    "City": "Hatfield"
  },
  {
    "State": "AR",
    "City": "Jessieville"
  },
  {
    "State": "AR",
    "City": "Kirby"
  },
  {
    "State": "AR",
    "City": "Langley"
  },
  {
    "State": "AR",
    "City": "Mena"
  },
  {
    "State": "AR",
    "City": "Mountain Pine"
  },
  {
    "State": "AR",
    "City": "Mount Ida"
  },
  {
    "State": "AR",
    "City": "Murfreesboro"
  },
  {
    "State": "AR",
    "City": "Newhope"
  },
  {
    "State": "AR",
    "City": "Norman"
  },
  {
    "State": "AR",
    "City": "Oden"
  },
  {
    "State": "AR",
    "City": "Okolona"
  },
  {
    "State": "AR",
    "City": "Pearcy"
  },
  {
    "State": "AR",
    "City": "Pencil Bluff"
  },
  {
    "State": "AR",
    "City": "Royal"
  },
  {
    "State": "AR",
    "City": "Sims"
  },
  {
    "State": "AR",
    "City": "Story"
  },
  {
    "State": "AR",
    "City": "Umpire"
  },
  {
    "State": "AR",
    "City": "Vandervoort"
  },
  {
    "State": "AR",
    "City": "Wickes"
  },
  {
    "State": "AR",
    "City": "Adona"
  },
  {
    "State": "AR",
    "City": "Alexander"
  },
  {
    "State": "AR",
    "City": "Almyra"
  },
  {
    "State": "AR",
    "City": "Altheimer"
  },
  {
    "State": "AR",
    "City": "Amagon"
  },
  {
    "State": "AR",
    "City": "Augusta"
  },
  {
    "State": "AR",
    "City": "Austin"
  },
  {
    "State": "AR",
    "City": "Bald Knob"
  },
  {
    "State": "AR",
    "City": "Bauxite"
  },
  {
    "State": "AR",
    "City": "Beebe"
  },
  {
    "State": "AR",
    "City": "Bee Branch"
  },
  {
    "State": "AR",
    "City": "Beedeville"
  },
  {
    "State": "AR",
    "City": "Benton"
  },
  {
    "State": "AR",
    "City": "Bigelow"
  },
  {
    "State": "AR",
    "City": "Biscoe"
  },
  {
    "State": "AR",
    "City": "Bradford"
  },
  {
    "State": "AR",
    "City": "Brinkley"
  },
  {
    "State": "AR",
    "City": "Bryant"
  },
  {
    "State": "AR",
    "City": "Cabot"
  },
  {
    "State": "AR",
    "City": "Carlisle"
  },
  {
    "State": "AR",
    "City": "Casa"
  },
  {
    "State": "AR",
    "City": "Casscoe"
  },
  {
    "State": "AR",
    "City": "Center Ridge"
  },
  {
    "State": "AR",
    "City": "Choctaw"
  },
  {
    "State": "AR",
    "City": "Clarendon"
  },
  {
    "State": "AR",
    "City": "Cleveland"
  },
  {
    "State": "AR",
    "City": "Clinton"
  },
  {
    "State": "AR",
    "City": "Conway"
  },
  {
    "State": "AR",
    "City": "Cotton Plant"
  },
  {
    "State": "AR",
    "City": "Coy"
  },
  {
    "State": "AR",
    "City": "Crocketts Bluff"
  },
  {
    "State": "AR",
    "City": "Damascus"
  },
  {
    "State": "AR",
    "City": "Des Arc"
  },
  {
    "State": "AR",
    "City": "De Valls Bluff"
  },
  {
    "State": "AR",
    "City": "De Witt"
  },
  {
    "State": "AR",
    "City": "Diaz"
  },
  {
    "State": "AR",
    "City": "Edgemont"
  },
  {
    "State": "AR",
    "City": "El Paso"
  },
  {
    "State": "AR",
    "City": "England"
  },
  {
    "State": "AR",
    "City": "Enola"
  },
  {
    "State": "AR",
    "City": "Ethel"
  },
  {
    "State": "AR",
    "City": "Fox"
  },
  {
    "State": "AR",
    "City": "Garner"
  },
  {
    "State": "AR",
    "City": "College Station"
  },
  {
    "State": "AR",
    "City": "Gillett"
  },
  {
    "State": "AR",
    "City": "Grapevine"
  },
  {
    "State": "AR",
    "City": "Greenbrier"
  },
  {
    "State": "AR",
    "City": "Gregory"
  },
  {
    "State": "AR",
    "City": "Griffithville"
  },
  {
    "State": "AR",
    "City": "Guy"
  },
  {
    "State": "AR",
    "City": "Hattieville"
  },
  {
    "State": "AR",
    "City": "Hazen"
  },
  {
    "State": "AR",
    "City": "Hensley"
  },
  {
    "State": "AR",
    "City": "Hickory Plains"
  },
  {
    "State": "AR",
    "City": "Higden"
  },
  {
    "State": "AR",
    "City": "Higginson"
  },
  {
    "State": "AR",
    "City": "Holly Grove"
  },
  {
    "State": "AR",
    "City": "Houston"
  },
  {
    "State": "AR",
    "City": "Humnoke"
  },
  {
    "State": "AR",
    "City": "Humphrey"
  },
  {
    "State": "AR",
    "City": "Hunter"
  },
  {
    "State": "AR",
    "City": "Jacksonport"
  },
  {
    "State": "AR",
    "City": "Jacksonville"
  },
  {
    "State": "AR",
    "City": "Jefferson"
  },
  {
    "State": "AR",
    "City": "Jerusalem"
  },
  {
    "State": "AR",
    "City": "Judsonia"
  },
  {
    "State": "AR",
    "City": "Kensett"
  },
  {
    "State": "AR",
    "City": "Keo"
  },
  {
    "State": "AR",
    "City": "Leola"
  },
  {
    "State": "AR",
    "City": "Letona"
  },
  {
    "State": "AR",
    "City": "Lonoke"
  },
  {
    "State": "AR",
    "City": "Lonsdale"
  },
  {
    "State": "AR",
    "City": "Fairfield Bay"
  },
  {
    "State": "AR",
    "City": "Little Rock Air Force Base"
  },
  {
    "State": "AR",
    "City": "Mc Crory"
  },
  {
    "State": "AR",
    "City": "Mc Rae"
  },
  {
    "State": "AR",
    "City": "Mabelvale"
  },
  {
    "State": "AR",
    "City": "Malvern"
  },
  {
    "State": "AR",
    "City": "Jones Mill"
  },
  {
    "State": "AR",
    "City": "Mayflower"
  },
  {
    "State": "AR",
    "City": "Menifee"
  },
  {
    "State": "AR",
    "City": "Monroe"
  },
  {
    "State": "AR",
    "City": "Morrilton"
  },
  {
    "State": "AR",
    "City": "Mount Vernon"
  },
  {
    "State": "AR",
    "City": "Newport"
  },
  {
    "State": "AR",
    "City": "Maumelle"
  },
  {
    "State": "AR",
    "City": "North Little Rock"
  },
  {
    "State": "AR",
    "City": "Sherwood"
  },
  {
    "State": "AR",
    "City": "Pangburn"
  },
  {
    "State": "AR",
    "City": "Paron"
  },
  {
    "State": "AR",
    "City": "Patterson"
  },
  {
    "State": "AR",
    "City": "Perry"
  },
  {
    "State": "AR",
    "City": "Perryville"
  },
  {
    "State": "AR",
    "City": "Plumerville"
  },
  {
    "State": "AR",
    "City": "Poyen"
  },
  {
    "State": "AR",
    "City": "Prattsville"
  },
  {
    "State": "AR",
    "City": "Prim"
  },
  {
    "State": "AR",
    "City": "Quitman"
  },
  {
    "State": "AR",
    "City": "Redfield"
  },
  {
    "State": "AR",
    "City": "Reydell"
  },
  {
    "State": "AR",
    "City": "Roe"
  },
  {
    "State": "AR",
    "City": "Roland"
  },
  {
    "State": "AR",
    "City": "Romance"
  },
  {
    "State": "AR",
    "City": "Rose Bud"
  },
  {
    "State": "AR",
    "City": "Russell"
  },
  {
    "State": "AR",
    "City": "Saint Charles"
  },
  {
    "State": "AR",
    "City": "Scotland"
  },
  {
    "State": "AR",
    "City": "Scott"
  },
  {
    "State": "AR",
    "City": "Searcy"
  },
  {
    "State": "AR",
    "City": "Sheridan"
  },
  {
    "State": "AR",
    "City": "Sherrill"
  },
  {
    "State": "AR",
    "City": "Shirley"
  },
  {
    "State": "AR",
    "City": "Solgohachia"
  },
  {
    "State": "AR",
    "City": "Springfield"
  },
  {
    "State": "AR",
    "City": "Stuttgart"
  },
  {
    "State": "AR",
    "City": "Sweet Home"
  },
  {
    "State": "AR",
    "City": "Thida"
  },
  {
    "State": "AR",
    "City": "Tichnor"
  },
  {
    "State": "AR",
    "City": "Traskwood"
  },
  {
    "State": "AR",
    "City": "Tucker"
  },
  {
    "State": "AR",
    "City": "Tupelo"
  },
  {
    "State": "AR",
    "City": "Ulm"
  },
  {
    "State": "AR",
    "City": "Vilonia"
  },
  {
    "State": "AR",
    "City": "Wabbaseka"
  },
  {
    "State": "AR",
    "City": "Ward"
  },
  {
    "State": "AR",
    "City": "West Point"
  },
  {
    "State": "AR",
    "City": "Wilburn"
  },
  {
    "State": "AR",
    "City": "Woodson"
  },
  {
    "State": "AR",
    "City": "Wooster"
  },
  {
    "State": "AR",
    "City": "Wright"
  },
  {
    "State": "AR",
    "City": "Wrightsville"
  },
  {
    "State": "AR",
    "City": "Little Rock"
  },
  {
    "State": "AR",
    "City": "West Memphis"
  },
  {
    "State": "AR",
    "City": "Armorel"
  },
  {
    "State": "AR",
    "City": "Aubrey"
  },
  {
    "State": "AR",
    "City": "Barton"
  },
  {
    "State": "AR",
    "City": "Bassett"
  },
  {
    "State": "AR",
    "City": "Blytheville"
  },
  {
    "State": "AR",
    "City": "Gosnell"
  },
  {
    "State": "AR",
    "City": "Brickeys"
  },
  {
    "State": "AR",
    "City": "Burdette"
  },
  {
    "State": "AR",
    "City": "Caldwell"
  },
  {
    "State": "AR",
    "City": "Cherry Valley"
  },
  {
    "State": "AR",
    "City": "Clarkedale"
  },
  {
    "State": "AR",
    "City": "Colt"
  },
  {
    "State": "AR",
    "City": "Crawfordsville"
  },
  {
    "State": "AR",
    "City": "Crumrod"
  },
  {
    "State": "AR",
    "City": "Driver"
  },
  {
    "State": "AR",
    "City": "Dyess"
  },
  {
    "State": "AR",
    "City": "Earle"
  },
  {
    "State": "AR",
    "City": "Edmondson"
  },
  {
    "State": "AR",
    "City": "Elaine"
  },
  {
    "State": "AR",
    "City": "Forrest City"
  },
  {
    "State": "AR",
    "City": "Frenchmans Bayou"
  },
  {
    "State": "AR",
    "City": "Gilmore"
  },
  {
    "State": "AR",
    "City": "Goodwin"
  },
  {
    "State": "AR",
    "City": "Haynes"
  },
  {
    "State": "AR",
    "City": "Helena"
  },
  {
    "State": "AR",
    "City": "Heth"
  },
  {
    "State": "AR",
    "City": "Hickory Ridge"
  },
  {
    "State": "AR",
    "City": "Hughes"
  },
  {
    "State": "AR",
    "City": "Joiner"
  },
  {
    "State": "AR",
    "City": "Keiser"
  },
  {
    "State": "AR",
    "City": "La Grange"
  },
  {
    "State": "AR",
    "City": "Lambrook"
  },
  {
    "State": "AR",
    "City": "Lepanto"
  },
  {
    "State": "AR",
    "City": "Lexa"
  },
  {
    "State": "AR",
    "City": "Luxora"
  },
  {
    "State": "AR",
    "City": "Madison"
  },
  {
    "State": "AR",
    "City": "Marianna"
  },
  {
    "State": "AR",
    "City": "Marion"
  },
  {
    "State": "AR",
    "City": "Marked Tree"
  },
  {
    "State": "AR",
    "City": "Marvell"
  },
  {
    "State": "AR",
    "City": "Mellwood"
  },
  {
    "State": "AR",
    "City": "Moro"
  },
  {
    "State": "AR",
    "City": "Oneida"
  },
  {
    "State": "AR",
    "City": "Osceola"
  },
  {
    "State": "AR",
    "City": "Palestine"
  },
  {
    "State": "AR",
    "City": "Parkin"
  },
  {
    "State": "AR",
    "City": "Poplar Grove"
  },
  {
    "State": "AR",
    "City": "Proctor"
  },
  {
    "State": "AR",
    "City": "Rivervale"
  },
  {
    "State": "AR",
    "City": "Snow Lake"
  },
  {
    "State": "AR",
    "City": "Turner"
  },
  {
    "State": "AR",
    "City": "Turrell"
  },
  {
    "State": "AR",
    "City": "Tyronza"
  },
  {
    "State": "AR",
    "City": "Vanndale"
  },
  {
    "State": "AR",
    "City": "Wabash"
  },
  {
    "State": "AR",
    "City": "West Helena"
  },
  {
    "State": "AR",
    "City": "West Ridge"
  },
  {
    "State": "AR",
    "City": "Wheatley"
  },
  {
    "State": "AR",
    "City": "Widener"
  },
  {
    "State": "AR",
    "City": "Wilson"
  },
  {
    "State": "AR",
    "City": "Wynne"
  },
  {
    "State": "AR",
    "City": "Jonesboro"
  },
  {
    "State": "AR",
    "City": "Alicia"
  },
  {
    "State": "AR",
    "City": "Bay"
  },
  {
    "State": "AR",
    "City": "Beech Grove"
  },
  {
    "State": "AR",
    "City": "Biggers"
  },
  {
    "State": "AR",
    "City": "Black Oak"
  },
  {
    "State": "AR",
    "City": "Black Rock"
  },
  {
    "State": "AR",
    "City": "Bono"
  },
  {
    "State": "AR",
    "City": "Brookland"
  },
  {
    "State": "AR",
    "City": "Caraway"
  },
  {
    "State": "AR",
    "City": "Cash"
  },
  {
    "State": "AR",
    "City": "Corning"
  },
  {
    "State": "AR",
    "City": "Datto"
  },
  {
    "State": "AR",
    "City": "Delaplaine"
  },
  {
    "State": "AR",
    "City": "Dell"
  },
  {
    "State": "AR",
    "City": "Egypt"
  },
  {
    "State": "AR",
    "City": "Etowah"
  },
  {
    "State": "AR",
    "City": "Fisher"
  },
  {
    "State": "AR",
    "City": "Greenway"
  },
  {
    "State": "AR",
    "City": "Grubbs"
  },
  {
    "State": "AR",
    "City": "Harrisburg"
  },
  {
    "State": "AR",
    "City": "Hoxie"
  },
  {
    "State": "AR",
    "City": "Imboden"
  },
  {
    "State": "AR",
    "City": "Knobel"
  },
  {
    "State": "AR",
    "City": "Lafe"
  },
  {
    "State": "AR",
    "City": "Lake City"
  },
  {
    "State": "AR",
    "City": "Leachville"
  },
  {
    "State": "AR",
    "City": "Light"
  },
  {
    "State": "AR",
    "City": "Lynn"
  },
  {
    "State": "AR",
    "City": "Mc Dougal"
  },
  {
    "State": "AR",
    "City": "Manila"
  },
  {
    "State": "AR",
    "City": "Marmaduke"
  },
  {
    "State": "AR",
    "City": "Maynard"
  },
  {
    "State": "AR",
    "City": "Minturn"
  },
  {
    "State": "AR",
    "City": "Monette"
  },
  {
    "State": "AR",
    "City": "O Kean"
  },
  {
    "State": "AR",
    "City": "Paragould"
  },
  {
    "State": "AR",
    "City": "Peach Orchard"
  },
  {
    "State": "AR",
    "City": "Piggott"
  },
  {
    "State": "AR",
    "City": "Pocahontas"
  },
  {
    "State": "AR",
    "City": "Pollard"
  },
  {
    "State": "AR",
    "City": "Portia"
  },
  {
    "State": "AR",
    "City": "Powhatan"
  },
  {
    "State": "AR",
    "City": "Ravenden"
  },
  {
    "State": "AR",
    "City": "Ravenden Springs"
  },
  {
    "State": "AR",
    "City": "Rector"
  },
  {
    "State": "AR",
    "City": "Reyno"
  },
  {
    "State": "AR",
    "City": "Saint Francis"
  },
  {
    "State": "AR",
    "City": "Sedgwick"
  },
  {
    "State": "AR",
    "City": "Smithville"
  },
  {
    "State": "AR",
    "City": "State University"
  },
  {
    "State": "AR",
    "City": "Strawberry"
  },
  {
    "State": "AR",
    "City": "Success"
  },
  {
    "State": "AR",
    "City": "Swifton"
  },
  {
    "State": "AR",
    "City": "Trumann"
  },
  {
    "State": "AR",
    "City": "Tuckerman"
  },
  {
    "State": "AR",
    "City": "Walcott"
  },
  {
    "State": "AR",
    "City": "Waldenburg"
  },
  {
    "State": "AR",
    "City": "Walnut Ridge"
  },
  {
    "State": "AR",
    "City": "Warm Springs"
  },
  {
    "State": "AR",
    "City": "Weiner"
  },
  {
    "State": "AR",
    "City": "Williford"
  },
  {
    "State": "AR",
    "City": "Batesville"
  },
  {
    "State": "AR",
    "City": "Horseshoe Bend"
  },
  {
    "State": "AR",
    "City": "Ash Flat"
  },
  {
    "State": "AR",
    "City": "Bexar"
  },
  {
    "State": "AR",
    "City": "Brockwell"
  },
  {
    "State": "AR",
    "City": "Calico Rock"
  },
  {
    "State": "AR",
    "City": "Camp"
  },
  {
    "State": "AR",
    "City": "Cave City"
  },
  {
    "State": "AR",
    "City": "Charlotte"
  },
  {
    "State": "AR",
    "City": "Concord"
  },
  {
    "State": "AR",
    "City": "Cord"
  },
  {
    "State": "AR",
    "City": "Cherokee Village"
  },
  {
    "State": "AR",
    "City": "Cushman"
  },
  {
    "State": "AR",
    "City": "Desha"
  },
  {
    "State": "AR",
    "City": "Dolph"
  },
  {
    "State": "AR",
    "City": "Drasco"
  },
  {
    "State": "AR",
    "City": "Elizabeth"
  },
  {
    "State": "AR",
    "City": "Evening Shade"
  },
  {
    "State": "AR",
    "City": "Fifty Six"
  },
  {
    "State": "AR",
    "City": "Floral"
  },
  {
    "State": "AR",
    "City": "Franklin"
  },
  {
    "State": "AR",
    "City": "Gamaliel"
  },
  {
    "State": "AR",
    "City": "Gepp"
  },
  {
    "State": "AR",
    "City": "Glencoe"
  },
  {
    "State": "AR",
    "City": "Guion"
  },
  {
    "State": "AR",
    "City": "Hardy"
  },
  {
    "State": "AR",
    "City": "Heber Springs"
  },
  {
    "State": "AR",
    "City": "Henderson"
  },
  {
    "State": "AR",
    "City": "Ida"
  },
  {
    "State": "AR",
    "City": "Locust Grove"
  },
  {
    "State": "AR",
    "City": "Magness"
  },
  {
    "State": "AR",
    "City": "Mammoth Spring"
  },
  {
    "State": "AR",
    "City": "Marcella"
  },
  {
    "State": "AR",
    "City": "Melbourne"
  },
  {
    "State": "AR",
    "City": "Mountain View"
  },
  {
    "State": "AR",
    "City": "Mount Pleasant"
  },
  {
    "State": "AR",
    "City": "Newark"
  },
  {
    "State": "AR",
    "City": "Oil Trough"
  },
  {
    "State": "AR",
    "City": "Oxford"
  },
  {
    "State": "AR",
    "City": "Pineville"
  },
  {
    "State": "AR",
    "City": "Pleasant Grove"
  },
  {
    "State": "AR",
    "City": "Pleasant Plains"
  },
  {
    "State": "AR",
    "City": "Poughkeepsie"
  },
  {
    "State": "AR",
    "City": "Rosie"
  },
  {
    "State": "AR",
    "City": "Saffell"
  },
  {
    "State": "AR",
    "City": "Sage"
  },
  {
    "State": "AR",
    "City": "Salado"
  },
  {
    "State": "AR",
    "City": "Salem"
  },
  {
    "State": "AR",
    "City": "Sidney"
  },
  {
    "State": "AR",
    "City": "Sturkie"
  },
  {
    "State": "AR",
    "City": "Sulphur Rock"
  },
  {
    "State": "AR",
    "City": "Tumbling Shoals"
  },
  {
    "State": "AR",
    "City": "Viola"
  },
  {
    "State": "AR",
    "City": "Violet Hill"
  },
  {
    "State": "AR",
    "City": "Wideman"
  },
  {
    "State": "AR",
    "City": "Wiseman"
  },
  {
    "State": "AR",
    "City": "Harrison"
  },
  {
    "State": "AR",
    "City": "Alpena"
  },
  {
    "State": "AR",
    "City": "Beaver"
  },
  {
    "State": "AR",
    "City": "Bergman"
  },
  {
    "State": "AR",
    "City": "Berryville"
  },
  {
    "State": "AR",
    "City": "Big Flat"
  },
  {
    "State": "AR",
    "City": "Bull Shoals"
  },
  {
    "State": "AR",
    "City": "Clarkridge"
  },
  {
    "State": "AR",
    "City": "Compton"
  },
  {
    "State": "AR",
    "City": "Cotter"
  },
  {
    "State": "AR",
    "City": "Deer"
  },
  {
    "State": "AR",
    "City": "Dennard"
  },
  {
    "State": "AR",
    "City": "Diamond City"
  },
  {
    "State": "AR",
    "City": "Eureka Springs"
  },
  {
    "State": "AR",
    "City": "Everton"
  },
  {
    "State": "AR",
    "City": "Flippin"
  },
  {
    "State": "AR",
    "City": "Gassville"
  },
  {
    "State": "AR",
    "City": "Gilbert"
  },
  {
    "State": "AR",
    "City": "Green Forest"
  },
  {
    "State": "AR",
    "City": "Harriet"
  },
  {
    "State": "AR",
    "City": "Hasty"
  },
  {
    "State": "AR",
    "City": "Jasper"
  },
  {
    "State": "AR",
    "City": "Lakeview"
  },
  {
    "State": "MO",
    "City": "Lead Hill"
  },
  {
    "State": "AR",
    "City": "Lead Hill"
  },
  {
    "State": "AR",
    "City": "Leslie"
  },
  {
    "State": "AR",
    "City": "Marble Falls"
  },
  {
    "State": "AR",
    "City": "Marshall"
  },
  {
    "State": "AR",
    "City": "Midway"
  },
  {
    "State": "AR",
    "City": "Mountain Home"
  },
  {
    "State": "AR",
    "City": "Mount Judea"
  },
  {
    "State": "AR",
    "City": "Timbo"
  },
  {
    "State": "AR",
    "City": "Norfork"
  },
  {
    "State": "AR",
    "City": "Oak Grove"
  },
  {
    "State": "AR",
    "City": "Oakland"
  },
  {
    "State": "AR",
    "City": "Omaha"
  },
  {
    "State": "AR",
    "City": "Onia"
  },
  {
    "State": "AR",
    "City": "Parthenon"
  },
  {
    "State": "AR",
    "City": "Peel"
  },
  {
    "State": "AR",
    "City": "Pindall"
  },
  {
    "State": "AR",
    "City": "Ponca"
  },
  {
    "State": "AR",
    "City": "Pyatt"
  },
  {
    "State": "AR",
    "City": "Saint Joe"
  },
  {
    "State": "AR",
    "City": "Summit"
  },
  {
    "State": "AR",
    "City": "Tilly"
  },
  {
    "State": "AR",
    "City": "Valley Springs"
  },
  {
    "State": "AR",
    "City": "Vendor"
  },
  {
    "State": "AR",
    "City": "Western Grove"
  },
  {
    "State": "AR",
    "City": "Witts Springs"
  },
  {
    "State": "AR",
    "City": "Yellville"
  },
  {
    "State": "AR",
    "City": "Fayetteville"
  },
  {
    "State": "AR",
    "City": "Avoca"
  },
  {
    "State": "AR",
    "City": "Bentonville"
  },
  {
    "State": "AR",
    "City": "Bella Vista"
  },
  {
    "State": "AR",
    "City": "Canehill"
  },
  {
    "State": "AR",
    "City": "Cave Springs"
  },
  {
    "State": "AR",
    "City": "Centerton"
  },
  {
    "State": "AR",
    "City": "Combs"
  },
  {
    "State": "AR",
    "City": "Decatur"
  },
  {
    "State": "AR",
    "City": "Elkins"
  },
  {
    "State": "AR",
    "City": "Elm Springs"
  },
  {
    "State": "AR",
    "City": "Evansville"
  },
  {
    "State": "AR",
    "City": "Farmington"
  },
  {
    "State": "AR",
    "City": "Garfield"
  },
  {
    "State": "AR",
    "City": "Gateway"
  },
  {
    "State": "AR",
    "City": "Gentry"
  },
  {
    "State": "AR",
    "City": "Goshen"
  },
  {
    "State": "AR",
    "City": "Gravette"
  },
  {
    "State": "AR",
    "City": "Greenland"
  },
  {
    "State": "AR",
    "City": "Hindsville"
  },
  {
    "State": "AR",
    "City": "Hiwasse"
  },
  {
    "State": "AR",
    "City": "Huntsville"
  },
  {
    "State": "AR",
    "City": "Johnson"
  },
  {
    "State": "AR",
    "City": "Kingston"
  },
  {
    "State": "AR",
    "City": "Lincoln"
  },
  {
    "State": "AR",
    "City": "Lowell"
  },
  {
    "State": "AR",
    "City": "Maysville"
  },
  {
    "State": "AR",
    "City": "Morrow"
  },
  {
    "State": "AR",
    "City": "Pea Ridge"
  },
  {
    "State": "AR",
    "City": "Pettigrew"
  },
  {
    "State": "AR",
    "City": "Prairie Grove"
  },
  {
    "State": "AR",
    "City": "Rogers"
  },
  {
    "State": "AR",
    "City": "Saint Paul"
  },
  {
    "State": "AR",
    "City": "Siloam Springs"
  },
  {
    "State": "AR",
    "City": "Springdale"
  },
  {
    "State": "AR",
    "City": "Sulphur Springs"
  },
  {
    "State": "AR",
    "City": "Summers"
  },
  {
    "State": "AR",
    "City": "Tontitown"
  },
  {
    "State": "AR",
    "City": "Wesley"
  },
  {
    "State": "AR",
    "City": "West Fork"
  },
  {
    "State": "AR",
    "City": "Witter"
  },
  {
    "State": "AR",
    "City": "Russellville"
  },
  {
    "State": "AR",
    "City": "Alix"
  },
  {
    "State": "AR",
    "City": "Altus"
  },
  {
    "State": "AR",
    "City": "Atkins"
  },
  {
    "State": "AR",
    "City": "Belleville"
  },
  {
    "State": "AR",
    "City": "Blue Mountain"
  },
  {
    "State": "AR",
    "City": "Bluffton"
  },
  {
    "State": "AR",
    "City": "Briggsville"
  },
  {
    "State": "AR",
    "City": "Centerville"
  },
  {
    "State": "AR",
    "City": "Clarksville"
  },
  {
    "State": "AR",
    "City": "Coal Hill"
  },
  {
    "State": "AR",
    "City": "Danville"
  },
  {
    "State": "AR",
    "City": "Dardanelle"
  },
  {
    "State": "AR",
    "City": "Delaware"
  },
  {
    "State": "AR",
    "City": "Dover"
  },
  {
    "State": "AR",
    "City": "Gravelly"
  },
  {
    "State": "AR",
    "City": "Hagarville"
  },
  {
    "State": "AR",
    "City": "Hartman"
  },
  {
    "State": "AR",
    "City": "Harvey"
  },
  {
    "State": "AR",
    "City": "Havana"
  },
  {
    "State": "AR",
    "City": "Hector"
  },
  {
    "State": "AR",
    "City": "Knoxville"
  },
  {
    "State": "AR",
    "City": "Lamar"
  },
  {
    "State": "AR",
    "City": "London"
  },
  {
    "State": "AR",
    "City": "New Blaine"
  },
  {
    "State": "AR",
    "City": "Oark"
  },
  {
    "State": "AR",
    "City": "Ola"
  },
  {
    "State": "AR",
    "City": "Ozone"
  },
  {
    "State": "AR",
    "City": "Paris"
  },
  {
    "State": "AR",
    "City": "Pelsor"
  },
  {
    "State": "AR",
    "City": "Plainview"
  },
  {
    "State": "AR",
    "City": "Pottsville"
  },
  {
    "State": "AR",
    "City": "Rover"
  },
  {
    "State": "AR",
    "City": "Scranton"
  },
  {
    "State": "AR",
    "City": "Subiaco"
  },
  {
    "State": "AR",
    "City": "Fort Smith"
  },
  {
    "State": "AR",
    "City": "Alma"
  },
  {
    "State": "AR",
    "City": "Barling"
  },
  {
    "State": "AR",
    "City": "Boles"
  },
  {
    "State": "AR",
    "City": "Booneville"
  },
  {
    "State": "AR",
    "City": "Branch"
  },
  {
    "State": "AR",
    "City": "Cecil"
  },
  {
    "State": "AR",
    "City": "Cedarville"
  },
  {
    "State": "AR",
    "City": "Charleston"
  },
  {
    "State": "AR",
    "City": "Chester"
  },
  {
    "State": "AR",
    "City": "Dyer"
  },
  {
    "State": "AR",
    "City": "Greenwood"
  },
  {
    "State": "AR",
    "City": "Hackett"
  },
  {
    "State": "AR",
    "City": "Hartford"
  },
  {
    "State": "AR",
    "City": "Huntington"
  },
  {
    "State": "AR",
    "City": "Lavaca"
  },
  {
    "State": "AR",
    "City": "Magazine"
  },
  {
    "State": "AR",
    "City": "Mansfield"
  },
  {
    "State": "AR",
    "City": "Midland"
  },
  {
    "State": "AR",
    "City": "Mountainburg"
  },
  {
    "State": "AR",
    "City": "Mulberry"
  },
  {
    "State": "AR",
    "City": "Natural Dam"
  },
  {
    "State": "AR",
    "City": "Ozark"
  },
  {
    "State": "AR",
    "City": "Parks"
  },
  {
    "State": "AR",
    "City": "Ratcliff"
  },
  {
    "State": "AR",
    "City": "Rudy"
  },
  {
    "State": "AR",
    "City": "Uniontown"
  },
  {
    "State": "AR",
    "City": "Van Buren"
  },
  {
    "State": "AR",
    "City": "Waldron"
  },
  {
    "State": "AR",
    "City": "Winslow"
  },
  {
    "State": "OK",
    "City": "Albert"
  },
  {
    "State": "OK",
    "City": "Alex"
  },
  {
    "State": "OK",
    "City": "Edmond"
  },
  {
    "State": "OK",
    "City": "Amber"
  },
  {
    "State": "OK",
    "City": "Anadarko"
  },
  {
    "State": "OK",
    "City": "Apache"
  },
  {
    "State": "OK",
    "City": "Arcadia"
  },
  {
    "State": "OK",
    "City": "Bethany"
  },
  {
    "State": "OK",
    "City": "Binger"
  },
  {
    "State": "OK",
    "City": "Blanchard"
  },
  {
    "State": "OK",
    "City": "Bradley"
  },
  {
    "State": "OK",
    "City": "Calumet"
  },
  {
    "State": "OK",
    "City": "Carnegie"
  },
  {
    "State": "OK",
    "City": "Cashion"
  },
  {
    "State": "OK",
    "City": "Cement"
  },
  {
    "State": "OK",
    "City": "Chickasha"
  },
  {
    "State": "OK",
    "City": "Norman"
  },
  {
    "State": "OK",
    "City": "Choctaw"
  },
  {
    "State": "OK",
    "City": "Colony"
  },
  {
    "State": "OK",
    "City": "Concho"
  },
  {
    "State": "OK",
    "City": "Corn"
  },
  {
    "State": "OK",
    "City": "Coyle"
  },
  {
    "State": "OK",
    "City": "Crescent"
  },
  {
    "State": "OK",
    "City": "Cyril"
  },
  {
    "State": "OK",
    "City": "Davis"
  },
  {
    "State": "OK",
    "City": "Dibble"
  },
  {
    "State": "OK",
    "City": "Dougherty"
  },
  {
    "State": "OK",
    "City": "Eakly"
  },
  {
    "State": "OK",
    "City": "El Reno"
  },
  {
    "State": "OK",
    "City": "Fort Cobb"
  },
  {
    "State": "OK",
    "City": "Geary"
  },
  {
    "State": "OK",
    "City": "Gotebo"
  },
  {
    "State": "OK",
    "City": "Gracemont"
  },
  {
    "State": "OK",
    "City": "Greenfield"
  },
  {
    "State": "OK",
    "City": "Guthrie"
  },
  {
    "State": "OK",
    "City": "Harrah"
  },
  {
    "State": "OK",
    "City": "Hinton"
  },
  {
    "State": "OK",
    "City": "Hydro"
  },
  {
    "State": "OK",
    "City": "Jones"
  },
  {
    "State": "OK",
    "City": "Langston"
  },
  {
    "State": "OK",
    "City": "Lexington"
  },
  {
    "State": "OK",
    "City": "Lindsay"
  },
  {
    "State": "OK",
    "City": "Lookeba"
  },
  {
    "State": "OK",
    "City": "Luther"
  },
  {
    "State": "OK",
    "City": "Marlow"
  },
  {
    "State": "OK",
    "City": "Marshall"
  },
  {
    "State": "OK",
    "City": "Maysville"
  },
  {
    "State": "OK",
    "City": "Meridian"
  },
  {
    "State": "OK",
    "City": "Minco"
  },
  {
    "State": "OK",
    "City": "Morrison"
  },
  {
    "State": "OK",
    "City": "Mountain View"
  },
  {
    "State": "OK",
    "City": "Mulhall"
  },
  {
    "State": "OK",
    "City": "Mustang"
  },
  {
    "State": "OK",
    "City": "Newcastle"
  },
  {
    "State": "OK",
    "City": "Nicoma Park"
  },
  {
    "State": "OK",
    "City": "Ninnekah"
  },
  {
    "State": "OK",
    "City": "Noble"
  },
  {
    "State": "OK",
    "City": "Orlando"
  },
  {
    "State": "OK",
    "City": "Paoli"
  },
  {
    "State": "OK",
    "City": "Pauls Valley"
  },
  {
    "State": "OK",
    "City": "Perry"
  },
  {
    "State": "OK",
    "City": "Piedmont"
  },
  {
    "State": "OK",
    "City": "Pocasset"
  },
  {
    "State": "OK",
    "City": "Purcell"
  },
  {
    "State": "OK",
    "City": "Rush Springs"
  },
  {
    "State": "OK",
    "City": "Spencer"
  },
  {
    "State": "OK",
    "City": "Yukon"
  },
  {
    "State": "OK",
    "City": "Sulphur"
  },
  {
    "State": "OK",
    "City": "Tuttle"
  },
  {
    "State": "OK",
    "City": "Union City"
  },
  {
    "State": "OK",
    "City": "Verden"
  },
  {
    "State": "OK",
    "City": "Washington"
  },
  {
    "State": "OK",
    "City": "Washita"
  },
  {
    "State": "OK",
    "City": "Wayne"
  },
  {
    "State": "OK",
    "City": "Weatherford"
  },
  {
    "State": "OK",
    "City": "Wheatland"
  },
  {
    "State": "OK",
    "City": "Wynnewood"
  },
  {
    "State": "OK",
    "City": "Oklahoma City"
  },
  {
    "State": "TX",
    "City": "Austin"
  },
  {
    "State": "OK",
    "City": "Ardmore"
  },
  {
    "State": "OK",
    "City": "Countyline"
  },
  {
    "State": "OK",
    "City": "Burneyville"
  },
  {
    "State": "OK",
    "City": "Coleman"
  },
  {
    "State": "OK",
    "City": "Elmore City"
  },
  {
    "State": "OK",
    "City": "Foster"
  },
  {
    "State": "OK",
    "City": "Fox"
  },
  {
    "State": "OK",
    "City": "Gene Autry"
  },
  {
    "State": "OK",
    "City": "Graham"
  },
  {
    "State": "OK",
    "City": "Healdton"
  },
  {
    "State": "OK",
    "City": "Kingston"
  },
  {
    "State": "OK",
    "City": "Lebanon"
  },
  {
    "State": "OK",
    "City": "Leon"
  },
  {
    "State": "OK",
    "City": "Loco"
  },
  {
    "State": "OK",
    "City": "Lone Grove"
  },
  {
    "State": "OK",
    "City": "Hennepin"
  },
  {
    "State": "OK",
    "City": "Madill"
  },
  {
    "State": "OK",
    "City": "Mannsville"
  },
  {
    "State": "OK",
    "City": "Marietta"
  },
  {
    "State": "OK",
    "City": "Mead"
  },
  {
    "State": "OK",
    "City": "Milburn"
  },
  {
    "State": "OK",
    "City": "Overbrook"
  },
  {
    "State": "OK",
    "City": "Ravia"
  },
  {
    "State": "OK",
    "City": "Ringling"
  },
  {
    "State": "OK",
    "City": "Springer"
  },
  {
    "State": "OK",
    "City": "Thackerville"
  },
  {
    "State": "OK",
    "City": "Tishomingo"
  },
  {
    "State": "OK",
    "City": "Wapanucka"
  },
  {
    "State": "OK",
    "City": "Wilson"
  },
  {
    "State": "OK",
    "City": "Ratliff City"
  },
  {
    "State": "OK",
    "City": "Tatums"
  },
  {
    "State": "OK",
    "City": "Tussy"
  },
  {
    "State": "OK",
    "City": "Velma"
  },
  {
    "State": "OK",
    "City": "Lawton"
  },
  {
    "State": "OK",
    "City": "Fort Sill"
  },
  {
    "State": "OK",
    "City": "Addington"
  },
  {
    "State": "OK",
    "City": "Altus"
  },
  {
    "State": "OK",
    "City": "Altus AFB"
  },
  {
    "State": "OK",
    "City": "Blair"
  },
  {
    "State": "OK",
    "City": "Cache"
  },
  {
    "State": "OK",
    "City": "Chattanooga"
  },
  {
    "State": "OK",
    "City": "Comanche"
  },
  {
    "State": "OK",
    "City": "Davidson"
  },
  {
    "State": "OK",
    "City": "Devol"
  },
  {
    "State": "OK",
    "City": "Duke"
  },
  {
    "State": "OK",
    "City": "Duncan"
  },
  {
    "State": "OK",
    "City": "Eldorado"
  },
  {
    "State": "OK",
    "City": "Elgin"
  },
  {
    "State": "OK",
    "City": "Elmer"
  },
  {
    "State": "OK",
    "City": "Faxon"
  },
  {
    "State": "OK",
    "City": "Fletcher"
  },
  {
    "State": "OK",
    "City": "Frederick"
  },
  {
    "State": "OK",
    "City": "Geronimo"
  },
  {
    "State": "OK",
    "City": "Gould"
  },
  {
    "State": "OK",
    "City": "Grandfield"
  },
  {
    "State": "OK",
    "City": "Granite"
  },
  {
    "State": "OK",
    "City": "Hastings"
  },
  {
    "State": "OK",
    "City": "Headrick"
  },
  {
    "State": "OK",
    "City": "Hollis"
  },
  {
    "State": "OK",
    "City": "Hollister"
  },
  {
    "State": "OK",
    "City": "Indiahoma"
  },
  {
    "State": "OK",
    "City": "Loveland"
  },
  {
    "State": "OK",
    "City": "Mangum"
  },
  {
    "State": "OK",
    "City": "Manitou"
  },
  {
    "State": "OK",
    "City": "Martha"
  },
  {
    "State": "OK",
    "City": "Medicine Park"
  },
  {
    "State": "OK",
    "City": "Meers"
  },
  {
    "State": "OK",
    "City": "Mountain Park"
  },
  {
    "State": "OK",
    "City": "Olustee"
  },
  {
    "State": "OK",
    "City": "Oscar"
  },
  {
    "State": "OK",
    "City": "Randlett"
  },
  {
    "State": "OK",
    "City": "Roosevelt"
  },
  {
    "State": "OK",
    "City": "Ryan"
  },
  {
    "State": "OK",
    "City": "Snyder"
  },
  {
    "State": "OK",
    "City": "Sterling"
  },
  {
    "State": "OK",
    "City": "Temple"
  },
  {
    "State": "OK",
    "City": "Terral"
  },
  {
    "State": "OK",
    "City": "Tipton"
  },
  {
    "State": "OK",
    "City": "Vinson"
  },
  {
    "State": "OK",
    "City": "Walters"
  },
  {
    "State": "OK",
    "City": "Waurika"
  },
  {
    "State": "OK",
    "City": "Clinton"
  },
  {
    "State": "OK",
    "City": "Arapaho"
  },
  {
    "State": "OK",
    "City": "Bessie"
  },
  {
    "State": "OK",
    "City": "Burns Flat"
  },
  {
    "State": "OK",
    "City": "Butler"
  },
  {
    "State": "OK",
    "City": "Canute"
  },
  {
    "State": "OK",
    "City": "Carter"
  },
  {
    "State": "OK",
    "City": "Cheyenne"
  },
  {
    "State": "OK",
    "City": "Cordell"
  },
  {
    "State": "OK",
    "City": "Crawford"
  },
  {
    "State": "OK",
    "City": "Custer City"
  },
  {
    "State": "OK",
    "City": "Dill City"
  },
  {
    "State": "OK",
    "City": "Durham"
  },
  {
    "State": "OK",
    "City": "Elk City"
  },
  {
    "State": "OK",
    "City": "Erick"
  },
  {
    "State": "OK",
    "City": "Fay"
  },
  {
    "State": "OK",
    "City": "Foss"
  },
  {
    "State": "OK",
    "City": "Hammon"
  },
  {
    "State": "OK",
    "City": "Hobart"
  },
  {
    "State": "OK",
    "City": "Leedey"
  },
  {
    "State": "OK",
    "City": "Lone Wolf"
  },
  {
    "State": "OK",
    "City": "Oakwood"
  },
  {
    "State": "OK",
    "City": "Putnam"
  },
  {
    "State": "OK",
    "City": "Reydon"
  },
  {
    "State": "OK",
    "City": "Rocky"
  },
  {
    "State": "OK",
    "City": "Sayre"
  },
  {
    "State": "OK",
    "City": "Seiling"
  },
  {
    "State": "OK",
    "City": "Sentinel"
  },
  {
    "State": "OK",
    "City": "Sweetwater"
  },
  {
    "State": "OK",
    "City": "Taloga"
  },
  {
    "State": "OK",
    "City": "Texola"
  },
  {
    "State": "OK",
    "City": "Thomas"
  },
  {
    "State": "OK",
    "City": "Willow"
  },
  {
    "State": "OK",
    "City": "Enid"
  },
  {
    "State": "OK",
    "City": "Aline"
  },
  {
    "State": "OK",
    "City": "Alva"
  },
  {
    "State": "OK",
    "City": "Ames"
  },
  {
    "State": "OK",
    "City": "Amorita"
  },
  {
    "State": "OK",
    "City": "Bison"
  },
  {
    "State": "OK",
    "City": "Burlington"
  },
  {
    "State": "OK",
    "City": "Canton"
  },
  {
    "State": "OK",
    "City": "Carmen"
  },
  {
    "State": "OK",
    "City": "Carrier"
  },
  {
    "State": "OK",
    "City": "Cherokee"
  },
  {
    "State": "OK",
    "City": "Cleo Springs"
  },
  {
    "State": "OK",
    "City": "Covington"
  },
  {
    "State": "OK",
    "City": "Dacoma"
  },
  {
    "State": "OK",
    "City": "Douglas"
  },
  {
    "State": "OK",
    "City": "Dover"
  },
  {
    "State": "OK",
    "City": "Drummond"
  },
  {
    "State": "OK",
    "City": "Fairmont"
  },
  {
    "State": "OK",
    "City": "Fairview"
  },
  {
    "State": "OK",
    "City": "Garber"
  },
  {
    "State": "OK",
    "City": "Goltry"
  },
  {
    "State": "OK",
    "City": "Helena"
  },
  {
    "State": "OK",
    "City": "Hennessey"
  },
  {
    "State": "OK",
    "City": "Hillsdale"
  },
  {
    "State": "OK",
    "City": "Hitchcock"
  },
  {
    "State": "OK",
    "City": "Hopeton"
  },
  {
    "State": "OK",
    "City": "Isabella"
  },
  {
    "State": "OK",
    "City": "Jet"
  },
  {
    "State": "OK",
    "City": "Kingfisher"
  },
  {
    "State": "OK",
    "City": "Kremlin"
  },
  {
    "State": "OK",
    "City": "Lahoma"
  },
  {
    "State": "OK",
    "City": "Longdale"
  },
  {
    "State": "OK",
    "City": "Loyal"
  },
  {
    "State": "OK",
    "City": "Lucien"
  },
  {
    "State": "OK",
    "City": "Manchester"
  },
  {
    "State": "OK",
    "City": "Medford"
  },
  {
    "State": "OK",
    "City": "Meno"
  },
  {
    "State": "OK",
    "City": "Nash"
  },
  {
    "State": "OK",
    "City": "Okarche"
  },
  {
    "State": "OK",
    "City": "Okeene"
  },
  {
    "State": "OK",
    "City": "Omega"
  },
  {
    "State": "OK",
    "City": "Pond Creek"
  },
  {
    "State": "OK",
    "City": "Ringwood"
  },
  {
    "State": "OK",
    "City": "Southard"
  },
  {
    "State": "OK",
    "City": "Wakita"
  },
  {
    "State": "OK",
    "City": "Watonga"
  },
  {
    "State": "OK",
    "City": "Waukomis"
  },
  {
    "State": "OK",
    "City": "Woodward"
  },
  {
    "State": "OK",
    "City": "Arnett"
  },
  {
    "State": "OK",
    "City": "Buffalo"
  },
  {
    "State": "OK",
    "City": "Camargo"
  },
  {
    "State": "OK",
    "City": "Chester"
  },
  {
    "State": "OK",
    "City": "Fargo"
  },
  {
    "State": "OK",
    "City": "Fort Supply"
  },
  {
    "State": "OK",
    "City": "Freedom"
  },
  {
    "State": "OK",
    "City": "Gage"
  },
  {
    "State": "OK",
    "City": "Gate"
  },
  {
    "State": "OK",
    "City": "Laverne"
  },
  {
    "State": "OK",
    "City": "May"
  },
  {
    "State": "OK",
    "City": "Mooreland"
  },
  {
    "State": "OK",
    "City": "Mutual"
  },
  {
    "State": "OK",
    "City": "Rosston"
  },
  {
    "State": "OK",
    "City": "Sharon"
  },
  {
    "State": "OK",
    "City": "Shattuck"
  },
  {
    "State": "OK",
    "City": "Vici"
  },
  {
    "State": "OK",
    "City": "Waynoka"
  },
  {
    "State": "OK",
    "City": "Adams"
  },
  {
    "State": "OK",
    "City": "Balko"
  },
  {
    "State": "OK",
    "City": "Beaver"
  },
  {
    "State": "OK",
    "City": "Boise City"
  },
  {
    "State": "OK",
    "City": "Felt"
  },
  {
    "State": "OK",
    "City": "Forgan"
  },
  {
    "State": "OK",
    "City": "Goodwell"
  },
  {
    "State": "OK",
    "City": "Guymon"
  },
  {
    "State": "OK",
    "City": "Hardesty"
  },
  {
    "State": "OK",
    "City": "Hooker"
  },
  {
    "State": "OK",
    "City": "Kenton"
  },
  {
    "State": "OK",
    "City": "Keyes"
  },
  {
    "State": "OK",
    "City": "Texhoma"
  },
  {
    "State": "OK",
    "City": "Turpin"
  },
  {
    "State": "OK",
    "City": "Tyrone"
  },
  {
    "State": "TX",
    "City": "Texhoma"
  },
  {
    "State": "OK",
    "City": "Avant"
  },
  {
    "State": "OK",
    "City": "Barnsdall"
  },
  {
    "State": "OK",
    "City": "Bartlesville"
  },
  {
    "State": "OK",
    "City": "Bixby"
  },
  {
    "State": "OK",
    "City": "Bristow"
  },
  {
    "State": "OK",
    "City": "Broken Arrow"
  },
  {
    "State": "OK",
    "City": "Catoosa"
  },
  {
    "State": "OK",
    "City": "Chelsea"
  },
  {
    "State": "OK",
    "City": "Claremore"
  },
  {
    "State": "OK",
    "City": "Cleveland"
  },
  {
    "State": "OK",
    "City": "Collinsville"
  },
  {
    "State": "OK",
    "City": "Copan"
  },
  {
    "State": "OK",
    "City": "Cushing"
  },
  {
    "State": "OK",
    "City": "Davenport"
  },
  {
    "State": "OK",
    "City": "Delaware"
  },
  {
    "State": "OK",
    "City": "Depew"
  },
  {
    "State": "OK",
    "City": "Dewey"
  },
  {
    "State": "OK",
    "City": "Drumright"
  },
  {
    "State": "OK",
    "City": "Foyil"
  },
  {
    "State": "OK",
    "City": "Glencoe"
  },
  {
    "State": "OK",
    "City": "Glenpool"
  },
  {
    "State": "OK",
    "City": "Hallett"
  },
  {
    "State": "OK",
    "City": "Hominy"
  },
  {
    "State": "OK",
    "City": "Inola"
  },
  {
    "State": "OK",
    "City": "Jenks"
  },
  {
    "State": "OK",
    "City": "Jennings"
  },
  {
    "State": "OK",
    "City": "Kellyville"
  },
  {
    "State": "OK",
    "City": "Kiefer"
  },
  {
    "State": "OK",
    "City": "Lenapah"
  },
  {
    "State": "OK",
    "City": "Leonard"
  },
  {
    "State": "OK",
    "City": "Mannford"
  },
  {
    "State": "OK",
    "City": "Maramec"
  },
  {
    "State": "OK",
    "City": "Milfay"
  },
  {
    "State": "OK",
    "City": "Mounds"
  },
  {
    "State": "OK",
    "City": "Nowata"
  },
  {
    "State": "OK",
    "City": "Oakhurst"
  },
  {
    "State": "OK",
    "City": "Ochelata"
  },
  {
    "State": "OK",
    "City": "Oilton"
  },
  {
    "State": "OK",
    "City": "Oologah"
  },
  {
    "State": "OK",
    "City": "Osage"
  },
  {
    "State": "OK",
    "City": "Owasso"
  },
  {
    "State": "OK",
    "City": "Pawhuska"
  },
  {
    "State": "OK",
    "City": "Pawnee"
  },
  {
    "State": "OK",
    "City": "Perkins"
  },
  {
    "State": "OK",
    "City": "Prue"
  },
  {
    "State": "OK",
    "City": "Ramona"
  },
  {
    "State": "OK",
    "City": "Ripley"
  },
  {
    "State": "OK",
    "City": "Sand Springs"
  },
  {
    "State": "OK",
    "City": "Sapulpa"
  },
  {
    "State": "OK",
    "City": "Shamrock"
  },
  {
    "State": "OK",
    "City": "Skiatook"
  },
  {
    "State": "OK",
    "City": "Slick"
  },
  {
    "State": "OK",
    "City": "S Coffeyville"
  },
  {
    "State": "OK",
    "City": "Sperry"
  },
  {
    "State": "OK",
    "City": "Stillwater"
  },
  {
    "State": "OK",
    "City": "Stroud"
  },
  {
    "State": "OK",
    "City": "Talala"
  },
  {
    "State": "OK",
    "City": "Terlton"
  },
  {
    "State": "OK",
    "City": "Vera"
  },
  {
    "State": "OK",
    "City": "Wann"
  },
  {
    "State": "OK",
    "City": "Wynona"
  },
  {
    "State": "OK",
    "City": "Yale"
  },
  {
    "State": "OK",
    "City": "Tulsa"
  },
  {
    "State": "OK",
    "City": "Vinita"
  },
  {
    "State": "OK",
    "City": "Adair"
  },
  {
    "State": "OK",
    "City": "Afton"
  },
  {
    "State": "OK",
    "City": "Big Cabin"
  },
  {
    "State": "OK",
    "City": "Bluejacket"
  },
  {
    "State": "OK",
    "City": "Cardin"
  },
  {
    "State": "OK",
    "City": "Chouteau"
  },
  {
    "State": "OK",
    "City": "Colcord"
  },
  {
    "State": "OK",
    "City": "Commerce"
  },
  {
    "State": "OK",
    "City": "Disney"
  },
  {
    "State": "OK",
    "City": "Eucha"
  },
  {
    "State": "OK",
    "City": "Fairland"
  },
  {
    "State": "OK",
    "City": "Grove"
  },
  {
    "State": "OK",
    "City": "Jay"
  },
  {
    "State": "OK",
    "City": "Kansas"
  },
  {
    "State": "OK",
    "City": "Ketchum"
  },
  {
    "State": "OK",
    "City": "Langley"
  },
  {
    "State": "OK",
    "City": "Locust Grove"
  },
  {
    "State": "OK",
    "City": "Miami"
  },
  {
    "State": "OK",
    "City": "North Miami"
  },
  {
    "State": "OK",
    "City": "Oaks"
  },
  {
    "State": "OK",
    "City": "Picher"
  },
  {
    "State": "OK",
    "City": "Pryor"
  },
  {
    "State": "OK",
    "City": "Quapaw"
  },
  {
    "State": "OK",
    "City": "Rose"
  },
  {
    "State": "OK",
    "City": "Salina"
  },
  {
    "State": "OK",
    "City": "Spavinaw"
  },
  {
    "State": "OK",
    "City": "Strang"
  },
  {
    "State": "OK",
    "City": "Twin Oaks"
  },
  {
    "State": "OK",
    "City": "Welch"
  },
  {
    "State": "OK",
    "City": "Wyandotte"
  },
  {
    "State": "OK",
    "City": "Muskogee"
  },
  {
    "State": "OK",
    "City": "Beggs"
  },
  {
    "State": "OK",
    "City": "Boynton"
  },
  {
    "State": "OK",
    "City": "Braggs"
  },
  {
    "State": "OK",
    "City": "Canadian"
  },
  {
    "State": "OK",
    "City": "Checotah"
  },
  {
    "State": "OK",
    "City": "Cookson"
  },
  {
    "State": "OK",
    "City": "Council Hill"
  },
  {
    "State": "OK",
    "City": "Coweta"
  },
  {
    "State": "OK",
    "City": "Crowder"
  },
  {
    "State": "OK",
    "City": "Dewar"
  },
  {
    "State": "OK",
    "City": "Eufaula"
  },
  {
    "State": "OK",
    "City": "Fort Gibson"
  },
  {
    "State": "OK",
    "City": "Gore"
  },
  {
    "State": "OK",
    "City": "Haskell"
  },
  {
    "State": "OK",
    "City": "Henryetta"
  },
  {
    "State": "OK",
    "City": "Hitchita"
  },
  {
    "State": "OK",
    "City": "Hoyt"
  },
  {
    "State": "OK",
    "City": "Hulbert"
  },
  {
    "State": "OK",
    "City": "Indianola"
  },
  {
    "State": "OK",
    "City": "Moodys"
  },
  {
    "State": "OK",
    "City": "Morris"
  },
  {
    "State": "OK",
    "City": "Okay"
  },
  {
    "State": "OK",
    "City": "Okmulgee"
  },
  {
    "State": "OK",
    "City": "Oktaha"
  },
  {
    "State": "OK",
    "City": "Park Hill"
  },
  {
    "State": "OK",
    "City": "Peggs"
  },
  {
    "State": "OK",
    "City": "Porter"
  },
  {
    "State": "OK",
    "City": "Porum"
  },
  {
    "State": "OK",
    "City": "Preston"
  },
  {
    "State": "OK",
    "City": "Proctor"
  },
  {
    "State": "OK",
    "City": "Redbird"
  },
  {
    "State": "OK",
    "City": "Rentiesville"
  },
  {
    "State": "OK",
    "City": "Schulter"
  },
  {
    "State": "OK",
    "City": "Stidham"
  },
  {
    "State": "OK",
    "City": "Stigler"
  },
  {
    "State": "OK",
    "City": "Taft"
  },
  {
    "State": "OK",
    "City": "Tahlequah"
  },
  {
    "State": "OK",
    "City": "Wagoner"
  },
  {
    "State": "OK",
    "City": "Wainwright"
  },
  {
    "State": "OK",
    "City": "Warner"
  },
  {
    "State": "OK",
    "City": "Webbers Falls"
  },
  {
    "State": "OK",
    "City": "Welling"
  },
  {
    "State": "OK",
    "City": "Whitefield"
  },
  {
    "State": "OK",
    "City": "Mcalester"
  },
  {
    "State": "OK",
    "City": "Albion"
  },
  {
    "State": "OK",
    "City": "Alderson"
  },
  {
    "State": "OK",
    "City": "Antlers"
  },
  {
    "State": "OK",
    "City": "Atoka"
  },
  {
    "State": "OK",
    "City": "Blanco"
  },
  {
    "State": "OK",
    "City": "Blocker"
  },
  {
    "State": "OK",
    "City": "Bromide"
  },
  {
    "State": "OK",
    "City": "Calvin"
  },
  {
    "State": "OK",
    "City": "Caney"
  },
  {
    "State": "OK",
    "City": "Centrahoma"
  },
  {
    "State": "OK",
    "City": "Clarita"
  },
  {
    "State": "OK",
    "City": "Clayton"
  },
  {
    "State": "OK",
    "City": "Coalgate"
  },
  {
    "State": "OK",
    "City": "Daisy"
  },
  {
    "State": "OK",
    "City": "Finley"
  },
  {
    "State": "OK",
    "City": "Gowen"
  },
  {
    "State": "OK",
    "City": "Haileyville"
  },
  {
    "State": "OK",
    "City": "Hartshorne"
  },
  {
    "State": "OK",
    "City": "Honobia"
  },
  {
    "State": "OK",
    "City": "Kinta"
  },
  {
    "State": "OK",
    "City": "Kiowa"
  },
  {
    "State": "OK",
    "City": "Krebs"
  },
  {
    "State": "OK",
    "City": "Lane"
  },
  {
    "State": "OK",
    "City": "Lehigh"
  },
  {
    "State": "OK",
    "City": "Moyers"
  },
  {
    "State": "OK",
    "City": "Nashoba"
  },
  {
    "State": "OK",
    "City": "Panola"
  },
  {
    "State": "OK",
    "City": "Pittsburg"
  },
  {
    "State": "OK",
    "City": "Quinton"
  },
  {
    "State": "OK",
    "City": "Rattan"
  },
  {
    "State": "OK",
    "City": "Red Oak"
  },
  {
    "State": "OK",
    "City": "Savanna"
  },
  {
    "State": "OK",
    "City": "Snow"
  },
  {
    "State": "OK",
    "City": "Stringtown"
  },
  {
    "State": "OK",
    "City": "Stuart"
  },
  {
    "State": "OK",
    "City": "Talihina"
  },
  {
    "State": "OK",
    "City": "Tupelo"
  },
  {
    "State": "OK",
    "City": "Tuskahoma"
  },
  {
    "State": "OK",
    "City": "Wardville"
  },
  {
    "State": "OK",
    "City": "Whitesboro"
  },
  {
    "State": "OK",
    "City": "Wilburton"
  },
  {
    "State": "OK",
    "City": "Ponca City"
  },
  {
    "State": "OK",
    "City": "Billings"
  },
  {
    "State": "OK",
    "City": "Blackwell"
  },
  {
    "State": "OK",
    "City": "Braman"
  },
  {
    "State": "OK",
    "City": "Burbank"
  },
  {
    "State": "OK",
    "City": "Deer Creek"
  },
  {
    "State": "OK",
    "City": "Fairfax"
  },
  {
    "State": "OK",
    "City": "Hunter"
  },
  {
    "State": "OK",
    "City": "Kaw City"
  },
  {
    "State": "OK",
    "City": "Lamont"
  },
  {
    "State": "OK",
    "City": "Marland"
  },
  {
    "State": "OK",
    "City": "Nardin"
  },
  {
    "State": "OK",
    "City": "Newkirk"
  },
  {
    "State": "OK",
    "City": "Ralston"
  },
  {
    "State": "OK",
    "City": "Red Rock"
  },
  {
    "State": "OK",
    "City": "Shidler"
  },
  {
    "State": "OK",
    "City": "Tonkawa"
  },
  {
    "State": "OK",
    "City": "Durant"
  },
  {
    "State": "OK",
    "City": "Achille"
  },
  {
    "State": "OK",
    "City": "Albany"
  },
  {
    "State": "OK",
    "City": "Battiest"
  },
  {
    "State": "OK",
    "City": "Bennington"
  },
  {
    "State": "OK",
    "City": "Bethel"
  },
  {
    "State": "OK",
    "City": "Bokchito"
  },
  {
    "State": "OK",
    "City": "Boswell"
  },
  {
    "State": "OK",
    "City": "Broken Bow"
  },
  {
    "State": "OK",
    "City": "Caddo"
  },
  {
    "State": "OK",
    "City": "Calera"
  },
  {
    "State": "OK",
    "City": "Cartwright"
  },
  {
    "State": "OK",
    "City": "Colbert"
  },
  {
    "State": "OK",
    "City": "Eagletown"
  },
  {
    "State": "OK",
    "City": "Fort Towson"
  },
  {
    "State": "OK",
    "City": "Garvin"
  },
  {
    "State": "OK",
    "City": "Golden"
  },
  {
    "State": "OK",
    "City": "Grant"
  },
  {
    "State": "OK",
    "City": "Haworth"
  },
  {
    "State": "OK",
    "City": "Hendrix"
  },
  {
    "State": "OK",
    "City": "Hugo"
  },
  {
    "State": "OK",
    "City": "Idabel"
  },
  {
    "State": "OK",
    "City": "Kemp"
  },
  {
    "State": "OK",
    "City": "Kenefic"
  },
  {
    "State": "OK",
    "City": "Millerton"
  },
  {
    "State": "OK",
    "City": "Pickens"
  },
  {
    "State": "OK",
    "City": "Platter"
  },
  {
    "State": "OK",
    "City": "Ringold"
  },
  {
    "State": "OK",
    "City": "Rufe"
  },
  {
    "State": "OK",
    "City": "Sawyer"
  },
  {
    "State": "OK",
    "City": "Soper"
  },
  {
    "State": "OK",
    "City": "Spencerville"
  },
  {
    "State": "OK",
    "City": "Swink"
  },
  {
    "State": "OK",
    "City": "Valliant"
  },
  {
    "State": "OK",
    "City": "Wright City"
  },
  {
    "State": "OK",
    "City": "Shawnee"
  },
  {
    "State": "OK",
    "City": "Seminole"
  },
  {
    "State": "OK",
    "City": "Ada"
  },
  {
    "State": "OK",
    "City": "Agra"
  },
  {
    "State": "OK",
    "City": "Allen"
  },
  {
    "State": "OK",
    "City": "Asher"
  },
  {
    "State": "OK",
    "City": "Atwood"
  },
  {
    "State": "OK",
    "City": "Boley"
  },
  {
    "State": "OK",
    "City": "Bowlegs"
  },
  {
    "State": "OK",
    "City": "Byars"
  },
  {
    "State": "OK",
    "City": "Carney"
  },
  {
    "State": "OK",
    "City": "Castle"
  },
  {
    "State": "OK",
    "City": "Chandler"
  },
  {
    "State": "OK",
    "City": "Connerville"
  },
  {
    "State": "OK",
    "City": "Cromwell"
  },
  {
    "State": "OK",
    "City": "Dustin"
  },
  {
    "State": "OK",
    "City": "Earlsboro"
  },
  {
    "State": "OK",
    "City": "Fittstown"
  },
  {
    "State": "OK",
    "City": "Fitzhugh"
  },
  {
    "State": "OK",
    "City": "Francis"
  },
  {
    "State": "OK",
    "City": "Hanna"
  },
  {
    "State": "OK",
    "City": "Holdenville"
  },
  {
    "State": "OK",
    "City": "Konawa"
  },
  {
    "State": "OK",
    "City": "Lamar"
  },
  {
    "State": "OK",
    "City": "Mcloud"
  },
  {
    "State": "OK",
    "City": "Macomb"
  },
  {
    "State": "OK",
    "City": "Maud"
  },
  {
    "State": "OK",
    "City": "Meeker"
  },
  {
    "State": "OK",
    "City": "Mill Creek"
  },
  {
    "State": "OK",
    "City": "Newalla"
  },
  {
    "State": "OK",
    "City": "Okemah"
  },
  {
    "State": "OK",
    "City": "Paden"
  },
  {
    "State": "OK",
    "City": "Prague"
  },
  {
    "State": "OK",
    "City": "Roff"
  },
  {
    "State": "OK",
    "City": "Saint Louis"
  },
  {
    "State": "OK",
    "City": "Sasakwa"
  },
  {
    "State": "OK",
    "City": "Sparks"
  },
  {
    "State": "OK",
    "City": "Stonewall"
  },
  {
    "State": "OK",
    "City": "Stratford"
  },
  {
    "State": "OK",
    "City": "Tecumseh"
  },
  {
    "State": "OK",
    "City": "Tryon"
  },
  {
    "State": "OK",
    "City": "Wanette"
  },
  {
    "State": "OK",
    "City": "Weleetka"
  },
  {
    "State": "OK",
    "City": "Wellston"
  },
  {
    "State": "OK",
    "City": "Wetumka"
  },
  {
    "State": "OK",
    "City": "Wewoka"
  },
  {
    "State": "OK",
    "City": "Arkoma"
  },
  {
    "State": "OK",
    "City": "Pocola"
  },
  {
    "State": "OK",
    "City": "Bokoshe"
  },
  {
    "State": "OK",
    "City": "Bunch"
  },
  {
    "State": "OK",
    "City": "Cameron"
  },
  {
    "State": "OK",
    "City": "Fanshawe"
  },
  {
    "State": "OK",
    "City": "Gans"
  },
  {
    "State": "OK",
    "City": "Heavener"
  },
  {
    "State": "OK",
    "City": "Hodgen"
  },
  {
    "State": "OK",
    "City": "Howe"
  },
  {
    "State": "OK",
    "City": "Keota"
  },
  {
    "State": "OK",
    "City": "Leflore"
  },
  {
    "State": "OK",
    "City": "Lequire"
  },
  {
    "State": "OK",
    "City": "Mccurtain"
  },
  {
    "State": "OK",
    "City": "Marble City"
  },
  {
    "State": "OK",
    "City": "Moffett"
  },
  {
    "State": "OK",
    "City": "Monroe"
  },
  {
    "State": "OK",
    "City": "Muldrow"
  },
  {
    "State": "OK",
    "City": "Muse"
  },
  {
    "State": "OK",
    "City": "Panama"
  },
  {
    "State": "OK",
    "City": "Poteau"
  },
  {
    "State": "OK",
    "City": "Roland"
  },
  {
    "State": "OK",
    "City": "Sallisaw"
  },
  {
    "State": "OK",
    "City": "Shady Point"
  },
  {
    "State": "OK",
    "City": "Smithville"
  },
  {
    "State": "OK",
    "City": "Spiro"
  },
  {
    "State": "OK",
    "City": "Stilwell"
  },
  {
    "State": "OK",
    "City": "Vian"
  },
  {
    "State": "OK",
    "City": "Watson"
  },
  {
    "State": "OK",
    "City": "Watts"
  },
  {
    "State": "OK",
    "City": "Westville"
  },
  {
    "State": "OK",
    "City": "Wister"
  },
  {
    "State": "TX",
    "City": "Addison"
  },
  {
    "State": "TX",
    "City": "Allen"
  },
  {
    "State": "TX",
    "City": "Carrollton"
  },
  {
    "State": "TX",
    "City": "Celina"
  },
  {
    "State": "TX",
    "City": "Irving"
  },
  {
    "State": "TX",
    "City": "Coppell"
  },
  {
    "State": "TX",
    "City": "Denison"
  },
  {
    "State": "TX",
    "City": "Flower Mound"
  },
  {
    "State": "TX",
    "City": "Plano"
  },
  {
    "State": "TX",
    "City": "Lewisville"
  },
  {
    "State": "TX",
    "City": "Rowlett"
  },
  {
    "State": "TX",
    "City": "Rockwall"
  },
  {
    "State": "TX",
    "City": "Frisco"
  },
  {
    "State": "TX",
    "City": "Garland"
  },
  {
    "State": "TX",
    "City": "Sachse"
  },
  {
    "State": "TX",
    "City": "Grand Prairie"
  },
  {
    "State": "TX",
    "City": "The Colony"
  },
  {
    "State": "TX",
    "City": "Gunter"
  },
  {
    "State": "TX",
    "City": "Lake Dallas"
  },
  {
    "State": "TX",
    "City": "Little Elm"
  },
  {
    "State": "TX",
    "City": "Mckinney"
  },
  {
    "State": "TX",
    "City": "Pottsboro"
  },
  {
    "State": "TX",
    "City": "Prosper"
  },
  {
    "State": "TX",
    "City": "Richardson"
  },
  {
    "State": "TX",
    "City": "Sherman"
  },
  {
    "State": "TX",
    "City": "Weston"
  },
  {
    "State": "TX",
    "City": "Wylie"
  },
  {
    "State": "TX",
    "City": "Bardwell"
  },
  {
    "State": "TX",
    "City": "Barry"
  },
  {
    "State": "TX",
    "City": "Canton"
  },
  {
    "State": "TX",
    "City": "Cedar Hill"
  },
  {
    "State": "TX",
    "City": "Chatfield"
  },
  {
    "State": "TX",
    "City": "Corsicana"
  },
  {
    "State": "TX",
    "City": "Crandall"
  },
  {
    "State": "TX",
    "City": "Desoto"
  },
  {
    "State": "TX",
    "City": "Duncanville"
  },
  {
    "State": "TX",
    "City": "Edgewood"
  },
  {
    "State": "TX",
    "City": "Elmo"
  },
  {
    "State": "TX",
    "City": "Ennis"
  },
  {
    "State": "TX",
    "City": "Copeville"
  },
  {
    "State": "TX",
    "City": "Eustace"
  },
  {
    "State": "TX",
    "City": "Ferris"
  },
  {
    "State": "TX",
    "City": "Forney"
  },
  {
    "State": "TX",
    "City": "Fruitvale"
  },
  {
    "State": "TX",
    "City": "Fate"
  },
  {
    "State": "TX",
    "City": "Lancaster"
  },
  {
    "State": "TX",
    "City": "Caddo Mills"
  },
  {
    "State": "TX",
    "City": "Grand Saline"
  },
  {
    "State": "TX",
    "City": "Hutchins"
  },
  {
    "State": "TX",
    "City": "Kaufman"
  },
  {
    "State": "TX",
    "City": "Kemp"
  },
  {
    "State": "TX",
    "City": "Kerens"
  },
  {
    "State": "TX",
    "City": "Mabank"
  },
  {
    "State": "TX",
    "City": "Malakoff"
  },
  {
    "State": "TX",
    "City": "Mesquite"
  },
  {
    "State": "TX",
    "City": "Palmer"
  },
  {
    "State": "TX",
    "City": "Powell"
  },
  {
    "State": "TX",
    "City": "Red Oak"
  },
  {
    "State": "TX",
    "City": "Rice"
  },
  {
    "State": "TX",
    "City": "Rosser"
  },
  {
    "State": "TX",
    "City": "Scurry"
  },
  {
    "State": "TX",
    "City": "Seagoville"
  },
  {
    "State": "TX",
    "City": "Terrell"
  },
  {
    "State": "TX",
    "City": "Trinidad"
  },
  {
    "State": "TX",
    "City": "Josephine"
  },
  {
    "State": "TX",
    "City": "Waxahachie"
  },
  {
    "State": "TX",
    "City": "Lavon"
  },
  {
    "State": "TX",
    "City": "Wills Point"
  },
  {
    "State": "TX",
    "City": "Wilmer"
  },
  {
    "State": "TX",
    "City": "Nevada"
  },
  {
    "State": "TX",
    "City": "Balch Springs"
  },
  {
    "State": "TX",
    "City": "Sunnyvale"
  },
  {
    "State": "TX",
    "City": "Royse City"
  },
  {
    "State": "TX",
    "City": "Dallas"
  },
  {
    "State": "TX",
    "City": "Greenville"
  },
  {
    "State": "TX",
    "City": "Princeton"
  },
  {
    "State": "TX",
    "City": "Anna"
  },
  {
    "State": "TX",
    "City": "Alba"
  },
  {
    "State": "TX",
    "City": "Arthur City"
  },
  {
    "State": "TX",
    "City": "Bagwell"
  },
  {
    "State": "TX",
    "City": "Bailey"
  },
  {
    "State": "TX",
    "City": "Bells"
  },
  {
    "State": "TX",
    "City": "Ben Franklin"
  },
  {
    "State": "TX",
    "City": "Blossom"
  },
  {
    "State": "TX",
    "City": "Bogata"
  },
  {
    "State": "TX",
    "City": "Bonham"
  },
  {
    "State": "TX",
    "City": "Brashear"
  },
  {
    "State": "TX",
    "City": "Brookston"
  },
  {
    "State": "TX",
    "City": "Campbell"
  },
  {
    "State": "TX",
    "City": "Celeste"
  },
  {
    "State": "TX",
    "City": "Blue Ridge"
  },
  {
    "State": "TX",
    "City": "Chicota"
  },
  {
    "State": "TX",
    "City": "Clarksville"
  },
  {
    "State": "TX",
    "City": "Commerce"
  },
  {
    "State": "TX",
    "City": "Como"
  },
  {
    "State": "TX",
    "City": "Cooper"
  },
  {
    "State": "TX",
    "City": "Cumby"
  },
  {
    "State": "TX",
    "City": "Cunningham"
  },
  {
    "State": "TX",
    "City": "Deport"
  },
  {
    "State": "TX",
    "City": "Detroit"
  },
  {
    "State": "TX",
    "City": "Dike"
  },
  {
    "State": "TX",
    "City": "Dodd City"
  },
  {
    "State": "TX",
    "City": "Ector"
  },
  {
    "State": "TX",
    "City": "Emory"
  },
  {
    "State": "TX",
    "City": "Enloe"
  },
  {
    "State": "TX",
    "City": "Farmersville"
  },
  {
    "State": "TX",
    "City": "Gober"
  },
  {
    "State": "TX",
    "City": "Golden"
  },
  {
    "State": "TX",
    "City": "Honey Grove"
  },
  {
    "State": "TX",
    "City": "Ivanhoe"
  },
  {
    "State": "TX",
    "City": "Klondike"
  },
  {
    "State": "TX",
    "City": "Ladonia"
  },
  {
    "State": "TX",
    "City": "Lake Creek"
  },
  {
    "State": "TX",
    "City": "Leesburg"
  },
  {
    "State": "TX",
    "City": "Leonard"
  },
  {
    "State": "TX",
    "City": "Lone Oak"
  },
  {
    "State": "TX",
    "City": "Melissa"
  },
  {
    "State": "TX",
    "City": "Mount Pleasant"
  },
  {
    "State": "TX",
    "City": "Mount Vernon"
  },
  {
    "State": "TX",
    "City": "Merit"
  },
  {
    "State": "TX",
    "City": "Howe"
  },
  {
    "State": "TX",
    "City": "Paris"
  },
  {
    "State": "TX",
    "City": "Pattonville"
  },
  {
    "State": "TX",
    "City": "Pecan Gap"
  },
  {
    "State": "TX",
    "City": "Petty"
  },
  {
    "State": "TX",
    "City": "Pickton"
  },
  {
    "State": "TX",
    "City": "Point"
  },
  {
    "State": "TX",
    "City": "Powderly"
  },
  {
    "State": "TX",
    "City": "Quinlan"
  },
  {
    "State": "TX",
    "City": "Randolph"
  },
  {
    "State": "TX",
    "City": "Ravenna"
  },
  {
    "State": "TX",
    "City": "Roxton"
  },
  {
    "State": "TX",
    "City": "Saltillo"
  },
  {
    "State": "TX",
    "City": "Savoy"
  },
  {
    "State": "TX",
    "City": "Scroggins"
  },
  {
    "State": "TX",
    "City": "Sulphur Bluff"
  },
  {
    "State": "TX",
    "City": "Sulphur Springs"
  },
  {
    "State": "TX",
    "City": "Westminster"
  },
  {
    "State": "TX",
    "City": "Sumner"
  },
  {
    "State": "TX",
    "City": "Talco"
  },
  {
    "State": "TX",
    "City": "Telephone"
  },
  {
    "State": "TX",
    "City": "Tom Bean"
  },
  {
    "State": "TX",
    "City": "Trenton"
  },
  {
    "State": "TX",
    "City": "Whitewright"
  },
  {
    "State": "TX",
    "City": "Windom"
  },
  {
    "State": "TX",
    "City": "Winfield"
  },
  {
    "State": "TX",
    "City": "Winnsboro"
  },
  {
    "State": "TX",
    "City": "Van Alstyne"
  },
  {
    "State": "TX",
    "City": "Wolfe City"
  },
  {
    "State": "TX",
    "City": "Yantis"
  },
  {
    "State": "TX",
    "City": "Texarkana"
  },
  {
    "State": "TX",
    "City": "Annona"
  },
  {
    "State": "TX",
    "City": "Atlanta"
  },
  {
    "State": "TX",
    "City": "Avery"
  },
  {
    "State": "TX",
    "City": "Bivins"
  },
  {
    "State": "TX",
    "City": "Bloomburg"
  },
  {
    "State": "TX",
    "City": "Cookville"
  },
  {
    "State": "TX",
    "City": "De Kalb"
  },
  {
    "State": "TX",
    "City": "Douglassville"
  },
  {
    "State": "TX",
    "City": "Hooks"
  },
  {
    "State": "TX",
    "City": "Kildare"
  },
  {
    "State": "TX",
    "City": "Linden"
  },
  {
    "State": "TX",
    "City": "Lodi"
  },
  {
    "State": "TX",
    "City": "Mc Leod"
  },
  {
    "State": "TX",
    "City": "Marietta"
  },
  {
    "State": "TX",
    "City": "Maud"
  },
  {
    "State": "TX",
    "City": "Naples"
  },
  {
    "State": "TX",
    "City": "Nash"
  },
  {
    "State": "TX",
    "City": "New Boston"
  },
  {
    "State": "TX",
    "City": "Omaha"
  },
  {
    "State": "TX",
    "City": "Queen City"
  },
  {
    "State": "TX",
    "City": "Redwater"
  },
  {
    "State": "TX",
    "City": "Simms"
  },
  {
    "State": "TX",
    "City": "Longview"
  },
  {
    "State": "TX",
    "City": "Avinger"
  },
  {
    "State": "TX",
    "City": "Beckville"
  },
  {
    "State": "TX",
    "City": "Carthage"
  },
  {
    "State": "TX",
    "City": "Cason"
  },
  {
    "State": "TX",
    "City": "Clayton"
  },
  {
    "State": "TX",
    "City": "Daingerfield"
  },
  {
    "State": "TX",
    "City": "De Berry"
  },
  {
    "State": "TX",
    "City": "Diana"
  },
  {
    "State": "TX",
    "City": "Easton"
  },
  {
    "State": "TX",
    "City": "Elysian Fields"
  },
  {
    "State": "TX",
    "City": "Gary"
  },
  {
    "State": "TX",
    "City": "Gilmer"
  },
  {
    "State": "TX",
    "City": "Gladewater"
  },
  {
    "State": "TX",
    "City": "Hallsville"
  },
  {
    "State": "TX",
    "City": "Harleton"
  },
  {
    "State": "TX",
    "City": "Henderson"
  },
  {
    "State": "TX",
    "City": "Hughes Springs"
  },
  {
    "State": "TX",
    "City": "Jefferson"
  },
  {
    "State": "TX",
    "City": "Joinerville"
  },
  {
    "State": "TX",
    "City": "Jonesville"
  },
  {
    "State": "TX",
    "City": "Judson"
  },
  {
    "State": "TX",
    "City": "Karnack"
  },
  {
    "State": "TX",
    "City": "Kilgore"
  },
  {
    "State": "TX",
    "City": "Laird Hill"
  },
  {
    "State": "TX",
    "City": "Laneville"
  },
  {
    "State": "TX",
    "City": "Lone Star"
  },
  {
    "State": "TX",
    "City": "Long Branch"
  },
  {
    "State": "TX",
    "City": "Marshall"
  },
  {
    "State": "TX",
    "City": "Minden"
  },
  {
    "State": "TX",
    "City": "Mount Enterprise"
  },
  {
    "State": "TX",
    "City": "New London"
  },
  {
    "State": "TX",
    "City": "Ore City"
  },
  {
    "State": "TX",
    "City": "Overton"
  },
  {
    "State": "TX",
    "City": "Panola"
  },
  {
    "State": "TX",
    "City": "Pittsburg"
  },
  {
    "State": "TX",
    "City": "Price"
  },
  {
    "State": "TX",
    "City": "Scottsville"
  },
  {
    "State": "TX",
    "City": "Selman City"
  },
  {
    "State": "TX",
    "City": "Tatum"
  },
  {
    "State": "TX",
    "City": "Waskom"
  },
  {
    "State": "TX",
    "City": "White Oak"
  },
  {
    "State": "TX",
    "City": "Woodlawn"
  },
  {
    "State": "TX",
    "City": "Tyler"
  },
  {
    "State": "TX",
    "City": "Arp"
  },
  {
    "State": "TX",
    "City": "Athens"
  },
  {
    "State": "TX",
    "City": "Ben Wheeler"
  },
  {
    "State": "TX",
    "City": "Big Sandy"
  },
  {
    "State": "TX",
    "City": "Brownsboro"
  },
  {
    "State": "TX",
    "City": "Bullard"
  },
  {
    "State": "TX",
    "City": "Chandler"
  },
  {
    "State": "TX",
    "City": "Cuney"
  },
  {
    "State": "TX",
    "City": "Cushing"
  },
  {
    "State": "TX",
    "City": "Flint"
  },
  {
    "State": "TX",
    "City": "Frankston"
  },
  {
    "State": "TX",
    "City": "Gallatin"
  },
  {
    "State": "TX",
    "City": "Hawkins"
  },
  {
    "State": "TX",
    "City": "Jacksonville"
  },
  {
    "State": "TX",
    "City": "Larue"
  },
  {
    "State": "TX",
    "City": "Lindale"
  },
  {
    "State": "TX",
    "City": "Maydelle"
  },
  {
    "State": "TX",
    "City": "Mineola"
  },
  {
    "State": "TX",
    "City": "Murchison"
  },
  {
    "State": "TX",
    "City": "Neches"
  },
  {
    "State": "TX",
    "City": "New Summerfield"
  },
  {
    "State": "TX",
    "City": "Poynor"
  },
  {
    "State": "TX",
    "City": "Quitman"
  },
  {
    "State": "TX",
    "City": "Reklaw"
  },
  {
    "State": "TX",
    "City": "Rusk"
  },
  {
    "State": "TX",
    "City": "Sacul"
  },
  {
    "State": "TX",
    "City": "Troup"
  },
  {
    "State": "TX",
    "City": "Van"
  },
  {
    "State": "TX",
    "City": "Whitehouse"
  },
  {
    "State": "TX",
    "City": "Winona"
  },
  {
    "State": "TX",
    "City": "Palestine"
  },
  {
    "State": "TX",
    "City": "Buffalo"
  },
  {
    "State": "TX",
    "City": "Cayuga"
  },
  {
    "State": "TX",
    "City": "Centerville"
  },
  {
    "State": "TX",
    "City": "Centralia"
  },
  {
    "State": "TX",
    "City": "Crockett"
  },
  {
    "State": "TX",
    "City": "Donie"
  },
  {
    "State": "TX",
    "City": "Elkhart"
  },
  {
    "State": "TX",
    "City": "Fairfield"
  },
  {
    "State": "TX",
    "City": "Grapeland"
  },
  {
    "State": "TX",
    "City": "Groveton"
  },
  {
    "State": "TX",
    "City": "Jewett"
  },
  {
    "State": "TX",
    "City": "Kennard"
  },
  {
    "State": "TX",
    "City": "Kirvin"
  },
  {
    "State": "TX",
    "City": "Latexo"
  },
  {
    "State": "TX",
    "City": "Leona"
  },
  {
    "State": "TX",
    "City": "Lovelady"
  },
  {
    "State": "TX",
    "City": "Midway"
  },
  {
    "State": "TX",
    "City": "Montalba"
  },
  {
    "State": "TX",
    "City": "Oakwood"
  },
  {
    "State": "TX",
    "City": "Pennington"
  },
  {
    "State": "TX",
    "City": "Ratcliff"
  },
  {
    "State": "TX",
    "City": "Streetman"
  },
  {
    "State": "TX",
    "City": "Teague"
  },
  {
    "State": "TX",
    "City": "Tennessee Colony"
  },
  {
    "State": "TX",
    "City": "Trinity"
  },
  {
    "State": "TX",
    "City": "Woodlake"
  },
  {
    "State": "TX",
    "City": "Lufkin"
  },
  {
    "State": "TX",
    "City": "Alto"
  },
  {
    "State": "TX",
    "City": "Apple Springs"
  },
  {
    "State": "TX",
    "City": "Bon Wier"
  },
  {
    "State": "TX",
    "City": "Broaddus"
  },
  {
    "State": "TX",
    "City": "Bronson"
  },
  {
    "State": "TX",
    "City": "Brookeland"
  },
  {
    "State": "TX",
    "City": "Burkeville"
  },
  {
    "State": "TX",
    "City": "Call"
  },
  {
    "State": "TX",
    "City": "Camden"
  },
  {
    "State": "TX",
    "City": "Center"
  },
  {
    "State": "TX",
    "City": "Chester"
  },
  {
    "State": "TX",
    "City": "Chireno"
  },
  {
    "State": "TX",
    "City": "Colmesneil"
  },
  {
    "State": "TX",
    "City": "Corrigan"
  },
  {
    "State": "TX",
    "City": "Diboll"
  },
  {
    "State": "TX",
    "City": "Doucette"
  },
  {
    "State": "TX",
    "City": "Douglass"
  },
  {
    "State": "TX",
    "City": "Etoile"
  },
  {
    "State": "TX",
    "City": "Garrison"
  },
  {
    "State": "TX",
    "City": "Hemphill"
  },
  {
    "State": "TX",
    "City": "Huntington"
  },
  {
    "State": "TX",
    "City": "Jasper"
  },
  {
    "State": "TX",
    "City": "Joaquin"
  },
  {
    "State": "TX",
    "City": "Kirbyville"
  },
  {
    "State": "TX",
    "City": "Martinsville"
  },
  {
    "State": "TX",
    "City": "Milam"
  },
  {
    "State": "TX",
    "City": "Moscow"
  },
  {
    "State": "TX",
    "City": "Nacogdoches"
  },
  {
    "State": "TX",
    "City": "Newton"
  },
  {
    "State": "TX",
    "City": "Pineland"
  },
  {
    "State": "TX",
    "City": "Pollok"
  },
  {
    "State": "TX",
    "City": "San Augustine"
  },
  {
    "State": "TX",
    "City": "Shelbyville"
  },
  {
    "State": "TX",
    "City": "Tenaha"
  },
  {
    "State": "TX",
    "City": "Timpson"
  },
  {
    "State": "TX",
    "City": "Wells"
  },
  {
    "State": "TX",
    "City": "Wiergate"
  },
  {
    "State": "TX",
    "City": "Woden"
  },
  {
    "State": "TX",
    "City": "Woodville"
  },
  {
    "State": "TX",
    "City": "Zavalla"
  },
  {
    "State": "TX",
    "City": "Arlington"
  },
  {
    "State": "TX",
    "City": "Aledo"
  },
  {
    "State": "TX",
    "City": "Alvarado"
  },
  {
    "State": "TX",
    "City": "Azle"
  },
  {
    "State": "TX",
    "City": "Bedford"
  },
  {
    "State": "TX",
    "City": "Boyd"
  },
  {
    "State": "TX",
    "City": "Burleson"
  },
  {
    "State": "TX",
    "City": "Cleburne"
  },
  {
    "State": "TX",
    "City": "Colleyville"
  },
  {
    "State": "TX",
    "City": "Cresson"
  },
  {
    "State": "TX",
    "City": "Crowley"
  },
  {
    "State": "TX",
    "City": "Euless"
  },
  {
    "State": "TX",
    "City": "Forreston"
  },
  {
    "State": "TX",
    "City": "Glen Rose"
  },
  {
    "State": "TX",
    "City": "Godley"
  },
  {
    "State": "TX",
    "City": "Granbury"
  },
  {
    "State": "TX",
    "City": "Grandview"
  },
  {
    "State": "TX",
    "City": "Grapevine"
  },
  {
    "State": "TX",
    "City": "Haslet"
  },
  {
    "State": "TX",
    "City": "Hurst"
  },
  {
    "State": "TX",
    "City": "Itasca"
  },
  {
    "State": "TX",
    "City": "Joshua"
  },
  {
    "State": "TX",
    "City": "Keene"
  },
  {
    "State": "TX",
    "City": "Kennedale"
  },
  {
    "State": "TX",
    "City": "Lillian"
  },
  {
    "State": "TX",
    "City": "Mansfield"
  },
  {
    "State": "TX",
    "City": "Maypearl"
  },
  {
    "State": "TX",
    "City": "Midlothian"
  },
  {
    "State": "TX",
    "City": "Millsap"
  },
  {
    "State": "TX",
    "City": "Mineral Wells"
  },
  {
    "State": "TX",
    "City": "Nemo"
  },
  {
    "State": "TX",
    "City": "Newark"
  },
  {
    "State": "TX",
    "City": "Paradise"
  },
  {
    "State": "TX",
    "City": "Rainbow"
  },
  {
    "State": "TX",
    "City": "Rhome"
  },
  {
    "State": "TX",
    "City": "Springtown"
  },
  {
    "State": "TX",
    "City": "Venus"
  },
  {
    "State": "TX",
    "City": "Weatherford"
  },
  {
    "State": "TX",
    "City": "Southlake"
  },
  {
    "State": "TX",
    "City": "Rio Vista"
  },
  {
    "State": "TX",
    "City": "Fort Worth"
  },
  {
    "State": "TX",
    "City": "Haltom City"
  },
  {
    "State": "TX",
    "City": "Naval Air Station Jrb"
  },
  {
    "State": "TX",
    "City": "North Richland Hills"
  },
  {
    "State": "TX",
    "City": "Denton"
  },
  {
    "State": "TX",
    "City": "Alvord"
  },
  {
    "State": "TX",
    "City": "Argyle"
  },
  {
    "State": "TX",
    "City": "Aubrey"
  },
  {
    "State": "TX",
    "City": "Bellevue"
  },
  {
    "State": "TX",
    "City": "Bowie"
  },
  {
    "State": "TX",
    "City": "Collinsville"
  },
  {
    "State": "TX",
    "City": "Decatur"
  },
  {
    "State": "TX",
    "City": "Era"
  },
  {
    "State": "TX",
    "City": "Forestburg"
  },
  {
    "State": "TX",
    "City": "Gainesville"
  },
  {
    "State": "TX",
    "City": "Keller"
  },
  {
    "State": "TX",
    "City": "Gordonville"
  },
  {
    "State": "TX",
    "City": "Greenwood"
  },
  {
    "State": "TX",
    "City": "Justin"
  },
  {
    "State": "TX",
    "City": "Krum"
  },
  {
    "State": "TX",
    "City": "Lindsay"
  },
  {
    "State": "TX",
    "City": "Montague"
  },
  {
    "State": "TX",
    "City": "Muenster"
  },
  {
    "State": "TX",
    "City": "Myra"
  },
  {
    "State": "TX",
    "City": "Nocona"
  },
  {
    "State": "TX",
    "City": "Pilot Point"
  },
  {
    "State": "TX",
    "City": "Ponder"
  },
  {
    "State": "TX",
    "City": "Ringgold"
  },
  {
    "State": "TX",
    "City": "Roanoke"
  },
  {
    "State": "TX",
    "City": "Rosston"
  },
  {
    "State": "TX",
    "City": "Sadler"
  },
  {
    "State": "TX",
    "City": "Saint Jo"
  },
  {
    "State": "TX",
    "City": "Sanger"
  },
  {
    "State": "TX",
    "City": "Slidell"
  },
  {
    "State": "TX",
    "City": "Southmayd"
  },
  {
    "State": "TX",
    "City": "Sunset"
  },
  {
    "State": "TX",
    "City": "Tioga"
  },
  {
    "State": "TX",
    "City": "Valley View"
  },
  {
    "State": "TX",
    "City": "Whitesboro"
  },
  {
    "State": "TX",
    "City": "Wichita Falls"
  },
  {
    "State": "TX",
    "City": "Sheppard AFB"
  },
  {
    "State": "TX",
    "City": "Archer City"
  },
  {
    "State": "TX",
    "City": "Bluegrove"
  },
  {
    "State": "TX",
    "City": "Burkburnett"
  },
  {
    "State": "TX",
    "City": "Byers"
  },
  {
    "State": "TX",
    "City": "Electra"
  },
  {
    "State": "TX",
    "City": "Goree"
  },
  {
    "State": "TX",
    "City": "Harrold"
  },
  {
    "State": "TX",
    "City": "Henrietta"
  },
  {
    "State": "TX",
    "City": "Holliday"
  },
  {
    "State": "TX",
    "City": "Iowa Park"
  },
  {
    "State": "TX",
    "City": "Kamay"
  },
  {
    "State": "TX",
    "City": "Megargel"
  },
  {
    "State": "TX",
    "City": "Munday"
  },
  {
    "State": "TX",
    "City": "Newcastle"
  },
  {
    "State": "TX",
    "City": "Oklaunion"
  },
  {
    "State": "TX",
    "City": "Olney"
  },
  {
    "State": "TX",
    "City": "Petrolia"
  },
  {
    "State": "TX",
    "City": "Scotland"
  },
  {
    "State": "TX",
    "City": "Seymour"
  },
  {
    "State": "TX",
    "City": "Vernon"
  },
  {
    "State": "TX",
    "City": "Weinert"
  },
  {
    "State": "TX",
    "City": "Windthorst"
  },
  {
    "State": "TX",
    "City": "Stephenville"
  },
  {
    "State": "TX",
    "City": "Breckenridge"
  },
  {
    "State": "TX",
    "City": "Bridgeport"
  },
  {
    "State": "TX",
    "City": "Bryson"
  },
  {
    "State": "TX",
    "City": "Caddo"
  },
  {
    "State": "TX",
    "City": "Albany"
  },
  {
    "State": "TX",
    "City": "Chico"
  },
  {
    "State": "TX",
    "City": "Blanket"
  },
  {
    "State": "TX",
    "City": "Bluff Dale"
  },
  {
    "State": "TX",
    "City": "Carbon"
  },
  {
    "State": "TX",
    "City": "Carlton"
  },
  {
    "State": "TX",
    "City": "Cisco"
  },
  {
    "State": "TX",
    "City": "Dennis"
  },
  {
    "State": "TX",
    "City": "Comanche"
  },
  {
    "State": "TX",
    "City": "Cross Plains"
  },
  {
    "State": "TX",
    "City": "De Leon"
  },
  {
    "State": "TX",
    "City": "Desdemona"
  },
  {
    "State": "TX",
    "City": "Dublin"
  },
  {
    "State": "TX",
    "City": "Eastland"
  },
  {
    "State": "TX",
    "City": "Graford"
  },
  {
    "State": "TX",
    "City": "Graham"
  },
  {
    "State": "TX",
    "City": "Energy"
  },
  {
    "State": "TX",
    "City": "Gordon"
  },
  {
    "State": "TX",
    "City": "Gorman"
  },
  {
    "State": "TX",
    "City": "Gustine"
  },
  {
    "State": "TX",
    "City": "Hico"
  },
  {
    "State": "TX",
    "City": "Jacksboro"
  },
  {
    "State": "TX",
    "City": "Jermyn"
  },
  {
    "State": "TX",
    "City": "Loving"
  },
  {
    "State": "TX",
    "City": "Lingleville"
  },
  {
    "State": "TX",
    "City": "Lipan"
  },
  {
    "State": "TX",
    "City": "Mingus"
  },
  {
    "State": "TX",
    "City": "Moran"
  },
  {
    "State": "TX",
    "City": "Morgan Mill"
  },
  {
    "State": "TX",
    "City": "Olden"
  },
  {
    "State": "TX",
    "City": "Paluxy"
  },
  {
    "State": "TX",
    "City": "Proctor"
  },
  {
    "State": "TX",
    "City": "Putnam"
  },
  {
    "State": "TX",
    "City": "Ranger"
  },
  {
    "State": "TX",
    "City": "Rising Star"
  },
  {
    "State": "TX",
    "City": "Santo"
  },
  {
    "State": "TX",
    "City": "Sidney"
  },
  {
    "State": "TX",
    "City": "Strawn"
  },
  {
    "State": "TX",
    "City": "Tolar"
  },
  {
    "State": "TX",
    "City": "South Bend"
  },
  {
    "State": "TX",
    "City": "Throckmorton"
  },
  {
    "State": "TX",
    "City": "Palo Pinto"
  },
  {
    "State": "TX",
    "City": "Peaster"
  },
  {
    "State": "TX",
    "City": "Perrin"
  },
  {
    "State": "TX",
    "City": "Poolville"
  },
  {
    "State": "TX",
    "City": "Whitt"
  },
  {
    "State": "TX",
    "City": "Woodson"
  },
  {
    "State": "TX",
    "City": "Temple"
  },
  {
    "State": "TX",
    "City": "Bartlett"
  },
  {
    "State": "TX",
    "City": "Belton"
  },
  {
    "State": "TX",
    "City": "Buckholts"
  },
  {
    "State": "TX",
    "City": "Burlington"
  },
  {
    "State": "TX",
    "City": "Cameron"
  },
  {
    "State": "TX",
    "City": "Copperas Cove"
  },
  {
    "State": "TX",
    "City": "Davilla"
  },
  {
    "State": "TX",
    "City": "Eddy"
  },
  {
    "State": "TX",
    "City": "Evant"
  },
  {
    "State": "TX",
    "City": "Flat"
  },
  {
    "State": "TX",
    "City": "Florence"
  },
  {
    "State": "TX",
    "City": "Gatesville"
  },
  {
    "State": "TX",
    "City": "Granger"
  },
  {
    "State": "TX",
    "City": "Hamilton"
  },
  {
    "State": "TX",
    "City": "Heidenheimer"
  },
  {
    "State": "TX",
    "City": "Holland"
  },
  {
    "State": "TX",
    "City": "Jarrell"
  },
  {
    "State": "TX",
    "City": "Jonesboro"
  },
  {
    "State": "TX",
    "City": "Kempner"
  },
  {
    "State": "TX",
    "City": "Killeen"
  },
  {
    "State": "TX",
    "City": "Fort Hood"
  },
  {
    "State": "TX",
    "City": "Harker Heights"
  },
  {
    "State": "TX",
    "City": "Lampasas"
  },
  {
    "State": "TX",
    "City": "Little River Academy"
  },
  {
    "State": "TX",
    "City": "Milano"
  },
  {
    "State": "TX",
    "City": "Moody"
  },
  {
    "State": "TX",
    "City": "Mound"
  },
  {
    "State": "TX",
    "City": "Nolanville"
  },
  {
    "State": "TX",
    "City": "Oglesby"
  },
  {
    "State": "TX",
    "City": "Pendleton"
  },
  {
    "State": "TX",
    "City": "Pottsville"
  },
  {
    "State": "TX",
    "City": "Purmela"
  },
  {
    "State": "TX",
    "City": "Rockdale"
  },
  {
    "State": "TX",
    "City": "Rogers"
  },
  {
    "State": "TX",
    "City": "Rosebud"
  },
  {
    "State": "TX",
    "City": "Salado"
  },
  {
    "State": "TX",
    "City": "Schwertner"
  },
  {
    "State": "TX",
    "City": "Taylor"
  },
  {
    "State": "TX",
    "City": "Thorndale"
  },
  {
    "State": "TX",
    "City": "Thrall"
  },
  {
    "State": "TX",
    "City": "Troy"
  },
  {
    "State": "TX",
    "City": "Abbott"
  },
  {
    "State": "TX",
    "City": "Aquilla"
  },
  {
    "State": "TX",
    "City": "Avalon"
  },
  {
    "State": "TX",
    "City": "Axtell"
  },
  {
    "State": "TX",
    "City": "Blooming Grove"
  },
  {
    "State": "TX",
    "City": "Blum"
  },
  {
    "State": "TX",
    "City": "Brandon"
  },
  {
    "State": "TX",
    "City": "Bremond"
  },
  {
    "State": "TX",
    "City": "Bruceville"
  },
  {
    "State": "TX",
    "City": "Bynum"
  },
  {
    "State": "TX",
    "City": "Chilton"
  },
  {
    "State": "TX",
    "City": "China Spring"
  },
  {
    "State": "TX",
    "City": "Clifton"
  },
  {
    "State": "TX",
    "City": "Coolidge"
  },
  {
    "State": "TX",
    "City": "Covington"
  },
  {
    "State": "TX",
    "City": "Cranfills Gap"
  },
  {
    "State": "TX",
    "City": "Crawford"
  },
  {
    "State": "TX",
    "City": "Dawson"
  },
  {
    "State": "TX",
    "City": "Elm Mott"
  },
  {
    "State": "TX",
    "City": "Frost"
  },
  {
    "State": "TX",
    "City": "Groesbeck"
  },
  {
    "State": "TX",
    "City": "Hewitt"
  },
  {
    "State": "TX",
    "City": "Laguna Park"
  },
  {
    "State": "TX",
    "City": "Hillsboro"
  },
  {
    "State": "TX",
    "City": "Hubbard"
  },
  {
    "State": "TX",
    "City": "Iredell"
  },
  {
    "State": "TX",
    "City": "Irene"
  },
  {
    "State": "TX",
    "City": "Italy"
  },
  {
    "State": "TX",
    "City": "Kopperl"
  },
  {
    "State": "TX",
    "City": "Kosse"
  },
  {
    "State": "TX",
    "City": "Leroy"
  },
  {
    "State": "TX",
    "City": "Lorena"
  },
  {
    "State": "TX",
    "City": "Lott"
  },
  {
    "State": "TX",
    "City": "Mc Gregor"
  },
  {
    "State": "TX",
    "City": "Malone"
  },
  {
    "State": "TX",
    "City": "Marlin"
  },
  {
    "State": "TX",
    "City": "Mart"
  },
  {
    "State": "TX",
    "City": "Meridian"
  },
  {
    "State": "TX",
    "City": "Mertens"
  },
  {
    "State": "TX",
    "City": "Mexia"
  },
  {
    "State": "TX",
    "City": "Milford"
  },
  {
    "State": "TX",
    "City": "Morgan"
  },
  {
    "State": "TX",
    "City": "Mount Calm"
  },
  {
    "State": "TX",
    "City": "Penelope"
  },
  {
    "State": "TX",
    "City": "Prairie Hill"
  },
  {
    "State": "TX",
    "City": "Purdon"
  },
  {
    "State": "TX",
    "City": "Reagan"
  },
  {
    "State": "TX",
    "City": "Richland"
  },
  {
    "State": "TX",
    "City": "Riesel"
  },
  {
    "State": "TX",
    "City": "Ross"
  },
  {
    "State": "TX",
    "City": "Satin"
  },
  {
    "State": "TX",
    "City": "Tehuacana"
  },
  {
    "State": "TX",
    "City": "Thornton"
  },
  {
    "State": "TX",
    "City": "Valley Mills"
  },
  {
    "State": "TX",
    "City": "Walnut Springs"
  },
  {
    "State": "TX",
    "City": "West"
  },
  {
    "State": "TX",
    "City": "Whitney"
  },
  {
    "State": "TX",
    "City": "Wortham"
  },
  {
    "State": "TX",
    "City": "Waco"
  },
  {
    "State": "TX",
    "City": "Woodway"
  },
  {
    "State": "TX",
    "City": "Brownwood"
  },
  {
    "State": "TX",
    "City": "Early"
  },
  {
    "State": "TX",
    "City": "Art"
  },
  {
    "State": "TX",
    "City": "Ballinger"
  },
  {
    "State": "TX",
    "City": "Bangs"
  },
  {
    "State": "TX",
    "City": "Bend"
  },
  {
    "State": "TX",
    "City": "Brady"
  },
  {
    "State": "TX",
    "City": "Brookesmith"
  },
  {
    "State": "TX",
    "City": "Burkett"
  },
  {
    "State": "TX",
    "City": "Castell"
  },
  {
    "State": "TX",
    "City": "Cherokee"
  },
  {
    "State": "TX",
    "City": "Coleman"
  },
  {
    "State": "TX",
    "City": "Doole"
  },
  {
    "State": "TX",
    "City": "Eden"
  },
  {
    "State": "TX",
    "City": "Fort Mc Kavett"
  },
  {
    "State": "TX",
    "City": "Fredonia"
  },
  {
    "State": "TX",
    "City": "Goldthwaite"
  },
  {
    "State": "TX",
    "City": "Gouldbusk"
  },
  {
    "State": "TX",
    "City": "Hext"
  },
  {
    "State": "TX",
    "City": "Junction"
  },
  {
    "State": "TX",
    "City": "Lohn"
  },
  {
    "State": "TX",
    "City": "Lometa"
  },
  {
    "State": "TX",
    "City": "London"
  },
  {
    "State": "TX",
    "City": "Lowake"
  },
  {
    "State": "TX",
    "City": "Mason"
  },
  {
    "State": "TX",
    "City": "May"
  },
  {
    "State": "TX",
    "City": "Melvin"
  },
  {
    "State": "TX",
    "City": "Menard"
  },
  {
    "State": "TX",
    "City": "Miles"
  },
  {
    "State": "TX",
    "City": "Millersview"
  },
  {
    "State": "TX",
    "City": "Mullin"
  },
  {
    "State": "TX",
    "City": "Norton"
  },
  {
    "State": "TX",
    "City": "Paint Rock"
  },
  {
    "State": "TX",
    "City": "Pontotoc"
  },
  {
    "State": "TX",
    "City": "Priddy"
  },
  {
    "State": "TX",
    "City": "Richland Springs"
  },
  {
    "State": "TX",
    "City": "Rochelle"
  },
  {
    "State": "TX",
    "City": "Rockwood"
  },
  {
    "State": "TX",
    "City": "Roosevelt"
  },
  {
    "State": "TX",
    "City": "Rowena"
  },
  {
    "State": "TX",
    "City": "San Saba"
  },
  {
    "State": "TX",
    "City": "Santa Anna"
  },
  {
    "State": "TX",
    "City": "Star"
  },
  {
    "State": "TX",
    "City": "Talpa"
  },
  {
    "State": "TX",
    "City": "Telegraph"
  },
  {
    "State": "TX",
    "City": "Valera"
  },
  {
    "State": "TX",
    "City": "Valley Spring"
  },
  {
    "State": "TX",
    "City": "Veribest"
  },
  {
    "State": "TX",
    "City": "Voca"
  },
  {
    "State": "TX",
    "City": "Voss"
  },
  {
    "State": "TX",
    "City": "Zephyr"
  },
  {
    "State": "TX",
    "City": "San Angelo"
  },
  {
    "State": "TX",
    "City": "Goodfellow AFB"
  },
  {
    "State": "TX",
    "City": "Barnhart"
  },
  {
    "State": "TX",
    "City": "Big Lake"
  },
  {
    "State": "TX",
    "City": "Bronte"
  },
  {
    "State": "TX",
    "City": "Carlsbad"
  },
  {
    "State": "TX",
    "City": "Christoval"
  },
  {
    "State": "TX",
    "City": "Eldorado"
  },
  {
    "State": "TX",
    "City": "Eola"
  },
  {
    "State": "TX",
    "City": "Knickerbocker"
  },
  {
    "State": "TX",
    "City": "Mereta"
  },
  {
    "State": "TX",
    "City": "Mertzon"
  },
  {
    "State": "TX",
    "City": "Ozona"
  },
  {
    "State": "TX",
    "City": "Robert Lee"
  },
  {
    "State": "TX",
    "City": "Silver"
  },
  {
    "State": "TX",
    "City": "Sonora"
  },
  {
    "State": "TX",
    "City": "Sterling City"
  },
  {
    "State": "TX",
    "City": "Tennyson"
  },
  {
    "State": "TX",
    "City": "Vancourt"
  },
  {
    "State": "TX",
    "City": "Wall"
  },
  {
    "State": "TX",
    "City": "Water Valley"
  },
  {
    "State": "TX",
    "City": "Houston"
  },
  {
    "State": "TX",
    "City": "Conroe"
  },
  {
    "State": "TX",
    "City": "North Houston"
  },
  {
    "State": "TX",
    "City": "Montgomery"
  },
  {
    "State": "TX",
    "City": "Willis"
  },
  {
    "State": "TX",
    "City": "Huntsville"
  },
  {
    "State": "TX",
    "City": "Kingwood"
  },
  {
    "State": "TX",
    "City": "Ace"
  },
  {
    "State": "TX",
    "City": "Cleveland"
  },
  {
    "State": "TX",
    "City": "Coldspring"
  },
  {
    "State": "TX",
    "City": "Dallardsville"
  },
  {
    "State": "TX",
    "City": "Dobbin"
  },
  {
    "State": "TX",
    "City": "Dodge"
  },
  {
    "State": "TX",
    "City": "Goodrich"
  },
  {
    "State": "TX",
    "City": "Huffman"
  },
  {
    "State": "TX",
    "City": "Hufsmith"
  },
  {
    "State": "TX",
    "City": "Humble"
  },
  {
    "State": "TX",
    "City": "Leggett"
  },
  {
    "State": "TX",
    "City": "Livingston"
  },
  {
    "State": "TX",
    "City": "Magnolia"
  },
  {
    "State": "TX",
    "City": "New Caney"
  },
  {
    "State": "TX",
    "City": "New Waverly"
  },
  {
    "State": "TX",
    "City": "Oakhurst"
  },
  {
    "State": "TX",
    "City": "Onalaska"
  },
  {
    "State": "TX",
    "City": "Pinehurst"
  },
  {
    "State": "TX",
    "City": "Plantersville"
  },
  {
    "State": "TX",
    "City": "Pointblank"
  },
  {
    "State": "TX",
    "City": "Porter"
  },
  {
    "State": "TX",
    "City": "Riverside"
  },
  {
    "State": "TX",
    "City": "Romayor"
  },
  {
    "State": "TX",
    "City": "Rye"
  },
  {
    "State": "TX",
    "City": "Shepherd"
  },
  {
    "State": "TX",
    "City": "Splendora"
  },
  {
    "State": "TX",
    "City": "Spring"
  },
  {
    "State": "TX",
    "City": "Thicket"
  },
  {
    "State": "TX",
    "City": "Tomball"
  },
  {
    "State": "TX",
    "City": "Votaw"
  },
  {
    "State": "TX",
    "City": "Bellaire"
  },
  {
    "State": "TX",
    "City": "Bay City"
  },
  {
    "State": "TX",
    "City": "Richmond"
  },
  {
    "State": "TX",
    "City": "Cypress"
  },
  {
    "State": "TX",
    "City": "Alief"
  },
  {
    "State": "TX",
    "City": "Altair"
  },
  {
    "State": "TX",
    "City": "Barker"
  },
  {
    "State": "TX",
    "City": "Cedar Lane"
  },
  {
    "State": "TX",
    "City": "Beasley"
  },
  {
    "State": "TX",
    "City": "Bellville"
  },
  {
    "State": "TX",
    "City": "Blessing"
  },
  {
    "State": "TX",
    "City": "Boling"
  },
  {
    "State": "TX",
    "City": "Brazoria"
  },
  {
    "State": "TX",
    "City": "Brookshire"
  },
  {
    "State": "TX",
    "City": "Chappell Hill"
  },
  {
    "State": "TX",
    "City": "Collegeport"
  },
  {
    "State": "TX",
    "City": "Damon"
  },
  {
    "State": "TX",
    "City": "Danciger"
  },
  {
    "State": "TX",
    "City": "Danevang"
  },
  {
    "State": "TX",
    "City": "Eagle Lake"
  },
  {
    "State": "TX",
    "City": "East Bernard"
  },
  {
    "State": "TX",
    "City": "Egypt"
  },
  {
    "State": "TX",
    "City": "El Campo"
  },
  {
    "State": "TX",
    "City": "Elmaton"
  },
  {
    "State": "TX",
    "City": "Fulshear"
  },
  {
    "State": "TX",
    "City": "Garwood"
  },
  {
    "State": "TX",
    "City": "Glen Flora"
  },
  {
    "State": "TX",
    "City": "Guy"
  },
  {
    "State": "TX",
    "City": "Hempstead"
  },
  {
    "State": "TX",
    "City": "Prairie View"
  },
  {
    "State": "TX",
    "City": "Hockley"
  },
  {
    "State": "TX",
    "City": "Hungerford"
  },
  {
    "State": "TX",
    "City": "Katy"
  },
  {
    "State": "TX",
    "City": "Kendleton"
  },
  {
    "State": "TX",
    "City": "Kenney"
  },
  {
    "State": "TX",
    "City": "Lane City"
  },
  {
    "State": "TX",
    "City": "Lissie"
  },
  {
    "State": "TX",
    "City": "Louise"
  },
  {
    "State": "TX",
    "City": "Markham"
  },
  {
    "State": "TX",
    "City": "Matagorda"
  },
  {
    "State": "TX",
    "City": "Midfield"
  },
  {
    "State": "TX",
    "City": "Missouri City"
  },
  {
    "State": "TX",
    "City": "Nada"
  },
  {
    "State": "TX",
    "City": "Needville"
  },
  {
    "State": "TX",
    "City": "Old Ocean"
  },
  {
    "State": "TX",
    "City": "Orchard"
  },
  {
    "State": "TX",
    "City": "Palacios"
  },
  {
    "State": "TX",
    "City": "Pattison"
  },
  {
    "State": "TX",
    "City": "Pierce"
  },
  {
    "State": "TX",
    "City": "Pledger"
  },
  {
    "State": "TX",
    "City": "Rock Island"
  },
  {
    "State": "TX",
    "City": "Rosenberg"
  },
  {
    "State": "TX",
    "City": "San Felipe"
  },
  {
    "State": "TX",
    "City": "Sealy"
  },
  {
    "State": "TX",
    "City": "Sheridan"
  },
  {
    "State": "TX",
    "City": "Simonton"
  },
  {
    "State": "TX",
    "City": "Stafford"
  },
  {
    "State": "TX",
    "City": "Sugar Land"
  },
  {
    "State": "TX",
    "City": "Sweeny"
  },
  {
    "State": "TX",
    "City": "Thompsons"
  },
  {
    "State": "TX",
    "City": "Van Vleck"
  },
  {
    "State": "TX",
    "City": "Wadsworth"
  },
  {
    "State": "TX",
    "City": "Waller"
  },
  {
    "State": "TX",
    "City": "Wallis"
  },
  {
    "State": "TX",
    "City": "West Columbia"
  },
  {
    "State": "TX",
    "City": "Wharton"
  },
  {
    "State": "TX",
    "City": "Pasadena"
  },
  {
    "State": "TX",
    "City": "Santa Fe"
  },
  {
    "State": "TX",
    "City": "Alvin"
  },
  {
    "State": "TX",
    "City": "Anahuac"
  },
  {
    "State": "TX",
    "City": "Angleton"
  },
  {
    "State": "TX",
    "City": "Bacliff"
  },
  {
    "State": "TX",
    "City": "Batson"
  },
  {
    "State": "TX",
    "City": "Baytown"
  },
  {
    "State": "TX",
    "City": "Channelview"
  },
  {
    "State": "TX",
    "City": "Clute"
  },
  {
    "State": "TX",
    "City": "Crosby"
  },
  {
    "State": "TX",
    "City": "Daisetta"
  },
  {
    "State": "TX",
    "City": "Danbury"
  },
  {
    "State": "TX",
    "City": "Dayton"
  },
  {
    "State": "TX",
    "City": "Deer Park"
  },
  {
    "State": "TX",
    "City": "Devers"
  },
  {
    "State": "TX",
    "City": "Dickinson"
  },
  {
    "State": "TX",
    "City": "Freeport"
  },
  {
    "State": "TX",
    "City": "Fresno"
  },
  {
    "State": "TX",
    "City": "Friendswood"
  },
  {
    "State": "TX",
    "City": "Galena Park"
  },
  {
    "State": "TX",
    "City": "Galveston"
  },
  {
    "State": "TX",
    "City": "Hankamer"
  },
  {
    "State": "TX",
    "City": "Hardin"
  },
  {
    "State": "TX",
    "City": "Highlands"
  },
  {
    "State": "TX",
    "City": "Hitchcock"
  },
  {
    "State": "TX",
    "City": "Hull"
  },
  {
    "State": "TX",
    "City": "Kemah"
  },
  {
    "State": "TX",
    "City": "Lake Jackson"
  },
  {
    "State": "TX",
    "City": "La Marque"
  },
  {
    "State": "TX",
    "City": "La Porte"
  },
  {
    "State": "TX",
    "City": "League City"
  },
  {
    "State": "TX",
    "City": "Liberty"
  },
  {
    "State": "TX",
    "City": "Liverpool"
  },
  {
    "State": "TX",
    "City": "Manvel"
  },
  {
    "State": "TX",
    "City": "Mont Belvieu"
  },
  {
    "State": "TX",
    "City": "Pearland"
  },
  {
    "State": "TX",
    "City": "Raywood"
  },
  {
    "State": "TX",
    "City": "Rosharon"
  },
  {
    "State": "TX",
    "City": "Saratoga"
  },
  {
    "State": "TX",
    "City": "Seabrook"
  },
  {
    "State": "TX",
    "City": "South Houston"
  },
  {
    "State": "TX",
    "City": "Texas City"
  },
  {
    "State": "TX",
    "City": "Wallisville"
  },
  {
    "State": "TX",
    "City": "Webster"
  },
  {
    "State": "TX",
    "City": "Bridge City"
  },
  {
    "State": "TX",
    "City": "Buna"
  },
  {
    "State": "TX",
    "City": "China"
  },
  {
    "State": "TX",
    "City": "Deweyville"
  },
  {
    "State": "TX",
    "City": "Evadale"
  },
  {
    "State": "TX",
    "City": "Fred"
  },
  {
    "State": "TX",
    "City": "Gilchrist"
  },
  {
    "State": "TX",
    "City": "Groves"
  },
  {
    "State": "TX",
    "City": "Hamshire"
  },
  {
    "State": "TX",
    "City": "High Island"
  },
  {
    "State": "TX",
    "City": "Hillister"
  },
  {
    "State": "TX",
    "City": "Kountze"
  },
  {
    "State": "TX",
    "City": "Mauriceville"
  },
  {
    "State": "TX",
    "City": "Nederland"
  },
  {
    "State": "TX",
    "City": "Nome"
  },
  {
    "State": "TX",
    "City": "Orange"
  },
  {
    "State": "TX",
    "City": "Orangefield"
  },
  {
    "State": "TX",
    "City": "Port Arthur"
  },
  {
    "State": "TX",
    "City": "Port Bolivar"
  },
  {
    "State": "TX",
    "City": "Port Neches"
  },
  {
    "State": "TX",
    "City": "Sabine Pass"
  },
  {
    "State": "TX",
    "City": "Silsbee"
  },
  {
    "State": "TX",
    "City": "Lumberton"
  },
  {
    "State": "TX",
    "City": "Sour Lake"
  },
  {
    "State": "TX",
    "City": "Spurger"
  },
  {
    "State": "TX",
    "City": "Stowell"
  },
  {
    "State": "TX",
    "City": "Vidor"
  },
  {
    "State": "TX",
    "City": "Village Mills"
  },
  {
    "State": "TX",
    "City": "Warren"
  },
  {
    "State": "TX",
    "City": "Winnie"
  },
  {
    "State": "TX",
    "City": "Beaumont"
  },
  {
    "State": "TX",
    "City": "Bryan"
  },
  {
    "State": "TX",
    "City": "Anderson"
  },
  {
    "State": "TX",
    "City": "Bedias"
  },
  {
    "State": "TX",
    "City": "Brenham"
  },
  {
    "State": "TX",
    "City": "Burton"
  },
  {
    "State": "TX",
    "City": "Caldwell"
  },
  {
    "State": "TX",
    "City": "Calvert"
  },
  {
    "State": "TX",
    "City": "Chriesman"
  },
  {
    "State": "TX",
    "City": "College Station"
  },
  {
    "State": "TX",
    "City": "Concord"
  },
  {
    "State": "TX",
    "City": "Deanville"
  },
  {
    "State": "TX",
    "City": "Dime Box"
  },
  {
    "State": "TX",
    "City": "Flynn"
  },
  {
    "State": "TX",
    "City": "Franklin"
  },
  {
    "State": "TX",
    "City": "Gause"
  },
  {
    "State": "TX",
    "City": "Hearne"
  },
  {
    "State": "TX",
    "City": "Iola"
  },
  {
    "State": "TX",
    "City": "Kurten"
  },
  {
    "State": "TX",
    "City": "Lyons"
  },
  {
    "State": "TX",
    "City": "Madisonville"
  },
  {
    "State": "TX",
    "City": "Marquez"
  },
  {
    "State": "TX",
    "City": "Millican"
  },
  {
    "State": "TX",
    "City": "Mumford"
  },
  {
    "State": "TX",
    "City": "Navasota"
  },
  {
    "State": "TX",
    "City": "New Baden"
  },
  {
    "State": "TX",
    "City": "Normangee"
  },
  {
    "State": "TX",
    "City": "North Zulch"
  },
  {
    "State": "TX",
    "City": "Richards"
  },
  {
    "State": "TX",
    "City": "Roans Prairie"
  },
  {
    "State": "TX",
    "City": "Shiro"
  },
  {
    "State": "TX",
    "City": "Snook"
  },
  {
    "State": "TX",
    "City": "Somerville"
  },
  {
    "State": "TX",
    "City": "Washington"
  },
  {
    "State": "TX",
    "City": "Wellborn"
  },
  {
    "State": "TX",
    "City": "Wheelock"
  },
  {
    "State": "TX",
    "City": "Victoria"
  },
  {
    "State": "TX",
    "City": "Austwell"
  },
  {
    "State": "TX",
    "City": "Bloomington"
  },
  {
    "State": "TX",
    "City": "Cuero"
  },
  {
    "State": "TX",
    "City": "Edna"
  },
  {
    "State": "TX",
    "City": "Fannin"
  },
  {
    "State": "TX",
    "City": "Francitas"
  },
  {
    "State": "TX",
    "City": "Ganado"
  },
  {
    "State": "TX",
    "City": "Goliad"
  },
  {
    "State": "TX",
    "City": "Hallettsville"
  },
  {
    "State": "TX",
    "City": "Hochheim"
  },
  {
    "State": "TX",
    "City": "Inez"
  },
  {
    "State": "TX",
    "City": "La Salle"
  },
  {
    "State": "TX",
    "City": "La Ward"
  },
  {
    "State": "TX",
    "City": "Lolita"
  },
  {
    "State": "TX",
    "City": "Mcfaddin"
  },
  {
    "State": "TX",
    "City": "Meyersville"
  },
  {
    "State": "TX",
    "City": "Moulton"
  },
  {
    "State": "TX",
    "City": "Nursery"
  },
  {
    "State": "TX",
    "City": "Placedo"
  },
  {
    "State": "TX",
    "City": "Point Comfort"
  },
  {
    "State": "TX",
    "City": "Port Lavaca"
  },
  {
    "State": "TX",
    "City": "Port O Connor"
  },
  {
    "State": "TX",
    "City": "Seadrift"
  },
  {
    "State": "TX",
    "City": "Shiner"
  },
  {
    "State": "TX",
    "City": "Sublime"
  },
  {
    "State": "TX",
    "City": "Sweet Home"
  },
  {
    "State": "TX",
    "City": "Telferner"
  },
  {
    "State": "TX",
    "City": "Thomaston"
  },
  {
    "State": "TX",
    "City": "Tivoli"
  },
  {
    "State": "TX",
    "City": "Vanderbilt"
  },
  {
    "State": "TX",
    "City": "Weesatche"
  },
  {
    "State": "TX",
    "City": "Westhoff"
  },
  {
    "State": "TX",
    "City": "Yoakum"
  },
  {
    "State": "TX",
    "City": "Artesia Wells"
  },
  {
    "State": "TX",
    "City": "Atascosa"
  },
  {
    "State": "TX",
    "City": "Bandera"
  },
  {
    "State": "TX",
    "City": "Bergheim"
  },
  {
    "State": "TX",
    "City": "Bigfoot"
  },
  {
    "State": "TX",
    "City": "Boerne"
  },
  {
    "State": "TX",
    "City": "Calliham"
  },
  {
    "State": "TX",
    "City": "Campbellton"
  },
  {
    "State": "TX",
    "City": "Castroville"
  },
  {
    "State": "TX",
    "City": "Center Point"
  },
  {
    "State": "TX",
    "City": "Charlotte"
  },
  {
    "State": "TX",
    "City": "Christine"
  },
  {
    "State": "TX",
    "City": "Comfort"
  },
  {
    "State": "TX",
    "City": "Cotulla"
  },
  {
    "State": "TX",
    "City": "Devine"
  },
  {
    "State": "TX",
    "City": "Dilley"
  },
  {
    "State": "TX",
    "City": "Encinal"
  },
  {
    "State": "TX",
    "City": "Fowlerton"
  },
  {
    "State": "TX",
    "City": "George West"
  },
  {
    "State": "TX",
    "City": "Helotes"
  },
  {
    "State": "TX",
    "City": "Hunt"
  },
  {
    "State": "TX",
    "City": "Ingram"
  },
  {
    "State": "TX",
    "City": "Jourdanton"
  },
  {
    "State": "TX",
    "City": "Kendalia"
  },
  {
    "State": "TX",
    "City": "Kerrville"
  },
  {
    "State": "TX",
    "City": "La Coste"
  },
  {
    "State": "TX",
    "City": "Laredo"
  },
  {
    "State": "TX",
    "City": "Leming"
  },
  {
    "State": "TX",
    "City": "Lytle"
  },
  {
    "State": "TX",
    "City": "Macdona"
  },
  {
    "State": "TX",
    "City": "Medina"
  },
  {
    "State": "TX",
    "City": "Mico"
  },
  {
    "State": "TX",
    "City": "Moore"
  },
  {
    "State": "TX",
    "City": "Mountain Home"
  },
  {
    "State": "TX",
    "City": "Natalia"
  },
  {
    "State": "TX",
    "City": "Oakville"
  },
  {
    "State": "TX",
    "City": "Pearsall"
  },
  {
    "State": "TX",
    "City": "Peggy"
  },
  {
    "State": "TX",
    "City": "Pipe Creek"
  },
  {
    "State": "TX",
    "City": "Pleasanton"
  },
  {
    "State": "TX",
    "City": "Poteet"
  },
  {
    "State": "TX",
    "City": "Rio Medina"
  },
  {
    "State": "TX",
    "City": "San Ygnacio"
  },
  {
    "State": "TX",
    "City": "Somerset"
  },
  {
    "State": "TX",
    "City": "Spring Branch"
  },
  {
    "State": "TX",
    "City": "Three Rivers"
  },
  {
    "State": "TX",
    "City": "Tilden"
  },
  {
    "State": "TX",
    "City": "Von Ormy"
  },
  {
    "State": "TX",
    "City": "Waring"
  },
  {
    "State": "TX",
    "City": "Whitsett"
  },
  {
    "State": "TX",
    "City": "Zapata"
  },
  {
    "State": "TX",
    "City": "Adkins"
  },
  {
    "State": "TX",
    "City": "Beeville"
  },
  {
    "State": "TX",
    "City": "Berclair"
  },
  {
    "State": "TX",
    "City": "Cibolo"
  },
  {
    "State": "TX",
    "City": "Converse"
  },
  {
    "State": "TX",
    "City": "Ecleto"
  },
  {
    "State": "TX",
    "City": "Elmendorf"
  },
  {
    "State": "TX",
    "City": "Falls City"
  },
  {
    "State": "TX",
    "City": "Floresville"
  },
  {
    "State": "TX",
    "City": "Geronimo"
  },
  {
    "State": "TX",
    "City": "Gillett"
  },
  {
    "State": "TX",
    "City": "Hobson"
  },
  {
    "State": "TX",
    "City": "Karnes City"
  },
  {
    "State": "TX",
    "City": "Kenedy"
  },
  {
    "State": "TX",
    "City": "La Vernia"
  },
  {
    "State": "TX",
    "City": "Leesville"
  },
  {
    "State": "TX",
    "City": "Mc Queeney"
  },
  {
    "State": "TX",
    "City": "Marion"
  },
  {
    "State": "TX",
    "City": "Mineral"
  },
  {
    "State": "TX",
    "City": "New Braunfels"
  },
  {
    "State": "TX",
    "City": "Canyon Lake"
  },
  {
    "State": "TX",
    "City": "Nixon"
  },
  {
    "State": "TX",
    "City": "Nordheim"
  },
  {
    "State": "TX",
    "City": "Normanna"
  },
  {
    "State": "TX",
    "City": "Pandora"
  },
  {
    "State": "TX",
    "City": "Panna Maria"
  },
  {
    "State": "TX",
    "City": "Pawnee"
  },
  {
    "State": "TX",
    "City": "Pettus"
  },
  {
    "State": "TX",
    "City": "Poth"
  },
  {
    "State": "TX",
    "City": "Universal City"
  },
  {
    "State": "TX",
    "City": "Jbsa Randolph"
  },
  {
    "State": "TX",
    "City": "Runge"
  },
  {
    "State": "TX",
    "City": "Saint Hedwig"
  },
  {
    "State": "TX",
    "City": "Schertz"
  },
  {
    "State": "TX",
    "City": "Seguin"
  },
  {
    "State": "TX",
    "City": "Smiley"
  },
  {
    "State": "TX",
    "City": "Stockdale"
  },
  {
    "State": "TX",
    "City": "Sutherland Springs"
  },
  {
    "State": "TX",
    "City": "Tuleta"
  },
  {
    "State": "TX",
    "City": "Bulverde"
  },
  {
    "State": "TX",
    "City": "Yorktown"
  },
  {
    "State": "TX",
    "City": "San Antonio"
  },
  {
    "State": "TX",
    "City": "Jbsa Ft Sam Houston"
  },
  {
    "State": "TX",
    "City": "Jbsa Lackland"
  },
  {
    "State": "TX",
    "City": "Agua Dulce"
  },
  {
    "State": "TX",
    "City": "Alice"
  },
  {
    "State": "TX",
    "City": "Aransas Pass"
  },
  {
    "State": "TX",
    "City": "Armstrong"
  },
  {
    "State": "TX",
    "City": "Banquete"
  },
  {
    "State": "TX",
    "City": "Bayside"
  },
  {
    "State": "TX",
    "City": "Benavides"
  },
  {
    "State": "TX",
    "City": "Ben Bolt"
  },
  {
    "State": "TX",
    "City": "Bishop"
  },
  {
    "State": "TX",
    "City": "Bruni"
  },
  {
    "State": "TX",
    "City": "Chapman Ranch"
  },
  {
    "State": "TX",
    "City": "Concepcion"
  },
  {
    "State": "TX",
    "City": "Dinero"
  },
  {
    "State": "TX",
    "City": "Driscoll"
  },
  {
    "State": "TX",
    "City": "Edroy"
  },
  {
    "State": "TX",
    "City": "Encino"
  },
  {
    "State": "TX",
    "City": "Falfurrias"
  },
  {
    "State": "TX",
    "City": "Freer"
  },
  {
    "State": "TX",
    "City": "Fulton"
  },
  {
    "State": "TX",
    "City": "Gregory"
  },
  {
    "State": "TX",
    "City": "Guerra"
  },
  {
    "State": "TX",
    "City": "Hebbronville"
  },
  {
    "State": "TX",
    "City": "Ingleside"
  },
  {
    "State": "TX",
    "City": "Kingsville"
  },
  {
    "State": "TX",
    "City": "Mathis"
  },
  {
    "State": "TX",
    "City": "Mirando City"
  },
  {
    "State": "TX",
    "City": "Odem"
  },
  {
    "State": "TX",
    "City": "Oilton"
  },
  {
    "State": "TX",
    "City": "Orange Grove"
  },
  {
    "State": "TX",
    "City": "Port Aransas"
  },
  {
    "State": "TX",
    "City": "Portland"
  },
  {
    "State": "TX",
    "City": "Premont"
  },
  {
    "State": "TX",
    "City": "Realitos"
  },
  {
    "State": "TX",
    "City": "Refugio"
  },
  {
    "State": "TX",
    "City": "Riviera"
  },
  {
    "State": "TX",
    "City": "Robstown"
  },
  {
    "State": "TX",
    "City": "Rockport"
  },
  {
    "State": "TX",
    "City": "Sandia"
  },
  {
    "State": "TX",
    "City": "San Diego"
  },
  {
    "State": "TX",
    "City": "Sarita"
  },
  {
    "State": "TX",
    "City": "Sinton"
  },
  {
    "State": "TX",
    "City": "Skidmore"
  },
  {
    "State": "TX",
    "City": "Taft"
  },
  {
    "State": "TX",
    "City": "Tynan"
  },
  {
    "State": "TX",
    "City": "Woodsboro"
  },
  {
    "State": "TX",
    "City": "Corpus Christi"
  },
  {
    "State": "TX",
    "City": "Mcallen"
  },
  {
    "State": "TX",
    "City": "Alamo"
  },
  {
    "State": "TX",
    "City": "Brownsville"
  },
  {
    "State": "TX",
    "City": "Combes"
  },
  {
    "State": "TX",
    "City": "Delmita"
  },
  {
    "State": "TX",
    "City": "Donna"
  },
  {
    "State": "TX",
    "City": "Edcouch"
  },
  {
    "State": "TX",
    "City": "Edinburg"
  },
  {
    "State": "TX",
    "City": "Elsa"
  },
  {
    "State": "TX",
    "City": "Falcon Heights"
  },
  {
    "State": "TX",
    "City": "Garciasville"
  },
  {
    "State": "TX",
    "City": "Grulla"
  },
  {
    "State": "TX",
    "City": "Hargill"
  },
  {
    "State": "TX",
    "City": "Harlingen"
  },
  {
    "State": "TX",
    "City": "Hidalgo"
  },
  {
    "State": "TX",
    "City": "La Blanca"
  },
  {
    "State": "TX",
    "City": "La Feria"
  },
  {
    "State": "TX",
    "City": "La Joya"
  },
  {
    "State": "TX",
    "City": "Lasara"
  },
  {
    "State": "TX",
    "City": "La Villa"
  },
  {
    "State": "TX",
    "City": "Linn"
  },
  {
    "State": "TX",
    "City": "Lopeno"
  },
  {
    "State": "TX",
    "City": "Los Ebanos"
  },
  {
    "State": "TX",
    "City": "Los Fresnos"
  },
  {
    "State": "TX",
    "City": "Los Indios"
  },
  {
    "State": "TX",
    "City": "Lozano"
  },
  {
    "State": "TX",
    "City": "Lyford"
  },
  {
    "State": "TX",
    "City": "Mercedes"
  },
  {
    "State": "TX",
    "City": "Mission"
  },
  {
    "State": "TX",
    "City": "Olmito"
  },
  {
    "State": "TX",
    "City": "Penitas"
  },
  {
    "State": "TX",
    "City": "Pharr"
  },
  {
    "State": "TX",
    "City": "Port Isabel"
  },
  {
    "State": "TX",
    "City": "Progreso"
  },
  {
    "State": "TX",
    "City": "Raymondville"
  },
  {
    "State": "TX",
    "City": "Rio Grande City"
  },
  {
    "State": "TX",
    "City": "Rio Hondo"
  },
  {
    "State": "TX",
    "City": "Roma"
  },
  {
    "State": "TX",
    "City": "Salineno"
  },
  {
    "State": "TX",
    "City": "San Benito"
  },
  {
    "State": "TX",
    "City": "San Isidro"
  },
  {
    "State": "TX",
    "City": "San Juan"
  },
  {
    "State": "TX",
    "City": "San Perlita"
  },
  {
    "State": "TX",
    "City": "Santa Elena"
  },
  {
    "State": "TX",
    "City": "Santa Maria"
  },
  {
    "State": "TX",
    "City": "Santa Rosa"
  },
  {
    "State": "TX",
    "City": "Sebastian"
  },
  {
    "State": "TX",
    "City": "Sullivan City"
  },
  {
    "State": "TX",
    "City": "Weslaco"
  },
  {
    "State": "TX",
    "City": "South Padre Island"
  },
  {
    "State": "TX",
    "City": "Port Mansfield"
  },
  {
    "State": "TX",
    "City": "Bastrop"
  },
  {
    "State": "TX",
    "City": "Belmont"
  },
  {
    "State": "TX",
    "City": "Bertram"
  },
  {
    "State": "TX",
    "City": "Blanco"
  },
  {
    "State": "TX",
    "City": "Bluffton"
  },
  {
    "State": "TX",
    "City": "Briggs"
  },
  {
    "State": "TX",
    "City": "Buchanan Dam"
  },
  {
    "State": "TX",
    "City": "Buda"
  },
  {
    "State": "TX",
    "City": "Burnet"
  },
  {
    "State": "TX",
    "City": "Cedar Creek"
  },
  {
    "State": "TX",
    "City": "Cedar Park"
  },
  {
    "State": "TX",
    "City": "Cost"
  },
  {
    "State": "TX",
    "City": "Coupland"
  },
  {
    "State": "TX",
    "City": "Dale"
  },
  {
    "State": "TX",
    "City": "Del Valle"
  },
  {
    "State": "TX",
    "City": "Doss"
  },
  {
    "State": "TX",
    "City": "Driftwood"
  },
  {
    "State": "TX",
    "City": "Dripping Springs"
  },
  {
    "State": "TX",
    "City": "Elgin"
  },
  {
    "State": "TX",
    "City": "Fentress"
  },
  {
    "State": "TX",
    "City": "Fischer"
  },
  {
    "State": "TX",
    "City": "Fredericksburg"
  },
  {
    "State": "TX",
    "City": "Georgetown"
  },
  {
    "State": "TX",
    "City": "Gonzales"
  },
  {
    "State": "TX",
    "City": "Harper"
  },
  {
    "State": "TX",
    "City": "Harwood"
  },
  {
    "State": "TX",
    "City": "Hutto"
  },
  {
    "State": "TX",
    "City": "Hye"
  },
  {
    "State": "TX",
    "City": "Johnson City"
  },
  {
    "State": "TX",
    "City": "Kingsbury"
  },
  {
    "State": "TX",
    "City": "Kingsland"
  },
  {
    "State": "TX",
    "City": "Kyle"
  },
  {
    "State": "TX",
    "City": "Leander"
  },
  {
    "State": "TX",
    "City": "Liberty Hill"
  },
  {
    "State": "TX",
    "City": "Llano"
  },
  {
    "State": "TX",
    "City": "Lockhart"
  },
  {
    "State": "TX",
    "City": "Luling"
  },
  {
    "State": "TX",
    "City": "Mc Dade"
  },
  {
    "State": "TX",
    "City": "Mc Neil"
  },
  {
    "State": "TX",
    "City": "Manchaca"
  },
  {
    "State": "TX",
    "City": "Manor"
  },
  {
    "State": "TX",
    "City": "Marble Falls"
  },
  {
    "State": "TX",
    "City": "Martindale"
  },
  {
    "State": "TX",
    "City": "Maxwell"
  },
  {
    "State": "TX",
    "City": "Horseshoe Bay"
  },
  {
    "State": "TX",
    "City": "Ottine"
  },
  {
    "State": "TX",
    "City": "Paige"
  },
  {
    "State": "TX",
    "City": "Pflugerville"
  },
  {
    "State": "TX",
    "City": "Prairie Lea"
  },
  {
    "State": "TX",
    "City": "Red Rock"
  },
  {
    "State": "TX",
    "City": "Round Mountain"
  },
  {
    "State": "TX",
    "City": "Round Rock"
  },
  {
    "State": "TX",
    "City": "San Marcos"
  },
  {
    "State": "TX",
    "City": "Spicewood"
  },
  {
    "State": "TX",
    "City": "Staples"
  },
  {
    "State": "TX",
    "City": "Stonewall"
  },
  {
    "State": "TX",
    "City": "Tow"
  },
  {
    "State": "TX",
    "City": "Walburg"
  },
  {
    "State": "TX",
    "City": "Weir"
  },
  {
    "State": "TX",
    "City": "Willow City"
  },
  {
    "State": "TX",
    "City": "Wimberley"
  },
  {
    "State": "TX",
    "City": "Wrightsboro"
  },
  {
    "State": "TX",
    "City": "Uvalde"
  },
  {
    "State": "TX",
    "City": "Asherton"
  },
  {
    "State": "TX",
    "City": "Barksdale"
  },
  {
    "State": "TX",
    "City": "Batesville"
  },
  {
    "State": "TX",
    "City": "Big Wells"
  },
  {
    "State": "TX",
    "City": "Brackettville"
  },
  {
    "State": "TX",
    "City": "Camp Wood"
  },
  {
    "State": "TX",
    "City": "Carrizo Springs"
  },
  {
    "State": "TX",
    "City": "Catarina"
  },
  {
    "State": "TX",
    "City": "Comstock"
  },
  {
    "State": "TX",
    "City": "Concan"
  },
  {
    "State": "TX",
    "City": "Crystal City"
  },
  {
    "State": "TX",
    "City": "Del Rio"
  },
  {
    "State": "TX",
    "City": "Laughlin AFB"
  },
  {
    "State": "TX",
    "City": "D Hanis"
  },
  {
    "State": "TX",
    "City": "Dryden"
  },
  {
    "State": "TX",
    "City": "Eagle Pass"
  },
  {
    "State": "TX",
    "City": "El Indio"
  },
  {
    "State": "TX",
    "City": "Hondo"
  },
  {
    "State": "TX",
    "City": "Knippa"
  },
  {
    "State": "TX",
    "City": "Langtry"
  },
  {
    "State": "TX",
    "City": "La Pryor"
  },
  {
    "State": "TX",
    "City": "Leakey"
  },
  {
    "State": "TX",
    "City": "Quemado"
  },
  {
    "State": "TX",
    "City": "Rio Frio"
  },
  {
    "State": "TX",
    "City": "Rocksprings"
  },
  {
    "State": "TX",
    "City": "Sabinal"
  },
  {
    "State": "TX",
    "City": "Tarpley"
  },
  {
    "State": "TX",
    "City": "Utopia"
  },
  {
    "State": "TX",
    "City": "Vanderpool"
  },
  {
    "State": "TX",
    "City": "Yancey"
  },
  {
    "State": "TX",
    "City": "Bleiblerville"
  },
  {
    "State": "TX",
    "City": "Carmine"
  },
  {
    "State": "TX",
    "City": "Cat Spring"
  },
  {
    "State": "TX",
    "City": "Columbus"
  },
  {
    "State": "TX",
    "City": "Alleyton"
  },
  {
    "State": "TX",
    "City": "Ellinger"
  },
  {
    "State": "TX",
    "City": "Fayetteville"
  },
  {
    "State": "TX",
    "City": "Flatonia"
  },
  {
    "State": "TX",
    "City": "Giddings"
  },
  {
    "State": "TX",
    "City": "Glidden"
  },
  {
    "State": "TX",
    "City": "Industry"
  },
  {
    "State": "TX",
    "City": "La Grange"
  },
  {
    "State": "TX",
    "City": "Ledbetter"
  },
  {
    "State": "TX",
    "City": "Lexington"
  },
  {
    "State": "TX",
    "City": "Lincoln"
  },
  {
    "State": "TX",
    "City": "Muldoon"
  },
  {
    "State": "TX",
    "City": "New Ulm"
  },
  {
    "State": "TX",
    "City": "Oakland"
  },
  {
    "State": "TX",
    "City": "Plum"
  },
  {
    "State": "TX",
    "City": "Rosanky"
  },
  {
    "State": "TX",
    "City": "Round Top"
  },
  {
    "State": "TX",
    "City": "Schulenburg"
  },
  {
    "State": "TX",
    "City": "Smithville"
  },
  {
    "State": "TX",
    "City": "Waelder"
  },
  {
    "State": "TX",
    "City": "Warda"
  },
  {
    "State": "TX",
    "City": "Warrenton"
  },
  {
    "State": "TX",
    "City": "Weimar"
  },
  {
    "State": "TX",
    "City": "West Point"
  },
  {
    "State": "TX",
    "City": "Adrian"
  },
  {
    "State": "TX",
    "City": "Alanreed"
  },
  {
    "State": "TX",
    "City": "Allison"
  },
  {
    "State": "TX",
    "City": "Booker"
  },
  {
    "State": "TX",
    "City": "Borger"
  },
  {
    "State": "TX",
    "City": "Bovina"
  },
  {
    "State": "TX",
    "City": "Boys Ranch"
  },
  {
    "State": "TX",
    "City": "Briscoe"
  },
  {
    "State": "TX",
    "City": "Bushland"
  },
  {
    "State": "TX",
    "City": "Cactus"
  },
  {
    "State": "TX",
    "City": "Canadian"
  },
  {
    "State": "TX",
    "City": "Canyon"
  },
  {
    "State": "TX",
    "City": "Channing"
  },
  {
    "State": "TX",
    "City": "Claude"
  },
  {
    "State": "TX",
    "City": "Cotton Center"
  },
  {
    "State": "TX",
    "City": "Dalhart"
  },
  {
    "State": "TX",
    "City": "Darrouzett"
  },
  {
    "State": "TX",
    "City": "Dawn"
  },
  {
    "State": "TX",
    "City": "Dimmitt"
  },
  {
    "State": "TX",
    "City": "Dumas"
  },
  {
    "State": "TX",
    "City": "Earth"
  },
  {
    "State": "TX",
    "City": "Edmonson"
  },
  {
    "State": "TX",
    "City": "Farnsworth"
  },
  {
    "State": "TX",
    "City": "Follett"
  },
  {
    "State": "TX",
    "City": "Friona"
  },
  {
    "State": "TX",
    "City": "Fritch"
  },
  {
    "State": "TX",
    "City": "Groom"
  },
  {
    "State": "TX",
    "City": "Gruver"
  },
  {
    "State": "TX",
    "City": "Hale Center"
  },
  {
    "State": "TX",
    "City": "Happy"
  },
  {
    "State": "TX",
    "City": "Hart"
  },
  {
    "State": "TX",
    "City": "Hartley"
  },
  {
    "State": "TX",
    "City": "Hereford"
  },
  {
    "State": "TX",
    "City": "Higgins"
  },
  {
    "State": "TX",
    "City": "Kerrick"
  },
  {
    "State": "TX",
    "City": "Kress"
  },
  {
    "State": "TX",
    "City": "Lazbuddie"
  },
  {
    "State": "TX",
    "City": "Lefors"
  },
  {
    "State": "TX",
    "City": "Lipscomb"
  },
  {
    "State": "TX",
    "City": "Mclean"
  },
  {
    "State": "TX",
    "City": "Masterson"
  },
  {
    "State": "TX",
    "City": "Miami"
  },
  {
    "State": "TX",
    "City": "Mobeetie"
  },
  {
    "State": "TX",
    "City": "Morse"
  },
  {
    "State": "TX",
    "City": "Nazareth"
  },
  {
    "State": "TX",
    "City": "Olton"
  },
  {
    "State": "TX",
    "City": "Pampa"
  },
  {
    "State": "TX",
    "City": "Panhandle"
  },
  {
    "State": "TX",
    "City": "Perryton"
  },
  {
    "State": "TX",
    "City": "Plainview"
  },
  {
    "State": "TX",
    "City": "Samnorwood"
  },
  {
    "State": "TX",
    "City": "Sanford"
  },
  {
    "State": "TX",
    "City": "Shamrock"
  },
  {
    "State": "TX",
    "City": "Skellytown"
  },
  {
    "State": "TX",
    "City": "Spearman"
  },
  {
    "State": "TX",
    "City": "Springlake"
  },
  {
    "State": "TX",
    "City": "Stinnett"
  },
  {
    "State": "TX",
    "City": "Stratford"
  },
  {
    "State": "TX",
    "City": "Summerfield"
  },
  {
    "State": "TX",
    "City": "Sunray"
  },
  {
    "State": "TX",
    "City": "Texline"
  },
  {
    "State": "TX",
    "City": "Tulia"
  },
  {
    "State": "TX",
    "City": "Umbarger"
  },
  {
    "State": "TX",
    "City": "Vega"
  },
  {
    "State": "TX",
    "City": "Waka"
  },
  {
    "State": "TX",
    "City": "Wayside"
  },
  {
    "State": "TX",
    "City": "Wellington"
  },
  {
    "State": "TX",
    "City": "Wheeler"
  },
  {
    "State": "TX",
    "City": "White Deer"
  },
  {
    "State": "TX",
    "City": "Wildorado"
  },
  {
    "State": "TX",
    "City": "Amarillo"
  },
  {
    "State": "TX",
    "City": "Childress"
  },
  {
    "State": "TX",
    "City": "Afton"
  },
  {
    "State": "TX",
    "City": "Aiken"
  },
  {
    "State": "TX",
    "City": "Cee Vee"
  },
  {
    "State": "TX",
    "City": "Chillicothe"
  },
  {
    "State": "TX",
    "City": "Clarendon"
  },
  {
    "State": "TX",
    "City": "Crowell"
  },
  {
    "State": "TX",
    "City": "Dickens"
  },
  {
    "State": "TX",
    "City": "Dodson"
  },
  {
    "State": "TX",
    "City": "Dougherty"
  },
  {
    "State": "TX",
    "City": "Estelline"
  },
  {
    "State": "TX",
    "City": "Flomot"
  },
  {
    "State": "TX",
    "City": "Floydada"
  },
  {
    "State": "TX",
    "City": "Guthrie"
  },
  {
    "State": "TX",
    "City": "Hedley"
  },
  {
    "State": "TX",
    "City": "Lakeview"
  },
  {
    "State": "TX",
    "City": "Lelia Lake"
  },
  {
    "State": "TX",
    "City": "Lockney"
  },
  {
    "State": "TX",
    "City": "Mcadoo"
  },
  {
    "State": "TX",
    "City": "Matador"
  },
  {
    "State": "TX",
    "City": "Memphis"
  },
  {
    "State": "TX",
    "City": "Odell"
  },
  {
    "State": "TX",
    "City": "Paducah"
  },
  {
    "State": "TX",
    "City": "Petersburg"
  },
  {
    "State": "TX",
    "City": "Quail"
  },
  {
    "State": "TX",
    "City": "Quanah"
  },
  {
    "State": "TX",
    "City": "Quitaque"
  },
  {
    "State": "TX",
    "City": "Roaring Springs"
  },
  {
    "State": "TX",
    "City": "Silverton"
  },
  {
    "State": "TX",
    "City": "South Plains"
  },
  {
    "State": "TX",
    "City": "Tell"
  },
  {
    "State": "TX",
    "City": "Turkey"
  },
  {
    "State": "TX",
    "City": "Abernathy"
  },
  {
    "State": "TX",
    "City": "Amherst"
  },
  {
    "State": "TX",
    "City": "Anton"
  },
  {
    "State": "TX",
    "City": "Bledsoe"
  },
  {
    "State": "TX",
    "City": "Brownfield"
  },
  {
    "State": "TX",
    "City": "Bula"
  },
  {
    "State": "TX",
    "City": "Crosbyton"
  },
  {
    "State": "TX",
    "City": "Denver City"
  },
  {
    "State": "TX",
    "City": "Enochs"
  },
  {
    "State": "TX",
    "City": "Farwell"
  },
  {
    "State": "TX",
    "City": "Fieldton"
  },
  {
    "State": "TX",
    "City": "Idalou"
  },
  {
    "State": "TX",
    "City": "Justiceburg"
  },
  {
    "State": "TX",
    "City": "Lamesa"
  },
  {
    "State": "TX",
    "City": "Levelland"
  },
  {
    "State": "TX",
    "City": "Littlefield"
  },
  {
    "State": "TX",
    "City": "Loop"
  },
  {
    "State": "TX",
    "City": "Lorenzo"
  },
  {
    "State": "TX",
    "City": "Maple"
  },
  {
    "State": "TX",
    "City": "Meadow"
  },
  {
    "State": "TX",
    "City": "Morton"
  },
  {
    "State": "TX",
    "City": "Muleshoe"
  },
  {
    "State": "TX",
    "City": "New Deal"
  },
  {
    "State": "TX",
    "City": "Odonnell"
  },
  {
    "State": "TX",
    "City": "Pep"
  },
  {
    "State": "TX",
    "City": "Plains"
  },
  {
    "State": "TX",
    "City": "Post"
  },
  {
    "State": "TX",
    "City": "Ralls"
  },
  {
    "State": "TX",
    "City": "Ropesville"
  },
  {
    "State": "TX",
    "City": "Seagraves"
  },
  {
    "State": "TX",
    "City": "Seminole"
  },
  {
    "State": "TX",
    "City": "Shallowater"
  },
  {
    "State": "TX",
    "City": "Slaton"
  },
  {
    "State": "TX",
    "City": "Ransom Canyon"
  },
  {
    "State": "TX",
    "City": "Smyer"
  },
  {
    "State": "TX",
    "City": "Spade"
  },
  {
    "State": "TX",
    "City": "Spur"
  },
  {
    "State": "TX",
    "City": "Sudan"
  },
  {
    "State": "TX",
    "City": "Sundown"
  },
  {
    "State": "TX",
    "City": "Tahoka"
  },
  {
    "State": "TX",
    "City": "Tokio"
  },
  {
    "State": "TX",
    "City": "Welch"
  },
  {
    "State": "TX",
    "City": "Wellman"
  },
  {
    "State": "TX",
    "City": "Whiteface"
  },
  {
    "State": "TX",
    "City": "Whitharral"
  },
  {
    "State": "TX",
    "City": "Wilson"
  },
  {
    "State": "TX",
    "City": "Wolfforth"
  },
  {
    "State": "TX",
    "City": "New Home"
  },
  {
    "State": "TX",
    "City": "Lubbock"
  },
  {
    "State": "TX",
    "City": "Anson"
  },
  {
    "State": "TX",
    "City": "Aspermont"
  },
  {
    "State": "TX",
    "City": "Avoca"
  },
  {
    "State": "TX",
    "City": "Baird"
  },
  {
    "State": "TX",
    "City": "Benjamin"
  },
  {
    "State": "TX",
    "City": "Blackwell"
  },
  {
    "State": "TX",
    "City": "Buffalo Gap"
  },
  {
    "State": "TX",
    "City": "Clyde"
  },
  {
    "State": "TX",
    "City": "Coahoma"
  },
  {
    "State": "TX",
    "City": "Colorado City"
  },
  {
    "State": "TX",
    "City": "Dunn"
  },
  {
    "State": "TX",
    "City": "Fluvanna"
  },
  {
    "State": "TX",
    "City": "Girard"
  },
  {
    "State": "TX",
    "City": "Goldsboro"
  },
  {
    "State": "TX",
    "City": "Hamlin"
  },
  {
    "State": "TX",
    "City": "Haskell"
  },
  {
    "State": "TX",
    "City": "Hawley"
  },
  {
    "State": "TX",
    "City": "Hermleigh"
  },
  {
    "State": "TX",
    "City": "Ira"
  },
  {
    "State": "TX",
    "City": "Jayton"
  },
  {
    "State": "TX",
    "City": "Knox City"
  },
  {
    "State": "TX",
    "City": "Lawn"
  },
  {
    "State": "TX",
    "City": "Loraine"
  },
  {
    "State": "TX",
    "City": "Lueders"
  },
  {
    "State": "TX",
    "City": "Mc Caulley"
  },
  {
    "State": "TX",
    "City": "Maryneal"
  },
  {
    "State": "TX",
    "City": "Merkel"
  },
  {
    "State": "TX",
    "City": "Nolan"
  },
  {
    "State": "TX",
    "City": "Novice"
  },
  {
    "State": "TX",
    "City": "O Brien"
  },
  {
    "State": "TX",
    "City": "Old Glory"
  },
  {
    "State": "TX",
    "City": "Ovalo"
  },
  {
    "State": "TX",
    "City": "Roby"
  },
  {
    "State": "TX",
    "City": "Rochester"
  },
  {
    "State": "TX",
    "City": "Roscoe"
  },
  {
    "State": "TX",
    "City": "Rotan"
  },
  {
    "State": "TX",
    "City": "Rule"
  },
  {
    "State": "TX",
    "City": "Snyder"
  },
  {
    "State": "TX",
    "City": "Stamford"
  },
  {
    "State": "TX",
    "City": "Sweetwater"
  },
  {
    "State": "TX",
    "City": "Sylvester"
  },
  {
    "State": "TX",
    "City": "Trent"
  },
  {
    "State": "TX",
    "City": "Tuscola"
  },
  {
    "State": "TX",
    "City": "Tye"
  },
  {
    "State": "TX",
    "City": "Westbrook"
  },
  {
    "State": "TX",
    "City": "Wingate"
  },
  {
    "State": "TX",
    "City": "Winters"
  },
  {
    "State": "TX",
    "City": "Abilene"
  },
  {
    "State": "TX",
    "City": "Dyess AFB"
  },
  {
    "State": "TX",
    "City": "Midland"
  },
  {
    "State": "TX",
    "City": "Ackerly"
  },
  {
    "State": "TX",
    "City": "Andrews"
  },
  {
    "State": "TX",
    "City": "Balmorhea"
  },
  {
    "State": "TX",
    "City": "Barstow"
  },
  {
    "State": "TX",
    "City": "Big Spring"
  },
  {
    "State": "TX",
    "City": "Coyanosa"
  },
  {
    "State": "TX",
    "City": "Crane"
  },
  {
    "State": "TX",
    "City": "Forsan"
  },
  {
    "State": "TX",
    "City": "Fort Davis"
  },
  {
    "State": "TX",
    "City": "Fort Stockton"
  },
  {
    "State": "TX",
    "City": "Gail"
  },
  {
    "State": "TX",
    "City": "Garden City"
  },
  {
    "State": "TX",
    "City": "Girvin"
  },
  {
    "State": "TX",
    "City": "Goldsmith"
  },
  {
    "State": "TX",
    "City": "Grandfalls"
  },
  {
    "State": "TX",
    "City": "Imperial"
  },
  {
    "State": "TX",
    "City": "Iraan"
  },
  {
    "State": "TX",
    "City": "Kermit"
  },
  {
    "State": "TX",
    "City": "Knott"
  },
  {
    "State": "TX",
    "City": "Lenorah"
  },
  {
    "State": "TX",
    "City": "Mc Camey"
  },
  {
    "State": "TX",
    "City": "Mentone"
  },
  {
    "State": "TX",
    "City": "Midkiff"
  },
  {
    "State": "TX",
    "City": "Monahans"
  },
  {
    "State": "TX",
    "City": "Gardendale"
  },
  {
    "State": "TX",
    "City": "Notrees"
  },
  {
    "State": "TX",
    "City": "Odessa"
  },
  {
    "State": "TX",
    "City": "Orla"
  },
  {
    "State": "TX",
    "City": "Pecos"
  },
  {
    "State": "TX",
    "City": "Penwell"
  },
  {
    "State": "TX",
    "City": "Pyote"
  },
  {
    "State": "TX",
    "City": "Rankin"
  },
  {
    "State": "TX",
    "City": "Saragosa"
  },
  {
    "State": "TX",
    "City": "Sheffield"
  },
  {
    "State": "TX",
    "City": "Stanton"
  },
  {
    "State": "TX",
    "City": "Tarzan"
  },
  {
    "State": "TX",
    "City": "Toyah"
  },
  {
    "State": "TX",
    "City": "Toyahvale"
  },
  {
    "State": "TX",
    "City": "Wickett"
  },
  {
    "State": "TX",
    "City": "Wink"
  },
  {
    "State": "TX",
    "City": "Anthony"
  },
  {
    "State": "TX",
    "City": "Alpine"
  },
  {
    "State": "TX",
    "City": "Big Bend National Park"
  },
  {
    "State": "TX",
    "City": "Canutillo"
  },
  {
    "State": "TX",
    "City": "Clint"
  },
  {
    "State": "TX",
    "City": "Dell City"
  },
  {
    "State": "TX",
    "City": "Fabens"
  },
  {
    "State": "TX",
    "City": "Fort Hancock"
  },
  {
    "State": "TX",
    "City": "Marathon"
  },
  {
    "State": "TX",
    "City": "Marfa"
  },
  {
    "State": "TX",
    "City": "Presidio"
  },
  {
    "State": "TX",
    "City": "Redford"
  },
  {
    "State": "TX",
    "City": "Salt Flat"
  },
  {
    "State": "TX",
    "City": "Sanderson"
  },
  {
    "State": "TX",
    "City": "San Elizario"
  },
  {
    "State": "TX",
    "City": "Sierra Blanca"
  },
  {
    "State": "TX",
    "City": "Terlingua"
  },
  {
    "State": "TX",
    "City": "Tornillo"
  },
  {
    "State": "TX",
    "City": "Valentine"
  },
  {
    "State": "TX",
    "City": "Van Horn"
  },
  {
    "State": "TX",
    "City": "El Paso"
  },
  {
    "State": "TX",
    "City": "Fort Bliss"
  },
  {
    "State": "CO",
    "City": "Arvada"
  },
  {
    "State": "CO",
    "City": "Aurora"
  },
  {
    "State": "CO",
    "City": "Broomfield"
  },
  {
    "State": "CO",
    "City": "Commerce City"
  },
  {
    "State": "CO",
    "City": "Dupont"
  },
  {
    "State": "CO",
    "City": "Eldorado Springs"
  },
  {
    "State": "CO",
    "City": "Lafayette"
  },
  {
    "State": "CO",
    "City": "Louisville"
  },
  {
    "State": "CO",
    "City": "Westminster"
  },
  {
    "State": "CO",
    "City": "Wheat Ridge"
  },
  {
    "State": "CO",
    "City": "Agate"
  },
  {
    "State": "CO",
    "City": "Bennett"
  },
  {
    "State": "CO",
    "City": "Byers"
  },
  {
    "State": "CO",
    "City": "Castle Rock"
  },
  {
    "State": "CO",
    "City": "Deer Trail"
  },
  {
    "State": "CO",
    "City": "Elbert"
  },
  {
    "State": "CO",
    "City": "Elizabeth"
  },
  {
    "State": "CO",
    "City": "Englewood"
  },
  {
    "State": "CO",
    "City": "Franktown"
  },
  {
    "State": "CO",
    "City": "Kiowa"
  },
  {
    "State": "CO",
    "City": "Larkspur"
  },
  {
    "State": "CO",
    "City": "Littleton"
  },
  {
    "State": "CO",
    "City": "Lone Tree"
  },
  {
    "State": "CO",
    "City": "Louviers"
  },
  {
    "State": "CO",
    "City": "Monument"
  },
  {
    "State": "CO",
    "City": "Palmer Lake"
  },
  {
    "State": "CO",
    "City": "Parker"
  },
  {
    "State": "CO",
    "City": "Sedalia"
  },
  {
    "State": "CO",
    "City": "Strasburg"
  },
  {
    "State": "CO",
    "City": "Watkins"
  },
  {
    "State": "CO",
    "City": "Denver"
  },
  {
    "State": "CO",
    "City": "Thornton"
  },
  {
    "State": "CO",
    "City": "Boulder"
  },
  {
    "State": "CO",
    "City": "Golden"
  },
  {
    "State": "CO",
    "City": "Alma"
  },
  {
    "State": "CO",
    "City": "Bailey"
  },
  {
    "State": "CO",
    "City": "Black Hawk"
  },
  {
    "State": "CO",
    "City": "Bond"
  },
  {
    "State": "CO",
    "City": "Breckenridge"
  },
  {
    "State": "CO",
    "City": "Buffalo Creek"
  },
  {
    "State": "CO",
    "City": "Burns"
  },
  {
    "State": "CO",
    "City": "Central City"
  },
  {
    "State": "CO",
    "City": "Clark"
  },
  {
    "State": "CO",
    "City": "Climax"
  },
  {
    "State": "CO",
    "City": "Coalmont"
  },
  {
    "State": "CO",
    "City": "Como"
  },
  {
    "State": "CO",
    "City": "Conifer"
  },
  {
    "State": "CO",
    "City": "Cowdrey"
  },
  {
    "State": "CO",
    "City": "Dillon"
  },
  {
    "State": "CO",
    "City": "Dumont"
  },
  {
    "State": "CO",
    "City": "Evergreen"
  },
  {
    "State": "CO",
    "City": "Empire"
  },
  {
    "State": "CO",
    "City": "Fairplay"
  },
  {
    "State": "CO",
    "City": "Fraser"
  },
  {
    "State": "CO",
    "City": "Frisco"
  },
  {
    "State": "CO",
    "City": "Georgetown"
  },
  {
    "State": "CO",
    "City": "Granby"
  },
  {
    "State": "CO",
    "City": "Grand Lake"
  },
  {
    "State": "CO",
    "City": "Grant"
  },
  {
    "State": "CO",
    "City": "Hartsel"
  },
  {
    "State": "CO",
    "City": "Hot Sulphur Springs"
  },
  {
    "State": "CO",
    "City": "Idaho Springs"
  },
  {
    "State": "CO",
    "City": "Idledale"
  },
  {
    "State": "CO",
    "City": "Indian Hills"
  },
  {
    "State": "CO",
    "City": "Jamestown"
  },
  {
    "State": "CO",
    "City": "Jefferson"
  },
  {
    "State": "CO",
    "City": "Kittredge"
  },
  {
    "State": "CO",
    "City": "Kremmling"
  },
  {
    "State": "CO",
    "City": "Leadville"
  },
  {
    "State": "CO",
    "City": "Mc Coy"
  },
  {
    "State": "CO",
    "City": "Morrison"
  },
  {
    "State": "CO",
    "City": "Nederland"
  },
  {
    "State": "CO",
    "City": "Oak Creek"
  },
  {
    "State": "CO",
    "City": "Parshall"
  },
  {
    "State": "CO",
    "City": "Phippsburg"
  },
  {
    "State": "CO",
    "City": "Pine"
  },
  {
    "State": "CO",
    "City": "Pinecliffe"
  },
  {
    "State": "CO",
    "City": "Rand"
  },
  {
    "State": "CO",
    "City": "Rollinsville"
  },
  {
    "State": "CO",
    "City": "Shawnee"
  },
  {
    "State": "CO",
    "City": "Silver Plume"
  },
  {
    "State": "CO",
    "City": "Steamboat Springs"
  },
  {
    "State": "CO",
    "City": "Tabernash"
  },
  {
    "State": "CO",
    "City": "Toponas"
  },
  {
    "State": "CO",
    "City": "Walden"
  },
  {
    "State": "CO",
    "City": "Ward"
  },
  {
    "State": "CO",
    "City": "Winter Park"
  },
  {
    "State": "CO",
    "City": "Yampa"
  },
  {
    "State": "CO",
    "City": "Silverthorne"
  },
  {
    "State": "CO",
    "City": "Longmont"
  },
  {
    "State": "CO",
    "City": "Allenspark"
  },
  {
    "State": "CO",
    "City": "Estes Park"
  },
  {
    "State": "CO",
    "City": "Bellvue"
  },
  {
    "State": "CO",
    "City": "Berthoud"
  },
  {
    "State": "CO",
    "City": "Dacono"
  },
  {
    "State": "CO",
    "City": "Drake"
  },
  {
    "State": "CO",
    "City": "Erie"
  },
  {
    "State": "CO",
    "City": "Firestone"
  },
  {
    "State": "CO",
    "City": "Fort Collins"
  },
  {
    "State": "CO",
    "City": "Frederick"
  },
  {
    "State": "CO",
    "City": "Glen Haven"
  },
  {
    "State": "CO",
    "City": "Hygiene"
  },
  {
    "State": "CO",
    "City": "Johnstown"
  },
  {
    "State": "CO",
    "City": "Laporte"
  },
  {
    "State": "CO",
    "City": "Livermore"
  },
  {
    "State": "CO",
    "City": "Loveland"
  },
  {
    "State": "CO",
    "City": "Lyons"
  },
  {
    "State": "CO",
    "City": "Masonville"
  },
  {
    "State": "CO",
    "City": "Mead"
  },
  {
    "State": "CO",
    "City": "Milliken"
  },
  {
    "State": "CO",
    "City": "Niwot"
  },
  {
    "State": "CO",
    "City": "Red Feather Lakes"
  },
  {
    "State": "CO",
    "City": "Severance"
  },
  {
    "State": "CO",
    "City": "Timnath"
  },
  {
    "State": "CO",
    "City": "Wellington"
  },
  {
    "State": "CO",
    "City": "Windsor"
  },
  {
    "State": "CO",
    "City": "Brighton"
  },
  {
    "State": "CO",
    "City": "Ault"
  },
  {
    "State": "CO",
    "City": "Briggsdale"
  },
  {
    "State": "CO",
    "City": "Carr"
  },
  {
    "State": "CO",
    "City": "Eastlake"
  },
  {
    "State": "CO",
    "City": "Eaton"
  },
  {
    "State": "CO",
    "City": "Evans"
  },
  {
    "State": "CO",
    "City": "Fort Lupton"
  },
  {
    "State": "CO",
    "City": "Galeton"
  },
  {
    "State": "CO",
    "City": "Gilcrest"
  },
  {
    "State": "CO",
    "City": "Gill"
  },
  {
    "State": "CO",
    "City": "Greeley"
  },
  {
    "State": "CO",
    "City": "Henderson"
  },
  {
    "State": "CO",
    "City": "Hudson"
  },
  {
    "State": "CO",
    "City": "Keenesburg"
  },
  {
    "State": "CO",
    "City": "Kersey"
  },
  {
    "State": "CO",
    "City": "La Salle"
  },
  {
    "State": "CO",
    "City": "Lucerne"
  },
  {
    "State": "CO",
    "City": "Nunn"
  },
  {
    "State": "CO",
    "City": "Orchard"
  },
  {
    "State": "CO",
    "City": "Pierce"
  },
  {
    "State": "CO",
    "City": "Platteville"
  },
  {
    "State": "CO",
    "City": "Roggen"
  },
  {
    "State": "CO",
    "City": "Weldona"
  },
  {
    "State": "CO",
    "City": "Wiggins"
  },
  {
    "State": "CO",
    "City": "Fort Morgan"
  },
  {
    "State": "CO",
    "City": "Log Lane Village"
  },
  {
    "State": "CO",
    "City": "Akron"
  },
  {
    "State": "CO",
    "City": "Amherst"
  },
  {
    "State": "CO",
    "City": "Atwood"
  },
  {
    "State": "CO",
    "City": "Brush"
  },
  {
    "State": "CO",
    "City": "Crook"
  },
  {
    "State": "CO",
    "City": "Eckley"
  },
  {
    "State": "CO",
    "City": "Fleming"
  },
  {
    "State": "CO",
    "City": "Grover"
  },
  {
    "State": "CO",
    "City": "Haxtun"
  },
  {
    "State": "CO",
    "City": "Hereford"
  },
  {
    "State": "CO",
    "City": "Hillrose"
  },
  {
    "State": "CO",
    "City": "Holyoke"
  },
  {
    "State": "CO",
    "City": "Idalia"
  },
  {
    "State": "CO",
    "City": "Iliff"
  },
  {
    "State": "CO",
    "City": "Julesburg"
  },
  {
    "State": "CO",
    "City": "Lindon"
  },
  {
    "State": "CO",
    "City": "Merino"
  },
  {
    "State": "CO",
    "City": "New Raymer"
  },
  {
    "State": "CO",
    "City": "Otis"
  },
  {
    "State": "CO",
    "City": "Ovid"
  },
  {
    "State": "CO",
    "City": "Padroni"
  },
  {
    "State": "CO",
    "City": "Paoli"
  },
  {
    "State": "CO",
    "City": "Peetz"
  },
  {
    "State": "CO",
    "City": "Sedgwick"
  },
  {
    "State": "CO",
    "City": "Snyder"
  },
  {
    "State": "CO",
    "City": "Sterling"
  },
  {
    "State": "CO",
    "City": "Stoneham"
  },
  {
    "State": "CO",
    "City": "Vernon"
  },
  {
    "State": "CO",
    "City": "Woodrow"
  },
  {
    "State": "CO",
    "City": "Wray"
  },
  {
    "State": "CO",
    "City": "Yuma"
  },
  {
    "State": "CO",
    "City": "Anton"
  },
  {
    "State": "CO",
    "City": "Arapahoe"
  },
  {
    "State": "CO",
    "City": "Arriba"
  },
  {
    "State": "CO",
    "City": "Bethune"
  },
  {
    "State": "CO",
    "City": "Burlington"
  },
  {
    "State": "CO",
    "City": "Calhan"
  },
  {
    "State": "CO",
    "City": "Cascade"
  },
  {
    "State": "CO",
    "City": "Cheyenne Wells"
  },
  {
    "State": "CO",
    "City": "Cope"
  },
  {
    "State": "CO",
    "City": "Cripple Creek"
  },
  {
    "State": "CO",
    "City": "Divide"
  },
  {
    "State": "CO",
    "City": "Flagler"
  },
  {
    "State": "CO",
    "City": "Florissant"
  },
  {
    "State": "CO",
    "City": "Fountain"
  },
  {
    "State": "CO",
    "City": "Genoa"
  },
  {
    "State": "CO",
    "City": "Green Mountain Falls"
  },
  {
    "State": "CO",
    "City": "Guffey"
  },
  {
    "State": "CO",
    "City": "Hugo"
  },
  {
    "State": "CO",
    "City": "Joes"
  },
  {
    "State": "CO",
    "City": "Karval"
  },
  {
    "State": "CO",
    "City": "Kirk"
  },
  {
    "State": "CO",
    "City": "Kit Carson"
  },
  {
    "State": "CO",
    "City": "Limon"
  },
  {
    "State": "CO",
    "City": "Lake George"
  },
  {
    "State": "CO",
    "City": "Manitou Springs"
  },
  {
    "State": "CO",
    "City": "Matheson"
  },
  {
    "State": "CO",
    "City": "Peyton"
  },
  {
    "State": "CO",
    "City": "Ramah"
  },
  {
    "State": "CO",
    "City": "Rush"
  },
  {
    "State": "CO",
    "City": "Seibert"
  },
  {
    "State": "CO",
    "City": "Simla"
  },
  {
    "State": "CO",
    "City": "Stratton"
  },
  {
    "State": "CO",
    "City": "Usaf Academy"
  },
  {
    "State": "CO",
    "City": "Victor"
  },
  {
    "State": "CO",
    "City": "Vona"
  },
  {
    "State": "CO",
    "City": "Wild Horse"
  },
  {
    "State": "CO",
    "City": "Woodland Park"
  },
  {
    "State": "CO",
    "City": "Yoder"
  },
  {
    "State": "CO",
    "City": "Colorado Springs"
  },
  {
    "State": "CO",
    "City": "Pueblo"
  },
  {
    "State": "CO",
    "City": "Colorado City"
  },
  {
    "State": "CO",
    "City": "Aguilar"
  },
  {
    "State": "CO",
    "City": "Arlington"
  },
  {
    "State": "CO",
    "City": "Avondale"
  },
  {
    "State": "CO",
    "City": "Beulah"
  },
  {
    "State": "CO",
    "City": "Boncarbo"
  },
  {
    "State": "CO",
    "City": "Boone"
  },
  {
    "State": "CO",
    "City": "Branson"
  },
  {
    "State": "CO",
    "City": "Campo"
  },
  {
    "State": "CO",
    "City": "Cheraw"
  },
  {
    "State": "CO",
    "City": "Crowley"
  },
  {
    "State": "CO",
    "City": "Ordway"
  },
  {
    "State": "CO",
    "City": "Eads"
  },
  {
    "State": "CO",
    "City": "Fort Lyon"
  },
  {
    "State": "CO",
    "City": "Fowler"
  },
  {
    "State": "CO",
    "City": "Gardner"
  },
  {
    "State": "CO",
    "City": "Granada"
  },
  {
    "State": "CO",
    "City": "Hartman"
  },
  {
    "State": "CO",
    "City": "Hasty"
  },
  {
    "State": "CO",
    "City": "Haswell"
  },
  {
    "State": "CO",
    "City": "Hoehne"
  },
  {
    "State": "CO",
    "City": "Holly"
  },
  {
    "State": "CO",
    "City": "Kim"
  },
  {
    "State": "CO",
    "City": "La Junta"
  },
  {
    "State": "CO",
    "City": "Lamar"
  },
  {
    "State": "CO",
    "City": "Las Animas"
  },
  {
    "State": "CO",
    "City": "La Veta"
  },
  {
    "State": "CO",
    "City": "Mc Clave"
  },
  {
    "State": "CO",
    "City": "Manzanola"
  },
  {
    "State": "CO",
    "City": "Model"
  },
  {
    "State": "CO",
    "City": "Olney Springs"
  },
  {
    "State": "CO",
    "City": "Pritchett"
  },
  {
    "State": "CO",
    "City": "Rocky Ford"
  },
  {
    "State": "CO",
    "City": "Rye"
  },
  {
    "State": "CO",
    "City": "Sheridan Lake"
  },
  {
    "State": "CO",
    "City": "Springfield"
  },
  {
    "State": "CO",
    "City": "Stonington"
  },
  {
    "State": "CO",
    "City": "Sugar City"
  },
  {
    "State": "CO",
    "City": "Swink"
  },
  {
    "State": "CO",
    "City": "Trinchera"
  },
  {
    "State": "CO",
    "City": "Trinidad"
  },
  {
    "State": "CO",
    "City": "Two Buttes"
  },
  {
    "State": "CO",
    "City": "Vilas"
  },
  {
    "State": "CO",
    "City": "Walsenburg"
  },
  {
    "State": "CO",
    "City": "Walsh"
  },
  {
    "State": "CO",
    "City": "Weston"
  },
  {
    "State": "CO",
    "City": "Wiley"
  },
  {
    "State": "CO",
    "City": "Alamosa"
  },
  {
    "State": "CO",
    "City": "Antonito"
  },
  {
    "State": "CO",
    "City": "Arboles"
  },
  {
    "State": "CO",
    "City": "Bayfield"
  },
  {
    "State": "CO",
    "City": "Blanca"
  },
  {
    "State": "CO",
    "City": "Capulin"
  },
  {
    "State": "CO",
    "City": "Center"
  },
  {
    "State": "CO",
    "City": "Chama"
  },
  {
    "State": "CO",
    "City": "Chimney Rock"
  },
  {
    "State": "CO",
    "City": "Chromo"
  },
  {
    "State": "CO",
    "City": "Conejos"
  },
  {
    "State": "CO",
    "City": "Creede"
  },
  {
    "State": "CO",
    "City": "Crestone"
  },
  {
    "State": "CO",
    "City": "Del Norte"
  },
  {
    "State": "CO",
    "City": "Fort Garland"
  },
  {
    "State": "CO",
    "City": "San Luis"
  },
  {
    "State": "CO",
    "City": "Homelake"
  },
  {
    "State": "CO",
    "City": "Hooper"
  },
  {
    "State": "CO",
    "City": "Ignacio"
  },
  {
    "State": "CO",
    "City": "Jaroso"
  },
  {
    "State": "CO",
    "City": "La Jara"
  },
  {
    "State": "CO",
    "City": "Manassa"
  },
  {
    "State": "CO",
    "City": "Moffat"
  },
  {
    "State": "CO",
    "City": "Monte Vista"
  },
  {
    "State": "CO",
    "City": "Mosca"
  },
  {
    "State": "CO",
    "City": "Pagosa Springs"
  },
  {
    "State": "CO",
    "City": "Romeo"
  },
  {
    "State": "CO",
    "City": "Saguache"
  },
  {
    "State": "CO",
    "City": "Sanford"
  },
  {
    "State": "CO",
    "City": "San Pablo"
  },
  {
    "State": "CO",
    "City": "South Fork"
  },
  {
    "State": "CO",
    "City": "Villa Grove"
  },
  {
    "State": "CO",
    "City": "Salida"
  },
  {
    "State": "CO",
    "City": "Almont"
  },
  {
    "State": "CO",
    "City": "Buena Vista"
  },
  {
    "State": "CO",
    "City": "Canon City"
  },
  {
    "State": "CO",
    "City": "Cimarron"
  },
  {
    "State": "CO",
    "City": "Coal Creek"
  },
  {
    "State": "CO",
    "City": "Coaldale"
  },
  {
    "State": "CO",
    "City": "Cotopaxi"
  },
  {
    "State": "CO",
    "City": "Crested Butte"
  },
  {
    "State": "CO",
    "City": "Florence"
  },
  {
    "State": "CO",
    "City": "Monarch"
  },
  {
    "State": "CO",
    "City": "Granite"
  },
  {
    "State": "CO",
    "City": "Gunnison"
  },
  {
    "State": "CO",
    "City": "Hillside"
  },
  {
    "State": "CO",
    "City": "Howard"
  },
  {
    "State": "CO",
    "City": "Lake City"
  },
  {
    "State": "CO",
    "City": "Nathrop"
  },
  {
    "State": "CO",
    "City": "Ohio City"
  },
  {
    "State": "CO",
    "City": "Parlin"
  },
  {
    "State": "CO",
    "City": "Penrose"
  },
  {
    "State": "CO",
    "City": "Pitkin"
  },
  {
    "State": "CO",
    "City": "Poncha Springs"
  },
  {
    "State": "CO",
    "City": "Powderhorn"
  },
  {
    "State": "CO",
    "City": "Rockvale"
  },
  {
    "State": "CO",
    "City": "Sargents"
  },
  {
    "State": "CO",
    "City": "Twin Lakes"
  },
  {
    "State": "CO",
    "City": "Westcliffe"
  },
  {
    "State": "CO",
    "City": "Wetmore"
  },
  {
    "State": "CO",
    "City": "Durango"
  },
  {
    "State": "CO",
    "City": "Cahone"
  },
  {
    "State": "CO",
    "City": "Cortez"
  },
  {
    "State": "CO",
    "City": "Dolores"
  },
  {
    "State": "CO",
    "City": "Dove Creek"
  },
  {
    "State": "CO",
    "City": "Egnar"
  },
  {
    "State": "CO",
    "City": "Hesperus"
  },
  {
    "State": "CO",
    "City": "Lewis"
  },
  {
    "State": "CO",
    "City": "Mancos"
  },
  {
    "State": "CO",
    "City": "Marvel"
  },
  {
    "State": "CO",
    "City": "Mesa Verde National Park"
  },
  {
    "State": "CO",
    "City": "Pleasant View"
  },
  {
    "State": "CO",
    "City": "Rico"
  },
  {
    "State": "CO",
    "City": "Towaoc"
  },
  {
    "State": "CO",
    "City": "Yellow Jacket"
  },
  {
    "State": "CO",
    "City": "Montrose"
  },
  {
    "State": "CO",
    "City": "Austin"
  },
  {
    "State": "CO",
    "City": "Bedrock"
  },
  {
    "State": "CO",
    "City": "Cedaredge"
  },
  {
    "State": "CO",
    "City": "Cory"
  },
  {
    "State": "CO",
    "City": "Crawford"
  },
  {
    "State": "CO",
    "City": "Delta"
  },
  {
    "State": "CO",
    "City": "Eckert"
  },
  {
    "State": "CO",
    "City": "Hotchkiss"
  },
  {
    "State": "CO",
    "City": "Lazear"
  },
  {
    "State": "CO",
    "City": "Naturita"
  },
  {
    "State": "CO",
    "City": "Norwood"
  },
  {
    "State": "CO",
    "City": "Nucla"
  },
  {
    "State": "CO",
    "City": "Olathe"
  },
  {
    "State": "CO",
    "City": "Ophir"
  },
  {
    "State": "CO",
    "City": "Ouray"
  },
  {
    "State": "CO",
    "City": "Paonia"
  },
  {
    "State": "CO",
    "City": "Paradox"
  },
  {
    "State": "CO",
    "City": "Placerville"
  },
  {
    "State": "CO",
    "City": "Redvale"
  },
  {
    "State": "CO",
    "City": "Ridgway"
  },
  {
    "State": "CO",
    "City": "Silverton"
  },
  {
    "State": "CO",
    "City": "Somerset"
  },
  {
    "State": "CO",
    "City": "Telluride"
  },
  {
    "State": "CO",
    "City": "Grand Junction"
  },
  {
    "State": "CO",
    "City": "Clifton"
  },
  {
    "State": "CO",
    "City": "Fruita"
  },
  {
    "State": "CO",
    "City": "Gateway"
  },
  {
    "State": "CO",
    "City": "Glade Park"
  },
  {
    "State": "CO",
    "City": "Loma"
  },
  {
    "State": "CO",
    "City": "Mack"
  },
  {
    "State": "CO",
    "City": "Palisade"
  },
  {
    "State": "CO",
    "City": "Whitewater"
  },
  {
    "State": "CO",
    "City": "Glenwood Springs"
  },
  {
    "State": "CO",
    "City": "Dinosaur"
  },
  {
    "State": "CO",
    "City": "Aspen"
  },
  {
    "State": "CO",
    "City": "Snowmass Village"
  },
  {
    "State": "CO",
    "City": "Avon"
  },
  {
    "State": "CO",
    "City": "Basalt"
  },
  {
    "State": "CO",
    "City": "Carbondale"
  },
  {
    "State": "CO",
    "City": "Collbran"
  },
  {
    "State": "CO",
    "City": "Craig"
  },
  {
    "State": "CO",
    "City": "De Beque"
  },
  {
    "State": "CO",
    "City": "Eagle"
  },
  {
    "State": "CO",
    "City": "Edwards"
  },
  {
    "State": "CO",
    "City": "Parachute"
  },
  {
    "State": "CO",
    "City": "Battlement Mesa"
  },
  {
    "State": "CO",
    "City": "Gypsum"
  },
  {
    "State": "CO",
    "City": "Hamilton"
  },
  {
    "State": "CO",
    "City": "Hayden"
  },
  {
    "State": "CO",
    "City": "Maybell"
  },
  {
    "State": "CO",
    "City": "Meeker"
  },
  {
    "State": "CO",
    "City": "Meredith"
  },
  {
    "State": "CO",
    "City": "Mesa"
  },
  {
    "State": "CO",
    "City": "Minturn"
  },
  {
    "State": "CO",
    "City": "Molina"
  },
  {
    "State": "CO",
    "City": "New Castle"
  },
  {
    "State": "CO",
    "City": "Rangely"
  },
  {
    "State": "CO",
    "City": "Red Cliff"
  },
  {
    "State": "CO",
    "City": "Rifle"
  },
  {
    "State": "CO",
    "City": "Silt"
  },
  {
    "State": "CO",
    "City": "Slater"
  },
  {
    "State": "CO",
    "City": "Snowmass"
  },
  {
    "State": "CO",
    "City": "Wolcott"
  },
  {
    "State": "CO",
    "City": "Woody Creek"
  },
  {
    "State": "CO",
    "City": "Vail"
  },
  {
    "State": "WY",
    "City": "Cheyenne"
  },
  {
    "State": "WY",
    "City": "Fe Warren AFB"
  },
  {
    "State": "WY",
    "City": "Albin"
  },
  {
    "State": "WY",
    "City": "Bosler"
  },
  {
    "State": "WY",
    "City": "Buford"
  },
  {
    "State": "WY",
    "City": "Burns"
  },
  {
    "State": "WY",
    "City": "Carpenter"
  },
  {
    "State": "WY",
    "City": "Centennial"
  },
  {
    "State": "WY",
    "City": "Garrett"
  },
  {
    "State": "WY",
    "City": "Granite Canon"
  },
  {
    "State": "WY",
    "City": "Hillsdale"
  },
  {
    "State": "WY",
    "City": "Horse Creek"
  },
  {
    "State": "WY",
    "City": "Jelm"
  },
  {
    "State": "WY",
    "City": "Laramie"
  },
  {
    "State": "WY",
    "City": "Meriden"
  },
  {
    "State": "WY",
    "City": "Pine Bluffs"
  },
  {
    "State": "WY",
    "City": "Rock River"
  },
  {
    "State": "WY",
    "City": "Tie Siding"
  },
  {
    "State": "WY",
    "City": "Yellowstone National Park"
  },
  {
    "State": "WY",
    "City": "Wheatland"
  },
  {
    "State": "WY",
    "City": "Chugwater"
  },
  {
    "State": "WY",
    "City": "Fort Laramie"
  },
  {
    "State": "WY",
    "City": "Glendo"
  },
  {
    "State": "WY",
    "City": "Guernsey"
  },
  {
    "State": "WY",
    "City": "Hartville"
  },
  {
    "State": "WY",
    "City": "Hawk Springs"
  },
  {
    "State": "WY",
    "City": "Huntley"
  },
  {
    "State": "WY",
    "City": "Jay Em"
  },
  {
    "State": "WY",
    "City": "Lagrange"
  },
  {
    "State": "WY",
    "City": "Lance Creek"
  },
  {
    "State": "WY",
    "City": "Lingle"
  },
  {
    "State": "WY",
    "City": "Lost Springs"
  },
  {
    "State": "WY",
    "City": "Lusk"
  },
  {
    "State": "WY",
    "City": "Manville"
  },
  {
    "State": "WY",
    "City": "Shawnee"
  },
  {
    "State": "WY",
    "City": "Torrington"
  },
  {
    "State": "WY",
    "City": "Van Tassell"
  },
  {
    "State": "WY",
    "City": "Veteran"
  },
  {
    "State": "WY",
    "City": "Yoder"
  },
  {
    "State": "WY",
    "City": "Rawlins"
  },
  {
    "State": "WY",
    "City": "Jeffrey City"
  },
  {
    "State": "WY",
    "City": "Baggs"
  },
  {
    "State": "WY",
    "City": "Bairoil"
  },
  {
    "State": "WY",
    "City": "Dixon"
  },
  {
    "State": "WY",
    "City": "Elk Mountain"
  },
  {
    "State": "WY",
    "City": "Encampment"
  },
  {
    "State": "WY",
    "City": "Hanna"
  },
  {
    "State": "WY",
    "City": "Medicine Bow"
  },
  {
    "State": "WY",
    "City": "Saratoga"
  },
  {
    "State": "WY",
    "City": "Savery"
  },
  {
    "State": "WY",
    "City": "Sinclair"
  },
  {
    "State": "WY",
    "City": "Walcott"
  },
  {
    "State": "WY",
    "City": "Wamsutter"
  },
  {
    "State": "WY",
    "City": "Worland"
  },
  {
    "State": "WY",
    "City": "Basin"
  },
  {
    "State": "WY",
    "City": "Burlington"
  },
  {
    "State": "WY",
    "City": "Byron"
  },
  {
    "State": "WY",
    "City": "Cody"
  },
  {
    "State": "WY",
    "City": "Cowley"
  },
  {
    "State": "WY",
    "City": "Deaver"
  },
  {
    "State": "WY",
    "City": "Emblem"
  },
  {
    "State": "WY",
    "City": "Frannie"
  },
  {
    "State": "WY",
    "City": "Greybull"
  },
  {
    "State": "WY",
    "City": "Hyattville"
  },
  {
    "State": "WY",
    "City": "Kirby"
  },
  {
    "State": "WY",
    "City": "Lovell"
  },
  {
    "State": "WY",
    "City": "Manderson"
  },
  {
    "State": "WY",
    "City": "Meeteetse"
  },
  {
    "State": "WY",
    "City": "Otto"
  },
  {
    "State": "WY",
    "City": "Powell"
  },
  {
    "State": "WY",
    "City": "Ralston"
  },
  {
    "State": "WY",
    "City": "Shell"
  },
  {
    "State": "WY",
    "City": "Ten Sleep"
  },
  {
    "State": "WY",
    "City": "Thermopolis"
  },
  {
    "State": "WY",
    "City": "Wapiti"
  },
  {
    "State": "WY",
    "City": "Riverton"
  },
  {
    "State": "WY",
    "City": "Arapahoe"
  },
  {
    "State": "WY",
    "City": "Crowheart"
  },
  {
    "State": "WY",
    "City": "Dubois"
  },
  {
    "State": "WY",
    "City": "Fort Washakie"
  },
  {
    "State": "WY",
    "City": "Hudson"
  },
  {
    "State": "WY",
    "City": "Kinnear"
  },
  {
    "State": "WY",
    "City": "Lander"
  },
  {
    "State": "WY",
    "City": "Pavillion"
  },
  {
    "State": "WY",
    "City": "Saint Stephens"
  },
  {
    "State": "WY",
    "City": "Casper"
  },
  {
    "State": "WY",
    "City": "Shirley Basin"
  },
  {
    "State": "WY",
    "City": "Alcova"
  },
  {
    "State": "WY",
    "City": "Arminto"
  },
  {
    "State": "WY",
    "City": "Douglas"
  },
  {
    "State": "WY",
    "City": "Edgerton"
  },
  {
    "State": "WY",
    "City": "Evansville"
  },
  {
    "State": "WY",
    "City": "Glenrock"
  },
  {
    "State": "WY",
    "City": "Hiland"
  },
  {
    "State": "WY",
    "City": "Kaycee"
  },
  {
    "State": "WY",
    "City": "Linch"
  },
  {
    "State": "WY",
    "City": "Lysite"
  },
  {
    "State": "WY",
    "City": "Midwest"
  },
  {
    "State": "WY",
    "City": "Mills"
  },
  {
    "State": "WY",
    "City": "Natrona"
  },
  {
    "State": "WY",
    "City": "Powder River"
  },
  {
    "State": "WY",
    "City": "Shoshoni"
  },
  {
    "State": "WY",
    "City": "Newcastle"
  },
  {
    "State": "WY",
    "City": "Aladdin"
  },
  {
    "State": "WY",
    "City": "Alva"
  },
  {
    "State": "WY",
    "City": "Beulah"
  },
  {
    "State": "WY",
    "City": "Devils Tower"
  },
  {
    "State": "WY",
    "City": "Four Corners"
  },
  {
    "State": "WY",
    "City": "Gillette"
  },
  {
    "State": "WY",
    "City": "Hulett"
  },
  {
    "State": "WY",
    "City": "Moorcroft"
  },
  {
    "State": "WY",
    "City": "Osage"
  },
  {
    "State": "WY",
    "City": "Recluse"
  },
  {
    "State": "WY",
    "City": "Rozet"
  },
  {
    "State": "WY",
    "City": "Sundance"
  },
  {
    "State": "WY",
    "City": "Upton"
  },
  {
    "State": "WY",
    "City": "Weston"
  },
  {
    "State": "WY",
    "City": "Wright"
  },
  {
    "State": "WY",
    "City": "Sheridan"
  },
  {
    "State": "WY",
    "City": "Arvada"
  },
  {
    "State": "WY",
    "City": "Banner"
  },
  {
    "State": "WY",
    "City": "Big Horn"
  },
  {
    "State": "WY",
    "City": "Buffalo"
  },
  {
    "State": "WY",
    "City": "Clearmont"
  },
  {
    "State": "WY",
    "City": "Dayton"
  },
  {
    "State": "WY",
    "City": "Leiter"
  },
  {
    "State": "WY",
    "City": "Parkman"
  },
  {
    "State": "WY",
    "City": "Ranchester"
  },
  {
    "State": "WY",
    "City": "Saddlestring"
  },
  {
    "State": "WY",
    "City": "Story"
  },
  {
    "State": "WY",
    "City": "Wolf"
  },
  {
    "State": "WY",
    "City": "Wyarno"
  },
  {
    "State": "WY",
    "City": "Rock Springs"
  },
  {
    "State": "WY",
    "City": "Bondurant"
  },
  {
    "State": "WY",
    "City": "Boulder"
  },
  {
    "State": "WY",
    "City": "Cora"
  },
  {
    "State": "WY",
    "City": "Little America"
  },
  {
    "State": "WY",
    "City": "Evanston"
  },
  {
    "State": "WY",
    "City": "Farson"
  },
  {
    "State": "WY",
    "City": "Fort Bridger"
  },
  {
    "State": "WY",
    "City": "Granger"
  },
  {
    "State": "WY",
    "City": "Green River"
  },
  {
    "State": "WY",
    "City": "Lonetree"
  },
  {
    "State": "WY",
    "City": "Lyman"
  },
  {
    "State": "WY",
    "City": "Mc Kinnon"
  },
  {
    "State": "WY",
    "City": "Mountain View"
  },
  {
    "State": "WY",
    "City": "Pinedale"
  },
  {
    "State": "WY",
    "City": "Point Of Rocks"
  },
  {
    "State": "WY",
    "City": "Reliance"
  },
  {
    "State": "WY",
    "City": "Robertson"
  },
  {
    "State": "WY",
    "City": "Superior"
  },
  {
    "State": "WY",
    "City": "Jackson"
  },
  {
    "State": "WY",
    "City": "Kelly"
  },
  {
    "State": "WY",
    "City": "Moose"
  },
  {
    "State": "WY",
    "City": "Moran"
  },
  {
    "State": "WY",
    "City": "Wilson"
  },
  {
    "State": "WY",
    "City": "Teton Village"
  },
  {
    "State": "WY",
    "City": "Kemmerer"
  },
  {
    "State": "WY",
    "City": "Afton"
  },
  {
    "State": "WY",
    "City": "Auburn"
  },
  {
    "State": "WY",
    "City": "Bedford"
  },
  {
    "State": "WY",
    "City": "Big Piney"
  },
  {
    "State": "WY",
    "City": "Cokeville"
  },
  {
    "State": "WY",
    "City": "Daniel"
  },
  {
    "State": "WY",
    "City": "Diamondville"
  },
  {
    "State": "WY",
    "City": "Etna"
  },
  {
    "State": "WY",
    "City": "Fairview"
  },
  {
    "State": "WY",
    "City": "Freedom"
  },
  {
    "State": "WY",
    "City": "Frontier"
  },
  {
    "State": "WY",
    "City": "Grover"
  },
  {
    "State": "WY",
    "City": "La Barge"
  },
  {
    "State": "WY",
    "City": "Opal"
  },
  {
    "State": "WY",
    "City": "Smoot"
  },
  {
    "State": "WY",
    "City": "Thayne"
  },
  {
    "State": "WY",
    "City": "Alpine"
  },
  {
    "State": "ID",
    "City": "Pocatello"
  },
  {
    "State": "ID",
    "City": "Fort Hall"
  },
  {
    "State": "ID",
    "City": "Aberdeen"
  },
  {
    "State": "ID",
    "City": "American Falls"
  },
  {
    "State": "ID",
    "City": "Arbon"
  },
  {
    "State": "ID",
    "City": "Arco"
  },
  {
    "State": "ID",
    "City": "Arimo"
  },
  {
    "State": "ID",
    "City": "Atomic City"
  },
  {
    "State": "ID",
    "City": "Bancroft"
  },
  {
    "State": "ID",
    "City": "Basalt"
  },
  {
    "State": "ID",
    "City": "Bern"
  },
  {
    "State": "ID",
    "City": "Blackfoot"
  },
  {
    "State": "ID",
    "City": "Bloomington"
  },
  {
    "State": "ID",
    "City": "Challis"
  },
  {
    "State": "ID",
    "City": "Clayton"
  },
  {
    "State": "ID",
    "City": "Clifton"
  },
  {
    "State": "ID",
    "City": "Cobalt"
  },
  {
    "State": "ID",
    "City": "Conda"
  },
  {
    "State": "ID",
    "City": "Dayton"
  },
  {
    "State": "ID",
    "City": "Dingle"
  },
  {
    "State": "ID",
    "City": "Downey"
  },
  {
    "State": "ID",
    "City": "Ellis"
  },
  {
    "State": "ID",
    "City": "Firth"
  },
  {
    "State": "ID",
    "City": "Franklin"
  },
  {
    "State": "ID",
    "City": "Geneva"
  },
  {
    "State": "ID",
    "City": "Georgetown"
  },
  {
    "State": "ID",
    "City": "Grace"
  },
  {
    "State": "ID",
    "City": "Holbrook"
  },
  {
    "State": "ID",
    "City": "Howe"
  },
  {
    "State": "ID",
    "City": "Inkom"
  },
  {
    "State": "ID",
    "City": "Lava Hot Springs"
  },
  {
    "State": "ID",
    "City": "Mccammon"
  },
  {
    "State": "ID",
    "City": "Mackay"
  },
  {
    "State": "ID",
    "City": "Malad City"
  },
  {
    "State": "ID",
    "City": "May"
  },
  {
    "State": "ID",
    "City": "Montpelier"
  },
  {
    "State": "ID",
    "City": "Moore"
  },
  {
    "State": "ID",
    "City": "Moreland"
  },
  {
    "State": "ID",
    "City": "Paris"
  },
  {
    "State": "ID",
    "City": "Pingree"
  },
  {
    "State": "ID",
    "City": "Preston"
  },
  {
    "State": "ID",
    "City": "Rockland"
  },
  {
    "State": "ID",
    "City": "Saint Charles"
  },
  {
    "State": "ID",
    "City": "Shelley"
  },
  {
    "State": "ID",
    "City": "Soda Springs"
  },
  {
    "State": "ID",
    "City": "Springfield"
  },
  {
    "State": "ID",
    "City": "Stanley"
  },
  {
    "State": "ID",
    "City": "Swanlake"
  },
  {
    "State": "ID",
    "City": "Thatcher"
  },
  {
    "State": "ID",
    "City": "Wayan"
  },
  {
    "State": "ID",
    "City": "Weston"
  },
  {
    "State": "ID",
    "City": "Fish Haven"
  },
  {
    "State": "ID",
    "City": "Twin Falls"
  },
  {
    "State": "ID",
    "City": "Rogerson"
  },
  {
    "State": "ID",
    "City": "Albion"
  },
  {
    "State": "ID",
    "City": "Almo"
  },
  {
    "State": "ID",
    "City": "Bellevue"
  },
  {
    "State": "ID",
    "City": "Bliss"
  },
  {
    "State": "ID",
    "City": "Buhl"
  },
  {
    "State": "ID",
    "City": "Burley"
  },
  {
    "State": "ID",
    "City": "Carey"
  },
  {
    "State": "ID",
    "City": "Castleford"
  },
  {
    "State": "ID",
    "City": "Corral"
  },
  {
    "State": "ID",
    "City": "Declo"
  },
  {
    "State": "ID",
    "City": "Dietrich"
  },
  {
    "State": "ID",
    "City": "Eden"
  },
  {
    "State": "ID",
    "City": "Fairfield"
  },
  {
    "State": "ID",
    "City": "Filer"
  },
  {
    "State": "ID",
    "City": "Gooding"
  },
  {
    "State": "ID",
    "City": "Hagerman"
  },
  {
    "State": "ID",
    "City": "Hailey"
  },
  {
    "State": "ID",
    "City": "Hansen"
  },
  {
    "State": "ID",
    "City": "Hazelton"
  },
  {
    "State": "ID",
    "City": "Heyburn"
  },
  {
    "State": "ID",
    "City": "Hill City"
  },
  {
    "State": "ID",
    "City": "Jerome"
  },
  {
    "State": "ID",
    "City": "Ketchum"
  },
  {
    "State": "ID",
    "City": "Kimberly"
  },
  {
    "State": "ID",
    "City": "Malta"
  },
  {
    "State": "ID",
    "City": "Minidoka"
  },
  {
    "State": "ID",
    "City": "Murtaugh"
  },
  {
    "State": "ID",
    "City": "Oakley"
  },
  {
    "State": "ID",
    "City": "Paul"
  },
  {
    "State": "ID",
    "City": "Picabo"
  },
  {
    "State": "ID",
    "City": "Richfield"
  },
  {
    "State": "ID",
    "City": "Rupert"
  },
  {
    "State": "ID",
    "City": "Shoshone"
  },
  {
    "State": "ID",
    "City": "Sun Valley"
  },
  {
    "State": "ID",
    "City": "Wendell"
  },
  {
    "State": "ID",
    "City": "Idaho Falls"
  },
  {
    "State": "WY",
    "City": "Alta"
  },
  {
    "State": "ID",
    "City": "Ashton"
  },
  {
    "State": "ID",
    "City": "Chester"
  },
  {
    "State": "ID",
    "City": "Driggs"
  },
  {
    "State": "ID",
    "City": "Dubois"
  },
  {
    "State": "ID",
    "City": "Felt"
  },
  {
    "State": "ID",
    "City": "Hamer"
  },
  {
    "State": "ID",
    "City": "Iona"
  },
  {
    "State": "ID",
    "City": "Irwin"
  },
  {
    "State": "ID",
    "City": "Island Park"
  },
  {
    "State": "ID",
    "City": "Lewisville"
  },
  {
    "State": "ID",
    "City": "Macks Inn"
  },
  {
    "State": "ID",
    "City": "Menan"
  },
  {
    "State": "ID",
    "City": "Monteview"
  },
  {
    "State": "ID",
    "City": "Newdale"
  },
  {
    "State": "ID",
    "City": "Parker"
  },
  {
    "State": "ID",
    "City": "Rexburg"
  },
  {
    "State": "ID",
    "City": "Rigby"
  },
  {
    "State": "ID",
    "City": "Ririe"
  },
  {
    "State": "ID",
    "City": "Roberts"
  },
  {
    "State": "ID",
    "City": "Saint Anthony"
  },
  {
    "State": "ID",
    "City": "Spencer"
  },
  {
    "State": "ID",
    "City": "Sugar City"
  },
  {
    "State": "ID",
    "City": "Swan Valley"
  },
  {
    "State": "ID",
    "City": "Terreton"
  },
  {
    "State": "ID",
    "City": "Teton"
  },
  {
    "State": "ID",
    "City": "Tetonia"
  },
  {
    "State": "ID",
    "City": "Ucon"
  },
  {
    "State": "ID",
    "City": "Victor"
  },
  {
    "State": "ID",
    "City": "Carmen"
  },
  {
    "State": "ID",
    "City": "Gibbonsville"
  },
  {
    "State": "ID",
    "City": "Leadore"
  },
  {
    "State": "ID",
    "City": "Lemhi"
  },
  {
    "State": "ID",
    "City": "North Fork"
  },
  {
    "State": "ID",
    "City": "Salmon"
  },
  {
    "State": "ID",
    "City": "Tendoy"
  },
  {
    "State": "ID",
    "City": "Shoup"
  },
  {
    "State": "ID",
    "City": "Lewiston"
  },
  {
    "State": "ID",
    "City": "Ahsahka"
  },
  {
    "State": "ID",
    "City": "Cottonwood"
  },
  {
    "State": "ID",
    "City": "Craigmont"
  },
  {
    "State": "ID",
    "City": "Culdesac"
  },
  {
    "State": "ID",
    "City": "Elk City"
  },
  {
    "State": "ID",
    "City": "Ferdinand"
  },
  {
    "State": "ID",
    "City": "Grangeville"
  },
  {
    "State": "ID",
    "City": "Fenn"
  },
  {
    "State": "ID",
    "City": "Greencreek"
  },
  {
    "State": "ID",
    "City": "Juliaetta"
  },
  {
    "State": "ID",
    "City": "Kamiah"
  },
  {
    "State": "ID",
    "City": "Kendrick"
  },
  {
    "State": "ID",
    "City": "Kooskia"
  },
  {
    "State": "ID",
    "City": "Lapwai"
  },
  {
    "State": "ID",
    "City": "Lenore"
  },
  {
    "State": "ID",
    "City": "Lucile"
  },
  {
    "State": "ID",
    "City": "Nezperce"
  },
  {
    "State": "ID",
    "City": "Orofino"
  },
  {
    "State": "ID",
    "City": "Peck"
  },
  {
    "State": "ID",
    "City": "Pierce"
  },
  {
    "State": "ID",
    "City": "Pollock"
  },
  {
    "State": "ID",
    "City": "Reubens"
  },
  {
    "State": "ID",
    "City": "Riggins"
  },
  {
    "State": "ID",
    "City": "Stites"
  },
  {
    "State": "ID",
    "City": "Weippe"
  },
  {
    "State": "ID",
    "City": "White Bird"
  },
  {
    "State": "ID",
    "City": "Winchester"
  },
  {
    "State": "ID",
    "City": "Atlanta"
  },
  {
    "State": "ID",
    "City": "Banks"
  },
  {
    "State": "ID",
    "City": "Bruneau"
  },
  {
    "State": "ID",
    "City": "Caldwell"
  },
  {
    "State": "ID",
    "City": "Cambridge"
  },
  {
    "State": "ID",
    "City": "Cascade"
  },
  {
    "State": "ID",
    "City": "Council"
  },
  {
    "State": "ID",
    "City": "Donnelly"
  },
  {
    "State": "ID",
    "City": "Eagle"
  },
  {
    "State": "ID",
    "City": "Emmett"
  },
  {
    "State": "ID",
    "City": "Fruitland"
  },
  {
    "State": "ID",
    "City": "Garden Valley"
  },
  {
    "State": "ID",
    "City": "Glenns Ferry"
  },
  {
    "State": "ID",
    "City": "Grand View"
  },
  {
    "State": "ID",
    "City": "Greenleaf"
  },
  {
    "State": "ID",
    "City": "Hammett"
  },
  {
    "State": "ID",
    "City": "Homedale"
  },
  {
    "State": "ID",
    "City": "Horseshoe Bend"
  },
  {
    "State": "ID",
    "City": "Huston"
  },
  {
    "State": "ID",
    "City": "Idaho City"
  },
  {
    "State": "ID",
    "City": "Indian Valley"
  },
  {
    "State": "ID",
    "City": "King Hill"
  },
  {
    "State": "ID",
    "City": "Kuna"
  },
  {
    "State": "ID",
    "City": "Lake Fork"
  },
  {
    "State": "ID",
    "City": "Letha"
  },
  {
    "State": "ID",
    "City": "Lowman"
  },
  {
    "State": "ID",
    "City": "Mccall"
  },
  {
    "State": "ID",
    "City": "Marsing"
  },
  {
    "State": "ID",
    "City": "Melba"
  },
  {
    "State": "ID",
    "City": "Meridian"
  },
  {
    "State": "ID",
    "City": "Mesa"
  },
  {
    "State": "ID",
    "City": "Middleton"
  },
  {
    "State": "ID",
    "City": "Midvale"
  },
  {
    "State": "ID",
    "City": "Mountain Home"
  },
  {
    "State": "ID",
    "City": "Mountain Home AFB"
  },
  {
    "State": "ID",
    "City": "Murphy"
  },
  {
    "State": "ID",
    "City": "Nampa"
  },
  {
    "State": "ID",
    "City": "New Meadows"
  },
  {
    "State": "ID",
    "City": "New Plymouth"
  },
  {
    "State": "ID",
    "City": "Notus"
  },
  {
    "State": "ID",
    "City": "Ola"
  },
  {
    "State": "ID",
    "City": "Parma"
  },
  {
    "State": "ID",
    "City": "Payette"
  },
  {
    "State": "ID",
    "City": "Placerville"
  },
  {
    "State": "ID",
    "City": "Star"
  },
  {
    "State": "ID",
    "City": "Sweet"
  },
  {
    "State": "ID",
    "City": "Warren"
  },
  {
    "State": "ID",
    "City": "Weiser"
  },
  {
    "State": "ID",
    "City": "Wilder"
  },
  {
    "State": "ID",
    "City": "Yellow Pine"
  },
  {
    "State": "ID",
    "City": "Boise"
  },
  {
    "State": "ID",
    "City": "Garden City"
  },
  {
    "State": "ID",
    "City": "Athol"
  },
  {
    "State": "ID",
    "City": "Avery"
  },
  {
    "State": "ID",
    "City": "Bayview"
  },
  {
    "State": "ID",
    "City": "Blanchard"
  },
  {
    "State": "ID",
    "City": "Bonners Ferry"
  },
  {
    "State": "ID",
    "City": "Bovill"
  },
  {
    "State": "ID",
    "City": "Calder"
  },
  {
    "State": "ID",
    "City": "Careywood"
  },
  {
    "State": "ID",
    "City": "Cataldo"
  },
  {
    "State": "ID",
    "City": "Clark Fork"
  },
  {
    "State": "ID",
    "City": "Clarkia"
  },
  {
    "State": "ID",
    "City": "Cocolalla"
  },
  {
    "State": "ID",
    "City": "Coeur D Alene"
  },
  {
    "State": "ID",
    "City": "Coolin"
  },
  {
    "State": "ID",
    "City": "Oldtown"
  },
  {
    "State": "ID",
    "City": "Deary"
  },
  {
    "State": "ID",
    "City": "Desmet"
  },
  {
    "State": "ID",
    "City": "Dover"
  },
  {
    "State": "ID",
    "City": "Eastport"
  },
  {
    "State": "ID",
    "City": "Elk River"
  },
  {
    "State": "ID",
    "City": "Fernwood"
  },
  {
    "State": "ID",
    "City": "Genesee"
  },
  {
    "State": "ID",
    "City": "Harrison"
  },
  {
    "State": "ID",
    "City": "Harvard"
  },
  {
    "State": "ID",
    "City": "Hayden"
  },
  {
    "State": "ID",
    "City": "Hope"
  },
  {
    "State": "ID",
    "City": "Kellogg"
  },
  {
    "State": "ID",
    "City": "Kingston"
  },
  {
    "State": "ID",
    "City": "Kootenai"
  },
  {
    "State": "ID",
    "City": "Laclede"
  },
  {
    "State": "ID",
    "City": "Medimont"
  },
  {
    "State": "ID",
    "City": "Moscow"
  },
  {
    "State": "ID",
    "City": "Moyie Springs"
  },
  {
    "State": "ID",
    "City": "Mullan"
  },
  {
    "State": "ID",
    "City": "Naples"
  },
  {
    "State": "ID",
    "City": "Nordman"
  },
  {
    "State": "ID",
    "City": "Osburn"
  },
  {
    "State": "ID",
    "City": "Pinehurst"
  },
  {
    "State": "ID",
    "City": "Plummer"
  },
  {
    "State": "ID",
    "City": "Ponderay"
  },
  {
    "State": "ID",
    "City": "Porthill"
  },
  {
    "State": "ID",
    "City": "Post Falls"
  },
  {
    "State": "ID",
    "City": "Potlatch"
  },
  {
    "State": "ID",
    "City": "Priest River"
  },
  {
    "State": "ID",
    "City": "Princeton"
  },
  {
    "State": "ID",
    "City": "Rathdrum"
  },
  {
    "State": "ID",
    "City": "Sagle"
  },
  {
    "State": "ID",
    "City": "Saint Maries"
  },
  {
    "State": "ID",
    "City": "Sandpoint"
  },
  {
    "State": "ID",
    "City": "Colburn"
  },
  {
    "State": "ID",
    "City": "Santa"
  },
  {
    "State": "ID",
    "City": "Silverton"
  },
  {
    "State": "ID",
    "City": "Smelterville"
  },
  {
    "State": "ID",
    "City": "Spirit Lake"
  },
  {
    "State": "ID",
    "City": "Tensed"
  },
  {
    "State": "ID",
    "City": "Troy"
  },
  {
    "State": "ID",
    "City": "Viola"
  },
  {
    "State": "ID",
    "City": "Wallace"
  },
  {
    "State": "ID",
    "City": "Murray"
  },
  {
    "State": "ID",
    "City": "Worley"
  },
  {
    "State": "UT",
    "City": "Altamont"
  },
  {
    "State": "UT",
    "City": "Altonah"
  },
  {
    "State": "UT",
    "City": "American Fork"
  },
  {
    "State": "UT",
    "City": "Alpine"
  },
  {
    "State": "UT",
    "City": "Eagle Mountain"
  },
  {
    "State": "UT",
    "City": "Bingham Canyon"
  },
  {
    "State": "UT",
    "City": "Bluebell"
  },
  {
    "State": "UT",
    "City": "Bonanza"
  },
  {
    "State": "UT",
    "City": "South Jordan"
  },
  {
    "State": "UT",
    "City": "Bountiful"
  },
  {
    "State": "UT",
    "City": "Cedar Valley"
  },
  {
    "State": "UT",
    "City": "Centerville"
  },
  {
    "State": "UT",
    "City": "Clearfield"
  },
  {
    "State": "UT",
    "City": "Coalville"
  },
  {
    "State": "UT",
    "City": "Croydon"
  },
  {
    "State": "UT",
    "City": "Draper"
  },
  {
    "State": "UT",
    "City": "Duchesne"
  },
  {
    "State": "UT",
    "City": "Dugway"
  },
  {
    "State": "UT",
    "City": "Dutch John"
  },
  {
    "State": "UT",
    "City": "Echo"
  },
  {
    "State": "UT",
    "City": "Farmington"
  },
  {
    "State": "UT",
    "City": "Fort Duchesne"
  },
  {
    "State": "UT",
    "City": "Fruitland"
  },
  {
    "State": "UT",
    "City": "Garden City"
  },
  {
    "State": "UT",
    "City": "Grantsville"
  },
  {
    "State": "UT",
    "City": "Hanna"
  },
  {
    "State": "UT",
    "City": "Heber City"
  },
  {
    "State": "UT",
    "City": "Henefer"
  },
  {
    "State": "UT",
    "City": "Ibapah"
  },
  {
    "State": "UT",
    "City": "Jensen"
  },
  {
    "State": "UT",
    "City": "Kamas"
  },
  {
    "State": "UT",
    "City": "Kaysville"
  },
  {
    "State": "UT",
    "City": "Laketown"
  },
  {
    "State": "UT",
    "City": "Lapoint"
  },
  {
    "State": "UT",
    "City": "Layton"
  },
  {
    "State": "UT",
    "City": "Lindon"
  },
  {
    "State": "UT",
    "City": "Lehi"
  },
  {
    "State": "UT",
    "City": "Magna"
  },
  {
    "State": "UT",
    "City": "Saratoga Springs"
  },
  {
    "State": "UT",
    "City": "Manila"
  },
  {
    "State": "UT",
    "City": "Midvale"
  },
  {
    "State": "UT",
    "City": "Midway"
  },
  {
    "State": "UT",
    "City": "Morgan"
  },
  {
    "State": "UT",
    "City": "Mountain Home"
  },
  {
    "State": "UT",
    "City": "Myton"
  },
  {
    "State": "UT",
    "City": "Neola"
  },
  {
    "State": "UT",
    "City": "North Salt Lake"
  },
  {
    "State": "UT",
    "City": "Oakley"
  },
  {
    "State": "UT",
    "City": "Hill AFB"
  },
  {
    "State": "UT",
    "City": "Orem"
  },
  {
    "State": "UT",
    "City": "Vineyard"
  },
  {
    "State": "UT",
    "City": "Park City"
  },
  {
    "State": "UT",
    "City": "Peoa"
  },
  {
    "State": "UT",
    "City": "Pleasant Grove"
  },
  {
    "State": "UT",
    "City": "Randlett"
  },
  {
    "State": "UT",
    "City": "Randolph"
  },
  {
    "State": "UT",
    "City": "Riverton"
  },
  {
    "State": "UT",
    "City": "Roosevelt"
  },
  {
    "State": "UT",
    "City": "Roy"
  },
  {
    "State": "UT",
    "City": "Rush Valley"
  },
  {
    "State": "UT",
    "City": "Sandy"
  },
  {
    "State": "UT",
    "City": "Stockton"
  },
  {
    "State": "UT",
    "City": "Tabiona"
  },
  {
    "State": "UT",
    "City": "Talmage"
  },
  {
    "State": "UT",
    "City": "Tooele"
  },
  {
    "State": "UT",
    "City": "Syracuse"
  },
  {
    "State": "UT",
    "City": "Tridell"
  },
  {
    "State": "UT",
    "City": "Vernal"
  },
  {
    "State": "UT",
    "City": "Vernon"
  },
  {
    "State": "UT",
    "City": "West Jordan"
  },
  {
    "State": "UT",
    "City": "Wallsburg"
  },
  {
    "State": "UT",
    "City": "Wendover"
  },
  {
    "State": "UT",
    "City": "Whiterocks"
  },
  {
    "State": "UT",
    "City": "Woodruff"
  },
  {
    "State": "UT",
    "City": "Woods Cross"
  },
  {
    "State": "UT",
    "City": "Herriman"
  },
  {
    "State": "UT",
    "City": "Salt Lake City"
  },
  {
    "State": "UT",
    "City": "West Valley City"
  },
  {
    "State": "UT",
    "City": "Ogden"
  },
  {
    "State": "UT",
    "City": "Bear River City"
  },
  {
    "State": "UT",
    "City": "Brigham City"
  },
  {
    "State": "UT",
    "City": "Cache Junction"
  },
  {
    "State": "UT",
    "City": "Clarkston"
  },
  {
    "State": "UT",
    "City": "Collinston"
  },
  {
    "State": "UT",
    "City": "Corinne"
  },
  {
    "State": "UT",
    "City": "Cornish"
  },
  {
    "State": "UT",
    "City": "Deweyville"
  },
  {
    "State": "UT",
    "City": "Eden"
  },
  {
    "State": "UT",
    "City": "Fielding"
  },
  {
    "State": "UT",
    "City": "Garland"
  },
  {
    "State": "UT",
    "City": "Grouse Creek"
  },
  {
    "State": "UT",
    "City": "Honeyville"
  },
  {
    "State": "UT",
    "City": "Hooper"
  },
  {
    "State": "UT",
    "City": "Howell"
  },
  {
    "State": "UT",
    "City": "Huntsville"
  },
  {
    "State": "UT",
    "City": "Hyde Park"
  },
  {
    "State": "UT",
    "City": "Hyrum"
  },
  {
    "State": "UT",
    "City": "Lewiston"
  },
  {
    "State": "UT",
    "City": "Logan"
  },
  {
    "State": "UT",
    "City": "Mantua"
  },
  {
    "State": "UT",
    "City": "Mendon"
  },
  {
    "State": "UT",
    "City": "Millville"
  },
  {
    "State": "UT",
    "City": "Newton"
  },
  {
    "State": "UT",
    "City": "Paradise"
  },
  {
    "State": "UT",
    "City": "Park Valley"
  },
  {
    "State": "UT",
    "City": "Plymouth"
  },
  {
    "State": "UT",
    "City": "Portage"
  },
  {
    "State": "UT",
    "City": "Providence"
  },
  {
    "State": "UT",
    "City": "Richmond"
  },
  {
    "State": "UT",
    "City": "Riverside"
  },
  {
    "State": "UT",
    "City": "Smithfield"
  },
  {
    "State": "UT",
    "City": "Snowville"
  },
  {
    "State": "UT",
    "City": "Tremonton"
  },
  {
    "State": "UT",
    "City": "Trenton"
  },
  {
    "State": "UT",
    "City": "Wellsville"
  },
  {
    "State": "UT",
    "City": "Willard"
  },
  {
    "State": "UT",
    "City": "Price"
  },
  {
    "State": "UT",
    "City": "Aneth"
  },
  {
    "State": "UT",
    "City": "Blanding"
  },
  {
    "State": "UT",
    "City": "Bluff"
  },
  {
    "State": "UT",
    "City": "Castle Dale"
  },
  {
    "State": "UT",
    "City": "Cisco"
  },
  {
    "State": "UT",
    "City": "Clawson"
  },
  {
    "State": "UT",
    "City": "Cleveland"
  },
  {
    "State": "UT",
    "City": "East Carbon"
  },
  {
    "State": "UT",
    "City": "Elmo"
  },
  {
    "State": "UT",
    "City": "Emery"
  },
  {
    "State": "UT",
    "City": "Ferron"
  },
  {
    "State": "UT",
    "City": "Green River"
  },
  {
    "State": "UT",
    "City": "Helper"
  },
  {
    "State": "UT",
    "City": "Huntington"
  },
  {
    "State": "UT",
    "City": "Kenilworth"
  },
  {
    "State": "UT",
    "City": "La Sal"
  },
  {
    "State": "UT",
    "City": "Mexican Hat"
  },
  {
    "State": "UT",
    "City": "Moab"
  },
  {
    "State": "UT",
    "City": "Lake Powell"
  },
  {
    "State": "UT",
    "City": "Montezuma Creek"
  },
  {
    "State": "UT",
    "City": "Monticello"
  },
  {
    "State": "UT",
    "City": "Monument Valley"
  },
  {
    "State": "UT",
    "City": "Orangeville"
  },
  {
    "State": "UT",
    "City": "Sunnyside"
  },
  {
    "State": "UT",
    "City": "Thompson"
  },
  {
    "State": "UT",
    "City": "Wellington"
  },
  {
    "State": "UT",
    "City": "Provo"
  },
  {
    "State": "UT",
    "City": "Aurora"
  },
  {
    "State": "UT",
    "City": "Axtell"
  },
  {
    "State": "UT",
    "City": "Centerfield"
  },
  {
    "State": "UT",
    "City": "Chester"
  },
  {
    "State": "UT",
    "City": "Delta"
  },
  {
    "State": "UT",
    "City": "Elberta"
  },
  {
    "State": "UT",
    "City": "Ephraim"
  },
  {
    "State": "UT",
    "City": "Eureka"
  },
  {
    "State": "UT",
    "City": "Fairview"
  },
  {
    "State": "UT",
    "City": "Fayette"
  },
  {
    "State": "UT",
    "City": "Fillmore"
  },
  {
    "State": "UT",
    "City": "Fountain Green"
  },
  {
    "State": "UT",
    "City": "Goshen"
  },
  {
    "State": "UT",
    "City": "Gunnison"
  },
  {
    "State": "UT",
    "City": "Hinckley"
  },
  {
    "State": "UT",
    "City": "Holden"
  },
  {
    "State": "UT",
    "City": "Kanosh"
  },
  {
    "State": "UT",
    "City": "Leamington"
  },
  {
    "State": "UT",
    "City": "Levan"
  },
  {
    "State": "UT",
    "City": "Lynndyl"
  },
  {
    "State": "UT",
    "City": "Manti"
  },
  {
    "State": "UT",
    "City": "Mayfield"
  },
  {
    "State": "UT",
    "City": "Meadow"
  },
  {
    "State": "UT",
    "City": "Mona"
  },
  {
    "State": "UT",
    "City": "Moroni"
  },
  {
    "State": "UT",
    "City": "Mount Pleasant"
  },
  {
    "State": "UT",
    "City": "Nephi"
  },
  {
    "State": "UT",
    "City": "Oak City"
  },
  {
    "State": "UT",
    "City": "Payson"
  },
  {
    "State": "UT",
    "City": "Redmond"
  },
  {
    "State": "UT",
    "City": "Salem"
  },
  {
    "State": "UT",
    "City": "Salina"
  },
  {
    "State": "UT",
    "City": "Santaquin"
  },
  {
    "State": "UT",
    "City": "Scipio"
  },
  {
    "State": "UT",
    "City": "Sigurd"
  },
  {
    "State": "UT",
    "City": "Spanish Fork"
  },
  {
    "State": "UT",
    "City": "Spring City"
  },
  {
    "State": "UT",
    "City": "Springville"
  },
  {
    "State": "UT",
    "City": "Mapleton"
  },
  {
    "State": "UT",
    "City": "Sterling"
  },
  {
    "State": "UT",
    "City": "Wales"
  },
  {
    "State": "UT",
    "City": "Richfield"
  },
  {
    "State": "UT",
    "City": "Alton"
  },
  {
    "State": "UT",
    "City": "Annabella"
  },
  {
    "State": "UT",
    "City": "Antimony"
  },
  {
    "State": "UT",
    "City": "Beaver"
  },
  {
    "State": "UT",
    "City": "Beryl"
  },
  {
    "State": "UT",
    "City": "Bicknell"
  },
  {
    "State": "UT",
    "City": "Boulder"
  },
  {
    "State": "UT",
    "City": "Bryce Canyon"
  },
  {
    "State": "UT",
    "City": "Cannonville"
  },
  {
    "State": "UT",
    "City": "Brian Head"
  },
  {
    "State": "UT",
    "City": "Cedar City"
  },
  {
    "State": "UT",
    "City": "Central"
  },
  {
    "State": "UT",
    "City": "Circleville"
  },
  {
    "State": "UT",
    "City": "Elsinore"
  },
  {
    "State": "UT",
    "City": "Enterprise"
  },
  {
    "State": "UT",
    "City": "Escalante"
  },
  {
    "State": "UT",
    "City": "Garrison"
  },
  {
    "State": "UT",
    "City": "Glendale"
  },
  {
    "State": "UT",
    "City": "Glenwood"
  },
  {
    "State": "UT",
    "City": "Greenville"
  },
  {
    "State": "UT",
    "City": "Greenwich"
  },
  {
    "State": "UT",
    "City": "Gunlock"
  },
  {
    "State": "UT",
    "City": "Hanksville"
  },
  {
    "State": "UT",
    "City": "Hatch"
  },
  {
    "State": "UT",
    "City": "Henrieville"
  },
  {
    "State": "UT",
    "City": "Hurricane"
  },
  {
    "State": "UT",
    "City": "Ivins"
  },
  {
    "State": "UT",
    "City": "Joseph"
  },
  {
    "State": "UT",
    "City": "Junction"
  },
  {
    "State": "UT",
    "City": "Kanab"
  },
  {
    "State": "UT",
    "City": "Kanarraville"
  },
  {
    "State": "UT",
    "City": "Kingston"
  },
  {
    "State": "UT",
    "City": "Koosharem"
  },
  {
    "State": "UT",
    "City": "La Verkin"
  },
  {
    "State": "UT",
    "City": "Leeds"
  },
  {
    "State": "UT",
    "City": "Loa"
  },
  {
    "State": "UT",
    "City": "Lyman"
  },
  {
    "State": "UT",
    "City": "Marysvale"
  },
  {
    "State": "UT",
    "City": "Milford"
  },
  {
    "State": "UT",
    "City": "Minersville"
  },
  {
    "State": "UT",
    "City": "Modena"
  },
  {
    "State": "UT",
    "City": "Monroe"
  },
  {
    "State": "UT",
    "City": "Mount Carmel"
  },
  {
    "State": "UT",
    "City": "Newcastle"
  },
  {
    "State": "UT",
    "City": "New Harmony"
  },
  {
    "State": "UT",
    "City": "Orderville"
  },
  {
    "State": "UT",
    "City": "Panguitch"
  },
  {
    "State": "UT",
    "City": "Paragonah"
  },
  {
    "State": "UT",
    "City": "Parowan"
  },
  {
    "State": "UT",
    "City": "Duck Creek Village"
  },
  {
    "State": "UT",
    "City": "Rockville"
  },
  {
    "State": "UT",
    "City": "Bryce"
  },
  {
    "State": "UT",
    "City": "Santa Clara"
  },
  {
    "State": "UT",
    "City": "Sevier"
  },
  {
    "State": "UT",
    "City": "Springdale"
  },
  {
    "State": "UT",
    "City": "Saint George"
  },
  {
    "State": "UT",
    "City": "Summit"
  },
  {
    "State": "UT",
    "City": "Teasdale"
  },
  {
    "State": "UT",
    "City": "Toquerville"
  },
  {
    "State": "UT",
    "City": "Torrey"
  },
  {
    "State": "UT",
    "City": "Tropic"
  },
  {
    "State": "UT",
    "City": "Virgin"
  },
  {
    "State": "UT",
    "City": "Washington"
  },
  {
    "State": "UT",
    "City": "Pine Valley"
  },
  {
    "State": "UT",
    "City": "Veyo"
  },
  {
    "State": "UT",
    "City": "Dammeron Valley"
  },
  {
    "State": "UT",
    "City": "Hildale"
  },
  {
    "State": "AZ",
    "City": "Phoenix"
  },
  {
    "State": "AZ",
    "City": "New River"
  },
  {
    "State": "AZ",
    "City": "Apache Junction"
  },
  {
    "State": "AZ",
    "City": "Gold Canyon"
  },
  {
    "State": "AZ",
    "City": "Bapchule"
  },
  {
    "State": "AZ",
    "City": "Casa Grande"
  },
  {
    "State": "AZ",
    "City": "Arizona City"
  },
  {
    "State": "AZ",
    "City": "Chandler Heights"
  },
  {
    "State": "AZ",
    "City": "Coolidge"
  },
  {
    "State": "AZ",
    "City": "Eloy"
  },
  {
    "State": "AZ",
    "City": "Florence"
  },
  {
    "State": "AZ",
    "City": "Hayden"
  },
  {
    "State": "AZ",
    "City": "Kearny"
  },
  {
    "State": "AZ",
    "City": "Maricopa"
  },
  {
    "State": "AZ",
    "City": "San Tan Valley"
  },
  {
    "State": "AZ",
    "City": "Picacho"
  },
  {
    "State": "AZ",
    "City": "Queen Creek"
  },
  {
    "State": "AZ",
    "City": "Red Rock"
  },
  {
    "State": "AZ",
    "City": "Sacaton"
  },
  {
    "State": "AZ",
    "City": "Stanfield"
  },
  {
    "State": "AZ",
    "City": "Superior"
  },
  {
    "State": "AZ",
    "City": "Tortilla Flat"
  },
  {
    "State": "AZ",
    "City": "Valley Farms"
  },
  {
    "State": "AZ",
    "City": "Winkelman"
  },
  {
    "State": "AZ",
    "City": "Mesa"
  },
  {
    "State": "AZ",
    "City": "Chandler"
  },
  {
    "State": "AZ",
    "City": "Gilbert"
  },
  {
    "State": "AZ",
    "City": "Higley"
  },
  {
    "State": "AZ",
    "City": "Scottsdale"
  },
  {
    "State": "AZ",
    "City": "Paradise Valley"
  },
  {
    "State": "AZ",
    "City": "Rio Verde"
  },
  {
    "State": "AZ",
    "City": "Fort Mcdowell"
  },
  {
    "State": "AZ",
    "City": "Fountain Hills"
  },
  {
    "State": "AZ",
    "City": "Tempe"
  },
  {
    "State": "AZ",
    "City": "Glendale"
  },
  {
    "State": "AZ",
    "City": "Luke Air Force Base"
  },
  {
    "State": "AZ",
    "City": "Aguila"
  },
  {
    "State": "AZ",
    "City": "Ajo"
  },
  {
    "State": "AZ",
    "City": "Arlington"
  },
  {
    "State": "AZ",
    "City": "Avondale"
  },
  {
    "State": "AZ",
    "City": "Black Canyon City"
  },
  {
    "State": "AZ",
    "City": "Bouse"
  },
  {
    "State": "AZ",
    "City": "Buckeye"
  },
  {
    "State": "AZ",
    "City": "Cave Creek"
  },
  {
    "State": "AZ",
    "City": "Cibola"
  },
  {
    "State": "AZ",
    "City": "Cashion"
  },
  {
    "State": "AZ",
    "City": "Congress"
  },
  {
    "State": "AZ",
    "City": "Dateland"
  },
  {
    "State": "AZ",
    "City": "Ehrenberg"
  },
  {
    "State": "AZ",
    "City": "El Mirage"
  },
  {
    "State": "AZ",
    "City": "San Luis"
  },
  {
    "State": "AZ",
    "City": "Gila Bend"
  },
  {
    "State": "AZ",
    "City": "Goodyear"
  },
  {
    "State": "AZ",
    "City": "Laveen"
  },
  {
    "State": "AZ",
    "City": "Litchfield Park"
  },
  {
    "State": "AZ",
    "City": "Lukeville"
  },
  {
    "State": "AZ",
    "City": "Morristown"
  },
  {
    "State": "AZ",
    "City": "Palo Verde"
  },
  {
    "State": "AZ",
    "City": "Parker"
  },
  {
    "State": "AZ",
    "City": "Peoria"
  },
  {
    "State": "AZ",
    "City": "Quartzsite"
  },
  {
    "State": "AZ",
    "City": "Roll"
  },
  {
    "State": "AZ",
    "City": "Salome"
  },
  {
    "State": "AZ",
    "City": "Somerton"
  },
  {
    "State": "AZ",
    "City": "Sun City"
  },
  {
    "State": "AZ",
    "City": "Tacna"
  },
  {
    "State": "AZ",
    "City": "Tolleson"
  },
  {
    "State": "AZ",
    "City": "Tonopah"
  },
  {
    "State": "AZ",
    "City": "Waddell"
  },
  {
    "State": "AZ",
    "City": "Wellton"
  },
  {
    "State": "AZ",
    "City": "Wenden"
  },
  {
    "State": "AZ",
    "City": "Wickenburg"
  },
  {
    "State": "AZ",
    "City": "Wikieup"
  },
  {
    "State": "AZ",
    "City": "Wittmann"
  },
  {
    "State": "AZ",
    "City": "Yarnell"
  },
  {
    "State": "AZ",
    "City": "Youngtown"
  },
  {
    "State": "AZ",
    "City": "Yuma"
  },
  {
    "State": "AZ",
    "City": "Poston"
  },
  {
    "State": "AZ",
    "City": "Surprise"
  },
  {
    "State": "AZ",
    "City": "Sun City West"
  },
  {
    "State": "AZ",
    "City": "Carefree"
  },
  {
    "State": "AZ",
    "City": "Globe"
  },
  {
    "State": "AZ",
    "City": "Bylas"
  },
  {
    "State": "AZ",
    "City": "Central"
  },
  {
    "State": "AZ",
    "City": "Claypool"
  },
  {
    "State": "AZ",
    "City": "Clifton"
  },
  {
    "State": "AZ",
    "City": "Duncan"
  },
  {
    "State": "AZ",
    "City": "Eden"
  },
  {
    "State": "AZ",
    "City": "Fort Thomas"
  },
  {
    "State": "AZ",
    "City": "Miami"
  },
  {
    "State": "AZ",
    "City": "Morenci"
  },
  {
    "State": "AZ",
    "City": "Payson"
  },
  {
    "State": "AZ",
    "City": "Peridot"
  },
  {
    "State": "AZ",
    "City": "Pima"
  },
  {
    "State": "AZ",
    "City": "Pine"
  },
  {
    "State": "AZ",
    "City": "Roosevelt"
  },
  {
    "State": "AZ",
    "City": "Safford"
  },
  {
    "State": "AZ",
    "City": "San Carlos"
  },
  {
    "State": "AZ",
    "City": "Solomon"
  },
  {
    "State": "AZ",
    "City": "Thatcher"
  },
  {
    "State": "AZ",
    "City": "Tonto Basin"
  },
  {
    "State": "AZ",
    "City": "Young"
  },
  {
    "State": "AZ",
    "City": "Arivaca"
  },
  {
    "State": "AZ",
    "City": "Benson"
  },
  {
    "State": "AZ",
    "City": "Bisbee"
  },
  {
    "State": "AZ",
    "City": "Bowie"
  },
  {
    "State": "AZ",
    "City": "Cochise"
  },
  {
    "State": "AZ",
    "City": "Douglas"
  },
  {
    "State": "AZ",
    "City": "Dragoon"
  },
  {
    "State": "AZ",
    "City": "Elfrida"
  },
  {
    "State": "AZ",
    "City": "Elgin"
  },
  {
    "State": "AZ",
    "City": "Fort Huachuca"
  },
  {
    "State": "AZ",
    "City": "Green Valley"
  },
  {
    "State": "AZ",
    "City": "Hereford"
  },
  {
    "State": "AZ",
    "City": "Huachuca City"
  },
  {
    "State": "AZ",
    "City": "Mc Neal"
  },
  {
    "State": "AZ",
    "City": "Mammoth"
  },
  {
    "State": "AZ",
    "City": "Mount Lemmon"
  },
  {
    "State": "AZ",
    "City": "Naco"
  },
  {
    "State": "AZ",
    "City": "Nogales"
  },
  {
    "State": "AZ",
    "City": "Oracle"
  },
  {
    "State": "AZ",
    "City": "Patagonia"
  },
  {
    "State": "AZ",
    "City": "Pearce"
  },
  {
    "State": "AZ",
    "City": "Pirtleville"
  },
  {
    "State": "AZ",
    "City": "Pomerene"
  },
  {
    "State": "AZ",
    "City": "Sahuarita"
  },
  {
    "State": "AZ",
    "City": "Saint David"
  },
  {
    "State": "AZ",
    "City": "San Manuel"
  },
  {
    "State": "AZ",
    "City": "San Simon"
  },
  {
    "State": "AZ",
    "City": "Sasabe"
  },
  {
    "State": "AZ",
    "City": "Sells"
  },
  {
    "State": "AZ",
    "City": "Sierra Vista"
  },
  {
    "State": "AZ",
    "City": "Sonoita"
  },
  {
    "State": "AZ",
    "City": "Tombstone"
  },
  {
    "State": "AZ",
    "City": "Topawa"
  },
  {
    "State": "AZ",
    "City": "Tumacacori"
  },
  {
    "State": "AZ",
    "City": "Vail"
  },
  {
    "State": "AZ",
    "City": "Willcox"
  },
  {
    "State": "AZ",
    "City": "Amado"
  },
  {
    "State": "AZ",
    "City": "Tubac"
  },
  {
    "State": "AZ",
    "City": "Rio Rico"
  },
  {
    "State": "AZ",
    "City": "Cortaro"
  },
  {
    "State": "AZ",
    "City": "Marana"
  },
  {
    "State": "AZ",
    "City": "Rillito"
  },
  {
    "State": "AZ",
    "City": "Tucson"
  },
  {
    "State": "AZ",
    "City": "Catalina"
  },
  {
    "State": "AZ",
    "City": "Show Low"
  },
  {
    "State": "AZ",
    "City": "Cibecue"
  },
  {
    "State": "AZ",
    "City": "White Mountain Lake"
  },
  {
    "State": "AZ",
    "City": "Alpine"
  },
  {
    "State": "AZ",
    "City": "Blue"
  },
  {
    "State": "AZ",
    "City": "Clay Springs"
  },
  {
    "State": "AZ",
    "City": "Concho"
  },
  {
    "State": "AZ",
    "City": "Eagar"
  },
  {
    "State": "AZ",
    "City": "Fort Apache"
  },
  {
    "State": "AZ",
    "City": "Greer"
  },
  {
    "State": "AZ",
    "City": "Heber"
  },
  {
    "State": "AZ",
    "City": "Lakeside"
  },
  {
    "State": "AZ",
    "City": "Mcnary"
  },
  {
    "State": "AZ",
    "City": "Forest Lakes"
  },
  {
    "State": "AZ",
    "City": "Nutrioso"
  },
  {
    "State": "AZ",
    "City": "Overgaard"
  },
  {
    "State": "AZ",
    "City": "Pinedale"
  },
  {
    "State": "AZ",
    "City": "Pinetop"
  },
  {
    "State": "AZ",
    "City": "Saint Johns"
  },
  {
    "State": "AZ",
    "City": "Snowflake"
  },
  {
    "State": "AZ",
    "City": "Springerville"
  },
  {
    "State": "AZ",
    "City": "Taylor"
  },
  {
    "State": "AZ",
    "City": "Vernon"
  },
  {
    "State": "AZ",
    "City": "Whiteriver"
  },
  {
    "State": "AZ",
    "City": "Woodruff"
  },
  {
    "State": "AZ",
    "City": "Flagstaff"
  },
  {
    "State": "AZ",
    "City": "Bellemont"
  },
  {
    "State": "AZ",
    "City": "Gray Mountain"
  },
  {
    "State": "AZ",
    "City": "Munds Park"
  },
  {
    "State": "AZ",
    "City": "Parks"
  },
  {
    "State": "AZ",
    "City": "Cameron"
  },
  {
    "State": "AZ",
    "City": "Colorado City"
  },
  {
    "State": "AZ",
    "City": "Fredonia"
  },
  {
    "State": "AZ",
    "City": "Grand Canyon"
  },
  {
    "State": "AZ",
    "City": "Happy Jack"
  },
  {
    "State": "AZ",
    "City": "Holbrook"
  },
  {
    "State": "AZ",
    "City": "Petrified Forest Natl Pk"
  },
  {
    "State": "AZ",
    "City": "Sun Valley"
  },
  {
    "State": "AZ",
    "City": "Hotevilla"
  },
  {
    "State": "AZ",
    "City": "Indian Wells"
  },
  {
    "State": "AZ",
    "City": "Joseph City"
  },
  {
    "State": "AZ",
    "City": "Kayenta"
  },
  {
    "State": "AZ",
    "City": "Keams Canyon"
  },
  {
    "State": "AZ",
    "City": "Leupp"
  },
  {
    "State": "AZ",
    "City": "Marble Canyon"
  },
  {
    "State": "AZ",
    "City": "Mormon Lake"
  },
  {
    "State": "AZ",
    "City": "Kykotsmovi Village"
  },
  {
    "State": "AZ",
    "City": "Page"
  },
  {
    "State": "AZ",
    "City": "Polacca"
  },
  {
    "State": "AZ",
    "City": "Second Mesa"
  },
  {
    "State": "AZ",
    "City": "Tonalea"
  },
  {
    "State": "AZ",
    "City": "Tuba City"
  },
  {
    "State": "AZ",
    "City": "Williams"
  },
  {
    "State": "AZ",
    "City": "Winslow"
  },
  {
    "State": "AZ",
    "City": "North Rim"
  },
  {
    "State": "AZ",
    "City": "Kaibeto"
  },
  {
    "State": "AZ",
    "City": "Shonto"
  },
  {
    "State": "AZ",
    "City": "Prescott"
  },
  {
    "State": "AZ",
    "City": "Prescott Valley"
  },
  {
    "State": "AZ",
    "City": "Ash Fork"
  },
  {
    "State": "AZ",
    "City": "Bagdad"
  },
  {
    "State": "AZ",
    "City": "Camp Verde"
  },
  {
    "State": "AZ",
    "City": "Chino Valley"
  },
  {
    "State": "AZ",
    "City": "Clarkdale"
  },
  {
    "State": "AZ",
    "City": "Cornville"
  },
  {
    "State": "AZ",
    "City": "Cottonwood"
  },
  {
    "State": "AZ",
    "City": "Dewey"
  },
  {
    "State": "AZ",
    "City": "Humboldt"
  },
  {
    "State": "AZ",
    "City": "Jerome"
  },
  {
    "State": "AZ",
    "City": "Kirkland"
  },
  {
    "State": "AZ",
    "City": "Mayer"
  },
  {
    "State": "AZ",
    "City": "Paulden"
  },
  {
    "State": "AZ",
    "City": "Rimrock"
  },
  {
    "State": "AZ",
    "City": "Sedona"
  },
  {
    "State": "AZ",
    "City": "Seligman"
  },
  {
    "State": "AZ",
    "City": "Skull Valley"
  },
  {
    "State": "AZ",
    "City": "Lake Montezuma"
  },
  {
    "State": "AZ",
    "City": "Crown King"
  },
  {
    "State": "AZ",
    "City": "Kingman"
  },
  {
    "State": "AZ",
    "City": "Lake Havasu City"
  },
  {
    "State": "AZ",
    "City": "Hackberry"
  },
  {
    "State": "AZ",
    "City": "Hualapai"
  },
  {
    "State": "AZ",
    "City": "Golden Valley"
  },
  {
    "State": "AZ",
    "City": "Fort Mohave"
  },
  {
    "State": "AZ",
    "City": "Bullhead City"
  },
  {
    "State": "AZ",
    "City": "Chloride"
  },
  {
    "State": "AZ",
    "City": "Littlefield"
  },
  {
    "State": "AZ",
    "City": "Oatman"
  },
  {
    "State": "AZ",
    "City": "Peach Springs"
  },
  {
    "State": "AZ",
    "City": "Supai"
  },
  {
    "State": "AZ",
    "City": "Topock"
  },
  {
    "State": "AZ",
    "City": "Valentine"
  },
  {
    "State": "AZ",
    "City": "Yucca"
  },
  {
    "State": "AZ",
    "City": "Mohave Valley"
  },
  {
    "State": "AZ",
    "City": "Dolan Springs"
  },
  {
    "State": "AZ",
    "City": "Temple Bar Marina"
  },
  {
    "State": "AZ",
    "City": "Meadview"
  },
  {
    "State": "AZ",
    "City": "Willow Beach"
  },
  {
    "State": "AZ",
    "City": "Chambers"
  },
  {
    "State": "AZ",
    "City": "Chinle"
  },
  {
    "State": "AZ",
    "City": "Fort Defiance"
  },
  {
    "State": "AZ",
    "City": "Ganado"
  },
  {
    "State": "AZ",
    "City": "Houck"
  },
  {
    "State": "AZ",
    "City": "Lukachukai"
  },
  {
    "State": "AZ",
    "City": "Lupton"
  },
  {
    "State": "AZ",
    "City": "Pinon"
  },
  {
    "State": "AZ",
    "City": "Saint Michaels"
  },
  {
    "State": "AZ",
    "City": "Sanders"
  },
  {
    "State": "AZ",
    "City": "Teec Nos Pos"
  },
  {
    "State": "AZ",
    "City": "Window Rock"
  },
  {
    "State": "AZ",
    "City": "Blue Gap"
  },
  {
    "State": "AZ",
    "City": "Dennehotso"
  },
  {
    "State": "AZ",
    "City": "Many Farms"
  },
  {
    "State": "AZ",
    "City": "Nazlini"
  },
  {
    "State": "AZ",
    "City": "Red Valley"
  },
  {
    "State": "AZ",
    "City": "Rock Point"
  },
  {
    "State": "AZ",
    "City": "Round Rock"
  },
  {
    "State": "AZ",
    "City": "Tsaile"
  },
  {
    "State": "NM",
    "City": "Algodones"
  },
  {
    "State": "NM",
    "City": "Belen"
  },
  {
    "State": "NM",
    "City": "Bernalillo"
  },
  {
    "State": "NM",
    "City": "Bluewater"
  },
  {
    "State": "NM",
    "City": "Bosque"
  },
  {
    "State": "NM",
    "City": "Casa Blanca"
  },
  {
    "State": "NM",
    "City": "Cedar Crest"
  },
  {
    "State": "NM",
    "City": "Cedarvale"
  },
  {
    "State": "NM",
    "City": "Cerrillos"
  },
  {
    "State": "NM",
    "City": "Claunch"
  },
  {
    "State": "NM",
    "City": "Coyote"
  },
  {
    "State": "NM",
    "City": "Cuba"
  },
  {
    "State": "NM",
    "City": "Cubero"
  },
  {
    "State": "NM",
    "City": "Edgewood"
  },
  {
    "State": "NM",
    "City": "Estancia"
  },
  {
    "State": "NM",
    "City": "Gallina"
  },
  {
    "State": "NM",
    "City": "Counselor"
  },
  {
    "State": "NM",
    "City": "Grants"
  },
  {
    "State": "NM",
    "City": "Milan"
  },
  {
    "State": "NM",
    "City": "Isleta"
  },
  {
    "State": "NM",
    "City": "Jarales"
  },
  {
    "State": "NM",
    "City": "Jemez Pueblo"
  },
  {
    "State": "NM",
    "City": "Jemez Springs"
  },
  {
    "State": "NM",
    "City": "Laguna"
  },
  {
    "State": "NM",
    "City": "La Jara"
  },
  {
    "State": "NM",
    "City": "La Joya"
  },
  {
    "State": "NM",
    "City": "Lindrith"
  },
  {
    "State": "NM",
    "City": "Los Lunas"
  },
  {
    "State": "NM",
    "City": "Mcintosh"
  },
  {
    "State": "NM",
    "City": "Pueblo Of Acoma"
  },
  {
    "State": "NM",
    "City": "Moriarty"
  },
  {
    "State": "NM",
    "City": "Mountainair"
  },
  {
    "State": "NM",
    "City": "Nageezi"
  },
  {
    "State": "NM",
    "City": "New Laguna"
  },
  {
    "State": "NM",
    "City": "Paguate"
  },
  {
    "State": "NM",
    "City": "Pena Blanca"
  },
  {
    "State": "NM",
    "City": "Peralta"
  },
  {
    "State": "NM",
    "City": "Placitas"
  },
  {
    "State": "NM",
    "City": "Ponderosa"
  },
  {
    "State": "NM",
    "City": "Prewitt"
  },
  {
    "State": "NM",
    "City": "Regina"
  },
  {
    "State": "NM",
    "City": "Sandia Park"
  },
  {
    "State": "NM",
    "City": "Corrales"
  },
  {
    "State": "NM",
    "City": "San Fidel"
  },
  {
    "State": "NM",
    "City": "San Rafael"
  },
  {
    "State": "NM",
    "City": "Santo Domingo Pueblo"
  },
  {
    "State": "NM",
    "City": "San Ysidro"
  },
  {
    "State": "NM",
    "City": "Stanley"
  },
  {
    "State": "NM",
    "City": "Tijeras"
  },
  {
    "State": "NM",
    "City": "Tome"
  },
  {
    "State": "NM",
    "City": "Torreon"
  },
  {
    "State": "NM",
    "City": "Veguita"
  },
  {
    "State": "NM",
    "City": "Willard"
  },
  {
    "State": "NM",
    "City": "Youngsville"
  },
  {
    "State": "NM",
    "City": "Bosque Farms"
  },
  {
    "State": "NM",
    "City": "Clines Corners"
  },
  {
    "State": "NM",
    "City": "Cochiti Pueblo"
  },
  {
    "State": "NM",
    "City": "Cochiti Lake"
  },
  {
    "State": "NM",
    "City": "Albuquerque"
  },
  {
    "State": "NM",
    "City": "Kirtland AFB"
  },
  {
    "State": "NM",
    "City": "Rio Rancho"
  },
  {
    "State": "NM",
    "City": "Gallup"
  },
  {
    "State": "NM",
    "City": "Brimhall"
  },
  {
    "State": "NM",
    "City": "Church Rock"
  },
  {
    "State": "NM",
    "City": "Continental Divide"
  },
  {
    "State": "NM",
    "City": "Crownpoint"
  },
  {
    "State": "NM",
    "City": "Fence Lake"
  },
  {
    "State": "NM",
    "City": "Fort Wingate"
  },
  {
    "State": "NM",
    "City": "Gamerco"
  },
  {
    "State": "NM",
    "City": "Mentmore"
  },
  {
    "State": "NM",
    "City": "Mexican Springs"
  },
  {
    "State": "NM",
    "City": "Ramah"
  },
  {
    "State": "NM",
    "City": "Rehoboth"
  },
  {
    "State": "NM",
    "City": "Thoreau"
  },
  {
    "State": "NM",
    "City": "Tohatchi"
  },
  {
    "State": "NM",
    "City": "Vanderwagen"
  },
  {
    "State": "NM",
    "City": "Zuni"
  },
  {
    "State": "NM",
    "City": "Navajo"
  },
  {
    "State": "NM",
    "City": "Jamestown"
  },
  {
    "State": "NM",
    "City": "Pinehill"
  },
  {
    "State": "NM",
    "City": "Sheep Springs"
  },
  {
    "State": "NM",
    "City": "Smith Lake"
  },
  {
    "State": "NM",
    "City": "Yatahey"
  },
  {
    "State": "NM",
    "City": "Farmington"
  },
  {
    "State": "NM",
    "City": "Aztec"
  },
  {
    "State": "NM",
    "City": "Blanco"
  },
  {
    "State": "NM",
    "City": "Bloomfield"
  },
  {
    "State": "NM",
    "City": "Flora Vista"
  },
  {
    "State": "NM",
    "City": "Fruitland"
  },
  {
    "State": "NM",
    "City": "Kirtland"
  },
  {
    "State": "NM",
    "City": "La Plata"
  },
  {
    "State": "NM",
    "City": "Navajo Dam"
  },
  {
    "State": "NM",
    "City": "Shiprock"
  },
  {
    "State": "NM",
    "City": "Waterflow"
  },
  {
    "State": "NM",
    "City": "Newcomb"
  },
  {
    "State": "NM",
    "City": "Sanostee"
  },
  {
    "State": "NM",
    "City": "Santa Fe"
  },
  {
    "State": "NM",
    "City": "Abiquiu"
  },
  {
    "State": "NM",
    "City": "Alcalde"
  },
  {
    "State": "NM",
    "City": "Amalia"
  },
  {
    "State": "NM",
    "City": "Arroyo Hondo"
  },
  {
    "State": "NM",
    "City": "Arroyo Seco"
  },
  {
    "State": "NM",
    "City": "Canjilon"
  },
  {
    "State": "NM",
    "City": "Canones"
  },
  {
    "State": "NM",
    "City": "Carson"
  },
  {
    "State": "NM",
    "City": "Cebolla"
  },
  {
    "State": "NM",
    "City": "Cerro"
  },
  {
    "State": "NM",
    "City": "Chama"
  },
  {
    "State": "NM",
    "City": "Chamisal"
  },
  {
    "State": "NM",
    "City": "Chimayo"
  },
  {
    "State": "NM",
    "City": "Cordova"
  },
  {
    "State": "NM",
    "City": "Costilla"
  },
  {
    "State": "NM",
    "City": "Taos Ski Valley"
  },
  {
    "State": "NM",
    "City": "Dixon"
  },
  {
    "State": "NM",
    "City": "Dulce"
  },
  {
    "State": "NM",
    "City": "El Prado"
  },
  {
    "State": "NM",
    "City": "El Rito"
  },
  {
    "State": "NM",
    "City": "Embudo"
  },
  {
    "State": "NM",
    "City": "Espanola"
  },
  {
    "State": "NM",
    "City": "Glorieta"
  },
  {
    "State": "NM",
    "City": "Hernandez"
  },
  {
    "State": "NM",
    "City": "Ilfeld"
  },
  {
    "State": "NM",
    "City": "La Madera"
  },
  {
    "State": "NM",
    "City": "Lamy"
  },
  {
    "State": "NM",
    "City": "Llano"
  },
  {
    "State": "NM",
    "City": "Los Alamos"
  },
  {
    "State": "NM",
    "City": "White Rock"
  },
  {
    "State": "NM",
    "City": "Medanales"
  },
  {
    "State": "NM",
    "City": "Ojo Caliente"
  },
  {
    "State": "NM",
    "City": "Los Ojos"
  },
  {
    "State": "NM",
    "City": "Pecos"
  },
  {
    "State": "NM",
    "City": "Penasco"
  },
  {
    "State": "NM",
    "City": "Petaca"
  },
  {
    "State": "NM",
    "City": "Questa"
  },
  {
    "State": "NM",
    "City": "Ranchos De Taos"
  },
  {
    "State": "NM",
    "City": "Red River"
  },
  {
    "State": "NM",
    "City": "Ribera"
  },
  {
    "State": "NM",
    "City": "Rowe"
  },
  {
    "State": "NM",
    "City": "San Cristobal"
  },
  {
    "State": "NM",
    "City": "San Jose"
  },
  {
    "State": "NM",
    "City": "Ohkay Owingeh"
  },
  {
    "State": "NM",
    "City": "Santa Cruz"
  },
  {
    "State": "NM",
    "City": "Serafina"
  },
  {
    "State": "NM",
    "City": "Taos"
  },
  {
    "State": "NM",
    "City": "Tererro"
  },
  {
    "State": "NM",
    "City": "Tesuque"
  },
  {
    "State": "NM",
    "City": "Tierra Amarilla"
  },
  {
    "State": "NM",
    "City": "Trampas"
  },
  {
    "State": "NM",
    "City": "Tres Piedras"
  },
  {
    "State": "NM",
    "City": "Truchas"
  },
  {
    "State": "NM",
    "City": "Vadito"
  },
  {
    "State": "NM",
    "City": "Valdez"
  },
  {
    "State": "NM",
    "City": "Vallecitos"
  },
  {
    "State": "NM",
    "City": "Velarde"
  },
  {
    "State": "NM",
    "City": "Villanueva"
  },
  {
    "State": "NM",
    "City": "Spaceport City"
  },
  {
    "State": "NM",
    "City": "Las Vegas"
  },
  {
    "State": "NM",
    "City": "Angel Fire"
  },
  {
    "State": "NM",
    "City": "Anton Chico"
  },
  {
    "State": "NM",
    "City": "Buena Vista"
  },
  {
    "State": "NM",
    "City": "Chacon"
  },
  {
    "State": "NM",
    "City": "Cimarron"
  },
  {
    "State": "NM",
    "City": "Cleveland"
  },
  {
    "State": "NM",
    "City": "Eagle Nest"
  },
  {
    "State": "NM",
    "City": "Guadalupita"
  },
  {
    "State": "NM",
    "City": "Holman"
  },
  {
    "State": "NM",
    "City": "La Loma"
  },
  {
    "State": "NM",
    "City": "Maxwell"
  },
  {
    "State": "NM",
    "City": "Miami"
  },
  {
    "State": "NM",
    "City": "Mills"
  },
  {
    "State": "NM",
    "City": "Montezuma"
  },
  {
    "State": "NM",
    "City": "Mora"
  },
  {
    "State": "NM",
    "City": "Mosquero"
  },
  {
    "State": "NM",
    "City": "Ocate"
  },
  {
    "State": "NM",
    "City": "Ojo Feliz"
  },
  {
    "State": "NM",
    "City": "Rainsville"
  },
  {
    "State": "NM",
    "City": "Raton"
  },
  {
    "State": "NM",
    "City": "Rociada"
  },
  {
    "State": "NM",
    "City": "Roy"
  },
  {
    "State": "NM",
    "City": "Sapello"
  },
  {
    "State": "NM",
    "City": "Solano"
  },
  {
    "State": "NM",
    "City": "Springer"
  },
  {
    "State": "NM",
    "City": "Ute Park"
  },
  {
    "State": "NM",
    "City": "Valmora"
  },
  {
    "State": "NM",
    "City": "Wagon Mound"
  },
  {
    "State": "NM",
    "City": "Watrous"
  },
  {
    "State": "NM",
    "City": "Socorro"
  },
  {
    "State": "NM",
    "City": "Aragon"
  },
  {
    "State": "NM",
    "City": "Datil"
  },
  {
    "State": "NM",
    "City": "Lemitar"
  },
  {
    "State": "NM",
    "City": "Luna"
  },
  {
    "State": "NM",
    "City": "Magdalena"
  },
  {
    "State": "NM",
    "City": "Pie Town"
  },
  {
    "State": "NM",
    "City": "Polvadera"
  },
  {
    "State": "NM",
    "City": "Quemado"
  },
  {
    "State": "NM",
    "City": "Reserve"
  },
  {
    "State": "NM",
    "City": "San Acacia"
  },
  {
    "State": "NM",
    "City": "San Antonio"
  },
  {
    "State": "NM",
    "City": "Truth Or Consequences"
  },
  {
    "State": "NM",
    "City": "Arrey"
  },
  {
    "State": "NM",
    "City": "Caballo"
  },
  {
    "State": "NM",
    "City": "Derry"
  },
  {
    "State": "NM",
    "City": "Elephant Butte"
  },
  {
    "State": "NM",
    "City": "Garfield"
  },
  {
    "State": "NM",
    "City": "Hatch"
  },
  {
    "State": "NM",
    "City": "Monticello"
  },
  {
    "State": "NM",
    "City": "Rincon"
  },
  {
    "State": "NM",
    "City": "Salem"
  },
  {
    "State": "NM",
    "City": "Williamsburg"
  },
  {
    "State": "NM",
    "City": "Winston"
  },
  {
    "State": "NM",
    "City": "Las Cruces"
  },
  {
    "State": "NM",
    "City": "White Sands Missile Range"
  },
  {
    "State": "NM",
    "City": "Santa Teresa"
  },
  {
    "State": "NM",
    "City": "Playas"
  },
  {
    "State": "NM",
    "City": "Animas"
  },
  {
    "State": "NM",
    "City": "Anthony"
  },
  {
    "State": "NM",
    "City": "Arenas Valley"
  },
  {
    "State": "NM",
    "City": "Bayard"
  },
  {
    "State": "NM",
    "City": "Berino"
  },
  {
    "State": "NM",
    "City": "Buckhorn"
  },
  {
    "State": "NM",
    "City": "Santa Clara"
  },
  {
    "State": "NM",
    "City": "Chamberino"
  },
  {
    "State": "NM",
    "City": "Cliff"
  },
  {
    "State": "NM",
    "City": "Columbus"
  },
  {
    "State": "NM",
    "City": "Deming"
  },
  {
    "State": "NM",
    "City": "Dona Ana"
  },
  {
    "State": "NM",
    "City": "Fairacres"
  },
  {
    "State": "NM",
    "City": "Faywood"
  },
  {
    "State": "NM",
    "City": "Fort Bayard"
  },
  {
    "State": "NM",
    "City": "Gila"
  },
  {
    "State": "NM",
    "City": "Glenwood"
  },
  {
    "State": "NM",
    "City": "Hachita"
  },
  {
    "State": "NM",
    "City": "Hanover"
  },
  {
    "State": "NM",
    "City": "Hillsboro"
  },
  {
    "State": "NM",
    "City": "Hurley"
  },
  {
    "State": "NM",
    "City": "La Mesa"
  },
  {
    "State": "NM",
    "City": "Lordsburg"
  },
  {
    "State": "NM",
    "City": "Mesilla"
  },
  {
    "State": "NM",
    "City": "Mesilla Park"
  },
  {
    "State": "NM",
    "City": "Mesquite"
  },
  {
    "State": "NM",
    "City": "Mimbres"
  },
  {
    "State": "NM",
    "City": "Mule Creek"
  },
  {
    "State": "NM",
    "City": "Organ"
  },
  {
    "State": "NM",
    "City": "Pinos Altos"
  },
  {
    "State": "NM",
    "City": "Radium Springs"
  },
  {
    "State": "NM",
    "City": "Redrock"
  },
  {
    "State": "NM",
    "City": "Rodeo"
  },
  {
    "State": "NM",
    "City": "San Miguel"
  },
  {
    "State": "NM",
    "City": "Silver City"
  },
  {
    "State": "NM",
    "City": "Sunland Park"
  },
  {
    "State": "NM",
    "City": "Tyrone"
  },
  {
    "State": "NM",
    "City": "Vado"
  },
  {
    "State": "NM",
    "City": "Chaparral"
  },
  {
    "State": "NM",
    "City": "Clovis"
  },
  {
    "State": "NM",
    "City": "Cannon AFB"
  },
  {
    "State": "NM",
    "City": "Broadview"
  },
  {
    "State": "NM",
    "City": "Causey"
  },
  {
    "State": "NM",
    "City": "Crossroads"
  },
  {
    "State": "NM",
    "City": "Dora"
  },
  {
    "State": "NM",
    "City": "Elida"
  },
  {
    "State": "NM",
    "City": "Floyd"
  },
  {
    "State": "NM",
    "City": "Fort Sumner"
  },
  {
    "State": "NM",
    "City": "Grady"
  },
  {
    "State": "NM",
    "City": "House"
  },
  {
    "State": "NM",
    "City": "Kenna"
  },
  {
    "State": "NM",
    "City": "Lingo"
  },
  {
    "State": "NM",
    "City": "Melrose"
  },
  {
    "State": "NM",
    "City": "Milnesand"
  },
  {
    "State": "NM",
    "City": "Pep"
  },
  {
    "State": "NM",
    "City": "Portales"
  },
  {
    "State": "NM",
    "City": "Rogers"
  },
  {
    "State": "NM",
    "City": "Saint Vrain"
  },
  {
    "State": "NM",
    "City": "Taiban"
  },
  {
    "State": "NM",
    "City": "Texico"
  },
  {
    "State": "NM",
    "City": "Yeso"
  },
  {
    "State": "NM",
    "City": "Roswell"
  },
  {
    "State": "NM",
    "City": "Artesia"
  },
  {
    "State": "NM",
    "City": "Caprock"
  },
  {
    "State": "NM",
    "City": "Carlsbad"
  },
  {
    "State": "NM",
    "City": "Dexter"
  },
  {
    "State": "NM",
    "City": "Eunice"
  },
  {
    "State": "NM",
    "City": "Hagerman"
  },
  {
    "State": "NM",
    "City": "Hobbs"
  },
  {
    "State": "NM",
    "City": "Hope"
  },
  {
    "State": "NM",
    "City": "Jal"
  },
  {
    "State": "NM",
    "City": "Lake Arthur"
  },
  {
    "State": "NM",
    "City": "Lakewood"
  },
  {
    "State": "NM",
    "City": "Loco Hills"
  },
  {
    "State": "NM",
    "City": "Loving"
  },
  {
    "State": "NM",
    "City": "Lovington"
  },
  {
    "State": "NM",
    "City": "Mcdonald"
  },
  {
    "State": "NM",
    "City": "Malaga"
  },
  {
    "State": "NM",
    "City": "Maljamar"
  },
  {
    "State": "NM",
    "City": "Monument"
  },
  {
    "State": "NM",
    "City": "Tatum"
  },
  {
    "State": "NM",
    "City": "Whites City"
  },
  {
    "State": "NM",
    "City": "Carrizozo"
  },
  {
    "State": "NM",
    "City": "Alamogordo"
  },
  {
    "State": "NM",
    "City": "Alto"
  },
  {
    "State": "NM",
    "City": "Bent"
  },
  {
    "State": "NM",
    "City": "Capitan"
  },
  {
    "State": "NM",
    "City": "Cloudcroft"
  },
  {
    "State": "NM",
    "City": "Corona"
  },
  {
    "State": "NM",
    "City": "Encino"
  },
  {
    "State": "NM",
    "City": "Fort Stanton"
  },
  {
    "State": "NM",
    "City": "Glencoe"
  },
  {
    "State": "NM",
    "City": "High Rolls Mountain Park"
  },
  {
    "State": "NM",
    "City": "Holloman Air Force Base"
  },
  {
    "State": "NM",
    "City": "Hondo"
  },
  {
    "State": "NM",
    "City": "La Luz"
  },
  {
    "State": "NM",
    "City": "Lincoln"
  },
  {
    "State": "NM",
    "City": "Mayhill"
  },
  {
    "State": "NM",
    "City": "Mescalero"
  },
  {
    "State": "NM",
    "City": "Nogal"
  },
  {
    "State": "NM",
    "City": "Orogrande"
  },
  {
    "State": "NM",
    "City": "Picacho"
  },
  {
    "State": "NM",
    "City": "Pinon"
  },
  {
    "State": "NM",
    "City": "Ruidoso"
  },
  {
    "State": "NM",
    "City": "Ruidoso Downs"
  },
  {
    "State": "NM",
    "City": "Sacramento"
  },
  {
    "State": "NM",
    "City": "San Patricio"
  },
  {
    "State": "NM",
    "City": "Sunspot"
  },
  {
    "State": "NM",
    "City": "Timberon"
  },
  {
    "State": "NM",
    "City": "Tinnie"
  },
  {
    "State": "NM",
    "City": "Tularosa"
  },
  {
    "State": "NM",
    "City": "Vaughn"
  },
  {
    "State": "NM",
    "City": "Weed"
  },
  {
    "State": "NM",
    "City": "Tucumcari"
  },
  {
    "State": "NM",
    "City": "Amistad"
  },
  {
    "State": "NM",
    "City": "Bard"
  },
  {
    "State": "NM",
    "City": "Capulin"
  },
  {
    "State": "NM",
    "City": "Clayton"
  },
  {
    "State": "NM",
    "City": "Conchas Dam"
  },
  {
    "State": "NM",
    "City": "Cuervo"
  },
  {
    "State": "NM",
    "City": "Des Moines"
  },
  {
    "State": "NM",
    "City": "Folsom"
  },
  {
    "State": "NM",
    "City": "Garita"
  },
  {
    "State": "NM",
    "City": "Gladstone"
  },
  {
    "State": "NM",
    "City": "Grenville"
  },
  {
    "State": "NM",
    "City": "Logan"
  },
  {
    "State": "NM",
    "City": "Mcalister"
  },
  {
    "State": "NM",
    "City": "Nara Visa"
  },
  {
    "State": "NM",
    "City": "Newkirk"
  },
  {
    "State": "NM",
    "City": "Quay"
  },
  {
    "State": "NM",
    "City": "San Jon"
  },
  {
    "State": "NM",
    "City": "Santa Rosa"
  },
  {
    "State": "NM",
    "City": "Sedan"
  },
  {
    "State": "NM",
    "City": "Trementina"
  },
  {
    "State": "DC",
    "City": "North Pole"
  },
  {
    "State": "NV",
    "City": "The Lakes"
  },
  {
    "State": "NV",
    "City": "Alamo"
  },
  {
    "State": "NV",
    "City": "Henderson"
  },
  {
    "State": "NV",
    "City": "Beatty"
  },
  {
    "State": "NV",
    "City": "Blue Diamond"
  },
  {
    "State": "NV",
    "City": "Boulder City"
  },
  {
    "State": "NV",
    "City": "Bunkerville"
  },
  {
    "State": "NV",
    "City": "Caliente"
  },
  {
    "State": "NV",
    "City": "Dyer"
  },
  {
    "State": "NV",
    "City": "Goldfield"
  },
  {
    "State": "NV",
    "City": "Hiko"
  },
  {
    "State": "NV",
    "City": "Indian Springs"
  },
  {
    "State": "NV",
    "City": "Jean"
  },
  {
    "State": "NV",
    "City": "Amargosa Valley"
  },
  {
    "State": "NV",
    "City": "Logandale"
  },
  {
    "State": "NV",
    "City": "Manhattan"
  },
  {
    "State": "NV",
    "City": "Mercury"
  },
  {
    "State": "NV",
    "City": "Mesquite"
  },
  {
    "State": "NV",
    "City": "Moapa"
  },
  {
    "State": "NV",
    "City": "Laughlin"
  },
  {
    "State": "NV",
    "City": "North Las Vegas"
  },
  {
    "State": "NV",
    "City": "Coyote Springs"
  },
  {
    "State": "NV",
    "City": "Cal Nev Ari"
  },
  {
    "State": "NV",
    "City": "Overton"
  },
  {
    "State": "NV",
    "City": "Pahrump"
  },
  {
    "State": "NV",
    "City": "Panaca"
  },
  {
    "State": "NV",
    "City": "Pioche"
  },
  {
    "State": "NV",
    "City": "Round Mountain"
  },
  {
    "State": "NV",
    "City": "Searchlight"
  },
  {
    "State": "NV",
    "City": "Silverpeak"
  },
  {
    "State": "NV",
    "City": "Tonopah"
  },
  {
    "State": "NV",
    "City": "Sloan"
  },
  {
    "State": "NV",
    "City": "Las Vegas"
  },
  {
    "State": "NV",
    "City": "Nellis AFB"
  },
  {
    "State": "NV",
    "City": "Ely"
  },
  {
    "State": "NV",
    "City": "Austin"
  },
  {
    "State": "NV",
    "City": "Baker"
  },
  {
    "State": "NV",
    "City": "Duckwater"
  },
  {
    "State": "NV",
    "City": "Eureka"
  },
  {
    "State": "NV",
    "City": "Lund"
  },
  {
    "State": "NV",
    "City": "Mc Gill"
  },
  {
    "State": "NV",
    "City": "Ruth"
  },
  {
    "State": "NV",
    "City": "Crystal Bay"
  },
  {
    "State": "NV",
    "City": "Dayton"
  },
  {
    "State": "NV",
    "City": "Denio"
  },
  {
    "State": "NV",
    "City": "Empire"
  },
  {
    "State": "NV",
    "City": "Fallon"
  },
  {
    "State": "NV",
    "City": "Fernley"
  },
  {
    "State": "NV",
    "City": "Gabbs"
  },
  {
    "State": "NV",
    "City": "Gardnerville"
  },
  {
    "State": "NV",
    "City": "Genoa"
  },
  {
    "State": "NV",
    "City": "Gerlach"
  },
  {
    "State": "NV",
    "City": "Glenbrook"
  },
  {
    "State": "NV",
    "City": "Golconda"
  },
  {
    "State": "NV",
    "City": "Hawthorne"
  },
  {
    "State": "NV",
    "City": "Imlay"
  },
  {
    "State": "NV",
    "City": "Lovelock"
  },
  {
    "State": "NV",
    "City": "Luning"
  },
  {
    "State": "NV",
    "City": "Mc Dermitt"
  },
  {
    "State": "NV",
    "City": "Mina"
  },
  {
    "State": "NV",
    "City": "Minden"
  },
  {
    "State": "NV",
    "City": "Nixon"
  },
  {
    "State": "NV",
    "City": "Orovada"
  },
  {
    "State": "NV",
    "City": "Paradise Valley"
  },
  {
    "State": "NV",
    "City": "Schurz"
  },
  {
    "State": "NV",
    "City": "Silver City"
  },
  {
    "State": "NV",
    "City": "Silver Springs"
  },
  {
    "State": "NV",
    "City": "Smith"
  },
  {
    "State": "NV",
    "City": "Sparks"
  },
  {
    "State": "NV",
    "City": "Sun Valley"
  },
  {
    "State": "NV",
    "City": "Valmy"
  },
  {
    "State": "NV",
    "City": "Verdi"
  },
  {
    "State": "NV",
    "City": "Virginia City"
  },
  {
    "State": "NV",
    "City": "Wadsworth"
  },
  {
    "State": "NV",
    "City": "Wellington"
  },
  {
    "State": "NV",
    "City": "Winnemucca"
  },
  {
    "State": "NV",
    "City": "Yerington"
  },
  {
    "State": "NV",
    "City": "Zephyr Cove"
  },
  {
    "State": "NV",
    "City": "Stateline"
  },
  {
    "State": "NV",
    "City": "Incline Village"
  },
  {
    "State": "NV",
    "City": "Reno"
  },
  {
    "State": "NV",
    "City": "Carson City"
  },
  {
    "State": "NV",
    "City": "Washoe Valley"
  },
  {
    "State": "NV",
    "City": "Elko"
  },
  {
    "State": "NV",
    "City": "Spring Creek"
  },
  {
    "State": "NV",
    "City": "Battle Mountain"
  },
  {
    "State": "NV",
    "City": "Crescent Valley"
  },
  {
    "State": "NV",
    "City": "Carlin"
  },
  {
    "State": "NV",
    "City": "Deeth"
  },
  {
    "State": "NV",
    "City": "Halleck"
  },
  {
    "State": "NV",
    "City": "Jackpot"
  },
  {
    "State": "NV",
    "City": "Jarbidge"
  },
  {
    "State": "NV",
    "City": "Lamoille"
  },
  {
    "State": "NV",
    "City": "Montello"
  },
  {
    "State": "NV",
    "City": "Mountain City"
  },
  {
    "State": "NV",
    "City": "Owyhee"
  },
  {
    "State": "NV",
    "City": "Ruby Valley"
  },
  {
    "State": "NV",
    "City": "Tuscarora"
  },
  {
    "State": "NV",
    "City": "Wells"
  },
  {
    "State": "NV",
    "City": "West Wendover"
  },
  {
    "State": "CA",
    "City": "Los Angeles"
  },
  {
    "State": "CA",
    "City": "West Hollywood"
  },
  {
    "State": "CA",
    "City": "Dodgertown"
  },
  {
    "State": "CA",
    "City": "Playa Vista"
  },
  {
    "State": "CA",
    "City": "Bell Gardens"
  },
  {
    "State": "CA",
    "City": "Bell"
  },
  {
    "State": "CA",
    "City": "Beverly Hills"
  },
  {
    "State": "CA",
    "City": "Compton"
  },
  {
    "State": "CA",
    "City": "Culver City"
  },
  {
    "State": "CA",
    "City": "Downey"
  },
  {
    "State": "CA",
    "City": "El Segundo"
  },
  {
    "State": "CA",
    "City": "Gardena"
  },
  {
    "State": "CA",
    "City": "Hawthorne"
  },
  {
    "State": "CA",
    "City": "Hermosa Beach"
  },
  {
    "State": "CA",
    "City": "Huntington Park"
  },
  {
    "State": "CA",
    "City": "Lawndale"
  },
  {
    "State": "CA",
    "City": "Lynwood"
  },
  {
    "State": "CA",
    "City": "Malibu"
  },
  {
    "State": "CA",
    "City": "Manhattan Beach"
  },
  {
    "State": "CA",
    "City": "Maywood"
  },
  {
    "State": "CA",
    "City": "Pacific Palisades"
  },
  {
    "State": "CA",
    "City": "Palos Verdes Peninsula"
  },
  {
    "State": "CA",
    "City": "Rancho Palos Verdes"
  },
  {
    "State": "CA",
    "City": "Redondo Beach"
  },
  {
    "State": "CA",
    "City": "South Gate"
  },
  {
    "State": "CA",
    "City": "Topanga"
  },
  {
    "State": "CA",
    "City": "Venice"
  },
  {
    "State": "CA",
    "City": "Marina Del Rey"
  },
  {
    "State": "CA",
    "City": "Playa Del Rey"
  },
  {
    "State": "CA",
    "City": "Inglewood"
  },
  {
    "State": "CA",
    "City": "Santa Monica"
  },
  {
    "State": "CA",
    "City": "Torrance"
  },
  {
    "State": "CA",
    "City": "Whittier"
  },
  {
    "State": "CA",
    "City": "Buena Park"
  },
  {
    "State": "CA",
    "City": "La Palma"
  },
  {
    "State": "CA",
    "City": "Cypress"
  },
  {
    "State": "CA",
    "City": "La Habra"
  },
  {
    "State": "CA",
    "City": "La Mirada"
  },
  {
    "State": "CA",
    "City": "Montebello"
  },
  {
    "State": "CA",
    "City": "Norwalk"
  },
  {
    "State": "CA",
    "City": "Pico Rivera"
  },
  {
    "State": "CA",
    "City": "Santa Fe Springs"
  },
  {
    "State": "CA",
    "City": "Stanton"
  },
  {
    "State": "CA",
    "City": "Artesia"
  },
  {
    "State": "CA",
    "City": "Cerritos"
  },
  {
    "State": "CA",
    "City": "Avalon"
  },
  {
    "State": "CA",
    "City": "Bellflower"
  },
  {
    "State": "CA",
    "City": "Harbor City"
  },
  {
    "State": "CA",
    "City": "Lakewood"
  },
  {
    "State": "CA",
    "City": "Hawaiian Gardens"
  },
  {
    "State": "CA",
    "City": "Lomita"
  },
  {
    "State": "CA",
    "City": "Los Alamitos"
  },
  {
    "State": "CA",
    "City": "Paramount"
  },
  {
    "State": "CA",
    "City": "San Pedro"
  },
  {
    "State": "CA",
    "City": "Seal Beach"
  },
  {
    "State": "CA",
    "City": "Sunset Beach"
  },
  {
    "State": "CA",
    "City": "Surfside"
  },
  {
    "State": "CA",
    "City": "Wilmington"
  },
  {
    "State": "CA",
    "City": "Carson"
  },
  {
    "State": "CA",
    "City": "Signal Hill"
  },
  {
    "State": "CA",
    "City": "Long Beach"
  },
  {
    "State": "CA",
    "City": "Altadena"
  },
  {
    "State": "CA",
    "City": "Arcadia"
  },
  {
    "State": "CA",
    "City": "Duarte"
  },
  {
    "State": "CA",
    "City": "La Canada Flintridge"
  },
  {
    "State": "CA",
    "City": "Monrovia"
  },
  {
    "State": "CA",
    "City": "Montrose"
  },
  {
    "State": "CA",
    "City": "Mount Wilson"
  },
  {
    "State": "CA",
    "City": "Sierra Madre"
  },
  {
    "State": "CA",
    "City": "South Pasadena"
  },
  {
    "State": "CA",
    "City": "Sunland"
  },
  {
    "State": "CA",
    "City": "Tujunga"
  },
  {
    "State": "CA",
    "City": "Verdugo City"
  },
  {
    "State": "CA",
    "City": "Pasadena"
  },
  {
    "State": "CA",
    "City": "San Marino"
  },
  {
    "State": "CA",
    "City": "Glendale"
  },
  {
    "State": "CA",
    "City": "La Crescenta"
  },
  {
    "State": "CA",
    "City": "Agoura Hills"
  },
  {
    "State": "CA",
    "City": "Calabasas"
  },
  {
    "State": "CA",
    "City": "Canoga Park"
  },
  {
    "State": "CA",
    "City": "Winnetka"
  },
  {
    "State": "CA",
    "City": "West Hills"
  },
  {
    "State": "CA",
    "City": "Castaic"
  },
  {
    "State": "CA",
    "City": "Chatsworth"
  },
  {
    "State": "CA",
    "City": "Encino"
  },
  {
    "State": "CA",
    "City": "Newbury Park"
  },
  {
    "State": "CA",
    "City": "Newhall"
  },
  {
    "State": "CA",
    "City": "Northridge"
  },
  {
    "State": "CA",
    "City": "Porter Ranch"
  },
  {
    "State": "CA",
    "City": "Pacoima"
  },
  {
    "State": "CA",
    "City": "Reseda"
  },
  {
    "State": "CA",
    "City": "San Fernando"
  },
  {
    "State": "CA",
    "City": "Sylmar"
  },
  {
    "State": "CA",
    "City": "North Hills"
  },
  {
    "State": "CA",
    "City": "Granada Hills"
  },
  {
    "State": "CA",
    "City": "Mission Hills"
  },
  {
    "State": "CA",
    "City": "Santa Clarita"
  },
  {
    "State": "CA",
    "City": "Canyon Country"
  },
  {
    "State": "CA",
    "City": "Sun Valley"
  },
  {
    "State": "CA",
    "City": "Valencia"
  },
  {
    "State": "CA",
    "City": "Tarzana"
  },
  {
    "State": "CA",
    "City": "Thousand Oaks"
  },
  {
    "State": "CA",
    "City": "Westlake Village"
  },
  {
    "State": "CA",
    "City": "Woodland Hills"
  },
  {
    "State": "CA",
    "City": "Oak Park"
  },
  {
    "State": "CA",
    "City": "Stevenson Ranch"
  },
  {
    "State": "CA",
    "City": "Van Nuys"
  },
  {
    "State": "CA",
    "City": "Panorama City"
  },
  {
    "State": "CA",
    "City": "Sherman Oaks"
  },
  {
    "State": "CA",
    "City": "Burbank"
  },
  {
    "State": "CA",
    "City": "North Hollywood"
  },
  {
    "State": "CA",
    "City": "Studio City"
  },
  {
    "State": "CA",
    "City": "Valley Village"
  },
  {
    "State": "CA",
    "City": "Universal City"
  },
  {
    "State": "CA",
    "City": "Toluca Lake"
  },
  {
    "State": "CA",
    "City": "Rancho Cucamonga"
  },
  {
    "State": "CA",
    "City": "Azusa"
  },
  {
    "State": "CA",
    "City": "Baldwin Park"
  },
  {
    "State": "CA",
    "City": "Chino"
  },
  {
    "State": "CA",
    "City": "Chino Hills"
  },
  {
    "State": "CA",
    "City": "Claremont"
  },
  {
    "State": "CA",
    "City": "City Of Industry"
  },
  {
    "State": "CA",
    "City": "Covina"
  },
  {
    "State": "CA",
    "City": "El Monte"
  },
  {
    "State": "CA",
    "City": "South El Monte"
  },
  {
    "State": "CA",
    "City": "Glendora"
  },
  {
    "State": "CA",
    "City": "Guasti"
  },
  {
    "State": "CA",
    "City": "La Puente"
  },
  {
    "State": "CA",
    "City": "Hacienda Heights"
  },
  {
    "State": "CA",
    "City": "Rowland Heights"
  },
  {
    "State": "CA",
    "City": "La Verne"
  },
  {
    "State": "CA",
    "City": "Mira Loma"
  },
  {
    "State": "CA",
    "City": "Monterey Park"
  },
  {
    "State": "CA",
    "City": "Ontario"
  },
  {
    "State": "CA",
    "City": "Mt Baldy"
  },
  {
    "State": "CA",
    "City": "Montclair"
  },
  {
    "State": "CA",
    "City": "Diamond Bar"
  },
  {
    "State": "CA",
    "City": "Pomona"
  },
  {
    "State": "CA",
    "City": "Rosemead"
  },
  {
    "State": "CA",
    "City": "San Dimas"
  },
  {
    "State": "CA",
    "City": "San Gabriel"
  },
  {
    "State": "CA",
    "City": "Temple City"
  },
  {
    "State": "CA",
    "City": "Upland"
  },
  {
    "State": "CA",
    "City": "Walnut"
  },
  {
    "State": "CA",
    "City": "West Covina"
  },
  {
    "State": "CA",
    "City": "Alhambra"
  },
  {
    "State": "CA",
    "City": "Alpine"
  },
  {
    "State": "CA",
    "City": "Bonita"
  },
  {
    "State": "CA",
    "City": "Boulevard"
  },
  {
    "State": "CA",
    "City": "Campo"
  },
  {
    "State": "CA",
    "City": "Chula Vista"
  },
  {
    "State": "CA",
    "City": "Descanso"
  },
  {
    "State": "CA",
    "City": "Dulzura"
  },
  {
    "State": "CA",
    "City": "Guatay"
  },
  {
    "State": "CA",
    "City": "Imperial Beach"
  },
  {
    "State": "CA",
    "City": "Jacumba"
  },
  {
    "State": "CA",
    "City": "Jamul"
  },
  {
    "State": "CA",
    "City": "La Mesa"
  },
  {
    "State": "CA",
    "City": "Lemon Grove"
  },
  {
    "State": "CA",
    "City": "Lincoln Acres"
  },
  {
    "State": "CA",
    "City": "Mount Laguna"
  },
  {
    "State": "CA",
    "City": "National City"
  },
  {
    "State": "CA",
    "City": "Pine Valley"
  },
  {
    "State": "CA",
    "City": "Potrero"
  },
  {
    "State": "CA",
    "City": "Spring Valley"
  },
  {
    "State": "CA",
    "City": "Tecate"
  },
  {
    "State": "CA",
    "City": "Bonsall"
  },
  {
    "State": "CA",
    "City": "Borrego Springs"
  },
  {
    "State": "CA",
    "City": "Cardiff By The Sea"
  },
  {
    "State": "CA",
    "City": "Carlsbad"
  },
  {
    "State": "CA",
    "City": "Del Mar"
  },
  {
    "State": "CA",
    "City": "El Cajon"
  },
  {
    "State": "CA",
    "City": "Encinitas"
  },
  {
    "State": "CA",
    "City": "Escondido"
  },
  {
    "State": "CA",
    "City": "Fallbrook"
  },
  {
    "State": "CA",
    "City": "Julian"
  },
  {
    "State": "CA",
    "City": "La Jolla"
  },
  {
    "State": "CA",
    "City": "Lakeside"
  },
  {
    "State": "CA",
    "City": "Oceanside"
  },
  {
    "State": "CA",
    "City": "Camp Pendleton"
  },
  {
    "State": "CA",
    "City": "Pala"
  },
  {
    "State": "CA",
    "City": "Palomar Mountain"
  },
  {
    "State": "CA",
    "City": "Pauma Valley"
  },
  {
    "State": "CA",
    "City": "Poway"
  },
  {
    "State": "CA",
    "City": "Ramona"
  },
  {
    "State": "CA",
    "City": "Ranchita"
  },
  {
    "State": "CA",
    "City": "Rancho Santa Fe"
  },
  {
    "State": "CA",
    "City": "San Luis Rey"
  },
  {
    "State": "CA",
    "City": "San Marcos"
  },
  {
    "State": "CA",
    "City": "Santa Ysabel"
  },
  {
    "State": "CA",
    "City": "Santee"
  },
  {
    "State": "CA",
    "City": "Solana Beach"
  },
  {
    "State": "CA",
    "City": "Vista"
  },
  {
    "State": "CA",
    "City": "Valley Center"
  },
  {
    "State": "CA",
    "City": "Warner Springs"
  },
  {
    "State": "CA",
    "City": "San Diego"
  },
  {
    "State": "CA",
    "City": "Coronado"
  },
  {
    "State": "CA",
    "City": "San Ysidro"
  },
  {
    "State": "CA",
    "City": "Indio"
  },
  {
    "State": "CA",
    "City": "Indian Wells"
  },
  {
    "State": "CA",
    "City": "Palm Desert"
  },
  {
    "State": "CA",
    "City": "Banning"
  },
  {
    "State": "CA",
    "City": "Bard"
  },
  {
    "State": "CA",
    "City": "Beaumont"
  },
  {
    "State": "CA",
    "City": "Blythe"
  },
  {
    "State": "CA",
    "City": "Brawley"
  },
  {
    "State": "CA",
    "City": "Cabazon"
  },
  {
    "State": "CA",
    "City": "Calexico"
  },
  {
    "State": "CA",
    "City": "Calipatria"
  },
  {
    "State": "CA",
    "City": "Cathedral City"
  },
  {
    "State": "CA",
    "City": "Coachella"
  },
  {
    "State": "CA",
    "City": "Desert Center"
  },
  {
    "State": "CA",
    "City": "Desert Hot Springs"
  },
  {
    "State": "CA",
    "City": "Earp"
  },
  {
    "State": "CA",
    "City": "El Centro"
  },
  {
    "State": "CA",
    "City": "La Quinta"
  },
  {
    "State": "CA",
    "City": "Heber"
  },
  {
    "State": "CA",
    "City": "Holtville"
  },
  {
    "State": "CA",
    "City": "Imperial"
  },
  {
    "State": "CA",
    "City": "Joshua Tree"
  },
  {
    "State": "CA",
    "City": "Mecca"
  },
  {
    "State": "CA",
    "City": "Morongo Valley"
  },
  {
    "State": "CA",
    "City": "Niland"
  },
  {
    "State": "CA",
    "City": "North Palm Springs"
  },
  {
    "State": "CA",
    "City": "Ocotillo"
  },
  {
    "State": "CA",
    "City": "Palm Springs"
  },
  {
    "State": "CA",
    "City": "Palo Verde"
  },
  {
    "State": "CA",
    "City": "Parker Dam"
  },
  {
    "State": "CA",
    "City": "Pioneertown"
  },
  {
    "State": "CA",
    "City": "Rancho Mirage"
  },
  {
    "State": "CA",
    "City": "Seeley"
  },
  {
    "State": "CA",
    "City": "Thermal"
  },
  {
    "State": "CA",
    "City": "Salton City"
  },
  {
    "State": "CA",
    "City": "Thousand Palms"
  },
  {
    "State": "CA",
    "City": "Twentynine Palms"
  },
  {
    "State": "CA",
    "City": "Vidal"
  },
  {
    "State": "CA",
    "City": "Westmorland"
  },
  {
    "State": "CA",
    "City": "Whitewater"
  },
  {
    "State": "CA",
    "City": "Winterhaven"
  },
  {
    "State": "CA",
    "City": "Yucca Valley"
  },
  {
    "State": "CA",
    "City": "Landers"
  },
  {
    "State": "CA",
    "City": "Adelanto"
  },
  {
    "State": "CA",
    "City": "Amboy"
  },
  {
    "State": "CA",
    "City": "Angelus Oaks"
  },
  {
    "State": "CA",
    "City": "Apple Valley"
  },
  {
    "State": "CA",
    "City": "Baker"
  },
  {
    "State": "CA",
    "City": "Fort Irwin"
  },
  {
    "State": "CA",
    "City": "Barstow"
  },
  {
    "State": "CA",
    "City": "Grand Terrace"
  },
  {
    "State": "CA",
    "City": "Big Bear City"
  },
  {
    "State": "CA",
    "City": "Big Bear Lake"
  },
  {
    "State": "CA",
    "City": "Bloomington"
  },
  {
    "State": "CA",
    "City": "Blue Jay"
  },
  {
    "State": "CA",
    "City": "Bryn Mawr"
  },
  {
    "State": "CA",
    "City": "Calimesa"
  },
  {
    "State": "CA",
    "City": "Cedar Glen"
  },
  {
    "State": "CA",
    "City": "Cedarpines Park"
  },
  {
    "State": "CA",
    "City": "Cima"
  },
  {
    "State": "CA",
    "City": "Colton"
  },
  {
    "State": "CA",
    "City": "Crestline"
  },
  {
    "State": "CA",
    "City": "Crest Park"
  },
  {
    "State": "CA",
    "City": "Daggett"
  },
  {
    "State": "CA",
    "City": "Death Valley"
  },
  {
    "State": "CA",
    "City": "Phelan"
  },
  {
    "State": "CA",
    "City": "Fontana"
  },
  {
    "State": "CA",
    "City": "Essex"
  },
  {
    "State": "CA",
    "City": "Fawnskin"
  },
  {
    "State": "CA",
    "City": "Ludlow"
  },
  {
    "State": "CA",
    "City": "Forest Falls"
  },
  {
    "State": "CA",
    "City": "Hesperia"
  },
  {
    "State": "CA",
    "City": "Green Valley Lake"
  },
  {
    "State": "CA",
    "City": "Helendale"
  },
  {
    "State": "CA",
    "City": "Highland"
  },
  {
    "State": "CA",
    "City": "Hinkley"
  },
  {
    "State": "CA",
    "City": "Loma Linda"
  },
  {
    "State": "CA",
    "City": "Lake Arrowhead"
  },
  {
    "State": "CA",
    "City": "Lucerne Valley"
  },
  {
    "State": "CA",
    "City": "Lytle Creek"
  },
  {
    "State": "CA",
    "City": "Mentone"
  },
  {
    "State": "CA",
    "City": "Needles"
  },
  {
    "State": "CA",
    "City": "Nipton"
  },
  {
    "State": "CA",
    "City": "Newberry Springs"
  },
  {
    "State": "CA",
    "City": "Mountain Pass"
  },
  {
    "State": "CA",
    "City": "Oro Grande"
  },
  {
    "State": "CA",
    "City": "Patton"
  },
  {
    "State": "CA",
    "City": "Pinon Hills"
  },
  {
    "State": "CA",
    "City": "Redlands"
  },
  {
    "State": "CA",
    "City": "Rialto"
  },
  {
    "State": "CA",
    "City": "Rimforest"
  },
  {
    "State": "CA",
    "City": "Running Springs"
  },
  {
    "State": "CA",
    "City": "Shoshone"
  },
  {
    "State": "CA",
    "City": "Skyforest"
  },
  {
    "State": "CA",
    "City": "Sugarloaf"
  },
  {
    "State": "CA",
    "City": "Tecopa"
  },
  {
    "State": "CA",
    "City": "Twin Peaks"
  },
  {
    "State": "CA",
    "City": "Victorville"
  },
  {
    "State": "CA",
    "City": "Wrightwood"
  },
  {
    "State": "CA",
    "City": "Yermo"
  },
  {
    "State": "CA",
    "City": "Yucaipa"
  },
  {
    "State": "CA",
    "City": "San Bernardino"
  },
  {
    "State": "CA",
    "City": "Riverside"
  },
  {
    "State": "CA",
    "City": "Jurupa Valley"
  },
  {
    "State": "CA",
    "City": "March Air Reserve Base"
  },
  {
    "State": "CA",
    "City": "Lake Elsinore"
  },
  {
    "State": "CA",
    "City": "Aguanga"
  },
  {
    "State": "CA",
    "City": "Anza"
  },
  {
    "State": "CA",
    "City": "Hemet"
  },
  {
    "State": "CA",
    "City": "Homeland"
  },
  {
    "State": "CA",
    "City": "Idyllwild"
  },
  {
    "State": "CA",
    "City": "Moreno Valley"
  },
  {
    "State": "CA",
    "City": "Mountain Center"
  },
  {
    "State": "CA",
    "City": "Murrieta"
  },
  {
    "State": "CA",
    "City": "Nuevo"
  },
  {
    "State": "CA",
    "City": "Perris"
  },
  {
    "State": "CA",
    "City": "San Jacinto"
  },
  {
    "State": "CA",
    "City": "Menifee"
  },
  {
    "State": "CA",
    "City": "Temecula"
  },
  {
    "State": "CA",
    "City": "Wildomar"
  },
  {
    "State": "CA",
    "City": "Winchester"
  },
  {
    "State": "CA",
    "City": "Irvine"
  },
  {
    "State": "CA",
    "City": "Huntington Beach"
  },
  {
    "State": "CA",
    "City": "Laguna Niguel"
  },
  {
    "State": "CA",
    "City": "El Toro"
  },
  {
    "State": "CA",
    "City": "Foothill Ranch"
  },
  {
    "State": "CA",
    "City": "Capistrano Beach"
  },
  {
    "State": "CA",
    "City": "Corona Del Mar"
  },
  {
    "State": "CA",
    "City": "Costa Mesa"
  },
  {
    "State": "CA",
    "City": "Dana Point"
  },
  {
    "State": "CA",
    "City": "Lake Forest"
  },
  {
    "State": "CA",
    "City": "Laguna Woods"
  },
  {
    "State": "CA",
    "City": "East Irvine"
  },
  {
    "State": "CA",
    "City": "Laguna Beach"
  },
  {
    "State": "CA",
    "City": "Laguna Hills"
  },
  {
    "State": "CA",
    "City": "Midway City"
  },
  {
    "State": "CA",
    "City": "Aliso Viejo"
  },
  {
    "State": "CA",
    "City": "Newport Coast"
  },
  {
    "State": "CA",
    "City": "Newport Beach"
  },
  {
    "State": "CA",
    "City": "San Clemente"
  },
  {
    "State": "CA",
    "City": "San Juan Capistrano"
  },
  {
    "State": "CA",
    "City": "Silverado"
  },
  {
    "State": "CA",
    "City": "Trabuco Canyon"
  },
  {
    "State": "CA",
    "City": "Westminster"
  },
  {
    "State": "CA",
    "City": "Rancho Santa Margarita"
  },
  {
    "State": "CA",
    "City": "Mission Viejo"
  },
  {
    "State": "CA",
    "City": "Ladera Ranch"
  },
  {
    "State": "CA",
    "City": "Santa Ana"
  },
  {
    "State": "CA",
    "City": "Fountain Valley"
  },
  {
    "State": "CA",
    "City": "Tustin"
  },
  {
    "State": "CA",
    "City": "Anaheim"
  },
  {
    "State": "CA",
    "City": "Atwood"
  },
  {
    "State": "CA",
    "City": "Brea"
  },
  {
    "State": "CA",
    "City": "Fullerton"
  },
  {
    "State": "CA",
    "City": "Garden Grove"
  },
  {
    "State": "CA",
    "City": "Orange"
  },
  {
    "State": "CA",
    "City": "Norco"
  },
  {
    "State": "CA",
    "City": "Villa Park"
  },
  {
    "State": "CA",
    "City": "Placentia"
  },
  {
    "State": "CA",
    "City": "Corona"
  },
  {
    "State": "CA",
    "City": "Yorba Linda"
  },
  {
    "State": "CA",
    "City": "Ventura"
  },
  {
    "State": "CA",
    "City": "Camarillo"
  },
  {
    "State": "CA",
    "City": "Carpinteria"
  },
  {
    "State": "CA",
    "City": "Fillmore"
  },
  {
    "State": "CA",
    "City": "Moorpark"
  },
  {
    "State": "CA",
    "City": "Oak View"
  },
  {
    "State": "CA",
    "City": "Ojai"
  },
  {
    "State": "CA",
    "City": "Oxnard"
  },
  {
    "State": "CA",
    "City": "Piru"
  },
  {
    "State": "CA",
    "City": "Port Hueneme"
  },
  {
    "State": "CA",
    "City": "Point Mugu Nawc"
  },
  {
    "State": "CA",
    "City": "Port Hueneme Cbc Base"
  },
  {
    "State": "CA",
    "City": "Santa Paula"
  },
  {
    "State": "CA",
    "City": "Simi Valley"
  },
  {
    "State": "CA",
    "City": "Brandeis"
  },
  {
    "State": "CA",
    "City": "Somis"
  },
  {
    "State": "CA",
    "City": "Summerland"
  },
  {
    "State": "CA",
    "City": "Santa Barbara"
  },
  {
    "State": "CA",
    "City": "Goleta"
  },
  {
    "State": "CA",
    "City": "Alpaugh"
  },
  {
    "State": "CA",
    "City": "Armona"
  },
  {
    "State": "CA",
    "City": "Arvin"
  },
  {
    "State": "CA",
    "City": "Avenal"
  },
  {
    "State": "CA",
    "City": "Bodfish"
  },
  {
    "State": "CA",
    "City": "Buttonwillow"
  },
  {
    "State": "CA",
    "City": "California Hot Springs"
  },
  {
    "State": "CA",
    "City": "Camp Nelson"
  },
  {
    "State": "CA",
    "City": "Coalinga"
  },
  {
    "State": "CA",
    "City": "Corcoran"
  },
  {
    "State": "CA",
    "City": "Delano"
  },
  {
    "State": "CA",
    "City": "Ducor"
  },
  {
    "State": "CA",
    "City": "Earlimart"
  },
  {
    "State": "CA",
    "City": "Edison"
  },
  {
    "State": "CA",
    "City": "Exeter"
  },
  {
    "State": "CA",
    "City": "Pine Mountain Club"
  },
  {
    "State": "CA",
    "City": "Farmersville"
  },
  {
    "State": "CA",
    "City": "Fellows"
  },
  {
    "State": "CA",
    "City": "Frazier Park"
  },
  {
    "State": "CA",
    "City": "Glennville"
  },
  {
    "State": "CA",
    "City": "Goshen"
  },
  {
    "State": "CA",
    "City": "Hanford"
  },
  {
    "State": "CA",
    "City": "Huron"
  },
  {
    "State": "CA",
    "City": "Ivanhoe"
  },
  {
    "State": "CA",
    "City": "Kaweah"
  },
  {
    "State": "CA",
    "City": "Kernville"
  },
  {
    "State": "CA",
    "City": "Kettleman City"
  },
  {
    "State": "CA",
    "City": "Lake Isabella"
  },
  {
    "State": "CA",
    "City": "Lamont"
  },
  {
    "State": "CA",
    "City": "Laton"
  },
  {
    "State": "CA",
    "City": "Lebec"
  },
  {
    "State": "CA",
    "City": "Lemon Cove"
  },
  {
    "State": "CA",
    "City": "Lemoore"
  },
  {
    "State": "CA",
    "City": "Lindsay"
  },
  {
    "State": "CA",
    "City": "Lost Hills"
  },
  {
    "State": "CA",
    "City": "Mc Farland"
  },
  {
    "State": "CA",
    "City": "Mc Kittrick"
  },
  {
    "State": "CA",
    "City": "Maricopa"
  },
  {
    "State": "CA",
    "City": "New Cuyama"
  },
  {
    "State": "CA",
    "City": "Onyx"
  },
  {
    "State": "CA",
    "City": "Pixley"
  },
  {
    "State": "CA",
    "City": "Porterville"
  },
  {
    "State": "CA",
    "City": "Posey"
  },
  {
    "State": "CA",
    "City": "Richgrove"
  },
  {
    "State": "CA",
    "City": "Sequoia National Park"
  },
  {
    "State": "CA",
    "City": "Shafter"
  },
  {
    "State": "CA",
    "City": "Springville"
  },
  {
    "State": "CA",
    "City": "Stratford"
  },
  {
    "State": "CA",
    "City": "Strathmore"
  },
  {
    "State": "CA",
    "City": "Taft"
  },
  {
    "State": "CA",
    "City": "Terra Bella"
  },
  {
    "State": "CA",
    "City": "Three Rivers"
  },
  {
    "State": "CA",
    "City": "Tipton"
  },
  {
    "State": "CA",
    "City": "Tulare"
  },
  {
    "State": "CA",
    "City": "Tupman"
  },
  {
    "State": "CA",
    "City": "Visalia"
  },
  {
    "State": "CA",
    "City": "Wasco"
  },
  {
    "State": "CA",
    "City": "Waukena"
  },
  {
    "State": "CA",
    "City": "Weldon"
  },
  {
    "State": "CA",
    "City": "Wofford Heights"
  },
  {
    "State": "CA",
    "City": "Woodlake"
  },
  {
    "State": "CA",
    "City": "Woody"
  },
  {
    "State": "CA",
    "City": "Bakersfield"
  },
  {
    "State": "CA",
    "City": "San Luis Obispo"
  },
  {
    "State": "CA",
    "City": "Los Osos"
  },
  {
    "State": "CA",
    "City": "Arroyo Grande"
  },
  {
    "State": "CA",
    "City": "Atascadero"
  },
  {
    "State": "CA",
    "City": "Avila Beach"
  },
  {
    "State": "CA",
    "City": "Bradley"
  },
  {
    "State": "CA",
    "City": "Buellton"
  },
  {
    "State": "CA",
    "City": "Cambria"
  },
  {
    "State": "CA",
    "City": "Casmalia"
  },
  {
    "State": "CA",
    "City": "Cayucos"
  },
  {
    "State": "CA",
    "City": "Creston"
  },
  {
    "State": "CA",
    "City": "Grover Beach"
  },
  {
    "State": "CA",
    "City": "Guadalupe"
  },
  {
    "State": "CA",
    "City": "Harmony"
  },
  {
    "State": "CA",
    "City": "Lompoc"
  },
  {
    "State": "CA",
    "City": "Los Alamos"
  },
  {
    "State": "CA",
    "City": "Los Olivos"
  },
  {
    "State": "CA",
    "City": "Morro Bay"
  },
  {
    "State": "CA",
    "City": "Nipomo"
  },
  {
    "State": "CA",
    "City": "Oceano"
  },
  {
    "State": "CA",
    "City": "Paso Robles"
  },
  {
    "State": "CA",
    "City": "Pismo Beach"
  },
  {
    "State": "CA",
    "City": "San Ardo"
  },
  {
    "State": "CA",
    "City": "San Miguel"
  },
  {
    "State": "CA",
    "City": "San Simeon"
  },
  {
    "State": "CA",
    "City": "Santa Margarita"
  },
  {
    "State": "CA",
    "City": "Santa Maria"
  },
  {
    "State": "CA",
    "City": "Santa Ynez"
  },
  {
    "State": "CA",
    "City": "Shandon"
  },
  {
    "State": "CA",
    "City": "Solvang"
  },
  {
    "State": "CA",
    "City": "Templeton"
  },
  {
    "State": "CA",
    "City": "Mojave"
  },
  {
    "State": "CA",
    "City": "California City"
  },
  {
    "State": "CA",
    "City": "Acton"
  },
  {
    "State": "CA",
    "City": "Benton"
  },
  {
    "State": "CA",
    "City": "Big Pine"
  },
  {
    "State": "CA",
    "City": "Bishop"
  },
  {
    "State": "CA",
    "City": "Boron"
  },
  {
    "State": "CA",
    "City": "Bridgeport"
  },
  {
    "State": "CA",
    "City": "Caliente"
  },
  {
    "State": "CA",
    "City": "Cantil"
  },
  {
    "State": "CA",
    "City": "Darwin"
  },
  {
    "State": "CA",
    "City": "Edwards"
  },
  {
    "State": "CA",
    "City": "Independence"
  },
  {
    "State": "CA",
    "City": "Inyokern"
  },
  {
    "State": "CA",
    "City": "Johannesburg"
  },
  {
    "State": "CA",
    "City": "June Lake"
  },
  {
    "State": "CA",
    "City": "Keeler"
  },
  {
    "State": "CA",
    "City": "Keene"
  },
  {
    "State": "CA",
    "City": "Lake Hughes"
  },
  {
    "State": "CA",
    "City": "Lancaster"
  },
  {
    "State": "CA",
    "City": "Lee Vining"
  },
  {
    "State": "CA",
    "City": "Little Lake"
  },
  {
    "State": "CA",
    "City": "Littlerock"
  },
  {
    "State": "CA",
    "City": "Llano"
  },
  {
    "State": "CA",
    "City": "Lone Pine"
  },
  {
    "State": "CA",
    "City": "Mammoth Lakes"
  },
  {
    "State": "CA",
    "City": "Olancha"
  },
  {
    "State": "CA",
    "City": "Palmdale"
  },
  {
    "State": "CA",
    "City": "Pearblossom"
  },
  {
    "State": "CA",
    "City": "Randsburg"
  },
  {
    "State": "CA",
    "City": "Ridgecrest"
  },
  {
    "State": "CA",
    "City": "Red Mountain"
  },
  {
    "State": "CA",
    "City": "Rosamond"
  },
  {
    "State": "CA",
    "City": "Tehachapi"
  },
  {
    "State": "CA",
    "City": "Trona"
  },
  {
    "State": "CA",
    "City": "Valyermo"
  },
  {
    "State": "CA",
    "City": "Ahwahnee"
  },
  {
    "State": "CA",
    "City": "Auberry"
  },
  {
    "State": "CA",
    "City": "Badger"
  },
  {
    "State": "CA",
    "City": "Bass Lake"
  },
  {
    "State": "CA",
    "City": "Big Creek"
  },
  {
    "State": "CA",
    "City": "Biola"
  },
  {
    "State": "CA",
    "City": "Burrel"
  },
  {
    "State": "CA",
    "City": "Cantua Creek"
  },
  {
    "State": "CA",
    "City": "Caruthers"
  },
  {
    "State": "CA",
    "City": "Chowchilla"
  },
  {
    "State": "CA",
    "City": "Clovis"
  },
  {
    "State": "CA",
    "City": "Coarsegold"
  },
  {
    "State": "CA",
    "City": "Cutler"
  },
  {
    "State": "CA",
    "City": "Del Rey"
  },
  {
    "State": "CA",
    "City": "Dinuba"
  },
  {
    "State": "CA",
    "City": "Dos Palos"
  },
  {
    "State": "CA",
    "City": "Dunlap"
  },
  {
    "State": "CA",
    "City": "Firebaugh"
  },
  {
    "State": "CA",
    "City": "Fish Camp"
  },
  {
    "State": "CA",
    "City": "Five Points"
  },
  {
    "State": "CA",
    "City": "Fowler"
  },
  {
    "State": "CA",
    "City": "Friant"
  },
  {
    "State": "CA",
    "City": "Helm"
  },
  {
    "State": "CA",
    "City": "Hume"
  },
  {
    "State": "CA",
    "City": "Kerman"
  },
  {
    "State": "CA",
    "City": "Kingsburg"
  },
  {
    "State": "CA",
    "City": "Kings Canyon National Pk"
  },
  {
    "State": "CA",
    "City": "Lakeshore"
  },
  {
    "State": "CA",
    "City": "Los Banos"
  },
  {
    "State": "CA",
    "City": "Madera"
  },
  {
    "State": "CA",
    "City": "Mendota"
  },
  {
    "State": "CA",
    "City": "Miramonte"
  },
  {
    "State": "CA",
    "City": "Mono Hot Springs"
  },
  {
    "State": "CA",
    "City": "North Fork"
  },
  {
    "State": "CA",
    "City": "Oakhurst"
  },
  {
    "State": "CA",
    "City": "O Neals"
  },
  {
    "State": "CA",
    "City": "Orange Cove"
  },
  {
    "State": "CA",
    "City": "Orosi"
  },
  {
    "State": "CA",
    "City": "Parlier"
  },
  {
    "State": "CA",
    "City": "Piedra"
  },
  {
    "State": "CA",
    "City": "Fresno"
  },
  {
    "State": "CA",
    "City": "Prather"
  },
  {
    "State": "CA",
    "City": "Raisin City"
  },
  {
    "State": "CA",
    "City": "Raymond"
  },
  {
    "State": "CA",
    "City": "Reedley"
  },
  {
    "State": "CA",
    "City": "Riverdale"
  },
  {
    "State": "CA",
    "City": "Sanger"
  },
  {
    "State": "CA",
    "City": "San Joaquin"
  },
  {
    "State": "CA",
    "City": "Santa Rita Park"
  },
  {
    "State": "CA",
    "City": "Selma"
  },
  {
    "State": "CA",
    "City": "Shaver Lake"
  },
  {
    "State": "CA",
    "City": "South Dos Palos"
  },
  {
    "State": "CA",
    "City": "Sultana"
  },
  {
    "State": "CA",
    "City": "Tollhouse"
  },
  {
    "State": "CA",
    "City": "Tranquillity"
  },
  {
    "State": "CA",
    "City": "Wishon"
  },
  {
    "State": "CA",
    "City": "Yettem"
  },
  {
    "State": "CA",
    "City": "Traver"
  },
  {
    "State": "CA",
    "City": "Squaw Valley"
  },
  {
    "State": "CA",
    "City": "Salinas"
  },
  {
    "State": "CA",
    "City": "Big Sur"
  },
  {
    "State": "CA",
    "City": "Carmel By The Sea"
  },
  {
    "State": "CA",
    "City": "Carmel"
  },
  {
    "State": "CA",
    "City": "Carmel Valley"
  },
  {
    "State": "CA",
    "City": "Chualar"
  },
  {
    "State": "CA",
    "City": "Gonzales"
  },
  {
    "State": "CA",
    "City": "Greenfield"
  },
  {
    "State": "CA",
    "City": "Jolon"
  },
  {
    "State": "CA",
    "City": "King City"
  },
  {
    "State": "CA",
    "City": "Lockwood"
  },
  {
    "State": "CA",
    "City": "Marina"
  },
  {
    "State": "CA",
    "City": "Monterey"
  },
  {
    "State": "CA",
    "City": "Pacific Grove"
  },
  {
    "State": "CA",
    "City": "Pebble Beach"
  },
  {
    "State": "CA",
    "City": "San Lucas"
  },
  {
    "State": "CA",
    "City": "Seaside"
  },
  {
    "State": "CA",
    "City": "Soledad"
  },
  {
    "State": "CA",
    "City": "Spreckels"
  },
  {
    "State": "CA",
    "City": "Belmont"
  },
  {
    "State": "CA",
    "City": "Brisbane"
  },
  {
    "State": "CA",
    "City": "Burlingame"
  },
  {
    "State": "CA",
    "City": "Daly City"
  },
  {
    "State": "CA",
    "City": "El Granada"
  },
  {
    "State": "CA",
    "City": "Half Moon Bay"
  },
  {
    "State": "CA",
    "City": "La Honda"
  },
  {
    "State": "CA",
    "City": "Loma Mar"
  },
  {
    "State": "CA",
    "City": "Los Altos"
  },
  {
    "State": "CA",
    "City": "Menlo Park"
  },
  {
    "State": "CA",
    "City": "Atherton"
  },
  {
    "State": "CA",
    "City": "Portola Valley"
  },
  {
    "State": "CA",
    "City": "Millbrae"
  },
  {
    "State": "CA",
    "City": "Mountain View"
  },
  {
    "State": "CA",
    "City": "Montara"
  },
  {
    "State": "CA",
    "City": "Moss Beach"
  },
  {
    "State": "CA",
    "City": "Pacifica"
  },
  {
    "State": "CA",
    "City": "Pescadero"
  },
  {
    "State": "CA",
    "City": "Redwood City"
  },
  {
    "State": "CA",
    "City": "San Bruno"
  },
  {
    "State": "CA",
    "City": "San Carlos"
  },
  {
    "State": "CA",
    "City": "San Gregorio"
  },
  {
    "State": "CA",
    "City": "South San Francisco"
  },
  {
    "State": "CA",
    "City": "Sunnyvale"
  },
  {
    "State": "CA",
    "City": "San Francisco"
  },
  {
    "State": "CA",
    "City": "Sacramento"
  },
  {
    "State": "CA",
    "City": "Palo Alto"
  },
  {
    "State": "CA",
    "City": "Stanford"
  },
  {
    "State": "CA",
    "City": "San Mateo"
  },
  {
    "State": "CA",
    "City": "Alameda"
  },
  {
    "State": "CA",
    "City": "American Canyon"
  },
  {
    "State": "CA",
    "City": "Discovery Bay"
  },
  {
    "State": "CA",
    "City": "Danville"
  },
  {
    "State": "CA",
    "City": "Alamo"
  },
  {
    "State": "CA",
    "City": "Angwin"
  },
  {
    "State": "CA",
    "City": "Antioch"
  },
  {
    "State": "CA",
    "City": "Benicia"
  },
  {
    "State": "CA",
    "City": "Bethel Island"
  },
  {
    "State": "CA",
    "City": "Birds Landing"
  },
  {
    "State": "CA",
    "City": "Brentwood"
  },
  {
    "State": "CA",
    "City": "Byron"
  },
  {
    "State": "CA",
    "City": "Calistoga"
  },
  {
    "State": "CA",
    "City": "Canyon"
  },
  {
    "State": "CA",
    "City": "Clayton"
  },
  {
    "State": "CA",
    "City": "Concord"
  },
  {
    "State": "CA",
    "City": "Pleasant Hill"
  },
  {
    "State": "CA",
    "City": "Crockett"
  },
  {
    "State": "CA",
    "City": "Diablo"
  },
  {
    "State": "CA",
    "City": "El Cerrito"
  },
  {
    "State": "CA",
    "City": "Fairfield"
  },
  {
    "State": "CA",
    "City": "Travis AFB"
  },
  {
    "State": "CA",
    "City": "Fremont"
  },
  {
    "State": "CA",
    "City": "Hayward"
  },
  {
    "State": "CA",
    "City": "Castro Valley"
  },
  {
    "State": "CA",
    "City": "Hercules"
  },
  {
    "State": "CA",
    "City": "Knightsen"
  },
  {
    "State": "CA",
    "City": "Lafayette"
  },
  {
    "State": "CA",
    "City": "Livermore"
  },
  {
    "State": "CA",
    "City": "Martinez"
  },
  {
    "State": "CA",
    "City": "Moraga"
  },
  {
    "State": "CA",
    "City": "Napa"
  },
  {
    "State": "CA",
    "City": "Newark"
  },
  {
    "State": "CA",
    "City": "Oakley"
  },
  {
    "State": "CA",
    "City": "Oakville"
  },
  {
    "State": "CA",
    "City": "Orinda"
  },
  {
    "State": "CA",
    "City": "Pinole"
  },
  {
    "State": "CA",
    "City": "Pittsburg"
  },
  {
    "State": "CA",
    "City": "Pleasanton"
  },
  {
    "State": "CA",
    "City": "Pope Valley"
  },
  {
    "State": "CA",
    "City": "Dublin"
  },
  {
    "State": "CA",
    "City": "Port Costa"
  },
  {
    "State": "CA",
    "City": "Rio Vista"
  },
  {
    "State": "CA",
    "City": "Rodeo"
  },
  {
    "State": "CA",
    "City": "Rutherford"
  },
  {
    "State": "CA",
    "City": "Saint Helena"
  },
  {
    "State": "CA",
    "City": "Deer Park"
  },
  {
    "State": "CA",
    "City": "San Leandro"
  },
  {
    "State": "CA",
    "City": "San Lorenzo"
  },
  {
    "State": "CA",
    "City": "San Ramon"
  },
  {
    "State": "CA",
    "City": "Suisun City"
  },
  {
    "State": "CA",
    "City": "Sunol"
  },
  {
    "State": "CA",
    "City": "Union City"
  },
  {
    "State": "CA",
    "City": "Vallejo"
  },
  {
    "State": "CA",
    "City": "Walnut Creek"
  },
  {
    "State": "CA",
    "City": "Yountville"
  },
  {
    "State": "CA",
    "City": "Oakland"
  },
  {
    "State": "CA",
    "City": "Emeryville"
  },
  {
    "State": "CA",
    "City": "Piedmont"
  },
  {
    "State": "CA",
    "City": "Berkeley"
  },
  {
    "State": "CA",
    "City": "Albany"
  },
  {
    "State": "CA",
    "City": "Richmond"
  },
  {
    "State": "CA",
    "City": "El Sobrante"
  },
  {
    "State": "CA",
    "City": "San Pablo"
  },
  {
    "State": "CA",
    "City": "San Rafael"
  },
  {
    "State": "CA",
    "City": "Greenbrae"
  },
  {
    "State": "CA",
    "City": "Kentfield"
  },
  {
    "State": "CA",
    "City": "Belvedere Tiburon"
  },
  {
    "State": "CA",
    "City": "Bodega"
  },
  {
    "State": "CA",
    "City": "Bodega Bay"
  },
  {
    "State": "CA",
    "City": "Bolinas"
  },
  {
    "State": "CA",
    "City": "Corte Madera"
  },
  {
    "State": "CA",
    "City": "Rohnert Park"
  },
  {
    "State": "CA",
    "City": "Dillon Beach"
  },
  {
    "State": "CA",
    "City": "Fairfax"
  },
  {
    "State": "CA",
    "City": "Cotati"
  },
  {
    "State": "CA",
    "City": "Forest Knolls"
  },
  {
    "State": "CA",
    "City": "Inverness"
  },
  {
    "State": "CA",
    "City": "Lagunitas"
  },
  {
    "State": "CA",
    "City": "Larkspur"
  },
  {
    "State": "CA",
    "City": "Marshall"
  },
  {
    "State": "CA",
    "City": "Mill Valley"
  },
  {
    "State": "CA",
    "City": "Novato"
  },
  {
    "State": "CA",
    "City": "Nicasio"
  },
  {
    "State": "CA",
    "City": "Olema"
  },
  {
    "State": "CA",
    "City": "Penngrove"
  },
  {
    "State": "CA",
    "City": "Petaluma"
  },
  {
    "State": "CA",
    "City": "Point Reyes Station"
  },
  {
    "State": "CA",
    "City": "Ross"
  },
  {
    "State": "CA",
    "City": "San Anselmo"
  },
  {
    "State": "CA",
    "City": "San Geronimo"
  },
  {
    "State": "CA",
    "City": "San Quentin"
  },
  {
    "State": "CA",
    "City": "Sausalito"
  },
  {
    "State": "CA",
    "City": "Stinson Beach"
  },
  {
    "State": "CA",
    "City": "Tomales"
  },
  {
    "State": "CA",
    "City": "Valley Ford"
  },
  {
    "State": "CA",
    "City": "Woodacre"
  },
  {
    "State": "CA",
    "City": "Aptos"
  },
  {
    "State": "CA",
    "City": "Alviso"
  },
  {
    "State": "CA",
    "City": "Aromas"
  },
  {
    "State": "CA",
    "City": "Ben Lomond"
  },
  {
    "State": "CA",
    "City": "Boulder Creek"
  },
  {
    "State": "CA",
    "City": "Brookdale"
  },
  {
    "State": "CA",
    "City": "Campbell"
  },
  {
    "State": "CA",
    "City": "Capitola"
  },
  {
    "State": "CA",
    "City": "Castroville"
  },
  {
    "State": "CA",
    "City": "Coyote"
  },
  {
    "State": "CA",
    "City": "Cupertino"
  },
  {
    "State": "CA",
    "City": "Davenport"
  },
  {
    "State": "CA",
    "City": "Felton"
  },
  {
    "State": "CA",
    "City": "Freedom"
  },
  {
    "State": "CA",
    "City": "Gilroy"
  },
  {
    "State": "CA",
    "City": "Hollister"
  },
  {
    "State": "CA",
    "City": "Holy City"
  },
  {
    "State": "CA",
    "City": "Los Gatos"
  },
  {
    "State": "CA",
    "City": "Milpitas"
  },
  {
    "State": "CA",
    "City": "Morgan Hill"
  },
  {
    "State": "CA",
    "City": "Moss Landing"
  },
  {
    "State": "CA",
    "City": "Mount Hermon"
  },
  {
    "State": "CA",
    "City": "New Almaden"
  },
  {
    "State": "CA",
    "City": "Paicines"
  },
  {
    "State": "CA",
    "City": "Redwood Estates"
  },
  {
    "State": "CA",
    "City": "San Juan Bautista"
  },
  {
    "State": "CA",
    "City": "San Martin"
  },
  {
    "State": "CA",
    "City": "Santa Clara"
  },
  {
    "State": "CA",
    "City": "Santa Cruz"
  },
  {
    "State": "CA",
    "City": "Scotts Valley"
  },
  {
    "State": "CA",
    "City": "Saratoga"
  },
  {
    "State": "CA",
    "City": "Soquel"
  },
  {
    "State": "CA",
    "City": "Tres Pinos"
  },
  {
    "State": "CA",
    "City": "Watsonville"
  },
  {
    "State": "CA",
    "City": "San Jose"
  },
  {
    "State": "CA",
    "City": "Mount Hamilton"
  },
  {
    "State": "CA",
    "City": "Stockton"
  },
  {
    "State": "CA",
    "City": "Acampo"
  },
  {
    "State": "CA",
    "City": "Altaville"
  },
  {
    "State": "CA",
    "City": "Angels Camp"
  },
  {
    "State": "CA",
    "City": "Arnold"
  },
  {
    "State": "CA",
    "City": "Avery"
  },
  {
    "State": "CA",
    "City": "Burson"
  },
  {
    "State": "CA",
    "City": "Campo Seco"
  },
  {
    "State": "CA",
    "City": "Clements"
  },
  {
    "State": "CA",
    "City": "Copperopolis"
  },
  {
    "State": "CA",
    "City": "Douglas Flat"
  },
  {
    "State": "CA",
    "City": "Farmington"
  },
  {
    "State": "CA",
    "City": "French Camp"
  },
  {
    "State": "CA",
    "City": "Glencoe"
  },
  {
    "State": "CA",
    "City": "Hathaway Pines"
  },
  {
    "State": "CA",
    "City": "Holt"
  },
  {
    "State": "CA",
    "City": "Linden"
  },
  {
    "State": "CA",
    "City": "Lockeford"
  },
  {
    "State": "CA",
    "City": "Lodi"
  },
  {
    "State": "CA",
    "City": "Mokelumne Hill"
  },
  {
    "State": "CA",
    "City": "Mountain Ranch"
  },
  {
    "State": "CA",
    "City": "Murphys"
  },
  {
    "State": "CA",
    "City": "Rail Road Flat"
  },
  {
    "State": "CA",
    "City": "San Andreas"
  },
  {
    "State": "CA",
    "City": "Vallecito"
  },
  {
    "State": "CA",
    "City": "Valley Springs"
  },
  {
    "State": "CA",
    "City": "Victor"
  },
  {
    "State": "CA",
    "City": "Wallace"
  },
  {
    "State": "CA",
    "City": "West Point"
  },
  {
    "State": "CA",
    "City": "Wilseyville"
  },
  {
    "State": "CA",
    "City": "Woodbridge"
  },
  {
    "State": "CA",
    "City": "Atwater"
  },
  {
    "State": "CA",
    "City": "Ballico"
  },
  {
    "State": "CA",
    "City": "Tracy"
  },
  {
    "State": "CA",
    "City": "Big Oak Flat"
  },
  {
    "State": "CA",
    "City": "Catheys Valley"
  },
  {
    "State": "CA",
    "City": "Ceres"
  },
  {
    "State": "CA",
    "City": "Chinese Camp"
  },
  {
    "State": "CA",
    "City": "Columbia"
  },
  {
    "State": "CA",
    "City": "Coulterville"
  },
  {
    "State": "CA",
    "City": "Cressey"
  },
  {
    "State": "CA",
    "City": "Crows Landing"
  },
  {
    "State": "CA",
    "City": "Pinecrest"
  },
  {
    "State": "CA",
    "City": "Delhi"
  },
  {
    "State": "CA",
    "City": "Denair"
  },
  {
    "State": "CA",
    "City": "El Nido"
  },
  {
    "State": "CA",
    "City": "El Portal"
  },
  {
    "State": "CA",
    "City": "Empire"
  },
  {
    "State": "CA",
    "City": "Escalon"
  },
  {
    "State": "CA",
    "City": "Groveland"
  },
  {
    "State": "CA",
    "City": "Gustine"
  },
  {
    "State": "CA",
    "City": "Hickman"
  },
  {
    "State": "CA",
    "City": "Hilmar"
  },
  {
    "State": "CA",
    "City": "Hornitos"
  },
  {
    "State": "CA",
    "City": "Hughson"
  },
  {
    "State": "CA",
    "City": "Jamestown"
  },
  {
    "State": "CA",
    "City": "Keyes"
  },
  {
    "State": "CA",
    "City": "La Grange"
  },
  {
    "State": "CA",
    "City": "Lathrop"
  },
  {
    "State": "CA",
    "City": "Le Grand"
  },
  {
    "State": "CA",
    "City": "Livingston"
  },
  {
    "State": "CA",
    "City": "Long Barn"
  },
  {
    "State": "CA",
    "City": "Manteca"
  },
  {
    "State": "CA",
    "City": "Mariposa"
  },
  {
    "State": "CA",
    "City": "Merced"
  },
  {
    "State": "CA",
    "City": "Midpines"
  },
  {
    "State": "CA",
    "City": "Mi Wuk Village"
  },
  {
    "State": "CA",
    "City": "Moccasin"
  },
  {
    "State": "CA",
    "City": "Modesto"
  },
  {
    "State": "CA",
    "City": "Newman"
  },
  {
    "State": "CA",
    "City": "Oakdale"
  },
  {
    "State": "CA",
    "City": "Patterson"
  },
  {
    "State": "CA",
    "City": "Planada"
  },
  {
    "State": "CA",
    "City": "Ripon"
  },
  {
    "State": "CA",
    "City": "Riverbank"
  },
  {
    "State": "CA",
    "City": "Salida"
  },
  {
    "State": "CA",
    "City": "Snelling"
  },
  {
    "State": "CA",
    "City": "Sonora"
  },
  {
    "State": "CA",
    "City": "Soulsbyville"
  },
  {
    "State": "CA",
    "City": "Standard"
  },
  {
    "State": "CA",
    "City": "Stevinson"
  },
  {
    "State": "CA",
    "City": "Strawberry"
  },
  {
    "State": "CA",
    "City": "Tuolumne"
  },
  {
    "State": "CA",
    "City": "Turlock"
  },
  {
    "State": "CA",
    "City": "Twain Harte"
  },
  {
    "State": "CA",
    "City": "Vernalis"
  },
  {
    "State": "CA",
    "City": "Waterford"
  },
  {
    "State": "CA",
    "City": "Westley"
  },
  {
    "State": "CA",
    "City": "Winton"
  },
  {
    "State": "CA",
    "City": "Yosemite National Park"
  },
  {
    "State": "CA",
    "City": "Santa Rosa"
  },
  {
    "State": "CA",
    "City": "Albion"
  },
  {
    "State": "CA",
    "City": "Annapolis"
  },
  {
    "State": "CA",
    "City": "Boonville"
  },
  {
    "State": "CA",
    "City": "Boyes Hot Springs"
  },
  {
    "State": "CA",
    "City": "Branscomb"
  },
  {
    "State": "CA",
    "City": "Calpella"
  },
  {
    "State": "CA",
    "City": "Camp Meeker"
  },
  {
    "State": "CA",
    "City": "Caspar"
  },
  {
    "State": "CA",
    "City": "Cazadero"
  },
  {
    "State": "CA",
    "City": "Clearlake"
  },
  {
    "State": "CA",
    "City": "Clearlake Oaks"
  },
  {
    "State": "CA",
    "City": "Clearlake Park"
  },
  {
    "State": "CA",
    "City": "Cloverdale"
  },
  {
    "State": "CA",
    "City": "Cobb"
  },
  {
    "State": "CA",
    "City": "Comptche"
  },
  {
    "State": "CA",
    "City": "Covelo"
  },
  {
    "State": "CA",
    "City": "Dos Rios"
  },
  {
    "State": "CA",
    "City": "Duncans Mills"
  },
  {
    "State": "CA",
    "City": "Eldridge"
  },
  {
    "State": "CA",
    "City": "Elk"
  },
  {
    "State": "CA",
    "City": "El Verano"
  },
  {
    "State": "CA",
    "City": "Finley"
  },
  {
    "State": "CA",
    "City": "Forestville"
  },
  {
    "State": "CA",
    "City": "Fort Bragg"
  },
  {
    "State": "CA",
    "City": "Fulton"
  },
  {
    "State": "CA",
    "City": "Geyserville"
  },
  {
    "State": "CA",
    "City": "Glen Ellen"
  },
  {
    "State": "CA",
    "City": "Glenhaven"
  },
  {
    "State": "CA",
    "City": "Graton"
  },
  {
    "State": "CA",
    "City": "Gualala"
  },
  {
    "State": "CA",
    "City": "Guerneville"
  },
  {
    "State": "CA",
    "City": "Healdsburg"
  },
  {
    "State": "CA",
    "City": "Hopland"
  },
  {
    "State": "CA",
    "City": "Jenner"
  },
  {
    "State": "CA",
    "City": "Kelseyville"
  },
  {
    "State": "CA",
    "City": "Kenwood"
  },
  {
    "State": "CA",
    "City": "Lakeport"
  },
  {
    "State": "CA",
    "City": "Laytonville"
  },
  {
    "State": "CA",
    "City": "Little River"
  },
  {
    "State": "CA",
    "City": "Lower Lake"
  },
  {
    "State": "CA",
    "City": "Lucerne"
  },
  {
    "State": "CA",
    "City": "Manchester"
  },
  {
    "State": "CA",
    "City": "Mendocino"
  },
  {
    "State": "CA",
    "City": "Middletown"
  },
  {
    "State": "CA",
    "City": "Monte Rio"
  },
  {
    "State": "CA",
    "City": "Navarro"
  },
  {
    "State": "CA",
    "City": "Nice"
  },
  {
    "State": "CA",
    "City": "Occidental"
  },
  {
    "State": "CA",
    "City": "Philo"
  },
  {
    "State": "CA",
    "City": "Hidden Valley Lake"
  },
  {
    "State": "CA",
    "City": "Point Arena"
  },
  {
    "State": "CA",
    "City": "Potter Valley"
  },
  {
    "State": "CA",
    "City": "Redwood Valley"
  },
  {
    "State": "CA",
    "City": "Rio Nido"
  },
  {
    "State": "CA",
    "City": "Sebastopol"
  },
  {
    "State": "CA",
    "City": "Sonoma"
  },
  {
    "State": "CA",
    "City": "Stewarts Point"
  },
  {
    "State": "CA",
    "City": "Talmage"
  },
  {
    "State": "CA",
    "City": "Ukiah"
  },
  {
    "State": "CA",
    "City": "Upper Lake"
  },
  {
    "State": "CA",
    "City": "Villa Grande"
  },
  {
    "State": "CA",
    "City": "Vineburg"
  },
  {
    "State": "CA",
    "City": "Westport"
  },
  {
    "State": "CA",
    "City": "Willits"
  },
  {
    "State": "CA",
    "City": "Windsor"
  },
  {
    "State": "CA",
    "City": "Witter Springs"
  },
  {
    "State": "CA",
    "City": "Yorkville"
  },
  {
    "State": "CA",
    "City": "The Sea Ranch"
  },
  {
    "State": "CA",
    "City": "Eureka"
  },
  {
    "State": "CA",
    "City": "Alderpoint"
  },
  {
    "State": "CA",
    "City": "Blocksburg"
  },
  {
    "State": "CA",
    "City": "Arcata"
  },
  {
    "State": "CA",
    "City": "Mckinleyville"
  },
  {
    "State": "CA",
    "City": "Bayside"
  },
  {
    "State": "CA",
    "City": "Blue Lake"
  },
  {
    "State": "CA",
    "City": "Bridgeville"
  },
  {
    "State": "CA",
    "City": "Burnt Ranch"
  },
  {
    "State": "CA",
    "City": "Carlotta"
  },
  {
    "State": "CA",
    "City": "Crescent City"
  },
  {
    "State": "CA",
    "City": "Cutten"
  },
  {
    "State": "CA",
    "City": "Ferndale"
  },
  {
    "State": "CA",
    "City": "Fields Landing"
  },
  {
    "State": "CA",
    "City": "Fort Dick"
  },
  {
    "State": "CA",
    "City": "Fortuna"
  },
  {
    "State": "CA",
    "City": "Garberville"
  },
  {
    "State": "CA",
    "City": "Gasquet"
  },
  {
    "State": "CA",
    "City": "Honeydew"
  },
  {
    "State": "CA",
    "City": "Hoopa"
  },
  {
    "State": "CA",
    "City": "Hydesville"
  },
  {
    "State": "CA",
    "City": "Klamath"
  },
  {
    "State": "CA",
    "City": "Kneeland"
  },
  {
    "State": "CA",
    "City": "Korbel"
  },
  {
    "State": "CA",
    "City": "Loleta"
  },
  {
    "State": "CA",
    "City": "Mad River"
  },
  {
    "State": "CA",
    "City": "Miranda"
  },
  {
    "State": "CA",
    "City": "Myers Flat"
  },
  {
    "State": "CA",
    "City": "Orick"
  },
  {
    "State": "CA",
    "City": "Orleans"
  },
  {
    "State": "CA",
    "City": "Petrolia"
  },
  {
    "State": "CA",
    "City": "Phillipsville"
  },
  {
    "State": "CA",
    "City": "Redway"
  },
  {
    "State": "CA",
    "City": "Rio Dell"
  },
  {
    "State": "CA",
    "City": "Salyer"
  },
  {
    "State": "CA",
    "City": "Samoa"
  },
  {
    "State": "CA",
    "City": "Scotia"
  },
  {
    "State": "CA",
    "City": "Smith River"
  },
  {
    "State": "CA",
    "City": "Somes Bar"
  },
  {
    "State": "CA",
    "City": "Redcrest"
  },
  {
    "State": "CA",
    "City": "Trinidad"
  },
  {
    "State": "CA",
    "City": "Weott"
  },
  {
    "State": "CA",
    "City": "Willow Creek"
  },
  {
    "State": "CA",
    "City": "Leggett"
  },
  {
    "State": "CA",
    "City": "Piercy"
  },
  {
    "State": "CA",
    "City": "Whitethorn"
  },
  {
    "State": "CA",
    "City": "Zenia"
  },
  {
    "State": "CA",
    "City": "Amador City"
  },
  {
    "State": "CA",
    "City": "Auburn"
  },
  {
    "State": "CA",
    "City": "West Sacramento"
  },
  {
    "State": "CA",
    "City": "Brooks"
  },
  {
    "State": "CA",
    "City": "Capay"
  },
  {
    "State": "CA",
    "City": "Carmichael"
  },
  {
    "State": "CA",
    "City": "Citrus Heights"
  },
  {
    "State": "CA",
    "City": "Clarksburg"
  },
  {
    "State": "CA",
    "City": "Coloma"
  },
  {
    "State": "CA",
    "City": "Cool"
  },
  {
    "State": "CA",
    "City": "Courtland"
  },
  {
    "State": "CA",
    "City": "Davis"
  },
  {
    "State": "CA",
    "City": "Diamond Springs"
  },
  {
    "State": "CA",
    "City": "Dixon"
  },
  {
    "State": "CA",
    "City": "El Dorado"
  },
  {
    "State": "CA",
    "City": "Elk Grove"
  },
  {
    "State": "CA",
    "City": "Elmira"
  },
  {
    "State": "CA",
    "City": "Elverta"
  },
  {
    "State": "CA",
    "City": "Esparto"
  },
  {
    "State": "CA",
    "City": "Fair Oaks"
  },
  {
    "State": "CA",
    "City": "Fiddletown"
  },
  {
    "State": "CA",
    "City": "Folsom"
  },
  {
    "State": "CA",
    "City": "Foresthill"
  },
  {
    "State": "CA",
    "City": "Galt"
  },
  {
    "State": "CA",
    "City": "Garden Valley"
  },
  {
    "State": "CA",
    "City": "Georgetown"
  },
  {
    "State": "CA",
    "City": "Greenwood"
  },
  {
    "State": "CA",
    "City": "Grizzly Flats"
  },
  {
    "State": "CA",
    "City": "Guinda"
  },
  {
    "State": "CA",
    "City": "Herald"
  },
  {
    "State": "CA",
    "City": "Hood"
  },
  {
    "State": "CA",
    "City": "Ione"
  },
  {
    "State": "CA",
    "City": "Isleton"
  },
  {
    "State": "CA",
    "City": "Jackson"
  },
  {
    "State": "CA",
    "City": "Kit Carson"
  },
  {
    "State": "CA",
    "City": "Knights Landing"
  },
  {
    "State": "CA",
    "City": "Kirkwood"
  },
  {
    "State": "CA",
    "City": "Lincoln"
  },
  {
    "State": "CA",
    "City": "Loomis"
  },
  {
    "State": "CA",
    "City": "Lotus"
  },
  {
    "State": "CA",
    "City": "Mcclellan"
  },
  {
    "State": "CA",
    "City": "Madison"
  },
  {
    "State": "CA",
    "City": "Martell"
  },
  {
    "State": "CA",
    "City": "Mather"
  },
  {
    "State": "CA",
    "City": "Mount Aukum"
  },
  {
    "State": "CA",
    "City": "Newcastle"
  },
  {
    "State": "CA",
    "City": "Nicolaus"
  },
  {
    "State": "CA",
    "City": "North Highlands"
  },
  {
    "State": "CA",
    "City": "Roseville"
  },
  {
    "State": "CA",
    "City": "Orangevale"
  },
  {
    "State": "CA",
    "City": "Penryn"
  },
  {
    "State": "CA",
    "City": "Pilot Hill"
  },
  {
    "State": "CA",
    "City": "Pine Grove"
  },
  {
    "State": "CA",
    "City": "Pioneer"
  },
  {
    "State": "CA",
    "City": "Placerville"
  },
  {
    "State": "CA",
    "City": "Pleasant Grove"
  },
  {
    "State": "CA",
    "City": "Plymouth"
  },
  {
    "State": "CA",
    "City": "Rancho Cordova"
  },
  {
    "State": "CA",
    "City": "Represa"
  },
  {
    "State": "CA",
    "City": "Rescue"
  },
  {
    "State": "CA",
    "City": "Rio Linda"
  },
  {
    "State": "CA",
    "City": "Rio Oso"
  },
  {
    "State": "CA",
    "City": "River Pines"
  },
  {
    "State": "CA",
    "City": "Robbins"
  },
  {
    "State": "CA",
    "City": "Rocklin"
  },
  {
    "State": "CA",
    "City": "Rumsey"
  },
  {
    "State": "CA",
    "City": "Ryde"
  },
  {
    "State": "CA",
    "City": "Sheridan"
  },
  {
    "State": "CA",
    "City": "Shingle Springs"
  },
  {
    "State": "CA",
    "City": "Sloughhouse"
  },
  {
    "State": "CA",
    "City": "Somerset"
  },
  {
    "State": "CA",
    "City": "Sutter Creek"
  },
  {
    "State": "CA",
    "City": "Thornton"
  },
  {
    "State": "CA",
    "City": "Vacaville"
  },
  {
    "State": "CA",
    "City": "Volcano"
  },
  {
    "State": "CA",
    "City": "Walnut Grove"
  },
  {
    "State": "CA",
    "City": "Wheatland"
  },
  {
    "State": "CA",
    "City": "Wilton"
  },
  {
    "State": "CA",
    "City": "Winters"
  },
  {
    "State": "CA",
    "City": "Woodland"
  },
  {
    "State": "CA",
    "City": "Yolo"
  },
  {
    "State": "CA",
    "City": "Zamora"
  },
  {
    "State": "CA",
    "City": "Drytown"
  },
  {
    "State": "CA",
    "City": "Alta"
  },
  {
    "State": "CA",
    "City": "Applegate"
  },
  {
    "State": "CA",
    "City": "Camino"
  },
  {
    "State": "CA",
    "City": "Chicago Park"
  },
  {
    "State": "CA",
    "City": "Colfax"
  },
  {
    "State": "CA",
    "City": "Dutch Flat"
  },
  {
    "State": "CA",
    "City": "Emigrant Gap"
  },
  {
    "State": "CA",
    "City": "Gold Run"
  },
  {
    "State": "CA",
    "City": "Kyburz"
  },
  {
    "State": "CA",
    "City": "Echo Lake"
  },
  {
    "State": "CA",
    "City": "Meadow Vista"
  },
  {
    "State": "CA",
    "City": "Norden"
  },
  {
    "State": "CA",
    "City": "Pollock Pines"
  },
  {
    "State": "CA",
    "City": "Soda Springs"
  },
  {
    "State": "CA",
    "City": "Twin Bridges"
  },
  {
    "State": "CA",
    "City": "Weimar"
  },
  {
    "State": "CA",
    "City": "Granite Bay"
  },
  {
    "State": "CA",
    "City": "El Dorado Hills"
  },
  {
    "State": "CA",
    "City": "Antelope"
  },
  {
    "State": "CA",
    "City": "Marysville"
  },
  {
    "State": "CA",
    "City": "Beale AFB"
  },
  {
    "State": "CA",
    "City": "Alleghany"
  },
  {
    "State": "CA",
    "City": "Arbuckle"
  },
  {
    "State": "CA",
    "City": "Artois"
  },
  {
    "State": "CA",
    "City": "Bangor"
  },
  {
    "State": "CA",
    "City": "Belden"
  },
  {
    "State": "CA",
    "City": "Berry Creek"
  },
  {
    "State": "CA",
    "City": "Biggs"
  },
  {
    "State": "CA",
    "City": "Browns Valley"
  },
  {
    "State": "CA",
    "City": "Brownsville"
  },
  {
    "State": "CA",
    "City": "Butte City"
  },
  {
    "State": "CA",
    "City": "Camptonville"
  },
  {
    "State": "CA",
    "City": "Canyon Dam"
  },
  {
    "State": "CA",
    "City": "Cedar Ridge"
  },
  {
    "State": "CA",
    "City": "Challenge"
  },
  {
    "State": "CA",
    "City": "Chico"
  },
  {
    "State": "CA",
    "City": "Clipper Mills"
  },
  {
    "State": "CA",
    "City": "Colusa"
  },
  {
    "State": "CA",
    "City": "Crescent Mills"
  },
  {
    "State": "CA",
    "City": "Dobbins"
  },
  {
    "State": "CA",
    "City": "Downieville"
  },
  {
    "State": "CA",
    "City": "Dunnigan"
  },
  {
    "State": "CA",
    "City": "Durham"
  },
  {
    "State": "CA",
    "City": "Elk Creek"
  },
  {
    "State": "CA",
    "City": "Feather Falls"
  },
  {
    "State": "CA",
    "City": "Forbestown"
  },
  {
    "State": "CA",
    "City": "Forest Ranch"
  },
  {
    "State": "CA",
    "City": "Glenn"
  },
  {
    "State": "CA",
    "City": "Goodyears Bar"
  },
  {
    "State": "CA",
    "City": "Grass Valley"
  },
  {
    "State": "CA",
    "City": "Penn Valley"
  },
  {
    "State": "CA",
    "City": "Greenville"
  },
  {
    "State": "CA",
    "City": "Gridley"
  },
  {
    "State": "CA",
    "City": "Grimes"
  },
  {
    "State": "CA",
    "City": "Hamilton City"
  },
  {
    "State": "CA",
    "City": "Live Oak"
  },
  {
    "State": "CA",
    "City": "Magalia"
  },
  {
    "State": "CA",
    "City": "Maxwell"
  },
  {
    "State": "CA",
    "City": "Meadow Valley"
  },
  {
    "State": "CA",
    "City": "Meridian"
  },
  {
    "State": "CA",
    "City": "Nelson"
  },
  {
    "State": "CA",
    "City": "Nevada City"
  },
  {
    "State": "CA",
    "City": "North San Juan"
  },
  {
    "State": "CA",
    "City": "Olivehurst"
  },
  {
    "State": "CA",
    "City": "Oregon House"
  },
  {
    "State": "CA",
    "City": "Orland"
  },
  {
    "State": "CA",
    "City": "Oroville"
  },
  {
    "State": "CA",
    "City": "Paradise"
  },
  {
    "State": "CA",
    "City": "Palermo"
  },
  {
    "State": "CA",
    "City": "Princeton"
  },
  {
    "State": "CA",
    "City": "Quincy"
  },
  {
    "State": "CA",
    "City": "Rackerby"
  },
  {
    "State": "CA",
    "City": "Richvale"
  },
  {
    "State": "CA",
    "City": "Rough And Ready"
  },
  {
    "State": "CA",
    "City": "Smartsville"
  },
  {
    "State": "CA",
    "City": "Stirling City"
  },
  {
    "State": "CA",
    "City": "Stonyford"
  },
  {
    "State": "CA",
    "City": "Storrie"
  },
  {
    "State": "CA",
    "City": "Strawberry Valley"
  },
  {
    "State": "CA",
    "City": "Sutter"
  },
  {
    "State": "CA",
    "City": "Taylorsville"
  },
  {
    "State": "CA",
    "City": "Twain"
  },
  {
    "State": "CA",
    "City": "Washington"
  },
  {
    "State": "CA",
    "City": "Williams"
  },
  {
    "State": "CA",
    "City": "Willows"
  },
  {
    "State": "CA",
    "City": "Yuba City"
  },
  {
    "State": "CA",
    "City": "Redding"
  },
  {
    "State": "CA",
    "City": "Adin"
  },
  {
    "State": "CA",
    "City": "Anderson"
  },
  {
    "State": "CA",
    "City": "Bella Vista"
  },
  {
    "State": "CA",
    "City": "Bieber"
  },
  {
    "State": "CA",
    "City": "Big Bar"
  },
  {
    "State": "CA",
    "City": "Big Bend"
  },
  {
    "State": "CA",
    "City": "Burney"
  },
  {
    "State": "CA",
    "City": "Callahan"
  },
  {
    "State": "CA",
    "City": "Canby"
  },
  {
    "State": "CA",
    "City": "Cassel"
  },
  {
    "State": "CA",
    "City": "Castella"
  },
  {
    "State": "CA",
    "City": "Shasta Lake"
  },
  {
    "State": "CA",
    "City": "Chester"
  },
  {
    "State": "CA",
    "City": "Corning"
  },
  {
    "State": "CA",
    "City": "Cottonwood"
  },
  {
    "State": "CA",
    "City": "Dorris"
  },
  {
    "State": "CA",
    "City": "Douglas City"
  },
  {
    "State": "CA",
    "City": "Dunsmuir"
  },
  {
    "State": "CA",
    "City": "Etna"
  },
  {
    "State": "CA",
    "City": "Fall River Mills"
  },
  {
    "State": "CA",
    "City": "Flournoy"
  },
  {
    "State": "CA",
    "City": "Forks Of Salmon"
  },
  {
    "State": "CA",
    "City": "Fort Jones"
  },
  {
    "State": "CA",
    "City": "French Gulch"
  },
  {
    "State": "CA",
    "City": "Gazelle"
  },
  {
    "State": "CA",
    "City": "Gerber"
  },
  {
    "State": "CA",
    "City": "Greenview"
  },
  {
    "State": "CA",
    "City": "Grenada"
  },
  {
    "State": "CA",
    "City": "Happy Camp"
  },
  {
    "State": "CA",
    "City": "Hat Creek"
  },
  {
    "State": "CA",
    "City": "Hayfork"
  },
  {
    "State": "CA",
    "City": "Hornbrook"
  },
  {
    "State": "CA",
    "City": "Hyampom"
  },
  {
    "State": "CA",
    "City": "Igo"
  },
  {
    "State": "CA",
    "City": "Junction City"
  },
  {
    "State": "CA",
    "City": "Klamath River"
  },
  {
    "State": "CA",
    "City": "Lakehead"
  },
  {
    "State": "CA",
    "City": "Lewiston"
  },
  {
    "State": "CA",
    "City": "Lookout"
  },
  {
    "State": "CA",
    "City": "Los Molinos"
  },
  {
    "State": "CA",
    "City": "Mcarthur"
  },
  {
    "State": "CA",
    "City": "Mccloud"
  },
  {
    "State": "CA",
    "City": "Macdoel"
  },
  {
    "State": "CA",
    "City": "Manton"
  },
  {
    "State": "CA",
    "City": "Mill Creek"
  },
  {
    "State": "CA",
    "City": "Millville"
  },
  {
    "State": "CA",
    "City": "Mineral"
  },
  {
    "State": "CA",
    "City": "Montague"
  },
  {
    "State": "CA",
    "City": "Montgomery Creek"
  },
  {
    "State": "CA",
    "City": "Mount Shasta"
  },
  {
    "State": "CA",
    "City": "Nubieber"
  },
  {
    "State": "CA",
    "City": "Oak Run"
  },
  {
    "State": "CA",
    "City": "Obrien"
  },
  {
    "State": "CA",
    "City": "Old Station"
  },
  {
    "State": "CA",
    "City": "Palo Cedro"
  },
  {
    "State": "CA",
    "City": "Paskenta"
  },
  {
    "State": "CA",
    "City": "Paynes Creek"
  },
  {
    "State": "CA",
    "City": "Platina"
  },
  {
    "State": "CA",
    "City": "Proberta"
  },
  {
    "State": "CA",
    "City": "Red Bluff"
  },
  {
    "State": "CA",
    "City": "Round Mountain"
  },
  {
    "State": "CA",
    "City": "Scott Bar"
  },
  {
    "State": "CA",
    "City": "Seiad Valley"
  },
  {
    "State": "CA",
    "City": "Shasta"
  },
  {
    "State": "CA",
    "City": "Shingletown"
  },
  {
    "State": "CA",
    "City": "Tehama"
  },
  {
    "State": "CA",
    "City": "Trinity Center"
  },
  {
    "State": "CA",
    "City": "Vina"
  },
  {
    "State": "CA",
    "City": "Weaverville"
  },
  {
    "State": "CA",
    "City": "Weed"
  },
  {
    "State": "CA",
    "City": "Whiskeytown"
  },
  {
    "State": "CA",
    "City": "Whitmore"
  },
  {
    "State": "CA",
    "City": "Yreka"
  },
  {
    "State": "CA",
    "City": "Alturas"
  },
  {
    "State": "CA",
    "City": "Blairsden Graeagle"
  },
  {
    "State": "CA",
    "City": "Cedarville"
  },
  {
    "State": "CA",
    "City": "Chilcoot"
  },
  {
    "State": "CA",
    "City": "Clio"
  },
  {
    "State": "CA",
    "City": "Coleville"
  },
  {
    "State": "CA",
    "City": "Davis Creek"
  },
  {
    "State": "CA",
    "City": "Doyle"
  },
  {
    "State": "CA",
    "City": "Eagleville"
  },
  {
    "State": "CA",
    "City": "Floriston"
  },
  {
    "State": "CA",
    "City": "Fort Bidwell"
  },
  {
    "State": "CA",
    "City": "Herlong"
  },
  {
    "State": "CA",
    "City": "Janesville"
  },
  {
    "State": "CA",
    "City": "Lake City"
  },
  {
    "State": "CA",
    "City": "Likely"
  },
  {
    "State": "CA",
    "City": "Litchfield"
  },
  {
    "State": "CA",
    "City": "Loyalton"
  },
  {
    "State": "CA",
    "City": "Madeline"
  },
  {
    "State": "CA",
    "City": "Markleeville"
  },
  {
    "State": "CA",
    "City": "Milford"
  },
  {
    "State": "CA",
    "City": "Portola"
  },
  {
    "State": "CA",
    "City": "Ravendale"
  },
  {
    "State": "CA",
    "City": "Calpine"
  },
  {
    "State": "CA",
    "City": "Sierra City"
  },
  {
    "State": "CA",
    "City": "Sierraville"
  },
  {
    "State": "CA",
    "City": "Susanville"
  },
  {
    "State": "CA",
    "City": "Standish"
  },
  {
    "State": "CA",
    "City": "Beckwourth"
  },
  {
    "State": "CA",
    "City": "Termo"
  },
  {
    "State": "CA",
    "City": "Topaz"
  },
  {
    "State": "CA",
    "City": "Tulelake"
  },
  {
    "State": "CA",
    "City": "Vinton"
  },
  {
    "State": "CA",
    "City": "Wendel"
  },
  {
    "State": "CA",
    "City": "Westwood"
  },
  {
    "State": "CA",
    "City": "Carnelian Bay"
  },
  {
    "State": "CA",
    "City": "Homewood"
  },
  {
    "State": "CA",
    "City": "Tahoma"
  },
  {
    "State": "CA",
    "City": "Kings Beach"
  },
  {
    "State": "CA",
    "City": "Tahoe City"
  },
  {
    "State": "CA",
    "City": "Olympic Valley"
  },
  {
    "State": "CA",
    "City": "Tahoe Vista"
  },
  {
    "State": "CA",
    "City": "South Lake Tahoe"
  },
  {
    "State": "CA",
    "City": "Truckee"
  },
  {
    "State": "AP",
    "City": "Apo"
  },
  {
    "State": "AP",
    "City": "Dpo"
  },
  {
    "State": "AP",
    "City": "Fpo"
  },
  {
    "State": "HI",
    "City": "Aiea"
  },
  {
    "State": "HI",
    "City": "Anahola"
  },
  {
    "State": "HI",
    "City": "Captain Cook"
  },
  {
    "State": "HI",
    "City": "Eleele"
  },
  {
    "State": "HI",
    "City": "Ewa Beach"
  },
  {
    "State": "HI",
    "City": "Kapolei"
  },
  {
    "State": "HI",
    "City": "Haiku"
  },
  {
    "State": "HI",
    "City": "Hakalau"
  },
  {
    "State": "HI",
    "City": "Haleiwa"
  },
  {
    "State": "HI",
    "City": "Hana"
  },
  {
    "State": "HI",
    "City": "Hanalei"
  },
  {
    "State": "HI",
    "City": "Hanamaulu"
  },
  {
    "State": "HI",
    "City": "Hanapepe"
  },
  {
    "State": "HI",
    "City": "Hauula"
  },
  {
    "State": "HI",
    "City": "Hawaii National Park"
  },
  {
    "State": "HI",
    "City": "Hawi"
  },
  {
    "State": "HI",
    "City": "Hilo"
  },
  {
    "State": "HI",
    "City": "Princeville"
  },
  {
    "State": "HI",
    "City": "Holualoa"
  },
  {
    "State": "HI",
    "City": "Honaunau"
  },
  {
    "State": "HI",
    "City": "Honokaa"
  },
  {
    "State": "HI",
    "City": "Honomu"
  },
  {
    "State": "HI",
    "City": "Hoolehua"
  },
  {
    "State": "HI",
    "City": "Kaaawa"
  },
  {
    "State": "HI",
    "City": "Kahuku"
  },
  {
    "State": "HI",
    "City": "Kahului"
  },
  {
    "State": "HI",
    "City": "Kailua"
  },
  {
    "State": "HI",
    "City": "Ocean View"
  },
  {
    "State": "HI",
    "City": "Waikoloa"
  },
  {
    "State": "HI",
    "City": "Keauhou"
  },
  {
    "State": "HI",
    "City": "Kailua Kona"
  },
  {
    "State": "HI",
    "City": "Kalaheo"
  },
  {
    "State": "HI",
    "City": "Kalaupapa"
  },
  {
    "State": "HI",
    "City": "Kamuela"
  },
  {
    "State": "HI",
    "City": "Kaneohe"
  },
  {
    "State": "HI",
    "City": "Kapaa"
  },
  {
    "State": "HI",
    "City": "Kaumakani"
  },
  {
    "State": "HI",
    "City": "Kaunakakai"
  },
  {
    "State": "HI",
    "City": "Keaau"
  },
  {
    "State": "HI",
    "City": "Kealakekua"
  },
  {
    "State": "HI",
    "City": "Kealia"
  },
  {
    "State": "HI",
    "City": "Kekaha"
  },
  {
    "State": "HI",
    "City": "Kihei"
  },
  {
    "State": "HI",
    "City": "Kilauea"
  },
  {
    "State": "HI",
    "City": "Kapaau"
  },
  {
    "State": "HI",
    "City": "Koloa"
  },
  {
    "State": "HI",
    "City": "Kualapuu"
  },
  {
    "State": "HI",
    "City": "Kunia"
  },
  {
    "State": "HI",
    "City": "Kurtistown"
  },
  {
    "State": "HI",
    "City": "Lahaina"
  },
  {
    "State": "HI",
    "City": "Laie"
  },
  {
    "State": "HI",
    "City": "Lanai City"
  },
  {
    "State": "HI",
    "City": "Laupahoehoe"
  },
  {
    "State": "HI",
    "City": "Lawai"
  },
  {
    "State": "HI",
    "City": "Lihue"
  },
  {
    "State": "HI",
    "City": "Makawao"
  },
  {
    "State": "HI",
    "City": "Makaweli"
  },
  {
    "State": "HI",
    "City": "Maunaloa"
  },
  {
    "State": "HI",
    "City": "Mountain View"
  },
  {
    "State": "HI",
    "City": "Naalehu"
  },
  {
    "State": "HI",
    "City": "Ninole"
  },
  {
    "State": "HI",
    "City": "Ookala"
  },
  {
    "State": "HI",
    "City": "Paauilo"
  },
  {
    "State": "HI",
    "City": "Pahala"
  },
  {
    "State": "HI",
    "City": "Pahoa"
  },
  {
    "State": "HI",
    "City": "Paia"
  },
  {
    "State": "HI",
    "City": "Papaaloa"
  },
  {
    "State": "HI",
    "City": "Papaikou"
  },
  {
    "State": "HI",
    "City": "Pearl City"
  },
  {
    "State": "HI",
    "City": "Pepeekeo"
  },
  {
    "State": "HI",
    "City": "Puunene"
  },
  {
    "State": "HI",
    "City": "Volcano"
  },
  {
    "State": "HI",
    "City": "Wahiawa"
  },
  {
    "State": "HI",
    "City": "Pukalani"
  },
  {
    "State": "HI",
    "City": "Mililani"
  },
  {
    "State": "HI",
    "City": "Kula"
  },
  {
    "State": "HI",
    "City": "Waialua"
  },
  {
    "State": "HI",
    "City": "Waianae"
  },
  {
    "State": "HI",
    "City": "Wailuku"
  },
  {
    "State": "HI",
    "City": "Waimanalo"
  },
  {
    "State": "HI",
    "City": "Waimea"
  },
  {
    "State": "HI",
    "City": "Waipahu"
  },
  {
    "State": "AS",
    "City": "Pago Pago"
  },
  {
    "State": "HI",
    "City": "Honolulu"
  },
  {
    "State": "HI",
    "City": "Jbphh"
  },
  {
    "State": "HI",
    "City": "Wheeler Army Airfield"
  },
  {
    "State": "HI",
    "City": "Schofield Barracks"
  },
  {
    "State": "HI",
    "City": "Fort Shafter"
  },
  {
    "State": "HI",
    "City": "Tripler Army Medical Center"
  },
  {
    "State": "HI",
    "City": "Camp H M Smith"
  },
  {
    "State": "HI",
    "City": "Mcbh Kaneohe Bay"
  },
  {
    "State": "HI",
    "City": "Wake Island"
  },
  {
    "State": "GU",
    "City": "Hagatna"
  },
  {
    "State": "GU",
    "City": "Dededo"
  },
  {
    "State": "GU",
    "City": "Barrigada"
  },
  {
    "State": "GU",
    "City": "Santa Rita"
  },
  {
    "State": "GU",
    "City": "Merizo"
  },
  {
    "State": "GU",
    "City": "Inarajan"
  },
  {
    "State": "GU",
    "City": "Agana Heights"
  },
  {
    "State": "GU",
    "City": "Mangilao"
  },
  {
    "State": "GU",
    "City": "Agat"
  },
  {
    "State": "GU",
    "City": "Yigo"
  },
  {
    "State": "GU",
    "City": "Tamuning"
  },
  {
    "State": "PW",
    "City": "Ngerulmud"
  },
  {
    "State": "PW",
    "City": "Koror"
  },
  {
    "State": "FM",
    "City": "Pohnpei"
  },
  {
    "State": "FM",
    "City": "Chuuk"
  },
  {
    "State": "FM",
    "City": "Yap"
  },
  {
    "State": "FM",
    "City": "Kosrae"
  },
  {
    "State": "MP",
    "City": "Saipan"
  },
  {
    "State": "MP",
    "City": "Rota"
  },
  {
    "State": "MP",
    "City": "Tinian"
  },
  {
    "State": "MH",
    "City": "Majuro"
  },
  {
    "State": "MH",
    "City": "Ebeye"
  },
  {
    "State": "OR",
    "City": "Antelope"
  },
  {
    "State": "OR",
    "City": "Aurora"
  },
  {
    "State": "OR",
    "City": "Beaverton"
  },
  {
    "State": "OR",
    "City": "Beavercreek"
  },
  {
    "State": "OR",
    "City": "Boring"
  },
  {
    "State": "OR",
    "City": "Bridal Veil"
  },
  {
    "State": "OR",
    "City": "Brightwood"
  },
  {
    "State": "OR",
    "City": "Canby"
  },
  {
    "State": "OR",
    "City": "Cascade Locks"
  },
  {
    "State": "OR",
    "City": "Clackamas"
  },
  {
    "State": "OR",
    "City": "Clatskanie"
  },
  {
    "State": "OR",
    "City": "Colton"
  },
  {
    "State": "OR",
    "City": "Columbia City"
  },
  {
    "State": "OR",
    "City": "Corbett"
  },
  {
    "State": "OR",
    "City": "Donald"
  },
  {
    "State": "OR",
    "City": "Dufur"
  },
  {
    "State": "OR",
    "City": "Eagle Creek"
  },
  {
    "State": "OR",
    "City": "Estacada"
  },
  {
    "State": "OR",
    "City": "Fairview"
  },
  {
    "State": "OR",
    "City": "Gervais"
  },
  {
    "State": "OR",
    "City": "Gladstone"
  },
  {
    "State": "OR",
    "City": "Government Camp"
  },
  {
    "State": "OR",
    "City": "Grass Valley"
  },
  {
    "State": "OR",
    "City": "Gresham"
  },
  {
    "State": "OR",
    "City": "Hood River"
  },
  {
    "State": "OR",
    "City": "Hubbard"
  },
  {
    "State": "OR",
    "City": "Kent"
  },
  {
    "State": "OR",
    "City": "Lake Oswego"
  },
  {
    "State": "OR",
    "City": "Marylhurst"
  },
  {
    "State": "OR",
    "City": "Maupin"
  },
  {
    "State": "OR",
    "City": "Molalla"
  },
  {
    "State": "OR",
    "City": "Moro"
  },
  {
    "State": "OR",
    "City": "Mosier"
  },
  {
    "State": "OR",
    "City": "Mount Hood Parkdale"
  },
  {
    "State": "OR",
    "City": "Mulino"
  },
  {
    "State": "OR",
    "City": "Odell"
  },
  {
    "State": "OR",
    "City": "Oregon City"
  },
  {
    "State": "OR",
    "City": "Rainier"
  },
  {
    "State": "OR",
    "City": "Rhododendron"
  },
  {
    "State": "OR",
    "City": "Rufus"
  },
  {
    "State": "OR",
    "City": "Saint Helens"
  },
  {
    "State": "OR",
    "City": "Warren"
  },
  {
    "State": "OR",
    "City": "Deer Island"
  },
  {
    "State": "OR",
    "City": "Sandy"
  },
  {
    "State": "OR",
    "City": "Scappoose"
  },
  {
    "State": "OR",
    "City": "Shaniko"
  },
  {
    "State": "OR",
    "City": "The Dalles"
  },
  {
    "State": "OR",
    "City": "Troutdale"
  },
  {
    "State": "OR",
    "City": "Tualatin"
  },
  {
    "State": "OR",
    "City": "Tygh Valley"
  },
  {
    "State": "OR",
    "City": "Vernonia"
  },
  {
    "State": "OR",
    "City": "Wasco"
  },
  {
    "State": "OR",
    "City": "Welches"
  },
  {
    "State": "OR",
    "City": "West Linn"
  },
  {
    "State": "OR",
    "City": "Wilsonville"
  },
  {
    "State": "OR",
    "City": "Woodburn"
  },
  {
    "State": "OR",
    "City": "Happy Valley"
  },
  {
    "State": "OR",
    "City": "Damascus"
  },
  {
    "State": "OR",
    "City": "Amity"
  },
  {
    "State": "OR",
    "City": "Arch Cape"
  },
  {
    "State": "OR",
    "City": "Astoria"
  },
  {
    "State": "OR",
    "City": "Banks"
  },
  {
    "State": "OR",
    "City": "Bay City"
  },
  {
    "State": "OR",
    "City": "Beaver"
  },
  {
    "State": "OR",
    "City": "Buxton"
  },
  {
    "State": "OR",
    "City": "Cannon Beach"
  },
  {
    "State": "OR",
    "City": "Carlton"
  },
  {
    "State": "OR",
    "City": "Cloverdale"
  },
  {
    "State": "OR",
    "City": "Cornelius"
  },
  {
    "State": "OR",
    "City": "Dayton"
  },
  {
    "State": "OR",
    "City": "Dundee"
  },
  {
    "State": "OR",
    "City": "Forest Grove"
  },
  {
    "State": "OR",
    "City": "Gales Creek"
  },
  {
    "State": "OR",
    "City": "Garibaldi"
  },
  {
    "State": "OR",
    "City": "Gaston"
  },
  {
    "State": "OR",
    "City": "Hammond"
  },
  {
    "State": "OR",
    "City": "Hebo"
  },
  {
    "State": "OR",
    "City": "Hillsboro"
  },
  {
    "State": "OR",
    "City": "Manning"
  },
  {
    "State": "OR",
    "City": "Lafayette"
  },
  {
    "State": "OR",
    "City": "Mcminnville"
  },
  {
    "State": "OR",
    "City": "Manzanita"
  },
  {
    "State": "OR",
    "City": "Nehalem"
  },
  {
    "State": "OR",
    "City": "Newberg"
  },
  {
    "State": "OR",
    "City": "North Plains"
  },
  {
    "State": "OR",
    "City": "Oceanside"
  },
  {
    "State": "OR",
    "City": "Pacific City"
  },
  {
    "State": "OR",
    "City": "Rockaway Beach"
  },
  {
    "State": "OR",
    "City": "Saint Paul"
  },
  {
    "State": "OR",
    "City": "Seaside"
  },
  {
    "State": "OR",
    "City": "Sherwood"
  },
  {
    "State": "OR",
    "City": "Tillamook"
  },
  {
    "State": "OR",
    "City": "Netarts"
  },
  {
    "State": "OR",
    "City": "Timber"
  },
  {
    "State": "OR",
    "City": "Tolovana Park"
  },
  {
    "State": "OR",
    "City": "Warrenton"
  },
  {
    "State": "OR",
    "City": "Wheeler"
  },
  {
    "State": "OR",
    "City": "Yamhill"
  },
  {
    "State": "OR",
    "City": "Neskowin"
  },
  {
    "State": "OR",
    "City": "Portland"
  },
  {
    "State": "OR",
    "City": "Salem"
  },
  {
    "State": "OR",
    "City": "Keizer"
  },
  {
    "State": "OR",
    "City": "Albany"
  },
  {
    "State": "OR",
    "City": "Alsea"
  },
  {
    "State": "OR",
    "City": "Aumsville"
  },
  {
    "State": "OR",
    "City": "Blodgett"
  },
  {
    "State": "OR",
    "City": "Brownsville"
  },
  {
    "State": "OR",
    "City": "Cascadia"
  },
  {
    "State": "OR",
    "City": "Corvallis"
  },
  {
    "State": "OR",
    "City": "Crabtree"
  },
  {
    "State": "OR",
    "City": "Crawfordsville"
  },
  {
    "State": "OR",
    "City": "Dallas"
  },
  {
    "State": "OR",
    "City": "Depoe Bay"
  },
  {
    "State": "OR",
    "City": "Detroit"
  },
  {
    "State": "OR",
    "City": "Eddyville"
  },
  {
    "State": "OR",
    "City": "Falls City"
  },
  {
    "State": "OR",
    "City": "Foster"
  },
  {
    "State": "OR",
    "City": "Gates"
  },
  {
    "State": "OR",
    "City": "Grand Ronde"
  },
  {
    "State": "OR",
    "City": "Halsey"
  },
  {
    "State": "OR",
    "City": "Idanha"
  },
  {
    "State": "OR",
    "City": "Independence"
  },
  {
    "State": "OR",
    "City": "Jefferson"
  },
  {
    "State": "OR",
    "City": "Lebanon"
  },
  {
    "State": "OR",
    "City": "Logsden"
  },
  {
    "State": "OR",
    "City": "Lyons"
  },
  {
    "State": "OR",
    "City": "Mill City"
  },
  {
    "State": "OR",
    "City": "Monmouth"
  },
  {
    "State": "OR",
    "City": "Mount Angel"
  },
  {
    "State": "OR",
    "City": "Neotsu"
  },
  {
    "State": "OR",
    "City": "Newport"
  },
  {
    "State": "OR",
    "City": "South Beach"
  },
  {
    "State": "OR",
    "City": "Lincoln City"
  },
  {
    "State": "OR",
    "City": "Otis"
  },
  {
    "State": "OR",
    "City": "Otter Rock"
  },
  {
    "State": "OR",
    "City": "Philomath"
  },
  {
    "State": "OR",
    "City": "Rickreall"
  },
  {
    "State": "OR",
    "City": "Rose Lodge"
  },
  {
    "State": "OR",
    "City": "Saint Benedict"
  },
  {
    "State": "OR",
    "City": "Scio"
  },
  {
    "State": "OR",
    "City": "Scotts Mills"
  },
  {
    "State": "OR",
    "City": "Seal Rock"
  },
  {
    "State": "OR",
    "City": "Shedd"
  },
  {
    "State": "OR",
    "City": "Sheridan"
  },
  {
    "State": "OR",
    "City": "Siletz"
  },
  {
    "State": "OR",
    "City": "Silverton"
  },
  {
    "State": "OR",
    "City": "Stayton"
  },
  {
    "State": "OR",
    "City": "Mehama"
  },
  {
    "State": "OR",
    "City": "Sublimity"
  },
  {
    "State": "OR",
    "City": "Sweet Home"
  },
  {
    "State": "OR",
    "City": "Gleneden Beach"
  },
  {
    "State": "OR",
    "City": "Tangent"
  },
  {
    "State": "OR",
    "City": "Tidewater"
  },
  {
    "State": "OR",
    "City": "Toledo"
  },
  {
    "State": "OR",
    "City": "Turner"
  },
  {
    "State": "OR",
    "City": "Waldport"
  },
  {
    "State": "OR",
    "City": "Willamina"
  },
  {
    "State": "OR",
    "City": "Eugene"
  },
  {
    "State": "OR",
    "City": "Agness"
  },
  {
    "State": "OR",
    "City": "Allegany"
  },
  {
    "State": "OR",
    "City": "Alvadore"
  },
  {
    "State": "OR",
    "City": "Azalea"
  },
  {
    "State": "OR",
    "City": "Bandon"
  },
  {
    "State": "OR",
    "City": "Blachly"
  },
  {
    "State": "OR",
    "City": "Blue River"
  },
  {
    "State": "OR",
    "City": "Broadbent"
  },
  {
    "State": "OR",
    "City": "Brookings"
  },
  {
    "State": "OR",
    "City": "Camas Valley"
  },
  {
    "State": "OR",
    "City": "Canyonville"
  },
  {
    "State": "OR",
    "City": "Cheshire"
  },
  {
    "State": "OR",
    "City": "Coos Bay"
  },
  {
    "State": "OR",
    "City": "Coquille"
  },
  {
    "State": "OR",
    "City": "Cottage Grove"
  },
  {
    "State": "OR",
    "City": "Crescent Lake"
  },
  {
    "State": "OR",
    "City": "Creswell"
  },
  {
    "State": "OR",
    "City": "Culp Creek"
  },
  {
    "State": "OR",
    "City": "Curtin"
  },
  {
    "State": "OR",
    "City": "Days Creek"
  },
  {
    "State": "OR",
    "City": "Deadwood"
  },
  {
    "State": "OR",
    "City": "Dexter"
  },
  {
    "State": "OR",
    "City": "Dillard"
  },
  {
    "State": "OR",
    "City": "Dorena"
  },
  {
    "State": "OR",
    "City": "Drain"
  },
  {
    "State": "OR",
    "City": "Elkton"
  },
  {
    "State": "OR",
    "City": "Elmira"
  },
  {
    "State": "OR",
    "City": "Fall Creek"
  },
  {
    "State": "OR",
    "City": "Florence"
  },
  {
    "State": "OR",
    "City": "Gardiner"
  },
  {
    "State": "OR",
    "City": "Glendale"
  },
  {
    "State": "OR",
    "City": "Glide"
  },
  {
    "State": "OR",
    "City": "Gold Beach"
  },
  {
    "State": "OR",
    "City": "Harrisburg"
  },
  {
    "State": "OR",
    "City": "Idleyld Park"
  },
  {
    "State": "OR",
    "City": "Junction City"
  },
  {
    "State": "OR",
    "City": "Lakeside"
  },
  {
    "State": "OR",
    "City": "Langlois"
  },
  {
    "State": "OR",
    "City": "Lorane"
  },
  {
    "State": "OR",
    "City": "Lowell"
  },
  {
    "State": "OR",
    "City": "Mapleton"
  },
  {
    "State": "OR",
    "City": "Marcola"
  },
  {
    "State": "OR",
    "City": "Pleasant Hill"
  },
  {
    "State": "OR",
    "City": "Monroe"
  },
  {
    "State": "OR",
    "City": "Myrtle Creek"
  },
  {
    "State": "OR",
    "City": "Myrtle Point"
  },
  {
    "State": "OR",
    "City": "North Bend"
  },
  {
    "State": "OR",
    "City": "Noti"
  },
  {
    "State": "OR",
    "City": "Oakland"
  },
  {
    "State": "OR",
    "City": "Oakridge"
  },
  {
    "State": "OR",
    "City": "Ophir"
  },
  {
    "State": "OR",
    "City": "Port Orford"
  },
  {
    "State": "OR",
    "City": "Powers"
  },
  {
    "State": "OR",
    "City": "Reedsport"
  },
  {
    "State": "OR",
    "City": "Riddle"
  },
  {
    "State": "OR",
    "City": "Roseburg"
  },
  {
    "State": "OR",
    "City": "Scottsburg"
  },
  {
    "State": "OR",
    "City": "Springfield"
  },
  {
    "State": "OR",
    "City": "Sixes"
  },
  {
    "State": "OR",
    "City": "Sutherlin"
  },
  {
    "State": "OR",
    "City": "Swisshome"
  },
  {
    "State": "OR",
    "City": "Tenmile"
  },
  {
    "State": "OR",
    "City": "Thurston"
  },
  {
    "State": "OR",
    "City": "Tiller"
  },
  {
    "State": "OR",
    "City": "Umpqua"
  },
  {
    "State": "OR",
    "City": "Veneta"
  },
  {
    "State": "OR",
    "City": "Vida"
  },
  {
    "State": "OR",
    "City": "Walterville"
  },
  {
    "State": "OR",
    "City": "Walton"
  },
  {
    "State": "OR",
    "City": "Wedderburn"
  },
  {
    "State": "OR",
    "City": "Westfir"
  },
  {
    "State": "OR",
    "City": "Westlake"
  },
  {
    "State": "OR",
    "City": "Wilbur"
  },
  {
    "State": "OR",
    "City": "Winchester"
  },
  {
    "State": "OR",
    "City": "Winston"
  },
  {
    "State": "OR",
    "City": "Wolf Creek"
  },
  {
    "State": "OR",
    "City": "Yachats"
  },
  {
    "State": "OR",
    "City": "Yoncalla"
  },
  {
    "State": "OR",
    "City": "Medford"
  },
  {
    "State": "OR",
    "City": "Central Point"
  },
  {
    "State": "OR",
    "City": "White City"
  },
  {
    "State": "OR",
    "City": "Ashland"
  },
  {
    "State": "OR",
    "City": "Butte Falls"
  },
  {
    "State": "OR",
    "City": "Cave Junction"
  },
  {
    "State": "OR",
    "City": "Eagle Point"
  },
  {
    "State": "OR",
    "City": "Gold Hill"
  },
  {
    "State": "OR",
    "City": "Grants Pass"
  },
  {
    "State": "OR",
    "City": "Jacksonville"
  },
  {
    "State": "OR",
    "City": "Kerby"
  },
  {
    "State": "OR",
    "City": "Merlin"
  },
  {
    "State": "OR",
    "City": "Murphy"
  },
  {
    "State": "OR",
    "City": "O Brien"
  },
  {
    "State": "OR",
    "City": "Phoenix"
  },
  {
    "State": "OR",
    "City": "Prospect"
  },
  {
    "State": "OR",
    "City": "Rogue River"
  },
  {
    "State": "OR",
    "City": "Selma"
  },
  {
    "State": "OR",
    "City": "Shady Cove"
  },
  {
    "State": "OR",
    "City": "Talent"
  },
  {
    "State": "OR",
    "City": "Trail"
  },
  {
    "State": "OR",
    "City": "Wilderville"
  },
  {
    "State": "OR",
    "City": "Williams"
  },
  {
    "State": "OR",
    "City": "Klamath Falls"
  },
  {
    "State": "OR",
    "City": "Crater Lake"
  },
  {
    "State": "OR",
    "City": "Adel"
  },
  {
    "State": "OR",
    "City": "Beatty"
  },
  {
    "State": "OR",
    "City": "Bly"
  },
  {
    "State": "OR",
    "City": "Bonanza"
  },
  {
    "State": "OR",
    "City": "Chiloquin"
  },
  {
    "State": "OR",
    "City": "Dairy"
  },
  {
    "State": "OR",
    "City": "Fort Klamath"
  },
  {
    "State": "OR",
    "City": "Keno"
  },
  {
    "State": "OR",
    "City": "Lakeview"
  },
  {
    "State": "OR",
    "City": "Malin"
  },
  {
    "State": "OR",
    "City": "Merrill"
  },
  {
    "State": "OR",
    "City": "Midland"
  },
  {
    "State": "OR",
    "City": "New Pine Creek"
  },
  {
    "State": "OR",
    "City": "Paisley"
  },
  {
    "State": "OR",
    "City": "Plush"
  },
  {
    "State": "OR",
    "City": "Silver Lake"
  },
  {
    "State": "OR",
    "City": "Sprague River"
  },
  {
    "State": "OR",
    "City": "Summer Lake"
  },
  {
    "State": "OR",
    "City": "Christmas Valley"
  },
  {
    "State": "OR",
    "City": "Bend"
  },
  {
    "State": "OR",
    "City": "Fields"
  },
  {
    "State": "OR",
    "City": "Ashwood"
  },
  {
    "State": "OR",
    "City": "Brothers"
  },
  {
    "State": "OR",
    "City": "Burns"
  },
  {
    "State": "OR",
    "City": "Princeton"
  },
  {
    "State": "OR",
    "City": "Diamond"
  },
  {
    "State": "OR",
    "City": "Camp Sherman"
  },
  {
    "State": "OR",
    "City": "Chemult"
  },
  {
    "State": "OR",
    "City": "Crane"
  },
  {
    "State": "OR",
    "City": "Crescent"
  },
  {
    "State": "OR",
    "City": "Culver"
  },
  {
    "State": "OR",
    "City": "Fort Rock"
  },
  {
    "State": "OR",
    "City": "Frenchglen"
  },
  {
    "State": "OR",
    "City": "Gilchrist"
  },
  {
    "State": "OR",
    "City": "Hines"
  },
  {
    "State": "OR",
    "City": "La Pine"
  },
  {
    "State": "OR",
    "City": "Madras"
  },
  {
    "State": "OR",
    "City": "Mitchell"
  },
  {
    "State": "OR",
    "City": "Paulina"
  },
  {
    "State": "OR",
    "City": "Post"
  },
  {
    "State": "OR",
    "City": "Powell Butte"
  },
  {
    "State": "OR",
    "City": "Prineville"
  },
  {
    "State": "OR",
    "City": "Redmond"
  },
  {
    "State": "OR",
    "City": "Riley"
  },
  {
    "State": "OR",
    "City": "Sisters"
  },
  {
    "State": "OR",
    "City": "Terrebonne"
  },
  {
    "State": "OR",
    "City": "Warm Springs"
  },
  {
    "State": "OR",
    "City": "Pendleton"
  },
  {
    "State": "OR",
    "City": "Adams"
  },
  {
    "State": "OR",
    "City": "Arlington"
  },
  {
    "State": "OR",
    "City": "Athena"
  },
  {
    "State": "OR",
    "City": "Baker City"
  },
  {
    "State": "OR",
    "City": "Bates"
  },
  {
    "State": "OR",
    "City": "Boardman"
  },
  {
    "State": "OR",
    "City": "Bridgeport"
  },
  {
    "State": "OR",
    "City": "Canyon City"
  },
  {
    "State": "OR",
    "City": "Condon"
  },
  {
    "State": "OR",
    "City": "Cove"
  },
  {
    "State": "OR",
    "City": "Dayville"
  },
  {
    "State": "OR",
    "City": "Echo"
  },
  {
    "State": "OR",
    "City": "Elgin"
  },
  {
    "State": "OR",
    "City": "Enterprise"
  },
  {
    "State": "OR",
    "City": "Fossil"
  },
  {
    "State": "OR",
    "City": "Haines"
  },
  {
    "State": "OR",
    "City": "Halfway"
  },
  {
    "State": "OR",
    "City": "Helix"
  },
  {
    "State": "OR",
    "City": "Heppner"
  },
  {
    "State": "OR",
    "City": "Hereford"
  },
  {
    "State": "OR",
    "City": "Hermiston"
  },
  {
    "State": "OR",
    "City": "Lexington"
  },
  {
    "State": "OR",
    "City": "Oxbow"
  },
  {
    "State": "OR",
    "City": "Imbler"
  },
  {
    "State": "OR",
    "City": "Imnaha"
  },
  {
    "State": "OR",
    "City": "Ione"
  },
  {
    "State": "OR",
    "City": "Irrigon"
  },
  {
    "State": "OR",
    "City": "John Day"
  },
  {
    "State": "OR",
    "City": "Joseph"
  },
  {
    "State": "OR",
    "City": "Kimberly"
  },
  {
    "State": "OR",
    "City": "La Grande"
  },
  {
    "State": "OR",
    "City": "Long Creek"
  },
  {
    "State": "OR",
    "City": "Lostine"
  },
  {
    "State": "OR",
    "City": "Meacham"
  },
  {
    "State": "OR",
    "City": "Mikkalo"
  },
  {
    "State": "OR",
    "City": "Milton Freewater"
  },
  {
    "State": "OR",
    "City": "Monument"
  },
  {
    "State": "OR",
    "City": "Mount Vernon"
  },
  {
    "State": "OR",
    "City": "North Powder"
  },
  {
    "State": "OR",
    "City": "Pilot Rock"
  },
  {
    "State": "OR",
    "City": "Prairie City"
  },
  {
    "State": "OR",
    "City": "Richland"
  },
  {
    "State": "OR",
    "City": "Seneca"
  },
  {
    "State": "OR",
    "City": "Spray"
  },
  {
    "State": "OR",
    "City": "Stanfield"
  },
  {
    "State": "OR",
    "City": "Summerville"
  },
  {
    "State": "OR",
    "City": "Sumpter"
  },
  {
    "State": "OR",
    "City": "Ukiah"
  },
  {
    "State": "OR",
    "City": "Umatilla"
  },
  {
    "State": "OR",
    "City": "Union"
  },
  {
    "State": "OR",
    "City": "Unity"
  },
  {
    "State": "OR",
    "City": "Wallowa"
  },
  {
    "State": "OR",
    "City": "Weston"
  },
  {
    "State": "OR",
    "City": "Adrian"
  },
  {
    "State": "OR",
    "City": "Arock"
  },
  {
    "State": "OR",
    "City": "Brogan"
  },
  {
    "State": "OR",
    "City": "Drewsey"
  },
  {
    "State": "OR",
    "City": "Durkee"
  },
  {
    "State": "OR",
    "City": "Harper"
  },
  {
    "State": "OR",
    "City": "Huntington"
  },
  {
    "State": "OR",
    "City": "Ironside"
  },
  {
    "State": "OR",
    "City": "Jamieson"
  },
  {
    "State": "OR",
    "City": "Jordan Valley"
  },
  {
    "State": "OR",
    "City": "Juntura"
  },
  {
    "State": "OR",
    "City": "Nyssa"
  },
  {
    "State": "OR",
    "City": "Ontario"
  },
  {
    "State": "OR",
    "City": "Riverside"
  },
  {
    "State": "OR",
    "City": "Vale"
  },
  {
    "State": "OR",
    "City": "Westfall"
  },
  {
    "State": "WA",
    "City": "Auburn"
  },
  {
    "State": "WA",
    "City": "Federal Way"
  },
  {
    "State": "WA",
    "City": "Bellevue"
  },
  {
    "State": "WA",
    "City": "Black Diamond"
  },
  {
    "State": "WA",
    "City": "Bothell"
  },
  {
    "State": "WA",
    "City": "Burton"
  },
  {
    "State": "WA",
    "City": "Carnation"
  },
  {
    "State": "WA",
    "City": "Duvall"
  },
  {
    "State": "WA",
    "City": "Edmonds"
  },
  {
    "State": "WA",
    "City": "Enumclaw"
  },
  {
    "State": "WA",
    "City": "Fall City"
  },
  {
    "State": "WA",
    "City": "Hobart"
  },
  {
    "State": "WA",
    "City": "Issaquah"
  },
  {
    "State": "WA",
    "City": "Kenmore"
  },
  {
    "State": "WA",
    "City": "Kent"
  },
  {
    "State": "WA",
    "City": "Kirkland"
  },
  {
    "State": "WA",
    "City": "Lynnwood"
  },
  {
    "State": "WA",
    "City": "Maple Valley"
  },
  {
    "State": "WA",
    "City": "Medina"
  },
  {
    "State": "WA",
    "City": "Mercer Island"
  },
  {
    "State": "WA",
    "City": "Mountlake Terrace"
  },
  {
    "State": "WA",
    "City": "North Bend"
  },
  {
    "State": "WA",
    "City": "Pacific"
  },
  {
    "State": "WA",
    "City": "Preston"
  },
  {
    "State": "WA",
    "City": "Ravensdale"
  },
  {
    "State": "WA",
    "City": "Redmond"
  },
  {
    "State": "WA",
    "City": "Redondo"
  },
  {
    "State": "WA",
    "City": "Renton"
  },
  {
    "State": "WA",
    "City": "Rollingbay"
  },
  {
    "State": "WA",
    "City": "Seahurst"
  },
  {
    "State": "WA",
    "City": "Snoqualmie"
  },
  {
    "State": "WA",
    "City": "Snoqualmie Pass"
  },
  {
    "State": "WA",
    "City": "Vashon"
  },
  {
    "State": "WA",
    "City": "Woodinville"
  },
  {
    "State": "WA",
    "City": "Sammamish"
  },
  {
    "State": "WA",
    "City": "Mill Creek"
  },
  {
    "State": "WA",
    "City": "Seattle"
  },
  {
    "State": "WA",
    "City": "Bainbridge Island"
  },
  {
    "State": "WA",
    "City": "Everett"
  },
  {
    "State": "WA",
    "City": "Acme"
  },
  {
    "State": "WA",
    "City": "Anacortes"
  },
  {
    "State": "WA",
    "City": "Blakely Island"
  },
  {
    "State": "WA",
    "City": "Arlington"
  },
  {
    "State": "WA",
    "City": "Baring"
  },
  {
    "State": "WA",
    "City": "Bellingham"
  },
  {
    "State": "WA",
    "City": "Blaine"
  },
  {
    "State": "WA",
    "City": "Bow"
  },
  {
    "State": "WA",
    "City": "Burlington"
  },
  {
    "State": "WA",
    "City": "Clearlake"
  },
  {
    "State": "WA",
    "City": "Clinton"
  },
  {
    "State": "WA",
    "City": "Concrete"
  },
  {
    "State": "WA",
    "City": "Conway"
  },
  {
    "State": "WA",
    "City": "Coupeville"
  },
  {
    "State": "WA",
    "City": "Custer"
  },
  {
    "State": "WA",
    "City": "Darrington"
  },
  {
    "State": "WA",
    "City": "Deer Harbor"
  },
  {
    "State": "WA",
    "City": "Deming"
  },
  {
    "State": "WA",
    "City": "Eastsound"
  },
  {
    "State": "WA",
    "City": "Everson"
  },
  {
    "State": "WA",
    "City": "Ferndale"
  },
  {
    "State": "WA",
    "City": "Freeland"
  },
  {
    "State": "WA",
    "City": "Friday Harbor"
  },
  {
    "State": "WA",
    "City": "Gold Bar"
  },
  {
    "State": "WA",
    "City": "Granite Falls"
  },
  {
    "State": "WA",
    "City": "Greenbank"
  },
  {
    "State": "WA",
    "City": "Hamilton"
  },
  {
    "State": "WA",
    "City": "Index"
  },
  {
    "State": "WA",
    "City": "La Conner"
  },
  {
    "State": "WA",
    "City": "Lake Stevens"
  },
  {
    "State": "WA",
    "City": "North Lakewood"
  },
  {
    "State": "WA",
    "City": "Langley"
  },
  {
    "State": "WA",
    "City": "Lopez Island"
  },
  {
    "State": "WA",
    "City": "Lummi Island"
  },
  {
    "State": "WA",
    "City": "Lyman"
  },
  {
    "State": "WA",
    "City": "Lynden"
  },
  {
    "State": "WA",
    "City": "Maple Falls"
  },
  {
    "State": "WA",
    "City": "Marblemount"
  },
  {
    "State": "WA",
    "City": "Marysville"
  },
  {
    "State": "WA",
    "City": "Monroe"
  },
  {
    "State": "WA",
    "City": "Mount Vernon"
  },
  {
    "State": "WA",
    "City": "Mukilteo"
  },
  {
    "State": "WA",
    "City": "Nooksack"
  },
  {
    "State": "WA",
    "City": "Oak Harbor"
  },
  {
    "State": "WA",
    "City": "Olga"
  },
  {
    "State": "WA",
    "City": "Orcas"
  },
  {
    "State": "WA",
    "City": "Point Roberts"
  },
  {
    "State": "WA",
    "City": "Camano Island"
  },
  {
    "State": "WA",
    "City": "Rockport"
  },
  {
    "State": "WA",
    "City": "Sedro Woolley"
  },
  {
    "State": "WA",
    "City": "Shaw Island"
  },
  {
    "State": "WA",
    "City": "Silvana"
  },
  {
    "State": "WA",
    "City": "Skykomish"
  },
  {
    "State": "WA",
    "City": "Snohomish"
  },
  {
    "State": "WA",
    "City": "Stanwood"
  },
  {
    "State": "WA",
    "City": "Startup"
  },
  {
    "State": "WA",
    "City": "Sultan"
  },
  {
    "State": "WA",
    "City": "Sumas"
  },
  {
    "State": "WA",
    "City": "Waldron"
  },
  {
    "State": "WA",
    "City": "Anderson Island"
  },
  {
    "State": "WA",
    "City": "Ashford"
  },
  {
    "State": "WA",
    "City": "Beaver"
  },
  {
    "State": "WA",
    "City": "Bremerton"
  },
  {
    "State": "WA",
    "City": "Silverdale"
  },
  {
    "State": "WA",
    "City": "Brinnon"
  },
  {
    "State": "WA",
    "City": "Buckley"
  },
  {
    "State": "WA",
    "City": "Burley"
  },
  {
    "State": "WA",
    "City": "Carbonado"
  },
  {
    "State": "WA",
    "City": "Carlsborg"
  },
  {
    "State": "WA",
    "City": "Chimacum"
  },
  {
    "State": "WA",
    "City": "Clallam Bay"
  },
  {
    "State": "WA",
    "City": "Dupont"
  },
  {
    "State": "WA",
    "City": "Eatonville"
  },
  {
    "State": "WA",
    "City": "Gig Harbor"
  },
  {
    "State": "WA",
    "City": "Elbe"
  },
  {
    "State": "WA",
    "City": "Forks"
  },
  {
    "State": "WA",
    "City": "Fox Island"
  },
  {
    "State": "WA",
    "City": "Glenoma"
  },
  {
    "State": "WA",
    "City": "Graham"
  },
  {
    "State": "WA",
    "City": "Port Hadlock"
  },
  {
    "State": "WA",
    "City": "Hansville"
  },
  {
    "State": "WA",
    "City": "Indianola"
  },
  {
    "State": "WA",
    "City": "Joyce"
  },
  {
    "State": "WA",
    "City": "Kapowsin"
  },
  {
    "State": "WA",
    "City": "Keyport"
  },
  {
    "State": "WA",
    "City": "Kingston"
  },
  {
    "State": "WA",
    "City": "La Grande"
  },
  {
    "State": "WA",
    "City": "Lakebay"
  },
  {
    "State": "WA",
    "City": "La Push"
  },
  {
    "State": "WA",
    "City": "Longbranch"
  },
  {
    "State": "WA",
    "City": "Sumner"
  },
  {
    "State": "WA",
    "City": "Manchester"
  },
  {
    "State": "WA",
    "City": "Milton"
  },
  {
    "State": "WA",
    "City": "Mineral"
  },
  {
    "State": "WA",
    "City": "Morton"
  },
  {
    "State": "WA",
    "City": "Neah Bay"
  },
  {
    "State": "WA",
    "City": "Nordland"
  },
  {
    "State": "WA",
    "City": "Olalla"
  },
  {
    "State": "WA",
    "City": "Orting"
  },
  {
    "State": "WA",
    "City": "Packwood"
  },
  {
    "State": "WA",
    "City": "Port Angeles"
  },
  {
    "State": "WA",
    "City": "Port Gamble"
  },
  {
    "State": "WA",
    "City": "Port Ludlow"
  },
  {
    "State": "WA",
    "City": "Port Orchard"
  },
  {
    "State": "WA",
    "City": "Port Townsend"
  },
  {
    "State": "WA",
    "City": "Poulsbo"
  },
  {
    "State": "WA",
    "City": "Puyallup"
  },
  {
    "State": "WA",
    "City": "Quilcene"
  },
  {
    "State": "WA",
    "City": "Randle"
  },
  {
    "State": "WA",
    "City": "Retsil"
  },
  {
    "State": "WA",
    "City": "Seabeck"
  },
  {
    "State": "WA",
    "City": "Sekiu"
  },
  {
    "State": "WA",
    "City": "Sequim"
  },
  {
    "State": "WA",
    "City": "South Colby"
  },
  {
    "State": "WA",
    "City": "South Prairie"
  },
  {
    "State": "WA",
    "City": "Southworth"
  },
  {
    "State": "WA",
    "City": "Spanaway"
  },
  {
    "State": "WA",
    "City": "Steilacoom"
  },
  {
    "State": "WA",
    "City": "Bonney Lake"
  },
  {
    "State": "WA",
    "City": "Suquamish"
  },
  {
    "State": "WA",
    "City": "Tracyton"
  },
  {
    "State": "WA",
    "City": "Vaughn"
  },
  {
    "State": "WA",
    "City": "Wauna"
  },
  {
    "State": "WA",
    "City": "Wilkeson"
  },
  {
    "State": "WA",
    "City": "Longmire"
  },
  {
    "State": "WA",
    "City": "Paradise Inn"
  },
  {
    "State": "WA",
    "City": "Tacoma"
  },
  {
    "State": "WA",
    "City": "Fife"
  },
  {
    "State": "WA",
    "City": "Camp Murray"
  },
  {
    "State": "WA",
    "City": "Mcchord AFB"
  },
  {
    "State": "WA",
    "City": "Lakewood"
  },
  {
    "State": "WA",
    "City": "University Place"
  },
  {
    "State": "WA",
    "City": "Olympia"
  },
  {
    "State": "WA",
    "City": "Lacey"
  },
  {
    "State": "WA",
    "City": "Tumwater"
  },
  {
    "State": "WA",
    "City": "Aberdeen"
  },
  {
    "State": "WA",
    "City": "Adna"
  },
  {
    "State": "WA",
    "City": "Allyn"
  },
  {
    "State": "WA",
    "City": "Amanda Park"
  },
  {
    "State": "WA",
    "City": "Bay Center"
  },
  {
    "State": "WA",
    "City": "Belfair"
  },
  {
    "State": "WA",
    "City": "Bucoda"
  },
  {
    "State": "WA",
    "City": "Centralia"
  },
  {
    "State": "WA",
    "City": "Chehalis"
  },
  {
    "State": "WA",
    "City": "Cinebar"
  },
  {
    "State": "WA",
    "City": "Copalis Beach"
  },
  {
    "State": "WA",
    "City": "Copalis Crossing"
  },
  {
    "State": "WA",
    "City": "Cosmopolis"
  },
  {
    "State": "WA",
    "City": "Curtis"
  },
  {
    "State": "WA",
    "City": "Doty"
  },
  {
    "State": "WA",
    "City": "East Olympia"
  },
  {
    "State": "WA",
    "City": "Elma"
  },
  {
    "State": "WA",
    "City": "Ethel"
  },
  {
    "State": "WA",
    "City": "Galvin"
  },
  {
    "State": "WA",
    "City": "Grapeview"
  },
  {
    "State": "WA",
    "City": "Grayland"
  },
  {
    "State": "WA",
    "City": "Hoodsport"
  },
  {
    "State": "WA",
    "City": "Hoquiam"
  },
  {
    "State": "WA",
    "City": "Humptulips"
  },
  {
    "State": "WA",
    "City": "Lebam"
  },
  {
    "State": "WA",
    "City": "Lilliwaup"
  },
  {
    "State": "WA",
    "City": "Littlerock"
  },
  {
    "State": "WA",
    "City": "Mccleary"
  },
  {
    "State": "WA",
    "City": "Mckenna"
  },
  {
    "State": "WA",
    "City": "Malone"
  },
  {
    "State": "WA",
    "City": "Matlock"
  },
  {
    "State": "WA",
    "City": "Menlo"
  },
  {
    "State": "WA",
    "City": "Moclips"
  },
  {
    "State": "WA",
    "City": "Montesano"
  },
  {
    "State": "WA",
    "City": "Mossyrock"
  },
  {
    "State": "WA",
    "City": "Napavine"
  },
  {
    "State": "WA",
    "City": "Neilton"
  },
  {
    "State": "WA",
    "City": "Oakville"
  },
  {
    "State": "WA",
    "City": "Ocean Shores"
  },
  {
    "State": "WA",
    "City": "Onalaska"
  },
  {
    "State": "WA",
    "City": "Pacific Beach"
  },
  {
    "State": "WA",
    "City": "Pe Ell"
  },
  {
    "State": "WA",
    "City": "Quinault"
  },
  {
    "State": "WA",
    "City": "Rainier"
  },
  {
    "State": "WA",
    "City": "Raymond"
  },
  {
    "State": "WA",
    "City": "Rochester"
  },
  {
    "State": "WA",
    "City": "Roy"
  },
  {
    "State": "WA",
    "City": "Ryderwood"
  },
  {
    "State": "WA",
    "City": "Salkum"
  },
  {
    "State": "WA",
    "City": "Satsop"
  },
  {
    "State": "WA",
    "City": "Shelton"
  },
  {
    "State": "WA",
    "City": "Silver Creek"
  },
  {
    "State": "WA",
    "City": "South Bend"
  },
  {
    "State": "WA",
    "City": "Taholah"
  },
  {
    "State": "WA",
    "City": "Tahuya"
  },
  {
    "State": "WA",
    "City": "Tenino"
  },
  {
    "State": "WA",
    "City": "Tokeland"
  },
  {
    "State": "WA",
    "City": "Toledo"
  },
  {
    "State": "WA",
    "City": "Union"
  },
  {
    "State": "WA",
    "City": "Vader"
  },
  {
    "State": "WA",
    "City": "Westport"
  },
  {
    "State": "WA",
    "City": "Winlock"
  },
  {
    "State": "WA",
    "City": "Yelm"
  },
  {
    "State": "WA",
    "City": "Amboy"
  },
  {
    "State": "WA",
    "City": "Appleton"
  },
  {
    "State": "WA",
    "City": "Ariel"
  },
  {
    "State": "WA",
    "City": "Battle Ground"
  },
  {
    "State": "WA",
    "City": "Bingen"
  },
  {
    "State": "WA",
    "City": "Brush Prairie"
  },
  {
    "State": "WA",
    "City": "Camas"
  },
  {
    "State": "WA",
    "City": "Carrolls"
  },
  {
    "State": "WA",
    "City": "Carson"
  },
  {
    "State": "WA",
    "City": "Castle Rock"
  },
  {
    "State": "WA",
    "City": "Cathlamet"
  },
  {
    "State": "WA",
    "City": "Centerville"
  },
  {
    "State": "WA",
    "City": "Chinook"
  },
  {
    "State": "WA",
    "City": "Cougar"
  },
  {
    "State": "WA",
    "City": "Dallesport"
  },
  {
    "State": "WA",
    "City": "Glenwood"
  },
  {
    "State": "WA",
    "City": "Goldendale"
  },
  {
    "State": "WA",
    "City": "Grays River"
  },
  {
    "State": "WA",
    "City": "Heisson"
  },
  {
    "State": "WA",
    "City": "Husum"
  },
  {
    "State": "WA",
    "City": "Ilwaco"
  },
  {
    "State": "WA",
    "City": "Kalama"
  },
  {
    "State": "WA",
    "City": "Kelso"
  },
  {
    "State": "WA",
    "City": "Klickitat"
  },
  {
    "State": "WA",
    "City": "La Center"
  },
  {
    "State": "WA",
    "City": "Long Beach"
  },
  {
    "State": "WA",
    "City": "Longview"
  },
  {
    "State": "WA",
    "City": "Lyle"
  },
  {
    "State": "WA",
    "City": "Nahcotta"
  },
  {
    "State": "WA",
    "City": "Naselle"
  },
  {
    "State": "WA",
    "City": "North Bonneville"
  },
  {
    "State": "WA",
    "City": "Ocean Park"
  },
  {
    "State": "WA",
    "City": "Oysterville"
  },
  {
    "State": "WA",
    "City": "Ridgefield"
  },
  {
    "State": "WA",
    "City": "Rosburg"
  },
  {
    "State": "WA",
    "City": "Seaview"
  },
  {
    "State": "WA",
    "City": "Silverlake"
  },
  {
    "State": "WA",
    "City": "Skamokawa"
  },
  {
    "State": "WA",
    "City": "Stevenson"
  },
  {
    "State": "WA",
    "City": "Toutle"
  },
  {
    "State": "WA",
    "City": "Trout Lake"
  },
  {
    "State": "WA",
    "City": "Underwood"
  },
  {
    "State": "WA",
    "City": "Vancouver"
  },
  {
    "State": "WA",
    "City": "Wahkiacus"
  },
  {
    "State": "WA",
    "City": "Washougal"
  },
  {
    "State": "WA",
    "City": "White Salmon"
  },
  {
    "State": "WA",
    "City": "Wishram"
  },
  {
    "State": "WA",
    "City": "Woodland"
  },
  {
    "State": "WA",
    "City": "Yacolt"
  },
  {
    "State": "WA",
    "City": "Wenatchee"
  },
  {
    "State": "WA",
    "City": "East Wenatchee"
  },
  {
    "State": "WA",
    "City": "Ardenvoir"
  },
  {
    "State": "WA",
    "City": "Brewster"
  },
  {
    "State": "WA",
    "City": "Bridgeport"
  },
  {
    "State": "WA",
    "City": "Carlton"
  },
  {
    "State": "WA",
    "City": "Cashmere"
  },
  {
    "State": "WA",
    "City": "Chelan"
  },
  {
    "State": "WA",
    "City": "Chelan Falls"
  },
  {
    "State": "WA",
    "City": "Conconully"
  },
  {
    "State": "WA",
    "City": "Dryden"
  },
  {
    "State": "WA",
    "City": "Entiat"
  },
  {
    "State": "WA",
    "City": "Ephrata"
  },
  {
    "State": "WA",
    "City": "George"
  },
  {
    "State": "WA",
    "City": "Leavenworth"
  },
  {
    "State": "WA",
    "City": "Loomis"
  },
  {
    "State": "WA",
    "City": "Malaga"
  },
  {
    "State": "WA",
    "City": "Malott"
  },
  {
    "State": "WA",
    "City": "Mansfield"
  },
  {
    "State": "WA",
    "City": "Manson"
  },
  {
    "State": "WA",
    "City": "Marlin"
  },
  {
    "State": "WA",
    "City": "Mazama"
  },
  {
    "State": "WA",
    "City": "Methow"
  },
  {
    "State": "WA",
    "City": "Monitor"
  },
  {
    "State": "WA",
    "City": "Moses Lake"
  },
  {
    "State": "WA",
    "City": "Okanogan"
  },
  {
    "State": "WA",
    "City": "Omak"
  },
  {
    "State": "WA",
    "City": "Orondo"
  },
  {
    "State": "WA",
    "City": "Oroville"
  },
  {
    "State": "WA",
    "City": "Palisades"
  },
  {
    "State": "WA",
    "City": "Pateros"
  },
  {
    "State": "WA",
    "City": "Peshastin"
  },
  {
    "State": "WA",
    "City": "Quincy"
  },
  {
    "State": "WA",
    "City": "Riverside"
  },
  {
    "State": "WA",
    "City": "Rock Island"
  },
  {
    "State": "WA",
    "City": "Soap Lake"
  },
  {
    "State": "WA",
    "City": "Stehekin"
  },
  {
    "State": "WA",
    "City": "Stratford"
  },
  {
    "State": "WA",
    "City": "Tonasket"
  },
  {
    "State": "WA",
    "City": "Twisp"
  },
  {
    "State": "WA",
    "City": "Warden"
  },
  {
    "State": "WA",
    "City": "Waterville"
  },
  {
    "State": "WA",
    "City": "Wauconda"
  },
  {
    "State": "WA",
    "City": "Wilson Creek"
  },
  {
    "State": "WA",
    "City": "Winthrop"
  },
  {
    "State": "WA",
    "City": "Yakima"
  },
  {
    "State": "WA",
    "City": "Brownstown"
  },
  {
    "State": "WA",
    "City": "Buena"
  },
  {
    "State": "WA",
    "City": "Cle Elum"
  },
  {
    "State": "WA",
    "City": "Cowiche"
  },
  {
    "State": "WA",
    "City": "Easton"
  },
  {
    "State": "WA",
    "City": "Ellensburg"
  },
  {
    "State": "WA",
    "City": "Naches"
  },
  {
    "State": "WA",
    "City": "Grandview"
  },
  {
    "State": "WA",
    "City": "Granger"
  },
  {
    "State": "WA",
    "City": "Harrah"
  },
  {
    "State": "WA",
    "City": "Kittitas"
  },
  {
    "State": "WA",
    "City": "Mabton"
  },
  {
    "State": "WA",
    "City": "Moxee"
  },
  {
    "State": "WA",
    "City": "Outlook"
  },
  {
    "State": "WA",
    "City": "Parker"
  },
  {
    "State": "WA",
    "City": "Ronald"
  },
  {
    "State": "WA",
    "City": "Roslyn"
  },
  {
    "State": "WA",
    "City": "Selah"
  },
  {
    "State": "WA",
    "City": "South Cle Elum"
  },
  {
    "State": "WA",
    "City": "Sunnyside"
  },
  {
    "State": "WA",
    "City": "Thorp"
  },
  {
    "State": "WA",
    "City": "Tieton"
  },
  {
    "State": "WA",
    "City": "Toppenish"
  },
  {
    "State": "WA",
    "City": "Vantage"
  },
  {
    "State": "WA",
    "City": "Wapato"
  },
  {
    "State": "WA",
    "City": "White Swan"
  },
  {
    "State": "WA",
    "City": "Zillah"
  },
  {
    "State": "WA",
    "City": "Airway Heights"
  },
  {
    "State": "WA",
    "City": "Chattaroy"
  },
  {
    "State": "WA",
    "City": "Cheney"
  },
  {
    "State": "WA",
    "City": "Colbert"
  },
  {
    "State": "WA",
    "City": "Deer Park"
  },
  {
    "State": "WA",
    "City": "Edwall"
  },
  {
    "State": "WA",
    "City": "Elk"
  },
  {
    "State": "WA",
    "City": "Fairchild Air Force Base"
  },
  {
    "State": "WA",
    "City": "Fairfield"
  },
  {
    "State": "WA",
    "City": "Ford"
  },
  {
    "State": "WA",
    "City": "Four Lakes"
  },
  {
    "State": "WA",
    "City": "Greenacres"
  },
  {
    "State": "WA",
    "City": "Lamont"
  },
  {
    "State": "WA",
    "City": "Latah"
  },
  {
    "State": "WA",
    "City": "Liberty Lake"
  },
  {
    "State": "WA",
    "City": "Marshall"
  },
  {
    "State": "WA",
    "City": "Mead"
  },
  {
    "State": "WA",
    "City": "Medical Lake"
  },
  {
    "State": "WA",
    "City": "Mica"
  },
  {
    "State": "WA",
    "City": "Newman Lake"
  },
  {
    "State": "WA",
    "City": "Nine Mile Falls"
  },
  {
    "State": "WA",
    "City": "Otis Orchards"
  },
  {
    "State": "WA",
    "City": "Reardan"
  },
  {
    "State": "WA",
    "City": "Rockford"
  },
  {
    "State": "WA",
    "City": "Spangle"
  },
  {
    "State": "WA",
    "City": "Sprague"
  },
  {
    "State": "WA",
    "City": "Tekoa"
  },
  {
    "State": "WA",
    "City": "Tumtum"
  },
  {
    "State": "WA",
    "City": "Valleyford"
  },
  {
    "State": "WA",
    "City": "Veradale"
  },
  {
    "State": "WA",
    "City": "Waverly"
  },
  {
    "State": "WA",
    "City": "Wellpinit"
  },
  {
    "State": "WA",
    "City": "Addy"
  },
  {
    "State": "WA",
    "City": "Albion"
  },
  {
    "State": "WA",
    "City": "Almira"
  },
  {
    "State": "WA",
    "City": "Belmont"
  },
  {
    "State": "WA",
    "City": "Benge"
  },
  {
    "State": "WA",
    "City": "Boyds"
  },
  {
    "State": "WA",
    "City": "Chewelah"
  },
  {
    "State": "WA",
    "City": "Clayton"
  },
  {
    "State": "WA",
    "City": "Colfax"
  },
  {
    "State": "WA",
    "City": "Colton"
  },
  {
    "State": "WA",
    "City": "Colville"
  },
  {
    "State": "WA",
    "City": "Coulee City"
  },
  {
    "State": "WA",
    "City": "Coulee Dam"
  },
  {
    "State": "WA",
    "City": "Creston"
  },
  {
    "State": "WA",
    "City": "Curlew"
  },
  {
    "State": "WA",
    "City": "Cusick"
  },
  {
    "State": "WA",
    "City": "Danville"
  },
  {
    "State": "WA",
    "City": "Davenport"
  },
  {
    "State": "WA",
    "City": "Electric City"
  },
  {
    "State": "WA",
    "City": "Elmer City"
  },
  {
    "State": "WA",
    "City": "Endicott"
  },
  {
    "State": "WA",
    "City": "Evans"
  },
  {
    "State": "WA",
    "City": "Farmington"
  },
  {
    "State": "WA",
    "City": "Fruitland"
  },
  {
    "State": "WA",
    "City": "Garfield"
  },
  {
    "State": "WA",
    "City": "Gifford"
  },
  {
    "State": "WA",
    "City": "Grand Coulee"
  },
  {
    "State": "WA",
    "City": "Harrington"
  },
  {
    "State": "WA",
    "City": "Hartline"
  },
  {
    "State": "WA",
    "City": "Hay"
  },
  {
    "State": "WA",
    "City": "Hunters"
  },
  {
    "State": "WA",
    "City": "Inchelium"
  },
  {
    "State": "WA",
    "City": "Ione"
  },
  {
    "State": "WA",
    "City": "Keller"
  },
  {
    "State": "WA",
    "City": "Kettle Falls"
  },
  {
    "State": "WA",
    "City": "Lacrosse"
  },
  {
    "State": "WA",
    "City": "Lamona"
  },
  {
    "State": "WA",
    "City": "Laurier"
  },
  {
    "State": "WA",
    "City": "Lincoln"
  },
  {
    "State": "WA",
    "City": "Loon Lake"
  },
  {
    "State": "WA",
    "City": "Malden"
  },
  {
    "State": "WA",
    "City": "Malo"
  },
  {
    "State": "WA",
    "City": "Marcus"
  },
  {
    "State": "WA",
    "City": "Metaline"
  },
  {
    "State": "WA",
    "City": "Metaline Falls"
  },
  {
    "State": "WA",
    "City": "Mohler"
  },
  {
    "State": "WA",
    "City": "Nespelem"
  },
  {
    "State": "WA",
    "City": "Newport"
  },
  {
    "State": "WA",
    "City": "Northport"
  },
  {
    "State": "WA",
    "City": "Oakesdale"
  },
  {
    "State": "WA",
    "City": "Odessa"
  },
  {
    "State": "WA",
    "City": "Orient"
  },
  {
    "State": "WA",
    "City": "Palouse"
  },
  {
    "State": "WA",
    "City": "Pullman"
  },
  {
    "State": "WA",
    "City": "Republic"
  },
  {
    "State": "WA",
    "City": "Rice"
  },
  {
    "State": "WA",
    "City": "Ritzville"
  },
  {
    "State": "WA",
    "City": "Rosalia"
  },
  {
    "State": "WA",
    "City": "Saint John"
  },
  {
    "State": "WA",
    "City": "Springdale"
  },
  {
    "State": "WA",
    "City": "Steptoe"
  },
  {
    "State": "WA",
    "City": "Thornton"
  },
  {
    "State": "WA",
    "City": "Uniontown"
  },
  {
    "State": "WA",
    "City": "Usk"
  },
  {
    "State": "WA",
    "City": "Valley"
  },
  {
    "State": "WA",
    "City": "Wilbur"
  },
  {
    "State": "WA",
    "City": "Spokane"
  },
  {
    "State": "WA",
    "City": "Pasco"
  },
  {
    "State": "WA",
    "City": "Benton City"
  },
  {
    "State": "WA",
    "City": "Beverly"
  },
  {
    "State": "WA",
    "City": "Bickleton"
  },
  {
    "State": "WA",
    "City": "Burbank"
  },
  {
    "State": "WA",
    "City": "College Place"
  },
  {
    "State": "WA",
    "City": "Connell"
  },
  {
    "State": "WA",
    "City": "Dayton"
  },
  {
    "State": "WA",
    "City": "Dixie"
  },
  {
    "State": "WA",
    "City": "Eltopia"
  },
  {
    "State": "WA",
    "City": "Hooper"
  },
  {
    "State": "WA",
    "City": "Kahlotus"
  },
  {
    "State": "WA",
    "City": "Kennewick"
  },
  {
    "State": "WA",
    "City": "Lind"
  },
  {
    "State": "WA",
    "City": "Mesa"
  },
  {
    "State": "WA",
    "City": "Othello"
  },
  {
    "State": "WA",
    "City": "Paterson"
  },
  {
    "State": "WA",
    "City": "Plymouth"
  },
  {
    "State": "WA",
    "City": "Pomeroy"
  },
  {
    "State": "WA",
    "City": "Prescott"
  },
  {
    "State": "WA",
    "City": "Mattawa"
  },
  {
    "State": "WA",
    "City": "Prosser"
  },
  {
    "State": "WA",
    "City": "Richland"
  },
  {
    "State": "WA",
    "City": "West Richland"
  },
  {
    "State": "WA",
    "City": "Roosevelt"
  },
  {
    "State": "WA",
    "City": "Royal City"
  },
  {
    "State": "WA",
    "City": "Starbuck"
  },
  {
    "State": "WA",
    "City": "Touchet"
  },
  {
    "State": "WA",
    "City": "Waitsburg"
  },
  {
    "State": "WA",
    "City": "Walla Walla"
  },
  {
    "State": "WA",
    "City": "Wallula"
  },
  {
    "State": "WA",
    "City": "Washtucna"
  },
  {
    "State": "WA",
    "City": "Anatone"
  },
  {
    "State": "WA",
    "City": "Asotin"
  },
  {
    "State": "WA",
    "City": "Clarkston"
  },
  {
    "State": "AK",
    "City": "Anchorage"
  },
  {
    "State": "AK",
    "City": "Jber"
  },
  {
    "State": "AK",
    "City": "Indian"
  },
  {
    "State": "AK",
    "City": "Kongiganak"
  },
  {
    "State": "AK",
    "City": "Adak"
  },
  {
    "State": "AK",
    "City": "Atka"
  },
  {
    "State": "AK",
    "City": "Chignik Lake"
  },
  {
    "State": "AK",
    "City": "Port Heiden"
  },
  {
    "State": "AK",
    "City": "Port Lions"
  },
  {
    "State": "AK",
    "City": "Akiachak"
  },
  {
    "State": "AK",
    "City": "Akiak"
  },
  {
    "State": "AK",
    "City": "Akutan"
  },
  {
    "State": "AK",
    "City": "Alakanuk"
  },
  {
    "State": "AK",
    "City": "Aleknagik"
  },
  {
    "State": "AK",
    "City": "Anchor Point"
  },
  {
    "State": "AK",
    "City": "Aniak"
  },
  {
    "State": "AK",
    "City": "Anvik"
  },
  {
    "State": "AK",
    "City": "Bethel"
  },
  {
    "State": "AK",
    "City": "Chefornak"
  },
  {
    "State": "AK",
    "City": "Chevak"
  },
  {
    "State": "AK",
    "City": "Chignik"
  },
  {
    "State": "AK",
    "City": "Chignik Lagoon"
  },
  {
    "State": "AK",
    "City": "Chitina"
  },
  {
    "State": "AK",
    "City": "Chugiak"
  },
  {
    "State": "AK",
    "City": "Clam Gulch"
  },
  {
    "State": "AK",
    "City": "Clarks Point"
  },
  {
    "State": "AK",
    "City": "Cold Bay"
  },
  {
    "State": "AK",
    "City": "Cooper Landing"
  },
  {
    "State": "AK",
    "City": "Copper Center"
  },
  {
    "State": "AK",
    "City": "Cordova"
  },
  {
    "State": "AK",
    "City": "Crooked Creek"
  },
  {
    "State": "AK",
    "City": "Dillingham"
  },
  {
    "State": "AK",
    "City": "Eagle River"
  },
  {
    "State": "AK",
    "City": "Eek"
  },
  {
    "State": "AK",
    "City": "Egegik"
  },
  {
    "State": "AK",
    "City": "Ekwok"
  },
  {
    "State": "AK",
    "City": "Emmonak"
  },
  {
    "State": "AK",
    "City": "False Pass"
  },
  {
    "State": "AK",
    "City": "Marshall"
  },
  {
    "State": "AK",
    "City": "Gakona"
  },
  {
    "State": "AK",
    "City": "Girdwood"
  },
  {
    "State": "AK",
    "City": "Glennallen"
  },
  {
    "State": "AK",
    "City": "Goodnews Bay"
  },
  {
    "State": "AK",
    "City": "Grayling"
  },
  {
    "State": "AK",
    "City": "Saint George Island"
  },
  {
    "State": "AK",
    "City": "Holy Cross"
  },
  {
    "State": "AK",
    "City": "Homer"
  },
  {
    "State": "AK",
    "City": "Hooper Bay"
  },
  {
    "State": "AK",
    "City": "Hope"
  },
  {
    "State": "AK",
    "City": "Iliamna"
  },
  {
    "State": "AK",
    "City": "Kalskag"
  },
  {
    "State": "AK",
    "City": "Karluk"
  },
  {
    "State": "AK",
    "City": "Kasigluk"
  },
  {
    "State": "AK",
    "City": "Kasilof"
  },
  {
    "State": "AK",
    "City": "Kenai"
  },
  {
    "State": "AK",
    "City": "King Cove"
  },
  {
    "State": "AK",
    "City": "King Salmon"
  },
  {
    "State": "AK",
    "City": "Kipnuk"
  },
  {
    "State": "AK",
    "City": "Kodiak"
  },
  {
    "State": "AK",
    "City": "Kotlik"
  },
  {
    "State": "AK",
    "City": "Kwethluk"
  },
  {
    "State": "AK",
    "City": "Kwigillingok"
  },
  {
    "State": "AK",
    "City": "Wasilla"
  },
  {
    "State": "AK",
    "City": "Larsen Bay"
  },
  {
    "State": "AK",
    "City": "Levelock"
  },
  {
    "State": "AK",
    "City": "Lower Kalskag"
  },
  {
    "State": "AK",
    "City": "Mc Grath"
  },
  {
    "State": "AK",
    "City": "Manokotak"
  },
  {
    "State": "AK",
    "City": "Mekoryuk"
  },
  {
    "State": "AK",
    "City": "Moose Pass"
  },
  {
    "State": "AK",
    "City": "Mountain Village"
  },
  {
    "State": "AK",
    "City": "Naknek"
  },
  {
    "State": "AK",
    "City": "Napakiak"
  },
  {
    "State": "AK",
    "City": "Nikiski"
  },
  {
    "State": "AK",
    "City": "New Stuyahok"
  },
  {
    "State": "AK",
    "City": "Toksook Bay"
  },
  {
    "State": "AK",
    "City": "Nikolski"
  },
  {
    "State": "AK",
    "City": "Ninilchik"
  },
  {
    "State": "AK",
    "City": "Nondalton"
  },
  {
    "State": "AK",
    "City": "Nunapitchuk"
  },
  {
    "State": "AK",
    "City": "Old Harbor"
  },
  {
    "State": "AK",
    "City": "Ouzinkie"
  },
  {
    "State": "AK",
    "City": "Palmer"
  },
  {
    "State": "AK",
    "City": "Pedro Bay"
  },
  {
    "State": "AK",
    "City": "Perryville"
  },
  {
    "State": "AK",
    "City": "Pilot Point"
  },
  {
    "State": "AK",
    "City": "Pilot Station"
  },
  {
    "State": "AK",
    "City": "Platinum"
  },
  {
    "State": "AK",
    "City": "Big Lake"
  },
  {
    "State": "AK",
    "City": "Port Alsworth"
  },
  {
    "State": "AK",
    "City": "Quinhagak"
  },
  {
    "State": "AK",
    "City": "Red Devil"
  },
  {
    "State": "AK",
    "City": "Russian Mission"
  },
  {
    "State": "AK",
    "City": "Saint Marys"
  },
  {
    "State": "AK",
    "City": "Saint Michael"
  },
  {
    "State": "AK",
    "City": "Saint Paul Island"
  },
  {
    "State": "AK",
    "City": "Sand Point"
  },
  {
    "State": "AK",
    "City": "Scammon Bay"
  },
  {
    "State": "AK",
    "City": "Seldovia"
  },
  {
    "State": "AK",
    "City": "Seward"
  },
  {
    "State": "AK",
    "City": "Shageluk"
  },
  {
    "State": "AK",
    "City": "Nunam Iqua"
  },
  {
    "State": "AK",
    "City": "Skwentna"
  },
  {
    "State": "AK",
    "City": "Sleetmute"
  },
  {
    "State": "AK",
    "City": "Soldotna"
  },
  {
    "State": "AK",
    "City": "South Naknek"
  },
  {
    "State": "AK",
    "City": "Stebbins"
  },
  {
    "State": "AK",
    "City": "Sterling"
  },
  {
    "State": "AK",
    "City": "Sutton"
  },
  {
    "State": "AK",
    "City": "Takotna"
  },
  {
    "State": "AK",
    "City": "Talkeetna"
  },
  {
    "State": "AK",
    "City": "Tatitlek"
  },
  {
    "State": "AK",
    "City": "Togiak"
  },
  {
    "State": "AK",
    "City": "Tuluksak"
  },
  {
    "State": "AK",
    "City": "Tuntutuliak"
  },
  {
    "State": "AK",
    "City": "Tununak"
  },
  {
    "State": "AK",
    "City": "Tyonek"
  },
  {
    "State": "AK",
    "City": "Trapper Creek"
  },
  {
    "State": "AK",
    "City": "Unalakleet"
  },
  {
    "State": "AK",
    "City": "Unalaska"
  },
  {
    "State": "AK",
    "City": "Valdez"
  },
  {
    "State": "AK",
    "City": "Willow"
  },
  {
    "State": "AK",
    "City": "Yakutat"
  },
  {
    "State": "AK",
    "City": "Nightmute"
  },
  {
    "State": "AK",
    "City": "Nikolai"
  },
  {
    "State": "AK",
    "City": "Dutch Harbor"
  },
  {
    "State": "AK",
    "City": "Whittier"
  },
  {
    "State": "AK",
    "City": "Houston"
  },
  {
    "State": "AK",
    "City": "Fairbanks"
  },
  {
    "State": "AK",
    "City": "Eielson AFB"
  },
  {
    "State": "AK",
    "City": "Fort Wainwright"
  },
  {
    "State": "AK",
    "City": "Clear"
  },
  {
    "State": "AK",
    "City": "North Pole"
  },
  {
    "State": "AK",
    "City": "Salcha"
  },
  {
    "State": "AK",
    "City": "Two Rivers"
  },
  {
    "State": "AK",
    "City": "Allakaket"
  },
  {
    "State": "AK",
    "City": "Anaktuvuk Pass"
  },
  {
    "State": "AK",
    "City": "Arctic Village"
  },
  {
    "State": "AK",
    "City": "Barrow"
  },
  {
    "State": "AK",
    "City": "Beaver"
  },
  {
    "State": "AK",
    "City": "Ester"
  },
  {
    "State": "AK",
    "City": "Bettles Field"
  },
  {
    "State": "AK",
    "City": "Buckland"
  },
  {
    "State": "AK",
    "City": "Cantwell"
  },
  {
    "State": "AK",
    "City": "Central"
  },
  {
    "State": "AK",
    "City": "Fort Greely"
  },
  {
    "State": "AK",
    "City": "Chicken"
  },
  {
    "State": "AK",
    "City": "Circle"
  },
  {
    "State": "AK",
    "City": "Prudhoe Bay"
  },
  {
    "State": "AK",
    "City": "Deering"
  },
  {
    "State": "AK",
    "City": "Delta Junction"
  },
  {
    "State": "AK",
    "City": "Eagle"
  },
  {
    "State": "AK",
    "City": "Elim"
  },
  {
    "State": "AK",
    "City": "Fort Yukon"
  },
  {
    "State": "AK",
    "City": "Galena"
  },
  {
    "State": "AK",
    "City": "Gambell"
  },
  {
    "State": "AK",
    "City": "Healy"
  },
  {
    "State": "AK",
    "City": "Anderson"
  },
  {
    "State": "AK",
    "City": "Hughes"
  },
  {
    "State": "AK",
    "City": "Huslia"
  },
  {
    "State": "AK",
    "City": "Kaktovik"
  },
  {
    "State": "AK",
    "City": "Kaltag"
  },
  {
    "State": "AK",
    "City": "Kiana"
  },
  {
    "State": "AK",
    "City": "Kivalina"
  },
  {
    "State": "AK",
    "City": "Kobuk"
  },
  {
    "State": "AK",
    "City": "Kotzebue"
  },
  {
    "State": "AK",
    "City": "Koyuk"
  },
  {
    "State": "AK",
    "City": "Koyukuk"
  },
  {
    "State": "AK",
    "City": "Denali National Park"
  },
  {
    "State": "AK",
    "City": "Manley Hot Springs"
  },
  {
    "State": "AK",
    "City": "Lake Minchumina"
  },
  {
    "State": "AK",
    "City": "Minto"
  },
  {
    "State": "AK",
    "City": "Point Lay"
  },
  {
    "State": "AK",
    "City": "Nenana"
  },
  {
    "State": "AK",
    "City": "Noatak"
  },
  {
    "State": "AK",
    "City": "Nome"
  },
  {
    "State": "AK",
    "City": "Noorvik"
  },
  {
    "State": "AK",
    "City": "Northway"
  },
  {
    "State": "AK",
    "City": "Nulato"
  },
  {
    "State": "AK",
    "City": "Point Hope"
  },
  {
    "State": "AK",
    "City": "Rampart"
  },
  {
    "State": "AK",
    "City": "Ruby"
  },
  {
    "State": "AK",
    "City": "Savoonga"
  },
  {
    "State": "AK",
    "City": "Selawik"
  },
  {
    "State": "AK",
    "City": "Shaktoolik"
  },
  {
    "State": "AK",
    "City": "Shishmaref"
  },
  {
    "State": "AK",
    "City": "Shungnak"
  },
  {
    "State": "AK",
    "City": "Stevens Village"
  },
  {
    "State": "AK",
    "City": "Tanacross"
  },
  {
    "State": "AK",
    "City": "Tanana"
  },
  {
    "State": "AK",
    "City": "Teller"
  },
  {
    "State": "AK",
    "City": "Tok"
  },
  {
    "State": "AK",
    "City": "Venetie"
  },
  {
    "State": "AK",
    "City": "Wainwright"
  },
  {
    "State": "AK",
    "City": "Wales"
  },
  {
    "State": "AK",
    "City": "White Mountain"
  },
  {
    "State": "AK",
    "City": "Brevig Mission"
  },
  {
    "State": "AK",
    "City": "Ambler"
  },
  {
    "State": "AK",
    "City": "Chalkyitsik"
  },
  {
    "State": "AK",
    "City": "Nuiqsut"
  },
  {
    "State": "AK",
    "City": "Atqasuk"
  },
  {
    "State": "AK",
    "City": "Juneau"
  },
  {
    "State": "AK",
    "City": "Angoon"
  },
  {
    "State": "AK",
    "City": "Auke Bay"
  },
  {
    "State": "AK",
    "City": "Douglas"
  },
  {
    "State": "AK",
    "City": "Elfin Cove"
  },
  {
    "State": "AK",
    "City": "Gustavus"
  },
  {
    "State": "AK",
    "City": "Haines"
  },
  {
    "State": "AK",
    "City": "Hoonah"
  },
  {
    "State": "AK",
    "City": "Kake"
  },
  {
    "State": "AK",
    "City": "Pelican"
  },
  {
    "State": "AK",
    "City": "Petersburg"
  },
  {
    "State": "AK",
    "City": "Sitka"
  },
  {
    "State": "AK",
    "City": "Port Alexander"
  },
  {
    "State": "AK",
    "City": "Skagway"
  },
  {
    "State": "AK",
    "City": "Tenakee Springs"
  },
  {
    "State": "AK",
    "City": "Ketchikan"
  },
  {
    "State": "AK",
    "City": "Meyers Chuck"
  },
  {
    "State": "AK",
    "City": "Coffman Cove"
  },
  {
    "State": "AK",
    "City": "Thorne Bay"
  },
  {
    "State": "AK",
    "City": "Craig"
  },
  {
    "State": "AK",
    "City": "Hydaburg"
  },
  {
    "State": "AK",
    "City": "Hyder"
  },
  {
    "State": "AK",
    "City": "Klawock"
  },
  {
    "State": "AK",
    "City": "Metlakatla"
  },
  {
    "State": "AK",
    "City": "Point Baker"
  },
  {
    "State": "AK",
    "City": "Ward Cove"
  },
  {
    "State": "AK",
    "City": "Wrangell"
  }
]`);
